(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(`@charset "UTF-8";.accordion-item-module_accordionItem__XDkKJ {
  min-width: 360px;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_headingWrapper__6M6lu {
  display: flex;
  align-items: center;
  gap: 16px;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 4px;
  background-color: white;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK .accordion-item-module_title__Y-E14 {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #00204d;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK .accordion-item-module_smallTitle__Jv3NP {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK .accordion-item-module_arrowDown__KY2np {
  margin-left: 6px;
  margin-right: 13px;
  transition: transform 0.3s ease;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK .accordion-item-module_expanded__hyqbB {
  transform: rotate(180deg);
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK:focus-visible {
  outline: 2px solid #006aff;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK:hover {
  background-color: #e5f0ff;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_heading__K6kSK:active {
  background-color: #cce1ff;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_content__IgLsd {
  padding-top: 24px;
  padding-left: 2px;
}
.accordion-item-module_accordionItem__XDkKJ .accordion-item-module_hidden__qWXem {
  display: none;
}

.accordion-item-module_withBottomBorder__uL76T {
  border-bottom: 1px solid #adbfd9;
}
.accordion-item-module_withBottomBorder__uL76T .accordion-item-module_content__IgLsd {
  padding-bottom: 16px;
}

.accordion-item-module_disabled__ASCd0 .accordion-item-module_heading__K6kSK:hover {
  cursor: not-allowed;
  background-color: white;
}
.accordion-item-module_disabled__ASCd0 .accordion-item-module_heading__K6kSK .accordion-item-module_title__Y-E14 {
  color: #adbfd9;
}
.accordion-item-module_disabled__ASCd0 .accordion-item-module_heading__K6kSK svg path {
  fill: #adbfd9;
}.accordion-module_accordion__mqGl- {
  box-sizing: border-box;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 24px;
}.action-card-module_container__qAV6L {
  box-sizing: border-box;
  width: 360px;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 16px 24px;
  border-radius: 12px;
  box-shadow: 1px 2px 8px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  text-decoration: none;
  gap: 8px;
}
.action-card-module_container__qAV6L.action-card-module_defaultCard__TRtOb:hover {
  background-color: #e5f0ff;
  box-shadow: 1px 2px 12px 0px rgba(0, 0, 0, 0.21);
}
.action-card-module_container__qAV6L.action-card-module_defaultCard__TRtOb:hover .action-card-module_icon__7aarz {
  color: #62748c;
}
.action-card-module_container__qAV6L.action-card-module_defaultCard__TRtOb:hover .action-card-module_icon__7aarz svg path {
  fill: currentColor;
}
.action-card-module_container__qAV6L.action-card-module_defaultCard__TRtOb:hover .action-card-module_label__V-9YM {
  cursor: pointer;
  color: #62748c;
}
.action-card-module_container__qAV6L.action-card-module_defaultCard__TRtOb:hover .action-card-module_circle__uOzlE {
  background-color: #cce1ff;
}
.action-card-module_container__qAV6L:focus-visible {
  outline: 2px solid #006aff;
}
.action-card-module_container__qAV6L div:first-child {
  display: flex;
  align-items: center;
}
.action-card-module_container__qAV6L .action-card-module_label__V-9YM {
  color: #00204d;
  font-size: 18px;
  line-height: 26px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
.action-card-module_container__qAV6L .action-card-module_labelSection__-w3Ex {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.action-card-module_container__qAV6L .action-card-module_icon__7aarz {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}

.action-card-module_completedCard__AS3dt {
  cursor: not-allowed;
  background-color: white;
}
.action-card-module_completedCard__AS3dt .action-card-module_label__V-9YM {
  pointer-events: none;
}

.action-card-module_activeCard__vgYpU {
  pointer-events: none;
  background-color: #cce1ff;
}

.action-card-module_disabledCard__5fl6w {
  cursor: not-allowed;
}
.action-card-module_disabledCard__5fl6w .action-card-module_icon__7aarz {
  color: #adbfd9;
}
.action-card-module_disabledCard__5fl6w .action-card-module_icon__7aarz svg path {
  fill: currentColor;
}
.action-card-module_disabledCard__5fl6w .action-card-module_label__V-9YM {
  color: #adbfd9;
  pointer-events: none;
}

.action-card-module_circle__uOzlE {
  border-radius: 50%;
  width: 56px;
  min-width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-card-module_circleBlue__9L906 {
  background-color: #e5f0ff;
}

.action-card-module_circleGreen__GYUnr {
  background-color: #e6f3f1;
}

.action-card-module_circleActive__wFORv {
  background-color: #b8d5ff;
}.advanced-table-module_wrapper__0HaIg {
  width: 100%;
  position: relative;
}

.advanced-table-module_header__Z9uZa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.advanced-table-module_title__kO54z {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #00204d;
  margin: 0;
}

.advanced-table-module_headerActions__IV9EX {
  display: flex;
  gap: 8px;
  align-items: center;
}

.advanced-table-module_tableContainer__McS-- {
  width: 100%;
  overflow: auto;
  border: 1px solid #adbfd9;
  border-radius: 8px;
  background: white;
}
.advanced-table-module_tableContainer__McS--.advanced-table-module_stickyHeader__l9a6f {
  max-height: var(--table-max-height, 600px);
}

.advanced-table-module_table__3eKRP {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  table-layout: fixed;
}

.advanced-table-module_thead__PFCZ6 {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ebf0f7;
}

.advanced-table-module_headerRow__-xZhJ {
  border-bottom: 2px solid #adbfd9;
}

.advanced-table-module_headerCell__8fkQy {
  padding: 12px 16px;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  background: #ebf0f7;
  border-bottom: 2px solid #adbfd9;
  position: relative;
  user-select: none;
}
.advanced-table-module_headerCell__8fkQy:not(:last-child) {
  border-right: 1px solid #adbfd9;
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_sortable__yIxZg {
  cursor: pointer;
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_sortable__yIxZg:hover {
  background: #e5f0ff;
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_pinnedLeft__ufL5v {
  position: sticky;
  z-index: 2;
  background: #ebf0f7;
  box-shadow: 2px 0 4px rgba(0, 11, 26, 0.1);
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_pinnedRight__XOFS- {
  position: sticky;
  z-index: 2;
  background: #ebf0f7;
  box-shadow: -2px 0 4px rgba(0, 11, 26, 0.1);
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_resizable__MQzkI .advanced-table-module_resizer__W4MqT {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 4px;
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  opacity: 0;
  transition: opacity 0.2s;
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_resizable__MQzkI .advanced-table-module_resizer__W4MqT:hover, .advanced-table-module_headerCell__8fkQy.advanced-table-module_resizable__MQzkI .advanced-table-module_resizer__W4MqT.advanced-table-module_isResizing__L-wDP {
  opacity: 1;
  background: #006aff;
}
.advanced-table-module_headerCell__8fkQy.advanced-table-module_resizable__MQzkI:hover .advanced-table-module_resizer__W4MqT {
  opacity: 0.5;
}

.advanced-table-module_headerCellContent__WSsKE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  white-space: nowrap;
}

.advanced-table-module_headerLabel__V6-Gm {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.advanced-table-module_sortIcon__jye0a {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  color: #62748c;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.advanced-table-module_sortIcon__jye0a.advanced-table-module_active__YMufi {
  opacity: 1;
  color: #006aff;
}

.advanced-table-module_expandCollapseButton__B3DWD {
  background: #006AFF;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  font-weight: 300;
  line-height: 1;
  transition: background-color 0.2s, transform 0.1s;
}
.advanced-table-module_expandCollapseButton__B3DWD:hover {
  background: #0052CC;
  transform: scale(1.05);
}
.advanced-table-module_expandCollapseButton__B3DWD:active {
  transform: scale(0.95);
}

.advanced-table-module_collapsableColumn__hKfv3 {
  background-color: #E5F0F7 !important;
}
.advanced-table-module_collapsableColumn__hKfv3.advanced-table-module_pinnedLeft__ufL5v, .advanced-table-module_collapsableColumn__hKfv3.advanced-table-module_pinnedRight__XOFS- {
  background-color: #E5F0F7 !important;
}
.advanced-table-module_row__beOpp:hover .advanced-table-module_collapsableColumn__hKfv3 {
  background-color: #d6e8f3 !important;
}
.advanced-table-module_row__beOpp.advanced-table-module_selected__uoF-W .advanced-table-module_collapsableColumn__hKfv3 {
  background-color: #c7e0ef !important;
}
.advanced-table-module_row__beOpp.advanced-table-module_expanded__a3kGU .advanced-table-module_collapsableColumn__hKfv3 {
  background-color: #d6e8f3 !important;
}

.advanced-table-module_columnMenu__G3Olz {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.advanced-table-module_columnMenuButton__U7yve {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #62748c;
  opacity: 0;
  transition: opacity 0.2s;
  border-radius: 5px;
  display: flex;
  align-items: center;
  line-height: 1;
}
.advanced-table-module_columnMenuButton__U7yve:hover {
  background: #e5f0ff;
  color: #00204d;
}
.advanced-table-module_headerCell__8fkQy:hover .advanced-table-module_columnMenuButton__U7yve, .advanced-table-module_headerCell__8fkQy:focus-within .advanced-table-module_columnMenuButton__U7yve {
  opacity: 1;
}

.advanced-table-module_columnMenuDropdown__G8-iN {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #adbfd9;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 11, 26, 0.15);
  min-width: 160px;
  z-index: 100;
  overflow: hidden;
}

.advanced-table-module_columnMenuItem__S-bRi {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  transition: background-color 0.15s;
}
.advanced-table-module_columnMenuItem__S-bRi:hover {
  background: #f4f8ff;
}
.advanced-table-module_columnMenuItem__S-bRi:not(:last-child) {
  border-bottom: 1px solid #ebf0f7;
}

.advanced-table-module_menuIcon__QjBd- {
  font-size: 16px;
}

.advanced-table-module_groupHeader__uBKJZ {
  padding: 8px 16px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #62748c;
  background: #ebf0f7;
  border-bottom: 1px solid #adbfd9;
}

.advanced-table-module_tbody__p4gXB {
  background: white;
}

.advanced-table-module_row__beOpp {
  border-bottom: 1px solid #ebf0f7;
  transition: background-color 0.15s;
}
.advanced-table-module_row__beOpp:hover {
  background: #f4f8ff;
}
.advanced-table-module_row__beOpp:hover .advanced-table-module_pinnedLeft__ufL5v,
.advanced-table-module_row__beOpp:hover .advanced-table-module_pinnedRight__XOFS- {
  background: #f4f8ff;
}
.advanced-table-module_row__beOpp.advanced-table-module_clickable__gx0mv {
  cursor: pointer;
}
.advanced-table-module_row__beOpp.advanced-table-module_selected__uoF-W {
  background: #e5f0ff;
}
.advanced-table-module_row__beOpp.advanced-table-module_selected__uoF-W .advanced-table-module_pinnedLeft__ufL5v,
.advanced-table-module_row__beOpp.advanced-table-module_selected__uoF-W .advanced-table-module_pinnedRight__XOFS- {
  background: #e5f0ff;
}
.advanced-table-module_row__beOpp.advanced-table-module_expanded__a3kGU {
  background: #ebf0f7;
}
.advanced-table-module_row__beOpp.advanced-table-module_expanded__a3kGU .advanced-table-module_pinnedLeft__ufL5v,
.advanced-table-module_row__beOpp.advanced-table-module_expanded__a3kGU .advanced-table-module_pinnedRight__XOFS- {
  background: #ebf0f7;
}

.advanced-table-module_cell__WDT5X {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  vertical-align: middle;
}
.advanced-table-module_cell__WDT5X:not(:last-child) {
  border-right: 1px solid #ebf0f7;
}
.advanced-table-module_cell__WDT5X.advanced-table-module_pinnedLeft__ufL5v {
  position: sticky;
  z-index: 1;
  background: white;
  box-shadow: 2px 0 4px rgba(0, 11, 26, 0.05);
}
.advanced-table-module_cell__WDT5X.advanced-table-module_pinnedRight__XOFS- {
  position: sticky;
  z-index: 1;
  background: white;
  box-shadow: -2px 0 4px rgba(0, 11, 26, 0.05);
}

.advanced-table-module_expandedRow__5-sDl {
  background: #ebf0f7;
  border-bottom: 2px solid #adbfd9;
}

.advanced-table-module_expandedContent__-ULyl {
  padding: 16px;
}

.advanced-table-module_emptyState__UJu8t {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #62748c;
  text-align: center;
}

.advanced-table-module_emptyIcon__8L-Ei {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.3;
}

.advanced-table-module_emptyText__A52Nm {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  margin-bottom: 8px;
}

.advanced-table-module_loadingOverlay__NDCaR {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.advanced-table-module_pagination__e9Yrw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #adbfd9;
}

.advanced-table-module_paginationInfo__1HQuC {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #62748c;
}

.advanced-table-module_paginationControls__ZnGLp {
  display: flex;
  gap: 8px;
  align-items: center;
}

.advanced-table-module_pageButton__RhxEp {
  padding: 6px 12px;
  border: 1px solid #adbfd9;
  background: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  transition: all 0.2s;
}
.advanced-table-module_pageButton__RhxEp:hover:not(:disabled) {
  background: #f4f8ff;
  border-color: #006aff;
}
.advanced-table-module_pageButton__RhxEp:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #adbfd9;
}
.advanced-table-module_pageButton__RhxEp.advanced-table-module_active__YMufi {
  background: #006aff;
  color: white;
  border-color: #006aff;
}

.advanced-table-module_pageSizeSelect__TbLJn {
  padding: 6px 12px;
  border: 1px solid #adbfd9;
  border-radius: 5px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  background: white;
  color: #00204d;
  cursor: pointer;
}
.advanced-table-module_pageSizeSelect__TbLJn:hover {
  border-color: #006aff;
}
.advanced-table-module_pageSizeSelect__TbLJn:focus {
  outline: 2px solid #006aff;
}

@media (max-width: 1024px) {
  .advanced-table-module_priorityMedium__EG3z6 {
    display: none;
  }
}
@media (max-width: 768px) {
  .advanced-table-module_priorityLow__yd2NV {
    display: none;
  }
  .advanced-table-module_headerCell__8fkQy,
  .advanced-table-module_cell__WDT5X {
    padding: 8px 12px;
  }
}
.advanced-table-module_customizerButton__W0sYU {
  padding: 8px 12px;
  border: 1px solid #adbfd9;
  background: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.advanced-table-module_customizerButton__W0sYU:hover {
  background: #f4f8ff;
  border-color: #006aff;
}
.advanced-table-module_customizerButton__W0sYU:focus {
  outline: 2px solid #006aff;
}

.advanced-table-module_customizerModal__ZQitZ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 11, 26, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.advanced-table-module_customizerContent__blhAD {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 24px rgba(0, 11, 26, 0.15);
}

.advanced-table-module_customizerHeader__F60r7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.advanced-table-module_customizerTitle__vYm45 {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #00204d;
  margin: 0;
}

.advanced-table-module_customizerClose__cETCu {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #62748c;
}
.advanced-table-module_customizerClose__cETCu:hover {
  color: #00204d;
}

.advanced-table-module_columnList__P5Gp- {
  list-style: none;
  padding: 0;
  margin: 0;
}

.advanced-table-module_columnItem__HNh1J {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #ebf0f7;
  border-radius: 5px;
  margin-bottom: 8px;
  background: white;
  transition: background-color 0.2s;
}
.advanced-table-module_columnItem__HNh1J:hover {
  background: #f4f8ff;
}

.advanced-table-module_columnInfo__pxw1l {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.advanced-table-module_dragHandle__2sNNi {
  cursor: grab;
  color: #62748c;
  font-size: 18px;
}
.advanced-table-module_dragHandle__2sNNi:active {
  cursor: grabbing;
}

.advanced-table-module_columnName__O2snk {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}

.advanced-table-module_columnActions__G-UBu {
  display: flex;
  gap: 8px;
  align-items: center;
}

.advanced-table-module_pinButton__3wuCu {
  padding: 4px 8px;
  border: 1px solid #adbfd9;
  background: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #00204d;
  transition: all 0.2s;
}
.advanced-table-module_pinButton__3wuCu:hover {
  background: #f4f8ff;
}
.advanced-table-module_pinButton__3wuCu.advanced-table-module_pinned__5Fr4n {
  background: #e5f0ff;
  border-color: #006aff;
  color: #006aff;
}

.advanced-table-module_visibilityToggle__pN98v {
  appearance: none;
  width: 40px;
  height: 20px;
  background: #adbfd9;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s;
}
.advanced-table-module_visibilityToggle__pN98v:checked {
  background: #006aff;
}
.advanced-table-module_visibilityToggle__pN98v::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  top: 2px;
  left: 2px;
  transition: transform 0.2s;
}
.advanced-table-module_visibilityToggle__pN98v:checked::before {
  transform: translateX(20px);
}.avatar-module_avatar__gw6mG {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border: 2px solid white;
  border-radius: 100%;
  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.1);
  background-position: center;
  background-size: cover;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 200ms;
  position: relative;
}
.avatar-module_avatar--active__X6g7j {
  box-shadow: inset 0 0 99px rgba(0, 119, 255, 0.129);
}
.avatar-module_avatar__gw6mG.avatar-module_decorative__CwlP8 {
  cursor: default !important;
}
.avatar-module_avatar__gw6mG:hover:not(.avatar-module_decorative__CwlP8):not(.avatar-module_colorCodedByOrder__9FI9R) {
  background-color: white;
}
.avatar-module_avatar--size-small__VWN85 {
  width: 24px;
  height: 24px;
  font-size: 10px;
}
.avatar-module_avatar--size-large__ZnKyv {
  width: 40px;
  height: 40px;
  font-size: 18px;
}
.avatar-module_avatar__gw6mG:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: -2px;
}
.avatar-module_avatar__gw6mG:focus:not(:focus-visible) {
  outline: none;
}

.avatar-module_avatar--color-by-order-0__B86MS {
  background-color: #0974c1;
  border-color: #064f83;
  color: white;
}

.avatar-module_avatar--color-by-order-1__Olh2W {
  background-color: #8b5ed4;
  border-color: #723bca;
  color: white;
}

.avatar-module_avatar--color-by-order-2__uJKcT {
  background-color: #ff8000;
  border-color: #cc6600;
  color: black;
}

.avatar-module_avatar--color-by-order-3__yrlXy {
  background-color: #01fbff;
  border-color: #009699;
  color: black;
}

.avatar-module_avatar--color-by-order-4__-4Tu1 {
  background-color: #ff55cc;
  border-color: #ff00bb;
  color: black;
}

.avatar-module_avatar--color-by-order-5__YPrFR {
  background-color: #e6f1fa;
  border-color: white;
  color: #0070bf;
}

.avatar-module_blue__HGIn3 {
  color: #0070bf;
  background-color: #e6f1fa;
}

.avatar-module_green__ee9-J {
  color: #007a6a;
  background-color: #e6f3f1;
}

.avatar-module_red__DXBKl {
  color: #d71717;
  background-color: #ffeaea;
}

.avatar-module_yellow__JBAVp {
  color: #c4811d;
  background-color: #fff6ea;
}

.avatar-module_purple__XZfhx {
  color: #723bca;
  background-color: #f1ebfa;
}

.avatar-module_badge__dk1pc {
  position: absolute;
  bottom: -5px;
  right: -5px;
  display: flex;
}:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{left:0;opacity:0;pointer-events:none;position:absolute;top:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{background:inherit;position:absolute}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay) ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay) ease-in}.styles-module_tooltip__mnnfp{border-radius:3px;font-size:90%;padding:8px 16px;width:max-content}.styles-module_arrow__K0L3T{height:8px;width:8px}[class*=react-tooltip__place-top]>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*=react-tooltip__place-right]>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*=react-tooltip__place-bottom]>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*=react-tooltip__place-left]>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}:root {
  --rt-opacity: 1;
}

.tooltip__wrapper {
  display: contents;
}

.tooltip {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  border-radius: 4px;
  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.1);
  color: #ffffff !important;
  background-color: #00204d !important;
  max-width: 300px;
  box-sizing: border-box;
  text-align: left;
  z-index: 10;
  font-size: 12px !important;
}
.tooltip::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: #00204d;
  z-index: -1;
}
.tooltip__arrow {
  width: 8px;
  height: 8px;
  border-radius: 1px;
  background-color: #00204d;
  z-index: -2;
}

.tooltip.tooltip--light {
  background-color: #ffffff !important;
  color: #00204d !important;
  border: 1px solid #adbfd9;
}
.tooltip.tooltip--light::before {
  background-color: #ffffff;
}
.tooltip.tooltip--light .tooltip__arrow {
  background-color: #ffffff;
  border: 1px solid #adbfd9;
  margin: -1px;
}
.tooltip.tooltip--light[class*=react-tooltip__place-right] .tooltip__arrow {
  border-left: 0;
  border-top: 0;
}
.tooltip.tooltip--light[class*=react-tooltip__place-left] .tooltip__arrow {
  border-left: 0;
  border-top: 0;
}
.tooltip.tooltip--light[class*=react-tooltip__place-top] .tooltip__arrow {
  border-top: 0;
  border-left: 0;
}
.tooltip.tooltip--light[class*=react-tooltip__place-bottom] .tooltip__arrow {
  border-top: 0;
  border-left: 0;
}.avatars-module_avatars__BdLe4 {
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  width: fit-content;
}

.avatars-module_dotsTooltip__-TLQM {
  text-align: left;
}

.avatars-module_children-avatar__i9lDP:not(:first-child) {
  margin-left: -6px;
}
.avatars-module_children-avatar__i9lDP:hover, .avatars-module_children-avatar__i9lDP:focus-within {
  z-index: 99 !important;
}.bar-chart-module_barChart__iE-iG {
  display: flex;
  align-items: center;
}.button-module_button__Z331g {
  all: unset;
  width: fit-content;
  border-radius: 5px;
  background-color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  outline: none;
  border: none;
  text-decoration: none;
}
.button-module_button__content__9h4R4 {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.button-module_button__text__MRvbu {
  display: inline-block;
}
.button-module_button--as-component__Cf0EP {
  text-decoration: none;
  display: inline-flex;
}
.button-module_button__left-icon-wrapper__DjiYD, .button-module_button__right-icon-wrapper__PVDu6 {
  width: 16px;
  height: 16px;
}
.button-module_button__left-icon-wrapper__DjiYD svg, .button-module_button__right-icon-wrapper__PVDu6 svg {
  width: 16px;
  height: 16px;
}
.button-module_button__counter-wrapper__86jEc {
  border-radius: 50vh;
  width: fit-content;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  padding: 2px;
  min-width: 16px;
}
.button-module_button__Z331g[aria-disabled=true], .button-module_button--loading__8GhE4 {
  cursor: not-allowed;
}
.button-module_button__Z331g:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.button-module_button__Z331g:focus:not(:focus-visible) {
  outline: none;
}
.button-module_button--full-width__KuOth {
  width: 100%;
}
.button-module_button--size-large__4A7f5 {
  border-radius: 8px;
  height: 44px;
  gap: 8px;
  padding: 12px 24px;
}
.button-module_button--size-large__4A7f5 .button-module_button__content__9h4R4 {
  gap: 8px;
}
.button-module_button--size-large__4A7f5 .button-module_button__text__MRvbu {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.button-module_button--size-medium__PNgpr {
  border-radius: 4px;
  height: 36px;
  gap: 4px;
  padding: 8px 12px;
}
.button-module_button--size-medium__PNgpr .button-module_button__content__9h4R4 {
  gap: 4px;
}
.button-module_button--size-medium__PNgpr .button-module_button__text__MRvbu {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.button-module_button--size-small__CgTo7 {
  border-radius: 4px;
  height: 32px;
  gap: 4px;
  padding: 8px 12px;
}
.button-module_button--size-small__CgTo7 .button-module_button__content__9h4R4 {
  gap: 4px;
}
.button-module_button--size-small__CgTo7 .button-module_button__text__MRvbu {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.button-module_button--size-small__CgTo7 .button-module_button__counter-wrapper__86jEc {
  padding: 0px 2px;
  min-width: 12px;
}
.button-module_button--icon-only__pv5vL {
  padding: 0;
}
.button-module_button--size-large__4A7f5.button-module_button--icon-only__pv5vL {
  width: 44px;
}
.button-module_button--size-medium__PNgpr.button-module_button--icon-only__pv5vL {
  width: 36px;
}
.button-module_button--size-small__CgTo7.button-module_button--icon-only__pv5vL {
  width: 32px;
}
.button-module_button--variant-primary__h1ZBU {
  border: none;
  background-color: var(--button-primary-bg, #006aff);
  color: white;
}
.button-module_button--variant-primary__h1ZBU .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-primary__h1ZBU .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: white;
  fill: white;
}
.button-module_button--variant-primary__h1ZBU .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-primary__h1ZBU .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: white;
  fill: white;
}
.button-module_button--variant-primary__h1ZBU .button-module_button__loader__1NT-v {
  border-bottom-color: white;
}
.button-module_button--variant-primary__h1ZBU .button-module_button__counter-wrapper__86jEc {
  background-color: white;
  color: #006aff;
}
.button-module_button--variant-primary__h1ZBU:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) {
  background-color: var(--button-primary-bg-hover, #3388ff);
}
.button-module_button--variant-primary__h1ZBU:active {
  background-color: var(--button-primary-bg-active, #005fe5);
}
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] {
  background-color: #ebf0f7;
  color: #adbfd9;
}
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-primary__h1ZBU[aria-disabled=true] .button-module_button__counter-wrapper__86jEc {
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-primary__h1ZBU.button-module_button--loading__8GhE4 {
  background-color: var(--button-primary-bg-active, #005fe5);
}
.button-module_button--variant-secondary__nja0P {
  border: solid 1px #006aff;
  background-color: white;
  color: #006aff;
}
.button-module_button--variant-secondary__nja0P .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-secondary__nja0P .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #006aff;
  fill: #006aff;
}
.button-module_button--variant-secondary__nja0P .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-secondary__nja0P .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #006aff;
  fill: #006aff;
}
.button-module_button--variant-secondary__nja0P .button-module_button__loader__1NT-v {
  border-bottom-color: #006aff;
}
.button-module_button--variant-secondary__nja0P .button-module_button__counter-wrapper__86jEc {
  background-color: #006aff;
  color: white;
}
.button-module_button--variant-secondary__nja0P:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) {
  background-color: #e5f0ff;
}
.button-module_button--variant-secondary__nja0P:active {
  background-color: #cce1ff;
  color: #005fe5;
}
.button-module_button--variant-secondary__nja0P:active .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-secondary__nja0P:active .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-secondary__nja0P:active .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-secondary__nja0P:active .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-secondary__nja0P:active .button-module_button__loader__1NT-v {
  border-bottom-color: #005fe5;
}
.button-module_button--variant-secondary__nja0P[aria-disabled=true] {
  border: solid 1px #adbfd9;
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 {
  background-color: #cce1ff;
  color: #005fe5;
}
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-secondary__nja0P.button-module_button--loading__8GhE4 .button-module_button__loader__1NT-v {
  border-bottom-color: #005fe5;
}
.button-module_button--variant-tertiary__-XASz {
  border: none;
  background-color: white;
  color: #006aff;
}
.button-module_button--variant-tertiary__-XASz .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-tertiary__-XASz .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #006aff;
  fill: #006aff;
}
.button-module_button--variant-tertiary__-XASz .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-tertiary__-XASz .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #006aff;
  fill: #006aff;
}
.button-module_button--variant-tertiary__-XASz .button-module_button__loader__1NT-v {
  border-bottom-color: #006aff;
}
.button-module_button--variant-tertiary__-XASz .button-module_button__counter-wrapper__86jEc {
  background-color: #006aff;
  color: white;
}
.button-module_button--variant-tertiary__-XASz:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) {
  background-color: #e5f0ff;
}
.button-module_button--variant-tertiary__-XASz:active {
  background-color: #cce1ff;
  color: #005fe5;
}
.button-module_button--variant-tertiary__-XASz:active .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-tertiary__-XASz:active .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-tertiary__-XASz:active .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-tertiary__-XASz:active .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-tertiary__-XASz:active .button-module_button__loader__1NT-v {
  border-bottom-color: #005fe5;
}
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] {
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 {
  background-color: #cce1ff;
  color: #005fe5;
}
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #005fe5;
  fill: #005fe5;
}
.button-module_button--variant-tertiary__-XASz.button-module_button--loading__8GhE4 .button-module_button__loader__1NT-v {
  border-bottom-color: #005fe5;
}
.button-module_button--variant-text__oH84u {
  border: none;
  background-color: transparent;
  color: #000b1a;
}
.button-module_button--variant-text__oH84u .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-text__oH84u .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #000b1a;
  fill: #000b1a;
}
.button-module_button--variant-text__oH84u .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-text__oH84u .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #000b1a;
  fill: #000b1a;
}
.button-module_button--variant-text__oH84u .button-module_button__loader__1NT-v {
  border-bottom-color: #000b1a;
}
.button-module_button--variant-text__oH84u .button-module_button__counter-wrapper__86jEc {
  background-color: #000b1a;
  color: white;
}
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) {
  background-color: #e5f0ff;
  color: #62748c;
}
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #62748c;
  fill: #62748c;
}
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #62748c;
  fill: #62748c;
}
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__loader__1NT-v {
  border-bottom-color: #62748c;
}
.button-module_button--variant-text__oH84u:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__counter-wrapper__86jEc {
  background-color: #62748c;
  color: #e5f0ff;
}
.button-module_button--variant-text__oH84u:active {
  background-color: #cce1ff;
}
.button-module_button--variant-text__oH84u[aria-disabled=true] {
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-negative__yPuaC, .button-module_button--variant-negativeSecondary__w4Z2R {
  border: none;
  background-color: transparent;
  color: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negative__yPuaC .button-module_button__right-icon-wrapper__PVDu6 svg, .button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negative__yPuaC .button-module_button__right-icon-wrapper__PVDu6 svg path, .button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC .button-module_button__loader__1NT-v, .button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__loader__1NT-v {
  border-bottom-color: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__counter-wrapper__86jEc {
  background-color: #ec4a4a;
  color: white;
}
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]), .button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) {
  background-color: #ffeaea;
  color: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg, .button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg path, .button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__loader__1NT-v, .button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__loader__1NT-v {
  border-bottom-color: #ec4a4a;
}
.button-module_button--variant-negative__yPuaC:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-negativeSecondary__w4Z2R:hover:not(.button-module_button--loading__8GhE4):not([aria-disabled=true]) .button-module_button__counter-wrapper__86jEc {
  background-color: #ec4a4a;
  color: white;
}
.button-module_button--variant-negative__yPuaC:active, .button-module_button--variant-negativeSecondary__w4Z2R:active {
  background-color: #ffeaea;
}
.button-module_button--variant-negative__yPuaC[aria-disabled=true], .button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] {
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg, .button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path, .button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__loader__1NT-v, .button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-negativePrimary__VUOsM {
  border: none;
  background-color: #d71717;
  color: white;
}
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: white;
  fill: white;
}
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: white;
  fill: white;
}
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__loader__1NT-v {
  border-bottom-color: white;
}
.button-module_button--variant-negativePrimary__VUOsM .button-module_button__counter-wrapper__86jEc {
  background-color: white;
  color: #d71717;
}
.button-module_button--variant-negativePrimary__VUOsM:hover {
  background-color: #ec4a4a;
  color: white;
}
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true], .button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover {
  background-color: #ebf0f7;
  color: #adbfd9;
}
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg, .button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path, .button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__loader__1NT-v, .button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true] .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-negativePrimary__VUOsM[aria-disabled=true]:hover .button-module_button__counter-wrapper__86jEc {
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-negativeSecondary__w4Z2R {
  border: solid 1px #ec4a4a;
  background-color: white;
  color: #ec4a4a;
}
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #ec4a4a;
  fill: #ec4a4a;
}
.button-module_button--variant-negativeSecondary__w4Z2R .button-module_button__loader__1NT-v {
  border-bottom-color: #ec4a4a;
}
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] {
  border: solid 1px #adbfd9;
  background-color: white;
  color: #adbfd9;
}
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg,
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__left-icon-wrapper__DjiYD svg path,
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__right-icon-wrapper__PVDu6 svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.button-module_button--variant-negativeSecondary__w4Z2R[aria-disabled=true] .button-module_button__loader__1NT-v {
  border-bottom-color: #adbfd9;
}
.button-module_button--variant-secondary__nja0P[aria-disabled=true] .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-tertiary__-XASz[aria-disabled=true] .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-text__oH84u[aria-disabled=true] .button-module_button__counter-wrapper__86jEc, .button-module_button--variant-negative__yPuaC[aria-disabled=true] .button-module_button__counter-wrapper__86jEc {
  background-color: #adbfd9;
  color: white;
}
.button-module_button--variant-text__oH84u.button-module_button--loading__8GhE4 {
  background-color: #cce1ff;
}.styles-module_loader__84O2M {
  align-items: center;
  display: flex;
}
.styles-module_loader__84O2M.styles-module_animation__zEO9U {
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.styles-module_loader__84O2M.styles-module_animation__zEO9U > div {
  -webkit-animation: styles-module_bounce-delay__BTq2m 1.4s infinite ease-in-out both;
  animation: styles-module_bounce-delay__BTq2m 1.4s infinite ease-in-out both;
  border-radius: 100%;
  display: inline-block;
  background-color: #006aff;
}
.styles-module_loader__84O2M.styles-module_animation__zEO9U .styles-module_bounce1__UFXT6 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.styles-module_loader__84O2M.styles-module_animation__zEO9U .styles-module_bounce2__THqFp {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.styles-module_loader--color-interactive__b91-R > div {
  background-color: #006aff !important;
}
.styles-module_loader--color-white__9U7Og > div {
  background-color: white !important;
}
.styles-module_loader--color-interactive-dark__1roQO > div {
  background-color: #005fe5 !important;
}
.styles-module_loader--size-small__F0F7h > div {
  height: 8px;
  width: 8px;
}
.styles-module_loader--size-medium__-8o5l > div {
  height: 18px;
  width: 18px;
}
.styles-module_loader--size-large__mhFtF > div {
  height: 24px;
  width: 24px;
}

@-webkit-keyframes styles-module_bounce-delay__BTq2m {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes styles-module_bounce-delay__BTq2m {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}.styles-module_loader__2DUDM {
  border-style: solid;
  border-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: styles-module_rotation__lYYqb 1s linear infinite;
}
.styles-module_loader--color-white__O2iyE {
  border-bottom-color: white;
}
.styles-module_loader--color-interactive__mT9Eb {
  border-bottom-color: #3388ff;
}
.styles-module_loader--color-interactive-dark__ZPgn8 {
  border-bottom-color: #005fe5;
}
.styles-module_loader--size-small__XA3yY {
  width: 14.5px;
  height: 14.5px;
  border-width: 2px;
}
.styles-module_loader--size-medium__eSAJZ {
  width: 34.5px;
  height: 34.5px;
  border-width: 4px;
}
.styles-module_loader--size-large__dS3td {
  width: 46.5px;
  height: 46.6px;
  border-width: 5px;
}

@keyframes styles-module_rotation__lYYqb {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}.styles-module_loader__wrapper__T2Tb0 {
  padding: 1.5px;
}

.styles-module_page-loader-wrapper__5uh7l {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}.chip-module_container__L6Fwa {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  background-color: #ffd129;
  color: #00204d;
  border-radius: 4px;
  width: max-content;
  height: 20px;
  padding: 0 4px;
  border-radius: 4px;
}
.chip-module_container__L6Fwa.chip-module_default__NL5lH:hover {
  background-color: #ffda54;
  cursor: pointer;
}
.chip-module_container__L6Fwa .chip-module_iconWrapper__Y2Edt {
  width: 16px;
  height: 16px;
}
.chip-module_container__L6Fwa .chip-module_content__XpQEQ {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chip-module_container__L6Fwa .chip-module_dismissIcon__RFex6 {
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  height: 7px;
  width: 7px;
}
.chip-module_container__L6Fwa .chip-module_dismissIcon__RFex6:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 0.2px;
  outline-offset: 2px;
}
.chip-module_container__L6Fwa .chip-module_dismissIcon__RFex6 svg {
  width: 100%;
  height: 100%;
}
.chip-module_container__L6Fwa .chip-module_dismissIcon__RFex6 svg path {
  fill: #00204d;
}

.chip-module_active__uJfiq {
  background-color: #e6bc25;
}

.chip-module_disabled__21ZO5 {
  background-color: #ebf0f7;
  color: #62748c;
}
.chip-module_disabled__21ZO5, .chip-module_disabled__21ZO5 * {
  cursor: not-allowed !important;
}
.chip-module_disabled__21ZO5 .chip-module_dismissIcon__RFex6 svg path {
  fill: #62748c;
}.countdown-module_countdown__krAOE {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 40px;
  border: 2px solid #e6f1fa;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  line-height: 24px;
}

.countdown-module_circularCounter__k-VQ- {
  width: 20px !important;
  margin-left: 4px;
}.drawer-module_drawer__M9tID {
  position: fixed;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  right: 0;
  top: 0;
  bottom: 0;
  width: 66vw;
  max-width: 976px;
  min-width: 592px;
  transition: 0.18s ease-in-out;
  background-color: white;
  z-index: 999;
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
  padding: 32px 24px 24px 24px;
}
.drawer-module_drawer__M9tID:focus {
  outline: 2px solid #006aff;
}
.drawer-module_drawer__M9tID *:focus {
  outline: 2px solid #006aff;
}
.drawer-module_drawer__M9tID.drawer-module_open__YuyKG {
  transform: translateX(0);
}
.drawer-module_drawer__M9tID.drawer-module_closed__X4dM- {
  transform: translateX(100%);
}
.drawer-module_drawer__M9tID .drawer-module_header__IrV2g {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drawer-module_drawer__M9tID .drawer-module_title__-Oex- {
  font-size: 36px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #00204d;
}
.drawer-module_drawer__M9tID .drawer-module_body__fGi7v {
  position: relative;
  margin: 45px 0 30px 0;
  padding: 0;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #62748c #ebf0f7;
  box-sizing: border-box;
}
.drawer-module_drawer__M9tID .drawer-module_body__fGi7v::-webkit-scrollbar {
  width: 5px !important;
  transform: translateX(45px);
}
.drawer-module_drawer__M9tID .drawer-module_body__fGi7v::-webkit-scrollbar-track {
  background: #ebf0f7 !important;
}
.drawer-module_drawer__M9tID .drawer-module_body__fGi7v::-webkit-scrollbar-thumb {
  background: #62748c !important;
  width: 5px !important;
  border-radius: 3px;
}
.drawer-module_drawer__M9tID .drawer-module_closeButton__7yw5U {
  background: none;
  font-size: 1.2em;
  height: min-content;
}
.drawer-module_drawer__M9tID .drawer-module_closeButton__7yw5U path {
  fill: black;
}

.drawer-module_overlay__Cv-ju {
  z-index: 998;
  content: "";
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 11, 26, 0.3);
}

.drawer-module_loader__-CfL- {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}/* Dropdown Menu Container styles */
.sz-dropdown-menu-module_menu-main-container__SzRWh {
  position: relative;
  display: inline-block;
}

.sz-dropdown-menu-module_dropdown-menu-container__zwW0g {
  position: absolute;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  background: white;
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 4px 4px;
}
.sz-dropdown-menu-module_dropdown-menu-container__zwW0g.sz-dropdown-menu-module_right__3VH7N {
  right: 0;
}
.sz-dropdown-menu-module_dropdown-menu-container__zwW0g.sz-dropdown-menu-module_left__oYcc9 {
  right: initial;
}

.sz-dropdown-menu-module_dropdown-menu-content__adkXY {
  width: 100%;
  padding: 4px 0;
}

a.sz-dropdown-menu-module_menu-item-button__ndHXg {
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
}

.sz-dropdown-menu-module_menu-item-button__ndHXg {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  background: white;
  padding: 10px 12px;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg .sz-dropdown-menu-module_label__c92KJ {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg .sz-dropdown-menu-module_additional-info__pYGoz {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
  padding-top: 4px;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg:hover:not([aria-disabled=true]) {
  background-color: #e5f0ff;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg:active {
  background-color: #cce1ff;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg:focus-visible {
  box-shadow: -2px 0px 0px 0px #006aff, 2px 0px 0px 0px #006aff;
  offset: -2px;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg:focus:not(:focus-visible) {
  outline: none;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg[aria-disabled=true] {
  cursor: not-allowed;
  background-color: white;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg[aria-disabled=true] .sz-dropdown-menu-module_iconContainer__G9NnR svg path {
  fill: #adbfd9;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg[aria-disabled=true] .sz-dropdown-menu-module_item-info-container__twDZi {
  color: #adbfd9;
}
.sz-dropdown-menu-module_menu-item-button__ndHXg[aria-disabled=true] .sz-dropdown-menu-module_item-info-container__twDZi .sz-dropdown-menu-module_additional-info__pYGoz {
  color: #adbfd9;
}

.sz-dropdown-menu-module_menu-button__eH8f5 .sz-dropdown-menu-module_btnLabel__v9id9 {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}

.sz-dropdown-menu-module_no-label-button__N2Apu {
  padding: 0;
}

.sz-dropdown-menu-module_item-icons-container__TYrb7 {
  display: flex;
  align-items: center;
  align-self: baseline;
}

.sz-dropdown-menu-module_item-icons-container__TYrb7 > * {
  margin-right: 12px;
}

.sz-dropdown-menu-module_item-info-container__twDZi {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}.dropdown {
  display: inline-block;
  position: relative;
}
.dropdown__list {
  position: absolute;
  top: calc(100% + 8px);
  padding: 4px 0;
  margin: 0;
  list-style: none;
  box-shadow: 2px 4px 16px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 8px;
  z-index: 10;
}
.dropdown__list::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.dropdown__list--align-left {
  left: 0;
}
.dropdown__list--align-center {
  left: 50%;
  transform: translateX(-50%);
}
.dropdown__list--align-right {
  right: 0;
}
.dropdown__trigger {
  cursor: pointer;
}.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
  padding: 0 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 100ms;
}
.dropdown-item:hover {
  background-color: #f5f5f5;
}
.dropdown-item--active {
  cursor: default;
}
.dropdown-item--active:hover {
  background-color: transparent;
}
.dropdown-item--active .dropdown-item__label {
  color: #10b7ff;
}
.dropdown-item__label {
  font-size: 14px;
  color: #000000;
}
.dropdown-item__second-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #757575;
}.sz-field-label {
  width: 100%;
}
.sz-field-label__title {
  margin-bottom: 3px;
  min-height: 16px;
  color: #62748c;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.sz-field-label__bottom-text {
  margin-top: 4px;
  height: 16px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #00204d;
}
.sz-field-label_error .sz-field-label__title,
.sz-field-label_error .sz-field-label__bottom-text {
  color: #d71717;
}
.sz-field-label_disabled .sz-field-label__title,
.sz-field-label_disabled .sz-field-label__bottom-text {
  color: #adbfd9;
  cursor: not-allowed;
}.file-upload-module_container__qV-bG {
  box-sizing: border-box;
  width: 352px;
  max-width: 100%;
  padding: 16px;
  border: 1px dashed #3388ff;
  border-radius: 5px;
  background: white;
  font-family: inherit;
  font-size: 14px;
  line-height: 16px;
  color: #00204d;
}
.file-upload-module_container__qV-bG:focus {
  outline: none;
}
.file-upload-module_container__qV-bG:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
}

.file-upload-module_full__GJGtR {
  width: 100%;
}

.file-upload-module_prompt__I21qe {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 138px;
  text-align: center;
}

.file-upload-module_fit__HWPhi .file-upload-module_prompt__I21qe {
  min-height: 0;
}

.file-upload-module_group__XL-fk {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.file-upload-module_drag__Ywh2- {
  background: #cce1ff;
}

.file-upload-module_invalid__86fnf {
  background: #ffeaea;
  border-color: #d71717;
}

.file-upload-module_failed__3Qcew {
  border-color: #d71717;
}

.file-upload-module_heading__vA65e {
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  text-wrap: pretty;
}

.file-upload-module_heading-error__je4or {
  color: #d71717;
}

.file-upload-module_description__DEfis {
  margin: 0;
  color: #62748c;
  text-wrap: pretty;
}

.file-upload-module_description-error__rOhJG {
  color: #00204d;
}

.file-upload-module_browse__TK1rq {
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: #006aff;
  text-decoration: none;
  cursor: pointer;
}
.file-upload-module_browse__TK1rq:hover {
  text-decoration: underline;
}
.file-upload-module_browse__TK1rq:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
  border-radius: 2px;
}

.file-upload-module_icon__PzQ1l {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.file-upload-module_icon__PzQ1l svg {
  display: block;
  width: 100%;
  height: 100%;
}

.file-upload-module_icon-interactive__B-rZU {
  color: #006aff;
}

.file-upload-module_icon-red__qqmtl {
  color: #d71717;
}

.file-upload-module_icon-green__mIrYQ {
  color: #007a6a;
}

.file-upload-module_row__6c5h- {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.file-upload-module_name__y90B7 {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-upload-module_icon-button__uX0O8 {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: none;
  color: #006aff;
  cursor: pointer;
}
.file-upload-module_icon-button__uX0O8:hover {
  background: #ebf0f7;
}
.file-upload-module_icon-button__uX0O8:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 1px;
}

.file-upload-module_icon-button-red__2IeL1 {
  color: #d71717;
}.file-upload-module_sz-file-upload-input__x7Dsd {
  display: flex;
  border-bottom: 1px solid #1a1f36;
  height: 25px;
  box-sizing: border-box;
  width: 100%;
  background-color: transparent;
  cursor: pointer;
  align-items: center;
  position: relative;
}
.file-upload-module_sz-file-upload-input_wrapper--focused__cKIbR {
  border-radius: 2px;
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.file-upload-module_sz-file-upload-input--disabled__K3aiq {
  border-bottom: 1px solid #adbfd9;
  cursor: not-allowed;
  color: #adbfd9;
}
.file-upload-module_sz-file-upload-input__x7Dsd input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}
.file-upload-module_sz-file-upload-input__value__B-3qL {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 10px;
}
.file-upload-module_sz-file-upload-input__label__qhh-1 {
  display: flex;
  width: 100%;
  gap: 4px;
  cursor: pointer;
}
.file-upload-module_sz-file-upload-input__label--disabled__gsuZj {
  cursor: not-allowed;
}
.file-upload-module_sz-file-upload-input__icon__W7S-k {
  width: 16px;
  height: 16px;
}
.file-upload-module_sz-file-upload-input__icon-wrapper__1MAri {
  width: 16px;
  height: 16px;
  padding-right: 4px;
}
.file-upload-module_sz-file-upload-input__icon-container__zTcWf {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 18px;
  bottom: 5px;
  cursor: pointer;
  background-color: transparent;
}
.file-upload-module_sz-file-upload-input__icon-container__zTcWf:focus {
  border-radius: 2px;
  outline: 2px solid #006aff;
}
.file-upload-module_sz-file-upload-input--error__MAayp {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #d71717;
}.informational-content-module_title__vFJVd {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  margin-bottom: 24px;
  color: #00204d;
}

.informational-content-module_container__-3MmS {
  display: flex;
  gap: 24px;
  color: #00204d;
}
.informational-content-module_container__-3MmS:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.informational-content-module_container__-3MmS.informational-content-module_vertical__nMkOC {
  flex-direction: column;
}
.informational-content-module_container__-3MmS.informational-content-module_horizontal__zhubu {
  flex-direction: row;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC {
  display: flex;
  gap: 16px;
  flex: 1;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC:focus {
  outline: 2px solid #006aff;
  border-radius: 1px;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC .informational-content-module_cardIcon__oH96c {
  min-width: 48px;
  height: 48px;
  border-radius: 90px;
  background-color: #ebf0f7;
  display: flex;
  align-items: center;
  justify-content: center;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC .informational-content-module_cardRightContent__ik5WO {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC .informational-content-module_cardRightContent__ik5WO.informational-content-module_noTitle__MQEeT {
  gap: 0;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC .informational-content-module_cardRightContent__ik5WO .informational-content-module_cardTitle__LVCSA {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.informational-content-module_container__-3MmS .informational-content-module_card__6GRnC .informational-content-module_cardRightContent__ik5WO .informational-content-module_cardSubTitle__iyDEX {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}.inline-notification-module_sz-inline-notification__L-6qt {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-radius: 8px;
}
.inline-notification-module_sz-inline-notification__L-6qt.inline-notification-module_NEUTRAL__nxBUK {
  background-color: white;
  border: 1px solid #e6f3f1;
}
.inline-notification-module_sz-inline-notification__L-6qt.inline-notification-module_INFORMATION__i46Ar {
  background-color: #e5f0ff;
}
.inline-notification-module_sz-inline-notification__L-6qt.inline-notification-module_SUCCESS__OdX4i {
  background-color: #e6f3f1;
}
.inline-notification-module_sz-inline-notification__L-6qt.inline-notification-module_WARNING__68rZa {
  background-color: #fff6ea;
}
.inline-notification-module_sz-inline-notification__L-6qt.inline-notification-module_ERROR__LUH4g {
  background-color: #ffeaea;
}
.inline-notification-module_sz-inline-notification__L-6qt:focus-visible {
  outline: 2px solid #006aff;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_content-container__uq68z {
  display: flex;
  gap: 16px;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_content-container__uq68z .inline-notification-module_text-container__mR0zL {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_body__dF12F {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_body__dF12F > * {
  line-height: 24px;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_icon-container__pd1dR {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_actions__J38bU {
  display: flex;
  gap: 16px;
}
.inline-notification-module_sz-inline-notification__L-6qt .inline-notification-module_dismiss-button__E9ExB {
  padding: 0px 12px;
}

.inline-notification-module_title__-EY-G {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  min-height: 24px;
  align-items: center;
}.link-module_container__KRlBS {
  font-size: 14px;
  line-height: 20px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding: 0 4px;
  color: #006aff;
  text-decoration: underline;
  cursor: pointer;
}

.link-module_container__KRlBS:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}

.link-module_container__KRlBS:not(.link-module_disabledLink__jmzh5):active {
  color: #005fe5;
}

.link-module_disabledLink__jmzh5 {
  cursor: not-allowed;
  color: #adbfd9;
}
.link-module_disabledLink__jmzh5 svg,
.link-module_disabledLink__jmzh5 path {
  fill: currentColor;
}.modal-buttons-module_sz-modal-buttons__NBGHH {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-end;
}.modal-module_overlay__a52Ni {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 11, 26, 0.1882352941);
  z-index: 9999;
}

.modal-module_sz-modal__6o1l7 {
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  box-shadow: 2px 4px 16px 0px rgba(0, 11, 26, 0.1215686275);
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-height: 90%;
  max-width: 90%;
}
.modal-module_sz-modal__6o1l7:focus-visible {
  outline: none;
}
.modal-module_sz-modal__6o1l7 .modal-module_header-container__2ZqJ6 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.modal-module_sz-modal__6o1l7 .modal-module_header-text__VmJOw {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #00204d;
  width: -moz-available;
  width: -webkit-fill-available;
}
.modal-module_sz-modal__6o1l7 .modal-module_action-buttons__PzSqY {
  margin-top: 24px;
}
.modal-module_sz-modal__6o1l7 .modal-module_icon-container__28rhJ {
  display: flex;
  align-items: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-right: 10px;
}
.modal-module_sz-modal__6o1l7 .modal-module_close-modal-button__a877o {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  cursor: pointer;
  background-color: transparent;
}
.modal-module_sz-modal__6o1l7 .modal-module_close-modal-button__a877o:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 3px;
}
.modal-module_sz-modal__6o1l7 .modal-module_dialogContent__j2CrK {
  flex: 1 1 100%;
}
.modal-module_sz-modal__6o1l7 .modal-module_dialogScrollable__wu8vQ {
  overflow-y: scroll;
}.multi-file-upload-module_container__GK0m3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  color: #00204d;
}

.multi-file-upload-module_list__TUb1V {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.multi-file-upload-module_row__4Zfgv {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
}

.multi-file-upload-module_row--uploading__o9GzY {
  border-color: #cce1ff;
  background: #f4f8ff;
}

.multi-file-upload-module_row--uploaded__9rCG8 {
  border-color: #006aff;
}

.multi-file-upload-module_row--fixed__2Q4cm {
  align-items: center;
  padding: 12px 16px;
  border-color: #ebf0f7;
}

.multi-file-upload-module_row--failed__8b78u {
  border-color: #d71717;
  background: #ffeaea;
}

.multi-file-upload-module_row-icon__-nNTI {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e6f1fa;
  color: #0070bf;
}
.multi-file-upload-module_row-icon__-nNTI svg {
  display: block;
}
.multi-file-upload-module_row-icon__-nNTI svg path {
  fill: currentColor;
}

.multi-file-upload-module_row-body__ZT39J {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.multi-file-upload-module_eyebrow__IT6io {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
}

.multi-file-upload-module_status__ffKL6 {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
}

.multi-file-upload-module_status--uploading__wNNQZ {
  margin-top: 4px;
}

.multi-file-upload-module_status--uploaded__2JgJc {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}

.multi-file-upload-module_status--error__cI8BK {
  color: #d71717;
}

.multi-file-upload-module_name__qIraO {
  display: flex;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}

.multi-file-upload-module_progress__k27ug {
  width: 100%;
  margin-top: 8px;
}

.multi-file-upload-module_row-trailing__P4BH- {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  align-self: stretch;
  width: 32px;
  min-height: 32px;
}

.multi-file-upload-module_badge__47skT {
  position: absolute;
  inset: 0;
  margin: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffd129;
  color: #00204d;
  transition: opacity 0.15s ease;
}
.multi-file-upload-module_badge__47skT svg {
  display: block;
}
.multi-file-upload-module_badge__47skT svg path {
  fill: currentColor;
}

.multi-file-upload-module_row-trailing__P4BH- .multi-file-upload-module_remove__e5NBR {
  position: absolute;
  inset: 0;
  margin: auto;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.multi-file-upload-module_row--editable__Vmrgs:hover .multi-file-upload-module_badge__47skT,
.multi-file-upload-module_row--editable__Vmrgs:focus-within .multi-file-upload-module_badge__47skT,
.multi-file-upload-module_row--editable__Vmrgs.multi-file-upload-module_row--failed__8b78u .multi-file-upload-module_badge__47skT {
  opacity: 0;
}
.multi-file-upload-module_row--editable__Vmrgs:hover .multi-file-upload-module_row-trailing__P4BH- .multi-file-upload-module_remove__e5NBR,
.multi-file-upload-module_row--editable__Vmrgs:focus-within .multi-file-upload-module_row-trailing__P4BH- .multi-file-upload-module_remove__e5NBR,
.multi-file-upload-module_row--editable__Vmrgs.multi-file-upload-module_row--failed__8b78u .multi-file-upload-module_row-trailing__P4BH- .multi-file-upload-module_remove__e5NBR {
  opacity: 1;
}

@media (hover: none) {
  .multi-file-upload-module_row--editable__Vmrgs.multi-file-upload-module_row--uploaded__9rCG8 .multi-file-upload-module_badge__47skT {
    opacity: 0;
  }
  .multi-file-upload-module_row--editable__Vmrgs.multi-file-upload-module_row--uploaded__9rCG8 .multi-file-upload-module_row-trailing__P4BH- .multi-file-upload-module_remove__e5NBR {
    opacity: 1;
  }
}
.multi-file-upload-module_box__BitgR {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border: 1px dashed #adbfd9;
  border-radius: 8px;
  background: transparent;
  box-sizing: border-box;
  transition: padding 0.25s ease, border-color 0.2s ease, background-color 0.15s ease;
}
.multi-file-upload-module_box__BitgR:focus {
  outline: none;
}

.multi-file-upload-module_box--drag__4DCV5 {
  padding: 28px 16px;
  border: 1.5px dashed #006aff;
  background: #e5f0ff;
}

.multi-file-upload-module_box-icon__6XFQh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ebf0f7;
  color: #62748c;
  transition: background-color 0.15s ease;
}
.multi-file-upload-module_box-icon__6XFQh svg {
  display: block;
}
.multi-file-upload-module_box-icon__6XFQh svg path {
  fill: currentColor;
}
.multi-file-upload-module_box--drag__4DCV5 .multi-file-upload-module_box-icon__6XFQh {
  background: white;
  color: #006aff;
}

.multi-file-upload-module_box-body__io6yd {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 0;
}

.multi-file-upload-module_box-title__J1lyk {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}

.multi-file-upload-module_box-hint__Qus91 {
  margin: 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
  text-wrap: pretty;
}

.multi-file-upload-module_browse__Zbp2z {
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: #006aff;
  text-decoration: none;
  cursor: pointer;
}
.multi-file-upload-module_browse__Zbp2z:hover {
  text-decoration: underline;
}
.multi-file-upload-module_browse__Zbp2z:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
  border-radius: 2px;
}

.multi-file-upload-module_error__8f3fr {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #d71717;
}

.multi-file-upload-module_box-trailing__NHX02 {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  height: 48px;
}.progress-bar-module_progressBar__JRrJR {
  width: 100%;
}

.progress-bar-module_root__dqvpE {
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: #ebf0f7;
}
.progress-bar-module_root__dqvpE.progress-bar-module_accent__Z21jd {
  background-color: #cce1ff;
}
.progress-bar-module_root__dqvpE.progress-bar-module_completeInteractive__u-Gom .progress-bar-module_indicator__3Wa-y[data-state=complete] {
  background-color: #006aff;
}
.progress-bar-module_root__dqvpE.progress-bar-module_sm__iwR1f {
  height: 4px;
  border-radius: 2px;
}
.progress-bar-module_root__dqvpE.progress-bar-module_sm__iwR1f .progress-bar-module_indicator__3Wa-y {
  border-radius: 2px;
}
.progress-bar-module_root__dqvpE.progress-bar-module_md__c-0Vc {
  height: 8px;
  border-radius: 4px;
}
.progress-bar-module_root__dqvpE.progress-bar-module_md__c-0Vc .progress-bar-module_indicator__3Wa-y {
  border-radius: 4px;
}
.progress-bar-module_root__dqvpE.progress-bar-module_lg__4eqRF {
  height: 12px;
  border-radius: 4px;
}
.progress-bar-module_root__dqvpE.progress-bar-module_lg__4eqRF .progress-bar-module_indicator__3Wa-y {
  border-radius: 4px;
}

.progress-bar-module_indicator__3Wa-y {
  height: 100%;
  background-color: #006aff;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s linear;
}
.progress-bar-module_indicator__3Wa-y[data-state=complete] {
  background-color: #007a6a;
}
.progress-bar-module_indicator__3Wa-y[data-state=error] {
  background-color: #d71717;
}
.progress-bar-module_indicator__3Wa-y[data-state=indeterminate] {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40%;
  animation: progress-bar-module_sweep__Sc1ip 1.4s cubic-bezier(0.65, 0.05, 0.36, 1) infinite;
}

@keyframes progress-bar-module_sweep__Sc1ip {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(250%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-module_indicator__3Wa-y {
    transition: none;
  }
  .progress-bar-module_indicator__3Wa-y[data-state=indeterminate] {
    width: 100%;
    animation: none;
    transform: none;
    opacity: 0.4;
  }
}
.progress-bar-module_header__kzOhi {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}

.progress-bar-module_label__pDwGS {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}

.progress-bar-module_value__r9BQL {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #62748c;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.progress-bar-module_value__r9BQL.progress-bar-module_error__TQfjQ {
  color: #d71717;
}

.progress-bar-module_helper__9L8e4 {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  margin-top: 6px;
  color: #62748c;
}
.progress-bar-module_helper__9L8e4.progress-bar-module_error__TQfjQ {
  color: #d71717;
}

.progress-bar-module_inlineRow__nFs4A {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-bar-module_inlineTrack__LVlin {
  flex: 1 1 auto;
  min-width: 0;
}.sz-multiselect {
  width: 100% !important;
}
.sz-multiselect:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.sz-multiselect--underline .sz-multiselect__control {
  border-bottom: 1px solid #00204d !important;
}
.sz-multiselect--underline.sz-multiselect--is-disabled .sz-multiselect__control, .sz-multiselect.sz-multiselect--has-error.sz-multiselect--is-disabled .sz-multiselect__control {
  border-bottom: 1px solid #adbfd9 !important;
}
.sz-multiselect--is-disabled .sz-multiselect__multi-value__remove, .sz-multiselect--is-disabled .sz-multiselect__indicator {
  cursor: not-allowed;
  pointer-events: none;
}
.sz-multiselect.sz-multiselect--has-error .sz-multiselect__control {
  border-bottom: 1px solid #d71717 !important;
}
.sz-multiselect.sz-multiselect--disabled .sz-multiselect__control {
  border-bottom: 1px solid #adbfd9 !important;
  cursor: not-allowed;
}
.sz-multiselect.sz-multiselect--disabled .sz-multiselect__indicator {
  cursor: not-allowed;
  pointer-events: none;
}
.sz-multiselect__menu {
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1) !important;
}
.sz-multiselect__control {
  min-height: 25px !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  cursor: pointer;
}
.sz-multiselect__control:focus {
  outline: none !important;
}
.sz-multiselect__control--is-disabled {
  background-color: #ffffff !important;
  pointer-events: auto;
}
.sz-multiselect__control--is-disabled .sz-multiselect__indicator svg {
  display: none;
}
.sz-multiselect__value-container {
  padding: 0 !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.sz-multiselect__multi-value {
  margin: 0 2px 2px 2px !important;
  background-color: #10b7ff !important;
  color: #ffffff !important;
}
.sz-multiselect__multi-value__remove:hover {
  background-color: #10b7ff !important;
  color: #ffffff !important;
  cursor: pointer;
}
.sz-multiselect__multi-value__label {
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.33 !important;
  letter-spacing: normal !important;
}
.sz-multiselect__indicator-separator {
  display: none !important;
}
.sz-multiselect__input-container {
  margin: 0 !important;
  padding: 0 !important;
}
.sz-multiselect__placeholder {
  color: #9e9e9e;
  margin: 0 !important;
}
.sz-multiselect__indicators {
  height: 24px;
}
.sz-multiselect--has-indicator .sz-multiselect__indicator {
  display: block !important;
  padding: 0 4px;
  height: 16px;
  cursor: pointer;
}
.sz-multiselect--has-indicator .sz-multiselect__indicator svg {
  width: 16px !important;
  height: 16px !important;
}
.sz-multiselect__indicator {
  display: none !important;
}
.sz-multiselect__dropdown-indicator {
  padding-right: 0 !important;
}
.sz-multiselect__option {
  padding: 8px 4px !important;
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 1.43 !important;
  color: #757575 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 28px;
  cursor: pointer !important;
  border: 2px solid transparent;
}
.sz-multiselect__option:hover {
  background-color: #deebff !important;
  border-right-color: transparent;
  border-left-color: transparent;
}
.sz-multiselect__option--is-selected {
  background-color: #ffffff !important;
}
.sz-multiselect__option--is-selected [class^=multiselect_labelWrapper] span:first-child {
  font-weight: 500;
}
.sz-multiselect__option--is-focused {
  background-color: white !important;
  border-right-color: var(--color-interactive-dark);
  border-left-color: var(--color-interactive-dark);
}
.sz-multiselect__menu-list {
  padding-top: 6px !important;
}
.sz-multiselect__menu-list::-webkit-scrollbar {
  width: 12px;
}
.sz-multiselect__menu-list::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 50px;
  background-color: #62748c !important;
  background-clip: padding-box;
}
.sz-multiselect__input {
  caret-color: transparent !important;
}
.sz-multiselect__menu-wrapper {
  padding: 4px 0;
}
.sz-multiselect__menu-button-wrapper {
  padding: 4px 16px;
}
.sz-multiselect__more-selected-badge {
  padding: 3px 3px 3px 6px;
  margin: 0 2px 2px 2px;
  background-color: #10b7ff;
  color: #ffffff;
  border-radius: 2px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.sz-multiselect__multi-value-remove-placeholder {
  width: 3px;
}
.sz-multiselect__loading-indicator {
  display: none !important;
}

.multiselect-module_chipSpacing__OzcxJ {
  margin-right: 2px;
}

.multiselect-module_selectOption__OC-68 {
  max-width: 100% !important;
  display: grid;
  align-items: center;
  grid-template-columns: 20px 1fr;
  row-gap: 4px;
}
.multiselect-module_selectOption__OC-68 > div:first-child {
  justify-self: center;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_circle__7T1ma {
  background-color: #ffd129;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid black;
  width: 8px;
  height: 8px;
  margin-right: 3px;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelWrapper__mXeJh {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #00204d;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_label__4uQU9 {
  flex: 0 1 min-content;
  display: flex;
  align-items: center;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_selectOptionNote__qvrE1 {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelDescriptionContainer__A-pMU {
  flex: 1 0 max-content;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelDescriptionWrapper__4QZKA {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelDescription__t7lOC {
  display: inline-flex;
  margin-left: 5px;
  gap: 5px;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelDescription__t7lOC span {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelCounter__NqIPY {
  flex: 1 0 auto;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelCounter__NqIPY .multiselect-module_labelCounterContent__NPG8u {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #00204d;
}
.multiselect-module_selectOption__OC-68 .multiselect-module_labelCounter__NqIPY .multiselect-module_labelCounterIcon__o6yh4 {
  width: 16px;
  height: 16px;
}

.multiselect-module_chip__3ngLN {
  margin-right: 4px;
}
.multiselect-module_chip__3ngLN:hover {
  cursor: pointer;
}

.multiselect-module_clearValueButton__2neJO {
  background-color: unset;
}
.multiselect-module_clearValueButton__2neJO:focus {
  outline: 2px solid #006aff;
  border-radius: 1px;
}

.multiselect-module_loadMoreWrapper__DguzE {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.multiselect-module_disabledOptions__Mimqi {
  pointer-events: none;
}

.multiselect-module_truncatedLabel__NCatw {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.multiselect-module_paginatedOptionsLoader__1-6HC {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
}.navigational-link-module_container__KCMyF {
  font-size: 12px;
  line-height: 16px;
  width: max-content;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: #00204d;
  padding: 4px 8px;
}
.navigational-link-module_container__KCMyF .navigational-link-module_icon__wkTqH {
  color: #00204d;
}
.navigational-link-module_container__KCMyF > * {
  display: block;
}
.navigational-link-module_container__KCMyF:hover {
  cursor: pointer;
  color: #3388ff;
  text-decoration: underline;
}
.navigational-link-module_container__KCMyF:hover svg path {
  fill: #3388ff;
}
.navigational-link-module_container__KCMyF:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 2px;
}
.navigational-link-module_container__KCMyF:hover {
  cursor: pointer;
  color: #3388ff;
  text-decoration: underline;
}
.navigational-link-module_container__KCMyF:hover svg path {
  fill: #3388ff;
}
.navigational-link-module_container__KCMyF .navigational-link-module_linkContainer__hOwzv {
  font-size: 12px;
}
.navigational-link-module_container__KCMyF .navigational-link-module_linkContainer__hOwzv > * {
  font-size: 12px;
}
.navigational-link-module_container__KCMyF .navigational-link-module_linkContainer__hOwzv:active {
  color: #005fe5;
}

.navigational-link-module_activatedLink__0DEh3 {
  color: #000b1a;
  pointer-events: none;
}
.navigational-link-module_activatedLink__0DEh3 a:visited {
  text-decoration: none;
  color: unset;
}
.navigational-link-module_activatedLink__0DEh3 .navigational-link-module_linkContainer__hOwzv,
.navigational-link-module_activatedLink__0DEh3 * {
  font-weight: 500;
}
.navigational-link-module_activatedLink__0DEh3 svg path {
  fill: #000b1a;
}

.navigational-link-module_disabledLink__Du2E2 {
  color: #adbfd9;
  pointer-events: none;
}
.navigational-link-module_disabledLink__Du2E2 svg path {
  fill: #adbfd9;
}.sz-toast {
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.1);
  padding: 16px !important;
  gap: 16px;
  align-items: normal !important;
  width: 380px;
}
.sz-toast div {
  margin: 0;
}
.sz-toast svg {
  flex-shrink: 0;
}.notification-body-module_notificationBody__yhJBZ {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  flex-grow: 1;
}
.notification-body-module_notificationBody__yhJBZ .notification-body-module_header__OdaRC {
  display: flex;
  justify-content: space-between;
  margin-top: 3px;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.notification-body-module_notificationBody__yhJBZ .notification-body-module_header__OdaRC .notification-body-module_closeIconWrapper__mdNoJ {
  padding-top: 2px;
}
.notification-body-module_notificationBody__yhJBZ .notification-body-module_header__OdaRC .notification-body-module_closeIconWrapper__mdNoJ .notification-body-module_closeIcon__VVn30:hover {
  cursor: pointer;
}
.notification-body-module_notificationBody__yhJBZ .notification-body-module_content__le2Jm {
  margin-top: 4px;
  margin-right: 28px;
}.page-indicator-module_pageIndicator__TZY4- {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 40px;
  border: 2px solid #e6f1fa;
}
.page-indicator-module_pageIndicator__TZY4- .page-indicator-module_hidden__9xSpl {
  position: absolute;
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}
.page-indicator-module_pageIndicator__TZY4- .page-indicator-module_pageIndicatorText__a2pet, .page-indicator-module_pageIndicator__TZY4- .page-indicator-module_pageIndicatorSuffix__zLw97 {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  line-height: 24px;
}
.page-indicator-module_pageIndicator__TZY4- .page-indicator-module_pageIndicatorSuffix__zLw97 {
  color: #0070bf;
}
.popper-module_anchor__85o-D {
  display: inline-flex;
}

@keyframes popper-module_popper-in__ltaPT {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.popper-module_panel__LNMHJ {
  box-sizing: border-box;
  background: white;
  border: 1px solid #ebf0f7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 32, 77, 0.12), 0 1px 2px rgba(0, 32, 77, 0.08);
  outline: none;
  animation: popper-module_popper-in__ltaPT 0.12s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .popper-module_panel__LNMHJ {
    animation: none;
  }
}

.popper-module_header__iH27U {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 0 16px;
}

.popper-module_title__Ckwdk {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  padding-top: 2px;
}

.popper-module_close__LqwlG {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #62748c;
}
.popper-module_close__LqwlG:hover {
  background: #ebf0f7;
  color: #00204d;
}
.popper-module_close__LqwlG:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 1px;
}

.popper-module_body__FOOy6 {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  padding: 16px;
  color: #62748c;
}

.popper-module_body-below-header__dNZv9 {
  padding: 8px 16px 16px;
}

.popper-module_footer__hh85I {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #ebf0f7;
}

/* The arrow caret is inline-styled in popper.tsx — its geometry (side-dependent
   borders and 6px protrusion) comes verbatim from the proposal source. */.radio-button-module_container__EEDt- {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}
.radio-button-module_container__EEDt-:not(.radio-button-module_withImage__QVuh3) {
  padding: 1px 3px;
  display: grid;
  grid-template-columns: 20px auto;
  align-items: center;
  gap: 4px;
  text-align: left;
}
.radio-button-module_container__EEDt-:not(.radio-button-module_withImage__QVuh3), .radio-button-module_container__EEDt-:not(.radio-button-module_withImage__QVuh3) * {
  box-sizing: border-box;
}
.radio-button-module_container__EEDt-:not(.radio-button-module_withImage__QVuh3):focus-within {
  outline: 2px solid #006aff;
  border-radius: 5px;
}
.radio-button-module_container__EEDt-:hover {
  cursor: pointer;
}
.radio-button-module_container__EEDt- input[type=radio] {
  -webkit-appearance: none;
  appearance: none;
  font: inherit;
  width: 18px;
  height: 18px;
  border: 0.15em solid #62748c;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.radio-button-module_container__EEDt- input[type=radio]:checked {
  border-color: #ffd129;
  background-color: #ffd129;
}
.radio-button-module_container__EEDt- input[type=radio]:checked::before {
  transform: scale(1);
}
.radio-button-module_container__EEDt- input[type=radio]::before {
  content: "";
  border-radius: 50%;
  transition: 120ms transform ease-in-out;
  border: 4px solid #1a1f36;
  box-shadow: inset 1em 1em #ffd129;
  transform: scale(0);
}
.radio-button-module_container__EEDt-.radio-button-module_error__WluB6 input[type=radio] {
  border-color: #d71717;
  border: 2px solid #d71717;
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG {
  cursor: not-allowed;
  color: #adbfd9;
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG * {
  cursor: not-allowed;
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG input[type=radio] {
  border-color: #adbfd9;
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG input[type=radio]:checked {
  border-color: #ebf0f7;
  background-color: #ebf0f7;
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG input[type=radio]:checked::before {
  transform: scale(1);
}
.radio-button-module_container__EEDt-.radio-button-module_disabled__o0NbG input[type=radio]::before {
  content: "";
  border-radius: 50%;
  transition: 120ms transform ease-in-out;
  border: 4px solid #adbfd9;
  box-shadow: inset 1em 1em #1a1f36;
  transform: scale(0);
}

.radio-button-module_withImage__QVuh3 input[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.radio-button-module_withImage__QVuh3:focus-within .radio-button-module_image__IgWK0 {
  outline: 2px solid #006aff;
  border-radius: 5px;
  outline-offset: 2px;
}
.radio-button-module_withImage__QVuh3.radio-button-module_squareOutline__cwFee:focus-within .radio-button-module_image__IgWK0 {
  border-radius: 0px;
}
.radio-button-module_withImage__QVuh3 .radio-button-module_image__IgWK0 svg {
  box-sizing: border-box;
}
.radio-button-module_withImage__QVuh3.radio-button-module_error__WluB6 .radio-button-module_image__IgWK0 .radio-button-module_wrapper__GTvyw {
  border: 1px solid #d71717;
  box-sizing: border-box;
}

.radio-button-module_svgWithLabel__DdZtO {
  width: 100%;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_image__IgWK0 {
  width: 100%;
  height: 100%;
  position: relative;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_image__IgWK0 svg {
  display: block;
  width: 100%;
  height: 100%;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_image__IgWK0 .radio-button-module_wrapper__GTvyw {
  mix-blend-mode: multiply;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border-radius: 5px;
  border: none;
  position: absolute;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_image__IgWK0:hover .radio-button-module_wrapper__GTvyw {
  display: block;
  background-color: #e6f1fa;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_image__IgWK0:active .radio-button-module_wrapper__GTvyw {
  display: block;
  background-color: #cce1ff;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_label__cdHBo {
  margin-top: 8px;
  position: relative;
  text-align: center;
  min-height: 17px;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_label__cdHBo .radio-button-module_svgContainer__BtrmH {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  margin-right: 5px;
  margin-top: -3px;
}
.radio-button-module_svgWithLabel__DdZtO .radio-button-module_label__cdHBo .radio-button-module_svgContainer__BtrmH svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 3px;
  left: 0;
}

.radio-button-module_svgWithLabelDisabled__ninFa {
  color: #adbfd9;
}
.radio-button-module_svgWithLabelDisabled__ninFa .radio-button-module_image__IgWK0 .radio-button-module_wrapper__GTvyw {
  display: block;
  background-color: #ebf0f7;
}.rating-module_ratingContainer__f-x0v {
  display: inline-flex;
  align-items: center;
  height: 100%;
}
.rating-module_ratingContainer__f-x0v .rating-module_star__I48hq {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  aspect-ratio: 1;
}
.rating-module_ratingContainer__f-x0v .rating-module_star__I48hq .rating-module_icon__JJN3N {
  width: 100%;
  height: 100%;
}.score-card-module_scoreCard__1I-3f {
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: #e5f0ff;
  border-radius: 5px;
  gap: 8px;
  color: #00204d;
}
.score-card-module_scoreCard__1I-3f .score-card-module_tooltip__uzbU1 {
  text-align: center;
}
.score-card-module_scoreCard__1I-3f .score-card-module_header__iRGfC {
  display: flex;
  align-items: center;
  gap: 8px;
}
.score-card-module_scoreCard__1I-3f .score-card-module_header__iRGfC .score-card-module_title__uV-CH {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.score-card-module_scoreCard__1I-3f .score-card-module_header__iRGfC .score-card-module_infoIconWrapper__rPcL4 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.score-card-module_scoreCard__1I-3f .score-card-module_content__N6AIF {
  display: flex;
  align-items: center;
  gap: 8px;
}
.score-card-module_scoreCard__1I-3f .score-card-module_content__N6AIF .score-card-module_score__8-yNy {
  font-size: 36px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.score-card-module_scoreCard__1I-3f .score-card-module_content__N6AIF .score-card-module_ratingSection__Cc9Gr {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 4px;
}
.score-card-module_scoreCard__1I-3f .score-card-module_content__N6AIF .score-card-module_ratingSection__Cc9Gr .score-card-module_rating__j-ztE {
  height: 12px;
}
.score-card-module_scoreCard__1I-3f .score-card-module_content__N6AIF .score-card-module_ratingSection__Cc9Gr .score-card-module_subtitle__Wv3mQ {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}.score-indicator-module_scoreIndicator__PeL4Q {
  display: flex;
  gap: 1px;
  align-items: center;
}
.score-indicator-module_scoreIndicator__PeL4Q .score-indicator-module_indicatorWrapper__jCI9p {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.score-indicator-module_scoreIndicator__PeL4Q .score-indicator-module_indicatorWrapper__jCI9p .score-indicator-module_indicator__aE8I5 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid #00204d;
  background-color: white;
}
.score-indicator-module_scoreIndicator__PeL4Q .score-indicator-module_text__wmafx {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.score-indicator-module_scoreIndicator__PeL4Q .score-indicator-module_text__wmafx .score-indicator-module_integralIcon__Isewb {
  margin-left: 1px;
}

.score-indicator-module_dark__mYA7H .score-indicator-module_indicatorWrapper__jCI9p .score-indicator-module_indicator__aE8I5 {
  border-color: white;
  background-color: #00204d;
}
.score-indicator-module_dark__mYA7H .score-indicator-module_text__wmafx {
  color: white;
}
.score-indicator-module_dark__mYA7H .score-indicator-module_text__wmafx .score-indicator-module_darkIntegralIcon__RPUbY path {
  fill: white;
}.search:focus-within,
.sz-search:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.search__placeholder,
.sz-search__placeholder {
  color: #00204d !important;
}
.search__control-icon,
.sz-search__control-icon {
  margin-left: 8px;
}
.search__control-icon path,
.sz-search__control-icon path {
  fill: #006aff;
}
.search__value-container,
.sz-search__value-container {
  margin-left: 5px !important;
}
.search__search-btn, .search__clear-btn,
.sz-search__search-btn,
.sz-search__clear-btn {
  background: unset;
  height: unset !important;
  border: none;
}
.search__search-btn .button__content, .search__clear-btn .button__content,
.sz-search__search-btn .button__content,
.sz-search__clear-btn .button__content {
  display: flex;
  align-items: center;
}
.search__search-btn path, .search__clear-btn path,
.sz-search__search-btn path,
.sz-search__clear-btn path {
  fill: #00204d;
}
.search__clear-btn,
.sz-search__clear-btn {
  width: 20px;
  margin: 0 5px;
}
.search__clear-btn:focus,
.sz-search__clear-btn:focus {
  outline: 2px solid #006aff;
  outline-offset: 2px;
  border-radius: 3px;
}
.search__search-btn,
.sz-search__search-btn {
  padding: 4px 12px !important;
  margin: 2px 0 !important;
  margin-right: 3px !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
}
.search__search-btn-icon,
.sz-search__search-btn-icon {
  margin-right: 4px;
}
.search__menu,
.sz-search__menu {
  margin-top: 4px !important;
}
.search__option,
.sz-search__option {
  padding: 10px 20px !important;
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 1.43 !important;
  color: #00204d !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 28px;
  cursor: pointer !important;
  border: 2px solid transparent;
}
.search__option-label-text,
.sz-search__option-label-text {
  color: #00204d;
}
.search__option-label-2,
.sz-search__option-label-2 {
  color: #62748c !important;
}
.search__option:hover,
.sz-search__option:hover {
  background-color: #e5f0ff !important;
  border-right-color: transparent;
  border-left-color: transparent;
}
.search__option--is-selected,
.sz-search__option--is-selected {
  background-color: #ffffff !important;
}
.search__option--is-focused,
.sz-search__option--is-focused {
  background-color: white !important;
  border-right-color: var(--color-interactive-dark);
  border-left-color: var(--color-interactive-dark);
}
.search__option-label,
.sz-search__option-label {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000000;
}
.search__option-label-2,
.sz-search__option-label-2 {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  margin-top: 8px;
  color: #757575;
}
.search__option-icon,
.sz-search__option-icon {
  margin-left: 8px;
}
.search__load-more-wrapper,
.sz-search__load-more-wrapper {
  display: flex;
  justify-content: center;
  margin: 12px 0;
}
.search__menu-list,
.sz-search__menu-list {
  padding: 0 !important;
}
.search__menu-list::-webkit-scrollbar-thumb,
.sz-search__menu-list::-webkit-scrollbar-thumb {
  background-color: #62748c !important;
}
.search__menu-notice,
.sz-search__menu-notice {
  padding: 0 !important;
}
.search__reverse-order,
.sz-search__reverse-order {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.search .searching-label,
.sz-search .searching-label {
  color: #62748c;
  padding: 22px 12px;
  text-align: center;
  box-sizing: border-box;
  font-size: 12px;
}
.search .sz-search__control,
.sz-search .sz-search__control {
  border-color: #00204d;
}
.search .sz-search__input-container,
.search .sz-search__placeholder,
.sz-search .sz-search__input-container,
.sz-search .sz-search__placeholder {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}
.search .search__control-icon,
.sz-search .search__control-icon {
  margin-left: 3px !important;
}
.search--disabled:hover *,
.sz-search--disabled:hover * {
  cursor: not-allowed !important;
}
.search--disabled .search__control-icon path,
.sz-search--disabled .search__control-icon path {
  fill: #adbfd9;
}
.search--disabled .search__search-btn,
.sz-search--disabled .search__search-btn {
  border-color: #adbfd9 !important;
  color: #adbfd9 !important;
}
.search--disabled .sz-search__input,
.sz-search--disabled .sz-search__input {
  caret-color: transparent !important;
}
.search--disabled .sz-search__placeholder,
.sz-search--disabled .sz-search__placeholder {
  color: #adbfd9 !important;
}
.search--disabled .sz-search__control,
.sz-search--disabled .sz-search__control {
  border-color: #adbfd9 !important;
}.text-input-module_sz-text-input__Gr3k5 {
  box-sizing: border-box;
  width: 100%;
  background-color: transparent;
  height: 25px;
}
.text-input-module_sz-text-input_focused__o5qft {
  border-radius: 2px;
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.text-input-module_sz-text-input_error__omzg0 .text-input-module_sz-text-input__input-wrapper__XU6it {
  border-bottom: 1px solid #d71717;
}
.text-input-module_sz-text-input_error__omzg0 .text-input-module_sz-text-input__input-element__c9Gmb::placeholder {
  color: #d71717;
}
.text-input-module_sz-text-input_disabled__Ls5bJ .text-input-module_sz-text-input__input-wrapper__XU6it {
  border-bottom: 1px solid #adbfd9;
}
.text-input-module_sz-text-input_disabled__Ls5bJ .text-input-module_sz-text-input__input-element__c9Gmb {
  cursor: not-allowed;
  caret-color: transparent;
  color: #62748c;
}
.text-input-module_sz-text-input_disabled__Ls5bJ .text-input-module_sz-text-input__input-element__c9Gmb::placeholder {
  color: #adbfd9;
}
.text-input-module_sz-text-input_disabled__Ls5bJ .text-input-module_sz-text-input__password-visibility-icon__18Nfl {
  cursor: not-allowed;
}
.text-input-module_sz-text-input_disabled__Ls5bJ .text-input-module_sz-text-input__password-visibility-icon__18Nfl path {
  fill: #adbfd9;
}
.text-input-module_sz-text-input__input-wrapper__XU6it {
  display: flex;
  border-bottom: 1px solid #00204d;
  height: 24px;
}
.text-input-module_sz-text-input__input-element__c9Gmb {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  padding-left: 0;
  border: 0;
  color: #00204d;
  background-color: transparent;
  border-radius: 0;
  width: 100%;
  height: 20px;
}
.text-input-module_sz-text-input__input-element__c9Gmb::placeholder {
  color: #00204d;
  opacity: 1;
}
.text-input-module_sz-text-input__icon-wrapper__q3n-e {
  display: flex;
  align-content: center;
}
.text-input-module_sz-text-input__password-visibility-button__5nnA8 {
  background-color: transparent;
  border-radius: 2px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
}
.text-input-module_sz-text-input__password-visibility-button__5nnA8:focus-visible {
  outline: 2px solid #006aff;
}
.text-input-module_sz-text-input__password-visibility-button__5nnA8:focus:not(:focus-visible) {
  outline: none;
}
.text-input-module_sz-text-input__password-visibility-icon__18Nfl {
  width: 16px;
  height: 16px;
}
.text-input-module_sz-text-input__character-counter__Lk6wd {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
  margin-left: 4px;
}
.text-input-module_sz-text-input__character-counter-error__F5awk {
  color: #d71717;
}.searchable-select-module_overlay__619Fu,
.searchable-select-module_inline__winzt {
  width: 100%;
}

.searchable-select-module_multiControl__yIV2k {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 24px;
  width: 100%;
  padding-bottom: 4px;
  border-bottom: 1px solid #00204d;
}
.searchable-select-module_multiControl__yIV2k.searchable-select-module_error__vR4yJ {
  border-bottom-color: #d71717;
}
.searchable-select-module_multiControl__yIV2k.searchable-select-module_disabled__o6ijJ {
  border-bottom-color: #adbfd9;
}

.searchable-select-module_chip__-hiQk {
  flex-shrink: 0;
}

.searchable-select-module_multiInput__rzd3- {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  flex: 1;
  min-width: 60px;
  background: transparent;
  border: 0;
  outline: none;
  color: #00204d;
}
.searchable-select-module_multiInput__rzd3-::placeholder {
  color: #62748c;
}
.searchable-select-module_multiInput__rzd3-:disabled {
  color: #adbfd9;
  cursor: not-allowed;
}

.searchable-select-module_actions__gdF5r {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.searchable-select-module_iconButton__DOfQr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #62748c;
}
.searchable-select-module_iconButton__DOfQr:hover {
  color: #00204d;
}
.searchable-select-module_iconButton__DOfQr:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 1px;
}
.searchable-select-module_iconButton__DOfQr:disabled {
  cursor: not-allowed;
}

.searchable-select-module_chevron__usG-8 {
  color: #00204d;
  transition: transform 0.15s ease;
}

.searchable-select-module_chevronOpen__RalH7 {
  transform: rotate(180deg);
}

.searchable-select-module_content__5xehk {
  min-width: var(--radix-popover-trigger-width);
  background: white;
  border-radius: 0 0 4px 4px;
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1019607843);
  z-index: 10;
}

.searchable-select-module_inline__winzt .searchable-select-module_list__deRK1 {
  border: 1px solid #ebf0f7;
  border-radius: 0 0 4px 4px;
  margin-top: 4px;
}

.searchable-select-module_list__deRK1 {
  max-height: var(--radix-popover-content-available-height, 320px);
  overflow-y: auto;
  padding: 4px 0;
  scrollbar-width: thin;
  scrollbar-color: #62748c transparent;
}
.searchable-select-module_list__deRK1::-webkit-scrollbar {
  width: 6px;
}
.searchable-select-module_list__deRK1::-webkit-scrollbar-track {
  background: transparent;
}
.searchable-select-module_list__deRK1::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #62748c;
}

.searchable-select-module_group__4OXFC {
  display: flex;
  flex-direction: column;
}

.searchable-select-module_groupLabel__zPatn {
  display: block;
  padding: 12px 0 4px 16px;
  color: #62748c;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}

.searchable-select-module_groupLabelLarge__BSCP5 {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}
.searchable-select-module_groupLabelLarge__BSCP5 .searchable-select-module_groupCount__E92yo {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}

.searchable-select-module_groupCount__E92yo {
  color: #62748c;
}

.searchable-select-module_separator__wwLEn {
  height: 1px;
  margin: 0 4px;
  background-color: #ebf0f7;
}

.searchable-select-module_item__OZXrO {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 14px 20px 14px 0;
  color: #00204d;
  cursor: pointer;
  outline: none;
  user-select: none;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.searchable-select-module_item__OZXrO.searchable-select-module_itemActive__yVY0N {
  background-color: #e5f0ff;
}
.searchable-select-module_item__OZXrO.searchable-select-module_itemSelected__GanK2 .searchable-select-module_itemLabel__Ms08c {
  font-weight: 500;
}
.searchable-select-module_item__OZXrO.searchable-select-module_itemDisabled__NVmg0 {
  color: #adbfd9;
  cursor: not-allowed;
  pointer-events: none;
}

.searchable-select-module_itemIndicator__rEciX {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  margin-left: 4px;
  flex-shrink: 0;
}

.searchable-select-module_indicatorDot__jU2ub {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffd129;
  border: 1px solid #00204d;
}

.searchable-select-module_itemIcon__VX9vn {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.searchable-select-module_itemLabel__Ms08c {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchable-select-module_itemDescription__EkLpN {
  color: #62748c;
  white-space: nowrap;
}

.searchable-select-module_empty__Z6un1 {
  padding: 8px 12px;
  text-align: center;
  color: #00204d;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}

.searchable-select-module_loading__cFbS2 {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
}.segmented-control-module_root__MZjDJ {
  display: inline-flex;
  align-items: stretch;
  width: fit-content;
  padding: 3px;
  gap: 2px;
  border-radius: 8px;
  background-color: #ebf0f7;
  list-style-type: none;
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;
  border: none;
  border-radius: 6px;
  background-color: transparent;
  color: #62748c;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX:hover:not([data-state=on]):not(:disabled) {
  color: #00204d;
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX[data-state=on] {
  background-color: white;
  color: #00204d;
  box-shadow: 0 1px 3px 0 rgba(0, 32, 77, 0.1215686275);
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX:focus:not(:focus-visible) {
  outline: none;
}
.segmented-control-module_root__MZjDJ .segmented-control-module_item__q4fTX:disabled {
  color: #adbfd9;
  cursor: not-allowed;
}
.segmented-control-module_root__MZjDJ.segmented-control-module_small__zZ7mi .segmented-control-module_item__q4fTX {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  height: 28px;
  padding: 0 12px;
}
.segmented-control-module_root__MZjDJ.segmented-control-module_medium__aKGr9 .segmented-control-module_item__q4fTX {
  height: 36px;
  padding: 0 16px;
}
.segmented-control-module_root__MZjDJ.segmented-control-module_large__BQjBD .segmented-control-module_item__q4fTX {
  height: 44px;
  padding: 0 20px;
}
.segmented-control-module_root__MZjDJ:has(.segmented-control-module_item__q4fTX:disabled) {
  background-color: #ebf0f7;
}.segmented-scale-module_root__Tu2Ak {
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(min-content, 1fr);
  align-items: stretch;
  width: fit-content;
  max-width: 100%;
  border: 1px solid #adbfd9;
  border-radius: 5px;
  overflow: hidden;
  background: white;
}
.segmented-scale-module_root__Tu2Ak.segmented-scale-module_fullWidth__o87YD {
  width: 100%;
}

.segmented-scale-module_cell__mCdgn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  background: transparent;
  color: #62748c;
  font-family: inherit;
  cursor: pointer;
  border: 0;
  border-right: 1px solid #adbfd9;
  white-space: nowrap;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.segmented-scale-module_cell__mCdgn:last-child {
  border-right: 0;
}
.segmented-scale-module_cell__mCdgn:focus {
  outline: none;
}
.segmented-scale-module_cell__mCdgn:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: -2px;
  z-index: 1;
}
.segmented-scale-module_cell__mCdgn:hover:not(.segmented-scale-module_readOnly__VU0GD):not(:disabled):not(.segmented-scale-module_scaled__XltGC) {
  background: #e5f0ff;
  color: #006aff;
}
.segmented-scale-module_cell__mCdgn:disabled {
  cursor: not-allowed;
  color: #adbfd9;
}
.segmented-scale-module_cell__mCdgn svg {
  display: block;
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
}

.segmented-scale-module_readOnly__VU0GD {
  cursor: default;
}

.segmented-scale-module_selected__0qZx8 {
  color: #006aff;
  background: #e5f0ff;
  font-weight: 500;
}

.segmented-scale-module_root__Tu2Ak .segmented-scale-module_cell__mCdgn.segmented-scale-module_scaled__XltGC {
  background: var(--segmented-scale-bg);
  color: var(--segmented-scale-fg);
  font-weight: 500;
}

.segmented-scale-module_dimmed__K7ffJ {
  color: #adbfd9;
}

.segmented-scale-module_icon__KxVST {
  display: flex;
  color: #00204d;
}

.segmented-scale-module_cell__mCdgn:hover:not(.segmented-scale-module_readOnly__VU0GD):not(:disabled):not(.segmented-scale-module_scaled__XltGC) .segmented-scale-module_icon__KxVST,
.segmented-scale-module_cell__mCdgn:disabled .segmented-scale-module_icon__KxVST,
.segmented-scale-module_selected__0qZx8 .segmented-scale-module_icon__KxVST,
.segmented-scale-module_scaled__XltGC .segmented-scale-module_icon__KxVST,
.segmented-scale-module_dimmed__K7ffJ .segmented-scale-module_icon__KxVST {
  color: inherit;
}

.segmented-scale-module_small__7KCUX .segmented-scale-module_cell__mCdgn {
  padding: 7px 12px;
  font-size: 13px;
  min-width: 30px;
}
.segmented-scale-module_small__7KCUX .segmented-scale-module_cell__mCdgn.segmented-scale-module_iconOnly__lW6J2 {
  padding: 7px;
}
.segmented-scale-module_small__7KCUX .segmented-scale-module_icon__KxVST {
  font-size: 18px;
}

.segmented-scale-module_medium__eQT9b .segmented-scale-module_cell__mCdgn {
  padding: 12px 16px;
  font-size: 14px;
  min-width: 36px;
}
.segmented-scale-module_medium__eQT9b .segmented-scale-module_cell__mCdgn.segmented-scale-module_iconOnly__lW6J2 {
  padding: 12px;
}
.segmented-scale-module_medium__eQT9b .segmented-scale-module_icon__KxVST {
  font-size: 22px;
}

.segmented-scale-module_root__Tu2Ak .segmented-scale-module_cell__mCdgn.segmented-scale-module_compact__SEKDy {
  padding: 0 4px;
  font-size: 10px;
}

.segmented-scale-module_wrap__ccJ7f {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
}

.segmented-scale-module_wrapRow__jyWV7 {
  display: flex;
}

.segmented-scale-module_selectedLabel__c-xEH {
  min-height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #62748c;
}

@media (prefers-reduced-motion: reduce) {
  .segmented-scale-module_cell__mCdgn {
    transition: none;
  }
}.select-menu-module_trigger__IIDzd {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 25px;
  width: 100%;
  padding-bottom: 4px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #00204d;
  border-radius: 0;
  cursor: pointer;
  color: #00204d;
}
.select-menu-module_trigger__IIDzd:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.select-menu-module_trigger__IIDzd.select-menu-module_error__jj1PO {
  border-bottom-color: #d71717;
}
.select-menu-module_trigger__IIDzd.select-menu-module_disabled__IXwWO {
  border-bottom-color: #adbfd9;
  color: #adbfd9;
  cursor: not-allowed;
}
.select-menu-module_trigger__IIDzd.select-menu-module_disabled__IXwWO .select-menu-module_chevron__-mnCa path {
  fill: #adbfd9;
}

.select-menu-module_triggerIcon__1aLad {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.select-menu-module_triggerLabel__TL2az {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-menu-module_triggerLabel__TL2az.select-menu-module_placeholder__BBhlm {
  color: #62748c;
}

.select-menu-module_chevron__-mnCa {
  flex-shrink: 0;
  color: #00204d;
  transition: transform 0.15s ease;
}

.select-menu-module_trigger__IIDzd[data-state=open] .select-menu-module_chevron__-mnCa {
  transform: rotate(180deg);
}

.select-menu-module_content__c-V8n {
  min-width: var(--radix-dropdown-menu-trigger-width);
  max-height: var(--radix-dropdown-menu-content-available-height);
  padding: 4px 0;
  background: white;
  border-radius: 0 0 4px 4px;
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1019607843);
  overflow-y: auto;
  z-index: 10;
}

.select-menu-module_groupLabel__toA8S {
  display: block;
  padding: 12px 0 0 20px;
  color: #62748c;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}

.select-menu-module_item__5yA5e {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 20px 10px 0;
  color: #00204d;
  cursor: pointer;
  outline: none;
  user-select: none;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.select-menu-module_item__5yA5e[data-highlighted], .select-menu-module_item__5yA5e:hover {
  background-color: #e5f0ff;
}
.select-menu-module_item__5yA5e[data-state=checked] .select-menu-module_itemLabel__m47VL {
  font-weight: 500;
}
.select-menu-module_item__5yA5e[data-state=unchecked] {
  padding-left: 20px;
}
.select-menu-module_item__5yA5e[data-state=unchecked] .select-menu-module_itemIndicator__u5PgB {
  display: none;
}
.select-menu-module_item__5yA5e[data-disabled] {
  color: #adbfd9;
  cursor: not-allowed;
  pointer-events: none;
}

.select-menu-module_itemIndicator__u5PgB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  flex-shrink: 0;
}

.select-menu-module_indicatorDot__nN3kk {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffd129;
  border: 1px solid #00204d;
}

.select-menu-module_itemIcon__uRsKC {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.select-menu-module_itemLabel__m47VL {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-menu-module_separator__iimMP {
  height: 1px;
  margin: 0 10px;
  background-color: #ebf0f7;
}.sz-select {
  width: 100% !important;
}
.sz-select:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.sz-select--underline .sz-select__control {
  border-bottom: 1px solid #00204d !important;
}
.sz-select--underline .sz-select__control:hover {
  cursor: pointer;
}
.sz-select--underline.sz-select--is-disabled .sz-select__control, .sz-select.sz-select--has-error.sz-select--is-disabled .sz-select__control {
  border-bottom: 1px solid #adbfd9 !important;
}
.sz-select--is-disabled .sz-select__indicator {
  cursor: not-allowed;
  pointer-events: none;
}
.sz-select.sz-select--has-error .sz-select__control {
  border-bottom: 1px solid #d71717 !important;
}
.sz-select.sz-select--disabled .sz-select__control {
  border-bottom: 1px solid #adbfd9 !important;
  cursor: not-allowed;
}
.sz-select.sz-select--disabled .sz-select__indicator {
  cursor: not-allowed;
  pointer-events: none;
}
.sz-select.sz-select--disabled .sz-select__single-value {
  color: #adbfd9 !important;
}
.sz-select.sz-select--disabled .sz-select__input {
  cursor: not-allowed !important;
  caret-color: transparent;
}
.sz-select__control {
  min-height: 25px !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  cursor: pointer;
}
.sz-select__control:focus {
  outline: none !important;
}
.sz-select__control--is-disabled {
  background-color: #ffffff !important;
  pointer-events: auto;
}
.sz-select__control--is-disabled .sz-select__indicator svg {
  display: none;
}
.sz-select__value-container {
  padding: 0 !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.sz-select__indicator-separator {
  display: none !important;
}
.sz-select__input-container {
  margin: 0 !important;
  padding: 0 !important;
}
.sz-select__placeholder {
  color: #9e9e9e;
  margin: 0 !important;
}
.sz-select__indicators {
  height: 24px;
  display: flex;
  gap: 4px;
}
.sz-select--has-indicator .sz-select__dropdown-indicator {
  display: block !important;
  height: 16px;
  cursor: pointer;
}
.sz-select--has-indicator .sz-select__dropdown-indicator svg {
  width: 16px !important;
  height: 16px !important;
}
.sz-select__dropdown-indicator {
  display: none !important;
  padding: 0 !important;
}
.sz-select__clear-indicator {
  padding: 0 !important;
  display: block !important;
  height: 16px;
  cursor: pointer;
}
.sz-select__clear-indicator svg {
  width: 16px !important;
  height: 16px !important;
}
.sz-select__option {
  padding: 8px 4px !important;
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 1.43 !important;
  color: #757575 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 28px;
  cursor: pointer !important;
  border: 2px solid transparent;
}
.sz-select__option--is-selected {
  background-color: #ffffff !important;
}
.sz-select__option--is-selected [class^=select_labelWrapper] span:first-child {
  font-weight: 500;
}
.sz-select__option:hover {
  background-color: #e5f0ff !important;
  border-right-color: transparent;
  border-left-color: transparent;
}
.sz-select__option--is-focused {
  background-color: white !important;
  border-right-color: var(--color-interactive-dark);
  border-left-color: var(--color-interactive-dark);
}
.sz-select__option--is-disabled {
  cursor: not-allowed !important;
}
.sz-select__menu {
  margin-top: 4px !important;
  box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.1019607843) !important;
  min-height: 44px;
  border-radius: 0px 0px 4px 4px !important;
}
.sz-select__menu-notice {
  color: #62748c !important;
}
.sz-select__menu-list {
  padding-top: 6px !important;
}
.sz-select__menu-list::-webkit-scrollbar {
  width: 14px;
}
.sz-select__menu-list::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 50px;
  background-color: #62748c;
}
.sz-select__menu-notice {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.sz-select__menu-wrapper {
  padding: 4px 0;
}
.sz-select__menu-button-wrapper {
  padding: 4px 16px;
}
.sz-select__more-selected-badge {
  padding: 3px 3px 3px 6px;
  margin: 0 2px 2px 2px;
  background-color: #10b7ff;
  color: #ffffff;
  border-radius: 2px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}

.select-module_selectOption__FmcU5 {
  max-width: 100% !important;
  display: grid;
  align-items: center;
  grid-template-columns: 20px 1fr;
  row-gap: 4px;
}
.select-module_selectOption__FmcU5 > div:first-child {
  justify-self: center;
}
.select-module_selectOption__FmcU5 .select-module_circle__HxTLp {
  background-color: #ffd129;
  border-radius: 50%;
  border: 1px solid black;
  width: 6px;
  height: 6px;
  margin-right: 3px;
}
.select-module_selectOption__FmcU5 .select-module_labelWrapper__V9nGA {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #00204d;
}
.select-module_selectOption__FmcU5 .select-module_labelWrapperWithTag__fGRq7 {
  justify-content: space-between;
}
.select-module_selectOption__FmcU5 .select-module_label__ay-3s {
  flex: 0 1 min-content;
  display: flex;
  align-items: center;
}
.select-module_selectOption__FmcU5 .select-module_labelIconWrapper__PqHoY {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 4px;
}
.select-module_selectOption__FmcU5 .select-module_selectOptionNote__MbJe- {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-module_selectOption__FmcU5 .select-module_labelDescriptionContainer__nkq0R {
  flex: 1 0 max-content;
}
.select-module_selectOption__FmcU5 .select-module_labelDescriptionWrapper__KgasE {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.select-module_selectOption__FmcU5 .select-module_labelDescription__rT732 {
  display: inline-flex;
  margin-left: 5px;
  gap: 5px;
}
.select-module_selectOption__FmcU5 .select-module_labelDescription__rT732 span {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
}
.select-module_selectOption__FmcU5 .select-module_labelCounter__FfV7S {
  flex: 1 0 auto;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
}
.select-module_selectOption__FmcU5 .select-module_labelCounter__FfV7S .select-module_labelCounterContent__s9TuZ {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #00204d;
}
.select-module_selectOption__FmcU5 .select-module_labelCounter__FfV7S .select-module_labelCounterIcon__5h4gg {
  width: 16px;
  height: 16px;
}

.select-module_selectNoMatches__lq9Wy {
  color: #00204d;
}

.select-module_selectLoadMore__SSymv {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.select-module_paginatedOptionsLoader__R5Snv {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
}

.select-module_clearValueButton__XoaQI {
  background-color: unset;
}
.select-module_clearValueButton__XoaQI:focus {
  outline: 2px solid #006aff;
  border-radius: 1px;
}

.select-module_truncatedLabel__ZFBor {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}.skill-card-module_skillCard__eWZaM {
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #ebf0f7;
}
.skill-card-module_skillCard__eWZaM:focus {
  outline: 2px solid #006aff;
  outline-offset: -1px;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb {
  padding: 8px 8px 8px 12px;
  display: flex;
  align-items: center;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb:hover {
  background: #e5f0ff;
  cursor: pointer;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb:active {
  background: #cce1ff;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb .skill-card-module_label__1bvBG {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #00204d;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb .skill-card-module_label__1bvBG:hover {
  cursor: pointer;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_main__buYSb .skill-card-module_icons__NgqY9 {
  display: flex;
  margin-left: 8px;
  gap: 8px;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_actions__Xs1E6 {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 6px;
  padding: 5px 8px 5px 4px;
  background-color: #ebf0f7;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_actions__Xs1E6 .skill-card-module_actionIcon__hQcQ9 {
  display: flex;
  align-items: center;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_actions__Xs1E6 .skill-card-module_addButton__JIThh {
  width: 32px;
  height: 32px;
  padding: 0;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_actions__Xs1E6 .skill-card-module_dismissButton__ET5ft {
  width: 24px;
  height: 32px;
  background-color: transparent;
  padding: 0;
}
.skill-card-module_skillCard__eWZaM .skill-card-module_icon__VQmr5 {
  width: 16px;
  height: 16px;
}

.skill-card-module_disabled__gvZwo .skill-card-module_main__buYSb:hover {
  background: none;
  cursor: not-allowed;
}
.skill-card-module_disabled__gvZwo .skill-card-module_main__buYSb:focus {
  border: 2px solid #006aff;
}
.skill-card-module_disabled__gvZwo .skill-card-module_main__buYSb:active {
  background: #e5f0ff;
}
.skill-card-module_disabled__gvZwo .skill-card-module_main__buYSb .skill-card-module_label__1bvBG {
  color: #adbfd9;
}
.skill-card-module_disabled__gvZwo .skill-card-module_main__buYSb .skill-card-module_label__1bvBG:hover {
  cursor: not-allowed !important;
}
.skill-card-module_disabled__gvZwo .skill-card-module_actions__Xs1E6 .skill-card-module_addButton__JIThh:hover {
  background-color: #ebf0f7;
}.slider-input-module_sliderContainer__7gU-k {
  position: relative;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
  user-select: none;
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderTrack__iFhio {
  position: relative;
  flex-grow: 1;
  height: 4px;
  border-radius: 2px;
  background: #ebf0f7;
  cursor: pointer;
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderRange__GMhE0 {
  position: absolute;
  height: 4px;
  border-radius: 2px;
  background: #006aff;
  transition: background 0.15s;
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderThumb__Q2XlK {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #006aff;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  cursor: grab;
  transition: transform 0.1s, box-shadow 0.15s, background 0.15s;
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderThumb__Q2XlK:hover {
  box-shadow: 0 0 0 3px rgba(0, 106, 255, 0.08), 0 1px 3px rgba(0, 0, 0, 0.12);
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderThumb__Q2XlK:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 106, 255, 0.2);
}
.slider-input-module_sliderContainer__7gU-k .slider-input-module_sliderThumb__Q2XlK:active {
  box-shadow: 0 0 0 4px rgba(0, 106, 255, 0.13), 0 2px 8px rgba(0, 0, 0, 0.15);
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_error__e3Uzf .slider-input-module_sliderRange__GMhE0 {
  background-color: #d71717;
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_error__e3Uzf .slider-input-module_sliderThumb__Q2XlK {
  background-color: #d71717;
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_error__e3Uzf .slider-input-module_sliderThumb__Q2XlK:hover {
  box-shadow: 0 0 0 3px rgba(215, 23, 23, 0.08), 0 1px 3px rgba(0, 0, 0, 0.12);
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_error__e3Uzf .slider-input-module_sliderThumb__Q2XlK:focus-visible {
  box-shadow: 0 0 0 3px rgba(215, 23, 23, 0.2);
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_error__e3Uzf .slider-input-module_sliderThumb__Q2XlK:active {
  box-shadow: 0 0 0 4px rgba(215, 23, 23, 0.13), 0 2px 8px rgba(0, 0, 0, 0.15);
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_disabled__AXkU9 .slider-input-module_sliderRange__GMhE0 {
  background-color: #adbfd9;
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_disabled__AXkU9 .slider-input-module_sliderTrack__iFhio {
  cursor: not-allowed;
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_disabled__AXkU9 .slider-input-module_sliderThumb__Q2XlK {
  background-color: #adbfd9;
  cursor: not-allowed;
}
.slider-input-module_sliderContainer__7gU-k.slider-input-module_disabled__AXkU9 .slider-input-module_sliderThumb__Q2XlK:hover, .slider-input-module_sliderContainer__7gU-k.slider-input-module_disabled__AXkU9 .slider-input-module_sliderThumb__Q2XlK:active {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}.rc-slider {
  position: relative;
  height: 14px;
  padding: 5px 0;
  width: 100%;
  border-radius: 6px;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-rail {
  position: absolute;
  width: 100%;
  background-color: #e9e9e9;
  height: 4px;
  border-radius: 6px;
}
.rc-slider-track {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 6px;
  background-color: #abe2fb;
}
.rc-slider-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  cursor: pointer;
  cursor: -webkit-grab;
  margin-top: -5px;
  cursor: grab;
  border-radius: 50%;
  border: solid 2px #96dbfa;
  background-color: #fff;
  touch-action: pan-x;
}
.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #57c5f7;
  box-shadow: 0 0 0 5px #96dbfa;
}
.rc-slider-handle:focus {
  outline: none;
}
.rc-slider-handle-click-focused:focus {
  border-color: #96dbfa;
  box-shadow: unset;
}
.rc-slider-handle:hover {
  border-color: #57c5f7;
}
.rc-slider-handle:active {
  border-color: #57c5f7;
  box-shadow: 0 0 5px #57c5f7;
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.rc-slider-mark {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  font-size: 12px;
}
.rc-slider-mark-text {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  color: #999;
}
.rc-slider-mark-text-active {
  color: #666;
}
.rc-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}
.rc-slider-dot {
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  border: 2px solid #e9e9e9;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}
.rc-slider-dot-active {
  border-color: #96dbfa;
}
.rc-slider-dot-reverse {
  margin-right: -4px;
}
.rc-slider-disabled {
  background-color: #e9e9e9;
}
.rc-slider-disabled .rc-slider-track {
  background-color: #ccc;
}
.rc-slider-disabled .rc-slider-handle,
.rc-slider-disabled .rc-slider-dot {
  border-color: #ccc;
  box-shadow: none;
  background-color: #fff;
  cursor: not-allowed;
}
.rc-slider-disabled .rc-slider-mark-text,
.rc-slider-disabled .rc-slider-dot {
  cursor: not-allowed !important;
}
.rc-slider-vertical {
  width: 14px;
  height: 100%;
  padding: 0 5px;
}
.rc-slider-vertical .rc-slider-rail {
  height: 100%;
  width: 4px;
}
.rc-slider-vertical .rc-slider-track {
  left: 5px;
  bottom: 0;
  width: 4px;
}
.rc-slider-vertical .rc-slider-handle {
  margin-left: -5px;
  touch-action: pan-y;
}
.rc-slider-vertical .rc-slider-mark {
  top: 0;
  left: 18px;
  height: 100%;
}
.rc-slider-vertical .rc-slider-step {
  height: 100%;
  width: 4px;
}
.rc-slider-vertical .rc-slider-dot {
  left: 2px;
  margin-bottom: -4px;
}
.rc-slider-vertical .rc-slider-dot:first-child {
  margin-bottom: -4px;
}
.rc-slider-vertical .rc-slider-dot:last-child {
  margin-bottom: -4px;
}
.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}
.rc-slider-tooltip-zoom-down-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}
.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
  animation-name: rcSliderTooltipZoomDownIn;
  animation-play-state: running;
}
.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
  animation-name: rcSliderTooltipZoomDownOut;
  animation-play-state: running;
}
.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  transform: scale(0, 0);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.rc-slider-tooltip-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
@keyframes rcSliderTooltipZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
}
@keyframes rcSliderTooltipZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
}
.rc-slider-tooltip {
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-tooltip * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-tooltip-hidden {
  display: none;
}
.rc-slider-tooltip-placement-top {
  padding: 4px 0 8px 0;
}
.rc-slider-tooltip-inner {
  padding: 6px 2px;
  min-width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 1;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #6c6c6c;
  border-radius: 6px;
  box-shadow: 0 0 4px #d9d9d9;
}
.rc-slider-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
  bottom: 4px;
  left: 50%;
  margin-left: -4px;
  border-width: 4px 4px 0;
  border-top-color: #6c6c6c;
}
.slider-module_slider__custom-rail__ZZ3J1 {
  box-sizing: border-box;
  background-color: #ebf0f7;
}
.slider-module_slider__custom-rail--unselected__V2enU:hover {
  background-color: #006aff;
}
.slider-module_slider__with-reset__yCykE {
  display: flex;
  gap: 24px;
}
.slider-module_slider__reset-button__9fsty {
  background: transparent;
  padding: 0 4px;
  height: 24px;
  visibility: hidden;
  color: #006aff;
}
.slider-module_slider__with-reset__yCykE:hover .slider-module_slider__reset-button-available__QlRWI {
  visibility: visible;
}
.slider-module_slider__reset-button-available__QlRWI:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.slider-module_slider__handle__yKBq- path {
  fill: #00204d;
}
.slider-module_slider__handle__yKBq-:hover:not(:active) {
  background-color: #ffda54 !important;
  border-color: #62748c !important;
}
.slider-module_slider__handle__yKBq-:hover:not(:active) svg path {
  fill: #62748c;
}
.slider-module_slider__handle-icon-hidden__DMsPE {
  outline: none;
}
.slider-module_slider__handle__yKBq-:active {
  outline: none;
  background-color: #e6bc25 !important;
}
.slider-module_slider__handle-icon-wrapper__iGaZo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.slider-module_slider__2oXtv .slider-module_slider__handle__yKBq-:focus {
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.slider-module_slider__2oXtv .rc-slider-dot:before {
  content: "";
  width: 8px;
  height: 8px;
  background-color: #006aff;
  display: block;
  border-radius: 50%;
}
.slider-module_slider__2oXtv .rc-slider-dot:hover:before {
  background-color: #3388ff;
}
.slider-module_slider__unselected__fn8R4 .slider-module_slider__custom-rail--focused__Jyz8N {
  background-color: #006aff;
}
.slider-module_slider__unselected__fn8R4 .slider-module_slider__custom-rail__ZZ3J1:hover .rc-slider-dot::before, .slider-module_slider__unselected__fn8R4 .slider-module_slider__custom-rail--focused__Jyz8N .rc-slider-dot::before {
  background-color: #006aff;
  width: 14px;
  height: 14px;
  background-color: transparent;
  border: 2px solid white;
  border-radius: 50%;
}
.slider-module_slider__show-marks-on-selected__tuCMl :nth-last-child(1 of .rc-slider-mark-text-active) {
  display: block;
}
.slider-module_slider__show-marks-on-selected__tuCMl .rc-slider-mark-text {
  display: none;
}
.slider-module_slider--disabled__e8Gdi .slider-module_slider__handle__yKBq- path {
  fill: #adbfd9;
}
.slider-module_slider--disabled__e8Gdi .rc-slider-dot:before {
  background-color: #adbfd9;
}
.slider-module_slider--disabled__e8Gdi .rc-slider-dot:hover:before {
  background-color: #adbfd9;
}

.slider-module_slider__unselected__fn8R4.slider-module_slider__show-marks-on-selected__tuCMl .rc-slider-mark-text {
  display: none;
}

body:not(.using-mouse) .slider-module_slider__focused__URKTf.slider-module_slider__selected__bCm4d .slider-module_slider__reset-button-available__QlRWI {
  visibility: visible;
}.switch > label {
  padding: 0 4px;
}
.switch > label:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 3px;
}
.switch__checkbox {
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;
}
.switch__button-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  background: #62748c;
  border-radius: 100px;
  transition: background-color 0.2s;
}
.switch.switch--state-on .switch__button-wrapper {
  background-color: #ffd129;
}
.switch--disabled .switch__button-wrapper,
.switch--disabled .switch__label,
.switch--disabled .switch__label-content {
  cursor: not-allowed;
  color: #adbfd9;
}
.switch--disabled.switch--state-on .switch__button-wrapper {
  background-color: #ebf0f7;
}
.switch--disabled.switch--state-off .switch__button-wrapper {
  background-color: #adbfd9;
}
.switch--size-small .switch__button-wrapper {
  width: 20px;
  height: 10px;
}
.switch--size-small .switch__button {
  width: 6px;
  height: 6px;
  top: 2px;
  left: 2px;
}
.switch--size-large .switch__button-wrapper {
  width: 32px;
  height: 16px;
}
.switch--size-large .switch__button {
  width: 10px;
  height: 10px;
  top: 3px;
  left: 3px;
}
.switch__button {
  content: "";
  position: absolute;
  border-radius: 10px;
  transition: 0.2s;
  background: #ffffff;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
}
.switch__button-on {
  background: #1a1f36;
}
.switch__button-off {
  background: #ffffff;
}
.switch__button-disabled-off {
  background: #ffffff;
}
.switch__button-disabled-on {
  background: #adbfd9;
}
.switch--state-on .switch__button {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}
.switch__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  min-height: 20px;
}
.switch__label-content {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  cursor: pointer;
  color: #00204d;
}:root {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-one {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-two {
  --cds-layer: var(--cds-layer-02, #ffffff);
  --cds-layer-active: var(--cds-layer-active-02, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-02, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-02, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-02, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-02, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-02, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-02, #a8a8a8);
  --cds-field: var(--cds-field-02, #ffffff);
  --cds-field-hover: var(--cds-field-hover-02, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-01, #c6c6c6);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-02, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-02, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-02, #a8a8a8);
}

.cds--layer-three {
  --cds-layer: var(--cds-layer-03, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-03, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-03, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-03, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-03, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-03, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-03, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-03, #a8a8a8);
  --cds-field: var(--cds-field-03, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-03, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-02, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-03, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-03, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-03, #c6c6c6);
}

@keyframes cds--hide-feedback {
  0% {
    opacity: 1;
    visibility: inherit;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes cds--show-feedback {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: inherit;
  }
}
@keyframes cds--skeleton {
  0% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
  20% {
    opacity: 1;
    transform: scaleX(1);
    transform-origin: left;
  }
  28% {
    transform: scaleX(1);
    transform-origin: right;
  }
  51% {
    transform: scaleX(0);
    transform-origin: right;
  }
  58% {
    transform: scaleX(0);
    transform-origin: right;
  }
  82% {
    transform: scaleX(1);
    transform-origin: right;
  }
  83% {
    transform: scaleX(1);
    transform-origin: left;
  }
  96% {
    transform: scaleX(0);
    transform-origin: left;
  }
  100% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px var(--cds-field) inset;
  -webkit-text-fill-color: var(--cds-text-primary, #161616);
}

.cds--fieldset {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--fieldset *,
.cds--fieldset *::before,
.cds--fieldset *::after {
  box-sizing: inherit;
}

.cds--form-item {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
}

.cds--label html {
  font-size: 100%;
}
.cds--label body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--label code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--label strong {
  font-weight: 600;
}
.cds--label {
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  display: inline-block;
  color: var(--cds-text-secondary, #525252);
  font-weight: 400;
  line-height: 1rem;
  margin-block-end: 0.5rem;
  vertical-align: baseline;
}

.cds--label .cds--toggletip-label {
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--label--no-margin {
  margin-block-end: 0;
}

.cds--label + .cds--tooltip {
  position: relative;
  inset-block-start: 0.2rem;
  inset-inline-start: 0.5rem;
}

.cds--label + .cds--tooltip .cds--tooltip__trigger {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger *,
.cds--label + .cds--tooltip .cds--tooltip__trigger *::before,
.cds--label + .cds--tooltip .cds--tooltip__trigger *::after {
  box-sizing: inherit;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger::-moz-focus-inner {
  border: 0;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger:focus {
  outline: 1px solid var(--cds-focus, #0f62fe);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger svg {
  fill: var(--cds-icon-secondary, #525252);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger svg :hover {
  fill: var(--cds-icon-primary, #161616);
}

.cds--label + .cds--toggletip {
  inset-block-start: 0.2rem;
  inset-inline-start: 0.5rem;
}

.cds--label.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--label.cds--skeleton:hover, .cds--label.cds--skeleton:focus, .cds--label.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--label.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--label.cds--skeleton::before {
    animation: none;
  }
}
.cds--label.cds--skeleton {
  block-size: 0.875rem;
  inline-size: 4.6875rem;
}

input[type=number] {
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
}

input[data-invalid]:not(:focus),
.cds--number[data-invalid] input[type=number]:not(:focus),
.cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:not(:focus),
.cds--text-area__wrapper[data-invalid] > .cds--text-area--invalid:not(:focus),
.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),
.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused),
.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus) {
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  input[data-invalid]:not(:focus),
  .cds--number[data-invalid] input[type=number]:not(:focus),
  .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:not(:focus),
  .cds--text-area__wrapper[data-invalid] > .cds--text-area--invalid:not(:focus),
  .cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),
  .cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused),
  .cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus) {
    outline-style: dotted;
  }
}

input[data-invalid] ~ .cds--form-requirement,
.cds--number[data-invalid] .cds--number__input-wrapper ~ .cds--form-requirement,
.cds--number__input-wrapper--warning ~ .cds--form-requirement,
.cds--date-picker-input__wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--warn ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--invalid ~ .cds--form-requirement,
.cds--time-picker--invalid ~ .cds--form-requirement,
.cds--time-picker--warning ~ .cds--form-requirement,
.cds--text-input__field-wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-input__field-wrapper--warning ~ .cds--form-requirement,
.cds--text-input__field-wrapper--warning > .cds--text-input ~ .cds--form-requirement,
.cds--text-area__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-area__wrapper--warn ~ .cds--form-requirement,
.cds--select-input__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--select--warning .cds--select-input__wrapper ~ .cds--form-requirement,
.cds--time-picker[data-invalid] ~ .cds--form-requirement,
.cds--list-box[data-invalid] ~ .cds--form-requirement,
.cds--list-box--warning ~ .cds--form-requirement {
  display: block;
  overflow: visible;
  font-weight: 400;
  max-block-size: 12.5rem;
}

input[data-invalid] ~ .cds--form-requirement,
.cds--number[data-invalid] .cds--number__input-wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--invalid ~ .cds--form-requirement,
.cds--time-picker--invalid ~ .cds--form-requirement,
.cds--text-input__field-wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-area__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--select-input__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--time-picker[data-invalid] ~ .cds--form-requirement,
.cds--list-box[data-invalid] ~ .cds--form-requirement {
  color: var(--cds-text-error, #da1e28);
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid],
.cds--form--fluid .cds--text-input__field-wrapper--warning {
  display: block;
}

.cds--form--fluid input[data-invalid] {
  outline: none;
}

.cds--form--fluid .cds--form-requirement {
  padding: 0.5rem 2.5rem 0.5rem 1rem;
  margin: 0;
}

input:not(output, [data-invalid]):-moz-ui-invalid {
  box-shadow: none;
}

.cds--form-requirement html {
  font-size: 100%;
}
.cds--form-requirement body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--form-requirement code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--form-requirement strong {
  font-weight: 600;
}
.cds--form-requirement {
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  display: none;
  overflow: hidden;
  margin: 0.25rem 0 0;
  max-block-size: 0;
}

.cds--select--inline .cds--form__helper-text {
  margin-block-start: 0;
}

.cds--form__helper-text {
  font-size: var(--cds-helper-text-01-font-size, 0.75rem);
  line-height: var(--cds-helper-text-01-line-height, 1.33333);
  letter-spacing: var(--cds-helper-text-01-letter-spacing, 0.32px);
  z-index: 0;
  color: var(--cds-text-secondary, #525252);
  inline-size: 100%;
  margin-block-start: 0.25rem;
  opacity: 1;
}

.cds--label--disabled,
.cds--form__helper-text--disabled {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

fieldset[disabled] .cds--label,
fieldset[disabled] .cds--form__helper-text {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--assistive-text,
.cds--visually-hidden {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--checkbox-group {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--checkbox-group *,
.cds--checkbox-group *::before,
.cds--checkbox-group *::after {
  box-sizing: inherit;
}

.cds--form-item.cds--checkbox-wrapper {
  position: relative;
  margin-block-end: 0.375rem;
}

.cds--form-item.cds--checkbox-wrapper:first-of-type {
  margin-block-start: 0;
}

.cds--label + .cds--form-item.cds--checkbox-wrapper {
  margin-block-start: -0.125rem;
}

.cds--form-item.cds--checkbox-wrapper:last-of-type {
  margin-block-end: 0.1875rem;
}

.cds--checkbox {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  inset-block-start: 1.25rem;
  inset-inline-start: 0.7rem;
}

.cds--checkbox-label html {
  font-size: 100%;
}
.cds--checkbox-label body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--checkbox-label code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--checkbox-label strong {
  font-weight: 600;
}
.cds--checkbox-label {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: flex;
  cursor: pointer;
  min-block-size: 1.25rem;
  padding-block-start: 0.125rem;
  padding-inline-start: 1.25rem;
  user-select: none;
}

.cds--checkbox-label-text {
  padding-inline-start: 0.625rem;
}

.cds--checkbox-label::before,
.cds--checkbox-label::after {
  box-sizing: border-box;
}
@media print {
  .cds--checkbox-label::before,
  .cds--checkbox-label::after {
    print-color-adjust: exact;
  }
}

.cds--checkbox-label::before {
  position: absolute;
  border: 1px solid var(--cds-icon-primary, #161616);
  border-radius: 2px;
  background-color: transparent;
  block-size: 1rem;
  content: "";
  inline-size: 1rem;
  inset-block-start: 0.125rem;
  inset-inline-start: 0;
  margin-block: 0.0625rem 0.125rem;
  margin-inline: 0.1875rem 0;
}

.cds--checkbox-label::after {
  position: absolute;
  background: none;
  block-size: 0.3125rem;
  border-block-end: 1.5px solid var(--cds-icon-inverse, #ffffff);
  border-inline-start: 1.5px solid var(--cds-icon-inverse, #ffffff);
  content: "";
  inline-size: 0.5625rem;
  inset-block-start: 0.40625rem;
  inset-inline-start: 0.4375rem;
  margin-block-start: -0.1875rem;
  transform: scale(0) rotate(-45deg);
  transform-origin: bottom right;
}

.cds--checkbox:checked + .cds--checkbox-label::before,
.cds--checkbox:indeterminate + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true]::before {
  border: none;
  border-width: 1px;
  background-color: var(--cds-icon-primary, #161616);
}

.cds--checkbox:checked + .cds--checkbox-label::after,
.cds--checkbox-label[data-contained-checkbox-state=true]::after {
  transform: scale(1) rotate(-45deg);
}

.cds--checkbox:indeterminate + .cds--checkbox-label::after {
  border-block-end: 2px solid var(--cds-icon-inverse, #ffffff);
  border-inline-start: 0 solid var(--cds-icon-inverse, #ffffff);
  inline-size: 0.5rem;
  inset-block-start: 0.6875rem;
  transform: scale(1) rotate(0deg);
}

.cds--checkbox:focus + .cds--checkbox-label::before,
.cds--checkbox-label__focus::before,
.cds--checkbox:checked:focus + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus::before,
.cds--checkbox:indeterminate:focus + .cds--checkbox-label::before {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--checkbox:disabled + .cds--checkbox-label,
.cds--checkbox-label[data-contained-checkbox-disabled=true] {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--checkbox:disabled + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-disabled=true]::before {
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox:checked:disabled + .cds--checkbox-label::before,
.cds--checkbox:indeterminate:disabled + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]::before {
  background-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox-group[data-invalid] .cds--checkbox-label::before,
.cds--checkbox-wrapper--invalid .cds--checkbox-label::before,
.cds--checkbox-wrapper--invalid .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid var(--cds-support-error, #da1e28);
}

.cds--checkbox-group .cds--checkbox-wrapper--invalid > .cds--checkbox__validation-msg,
.cds--checkbox-group .cds--checkbox-wrapper--warning > .cds--checkbox__validation-msg,
.cds--checkbox-group .cds--checkbox-wrapper > .cds--form__helper-text {
  display: none;
}

.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label::before,
.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid var(--cds-icon-primary, #161616);
}

.cds--checkbox-group__validation-msg,
.cds--checkbox__validation-msg {
  display: none;
  align-items: flex-start;
  margin-block-start: 0.25rem;
}

.cds--checkbox__invalid-icon {
  margin: 0.0625rem 0.0625rem 0 0.1875rem;
  fill: var(--cds-support-error, #da1e28);
  min-inline-size: 1rem;
}

.cds--checkbox__invalid-icon--warning {
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--checkbox__invalid-icon--warning path:first-of-type {
  fill: #000000;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,
.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,
.cds--checkbox-wrapper--invalid > .cds--checkbox__validation-msg,
.cds--checkbox-wrapper--warning > .cds--checkbox__validation-msg {
  display: flex;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement {
  display: block;
  overflow: visible;
  margin-block-start: 0;
  margin-inline-start: 0.5rem;
  max-block-size: 100%;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement {
  color: var(--cds-text-error, #da1e28);
}

.cds--checkbox-group--readonly .cds--checkbox-label,
.cds--checkbox-wrapper--readonly .cds--checkbox-label {
  cursor: default;
}

.cds--checkbox-group--readonly .cds--checkbox-label-text,
.cds--checkbox-wrapper--readonly .cds--checkbox-label-text {
  cursor: text;
  user-select: text;
}

.cds--checkbox-group--readonly .cds--checkbox + .cds--checkbox-label::before,
.cds--checkbox-wrapper--readonly .cds--checkbox + .cds--checkbox-label::before {
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox-group--readonly .cds--checkbox:checked + .cds--checkbox-label::before,
.cds--checkbox-wrapper--readonly .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
  background: transparent;
}

.cds--checkbox-group--readonly .cds--checkbox:checked + .cds--checkbox-label::after,
.cds--checkbox-wrapper--readonly .cds--checkbox:checked + .cds--checkbox-label::after {
  border-color: var(--cds-text-primary, #161616);
}

.cds--checkbox-skeleton .cds--checkbox-label {
  cursor: default;
}

.cds--checkbox-label-text.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--checkbox-label-text.cds--skeleton:hover, .cds--checkbox-label-text.cds--skeleton:focus, .cds--checkbox-label-text.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--checkbox-label-text.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--checkbox-label-text.cds--skeleton::before {
    animation: none;
  }
}
.cds--checkbox-label-text.cds--skeleton {
  block-size: 1rem;
  inline-size: 6.25rem;
  margin-block: 0.0625rem 0;
  margin-inline: 0.375rem 0;
}

.cds--checkbox--inline {
  position: relative;
}

[dir=rtl] .cds--checkbox-label::after {
  margin-block-start: 0;
  margin-inline-start: -0.0625rem;
  transform-origin: center;
}

[dir=rtl] .cds--checkbox:checked + .cds--checkbox-label::after,
[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]::after {
  transform: scale(1.2) rotate3d(0.5, 1, 0, 158deg);
}

.cds--checkbox-group--slug legend.cds--label,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text {
  display: flex;
}

.cds--checkbox-group--slug legend.cds--label .cds--slug,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug {
  margin-inline-start: 0.5rem;
}

.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline {
  line-height: inherit;
  margin-block-start: -0.0625rem;
}

.cds--radio-button-group {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--radio-button-group *,
.cds--radio-button-group *::before,
.cds--radio-button-group *::after {
  box-sizing: inherit;
}
.cds--radio-button-group {
  position: relative;
  display: flex;
  align-items: center;
}

.cds--label + .cds--form-item .cds--radio-button-group {
  margin-block-start: 0;
}

.cds--radio-button-group--vertical {
  flex-direction: column;
  align-items: flex-start;
}
.cds--radio-button-group--vertical.cds--radio-button-group--label-left {
  align-items: flex-end;
}
.cds--radio-button-group--vertical .cds--radio-button__label {
  margin-inline-end: 0;
}
.cds--radio-button-group--vertical .cds--radio-button__label:not(:last-of-type) {
  margin-block-end: 0.5rem;
}

.cds--radio-button {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  margin-block-start: 0.9rem;
  margin-inline-start: 0.63rem;
  visibility: inherit;
}

.cds--radio-button__label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-inline-end: 1rem;
}

.cds--radio-button__label-text {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  flex: 1;
}

.cds--radio-button__appearance {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--radio-button__appearance *,
.cds--radio-button__appearance *::before,
.cds--radio-button__appearance *::after {
  box-sizing: inherit;
}
.cds--radio-button__appearance {
  flex-shrink: 0;
  border: 1px solid var(--cds-icon-primary, #161616);
  border-radius: 50%;
  background-color: transparent;
  block-size: 1.125rem;
  inline-size: 1.125rem;
  margin-block: 0.0625rem 0.125rem;
  margin-inline: 0.125rem 0.625rem;
}

.cds--radio-button-group--vertical .cds--radio-button__appearance {
  margin-block: 0;
}

.cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance {
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: var(--cds-icon-primary, #161616);
}
.cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  background-color: var(--cds-icon-primary, #161616);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  transform: scale(0.5);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
    fill: ButtonText;
    background-color: ButtonText;
  }
}
@media print {
  .cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
    print-color-adjust: exact;
  }
}

.cds--radio-button:disabled + .cds--radio-button__label {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--radio-button:disabled + .cds--radio-button__label .cds--radio-button__appearance,
.cds--radio-button:disabled:checked + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--radio-button:disabled + .cds--radio-button__label .cds--radio-button__appearance::before,
.cds--radio-button:disabled:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
  background-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--radio-button-group--readonly .cds--radio-button + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--radio-button-group--readonly .cds--radio-button__label {
  cursor: default;
}

.cds--radio-button-group--readonly .cds--radio-button__label-text {
  cursor: text;
  user-select: text;
}

.cds--radio-button-group--invalid .cds--radio-button + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: var(--cds-support-error, #da1e28);
}

.cds--radio-button__validation-msg {
  display: none;
  align-items: flex-end;
  margin-block-start: 0.375rem;
}

.cds--radio-button__invalid-icon {
  fill: var(--cds-support-error, #da1e28);
  margin-inline: 0.1875rem 0.0625rem;
}

.cds--radio-button__invalid-icon--warning {
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--radio-button__invalid-icon--warning path:first-of-type {
  fill: #000000;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg,
.cds--radio-button-group--warning + .cds--radio-button__validation-msg {
  display: flex;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg .cds--form-requirement,
.cds--radio-button-group--warning + .cds--radio-button__validation-msg .cds--form-requirement {
  display: block;
  overflow: visible;
  margin-block-start: 0;
  margin-inline-start: 0.5rem;
  max-block-size: 100%;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg .cds--form-requirement {
  color: var(--cds-text-error, #da1e28);
}

.cds--radio-button-group ~ .cds--form__helper-text {
  margin-block-start: 0.375rem;
}

.cds--radio-button:focus + .cds--radio-button__label .cds--radio-button__appearance {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1.5px;
}

.cds--radio-button__label.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--radio-button__label.cds--skeleton:hover, .cds--radio-button__label.cds--skeleton:focus, .cds--radio-button__label.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--radio-button__label.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--radio-button__label.cds--skeleton::before {
    animation: none;
  }
}
.cds--radio-button__label.cds--skeleton {
  block-size: 1.125rem;
  inline-size: 6.25rem;
}

.cds--radio-button__label.cds--skeleton .cds--radio-button__appearance {
  display: none;
}

.cds--radio-button-wrapper .cds--radio-button__label {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
}

.cds--radio-button-wrapper:not(:last-of-type) {
  margin-inline-end: 1rem;
}

.cds--radio-button-group--vertical .cds--radio-button-wrapper {
  margin-block-end: 0.375rem;
  margin-inline-end: 0;
}

.cds--radio-button-group--vertical .cds--radio-button-wrapper .cds--radio-button__label {
  padding-block-start: 0.125rem;
}

.cds--radio-button-group--label-right .cds--radio-button__label,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-right .cds--radio-button__label {
  flex-direction: row;
}

.cds--radio-button-group--label-left .cds--radio-button__label,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__label {
  flex-direction: row-reverse;
}

.cds--radio-button-group--label-left .cds--radio-button__appearance,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__appearance {
  margin-inline-end: 0;
  margin-inline-start: 0.5rem;
}

.cds--radio-button-group--slug legend.cds--label,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text {
  display: flex;
}

.cds--radio-button-group--slug legend.cds--label .cds--slug,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug {
  margin-inline-start: 0.5rem;
}

.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug__button--inline {
  line-height: inherit;
  margin-block-start: -0.0625rem;
}

.cds--data-table-container {
  position: relative;
  padding-block-start: 0.125rem;
}

.cds--data-table-content {
  display: block;
  overflow-x: auto;
}

.cds--data-table-content:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--data-table-content:focus {
    outline-style: dotted;
  }
}

.cds--data-table-header {
  background-color: var(--cds-layer);
  padding-block-end: 1.5rem;
  padding-block-start: 1rem;
  padding-inline: 1rem;
}

.cds--data-table-header__title {
  font-size: var(--cds-heading-03-font-size, 1.25rem);
  font-weight: var(--cds-heading-03-font-weight, 400);
  line-height: var(--cds-heading-03-line-height, 1.4);
  letter-spacing: var(--cds-heading-03-letter-spacing, 0);
  color: var(--cds-text-primary, #161616);
}

.cds--data-table-header__description {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: var(--cds-text-secondary, #525252);
}
@media (min-width: 42rem) {
  .cds--data-table-header__description {
    max-inline-size: 50ch;
  }
}
@media (min-width: 66rem) {
  .cds--data-table-header__description {
    max-inline-size: 80ch;
  }
}

.cds--data-table {
  border-collapse: collapse;
  border-spacing: 0;
  inline-size: 100%;
}

.cds--data-table thead {
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  background-color: var(--cds-layer-accent);
}

.cds--data-table tbody {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  background-color: var(--cds-layer);
  inline-size: 100%;
}

.cds--data-table tr {
  border: none;
  block-size: 3rem;
  inline-size: 100%;
}

.cds--data-table tbody tr,
.cds--data-table tbody tr td,
.cds--data-table tbody tr th {
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--data-table tbody tr:not([data-child-row]):hover,
.cds--data-table tbody tr[data-child-row]:hover > td {
  background-color: var(--cds-layer-hover);
}

.cds--data-table tbody tr:hover td,
.cds--data-table tbody tr:hover th {
  border-block-end: 1px solid var(--cds-layer-hover);
  border-block-start: 1px solid var(--cds-layer-hover);
  color: var(--cds-text-primary, #161616);
}

.cds--data-table tr + :not(.cds--popover-container):hover .cds--link {
  color: var(--cds-link-secondary, #0043ce);
}

.cds--data-table tr + :not(.cds--popover-container):hover .cds--link--disabled {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--data-table th,
.cds--data-table td {
  text-align: start;
  vertical-align: middle;
}

.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand) {
  padding-block-end: 1rem;
  padding-block-start: 1rem;
}
.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-menu {
  padding-block-start: 0.5rem;
}
.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-checkbox:not(.cds--table-column-radio) {
  padding-block-start: 0.8125rem;
}
.cds--data-table.cds--data-table--top-aligned-body td {
  vertical-align: top;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header) {
  padding-block-end: 1rem;
  padding-block-start: 1rem;
}
.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-menu {
  padding-block-start: 0.5rem;
}
.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-checkbox {
  padding-block-start: 0.8125rem;
}
.cds--data-table.cds--data-table--top-aligned-header th {
  vertical-align: top;
}

.cds--data-table th[align=right],
.cds--data-table td[align=right] {
  text-align: end;
}

.cds--data-table th[align=center],
.cds--data-table td[align=center] {
  text-align: center;
}

.cds--data-table th {
  background-color: var(--cds-layer-accent);
  color: var(--cds-text-primary, #161616);
  padding-inline-end: 1rem;
  padding-inline-start: 1rem;
}

.cds--data-table th:last-of-type {
  position: static;
  inline-size: auto;
}

.cds--data-table .cds--table-header-label {
  text-align: start;
}

.cds--data-table td,
.cds--data-table tbody th {
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-layer);
  color: var(--cds-text-secondary, #525252);
  padding-inline-end: 1rem;
  padding-inline-start: 1rem;
}
.cds--data-table td + td:first-of-type,
.cds--data-table tbody th + td:first-of-type {
  padding-inline-start: 0.75rem;
}

@supports (-moz-appearance: none) {
  .cds--data-table td {
    background-clip: padding-box;
  }
}
.cds--data-table .cds--list-box input[role=combobox],
.cds--data-table .cds--list-box input[type=text],
.cds--data-table .cds--dropdown,
.cds--data-table .cds--list-box,
.cds--data-table .cds--number input[type=number],
.cds--data-table .cds--number__control-btn::before,
.cds--data-table .cds--number__control-btn::after,
.cds--data-table .cds--text-input,
.cds--data-table .cds--select-input {
  background-color: var(--cds-field-02, #ffffff);
}

.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus {
    outline-style: dotted;
  }
}

.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=true]:focus {
  outline: none;
}

@media screen and (hover: hover), (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .cds--data-table td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon {
    opacity: 0;
  }
}
.cds--data-table td.cds--table-column-menu .cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--data-table.cds--data-table--visible-overflow-menu td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon,
.cds--data-table td.cds--table-column-menu .cds--overflow-menu:hover .cds--overflow-menu__icon,
.cds--data-table td.cds--table-column-menu .cds--overflow-menu:focus .cds--overflow-menu__icon,
.cds--data-table tr:hover td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--table-row--menu-option .cds--overflow-menu-options__btn .cds--overflow-menu-options__option-content svg {
  position: relative;
  inset-block-start: 0.1875rem;
  margin-inline-end: 0.5rem;
}

.cds--data-table .cds--overflow-menu:hover,
.cds--data-table .cds--overflow-menu__trigger:hover {
  background-color: var(--cds-layer-selected-hover);
}

.cds--data-table--selected .cds--overflow-menu:hover,
.cds--data-table--selected .cds--overflow-menu__trigger:hover {
  background-color: var(--cds-layer-hover);
}

.cds--data-table--selected .cds--link:not(.cds--link--disabled) {
  color: var(--cds-link-secondary, #0043ce);
}

.cds--data-table--xs td.cds--table-column-menu,
.cds--data-table--sm td.cds--table-column-menu {
  block-size: 1.5rem;
  padding-block-end: 0;
  padding-block-start: 0;
}

.cds--data-table--sm td.cds--table-column-menu {
  block-size: 2rem;
}

.cds--data-table--md td.cds--table-column-menu {
  block-size: 2.5rem;
}

.cds--data-table--xl .cds--table-column-menu {
  padding-block-start: 0.5rem;
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(odd) td {
  border-block-end: 1px solid var(--cds-layer);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(even) td {
  border-block-end: 1px solid var(--cds-layer-accent);
  border-block-start: 1px solid var(--cds-layer-accent);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):nth-child(even) {
  background-color: var(--cds-layer-accent);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):hover td {
  border-block-end: 1px solid var(--cds-layer-hover);
  border-block-start: 1px solid var(--cds-layer-hover);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):hover {
  background-color: var(--cds-layer-hover);
}

.cds--table-column-checkbox .cds--checkbox-label {
  min-block-size: 1.5rem;
  padding-inline-start: 0;
}

.cds--table-column-checkbox .cds--checkbox-label::before {
  margin-block-start: 0.125rem;
}

.cds--table-column-checkbox .cds--checkbox-label::after {
  inset-block-start: 0.46875rem;
}

.cds--data-table th.cds--table-column-checkbox {
  position: static;
  background-color: var(--cds-layer-accent);
  inline-size: 2rem;
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--data-table thead th.cds--table-column-checkbox,
.cds--data-table tbody td.cds--table-column-checkbox,
.cds--data-table thead th.cds--table-expand,
.cds--data-table tbody td.cds--table-expand {
  min-inline-size: 0;
}

.cds--data-table thead th.cds--table-column-checkbox,
.cds--data-table tbody td.cds--table-column-checkbox {
  min-inline-size: 2.5rem;
  padding-inline-end: 0.25rem;
  padding-inline-start: 1rem;
}

.cds--data-table thead th.cds--table-expand,
.cds--data-table tbody td.cds--table-expand {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--data-table--xs thead th.cds--table-expand,
.cds--data-table--xs tbody td.cds--table-expand {
  padding: 0 0 0 0.5rem;
  block-size: 1.5rem;
  inline-size: 1.5rem;
}

.cds--data-table--sm thead th.cds--table-expand,
.cds--data-table--sm tbody td.cds--table-expand {
  padding: 0;
  block-size: 2rem;
  inline-size: 2rem;
  padding-inline-start: 0.5rem;
}

.cds--data-table--md thead th.cds--table-expand,
.cds--data-table--md tbody td.cds--table-expand {
  padding: 0.25rem 0 0.25rem 0.5rem;
  block-size: 2.5rem;
  inline-size: 2.5rem;
}

.cds--data-table--xl thead th.cds--table-expand,
.cds--data-table--xl tbody td.cds--table-expand {
  block-size: 4rem;
  padding-block-end: 1.375rem;
  padding-block-start: 0.625rem;
}

.cds--data-table--xl .cds--table-column-checkbox {
  padding-block-start: 0.8125rem;
}

.cds--data-table--xl .cds--table-column-radio {
  padding-block-start: 1rem;
}

.cds--table-column-radio {
  inline-size: 48px;
}

.cds--table-column-radio .cds--radio-button__appearance {
  margin-inline-end: -0.125rem;
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected td,
tr.cds--data-table--selected td {
  border-block-end: 1px solid var(--cds-layer-active);
  border-block-start: 1px solid var(--cds-layer-selected);
  color: var(--cds-text-primary, #161616);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected,
tr.cds--data-table--selected {
  background-color: var(--cds-layer-selected);
}

.cds--data-table--zebra tbody tr:first-of-type:nth-child(odd).cds--data-table--selected td,
tr.cds--data-table--selected:first-of-type td {
  border-block-start: 1px solid var(--cds-border-subtle-selected);
}

.cds--data-table--zebra tbody tr:last-of-type:nth-child(odd).cds--data-table--selected td,
.cds--data-table--zebra tbody tr:last-of-type:nth-child(even).cds--data-table--selected td,
tr.cds--data-table--selected:last-of-type td {
  border-block-end: 1px solid var(--cds-layer-selected);
  border-block-start: 1px solid var(--cds-layer-selected);
}

.cds--data-table--zebra tbody tr:nth-child(even).cds--data-table--selected td {
  border-block-end: 1px solid var(--cds-layer-active);
}

.cds--data-table--zebra tbody tr:nth-child(even).cds--data-table--selected:hover td {
  border-block-end: 1px solid var(--cds-layer-selected-hover);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover td,
.cds--data-table tbody .cds--data-table--selected:hover td {
  border-block-end: 1px solid var(--cds-layer-selected-hover);
  border-block-start: 1px solid var(--cds-layer-selected-hover);
  color: var(--cds-text-primary, #161616);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover,
.cds--data-table tbody .cds--data-table--selected:hover {
  background-color: var(--cds-layer-selected-hover);
}

.cds--data-table--selected .cds--overflow-menu .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--data-table--xs thead tr,
.cds--data-table--xs tbody tr,
.cds--data-table--xs tbody tr th {
  block-size: 1.5rem;
}

.cds--data-table--xs .cds--table-header-label {
  padding-block-end: 0.125rem;
  padding-block-start: 0.125rem;
}

.cds--data-table--xs td,
.cds--data-table--xs tbody tr th {
  padding-block-end: 0.125rem;
  padding-block-start: 0.125rem;
}

.cds--data-table--xs .cds--overflow-menu {
  block-size: calc(100% + 1px);
  inline-size: 2rem;
}

.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block-end: 0;
  padding-block-start: 0;
}

.cds--data-table.cds--data-table--xs .cds--table-column-checkbox .cds--checkbox-label {
  block-size: 1.4375rem;
  min-block-size: 1.4375rem;
}

.cds--data-table--sm thead tr,
.cds--data-table--sm tbody tr,
.cds--data-table--sm tbody tr th {
  block-size: 2rem;
}

.cds--data-table--sm .cds--table-header-label {
  padding-block-end: 0.4375rem;
  padding-block-start: 0.4375rem;
}

.cds--data-table--sm td,
.cds--data-table--sm tbody tr th,
.cds--data-table--sm.cds--data-table--top-aligned-header th.cds--table-column-checkbox {
  padding-block-end: 0.375rem;
  padding-block-start: 0.4375rem;
}

.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block-end: 0.1875rem;
  padding-block-start: 0.1875rem;
}

.cds--data-table--sm .cds--overflow-menu {
  block-size: calc(100% + 1px);
}

.cds--data-table--md thead tr,
.cds--data-table--md tbody tr,
.cds--data-table--md tbody tr th {
  block-size: 2.5rem;
}

.cds--data-table--md .cds--table-header-label,
.cds--data-table--md.cds--data-table--top-aligned-header th.cds--table-column-checkbox {
  padding-block-end: 0.4375rem;
  padding-block-start: 0.4375rem;
}

.cds--data-table--md td,
.cds--data-table--md tbody tr th {
  padding-block-end: 0.375rem;
  padding-block-start: 0.4375rem;
}

.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block-end: 0.1875rem;
  padding-block-start: 0.1875rem;
}

.cds--data-table--md .cds--table-column-menu {
  padding-block-end: 0.1875rem;
  padding-block-start: 0.1875rem;
}

.cds--data-table--xl thead tr,
.cds--data-table--xl tbody tr,
.cds--data-table--xl tbody tr th {
  block-size: 4rem;
}

.cds--data-table--xl .cds--table-header-label {
  padding-block-end: 1rem;
  padding-block-start: 1rem;
}

.cds--data-table--xl td,
.cds--data-table--xl tbody tr th {
  padding-block-end: 1rem;
  padding-block-start: 1rem;
}

.cds--data-table--xl th,
.cds--data-table--xl td {
  vertical-align: top;
}

.cds--data-table--xl .cds--data-table--cell-secondary-text {
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--data-table--static {
  inline-size: auto;
}

.cds--data-table-container--static {
  inline-size: fit-content;
}

.cds--data-table_inner-container {
  background-color: var(--cds-layer-accent);
  transform: translateZ(0);
}

.cds--data-table--sticky-header {
  display: block;
  overflow-y: scroll;
}
.cds--data-table--sticky-header thead,
.cds--data-table--sticky-header tbody,
.cds--data-table--sticky-header tr,
.cds--data-table--sticky-header th,
.cds--data-table--sticky-header td {
  display: flex;
}
.cds--data-table--sticky-header thead {
  position: sticky;
  z-index: 1;
  overflow: scroll;
  inline-size: 100%;
  inset-block-start: 0;
  -ms-overflow-style: none;
  will-change: transform;
}
.cds--data-table--sticky-header thead tr th {
  border-block-end: 1px solid var(--cds-layer-active);
}
.cds--data-table--sticky-header tbody {
  flex-direction: column;
  -ms-overflow-style: none;
  overflow-x: scroll;
  will-change: transform;
}
.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row {
  block-size: auto;
  min-block-size: 3rem;
}
.cds--data-table--sticky-header tr.cds--expandable-row:not(.cds--parent-row) {
  block-size: auto;
}
.cds--data-table--sticky-header .cds--table-expand {
  max-inline-size: 3rem;
}
.cds--data-table--sticky-header thead .cds--table-expand {
  align-items: center;
}
.cds--data-table--sticky-header .cds--parent-row {
  min-block-size: 3rem;
}
.cds--data-table--sticky-header:not(.cds--data-table--xs):not(.cds--data-table--xl):not(.cds--data-table--sm) td:not(.cds--table-column-menu):not(.cds--table-column-checkbox) {
  padding-block-start: 0.875rem;
}
.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row:hover + tr[data-child-row] td {
  border-block-start: 1px solid var(--cds-layer-hover);
}
.cds--data-table--sticky-header tr.cds--expandable-row:last-of-type {
  overflow: hidden;
}
.cds--data-table--sticky-header tr.cds--data-table--selected:first-of-type td {
  border-block-start: none;
}
.cds--data-table--sticky-header thead th.cds--table-column-checkbox,
.cds--data-table--sticky-header tbody tr td.cds--table-column-checkbox {
  align-items: center;
  inline-size: 2.25rem;
  min-inline-size: 2.25rem;
}
.cds--data-table--sticky-header.cds--data-table--xl thead th.cds--table-column-checkbox, .cds--data-table--sticky-header.cds--data-table--xl td.cds--table-column-checkbox {
  align-items: flex-start;
}
.cds--data-table--sticky-header {
  /* When using sticky header, with a selection element in the first column, we need to set the last item to a fixed width to match the table body. We only want this to happen when the last table header does not have any text */
}
.cds--data-table--sticky-header th.cds--table-column-checkbox ~ th:last-of-type:empty {
  max-inline-size: 4rem;
}
.cds--data-table--sticky-header th:empty:not(.cds--table-expand) {
  max-inline-size: 2.25rem;
}
.cds--data-table--sticky-header td.cds--table-column-menu {
  align-items: center;
  block-size: auto;
  padding-block-start: 0;
}
.cds--data-table--sticky-header thead::-webkit-scrollbar,
.cds--data-table--sticky-header tbody::-webkit-scrollbar {
  display: none;
}
@-moz-document url-prefix() {
  .cds--data-table--sticky-header thead,
  .cds--data-table--sticky-header tbody {
    scrollbar-width: none;
  }
}
.cds--data-table--sticky-header tbody tr:last-of-type {
  border-block-end: 0;
}
.cds--data-table--sticky-header th:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon),
.cds--data-table--sticky-header td:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon) {
  inline-size: 100%;
  min-inline-size: 0;
}
.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row), .cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row), .cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row) {
  block-size: auto;
}
.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row) {
  min-block-size: 1.5rem;
}
.cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row) {
  min-block-size: 2rem;
}
.cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row) {
  min-block-size: 4rem;
}
.cds--data-table--sticky-header.cds--data-table--xs tr td.cds--table-expand {
  padding-block-start: 0.25rem;
}
.cds--data-table--sticky-header.cds--data-table--sm tr td.cds--table-expand {
  padding-block-start: 0.5rem;
}
.cds--data-table--sticky-header .cds--table-header-label {
  display: block;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-inline-size: calc(100% - 10px);
  overflow-y: hidden;
  padding-block-end: 1rem;
  padding-block-start: 0.9375rem;
}
.cds--data-table--sticky-header.cds--data-table--xs th .cds--table-header-label {
  padding-block-end: 0;
  padding-block-start: 0.1875rem;
}
.cds--data-table--sticky-header.cds--data-table--sm th .cds--table-header-label {
  padding-block-end: 0;
  padding-block-start: 0.5rem;
}
.cds--data-table--sticky-header.cds--data-table--xl th .cds--table-header-label {
  padding-block-start: 1rem;
}
.cds--data-table--sticky-header.cds--data-table--xl th.cds--table-expand {
  display: flex;
  align-items: flex-start;
}
.cds--data-table--sticky-header.cds--data-table--xs tr.cds--parent-row .cds--table-column-checkbox, .cds--data-table--sticky-header.cds--data-table--sm tr.cds--parent-row .cds--table-column-checkbox {
  align-items: flex-start;
}

.cds--data-table--max-width {
  max-inline-size: 100%;
}

.cds--data-table--sticky-header {
  max-block-size: 18.75rem;
}

.cds--data-table .cds--form-item.cds--checkbox-wrapper:last-of-type {
  margin: 0;
}

.cds--data-table--xs .cds--form-item.cds--checkbox-wrapper:last-of-type,
.cds--data-table--sm .cds--form-item.cds--checkbox-wrapper:last-of-type {
  margin: -0.1875rem 0;
}

.cds--data-table .cds--table-column-slug {
  inline-size: 1rem;
  padding-inline-end: 0;
}

tr.cds--data-table--slug-row,
tr.cds--data-table--slug-row + .cds--expandable-row {
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
  background-attachment: fixed;
}

.cds--data-table--slug-row {
  box-shadow: inset 1px 0 var(--cds-ai-border-strong, #4589ff);
}

.cds--data-table tbody tr.cds--data-table--slug-row:hover td,
tr.cds--data-table--slug-row.cds--expandable-row:hover + .cds--expandable-row[data-child-row] td,
tr.cds--data-table--slug-row.cds--expandable-row--hover + .cds--expandable-row[data-child-row]:hover > td,
tr.cds--data-table--slug-row.cds--expandable-row--hover > td,
tr.cds--data-table--selected.cds--data-table--slug-row.cds--expandable-row + tr.cds--expandable-row[data-child-row] > td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:first-of-type,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected:not(.cds--expandable-row):hover > td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover + tr[data-child-row] > td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover > td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover > td:first-of-type {
  background-color: transparent;
}

.cds--data-table tbody tr.cds--data-table--slug-row:hover,
tr.cds--data-table--slug-row:hover + .cds--expandable-row[data-child-row],
tr.cds--data-table--slug-row.cds--expandable-row--hover + .cds--expandable-row[data-child-row]:hover,
tr.cds--expandable-row--hover.cds--data-table--slug-row,
tr.cds--data-table--selected.cds--parent-row.cds--expandable-row--hover.cds--data-table--slug-row {
  background: linear-gradient(to right, var(--cds-ai-aura-hover-start, rgba(69, 137, 255, 0.32)) 0%, 15%, var(--cds-ai-aura-hover-end, rgba(255, 255, 255, 0)) 50%), var(--cds-ai-aura-hover-background, #edf5ff);
  background-attachment: fixed;
}

tr.cds--parent-row.cds--data-table--selected.cds--data-table--slug-row,
.cds--data-table--selected.cds--data-table--slug-row,
tr.cds--data-table--selected.cds--data-table--slug-row + .cds--expandable-row {
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%), var(--cds-layer-selected);
  background-attachment: fixed;
}

tr.cds--data-table--slug-row.cds--data-table--selected td,
tr.cds--data-table--slug-row.cds--data-table--selected:hover td,
tbody tr.cds--data-table--slug-row:hover td,
tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug) {
  border-block-end-color: var(--cds-border-subtle);
}

tr.cds--expandable-row.cds--data-table--selected.cds--data-table--slug-row[data-parent-row] > td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug) {
  border-block-end: 1px solid var(--cds-layer-selected);
}

tr.cds--parent-row.cds--data-table--slug-row.cds--expandable-row:hover td:first-of-type {
  border-block-end: 1px solid transparent;
}

.cds--data-table thead th.cds--table-sort__header--slug .cds--table-sort,
.cds--data-table thead th:has(> .cds--table-header-label--slug) {
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

.cds--table-column-slug .cds--slug {
  position: absolute;
  z-index: 2;
  transform: translateY(-50%);
}

.cds--data-table--xl .cds--table-column-slug .cds--slug {
  transform: translateY(1px);
}

th .cds--table-header-label.cds--table-header-label--slug {
  display: flex;
  align-items: center;
}

th .cds--table-header-label.cds--table-header-label--slug .cds--slug {
  margin-inline-start: auto;
}

th.cds--table-sort__header--slug,
th:has(.cds--table-header-label--slug) {
  box-shadow: inset 0 1px var(--cds-ai-border-strong, #4589ff);
}

td.cds--table-cell--column-slug {
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug {
  border-block-start: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug,
  .cds--data-table-content {
    outline: 1px solid transparent;
  }
}

.cds--layout--size-xs {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xs, 1.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xs {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xs, 1.5rem));
}

.cds--layout-constraint--size__min-xs {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout-constraint--size__max-xs {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout--size-sm {
  --cds-layout-size-height-context: var(--cds-layout-size-height-sm, 2rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-sm {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-sm, 2rem));
}

.cds--layout-constraint--size__min-sm {
  --cds-layout-size-height-min: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout-constraint--size__max-sm {
  --cds-layout-size-height-max: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout--size-md {
  --cds-layout-size-height-context: var(--cds-layout-size-height-md, 2.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-md {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-md, 2.5rem));
}

.cds--layout-constraint--size__min-md {
  --cds-layout-size-height-min: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout-constraint--size__max-md {
  --cds-layout-size-height-max: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout--size-lg {
  --cds-layout-size-height-context: var(--cds-layout-size-height-lg, 3rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-lg {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-lg, 3rem));
}

.cds--layout-constraint--size__min-lg {
  --cds-layout-size-height-min: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout-constraint--size__max-lg {
  --cds-layout-size-height-max: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout--size-xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xl, 4rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xl, 4rem));
}

.cds--layout-constraint--size__min-xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout-constraint--size__max-xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout--size-2xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-2xl, 5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-2xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-2xl, 5rem));
}

.cds--layout-constraint--size__min-2xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout-constraint--size__max-2xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout--density-condensed {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-condensed {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-condensed, 0.5rem));
}

.cds--layout-constraint--density__min-condensed {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout-constraint--density__max-condensed {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout--density-normal {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-normal, 1rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-normal {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-normal, 1rem));
}

.cds--layout-constraint--density__min-normal {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-normal, 1rem);
}

.cds--layout-constraint--density__max-normal {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-normal, 1rem);
}

:root {
  --cds-layout-size-height-xs: 1.5rem;
  --cds-layout-size-height-sm: 2rem;
  --cds-layout-size-height-md: 2.5rem;
  --cds-layout-size-height-lg: 3rem;
  --cds-layout-size-height-xl: 4rem;
  --cds-layout-size-height-2xl: 5rem;
  --cds-layout-size-height-min: 0px;
  --cds-layout-size-height-max: 999999999px;
  --cds-layout-density-padding-inline-condensed: 0.5rem;
  --cds-layout-density-padding-inline-normal: 1rem;
  --cds-layout-density-padding-inline-min: 0px;
  --cds-layout-density-padding-inline-max: 999999999px;
}

.cds--popover-container {
  display: inline-block;
}

.cds--popover-container:not(.cds--popover--auto-align) {
  position: relative;
}

.cds--popover--high-contrast .cds--popover {
  --cds-popover-background-color: var(--cds-background-inverse, #393939);
  --cds-popover-text-color: var(--cds-text-inverse, #ffffff);
}

.cds--popover--drop-shadow .cds--popover {
  --cds-popover-drop-shadow: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
}

.cds--popover--caret {
  --cds-popover-offset: 0.625rem;
}

.cds--popover {
  position: absolute;
  z-index: 6000;
  filter: var(--cds-popover-drop-shadow, none);
  inset: 0;
  pointer-events: none;
}

.cds--popover-content {
  --cds-layout-size-height-sm: 2rem;
}
.cds--layout--size-sm .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-sm);
}
.cds--popover-content {
  --cds-layout-size-height-md: 2.5rem;
}
.cds--layout--size-md .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-md);
}
.cds--popover-content {
  --cds-layout-size-height-lg: 3rem;
}
.cds--layout--size-lg .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-lg);
}
.cds--popover-content {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover-content *,
.cds--popover-content *::before,
.cds--popover-content *::after {
  box-sizing: inherit;
}
.cds--popover-content {
  position: absolute;
  z-index: 6000;
  display: none;
  border-radius: var(--cds-popover-border-radius, 2px);
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  color: var(--cds-popover-text-color, var(--cds-text-primary, #161616));
  inline-size: max-content;
  max-inline-size: 23rem;
  pointer-events: auto;
}

.cds--popover--open > .cds--popover > .cds--popover-content {
  display: block;
}

.cds--popover-content::before {
  position: absolute;
  display: none;
  content: "";
}

.cds--popover--open > .cds--popover > .cds--popover-content::before {
  display: block;
}

.cds--popover-caret,
.cds--popover--auto-align.cds--popover-caret {
  position: absolute;
  z-index: 6000;
  display: none;
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  will-change: transform;
}

.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-caret {
  display: block;
}

.cds--popover--auto-align.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-content > .cds--popover-caret {
  display: block;
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-caret {
  display: none;
}

.cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

.cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: 0;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 0;
  inset-inline-start: initial;
}

.cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-end: 0;
  transform: translate(var(--cds-popover-offset, 0rem), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: 0;
}

.cds--popover--bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-left > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-start > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-right > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-end > .cds--popover > .cds--popover-content::before {
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-start: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  transform: translateY(-100%);
}

.cds--popover--bottom > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, var(--cds-popover-offset, 0rem));
}

[dir=rtl] .cds--popover--bottom > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  transform: translate(50%, var(--cds-popover-offset, 0rem));
}

.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

.cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 0;
  inset-inline-start: initial;
}

.cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translate(var(--cds-popover-offset, 0rem), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: 0;
}

.cds--popover--top > .cds--popover > .cds--popover-content::before,
.cds--popover--top-left > .cds--popover > .cds--popover-content::before,
.cds--popover--top-start > .cds--popover > .cds--popover-content::before,
.cds--popover--top-right > .cds--popover > .cds--popover-content::before,
.cds--popover--top-end > .cds--popover > .cds--popover-content::before {
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  transform: translateY(100%);
}

.cds--popover--top > .cds--popover > .cds--popover-caret,
.cds--popover--top-left > .cds--popover > .cds--popover-caret,
.cds--popover--top-start > .cds--popover > .cds--popover-caret,
.cds--popover--top-right > .cds--popover > .cds--popover-caret,
.cds--popover--top-end > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  transform: translate(50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), -50%);
}

.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) * -1 - 16px));
}

.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--right > .cds--popover > .cds--popover-content::before,
.cds--popover--right-top > .cds--popover > .cds--popover-content::before,
.cds--popover--right-start > .cds--popover > .cds--popover-content::before,
.cds--popover--right-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--right-end > .cds--popover > .cds--popover-content::before {
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: translateX(-100%);
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(calc(var(--cds-popover-offset, 0rem) - 100%), -50%);
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 0.1px), -50%);
}

.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-0.5 * var(--cds-popover-offset, 0rem) - 16px));
}

.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--left > .cds--popover > .cds--popover-content::before,
.cds--popover--left-top > .cds--popover > .cds--popover-content::before,
.cds--popover--left-start > .cds--popover > .cds--popover-content::before,
.cds--popover--left-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--left-end > .cds--popover > .cds--popover-content::before {
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translateX(100%);
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 100%), -50%);
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-content {
  border-radius: 0;
}

.cds--popover--tab-tip .cds--popover {
  will-change: filter;
}

.cds--popover--tab-tip__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover--tab-tip__button *,
.cds--popover--tab-tip__button *::before,
.cds--popover--tab-tip__button *::after {
  box-sizing: inherit;
}
.cds--popover--tab-tip__button {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--popover--tab-tip__button::-moz-focus-inner {
  border: 0;
}
.cds--popover--tab-tip__button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--popover--tab-tip__button:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--popover--tab-tip__button:focus {
    outline-style: dotted;
  }
}
.cds--popover--tab-tip__button:hover {
  background-color: var(--cds-layer-hover);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button {
  background: var(--cds-layer);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus)::after {
  position: absolute;
  z-index: 6001;
  background: var(--cds-layer);
  block-size: 2px;
  content: "";
  inline-size: 100%;
  inset-block-end: 0;
}

.cds--popover--tab-tip__button svg {
  fill: var(--cds-icon-primary, #161616);
}

.cds--tooltip {
  --cds-popover-offset: 12px;
}

.cds--tooltip-content {
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: var(--cds-tooltip-padding-block, 1rem) var(--cds-tooltip-padding-inline, 1rem);
  color: var(--cds-text-inverse, #ffffff);
  max-inline-size: 18rem;
}

.cds--icon-tooltip {
  --cds-tooltip-padding-block: 0.125rem;
  --cds-popover-caret-width: 0.5rem;
  --cds-popover-caret-height: 0.25rem;
  --cds-popover-offset: 0.5rem;
}

.cds--icon-tooltip .cds--tooltip-content {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--definition-term {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--definition-term *,
.cds--definition-term *::before,
.cds--definition-term *::after {
  box-sizing: inherit;
}
.cds--definition-term {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--definition-term::-moz-focus-inner {
  border: 0;
}
.cds--definition-term {
  border-radius: 0;
  border-block-end: 1px dotted var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
}

.cds--definition-term:focus {
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--definition-term:focus {
    outline-style: dotted;
  }
}
.cds--definition-term:focus {
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-term:hover {
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-tooltip {
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: 0.5rem 1rem;
  max-inline-size: 11rem;
}

.cds--btn {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-lg)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-2xl)));
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  --temp-1lh: (
    var(--cds-body-compact-01-line-height, 1.28572) * 1em
  );
  --temp-expressive-1lh: (
    var(--cds-body-compact-02-line-height, 1.375) * 1em
  );
  --temp-padding-block-max: calc(
    (var(--cds-layout-size-height-lg) - var(--temp-1lh)) / 2 -
      0.0625rem
  );
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--btn *,
.cds--btn *::before,
.cds--btn *::after {
  box-sizing: inherit;
}
.cds--btn {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: space-between;
  border-radius: 0;
  margin: 0;
  cursor: pointer;
  inline-size: max-content;
  max-inline-size: 20rem;
  min-block-size: var(--cds-layout-size-height-local);
  outline: none;
  padding-block: min((var(--cds-layout-size-height-local) - var(--temp-1lh)) / 2 - 0.0625rem, var(--temp-padding-block-max));
  padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) * 3 + 1rem - 0.0625rem);
  padding-inline-start: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
  text-align: start;
  text-decoration: none;
  transition: background 70ms cubic-bezier(0, 0, 0.38, 0.9), box-shadow 70ms cubic-bezier(0, 0, 0.38, 0.9), border-color 70ms cubic-bezier(0, 0, 0.38, 0.9), outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
  vertical-align: top;
}
.cds--btn:disabled, .cds--btn:hover:disabled, .cds--btn:focus:disabled, .cds--btn.cds--btn--disabled, .cds--btn.cds--btn--disabled:hover, .cds--btn.cds--btn--disabled:focus {
  border-color: var(--cds-button-disabled, #c6c6c6);
  background: var(--cds-button-disabled, #c6c6c6);
  box-shadow: none;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
  cursor: not-allowed;
}
.cds--btn .cds--btn__icon {
  position: absolute;
  flex-shrink: 0;
  block-size: 1rem;
  inline-size: 1rem;
  inset-block-start: min((var(--cds-layout-size-height-local) - 1rem) / 2 - 0.0625rem, var(--temp-padding-block-max));
  inset-inline-end: var(--cds-layout-density-padding-inline-local);
  margin-block-start: 0.0625rem;
}

.cds--btn::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.cds--btn--primary {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: var(--cds-button-primary, #0f62fe);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--primary:hover {
  background-color: var(--cds-button-primary-hover, #0050e6);
}
.cds--btn--primary:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--primary:active {
  background-color: var(--cds-button-primary-active, #002d9c);
}
.cds--btn--primary .cds--btn__icon,
.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--primary:hover {
  color: var(--cds-text-on-color, #ffffff);
}

.cds--btn--secondary {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: var(--cds-button-secondary, #393939);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--secondary:hover {
  background-color: var(--cds-button-secondary-hover, #474747);
}
.cds--btn--secondary:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--secondary:active {
  background-color: var(--cds-button-secondary-active, #6f6f6f);
}
.cds--btn--secondary .cds--btn__icon,
.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--secondary:hover, .cds--btn--secondary:focus {
  color: var(--cds-text-on-color, #ffffff);
}

.cds--btn--tertiary {
  border-width: 1px;
  border-style: solid;
  border-color: var(--cds-button-tertiary, #0f62fe);
  background-color: transparent;
  color: var(--cds-button-tertiary, #0f62fe);
}
.cds--btn--tertiary:hover {
  background-color: var(--cds-button-tertiary-hover, #0050e6);
}
.cds--btn--tertiary:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--tertiary:active {
  background-color: var(--cds-button-tertiary-active, #002d9c);
}
.cds--btn--tertiary .cds--btn__icon,
.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--tertiary:hover {
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:focus {
  background-color: var(--cds-button-tertiary, #0f62fe);
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:active {
  border-color: transparent;
  background-color: var(--cds-button-tertiary-active, #002d9c);
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:disabled, .cds--btn--tertiary:hover:disabled, .cds--btn--tertiary:focus:disabled, .cds--btn--tertiary.cds--btn--disabled, .cds--btn--tertiary.cds--btn--disabled:hover, .cds--btn--tertiary.cds--btn--disabled:focus {
  background: transparent;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
  outline: none;
}

.cds--btn--ghost {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
  color: var(--cds-link-primary, #0f62fe);
}
.cds--btn--ghost:hover {
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}
.cds--btn--ghost:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--ghost:active {
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}
.cds--btn--ghost .cds--btn__icon,
.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--ghost {
  padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
}
.cds--btn--ghost .cds--btn__icon {
  position: static;
  margin-inline-start: 0.5rem;
}
.cds--btn--ghost:hover, .cds--btn--ghost:active {
  color: var(--cds-link-primary-hover, #0043ce);
}
.cds--btn--ghost:active {
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}
.cds--btn--ghost:disabled, .cds--btn--ghost:hover:disabled, .cds--btn--ghost:focus:disabled, .cds--btn--ghost.cds--btn--disabled, .cds--btn--ghost.cds--btn--disabled:hover, .cds--btn--ghost.cds--btn--disabled:focus {
  border-color: transparent;
  background: transparent;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
  outline: none;
}
.cds--btn--ghost:not([disabled]) svg {
  fill: var(--cds-icon-primary, #161616);
}

.cds--btn--icon-only {
  justify-content: center;
  padding: 0;
  block-size: var(--cds-layout-size-height-local);
  inline-size: var(--cds-layout-size-height-local);
  padding-block-start: min((var(--cds-layout-size-height-local) - 1rem) / 2 - 0.0625rem, var(--temp-padding-block-max));
}
.cds--btn--icon-only > :first-child {
  margin-block-start: 0.0625rem;
  min-inline-size: 1rem;
}
.cds--btn--icon-only .cds--btn__icon {
  position: static;
}
.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon, .cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon {
  margin: 0;
}

.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon,
.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon {
  margin-block-start: 0;
}

.cds--btn--icon-only.cds--btn--selected {
  background: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}

.cds--btn path[data-icon-path=inner-path] {
  fill: none;
}

.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),
.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon {
  fill: var(--cds-icon-primary, #161616);
}

.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),
.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,
.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon {
  fill: var(--cds-icon-on-color-disabled, #8d8d8d);
}

.cds--btn--ghost.cds--btn--icon-only[disabled] {
  cursor: not-allowed;
}

.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper {
  cursor: not-allowed;
}

.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled] {
  pointer-events: none;
}

.cds--btn--danger {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger:hover {
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger:active {
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger .cds--btn__icon,
.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger:hover {
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary {
  border-width: 1px;
  border-style: solid;
  border-color: var(--cds-button-danger-secondary, #da1e28);
  background-color: transparent;
  color: var(--cds-button-danger-secondary, #da1e28);
}
.cds--btn--danger--tertiary:hover {
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger--tertiary:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger--tertiary:active {
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger--tertiary .cds--btn__icon,
.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger--tertiary:hover {
  border-color: var(--cds-button-danger-hover, #b81921);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:focus {
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:active {
  border-color: var(--cds-button-danger-active, #750e13);
  background-color: var(--cds-button-danger-active, #750e13);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:disabled, .cds--btn--danger--tertiary:hover:disabled, .cds--btn--danger--tertiary:focus:disabled, .cds--btn--danger--tertiary.cds--btn--disabled, .cds--btn--danger--tertiary.cds--btn--disabled:hover, .cds--btn--danger--tertiary.cds--btn--disabled:focus {
  background: transparent;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
  outline: none;
}
.cds--btn--danger--ghost {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
  color: var(--cds-button-danger-secondary, #da1e28);
}
.cds--btn--danger--ghost:hover {
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger--ghost:focus {
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger--ghost:active {
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger--ghost .cds--btn__icon,
.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger--ghost {
  padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
}
.cds--btn--danger--ghost .cds--btn__icon {
  position: static;
  margin-inline-start: 0.5rem;
}
.cds--btn--danger--ghost:hover, .cds--btn--danger--ghost:active {
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--ghost:disabled, .cds--btn--danger--ghost:hover:disabled, .cds--btn--danger--ghost:focus:disabled, .cds--btn--danger--ghost.cds--btn--disabled, .cds--btn--danger--ghost.cds--btn--disabled:hover, .cds--btn--danger--ghost.cds--btn--disabled:focus {
  border-color: transparent;
  background: transparent;
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}

.cds--btn--expressive {
  font-size: var(--cds-body-compact-02-font-size, 1rem);
  font-weight: var(--cds-body-compact-02-font-weight, 400);
  line-height: var(--cds-body-compact-02-line-height, 1.375);
  letter-spacing: var(--cds-body-compact-02-letter-spacing, 0);
  padding-block: min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh)) / 2 - 0.0625rem, var(--temp-padding-block-max));
}

.cds--btn--icon-only.cds--btn--expressive {
  padding: 12px 13px;
}

.cds--btn.cds--btn--expressive .cds--btn__icon {
  block-size: 1.25rem;
  inline-size: 1.25rem;
}

.cds--btn-set .cds--btn.cds--btn--expressive {
  max-inline-size: 20rem;
}

.cds--btn.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--btn.cds--skeleton:hover, .cds--btn.cds--skeleton:focus, .cds--btn.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--btn.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--btn.cds--skeleton::before {
    animation: none;
  }
}
.cds--btn.cds--skeleton {
  inline-size: 9.375rem;
}

.cds--btn-set {
  display: flex;
}

.cds--btn-set--stacked {
  flex-direction: column;
}

.cds--btn-set .cds--btn {
  inline-size: 100%;
  max-inline-size: 12.25rem;
}
.cds--btn-set .cds--btn:not(:focus) {
  box-shadow: -0.0625rem 0 0 0 var(--cds-button-separator, #e0e0e0);
}
.cds--btn-set .cds--btn:first-of-type:not(:focus) {
  box-shadow: inherit;
}

.cds--btn-set .cds--btn:focus + .cds--btn {
  box-shadow: inherit;
}

.cds--btn-set--stacked .cds--btn:not(:focus) {
  box-shadow: 0 -0.0625rem 0 0 var(--cds-button-separator, #e0e0e0);
}

.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus) {
  box-shadow: inherit;
}

.cds--btn-set .cds--btn.cds--btn--disabled {
  box-shadow: -0.0625rem 0 0 0 var(--cds-icon-on-color-disabled, #8d8d8d);
}
.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type {
  box-shadow: none;
}

.cds--btn-set--stacked .cds--btn.cds--btn--disabled {
  box-shadow: 0 -0.0625rem 0 0 var(--cds-layer-selected-disabled, #8d8d8d);
}
.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type {
  box-shadow: none;
}

.cds--btn-set .cds--btn.cds--btn--loading {
  border-color: transparent;
  background-color: transparent;
  box-shadow: none;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),
  .cds--btn--ghost.cds--btn--icon-only .cds--btn__icon {
    fill: ButtonText;
  }
}

[dir=rtl] .cds--btn-set .cds--btn:not(:focus) {
  box-shadow: 0.0625rem 0 0 0 var(--cds-button-separator, #e0e0e0);
}

.cds--overflow-menu,
.cds--overflow-menu__trigger {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu *,
.cds--overflow-menu *::before,
.cds--overflow-menu *::after,
.cds--overflow-menu__trigger *,
.cds--overflow-menu__trigger *::before,
.cds--overflow-menu__trigger *::after {
  box-sizing: inherit;
}
.cds--overflow-menu,
.cds--overflow-menu__trigger {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--overflow-menu::-moz-focus-inner,
.cds--overflow-menu__trigger::-moz-focus-inner {
  border: 0;
}
.cds--overflow-menu,
.cds--overflow-menu__trigger {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu *,
.cds--overflow-menu *::before,
.cds--overflow-menu *::after,
.cds--overflow-menu__trigger *,
.cds--overflow-menu__trigger *::before,
.cds--overflow-menu__trigger *::after {
  box-sizing: inherit;
}
.cds--overflow-menu,
.cds--overflow-menu__trigger {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 2.5rem;
  cursor: pointer;
  inline-size: 2.5rem;
  min-block-size: 2.5rem;
  transition: outline 110ms cubic-bezier(0, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--overflow-menu:focus,
.cds--overflow-menu__trigger:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu:focus,
  .cds--overflow-menu__trigger:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu:hover,
.cds--overflow-menu__trigger:hover {
  background-color: var(--cds-layer-hover);
}

.cds--overflow-menu > :first-child {
  margin-block-start: 0;
}

.cds--overflow-menu--sm {
  block-size: 2rem;
  inline-size: 2rem;
  min-block-size: 2rem;
}

.cds--overflow-menu--lg {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus svg {
  outline: none;
}

.cds--overflow-menu.cds--overflow-menu--open,
.cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__trigger {
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  background-color: var(--cds-layer);
  transition: none;
}

.cds--overflow-menu--light.cds--overflow-menu--open,
.cds--overflow-menu--light.cds--overflow-menu--open .cds--overflow-menu__trigger {
  background-color: var(--cds-layer);
}

.cds--overflow-menu__icon {
  block-size: 1rem;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1rem;
}

.cds--overflow-menu__wrapper {
  line-height: 0;
}

.cds--overflow-menu-options {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu-options *,
.cds--overflow-menu-options *::before,
.cds--overflow-menu-options *::after {
  box-sizing: inherit;
}
.cds--overflow-menu-options {
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  position: absolute;
  z-index: 6000;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--cds-layer);
  inline-size: 10rem;
  inset-block-start: 32px;
  inset-inline-start: 0;
  list-style: none;
}
.cds--overflow-menu-options::after {
  position: absolute;
  display: block;
  background-color: var(--cds-layer);
  content: "";
  transition: background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--overflow-menu-options::after {
    transition: none;
  }
}

.cds--overflow-menu.cds--overflow-menu--open:hover {
  background-color: var(--cds-layer);
}

.cds--overflow-menu-options--light {
  background-color: var(--cds-layer);
}
.cds--overflow-menu-options--light::after {
  background-color: var(--cds-layer);
}

.cds--overflow-menu.cds--overflow-menu--light.cds--overflow-menu--open:hover {
  background-color: var(--cds-layer);
}

.cds--overflow-menu-options[data-floating-menu-direction=bottom]:not(.cds--breadcrumb-menu-options)::after {
  block-size: 0.1875rem;
  inline-size: 2.5rem;
  inset-block-start: -0.1875rem;
  inset-inline-start: 0;
}

.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  block-size: 0.5rem;
  inline-size: 2.5rem;
  inset-block-end: -0.5rem;
  inset-inline-start: 0;
}

.cds--overflow-menu-options[data-floating-menu-direction=left]::after {
  block-size: 2.5rem;
  inline-size: 0.375rem;
  inset-block-start: 0;
  inset-inline-end: -0.375rem;
}

.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 2.5rem;
  inline-size: 0.375rem;
  inset-block-start: 0;
  inset-inline-start: -0.375rem;
}

.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after, .cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  inline-size: 2rem;
}
.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=left]::after, .cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 2rem;
}

.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after, .cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  inline-size: 3rem;
}
.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=left]::after, .cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 3rem;
}

.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=top]::after,
.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after {
  inset-inline-end: 0;
  inset-inline-start: auto;
}

.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=left]::after,
.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  inset-block-end: 0;
  inset-block-start: auto;
}

.cds--overflow-menu-options--open {
  display: flex;
}

.cds--overflow-menu-options__content {
  inline-size: 100%;
}

.cds--overflow-menu-options__option {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu-options__option *,
.cds--overflow-menu-options__option *::before,
.cds--overflow-menu-options__option *::after {
  box-sizing: inherit;
}
.cds--overflow-menu-options__option {
  display: flex;
  align-items: center;
  padding: 0;
  background-color: transparent;
  block-size: 2.5rem;
  inline-size: 100%;
  transition: background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--overflow-menu-options--sm .cds--overflow-menu-options__option {
  block-size: 2rem;
}

.cds--overflow-menu-options--lg .cds--overflow-menu-options__option {
  block-size: 3rem;
}

.cds--overflow-menu--divider {
  border-block-start: 1px solid var(--cds-border-subtle);
}

.cds--overflow-menu--light .cds--overflow-menu--divider {
  border-block-start: 1px solid var(--cds-border-subtle);
}

a.cds--overflow-menu-options__btn::before {
  display: inline-block;
  block-size: 100%;
  content: "";
  vertical-align: middle;
}

.cds--overflow-menu-options__btn {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: inline-flex;
  align-items: center;
  padding: 0 1rem;
  border: none;
  background-color: transparent;
  block-size: 100%;
  color: var(--cds-text-secondary, #525252);
  cursor: pointer;
  font-family: inherit;
  font-weight: 400;
  inline-size: 100%;
  max-inline-size: 11.25rem;
  text-align: start;
  transition: outline 110ms cubic-bezier(0, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9), color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--overflow-menu-options__btn:hover {
  color: var(--cds-text-primary, #161616);
}
.cds--overflow-menu-options__btn:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu-options__btn:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu-options__btn::-moz-focus-inner {
  border: none;
}

.cds--overflow-menu-options__btn svg {
  fill: var(--cds-icon-secondary, #525252);
}

.cds--overflow-menu-options__btn:hover svg {
  fill: var(--cds-icon-primary, #161616);
}

.cds--overflow-menu-options__option-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--overflow-menu-options__option:hover {
  background-color: var(--cds-layer-hover);
}

.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover,
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus {
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: var(--cds-text-on-color, #ffffff);
}
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover svg,
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus svg {
  fill: currentColor;
}

.cds--overflow-menu-options__option--disabled:hover {
  background-color: var(--cds-layer);
  cursor: not-allowed;
}

.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:hover, .cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:active, .cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:focus {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: var(--cds-layer);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn svg {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--overflow-menu--flip {
  inset-inline-start: -140px;
}
.cds--overflow-menu--flip::before {
  inset-inline-start: 145px;
}

/* stylelint-disable */
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--overflow-menu:focus,
  .cds--overflow-menu-options__btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--overflow-menu svg {
    fill: ButtonText;
  }
}

/*stylelint-enable */
.cds--overflow-menu__top-start {
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 2.5rem)));
}

.cds--overflow-menu__top-end {
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 2.5rem)));
}

.cds--text-input {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--text-input *,
.cds--text-input *::before,
.cds--text-input *::after {
  box-sizing: inherit;
}
.cds--text-input {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  padding: 0 var(--cds-layout-density-padding-inline-local);
  border: none;
  background-color: var(--cds-field);
  block-size: var(--cds-layout-size-height-local);
  border-block-end: 1px solid var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
  font-family: inherit;
  inline-size: 100%;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--text-input:focus, .cds--text-input:active {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--text-input:focus, .cds--text-input:active {
    outline-style: dotted;
  }
}
.cds--text-input-wrapper svg[hidden] {
  display: none;
}

.cds--password-input {
  padding-inline-end: 2.5rem;
}

.cds--text-input--sm.cds--password-input {
  padding-inline-end: 2rem;
}

.cds--text-input--lg.cds--password-input {
  padding-inline-end: 3rem;
}

.cds--text-input::placeholder {
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
}

.cds--text-input--light {
  background-color: var(--cds-field-02, #ffffff);
}

.cds--text-input__field-wrapper {
  position: relative;
  display: flex;
  inline-size: 100%;
}

.cds--text-input__invalid-icon {
  position: absolute;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--text-input__invalid-icon--warning {
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--text-input__invalid-icon--warning path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--text-input--password__visibility {
  position: relative;
  display: inline-flex;
  overflow: visible;
  align-items: center;
}
.cds--text-input--password__visibility:focus {
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--text-input--password__visibility:focus {
    outline-style: dotted;
  }
}
.cds--text-input--password__visibility {
  cursor: pointer;
}
.cds--text-input--password__visibility:focus {
  outline: 1px solid transparent;
}
.cds--text-input--password__visibility:focus svg {
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--text-input--password__visibility:focus svg {
    outline-style: dotted;
  }
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  position: absolute;
  z-index: 6000;
  display: flex;
  align-items: center;
  opacity: 0;
  pointer-events: none;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    display: inline-block;
  }
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after {
  transition: opacity 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after {
    transition: none;
  }
}
.cds--text-input--password__visibility.cds--tooltip--a11y::before, .cds--text-input--password__visibility.cds--tooltip--a11y::after {
  transition: none;
}
.cds--text-input--password__visibility::before {
  border-style: solid;
  block-size: 0;
  content: "";
  inline-size: 0;
}
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  box-sizing: content-box;
  color: inherit;
  opacity: 1;
  white-space: normal;
  word-break: break-word;
}
.cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  z-index: 6000;
  padding: 0.1875rem 1rem;
  border-radius: 0.125rem;
  background-color: var(--cds-background-inverse, #393939);
  block-size: auto;
  color: var(--cds-text-inverse, #ffffff);
  font-weight: 400;
  inline-size: max-content;
  max-inline-size: 13rem;
  min-inline-size: 1.5rem;
  text-align: start;
  transform: translateX(-50%);
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@supports (-ms-accelerator: true) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@supports (-ms-ime-align: auto) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    border: 1px solid transparent;
  }
}
.cds--text-input--password__visibility::after {
  content: attr(aria-label);
}
.cds--text-input--password__visibility.cds--tooltip--a11y::after {
  content: none;
}
.cds--text-input--password__visibility.cds--tooltip--visible::before, .cds--text-input--password__visibility.cds--tooltip--visible::after, .cds--text-input--password__visibility:hover::before, .cds--text-input--password__visibility:hover::after, .cds--text-input--password__visibility:focus::before, .cds--text-input--password__visibility:focus::after {
  opacity: 1;
}
@keyframes cds--tooltip-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,
.cds--text-input--password__visibility.cds--tooltip--visible + .cds--assistive-text, .cds--text-input--password__visibility:hover .cds--assistive-text,
.cds--text-input--password__visibility:hover + .cds--assistive-text, .cds--text-input--password__visibility:focus .cds--assistive-text,
.cds--text-input--password__visibility:focus + .cds--assistive-text {
  overflow: visible;
  margin: auto;
  clip: auto;
}
.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,
.cds--text-input--password__visibility.cds--tooltip--visible + .cds--assistive-text, .cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y::before, .cds--text-input--password__visibility:hover .cds--assistive-text,
.cds--text-input--password__visibility:hover + .cds--assistive-text, .cds--text-input--password__visibility:hover.cds--tooltip--a11y::before, .cds--text-input--password__visibility:focus .cds--assistive-text,
.cds--text-input--password__visibility:focus + .cds--assistive-text, .cds--text-input--password__visibility:focus.cds--tooltip--a11y::before {
  animation: cds--tooltip-fade 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text, .cds--text-input--password__visibility.cds--tooltip--hidden + .cds--assistive-text {
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
}
.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y::before {
  animation: none;
  opacity: 0;
}
.cds--text-input--password__visibility .cds--assistive-text::after {
  position: absolute;
  display: block;
  content: "";
  block-size: 0.75rem;
  inline-size: 100%;
  inset-inline-start: 0;
  inset-block-start: -0.75rem;
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  inset-block-end: 0;
  inset-inline-start: 50%;
}
.cds--text-input--password__visibility::before {
  border-width: 0 0.25rem 0.3125rem 0.25rem;
  border-color: transparent transparent var(--cds-background-inverse, #393939) transparent;
  inset-block-end: -0.5rem;
  transform: translate(-50%, 100%);
}
.cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  inset-block-end: -0.8125rem;
  transform: translate(-50%, 100%);
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  block-size: 100%;
  cursor: pointer;
  inline-size: 2.5rem;
  inset-inline-end: 0;
  min-block-size: auto;
  transition: outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--toggle-password-tooltip .cds--popover {
  inset-inline-start: -2.5rem;
}

.cds--text-input--sm + .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  inline-size: 2rem;
}

.cds--text-input--lg + .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  inline-size: 3rem;
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg {
  fill: var(--cds-icon-secondary, #525252);
  transition: fill 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg {
    fill: ButtonText;
  }
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg,
.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg {
  fill: var(--cds-icon-primary, #161616);
}

.cds--text-input--invalid,
.cds--text-input--warning {
  padding-inline-end: 2.5rem;
}

.cds--text-input--invalid.cds--password-input {
  padding-inline-end: 4rem;
}

.cds--text-input--invalid + .cds--text-input--password__visibility__toggle {
  inset-inline-end: 1rem;
}

.cds--password-input-wrapper .cds--text-input__invalid-icon {
  inset-inline-end: 2.5rem;
}

.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  cursor: not-allowed;
}

.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--text-input__counter-alert {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
}

.cds--text-input:disabled {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: var(--cds-field);
  border-block-end: 1px solid transparent;
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  -webkit-text-fill-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--text-input--light:disabled {
  background-color: var(--cds-field-02, #ffffff);
}

.cds--text-input:disabled::placeholder {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  opacity: 1;
}

.cds--text-input--invalid {
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--text-input--invalid {
    outline-style: dotted;
  }
}
.cds--text-input--invalid {
  box-shadow: none;
}
.cds--text-input--invalid .cds--text-input--password__visibility__toggle {
  inset-inline-end: 2.5rem;
}

.cds--skeleton.cds--text-input {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--skeleton.cds--text-input:hover, .cds--skeleton.cds--text-input:focus, .cds--skeleton.cds--text-input:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--skeleton.cds--text-input::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--skeleton.cds--text-input::before {
    animation: none;
  }
}

.cds--form--fluid .cds--text-input-wrapper {
  position: relative;
  background: var(--cds-field);
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--form--fluid .cds--label {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  margin: 0;
  block-size: 1rem;
  inset-block-start: 0.8125rem;
  inset-inline-start: 1rem;
}

.cds--form--fluid .cds--form__helper-text {
  display: none;
}

.cds--form--fluid .cds--text-input {
  padding: 2rem 1rem 0.8125rem;
  min-block-size: 4rem;
}

.cds--text-input__divider,
.cds--form--fluid .cds--text-input__divider {
  display: none;
}

.cds--form--fluid .cds--text-input--invalid,
.cds--form--fluid .cds--text-input--warning {
  border-block-end: none;
}

.cds--form--fluid .cds--text-input--invalid + .cds--text-input__divider,
.cds--form--fluid .cds--text-input--warning + .cds--text-input__divider {
  display: block;
  border-style: solid;
  border-color: var(--cds-border-subtle);
  margin: 0 1rem;
  border-block-end: none;
}

.cds--form--fluid .cds--text-input__invalid-icon {
  inset-block-start: 5rem;
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid,
.cds--form--fluid .cds--text-input__field-wrapper--warning > .cds--text-input--warning {
  outline: none;
}

.cds--form--fluid .cds--text-input__field-wrapper--warning {
  border-block-end: 1px solid var(--cds-border-strong);
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus) {
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus) {
    outline-style: dotted;
  }
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within,
.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within,
  .cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within {
    outline-style: dotted;
  }
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:focus,
.cds--form--fluid .cds--text-input__field-wrapper--warning > .cds--text-input--warning:focus {
  outline: none;
}

.cds--text-input-wrapper.cds--text-input-wrapper--inline {
  flex-flow: row wrap;
}

.cds--text-input-wrapper .cds--label--inline {
  flex: 1;
  margin: 0.8125rem 0 0 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.cds--text-input-wrapper .cds--label--inline--sm {
  margin-block-start: 0.5625rem;
}

.cds--text-input-wrapper .cds--label--inline--lg {
  margin-block-start: 1.0625rem;
}

.cds--text-input__label-helper-wrapper {
  flex: 2;
  flex-direction: column;
  margin-inline-end: 1.5rem;
  max-inline-size: 8rem;
  overflow-wrap: break-word;
}

.cds--text-input-wrapper .cds--form__helper-text--inline {
  margin-block-start: 0.125rem;
}

.cds--text-input__field-outer-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  inline-size: 100%;
}

.cds--text-input__field-outer-wrapper--inline {
  flex: 8;
  flex-direction: column;
}

.cds--text-input-wrapper--inline .cds--form-requirement {
  display: block;
  overflow: visible;
  font-weight: 400;
  max-block-size: 12.5rem;
}

.cds--text-input-wrapper--inline--invalid .cds--form-requirement {
  color: var(--cds-text-error, #da1e28);
}

.cds--form--fluid .cds--text-input-wrapper--readonly,
.cds--text-input-wrapper--readonly .cds--text-input {
  background: transparent;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--text-input__field-wrapper .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--text-input__field-wrapper--slug .cds--text-input:not(:has(~ .cds--slug--revert)) {
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
  padding-inline-end: 2.5rem;
}

.cds--text-input--invalid:has(~ .cds--slug),
.cds--text-input--warning:has(~ .cds--slug) {
  padding-inline-end: 4rem;
}

.cds--text-input--invalid ~ .cds--slug,
.cds--text-input--warning ~ .cds--slug {
  inset-inline-end: 2.5rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,
  .cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg {
    fill: ButtonText;
  }
}

.cds--text-input__label-wrapper {
  display: flex;
  justify-content: space-between;
  inline-size: 100%;
}
.cds--text-input__label-wrapper .cds--text-input__label-counter {
  align-self: end;
}

.cds--search {
  position: relative;
  display: flex;
  align-items: center;
  inline-size: 100%;
}

.cds--search .cds--label {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--search-input {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-input *,
.cds--search-input *::before,
.cds--search-input *::after {
  box-sizing: inherit;
}
.cds--search-input {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  order: 1;
  padding: 0 2.5rem;
  border: none;
  appearance: none;
  background-color: var(--cds-field);
  border-block-end: 1px solid var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  text-overflow: ellipsis;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--search-input:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-input:focus {
    outline-style: dotted;
  }
}
.cds--search-input::placeholder {
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
}
.cds--search-input::-ms-clear {
  display: none;
}

.cds--search-input[disabled] {
  background-color: var(--cds-field);
  border-block-end: 1px solid transparent;
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--search-input[disabled]::placeholder {
  color: var(--cds-field);
}

.cds--search--light .cds--search-input {
  background: var(--cds-field-02, #ffffff);
}

.cds--search--light .cds--search-close::before {
  background: var(--cds-field-02, #ffffff);
}

.cds--search--sm .cds--search-input,
.cds--search--sm.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 2rem;
  block-size: 2rem;
}

.cds--search--sm .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--search--md .cds--search-input,
.cds--search--md.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 2.5rem;
  block-size: 2.5rem;
}

.cds--search--md .cds--search-magnifier-icon {
  inset-inline-start: 0.75rem;
}

.cds--search--lg .cds--search-input,
.cds--search--lg.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 3rem;
  block-size: 3rem;
}

.cds--search-magnifier-icon {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-magnifier-icon *,
.cds--search-magnifier-icon *::before,
.cds--search-magnifier-icon *::after {
  box-sizing: inherit;
}
.cds--search-magnifier-icon {
  position: absolute;
  z-index: 2;
  block-size: 1rem;
  fill: var(--cds-icon-secondary, #525252);
  inline-size: 1rem;
  inset-block-start: 50%;
  inset-inline-start: 1rem;
  pointer-events: none;
  transform: translateY(-50%);
}

.cds--search-close {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-close *,
.cds--search-close *::before,
.cds--search-close *::after {
  box-sizing: inherit;
}
.cds--search-close {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
}
.cds--search-close::-moz-focus-inner {
  border: 0;
}
.cds--search-close {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
}
.cds--search-close::before {
  position: absolute;
  display: block;
  background-color: var(--cds-field);
  block-size: calc(100% - 2px);
  content: "";
  inline-size: 2px;
  inset-block-start: 0.0625rem;
  inset-inline-start: 0;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--search-close::before {
    transition: none;
  }
}
.cds--search-close:hover {
  border-block-end: 1px solid var(--cds-border-strong);
}
.cds--search-close:hover::before {
  background-color: var(--cds-field-hover);
}

.cds--search-button {
  flex-shrink: 0;
  background-color: var(--cds-field);
  margin-inline-start: 0.125rem;
}
.cds--search-button svg {
  fill: currentColor;
  vertical-align: middle;
}

.cds--search-close svg {
  fill: inherit;
}

.cds--search-close,
.cds--search-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px 0;
  border-style: solid;
  border-color: transparent;
  block-size: 2.5rem;
  cursor: pointer;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  opacity: 1;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), border 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  visibility: inherit;
}
.cds--search-close:hover,
.cds--search-button:hover {
  background-color: var(--cds-field-hover);
}
.cds--search-close:focus,
.cds--search-button:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-close:focus,
  .cds--search-button:focus {
    outline-style: dotted;
  }
}
.cds--search-close:active,
.cds--search-button:active {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-close:active,
  .cds--search-button:active {
    outline-style: dotted;
  }
}
.cds--search-close:active,
.cds--search-button:active {
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}

.cds--search--disabled .cds--search-close,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier {
  cursor: not-allowed;
  outline: none;
}
.cds--search--disabled .cds--search-close:hover,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover {
  background-color: transparent;
  border-block-end-color: transparent;
}
.cds--search--disabled .cds--search-close:hover::before,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover::before {
  background-color: transparent;
}

.cds--search--disabled svg {
  fill: var(--cds-icon-on-color-disabled, #8d8d8d);
}

.cds--search-close:focus::before,
.cds--search-close:active::before {
  background-color: var(--cds-focus, #0f62fe);
}

.cds--search-input:focus ~ .cds--search-close:hover {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-input:focus ~ .cds--search-close:hover {
    outline-style: dotted;
  }
}

.cds--search--sm .cds--search-close,
.cds--search--sm ~ .cds--search-button, .cds--search--sm.cds--search--expandable, .cds--search--sm.cds--search--expandable .cds--search-magnifier {
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--search--sm.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 2rem;
}

.cds--search--md .cds--search-close,
.cds--search--md ~ .cds--search-button, .cds--search--md.cds--search--expandable, .cds--search--md.cds--search--expandable .cds--search-magnifier {
  block-size: 2.5rem;
  inline-size: 2.5rem;
}
.cds--search--md.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 2.5rem;
}

.cds--search--lg .cds--search-close,
.cds--search--lg ~ .cds--search-button, .cds--search--lg.cds--search--expandable, .cds--search--lg.cds--search--expandable .cds--search-magnifier {
  block-size: 3rem;
  inline-size: 3rem;
}
.cds--search--lg.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 3rem;
}

.cds--search-close--hidden {
  opacity: 0;
  visibility: hidden;
}

.cds--search--lg.cds--skeleton .cds--search-input,
.cds--search--md.cds--skeleton .cds--search-input,
.cds--search--sm.cds--skeleton .cds--search-input {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--search--lg.cds--skeleton .cds--search-input:hover, .cds--search--lg.cds--skeleton .cds--search-input:focus, .cds--search--lg.cds--skeleton .cds--search-input:active,
.cds--search--md.cds--skeleton .cds--search-input:hover,
.cds--search--md.cds--skeleton .cds--search-input:focus,
.cds--search--md.cds--skeleton .cds--search-input:active,
.cds--search--sm.cds--skeleton .cds--search-input:hover,
.cds--search--sm.cds--skeleton .cds--search-input:focus,
.cds--search--sm.cds--skeleton .cds--search-input:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--search--lg.cds--skeleton .cds--search-input::before,
.cds--search--md.cds--skeleton .cds--search-input::before,
.cds--search--sm.cds--skeleton .cds--search-input::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--search--lg.cds--skeleton .cds--search-input::before,
  .cds--search--md.cds--skeleton .cds--search-input::before,
  .cds--search--sm.cds--skeleton .cds--search-input::before {
    animation: none;
  }
}
.cds--search--lg.cds--skeleton .cds--search-input,
.cds--search--md.cds--skeleton .cds--search-input,
.cds--search--sm.cds--skeleton .cds--search-input {
  inline-size: 100%;
}
.cds--search--lg.cds--skeleton .cds--search-input::placeholder,
.cds--search--md.cds--skeleton .cds--search-input::placeholder,
.cds--search--sm.cds--skeleton .cds--search-input::placeholder {
  color: transparent;
}

.cds--search--expandable {
  transition: width 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--search--expandable.cds--search--expanded {
  inline-size: 100%;
}

.cds--search--expandable .cds--search-input {
  padding: 0;
  inline-size: 0;
  transition: padding 70ms cubic-bezier(0.2, 0, 0.38, 0.9), width 0s linear 70ms;
}
.cds--search--expandable .cds--search-input::placeholder {
  position: relative;
  opacity: 0;
  transition-duration: 70ms;
  transition-property: padding, opacity;
  transition-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--search--expandable.cds--search--expanded .cds--search-input {
  inline-size: 100%;
  transition: padding 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--search--expandable.cds--search--expanded .cds--search-input::placeholder {
  position: relative;
  padding: 0;
  opacity: 1;
}

.cds--search--expandable .cds--search-magnifier {
  position: absolute;
  cursor: pointer;
}
.cds--search--expandable .cds--search-magnifier:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
}

.cds--search--expandable .cds--search-magnifier:hover {
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.cds--search--expandable.cds--search--expanded .cds--search-magnifier {
  pointer-events: none;
}

.cds--search--expandable .cds--search-magnifier-icon {
  fill: var(--cds-icon-primary, #161616);
}

.cds--search--expandable.cds--search--expanded .cds--search-magnifier-icon {
  fill: var(--cds-icon-secondary, #525252);
}

.cds--search--expandable.cds--search--disabled svg {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--search-close svg,
  .cds--search-magnifier-icon {
    fill: ButtonText;
  }
}

.cds--table-toolbar {
  position: relative;
  z-index: 1;
  display: flex;
  background-color: var(--cds-layer);
  inline-size: 100%;
  min-block-size: 3rem;
}

.cds--toolbar-content {
  display: flex;
  justify-content: flex-end;
  block-size: 3rem;
  inline-size: 100%;
  transform: translate3d(0, 0, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--batch-actions ~ .cds--toolbar-content {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
}

.cds--toolbar-content .cds--search .cds--search-input {
  padding: 0 3rem;
  background-color: transparent;
  block-size: 3rem;
}

.cds--toolbar-content .cds--overflow-menu {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--batch-actions ~ .cds--toolbar-search-container {
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 110ms;
}

.cds--toolbar-search-container-expandable {
  position: relative;
  block-size: 3rem;
  box-shadow: none;
  cursor: pointer;
  inline-size: 3rem;
  transition: width 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--toolbar-search-container-expandable:hover {
  background-color: var(--cds-field-hover);
}

.cds--search.cds--toolbar-search-container-expandable {
  inline-size: 3rem;
}

.cds--toolbar-search-container-expandable .cds--search-input {
  block-size: 100%;
  cursor: pointer;
  opacity: 0;
}

.cds--toolbar-search-container-expandable:not(.cds--toolbar-search-container-active) .cds--search-input {
  padding: 0;
}

.cds--toolbar-search-container-disabled .cds--search-input {
  cursor: not-allowed;
}

.cds--toolbar-search-container-expandable.cds--search .cds--label {
  visibility: hidden;
}

.cds--toolbar-search-container-expandable.cds--search .cds--search-close {
  block-size: 3rem;
  inline-size: 3rem;
}
.cds--toolbar-search-container-expandable.cds--search .cds--search-close::before {
  background-color: var(--cds-field-hover);
  block-size: calc(100% - 0.25rem);
  inset-block-start: 0.125rem;
}

.cds--toolbar-search-container-expandable.cds--search .cds--search-close:focus::before {
  background-color: var(--cds-focus, #0f62fe);
}

.cds--table-toolbar .cds--search--lg .cds--search-magnifier-icon {
  inset-inline-start: 0;
}

.cds--table-toolbar:not(.cds--table-toolbar--sm) .cds--toolbar-search-container-persistent.cds--search--lg .cds--search-magnifier-icon {
  inset-inline-start: 1rem;
}

.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm:not(.cds--toolbar-search-container-active):not(.cds--toolbar-search-container-persistent) .cds--search-magnifier-icon {
  inset-inline-start: 0;
}

.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm.cds--toolbar-search-container-active .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--table-toolbar .cds--toolbar-search-container-persistent.cds--search--sm .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--toolbar-search-container-expandable .cds--search-magnifier-icon {
  padding: 1rem;
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--toolbar-search-container-expandable.cds--search--disabled .cds--search-magnifier-icon {
  background-color: var(--cds-layer);
  cursor: not-allowed;
  transition: background-color none;
}

.cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,
.cds--toolbar-search-container-active .cds--search-magnifier-icon:active,
.cds--toolbar-search-container-active .cds--search-magnifier-icon:hover {
  border: none;
  background-color: transparent;
  outline: none;
}

.cds--toolbar-search-container-active.cds--search {
  inline-size: 100%;
}

.cds--toolbar-search-container-active .cds--search-input {
  opacity: 1;
}

.cds--toolbar-search-container-active .cds--label,
.cds--toolbar-search-container-active .cds--search-input {
  padding: 0 3rem;
  cursor: text;
}

.cds--toolbar-search-container-active .cds--search-input:focus + .cds--search-close {
  border: none;
  box-shadow: none;
  outline: none;
}

.cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown) {
  border: none;
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-close,
.cds--toolbar-search-container-persistent .cds--search-close:hover,
.cds--toolbar-search-container-active .cds--search-close,
.cds--toolbar-search-container-active .cds--search-close:hover {
  border: none;
  background-color: transparent;
}

.cds--toolbar-search-container-persistent .cds--search-close::before {
  display: none;
}

.cds--overflow-menu.cds--toolbar-action {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu.cds--toolbar-action *,
.cds--overflow-menu.cds--toolbar-action *::before,
.cds--overflow-menu.cds--toolbar-action *::after {
  box-sizing: inherit;
}
.cds--overflow-menu.cds--toolbar-action {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--overflow-menu.cds--toolbar-action::-moz-focus-inner {
  border: 0;
}
.cds--overflow-menu.cds--toolbar-action {
  display: flex;
  padding: 1rem;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  transition: background 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--toolbar-action {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--toolbar-action *,
.cds--toolbar-action *::before,
.cds--toolbar-action *::after {
  box-sizing: inherit;
}
.cds--toolbar-action {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--toolbar-action::-moz-focus-inner {
  border: 0;
}
.cds--toolbar-action {
  display: flex;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  transition: background 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--toolbar-action:hover:not([disabled]) {
  background-color: var(--cds-field-hover);
}

.cds--toolbar-action[aria-expanded=true],
.cds--toolbar-action:hover[aria-expanded=true] {
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--toolbar-action[disabled] {
  cursor: not-allowed;
}

.cds--toolbar-action[disabled] .cds--toolbar-action__icon {
  cursor: not-allowed;
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--toolbar-action:focus:not([disabled]),
.cds--toolbar-action:active:not([disabled]) {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--toolbar-action:focus:not([disabled]),
  .cds--toolbar-action:active:not([disabled]) {
    outline-style: dotted;
  }
}
.cds--toolbar-action:focus:not([disabled]).cds--toolbar-search-container-expandable,
.cds--toolbar-action:active:not([disabled]).cds--toolbar-search-container-expandable {
  outline: none;
}

.cds--toolbar-action ~ .cds--btn {
  margin: 0;
  max-inline-size: none;
  white-space: nowrap;
}

.cds--overflow-menu--data-table {
  block-size: 3rem;
}

.cds--toolbar-action__icon {
  block-size: 1rem;
  fill: var(--cds-icon-primary, #161616);
  inline-size: auto;
  max-inline-size: 1rem;
}

.cds--toolbar-action__menu,
.cds--toolbar-action__menu.cds--overflow-menu-options::after {
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--toolbar-search-container-persistent {
  position: relative;
  block-size: 3rem;
  inline-size: 100%;
  opacity: 1;
}

.cds--toolbar-search-container-persistent + .cds--toolbar-content {
  position: relative;
  inline-size: auto;
}

.cds--toolbar-search-container-persistent .cds--search {
  position: initial;
}

.cds--toolbar-search-container-persistent .cds--search-magnifier-icon {
  inset-inline-start: 1rem;
}

.cds--toolbar-search-container-persistent .cds--search-input {
  padding: 0 3rem;
  border: none;
  block-size: 3rem;
}

.cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]) {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]) {
    outline-style: dotted;
  }
}

.cds--toolbar-search-container-persistent .cds--search-input:hover:not([disabled]) {
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-input:active:not([disabled]),
.cds--toolbar-search-container-persistent .cds--search-input:not(:placeholder-shown) {
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-close {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--batch-actions--active ~ .cds--toolbar-search-container,
.cds--batch-actions--active ~ .cds--toolbar-content {
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  transform: translate3d(0, 48px, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--batch-actions {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cds-background-brand, #0f62fe);
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  inset-block-end: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(0, 48px, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9), opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  will-change: transform;
}

.cds--batch-actions:focus {
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--batch-actions:focus {
    outline-style: dotted;
  }
}

.cds--batch-actions--active {
  z-index: 1;
  clip-path: polygon(0 0, 300% 0, 300% 300%, 0 300%);
  opacity: 1;
  pointer-events: all;
  transform: translate3d(0, 0, 0);
}

.cds--action-list {
  display: flex;
  align-items: center;
}

.cds--action-list .cds--btn,
.cds--batch-summary .cds--btn {
  color: var(--cds-text-on-color, #ffffff);
  padding-inline-end: 1rem;
  padding-inline-start: 1rem;
  white-space: nowrap;
}

.cds--action-list .cds--btn:disabled {
  border-color: transparent;
  background-color: transparent;
  color: var(--cds-text-on-color, #ffffff);
  opacity: 0.5;
}

.cds--action-list .cds--btn .cds--btn__icon {
  position: static;
  fill: var(--cds-icon-on-color, #ffffff);
  margin-inline-start: 0.5rem;
}

.cds--action-list .cds--btn .cds--btn__icon .st0 {
  fill: none;
}

.cds--batch-download {
  padding: 0.0625rem;
}

.cds--action-list .cds--btn--primary:focus::before,
.cds--action-list .cds--btn--primary::before,
.cds--action-list .cds--btn--primary:focus::after,
.cds--action-list .cds--btn--primary::after {
  display: none;
}

.cds--action-list .cds--btn--primary:focus,
.cds--batch-summary .cds--btn--primary:focus {
  outline: 2px solid var(--cds-layer);
  outline-offset: -0.125rem;
}

.cds--action-list .cds--btn--primary:nth-child(3):hover + .cds--btn--primary.cds--batch-summary__cancel::before,
.cds--action-list .cds--btn--primary:nth-child(3):focus + .cds--btn--primary.cds--batch-summary__cancel::before {
  opacity: 0;
}

.cds--btn--primary.cds--batch-summary__cancel::before {
  position: absolute;
  display: block;
  border: none;
  background-color: var(--cds-text-on-color, #ffffff);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
  inset-block-start: 0.9375rem;
  inset-inline-start: 0;
  opacity: 1;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--btn--primary.cds--batch-summary__cancel:hover::before {
  opacity: 0;
  transition: opacity 250ms cubic-bezier(0.5, 0, 0.1, 1);
}

.cds--batch-summary {
  position: sticky;
  z-index: 100000;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background-color: var(--cds-background-brand, #0f62fe);
  color: var(--cds-text-on-color, #ffffff);
  inset-inline-start: 0;
  min-block-size: 3rem;
}

.cds--batch-summary__scroll {
  box-shadow: 0.5px 0 0.2px var(--cds-link-primary-hover, #0043ce);
}

.cds--batch-summary__para {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--batch-summary__divider {
  padding-inline-start: 0.5rem;
}

.cds--table-toolbar--sm {
  block-size: 2rem;
  min-block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-input,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-input {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-close,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-close {
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-magnifier-icon,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-magnifier-icon {
  padding: 0.5rem;
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-action.cds--toolbar-search-container-persistent {
  inline-size: 100%;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable {
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search .cds--search-input {
  padding: 0 3rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active {
  flex: auto;
  transition: flex 175ms cubic-bezier(0.5, 0, 0.1, 1);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input {
  visibility: inherit;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
    outline-style: dotted;
  }
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
  background-color: var(--cds-field-hover);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:active,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown) {
  background-color: var(--cds-field-hover);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:active,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:hover {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: transparent;
}
.cds--table-toolbar--sm .cds--overflow-menu.cds--toolbar-action {
  block-size: 2rem;
  inline-size: 2rem;
  min-inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-content {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-content .cds--overflow-menu {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--search--disabled .cds--search-magnifier-icon:hover {
  background-color: transparent;
}

.cds--table-toolbar--sm .cds--batch-actions .cds--action-list {
  block-size: 2rem;
}

.cds--table-toolbar--sm .cds--toolbar-action {
  padding: 0.5rem 0;
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--table-toolbar--sm .cds--btn--primary {
  block-size: 2rem;
  min-block-size: auto;
  padding-block-end: 0.375rem;
  padding-block-start: 0.375rem;
}

.cds--table-toolbar--sm .cds--btn--primary.cds--batch-summary__cancel::before {
  inset-block-start: 0.5rem;
}

.cds--table-toolbar--sm .cds--toolbar-action ~ .cds--btn {
  overflow: hidden;
  block-size: 2rem;
}

.cds--table-toolbar--sm .cds--batch-summary {
  min-block-size: 2rem;
}

.cds--data-table tr.cds--parent-row:first-of-type td {
  border-block-start: 1px solid var(--cds-border-subtle);
}

.cds--expandable-row--hidden td {
  padding: 1rem;
  border-block-start: 0;
  inline-size: auto;
}

tr.cds--parent-row:not(.cds--expandable-row) + tr[data-child-row] {
  block-size: 0;
  transition: height 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

tr.cds--parent-row:not(.cds--expandable-row) + tr[data-child-row] td {
  border: 0;
  background-color: var(--cds-layer-hover);
  padding-block-end: 0;
  padding-block-start: 0;
  transition: padding 150ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

tr.cds--parent-row:not(.cds--expandable-row) + tr[data-child-row] td .cds--child-row-inner-container {
  overflow: hidden;
  max-block-size: 0;
}

tr.cds--parent-row.cds--expandable-row + tr[data-child-row] {
  transition: height 150ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

tr.cds--parent-row.cds--expandable-row + tr[data-child-row] td {
  border-block-end: 1px solid var(--cds-border-subtle);
  padding-inline-start: 3.5rem;
  transition: padding-bottom 150ms cubic-bezier(0.2, 0, 0.38, 0.9), transform 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

tbody:has(> tr.cds--data-table--slug-row) > tr.cds--expandable-row[data-child-row] td,
tbody:has(td.cds--table-column-checkbox) > tr.cds--expandable-row[data-child-row] td {
  padding-inline-start: 5.5rem;
}

tbody:has(> tr.cds--data-table--slug-row):has(td.cds--table-column-checkbox) > tr.cds--expandable-row[data-child-row] td {
  padding-inline-start: 7.5rem;
}

tr.cds--parent-row.cds--expandable-row + tr[data-child-row] td .cds--child-row-inner-container {
  max-block-size: 100%;
  padding-block: 1rem;
  padding-block-end: 1.5rem;
}

.cds--parent-row.cds--expandable-row > td,
.cds--parent-row.cds--expandable-row + tr[data-child-row] > td {
  border-block-end: 1px solid var(--cds-border-subtle);
  box-shadow: 0 1px var(--cds-border-subtle);
}

.cds--parent-row:not(.cds--expandable-row) + tr[data-child-row] > td {
  box-shadow: none;
}

.cds--parent-row.cds--expandable-row > td:first-of-type {
  box-shadow: none;
}

tr.cds--parent-row:not(.cds--expandable-row) td,
tr.cds--parent-row.cds--expandable-row td,
tr.cds--parent-row.cds--expandable-row {
  transition: height 150ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), border-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

tr.cds--parent-row:not(.cds--expandable-row):first-of-type:hover td {
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-border-subtle);
}

tr.cds--parent-row.cds--expandable-row:hover td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-border-subtle);
  color: var(--cds-text-primary, #161616);
}

tr.cds--parent-row.cds--expandable-row:hover td:first-of-type {
  border-block-end: 1px solid var(--cds-layer-hover);
}

tr.cds--parent-row.cds--expandable-row:hover + tr[data-child-row] td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-border-subtle);
  color: var(--cds-text-primary, #161616);
}

tr.cds--expandable-row--hover + tr[data-child-row] td {
  border-block-end: 1px solid var(--cds-border-subtle);
}

tr.cds--expandable-row--hover {
  background-color: var(--cds-layer-hover);
}

tr.cds--expandable-row--hover td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-border-subtle);
  color: var(--cds-text-primary, #161616);
}

tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td:first-of-type {
  border-block-end: 1px solid transparent;
}

.cds--data-table td.cds--table-expand {
  border-block-end: 1px solid var(--cds-border-subtle);
}

.cds--data-table th.cds--table-expand + .cds--table-column-checkbox,
.cds--data-table td.cds--table-expand + .cds--table-column-checkbox {
  padding-inline-end: 0.375rem;
  padding-inline-start: 0.375rem;
}

.cds--data-table td.cds--table-expand[data-previous-value=collapsed] + .cds--table-column-checkbox {
  border-block-end: 1px solid transparent;
  box-shadow: none;
}

.cds--data-table th.cds--table-expand + .cds--table-column-checkbox + th,
.cds--data-table td.cds--table-expand + .cds--table-column-checkbox + td {
  padding-inline-start: 0.5rem;
}

.cds--data-table td.cds--table-expand,
.cds--data-table th.cds--table-expand {
  padding: 0.5rem;
  padding-inline-end: 0;
}

.cds--data-table td.cds--table-expand[data-previous-value=collapsed] {
  border-block-end: 1px solid transparent;
}

.cds--table-expand[data-previous-value=collapsed] .cds--table-expand__svg {
  transform: rotate(270deg);
  transition: transform 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--table-expand__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--table-expand__button *,
.cds--table-expand__button *::before,
.cds--table-expand__button *::after {
  box-sizing: inherit;
}
.cds--table-expand__button {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
}
.cds--table-expand__button::-moz-focus-inner {
  border: 0;
}
.cds--table-expand__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  block-size: calc(100% + 1px);
  inline-size: 100%;
  vertical-align: inherit;
}

.cds--data-table--top-aligned-body td .cds--table-expand__button,
.cds--data-table--top-aligned-header th .cds--table-expand__button {
  align-items: start;
  block-size: 2rem;
  padding-block-start: 0.5rem;
}

.cds--data-table--top-aligned-body.cds--data-table--xs td .cds--table-expand__button,
.cds--data-table--top-aligned-header.cds--data-table--xs th .cds--table-expand__button {
  block-size: 1.5rem;
  padding-block-start: 0.25rem;
}

.cds--data-table--top-aligned-body.cds--data-table--md td .cds--table-expand__button,
.cds--data-table--top-aligned-header.cds--data-table--md th .cds--table-expand__button {
  margin-block-start: -0.25rem;
  padding-block-start: 0.5rem;
}

.cds--table-expand__button:focus {
  box-shadow: inset 0 0 0 2px var(--cds-focus, #0f62fe);
  outline: none;
}

.cds--table-expand__svg {
  fill: var(--cds-layer-selected-inverse, #161616);
  transform: rotate(90deg);
  transition: transform 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--data-table--xl .cds--table-expand__button {
  inline-size: 2rem;
}

tr.cds--parent-row.cds--expandable-row td.cds--table-expand + td::after {
  position: absolute;
  background-color: var(--cds-layer-accent);
  block-size: 0.0625rem;
  content: "";
  inline-size: 0.5rem;
  inset-block-end: -0.0625rem;
  inset-inline-start: 0;
}

tr.cds--parent-row.cds--expandable-row:hover td.cds--table-expand + td::after,
tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td.cds--table-expand + td::after {
  background-color: var(--cds-layer-hover);
}

tr.cds--parent-row.cds--data-table--selected td.cds--table-expand + td::after {
  display: none;
}

.cds--data-table--zebra tbody tr[data-parent-row]:nth-child(4n+3) td,
.cds--data-table--zebra tbody tr[data-child-row]:nth-child(4n+4) td {
  border-block-end: 1px solid var(--cds-layer);
}

.cds--data-table--zebra tbody tr[data-parent-row]:nth-child(4n+1) td,
.cds--data-table--zebra tbody tr[data-child-row]:nth-child(4n+2) td {
  background-color: var(--cds-layer-accent);
  border-block-end: 1px solid var(--cds-layer-accent);
  border-block-start: 1px solid var(--cds-layer-accent);
}

.cds--data-table--zebra tr.cds--parent-row td,
.cds--data-table--zebra tr.cds--parent-row.cds--expandable-row + tr[data-child-row] td {
  transition: transform 150ms cubic-bezier(0.2, 0, 0.38, 0.9), border-bottom 70ms cubic-bezier(0.2, 0, 0.38, 0.9), border-top 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--data-table--zebra tbody tr[data-parent-row]:hover td,
.cds--data-table--zebra tbody tr[data-parent-row]:hover + tr[data-child-row] td,
.cds--data-table--zebra tbody tr[data-child-row]:hover td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-layer-hover);
  border-block-start: 1px solid var(--cds-layer-hover);
}

.cds--data-table--zebra tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-layer-hover);
  border-block-start: 1px solid var(--cds-layer-hover);
}

tr.cds--parent-row.cds--data-table--selected {
  background-color: var(--cds-layer-selected);
}

tr.cds--parent-row.cds--data-table--selected:first-of-type td {
  border-block-start: 1px solid var(--cds-layer-active);
  box-shadow: 0 1px var(--cds-layer-active);
}

tr.cds--parent-row.cds--data-table--selected td {
  border-block-end: 1px solid var(--cds-layer-active);
  box-shadow: 0 1px var(--cds-layer-active);
  color: var(--cds-text-primary, #161616);
}

tr.cds--parent-row.cds--data-table--selected:last-of-type td {
  border-block-end: 1px solid transparent;
  box-shadow: 0 1px var(--cds-border-subtle);
}

tr.cds--parent-row.cds--data-table--selected:not(.cds--expandable-row):hover td {
  background-color: var(--cds-layer-selected-hover);
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-layer-selected-hover);
  box-shadow: 0 1px var(--cds-layer-selected-hover);
}

tr.cds--parent-row.cds--data-table--selected.cds--expandable-row td,
tr.cds--parent-row.cds--data-table--selected.cds--expandable-row td:first-of-type {
  border-block-end: 1px solid transparent;
  box-shadow: 0 1px var(--cds-layer-selected);
}

tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td,
tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:first-of-type,
tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover td,
tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover td:first-of-type {
  background-color: var(--cds-layer-selected-hover);
  border-block-end: 1px solid transparent;
  border-block-start: 1px solid var(--cds-layer-selected-hover);
  box-shadow: 0 1px var(--cds-layer-selected-hover);
}

tr.cds--parent-row.cds--data-table--selected.cds--expandable-row + tr[data-child-row] td {
  background-color: var(--cds-layer-hover);
  border-block-end: 1px solid var(--cds-border-subtle);
  border-block-start: 1px solid var(--cds-layer-active);
  box-shadow: 0 1px var(--cds-layer-active);
  color: var(--cds-text-primary, #161616);
}

tr.cds--parent-row.cds--data-table--selected.cds--expandable-row + tr[data-child-row]:last-of-type td {
  box-shadow: inset 0 -1px var(--cds-layer-active);
  padding-block-end: 1.5rem;
}

tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover + tr[data-child-row] td,
tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover + tr[data-child-row] td {
  background-color: var(--cds-layer-selected);
}

.cds--parent-row .cds--table-column-slug,
.cds--parent-row .cds--table-column-slug + td.cds--table-expand[data-previous-value=collapsed] {
  box-shadow: none;
}

.cds--parent-row.cds--expandable-row .cds--table-column-slug,
.cds--parent-row.cds--expandable-row .cds--table-column-slug + td.cds--table-expand[data-previous-value=collapsed] {
  border-block-end: 1px solid transparent;
}

.cds--data-table--slug-row td,
.cds--data-table tr.cds--data-table--slug-row:hover td {
  border-block-start: 1px solid transparent;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--table-expand__button:focus .cds--table-expand__svg {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--table-expand__svg {
    fill: ButtonText;
  }
}

.cds--data-table.cds--skeleton th {
  padding-inline-start: 1rem;
  vertical-align: middle;
}

.cds--data-table.cds--skeleton th span,
.cds--data-table.cds--skeleton td span {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--data-table.cds--skeleton th span:hover, .cds--data-table.cds--skeleton th span:focus, .cds--data-table.cds--skeleton th span:active,
.cds--data-table.cds--skeleton td span:hover,
.cds--data-table.cds--skeleton td span:focus,
.cds--data-table.cds--skeleton td span:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--data-table.cds--skeleton th span::before,
.cds--data-table.cds--skeleton td span::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--data-table.cds--skeleton th span::before,
  .cds--data-table.cds--skeleton td span::before {
    animation: none;
  }
}
.cds--data-table.cds--skeleton th span,
.cds--data-table.cds--skeleton td span {
  display: block;
  block-size: 1rem;
  inline-size: 4rem;
}

.cds--data-table.cds--skeleton tr:hover td {
  border-color: var(--cds-border-subtle);
  background: transparent;
}

.cds--data-table.cds--skeleton tr:hover td:first-of-type,
.cds--data-table.cds--skeleton tr:hover td:last-of-type {
  border-color: var(--cds-border-subtle);
}

.cds--data-table.cds--skeleton .cds--table-sort {
  pointer-events: none;
}

.cds--data-table.cds--skeleton th span {
  background: var(--cds-skeleton-element, #c6c6c6);
}

.cds--data-table.cds--skeleton th span::before {
  background: var(--cds-skeleton-background, #e8e8e8);
}

.cds--data-table-container.cds--skeleton .cds--data-table-header__title {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__title:hover, .cds--data-table-container.cds--skeleton .cds--data-table-header__title:focus, .cds--data-table-container.cds--skeleton .cds--data-table-header__title:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__title::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--data-table-container.cds--skeleton .cds--data-table-header__title::before {
    animation: none;
  }
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__title {
  block-size: 1.5rem;
  inline-size: 7.5rem;
}

.cds--data-table-container.cds--skeleton .cds--data-table-header__description {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__description:hover, .cds--data-table-container.cds--skeleton .cds--data-table-header__description:focus, .cds--data-table-container.cds--skeleton .cds--data-table-header__description:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__description::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--data-table-container.cds--skeleton .cds--data-table-header__description::before {
    animation: none;
  }
}
.cds--data-table-container.cds--skeleton .cds--data-table-header__description {
  block-size: 1rem;
  inline-size: 10rem;
  margin-block-start: 0.5rem;
}

.cds--data-table--sort th,
.cds--data-table th[aria-sort] {
  padding: 0;
  block-size: 3rem;
  border-block-end: none;
  border-block-start: none;
}

.cds--table-sort__description {
  display: none;
}

.cds--table-sort {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--table-sort *,
.cds--table-sort *::before,
.cds--table-sort *::after {
  box-sizing: inherit;
}
.cds--table-sort {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
}
.cds--table-sort::-moz-focus-inner {
  border: 0;
}
.cds--table-sort {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cds-layer-accent);
  color: var(--cds-text-primary, #161616);
  font: inherit;
  inline-size: 100%;
  line-height: 1;
  min-block-size: 100%;
  padding-inline-start: 1rem;
  text-align: start;
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9), outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--table-sort:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--table-sort:focus {
    outline-style: dotted;
  }
}

.cds--table-sort:hover {
  background: var(--cds-layer-selected-hover);
}

.cds--table-sort:focus svg,
.cds--table-sort:hover svg {
  opacity: 1;
}

.cds--data-table.cds--data-table--sort th > .cds--table-header-label {
  line-height: 1;
  padding-inline-end: 1rem;
  padding-inline-start: 1rem;
}

th .cds--table-sort__flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  block-size: 100%;
  inline-size: 100%;
  min-block-size: 3rem;
}

.cds--data-table--top-aligned-header th .cds--table-sort__flex {
  align-items: start;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th.cds--table-sort__header {
  padding-block-start: 1rem;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--sm th.cds--table-sort__header .cds--table-sort__flex .cds--table-header-label,
.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--xs th.cds--table-sort__header .cds--table-sort__flex .cds--table-header-label {
  padding-block-end: 0;
  padding-block-start: 0;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--sm th.cds--table-sort__header {
  padding-block-end: 0.4375rem;
  padding-block-start: 0.4375rem;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--xs th.cds--table-sort__header {
  padding-block-end: 0.125rem;
  padding-block-start: 0.125rem;
}

.cds--data-table--sort:not(.cds--data-table--xs):not(.cds--data-table--sm):not(.cds--data-table--md):not(.cds--data-table--xl) th .cds--table-sort__flex {
  /* IE11 workaround for align-items: center and min-height
      https://github.com/philipwalton/flexbugs/issues/231 */
}
@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  .cds--data-table--sort:not(.cds--data-table--xs):not(.cds--data-table--sm):not(.cds--data-table--md):not(.cds--data-table--xl) th .cds--table-sort__flex {
    block-size: 2.99rem;
  }
}

.cds--data-table--xs.cds--data-table--sort th .cds--table-sort__flex {
  min-block-size: 1.5rem;
}

.cds--data-table--sm.cds--data-table--sort th .cds--table-sort__flex {
  min-block-size: 2rem;
}

.cds--data-table--md.cds--data-table--sort th .cds--table-sort__flex {
  min-block-size: 2.5rem;
}

.cds--data-table--xl.cds--data-table--sort th .cds--table-sort__flex {
  align-items: flex-start;
  min-block-size: 4rem;
}

.cds--table-sort .cds--table-sort__icon-inactive {
  display: block;
}

.cds--table-sort .cds--table-sort__icon {
  display: none;
}

.cds--table-sort__icon-unsorted {
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1.25rem;
  margin-inline-end: 0.5rem;
  margin-inline-start: 0.5rem;
  min-inline-size: 1rem;
  opacity: 0;
}

.cds--table-sort.cds--table-sort--active {
  background: var(--cds-layer-selected-hover);
}

.cds--table-sort.cds--table-sort--active .cds--table-sort__icon-unsorted {
  display: none;
}

.cds--table-sort.cds--table-sort--active .cds--table-sort__icon {
  display: block;
  opacity: 1;
}

.cds--table-sort--descending .cds--table-sort__icon {
  transform: rotate(180deg);
}

.cds--table-sort__icon {
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1.25rem;
  margin-inline-end: 0.5rem;
  margin-inline-start: 0.5rem;
  min-inline-size: 1rem;
  opacity: 1;
  transform: rotate(0);
  transition: transform 250ms cubic-bezier(0.5, 0, 0.1, 1);
}

.cds--data-table--xs.cds--data-table--sort th {
  block-size: 1.5rem;
}

.cds--data-table--sm.cds--data-table--sort th {
  block-size: 2rem;
}

.cds--data-table--md.cds--data-table--sort th {
  block-size: 2.5rem;
}

.cds--data-table--xl.cds--data-table--sort th {
  block-size: 4rem;
}

.cds--data-table--xl.cds--data-table--sort th .cds--table-sort {
  display: inline-block;
  block-size: 4rem;
}

.cds--data-table--xl .cds--table-sort__icon-unsorted,
.cds--data-table--xl .cds--table-sort__icon {
  margin-block-start: 0.8125rem;
}

.cds--table-sort__header--slug .cds--table-sort__icon,
.cds--table-sort__header--slug .cds--table-sort__icon-unsorted {
  margin-inline-end: 0.5rem;
  margin-inline-start: auto;
}

.cds--table-sort__header--slug .cds--slug {
  margin-inline-end: 0.5rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--table-sort__icon,
  .cds--table-sort__icon-unsorted {
    fill: ButtonText;
  }
}

.cds--select {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--select *,
.cds--select *::before,
.cds--select *::after {
  box-sizing: inherit;
}
.cds--select {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  inline-size: 100%;
}

.cds--select-input__wrapper {
  position: relative;
  display: flex;
  align-items: center;
  inline-size: 100%;
}

.cds--select-input {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: block;
  border: none;
  border-radius: 0;
  appearance: none;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  border-block-end: 1px solid var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
  font-family: inherit;
  inline-size: 100%;
  opacity: 1;
  padding-block: 0;
  padding-inline: 1rem 3rem;
  text-overflow: ellipsis;
  transition: outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--select-input:hover {
  background-color: var(--cds-field-hover);
}
.cds--select-input::-ms-expand {
  display: none;
}
@-moz-document url-prefix() {
  .cds--select-input:-moz-focusring, .cds--select-input::-moz-focus-inner {
    background-image: none;
    color: transparent;
    text-shadow: 0 0 0 #000000;
  }
}
.cds--select-input:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--select-input:focus {
    outline-style: dotted;
  }
}
.cds--select-input:focus {
  color: var(--cds-text-primary, #161616);
}
.cds--select-input:disabled, .cds--select-input:hover:disabled {
  background-color: var(--cds-field);
  border-block-end-color: transparent;
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--select-input--sm {
  block-size: 2rem;
  max-block-size: 2rem;
}

.cds--select-input--lg {
  block-size: 3rem;
  max-block-size: 3rem;
}

.cds--select--disabled .cds--label,
.cds--select--disabled .cds--form__helper-text {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select-input__wrapper[data-invalid] .cds--select-input,
.cds--select--warning .cds--select-input {
  padding-inline-end: 4rem;
}

.cds--select-input:disabled ~ .cds--select__arrow {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select--light .cds--select-input {
  background-color: var(--cds-field-02, #ffffff);
}
.cds--select--light .cds--select-input:hover {
  background-color: var(--cds-field-hover);
}
.cds--select--light .cds--select-input:disabled, .cds--select--light .cds--select-input:hover:disabled {
  background-color: var(--cds-field-02, #ffffff);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--select__arrow {
  position: absolute;
  block-size: 100%;
  fill: var(--cds-icon-primary, #161616);
  inset-block-start: 0;
  inset-inline-end: 1rem;
  pointer-events: none;
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--select__arrow path {
    fill: ButtonText;
  }
}

.cds--select__invalid-icon {
  position: absolute;
  inset-inline-end: 2.5rem;
}

.cds--select-input__wrapper[data-invalid] .cds--select-input ~ .cds--select__invalid-icon {
  fill: var(--cds-support-error, #da1e28);
}

.cds--select__invalid-icon--warning {
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--select__invalid-icon--warning path[fill] {
  fill: #000000;
  opacity: 1;
}

optgroup.cds--select-optgroup,
.cds--select-option {
  background-color: var(--cds-layer-hover);
  color: var(--cds-text-primary, #161616);
}
optgroup.cds--select-optgroup:disabled,
.cds--select-option:disabled {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select--inline {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.cds--select--inline.cds--select--invalid .cds--label,
.cds--select--inline.cds--select--invalid .cds--form__helper-text {
  align-self: flex-start;
  margin-block-start: 0.8125rem;
}

.cds--select--inline .cds--form__helper-text {
  margin-block-end: 0;
  margin-inline-start: 0.5rem;
}

.cds--select--inline .cds--label {
  margin: 0 0.5rem 0 0;
  white-space: nowrap;
}

.cds--select--inline .cds--select-input {
  background-color: transparent;
  border-block-end: none;
  color: var(--cds-text-primary, #161616);
  inline-size: auto;
  padding-inline-end: 2rem;
  padding-inline-start: 0.5rem;
}

.cds--select--inline .cds--select-input:focus,
.cds--select--inline .cds--select-input:focus option,
.cds--select--inline .cds--select-input:focus optgroup {
  background-color: var(--cds-background, #ffffff);
}

.cds--select--inline .cds--select-input[disabled],
.cds--select--inline .cds--select-input[disabled]:hover {
  background-color: var(--cds-field);
}

.cds--select--inline .cds--select__arrow {
  inset-inline-end: 0.5rem;
}

.cds--select--inline.cds--select--invalid .cds--select-input {
  padding-inline-end: 3.5rem;
}

.cds--select--inline.cds--select--invalid .cds--select-input ~ .cds--select__invalid-icon {
  inset-inline-end: 2rem;
}

.cds--select--inline .cds--select-input:disabled {
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--select--inline .cds--select-input:disabled ~ * {
  cursor: not-allowed;
}

.cds--select--readonly .cds--select-input {
  background-color: transparent;
  border-block-end-color: var(--cds-border-subtle);
  cursor: default;
}

.cds--select--readonly .cds--select__arrow {
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--select.cds--skeleton:hover, .cds--select.cds--skeleton:focus, .cds--select.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--select.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--select.cds--skeleton::before {
    animation: none;
  }
}
.cds--select.cds--skeleton {
  block-size: 2.5rem;
  inline-size: 100%;
}

.cds--select.cds--skeleton .cds--select-input {
  display: none;
}

.cds--select--slug .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: calc(2.5rem + 8px + 1px);
  margin-block-start: 0.03125rem;
  transform: translateY(-50%);
}

.cds--select--slug .cds--slug::after,
.cds--select--slug .cds--slug::before {
  position: absolute;
  background-color: var(--cds-border-subtle-01, #c6c6c6);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
}

.cds--select--slug .cds--slug::before {
  display: none;
  inset-inline-start: calc(-0.5rem - 1px);
}

.cds--select--slug .cds--slug::after {
  display: block;
  inset-inline-end: calc(-0.5rem - 1px);
}

.cds--select--slug .cds--select-input:not(:has(~ .cds--slug--revert)) {
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
  padding-inline-end: 4rem;
}

.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:not(:has(~ .cds--slug--revert)) {
  padding-inline-end: 6rem;
}

.cds--select--slug:has(.cds--select__invalid-icon) .cds--slug::before {
  display: block;
}

.cds--select--slug .cds--select-input__wrapper[data-invalid] .cds--select-input ~ .cds--select__invalid-icon,
.cds--select--slug .cds--select-input__wrapper .cds--select-input ~ .cds--select__invalid-icon {
  inset-inline-end: 5rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--select__arrow {
    fill: ButtonText;
  }
}

.cds--data-table-container + .cds--pagination {
  border-block-start: 0;
}

.cds--pagination {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--pagination *,
.cds--pagination *::before,
.cds--pagination *::after {
  box-sizing: inherit;
}
.cds--pagination {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cds-layer);
  border-block-start: 1px solid var(--cds-border-subtle);
  inline-size: calc(100% - 1px);
  min-block-size: 2.5rem;
  overflow-x: auto;
}
@media (min-width: 42rem) {
  .cds--pagination {
    overflow: initial;
  }
  .cds--pagination .cds--pagination__control-buttons {
    display: flex;
  }
}
@media (max-width: 41.98rem) {
  .cds--pagination .cds--pagination__left > *,
  .cds--pagination .cds--pagination__right > * {
    display: none;
  }
  .cds--pagination .cds--pagination__items-count {
    display: initial;
  }
  .cds--pagination .cds--pagination__control-buttons {
    display: flex;
  }
}

.cds--pagination--sm {
  min-block-size: 2rem;
}

.cds--pagination--lg {
  min-block-size: 3rem;
}

.cds--pagination .cds--select {
  align-items: center;
  block-size: 100%;
}

.cds--pagination .cds--select-input--inline__wrapper {
  display: flex;
  block-size: 100%;
}

.cds--pagination .cds--select-input {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  block-size: 100%;
  inline-size: auto;
  line-height: 2.5rem;
  min-inline-size: auto;
}

.cds--pagination .cds--select--inline .cds--select-input {
  padding-inline: 1rem 2.25rem;
}

.cds--pagination--sm .cds--select-input {
  line-height: 2rem;
}

.cds--pagination--lg .cds--select-input {
  line-height: 3rem;
}

.cds--pagination .cds--select-input:hover {
  background: var(--cds-layer-hover);
}

.cds--pagination .cds--select--inline .cds--select-input:focus,
.cds--pagination .cds--select--inline .cds--select-input:focus option,
.cds--pagination .cds--select--inline .cds--select-input:focus optgroup {
  background-color: var(--cds-layer);
}

.cds--pagination .cds--select__arrow {
  inset-block-start: 50%;
  transform: translate(-0.5rem, -50%);
}

.cds--pagination .cds--select__item-count .cds--select-input {
  border-inline-end: 1px solid var(--cds-border-subtle);
}

.cds--pagination__right {
  border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--pagination__left,
.cds--pagination__right {
  display: flex;
  align-items: center;
  block-size: 100%;
}

.cds--pagination__left > .cds--form-item,
.cds--pagination__right > .cds--form-item {
  block-size: 100%;
}

.cds--pagination__left .cds--pagination__text,
.cds--pagination__right .cds--pagination__text {
  white-space: nowrap;
}

.cds--pagination__left .cds--pagination__text {
  margin-inline-end: 0.0625rem;
}

.cds--pagination__right .cds--pagination__text {
  margin-inline-end: 1rem;
  margin-inline-start: 0.0625rem;
}

.cds--pagination__right .cds--pagination__text.cds--pagination__page-text {
  margin-inline-end: 0.0625rem;
  margin-inline-start: 1rem;
}

.cds--pagination__right .cds--pagination__text.cds--pagination__page-text.cds--pagination__unknown-pages-text {
  margin-inline-end: 1rem;
}

.cds--pagination__right .cds--pagination__text:empty {
  margin: 0;
}

.cds--pagination__left {
  padding: 0 1rem 0 0;
}
@media (min-width: 42rem) {
  .cds--pagination__left {
    padding: 0 1rem;
  }
}

@media (min-width: 42rem) {
  .cds--pagination__text {
    display: inline-block;
  }
}

span.cds--pagination__text {
  color: var(--cds-text-primary, #161616);
  margin-inline-start: 1rem;
}

span.cds--pagination__text.cds--pagination__items-count {
  color: var(--cds-text-secondary, #525252);
}

.cds--pagination__button,
.cds--btn--ghost.cds--pagination__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--pagination__button *,
.cds--pagination__button *::before,
.cds--pagination__button *::after,
.cds--btn--ghost.cds--pagination__button *,
.cds--btn--ghost.cds--pagination__button *::before,
.cds--btn--ghost.cds--pagination__button *::after {
  box-sizing: inherit;
}
.cds--pagination__button,
.cds--btn--ghost.cds--pagination__button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  background: none;
  block-size: 2.5rem;
  border-inline-start: 1px solid var(--cds-border-subtle);
  cursor: pointer;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  min-block-size: 2rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--pagination__button > svg,
.cds--btn--ghost.cds--pagination__button > svg {
  margin-block-start: 0;
}

[dir=rtl] .cds--pagination__button > svg,
[dir=rtl] .cds--btn--ghost.cds--pagination__button > svg {
  transform: rotate(0.5turn);
}

.cds--pagination--sm .cds--pagination__button,
.cds--pagination--sm .cds--btn--ghost.cds--pagination__button {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--pagination--lg .cds--pagination__button,
.cds--pagination--lg .cds--btn--ghost.cds--pagination__button {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--pagination__button:focus,
.cds--btn--ghost:focus.cds--pagination__button {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--pagination__button:focus,
  .cds--btn--ghost:focus.cds--pagination__button {
    outline-style: dotted;
  }
}
.cds--pagination__button:focus,
.cds--btn--ghost:focus.cds--pagination__button {
  border-inline-start: 0;
}

.cds--pagination__button:hover,
.cds--btn--ghost:hover.cds--pagination__button {
  background: var(--cds-layer-hover);
}

.cds--pagination__button--no-index,
.cds--btn--ghost.cds--pagination__button--no-index {
  cursor: not-allowed;
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--pagination__button:disabled:hover,
.cds--pagination__button--no-index:hover,
.cds--btn--ghost:disabled:hover.cds--pagination__button,
.cds--btn--ghost:hover.cds--pagination__button--no-index {
  border-color: var(--cds-border-subtle);
  background: var(--cds-layer);
  cursor: not-allowed;
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--pagination.cds--skeleton .cds--skeleton__text {
  margin-block-end: 0;
  margin-inline-end: 1rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--pagination__button,
  .cds--btn--ghost.cds--pagination__button {
    outline: 1px solid transparent;
  }
}

[dir=rtl] .cds--pagination .cds--select__arrow {
  transform: translate(0.5rem, -50%);
}

.cds--unstable-pagination {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--unstable-pagination *,
.cds--unstable-pagination *::before,
.cds--unstable-pagination *::after {
  box-sizing: inherit;
}
.cds--unstable-pagination {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cds-layer);
  border-block-end: 1px solid transparent;
  border-block-start: 1px solid var(--cds-border-subtle);
  inline-size: 100%;
  min-block-size: 2.5rem;
}

@media (min-width: 42rem) {
  .cds--unstable-pagination__text {
    display: inline-block;
  }
}
.cds--unstable-pagination__text {
  margin: 0 1rem;
  color: var(--cds-text-secondary, #525252);
}

.cds--unstable-pagination__left,
.cds--unstable-pagination__right {
  display: flex;
  align-items: center;
  block-size: 100%;
}

.cds--unstable-pagination__left {
  padding: 0 1rem 0 0;
}

.cds--unstable-pagination__left > .cds--form-item,
.cds--unstable-pagination__right > .cds--form-item {
  block-size: 100%;
}

.cds--unstable-pagination__left .cds--unstable-pagination__text {
  margin-inline-end: 0.0625rem;
}

.cds--unstable-pagination__right .cds--unstable-pagination__text {
  margin-inline-end: 1rem;
  margin-inline-start: 0.0625rem;
}

.cds--unstable-pagination__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--unstable-pagination__button *,
.cds--unstable-pagination__button *::before,
.cds--unstable-pagination__button *::after {
  box-sizing: inherit;
}
.cds--unstable-pagination__button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  background: none;
  block-size: 2.5rem;
  border-inline-start: 1px solid var(--cds-border-subtle);
  color: var(--cds-icon-primary, #161616);
  cursor: pointer;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  min-block-size: 2rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--unstable-pagination__button .cds--btn__icon {
  block-size: initial;
  inline-size: initial;
}

.cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}

.cds--unstable-pagination__button:hover {
  background: var(--cds-layer-hover);
  color: var(--cds-icon-primary, #161616);
}

.cds--unstable-pagination__button--no-index {
  cursor: not-allowed;
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--unstable-pagination__button.cds--btn:disabled {
  border-color: var(--cds-border-subtle);
  background: transparent;
}

.cds--unstable-pagination__button:disabled:hover,
.cds--unstable-pagination__button--no-index:hover {
  background: transparent;
  cursor: not-allowed;
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--unstable-pagination__page-selector,
.cds--unstable-pagination__page-sizer {
  align-items: center;
  block-size: 100%;
}

.cds--unstable-pagination__page-selector .cds--select-input--inline__wrapper,
.cds--unstable-pagination__page-sizer .cds--select-input--inline__wrapper {
  display: flex;
  block-size: 100%;
}

.cds--unstable-pagination__page-selector .cds--select-input,
.cds--unstable-pagination__page-sizer .cds--select-input {
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  padding: 0 2.25rem 0 1rem;
  block-size: 100%;
  inline-size: auto;
  line-height: 2.5rem;
  min-inline-size: auto;
}

.cds--unstable-pagination__page-selector .cds--select-input:hover,
.cds--unstable-pagination__page-sizer .cds--select-input:hover {
  background: var(--cds-layer-hover);
}

.cds--unstable-pagination__page-selector .cds--select__arrow,
.cds--unstable-pagination__page-sizer .cds--select__arrow {
  inset-block-start: 50%;
  transform: translateY(-50%);
}
@media (min-width: 42rem) {
  .cds--unstable-pagination__page-selector .cds--select__arrow,
  .cds--unstable-pagination__page-sizer .cds--select__arrow {
    inset-inline-end: 1rem;
  }
}

.cds--unstable-pagination__page-selector {
  border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--unstable-pagination__page-sizer {
  border-inline-end: 1px solid var(--cds-border-subtle);
}

.cds--pagination-nav html {
  font-size: 100%;
}
.cds--pagination-nav body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--pagination-nav code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--pagination-nav strong {
  font-weight: 600;
}
.cds--pagination-nav {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  line-height: 0;
}

.cds--pagination-nav__list {
  display: flex;
  align-items: center;
  list-style: none;
}

.cds--pagination-nav__list-item {
  padding: 0;
}
.cds--pagination-nav__list-item:first-child {
  padding-inline-start: 0;
}
.cds--pagination-nav__list-item:last-child {
  padding-inline-end: 0;
}

.cds--pagination-nav__page {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--pagination-nav__page *,
.cds--pagination-nav__page *::before,
.cds--pagination-nav__page *::after {
  box-sizing: inherit;
}
.cds--pagination-nav__page {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
}
.cds--pagination-nav__page::-moz-focus-inner {
  border: 0;
}
.cds--pagination-nav__page {
  position: relative;
  display: block;
  padding: 1.0625rem 0.25rem;
  border-radius: 0;
  color: var(--cds-text-primary, #161616);
  font-weight: 400;
  line-height: 1;
  min-inline-size: 3rem;
  outline: 0;
  text-align: center;
  text-decoration: none;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9), color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  user-select: none;
}
.cds--pagination-nav__page:hover {
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: var(--cds-text-primary, #161616);
}
.cds--pagination-nav__page:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--pagination-nav__page:focus {
    outline-style: dotted;
  }
}
.cds--pagination-nav__page:disabled, .cds--pagination-nav__page.cds--pagination-nav__page--disabled {
  background: none;
  color: rgba(var(--cds-text-secondary, #525252), 0.5);
  outline: none;
  pointer-events: none;
}
.cds--pagination-nav__page:not(.cds--pagination-nav__page--direction)::after {
  position: absolute;
  display: block;
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: 0.25rem;
  content: "";
  inline-size: 0;
  inset-block-end: 0;
  inset-inline-start: 50%;
  opacity: 0;
  transition: width 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--pagination-nav__page:not(.cds--pagination-nav__page--direction)::after {
    transition: none;
  }
}
.cds--pagination-nav__page--active + .cds--pagination-nav__page::after, .cds--pagination-nav__page.cds--pagination-nav__page--active::after {
  inline-size: 1rem;
  inset-inline-start: calc(50% - 0.5rem);
  opacity: 1;
}
.cds--pagination-nav__page.cds--pagination-nav__page--active {
  background-color: initial;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
}
.cds--pagination-nav__page .cds--pagination-nav__icon {
  fill: currentColor;
  pointer-events: none;
}

.cds--pagination-nav__page--direction {
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 3rem;
  inline-size: 3rem;
  line-height: 0;
}

.cds--pagination-nav__select {
  position: relative;
}

.cds--pagination-nav__page--select {
  appearance: none;
  max-block-size: 3rem;
  text-indent: calc(50% - 4.5px);
}
@-moz-document url-prefix() {
  .cds--pagination-nav__page--select {
    text-indent: 0;
  }
}

.cds--pagination-nav__select-icon-wrapper {
  position: absolute;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  pointer-events: none;
}
.cds--pagination-nav__select-icon-wrapper:not(.cds--pagination-nav__page--direction)::after {
  position: absolute;
  display: block;
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: 0.25rem;
  content: "";
  inline-size: 0;
  inset-block-end: 0;
  inset-inline-start: 50%;
  opacity: 0;
  transition: width 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--pagination-nav__select-icon-wrapper:not(.cds--pagination-nav__page--direction)::after {
    transition: none;
  }
}
.cds--pagination-nav__page--active + .cds--pagination-nav__select-icon-wrapper::after, .cds--pagination-nav__select-icon-wrapper.cds--pagination-nav__page--active::after {
  inline-size: 1rem;
  inset-inline-start: calc(50% - 0.5rem);
  opacity: 1;
}
.cds--pagination-nav__page--active + .cds--pagination-nav__select-icon-wrapper .cds--pagination-nav__select-icon {
  display: none;
}

.cds--pagination-nav__select-icon {
  position: absolute;
  inset-block-start: calc(50% - 0.5rem);
  inset-inline-start: calc(50% - 0.5rem);
  pointer-events: none;
}

.cds--pagination-nav__accessibility-label {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

[dir=rtl] .cds--pagination-nav__list-item svg {
  transform: rotate(0.5turn);
}.table-module_tableWrapper__Wyte1 {
  display: flex;
  flex-direction: column-reverse;
}

.table-module_tableSelectAll__gM6Cc {
  background: #e6f1fa !important;
}

.table-module_tableContainer__PHBjN:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 3px;
}
.table-module_tableContainer__PHBjN .cds--data-table td {
  border-block-end: none;
  border-block-start: none;
}
.table-module_tableContainer__PHBjN .cds--data-table tbody tr:hover td {
  border-block-end: none;
  border-block-start: none;
}
.table-module_tableContainer__PHBjN .cds--data-table-header {
  background: transparent !important;
  padding: 16px 0 !important;
}
.table-module_tableContainer__PHBjN .cds--data-table-header__title {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: normal;
  color: #00204d;
}
.table-module_tableContainer__PHBjN .cds--table-sort .cds--table-sort__icon-unsorted {
  opacity: 1 !important;
}
.table-module_tableContainer__PHBjN .cds--table-header-label {
  font-weight: 500;
}
.table-module_tableContainer__PHBjN .cds--table-sort__flex {
  justify-content: flex-start;
  gap: 6px;
}
.table-module_tableContainer__PHBjN .cds--table-sort__flex svg {
  width: 16px;
  height: 16px;
}
.table-module_tableContainer__PHBjN .cds--table-sort__flex svg path {
  fill: #00204d;
}
.table-module_tableContainer__PHBjN tbody {
  background-color: white !important;
}
.table-module_tableContainer__PHBjN tbody:first-of-type {
  border-top: 1px solid #adbfd9;
}
.table-module_tableContainer__PHBjN tbody:last-of-type {
  border-bottom: 1px solid #adbfd9;
}
.table-module_tableContainer__PHBjN .table-module_tableHeader__C5ve7 {
  font-weight: 500 !important;
  color: #00204d !important;
  background: #e6f1fa !important;
  min-height: 56px !important;
}
.table-module_tableContainer__PHBjN .table-module_tableHeader__C5ve7:focus {
  border-radius: 6px;
}
.table-module_tableContainer__PHBjN .table-module_columnGroupToggle__Cn0Ui {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
  padding: 0;
  background: transparent;
  color: #00204d;
  vertical-align: middle;
}
.table-module_tableContainer__PHBjN .table-module_columnGroupToggle__Cn0Ui:focus-visible {
  outline: 2px solid #006aff;
  border-radius: 4px;
  outline-offset: 2px;
}
.table-module_tableContainer__PHBjN .table-module_sortableColumnGroupHeaderContent__8c8mM {
  display: flex;
  align-items: center;
  height: 100%;
  padding-inline-start: 16px;
}
.table-module_tableContainer__PHBjN .table-module_sortableColumnGroupHeaderContent__8c8mM .cds--table-sort {
  flex: 1;
  min-width: 0;
  padding-inline-start: 0;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG:first-child td {
  border-top: none;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG:last-child td {
  border-bottom: none;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG:hover td {
  background: #e5f0ff !important;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG:focus {
  outline: 2px solid #006aff;
  border-radius: 9px;
  outline-offset: -3px;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG td {
  color: #00204d !important;
  background: white !important;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG td:has(a) {
  padding: 0;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG td a {
  box-sizing: border-box;
  all: unset;
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  padding: 16px;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG td a:hover {
  cursor: pointer;
}
.table-module_tableContainer__PHBjN .table-module_tableRowClickable__ZTa7v {
  cursor: pointer !important;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG.table-module_pinnedRow__MkNrG td {
  background: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 6%, white) !important;
  animation: table-module_pinnedRowReveal__CNQl2 200ms ease-out;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG.table-module_pinnedRow__MkNrG td:first-of-type,
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG.table-module_pinnedRow__MkNrG td:first-of-type a {
  font-weight: 500;
}
.table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG.table-module_pinnedRow__MkNrG:hover td {
  background: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 12%, white) !important;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupHeaderRow__geEzA td {
  padding: 0 !important;
  background: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 17%, white) !important;
  border-top: none;
  border-bottom: none;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupToggle__pG4Kw {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 16px;
  border: none;
  background: transparent;
  text-align: left;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupToggle__pG4Kw:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: -2px;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupLabel__WZPJf {
  margin-left: calc(var(--pinned-group-label-indent, 63px) - 16px - 16px - 8px);
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 60%, #00204d);
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupMeta__lHqzl {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupCount__pKG5k {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 70%, #00204d);
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupAction__zvZZV {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  font-weight: 600;
  text-decoration: underline;
  color: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 60%, #00204d);
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupChevron__fjarn {
  color: color-mix(in srgb, var(--color-table-pinned-accent, #006aff) 70%, #00204d);
  transition: transform 180ms ease;
}
.table-module_tableContainer__PHBjN .table-module_pinnedGroupChevronCollapsed__rTe4B {
  transform: rotate(-90deg);
}
@media (prefers-reduced-motion: reduce) {
  .table-module_tableContainer__PHBjN .table-module_tableRow__mbKlG.table-module_pinnedRow__MkNrG td {
    animation: none;
  }
  .table-module_tableContainer__PHBjN .table-module_pinnedGroupChevron__fjarn {
    transition: none;
  }
}
.table-module_tableContainer__PHBjN .table-module_loader__NIswY {
  margin: 100px auto;
}
.table-module_tableContainer__PHBjN .table-module_archiveCellWrapper__Lx357 {
  width: 150px;
}
.table-module_tableContainer__PHBjN .table-module_hoverableVisible__M5EFq {
  visibility: visible;
  display: flex;
  justify-content: flex-end;
}
.table-module_tableContainer__PHBjN .table-module_hoverableHidden__-AQqs {
  visibility: hidden;
}

@keyframes table-module_pinnedRowReveal__CNQl2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.table-module_statePlaceholder__iRU8L {
  min-height: 480px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e6f1fa;
}

.table-module_noItemsContent__oMji- {
  color: #62748c;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
}
.table-module_noItemsContent__oMji- .table-module_noItemsButtonContainer__z0r6x {
  margin-top: 21px;
}
.table-module_noItemsContent__oMji- .table-module_noItemsButtonContainer__z0r6x button {
  margin: 9px auto;
}

.table-module_pagination__6SKNx {
  border: none !important;
  margin-top: 9px;
  background: transparent;
}
.table-module_pagination__6SKNx *:focus {
  outline: 2px solid #006aff;
  border-radius: 6px;
}
.table-module_pagination__6SKNx .cds--pagination__items-count {
  display: none;
}
.table-module_pagination__6SKNx .cds--select__arrow path {
  fill: #00204d;
}
.table-module_pagination__6SKNx .cds--select-input {
  border: none !important;
  border-bottom: 1px solid #00204d !important;
  color: #00204d;
}
.table-module_pagination__6SKNx .cds--select-input:hover {
  background: #e6f1fa !important;
}
.table-module_pagination__6SKNx .cds--pagination__text {
  color: #00204d;
}
.table-module_pagination__6SKNx .cds--pagination__right {
  border: none !important;
}
.table-module_pagination__6SKNx .cds--pagination__button--backward {
  border-left: 1px solid #00204d !important;
}
.table-module_pagination__6SKNx .cds--pagination__button--backward svg path {
  fill: #00204d;
}
.table-module_pagination__6SKNx .cds--pagination__button--backward:hover {
  background: #e6f1fa !important;
}
.table-module_pagination__6SKNx .cds--pagination__button--forward {
  border: none;
}
.table-module_pagination__6SKNx .cds--pagination__button--forward svg path {
  fill: #00204d;
}
.table-module_pagination__6SKNx .cds--pagination__button--forward:hover {
  background: #e6f1fa !important;
}
.table-module_pagination__6SKNx .cds--pagination__control-buttons span.cds--popover {
  display: none !important;
}
.table-module_pagination__6SKNx .cds--btn--disabled svg path {
  fill: #adbfd9;
}

.cds--table-toolbar {
  height: 60px;
  background-color: transparent;
  overflow: visible;
}
.cds--toolbar-content {
  height: 100%;
}
.cds--batch-actions ~ .cds--toolbar-content {
  clip-path: none;
  overflow: visible;
}

.table-module_toolbarContainer__5IONp {
  border-top: 1px solid #adbfd9;
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 8px;
  box-sizing: content-box;
}
.table-module_toolbarContainer__5IONp .table-module_toolbarLeftContainer__oy5DZ {
  flex: 0 1 100%;
  padding-right: 12px;
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: 8px;
}
.table-module_toolbarContainer__5IONp .table-module_toolbarLeftContainerEnd__TFFPk {
  display: flex;
  gap: 8px;
}
.table-module_toolbarContainer__5IONp .table-module_toolbarLeftContainerStart__VKPah {
  display: flex;
  gap: 8px;
}
.table-module_toolbarContainer__5IONp .table-module_toolbarRightContainer__9S4ol {
  flex: 1 0;
  padding-left: 12px;
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row;
  gap: 8px;
}
.table-module_toolbarContainer__5IONp .table-module_toolbarDelimiter__dTpg0 {
  width: 0px;
  border-left: 1px solid #adbfd9;
  height: 32px;
}

.table-module_disabledLink__3FCgG {
  pointer-events: none;
}:root {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-one {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-two {
  --cds-layer: var(--cds-layer-02, #ffffff);
  --cds-layer-active: var(--cds-layer-active-02, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-02, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-02, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-02, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-02, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-02, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-02, #a8a8a8);
  --cds-field: var(--cds-field-02, #ffffff);
  --cds-field-hover: var(--cds-field-hover-02, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-01, #c6c6c6);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-02, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-02, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-02, #a8a8a8);
}

.cds--layer-three {
  --cds-layer: var(--cds-layer-03, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-03, #c6c6c6);
  --cds-layer-hover: var(--cds-layer-hover-03, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-03, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-03, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-03, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-03, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-03, #a8a8a8);
  --cds-field: var(--cds-field-03, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-03, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-02, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-03, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-03, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-03, #c6c6c6);
}

@keyframes cds--hide-feedback {
  0% {
    opacity: 1;
    visibility: inherit;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes cds--show-feedback {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: inherit;
  }
}
@keyframes cds--skeleton {
  0% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
  20% {
    opacity: 1;
    transform: scaleX(1);
    transform-origin: left;
  }
  28% {
    transform: scaleX(1);
    transform-origin: right;
  }
  51% {
    transform: scaleX(0);
    transform-origin: right;
  }
  58% {
    transform: scaleX(0);
    transform-origin: right;
  }
  82% {
    transform: scaleX(1);
    transform-origin: right;
  }
  83% {
    transform: scaleX(1);
    transform-origin: left;
  }
  96% {
    transform: scaleX(0);
    transform-origin: left;
  }
  100% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
}
.cds--layout--size-xs {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xs, 1.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xs {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xs, 1.5rem));
}

.cds--layout-constraint--size__min-xs {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout-constraint--size__max-xs {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout--size-sm {
  --cds-layout-size-height-context: var(--cds-layout-size-height-sm, 2rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-sm {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-sm, 2rem));
}

.cds--layout-constraint--size__min-sm {
  --cds-layout-size-height-min: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout-constraint--size__max-sm {
  --cds-layout-size-height-max: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout--size-md {
  --cds-layout-size-height-context: var(--cds-layout-size-height-md, 2.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-md {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-md, 2.5rem));
}

.cds--layout-constraint--size__min-md {
  --cds-layout-size-height-min: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout-constraint--size__max-md {
  --cds-layout-size-height-max: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout--size-lg {
  --cds-layout-size-height-context: var(--cds-layout-size-height-lg, 3rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-lg {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-lg, 3rem));
}

.cds--layout-constraint--size__min-lg {
  --cds-layout-size-height-min: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout-constraint--size__max-lg {
  --cds-layout-size-height-max: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout--size-xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xl, 4rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xl, 4rem));
}

.cds--layout-constraint--size__min-xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout-constraint--size__max-xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout--size-2xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-2xl, 5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-2xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-2xl, 5rem));
}

.cds--layout-constraint--size__min-2xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout-constraint--size__max-2xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout--density-condensed {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-condensed {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-condensed, 0.5rem));
}

.cds--layout-constraint--density__min-condensed {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout-constraint--density__max-condensed {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout--density-normal {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-normal, 1rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-normal {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-normal, 1rem));
}

.cds--layout-constraint--density__min-normal {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-normal, 1rem);
}

.cds--layout-constraint--density__max-normal {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-normal, 1rem);
}

:root {
  --cds-layout-size-height-xs: 1.5rem;
  --cds-layout-size-height-sm: 2rem;
  --cds-layout-size-height-md: 2.5rem;
  --cds-layout-size-height-lg: 3rem;
  --cds-layout-size-height-xl: 4rem;
  --cds-layout-size-height-2xl: 5rem;
  --cds-layout-size-height-min: 0px;
  --cds-layout-size-height-max: 999999999px;
  --cds-layout-density-padding-inline-condensed: 0.5rem;
  --cds-layout-density-padding-inline-normal: 1rem;
  --cds-layout-density-padding-inline-min: 0px;
  --cds-layout-density-padding-inline-max: 999999999px;
}

.cds--assistive-text,
.cds--visually-hidden {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--popover-container {
  display: inline-block;
}

.cds--popover-container:not(.cds--popover--auto-align) {
  position: relative;
}

.cds--popover--high-contrast .cds--popover {
  --cds-popover-background-color: var(--cds-background-inverse, #393939);
  --cds-popover-text-color: var(--cds-text-inverse, #ffffff);
}

.cds--popover--drop-shadow .cds--popover {
  --cds-popover-drop-shadow: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
}

.cds--popover--caret {
  --cds-popover-offset: 0.625rem;
}

.cds--popover {
  position: absolute;
  z-index: 6000;
  filter: var(--cds-popover-drop-shadow, none);
  inset: 0;
  pointer-events: none;
}

.cds--popover-content {
  --cds-layout-size-height-sm: 2rem;
}
.cds--layout--size-sm .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-sm);
}
.cds--popover-content {
  --cds-layout-size-height-md: 2.5rem;
}
.cds--layout--size-md .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-md);
}
.cds--popover-content {
  --cds-layout-size-height-lg: 3rem;
}
.cds--layout--size-lg .cds--popover-content {
  --cds-layout-size-height: var(--cds-layout-size-height-lg);
}
.cds--popover-content {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover-content *,
.cds--popover-content *::before,
.cds--popover-content *::after {
  box-sizing: inherit;
}
.cds--popover-content {
  position: absolute;
  z-index: 6000;
  display: none;
  border-radius: var(--cds-popover-border-radius, 2px);
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  color: var(--cds-popover-text-color, var(--cds-text-primary, #161616));
  inline-size: max-content;
  max-inline-size: 23rem;
  pointer-events: auto;
}

.cds--popover--open > .cds--popover > .cds--popover-content {
  display: block;
}

.cds--popover-content::before {
  position: absolute;
  display: none;
  content: "";
}

.cds--popover--open > .cds--popover > .cds--popover-content::before {
  display: block;
}

.cds--popover-caret,
.cds--popover--auto-align.cds--popover-caret {
  position: absolute;
  z-index: 6000;
  display: none;
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  will-change: transform;
}

.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-caret {
  display: block;
}

.cds--popover--auto-align.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-content > .cds--popover-caret {
  display: block;
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-caret {
  display: none;
}

.cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

.cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: 0;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 0;
  inset-inline-start: initial;
}

.cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-end: 0;
  transform: translate(var(--cds-popover-offset, 0rem), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: 0;
}

.cds--popover--bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-left > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-start > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-right > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-end > .cds--popover > .cds--popover-content::before {
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-start: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  transform: translateY(-100%);
}

.cds--popover--bottom > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, var(--cds-popover-offset, 0rem));
}

[dir=rtl] .cds--popover--bottom > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  transform: translate(50%, var(--cds-popover-offset, 0rem));
}

.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

.cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 0;
  inset-inline-start: initial;
}

.cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translate(var(--cds-popover-offset, 0rem), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: 0;
}

.cds--popover--top > .cds--popover > .cds--popover-content::before,
.cds--popover--top-left > .cds--popover > .cds--popover-content::before,
.cds--popover--top-start > .cds--popover > .cds--popover-content::before,
.cds--popover--top-right > .cds--popover > .cds--popover-content::before,
.cds--popover--top-end > .cds--popover > .cds--popover-content::before {
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-inline-end: 0;
  inset-inline-start: 0;
  transform: translateY(100%);
}

.cds--popover--top > .cds--popover > .cds--popover-caret,
.cds--popover--top-left > .cds--popover > .cds--popover-caret,
.cds--popover--top-start > .cds--popover > .cds--popover-caret,
.cds--popover--top-right > .cds--popover > .cds--popover-caret,
.cds--popover--top-end > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  transform: translate(50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-height, 0.375rem);
  clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), -50%);
}

.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) * -1 - 16px));
}

.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-start: 100%;
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--right > .cds--popover > .cds--popover-content::before,
.cds--popover--right-top > .cds--popover > .cds--popover-content::before,
.cds--popover--right-start > .cds--popover > .cds--popover-content::before,
.cds--popover--right-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--right-end > .cds--popover > .cds--popover-content::before {
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: translateX(-100%);
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(calc(var(--cds-popover-offset, 0rem) - 100%), -50%);
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 0.1px), -50%);
}

.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-0.5 * var(--cds-popover-offset, 0rem) - 16px));
}

.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--left > .cds--popover > .cds--popover-content::before,
.cds--popover--left-top > .cds--popover > .cds--popover-content::before,
.cds--popover--left-start > .cds--popover > .cds--popover-content::before,
.cds--popover--left-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--left-end > .cds--popover > .cds--popover-content::before {
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translateX(100%);
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 100%), -50%);
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: var(--cds-popover-caret-width, 0.75rem);
  clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-content {
  border-radius: 0;
}

.cds--popover--tab-tip .cds--popover {
  will-change: filter;
}

.cds--popover--tab-tip__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover--tab-tip__button *,
.cds--popover--tab-tip__button *::before,
.cds--popover--tab-tip__button *::after {
  box-sizing: inherit;
}
.cds--popover--tab-tip__button {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--popover--tab-tip__button::-moz-focus-inner {
  border: 0;
}
.cds--popover--tab-tip__button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--popover--tab-tip__button:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--popover--tab-tip__button:focus {
    outline-style: dotted;
  }
}
.cds--popover--tab-tip__button:hover {
  background-color: var(--cds-layer-hover);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button {
  background: var(--cds-layer);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus)::after {
  position: absolute;
  z-index: 6001;
  background: var(--cds-layer);
  block-size: 2px;
  content: "";
  inline-size: 100%;
  inset-block-end: 0;
}

.cds--popover--tab-tip__button svg {
  fill: var(--cds-icon-primary, #161616);
}

.cds--tooltip {
  --cds-popover-offset: 12px;
}

.cds--tooltip-content {
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: var(--cds-tooltip-padding-block, 1rem) var(--cds-tooltip-padding-inline, 1rem);
  color: var(--cds-text-inverse, #ffffff);
  max-inline-size: 18rem;
}

.cds--icon-tooltip {
  --cds-tooltip-padding-block: 0.125rem;
  --cds-popover-caret-width: 0.5rem;
  --cds-popover-caret-height: 0.25rem;
  --cds-popover-offset: 0.5rem;
}

.cds--icon-tooltip .cds--tooltip-content {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--definition-term {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--definition-term *,
.cds--definition-term *::before,
.cds--definition-term *::after {
  box-sizing: inherit;
}
.cds--definition-term {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--definition-term::-moz-focus-inner {
  border: 0;
}
.cds--definition-term {
  border-radius: 0;
  border-block-end: 1px dotted var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
}

.cds--definition-term:focus {
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--definition-term:focus {
    outline-style: dotted;
  }
}
.cds--definition-term:focus {
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-term:hover {
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-tooltip {
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: 0.5rem 1rem;
  max-inline-size: 11rem;
}

.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  inline-size: 100%;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-label,
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-secondary-label {
  overflow: hidden;
  text-overflow: ellipsis;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item--icon {
  margin-inline-start: auto;
}

.cds--tabs,
.cds--tab-content {
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
}

.cds--tabs.cds--tabs--tall,
.cds--tabs.cds--tabs--contained.cds--tabs--tall {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-lg)), var(--cds-layout-size-height, var(--cds-layout-size-height-xl)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-xl)));
}

.cds--tabs html {
  font-size: 100%;
}
.cds--tabs body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--tabs code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--tabs strong {
  font-weight: 600;
}
.cds--tabs {
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  position: relative;
  display: flex;
  block-size: auto;
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  max-block-size: var(--cds-layout-size-height-xl);
  min-block-size: var(--cds-layout-size-height-local);
}
.cds--tabs.cds--tabs--contained {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-lg)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-xl)));
}
.cds--tabs .cds--tab--list {
  display: flex;
  inline-size: auto;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  will-change: scroll-position;
}
.cds--tabs .cds--tab--list::-webkit-scrollbar {
  display: none;
}
.cds--tabs .cds--tabs__nav {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav *,
.cds--tabs .cds--tabs__nav *::before,
.cds--tabs .cds--tabs__nav *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav {
  display: flex;
}
.cds--tabs .cds--tab--overflow-nav-button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tab--overflow-nav-button *,
.cds--tabs .cds--tab--overflow-nav-button *::before,
.cds--tabs .cds--tab--overflow-nav-button *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tab--overflow-nav-button {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--tabs .cds--tab--overflow-nav-button::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tab--overflow-nav-button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: var(--cds-background, #ffffff);
  inline-size: 2.5rem;
}
.cds--tabs .cds--tab--overflow-nav-button:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tab--overflow-nav-button:focus {
    outline-style: dotted;
  }
}
.cds--tabs .cds--tab--overflow-nav-button--hidden {
  display: none;
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button {
  margin: 0;
  background-color: var(--cds-layer-accent);
  inline-size: 3rem;
}
.cds--tabs .cds--tab--overflow-nav-button svg {
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tab--overflow-nav-button--next {
  position: absolute;
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-end: 0;
}
.cds--tabs .cds--tab--overflow-nav-button--next::before {
  position: absolute;
  z-index: 1;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-background, #ffffff));
  block-size: 100%;
  content: "";
  inline-size: 0.5rem;
  inset-inline-start: -0.5rem;
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button--next::before {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
.cds--tabs .cds--tab--overflow-nav-button--previous {
  position: absolute;
  inset-block-end: 0;
  inset-block-start: 0;
  inset-inline-start: 0;
}
.cds--tabs .cds--tab--overflow-nav-button--previous::before {
  position: absolute;
  z-index: 1;
  background: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-background, #ffffff));
  block-size: 100%;
  content: "";
  inline-size: 0.5rem;
  inset-inline-end: -0.5rem;
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button--previous::before {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--left {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-layer));
}
.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--right {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-layer));
}
.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
@media not all and (resolution >= 0.001dpcm) {
  @supports (-webkit-appearance: none) and (stroke-color: transparent) {
    .cds--tabs .cds--tabs__overflow-indicator--left {
      background-image: linear-gradient(to left, rgba(var(--cds-background, #ffffff), 0), var(--cds-background, #ffffff));
    }
    .cds--tabs .cds--tabs__overflow-indicator--right {
      background-image: linear-gradient(to right, rgba(var(--cds-background, #ffffff), 0), var(--cds-background, #ffffff));
    }
    .cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left {
      background-image: linear-gradient(to left, rgba(var(--cds-layer-accent), 0), var(--cds-layer-accent));
    }
    .cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right {
      background-image: linear-gradient(to right, rgba(var(--cds-layer-accent), 0), var(--cds-layer-accent));
    }
  }
}
.cds--tabs .cds--tabs__nav-item-label-wrapper {
  display: flex;
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item-label-wrapper {
  position: relative;
  inset-block-start: 0.0625rem;
}
.cds--tabs .cds--tabs__nav-item html {
  font-size: 100%;
}
.cds--tabs .cds--tabs__nav-item body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--tabs .cds--tabs__nav-item code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--tabs .cds--tabs__nav-item strong {
  font-weight: 600;
}
.cds--tabs .cds--tabs__nav-item {
  display: flex;
  flex: 1 0 auto;
  padding: 0;
  cursor: pointer;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs .cds--tabs__nav-item + .cds--tabs__nav-item {
  margin-inline-start: 0.0625rem;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item {
  background-color: var(--cds-layer-accent);
  box-shadow: -0.0625rem 0 0 0 var(--cds-border-strong);
  margin-inline-start: 0;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected + div + .cds--tabs__nav-item {
  box-shadow: -0.0625rem 0 0 0 transparent;
}
.cds--tabs .cds--tabs__nav-item .cds--tabs__nav-link {
  transition: color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), border-bottom-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs.cds--tabs--dismissable .cds--tabs__nav-link {
  padding-inline-end: 2.5rem;
}
.cds--tabs.cds--tabs--dismissable.cds--tabs--contained .cds--tabs__nav-link {
  padding-inline-end: calc(3rem - 1px);
}
.cds--tabs .cds--tabs__nav-item--close {
  position: relative;
  display: flex;
  align-items: center;
  inset-inline-start: calc(-0.75rem - 1px);
  margin-inline-start: calc(-1.5rem + 1px);
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item--close--hidden {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  position: static;
  inline-size: 0.1875rem;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tabs__nav-item--close--hidden {
  display: none;
}
.cds--tabs .cds--tabs__nav-item--close-icon {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav-item--close-icon *,
.cds--tabs .cds--tabs__nav-item--close-icon *::before,
.cds--tabs .cds--tabs__nav-item--close-icon *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav-item--close-icon {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
}
.cds--tabs .cds--tabs__nav-item--close-icon::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tabs__nav-item--close-icon {
  block-size: 1.5rem;
  inline-size: 1.5rem;
  padding-block: 0.25rem;
  padding-inline: 0.25rem;
  pointer-events: auto;
}
.cds--tabs .cds--tabs__nav-item--close-icon svg {
  block-size: 1rem;
  fill: var(--cds-text-secondary, #525252);
  inline-size: 1rem;
}
.cds--tabs .cds--tabs__nav-item--close-icon svg:hover {
  fill: var(--cds-text-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item--close-icon:hover {
  background-color: var(--cds-layer-hover);
}
.cds--tabs .cds--tabs__nav-item--close-icon:focus, .cds--tabs .cds--tabs__nav-item--close-icon:active {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tabs__nav-item--close-icon:focus, .cds--tabs .cds--tabs__nav-item--close-icon:active {
    outline-style: dotted;
  }
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon svg {
  fill: var(--cds-text-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item--close-icon--selected svg {
  fill: var(--cds-text-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover {
  background-color: inherit;
  cursor: not-allowed;
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled svg,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled svg,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover svg {
  fill: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:focus, .cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:active,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:focus,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:active,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:focus,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:active {
  outline: 2px solid transparent;
  outline-offset: -2px;
}
.cds--tabs .cds--tabs__nav-item--icon {
  display: flex;
  align-items: center;
  padding-inline-start: 0.5rem;
}
.cds--tabs .cds--tabs__nav-item--icon-left {
  display: flex;
  align-items: center;
  margin-block-start: -2px;
  padding-inline-end: 0.5rem;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon {
  padding-inline-start: var(--cds-layout-density-padding-inline-local);
}
.cds--tabs .cds--tabs__nav-link {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav-link *,
.cds--tabs .cds--tabs__nav-link *::before,
.cds--tabs .cds--tabs__nav-link *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav-link {
  display: inline-block;
  padding: 0;
  border: 0;
  appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
}
.cds--tabs .cds--tabs__nav-link::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tabs__nav-link {
  outline: 2px solid transparent;
  outline-offset: -2px;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  overflow: hidden;
  border-block-end: 2px solid var(--cds-border-subtle);
  color: var(--cds-text-secondary, #525252);
  padding-inline: var(--cds-layout-density-padding-inline-local);
  text-align: start;
  text-decoration: none;
  text-overflow: ellipsis;
  transition: border 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  white-space: nowrap;
}
.cds--tabs .cds--tabs__nav-link:focus, .cds--tabs .cds--tabs__nav-link:active {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tabs__nav-link:focus, .cds--tabs .cds--tabs__nav-link:active {
    outline-style: dotted;
  }
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-link {
  border-block-end: 0;
  padding-inline: var(--cds-layout-density-padding-inline-local);
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item-label {
  line-height: calc(3rem - 0.5rem * 2);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item-secondary-label {
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  min-block-size: 1rem;
}
.cds--tabs.cds--tabs__icon--default .cds--tab--list, .cds--tabs.cds--tabs__icon--lg .cds--tab--list {
  overflow-x: visible;
}
.cds--tabs .cds--tabs__nav-item--icon-only, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  block-size: var(--cds-layout-size-height-local);
  inline-size: var(--cds-layout-size-height-local);
}
.cds--tabs .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label {
  line-height: 0;
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):hover {
  border-block-end: 2px solid var(--cds-border-strong);
  color: var(--cds-text-primary, #161616);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):not(.cds--tabs__nav-item--hover-off):hover {
  background-color: var(--cds-layer-accent-hover);
  color: var(--cds-text-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item--selected {
  border-block-end: 2px solid var(--cds-border-interactive, #0f62fe);
  transition: color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected + .cds--tabs__nav-item {
  box-shadow: none;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--selected {
  box-shadow: inset 0 2px 0 0 var(--cds-border-interactive, #0f62fe);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected,
.cds--tabs .cds--tabs__nav-item--selected,
.cds--tabs .cds--tabs__nav-item--selected:focus .cds--tabs__nav-link:focus,
.cds--tabs .cds--tabs__nav-item--selected:active .cds--tabs__nav-link:active {
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  color: var(--cds-text-primary, #161616);
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected:hover {
  line-height: calc(3rem - 0.5rem * 2);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover {
  background-color: var(--cds-layer);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:focus,
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:active, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:focus,
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:active {
  box-shadow: none;
}
.cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected:hover {
  background-color: var(--cds-background, #ffffff);
}
.cds--tabs .cds--tabs__nav-item--disabled {
  background-color: transparent;
  border-block-end: 2px solid var(--cds-border-disabled, #c6c6c6);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}
.cds--tabs .cds--tabs__nav-item--disabled:hover {
  border-block-end: 2px solid var(--cds-border-disabled, #c6c6c6);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled:hover {
  background-color: var(--cds-button-disabled, #c6c6c6);
}
.cds--tabs .cds--tabs__nav-item--disabled:focus,
.cds--tabs .cds--tabs__nav-item--disabled:active {
  border-block-end: 2px solid var(--cds-border-disabled, #c6c6c6);
  outline: none;
  pointer-events: none;
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link {
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled:hover .cds--tabs__nav-link {
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:focus,
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:active {
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--disabled {
  border-block-end: none;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
}

.cds--tab-content {
  padding: var(--cds-layout-density-padding-inline-local);
}
.cds--tab-content:focus {
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tab-content:focus {
    outline-style: dotted;
  }
}

.cds--tabs--contained ~ .cds--tab-content {
  background: var(--cds-layer);
}

.cds--tab-content--interactive:focus {
  outline: none;
}

.cds--tabs.cds--skeleton {
  cursor: default;
  pointer-events: none;
}

.cds--skeleton.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-link {
  border-block-end: 2px solid var(--cds-skeleton-element, #c6c6c6);
}

.cds--tabs.cds--skeleton .cds--tabs__nav-link {
  display: flex;
  align-items: center;
  padding: 0 var(--cds-layout-density-padding-inline-local);
  block-size: 100%;
  inline-size: 10rem;
}

.cds--tabs.cds--skeleton .cds--tabs__nav-link span {
  position: relative;
  padding: 0;
  border: none;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span:hover, .cds--tabs.cds--skeleton .cds--tabs__nav-link span:focus, .cds--tabs.cds--skeleton .cds--tabs__nav-link span:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--tabs.cds--skeleton .cds--tabs__nav-link span::before {
    animation: none;
  }
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span {
  display: block;
  block-size: 0.875rem;
  inline-size: 100%;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tabs__nav-item .cds--tabs__nav-item--selected .cds--tabs__nav-item--selected {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tabs .cds--tabs__nav-item--disabled .cds--tabs__nav-link {
    color: GrayText;
    fill: GrayText;
  }
}/**
  Heavy use of !important rule because of the library's core stye overwrites.
*/
.tabs-module_tabsContainer__k8DKy {
  color: #00204d;
  isolation: initial !important;
  position: relative;
}
.tabs-module_tabsContainer__k8DKy .tabs-module_tabList__Fgii3 {
  border-width: 0px 0 0 2px;
  border-style: solid;
  border-color: #ebf0f7;
  padding: 0 0 0 2px;
  box-sizing: border-box;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs.cds--tabs--contained {
  width: max-content !important;
  border-left: 2px solid #ebf0f7 !important;
  padding: 0 2px !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tab-content:focus {
  outline: none !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item {
  background-color: #ebf0f7 !important;
  color: #00204d !important;
  margin-right: 2px;
  font-size: 12px !important;
  border-bottom: none !important;
  border-right: 2px solid transparent;
  transition-property: background-color, border-color !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item:last-of-type.cds--tabs__nav-item--selected {
  border-right: 2px solid #ebf0f7 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item:last-of-type:hover {
  border-right: 2px solid #ebf0f7 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item .cds--tabs__nav-item-label {
  color: #00204d !important;
  font-size: 12px !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--selected {
  background-color: white !important;
  border-top: 1px solid #00204d !important;
  box-shadow: inset 0 2px 0 0 #ffd129 !important;
  font-weight: 500 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--selected .cds--tabs__nav-item-label {
  font-weight: 500 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--selected .sz-tabs-tab-counter {
  background-color: #e6f1fa !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--selected {
  border-radius: revert !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled {
  color: #adbfd9 !important;
  cursor: not-allowed;
  background-color: #ebf0f7 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled .sz-tabs-tab-counter {
  color: #adbfd9 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled .sz-tabs-tab-icon svg path {
  fill: #adbfd9 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled .sz-tabs-tab-error-icon path {
  fill: #adbfd9 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item:hover:not(.cds--tabs__nav-item--selected):not([aria-invalid=true]) {
  background-color: white !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item:hover:not(.cds--tabs__nav-item--selected):not([aria-invalid=true]) .sz-tabs-tab-counter {
  background-color: #e6f1fa !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item:hover:not(.cds--tabs__nav-item--selected):not([aria-invalid=true]) .sz-tabs-tab-icon svg path {
  fill: #006aff !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled .cds--tabs__nav-item-label {
  color: #adbfd9 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item--disabled:hover:not(.cds--tabs__nav-item--selected):not([aria-invalid=true]) {
  background-color: #ebf0f7 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tabs__nav-item-label {
  display: flex;
  align-items: center;
  gap: 5px;
}
.tabs-module_tabsContainer__k8DKy .cds--tab--overflow-nav-button {
  background: #ebf0f7 !important;
}
.tabs-module_tabsContainer__k8DKy .cds--tab--overflow-nav-button svg {
  width: 24px !important;
  height: 24px !important;
  stroke: #00204d;
  stroke-width: 0.5px;
  stroke-dasharray: 2, 0;
  stroke-linejoin: round;
}
.tabs-module_tabsContainer__k8DKy .cds--tab--overflow-nav-button--next {
  border-left: 2px solid white;
}
.tabs-module_tabsContainer__k8DKy .cds--tab--overflow-nav-button--previous {
  border-right: 2px solid white;
  z-index: 10;
}

.tabs-module_tabsContainerVertical__rGl0z {
  display: flex;
  margin-left: 3px;
}
.tabs-module_tabsContainerVertical__rGl0z .tabs-module_tabList__Fgii3 {
  width: min-content;
  border-width: 0px 2px;
  border-style: solid;
  border-color: #ebf0f7;
  padding: 0;
  box-sizing: border-box;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs {
  max-height: revert;
  flex-basis: max-content;
  background-color: #ebf0f7 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs.cds--tabs--contained {
  border-left: unset !important;
  border-right: unset !important;
  padding: 2px 0 !important;
  border-radius: 0 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs .cds--tabs__nav-link {
  max-width: revert !important;
  flex-grow: 0;
  flex-basis: 50px;
  border-bottom: 1px solid white;
  margin: 0 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs .cds--tabs__nav-link:first-child {
  border-top: 1px solid white;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs .cds--tabs__nav-item {
  width: 100% !important;
  justify-content: flex-start !important;
  border-radius: 0 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tabs .cds--tabs__nav-item--selected {
  border-top: unset !important;
  border-left: 1px solid #00204d !important;
  box-shadow: inset 2px 0 0 0 #ffd129 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tab--list {
  width: min-content;
  display: flex;
  flex-direction: column;
  border-radius: 0 !important;
}
.tabs-module_tabsContainerVertical__rGl0z .cds--tab-content {
  width: 100%;
}

.tabs-module_counter__2SKpW {
  box-sizing: border-box;
  padding: 2px 5px 2px 5px;
  color: #0070bf !important;
  min-width: 20px;
  height: 20px;
  background: white;
  border-radius: 50px;
  color: #00204d;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-module_tab__vmSck {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  min-width: max-content !important;
  gap: 5px !important;
}

.tabs-module_errorTooltip__kIVTE {
  z-index: 9;
  max-width: min-content;
}

.tabs-module_errorTooltipIconWrapper__irXTb {
  display: flex;
  justify-content: center;
}

.tabs-module_truncateText__AYTvX {
  max-width: 153px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}.tag-module_tag-container__YC7BI {
  display: flex;
  width: fit-content;
  border-radius: 4px;
  justify-content: center;
  min-width: max-content;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_tag-container__YC7BI {
  background-color: #006aff;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_tag-container__YC7BI button {
  color: white;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_tag-container__YC7BI button svg {
  color: white;
  fill: white;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_tag-container__YC7BI button svg path {
  color: white;
  fill: white;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_tag-container__YC7BI {
  background-color: #3388ff;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_tag-container__YC7BI button {
  color: white;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_tag-container__YC7BI button svg {
  color: white;
  fill: white;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_tag-container__YC7BI button svg path {
  color: white;
  fill: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_tag-container__YC7BI {
  background-color: #ffd129;
}
.tag-module_OUTLINE__vo2qa .tag-module_tag-container__YC7BI {
  background-color: white;
}
.tag-module_OUTLINE__vo2qa .tag-module_tag-container__YC7BI button {
  border: 1px solid #94c3e4;
}
.tag-module_COVERED__MtqwF .tag-module_tag-container__YC7BI {
  background-color: #cce4f5;
}
.tag-module_GREEN__juNmS .tag-module_tag-container__YC7BI {
  background-color: #cce7e3;
}
.tag-module_GREEN_BACK__yyR-4 .tag-module_tag-container__YC7BI {
  background-color: #e6f3f1;
}
.tag-module_GREEN_BACK_MAX__CjnMk .tag-module_tag-container__YC7BI {
  background-color: #92d4c1;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_tag-container__YC7BI {
  background-color: #007a6a;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_tag-container__YC7BI button {
  color: white;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_tag-container__YC7BI button svg {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_tag-container__YC7BI button svg path {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_tag-container__YC7BI {
  background-color: #339d8f;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_tag-container__YC7BI button {
  color: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_tag-container__YC7BI button svg {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_tag-container__YC7BI button svg path {
  color: white;
  fill: white;
}
.tag-module_BLUE__z7Bpc .tag-module_tag-container__YC7BI {
  background-color: #cce4f5;
}
.tag-module_YELLOW__fScRM .tag-module_tag-container__YC7BI {
  background-color: #ffedd5;
}
.tag-module_YELLOW_BACK__LP7GN .tag-module_tag-container__YC7BI {
  background-color: #fff6ea;
}
.tag-module_RED__RD-C8 .tag-module_tag-container__YC7BI {
  background-color: #fad2d2;
}
.tag-module_PURPLE__Mf90l .tag-module_tag-container__YC7BI {
  background-color: #e3d8f4;
}
.tag-module_DISABLED__3yUqw .tag-module_tag-container__YC7BI {
  background-color: #ebf0f7;
}
.tag-module_DISABLED_FRONT__v3F6h .tag-module_tag-container__YC7BI {
  background-color: #adbfd9;
}
.tag-module_NONE__Gpm5m .tag-module_tag-container__YC7BI {
  background-color: white;
  border: 1px solid #ebf0f7;
}

.tag-module_main-button__tXi-6,
.tag-module_dismiss-button__8Dinv {
  border-radius: 4px;
  color: #00204d;
}
.tag-module_main-button__tXi-6:focus-visible,
.tag-module_dismiss-button__8Dinv:focus-visible {
  outline: 2px solid #006aff;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_INTERACTIVE__cBs7I .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #3388ff;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #ebf0f7;
  color: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg,
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path,
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator],
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator] {
  border-color: #00204d !important;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text],
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text] {
  color: #00204d !important;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_ACTIVATED__-Zf-W .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #3388ff;
  color: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg,
.tag-module_ACTIVATED__-Zf-W .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg {
  color: white;
  fill: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path,
.tag-module_ACTIVATED__-Zf-W .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path {
  color: white;
  fill: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator],
.tag-module_ACTIVATED__-Zf-W .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator] {
  border-color: white !important;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text],
.tag-module_ACTIVATED__-Zf-W .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text] {
  color: white !important;
}
.tag-module_OUTLINE__vo2qa .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_OUTLINE__vo2qa .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #ebf0f7;
}
.tag-module_COVERED__MtqwF .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_COVERED__MtqwF .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #3388ff;
  color: white;
}
.tag-module_COVERED__MtqwF .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg,
.tag-module_COVERED__MtqwF .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path,
.tag-module_COVERED__MtqwF .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) svg path {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator],
.tag-module_COVERED__MtqwF .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_indicator] {
  border-color: white !important;
}
.tag-module_COVERED__MtqwF .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text],
.tag-module_COVERED__MtqwF .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) [class*=score-indicator-module_text] {
  color: white !important;
}
.tag-module_GREEN__juNmS .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_GREEN__juNmS .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #e6f3f1;
}
.tag-module_GREEN_BACK__yyR-4 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_GREEN_BACK__yyR-4 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #cce7e3;
}
.tag-module_GREEN_BACK_MAX__CjnMk .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_GREEN_BACK_MAX__CjnMk .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #cce7e3;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_GREEN_FRONT__AQh90 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #339d8f;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button,
.tag-module_GREEN_FRONT__AQh90 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button {
  color: white;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg,
.tag-module_GREEN_FRONT__AQh90 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT__AQh90 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg path,
.tag-module_GREEN_FRONT__AQh90 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg path {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #92d4c1;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button,
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button {
  color: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg,
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg {
  color: white;
  fill: white;
}
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg path,
.tag-module_GREEN_FRONT_LIGHT__KS8ua .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) button svg path {
  color: white;
  fill: white;
}
.tag-module_BLUE__z7Bpc .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_BLUE__z7Bpc .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #e6f1fa;
}
.tag-module_YELLOW__fScRM .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_YELLOW__fScRM .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #fff6ea;
}
.tag-module_YELLOW_BACK__LP7GN .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_YELLOW_BACK__LP7GN .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #ffedd5;
}
.tag-module_RED__RD-C8 .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_RED__RD-C8 .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #ffeaea;
}
.tag-module_PURPLE__Mf90l .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_PURPLE__Mf90l .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #f1ebfa;
}
.tag-module_DISABLED__3yUqw .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_DISABLED__3yUqw .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #adbfd9;
}
.tag-module_DISABLED_FRONT__v3F6h .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_DISABLED_FRONT__v3F6h .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #adbfd9;
}
.tag-module_DARK_BACK_BLUE__OhRkp .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_DARK_BACK_BLUE__OhRkp .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #cce4f5;
}
.tag-module_NONE__Gpm5m .tag-module_main-button__tXi-6:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur),
.tag-module_NONE__Gpm5m .tag-module_dismiss-button__8Dinv:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd, .tag-module_selected__dzzur) {
  background-color: #ebf0f7;
}
.tag-module_main-button__tXi-6[aria-disabled=true],
.tag-module_dismiss-button__8Dinv[aria-disabled=true] {
  cursor: default;
  color: #adbfd9;
}
.tag-module_main-button__tXi-6[aria-disabled=true] svg,
.tag-module_dismiss-button__8Dinv[aria-disabled=true] svg {
  color: #adbfd9;
  fill: #adbfd9;
}
.tag-module_main-button__tXi-6[aria-disabled=true] svg path,
.tag-module_dismiss-button__8Dinv[aria-disabled=true] svg path {
  color: #adbfd9;
  fill: #adbfd9;
}
.tag-module_main-button__tXi-6.tag-module_presentational__3o8Xd,
.tag-module_dismiss-button__8Dinv.tag-module_presentational__3o8Xd {
  cursor: default;
}

.tag-module_selected__dzzur {
  border: 1px solid #3388ff !important;
  box-sizing: border-box;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur {
  background-color: #3388ff;
  color: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur svg {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur svg path {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur [class*=score-indicator-module_indicator] {
  border-color: white !important;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur [class*=score-indicator-module_text] {
  color: white !important;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur {
  background-color: #006aff;
}
.tag-module_OUTLINE__vo2qa .tag-module_selected__dzzur {
  background-color: #cce1ff;
}
.tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: white;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: #cce1ff;
  color: #00204d;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg path {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_indicator] {
  border-color: #00204d !important;
}
.tag-module_INTERACTIVE__cBs7I .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_text] {
  color: #00204d !important;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: #ebf0f7;
  color: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg path {
  color: #00204d;
  fill: #00204d;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_indicator] {
  border-color: #00204d !important;
}
.tag-module_INTERACTIVE_LIGHT__FVENs .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_text] {
  color: #00204d !important;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: #3388ff;
  color: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg path {
  color: white;
  fill: white;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_indicator] {
  border-color: white !important;
}
.tag-module_COVERED__MtqwF .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_text] {
  color: white !important;
}
.tag-module_OUTLINE__vo2qa .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: #ebf0f7;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) {
  background-color: #3388ff;
  color: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg {
  color: white;
  fill: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) svg path {
  color: white;
  fill: white;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_indicator] {
  border-color: white !important;
}
.tag-module_ACTIVATED__-Zf-W .tag-module_selected__dzzur:hover:not([aria-disabled=true], .tag-module_presentational__3o8Xd) [class*=score-indicator-module_text] {
  color: white !important;
}

.tag-module_main-button__tXi-6 {
  display: flex;
  align-items: center;
  background: transparent;
  padding: 4px 8px;
  box-sizing: border-box;
  border: 1px solid transparent;
}
.tag-module_main-button__tXi-6 .tag-module_iconWrapper__S48jF {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tag-module_main-button__tXi-6.tag-module_SMALL__ft2iJ {
  height: 24px;
  gap: 4px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
}
.tag-module_main-button__tXi-6.tag-module_SMALL__ft2iJ .tag-module_iconWrapper__S48jF {
  width: 14px;
}
.tag-module_main-button__tXi-6.tag-module_LARGE__FpDEp {
  height: 28px;
  gap: 8px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.tag-module_main-button__tXi-6.tag-module_LARGE__FpDEp .tag-module_iconWrapper__S48jF {
  width: 16px;
}

.tag-module_dismiss-button__8Dinv {
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.tag-module_dismiss-button__8Dinv.tag-module_SMALL__ft2iJ {
  height: 24px;
  width: 20px;
}
.tag-module_dismiss-button__8Dinv.tag-module_SMALL__ft2iJ:focus-visible {
  outline-offset: -5px;
  border-radius: 6px;
}
.tag-module_dismiss-button__8Dinv.tag-module_LARGE__FpDEp {
  height: 28px;
  width: 22px;
}
.tag-module_dismiss-button__8Dinv.tag-module_LARGE__FpDEp:focus-visible {
  outline-offset: -6px;
  border-radius: 8px;
}.text-area-module_sz-text-area__Ha96C {
  box-sizing: border-box;
  width: 100%;
  background-color: white;
}
.text-area-module_sz-text-area_focused__jCBth .text-area-module_sz-text-area__area-wrapper__RBhmF {
  border-radius: 2px;
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.text-area-module_sz-text-area_error__bj738 .text-area-module_sz-text-area__area-wrapper__RBhmF {
  border-top: 1px solid #d71717;
  border-bottom: 1px solid #d71717;
}
.text-area-module_sz-text-area_error__bj738 .text-area-module_sz-text-area__title__NOsdM {
  color: #d71717;
}
.text-area-module_sz-text-area_disabled__-MNJY .text-area-module_sz-text-area__area-wrapper__RBhmF {
  border-top: 1px solid #adbfd9;
  border-bottom: 1px solid #adbfd9;
}
.text-area-module_sz-text-area_disabled__-MNJY .text-area-module_sz-text-area__area-element__k3VpH {
  cursor: not-allowed;
  cursor: -moz-not-allowed;
  cursor: -webkit-not-allowed;
  color: #62748c;
}
.text-area-module_sz-text-area_disabled__-MNJY .text-area-module_sz-text-area__area-element__k3VpH::placeholder {
  color: #adbfd9;
}
.text-area-module_sz-text-area_disabled__-MNJY .text-area-module_sz-text-area__title__NOsdM {
  color: #adbfd9;
}
.text-area-module_sz-text-area__Ha96C [aria-disabled=true] {
  caret-color: transparent;
}
.text-area-module_sz-text-area__area-wrapper__RBhmF {
  border-top: 1px solid #00204d;
  border-bottom: 1px solid #00204d;
  border-right: 1px solid #ebf0f7;
  border-left: 1px solid #ebf0f7;
}
.text-area-module_sz-text-area__area-element__k3VpH {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  resize: none;
  padding: 16px 8px;
  color: #00204d;
  background-color: transparent;
  border-radius: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  scrollbar-width: thin;
}
.text-area-module_sz-text-area__area-element__k3VpH::-webkit-scrollbar {
  width: 5px;
}
.text-area-module_sz-text-area__area-element__k3VpH::-webkit-scrollbar-track {
  border-radius: 0 3px 3px 0;
}
.text-area-module_sz-text-area__area-element__k3VpH::-webkit-scrollbar-thumb {
  background-color: grey;
  border-radius: 5px;
}
.text-area-module_sz-text-area__area-element__k3VpH::placeholder {
  color: #62748c;
  opacity: 1;
}
.text-area-module_sz-text-area__title-wrapper__4kWlp {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.text-area-module_sz-text-area__max-characters__ePC7u {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #62748c;
}
.text-area-module_sz-text-area__max-characters-error__2RmlD {
  color: #d71717;
}
.text-area-module_sz-text-area__title__NOsdM {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  display: inline-block;
}
.text-area-module_sz-text-area__title__NOsdM.text-area-module_sz-text-area_active__5NZrW {
  color: #62748c;
  font-size: 12px;
}
.text-area-module_sz-text-area__error-title__5YMxM {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: #d71717;
}.week-calendar-module_root__dtqgq {
  --wc-row-h: 26px;
  --wc-header-h: 40px;
  --wc-label-inset: 7px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.week-calendar-module_scroll__dMsoZ {
  overflow-x: auto;
}

.week-calendar-module_viewport__QNSS4 {
  overflow: auto;
  height: calc(var(--wc-header-h) + var(--wc-label-inset) + var(--wc-viewport-rows) * var(--wc-row-h));
  scroll-padding-top: calc(var(--wc-header-h) + var(--wc-label-inset));
}

.week-calendar-module_grid__U4IJb {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  grid-template-rows: calc(var(--wc-header-h) + var(--wc-label-inset)) auto;
  column-gap: 2px;
  min-width: 640px;
}
.week-calendar-module_grid__U4IJb.week-calendar-module_withSecondaryZone__FcA4a {
  grid-template-columns: 48px 48px minmax(0, 1fr);
}

.week-calendar-module_gutterHead__Y4l6K,
.week-calendar-module_dayHeaders__xM9ck {
  position: sticky;
  top: 0;
  z-index: 3;
  align-self: start;
  height: var(--wc-header-h);
  box-sizing: border-box;
  background: white;
}

.week-calendar-module_gutterHead__Y4l6K {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 6px;
  padding-right: 6px;
  font-size: 11px;
  line-height: 14px;
  color: #62748c;
  font-weight: 500;
}

.week-calendar-module_dayHeaders__xM9ck {
  display: grid;
  grid-template-columns: repeat(var(--wc-days), minmax(0, 1fr));
  align-items: end;
  gap: 2px;
}

.week-calendar-module_dayHeader__zoMZ- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding-bottom: 6px;
}

.week-calendar-module_dayName__I9ZTs {
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: #00204d;
}

.week-calendar-module_dayDate__cqMgE {
  font-size: 11px;
  line-height: 14px;
  color: #62748c;
}

.week-calendar-module_gutterBody__TZ-W8 {
  position: relative;
  height: calc(var(--wc-rows) * var(--wc-row-h));
}

.week-calendar-module_hourLabel__NLYeE {
  position: absolute;
  right: 6px;
  transform: translateY(-50%);
  font-size: 11px;
  line-height: 14px;
  color: #62748c;
  white-space: nowrap;
}

.week-calendar-module_daysArea__1YYEg {
  position: relative;
}

.week-calendar-module_dayCards__004U3 {
  display: grid;
  grid-template-columns: repeat(var(--wc-days), minmax(0, 1fr));
  gap: 2px;
}

.week-calendar-module_dayCard__-lg4D {
  border: 1px solid #ebf0f7;
  border-radius: 4px;
  background: white;
  overflow: hidden;
}

.week-calendar-module_dayBody__GRGlI {
  position: relative;
  height: calc(var(--wc-rows) * var(--wc-row-h));
  pointer-events: none;
}

.week-calendar-module_hourLine__2Z3Yl {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #ebf0f7;
}

.week-calendar-module_outsideHours__mw243 {
  position: absolute;
  left: 0;
  right: 0;
  background: rgba(235, 240, 247, 0.35);
}

.week-calendar-module_elapsedWash__rky-3 {
  position: absolute;
  left: 0;
  right: 0;
  background: repeating-linear-gradient(135deg, rgba(235, 240, 247, 0.7) 0 3px, transparent 3px 8px);
}

.week-calendar-module_hold__h35L1 {
  position: absolute;
  left: 0;
  right: 0;
  background: rgba(241, 235, 250, 0.55);
  pointer-events: none;
}

.week-calendar-module_busyEvent__j5RuH {
  position: absolute;
  box-sizing: border-box;
  border-left: 3px solid var(--wc-owner-color);
  background: var(--wc-owner-bg);
  border-radius: 3px;
  padding: 3px 5px;
  overflow: hidden;
  pointer-events: none;
}

.week-calendar-module_busyEventTitle__r0ppJ {
  display: block;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: #00204d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.week-calendar-module_busyEventTime__6Ye2S {
  display: block;
  font-size: 11px;
  line-height: 14px;
  color: #62748c;
}

.week-calendar-module_hitLayer__oNo4U {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  user-select: none;
  touch-action: none;
}

.week-calendar-module_hitRow__nlD19 {
  display: grid;
  grid-template-columns: repeat(var(--wc-days), minmax(0, 1fr));
  gap: 2px;
  height: var(--wc-row-h);
}

.week-calendar-module_hitCell__u9et7 {
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 3px;
}
.week-calendar-module_hitCell__u9et7:hover:not(.week-calendar-module_suppressed__AC-2o) {
  background: #e5f0ff;
}
.week-calendar-module_hitCell__u9et7.week-calendar-module_busy__A35hu:hover:not(.week-calendar-module_suppressed__AC-2o) {
  background: #fff6ea;
}
.week-calendar-module_hitCell__u9et7:focus {
  outline: none;
}
.week-calendar-module_hitCell__u9et7:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: -2px;
}
.week-calendar-module_hitCell__u9et7.week-calendar-module_suppressed__AC-2o {
  cursor: default;
}
.week-calendar-module_hitCell__u9et7.week-calendar-module_elapsed__NgK8q {
  cursor: not-allowed;
}

.week-calendar-module_chosenLayer__8Fu-c {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(var(--wc-days), minmax(0, 1fr));
  gap: 2px;
  pointer-events: none;
}

.week-calendar-module_chosenDay__uozKE {
  position: relative;
}

.week-calendar-module_chosenBlock__Xn55x {
  position: absolute;
  left: 3px;
  right: 3px;
  box-sizing: border-box;
  background: #006aff;
  color: white;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 11px;
  line-height: 14px;
  overflow: hidden;
}
.week-calendar-module_chosenBlock__Xn55x.week-calendar-module_overBusy__qff2w {
  background: #c4811d;
  color: #000b1a;
}
.week-calendar-module_chosenBlock__Xn55x.week-calendar-module_overBusy__qff2w .week-calendar-module_removeButton__jfO1r {
  background: rgba(0, 11, 26, 0.12);
  color: #000b1a;
}
.week-calendar-module_chosenBlock__Xn55x.week-calendar-module_overBusy__qff2w .week-calendar-module_removeButton__jfO1r:hover {
  background: rgba(0, 11, 26, 0.16);
  box-shadow: inset 0 0 0 1px #000b1a;
}

.week-calendar-module_chosenLabelRow__ZH-69 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
}

.week-calendar-module_chosenTime__GPN3n {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.week-calendar-module_overBusyMarker__GwPPB {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  color: #000b1a;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

.week-calendar-module_chosenSublabel__2OsYH {
  display: block;
  font-size: 11px;
  line-height: 14px;
  opacity: 0.9;
  white-space: nowrap;
}

.week-calendar-module_removeButton__jfO1r {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: 0;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  pointer-events: auto;
}
.week-calendar-module_removeButton__jfO1r:hover {
  background: rgba(255, 255, 255, 0.45);
}
.week-calendar-module_removeButton__jfO1r:focus {
  outline: none;
}
.week-calendar-module_removeButton__jfO1r:focus-visible {
  outline: 2px solid white;
  outline-offset: 1px;
}

.week-calendar-module_legend__oAQyg {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: center;
}

.week-calendar-module_legendItem__CLvxT {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #62748c;
}
.week-calendar-module_legendItem__CLvxT.week-calendar-module_legendWarn__AUz6r {
  color: #00204d;
}

.week-calendar-module_legendSwatch__EGJdr {
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex: 0 0 auto;
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_picked__Fbm-- {
  background: #006aff;
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_free__14XGu {
  background: white;
  border: 1px solid #cce1ff;
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_outsideHoursSwatch__WLd-U {
  background: rgba(235, 240, 247, 0.55);
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_elapsedSwatch__kljV0 {
  background: repeating-linear-gradient(135deg, rgba(235, 240, 247, 0.9) 0 2px, transparent 2px 5px);
  border: 1px solid #ebf0f7;
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_overBusySwatch__tTq0W {
  background: #c4811d;
}
.week-calendar-module_legendSwatch__EGJdr.week-calendar-module_holdSwatch__oHMBY {
  background: rgba(241, 235, 250, 0.85);
}

.week-calendar-module_skeletonGrid__zVx9M {
  display: grid;
  grid-template-columns: 48px repeat(var(--wc-days), minmax(0, 1fr));
  gap: 2px;
  min-width: 640px;
}

.week-calendar-module_skeletonColumn__gsZtJ {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.week-calendar-module_skeletonCell__BnsGX {
  height: calc(var(--wc-row-h) * 2 - 2px);
  border-radius: 3px;
  background: #ebf0f7;
  animation: week-calendar-module_wcSkeletonPulse__moY6K 1.4s ease-in-out infinite;
}

.week-calendar-module_skeletonHeader__vq-Bh {
  height: calc(var(--wc-header-h) + var(--wc-label-inset) - 2px);
}

@keyframes week-calendar-module_wcSkeletonPulse__moY6K {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}
.week-calendar-module_visuallyHidden__2TAZ3 {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

@media (prefers-reduced-motion: reduce) {
  .week-calendar-module_skeletonCell__BnsGX {
    animation: none;
  }
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-color: #ccc;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -4px;
  position: absolute;
  width: 0;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-top: none;
  border-bottom-color: #f0f0f0;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  top: 0;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -8px;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  bottom: 0;
}
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
}

.react-datepicker {
  font-family: "Helvetica Neue", helvetica, arial, sans-serif;
  font-size: 0.8rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}
.react-datepicker-popper[data-placement^=bottom] {
  padding-top: 10px;
}
.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {
  left: auto;
  right: 50px;
}
.react-datepicker-popper[data-placement^=top] {
  padding-bottom: 10px;
}
.react-datepicker-popper[data-placement^=right] {
  padding-left: 8px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  padding-right: 8px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid #aeaeae;
  border-top-left-radius: 0.3rem;
  padding: 8px 0;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}
.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}
.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 15px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  align-items: center;
  background: none;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 2px;
  padding: 0;
  border: none;
  z-index: 1;
  height: 32px;
  width: 32px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 2px;
}
.react-datepicker__navigation--next {
  right: 2px;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 85px;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
}
.react-datepicker__navigation:hover *::before {
  border-color: #a6a6a6;
}

.react-datepicker__navigation-icon {
  position: relative;
  top: -1px;
  font-size: 20px;
  width: 0;
}
.react-datepicker__navigation-icon--next {
  left: -2px;
}
.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}
.react-datepicker__navigation-icon--previous {
  right: -2px;
}
.react-datepicker__navigation-icon--previous::before {
  transform: rotate(225deg);
  right: -7px;
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}
.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 180px;
}
.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}
.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}
.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: auto;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 85px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -87px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 85px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + (1.7rem / 2));
  overflow-y: scroll;
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  white-space: nowrap;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-names {
  margin-bottom: -8px;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
}
.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}
.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  border-radius: 0.3rem;
  background-color: #3dcc4a;
  color: #fff;
}
.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
  background-color: #32be3f;
}
.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}
.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}
.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: #1d5d90;
}
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  border-radius: 0.3rem;
  background-color: #bad9f1;
  color: rgb(0, 0, 0);
}
.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background-color: #1d5d90;
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: rgba(33, 107, 165, 0.5);
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range), .react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}
.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  cursor: default;
  color: #ccc;
}
.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}
.react-datepicker__input-container .react-datepicker__calendar-icon {
  position: absolute;
  padding: 0.5rem;
}

.react-datepicker__view-calendar-icon input {
  padding: 6px 10px 5px 25px;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
  position: relative;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  transform: rotate(135deg);
  right: -16px;
  top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0 6px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}
.react-datepicker__close-icon::after {
  cursor: pointer;
  background-color: #216ba5;
  color: #fff;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "×";
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.react-datepicker__children-container {
  width: 13.8rem;
  margin: 0.4rem;
  padding-right: 0.2rem;
  padding-left: 0.2rem;
  height: auto;
}

.react-datepicker__aria-live {
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  white-space: nowrap;
}

.react-datepicker__calendar-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}
.availability-calendar-module_root__h3nk4 {
  width: 100%;
}
.availability-calendar-module_root__h3nk4 .react-datepicker {
  width: 100%;
  font-family: inherit;
  color: #00204d;
  background: transparent;
  border: none;
  border-radius: 0;
}
.availability-calendar-module_root__h3nk4 .react-datepicker__month-container {
  width: 100%;
  float: none;
}
.availability-calendar-module_root__h3nk4 .react-datepicker__header {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}
.availability-calendar-module_root__h3nk4 .react-datepicker__month {
  margin: 0;
}
.availability-calendar-module_root__h3nk4 .react-datepicker__day-names,
.availability-calendar-module_root__h3nk4 .react-datepicker__week {
  display: flex;
  gap: 4px;
  margin: 0 0 4px;
}
.availability-calendar-module_root__h3nk4 .react-datepicker__week:last-child {
  margin-bottom: 0;
}

.availability-calendar-module_header__a91pl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.availability-calendar-module_month__dNKKh {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: normal;
  color: #00204d;
}

.availability-calendar-module_nav__DU8XI {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #006aff;
  cursor: pointer;
}
.availability-calendar-module_nav__DU8XI:hover:not(:disabled) {
  background-color: #e5f0ff;
}
.availability-calendar-module_nav__DU8XI:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 1px;
}
.availability-calendar-module_nav__DU8XI:disabled {
  color: #adbfd9;
  cursor: default;
}

.availability-calendar-module_dayName__HF1dx {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  height: 28px;
  min-width: 0;
  margin: 0;
  color: #62748c;
}

.availability-calendar-module_root__h3nk4 .availability-calendar-module_day__CiruZ {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 0;
  height: 36px;
  margin: 0;
  color: #62748c;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: not-allowed;
}
.availability-calendar-module_root__h3nk4 .availability-calendar-module_day__CiruZ:hover {
  background: transparent;
}
.availability-calendar-module_root__h3nk4 .availability-calendar-module_day__CiruZ:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 1px;
}

.availability-calendar-module_root__h3nk4 .availability-calendar-module_day__CiruZ.react-datepicker__day--outside-month:not(.availability-calendar-module_available__fUEgU) {
  color: #adbfd9;
  pointer-events: none;
}

.availability-calendar-module_root__h3nk4 .availability-calendar-module_available__fUEgU {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #006aff;
  border-color: #006aff;
  background: white;
  cursor: pointer;
}
.availability-calendar-module_root__h3nk4 .availability-calendar-module_available__fUEgU:hover {
  background: #e5f0ff;
}

.availability-calendar-module_root__h3nk4 .availability-calendar-module_selected__JBV6Z,
.availability-calendar-module_root__h3nk4 .availability-calendar-module_selected__JBV6Z:hover {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: white;
  background: #006aff;
  border-color: #006aff;
}.checkbox-module_checkbox__aFjGa {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
}
.checkbox-module_checkbox__input-container__RzMJX {
  display: inline-flex;
  flex-direction: row;
  cursor: pointer;
  padding: 2px 0;
}
.checkbox-module_checkbox__input-container-disabled__pmZ1- {
  cursor: not-allowed;
}
.checkbox-module_checkbox__label__KuEGC {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  padding-left: 6.5px;
  color: #00204d;
  cursor: inherit;
}
.checkbox-module_checkbox__bottom-text__5IUNr {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  height: 16px;
}
.checkbox-module_checkbox__input__v6EGi {
  width: 16px;
  height: 16px;
  cursor: inherit;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 2px;
  background-color: #ffffff;
  border: 2px solid #62748c;
  position: relative;
  flex: none;
  margin-top: 2px;
}
.checkbox-module_checkbox__input__v6EGi:before {
  content: "";
  display: block;
}
.checkbox-module_checkbox__input__v6EGi:checked {
  border-color: #ffd129;
  background-color: #ffd129;
}
.checkbox-module_checkbox__input__v6EGi:checked:before {
  width: 4px;
  height: 8px;
  margin: 0 auto;
  border-bottom: 2px solid #1a1f36;
  border-right: 2px solid #1a1f36;
  transform: rotate(45deg);
  transform-origin: center;
}
.checkbox-module_checkbox__input-disabled__80xGK:checked:before {
  border-color: #62748c;
}
.checkbox-module_checkbox__input-error__zqzLT:checked:before {
  border-color: #ffffff;
}
.checkbox-module_checkbox__input__v6EGi:indeterminate {
  border-color: #ffd129;
  background-color: #ffd129;
}
.checkbox-module_checkbox__input__v6EGi:indeterminate:before {
  width: 8px;
  height: 0;
  margin: 5px auto 0;
  border-bottom: 2px solid #1a1f36;
  border-right: none;
  transform: none;
}
.checkbox-module_checkbox__input-disabled__80xGK:indeterminate:before {
  border-color: #62748c;
}
.checkbox-module_checkbox__input-error__zqzLT:indeterminate:before {
  border-color: #ffffff;
}
.checkbox-module_checkbox__input-container__RzMJX:focus-within {
  border-radius: 1.5px;
  outline: 2px solid #006aff;
  outline-offset: 1px;
}
.checkbox-module_checkbox--disabled__HYEF5 {
  cursor: not-allowed;
}
.checkbox-module_checkbox--disabled__HYEF5 .checkbox-module_checkbox__label__KuEGC {
  color: #adbfd9;
}
.checkbox-module_checkbox--disabled__HYEF5 .checkbox-module_checkbox__input__v6EGi {
  border-color: #adbfd9;
}
.checkbox-module_checkbox--disabled__HYEF5 .checkbox-module_checkbox__input__v6EGi:checked,
.checkbox-module_checkbox--disabled__HYEF5 .checkbox-module_checkbox__input__v6EGi:indeterminate {
  border-color: #ebf0f7;
  background-color: #ebf0f7;
}
.checkbox-module_checkbox--disabled__HYEF5 .checkbox-module_checkbox__bottom-text__5IUNr {
  color: #adbfd9;
}
.checkbox-module_checkbox--error__DxME7 .checkbox-module_checkbox__input__v6EGi {
  border-color: #d71717;
}
.checkbox-module_checkbox--error__DxME7 .checkbox-module_checkbox__input__v6EGi:checked,
.checkbox-module_checkbox--error__DxME7 .checkbox-module_checkbox__input__v6EGi:indeterminate {
  border-color: #d71717;
  background-color: #d71717;
}
.checkbox-module_checkbox--error__DxME7 .checkbox-module_checkbox__bottom-text__5IUNr {
  color: #d71717;
}.checkbox-group-module_checkbox-group__Ky8-Q {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
}
.checkbox-group-module_checkbox-group__legend__-3ALf {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  display: block;
  margin-bottom: 8px;
}
.checkbox-group-module_checkbox-group__error__dLF42 {
  color: #d71717;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  height: 16px;
}.checkbox-group-item-module_checkbox-group-item__75ahF {
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  align-self: flex-start;
  padding: 2px 0;
}
.checkbox-group-item-module_checkbox-group-item__label__jllE3 {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  padding-left: 6.5px;
  color: #00204d;
  cursor: inherit;
}
.checkbox-group-item-module_checkbox-group-item__input__wGjt6 {
  width: 16px;
  height: 16px;
  cursor: inherit;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 2px;
  background-color: #ffffff;
  border: 2px solid #62748c;
  position: relative;
}
.checkbox-group-item-module_checkbox-group-item__input__wGjt6:before {
  content: "";
  display: block;
}
.checkbox-group-item-module_checkbox-group-item__input__wGjt6:checked {
  border-color: #ffd129;
  background-color: #ffd129;
}
.checkbox-group-item-module_checkbox-group-item__input__wGjt6:checked:before {
  width: 4px;
  height: 8px;
  margin: 0 auto;
  border-bottom: 2px solid #1a1f36;
  border-right: 2px solid #1a1f36;
  transform: rotate(45deg);
  transform-origin: center;
}
.checkbox-group-item-module_checkbox-group-item__input-disabled__jHH-G:checked:before {
  border-color: #adbfd9;
}
.checkbox-group-item-module_checkbox-group-item__input-error__mCCy3:checked:before {
  border-color: #ffffff;
}
.checkbox-group-item-module_checkbox-group-item__75ahF:focus-within {
  border-radius: 1.5px;
  outline: 2px solid #006aff;
  outline-offset: 1px;
}
.checkbox-group-item-module_checkbox-group-item--disabled__1aO5- {
  cursor: not-allowed;
}
.checkbox-group-item-module_checkbox-group-item--disabled__1aO5- .checkbox-group-item-module_checkbox-group-item__label__jllE3 {
  color: #adbfd9;
}
.checkbox-group-item-module_checkbox-group-item--disabled__1aO5- .checkbox-group-item-module_checkbox-group-item__input__wGjt6 {
  border-color: #adbfd9;
}
.checkbox-group-item-module_checkbox-group-item--disabled__1aO5- .checkbox-group-item-module_checkbox-group-item__input__wGjt6:checked {
  border-color: #ebf0f7;
  background-color: #ebf0f7;
}
.checkbox-group-item-module_checkbox-group-item--error__yKo-i .checkbox-group-item-module_checkbox-group-item__input__wGjt6 {
  border-color: #d71717;
}
.checkbox-group-item-module_checkbox-group-item--error__yKo-i .checkbox-group-item-module_checkbox-group-item__input__wGjt6:checked {
  border-color: #d71717;
  background-color: #d71717;
}.sz-datepicker-form-field .react-datepicker__day--keyboard-selected {
  background-color: transparent;
  border: 1px solid white;
  color: #00204d;
}
.sz-datepicker-form-field body:not(.using-mouse) .react-datepicker__day--keyboard-selected {
  background-color: #006aff;
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px white;
  color: white;
  border: 1px solid #006aff;
  box-shadow: none;
}
.sz-datepicker-form-field .react-datepicker {
  width: 280px;
  border-radius: 5px;
  border: none;
}
.sz-datepicker-form-field .react-datepicker-wrapper {
  width: 100%;
}
.sz-datepicker-form-field .react-datepicker__header {
  background-color: #ebf0f7;
  border-bottom: 1px solid #00204d;
}
.sz-datepicker-form-field .react-datepicker__input-container input {
  border-bottom: 1px solid #00204d;
  width: 100%;
  padding-bottom: 4px;
}
.sz-datepicker-form-field .react-datepicker__input-container input:focus-within {
  outline: 2px solid #006aff;
  outline-offset: 3px;
  border-radius: 1px;
}
.sz-datepicker-form-field .react-datepicker__input-container .input-error {
  border-bottom-color: #d71717;
}
.sz-datepicker-form-field .react-datepicker-popper[data-placement^=bottom] .sz-datepicker-form-field .react-datepicker__triangle {
  left: -10px !important;
}
.sz-datepicker-form-field .react-datepicker__month-container {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1490196078);
  width: 280px;
  border-radius: 5px;
}
.sz-datepicker-form-field .react-datepicker .react-datepicker__day-name {
  color: #00204d;
  width: 30px;
}
.sz-datepicker-form-field .react-datepicker .react-datepicker__current-month {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}
.sz-datepicker-form-field .react-datepicker__day--outside-month {
  color: #adbfd9;
}
.sz-datepicker-form-field .react-datepicker__navigation {
  width: 25px;
  height: 25px;
}
.sz-datepicker-form-field .react-datepicker__navigation--next {
  background: url("data:image/svg+xml,%3csvg%20width='22'%20height='32'%20viewBox='0%200%2022%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='path-1-inside-1_3071_22912'%20fill='white'%3e%3cpath%20d='M10.9982%2011L15.9982%2016L10.9982%2021L9.9375%2019.9393L13.8768%2016L9.9375%2012.0607L10.9982%2011Z'/%3e%3c/mask%3e%3cpath%20d='M10.9982%2011L15.9982%2016L10.9982%2021L9.9375%2019.9393L13.8768%2016L9.9375%2012.0607L10.9982%2011Z'%20fill='white'/%3e%3cpath%20d='M15.9982%2016L17.0588%2017.0607L18.1195%2016L17.0588%2014.9393L15.9982%2016ZM10.9982%2011L12.0588%209.93934L10.9982%208.87868L9.9375%209.93934L10.9982%2011ZM10.9982%2021L9.9375%2022.0607L10.9982%2023.1213L12.0588%2022.0607L10.9982%2021ZM9.9375%2012.0607L8.87684%2011L7.81618%2012.0607L8.87684%2013.1213L9.9375%2012.0607ZM9.9375%2019.9393L8.87684%2018.8787L7.81618%2019.9393L8.87684%2021L9.9375%2019.9393ZM13.8768%2016L14.9375%2017.0607L15.9982%2016L14.9375%2014.9393L13.8768%2016ZM17.0588%2014.9393L12.0588%209.93934L9.9375%2012.0607L14.9375%2017.0607L17.0588%2014.9393ZM12.0588%2022.0607L17.0588%2017.0607L14.9375%2014.9393L9.9375%2019.9393L12.0588%2022.0607ZM9.9375%209.93934L8.87684%2011L10.9982%2013.1213L12.0588%2012.0607L9.9375%209.93934ZM8.87684%2021L9.9375%2022.0607L12.0588%2019.9393L10.9982%2018.8787L8.87684%2021ZM12.8162%2014.9393L8.87684%2018.8787L10.9982%2021L14.9375%2017.0607L12.8162%2014.9393ZM8.87684%2013.1213L12.8162%2017.0607L14.9375%2014.9393L10.9982%2011L8.87684%2013.1213Z'%20fill='%23006AFF'%20mask='url(%23path-1-inside-1_3071_22912)'/%3e%3c/svg%3e") no-repeat;
}
.sz-datepicker-form-field .react-datepicker__navigation--previous {
  background: url("data:image/svg+xml,%3csvg%20width='22'%20height='32'%20viewBox='0%200%2022%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.0607%2012.0607L11%2011L6%2016L11%2021L12.0607%2019.9393L8.12132%2016L12.0607%2012.0607Z'%20fill='%23006AFF'/%3e%3c/svg%3e") no-repeat;
}
.sz-datepicker-form-field .react-datepicker__navigation-icon {
  display: none;
}
.sz-datepicker-form-field .react-datepicker__close-icon {
  border-radius: 5px;
  margin-left: 4px;
  margin-top: 1px;
  margin-right: 18px;
  padding: 0px;
  width: 20px;
  height: 20px;
}
.sz-datepicker-form-field .react-datepicker__close-icon:focus-visible {
  outline: 2px solid #006aff;
}
.sz-datepicker-form-field .react-datepicker__close-icon::before, .sz-datepicker-form-field .react-datepicker__close-icon::after {
  background-color: rgba(255, 255, 255, 0);
  color: #00204d;
  font-size: 20px;
}
.sz-datepicker-form-field .react-datepicker__close-icon::after {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sz-datepicker-form-field .react-datepicker__day, .sz-datepicker-form-field .react-datepicker__day:hover {
  border-radius: 50%;
  border: 1px solid white;
}
.sz-datepicker-form-field .react-datepicker__day:focus-visible, .sz-datepicker-form-field .react-datepicker__day:hover:focus-visible {
  outline: none;
}
.sz-datepicker-form-field .react-datepicker__day--today {
  font-weight: 400;
}
.sz-datepicker-form-field .react-datepicker__day--selected {
  background-color: #006aff;
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px white;
  color: white;
  border: 1px solid #006aff;
  box-shadow: none;
}
.sz-datepicker-form-field .react-datepicker__day:hover {
  background-color: #006aff;
  border: 1px solid #006aff;
  color: white;
  border-radius: 50%;
}
.sz-datepicker-form-field .react-datepicker__day--selected:hover {
  background-color: #ffd129;
  border: 1px solid #00204d;
  color: #00204d;
  border-radius: 50%;
}
.sz-datepicker-form-field .react-datepicker__day--selected:hover:focus-visible {
  border-radius: 50%;
}
.sz-datepicker-form-field .calendar-custom-input {
  background: url("data:image/svg+xml,%3csvg%20width='13'%20height='14'%20viewBox='0%200%2014%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.334%201.99935H11.6673V0.666016H10.334V1.99935H3.66732V0.666016H2.33398V1.99935H1.66732C0.933984%201.99935%200.333984%202.59935%200.333984%203.33268V13.9993C0.333984%2014.7327%200.933984%2015.3327%201.66732%2015.3327H12.334C13.0673%2015.3327%2013.6673%2014.7327%2013.6673%2013.9993V3.33268C13.6673%202.59935%2013.0673%201.99935%2012.334%201.99935ZM12.334%2013.9993H1.66732V6.66602H12.334V13.9993ZM12.334%205.33268H1.66732V3.33268H12.334V5.33268Z'%20fill='%2300204D'%20/%3e%3c/svg%3e") no-repeat right;
  background-size: 13px 15px;
  background-origin: content-box;
  padding-right: 3px;
  height: 20px;
  color: #00204d;
}
.sz-datepicker-form-field .calendar-custom-input::placeholder {
  color: #00204d;
}
.sz-datepicker-form-field .datepicker_disabled .calendar-custom-input {
  background: url("data:image/svg+xml,%3csvg%20width='13'%20height='14'%20viewBox='0%200%2014%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.334%201.99935H11.6673V0.666016H10.334V1.99935H3.66732V0.666016H2.33398V1.99935H1.66732C0.933984%201.99935%200.333984%202.59935%200.333984%203.33268V13.9993C0.333984%2014.7327%200.933984%2015.3327%201.66732%2015.3327H12.334C13.0673%2015.3327%2013.6673%2014.7327%2013.6673%2013.9993V3.33268C13.6673%202.59935%2013.0673%201.99935%2012.334%201.99935ZM12.334%2013.9993H1.66732V6.66602H12.334V13.9993ZM12.334%205.33268H1.66732V3.33268H12.334V5.33268Z'%20fill='%23ADBFD9'%20/%3e%3c/svg%3e") no-repeat right;
  border-bottom: 1px solid #adbfd9;
  background-size: 13px 15px;
  background-origin: content-box;
  color: #62748c;
  caret-color: transparent;
}
.sz-datepicker-form-field .datepicker_disabled .calendar-custom-input:hover {
  cursor: not-allowed;
}
.sz-datepicker-form-field .datepicker_disabled .calendar-custom-input::placeholder {
  color: #adbfd9;
}
.sz-datepicker-form-field .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-top-color: rgba(173, 191, 217, 0.1);
}.edit-form-wrapper-module_container__1rODH {
  min-width: 400px;
}
.edit-form-wrapper-module_container__1rODH .edit-form-wrapper-module_header__dQ-E0 {
  background-color: #006aff;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
}
.edit-form-wrapper-module_container__1rODH .edit-form-wrapper-module_header__dQ-E0 .edit-form-wrapper-module_title__EfCU- {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  line-height: 32px;
  color: white;
}
.edit-form-wrapper-module_container__1rODH .edit-form-wrapper-module_header__dQ-E0 .edit-form-wrapper-module_buttonsWrapper__zYSzJ {
  display: flex;
  gap: 8px;
}
.edit-form-wrapper-module_container__1rODH .edit-form-wrapper-module_contentWrapper__AyhzO {
  border: 1px solid #006aff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 16px 24px;
}.radio-button-group-module_radioButtonGroup__hr6lj {
  text-align: left;
}
.radio-button-group-module_radioButtonGroup__hr6lj .radio-button-group-module_title__tZKXy {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
  text-align: left;
  padding-bottom: 8px;
}
.radio-button-group-module_radioButtonGroup__hr6lj .radio-button-group-module_titleDisabled__c7JNg {
  color: #adbfd9;
}
.radio-button-group-module_radioButtonGroup__hr6lj .radio-button-group-module_items__ZOW6r {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.radio-button-group-module_radioButtonGroup__hr6lj .radio-button-group-module_horizontal__iAlDz {
  flex-direction: row;
  gap: 16px;
}
.radio-button-group-module_radioButtonGroup__hr6lj .radio-button-group-module_error__BwBCu {
  color: #d71717;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  height: 16px;
  margin-top: 8px;
}.sz-select-with-menu-button .sz-select__menu-wrapper {
  padding: 4px 0;
}
.sz-select-with-menu-button__menu-button-wrapper {
  padding: 4px 16px;
}
.sz-select-with-menu-button .sz-select__single-value {
  display: flex !important;
  gap: 8px;
}
.sz-select-with-menu-button .sz-select__option {
  gap: 4px;
}
.sz-select-with-menu-button__option-label, .sz-select-with-menu-button__selected-value-label {
  color: #000000;
}
.sz-select-with-menu-button__option-label-note, .sz-select-with-menu-button__selected-value-label-note {
  color: #757575;
}
.sz-select-with-menu-button__option-label-note {
  overflow-wrap: break-word;
  hyphens: manual;
}
.sz-select-with-menu-button__menu-button {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #10b7ff;
  background-color: transparent;
  opacity: 0.9;
  border: 0;
  cursor: pointer;
}.maintenance-page-module_maintenancePage__s9NO8 {
  background-color: #ebf0f7;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  flex-direction: column;
}

.maintenance-page-module_container__dv-9V {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.maintenance-page-module_container__dv-9V .maintenance-page-module_logo__4xZgQ {
  margin-bottom: 20px;
}
.maintenance-page-module_container__dv-9V .maintenance-page-module_logo__4xZgQ svg {
  width: 120px;
  height: auto;
}

.maintenance-page-module_message__o6JzW {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #00204d;
}
.maintenance-page-module_message__o6JzW .maintenance-page-module_title__-27ay {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: normal;
  margin-bottom: 16px;
}
.maintenance-page-module_message__o6JzW p {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.maintenance-page-module_message__o6JzW .maintenance-page-module_link__gwKaQ {
  color: #006aff;
}

.maintenance-page-module_buttonContainer__P4mPk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}.sz-modal-buttons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.sz-modal-buttons--buttons-full-width .button {
  flex: 1;
}
.sz-modal-buttons--buttons-position-center {
  justify-content: center;
}
.sz-modal-buttons--buttons-position-end {
  justify-content: flex-end;
}
.sz-modal-buttons--buttons-position-start {
  justify-content: start;
}.sz-notification-modal__message {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #00204d;
}.segmented-button-module_sz-segment-button__pn9wh {
  display: flex;
  width: fit-content;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  background-color: #e5f0ff;
  box-shadow: none;
  padding: 0px;
  border-radius: 4px;
  gap: 0;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid transparent;
  color: #00204d;
  font-weight: 600;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE {
    transition: none;
  }
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE .segmented-button-module_label__ZyLLd {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE .segmented-button-module_label__ZyLLd svg {
  width: 16px;
  height: 16px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE .segmented-button-module_primary__2Wd56 {
  color: #00204d;
  font-weight: 500;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE .segmented-button-module_secondary__hSAQx {
  color: #62748c;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_active__A7zaB {
  background-color: white;
  border: 1px solid #cce1ff;
  color: #00204d;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_disabled__R0oz3 {
  pointer-events: none;
  color: #adbfd9;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_disabled__R0oz3 .segmented-button-module_secondary__hSAQx {
  color: #adbfd9;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 3px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE:focus:not(:focus-visible) {
  outline: none;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE:hover:not(.segmented-button-module_active__A7zaB) {
  background-color: #f4f8ff;
  color: #00204d;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_LARGE__GbDjk {
  height: 44px;
  padding: 12px 24px 12px 24px;
  border-radius: 4px;
  font-size: 14px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_MEDIUM__wUs41 {
  height: 36px;
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  font-size: 14px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_sz-segment-item-button__94rsE.segmented-button-module_SMALL__XC4PS {
  height: 32px;
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.segmented-button-module_sz-segment-button__pn9wh .segmented-button-module_on-press__X-fQy {
  background-color: #cce1ff !important;
  color: #00204d !important;
  border: 1px solid #adbfd9;
}.selection-tile-module_selectionTile__xSYpK {
  padding: 16px;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #cce1ff;
  background-color: #ffffff;
  background-clip: padding-box;
  min-width: 344px;
  box-sizing: border-box;
}
.selection-tile-module_selectionTile__xSYpK:hover:not(.selection-tile-module_selectionTileDisableHoverStyle__EipWL) {
  background-color: #e5f0ff;
  cursor: pointer;
}
.selection-tile-module_selectionTile__xSYpK:focus-visible {
  outline: 2px solid #006aff;
  outline-offset: 2px;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_contentWrapper__NTGf5 {
  display: flex;
  gap: 8px;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=radio-button-module_container] {
  display: block;
  padding: 1px;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=radio-button-module_container]:focus-visible, .selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=radio-button-module_container]:focus-within {
  outline: none;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=checkbox-module_checkbox__input-container] {
  display: block;
  padding: 1px;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=checkbox-module_checkbox__input-container] [class*=checkbox-module_checkbox__input] {
  margin-top: 1px;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=checkbox-module_checkbox__input-container]:focus-visible, .selection-tile-module_selectionTile__xSYpK .selection-tile-module_inputs__tze-R [class*=checkbox-module_checkbox__input-container]:focus-within {
  outline: none;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_hiddenInputs__FTGQP {
  display: none;
}
.selection-tile-module_selectionTile__xSYpK .selection-tile-module_content__XdpIO {
  flex: 1;
}

.selection-tile-module_selectionTileError__wkwU4 {
  box-shadow: inset 0 0 0 1px #d71717;
}
.selection-tile-module_selectionTileError__wkwU4:hover {
  background-color: #ffffff;
}

.selection-tile-module_selectionTileChecked__IwIJo:not(.selection-tile-module_selectionTileDisabled__h339m) {
  border: 2px solid #006aff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.0509803922);
}

.selection-tile-module_selectionTileCheckedError__J-aXV {
  border: 2px solid #d71717;
  box-shadow: none;
}

.selection-tile-module_selectionTileDisabled__h339m {
  box-shadow: inset 0 0 0 1px #adbfd9;
  cursor: not-allowed;
}
.selection-tile-module_selectionTileDisabled__h339m:hover {
  background-color: #ffffff;
  cursor: default;
}

.selection-tile-module_selectionTileDisabled__h339m.selection-tile-module_selectionTileChecked__IwIJo {
  border: 2px solid #adbfd9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.0509803922);
}.slider-with-inputs-module_container__sihL0 {
  display: flex;
  flex-direction: column;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_label__8JATr {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_slider__dpgWu {
  margin-top: 8px;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_inputsContainer__FJkyH {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  margin-top: 8px;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_inputsContainer__FJkyH .slider-with-inputs-module_input__gI1VA.slider-with-inputs-module_large__bZz5b {
  width: 100px;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_inputsContainer__FJkyH .slider-with-inputs-module_input__gI1VA.slider-with-inputs-module_medium__u55Ee {
  width: 50px;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_inputsContainer__FJkyH .slider-with-inputs-module_input__gI1VA.slider-with-inputs-module_small__rOFCJ {
  width: 30px;
}
.slider-with-inputs-module_container__sihL0 .slider-with-inputs-module_error__gcmFV {
  color: #d71717;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 16px;
  letter-spacing: normal;
  margin-top: 4px;
}
.slider-with-inputs-module_container__sihL0.slider-with-inputs-module_error__gcmFV .slider-with-inputs-module_label__8JATr {
  color: #d71717;
}
.slider-with-inputs-module_container__sihL0.slider-with-inputs-module_disabled__-M4LD .slider-with-inputs-module_label__8JATr {
  color: #adbfd9;
}.sz-tabs-list {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  gap: 4px;
}
.sz-tabs-list .sz-tab {
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  border: 1px solid #d6d6d6;
  background-color: #ffffff;
  height: 44px;
  margin-bottom: -1px;
  border-radius: 8px 8px 0px 0px;
  background-color: #f5f5f5;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.sz-tabs-list .sz-tab__title {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: start;
}
.sz-tabs-list .sz-tab__description {
  color: #757575;
  font-size: 8px;
  line-height: 12px;
  font-style: normal;
  font-weight: 400;
  text-align: start;
}
.sz-tabs-list .sz-tab__additional-info {
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
  background-color: #ffffff;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
}
.sz-tabs-list .sz-tab--selected {
  border-bottom-color: transparent;
  background-color: #ffffff;
}
.sz-tabs-list .sz-tab--error {
  background-color: #fef6f6;
  border-color: #e54d42;
}
.sz-tabs-list .sz-tab--selected.sz-tab--error {
  border-bottom-color: transparent;
}`));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
import { jsx as jsx$1, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import React__default, { useState, useEffect, useRef, useMemo, createContext, useContext, useCallback, useImperativeHandle, useLayoutEffect as useLayoutEffect$1, Children, cloneElement, forwardRef, createElement, Component, useReducer, Fragment as Fragment$1, useId as useId$2, memo, isValidElement, version, createRef } from "react";
import { useReactTable, getExpandedRowModel, getPaginationRowModel, getSortedRowModel, getCoreRowModel, flexRender } from "@tanstack/react-table";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal, findDOMNode as findDOMNode$1 } from "react-dom";
import * as Progress from "@radix-ui/react-progress";
import { useFloating as useFloating$1, offset as offset$4, flip as flip$5, arrow as arrow$4, autoUpdate as autoUpdate$1, shift as shift$2 } from "@floating-ui/react-dom";
import * as RadixPopover from "@radix-ui/react-popover";
import * as ToggleGroup from "@radix-ui/react-toggle-group";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import * as RadixSlider from "@radix-ui/react-slider";
function ArrowDownIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "12",
      height: "8",
      viewBox: "0 0 12 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z",
          fill: "#00204D"
        }
      )
    }
  );
}
const accordionItem = "accordion-item-module_accordionItem__XDkKJ";
const headingWrapper = "accordion-item-module_headingWrapper__6M6lu";
const heading$1 = "accordion-item-module_heading__K6kSK";
const title$9 = "accordion-item-module_title__Y-E14";
const smallTitle = "accordion-item-module_smallTitle__Jv3NP";
const arrowDown = "accordion-item-module_arrowDown__KY2np";
const expanded$1 = "accordion-item-module_expanded__hyqbB";
const content$6 = "accordion-item-module_content__IgLsd";
const hidden$1 = "accordion-item-module_hidden__qWXem";
const withBottomBorder = "accordion-item-module_withBottomBorder__uL76T";
const disabled$8 = "accordion-item-module_disabled__ASCd0";
const styles$S = {
  accordionItem,
  headingWrapper,
  heading: heading$1,
  title: title$9,
  smallTitle,
  arrowDown,
  expanded: expanded$1,
  content: content$6,
  hidden: hidden$1,
  withBottomBorder,
  disabled: disabled$8
};
function r$1(e3) {
  var t3, f2, n2 = "";
  if ("string" == typeof e3 || "number" == typeof e3) n2 += e3;
  else if ("object" == typeof e3) if (Array.isArray(e3)) {
    var o2 = e3.length;
    for (t3 = 0; t3 < o2; t3++) e3[t3] && (f2 = r$1(e3[t3])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e3) e3[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e3, t3, f2 = 0, n2 = "", o2 = arguments.length; f2 < o2; f2++) (e3 = arguments[f2]) && (t3 = r$1(e3)) && (n2 && (n2 += " "), n2 += t3);
  return n2;
}
const AccordionItem = ({
  children,
  title: title2,
  id,
  withBottomBorder: withBottomBorder2,
  smallTitle: smallTitle2 = false,
  ariaLabel,
  opened = false,
  disabled: disabled2 = false,
  rightContent,
  onClick
}) => {
  const [expanded2, setExpanded] = useState(opened);
  const handleClick = () => {
    if (onClick) onClick();
    else setExpanded(!expanded2);
  };
  useEffect(() => {
    if (!onClick) return;
    setExpanded(opened);
  }, [opened, onClick]);
  const contentId = `accordion-item-content-${id}`;
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: clsx(
        styles$S.accordionItem,
        withBottomBorder2 && styles$S.withBottomBorder,
        disabled2 && styles$S.disabled
      ),
      "aria-disabled": disabled2,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$S.headingWrapper, children: [
          /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              "aria-controls": contentId,
              "aria-expanded": expanded2,
              className: styles$S.heading,
              onClick: handleClick,
              disabled: disabled2,
              "aria-disabled": disabled2,
              "aria-label": ariaLabel,
              children: [
                /* @__PURE__ */ jsx$1(
                  ArrowDownIcon,
                  {
                    className: clsx(expanded2 && styles$S.expanded, styles$S.arrowDown)
                  }
                ),
                /* @__PURE__ */ jsx$1("div", { className: clsx(styles$S.title, smallTitle2 && styles$S.smallTitle), children: title2 })
              ]
            }
          ),
          rightContent
        ] }),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            id: contentId,
            className: clsx(styles$S.content, !expanded2 && styles$S.hidden),
            children
          }
        )
      ]
    }
  );
};
const accordion = "accordion-module_accordion__mqGl-";
const styles$R = {
  accordion
};
function Accordion({ children }) {
  return /* @__PURE__ */ jsx$1("ul", { className: styles$R.accordion, children });
}
const container$a = "action-card-module_container__qAV6L";
const defaultCard = "action-card-module_defaultCard__TRtOb";
const icon$4 = "action-card-module_icon__7aarz";
const label$8 = "action-card-module_label__V-9YM";
const circle$2 = "action-card-module_circle__uOzlE";
const labelSection = "action-card-module_labelSection__-w3Ex";
const completedCard = "action-card-module_completedCard__AS3dt";
const activeCard = "action-card-module_activeCard__vgYpU";
const disabledCard = "action-card-module_disabledCard__5fl6w";
const circleBlue = "action-card-module_circleBlue__9L906";
const circleGreen = "action-card-module_circleGreen__GYUnr";
const circleActive = "action-card-module_circleActive__wFORv";
const styles$Q = {
  container: container$a,
  defaultCard,
  icon: icon$4,
  label: label$8,
  circle: circle$2,
  labelSection,
  completedCard,
  activeCard,
  disabledCard,
  circleBlue,
  circleGreen,
  circleActive
};
const Arrow$1 = () => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "24",
      height: "16",
      viewBox: "0 0 24 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M0 9.33333L18.8933 9.33333L14.12 14.12L16 16L24 8L16 0L14.12 1.88L18.8933 6.66667L0 6.66667V9.33333Z",
          fill: "#006AFF"
        }
      )
    }
  );
};
const Check = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_1_3075)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M12 21.56L6.43999 16L4.54666 17.88L12 25.3334L28 9.33337L26.12 7.45337L12 21.56Z",
            fill: "#007A6A"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_1_3075", children: /* @__PURE__ */ jsx$1("rect", { width: "32", height: "32", fill: "white" }) }) })
      ]
    }
  );
};
function ActionCard({
  label: label2,
  to,
  ariaLabel,
  alt,
  completed = false,
  active: active2 = false,
  disabled: disabled2 = false,
  icon: icon2,
  className,
  children,
  ...rest
}) {
  const url = disabled2 ? void 0 : to;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      href: url,
      tabIndex: 0,
      "aria-label": ariaLabel,
      className: clsx(
        styles$Q.container,
        !disabled2 && !completed && styles$Q.defaultCard,
        completed && styles$Q.completedCard,
        active2 && styles$Q.activeCard,
        disabled2 && styles$Q.disabledCard,
        className
      ),
      ...rest,
      children: [
        /* @__PURE__ */ jsxs("div", { children: [
          icon2 && /* @__PURE__ */ jsx$1("span", { className: styles$Q.icon, children: icon2 }),
          /* @__PURE__ */ jsxs("div", { className: styles$Q.labelSection, children: [
            /* @__PURE__ */ jsx$1("label", { className: styles$Q.label, children: label2 }),
            children
          ] })
        ] }),
        !disabled2 && /* @__PURE__ */ jsx$1(
          "div",
          {
            className: clsx(
              styles$Q.circle,
              completed ? styles$Q.circleGreen : styles$Q.circleBlue,
              active2 ? styles$Q.circleActive : ""
            ),
            children: completed ? /* @__PURE__ */ jsx$1(Check, {}) : /* @__PURE__ */ jsx$1(Arrow$1, {})
          }
        )
      ]
    }
  );
}
const wrapper$1 = "advanced-table-module_wrapper__0HaIg";
const header$7 = "advanced-table-module_header__Z9uZa";
const title$8 = "advanced-table-module_title__kO54z";
const headerActions = "advanced-table-module_headerActions__IV9EX";
const tableContainer$1 = "advanced-table-module_tableContainer__McS--";
const stickyHeader = "advanced-table-module_stickyHeader__l9a6f";
const table = "advanced-table-module_table__3eKRP";
const thead = "advanced-table-module_thead__PFCZ6";
const headerRow = "advanced-table-module_headerRow__-xZhJ";
const headerCell = "advanced-table-module_headerCell__8fkQy";
const sortable = "advanced-table-module_sortable__yIxZg";
const pinnedLeft = "advanced-table-module_pinnedLeft__ufL5v";
const pinnedRight = "advanced-table-module_pinnedRight__XOFS-";
const resizable = "advanced-table-module_resizable__MQzkI";
const resizer = "advanced-table-module_resizer__W4MqT";
const isResizing = "advanced-table-module_isResizing__L-wDP";
const headerCellContent = "advanced-table-module_headerCellContent__WSsKE";
const headerLabel = "advanced-table-module_headerLabel__V6-Gm";
const sortIcon = "advanced-table-module_sortIcon__jye0a";
const active$2 = "advanced-table-module_active__YMufi";
const expandCollapseButton = "advanced-table-module_expandCollapseButton__B3DWD";
const collapsableColumn = "advanced-table-module_collapsableColumn__hKfv3";
const row$2 = "advanced-table-module_row__beOpp";
const selected$3 = "advanced-table-module_selected__uoF-W";
const expanded = "advanced-table-module_expanded__a3kGU";
const columnMenu = "advanced-table-module_columnMenu__G3Olz";
const columnMenuButton = "advanced-table-module_columnMenuButton__U7yve";
const columnMenuDropdown = "advanced-table-module_columnMenuDropdown__G8-iN";
const columnMenuItem = "advanced-table-module_columnMenuItem__S-bRi";
const menuIcon = "advanced-table-module_menuIcon__QjBd-";
const tbody = "advanced-table-module_tbody__p4gXB";
const clickable = "advanced-table-module_clickable__gx0mv";
const cell$1 = "advanced-table-module_cell__WDT5X";
const expandedRow = "advanced-table-module_expandedRow__5-sDl";
const expandedContent = "advanced-table-module_expandedContent__-ULyl";
const emptyState = "advanced-table-module_emptyState__UJu8t";
const emptyIcon = "advanced-table-module_emptyIcon__8L-Ei";
const emptyText = "advanced-table-module_emptyText__A52Nm";
const loadingOverlay = "advanced-table-module_loadingOverlay__NDCaR";
const pagination$1 = "advanced-table-module_pagination__e9Yrw";
const paginationInfo = "advanced-table-module_paginationInfo__1HQuC";
const paginationControls = "advanced-table-module_paginationControls__ZnGLp";
const pageButton = "advanced-table-module_pageButton__RhxEp";
const pageSizeSelect = "advanced-table-module_pageSizeSelect__TbLJn";
const priorityMedium = "advanced-table-module_priorityMedium__EG3z6";
const priorityLow = "advanced-table-module_priorityLow__yd2NV";
const customizerButton = "advanced-table-module_customizerButton__W0sYU";
const customizerModal = "advanced-table-module_customizerModal__ZQitZ";
const customizerContent = "advanced-table-module_customizerContent__blhAD";
const customizerHeader = "advanced-table-module_customizerHeader__F60r7";
const customizerTitle = "advanced-table-module_customizerTitle__vYm45";
const customizerClose = "advanced-table-module_customizerClose__cETCu";
const columnList = "advanced-table-module_columnList__P5Gp-";
const columnItem = "advanced-table-module_columnItem__HNh1J";
const columnInfo = "advanced-table-module_columnInfo__pxw1l";
const dragHandle = "advanced-table-module_dragHandle__2sNNi";
const columnName = "advanced-table-module_columnName__O2snk";
const columnActions = "advanced-table-module_columnActions__G-UBu";
const pinButton = "advanced-table-module_pinButton__3wuCu";
const pinned = "advanced-table-module_pinned__5Fr4n";
const visibilityToggle = "advanced-table-module_visibilityToggle__pN98v";
const styles$P = {
  wrapper: wrapper$1,
  header: header$7,
  title: title$8,
  headerActions,
  tableContainer: tableContainer$1,
  stickyHeader,
  table,
  thead,
  headerRow,
  headerCell,
  sortable,
  pinnedLeft,
  pinnedRight,
  resizable,
  resizer,
  isResizing,
  headerCellContent,
  headerLabel,
  sortIcon,
  active: active$2,
  expandCollapseButton,
  collapsableColumn,
  row: row$2,
  selected: selected$3,
  expanded,
  columnMenu,
  columnMenuButton,
  columnMenuDropdown,
  columnMenuItem,
  menuIcon,
  tbody,
  clickable,
  cell: cell$1,
  expandedRow,
  expandedContent,
  emptyState,
  emptyIcon,
  emptyText,
  loadingOverlay,
  pagination: pagination$1,
  paginationInfo,
  paginationControls,
  pageButton,
  pageSizeSelect,
  priorityMedium,
  priorityLow,
  customizerButton,
  customizerModal,
  customizerContent,
  customizerHeader,
  customizerTitle,
  customizerClose,
  columnList,
  columnItem,
  columnInfo,
  dragHandle,
  columnName,
  columnActions,
  pinButton,
  pinned,
  visibilityToggle
};
const ColumnCustomizer = ({
  columns,
  columnVisibility,
  onVisibilityChange,
  columnPinning,
  onPinningChange,
  onClose
}) => {
  const [localVisibility, setLocalVisibility] = useState(columnVisibility);
  const [localPinning, setLocalPinning] = useState(
    columnPinning || { left: [], right: [] }
  );
  const handleVisibilityToggle = (columnId) => {
    const newVisibility = {
      ...localVisibility,
      [columnId]: !localVisibility[columnId]
    };
    setLocalVisibility(newVisibility);
    onVisibilityChange(newVisibility);
  };
  const handlePinToggle = (columnId, position2) => {
    if (!onPinningChange) return;
    const currentLeft = localPinning.left || [];
    const currentRight = localPinning.right || [];
    let newLeft = [...currentLeft];
    let newRight = [...currentRight];
    newLeft = newLeft.filter((id) => id !== columnId);
    newRight = newRight.filter((id) => id !== columnId);
    const isAlreadyPinned = position2 === "left" && currentLeft.includes(columnId) || position2 === "right" && currentRight.includes(columnId);
    if (!isAlreadyPinned) {
      if (position2 === "left") {
        newLeft.push(columnId);
      } else {
        newRight.push(columnId);
      }
    }
    const newPinning = { left: newLeft, right: newRight };
    setLocalPinning(newPinning);
    onPinningChange(newPinning);
  };
  const isPinned = (columnId, position2) => {
    const pins = position2 === "left" ? localPinning.left : localPinning.right;
    return pins?.includes(columnId) || false;
  };
  const isVisible2 = (columnId) => {
    return localVisibility[columnId] !== false;
  };
  return /* @__PURE__ */ jsx$1("div", { className: styles$P.customizerModal, onClick: onClose, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$P.customizerContent,
      onClick: (e3) => e3.stopPropagation(),
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$P.customizerHeader, children: [
          /* @__PURE__ */ jsx$1("h3", { className: styles$P.customizerTitle, children: "Customize Columns" }),
          /* @__PURE__ */ jsx$1("button", { className: styles$P.customizerClose, onClick: onClose, children: "×" })
        ] }),
        /* @__PURE__ */ jsx$1("ul", { className: styles$P.columnList, children: columns.map((column2) => {
          const columnId = String(
            column2.id || ("accessorKey" in column2 ? column2.accessorKey : "") || ""
          );
          if (!columnId) return null;
          return /* @__PURE__ */ jsxs("li", { className: styles$P.columnItem, children: [
            /* @__PURE__ */ jsxs("div", { className: styles$P.columnInfo, children: [
              /* @__PURE__ */ jsx$1("span", { className: styles$P.dragHandle, children: "☰" }),
              /* @__PURE__ */ jsx$1("span", { className: styles$P.columnName, children: typeof column2.header === "string" ? column2.header : columnId })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: styles$P.columnActions, children: [
              onPinningChange && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx$1(
                  "button",
                  {
                    className: `${styles$P.pinButton} ${isPinned(columnId, "left") ? styles$P.pinned : ""}`,
                    onClick: () => handlePinToggle(columnId, "left"),
                    title: "Pin to left",
                    children: "⇤"
                  }
                ),
                /* @__PURE__ */ jsx$1(
                  "button",
                  {
                    className: `${styles$P.pinButton} ${isPinned(columnId, "right") ? styles$P.pinned : ""}`,
                    onClick: () => handlePinToggle(columnId, "right"),
                    title: "Pin to right",
                    children: "⇥"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx$1(
                "input",
                {
                  type: "checkbox",
                  className: styles$P.visibilityToggle,
                  checked: isVisible2(columnId),
                  onChange: () => handleVisibilityToggle(columnId),
                  title: "Toggle visibility"
                }
              )
            ] })
          ] }, columnId);
        }) })
      ]
    }
  ) });
};
const ColumnHeaderMenu = ({
  columnId,
  columnName: columnName2,
  isPinned,
  onPinLeft,
  onPinRight,
  onUnpin
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  const handlePinLeft = (e3) => {
    e3.stopPropagation();
    onPinLeft();
    setIsOpen(false);
  };
  const handlePinRight = (e3) => {
    e3.stopPropagation();
    onPinRight();
    setIsOpen(false);
  };
  const handleUnpin = (e3) => {
    e3.stopPropagation();
    onUnpin();
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsxs("div", { className: styles$P.columnMenu, ref: menuRef, children: [
    /* @__PURE__ */ jsx$1(
      "button",
      {
        className: styles$P.columnMenuButton,
        onClick: (e3) => {
          e3.stopPropagation();
          setIsOpen(!isOpen);
        },
        "aria-label": `Column options for ${columnName2}`,
        title: "Column options",
        children: "⋮"
      }
    ),
    isOpen && /* @__PURE__ */ jsxs("div", { className: styles$P.columnMenuDropdown, children: [
      isPinned !== "left" && /* @__PURE__ */ jsxs(
        "button",
        {
          className: styles$P.columnMenuItem,
          onClick: handlePinLeft,
          children: [
            /* @__PURE__ */ jsx$1("span", { className: styles$P.menuIcon, children: "📌" }),
            "Pin to Left"
          ]
        }
      ),
      isPinned !== "right" && /* @__PURE__ */ jsxs(
        "button",
        {
          className: styles$P.columnMenuItem,
          onClick: handlePinRight,
          children: [
            /* @__PURE__ */ jsx$1("span", { className: styles$P.menuIcon, children: "📌" }),
            "Pin to Right"
          ]
        }
      ),
      isPinned && /* @__PURE__ */ jsxs(
        "button",
        {
          className: styles$P.columnMenuItem,
          onClick: handleUnpin,
          children: [
            /* @__PURE__ */ jsx$1("span", { className: styles$P.menuIcon, children: "📍" }),
            "Unpin"
          ]
        }
      )
    ] })
  ] });
};
function AdvancedTable({
  data,
  columns,
  title: title2,
  enableColumnPinning = false,
  initialPinnedColumns,
  enableColumnResizing = false,
  columnResizeMode = "onChange",
  enableColumnCustomization = false,
  enableResponsivePriority = false,
  enableSorting = true,
  initialSorting,
  sorting: controlledSorting,
  onSortingChange: controlledOnSortingChange,
  enablePagination = false,
  pageSizeOptions = [10, 20, 50, 100],
  initialPageSize = 20,
  enableRowSelection = false,
  onRowSelectionChange,
  onRowClick,
  emptyContent,
  loading: loading2 = false,
  className,
  dataTestId = "advanced-table",
  stickyHeader: stickyHeader2 = false,
  maxHeight,
  getRowClassName,
  enableExpanding = false,
  renderExpandedRow
}) {
  const [columnPinning, setColumnPinning] = useState(
    initialPinnedColumns || { left: [], right: [] }
  );
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnSizing, setColumnSizing] = useState({});
  const [sorting, setSorting] = useState(initialSorting || []);
  const [rowSelection, setRowSelection] = useState({});
  const [expanded2, setExpanded] = useState({});
  const [showCustomizer, setShowCustomizer] = useState(false);
  const [columnExpanded, setColumnExpanded] = useState({});
  const sortingState = controlledSorting !== void 0 ? controlledSorting : sorting;
  const onSortingChange = controlledOnSortingChange !== void 0 ? controlledOnSortingChange : setSorting;
  const getChildColumns = useMemo(() => {
    const childMap = {};
    columns.forEach((col) => {
      const advCol = col;
      const parentId = advCol.parentColumnId;
      if (parentId) {
        if (!childMap[parentId]) {
          childMap[parentId] = [];
        }
        childMap[parentId].push(col);
      }
    });
    return childMap;
  }, [columns]);
  const isParentColumn = (columnId) => {
    return !!getChildColumns[columnId]?.length;
  };
  const getParentColumnId = (columnId) => {
    const column2 = columns.find((col) => col.id === columnId);
    return column2?.parentColumnId;
  };
  React__default.useEffect(() => {
    const initialExpandedState = {};
    columns.forEach((col) => {
      const advCol = col;
      if (advCol.id && isParentColumn(advCol.id)) {
        initialExpandedState[advCol.id] = advCol.initialExpanded ?? false;
      }
    });
    setColumnExpanded(initialExpandedState);
  }, []);
  React__default.useEffect(() => {
    const initialVisibility = {};
    columns.forEach((col) => {
      const advCol = col;
      if (advCol.parentColumnId && advCol.id) {
        const isParentExpanded = columnExpanded[advCol.parentColumnId] ?? false;
        initialVisibility[advCol.id] = isParentExpanded;
      }
    });
    setColumnVisibility((prev2) => ({ ...prev2, ...initialVisibility }));
  }, [columns, columnExpanded]);
  const processedColumns = useMemo(() => {
    const reorderedColumns = [];
    const childColumnsMap = {};
    columns.forEach((col) => {
      const parentId = col.parentColumnId;
      if (parentId) {
        if (!childColumnsMap[parentId]) {
          childColumnsMap[parentId] = [];
        }
        childColumnsMap[parentId].push(col);
      }
    });
    columns.forEach((col) => {
      const colId = col.id;
      const isChild = col.parentColumnId;
      if (isChild) return;
      reorderedColumns.push(col);
      if (colId && childColumnsMap[colId]) {
        reorderedColumns.push(...childColumnsMap[colId]);
      }
    });
    const finalColumns = reorderedColumns.map((col) => {
      if (!enableResponsivePriority) return col;
      const priority = col.priority;
      const meta = {
        ...col.meta,
        className: priority ? `${col.meta?.className || ""} ${priority === "medium" ? styles$P.priorityMedium : ""} ${priority === "low" ? styles$P.priorityLow : ""}` : col.meta?.className
      };
      return { ...col, meta };
    });
    return finalColumns;
  }, [columns, enableResponsivePriority]);
  const table2 = useReactTable({
    data,
    columns: processedColumns,
    state: {
      ...enableColumnPinning && { columnPinning },
      columnVisibility,
      ...enableColumnResizing && { columnSizing },
      sorting: sortingState,
      ...enableRowSelection && { rowSelection },
      ...enableExpanding && { expanded: expanded2 }
    },
    onColumnPinningChange: enableColumnPinning ? setColumnPinning : void 0,
    onColumnVisibilityChange: setColumnVisibility,
    onColumnSizingChange: enableColumnResizing ? setColumnSizing : void 0,
    onSortingChange: enableSorting ? onSortingChange : void 0,
    onRowSelectionChange: enableRowSelection ? setRowSelection : void 0,
    onExpandedChange: enableExpanding ? setExpanded : void 0,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: enableSorting ? getSortedRowModel() : void 0,
    getPaginationRowModel: enablePagination ? getPaginationRowModel() : void 0,
    getExpandedRowModel: enableExpanding ? getExpandedRowModel() : void 0,
    enableColumnPinning,
    enableColumnResizing,
    columnResizeMode,
    enableSorting,
    enableRowSelection,
    enableExpanding,
    initialState: {
      pagination: enablePagination ? { pageSize: initialPageSize, pageIndex: 0 } : void 0
    }
  });
  const getColumnStyle = (columnId, isPinned, isChildColumn = false, parentColumnId) => {
    if (!enableColumnPinning) return {};
    const headerGroups = table2.getHeaderGroups();
    if (isChildColumn && parentColumnId) {
      const parentPinnedLeft = columnPinning.left?.includes(parentColumnId);
      const parentPinnedRight = columnPinning.right?.includes(parentColumnId);
      if (parentPinnedLeft) {
        const parentPinnedColumns = columnPinning.left || [];
        const parentIndex = parentPinnedColumns.indexOf(parentColumnId);
        let offset22 = 0;
        for (let i3 = 0; i3 <= parentIndex; i3++) {
          const colId = parentPinnedColumns[i3];
          for (const headerGroup of headerGroups) {
            const header2 = headerGroup.headers.find((h4) => h4.id === colId);
            if (header2) {
              offset22 += header2.getSize();
              break;
            }
          }
        }
        return { left: `${offset22}px` };
      } else if (parentPinnedRight) {
        const parentPinnedColumns = columnPinning.right || [];
        const parentIndex = parentPinnedColumns.indexOf(parentColumnId);
        let offset22 = 0;
        for (let i3 = parentPinnedColumns.length - 1; i3 >= parentIndex; i3--) {
          const colId = parentPinnedColumns[i3];
          for (const headerGroup of headerGroups) {
            const header2 = headerGroup.headers.find((h4) => h4.id === colId);
            if (header2) {
              offset22 += header2.getSize();
              break;
            }
          }
        }
        return { right: `${offset22}px` };
      }
    }
    if (!isPinned) return {};
    const pinnedColumns = isPinned === "left" ? columnPinning.left || [] : columnPinning.right || [];
    const columnIndex = pinnedColumns.indexOf(columnId);
    if (columnIndex === -1) return {};
    let offset3 = 0;
    if (isPinned === "left") {
      for (let i3 = 0; i3 < columnIndex; i3++) {
        const prevColumnId = pinnedColumns[i3];
        for (const headerGroup of headerGroups) {
          const header2 = headerGroup.headers.find((h4) => h4.id === prevColumnId);
          if (header2) {
            offset3 += header2.getSize();
            break;
          }
        }
      }
      return { left: `${offset3}px` };
    } else {
      for (let i3 = pinnedColumns.length - 1; i3 > columnIndex; i3--) {
        const nextColumnId = pinnedColumns[i3];
        for (const headerGroup of headerGroups) {
          const header2 = headerGroup.headers.find((h4) => h4.id === nextColumnId);
          if (header2) {
            offset3 += header2.getSize();
            break;
          }
        }
      }
      return { right: `${offset3}px` };
    }
  };
  const handlePinColumn = (columnId, position2) => {
    if (!enableColumnPinning) return;
    setColumnPinning((prev2) => {
      const newPinning = { ...prev2 };
      newPinning.left = (prev2.left || []).filter((id) => id !== columnId);
      newPinning.right = (prev2.right || []).filter((id) => id !== columnId);
      if (position2 === "left") {
        newPinning.left = [...newPinning.left, columnId];
      } else {
        newPinning.right = [...newPinning.right, columnId];
      }
      return newPinning;
    });
  };
  const handleUnpinColumn = (columnId) => {
    if (!enableColumnPinning) return;
    setColumnPinning((prev2) => ({
      left: (prev2.left || []).filter((id) => id !== columnId),
      right: (prev2.right || []).filter((id) => id !== columnId)
    }));
  };
  const handleToggleColumnExpand = (columnId) => {
    setColumnExpanded((prev2) => {
      const newExpanded = { ...prev2, [columnId]: !prev2[columnId] };
      const childCols = getChildColumns[columnId] || [];
      const newVisibility = {};
      childCols.forEach((childCol) => {
        const childId = childCol.id;
        if (childId) {
          newVisibility[childId] = newExpanded[columnId];
        }
      });
      setColumnVisibility((prevVis) => ({ ...prevVis, ...newVisibility }));
      if (enableColumnPinning) {
        const childIds = childCols.map((col) => col.id).filter(Boolean);
        setColumnPinning((prevPinning) => ({
          left: (prevPinning.left || []).filter((id) => !childIds.includes(id)),
          right: (prevPinning.right || []).filter((id) => !childIds.includes(id))
        }));
      }
      return newExpanded;
    });
  };
  React__default.useEffect(() => {
    if (enableRowSelection && onRowSelectionChange) {
      const selectedRows = table2.getSelectedRowModel().rows.map((row2) => row2.original);
      onRowSelectionChange(selectedRows);
    }
  }, [rowSelection, enableRowSelection, onRowSelectionChange, table2]);
  const containerStyle2 = maxHeight ? { "--table-max-height": typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight } : void 0;
  return /* @__PURE__ */ jsxs("div", { className: `${styles$P.wrapper} ${className || ""}`, "data-testid": dataTestId, children: [
    (title2 || enableColumnCustomization) && /* @__PURE__ */ jsxs("div", { className: styles$P.header, children: [
      title2 && /* @__PURE__ */ jsx$1("h2", { className: styles$P.title, children: title2 }),
      /* @__PURE__ */ jsx$1("div", { className: styles$P.headerActions, children: enableColumnCustomization && /* @__PURE__ */ jsxs(
        "button",
        {
          className: styles$P.customizerButton,
          onClick: () => setShowCustomizer(true),
          "aria-label": "Customize columns",
          children: [
            /* @__PURE__ */ jsx$1("span", { children: "⚙" }),
            "Customize Columns"
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${styles$P.tableContainer} ${stickyHeader2 ? styles$P.stickyHeader : ""}`,
        style: containerStyle2,
        children: [
          loading2 && /* @__PURE__ */ jsx$1("div", { className: styles$P.loadingOverlay, children: /* @__PURE__ */ jsx$1("div", { children: "Loading..." }) }),
          /* @__PURE__ */ jsxs("table", { className: styles$P.table, children: [
            /* @__PURE__ */ jsx$1("thead", { className: styles$P.thead, children: table2.getHeaderGroups().map((headerGroup) => {
              const allHeaders = headerGroup.headers;
              const finalHeaders = [];
              const processedChildIds = /* @__PURE__ */ new Set();
              allHeaders.forEach((header2) => {
                const parentId = getParentColumnId(header2.id);
                if (parentId && columnExpanded[parentId]) {
                  return;
                }
                finalHeaders.push(header2);
                if (isParentColumn(header2.id) && columnExpanded[header2.id]) {
                  const children = allHeaders.filter((h4) => {
                    const childParentId = getParentColumnId(h4.id);
                    return childParentId === header2.id && !processedChildIds.has(h4.id);
                  });
                  children.forEach((child) => processedChildIds.add(child.id));
                  finalHeaders.push(...children);
                }
              });
              return /* @__PURE__ */ jsx$1("tr", { className: styles$P.headerRow, children: finalHeaders.map((header2) => {
                const isPinned = header2.column.getIsPinned();
                const canSort = header2.column.getCanSort();
                const isSorted = header2.column.getIsSorted();
                const canResize = header2.column.getCanResize();
                const isExpanded = isParentColumn(header2.id) && columnExpanded[header2.id];
                const parentId = getParentColumnId(header2.id);
                const hasExpandedParent = parentId && columnExpanded[parentId];
                const isCollapsableColumn = isExpanded || hasExpandedParent;
                const parentPinnedLeft = hasExpandedParent && columnPinning.left?.includes(parentId);
                const parentPinnedRight = hasExpandedParent && columnPinning.right?.includes(parentId);
                const effectiveIsPinned = isPinned !== false ? isPinned : parentPinnedLeft ? "left" : parentPinnedRight ? "right" : false;
                return /* @__PURE__ */ jsxs(
                  "th",
                  {
                    className: `${styles$P.headerCell} ${canSort ? styles$P.sortable : ""} ${effectiveIsPinned === "left" ? styles$P.pinnedLeft : ""} ${effectiveIsPinned === "right" ? styles$P.pinnedRight : ""} ${canResize ? styles$P.resizable : ""} ${isCollapsableColumn ? styles$P.collapsableColumn : ""} ${header2.column.columnDef.meta?.className || ""}`,
                    style: {
                      ...getColumnStyle(header2.id, isPinned, hasExpandedParent || false, parentId),
                      width: `${header2.getSize()}px`
                    },
                    onClick: canSort ? header2.column.getToggleSortingHandler() : void 0,
                    children: [
                      header2.isPlaceholder ? null : /* @__PURE__ */ jsxs("div", { className: styles$P.headerCellContent, children: [
                        /* @__PURE__ */ jsxs("span", { className: styles$P.headerLabel, children: [
                          flexRender(
                            header2.column.columnDef.header,
                            header2.getContext()
                          ),
                          isParentColumn(header2.id) && /* @__PURE__ */ jsx$1(
                            "button",
                            {
                              className: styles$P.expandCollapseButton,
                              onClick: (e3) => {
                                e3.stopPropagation();
                                handleToggleColumnExpand(header2.id);
                              },
                              "aria-label": columnExpanded[header2.id] ? "Collapse column" : "Expand column",
                              children: columnExpanded[header2.id] ? "−" : "+"
                            }
                          ),
                          canSort && /* @__PURE__ */ jsx$1(
                            "span",
                            {
                              className: `${styles$P.sortIcon} ${isSorted ? styles$P.active : ""}`,
                              children: isSorted === "asc" ? "↑" : isSorted === "desc" ? "↓" : "↕"
                            }
                          )
                        ] }),
                        enableColumnPinning && header2.id !== "select" && /* @__PURE__ */ jsx$1(
                          ColumnHeaderMenu,
                          {
                            columnId: header2.id,
                            columnName: typeof header2.column.columnDef.header === "string" ? header2.column.columnDef.header : header2.id,
                            isPinned,
                            onPinLeft: () => handlePinColumn(header2.id, "left"),
                            onPinRight: () => handlePinColumn(header2.id, "right"),
                            onUnpin: () => handleUnpinColumn(header2.id)
                          }
                        )
                      ] }),
                      canResize && /* @__PURE__ */ jsx$1(
                        "div",
                        {
                          onMouseDown: header2.getResizeHandler(),
                          onTouchStart: header2.getResizeHandler(),
                          className: `${styles$P.resizer} ${header2.column.getIsResizing() ? styles$P.isResizing : ""}`
                        }
                      )
                    ]
                  },
                  header2.id
                );
              }) }, headerGroup.id);
            }) }),
            /* @__PURE__ */ jsx$1("tbody", { className: styles$P.tbody, children: table2.getRowModel().rows.length === 0 ? /* @__PURE__ */ jsx$1("tr", { children: /* @__PURE__ */ jsx$1("td", { colSpan: table2.getAllColumns().length, children: /* @__PURE__ */ jsxs("div", { className: styles$P.emptyState, children: [
              /* @__PURE__ */ jsx$1("div", { className: styles$P.emptyIcon, children: "📋" }),
              /* @__PURE__ */ jsx$1("div", { className: styles$P.emptyText, children: emptyContent || "No data available" })
            ] }) }) }) : table2.getRowModel().rows.map((row2) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
              /* @__PURE__ */ jsx$1(
                "tr",
                {
                  className: `${styles$P.row} ${onRowClick ? styles$P.clickable : ""} ${enableRowSelection && row2.getIsSelected() ? styles$P.selected : ""} ${enableExpanding && row2.getIsExpanded() ? styles$P.expanded : ""} ${getRowClassName ? getRowClassName(row2) : ""}`,
                  onClick: () => onRowClick?.(row2),
                  children: (() => {
                    const allCells = row2.getVisibleCells();
                    const finalCells = [];
                    const processedChildIds = /* @__PURE__ */ new Set();
                    allCells.forEach((cell2) => {
                      const parentId = getParentColumnId(cell2.column.id);
                      if (parentId && columnExpanded[parentId]) {
                        return;
                      }
                      finalCells.push(cell2);
                      if (isParentColumn(cell2.column.id) && columnExpanded[cell2.column.id]) {
                        const children = allCells.filter((c3) => {
                          const childParentId = getParentColumnId(c3.column.id);
                          return childParentId === cell2.column.id && !processedChildIds.has(c3.column.id);
                        });
                        children.forEach((child) => processedChildIds.add(child.column.id));
                        finalCells.push(...children);
                      }
                    });
                    return finalCells;
                  })().map((cell2) => {
                    const isPinned = cell2.column.getIsPinned();
                    const cellIsExpanded = isParentColumn(cell2.column.id) && columnExpanded[cell2.column.id];
                    const cellParentId = getParentColumnId(cell2.column.id);
                    const cellHasExpandedParent = cellParentId && columnExpanded[cellParentId];
                    const cellIsCollapsable = cellIsExpanded || cellHasExpandedParent;
                    const cellParentPinnedLeft = cellHasExpandedParent && columnPinning.left?.includes(cellParentId);
                    const cellParentPinnedRight = cellHasExpandedParent && columnPinning.right?.includes(cellParentId);
                    const cellEffectiveIsPinned = isPinned !== false ? isPinned : cellParentPinnedLeft ? "left" : cellParentPinnedRight ? "right" : false;
                    return /* @__PURE__ */ jsx$1(
                      "td",
                      {
                        className: `${styles$P.cell} ${cellEffectiveIsPinned === "left" ? styles$P.pinnedLeft : ""} ${cellEffectiveIsPinned === "right" ? styles$P.pinnedRight : ""} ${cellIsCollapsable ? styles$P.collapsableColumn : ""} ${cell2.column.columnDef.meta?.className || ""}`,
                        style: {
                          ...getColumnStyle(cell2.column.id, isPinned, cellHasExpandedParent || false, cellParentId),
                          width: `${cell2.column.getSize()}px`
                        },
                        children: flexRender(cell2.column.columnDef.cell, cell2.getContext())
                      },
                      cell2.id
                    );
                  })
                }
              ),
              enableExpanding && row2.getIsExpanded() && renderExpandedRow && /* @__PURE__ */ jsx$1("tr", { className: styles$P.expandedRow, children: /* @__PURE__ */ jsx$1("td", { colSpan: row2.getVisibleCells().length, children: /* @__PURE__ */ jsx$1("div", { className: styles$P.expandedContent, children: renderExpandedRow(row2) }) }) })
            ] }, row2.id)) })
          ] })
        ]
      }
    ),
    enablePagination && table2.getPageCount() > 0 && /* @__PURE__ */ jsxs("div", { className: styles$P.pagination, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$P.paginationInfo, children: [
        "Showing ",
        table2.getRowModel().rows.length,
        " of ",
        table2.getFilteredRowModel().rows.length,
        " results"
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles$P.paginationControls, children: [
        /* @__PURE__ */ jsx$1(
          "button",
          {
            className: styles$P.pageButton,
            onClick: () => table2.setPageIndex(0),
            disabled: !table2.getCanPreviousPage(),
            children: "««"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "button",
          {
            className: styles$P.pageButton,
            onClick: () => table2.previousPage(),
            disabled: !table2.getCanPreviousPage(),
            children: "«"
          }
        ),
        /* @__PURE__ */ jsxs("span", { style: { margin: "0 8px" }, children: [
          "Page ",
          table2.getState().pagination.pageIndex + 1,
          " of",
          " ",
          table2.getPageCount()
        ] }),
        /* @__PURE__ */ jsx$1(
          "button",
          {
            className: styles$P.pageButton,
            onClick: () => table2.nextPage(),
            disabled: !table2.getCanNextPage(),
            children: "»"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "button",
          {
            className: styles$P.pageButton,
            onClick: () => table2.setPageIndex(table2.getPageCount() - 1),
            disabled: !table2.getCanNextPage(),
            children: "»»"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "select",
          {
            className: styles$P.pageSizeSelect,
            value: table2.getState().pagination.pageSize,
            onChange: (e3) => table2.setPageSize(Number(e3.target.value)),
            children: pageSizeOptions.map((size) => /* @__PURE__ */ jsxs("option", { value: size, children: [
              size,
              " per page"
            ] }, size))
          }
        )
      ] })
    ] }),
    showCustomizer && /* @__PURE__ */ jsx$1(
      ColumnCustomizer,
      {
        columns: processedColumns,
        columnVisibility,
        onVisibilityChange: setColumnVisibility,
        columnPinning: enableColumnPinning ? columnPinning : void 0,
        onPinningChange: enableColumnPinning ? setColumnPinning : void 0,
        onClose: () => setShowCustomizer(false)
      }
    )
  ] });
}
const avatar = "avatar-module_avatar__gw6mG";
const decorative = "avatar-module_decorative__CwlP8";
const colorCodedByOrder = "avatar-module_colorCodedByOrder__9FI9R";
const blue = "avatar-module_blue__HGIn3";
const green = "avatar-module_green__ee9-J";
const red = "avatar-module_red__DXBKl";
const yellow = "avatar-module_yellow__JBAVp";
const purple = "avatar-module_purple__XZfhx";
const badge$1 = "avatar-module_badge__dk1pc";
const styles$O = {
  avatar,
  "avatar--active": "avatar-module_avatar--active__X6g7j",
  decorative,
  colorCodedByOrder,
  "avatar--size-small": "avatar-module_avatar--size-small__VWN85",
  "avatar--size-large": "avatar-module_avatar--size-large__ZnKyv",
  "avatar--color-by-order-0": "avatar-module_avatar--color-by-order-0__B86MS",
  "avatar--color-by-order-1": "avatar-module_avatar--color-by-order-1__Olh2W",
  "avatar--color-by-order-2": "avatar-module_avatar--color-by-order-2__uJKcT",
  "avatar--color-by-order-3": "avatar-module_avatar--color-by-order-3__yrlXy",
  "avatar--color-by-order-4": "avatar-module_avatar--color-by-order-4__-4Tu1",
  "avatar--color-by-order-5": "avatar-module_avatar--color-by-order-5__YPrFR",
  blue,
  green,
  red,
  yellow,
  purple,
  badge: badge$1
};
const min$3 = Math.min;
const max$3 = Math.max;
const round$2 = Math.round;
const floor$1 = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp(start2, value2, end2) {
  return max$3(start2, min$3(value2, end2));
}
function evaluate(value2, param) {
  return typeof value2 === "function" ? value2(param) : value2;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length2 = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement$1(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement$1(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement$1(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect$1(rect) {
  const {
    x: x3,
    y: y3,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y3,
    left: x3,
    right: x3 + width,
    bottom: y3 + height,
    x: x3,
    y: y3
  };
}
function computeCoordsFromPlacement(_ref3, placement, rtl) {
  let {
    reference: reference2,
    floating
  } = _ref3;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference2.x + reference2.width / 2 - floating.width / 2;
  const commonY = reference2.y + reference2.height / 2 - floating.height / 2;
  const commonAlign = reference2[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference2.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case "right":
      coords = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference2.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference2.x,
        y: reference2.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
async function detectOverflow$1(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x3,
    y: y3,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect$1(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x3,
    y: y3,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect$1(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const MAX_RESET_COUNT = 50;
const computePosition$1 = async (reference2, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config;
  const platformWithDetectOverflow = platform2.detectOverflow ? platform2 : {
    ...platform2,
    detectOverflow: detectOverflow$1
  };
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference: reference2,
    floating,
    strategy
  });
  let {
    x: x3,
    y: y3
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i3 = 0; i3 < middleware2.length; i3++) {
    const currentMiddleware = middleware2[i3];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name: name2,
      fn: fn2
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn2({
      x: x3,
      y: y3,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference: reference2,
        floating
      }
    });
    x3 = nextX != null ? nextX : x3;
    y3 = nextY != null ? nextY : y3;
    middlewareData[name2] = {
      ...middlewareData[name2],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference: reference2,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x3,
          y: y3
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i3 = -1;
    }
  }
  return {
    x: x3,
    y: y3,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
const arrow$3 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x: x3,
      y: y3,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options2, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x3,
      y: y3
    };
    const axis = getAlignmentAxis(placement);
    const length2 = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length2] + rects.reference[axis] - coords[axis] - rects.floating[length2];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length2];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length2] / 2 - 1;
    const minPadding = min$3(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$3(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length2] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length2] / 2 + centerToReference;
    const offset3 = clamp(min$12, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset3 && rects.reference[length2] / 2 - (center < min$12 ? minPadding : maxPadding) - arrowDimensions[length2] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$12 ? center - min$12 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset3,
        centerOffset: center - offset3 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$4 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "flip",
    options: options2,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options2, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement$1(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d4) => getSideAxis(d4.placement) === initialSideAxis ? d4.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d4) => d4.overflows[0] <= 0).sort((a4, b3) => a4.overflows[1] - b3.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d4) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d4.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d4) => [d4.placement, d4.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a4, b3) => a4[1] - b3[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$3 = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x3,
        y: y3,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x3 + diffCoords.x,
        y: y3 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "shift",
    options: options2,
    async fn(state) {
      const {
        x: x3,
        y: y3,
        placement,
        platform: platform2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref3) => {
            let {
              x: x4,
              y: y4
            } = _ref3;
            return {
              x: x4,
              y: y4
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const coords = {
        x: x3,
        y: y3
      };
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x3,
          y: limitedCoords.y - y3,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName$1(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow$1(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement$1(node2) {
  var _ref3;
  return (_ref3 = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref3.documentElement;
}
function isNode(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof Node || value2 instanceof getWindow$1(value2).Node;
}
function isElement$1(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof Element || value2 instanceof getWindow$1(value2).Element;
}
function isHTMLElement$1(value2) {
  if (!hasWindow()) {
    return false;
  }
  return value2 instanceof HTMLElement || value2 instanceof getWindow$1(value2).HTMLElement;
}
function isShadowRoot$1(value2) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value2 instanceof ShadowRoot || value2 instanceof getWindow$1(value2).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement$1(element) {
  return /^(table|td|th)$/.test(getNodeName$1(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(":popover-open")) {
      return true;
    }
  } catch (_e2) {
  }
  try {
    return element.matches(":modal");
  } catch (_e2) {
    return false;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value2) => !!value2 && value2 !== "none";
let isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css5 = isElement$1(elementOrCss) ? getComputedStyle$2(elementOrCss) : elementOrCss;
  return isNotNone(css5.transform) || isNotNone(css5.translate) || isNotNone(css5.scale) || isNotNone(css5.rotate) || isNotNone(css5.perspective) || !isWebKit() && (isNotNone(css5.backdropFilter) || isNotNone(css5.filter)) || willChangeRe.test(css5.willChange || "") || containRe.test(css5.contain || "");
}
function getContainingBlock$1(element) {
  let currentNode = getParentNode$1(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode$1(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node2) {
  return /^(html|body|#document)$/.test(getNodeName$1(node2));
}
function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll$1(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode$1(node2) {
  if (getNodeName$1(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot$1(node2) && node2.host || // Fallback.
    getDocumentElement$1(node2)
  );
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode$1(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css5 = getComputedStyle$2(element);
  let width = parseFloat(css5.width) || 0;
  let height = parseFloat(css5.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round$2(width) !== offsetWidth || round$2(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement$1(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x3 = ($2 ? round$2(rect.width) : rect.width) / width;
  let y3 = ($2 ? round$2(rect.height) : rect.height) / height;
  if (!x3 || !Number.isFinite(x3)) {
    x3 = 1;
  }
  if (!y3 || !Number.isFinite(y3)) {
    y3 = 1;
  }
  return {
    x: x3,
    y: y3
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$1(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect$1(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x3 = (clientRect.left + visualOffsets.x) / scale.x;
  let y3 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css5 = getComputedStyle$2(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css5.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css5.paddingTop)) * iframeScale.y;
      x3 *= iframeScale.x;
      y3 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x3 += left2;
      y3 += top2;
      currentWin = getWindow$1(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect$1({
    width,
    height,
    x: x3,
    y: y3
  });
}
function getWindowScrollBarX$1(element, rect) {
  const leftScroll = getNodeScroll$1(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect$1(getDocumentElement$1(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll2) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x3 = htmlRect.left + scroll2.scrollLeft - getWindowScrollBarX$1(documentElement, htmlRect);
  const y3 = htmlRect.top + scroll2.scrollTop;
  return {
    x: x3,
    y: y3
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref3) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref3;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement$1(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll2 = getNodeScroll$1(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect$1(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll2) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll2.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll2.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect$1(element) {
  const html = getDocumentElement$1(element);
  const scroll2 = getNodeScroll$1(element);
  const body2 = element.ownerDocument.body;
  const width = max$3(html.scrollWidth, html.clientWidth, body2.scrollWidth, body2.clientWidth);
  const height = max$3(html.scrollHeight, html.clientHeight, body2.scrollHeight, body2.clientHeight);
  let x3 = -scroll2.scrollLeft + getWindowScrollBarX$1(element);
  const y3 = -scroll2.scrollTop;
  if (getComputedStyle$2(body2).direction === "rtl") {
    x3 += max$3(html.clientWidth, body2.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect$1(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement$1(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x3 = 0;
  let y3 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x3 = visualViewport.offsetLeft;
      y3 = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX$1(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body2 = doc.body;
    const bodyStyles = getComputedStyle(body2);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body2.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function getInnerBoundingClientRect$1(element, strategy) {
  const clientRect = getBoundingClientRect$1(element, true, strategy === "fixed");
  const top2 = clientRect.top + element.clientTop;
  const left2 = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x3 = left2 * scale.x;
  const y3 = top2 * scale.y;
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect$1(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect$1(getDocumentElement$1(element));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect$1(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect$1(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode$1(element);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement$1(el) && getNodeName$1(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode$1(element) : element;
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === "absolute" || currentContainingBlockComputedStyle.position === "fixed") || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode$1(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect$1(_ref3) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref3;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top2 = firstRect.top;
  let right2 = firstRect.right;
  let bottom2 = firstRect.bottom;
  let left2 = firstRect.left;
  for (let i3 = 1; i3 < clippingAncestors.length; i3++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i3], strategy);
    top2 = max$3(rect.top, top2);
    right2 = min$3(rect.right, right2);
    bottom2 = min$3(rect.bottom, bottom2);
    left2 = max$3(rect.left, left2);
  }
  return {
    width: right2 - left2,
    height: bottom2 - top2,
    x: left2,
    y: top2
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect$1(element, true, isFixed, offsetParent);
  let scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX$1(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll2 = getNodeScroll$1(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll2) : createCoords(0);
  const x3 = rect.left + scroll2.scrollLeft - offsets.x - htmlOffset.x;
  const y3 = rect.top + scroll2.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x3,
    y: y3,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$2(element).position === "static";
}
function getTrueOffsetParent$1(element, polyfill2) {
  if (!isHTMLElement$1(element) || getComputedStyle$2(element).position === "fixed") {
    return null;
  }
  if (polyfill2) {
    return polyfill2(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement$1(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent$2(element, polyfill2) {
  const win = getWindow$1(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement$1(element)) {
    let svgOffsetParent = getParentNode$1(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement$1(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode$1(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent$1(element, polyfill2);
  while (offsetParent && isTableElement$1(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent$1(offsetParent, polyfill2);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock$1(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent$2;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$2(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent: getOffsetParent$2,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
function rectsAreEqual(a4, b3) {
  return a4.x === b3.x && a4.y === b3.y && a4.width === b3.width && a4.height === b3.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement$1(element);
  function cleanup2() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup2();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left: left2,
      top: top2,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor$1(top2);
    const insetRight = floor$1(root2.clientWidth - (left2 + width));
    const insetBottom = floor$1(root2.clientHeight - (top2 + height));
    const insetLeft = floor$1(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max$3(0, min$3(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (_e2) {
      io = new IntersectionObserver(handleObserve, options2);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup2;
}
function autoUpdate(reference2, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference2);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating ? getOverflowAncestors(floating) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref3) => {
      let [firstEntry] = _ref3;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect$1(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect$1(reference2);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$2 = offset$3;
const shift = shift$1;
const flip$3 = flip$4;
const arrow$2 = arrow$3;
const computePosition = (reference2, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference2, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
function getAugmentedNamespace(n2) {
  if (Object.prototype.hasOwnProperty.call(n2, "__esModule")) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a4 = function a5() {
      var isInstance = false;
      try {
        isInstance = this instanceof a5;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a4.prototype = f2.prototype;
  } else a4 = {};
  Object.defineProperty(a4, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k3) {
    var d4 = Object.getOwnPropertyDescriptor(n2, k3);
    Object.defineProperty(a4, k3, d4.get ? d4 : {
      enumerable: true,
      get: function() {
        return n2[k3];
      }
    });
  });
  return a4;
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module) {
    (function() {
      var hasOwn2 = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i3 = 0; i3 < arguments.length; i3++) {
          var arg = arguments[i3];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn2.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value2, newClass) {
        if (!newClass) {
          return value2;
        }
        if (value2) {
          return value2 + " " + newClass;
        }
        return value2 + newClass;
      }
      if (module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const r = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var define_process_env_default$2 = {};
const h$2 = "react-tooltip-core-styles", w$3 = "react-tooltip-base-styles", b$1 = { core: false, base: false };
function S$1({ css: e22, id: t22 = w$3, type: o2 = "base", ref: r2 }) {
  var l2, n2;
  if (!e22 || "undefined" == typeof document || b$1[o2]) return;
  if ("core" === o2 && "undefined" != typeof process && (null === (l2 = null === process || void 0 === process ? void 0 : define_process_env_default$2) || void 0 === l2 ? void 0 : l2.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
  if ("base" !== o2 && "undefined" != typeof process && (null === (n2 = null === process || void 0 === process ? void 0 : define_process_env_default$2) || void 0 === n2 ? void 0 : n2.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  "core" === o2 && (t22 = h$2), r2 || (r2 = {});
  const { insertAt: c22 } = r2;
  if (document.getElementById(t22)) return void console.warn(`[react-tooltip] Element with id '${t22}' already exists. Call \`removeStyle()\` first`);
  const i22 = document.head || document.getElementsByTagName("head")[0], s22 = document.createElement("style");
  s22.id = t22, s22.type = "text/css", "top" === c22 && i22.firstChild ? i22.insertBefore(s22, i22.firstChild) : i22.appendChild(s22), s22.styleSheet ? s22.styleSheet.cssText = e22 : s22.appendChild(document.createTextNode(e22)), b$1[o2] = true;
}
const E = async ({ elementReference: e22 = null, tooltipReference: t22 = null, tooltipArrowReference: o2 = null, place: r2 = "top", offset: l2 = 10, strategy: n2 = "absolute", middlewares: c22 = [offset$2(Number(l2)), flip$3({ fallbackAxisSideDirection: "start" }), shift({ padding: 5 })], border: i22 }) => {
  if (!e22) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r2 };
  if (null === t22) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r2 };
  const s22 = c22;
  return o2 ? (s22.push(arrow$2({ element: o2, padding: 5 })), computePosition(e22, t22, { placement: r2, strategy: n2, middleware: s22 }).then((({ x: e3, y: t3, placement: o3, middlewareData: r3 }) => {
    var l3, n3;
    const c3 = { left: `${e3}px`, top: `${t3}px`, border: i22 }, { x: s32, y: a22 } = null !== (l3 = r3.arrow) && void 0 !== l3 ? l3 : { x: 0, y: 0 }, u22 = null !== (n3 = { top: "bottom", right: "left", bottom: "top", left: "right" }[o3.split("-")[0]]) && void 0 !== n3 ? n3 : "bottom", d22 = i22 && { borderBottom: i22, borderRight: i22 };
    let p2 = 0;
    if (i22) {
      const e4 = `${i22}`.match(/(\d+)px/);
      p2 = (null == e4 ? void 0 : e4[1]) ? Number(e4[1]) : 1;
    }
    return { tooltipStyles: c3, tooltipArrowStyles: { left: null != s32 ? `${s32}px` : "", top: null != a22 ? `${a22}px` : "", right: "", bottom: "", ...d22, [u22]: `-${4 + p2}px` }, place: o3 };
  }))) : computePosition(e22, t22, { placement: "bottom", strategy: n2, middleware: s22 }).then((({ x: e3, y: t3, placement: o3 }) => ({ tooltipStyles: { left: `${e3}px`, top: `${t3}px` }, tooltipArrowStyles: {}, place: o3 })));
}, A$1 = (e22, t22) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e22, t22), _$1 = (e22, t22, o2) => {
  let r2 = null;
  const l2 = function(...l3) {
    const n2 = () => {
      r2 = null;
    };
    !r2 && (e22.apply(this, l3), r2 = setTimeout(n2, t22));
  };
  return l2.cancel = () => {
    r2 && (clearTimeout(r2), r2 = null);
  }, l2;
}, O$1 = (e22) => null !== e22 && !Array.isArray(e22) && "object" == typeof e22, T$1 = (e22, t22) => {
  if (e22 === t22) return true;
  if (Array.isArray(e22) && Array.isArray(t22)) return e22.length === t22.length && e22.every(((e3, o3) => T$1(e3, t22[o3])));
  if (Array.isArray(e22) !== Array.isArray(t22)) return false;
  if (!O$1(e22) || !O$1(t22)) return e22 === t22;
  const o2 = Object.keys(e22), r2 = Object.keys(t22);
  return o2.length === r2.length && o2.every(((o3) => T$1(e22[o3], t22[o3])));
}, k = (e22) => {
  if (!(e22 instanceof HTMLElement || e22 instanceof SVGElement)) return false;
  const t22 = getComputedStyle(e22);
  return ["overflow", "overflow-x", "overflow-y"].some(((e3) => {
    const o2 = t22.getPropertyValue(e3);
    return "auto" === o2 || "scroll" === o2;
  }));
}, C = (e22) => {
  if (!e22) return null;
  let t22 = e22.parentElement;
  for (; t22; ) {
    if (k(t22)) return t22;
    t22 = t22.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, L = "undefined" != typeof window ? useLayoutEffect$1 : useEffect, R = "DEFAULT_TOOLTIP_ID", x = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, N = createContext({ getTooltipData: () => x });
function I$1(e22 = R) {
  return useContext(N).getTooltipData(e22);
}
var B = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, z = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const D$1 = ({ forwardRef: t22, id: r2, className: c22, classNameArrow: i22, variant: u22 = "dark", anchorId: d22, anchorSelect: p2, place: v2 = "top", offset: m22 = 10, events: h22 = ["hover"], openOnClick: w22 = false, positionStrategy: b22 = "absolute", middlewares: S22, wrapper: g2, delayShow: A2 = 0, delayHide: O22 = 0, float: k22 = false, hidden: R22 = false, noArrow: x22 = false, clickable: N2 = false, closeOnEsc: $2 = false, closeOnScroll: j2 = false, closeOnResize: D22 = false, openEvents: q22, closeEvents: H22, globalCloseEvents: M4, imperativeModeOnly: W2, style: P2, position: V2, afterShow: F2, afterHide: K2, content: U2, contentWrapperRef: X3, isOpen: Y3, defaultIsOpen: G3 = false, setIsOpen: Z2, activeAnchor: J2, setActiveAnchor: Q3, border: ee2, opacity: te, arrowColor: oe2, role: re2 = "tooltip" }) => {
  var le2;
  const ne2 = useRef(null), ce = useRef(null), ie = useRef(null), se2 = useRef(null), ae = useRef(null), [ue2, de2] = useState({ tooltipStyles: {}, tooltipArrowStyles: {}, place: v2 }), [pe2, ve2] = useState(false), [me2, fe2] = useState(false), [ye2, he2] = useState(null), we2 = useRef(false), be2 = useRef(null), { anchorRefs: Se2, setActiveAnchor: ge2 } = I$1(r2), Ee2 = useRef(false), [Ae2, _e2] = useState([]), Oe2 = useRef(false), Te2 = w22 || h22.includes("click"), ke2 = Te2 || (null == q22 ? void 0 : q22.click) || (null == q22 ? void 0 : q22.dblclick) || (null == q22 ? void 0 : q22.mousedown), Ce2 = q22 ? { ...q22 } : { mouseenter: true, focus: true, click: false, dblclick: false, mousedown: false };
  !q22 && Te2 && Object.assign(Ce2, { mouseenter: false, focus: false, click: true });
  const Le2 = H22 ? { ...H22 } : { mouseleave: true, blur: true, click: false, dblclick: false, mouseup: false };
  !H22 && Te2 && Object.assign(Le2, { mouseleave: false, blur: false });
  const Re2 = M4 ? { ...M4 } : { escape: $2 || false, scroll: j2 || false, resize: D22 || false, clickOutsideAnchor: ke2 || false };
  W2 && (Object.assign(Ce2, { mouseenter: false, focus: false, click: false, dblclick: false, mousedown: false }), Object.assign(Le2, { mouseleave: false, blur: false, click: false, dblclick: false, mouseup: false }), Object.assign(Re2, { escape: false, scroll: false, resize: false, clickOutsideAnchor: false })), L((() => (Oe2.current = true, () => {
    Oe2.current = false;
  })), []);
  const xe2 = (e22) => {
    Oe2.current && (e22 && fe2(true), setTimeout((() => {
      Oe2.current && (null == Z2 || Z2(e22), void 0 === Y3 && ve2(e22));
    }), 10));
  };
  useEffect((() => {
    if (void 0 === Y3) return () => null;
    Y3 && fe2(true);
    const e22 = setTimeout((() => {
      ve2(Y3);
    }), 10);
    return () => {
      clearTimeout(e22);
    };
  }), [Y3]), useEffect((() => {
    if (pe2 !== we2.current) if (ae.current && clearTimeout(ae.current), we2.current = pe2, pe2) null == F2 || F2();
    else {
      const e22 = ((e3) => {
        const t3 = e3.match(/^([\d.]+)(ms|s)$/);
        if (!t3) return 0;
        const [, o2, r3] = t3;
        return Number(o2) * ("ms" === r3 ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      ae.current = setTimeout((() => {
        fe2(false), he2(null), null == K2 || K2();
      }), e22 + 25);
    }
  }), [pe2]);
  const Ne2 = (e22) => {
    de2(((t3) => T$1(t3, e22) ? t3 : e22));
  }, $e2 = (e22 = A2) => {
    ie.current && clearTimeout(ie.current), me2 ? xe2(true) : ie.current = setTimeout((() => {
      xe2(true);
    }), e22);
  }, Ie2 = (e22 = O22) => {
    se2.current && clearTimeout(se2.current), se2.current = setTimeout((() => {
      Ee2.current || xe2(false);
    }), e22);
  }, je2 = (e22) => {
    var t3;
    if (!e22) return;
    const o2 = null !== (t3 = e22.currentTarget) && void 0 !== t3 ? t3 : e22.target;
    if (!(null == o2 ? void 0 : o2.isConnected)) return Q3(null), void ge2({ current: null });
    A2 ? $e2() : xe2(true), Q3(o2), ge2({ current: o2 }), se2.current && clearTimeout(se2.current);
  }, Be2 = () => {
    N2 ? Ie2(O22 || 100) : O22 ? Ie2() : xe2(false), ie.current && clearTimeout(ie.current);
  }, ze = ({ x: e22, y: t3 }) => {
    var o2;
    const r3 = { getBoundingClientRect: () => ({ x: e22, y: t3, width: 0, height: 0, top: t3, left: e22, right: e22, bottom: t3 }) };
    E({ place: null !== (o2 = null == ye2 ? void 0 : ye2.place) && void 0 !== o2 ? o2 : v2, offset: m22, elementReference: r3, tooltipReference: ne2.current, tooltipArrowReference: ce.current, strategy: b22, middlewares: S22, border: ee2 }).then(((e3) => {
      Ne2(e3);
    }));
  }, De2 = (e22) => {
    if (!e22) return;
    const t3 = e22, o2 = { x: t3.clientX, y: t3.clientY };
    ze(o2), be2.current = o2;
  }, qe2 = (e22) => {
    var t3;
    if (!pe2) return;
    const o2 = e22.target;
    if (!o2.isConnected) return;
    if (null === (t3 = ne2.current) || void 0 === t3 ? void 0 : t3.contains(o2)) return;
    [document.querySelector(`[id='${d22}']`), ...Ae2].some(((e3) => null == e3 ? void 0 : e3.contains(o2))) || (xe2(false), ie.current && clearTimeout(ie.current));
  }, He2 = _$1(je2, 50), Me2 = _$1(Be2, 50), We2 = (e22) => {
    Me2.cancel(), He2(e22);
  }, Pe2 = () => {
    He2.cancel(), Me2();
  }, Ve2 = useCallback((() => {
    var e22, t3;
    const o2 = null !== (e22 = null == ye2 ? void 0 : ye2.position) && void 0 !== e22 ? e22 : V2;
    o2 ? ze(o2) : k22 ? be2.current && ze(be2.current) : (null == J2 ? void 0 : J2.isConnected) && E({ place: null !== (t3 = null == ye2 ? void 0 : ye2.place) && void 0 !== t3 ? t3 : v2, offset: m22, elementReference: J2, tooltipReference: ne2.current, tooltipArrowReference: ce.current, strategy: b22, middlewares: S22, border: ee2 }).then(((e3) => {
      Oe2.current && Ne2(e3);
    }));
  }), [pe2, J2, U2, P2, v2, null == ye2 ? void 0 : ye2.place, m22, b22, V2, null == ye2 ? void 0 : ye2.position, k22]);
  useEffect((() => {
    var e22, t3;
    const o2 = new Set(Se2);
    Ae2.forEach(((e3) => {
      o2.add({ current: e3 });
    }));
    const r3 = document.querySelector(`[id='${d22}']`);
    r3 && o2.add({ current: r3 });
    const l2 = () => {
      xe2(false);
    }, n2 = C(J2), c3 = C(ne2.current);
    Re2.scroll && (window.addEventListener("scroll", l2), null == n2 || n2.addEventListener("scroll", l2), null == c3 || c3.addEventListener("scroll", l2));
    let i3 = null;
    Re2.resize ? window.addEventListener("resize", l2) : J2 && ne2.current && (i3 = autoUpdate(J2, ne2.current, Ve2, { ancestorResize: true, elementResize: true, layoutShift: true }));
    const s22 = (e3) => {
      "Escape" === e3.key && xe2(false);
    };
    Re2.escape && window.addEventListener("keydown", s22), Re2.clickOutsideAnchor && window.addEventListener("click", qe2);
    const a22 = [], u3 = (e3) => {
      pe2 && (null == e3 ? void 0 : e3.target) === J2 || je2(e3);
    }, p3 = (e3) => {
      pe2 && (null == e3 ? void 0 : e3.target) === J2 && Be2();
    }, v3 = ["mouseenter", "mouseleave", "focus", "blur"], m32 = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Ce2).forEach((([e3, t4]) => {
      t4 && (v3.includes(e3) ? a22.push({ event: e3, listener: We2 }) : m32.includes(e3) && a22.push({ event: e3, listener: u3 }));
    })), Object.entries(Le2).forEach((([e3, t4]) => {
      t4 && (v3.includes(e3) ? a22.push({ event: e3, listener: Pe2 }) : m32.includes(e3) && a22.push({ event: e3, listener: p3 }));
    })), k22 && a22.push({ event: "pointermove", listener: De2 });
    const y22 = () => {
      Ee2.current = true;
    }, h32 = () => {
      Ee2.current = false, Be2();
    };
    return N2 && !ke2 && (null === (e22 = ne2.current) || void 0 === e22 || e22.addEventListener("mouseenter", y22), null === (t3 = ne2.current) || void 0 === t3 || t3.addEventListener("mouseleave", h32)), a22.forEach((({ event: e3, listener: t4 }) => {
      o2.forEach(((o3) => {
        var r4;
        null === (r4 = o3.current) || void 0 === r4 || r4.addEventListener(e3, t4);
      }));
    })), () => {
      var e3, t4;
      Re2.scroll && (window.removeEventListener("scroll", l2), null == n2 || n2.removeEventListener("scroll", l2), null == c3 || c3.removeEventListener("scroll", l2)), Re2.resize ? window.removeEventListener("resize", l2) : null == i3 || i3(), Re2.clickOutsideAnchor && window.removeEventListener("click", qe2), Re2.escape && window.removeEventListener("keydown", s22), N2 && !ke2 && (null === (e3 = ne2.current) || void 0 === e3 || e3.removeEventListener("mouseenter", y22), null === (t4 = ne2.current) || void 0 === t4 || t4.removeEventListener("mouseleave", h32)), a22.forEach((({ event: e4, listener: t5 }) => {
        o2.forEach(((o3) => {
          var r4;
          null === (r4 = o3.current) || void 0 === r4 || r4.removeEventListener(e4, t5);
        }));
      }));
    };
  }), [J2, Ve2, me2, Se2, Ae2, q22, H22, M4, Te2, A2, O22]), useEffect((() => {
    var e22, t3;
    let o2 = null !== (t3 = null !== (e22 = null == ye2 ? void 0 : ye2.anchorSelect) && void 0 !== e22 ? e22 : p2) && void 0 !== t3 ? t3 : "";
    !o2 && r2 && (o2 = `[data-tooltip-id='${r2.replace(/'/g, "\\'")}']`);
    const l2 = new MutationObserver(((e3) => {
      const t4 = [], l3 = [];
      e3.forEach(((e4) => {
        if ("attributes" === e4.type && "data-tooltip-id" === e4.attributeName) {
          e4.target.getAttribute("data-tooltip-id") === r2 ? t4.push(e4.target) : e4.oldValue === r2 && l3.push(e4.target);
        }
        if ("childList" === e4.type) {
          if (J2) {
            const t5 = [...e4.removedNodes].filter(((e5) => 1 === e5.nodeType));
            if (o2) try {
              l3.push(...t5.filter(((e5) => e5.matches(o2)))), l3.push(...t5.flatMap(((e5) => [...e5.querySelectorAll(o2)])));
            } catch (e5) {
            }
            t5.some(((e5) => {
              var t6;
              return !!(null === (t6 = null == e5 ? void 0 : e5.contains) || void 0 === t6 ? void 0 : t6.call(e5, J2)) && (fe2(false), xe2(false), Q3(null), ie.current && clearTimeout(ie.current), se2.current && clearTimeout(se2.current), true);
            }));
          }
          if (o2) try {
            const r3 = [...e4.addedNodes].filter(((e5) => 1 === e5.nodeType));
            t4.push(...r3.filter(((e5) => e5.matches(o2)))), t4.push(...r3.flatMap(((e5) => [...e5.querySelectorAll(o2)])));
          } catch (e5) {
          }
        }
      })), (t4.length || l3.length) && _e2(((e4) => [...e4.filter(((e5) => !l3.includes(e5))), ...t4]));
    }));
    return l2.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-tooltip-id"], attributeOldValue: true }), () => {
      l2.disconnect();
    };
  }), [r2, p2, null == ye2 ? void 0 : ye2.anchorSelect, J2]), useEffect((() => {
    Ve2();
  }), [Ve2]), useEffect((() => {
    if (!(null == X3 ? void 0 : X3.current)) return () => null;
    const e22 = new ResizeObserver((() => {
      setTimeout((() => Ve2()));
    }));
    return e22.observe(X3.current), () => {
      e22.disconnect();
    };
  }), [U2, null == X3 ? void 0 : X3.current]), useEffect((() => {
    var e22;
    const t3 = document.querySelector(`[id='${d22}']`), o2 = [...Ae2, t3];
    J2 && o2.includes(J2) || Q3(null !== (e22 = Ae2[0]) && void 0 !== e22 ? e22 : t3);
  }), [d22, Ae2, J2]), useEffect((() => (G3 && xe2(true), () => {
    ie.current && clearTimeout(ie.current), se2.current && clearTimeout(se2.current);
  })), []), useEffect((() => {
    var e22;
    let t3 = null !== (e22 = null == ye2 ? void 0 : ye2.anchorSelect) && void 0 !== e22 ? e22 : p2;
    if (!t3 && r2 && (t3 = `[data-tooltip-id='${r2.replace(/'/g, "\\'")}']`), t3) try {
      const e3 = Array.from(document.querySelectorAll(t3));
      _e2(e3);
    } catch (e3) {
      _e2([]);
    }
  }), [r2, p2, null == ye2 ? void 0 : ye2.anchorSelect]), useEffect((() => {
    ie.current && (clearTimeout(ie.current), $e2(A2));
  }), [A2]);
  const Fe2 = null !== (le2 = null == ye2 ? void 0 : ye2.content) && void 0 !== le2 ? le2 : U2, Ke2 = pe2 && Object.keys(ue2.tooltipStyles).length > 0;
  return useImperativeHandle(t22, (() => ({ open: (e22) => {
    if (null == e22 ? void 0 : e22.anchorSelect) try {
      document.querySelector(e22.anchorSelect);
    } catch (t3) {
      return void console.warn(`[react-tooltip] "${e22.anchorSelect}" is not a valid CSS selector`);
    }
    he2(null != e22 ? e22 : null), (null == e22 ? void 0 : e22.delay) ? $e2(e22.delay) : xe2(true);
  }, close: (e22) => {
    (null == e22 ? void 0 : e22.delay) ? Ie2(e22.delay) : xe2(false);
  }, activeAnchor: J2, place: ue2.place, isOpen: Boolean(me2 && !R22 && Fe2 && Ke2) }))), me2 && !R22 && Fe2 ? React__default.createElement(g2, { id: r2, role: re2, className: r("react-tooltip", B.tooltip, z.tooltip, z[u22], c22, `react-tooltip__place-${ue2.place}`, B[Ke2 ? "show" : "closing"], Ke2 ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b22 && B.fixed, N2 && B.clickable), onTransitionEnd: (e22) => {
    ae.current && clearTimeout(ae.current), pe2 || "opacity" !== e22.propertyName || (fe2(false), he2(null), null == K2 || K2());
  }, style: { ...P2, ...ue2.tooltipStyles, opacity: void 0 !== te && Ke2 ? te : void 0 }, ref: ne2 }, Fe2, React__default.createElement(g2, { className: r("react-tooltip-arrow", B.arrow, z.arrow, i22, x22 && B.noArrow), style: { ...ue2.tooltipArrowStyles, background: oe2 ? `linear-gradient(to right bottom, transparent 50%, ${oe2} 50%)` : void 0 }, ref: ce })) : null;
}, q = ({ content: t22 }) => React__default.createElement("span", { dangerouslySetInnerHTML: { __html: t22 } }), H = React__default.forwardRef((({ id: t22, anchorId: r2, anchorSelect: n2, content: c22, html: i22, render: a22, className: u22, classNameArrow: d22, variant: p2 = "dark", place: v2 = "top", offset: m22 = 10, wrapper: f2 = "div", children: h22 = null, events: w22 = ["hover"], openOnClick: b22 = false, positionStrategy: S22 = "absolute", middlewares: g2, delayShow: E22 = 0, delayHide: _2 = 0, float: O22 = false, hidden: T22 = false, noArrow: k22 = false, clickable: C2 = false, closeOnEsc: L22 = false, closeOnScroll: R22 = false, closeOnResize: x22 = false, openEvents: N2, closeEvents: $2, globalCloseEvents: j2, imperativeModeOnly: B22 = false, style: z22, position: H22, isOpen: M4, defaultIsOpen: W2 = false, disableStyleInjection: P2 = false, border: V2, opacity: F2, arrowColor: K2, setIsOpen: U2, afterShow: X3, afterHide: Y3, role: G3 = "tooltip" }, Z2) => {
  const [J2, Q3] = useState(c22), [ee2, te] = useState(i22), [oe2, re2] = useState(v2), [le2, ne2] = useState(p2), [ce, ie] = useState(m22), [se2, ae] = useState(E22), [ue2, de2] = useState(_2), [pe2, ve2] = useState(O22), [me2, fe2] = useState(T22), [ye2, he2] = useState(f2), [we2, be2] = useState(w22), [Se2, ge2] = useState(S22), [Ee2, Ae2] = useState(null), [_e2, Oe2] = useState(null), Te2 = useRef(P2), { anchorRefs: ke2, activeAnchor: Ce2 } = I$1(t22), Le2 = (e22) => null == e22 ? void 0 : e22.getAttributeNames().reduce(((t3, o2) => {
    var r3;
    if (o2.startsWith("data-tooltip-")) {
      t3[o2.replace(/^data-tooltip-/, "")] = null !== (r3 = null == e22 ? void 0 : e22.getAttribute(o2)) && void 0 !== r3 ? r3 : null;
    }
    return t3;
  }), {}), Re2 = (e22) => {
    const t3 = { place: (e3) => {
      var t4;
      re2(null !== (t4 = e3) && void 0 !== t4 ? t4 : v2);
    }, content: (e3) => {
      Q3(null != e3 ? e3 : c22);
    }, html: (e3) => {
      te(null != e3 ? e3 : i22);
    }, variant: (e3) => {
      var t4;
      ne2(null !== (t4 = e3) && void 0 !== t4 ? t4 : p2);
    }, offset: (e3) => {
      ie(null === e3 ? m22 : Number(e3));
    }, wrapper: (e3) => {
      var t4;
      he2(null !== (t4 = e3) && void 0 !== t4 ? t4 : f2);
    }, events: (e3) => {
      const t4 = null == e3 ? void 0 : e3.split(" ");
      be2(null != t4 ? t4 : w22);
    }, "position-strategy": (e3) => {
      var t4;
      ge2(null !== (t4 = e3) && void 0 !== t4 ? t4 : S22);
    }, "delay-show": (e3) => {
      ae(null === e3 ? E22 : Number(e3));
    }, "delay-hide": (e3) => {
      de2(null === e3 ? _2 : Number(e3));
    }, float: (e3) => {
      ve2(null === e3 ? O22 : "true" === e3);
    }, hidden: (e3) => {
      fe2(null === e3 ? T22 : "true" === e3);
    }, "class-name": (e3) => {
      Ae2(e3);
    } };
    Object.values(t3).forEach(((e3) => e3(null))), Object.entries(e22).forEach((([e3, o2]) => {
      var r3;
      null === (r3 = t3[e3]) || void 0 === r3 || r3.call(t3, o2);
    }));
  };
  useEffect((() => {
    Q3(c22);
  }), [c22]), useEffect((() => {
    te(i22);
  }), [i22]), useEffect((() => {
    re2(v2);
  }), [v2]), useEffect((() => {
    ne2(p2);
  }), [p2]), useEffect((() => {
    ie(m22);
  }), [m22]), useEffect((() => {
    ae(E22);
  }), [E22]), useEffect((() => {
    de2(_2);
  }), [_2]), useEffect((() => {
    ve2(O22);
  }), [O22]), useEffect((() => {
    fe2(T22);
  }), [T22]), useEffect((() => {
    ge2(S22);
  }), [S22]), useEffect((() => {
    Te2.current !== P2 && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }), [P2]), useEffect((() => {
    "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: "core" === P2, disableBase: P2 } }));
  }), []), useEffect((() => {
    var e22;
    const o2 = new Set(ke2);
    let l2 = n2;
    if (!l2 && t22 && (l2 = `[data-tooltip-id='${t22.replace(/'/g, "\\'")}']`), l2) try {
      document.querySelectorAll(l2).forEach(((e3) => {
        o2.add({ current: e3 });
      }));
    } catch (e3) {
      console.warn(`[react-tooltip] "${l2}" is not a valid CSS selector`);
    }
    const c3 = document.querySelector(`[id='${r2}']`);
    if (c3 && o2.add({ current: c3 }), !o2.size) return () => null;
    const i3 = null !== (e22 = null != _e2 ? _e2 : c3) && void 0 !== e22 ? e22 : Ce2.current, s22 = new MutationObserver(((e3) => {
      e3.forEach(((e4) => {
        var t3;
        if (!i3 || "attributes" !== e4.type || !(null === (t3 = e4.attributeName) || void 0 === t3 ? void 0 : t3.startsWith("data-tooltip-"))) return;
        const o3 = Le2(i3);
        Re2(o3);
      }));
    })), a32 = { attributes: true, childList: false, subtree: false };
    if (i3) {
      const e3 = Le2(i3);
      Re2(e3), s22.observe(i3, a32);
    }
    return () => {
      s22.disconnect();
    };
  }), [ke2, Ce2, _e2, r2, n2]), useEffect((() => {
    (null == z22 ? void 0 : z22.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V2 && !A$1("border", `${V2}`) && console.warn(`[react-tooltip] "${V2}" is not a valid \`border\`.`), (null == z22 ? void 0 : z22.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F2 && !A$1("opacity", `${F2}`) && console.warn(`[react-tooltip] "${F2}" is not a valid \`opacity\`.`);
  }), []);
  let xe2 = h22;
  const Ne2 = useRef(null);
  if (a22) {
    const t3 = a22({ content: (null == _e2 ? void 0 : _e2.getAttribute("data-tooltip-content")) || J2 || null, activeAnchor: _e2 });
    xe2 = t3 ? React__default.createElement("div", { ref: Ne2, className: "react-tooltip-content-wrapper" }, t3) : null;
  } else J2 && (xe2 = J2);
  ee2 && (xe2 = React__default.createElement(q, { content: ee2 }));
  const $e2 = { forwardRef: Z2, id: t22, anchorId: r2, anchorSelect: n2, className: r(u22, Ee2), classNameArrow: d22, content: xe2, contentWrapperRef: Ne2, place: oe2, variant: le2, offset: ce, wrapper: ye2, events: we2, openOnClick: b22, positionStrategy: Se2, middlewares: g2, delayShow: se2, delayHide: ue2, float: pe2, hidden: me2, noArrow: k22, clickable: C2, closeOnEsc: L22, closeOnScroll: R22, closeOnResize: x22, openEvents: N2, closeEvents: $2, globalCloseEvents: j2, imperativeModeOnly: B22, style: z22, position: H22, isOpen: M4, defaultIsOpen: W2, border: V2, opacity: F2, arrowColor: K2, setIsOpen: U2, afterShow: X3, afterHide: Y3, activeAnchor: _e2, setActiveAnchor: (e22) => Oe2(e22), role: G3 };
  return React__default.createElement(D$1, { ...$e2 });
}));
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", ((e22) => {
  e22.detail.disableCore || S$1({ css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`, type: "core" }), e22.detail.disableBase || S$1({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
}));
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i3 = 0; i3 < 256; ++i3) {
  byteToHex.push((i3 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset3 = 0) {
  return byteToHex[arr[offset3 + 0]] + byteToHex[arr[offset3 + 1]] + byteToHex[arr[offset3 + 2]] + byteToHex[arr[offset3 + 3]] + "-" + byteToHex[arr[offset3 + 4]] + byteToHex[arr[offset3 + 5]] + "-" + byteToHex[arr[offset3 + 6]] + byteToHex[arr[offset3 + 7]] + "-" + byteToHex[arr[offset3 + 8]] + byteToHex[arr[offset3 + 9]] + "-" + byteToHex[arr[offset3 + 10]] + byteToHex[arr[offset3 + 11]] + byteToHex[arr[offset3 + 12]] + byteToHex[arr[offset3 + 13]] + byteToHex[arr[offset3 + 14]] + byteToHex[arr[offset3 + 15]];
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options2, buf, offset3) {
  if (native.randomUUID && true && !options2) {
    return native.randomUUID();
  }
  options2 = options2 || {};
  const rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
function Tooltip$3({
  children,
  id,
  content: content2,
  render,
  className,
  classNameArrow,
  disabled: disabled2,
  ariaLabel,
  disableAriaLabel,
  dataTestid,
  ariaHiddenTooltip = true,
  variant = "dark",
  ...restProps
}) {
  const localId = useRef(id || v4());
  const ariaLabelContent = disableAriaLabel ? null : ariaLabel || content2;
  const getChildProps = () => {
    const childProps = {
      "data-tooltip-id": localId.current,
      ["data-testid"]: "tooltip-trigger"
    };
    if (!disableAriaLabel) {
      return {
        ...childProps,
        "aria-label": ariaLabelContent,
        ariaLabel: ariaLabelContent
      };
    }
    return childProps;
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    children && Children.map(children, (child) => {
      return cloneElement(child, getChildProps());
    }),
    !disabled2 && (content2 || render) && /* @__PURE__ */ jsx$1(
      "span",
      {
        "aria-hidden": ariaHiddenTooltip,
        "data-testid": dataTestid,
        className: "tooltip__wrapper",
        children: /* @__PURE__ */ jsx$1(
          H,
          {
            ...restProps,
            id: localId.current,
            content: content2,
            render,
            className: clsx(
              "tooltip",
              variant === "light" && "tooltip--light",
              className
            ),
            classNameArrow: clsx("tooltip__arrow", classNameArrow),
            clickable: true,
            positionStrategy: "fixed"
          }
        )
      }
    )
  ] });
}
var ColorVariant = /* @__PURE__ */ ((ColorVariant2) => {
  ColorVariant2["BLUE"] = "blue";
  ColorVariant2["GREEN"] = "green";
  ColorVariant2["PURPLE"] = "purple";
  ColorVariant2["YELLOW"] = "yellow";
  ColorVariant2["RED"] = "red";
  return ColorVariant2;
})(ColorVariant || {});
function Avatar({
  id = "0",
  user,
  icon: icon2,
  badge: badge2,
  size = "medium",
  colorVariant = "blue",
  className,
  ariaLabel,
  isActive: isActive2,
  isInteractive = true,
  tooltip: tooltip2,
  tooltipRender,
  tooltipClassName,
  ariaExpanded,
  onFocus: onFocus2,
  onClick,
  colorOrder
}) {
  const ref2 = useRef(null);
  const isColorCodedByOrder = colorOrder !== void 0;
  const handleFocus = () => {
    if (ref2?.current) {
      ref2.current.focus();
    }
    onFocus2?.(id);
  };
  const handleKeyPress = (e3) => {
    switch (e3.keyCode) {
      case 32:
      case 13:
        onClick?.(id);
        break;
    }
  };
  const handleOnClick = () => {
    isInteractive && onClick?.(id);
  };
  const getFirstLetter = (name2) => {
    return name2 ? name2[0]?.toUpperCase() : "";
  };
  const getAvatarContent = () => {
    const { firstName, lastName, showDots, initials } = user;
    if (icon2) {
      return icon2;
    }
    if (showDots) {
      return "...";
    }
    return initials || getFirstLetter(firstName) + getFirstLetter(lastName);
  };
  const componentStyles = user?.imageUrl ? { backgroundImage: `url(${user?.imageUrl})` } : {};
  const defaultClassName = clsx(
    styles$O["avatar"],
    styles$O[`avatar--size-${size}`],
    className
  );
  const getAvatar = () => {
    return isInteractive ? /* @__PURE__ */ jsxs(
      "button",
      {
        id: id ? String(id) : void 0,
        "aria-label": ariaLabel,
        onClick: handleOnClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyPress,
        ref: ref2,
        tabIndex: 0,
        className: clsx(
          defaultClassName,
          isActive2 && styles$O[`avatar--active`],
          isColorCodedByOrder && styles$O.colorCodedByOrder,
          isColorCodedByOrder ? styles$O[`avatar--color-by-order-${colorOrder}`] : styles$O[colorVariant]
        ),
        style: componentStyles,
        "data-testid": "avatar",
        "aria-expanded": ariaExpanded,
        children: [
          !user?.imageUrl && getAvatarContent(),
          badge2 && /* @__PURE__ */ jsx$1("div", { className: styles$O.badge, children: badge2 })
        ]
      }
    ) : /* @__PURE__ */ jsxs(
      "div",
      {
        "aria-label": ariaLabel,
        tabIndex: -1,
        className: clsx(
          defaultClassName,
          styles$O["decorative"],
          isColorCodedByOrder && styles$O.colorCodedByOrder,
          isColorCodedByOrder ? styles$O[`avatar--color-by-order-${colorOrder}`] : styles$O[colorVariant]
        ),
        style: componentStyles,
        "data-testid": "avatar",
        children: [
          !user?.imageUrl && getAvatarContent(),
          badge2 && /* @__PURE__ */ jsx$1("div", { className: styles$O.badge, children: badge2 })
        ]
      }
    );
  };
  return /* @__PURE__ */ jsx$1(Fragment, { children: tooltip2 || tooltipRender ? /* @__PURE__ */ jsx$1(
    Tooltip$3,
    {
      className: tooltipClassName,
      content: tooltip2,
      render: tooltipRender,
      children: getAvatar()
    }
  ) : getAvatar() });
}
const avatars = "avatars-module_avatars__BdLe4";
const dotsTooltip = "avatars-module_dotsTooltip__-TLQM";
const styles$N = {
  avatars,
  dotsTooltip,
  "children-avatar": "avatars-module_children-avatar__i9lDP"
};
const AvatarsGroup = ({
  avatars: avatars2,
  ariaLabel,
  size = "medium",
  containerClass,
  itemClass,
  maxAvatars,
  maxAvatarsMoreMessage,
  colorCoded = false
}) => {
  const getMoreAvatarsTooltip = (avatarNames) => {
    if (avatarNames.length > 20) {
      const overflows = avatarNames.length - 20;
      return avatarNames.splice(0, 20).join(", ") + ` + ${overflows} ${maxAvatarsMoreMessage ?? "others"}`;
    }
    return avatarNames.join(", ");
  };
  const avatarsVisible = useMemo(() => {
    if (maxAvatars && avatars2.length && avatars2.length > maxAvatars) {
      const dotsAvatar = {
        user: {
          firstName: "",
          lastName: "",
          showDots: true
        },
        tooltip: getMoreAvatarsTooltip(
          avatars2.slice(maxAvatars - 1, avatars2.length).map((avatar2) => avatar2.user.firstName + " " + avatar2.user.lastName)
        ),
        tooltipClassName: styles$N.dotsTooltip
      };
      return [...avatars2.slice(0, maxAvatars - 1), dotsAvatar];
    }
    return avatars2;
  }, [avatars2, maxAvatars]);
  return /* @__PURE__ */ jsx$1(
    "fieldset",
    {
      "aria-label": ariaLabel || "group of avatars",
      className: clsx(styles$N.avatars, containerClass),
      "data-testid": "avatars-group",
      children: avatarsVisible.map((avatar2, i3) => /* @__PURE__ */ jsx$1(
        "div",
        {
          className: clsx(styles$N["children-avatar"], itemClass),
          style: {
            zIndex: avatarsVisible.length - i3
          },
          children: /* @__PURE__ */ jsx$1(
            Avatar,
            {
              ...avatar2,
              size,
              ...colorCoded && { colorOrder: i3 }
            }
          )
        },
        `avatar_${i3}_${avatar2?.id}`
      ))
    }
  );
};
const barChart = "bar-chart-module_barChart__iE-iG";
const styles$M = {
  barChart
};
const BLUE$2 = "#006FBF";
const WHITE$2 = "#FFFFFF";
const DISABLED$6 = "#ADBFD9";
const BarChart = ({
  value: value2,
  isDisabled,
  className,
  dataTestId,
  title: title2
}) => {
  const defaultColor = isDisabled ? DISABLED$6 : BLUE$2;
  const thirdBarFill = value2 === 4 ? defaultColor : WHITE$2;
  const secondBarFill = [4, 3].includes(value2) ? BLUE$2 : WHITE$2;
  const firstBarFill = value2 !== 1 ? defaultColor : WHITE$2;
  const strokeWidth = 2;
  const borderRadius2 = 2;
  const strokeColor = defaultColor;
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      "data-testid": dataTestId || "bar-chart",
      className: styles$M.barChart,
      children: /* @__PURE__ */ jsxs(
        "svg",
        {
          role: "img",
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className,
          children: [
            /* @__PURE__ */ jsx$1("title", { children: title2 }),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "4",
                y: "26",
                width: "8",
                height: "12",
                rx: borderRadius2,
                fill: firstBarFill,
                stroke: strokeColor,
                strokeWidth
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "16",
                y: "14",
                width: "8",
                height: "24",
                rx: borderRadius2,
                fill: secondBarFill,
                stroke: strokeColor,
                strokeWidth
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "28",
                y: "2",
                width: "8",
                height: "36",
                rx: borderRadius2,
                fill: thirdBarFill,
                stroke: strokeColor,
                strokeWidth
              }
            )
          ]
        }
      )
    }
  );
};
const button = "button-module_button__Z331g";
const button__content = "button-module_button__content__9h4R4";
const button__text = "button-module_button__text__MRvbu";
const button__loader = "button-module_button__loader__1NT-v";
const style$2 = {
  button,
  button__content,
  button__text,
  "button--as-component": "button-module_button--as-component__Cf0EP",
  "button__left-icon-wrapper": "button-module_button__left-icon-wrapper__DjiYD",
  "button__right-icon-wrapper": "button-module_button__right-icon-wrapper__PVDu6",
  "button__counter-wrapper": "button-module_button__counter-wrapper__86jEc",
  "button--loading": "button-module_button--loading__8GhE4",
  "button--full-width": "button-module_button--full-width__KuOth",
  "button--size-large": "button-module_button--size-large__4A7f5",
  "button--size-medium": "button-module_button--size-medium__PNgpr",
  "button--size-small": "button-module_button--size-small__CgTo7",
  "button--icon-only": "button-module_button--icon-only__pv5vL",
  "button--variant-primary": "button-module_button--variant-primary__h1ZBU",
  button__loader,
  "button--variant-secondary": "button-module_button--variant-secondary__nja0P",
  "button--variant-tertiary": "button-module_button--variant-tertiary__-XASz",
  "button--variant-text": "button-module_button--variant-text__oH84u",
  "button--variant-negative": "button-module_button--variant-negative__yPuaC",
  "button--variant-negativeSecondary": "button-module_button--variant-negativeSecondary__w4Z2R",
  "button--variant-negativePrimary": "button-module_button--variant-negativePrimary__VUOsM"
};
const loader$3 = "styles-module_loader__84O2M";
const animation = "styles-module_animation__zEO9U";
const bounce1 = "styles-module_bounce1__UFXT6";
const bounce2 = "styles-module_bounce2__THqFp";
const styles$L = {
  loader: loader$3,
  animation,
  "bounce-delay": "styles-module_bounce-delay__BTq2m",
  bounce1,
  bounce2,
  "loader--color-interactive": "styles-module_loader--color-interactive__b91-R",
  "loader--color-white": "styles-module_loader--color-white__9U7Og",
  "loader--color-interactive-dark": "styles-module_loader--color-interactive-dark__1roQO",
  "loader--size-small": "styles-module_loader--size-small__F0F7h",
  "loader--size-medium": "styles-module_loader--size-medium__-8o5l",
  "loader--size-large": "styles-module_loader--size-large__mhFtF"
};
const Loader$1 = ({
  color = "interactive",
  size = "medium",
  className
}) => {
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: clsx(
        styles$L.loader,
        styles$L.animation,
        styles$L[`loader--color-${color}`],
        styles$L[`loader--size-${size}`],
        className
      ),
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$L.bounce1 }),
        /* @__PURE__ */ jsx$1("div", { className: styles$L.bounce2 }),
        /* @__PURE__ */ jsx$1("div", { className: styles$L.bounce3 })
      ]
    }
  );
};
const loader$2 = "styles-module_loader__2DUDM";
const rotation = "styles-module_rotation__lYYqb";
const styles$K = {
  loader: loader$2,
  rotation,
  "loader--color-white": "styles-module_loader--color-white__O2iyE",
  "loader--color-interactive": "styles-module_loader--color-interactive__mT9Eb",
  "loader--color-interactive-dark": "styles-module_loader--color-interactive-dark__ZPgn8",
  "loader--size-small": "styles-module_loader--size-small__XA3yY",
  "loader--size-medium": "styles-module_loader--size-medium__eSAJZ",
  "loader--size-large": "styles-module_loader--size-large__dS3td"
};
const Spinner = ({
  color = "interactive",
  size = "medium",
  className
}) => {
  return /* @__PURE__ */ jsx$1(
    "span",
    {
      className: clsx(
        styles$K["loader"],
        styles$K[`loader--color-${color}`],
        styles$K[`loader--size-${size}`],
        className
      )
    }
  );
};
const loader__wrapper = "styles-module_loader__wrapper__T2Tb0";
const style$1 = {
  loader__wrapper,
  "page-loader-wrapper": "styles-module_page-loader-wrapper__5uh7l"
};
const Loader = ({
  variant = "spinner",
  color = "interactive",
  size = "medium",
  isPageLoader,
  className
}) => {
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      "data-testid": "loader",
      className: isPageLoader ? style$1["page-loader-wrapper"] : style$1["loader__wrapper"],
      children: variant === "spinner" ? /* @__PURE__ */ jsx$1(
        Spinner,
        {
          color,
          size,
          className
        }
      ) : /* @__PURE__ */ jsx$1(
        Loader$1,
        {
          color,
          size,
          className
        }
      )
    }
  );
};
const ButtonComponent = ({
  children,
  size = "large",
  variant = "primary",
  className,
  fullWidth: fullWidth2,
  disabled: disabled2,
  leftIcon,
  rightIcon,
  iconOnly: iconOnly2,
  ariaLabel,
  loading: loading2,
  counter: counter2,
  onClick,
  component,
  ...rest
}, ref2) => {
  const Component2 = component || "button";
  return /* @__PURE__ */ jsx$1(
    Component2,
    {
      ref: ref2,
      className: clsx(
        style$2["button"],
        style$2[`button--size-${size}`],
        style$2[`button--variant-${variant}`],
        loading2 && style$2["button--loading"],
        fullWidth2 && style$2[`button--full-width`],
        iconOnly2 && style$2["button--icon-only"],
        component && style$2["button--as-component"],
        className
      ),
      "aria-disabled": disabled2,
      "aria-label": ariaLabel,
      onClick: (e3) => !disabled2 && !loading2 && onClick?.(e3),
      ...rest,
      children: /* @__PURE__ */ jsxs("div", { className: clsx("button__content", style$2["button__content"]), children: [
        leftIcon && !loading2 && /* @__PURE__ */ jsx$1("div", { className: clsx(style$2["button__left-icon-wrapper"]), children: leftIcon }),
        children && /* @__PURE__ */ jsx$1("span", { className: style$2["button__text"], children }),
        rightIcon && !loading2 && /* @__PURE__ */ jsx$1("div", { className: clsx(style$2["button__right-icon-wrapper"]), children: rightIcon }),
        loading2 && /* @__PURE__ */ jsx$1(Loader, { className: style$2["button__loader"], size: "small" }),
        counter2 && !loading2 && !rightIcon && /* @__PURE__ */ jsx$1("div", { className: clsx(style$2["button__counter-wrapper"]), children: counter2 })
      ] })
    }
  );
};
const Button$1 = forwardRef(ButtonComponent);
const IconX$1 = () => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 8 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M7.5 1.205L6.795 0.5L4 3.295L1.205 0.5L0.5 1.205L3.295 4L0.5 6.795L1.205 7.5L4 4.705L6.795 7.5L7.5 6.795L4.705 4L7.5 1.205Z",
          fill: "#00204D"
        }
      )
    }
  );
};
const container$9 = "chip-module_container__L6Fwa";
const iconWrapper$1 = "chip-module_iconWrapper__Y2Edt";
const content$5 = "chip-module_content__XpQEQ";
const dismissIcon = "chip-module_dismissIcon__RFex6";
const active$1 = "chip-module_active__uJfiq";
const disabled$7 = "chip-module_disabled__21ZO5";
const styles$J = {
  container: container$9,
  "default": "chip-module_default__NL5lH",
  iconWrapper: iconWrapper$1,
  content: content$5,
  dismissIcon,
  active: active$1,
  disabled: disabled$7
};
function Chip({
  children,
  onClick,
  disabled: disabled2,
  active: active2,
  fixed = false,
  maxChars,
  ariaLabel,
  className,
  tabIndex,
  icon: icon2,
  ...rest
}) {
  function handleDismiss(event) {
    if (onClick && !disabled2) {
      onClick(event);
    }
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        styles$J.container,
        !fixed && !active2 && !disabled2 && styles$J.default,
        disabled2 && styles$J.disabled,
        fixed && styles$J.fixed,
        active2 && !fixed && styles$J.active,
        className
      ),
      role: "button",
      onMouseDown: handleDismiss,
      ...rest,
      children: [
        icon2 && /* @__PURE__ */ jsx$1("div", { className: styles$J.iconWrapper, children: icon2 }),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: styles$J.content,
            style: maxChars ? { maxWidth: `${maxChars + 1}ch` } : {},
            children
          }
        ),
        !fixed && !active2 && /* @__PURE__ */ jsx$1(
          "button",
          {
            className: styles$J.dismissIcon,
            "aria-label": `Dismiss ${ariaLabel ?? children}`,
            "aria-disabled": disabled2,
            onKeyDown: handleDismiss,
            onMouseDown: handleDismiss,
            tabIndex,
            children: /* @__PURE__ */ jsx$1(IconX$1, {})
          }
        )
      ]
    }
  );
}
var extendStatics = function(d4, b3) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d5, b4) {
    d5.__proto__ = b4;
  } || function(d5, b4) {
    for (var p2 in b4) if (b4.hasOwnProperty(p2)) d5[p2] = b4[p2];
  };
  return extendStatics(d4, b3);
};
function __extends(d4, b3) {
  extendStatics(d4, b3);
  function __() {
    this.constructor = d4;
  }
  d4.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
}
var VIEWBOX_WIDTH = 100;
var VIEWBOX_HEIGHT = 100;
var VIEWBOX_HEIGHT_HALF = 50;
var VIEWBOX_CENTER_X = 50;
var VIEWBOX_CENTER_Y = 50;
function Path(_a) {
  var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style2 = _a.style;
  return createElement("path", { className, style: Object.assign({}, style2, getDashStyle({ pathRadius, dashRatio, counterClockwise })), d: getPathDescription({
    pathRadius,
    counterClockwise
  }), strokeWidth, fillOpacity: 0 });
}
function getPathDescription(_a) {
  var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
  var radius = pathRadius;
  var rotation2 = counterClockwise ? 1 : 0;
  return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation2 + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation2 + " 1 1 0,-" + 2 * radius + "\n    ";
}
function getDashStyle(_a) {
  var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
  var diameter = Math.PI * 2 * pathRadius;
  var gapLength = (1 - dashRatio) * diameter;
  return {
    strokeDasharray: diameter + "px " + diameter + "px",
    strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
  };
}
var CircularProgressbar = (function(_super) {
  __extends(CircularProgressbar2, _super);
  function CircularProgressbar2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CircularProgressbar2.prototype.getBackgroundPadding = function() {
    if (!this.props.background) {
      return 0;
    }
    return this.props.backgroundPadding;
  };
  CircularProgressbar2.prototype.getPathRadius = function() {
    return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
  };
  CircularProgressbar2.prototype.getPathRatio = function() {
    var _a = this.props, value2 = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
    var boundedValue = Math.min(Math.max(value2, minValue), maxValue);
    return (boundedValue - minValue) / (maxValue - minValue);
  };
  CircularProgressbar2.prototype.render = function() {
    var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles2 = _a.styles, strokeWidth = _a.strokeWidth, text2 = _a.text;
    var pathRadius = this.getPathRadius();
    var pathRatio = this.getPathRatio();
    return createElement(
      "svg",
      { className: classes.root + " " + className, style: styles2.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
      this.props.background ? createElement("circle", { className: classes.background, style: styles2.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF }) : null,
      createElement(Path, { className: classes.trail, counterClockwise, dashRatio: circleRatio, pathRadius, strokeWidth, style: styles2.trail }),
      createElement(Path, { className: classes.path, counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius, strokeWidth, style: styles2.path }),
      text2 ? createElement("text", { className: classes.text, style: styles2.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text2) : null
    );
  };
  CircularProgressbar2.defaultProps = {
    background: false,
    backgroundPadding: 0,
    circleRatio: 1,
    classes: {
      root: "CircularProgressbar",
      trail: "CircularProgressbar-trail",
      path: "CircularProgressbar-path",
      text: "CircularProgressbar-text",
      background: "CircularProgressbar-background"
    },
    counterClockwise: false,
    className: "",
    maxValue: 100,
    minValue: 0,
    strokeWidth: 8,
    styles: {
      root: {},
      trail: {},
      path: {},
      text: {},
      background: {}
    },
    text: ""
  };
  return CircularProgressbar2;
})(Component);
function buildStyles(_a) {
  var rotation2 = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
  var rotationTransform = rotation2 == null ? void 0 : "rotate(" + rotation2 + "turn)";
  var rotationTransformOrigin = rotation2 == null ? void 0 : "center center";
  return {
    root: {},
    path: removeUndefinedValues({
      stroke: pathColor,
      strokeLinecap,
      transform: rotationTransform,
      transformOrigin: rotationTransformOrigin,
      transition: pathTransition,
      transitionDuration: pathTransitionDuration == null ? void 0 : pathTransitionDuration + "s"
    }),
    trail: removeUndefinedValues({
      stroke: trailColor,
      strokeLinecap,
      transform: rotationTransform,
      transformOrigin: rotationTransformOrigin
    }),
    text: removeUndefinedValues({
      fill: textColor,
      fontSize: textSize
    }),
    background: removeUndefinedValues({
      fill: backgroundColor
    })
  };
}
function removeUndefinedValues(obj) {
  Object.keys(obj).forEach(function(key) {
    if (obj[key] == null) {
      delete obj[key];
    }
  });
  return obj;
}
const countdown = "countdown-module_countdown__krAOE";
const circularCounter = "countdown-module_circularCounter__k-VQ-";
const styles$I = {
  countdown,
  circularCounter
};
const useInterval = (callback, delay = 1e3, isActive2) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  });
  useEffect(() => {
    function tick() {
      if (typeof savedCallback?.current !== "undefined" && isActive2) {
        savedCallback?.current();
      }
    }
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay, isActive2]);
};
const customStyles = buildStyles({
  strokeLinecap: "butt",
  trailColor: "#e6f1fa",
  //$color-blue-back
  pathColor: "#0070bf"
  //$color-blue-front
});
const Countdown = ({
  timeInterval,
  isActiveDefault = true,
  timeLimit,
  onTimeout,
  getCountdownText
}) => {
  const [state, setState] = React__default.useState(timeInterval);
  const [percentage, setPercentage] = React__default.useState(100);
  const [isActive2, setIsActive] = React__default.useState(isActiveDefault);
  const decrement = () => {
    const nextState = state - 1;
    if (nextState === 0) {
      setIsActive(false);
      if (onTimeout) {
        onTimeout();
      }
    }
    setState(nextState);
    setPercentage(nextState / timeInterval * 100);
  };
  useInterval(decrement, 1e3, isActive2);
  return /* @__PURE__ */ jsxs("div", { className: styles$I.countdown, role: "timer", children: [
    getCountdownText(state),
    /* @__PURE__ */ jsx$1(
      CircularProgressbar,
      {
        className: styles$I.circularCounter,
        value: timeLimit ? state : percentage,
        strokeWidth: 50,
        styles: customStyles,
        maxValue: timeLimit,
        counterClockwise: true
      }
    )
  ] });
};
function CloseIcon$4() {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
          fill: "#00204D"
        }
      )
    }
  );
}
const drawer = "drawer-module_drawer__M9tID";
const open = "drawer-module_open__YuyKG";
const closed = "drawer-module_closed__X4dM-";
const header$6 = "drawer-module_header__IrV2g";
const title$7 = "drawer-module_title__-Oex-";
const body$2 = "drawer-module_body__fGi7v";
const closeButton = "drawer-module_closeButton__7yw5U";
const overlay$2 = "drawer-module_overlay__Cv-ju";
const loader$1 = "drawer-module_loader__-CfL-";
const styles$H = {
  drawer,
  open,
  closed,
  header: header$6,
  title: title$7,
  body: body$2,
  closeButton,
  overlay: overlay$2,
  loader: loader$1
};
function useIsDomReady() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return { isDomReady: mounted };
}
function Drawer({
  open: open2 = false,
  children,
  title: title2,
  onClose,
  loading: loading2,
  ariaLabelCloseBtn = "Close drawer",
  ariaLabelLoading = "Drawer opened. Loading content.",
  ariaLabelReady = "Drawer content ready.",
  className
}) {
  const { isDomReady } = useIsDomReady();
  const portalSlot = document.getElementById("sz-drawer");
  const drawerRef = useRef(null);
  const closeButtonRef = useRef(null);
  useEffect(() => {
    if (open2) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open2]);
  function handleCloseKeyDown(e3) {
    if (e3.key === "Enter" || e3.key === " ") {
      onClose();
      e3.preventDefault();
    }
    e3.stopPropagation();
    if (e3.key === "Tab" && !e3.shiftKey) {
      e3.preventDefault();
      drawerRef.current?.focus();
    }
  }
  function handleDrawerKeyDown(e3) {
    if (e3.target === e3.currentTarget && e3.key === "Tab" && e3.shiftKey) {
      e3.preventDefault();
      closeButtonRef.current?.focus();
    }
  }
  useEffect(() => {
    if (open2 && drawerRef.current) {
      drawerRef.current.focus();
    }
  }, [open2]);
  useEffect(() => {
    if (!open2) return;
    function handleEscapeKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }
    document.body.addEventListener("keydown", handleEscapeKeyDown);
    return () => {
      document.body.removeEventListener("keydown", handleEscapeKeyDown);
    };
  }, [open2, onClose]);
  const ariaLabel = loading2 ? ariaLabelLoading : ariaLabelReady;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isDomReady && createPortal(
      /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: clsx(
            styles$H.drawer,
            open2 ? styles$H.open : styles$H.closed,
            className
          ),
          "aria-label": ariaLabel,
          "aria-live": "assertive",
          tabIndex: open2 ? 0 : -1,
          onKeyDown: handleDrawerKeyDown,
          ref: drawerRef,
          "data-testid": "sz-drawer",
          children: [
            loading2 ? /* @__PURE__ */ jsx$1("div", { className: styles$H.loader, children: /* @__PURE__ */ jsx$1(Loader, { variant: "bubbles" }) }) : (
              // Do not render children when drawer is closed.
              /* @__PURE__ */ jsx$1("div", { className: styles$H.body, children: open2 && children })
            ),
            /* @__PURE__ */ jsxs("div", { className: styles$H.header, children: [
              /* @__PURE__ */ jsx$1("h2", { className: styles$H.title, children: !loading2 && title2 }),
              /* @__PURE__ */ jsx$1(
                "button",
                {
                  onClick: onClose,
                  onKeyDown: handleCloseKeyDown,
                  className: styles$H.closeButton,
                  "aria-label": ariaLabelCloseBtn || "Close drawer",
                  "data-testid": "sz-drawer-close-btn",
                  tabIndex: open2 ? 0 : -1,
                  ref: closeButtonRef,
                  children: /* @__PURE__ */ jsx$1(CloseIcon$4, {})
                }
              )
            ] })
          ]
        }
      ) }),
      portalSlot
    ),
    isDomReady && open2 && createPortal(
      /* @__PURE__ */ jsx$1(
        "div",
        {
          className: styles$H.overlay,
          onClick: onClose,
          "data-testid": "sz-drawer-overlay"
        }
      ),
      document.body
    )
  ] });
}
function useDrawer(options2) {
  const [isOpen, setIsOpen] = useState(false);
  const prevActiveElementRef = useRef(null);
  useLayoutEffect$1(() => {
    if (!isOpen && options2?.domTrigger) {
      options2.domTrigger.current?.focus();
      options2.domTrigger.current?.setAttribute("tab-index", "0");
    }
    if (!options2?.domTrigger) {
      if (isOpen) {
        prevActiveElementRef.current = document.activeElement;
      } else {
        prevActiveElementRef.current?.focus?.();
      }
    }
  }, [isOpen, options2?.domTrigger]);
  function closeDrawer() {
    setIsOpen(false);
    options2?.onCloseDrawer?.();
  }
  function openDrawer() {
    setIsOpen(true);
    options2?.onOpenDrawer?.();
  }
  return {
    isDrawerOpen: isOpen,
    closeDrawer,
    openDrawer
  };
}
var OutsideClickHandler$1 = {};
var propTypes = { exports: {} };
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var mocks;
var hasRequiredMocks;
function requireMocks() {
  if (hasRequiredMocks) return mocks;
  hasRequiredMocks = 1;
  function noop3() {
    return null;
  }
  noop3.isRequired = noop3;
  function noopThunk() {
    return noop3;
  }
  mocks = {
    and: noopThunk,
    between: noopThunk,
    booleanSome: noopThunk,
    childrenHavePropXorChildren: noopThunk,
    childrenOf: noopThunk,
    childrenOfType: noopThunk,
    childrenSequenceOf: noopThunk,
    componentWithName: noopThunk,
    disallowedIf: noopThunk,
    elementType: noopThunk,
    empty: noopThunk,
    explicitNull: noopThunk,
    forbidExtraProps: Object,
    integer: noopThunk,
    keysOf: noopThunk,
    mutuallyExclusiveProps: noopThunk,
    mutuallyExclusiveTrueProps: noopThunk,
    nChildren: noopThunk,
    nonNegativeInteger: noop3,
    nonNegativeNumber: noopThunk,
    numericString: noopThunk,
    object: noopThunk,
    or: noopThunk,
    predicate: noopThunk,
    range: noopThunk,
    ref: noopThunk,
    requiredBy: noopThunk,
    restrictedProp: noopThunk,
    sequenceOf: noopThunk,
    shape: noopThunk,
    stringEndsWith: noopThunk,
    stringStartsWith: noopThunk,
    uniqueArray: noopThunk,
    uniqueArrayOf: noopThunk,
    valuesOf: noopThunk,
    withShape: noopThunk
  };
  return mocks;
}
var airbnbPropTypes;
var hasRequiredAirbnbPropTypes;
function requireAirbnbPropTypes() {
  if (hasRequiredAirbnbPropTypes) return airbnbPropTypes;
  hasRequiredAirbnbPropTypes = 1;
  airbnbPropTypes = requireMocks();
  return airbnbPropTypes;
}
var CAN_USE_DOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }
  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }
  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, "passive", {
      // eslint-disable-next-line getter-return
      get: /* @__PURE__ */ (function() {
        function get2() {
          supportsPassiveOption = true;
        }
        return get2;
      })()
    });
    var noop3 = function noop4() {
    };
    window.addEventListener("testPassiveEventSupport", noop3, opts);
    window.removeEventListener("testPassiveEventSupport", noop3, opts);
  } catch (e3) {
  }
  return supportsPassiveOption;
}
var memoized = void 0;
function canUsePassiveEventListeners() {
  if (memoized === void 0) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}
function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return void 0;
  }
  if (!canUsePassiveEventListeners()) {
    return !!eventOptions.capture;
  }
  return eventOptions;
}
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }
  if (normalizedEventOptions === true) {
    return 100;
  }
  var capture = normalizedEventOptions.capture << 0;
  var passive2 = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive2 + once;
}
function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}
function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}
TargetEventHandlers.prototype.getEventHandlers = /* @__PURE__ */ (function() {
  function getEventHandlers(eventName, options2) {
    var key = String(eventName) + " " + String(eventOptionsKey(options2));
    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: void 0
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }
    return this.events[key];
  }
  return getEventHandlers;
})();
TargetEventHandlers.prototype.handleEvent = /* @__PURE__ */ (function() {
  function handleEvent(eventName, options2, event) {
    var eventHandlers = this.getEventHandlers(eventName, options2);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function(handler) {
      if (handler) {
        handler(event);
      }
    });
  }
  return handleEvent;
})();
TargetEventHandlers.prototype.add = /* @__PURE__ */ (function() {
  function add(eventName, listener, options2) {
    var _this = this;
    var eventHandlers = this.getEventHandlers(eventName, options2);
    ensureCanMutateNextEventHandlers(eventHandlers);
    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options2);
      this.target.addEventListener(eventName, eventHandlers.handleEvent, options2);
    }
    eventHandlers.nextHandlers.push(listener);
    var isSubscribed = true;
    var unsubscribe = /* @__PURE__ */ (function() {
      function unsubscribe2() {
        if (!isSubscribed) {
          return;
        }
        isSubscribed = false;
        ensureCanMutateNextEventHandlers(eventHandlers);
        var index2 = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index2, 1);
        if (eventHandlers.nextHandlers.length === 0) {
          if (_this.target) {
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options2);
          }
          eventHandlers.handleEvent = void 0;
        }
      }
      return unsubscribe2;
    })();
    return unsubscribe;
  }
  return add;
})();
var EVENT_HANDLERS_KEY = "__consolidated_events_handlers__";
function addEventListener(target, eventName, listener, options2) {
  if (!target[EVENT_HANDLERS_KEY]) {
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options2);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addEventListener
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var isArguments;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments;
  hasRequiredIsArguments = 1;
  var toStr = Object.prototype.toString;
  isArguments = function isArguments2(value2) {
    var str = toStr.call(value2);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) {
      isArgs = str !== "[object Array]" && value2 !== null && typeof value2 === "object" && typeof value2.length === "number" && value2.length >= 0 && toStr.call(value2.callee) === "[object Function]";
    }
    return isArgs;
  };
  return isArguments;
}
var implementation$3;
var hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$3;
  hasRequiredImplementation$3 = 1;
  var keysShim;
  if (!Object.keys) {
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = requireIsArguments();
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({ toString: null }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {
    }, "prototype");
    var dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    var equalsConstructorPrototype = function(o2) {
      var ctor = o2.constructor;
      return ctor && ctor.prototype === o2;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = (function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k3 in window) {
        try {
          if (!excludedKeys["$" + k3] && has.call(window, k3) && window[k3] !== null && typeof window[k3] === "object") {
            try {
              equalsConstructorPrototype(window[k3]);
            } catch (e3) {
              return true;
            }
          }
        } catch (e3) {
          return true;
        }
      }
      return false;
    })();
    var equalsConstructorPrototypeIfNotBuggy = function(o2) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o2);
      }
      try {
        return equalsConstructorPrototype(o2);
      } catch (e3) {
        return false;
      }
    };
    keysShim = function keys(object) {
      var isObject2 = object !== null && typeof object === "object";
      var isFunction = toStr.call(object) === "[object Function]";
      var isArguments2 = isArgs(object);
      var isString = isObject2 && toStr.call(object) === "[object String]";
      var theKeys = [];
      if (!isObject2 && !isFunction && !isArguments2) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction;
      if (isString && object.length > 0 && !has.call(object, 0)) {
        for (var i3 = 0; i3 < object.length; ++i3) {
          theKeys.push(String(i3));
        }
      }
      if (isArguments2 && object.length > 0) {
        for (var j = 0; j < object.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name2 in object) {
          if (!(skipProto && name2 === "prototype") && has.call(object, name2)) {
            theKeys.push(String(name2));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
        for (var k3 = 0; k3 < dontEnums.length; ++k3) {
          if (!(skipConstructor && dontEnums[k3] === "constructor") && has.call(object, dontEnums[k3])) {
            theKeys.push(dontEnums[k3]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$3 = keysShim;
  return implementation$3;
}
var objectKeys;
var hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys) return objectKeys;
  hasRequiredObjectKeys = 1;
  var slice2 = Array.prototype.slice;
  var isArgs = requireIsArguments();
  var origKeys = Object.keys;
  var keysShim = origKeys ? function keys(o2) {
    return origKeys(o2);
  } : requireImplementation$3();
  var originalKeys = Object.keys;
  keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
      var keysWorksWithArguments = (function() {
        var args = Object.keys(arguments);
        return args && args.length === arguments.length;
      })(1, 2);
      if (!keysWorksWithArguments) {
        Object.keys = function keys(object) {
          if (isArgs(object)) {
            return originalKeys(slice2.call(object));
          }
          return originalKeys(object);
        };
      }
    } else {
      Object.keys = keysShim;
    }
    return Object.keys || keysShim;
  };
  objectKeys = keysShim;
  return objectKeys;
}
var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var $defineProperty = Object.defineProperty || false;
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e3) {
      $defineProperty = false;
    }
  }
  esDefineProperty = $defineProperty;
  return esDefineProperty;
}
var syntax;
var hasRequiredSyntax;
function requireSyntax() {
  if (hasRequiredSyntax) return syntax;
  hasRequiredSyntax = 1;
  syntax = SyntaxError;
  return syntax;
}
var type;
var hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1;
  type = TypeError;
  return type;
}
var gOPD;
var hasRequiredGOPD;
function requireGOPD() {
  if (hasRequiredGOPD) return gOPD;
  hasRequiredGOPD = 1;
  gOPD = Object.getOwnPropertyDescriptor;
  return gOPD;
}
var gopd;
var hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var $gOPD = /* @__PURE__ */ requireGOPD();
  if ($gOPD) {
    try {
      $gOPD([], "length");
    } catch (e3) {
      $gOPD = null;
    }
  }
  gopd = $gOPD;
  return gopd;
}
var defineDataProperty;
var hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var gopd2 = /* @__PURE__ */ requireGopd();
  defineDataProperty = function defineDataProperty2(obj, property, value2) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") {
      throw new $TypeError("`obj` must be an object or a function`");
    }
    if (typeof property !== "string" && typeof property !== "symbol") {
      throw new $TypeError("`property` must be a string or a symbol`");
    }
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
      throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
      throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
      throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
      throw new $TypeError("`loose`, if provided, must be a boolean");
    }
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    var desc = !!gopd2 && gopd2(obj, property);
    if ($defineProperty) {
      $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value2,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
      });
    } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
      obj[property] = value2;
    } else {
      throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
    }
  };
  return defineDataProperty;
}
var hasPropertyDescriptors_1;
var hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var hasPropertyDescriptors = function hasPropertyDescriptors2() {
    return !!$defineProperty;
  };
  hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    if (!$defineProperty) {
      return null;
    }
    try {
      return $defineProperty([], "length", { value: 1 }).length !== 1;
    } catch (e3) {
      return true;
    }
  };
  hasPropertyDescriptors_1 = hasPropertyDescriptors;
  return hasPropertyDescriptors_1;
}
var defineProperties_1;
var hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var keys = requireObjectKeys();
  var hasSymbols2 = typeof Symbol === "function" && typeof /* @__PURE__ */ Symbol("foo") === "symbol";
  var toStr = Object.prototype.toString;
  var concat = Array.prototype.concat;
  var defineDataProperty2 = /* @__PURE__ */ requireDefineDataProperty();
  var isFunction = function(fn2) {
    return typeof fn2 === "function" && toStr.call(fn2) === "[object Function]";
  };
  var supportsDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors()();
  var defineProperty = function(object, name2, value2, predicate) {
    if (name2 in object) {
      if (predicate === true) {
        if (object[name2] === value2) {
          return;
        }
      } else if (!isFunction(predicate) || !predicate()) {
        return;
      }
    }
    if (supportsDescriptors) {
      defineDataProperty2(object, name2, value2, true);
    } else {
      defineDataProperty2(object, name2, value2);
    }
  };
  var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols2) {
      props = concat.call(props, Object.getOwnPropertySymbols(map));
    }
    for (var i3 = 0; i3 < props.length; i3 += 1) {
      defineProperty(object, props[i3], map[props[i3]], predicates[props[i3]]);
    }
  };
  defineProperties.supportsDescriptors = !!supportsDescriptors;
  defineProperties_1 = defineProperties;
  return defineProperties_1;
}
var callBind = { exports: {} };
var esObjectAtoms;
var hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  if (hasRequiredEsObjectAtoms) return esObjectAtoms;
  hasRequiredEsObjectAtoms = 1;
  esObjectAtoms = Object;
  return esObjectAtoms;
}
var esErrors;
var hasRequiredEsErrors;
function requireEsErrors() {
  if (hasRequiredEsErrors) return esErrors;
  hasRequiredEsErrors = 1;
  esErrors = Error;
  return esErrors;
}
var _eval;
var hasRequired_eval;
function require_eval() {
  if (hasRequired_eval) return _eval;
  hasRequired_eval = 1;
  _eval = EvalError;
  return _eval;
}
var range;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  range = RangeError;
  return range;
}
var ref;
var hasRequiredRef;
function requireRef() {
  if (hasRequiredRef) return ref;
  hasRequiredRef = 1;
  ref = ReferenceError;
  return ref;
}
var uri;
var hasRequiredUri;
function requireUri() {
  if (hasRequiredUri) return uri;
  hasRequiredUri = 1;
  uri = URIError;
  return uri;
}
var abs$1;
var hasRequiredAbs;
function requireAbs() {
  if (hasRequiredAbs) return abs$1;
  hasRequiredAbs = 1;
  abs$1 = Math.abs;
  return abs$1;
}
var floor;
var hasRequiredFloor;
function requireFloor() {
  if (hasRequiredFloor) return floor;
  hasRequiredFloor = 1;
  floor = Math.floor;
  return floor;
}
var max$2;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max$2;
  hasRequiredMax = 1;
  max$2 = Math.max;
  return max$2;
}
var min$2;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min$2;
  hasRequiredMin = 1;
  min$2 = Math.min;
  return min$2;
}
var pow;
var hasRequiredPow;
function requirePow() {
  if (hasRequiredPow) return pow;
  hasRequiredPow = 1;
  pow = Math.pow;
  return pow;
}
var round$1;
var hasRequiredRound;
function requireRound() {
  if (hasRequiredRound) return round$1;
  hasRequiredRound = 1;
  round$1 = Math.round;
  return round$1;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
  if (hasRequired_isNaN) return _isNaN;
  hasRequired_isNaN = 1;
  _isNaN = Number.isNaN || function isNaN2(a4) {
    return a4 !== a4;
  };
  return _isNaN;
}
var sign;
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign;
  hasRequiredSign = 1;
  var $isNaN = /* @__PURE__ */ require_isNaN();
  sign = function sign2(number) {
    if ($isNaN(number) || number === 0) {
      return number;
    }
    return number < 0 ? -1 : 1;
  };
  return sign;
}
var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  shams = function hasSymbols2() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
      return false;
    }
    if (typeof Symbol.iterator === "symbol") {
      return true;
    }
    var obj = {};
    var sym = /* @__PURE__ */ Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
      return false;
    }
    var symVal = 42;
    obj[sym] = symVal;
    for (var _2 in obj) {
      return false;
    }
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === "function") {
      var descriptor = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(obj, sym)
      );
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams;
}
var hasSymbols;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== "undefined" && Symbol;
  var hasSymbolSham = requireShams();
  hasSymbols = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
      return false;
    }
    if (typeof Symbol !== "function") {
      return false;
    }
    if (typeof origSymbol("foo") !== "symbol") {
      return false;
    }
    if (typeof /* @__PURE__ */ Symbol("bar") !== "symbol") {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols;
}
var Reflect_getPrototypeOf;
var hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  if (hasRequiredReflect_getPrototypeOf) return Reflect_getPrototypeOf;
  hasRequiredReflect_getPrototypeOf = 1;
  Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
  return Reflect_getPrototypeOf;
}
var Object_getPrototypeOf;
var hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  Object_getPrototypeOf = $Object.getPrototypeOf || null;
  return Object_getPrototypeOf;
}
var implementation$2;
var hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$2;
  hasRequiredImplementation$2 = 1;
  var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
  var toStr = Object.prototype.toString;
  var max2 = Math.max;
  var funcType = "[object Function]";
  var concatty = function concatty2(a4, b3) {
    var arr = [];
    for (var i3 = 0; i3 < a4.length; i3 += 1) {
      arr[i3] = a4[i3];
    }
    for (var j = 0; j < b3.length; j += 1) {
      arr[j + a4.length] = b3[j];
    }
    return arr;
  };
  var slicy = function slicy2(arrLike, offset3) {
    var arr = [];
    for (var i3 = offset3, j = 0; i3 < arrLike.length; i3 += 1, j += 1) {
      arr[j] = arrLike[i3];
    }
    return arr;
  };
  var joiny = function(arr, joiner) {
    var str = "";
    for (var i3 = 0; i3 < arr.length; i3 += 1) {
      str += arr[i3];
      if (i3 + 1 < arr.length) {
        str += joiner;
      }
    }
    return str;
  };
  implementation$2 = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
      if (this instanceof bound) {
        var result = target.apply(
          this,
          concatty(args, arguments)
        );
        if (Object(result) === result) {
          return result;
        }
        return this;
      }
      return target.apply(
        that,
        concatty(args, arguments)
      );
    };
    var boundLength = max2(0, target.length - args.length);
    var boundArgs = [];
    for (var i3 = 0; i3 < boundLength; i3++) {
      boundArgs[i3] = "$" + i3;
    }
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
      var Empty = function Empty2() {
      };
      Empty.prototype = target.prototype;
      bound.prototype = new Empty();
      Empty.prototype = null;
    }
    return bound;
  };
  return implementation$2;
}
var functionBind;
var hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var implementation2 = requireImplementation$2();
  functionBind = Function.prototype.bind || implementation2;
  return functionBind;
}
var functionCall;
var hasRequiredFunctionCall;
function requireFunctionCall() {
  if (hasRequiredFunctionCall) return functionCall;
  hasRequiredFunctionCall = 1;
  functionCall = Function.prototype.call;
  return functionCall;
}
var functionApply;
var hasRequiredFunctionApply;
function requireFunctionApply() {
  if (hasRequiredFunctionApply) return functionApply;
  hasRequiredFunctionApply = 1;
  functionApply = Function.prototype.apply;
  return functionApply;
}
var reflectApply;
var hasRequiredReflectApply;
function requireReflectApply() {
  if (hasRequiredReflectApply) return reflectApply;
  hasRequiredReflectApply = 1;
  reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
  return reflectApply;
}
var actualApply;
var hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply) return actualApply;
  hasRequiredActualApply = 1;
  var bind = requireFunctionBind();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var $reflectApply = requireReflectApply();
  actualApply = $reflectApply || bind.call($call, $apply);
  return actualApply;
}
var callBindApplyHelpers;
var hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers) return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var bind = requireFunctionBind();
  var $TypeError = /* @__PURE__ */ requireType();
  var $call = requireFunctionCall();
  var $actualApply = requireActualApply();
  callBindApplyHelpers = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== "function") {
      throw new $TypeError("a function is required");
    }
    return $actualApply(bind, $call, args);
  };
  return callBindApplyHelpers;
}
var get;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get;
  hasRequiredGet = 1;
  var callBind2 = requireCallBindApplyHelpers();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var hasProtoAccessor;
  try {
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e3) {
    if (!e3 || typeof e3 !== "object" || !("code" in e3) || e3.code !== "ERR_PROTO_ACCESS") {
      throw e3;
    }
  }
  var desc = !!hasProtoAccessor && gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  var $Object = Object;
  var $getPrototypeOf = $Object.getPrototypeOf;
  get = desc && typeof desc.get === "function" ? callBind2([desc.get]) : typeof $getPrototypeOf === "function" ? (
    /** @type {import('./get')} */
    function getDunder(value2) {
      return $getPrototypeOf(value2 == null ? value2 : $Object(value2));
    }
  ) : false;
  return get;
}
var getProto;
var hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto;
  hasRequiredGetProto = 1;
  var reflectGetProto = requireReflect_getPrototypeOf();
  var originalGetProto = requireObject_getPrototypeOf();
  var getDunderProto = /* @__PURE__ */ requireGet();
  getProto = reflectGetProto ? function getProto2(O3) {
    return reflectGetProto(O3);
  } : originalGetProto ? function getProto2(O3) {
    if (!O3 || typeof O3 !== "object" && typeof O3 !== "function") {
      throw new TypeError("getProto: not an object");
    }
    return originalGetProto(O3);
  } : getDunderProto ? function getProto2(O3) {
    return getDunderProto(O3);
  } : null;
  return getProto;
}
var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call2 = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind = requireFunctionBind();
  hasown = bind.call(call2, $hasOwn);
  return hasown;
}
var getIntrinsic;
var hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var undefined$1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var $Error = /* @__PURE__ */ requireEsErrors();
  var $EvalError = /* @__PURE__ */ require_eval();
  var $RangeError = /* @__PURE__ */ requireRange();
  var $ReferenceError = /* @__PURE__ */ requireRef();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var $URIError = /* @__PURE__ */ requireUri();
  var abs2 = /* @__PURE__ */ requireAbs();
  var floor2 = /* @__PURE__ */ requireFloor();
  var max2 = /* @__PURE__ */ requireMax();
  var min2 = /* @__PURE__ */ requireMin();
  var pow2 = /* @__PURE__ */ requirePow();
  var round2 = /* @__PURE__ */ requireRound();
  var sign2 = /* @__PURE__ */ requireSign();
  var $Function = Function;
  var getEvalledConstructor = function(expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e3) {
    }
  };
  var $gOPD = /* @__PURE__ */ requireGopd();
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var throwTypeError = function() {
    throw new $TypeError();
  };
  var ThrowTypeError = $gOPD ? (function() {
    try {
      arguments.callee;
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        return $gOPD(arguments, "callee").get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  })() : throwTypeError;
  var hasSymbols2 = requireHasSymbols()();
  var getProto2 = requireGetProto();
  var $ObjectGPO = requireObject_getPrototypeOf();
  var $ReflectGPO = requireReflect_getPrototypeOf();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var needsEval = {};
  var TypedArray = typeof Uint8Array === "undefined" || !getProto2 ? undefined$1 : getProto2(Uint8Array);
  var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": $EvalError,
    "%Float16Array%": typeof Float16Array === "undefined" ? undefined$1 : Float16Array,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(getProto2([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": $Object,
    "%Object.getOwnPropertyDescriptor%": $gOPD,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
    "%Function.prototype.call%": $call,
    "%Function.prototype.apply%": $apply,
    "%Object.defineProperty%": $defineProperty,
    "%Object.getPrototypeOf%": $ObjectGPO,
    "%Math.abs%": abs2,
    "%Math.floor%": floor2,
    "%Math.max%": max2,
    "%Math.min%": min2,
    "%Math.pow%": pow2,
    "%Math.round%": round2,
    "%Math.sign%": sign2,
    "%Reflect.getPrototypeOf%": $ReflectGPO
  };
  if (getProto2) {
    try {
      null.error;
    } catch (e3) {
      var errorProto = getProto2(getProto2(e3));
      INTRINSICS["%Error.prototype%"] = errorProto;
    }
  }
  var doEval = function doEval2(name2) {
    var value2;
    if (name2 === "%AsyncFunction%") {
      value2 = getEvalledConstructor("async function () {}");
    } else if (name2 === "%GeneratorFunction%") {
      value2 = getEvalledConstructor("function* () {}");
    } else if (name2 === "%AsyncGeneratorFunction%") {
      value2 = getEvalledConstructor("async function* () {}");
    } else if (name2 === "%AsyncGenerator%") {
      var fn2 = doEval2("%AsyncGeneratorFunction%");
      if (fn2) {
        value2 = fn2.prototype;
      }
    } else if (name2 === "%AsyncIteratorPrototype%") {
      var gen = doEval2("%AsyncGenerator%");
      if (gen && getProto2) {
        value2 = getProto2(gen.prototype);
      }
    }
    INTRINSICS[name2] = value2;
    return value2;
  };
  var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  };
  var bind = requireFunctionBind();
  var hasOwn2 = /* @__PURE__ */ requireHasown();
  var $concat = bind.call($call, Array.prototype.concat);
  var $spliceApply = bind.call($apply, Array.prototype.splice);
  var $replace = bind.call($call, String.prototype.replace);
  var $strSlice = bind.call($call, String.prototype.slice);
  var $exec = bind.call($call, RegExp.prototype.exec);
  var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = function stringToPath2(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    } else if (last === "%" && first !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    }
    var result = [];
    $replace(string, rePropName, function(match2, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match2;
    });
    return result;
  };
  var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
    var intrinsicName = name2;
    var alias;
    if (hasOwn2(LEGACY_ALIASES, intrinsicName)) {
      alias = LEGACY_ALIASES[intrinsicName];
      intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn2(INTRINSICS, intrinsicName)) {
      var value2 = INTRINSICS[intrinsicName];
      if (value2 === needsEval) {
        value2 = doEval(intrinsicName);
      }
      if (typeof value2 === "undefined" && !allowMissing) {
        throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
      }
      return {
        alias,
        name: intrinsicName,
        value: value2
      };
    }
    throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
  };
  getIntrinsic = function GetIntrinsic(name2, allowMissing) {
    if (typeof name2 !== "string" || name2.length === 0) {
      throw new $TypeError("intrinsic name must be a non-empty string");
    }
    if (arguments.length > 1 && typeof allowMissing !== "boolean") {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }
    if ($exec(/^%?[^%]*%?$/, name2) === null) {
      throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    }
    var parts = stringToPath(name2);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value2 = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
      intrinsicBaseName = alias[0];
      $spliceApply(parts, $concat([0, 1], alias));
    }
    for (var i3 = 1, isOwn = true; i3 < parts.length; i3 += 1) {
      var part = parts[i3];
      var first = $strSlice(part, 0, 1);
      var last = $strSlice(part, -1);
      if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
        throw new $SyntaxError("property names with quotes must have matching quotes");
      }
      if (part === "constructor" || !isOwn) {
        skipFurtherCaching = true;
      }
      intrinsicBaseName += "." + part;
      intrinsicRealName = "%" + intrinsicBaseName + "%";
      if (hasOwn2(INTRINSICS, intrinsicRealName)) {
        value2 = INTRINSICS[intrinsicRealName];
      } else if (value2 != null) {
        if (!(part in value2)) {
          if (!allowMissing) {
            throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
          }
          return void undefined$1;
        }
        if ($gOPD && i3 + 1 >= parts.length) {
          var desc = $gOPD(value2, part);
          isOwn = !!desc;
          if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
            value2 = desc.get;
          } else {
            value2 = value2[part];
          }
        } else {
          isOwn = hasOwn2(value2, part);
          value2 = value2[part];
        }
        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value2;
        }
      }
    }
    return value2;
  };
  return getIntrinsic;
}
var setFunctionLength;
var hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic();
  var define = /* @__PURE__ */ requireDefineDataProperty();
  var hasDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors()();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var $TypeError = /* @__PURE__ */ requireType();
  var $floor = GetIntrinsic("%Math.floor%");
  setFunctionLength = function setFunctionLength2(fn2, length2) {
    if (typeof fn2 !== "function") {
      throw new $TypeError("`fn` is not a function");
    }
    if (typeof length2 !== "number" || length2 < 0 || length2 > 4294967295 || $floor(length2) !== length2) {
      throw new $TypeError("`length` must be a positive 32-bit integer");
    }
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn2 && gOPD2) {
      var desc = gOPD2(fn2, "length");
      if (desc && !desc.configurable) {
        functionLengthIsConfigurable = false;
      }
      if (desc && !desc.writable) {
        functionLengthIsWritable = false;
      }
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
      if (hasDescriptors) {
        define(
          /** @type {Parameters<define>[0]} */
          fn2,
          "length",
          length2,
          true,
          true
        );
      } else {
        define(
          /** @type {Parameters<define>[0]} */
          fn2,
          "length",
          length2
        );
      }
    }
    return fn2;
  };
  return setFunctionLength;
}
var applyBind;
var hasRequiredApplyBind;
function requireApplyBind() {
  if (hasRequiredApplyBind) return applyBind;
  hasRequiredApplyBind = 1;
  var bind = requireFunctionBind();
  var $apply = requireFunctionApply();
  var actualApply2 = requireActualApply();
  applyBind = function applyBind2() {
    return actualApply2(bind, $apply, arguments);
  };
  return applyBind;
}
var hasRequiredCallBind;
function requireCallBind() {
  if (hasRequiredCallBind) return callBind.exports;
  hasRequiredCallBind = 1;
  (function(module) {
    var setFunctionLength2 = /* @__PURE__ */ requireSetFunctionLength();
    var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
    var callBindBasic = requireCallBindApplyHelpers();
    var applyBind2 = requireApplyBind();
    module.exports = function callBind2(originalFunction) {
      var func = callBindBasic(arguments);
      var adjustedLength = originalFunction.length - (arguments.length - 1);
      return setFunctionLength2(
        func,
        1 + (adjustedLength > 0 ? adjustedLength : 0),
        true
      );
    };
    if ($defineProperty) {
      $defineProperty(module.exports, "apply", { value: applyBind2 });
    } else {
      module.exports.apply = applyBind2;
    }
  })(callBind);
  return callBind.exports;
}
var RequireObjectCoercible;
var hasRequiredRequireObjectCoercible;
function requireRequireObjectCoercible() {
  if (hasRequiredRequireObjectCoercible) return RequireObjectCoercible;
  hasRequiredRequireObjectCoercible = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  RequireObjectCoercible = function RequireObjectCoercible2(value2) {
    if (value2 == null) {
      throw new $TypeError(arguments.length > 0 && arguments[1] || "Cannot call method on " + value2);
    }
    return value2;
  };
  return RequireObjectCoercible;
}
var callBound;
var hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic();
  var callBindBasic = requireCallBindApplyHelpers();
  var $indexOf = callBindBasic([GetIntrinsic("%String.prototype.indexOf%")]);
  callBound = function callBoundIntrinsic(name2, allowMissing) {
    var intrinsic = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      GetIntrinsic(name2, !!allowMissing)
    );
    if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
      return callBindBasic(
        /** @type {const} */
        [intrinsic]
      );
    }
    return intrinsic;
  };
  return callBound;
}
var implementation$1;
var hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$1;
  hasRequiredImplementation$1 = 1;
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var callBound2 = /* @__PURE__ */ requireCallBound();
  var $isEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  implementation$1 = function values(O3) {
    var obj = RequireObjectCoercible2(O3);
    var vals = [];
    for (var key in obj) {
      if ($isEnumerable(obj, key)) {
        vals[vals.length] = obj[key];
      }
    }
    return vals;
  };
  return implementation$1;
}
var polyfill$2;
var hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$2;
  hasRequiredPolyfill$1 = 1;
  var implementation2 = requireImplementation$1();
  polyfill$2 = function getPolyfill() {
    return typeof Object.values === "function" ? Object.values : implementation2;
  };
  return polyfill$2;
}
var shim$1;
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var getPolyfill = requirePolyfill$1();
  var define = requireDefineProperties();
  shim$1 = function shimValues() {
    var polyfill2 = getPolyfill();
    define(Object, { values: polyfill2 }, {
      values: function testValues() {
        return Object.values !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$1;
}
var object_values;
var hasRequiredObject_values;
function requireObject_values() {
  if (hasRequiredObject_values) return object_values;
  hasRequiredObject_values = 1;
  var define = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$1();
  var getPolyfill = requirePolyfill$1();
  var shim2 = requireShim$1();
  var polyfill2 = callBind2(getPolyfill(), Object);
  define(polyfill2, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  object_values = polyfill2;
  return object_values;
}
var implementation;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation;
  hasRequiredImplementation = 1;
  implementation = function contains2(other) {
    if (arguments.length < 1) {
      throw new TypeError("1 argument is required");
    }
    if (typeof other !== "object") {
      throw new TypeError("Argument 1 (”other“) to Node.contains must be an instance of Node");
    }
    var node2 = other;
    do {
      if (this === node2) {
        return true;
      }
      if (node2) {
        node2 = node2.parentNode;
      }
    } while (node2);
    return false;
  };
  return implementation;
}
var polyfill$1;
var hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill$1;
  hasRequiredPolyfill = 1;
  var implementation2 = requireImplementation();
  polyfill$1 = function getPolyfill() {
    if (typeof document !== "undefined") {
      if (document.contains) {
        return document.contains;
      }
      if (document.body && document.body.contains) {
        try {
          if (typeof document.body.contains.call(document, "") === "boolean") {
            return document.body.contains;
          }
        } catch (e3) {
        }
      }
    }
    return implementation2;
  };
  return polyfill$1;
}
var shim;
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var define = requireDefineProperties();
  var getPolyfill = requirePolyfill();
  shim = function shimContains() {
    var polyfill2 = getPolyfill();
    if (typeof document !== "undefined") {
      define(
        document,
        { contains: polyfill2 },
        { contains: function() {
          return document.contains !== polyfill2;
        } }
      );
      if (typeof Element !== "undefined") {
        define(
          Element.prototype,
          { contains: polyfill2 },
          { contains: function() {
            return Element.prototype.contains !== polyfill2;
          } }
        );
      }
    }
    return polyfill2;
  };
  return shim;
}
var document_contains;
var hasRequiredDocument_contains;
function requireDocument_contains() {
  if (hasRequiredDocument_contains) return document_contains;
  hasRequiredDocument_contains = 1;
  var define = requireDefineProperties();
  var implementation2 = requireImplementation();
  var getPolyfill = requirePolyfill();
  var polyfill2 = getPolyfill();
  var shim2 = requireShim();
  var boundContains = function contains2(node2, other) {
    return polyfill2.apply(node2, [other]);
  };
  define(boundContains, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  document_contains = boundContains;
  return document_contains;
}
var hasRequiredOutsideClickHandler;
function requireOutsideClickHandler() {
  if (hasRequiredOutsideClickHandler) return OutsideClickHandler$1;
  hasRequiredOutsideClickHandler = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    var _createClass2 = /* @__PURE__ */ (function() {
      function defineProperties(target, props) {
        for (var i3 = 0; i3 < props.length; i3++) {
          var descriptor = props[i3];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
    var _react = React__default;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes = /* @__PURE__ */ requirePropTypes();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _airbnbPropTypes = requireAirbnbPropTypes();
    var _consolidatedEvents = require$$3;
    var _object = requireObject_values();
    var _object2 = _interopRequireDefault(_object);
    var _document = requireDocument_contains();
    var _document2 = _interopRequireDefault(_document);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var DISPLAY = {
      BLOCK: "block",
      FLEX: "flex",
      INLINE: "inline",
      INLINE_BLOCK: "inline-block",
      CONTENTS: "contents"
    };
    var propTypes2 = (0, _airbnbPropTypes.forbidExtraProps)({
      children: _propTypes2["default"].node.isRequired,
      onOutsideClick: _propTypes2["default"].func.isRequired,
      disabled: _propTypes2["default"].bool,
      useCapture: _propTypes2["default"].bool,
      display: _propTypes2["default"].oneOf((0, _object2["default"])(DISPLAY))
    });
    var defaultProps2 = {
      disabled: false,
      // `useCapture` is set to true by default so that a `stopPropagation` in the
      // children will not prevent all outside click handlers from firing - maja
      useCapture: true,
      display: DISPLAY.BLOCK
    };
    var OutsideClickHandler2 = (function(_React$Component) {
      _inherits2(OutsideClickHandler3, _React$Component);
      function OutsideClickHandler3() {
        var _ref3;
        _classCallCheck2(this, OutsideClickHandler3);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var _this = _possibleConstructorReturn2(this, (_ref3 = OutsideClickHandler3.__proto__ || Object.getPrototypeOf(OutsideClickHandler3)).call.apply(_ref3, [this].concat(args)));
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
        return _this;
      }
      _createClass2(OutsideClickHandler3, [{
        key: "componentDidMount",
        value: /* @__PURE__ */ (function() {
          function componentDidMount() {
            var _props = this.props, disabled2 = _props.disabled, useCapture = _props.useCapture;
            if (!disabled2) this.addMouseDownEventListener(useCapture);
          }
          return componentDidMount;
        })()
      }, {
        key: "componentDidUpdate",
        value: /* @__PURE__ */ (function() {
          function componentDidUpdate(_ref22) {
            var prevDisabled = _ref22.disabled;
            var _props2 = this.props, disabled2 = _props2.disabled, useCapture = _props2.useCapture;
            if (prevDisabled !== disabled2) {
              if (disabled2) {
                this.removeEventListeners();
              } else {
                this.addMouseDownEventListener(useCapture);
              }
            }
          }
          return componentDidUpdate;
        })()
      }, {
        key: "componentWillUnmount",
        value: /* @__PURE__ */ (function() {
          function componentWillUnmount() {
            this.removeEventListeners();
          }
          return componentWillUnmount;
        })()
        // Use mousedown/mouseup to enforce that clicks remain outside the root's
        // descendant tree, even when dragged. This should also get triggered on
        // touch devices.
      }, {
        key: "onMouseDown",
        value: /* @__PURE__ */ (function() {
          function onMouseDown(e3) {
            var useCapture = this.props.useCapture;
            var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e3.target);
            if (!isDescendantOfRoot) {
              if (this.removeMouseUp) {
                this.removeMouseUp();
                this.removeMouseUp = null;
              }
              this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, "mouseup", this.onMouseUp, { capture: useCapture });
            }
          }
          return onMouseDown;
        })()
        // Use mousedown/mouseup to enforce that clicks remain outside the root's
        // descendant tree, even when dragged. This should also get triggered on
        // touch devices.
      }, {
        key: "onMouseUp",
        value: /* @__PURE__ */ (function() {
          function onMouseUp(e3) {
            var onOutsideClick = this.props.onOutsideClick;
            var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e3.target);
            if (this.removeMouseUp) {
              this.removeMouseUp();
              this.removeMouseUp = null;
            }
            if (!isDescendantOfRoot) {
              onOutsideClick(e3);
            }
          }
          return onMouseUp;
        })()
      }, {
        key: "setChildNodeRef",
        value: /* @__PURE__ */ (function() {
          function setChildNodeRef(ref2) {
            this.childNode = ref2;
          }
          return setChildNodeRef;
        })()
      }, {
        key: "addMouseDownEventListener",
        value: /* @__PURE__ */ (function() {
          function addMouseDownEventListener(useCapture) {
            this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, "mousedown", this.onMouseDown, { capture: useCapture });
          }
          return addMouseDownEventListener;
        })()
      }, {
        key: "removeEventListeners",
        value: /* @__PURE__ */ (function() {
          function removeEventListeners() {
            if (this.removeMouseDown) this.removeMouseDown();
            if (this.removeMouseUp) this.removeMouseUp();
          }
          return removeEventListeners;
        })()
      }, {
        key: "render",
        value: /* @__PURE__ */ (function() {
          function render() {
            var _props3 = this.props, children = _props3.children, display = _props3.display;
            return _react2["default"].createElement(
              "div",
              {
                ref: this.setChildNodeRef,
                style: display !== DISPLAY.BLOCK && (0, _object2["default"])(DISPLAY).includes(display) ? { display } : void 0
              },
              children
            );
          }
          return render;
        })()
      }]);
      return OutsideClickHandler3;
    })(_react2["default"].Component);
    exports$1["default"] = OutsideClickHandler2;
    OutsideClickHandler2.propTypes = propTypes2;
    OutsideClickHandler2.defaultProps = defaultProps2;
  })(OutsideClickHandler$1);
  return OutsideClickHandler$1;
}
var reactOutsideClickHandler;
var hasRequiredReactOutsideClickHandler;
function requireReactOutsideClickHandler() {
  if (hasRequiredReactOutsideClickHandler) return reactOutsideClickHandler;
  hasRequiredReactOutsideClickHandler = 1;
  reactOutsideClickHandler = requireOutsideClickHandler();
  return reactOutsideClickHandler;
}
var reactOutsideClickHandlerExports = requireReactOutsideClickHandler();
const OutsideClickHandler = /* @__PURE__ */ getDefaultExportFromCjs(reactOutsideClickHandlerExports);
const MenuIcon = () => {
  return /* @__PURE__ */ jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2650_8833)", children: /* @__PURE__ */ jsx$1("path", { d: "M7.99935 5.33464C8.73268 5.33464 9.33268 4.73464 9.33268 4.0013C9.33268 3.26797 8.73268 2.66797 7.99935 2.66797C7.26602 2.66797 6.66602 3.26797 6.66602 4.0013C6.66602 4.73464 7.26602 5.33464 7.99935 5.33464ZM7.99935 6.66797C7.26602 6.66797 6.66602 7.26797 6.66602 8.0013C6.66602 8.73463 7.26602 9.33463 7.99935 9.33463C8.73268 9.33463 9.33268 8.73463 9.33268 8.0013C9.33268 7.26797 8.73268 6.66797 7.99935 6.66797ZM7.99935 10.668C7.26602 10.668 6.66602 11.268 6.66602 12.0013C6.66602 12.7346 7.26602 13.3346 7.99935 13.3346C8.73268 13.3346 9.33268 12.7346 9.33268 12.0013C9.33268 11.268 8.73268 10.668 7.99935 10.668Z", fill: "#006AFF" }) }),
    /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2650_8833", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
  ] });
};
const right$1 = "sz-dropdown-menu-module_right__3VH7N";
const left$1 = "sz-dropdown-menu-module_left__oYcc9";
const label$7 = "sz-dropdown-menu-module_label__c92KJ";
const iconContainer = "sz-dropdown-menu-module_iconContainer__G9NnR";
const btnLabel = "sz-dropdown-menu-module_btnLabel__v9id9";
const styles$G = {
  "menu-main-container": "sz-dropdown-menu-module_menu-main-container__SzRWh",
  "dropdown-menu-container": "sz-dropdown-menu-module_dropdown-menu-container__zwW0g",
  right: right$1,
  left: left$1,
  "dropdown-menu-content": "sz-dropdown-menu-module_dropdown-menu-content__adkXY",
  "menu-item-button": "sz-dropdown-menu-module_menu-item-button__ndHXg",
  label: label$7,
  "additional-info": "sz-dropdown-menu-module_additional-info__pYGoz",
  iconContainer,
  "item-info-container": "sz-dropdown-menu-module_item-info-container__twDZi",
  "menu-button": "sz-dropdown-menu-module_menu-button__eH8f5",
  btnLabel,
  "item-icons-container": "sz-dropdown-menu-module_item-icons-container__TYrb7"
};
const DropdownMenuButton = ({
  id,
  label: label2,
  disabled: disabled2 = false,
  size,
  ariaLabel,
  onClick,
  showIcon,
  icon: icon2,
  rightIcon
}) => {
  const leftIcon = showIcon ? icon2 || /* @__PURE__ */ jsx$1(MenuIcon, {}) : void 0;
  return /* @__PURE__ */ jsx$1(
    Button$1,
    {
      id,
      "data-testid": "dropdown-menu",
      variant: "secondary",
      className: styles$G["menu-button"],
      size,
      leftIcon,
      rightIcon,
      onClick,
      disabled: disabled2,
      ariaLabel,
      children: label2 && /* @__PURE__ */ jsx$1("span", { className: styles$G.btnLabel, children: label2 })
    }
  );
};
const DropdownMenuContainer = forwardRef(({ children, align, className, ...props }, ref2) => {
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      ref: ref2,
      className: clsx(
        styles$G["dropdown-menu-container"],
        align === MenuPosition.LEFT ? styles$G.left : styles$G.right,
        className
      ),
      ...props,
      children
    }
  );
});
const DropdownMenuItem = ({
  label: label2,
  avatar: avatar2,
  icon: icon2,
  additionalInfo,
  ariaLabel,
  role,
  onClick = () => {
  },
  onEnter,
  className,
  disabled: disabled2,
  dataTestId,
  tooltip: tooltip2,
  component,
  to,
  target
}) => {
  const Component2 = component || "button";
  const onKeyboardPress = (event) => {
    if (disabled2) return;
    const { code } = event;
    if ((code === "Enter" || code === "Space") && onEnter) {
      event.preventDefault();
      onEnter();
    } else if (code === "Tab") {
      event.preventDefault();
    }
  };
  const handleClick = () => {
    if (!disabled2) onClick();
  };
  return /* @__PURE__ */ jsx$1(DropdownMenuItemWithTooltip, { tooltip: tooltip2, children: /* @__PURE__ */ jsxs(
    Component2,
    {
      "aria-label": ariaLabel || label2,
      className: clsx(styles$G["menu-item-button"], className),
      onClick: handleClick,
      onKeyDown: onKeyboardPress,
      role,
      "aria-disabled": disabled2,
      "data-testid": dataTestId,
      ...to && { to },
      ...target && { target },
      children: [
        /* @__PURE__ */ jsxs("div", { className: clsx(styles$G["item-icons-container"]), children: [
          avatar2 && /* @__PURE__ */ jsx$1(Avatar, { user: avatar2, isInteractive: false, size: "small" }),
          /* @__PURE__ */ jsx$1("div", { className: styles$G.iconContainer, children: icon2 })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: clsx(styles$G["item-info-container"]), children: [
          /* @__PURE__ */ jsx$1("span", { className: clsx(styles$G["label"]), children: label2 }),
          additionalInfo && /* @__PURE__ */ jsx$1("span", { className: clsx(styles$G["additional-info"]), children: additionalInfo })
        ] })
      ]
    }
  ) });
};
function DropdownMenuItemWithTooltip({
  tooltip: tooltip2,
  children
}) {
  if (!tooltip2) {
    return children;
  }
  return /* @__PURE__ */ jsx$1(Tooltip$3, { content: tooltip2, children });
}
var define_process_env_default$1 = {};
const OutsideClickHandlerTyped = OutsideClickHandler;
var MenuPosition = /* @__PURE__ */ ((MenuPosition2) => {
  MenuPosition2["LEFT"] = "left";
  MenuPosition2["RIGHT"] = "right";
  return MenuPosition2;
})(MenuPosition || {});
const DropdownMenu = forwardRef(
  ({
    id,
    label: label2,
    disabled: disabled2,
    options: options2,
    content: content2,
    showMenu = false,
    closeOnSelect = true,
    align = "right",
    size = "large",
    ariaLabel,
    showIcon = true,
    renderButton,
    onDropdownMenuButtonClick,
    onExpandedChange,
    dataTestId = "dropdown-menu-wrapper",
    icon: icon2,
    rightIcon,
    className,
    classNameDropdownMenu,
    portal = false,
    direction = "down"
  }, ref2) => {
    const menuButtonId = id || "dropdown-menu-button";
    const [expanded2, setExpanded] = useState(showMenu);
    const wrapperRef = useRef(null);
    const portalMenuRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState();
    const updatePortalPosition = useCallback(() => {
      const trigger2 = wrapperRef.current;
      const menu = portalMenuRef.current;
      if (!trigger2 || !menu) {
        return;
      }
      const rect = trigger2.getBoundingClientRect();
      const gap = 4;
      const viewportPadding = 8;
      const spaceBelow = window.innerHeight - rect.bottom - gap;
      const spaceAbove = rect.top - gap;
      const naturalHeight = menu.scrollHeight;
      const fits = (space2) => naturalHeight <= space2 - viewportPadding;
      const preferred = direction === "up" ? spaceAbove : spaceBelow;
      const fallback = direction === "up" ? spaceBelow : spaceAbove;
      const usePreferred = fits(preferred) || preferred >= fallback;
      const openUp = direction === "up" ? usePreferred : !usePreferred;
      const space = openUp ? spaceAbove : spaceBelow;
      const style2 = {
        position: "fixed",
        zIndex: 1e3,
        margin: 0,
        borderRadius: 4,
        maxHeight: Math.max(space - viewportPadding, 0),
        overflowY: "auto"
      };
      if (openUp) {
        style2.bottom = window.innerHeight - rect.top + gap;
        style2.top = "auto";
      } else {
        style2.top = rect.bottom + gap;
        style2.bottom = "auto";
      }
      if (align === "right") {
        style2.right = window.innerWidth - rect.right;
        style2.left = "auto";
      } else {
        style2.left = rect.left;
        style2.right = "auto";
      }
      setPortalStyle(style2);
    }, [align, direction]);
    useLayoutEffect$1(() => {
      if (!portal || !expanded2) {
        setPortalStyle(void 0);
        return void 0;
      }
      updatePortalPosition();
      window.addEventListener("scroll", updatePortalPosition, true);
      window.addEventListener("resize", updatePortalPosition);
      return () => {
        window.removeEventListener("scroll", updatePortalPosition, true);
        window.removeEventListener("resize", updatePortalPosition);
      };
    }, [portal, expanded2, updatePortalPosition]);
    const isTestEnv = () => define_process_env_default$1.JEST_WORKER_ID !== void 0;
    useImperativeHandle(ref2, () => ({
      collapseDropdownMenu: () => setExpanded(false)
    }));
    useEffect(() => {
      setExpanded(showMenu);
    }, [showMenu]);
    useEffect(() => {
      if (expanded2 !== showMenu) {
        onExpandedChange?.(expanded2);
      }
    }, [expanded2]);
    useEffect(() => {
      if (expanded2 && (isTestEnv() || document.getElementById(menuButtonId)?.matches(":focus-visible"))) {
        activate(
          document.getElementById("dropdown-menu-container")?.firstChild
        );
      }
    }, [expanded2]);
    useEffect(() => {
      document.getElementById(menuButtonId)?.setAttribute("aria-expanded", `${expanded2}`);
    }, [expanded2]);
    const activate = (item2) => {
      item2.focus();
    };
    const focusNextItem = () => {
      const item2 = document.activeElement;
      if (item2?.nextElementSibling) {
        activate(item2.nextElementSibling);
      }
    };
    const focusPreviousItem = () => {
      const item2 = document.activeElement;
      if (item2?.previousElementSibling) {
        activate(item2.previousElementSibling);
      }
    };
    const handleKeyDown = (event) => {
      const { code } = event;
      switch (code) {
        case "Tab":
          if (expanded2) {
            document.getElementById(menuButtonId)?.focus();
            setExpanded(false);
          }
          break;
        case "Escape":
          if (expanded2) {
            event.stopPropagation();
            setExpanded(false);
          }
          break;
        case "Enter":
        case "Space":
          if (closeOnSelect) {
            setExpanded(false);
          }
          break;
        case "ArrowUp":
          event.preventDefault();
          return focusPreviousItem();
        case "ArrowDown":
          event.preventDefault();
          return focusNextItem();
      }
    };
    const handleItemClick = (itemOnClick) => {
      if (closeOnSelect) {
        setExpanded(false);
      }
      if (itemOnClick) {
        itemOnClick();
      }
    };
    const handleDropdownMenuButtonClick = () => {
      setExpanded(!expanded2);
      onDropdownMenuButtonClick?.();
    };
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        ref: wrapperRef,
        className: clsx(styles$G["menu-main-container"], className),
        onKeyDown: handleKeyDown,
        "data-testid": dataTestId,
        children: /* @__PURE__ */ jsxs(
          OutsideClickHandlerTyped,
          {
            onOutsideClick: (event) => {
              if (portal && portalMenuRef.current?.contains(
                event.target
              )) {
                return;
              }
              expanded2 && setExpanded(false);
            },
            children: [
              renderButton ? renderButton(menuButtonId, expanded2, handleDropdownMenuButtonClick) : /* @__PURE__ */ jsx$1(
                DropdownMenuButton,
                {
                  id: menuButtonId,
                  label: label2,
                  disabled: disabled2,
                  onClick: handleDropdownMenuButtonClick,
                  size,
                  ariaLabel: ariaLabel || "Menu button",
                  "aria-expanded": expanded2,
                  showIcon,
                  icon: icon2,
                  rightIcon
                }
              ),
              expanded2 && ((menuContainer) => {
                return portal ? createPortal(menuContainer, document.body) : menuContainer;
              })(
                /* @__PURE__ */ jsxs(
                  DropdownMenuContainer,
                  {
                    ref: portal ? portalMenuRef : void 0,
                    "data-testid": `${dataTestId}-dropdown-menu-container`,
                    align,
                    id: "dropdown-menu-container",
                    className: classNameDropdownMenu,
                    style: portal ? portalStyle ?? {
                      position: "fixed",
                      visibility: "hidden"
                    } : void 0,
                    children: [
                      content2 && /* @__PURE__ */ jsx$1("div", { className: styles$G["dropdown-menu-content"], children: content2 }),
                      options2?.map((option, index2) => /* @__PURE__ */ jsx$1(
                        DropdownMenuItem,
                        {
                          label: option.label,
                          avatar: option.avatar,
                          ariaLabel: option.ariaLabel || option.label,
                          icon: option.icon,
                          additionalInfo: option.additionalInfo,
                          role: option.role,
                          onClick: () => handleItemClick(option.onClick),
                          onEnter: () => handleItemClick(option.onClick),
                          className: option.className,
                          disabled: option.disabled,
                          tooltip: option.tooltip,
                          dataTestId: `${dataTestId}-dropdown-menu-item-${index2}`,
                          component: option.component,
                          to: option.to,
                          target: option.target
                        },
                        index2
                      ))
                    ]
                  }
                )
              )
            ]
          }
        )
      }
    );
  }
);
var lib$2 = {};
var uaParser_min$1 = { exports: {} };
var uaParser_min = uaParser_min$1.exports;
var hasRequiredUaParser_min;
function requireUaParser_min() {
  if (hasRequiredUaParser_min) return uaParser_min$1.exports;
  hasRequiredUaParser_min = 1;
  (function(module, exports$1) {
    (function(window2, undefined$1) {
      var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
      var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
      var extend = function(regexes2, extensions) {
        var mergedRegexes = {};
        for (var i3 in regexes2) {
          if (extensions[i3] && extensions[i3].length % 2 === 0) {
            mergedRegexes[i3] = extensions[i3].concat(regexes2[i3]);
          } else {
            mergedRegexes[i3] = regexes2[i3];
          }
        }
        return mergedRegexes;
      }, enumerize = function(arr) {
        var enums = {};
        for (var i3 = 0; i3 < arr.length; i3++) {
          enums[arr[i3].toUpperCase()] = arr[i3];
        }
        return enums;
      }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      }, lowerize = function(str) {
        return str.toLowerCase();
      }, majorize = function(version2) {
        return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      }, trim2 = function(str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };
      var rgxMapper = function(ua, arrays) {
        var i3 = 0, j, k3, p2, q3, matches2, match2;
        while (i3 < arrays.length && !matches2) {
          var regex = arrays[i3], props = arrays[i3 + 1];
          j = k3 = 0;
          while (j < regex.length && !matches2) {
            if (!regex[j]) {
              break;
            }
            matches2 = regex[j++].exec(ua);
            if (!!matches2) {
              for (p2 = 0; p2 < props.length; p2++) {
                match2 = matches2[++k3];
                q3 = props[p2];
                if (typeof q3 === OBJ_TYPE && q3.length > 0) {
                  if (q3.length === 2) {
                    if (typeof q3[1] == FUNC_TYPE) {
                      this[q3[0]] = q3[1].call(this, match2);
                    } else {
                      this[q3[0]] = q3[1];
                    }
                  } else if (q3.length === 3) {
                    if (typeof q3[1] === FUNC_TYPE && !(q3[1].exec && q3[1].test)) {
                      this[q3[0]] = match2 ? q3[1].call(this, match2, q3[2]) : undefined$1;
                    } else {
                      this[q3[0]] = match2 ? match2.replace(q3[1], q3[2]) : undefined$1;
                    }
                  } else if (q3.length === 4) {
                    this[q3[0]] = match2 ? q3[3].call(this, match2.replace(q3[1], q3[2])) : undefined$1;
                  }
                } else {
                  this[q3] = match2 ? match2 : undefined$1;
                }
              }
            }
          }
          i3 += 2;
        }
      }, strMapper = function(str, map) {
        for (var i3 in map) {
          if (typeof map[i3] === OBJ_TYPE && map[i3].length > 0) {
            for (var j = 0; j < map[i3].length; j++) {
              if (has(map[i3][j], str)) {
                return i3 === UNKNOWN ? undefined$1 : i3;
              }
            }
          } else if (has(map[i3], str)) {
            return i3 === UNKNOWN ? undefined$1 : i3;
          }
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
      };
      var oldSafariMap = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, windowsVersionMap = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" };
      var regexes = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [VERSION, [NAME, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i], [VERSION, [NAME, OPERA + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " GX"]], [/\bopr\/([\w\.]+)/i], [VERSION, [NAME, OPERA]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [VERSION, [NAME, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [VERSION, [NAME, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [NAME, VERSION], [/quark(?:pc)?\/([-\w\.]+)/i], [VERSION, [NAME, "Quark"]], [/\bddg\/([\w\.]+)/i], [VERSION, [NAME, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [VERSION, [NAME, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [VERSION, [NAME, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [VERSION, [NAME, "Smart Lenovo " + BROWSER]], [/(avast|avg)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI" + SUFFIX_BROWSER]], [/fxios\/([\w\.-]+)/i], [VERSION, [NAME, FIREFOX]], [/\bqihoobrowser\/?([\w\.]*)/i], [VERSION, [NAME, "360"]], [/\b(qq)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1Browser"], VERSION], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1" + SUFFIX_BROWSER], VERSION], [/samsungbrowser\/([\w\.]+)/i], [VERSION, [NAME, SAMSUNG + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [VERSION, [NAME, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[NAME, "Sogou Mobile"], VERSION], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [NAME, VERSION], [/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i], [NAME], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [VERSION, NAME], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[NAME, FACEBOOK], VERSION], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /(daum)apps[\/ ]([\w\.]+)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i], [VERSION, [NAME, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [VERSION, [NAME, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[NAME, "Netscape"], VERSION], [/(wolvic|librewolf)\/([\w\.]+)/i], [NAME, VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /\b(links) \(([\w\.]+)/i], [NAME, [VERSION, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [NAME, [VERSION, /master.|lts./, ""]]], cpu: [[/\b((amd|x|x86[-_]?|wow|win)64)\b/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i], [[ARCHITECTURE, "arm64"]], [/\b(arm(v[67])?ht?n?[fl]p?)\b/i], [[ARCHITECTURE, "armhf"]], [/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i], [[ARCHITECTURE, "arm"]], [/((ppc|powerpc)(64)?)( mac|;|\))/i], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/ sun4\w[;\)]/i], [[ARCHITECTURE, "sparc"]], [/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i], [[ARCHITECTURE, lowerize]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i], [MODEL, [VENDOR, HONOR], [TYPE, TABLET]], [/honor([-\w ]+)[;\)]/i], [MODEL, [VENDOR, HONOR], [TYPE, MOBILE]], [/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i, / ([\w ]+) miui\/v?\d/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, OPPO], [TYPE, MOBILE]], [/\b(opd2(\d{3}a?))(?: bui|\))/i], [MODEL, [VENDOR, strMapper, { OnePlus: ["304", "403", "203"], "*": OPPO }], [TYPE, TABLET]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i], [MODEL, [VENDOR, LENOVO], [TYPE, TABLET]], [/(nokia) (t[12][01])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i], [[MODEL, /_/g, " "], [TYPE, MOBILE], [VENDOR, "Nokia"]], [/(pixel (c|tablet))\b/i], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, ONEPLUS], [TYPE, MOBILE]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [/(playbook);[-\w\),; ]+(rim)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [/(nexus 9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i], [MODEL, [VENDOR, "TCL"], [TYPE, TABLET]], [/(itel) ((\w+))/i], [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { tablet: ["p10001l", "w7001"], "*": "mobile" }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [MODEL, [VENDOR, "Energizer"], [TYPE, MOBILE]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [MODEL, [VENDOR, "Cat"], [TYPE, MOBILE]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [MODEL, [VENDOR, "Smartfren"], [TYPE, MOBILE]], [/droid.+; (a(?:015|06[35]|142p?))/i], [MODEL, [VENDOR, "Nothing"], [TYPE, MOBILE]], [/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i, /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i], [MODEL, [VENDOR, "Archos"], [TYPE, TABLET]], [/archos ([\w ]+)( b|\))/i, /; (ac[3-6]\d\w{2,8})( b|\))/i], [MODEL, [VENDOR, "Archos"], [TYPE, MOBILE]], [/(imo) (tab \w+)/i, /(infinix) (x1101b?)/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (hmd|imo) ([\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i, /(oppo) ?([\w ]+) bui/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kobo)\s(ereader|touch)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i], [MODEL, [VENDOR, NVIDIA], [TYPE, TABLET]], [/(sprint) (\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w+)( bui|\))/i], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/(shield \w+ tv)/i], [MODEL, [VENDOR, NVIDIA], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mi(tv|box)-?\w+) bui/i], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/Hbbtv.*(technisat) (.*);/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]], [/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i], [MODEL, [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[TYPE, SMARTTV]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield)( bui|\))/i], [MODEL, [VENDOR, NVIDIA], [TYPE, CONSOLE]], [/(playstation \w+)/i], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]], [/((pebble))app/i, /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/(ow(?:19|20)?we?[1-3]{1,3})/i], [MODEL, [VENDOR, OPPO], [TYPE, WEARABLE]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [/(opwwe\d{3})/i], [MODEL, [VENDOR, ONEPLUS], [TYPE, WEARABLE]], [/(moto 360)/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, WEARABLE]], [/(smartwatch 3)/i], [MODEL, [VENDOR, SONY], [TYPE, WEARABLE]], [/(g watch r)/i], [MODEL, [VENDOR, LG], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/droid.+; (glass) \d/i], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/(pico) (4|neo3(?: link|pro)?)/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/; (quest( \d| pro)?)/i], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [VENDOR, [TYPE, EMBEDDED]], [/(aeobc)\b/i], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [/(homepod).+mac os/i], [MODEL, [VENDOR, APPLE], [TYPE, EMBEDDED]], [/windows iot/i], [[TYPE, EMBEDDED]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[TYPE, MOBILE]], [/droid .+?; ([\w\. -]+)( bui|\))/i], [MODEL, [VENDOR, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [VERSION, [NAME, EDGE + "HTML"]], [/(arkweb)\/([\w\.]+)/i], [NAME, VERSION], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [NAME, VERSION], [/ladybird\//i], [[NAME, "LibWeb"]], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [VERSION, NAME]], os: [[/microsoft (windows) (vista|xp)/i], [NAME, VERSION], [/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[VERSION, strMapper, windowsVersionMap], [NAME, "Windows"]], [/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[NAME, MAC_OS], [VERSION, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [VERSION, NAME], [/(ubuntu) ([\w\.]+) like android/i], [[NAME, /(.+)/, "$1 Touch"], VERSION], [/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i], [NAME, VERSION], [/\(bb(10);/i], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [VERSION, [NAME, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [VERSION, [NAME, "watchOS"]], [/crkey\/([\d\.]+)/i], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[NAME, CHROMIUM_OS], VERSION], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [NAME, VERSION]] };
      var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
          extensions = ua;
          ua = undefined$1;
        }
        if (!(this instanceof UAParser)) {
          return new UAParser(ua, extensions).getResult();
        }
        var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
          var _browser = {};
          _browser[NAME] = undefined$1;
          _browser[VERSION] = undefined$1;
          rgxMapper.call(_browser, _ua, _rgxmap.browser);
          _browser[MAJOR] = majorize(_browser[VERSION]);
          if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
            _browser[NAME] = "Brave";
          }
          return _browser;
        };
        this.getCPU = function() {
          var _cpu = {};
          _cpu[ARCHITECTURE] = undefined$1;
          rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
          return _cpu;
        };
        this.getDevice = function() {
          var _device = {};
          _device[VENDOR] = undefined$1;
          _device[MODEL] = undefined$1;
          _device[TYPE] = undefined$1;
          rgxMapper.call(_device, _ua, _rgxmap.device);
          if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
            _device[TYPE] = MOBILE;
          }
          if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
            _device[MODEL] = "iPad";
            _device[TYPE] = TABLET;
          }
          return _device;
        };
        this.getEngine = function() {
          var _engine = {};
          _engine[NAME] = undefined$1;
          _engine[VERSION] = undefined$1;
          rgxMapper.call(_engine, _ua, _rgxmap.engine);
          return _engine;
        };
        this.getOS = function() {
          var _os = {};
          _os[NAME] = undefined$1;
          _os[VERSION] = undefined$1;
          rgxMapper.call(_os, _ua, _rgxmap.os);
          if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") {
            _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
          }
          return _os;
        };
        this.getResult = function() {
          return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
        };
        this.getUA = function() {
          return _ua;
        };
        this.setUA = function(ua2) {
          _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim2(ua2, UA_MAX_LENGTH) : ua2;
          return this;
        };
        this.setUA(_ua);
        return this;
      };
      UAParser.VERSION = LIBVERSION;
      UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
      UAParser.CPU = enumerize([ARCHITECTURE]);
      UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
      UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
      {
        if (module.exports) {
          exports$1 = module.exports = UAParser;
        }
        exports$1.UAParser = UAParser;
      }
      var $2 = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
      if ($2 && !$2.ua) {
        var parser = new UAParser();
        $2.ua = parser.getResult();
        $2.ua.get = function() {
          return parser.getUA();
        };
        $2.ua.set = function(ua) {
          parser.setUA(ua);
          var result = parser.getResult();
          for (var prop in result) {
            $2.ua[prop] = result[prop];
          }
        };
      }
    })(typeof window === "object" ? window : uaParser_min);
  })(uaParser_min$1, uaParser_min$1.exports);
  return uaParser_min$1.exports;
}
var hasRequiredLib$2;
function requireLib$2() {
  if (hasRequiredLib$2) return lib$2;
  hasRequiredLib$2 = 1;
  Object.defineProperty(lib$2, "__esModule", { value: true });
  function _interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
  }
  var React2 = React__default;
  var React__default$1 = _interopDefault(React2);
  var UAParser = requireUaParser_min();
  var ClientUAInstance = new UAParser();
  var browser = ClientUAInstance.getBrowser();
  var cpu = ClientUAInstance.getCPU();
  var device = ClientUAInstance.getDevice();
  var engine = ClientUAInstance.getEngine();
  var os = ClientUAInstance.getOS();
  var ua = ClientUAInstance.getUA();
  var setUa = function setUa2(userAgentString) {
    return ClientUAInstance.setUA(userAgentString);
  };
  var parseUserAgent = function parseUserAgent2(userAgent) {
    if (!userAgent) {
      console.error("No userAgent string was provided");
      return;
    }
    var UserAgentInstance = new UAParser(userAgent);
    return {
      UA: UserAgentInstance,
      browser: UserAgentInstance.getBrowser(),
      cpu: UserAgentInstance.getCPU(),
      device: UserAgentInstance.getDevice(),
      engine: UserAgentInstance.getEngine(),
      os: UserAgentInstance.getOS(),
      ua: UserAgentInstance.getUA(),
      setUserAgent: function setUserAgent2(userAgentString) {
        return UserAgentInstance.setUA(userAgentString);
      }
    };
  };
  var UAHelper = /* @__PURE__ */ Object.freeze({
    ClientUAInstance,
    browser,
    cpu,
    device,
    engine,
    os,
    ua,
    setUa,
    parseUserAgent
  });
  function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread22(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3] != null ? arguments[i3] : {};
      if (i3 % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i3 = 0; i3 < props.length; i3++) {
      var descriptor = props[i3];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    return Constructor;
  }
  function _defineProperty2(obj, key, value2) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value2,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value2;
    }
    return obj;
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i3 = 1; i3 < arguments.length; i3++) {
        var source = arguments[i3];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _getPrototypeOf2(o2) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o3) {
      return o3.__proto__ || Object.getPrototypeOf(o3);
    };
    return _getPrototypeOf2(o2);
  }
  function _setPrototypeOf2(o2, p2) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o3, p3) {
      o3.__proto__ = p3;
      return o3;
    };
    return _setPrototypeOf2(o2, p2);
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i3;
    for (i3 = 0; i3 < sourceKeys.length; i3++) {
      key = sourceKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties2(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose2(source, excluded);
    var key, i3;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
        key = sourceSymbolKeys[i3];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
      return call2;
    } else if (call2 !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _slicedToArray2(arr, i3) {
    return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i3) || _unsupportedIterableToArray2(arr, i3) || _nonIterableRest2();
  }
  function _arrayWithHoles2(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArrayLimit2(arr, i3) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e2;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i3 && _arr.length === i3) break;
      }
    } catch (err) {
      _d = true;
      _e2 = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e2;
      }
    }
    return _arr;
  }
  function _unsupportedIterableToArray2(o2, minLen) {
    if (!o2) return;
    if (typeof o2 === "string") return _arrayLikeToArray2(o2, minLen);
    var n2 = Object.prototype.toString.call(o2).slice(8, -1);
    if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
    if (n2 === "Map" || n2 === "Set") return Array.from(o2);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray2(o2, minLen);
  }
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
    return arr2;
  }
  function _nonIterableRest2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: void 0
  };
  var BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
  };
  var OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
  };
  var InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
  };
  var checkDeviceType = function checkDeviceType2(type2) {
    switch (type2) {
      case DeviceTypes.Mobile:
        return {
          isMobile: true
        };
      case DeviceTypes.Tablet:
        return {
          isTablet: true
        };
      case DeviceTypes.SmartTv:
        return {
          isSmartTV: true
        };
      case DeviceTypes.Console:
        return {
          isConsole: true
        };
      case DeviceTypes.Wearable:
        return {
          isWearable: true
        };
      case DeviceTypes.Browser:
        return {
          isBrowser: true
        };
      case DeviceTypes.Embedded:
        return {
          isEmbedded: true
        };
      default:
        return InitialDeviceTypes;
    }
  };
  var setUserAgent = function setUserAgent2(userAgent) {
    return setUa(userAgent);
  };
  var setDefaults = function setDefaults2(p2) {
    var d4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
    return p2 ? p2 : d4;
  };
  var getNavigatorInstance = function getNavigatorInstance2() {
    if (typeof window !== "undefined") {
      if (window.navigator || navigator) {
        return window.navigator || navigator;
      }
    }
    return false;
  };
  var isIOS13Check = function isIOS13Check2(type2) {
    var nav2 = getNavigatorInstance();
    return nav2 && nav2.platform && (nav2.platform.indexOf(type2) !== -1 || nav2.platform === "MacIntel" && nav2.maxTouchPoints > 1 && !window.MSStream);
  };
  var browserPayload = function browserPayload2(isBrowser3, browser2, engine2, os2, ua2) {
    return {
      isBrowser: isBrowser3,
      browserMajorVersion: setDefaults(browser2.major),
      browserFullVersion: setDefaults(browser2.version),
      browserName: setDefaults(browser2.name),
      engineName: setDefaults(engine2.name),
      engineVersion: setDefaults(engine2.version),
      osName: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      userAgent: setDefaults(ua2)
    };
  };
  var mobilePayload = function mobilePayload2(type2, device2, os2, ua2) {
    return _objectSpread22({}, type2, {
      vendor: setDefaults(device2.vendor),
      model: setDefaults(device2.model),
      os: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      ua: setDefaults(ua2)
    });
  };
  var smartTvPayload = function smartTvPayload2(isSmartTV2, engine2, os2, ua2) {
    return {
      isSmartTV: isSmartTV2,
      engineName: setDefaults(engine2.name),
      engineVersion: setDefaults(engine2.version),
      osName: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      userAgent: setDefaults(ua2)
    };
  };
  var consolePayload = function consolePayload2(isConsole2, engine2, os2, ua2) {
    return {
      isConsole: isConsole2,
      engineName: setDefaults(engine2.name),
      engineVersion: setDefaults(engine2.version),
      osName: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      userAgent: setDefaults(ua2)
    };
  };
  var wearablePayload = function wearablePayload2(isWearable2, engine2, os2, ua2) {
    return {
      isWearable: isWearable2,
      engineName: setDefaults(engine2.name),
      engineVersion: setDefaults(engine2.version),
      osName: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      userAgent: setDefaults(ua2)
    };
  };
  var embeddedPayload = function embeddedPayload2(isEmbedded2, device2, engine2, os2, ua2) {
    return {
      isEmbedded: isEmbedded2,
      vendor: setDefaults(device2.vendor),
      model: setDefaults(device2.model),
      engineName: setDefaults(engine2.name),
      engineVersion: setDefaults(engine2.version),
      osName: setDefaults(os2.name),
      osVersion: setDefaults(os2.version),
      userAgent: setDefaults(ua2)
    };
  };
  function deviceDetect(userAgent) {
    var _ref3 = userAgent ? parseUserAgent(userAgent) : UAHelper, device2 = _ref3.device, browser2 = _ref3.browser, engine2 = _ref3.engine, os2 = _ref3.os, ua2 = _ref3.ua;
    var type2 = checkDeviceType(device2.type);
    var isBrowser3 = type2.isBrowser, isMobile3 = type2.isMobile, isTablet2 = type2.isTablet, isSmartTV2 = type2.isSmartTV, isConsole2 = type2.isConsole, isWearable2 = type2.isWearable, isEmbedded2 = type2.isEmbedded;
    if (isBrowser3) {
      return browserPayload(isBrowser3, browser2, engine2, os2, ua2);
    }
    if (isSmartTV2) {
      return smartTvPayload(isSmartTV2, engine2, os2, ua2);
    }
    if (isConsole2) {
      return consolePayload(isConsole2, engine2, os2, ua2);
    }
    if (isMobile3) {
      return mobilePayload(type2, device2, os2, ua2);
    }
    if (isTablet2) {
      return mobilePayload(type2, device2, os2, ua2);
    }
    if (isWearable2) {
      return wearablePayload(isWearable2, engine2, os2, ua2);
    }
    if (isEmbedded2) {
      return embeddedPayload(isEmbedded2, device2, engine2, os2, ua2);
    }
  }
  var isMobileType = function isMobileType2(_ref3) {
    var type2 = _ref3.type;
    return type2 === DeviceTypes.Mobile;
  };
  var isTabletType = function isTabletType2(_ref22) {
    var type2 = _ref22.type;
    return type2 === DeviceTypes.Tablet;
  };
  var isMobileAndTabletType = function isMobileAndTabletType2(_ref3) {
    var type2 = _ref3.type;
    return type2 === DeviceTypes.Mobile || type2 === DeviceTypes.Tablet;
  };
  var isSmartTVType = function isSmartTVType2(_ref4) {
    var type2 = _ref4.type;
    return type2 === DeviceTypes.SmartTv;
  };
  var isBrowserType = function isBrowserType2(_ref5) {
    var type2 = _ref5.type;
    return type2 === DeviceTypes.Browser;
  };
  var isWearableType = function isWearableType2(_ref6) {
    var type2 = _ref6.type;
    return type2 === DeviceTypes.Wearable;
  };
  var isConsoleType = function isConsoleType2(_ref7) {
    var type2 = _ref7.type;
    return type2 === DeviceTypes.Console;
  };
  var isEmbeddedType = function isEmbeddedType2(_ref8) {
    var type2 = _ref8.type;
    return type2 === DeviceTypes.Embedded;
  };
  var getMobileVendor = function getMobileVendor2(_ref9) {
    var vendor = _ref9.vendor;
    return setDefaults(vendor);
  };
  var getMobileModel = function getMobileModel2(_ref10) {
    var model = _ref10.model;
    return setDefaults(model);
  };
  var getDeviceType = function getDeviceType2(_ref11) {
    var type2 = _ref11.type;
    return setDefaults(type2, "browser");
  };
  var isAndroidType = function isAndroidType2(_ref12) {
    var name2 = _ref12.name;
    return name2 === OsTypes.Android;
  };
  var isWindowsType = function isWindowsType2(_ref13) {
    var name2 = _ref13.name;
    return name2 === OsTypes.Windows;
  };
  var isMacOsType = function isMacOsType2(_ref14) {
    var name2 = _ref14.name;
    return name2 === OsTypes.MAC_OS;
  };
  var isWinPhoneType = function isWinPhoneType2(_ref15) {
    var name2 = _ref15.name;
    return name2 === OsTypes.WindowsPhone;
  };
  var isIOSType = function isIOSType2(_ref16) {
    var name2 = _ref16.name;
    return name2 === OsTypes.IOS;
  };
  var getOsVersion = function getOsVersion2(_ref17) {
    var version2 = _ref17.version;
    return setDefaults(version2);
  };
  var getOsName = function getOsName2(_ref18) {
    var name2 = _ref18.name;
    return setDefaults(name2);
  };
  var isChromeType = function isChromeType2(_ref19) {
    var name2 = _ref19.name;
    return name2 === BrowserTypes.Chrome;
  };
  var isFirefoxType = function isFirefoxType2(_ref20) {
    var name2 = _ref20.name;
    return name2 === BrowserTypes.Firefox;
  };
  var isChromiumType = function isChromiumType2(_ref21) {
    var name2 = _ref21.name;
    return name2 === BrowserTypes.Chromium;
  };
  var isEdgeType = function isEdgeType2(_ref22) {
    var name2 = _ref22.name;
    return name2 === BrowserTypes.Edge;
  };
  var isYandexType = function isYandexType2(_ref23) {
    var name2 = _ref23.name;
    return name2 === BrowserTypes.Yandex;
  };
  var isSafariType = function isSafariType2(_ref24) {
    var name2 = _ref24.name;
    return name2 === BrowserTypes.Safari || name2 === BrowserTypes.MobileSafari;
  };
  var isMobileSafariType = function isMobileSafariType2(_ref25) {
    var name2 = _ref25.name;
    return name2 === BrowserTypes.MobileSafari;
  };
  var isOperaType = function isOperaType2(_ref26) {
    var name2 = _ref26.name;
    return name2 === BrowserTypes.Opera;
  };
  var isIEType = function isIEType2(_ref27) {
    var name2 = _ref27.name;
    return name2 === BrowserTypes.InternetExplorer || name2 === BrowserTypes.Ie;
  };
  var isMIUIType = function isMIUIType2(_ref28) {
    var name2 = _ref28.name;
    return name2 === BrowserTypes.MIUI;
  };
  var isSamsungBrowserType = function isSamsungBrowserType2(_ref29) {
    var name2 = _ref29.name;
    return name2 === BrowserTypes.SamsungBrowser;
  };
  var getBrowserFullVersion = function getBrowserFullVersion2(_ref30) {
    var version2 = _ref30.version;
    return setDefaults(version2);
  };
  var getBrowserVersion = function getBrowserVersion2(_ref31) {
    var major = _ref31.major;
    return setDefaults(major);
  };
  var getBrowserName = function getBrowserName2(_ref32) {
    var name2 = _ref32.name;
    return setDefaults(name2);
  };
  var getEngineName = function getEngineName2(_ref33) {
    var name2 = _ref33.name;
    return setDefaults(name2);
  };
  var getEngineVersion = function getEngineVersion2(_ref34) {
    var version2 = _ref34.version;
    return setDefaults(version2);
  };
  var isElectronType = function isElectronType2() {
    var nav2 = getNavigatorInstance();
    var ua2 = nav2 && nav2.userAgent && nav2.userAgent.toLowerCase();
    return typeof ua2 === "string" ? /electron/.test(ua2) : false;
  };
  var isEdgeChromiumType = function isEdgeChromiumType2(ua2) {
    return typeof ua2 === "string" && ua2.indexOf("Edg/") !== -1;
  };
  var getIOS13 = function getIOS132() {
    var nav2 = getNavigatorInstance();
    return nav2 && (/iPad|iPhone|iPod/.test(nav2.platform) || nav2.platform === "MacIntel" && nav2.maxTouchPoints > 1) && !window.MSStream;
  };
  var getIPad13 = function getIPad132() {
    return isIOS13Check("iPad");
  };
  var getIphone13 = function getIphone132() {
    return isIOS13Check("iPhone");
  };
  var getIPod13 = function getIPod132() {
    return isIOS13Check("iPod");
  };
  var getUseragent = function getUseragent2(userAg) {
    return setDefaults(userAg);
  };
  function buildSelectorsObject(options2) {
    var _ref3 = options2 ? options2 : UAHelper, device2 = _ref3.device, browser2 = _ref3.browser, os2 = _ref3.os, engine2 = _ref3.engine, ua2 = _ref3.ua;
    return {
      isSmartTV: isSmartTVType(device2),
      isConsole: isConsoleType(device2),
      isWearable: isWearableType(device2),
      isEmbedded: isEmbeddedType(device2),
      isMobileSafari: isMobileSafariType(browser2) || getIPad13(),
      isChromium: isChromiumType(browser2),
      isMobile: isMobileAndTabletType(device2) || getIPad13(),
      isMobileOnly: isMobileType(device2),
      isTablet: isTabletType(device2) || getIPad13(),
      isBrowser: isBrowserType(device2),
      isDesktop: isBrowserType(device2),
      isAndroid: isAndroidType(os2),
      isWinPhone: isWinPhoneType(os2),
      isIOS: isIOSType(os2) || getIPad13(),
      isChrome: isChromeType(browser2),
      isFirefox: isFirefoxType(browser2),
      isSafari: isSafariType(browser2),
      isOpera: isOperaType(browser2),
      isIE: isIEType(browser2),
      osVersion: getOsVersion(os2),
      osName: getOsName(os2),
      fullBrowserVersion: getBrowserFullVersion(browser2),
      browserVersion: getBrowserVersion(browser2),
      browserName: getBrowserName(browser2),
      mobileVendor: getMobileVendor(device2),
      mobileModel: getMobileModel(device2),
      engineName: getEngineName(engine2),
      engineVersion: getEngineVersion(engine2),
      getUA: getUseragent(ua2),
      isEdge: isEdgeType(browser2) || isEdgeChromiumType(ua2),
      isYandex: isYandexType(browser2),
      deviceType: getDeviceType(device2),
      isIOS13: getIOS13(),
      isIPad13: getIPad13(),
      isIPhone13: getIphone13(),
      isIPod13: getIPod13(),
      isElectron: isElectronType(),
      isEdgeChromium: isEdgeChromiumType(ua2),
      isLegacyEdge: isEdgeType(browser2) && !isEdgeChromiumType(ua2),
      isWindows: isWindowsType(os2),
      isMacOs: isMacOsType(os2),
      isMIUI: isMIUIType(browser2),
      isSamsungBrowser: isSamsungBrowserType(browser2)
    };
  }
  var isSmartTV = isSmartTVType(device);
  var isConsole = isConsoleType(device);
  var isWearable = isWearableType(device);
  var isEmbedded = isEmbeddedType(device);
  var isMobileSafari = isMobileSafariType(browser) || getIPad13();
  var isChromium = isChromiumType(browser);
  var isMobile2 = isMobileAndTabletType(device) || getIPad13();
  var isMobileOnly = isMobileType(device);
  var isTablet = isTabletType(device) || getIPad13();
  var isBrowser2 = isBrowserType(device);
  var isDesktop = isBrowserType(device);
  var isAndroid = isAndroidType(os);
  var isWinPhone = isWinPhoneType(os);
  var isIOS2 = isIOSType(os) || getIPad13();
  var isChrome = isChromeType(browser);
  var isFirefox = isFirefoxType(browser);
  var isSafari = isSafariType(browser);
  var isOpera = isOperaType(browser);
  var isIE = isIEType(browser);
  var osVersion = getOsVersion(os);
  var osName = getOsName(os);
  var fullBrowserVersion = getBrowserFullVersion(browser);
  var browserVersion = getBrowserVersion(browser);
  var browserName = getBrowserName(browser);
  var mobileVendor = getMobileVendor(device);
  var mobileModel = getMobileModel(device);
  var engineName = getEngineName(engine);
  var engineVersion = getEngineVersion(engine);
  var getUA = getUseragent(ua);
  var isEdge2 = isEdgeType(browser) || isEdgeChromiumType(ua);
  var isYandex = isYandexType(browser);
  var deviceType = getDeviceType(device);
  var isIOS13 = getIOS13();
  var isIPad13 = getIPad13();
  var isIPhone13 = getIphone13();
  var isIPod13 = getIPod13();
  var isElectron = isElectronType();
  var isEdgeChromium = isEdgeChromiumType(ua);
  var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
  var isWindows = isWindowsType(os);
  var isMacOs = isMacOsType(os);
  var isMIUI = isMIUIType(browser);
  var isSamsungBrowser = isSamsungBrowserType(browser);
  var getSelectorsByUserAgent = function getSelectorsByUserAgent2(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
      console.error("No valid user agent string was provided");
      return;
    }
    var _UAHelper$parseUserAg = parseUserAgent(userAgent), device2 = _UAHelper$parseUserAg.device, browser2 = _UAHelper$parseUserAg.browser, os2 = _UAHelper$parseUserAg.os, engine2 = _UAHelper$parseUserAg.engine, ua2 = _UAHelper$parseUserAg.ua;
    return buildSelectorsObject({
      device: device2,
      browser: browser2,
      os: os2,
      engine: engine2,
      ua: ua2
    });
  };
  var AndroidView = function AndroidView2(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = _objectWithoutProperties2(_ref3, ["renderWithFragment", "children"]);
    return isAndroid ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var BrowserView = function BrowserView2(_ref22) {
    var renderWithFragment = _ref22.renderWithFragment, children = _ref22.children, props = _objectWithoutProperties2(_ref22, ["renderWithFragment", "children"]);
    return isBrowser2 ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var IEView = function IEView2(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = _objectWithoutProperties2(_ref3, ["renderWithFragment", "children"]);
    return isIE ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var IOSView = function IOSView2(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = _objectWithoutProperties2(_ref4, ["renderWithFragment", "children"]);
    return isIOS2 ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var MobileView = function MobileView2(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = _objectWithoutProperties2(_ref5, ["renderWithFragment", "children"]);
    return isMobile2 ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var TabletView = function TabletView2(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = _objectWithoutProperties2(_ref6, ["renderWithFragment", "children"]);
    return isTablet ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var WinPhoneView = function WinPhoneView2(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = _objectWithoutProperties2(_ref7, ["renderWithFragment", "children"]);
    return isWinPhone ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var MobileOnlyView = function MobileOnlyView2(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children;
    _ref8.viewClassName;
    _ref8.style;
    var props = _objectWithoutProperties2(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);
    return isMobileOnly ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var SmartTVView = function SmartTVView2(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = _objectWithoutProperties2(_ref9, ["renderWithFragment", "children"]);
    return isSmartTV ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var ConsoleView = function ConsoleView2(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = _objectWithoutProperties2(_ref10, ["renderWithFragment", "children"]);
    return isConsole ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var WearableView = function WearableView2(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = _objectWithoutProperties2(_ref11, ["renderWithFragment", "children"]);
    return isWearable ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  var CustomView = function CustomView2(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children;
    _ref12.viewClassName;
    _ref12.style;
    var condition = _ref12.condition, props = _objectWithoutProperties2(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
    return condition ? renderWithFragment ? React__default$1.createElement(React2.Fragment, null, children) : React__default$1.createElement("div", props, children) : null;
  };
  function withOrientationChange(WrappedComponent) {
    return /* @__PURE__ */ (function(_React$Component) {
      _inherits2(_class, _React$Component);
      function _class(props) {
        var _this;
        _classCallCheck2(this, _class);
        _this = _possibleConstructorReturn2(this, _getPrototypeOf2(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized2(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized2(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized2(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }
      _createClass2(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }
          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof2(window)) !== void 0 && isMobile2) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }
            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default$1.createElement(WrappedComponent, _extends2({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);
      return _class;
    })(React__default$1.Component);
  }
  function useMobileOrientation() {
    var _useState = React2.useState(function() {
      var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
      return {
        isPortrait: orientation === 0,
        isLandscape: orientation === 90,
        orientation: orientation === 0 ? "portrait" : "landscape"
      };
    }), _useState2 = _slicedToArray2(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = React2.useCallback(function() {
      var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
      var next2 = {
        isPortrait: orientation === 0,
        isLandscape: orientation === 90,
        orientation: orientation === 0 ? "portrait" : "landscape"
      };
      state.orientation !== next2.orientation && setState(next2);
    }, [state.orientation]);
    React2.useEffect(function() {
      if ((typeof window === "undefined" ? "undefined" : _typeof2(window)) !== void 0 && isMobile2) {
        handleOrientationChange();
        window.addEventListener("load", handleOrientationChange, false);
        window.addEventListener("resize", handleOrientationChange, false);
      }
      return function() {
        window.removeEventListener("resize", handleOrientationChange, false);
        window.removeEventListener("load", handleOrientationChange, false);
      };
    }, [handleOrientationChange]);
    return state;
  }
  function useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return parseUserAgent(hookUserAgent);
  }
  function useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = useDeviceData(hookUserAgent);
    var selectors = buildSelectorsObject(deviceData);
    return [selectors, deviceData];
  }
  lib$2.AndroidView = AndroidView;
  lib$2.BrowserTypes = BrowserTypes;
  lib$2.BrowserView = BrowserView;
  lib$2.ConsoleView = ConsoleView;
  lib$2.CustomView = CustomView;
  lib$2.IEView = IEView;
  lib$2.IOSView = IOSView;
  lib$2.MobileOnlyView = MobileOnlyView;
  lib$2.MobileView = MobileView;
  lib$2.OsTypes = OsTypes;
  lib$2.SmartTVView = SmartTVView;
  lib$2.TabletView = TabletView;
  lib$2.WearableView = WearableView;
  lib$2.WinPhoneView = WinPhoneView;
  lib$2.browserName = browserName;
  lib$2.browserVersion = browserVersion;
  lib$2.deviceDetect = deviceDetect;
  lib$2.deviceType = deviceType;
  lib$2.engineName = engineName;
  lib$2.engineVersion = engineVersion;
  lib$2.fullBrowserVersion = fullBrowserVersion;
  lib$2.getSelectorsByUserAgent = getSelectorsByUserAgent;
  lib$2.getUA = getUA;
  lib$2.isAndroid = isAndroid;
  lib$2.isBrowser = isBrowser2;
  lib$2.isChrome = isChrome;
  lib$2.isChromium = isChromium;
  lib$2.isConsole = isConsole;
  lib$2.isDesktop = isDesktop;
  lib$2.isEdge = isEdge2;
  lib$2.isEdgeChromium = isEdgeChromium;
  lib$2.isElectron = isElectron;
  lib$2.isEmbedded = isEmbedded;
  lib$2.isFirefox = isFirefox;
  lib$2.isIE = isIE;
  lib$2.isIOS = isIOS2;
  lib$2.isIOS13 = isIOS13;
  lib$2.isIPad13 = isIPad13;
  lib$2.isIPhone13 = isIPhone13;
  lib$2.isIPod13 = isIPod13;
  lib$2.isLegacyEdge = isLegacyEdge;
  lib$2.isMIUI = isMIUI;
  lib$2.isMacOs = isMacOs;
  lib$2.isMobile = isMobile2;
  lib$2.isMobileOnly = isMobileOnly;
  lib$2.isMobileSafari = isMobileSafari;
  lib$2.isOpera = isOpera;
  lib$2.isSafari = isSafari;
  lib$2.isSamsungBrowser = isSamsungBrowser;
  lib$2.isSmartTV = isSmartTV;
  lib$2.isTablet = isTablet;
  lib$2.isWearable = isWearable;
  lib$2.isWinPhone = isWinPhone;
  lib$2.isWindows = isWindows;
  lib$2.isYandex = isYandex;
  lib$2.mobileModel = mobileModel;
  lib$2.mobileVendor = mobileVendor;
  lib$2.osName = osName;
  lib$2.osVersion = osVersion;
  lib$2.parseUserAgent = parseUserAgent;
  lib$2.setUserAgent = setUserAgent;
  lib$2.useDeviceData = useDeviceData;
  lib$2.useDeviceSelectors = useDeviceSelectors;
  lib$2.useMobileOrientation = useMobileOrientation;
  lib$2.withOrientationChange = withOrientationChange;
  return lib$2;
}
var libExports$2 = requireLib$2();
const checkStandardDropdownItemType = (element) => ["string", "number", "boolean"].includes(typeof element);
const DropdownItem = ({
  label: label2,
  secondLabel,
  value: value2,
  isActive: isActive2,
  className,
  onChange: onChange2
}) => /* @__PURE__ */ jsxs(
  "li",
  {
    className: clsx(
      {
        "dropdown-item": checkStandardDropdownItemType(label2),
        "dropdown-item--active": isActive2
      },
      className
    ),
    onClick: () => !isActive2 && onChange2?.(value2),
    "data-testid": "dropdown-item",
    children: [
      /* @__PURE__ */ jsx$1("div", { className: "dropdown-item__label", children: label2 }),
      secondLabel && /* @__PURE__ */ jsx$1("div", { className: "dropdown-item__second-label", children: secondLabel })
    ]
  }
);
function Dropdown({
  triggerElement = "Show dropdown",
  items: items2,
  sortItems = true,
  //It was initially always sorted, we might want to change it
  value: value2,
  triggerAction = "hover",
  className,
  listClassName,
  itemClassName,
  width,
  align = "left",
  disabled: disabled2,
  onChange: onChange2
}) {
  const [dropdownTriggerAction, setDropdownTriggerAction] = useState(triggerAction);
  const [show, setShow] = useState(false);
  useEffect(() => {
    libExports$2.isMobile && setDropdownTriggerAction("click");
  }, []);
  const onTriggerMouseEnter = () => {
    if (disabled2) return;
    dropdownTriggerAction === "hover" && setShow(true);
  };
  const onTriggerMouseLeave = () => {
    if (disabled2) return;
    dropdownTriggerAction === "hover" && setShow(false);
  };
  const onTriggerClick = () => {
    if (disabled2) return;
    dropdownTriggerAction === "click" && setShow((show2) => !show2);
  };
  const dropdown = useRef(null);
  useEffect(() => {
    const outsideClickHandler = (e3) => {
      if (!(dropdown.current?.contains(e3.target) || dropdown.current === e3.target)) {
        setShow(false);
      }
    };
    if (!disabled2) document.addEventListener("click", outsideClickHandler);
    return () => {
      if (!disabled2) document.removeEventListener("click", outsideClickHandler);
    };
  }, []);
  const onChangeHandler = (itemValue) => {
    if (itemValue !== value2) {
      onChange2?.(itemValue);
      setShow(false);
    }
  };
  const sortedItems = useMemo(
    () => sortItems ? [...items2].sort(
      ({ value: itemValue }) => value2 === itemValue ? -1 : 1
    ) : items2,
    [items2, sortItems]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("dropdown", className),
      "data-testid": "dropdown",
      ref: dropdown,
      onMouseEnter: onTriggerMouseEnter,
      onMouseLeave: onTriggerMouseLeave,
      children: [
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: "dropdown__trigger",
            "data-testid": "dropdown-trigger",
            onClick: onTriggerClick,
            children: triggerElement
          }
        ),
        show && /* @__PURE__ */ jsx$1(
          "ul",
          {
            className: clsx(
              "dropdown__list",
              `dropdown__list--align-${align}`,
              listClassName
            ),
            style: { ...width && { width: `${width}px` } },
            "data-testid": "dropdown-list",
            children: sortedItems?.map(({ label: label2, secondLabel, value: itemValue }, i3) => /* @__PURE__ */ jsx$1(
              DropdownItem,
              {
                label: label2,
                secondLabel,
                value: itemValue,
                isActive: value2 === itemValue,
                className: itemClassName,
                onChange: onChangeHandler
              },
              i3
            ))
          }
        )
      ]
    }
  );
}
const FieldLabel = ({
  children,
  label: label2,
  bottomText,
  id,
  hasError,
  displayLabel = true,
  className,
  classNameTitle,
  disabled: disabled2,
  preventLableClickEvent,
  errorAriaLive = "polite",
  ariaLabel,
  renderBottomText = true
}) => /* @__PURE__ */ jsxs(
  "label",
  {
    className: clsx(
      "sz-field-label",
      hasError && "sz-field-label_error",
      disabled2 && "sz-field-label_disabled",
      className
    ),
    htmlFor: id,
    onClick: (e3) => preventLableClickEvent && e3.preventDefault(),
    children: [
      /* @__PURE__ */ jsx$1(
        "div",
        {
          className: clsx("sz-field-label__title", classNameTitle),
          id: `input-label-${id}`,
          "aria-label": ariaLabel,
          children: displayLabel ? label2 : ""
        }
      ),
      children,
      renderBottomText ? /* @__PURE__ */ jsx$1(
        "div",
        {
          className: "sz-field-label__bottom-text",
          "aria-live": errorAriaLive,
          id: `input-error-message-${id}`,
          children: bottomText
        }
      ) : null
    ]
  }
);
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed2, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed2, e3;
};
const COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(file, path, h4) {
  const f2 = withMimeType(file);
  const { webkitRelativePath } = file;
  const p2 = typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
  if (typeof f2.path !== "string") {
    setObjProp(f2, "path", p2);
  }
  setObjProp(f2, "relativePath", p2);
  return f2;
}
function withMimeType(file) {
  const { name: name2 } = file;
  const hasExtension = name2 && name2.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    const ext = name2.split(".").pop().toLowerCase();
    const type2 = COMMON_MIME_TYPES.get(ext);
    if (type2) {
      Object.defineProperty(file, "type", {
        value: type2,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
function setObjProp(f2, key, value2) {
  Object.defineProperty(f2, key, {
    value: value2,
    writable: false,
    configurable: false,
    enumerable: true
  });
}
const FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function* () {
    if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
      return getDataTransferFiles(evt.dataTransfer, evt.type);
    } else if (isChangeEvt(evt)) {
      return getInputFiles(evt);
    } else if (Array.isArray(evt) && evt.every((item2) => "getFile" in item2 && typeof item2.getFile === "function")) {
      return getFsHandleFiles(evt);
    }
    return [];
  });
}
function isDataTransfer(value2) {
  return isObject(value2);
}
function isChangeEvt(value2) {
  return isObject(value2) && isObject(value2.target);
}
function isObject(v2) {
  return typeof v2 === "object" && v2 !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map((file) => toFileWithPath(file));
}
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function* () {
    const files = yield Promise.all(handles.map((h4) => h4.getFile()));
    return files.map((file) => toFileWithPath(file));
  });
}
function getDataTransferFiles(dt2, type2) {
  return __awaiter(this, void 0, void 0, function* () {
    if (dt2.items) {
      const items2 = fromList(dt2.items).filter((item2) => item2.kind === "file");
      if (type2 !== "drop") {
        return items2;
      }
      const files = yield Promise.all(items2.map(toFilePromises));
      return noIgnoredFiles(flatten(files));
    }
    return noIgnoredFiles(fromList(dt2.files).map((file) => toFileWithPath(file)));
  });
}
function noIgnoredFiles(files) {
  return files.filter((file) => FILES_TO_IGNORE.indexOf(file.name) === -1);
}
function fromList(items2) {
  if (items2 === null) {
    return [];
  }
  const files = [];
  for (let i3 = 0; i3 < items2.length; i3++) {
    const file = items2[i3];
    files.push(file);
  }
  return files;
}
function toFilePromises(item2) {
  if (typeof item2.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item2);
  }
  const entry = item2.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item2, entry);
}
function flatten(items2) {
  return items2.reduce((acc, files) => [
    ...acc,
    ...Array.isArray(files) ? flatten(files) : [files]
  ], []);
}
function fromDataTransferItem(item2, entry) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    if (globalThis.isSecureContext && typeof item2.getAsFileSystemHandle === "function") {
      const h4 = yield item2.getAsFileSystemHandle();
      if (h4 === null) {
        throw new Error(`${item2} is not a File`);
      }
      if (h4 !== void 0) {
        const file2 = yield h4.getFile();
        file2.handle = h4;
        return toFileWithPath(file2);
      }
    }
    const file = item2.getAsFile();
    if (!file) {
      throw new Error(`${item2} is not a File`);
    }
    const fwp = toFileWithPath(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : void 0);
    return fwp;
  });
}
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function* () {
    return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
  });
}
function fromDirEntry(entry) {
  const reader = entry.createReader();
  return new Promise((resolve, reject) => {
    const entries = [];
    function readEntries() {
      reader.readEntries((batch) => __awaiter(this, void 0, void 0, function* () {
        if (!batch.length) {
          try {
            const files = yield Promise.all(entries);
            resolve(files);
          } catch (err) {
            reject(err);
          }
        } else {
          const items2 = Promise.all(batch.map(fromEntry));
          entries.push(items2);
          readEntries();
        }
      }), (err) => {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
      entry.file((file) => {
        const fwp = toFileWithPath(file, entry.fullPath);
        resolve(fwp);
      }, (err) => {
        reject(err);
      });
    });
  });
}
var es = {};
var hasRequiredEs;
function requireEs() {
  if (hasRequiredEs) return es;
  hasRequiredEs = 1;
  es.__esModule = true;
  es.default = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
      var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
      if (acceptedFilesArray.length === 0) {
        return true;
      }
      var fileName = file.name || "";
      var mimeType = (file.type || "").toLowerCase();
      var baseMimeType = mimeType.replace(/\/.*$/, "");
      return acceptedFilesArray.some(function(type2) {
        var validType = type2.trim().toLowerCase();
        if (validType.charAt(0) === ".") {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith("/*")) {
          return baseMimeType === validType.replace(/\/.*$/, "");
        }
        return mimeType === validType;
      });
    }
    return true;
  };
  return es;
}
var esExports = requireEs();
const _accepts = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$4(arr);
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = null != arguments[i3] ? arguments[i3] : {};
    i3 % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _slicedToArray$3(arr, i3) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i3) || _unsupportedIterableToArray$4(arr, i3) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$4(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$4(o2, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) {
    arr2[i3] = arr[i3];
  }
  return arr2;
}
function _iterableToArrayLimit$3(arr, i3) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i3 && _arr.length === i3) break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}
var accepts = typeof _accepts === "function" ? _accepts : _accepts.default;
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE
};
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr2() {
  var accept = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var acceptArr = accept.split(",");
  var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(msg)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr2(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr2(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function isDataTransferItemWithEmptyType(file) {
  return file.type === "" && typeof file.getAsFile === "function";
}
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept) || isDataTransferItemWithEmptyType(file);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value2) {
  return value2 !== void 0 && value2 !== null;
}
function allFilesAccepted(_ref3) {
  var files = _ref3.files, accept = _ref3.accept, minSize = _ref3.minSize, maxSize = _ref3.maxSize, multiple = _ref3.multiple, maxFiles = _ref3.maxFiles, validator = _ref3.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$3(_fileAccepted, 1), accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$3(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function(type2) {
    return type2 === "Files" || type2 === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers$1() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function(fn2) {
      if (!isPropagationStopped(event) && fn2) {
        fn2.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function(_ref22) {
      var _ref3 = _slicedToArray$3(_ref22, 2), mimeType = _ref3[0], ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
        ok = false;
      }
      return ok;
    }).reduce(function(agg, _ref4) {
      var _ref5 = _slicedToArray$3(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$5({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function(a4, _ref6) {
      var _ref7 = _slicedToArray$3(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
      return [].concat(_toConsumableArray$2(a4), [mimeType], _toConsumableArray$2(ext));
    }, []).filter(function(v2) {
      return isMIMEType(v2) || isExt(v2);
    }).join(",");
  }
  return void 0;
}
function isAbort(v2) {
  return v2 instanceof DOMException && (v2.name === "AbortError" || v2.code === v2.ABORT_ERR);
}
function isSecurityError(v2) {
  return v2 instanceof DOMException && (v2.name === "SecurityError" || v2.code === v2.SECURITY_ERR);
}
function isMIMEType(v2) {
  return v2 === "audio/*" || v2 === "video/*" || v2 === "image/*" || v2 === "text/*" || v2 === "application/*" || /\w+\/[-+.\w]+/g.test(v2);
}
function isExt(v2) {
  return /^.*\.[\w]+$/.test(v2);
}
var _excluded$7 = ["children"], _excluded2$3 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}
function _slicedToArray$2(arr, i3) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i3) || _unsupportedIterableToArray$3(arr, i3) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$3(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$3(o2, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) {
    arr2[i3] = arr[i3];
  }
  return arr2;
}
function _iterableToArrayLimit$2(arr, i3) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i3 && _arr.length === i3) break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = null != arguments[i3] ? arguments[i3] : {};
    i3 % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key = sourceSymbolKeys[i3];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(_ref3, ref2) {
  var children = _ref3.children, params = _objectWithoutProperties$1(_ref3, _excluded$7);
  var _useDropzone = useDropzone(params), open2 = _useDropzone.open, props = _objectWithoutProperties$1(_useDropzone, _excluded2$3);
  useImperativeHandle(ref2, function() {
    return {
      open: open2
    };
  }, [open2]);
  return /* @__PURE__ */ React__default.createElement(Fragment$1, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open2
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps$1 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps$1;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState$1 = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  isDragGlobal: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps$1), props), accept = _defaultProps$props.accept, disabled2 = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
  var acceptAttr = useMemo(function() {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function() {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function() {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$3;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function() {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$3;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState$1), _useReducer2 = _slicedToArray$2(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  var onWindowFocus = function onWindowFocus2() {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function() {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect(function() {
    window.addEventListener("focus", onWindowFocus, false);
    return function() {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var globalDragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop2(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function() {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function() {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  useEffect(function() {
    var onDocumentDragEnter = function onDocumentDragEnter2(event) {
      globalDragTargetsRef.current = [].concat(_toConsumableArray$1(globalDragTargetsRef.current), [event.target]);
      if (isEvtWithFiles(event)) {
        dispatch({
          isDragGlobal: true,
          type: "setDragGlobal"
        });
      }
    };
    var onDocumentDragLeave = function onDocumentDragLeave2(event) {
      globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function(el) {
        return el !== event.target && el !== null;
      });
      if (globalDragTargetsRef.current.length > 0) {
        return;
      }
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };
    var onDocumentDragEnd = function onDocumentDragEnd2() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };
    var onDocumentDropGlobal = function onDocumentDropGlobal2() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };
    document.addEventListener("dragenter", onDocumentDragEnter, false);
    document.addEventListener("dragleave", onDocumentDragLeave, false);
    document.addEventListener("dragend", onDocumentDragEnd, false);
    document.addEventListener("drop", onDocumentDropGlobal, false);
    return function() {
      document.removeEventListener("dragenter", onDocumentDragEnter);
      document.removeEventListener("dragleave", onDocumentDragLeave);
      document.removeEventListener("dragend", onDocumentDragEnd);
      document.removeEventListener("drop", onDocumentDropGlobal);
    };
  }, [rootRef]);
  useEffect(function() {
    if (!disabled2 && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function() {
    };
  }, [rootRef, autoFocus, disabled2]);
  var onErrCb = useCallback(function(e3) {
    if (onError) {
      onError(e3);
    } else {
      console.error(e3);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray$1(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files,
          accept: acceptAttr,
          minSize,
          maxSize,
          multiple,
          maxFiles,
          validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept,
          isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function(e3) {
        return onErrCb(e3);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {
      }
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function(files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function(file) {
      var _fileAccepted = fileAccepted(file, acceptAttr), _fileAccepted2 = _slicedToArray$2(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$2(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file,
          errors: errors.filter(function(e3) {
            return e3;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach(function(file) {
        fileRejections.push({
          file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles,
      fileRejections,
      isDragReject: fileRejections.length > 0,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch(function(e3) {
        return onErrCb(e3);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  var openFileDialog = useCallback(function() {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      var opts = {
        multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function(handles) {
        return getFilesFromEvent(handles);
      }).then(function(files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function(e3) {
        if (isAbort(e3)) {
          onFileDialogCancelCb(e3);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e3)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e3);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]);
  var onKeyDownCb = useCallback(function(event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  var onFocusCb = useCallback(function() {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function() {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function() {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler2(fn2) {
    return disabled2 ? null : fn2;
  };
  var composeKeyboardHandler = function composeKeyboardHandler2(fn2) {
    return noKeyboard ? null : composeHandler(fn2);
  };
  var composeDragHandler = function composeDragHandler2(fn2) {
    return noDrag ? null : composeHandler(fn2);
  };
  var stopPropagation = function stopPropagation2(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function() {
    return function() {
      var _ref22 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref22.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref22.role, onKeyDown = _ref22.onKeyDown, onFocus2 = _ref22.onFocus, onBlur = _ref22.onBlur, onClick = _ref22.onClick, onDragEnter2 = _ref22.onDragEnter, onDragOver2 = _ref22.onDragOver, onDragLeave2 = _ref22.onDragLeave, onDrop2 = _ref22.onDrop, rest = _objectWithoutProperties$1(_ref22, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty$4({
        onKeyDown: composeKeyboardHandler(composeEventHandlers$1(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers$1(onFocus2, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers$1(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers$1(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers$1(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers$1(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers$1(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers$1(onDrop2, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled2 && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled2]);
  var onInputElementClick = useCallback(function(event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange2 = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties$1(_ref3, _excluded4);
      var inputProps = _defineProperty$4({
        accept: acceptAttr,
        multiple,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: composeHandler(composeEventHandlers$1(onChange2, onDropCb)),
        onClick: composeHandler(composeEventHandlers$1(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled2]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled2,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState$1), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections,
        isDragReject: action.isDragReject
      });
    case "setDragGlobal":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragGlobal: action.isDragGlobal
      });
    case "reset":
      return _objectSpread({}, initialState$1);
    default:
      return state;
  }
}
function noop$3() {
}
const container$8 = "file-upload-module_container__qV-bG";
const full = "file-upload-module_full__GJGtR";
const prompt = "file-upload-module_prompt__I21qe";
const fit = "file-upload-module_fit__HWPhi";
const group$1 = "file-upload-module_group__XL-fk";
const drag = "file-upload-module_drag__Ywh2-";
const invalid = "file-upload-module_invalid__86fnf";
const failed = "file-upload-module_failed__3Qcew";
const heading = "file-upload-module_heading__vA65e";
const description = "file-upload-module_description__DEfis";
const browse$1 = "file-upload-module_browse__TK1rq";
const icon$3 = "file-upload-module_icon__PzQ1l";
const row$1 = "file-upload-module_row__6c5h-";
const name$1 = "file-upload-module_name__y90B7";
const styles$F = {
  container: container$8,
  full,
  prompt,
  fit,
  group: group$1,
  drag,
  invalid,
  failed,
  heading,
  "heading-error": "file-upload-module_heading-error__je4or",
  description,
  "description-error": "file-upload-module_description-error__rOhJG",
  browse: browse$1,
  icon: icon$3,
  "icon-interactive": "file-upload-module_icon-interactive__B-rZU",
  "icon-red": "file-upload-module_icon-red__qqmtl",
  "icon-green": "file-upload-module_icon-green__mIrYQ",
  row: row$1,
  name: name$1,
  "icon-button": "file-upload-module_icon-button__uX0O8",
  "icon-button-red": "file-upload-module_icon-button-red__2IeL1"
};
const FileUploadFileName = ({
  fileName,
  remeasureKey
}) => {
  const nameRef = useRef(null);
  const [truncated, setTruncated] = useState(false);
  useEffect(() => {
    const element = nameRef.current;
    setTruncated(!!element && element.scrollWidth > element.clientWidth + 1);
  }, [fileName, remeasureKey]);
  if (!truncated) {
    return /* @__PURE__ */ jsx$1("span", { className: styles$F["name"], ref: nameRef, children: fileName });
  }
  return /* @__PURE__ */ jsx$1(Tooltip$3, { content: fileName, variant: "dark", place: "top", disableAriaLabel: true, children: /* @__PURE__ */ jsx$1(
    "span",
    {
      className: styles$F["name"],
      ref: nameRef,
      "aria-label": fileName ?? void 0,
      children: fileName
    }
  ) });
};
const SvgEmail = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z", fill: "black" }));
const SvgPageOutlined = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.17 4L18 8.83V20H6V4H13.17ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14ZM16 17.43C16 16.62 15.52 15.9 14.78 15.58C13.93 15.21 12.99 15 12 15C11.01 15 10.07 15.21 9.22 15.58C8.48 15.9 8 16.62 8 17.43V18H16V17.43Z", fill: "black" }));
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z", fill: "white" }));
const SvgTrash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z", fill: "black" }));
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z", fill: "#323232" }));
const SvgAddUser = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }), /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 7, r: 4 }), /* @__PURE__ */ React.createElement("line", { x1: 19, x2: 19, y1: 8, y2: 14 }), /* @__PURE__ */ React.createElement("line", { x1: 22, x2: 16, y1: 11, y2: 11 }));
const SvgAiInterview = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.5 0L8.71875 1.71875L7 2.5L8.71875 3.28125L9.5 5L10.2812 3.28125L12 2.5L10.2812 1.71875L9.5 0Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M13.5 5L12.7188 6.71875L11 7.5L12.7188 8.28125L13.5 10L14.2812 8.28125L16 7.5L14.2812 6.71875L13.5 5Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M3 10.5C3.14167 10.5 3.26042 10.4521 3.35625 10.3563C3.45208 10.2604 3.5 10.1417 3.5 10C3.5 9.85833 3.45208 9.73958 3.35625 9.64375C3.26042 9.54792 3.14167 9.5 3 9.5C2.85833 9.5 2.73958 9.54792 2.64375 9.64375C2.54792 9.73958 2.5 9.85833 2.5 10C2.5 10.1417 2.54792 10.2604 2.64375 10.3563C2.73958 10.4521 2.85833 10.5 3 10.5ZM5 10.5C5.14167 10.5 5.26042 10.4521 5.35625 10.3563C5.45208 10.2604 5.5 10.1417 5.5 10C5.5 9.85833 5.45208 9.73958 5.35625 9.64375C5.26042 9.54792 5.14167 9.5 5 9.5C4.85833 9.5 4.73958 9.54792 4.64375 9.64375C4.54792 9.73958 4.5 9.85833 4.5 10C4.5 10.1417 4.54792 10.2604 4.64375 10.3563C4.73958 10.4521 4.85833 10.5 5 10.5ZM7 10.5C7.14167 10.5 7.26042 10.4521 7.35625 10.3563C7.45208 10.2604 7.5 10.1417 7.5 10C7.5 9.85833 7.45208 9.73958 7.35625 9.64375C7.26042 9.54792 7.14167 9.5 7 9.5C6.85833 9.5 6.73958 9.54792 6.64375 9.64375C6.54792 9.73958 6.5 9.85833 6.5 10C6.5 10.1417 6.54792 10.2604 6.64375 10.3563C6.73958 10.4521 6.85833 10.5 7 10.5ZM0 16V7C0 6.725 0.0979167 6.48958 0.29375 6.29375C0.489583 6.09792 0.725 6 1 6H9C9.275 6 9.51042 6.09792 9.70625 6.29375C9.90208 6.48958 10 6.725 10 7V13C10 13.275 9.90208 13.5104 9.70625 13.7063C9.51042 13.9021 9.275 14 9 14H2L0 16ZM1.575 13H9V7H1V13.5625L1.575 13Z", fill: "#723BCA" }));
const SvgAiSmall = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4884_4123)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.1667 6.00002L14.0001 4.16669L15.8334 3.33335L14.0001 2.50002L13.1667 0.666687L12.3334 2.50002L10.5001 3.33335L12.3334 4.16669L13.1667 6.00002Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M13.1667 10L12.3334 11.8334L10.5001 12.6667L12.3334 13.5L13.1667 15.3334L14.0001 13.5L15.8334 12.6667L14.0001 11.8334L13.1667 10Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M8.16675 6.33335L6.50008 2.66669L4.83341 6.33335L1.16675 8.00002L4.83341 9.66669L6.50008 13.3334L8.16675 9.66669L11.8334 8.00002L8.16675 6.33335ZM7.16008 8.66002L6.50008 10.1134L5.84008 8.66002L4.38675 8.00002L5.84008 7.34002L6.50008 5.88669L7.16008 7.34002L8.61341 8.00002L7.16008 8.66002Z", fill: "#723BCA" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4884_4123" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }))));
const SvgAiSparkle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "path-2-inside-1_3515_99426", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M19.8475 12.043C19.7901 12.043 19.7413 12.0318 19.7011 12.0095C19.6609 11.9873 19.6294 11.9483 19.6064 11.8926L19.107 10.7566L17.8499 10.222C17.7925 10.1997 17.7524 10.1691 17.7294 10.1301C17.7064 10.0911 17.695 10.0438 17.695 9.98807C17.695 9.93238 17.7064 9.88504 17.7294 9.84606C17.7524 9.80708 17.7925 9.77645 17.8499 9.75418L19.107 9.23628L19.6064 8.15036C19.6294 8.09467 19.6609 8.05569 19.7011 8.03341C19.7413 8.01114 19.7901 8 19.8475 8C19.9049 8 19.9537 8.01114 19.9939 8.03341C20.034 8.05569 20.0656 8.09467 20.0886 8.15036L20.5879 9.23628L21.845 9.75418C21.9024 9.77645 21.9426 9.80708 21.9656 9.84606C21.9885 9.88504 22 9.93238 22 9.98807C22 10.0438 21.9885 10.0911 21.9656 10.1301C21.9426 10.1691 21.9024 10.1997 21.845 10.222L20.5879 10.7566L20.0886 11.8926C20.0656 11.9483 20.034 11.9873 19.9939 12.0095C19.9537 12.0318 19.9049 12.043 19.8475 12.043ZM19.8475 22C19.8016 22 19.7556 21.9889 19.7097 21.9666C19.6638 21.9443 19.6294 21.9053 19.6064 21.8496L19.107 20.7637L17.8672 20.2458C17.8098 20.2235 17.7696 20.1929 17.7466 20.1539C17.7237 20.115 17.7122 20.0676 17.7122 20.0119C17.7122 19.9562 17.7237 19.9089 17.7466 19.8699C17.7696 19.8309 17.8098 19.8003 17.8672 19.778L19.107 19.2601L19.6064 18.1074C19.6294 18.0517 19.6609 18.0127 19.7011 17.9905C19.7413 17.9682 19.7901 17.957 19.8475 17.957C19.9049 17.957 19.9537 17.9682 19.9939 17.9905C20.034 18.0127 20.0656 18.0517 20.0886 18.1074L20.5879 19.2601L21.8278 19.778C21.8852 19.8003 21.9254 19.8309 21.9483 19.8699C21.9713 19.9089 21.9828 19.9562 21.9828 20.0119C21.9828 20.0676 21.9713 20.115 21.9483 20.1539C21.9254 20.1929 21.8852 20.2235 21.8278 20.2458L20.5879 20.7637L20.0886 21.8496C20.0656 21.9053 20.0312 21.9443 19.9852 21.9666C19.9393 21.9889 19.8934 22 19.8475 22ZM12.2878 19.1098C12.196 19.1098 12.107 19.0847 12.0209 19.0346C11.9348 18.9845 11.8688 18.9149 11.8229 18.8258L10.7036 16.5036L8.29274 15.4511C8.2009 15.4065 8.12915 15.3425 8.07749 15.2589C8.02583 15.1754 8 15.0891 8 15C8 14.9109 8.02583 14.8246 8.07749 14.741C8.12915 14.6575 8.2009 14.5935 8.29274 14.5489L10.7036 13.4964L11.8229 11.1909C11.8688 11.0907 11.9348 11.0155 12.0209 10.9654C12.107 10.9153 12.196 10.8902 12.2878 10.8902C12.3797 10.8902 12.4686 10.9153 12.5547 10.9654C12.6408 11.0155 12.7068 11.0851 12.7528 11.1742L13.8893 13.4964L16.2829 14.5489C16.3862 14.5935 16.4637 14.6575 16.5154 14.741C16.567 14.8246 16.5929 14.9109 16.5929 15C16.5929 15.0891 16.567 15.1754 16.5154 15.2589C16.4637 15.3425 16.3862 15.4065 16.2829 15.4511L13.8893 16.5036L12.7528 18.8258C12.7068 18.926 12.6408 18.9984 12.5547 19.043C12.4686 19.0875 12.3797 19.1098 12.2878 19.1098Z" })), /* @__PURE__ */ React.createElement("path", { d: "M19.6064 11.8926L20.9932 11.3208L20.9866 11.3048L20.9796 11.289L19.6064 11.8926ZM19.107 10.7566L20.4802 10.1529L20.241 9.60882L19.694 9.37621L19.107 10.7566ZM17.8499 10.222L18.437 8.8416L18.4149 8.83223L18.3926 8.82356L17.8499 10.222ZM17.8499 9.75418L18.3926 11.1526L18.407 11.147L18.4213 11.1411L17.8499 9.75418ZM19.107 9.23628L19.6784 10.6232L20.2235 10.3986L20.4698 9.86299L19.107 9.23628ZM19.6064 8.15036L20.9692 8.77707L20.9817 8.74984L20.9932 8.72212L19.6064 8.15036ZM20.0886 8.15036L18.7018 8.72212L18.7132 8.74984L18.7258 8.77707L20.0886 8.15036ZM20.5879 9.23628L19.2251 9.86299L19.4715 10.3986L20.0166 10.6232L20.5879 9.23628ZM21.845 9.75418L21.2736 11.1411L21.2879 11.147L21.3023 11.1526L21.845 9.75418ZM21.845 10.222L21.3023 8.82356L21.28 8.83223L21.258 8.8416L21.845 10.222ZM20.5879 10.7566L20.0009 9.37621L19.4539 9.60882L19.2148 10.1529L20.5879 10.7566ZM20.0886 11.8926L18.7154 11.289L18.7084 11.3048L18.7018 11.3208L20.0886 11.8926ZM19.6064 21.8496L20.9932 21.2779L20.9817 21.2502L20.9692 21.2229L19.6064 21.8496ZM19.107 20.7637L20.4698 20.137L20.2253 19.6052L19.6852 19.3796L19.107 20.7637ZM17.8672 20.2458L18.4453 18.8617L18.4277 18.8543L18.4098 18.8474L17.8672 20.2458ZM17.8672 19.778L18.4098 21.1764L18.4277 21.1695L18.4453 21.1621L17.8672 19.778ZM19.107 19.2601L19.6852 20.6442L20.2431 20.4112L20.4834 19.8564L19.107 19.2601ZM19.6064 18.1074L20.9828 18.7037L20.9881 18.6915L20.9932 18.6792L19.6064 18.1074ZM20.0886 18.1074L18.7018 18.6792L18.7069 18.6915L18.7122 18.7037L20.0886 18.1074ZM20.5879 19.2601L19.2116 19.8564L19.4519 20.4112L20.0098 20.6442L20.5879 19.2601ZM21.8278 19.778L21.2496 21.1621L21.2673 21.1695L21.2851 21.1764L21.8278 19.778ZM21.8278 20.2458L21.2851 18.8474L21.2673 18.8543L21.2496 18.8617L21.8278 20.2458ZM20.5879 20.7637L20.0098 19.3796L19.4697 19.6052L19.2251 20.137L20.5879 20.7637ZM20.0886 21.8496L18.7258 21.2229L18.7132 21.2502L18.7018 21.2779L20.0886 21.8496ZM11.8229 18.8258L10.4717 19.4771L10.4804 19.4951L10.4895 19.5129L11.8229 18.8258ZM10.7036 16.5036L12.0548 15.8523L11.8133 15.3514L11.3037 15.1289L10.7036 16.5036ZM8.29274 15.4511L7.63808 16.8007L7.66508 16.8138L7.69258 16.8258L8.29274 15.4511ZM8.29274 14.5489L7.69258 13.1742L7.66508 13.1862L7.63808 13.1993L8.29274 14.5489ZM10.7036 13.4964L11.3037 14.8711L11.8111 14.6496L12.0529 14.1515L10.7036 13.4964ZM11.8229 11.1909L13.1723 11.8461L13.1796 11.8309L13.1866 11.8157L11.8229 11.1909ZM12.7528 11.1742L14.1001 10.5148L14.0932 10.5009L14.0861 10.4871L12.7528 11.1742ZM13.8893 13.4964L12.542 14.1558L12.7832 14.6487L13.2855 14.8695L13.8893 13.4964ZM16.2829 14.5489L15.6791 15.9221L15.689 15.9263L16.2829 14.5489ZM16.2829 15.4511L15.689 14.0736L15.6791 14.078L16.2829 15.4511ZM13.8893 16.5036L13.2855 15.1305L12.7832 15.3513L12.542 15.8442L13.8893 16.5036ZM12.7528 18.8258L11.4055 18.1664L11.397 18.1836L11.3891 18.201L12.7528 18.8258ZM19.8475 10.543C19.982 10.543 20.1971 10.5694 20.4284 10.6977L18.9738 13.3214C19.2855 13.4942 19.5981 13.543 19.8475 13.543V10.543ZM20.4284 10.6977C20.7669 10.8853 20.9271 11.1606 20.9932 11.3208L18.2196 12.4644C18.3316 12.7359 18.5549 13.0892 18.9738 13.3214L20.4284 10.6977ZM20.9796 11.289L20.4802 10.1529L17.7338 11.3602L18.2332 12.4962L20.9796 11.289ZM19.694 9.37621L18.437 8.8416L17.2629 11.6023L18.52 12.1369L19.694 9.37621ZM18.3926 8.82356C18.5371 8.87962 18.821 9.02784 19.0219 9.36881L16.4369 10.8913C16.6837 11.3103 17.048 11.5197 17.3073 11.6204L18.3926 8.82356ZM19.0219 9.36881C19.1629 9.6083 19.195 9.83754 19.195 9.98807H16.195C16.195 10.25 16.2499 10.5739 16.4369 10.8913L19.0219 9.36881ZM19.195 9.98807C19.195 10.1386 19.1629 10.3678 19.0219 10.6073L16.4369 9.0848C16.2499 9.40225 16.195 9.72617 16.195 9.98807H19.195ZM19.0219 10.6073C18.821 10.9483 18.5371 11.0965 18.3926 11.1526L17.3073 8.35578C17.048 8.45639 16.6837 8.66587 16.4369 9.0848L19.0219 10.6073ZM18.4213 11.1411L19.6784 10.6232L18.5356 7.84937L17.2785 8.36727L18.4213 11.1411ZM20.4698 9.86299L20.9692 8.77707L18.2436 7.52364L17.7442 8.60956L20.4698 9.86299ZM20.9932 8.72212C20.9271 8.88232 20.7669 9.15762 20.4284 9.3453L18.9738 6.72152C18.5549 6.95376 18.3316 7.30702 18.2196 7.5786L20.9932 8.72212ZM20.4284 9.3453C20.1971 9.47353 19.982 9.5 19.8475 9.5V6.5C19.5981 6.5 19.2855 6.54875 18.9738 6.72152L20.4284 9.3453ZM19.8475 9.5C19.7129 9.5 19.4979 9.47353 19.2666 9.3453L20.7211 6.72152C20.4095 6.54875 20.0968 6.5 19.8475 6.5V9.5ZM19.2666 9.3453C18.928 9.15762 18.7679 8.88232 18.7018 8.72212L21.4753 7.5786C21.3633 7.30702 21.14 6.95376 20.7211 6.72152L19.2666 9.3453ZM18.7258 8.77707L19.2251 9.86299L21.9507 8.60956L21.4514 7.52364L18.7258 8.77707ZM20.0166 10.6232L21.2736 11.1411L22.4164 8.36727L21.1593 7.84937L20.0166 10.6232ZM21.3023 11.1526C21.1579 11.0965 20.8739 10.9483 20.6731 10.6073L23.258 9.0848C23.0113 8.66587 22.6469 8.45639 22.3877 8.35578L21.3023 11.1526ZM20.6731 10.6073C20.532 10.3678 20.5 10.1386 20.5 9.98807H23.5C23.5 9.72617 23.445 9.40225 23.258 9.0848L20.6731 10.6073ZM20.5 9.98807C20.5 9.83754 20.532 9.6083 20.6731 9.36881L23.258 10.8913C23.445 10.5739 23.5 10.25 23.5 9.98807H20.5ZM20.6731 9.36881C20.8739 9.02784 21.1579 8.87962 21.3023 8.82356L22.3877 11.6204C22.6469 11.5197 23.0113 11.3103 23.258 10.8913L20.6731 9.36881ZM21.258 8.8416L20.0009 9.37621L21.175 12.1369L22.4321 11.6023L21.258 8.8416ZM19.2148 10.1529L18.7154 11.289L21.4617 12.4962L21.9611 11.3602L19.2148 10.1529ZM18.7018 11.3208C18.7679 11.1606 18.928 10.8853 19.2666 10.6977L20.7211 13.3214C21.14 13.0892 21.3633 12.7359 21.4753 12.4644L18.7018 11.3208ZM19.2666 10.6977C19.4979 10.5694 19.7129 10.543 19.8475 10.543V13.543C20.0968 13.543 20.4095 13.4942 20.7211 13.3214L19.2666 10.6977ZM19.8475 20.5C20.0526 20.5 20.2293 20.5514 20.3644 20.617L19.0551 23.3162C19.282 23.4263 19.5505 23.5 19.8475 23.5V20.5ZM20.3644 20.617C20.7078 20.7836 20.9025 21.0581 20.9932 21.2779L18.2196 22.4214C18.3562 22.7526 18.6198 23.1051 19.0551 23.3162L20.3644 20.617ZM20.9692 21.2229L20.4698 20.137L17.7442 21.3904L18.2436 22.4764L20.9692 21.2229ZM19.6852 19.3796L18.4453 18.8617L17.289 21.6299L18.5289 22.1478L19.6852 19.3796ZM18.4098 18.8474C18.5543 18.9035 18.8383 19.0517 19.0391 19.3927L16.4541 20.9152C16.7009 21.3341 17.0652 21.5436 17.3245 21.6442L18.4098 18.8474ZM19.0391 19.3927C19.1801 19.6322 19.2122 19.8614 19.2122 20.0119H16.2122C16.2122 20.2739 16.2672 20.5978 16.4541 20.9152L19.0391 19.3927ZM19.2122 20.0119C19.2122 20.1625 19.1801 20.3917 19.0391 20.6312L16.4541 19.1087C16.2672 19.4261 16.2122 19.75 16.2122 20.0119H19.2122ZM19.0391 20.6312C18.8383 20.9722 18.5543 21.1204 18.4098 21.1764L17.3245 18.3796C17.0652 18.4803 16.7009 18.6897 16.4541 19.1087L19.0391 20.6312ZM18.4453 21.1621L19.6852 20.6442L18.5289 17.876L17.289 18.3939L18.4453 21.1621ZM20.4834 19.8564L20.9828 18.7037L18.23 17.5111L17.7306 18.6639L20.4834 19.8564ZM20.9932 18.6792C20.9271 18.8394 20.7669 19.1147 20.4284 19.3023L18.9738 16.6786C18.5549 16.9108 18.3316 17.2641 18.2196 17.5356L20.9932 18.6792ZM20.4284 19.3023C20.1971 19.4306 19.982 19.457 19.8475 19.457V16.457C19.5981 16.457 19.2855 16.5058 18.9738 16.6786L20.4284 19.3023ZM19.8475 19.457C19.7129 19.457 19.4979 19.4306 19.2666 19.3023L20.7211 16.6786C20.4095 16.5058 20.0968 16.457 19.8475 16.457V19.457ZM19.2666 19.3023C18.928 19.1147 18.7679 18.8394 18.7018 18.6792L21.4753 17.5356C21.3633 17.2641 21.14 16.9108 20.7211 16.6786L19.2666 19.3023ZM18.7122 18.7037L19.2116 19.8564L21.9643 18.6639L21.465 17.5111L18.7122 18.7037ZM20.0098 20.6442L21.2496 21.1621L22.406 18.3939L21.1661 17.876L20.0098 20.6442ZM21.2851 21.1764C21.1407 21.1204 20.8567 20.9722 20.6559 20.6312L23.2408 19.1087C22.9941 18.6897 22.6297 18.4803 22.3705 18.3796L21.2851 21.1764ZM20.6559 20.6312C20.5148 20.3917 20.4828 20.1625 20.4828 20.0119H23.4828C23.4828 19.75 23.4278 19.4261 23.2408 19.1087L20.6559 20.6312ZM20.4828 20.0119C20.4828 19.8614 20.5148 19.6322 20.6559 19.3927L23.2408 20.9152C23.4278 20.5977 23.4828 20.2738 23.4828 20.0119H20.4828ZM20.6559 19.3927C20.8567 19.0517 21.1407 18.9035 21.2851 18.8474L22.3705 21.6442C22.6297 21.5436 22.9941 21.3341 23.2408 20.9152L20.6559 19.3927ZM21.2496 18.8617L20.0098 19.3796L21.1661 22.1478L22.406 21.6299L21.2496 18.8617ZM19.2251 20.137L18.7258 21.2229L21.4514 22.4764L21.9507 21.3904L19.2251 20.137ZM18.7018 21.2779C18.7924 21.0581 18.9872 20.7836 19.3306 20.617L20.6399 23.3162C21.0751 23.1051 21.3388 22.7526 21.4753 22.4214L18.7018 21.2779ZM19.3306 20.617C19.4657 20.5514 19.6424 20.5 19.8475 20.5V23.5C20.1444 23.5 20.4129 23.4263 20.6399 23.3162L19.3306 20.617ZM12.2878 17.6098C12.4834 17.6098 12.6525 17.6667 12.7755 17.7382L11.2663 20.331C11.5615 20.5028 11.9086 20.6098 12.2878 20.6098V17.6098ZM12.7755 17.7382C12.938 17.8328 13.0721 17.9753 13.1562 18.1386L10.4895 19.5129C10.6655 19.8544 10.9316 20.1361 11.2663 20.331L12.7755 17.7382ZM13.1741 18.1745L12.0548 15.8523L9.35234 17.1549L10.4717 19.4771L13.1741 18.1745ZM11.3037 15.1289L8.8929 14.0764L7.69258 16.8258L10.1034 17.8783L11.3037 15.1289ZM8.94741 14.1015C9.10099 14.176 9.24916 14.3017 9.35323 14.47L6.80175 16.0479C7.00915 16.3833 7.30082 16.6371 7.63808 16.8007L8.94741 14.1015ZM9.35323 14.47C9.43268 14.5984 9.5 14.7823 9.5 15H6.5C6.5 15.3959 6.61898 15.7524 6.80175 16.0479L9.35323 14.47ZM9.5 15C9.5 15.2177 9.43268 15.4016 9.35323 15.53L6.80175 13.9521C6.61898 14.2476 6.5 14.6041 6.5 15H9.5ZM9.35323 15.53C9.24916 15.6983 9.10098 15.824 8.94741 15.8985L7.63808 13.1993C7.30082 13.3629 7.00915 13.6167 6.80175 13.9521L9.35323 15.53ZM8.8929 15.9236L11.3037 14.8711L10.1034 12.1217L7.69258 13.1742L8.8929 15.9236ZM12.0529 14.1515L13.1723 11.8461L10.4735 10.5358L9.35419 12.8413L12.0529 14.1515ZM13.1866 11.8157C13.118 11.9654 12.9853 12.1397 12.7755 12.2618L11.2663 9.66903C10.8844 9.89135 10.6196 10.216 10.4592 10.5662L13.1866 11.8157ZM12.7755 12.2618C12.6525 12.3333 12.4834 12.3902 12.2878 12.3902V9.39021C11.9086 9.39021 11.5615 9.4972 11.2663 9.66903L12.7755 12.2618ZM12.2878 12.3902C12.0923 12.3902 11.9231 12.3333 11.8001 12.2618L13.3093 9.66903C13.0142 9.4972 12.667 9.39021 12.2878 9.39021V12.3902ZM11.8001 12.2618C11.6376 12.1672 11.5036 12.0247 11.4194 11.8614L14.0861 10.4871C13.9101 10.1456 13.6441 9.86387 13.3093 9.66903L11.8001 12.2618ZM11.4055 11.8336L12.542 14.1558L15.2366 12.837L14.1001 10.5148L11.4055 11.8336ZM13.2855 14.8695L15.6791 15.922L16.8867 13.1758L14.4931 12.1233L13.2855 14.8695ZM15.689 15.9263C15.5526 15.8675 15.3724 15.7446 15.2396 15.53L17.7911 13.9521C17.5551 13.5704 17.2198 13.3194 16.8768 13.1715L15.689 15.9263ZM15.2396 15.53C15.1602 15.4016 15.0929 15.2177 15.0929 15H18.0929C18.0929 14.6041 17.9739 14.2476 17.7911 13.9521L15.2396 15.53ZM15.0929 15C15.0929 14.7823 15.1602 14.5984 15.2396 14.47L17.7911 16.0479C17.9739 15.7524 18.0929 15.3959 18.0929 15H15.0929ZM15.2396 14.47C15.3724 14.2554 15.5526 14.1325 15.689 14.0737L16.8768 16.8285C17.2198 16.6806 17.5551 16.4296 17.7911 16.0479L15.2396 14.47ZM15.6791 14.078L13.2855 15.1305L14.4931 17.8767L16.8867 16.8242L15.6791 14.078ZM12.542 15.8442L11.4055 18.1664L14.1001 19.4852L15.2366 17.163L12.542 15.8442ZM11.3891 18.201C11.4625 18.0407 11.6138 17.8409 11.8654 17.7107L13.2441 20.3752C13.6679 20.1559 13.9512 19.8113 14.1165 19.4505L11.3891 18.201ZM11.8654 17.7107C11.9802 17.6513 12.1264 17.6098 12.2878 17.6098V20.6098C12.6329 20.6098 12.9571 20.5237 13.2441 20.3752L11.8654 17.7107Z", fill: "#8B5ED4", mask: "url(#path-2-inside-1_3515_99426)" }));
const SvgAlert = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z", fill: "#C4811D" }));
const SvgAllInbox = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4857_418)" }, /* @__PURE__ */ React.createElement("path", { d: "M19 3H5C3.9 3 3 3.9 3 5V12C3 13.1 3.9 14 5 14H19C20.1 14 21 13.1 21 12V5C21 3.9 20.1 3 19 3ZM5 10H8.13C8.34 10.78 8.8 11.47 9.4 12H5V10ZM19 12H14.6C15.2 11.47 15.66 10.78 15.87 10H19V12ZM19 8H14V9C14 10.07 13.07 11 12 11C10.93 11 10 10.07 10 9V8H5V5H19V8ZM17 15H14V16C14 16.47 13.81 16.9 13.52 17.25C13.15 17.7 12.6 18 12 18C11.4 18 10.85 17.7 10.48 17.25C10.19 16.9 10 16.47 10 16V15H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15H17ZM5 17H8.13C8.15 17.09 8.19 17.17 8.22 17.25C8.46 17.93 8.87 18.53 9.4 19H5V17ZM19 19H14.6C15.14 18.53 15.55 17.93 15.78 17.25C15.81 17.17 15.85 17.09 15.87 17H19V19Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4857_418" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgAnalytics = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_4901_3440", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 18, height: 18 }, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_4901_3440)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.25 12.75H6.75V9H5.25V12.75ZM11.25 12.75H12.75V5.25H11.25V12.75ZM8.25 12.75H9.75V10.5H8.25V12.75ZM8.25 9H9.75V7.5H8.25V9ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM3.75 14.25H14.25V3.75H3.75V14.25Z", fill: "#E0982B" })));
const SvgAnimatedImages = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 16, viewBox: "0 -960 960 960", width: 16, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#D71717", d: "m480-420 240-160-240-160v320Zm28 220h224q-7 26-24 42t-44 20L228-85q-33 5-59.5-15.5T138-154L85-591q-4-33 16-59t53-30l46-6v80l-36 5 54 437 290-36Zm-148-80q-33 0-56.5-23.5T280-360v-440q0-33 23.5-56.5T360-880h440q33 0 56.5 23.5T880-800v440q0 33-23.5 56.5T800-280H360Zm0-80h440v-440H360v440Zm220-220ZM218-164Z" }));
const SvgApartment = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 8H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z", fill: "currentColor" }));
const SvgArchive = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM12 17.5L6.5 12H10V10H14V12H17.5L12 17.5ZM5.12 5L5.94 4H18L18.93 5H5.12Z", fill: "#006AFF" }));
const SvgArrowBack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5361_7951)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.3334 7.33335H5.22008L8.94675 3.60669L8.00008 2.66669L2.66675 8.00002L8.00008 13.3334L8.94008 12.3934L5.22008 8.66669H13.3334V7.33335Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5361_7951" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgArrowBackwardGreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_120_11)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.4697 4.46967L12 3.93934L13.0607 5L12.5303 5.53033L11.4697 4.46967ZM7 10L6.46967 10.5303C6.17678 10.2374 6.17678 9.76256 6.46967 9.46967L7 10ZM12.5303 14.4697L13.0607 15L12 16.0607L11.4697 15.5303L12.5303 14.4697ZM12.5303 5.53033L7.53033 10.5303L6.46967 9.46967L11.4697 4.46967L12.5303 5.53033ZM7.53033 9.46967L12.5303 14.4697L11.4697 15.5303L6.46967 10.5303L7.53033 9.46967Z", fill: "#03C8A4" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_120_11" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(0 20) rotate(-90)" }))));
const SvgArrowDownAccordion = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1781_20714)" }, /* @__PURE__ */ React.createElement("path", { d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1781_20714" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgArrowForward = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_18352_6081)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.67288 3.22412L8.53638 4.36063L13.034 8.86636H3.22461V10.4784H13.034L8.53638 14.9842L9.67288 16.1207L16.1212 9.6724L9.67288 3.22412Z", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_18352_6081" }, /* @__PURE__ */ React.createElement("rect", { width: 19.3448, height: 19.3448, fill: "white" }))));
const SvgArrowForwardGreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_120_2)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.53033 15.5303L8 16.0607L6.93934 15L7.46967 14.4697L8.53033 15.5303ZM13 10L13.5303 9.46967C13.8232 9.76256 13.8232 10.2374 13.5303 10.5303L13 10ZM7.46967 5.53033L6.93934 5L8 3.93934L8.53033 4.46967L7.46967 5.53033ZM7.46967 14.4697L12.4697 9.46967L13.5303 10.5303L8.53033 15.5303L7.46967 14.4697ZM12.4697 10.5303L7.46967 5.53033L8.53033 4.46967L13.5303 9.46967L12.4697 10.5303Z", fill: "#03C8A4" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_120_2" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(20) rotate(90)" }))));
const SvgArrowMedium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z", fill: "#0974C1" }));
const SvgArrowNorthEast = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7877_25259)" }, /* @__PURE__ */ React.createElement("path", { d: "M9 5V7H15.59L4 18.59L5.41 20L17 8.41V15H19V5H9Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7877_25259" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgAssignment = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_183_5108)" }, /* @__PURE__ */ React.createElement("path", { d: "M7 15H14V17H7V15ZM7 11H17V13H7V11ZM7 7H17V9H7V7ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_183_5108" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgAssignmentDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_19348_3745)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6667 1.99999H9.88C9.6 1.22666 8.86667 0.666656 8 0.666656C7.13333 0.666656 6.4 1.22666 6.12 1.99999H3.33333C2.6 1.99999 2 2.59999 2 3.33332V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33332C14 2.59999 13.4 1.99999 12.6667 1.99999ZM8 1.99999C8.36667 1.99999 8.66667 2.29999 8.66667 2.66666C8.66667 3.03332 8.36667 3.33332 8 3.33332C7.63333 3.33332 7.33333 3.03332 7.33333 2.66666C7.33333 2.29999 7.63333 1.99999 8 1.99999ZM9.33333 11.3333H4.66667V9.99999H9.33333V11.3333ZM11.3333 8.66666H4.66667V7.33332H11.3333V8.66666ZM11.3333 5.99999H4.66667V4.66666H11.3333V5.99999Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_19348_3745" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgAttachFile = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" }));
const SvgBin = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1886_2739)" }, /* @__PURE__ */ React.createElement("path", { d: "M3.99967 12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V4.66667H3.99967V12.6667ZM12.6663 2.66667H10.333L9.66634 2H6.33301L5.66634 2.66667H3.33301V4H12.6663V2.66667Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1886_2739" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBinOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.6668 6V12.6667H5.3335V6H10.6668ZM9.66683 2H6.3335L5.66683 2.66667H3.3335V4H12.6668V2.66667H10.3335L9.66683 2ZM12.0002 4.66667H4.00016V12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V4.66667Z", fill: "#EC4A4A" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3738_16877" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBlock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15892_10086)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM2.66634 8.00016C2.66634 5.0535 5.05301 2.66683 7.99967 2.66683C9.23301 2.66683 10.3663 3.08683 11.2663 3.7935L3.79301 11.2668C3.08634 10.3668 2.66634 9.2335 2.66634 8.00016ZM7.99967 13.3335C6.76634 13.3335 5.63301 12.9135 4.73301 12.2068L12.2063 4.7335C12.913 5.6335 13.333 6.76683 13.333 8.00016C13.333 10.9468 10.9463 13.3335 7.99967 13.3335Z", fill: "#62748C" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15892_10086" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBlueInfo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5662_1407)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.33301 4.66634H8.66634V5.99967H7.33301V4.66634ZM7.33301 7.33301H8.66634V11.333H7.33301V7.33301ZM7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05967 13.333 2.66634 10.9397 2.66634 7.99967C2.66634 5.05967 5.05967 2.66634 7.99967 2.66634C10.9397 2.66634 13.333 5.05967 13.333 7.99967C13.333 10.9397 10.9397 13.333 7.99967 13.333Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5662_1407" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBook = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 16C7.28333 16 8.04583 16.0875 8.7875 16.2625C9.52917 16.4375 10.2667 16.7 11 17.05V7.2C10.3167 6.8 9.59167 6.5 8.825 6.3C8.05833 6.1 7.28333 6 6.5 6C5.9 6 5.30417 6.05833 4.7125 6.175C4.12083 6.29167 3.55 6.46667 3 6.7V16.6C3.58333 16.4 4.1625 16.25 4.7375 16.15C5.3125 16.05 5.9 16 6.5 16ZM13 17.05C13.7333 16.7 14.4708 16.4375 15.2125 16.2625C15.9542 16.0875 16.7167 16 17.5 16C18.1 16 18.6875 16.05 19.2625 16.15C19.8375 16.25 20.4167 16.4 21 16.6V6.7C20.45 6.46667 19.8792 6.29167 19.2875 6.175C18.6958 6.05833 18.1 6 17.5 6C16.7167 6 15.9417 6.1 15.175 6.3C14.4083 6.5 13.6833 6.8 13 7.2V17.05ZM12 20C11.2 19.3667 10.3333 18.875 9.4 18.525C8.46667 18.175 7.5 18 6.5 18C5.8 18 5.1125 18.0917 4.4375 18.275C3.7625 18.4583 3.11667 18.7167 2.5 19.05C2.15 19.2333 1.8125 19.225 1.4875 19.025C1.1625 18.825 1 18.5333 1 18.15V6.1C1 5.91667 1.04583 5.74167 1.1375 5.575C1.22917 5.40833 1.36667 5.28333 1.55 5.2C2.31667 4.8 3.11667 4.5 3.95 4.3C4.78333 4.1 5.63333 4 6.5 4C7.46667 4 8.4125 4.125 9.3375 4.375C10.2625 4.625 11.15 5 12 5.5C12.85 5 13.7375 4.625 14.6625 4.375C15.5875 4.125 16.5333 4 17.5 4C18.3667 4 19.2167 4.1 20.05 4.3C20.8833 4.5 21.6833 4.8 22.45 5.2C22.6333 5.28333 22.7708 5.40833 22.8625 5.575C22.9542 5.74167 23 5.91667 23 6.1V18.15C23 18.5333 22.8375 18.825 22.5125 19.025C22.1875 19.225 21.85 19.2333 21.5 19.05C20.8833 18.7167 20.2375 18.4583 19.5625 18.275C18.8875 18.0917 18.2 18 17.5 18C16.5 18 15.5333 18.175 14.6 18.525C13.6667 18.875 12.8 19.3667 12 20Z", fill: "#0974C1" }));
const SvgBookmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7359_2867)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 1.33325H3.99999C3.26666 1.33325 2.66666 1.93325 2.66666 2.66659V13.3333C2.66666 14.0666 3.26666 14.6666 3.99999 14.6666H12C12.7333 14.6666 13.3333 14.0666 13.3333 13.3333V2.66659C13.3333 1.93325 12.7333 1.33325 12 1.33325ZM3.99999 2.66659H7.33332V7.99992L5.66666 6.99992L3.99999 7.99992V2.66659Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7359_2867" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBookmarkFlagEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15892_10205)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.333 2H4.66634C3.93301 2 3.33967 2.6 3.33967 3.33333L3.33301 14L7.99967 12L12.6663 14V3.33333C12.6663 2.6 12.0663 2 11.333 2ZM11.333 12L7.99967 10.5467L4.66634 12V3.33333H11.333V12Z", fill: "#62748C" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15892_10205" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBookmarkFlagFull = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15892_3856)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.333 2H4.66634C3.93301 2 3.33967 2.6 3.33967 3.33333L3.33301 14L7.99967 12L12.6663 14V3.33333C12.6663 2.6 12.0663 2 11.333 2Z", fill: "#62748C" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15892_3856" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBookmarkOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_14906_1468)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.9998 1.33331H3.99984C3.2665 1.33331 2.6665 1.93331 2.6665 2.66665V13.3333C2.6665 14.0666 3.2665 14.6666 3.99984 14.6666H11.9998C12.7332 14.6666 13.3332 14.0666 13.3332 13.3333V2.66665C13.3332 1.93331 12.7332 1.33331 11.9998 1.33331ZM5.99984 2.66665H7.33317V5.99998L6.6665 5.49998L5.99984 5.99998V2.66665ZM11.9998 13.3333H3.99984V2.66665H4.6665V8.66665L6.6665 7.16665L8.6665 8.66665V2.66665H11.9998V13.3333Z", fill: "#3388FF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_14906_1468" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgBox = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 30", width: 50, height: 30, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 0.5H25H34L42.5 10L27 21.5L8.5 10L16.5 0.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("ellipse", { cx: 24.9998, cy: 25.6668, rx: 24.3748, ry: 4.33329, fill: "#ADBFD9" }), /* @__PURE__ */ React.createElement("path", { d: "M34.1133 0.5L42.3896 10.5205L25.9902 21.7334L8.24805 10.5059L16.5527 0.5H34.1133Z", stroke: "#62748C" }), /* @__PURE__ */ React.createElement("mask", { id: "sz-icon-box-mask", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10C42.4687 10.0001 43.3643 10.8955 43.3643 12V25.333C43.3643 26.4375 42.4687 27.3329 41.3643 27.333H9.30273C8.19817 27.333 7.30273 26.4376 7.30273 25.333V12C7.30273 10.8954 8.19816 10 9.30273 10H17.3193L18.2402 13.2168C18.4858 14.0749 19.2705 14.6669 20.1631 14.667H30.0615C31.0042 14.6669 31.8187 14.0077 32.0166 13.0859L32.6797 10H41.3643Z" })), /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10C42.4687 10.0001 43.3643 10.8955 43.3643 12V25.333C43.3643 26.4375 42.4687 27.3329 41.3643 27.333H9.30273C8.19817 27.333 7.30273 26.4376 7.30273 25.333V12C7.30273 10.8954 8.19816 10 9.30273 10H17.3193L18.2402 13.2168C18.4858 14.0749 19.2705 14.6669 20.1631 14.667H30.0615C31.0042 14.6669 31.8187 14.0077 32.0166 13.0859L32.6797 10H41.3643Z", fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10L41.3644 9H41.3643V10ZM41.3643 27.333V28.333H41.3644L41.3643 27.333ZM9.30273 27.333L9.30273 28.333H9.30273V27.333ZM17.3193 10L18.2807 9.72478L18.0732 9H17.3193V10ZM18.2402 13.2168L19.2016 12.9416L19.2016 12.9416L18.2402 13.2168ZM20.1631 14.667L20.163 15.667H20.1631V14.667ZM30.0615 14.667V15.667H30.0616L30.0615 14.667ZM32.0166 13.0859L31.0389 12.8759L31.0389 12.8761L32.0166 13.0859ZM32.6797 10V9H31.8717L31.702 9.78992L32.6797 10ZM41.3643 10L41.3641 11C41.9165 11.0001 42.3643 11.4479 42.3643 12H43.3643H44.3643C44.3643 10.3431 43.0209 9.00018 41.3644 9L41.3643 10ZM43.3643 12H42.3643V25.333H43.3643H44.3643V12H43.3643ZM43.3643 25.333H42.3643C42.3643 25.8851 41.9165 26.3329 41.3641 26.333L41.3643 27.333L41.3644 28.333C43.0209 28.3328 44.3643 26.9899 44.3643 25.333H43.3643ZM41.3643 27.333V26.333H9.30273V27.333V28.333H41.3643V27.333ZM9.30273 27.333L9.30274 26.333C8.75045 26.333 8.30273 25.8853 8.30273 25.333H7.30273H6.30273C6.30273 26.9899 7.64588 28.333 9.30273 28.333L9.30273 27.333ZM7.30273 25.333H8.30273V12H7.30273H6.30273V25.333H7.30273ZM7.30273 12H8.30273C8.30273 11.4477 8.75045 11 9.30273 11V10V9C7.64588 9 6.30273 10.3431 6.30273 12H7.30273ZM9.30273 10V11H17.3193V10V9H9.30273V10ZM17.3193 10L16.358 10.2752L17.2789 13.492L18.2402 13.2168L19.2016 12.9416L18.2807 9.72478L17.3193 10ZM18.2402 13.2168L17.2788 13.492C17.6472 14.7789 18.8239 15.6669 20.163 15.667L20.1631 14.667L20.1632 13.667C19.7172 13.6669 19.3245 13.3709 19.2016 12.9416L18.2402 13.2168ZM20.1631 14.667V15.667H30.0615V14.667V13.667H20.1631V14.667ZM30.0615 14.667L30.0616 15.667C31.4764 15.6668 32.6977 14.6777 32.9943 13.2958L32.0166 13.0859L31.0389 12.8761C30.9398 13.3376 30.5321 13.6669 30.0614 13.667L30.0615 14.667ZM32.0166 13.0859L32.9943 13.296L33.6574 10.2101L32.6797 10L31.702 9.78992L31.0389 12.8759L32.0166 13.0859ZM32.6797 10V11H41.3643V10V9H32.6797V10Z", fill: "#62748C", mask: "url(#sz-icon-box-mask)" }));
const SvgBreadcrumbArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_243_41430)" }, /* @__PURE__ */ React.createElement("path", { d: "M8 14L12 10L8 6", stroke: "#4D4B4B", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_243_41430" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(20) rotate(90)" }))));
const SvgBriefcase = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7538_18831)" }, /* @__PURE__ */ React.createElement("path", { d: "M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7538_18831" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgBuild = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_183_5126)" }, /* @__PURE__ */ React.createElement("path", { d: "M22.61 18.99L13.53 9.90997C14.46 7.56997 13.98 4.80997 12.09 2.90997C9.79001 0.609971 6.21001 0.399971 3.66001 2.25997L7.50001 6.10997L6.08001 7.51997L2.25001 3.68997C0.390007 6.22997 0.600007 9.81997 2.90001 12.11C4.76001 13.97 7.47001 14.46 9.79001 13.59L18.9 22.7C19.29 23.09 19.92 23.09 20.31 22.7L22.61 20.4C23.01 20.02 23.01 19.39 22.61 18.99ZM19.61 20.59L10.15 11.13C9.54001 11.58 8.86001 11.85 8.15001 11.95C6.79001 12.15 5.36001 11.74 4.32001 10.7C3.37001 9.75997 2.93001 8.49997 3.00001 7.25997L6.09001 10.35L10.33 6.10997L7.24001 3.01997C8.48001 2.94997 9.73001 3.38997 10.68 4.32997C11.76 5.40997 12.17 6.89997 11.92 8.28997C11.8 8.99997 11.5 9.65997 11.04 10.25L20.49 19.7L19.61 20.59Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_183_5126" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgCalculate = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_183_5089)" }, /* @__PURE__ */ React.createElement("path", { d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M11.25 7.71997H6.25V9.21997H11.25V7.71997Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M18 15.75H13V17.25H18V15.75Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M18 13.25H13V14.75H18V13.25Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M14.09 10.95L15.5 9.54L16.91 10.95L17.97 9.89L16.56 8.47L17.97 7.06L16.91 6L15.5 7.41L14.09 6L13.03 7.06L14.44 8.47L13.03 9.89L14.09 10.95Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_183_5089" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5963_10451)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.333 2H12.6663V0.666664H11.333V2H4.66634V0.666664H3.33301V2H2.66634C1.93301 2 1.33301 2.6 1.33301 3.33333V14C1.33301 14.7333 1.93301 15.3333 2.66634 15.3333H13.333C14.0663 15.3333 14.6663 14.7333 14.6663 14V3.33333C14.6663 2.6 14.0663 2 13.333 2ZM13.333 14H2.66634V5.33333H13.333V14Z", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5963_10451" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgCalendarEvent = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9682_109714)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.1667 2.66665H12.5V1.33331H11.1667V2.66665H5.83333V1.33331H4.5V2.66665H3.83333C3.09333 2.66665 2.50667 3.26665 2.50667 3.99998L2.5 13.3333C2.5 14.0666 3.09333 14.6666 3.83333 14.6666H13.1667C13.9 14.6666 14.5 14.0666 14.5 13.3333V3.99998C14.5 3.26665 13.9 2.66665 13.1667 2.66665ZM13.1667 13.3333H3.83333V6.66665H13.1667V13.3333ZM13.1667 5.33331H3.83333V3.99998H13.1667V5.33331ZM8.5 8.66665H11.8333V12H8.5V8.66665Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9682_109714" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }))));
const SvgCalendarToday = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4519_4218)" }, /* @__PURE__ */ React.createElement("path", { d: "M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4519_4218" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgCallSplit = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.66667 0L8.19333 1.52667L6.27333 3.44667L7.22 4.39333L9.14 2.47333L10.6667 4V0H6.66667ZM4 0H0V4L1.52667 2.47333L4.66667 5.60667V10.6667H6V5.06L2.47333 1.52667L4 0Z", fill: "#00204D" }));
const SvgCancel = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17939_2999)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.00008 1.16667C3.77425 1.16667 1.16675 3.77417 1.16675 7.00001C1.16675 10.2258 3.77425 12.8333 7.00008 12.8333C10.2259 12.8333 12.8334 10.2258 12.8334 7.00001C12.8334 3.77417 10.2259 1.16667 7.00008 1.16667ZM7.00008 11.6667C4.42758 11.6667 2.33341 9.57251 2.33341 7.00001C2.33341 4.42751 4.42758 2.33334 7.00008 2.33334C9.57258 2.33334 11.6667 4.42751 11.6667 7.00001C11.6667 9.57251 9.57258 11.6667 7.00008 11.6667ZM9.09425 4.08334L7.00008 6.17751L4.90591 4.08334L4.08341 4.90584L6.17758 7.00001L4.08341 9.09417L4.90591 9.91667L7.00008 7.82251L9.09425 9.91667L9.91675 9.09417L7.82258 7.00001L9.91675 4.90584L9.09425 4.08334Z", fill: "#B31212" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17939_2999" }, /* @__PURE__ */ React.createElement("rect", { width: 14, height: 14, fill: "white" }))));
const SvgCancelFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M8.2 8.2L15.8 15.8M15.8 8.2L8.2 15.8", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }));
const SvgChat = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_5171_3936", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 17 }, /* @__PURE__ */ React.createElement("rect", { y: 0.500244, width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_5171_3936)" }, /* @__PURE__ */ React.createElement("path", { d: "M3.99992 9.8335H9.33325V8.50016H3.99992V9.8335ZM3.99992 7.8335H11.9999V6.50016H3.99992V7.8335ZM3.99992 5.8335H11.9999V4.50016H3.99992V5.8335ZM1.33325 15.1668V3.16683C1.33325 2.80016 1.46381 2.48627 1.72492 2.22516C1.98603 1.96405 2.29992 1.8335 2.66659 1.8335H13.3333C13.6999 1.8335 14.0138 1.96405 14.2749 2.22516C14.536 2.48627 14.6666 2.80016 14.6666 3.16683V11.1668C14.6666 11.5335 14.536 11.8474 14.2749 12.1085C14.0138 12.3696 13.6999 12.5002 13.3333 12.5002H3.99992L1.33325 15.1668ZM3.43325 11.1668H13.3333V3.16683H2.66659V11.9168L3.43325 11.1668Z", fill: "#3392D6" })));
const SvgChatIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 2V9H3.17L2.58 9.59L2 10.17V2H13ZM14 0H1C0.45 0 0 0.45 0 1V15L4 11H14C14.55 11 15 10.55 15 10V1C15 0.45 14.55 0 14 0ZM19 4H17V13H4V15C4 15.55 4.45 16 5 16H16L20 20V5C20 4.45 19.55 4 19 4Z", fill: "#006AFF" }));
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2584_2987)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.50001 10.78L3.72001 7.99999L2.77335 8.93999L6.50001 12.6667L14.5 4.66665L13.56 3.72665L6.50001 10.78Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2584_2987" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }))));
const SvgCheckCircleGreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5684_22658)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z", fill: "#007A6A" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5684_22658" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgCheckCircleGreenSmall = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_13412_4)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 1.75C4.05 1.75 1.25 4.55 1.25 8C1.25 11.45 4.05 14.25 7.5 14.25C10.95 14.25 13.75 11.45 13.75 8C13.75 4.55 10.95 1.75 7.5 1.75Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M7.5 1.75C4.05 1.75 1.25 4.55 1.25 8C1.25 11.45 4.05 14.25 7.5 14.25C10.95 14.25 13.75 11.45 13.75 8C13.75 4.55 10.95 1.75 7.5 1.75ZM6.25 11.125L3.125 8L4.00625 7.11875L6.25 9.35625L10.9937 4.6125L11.875 5.5L6.25 11.125Z", fill: "#339D8F" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_13412_4" }, /* @__PURE__ */ React.createElement("rect", { width: 15, height: 15, fill: "white" }))));
const SvgCheckCircleOutline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" }));
const SvgChecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 8, fill: "#FFD129" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7732_22406)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.79948 9.66724L5.13148 7.99924L4.56348 8.56324L6.79948 10.7992L11.5995 5.99924L11.0355 5.43524L6.79948 9.66724Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7732_22406" }, /* @__PURE__ */ React.createElement("rect", { width: 9.6, height: 9.6, fill: "white", transform: "translate(3.19922 3.19922)" }))));
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 5, viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.94 0L4 3.05333L7.06 0L8 0.94L4 4.94L0 0.94L0.94 0Z", fill: "white" }));
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.2733 3.94L9.33333 3L4.33333 8L9.33333 13L10.2733 12.06L6.22 8L10.2733 3.94Z", fill: "currentColor" }));
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.72667 3.94L6.66667 3L11.6667 8L6.66667 13L5.72667 12.06L9.78 8L5.72667 3.94Z", fill: "currentColor" }));
const SvgClock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1781_23313)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.0466 0.672852H6.04663V2.00618H10.0466V0.672852ZM7.37996 9.33952H8.7133V5.33952H7.37996V9.33952ZM12.7333 4.92618L13.68 3.97952C13.3933 3.63952 13.08 3.31952 12.74 3.03952L11.7933 3.98618C10.76 3.15952 9.45996 2.66618 8.04663 2.66618C4.7333 2.66618 2.04663 5.35285 2.04663 8.66618C2.04663 11.9795 4.72663 14.6662 8.04663 14.6662C11.3666 14.6662 14.0466 11.9795 14.0466 8.66618C14.0466 7.25952 13.5533 5.95952 12.7333 4.92618ZM8.04663 13.3395C5.46663 13.3395 3.37996 11.2529 3.37996 8.67285C3.37996 6.09285 5.46663 4.00618 8.04663 4.00618C10.6266 4.00618 12.7133 6.09285 12.7133 8.67285C12.7133 11.2529 10.6266 13.3395 8.04663 13.3395Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1781_23313" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }));
const SvgCloseSmall = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.33333 0.94L8.39334 0L4.66667 3.72667L0.94 0L0 0.94L3.72667 4.66667L0 8.39334L0.94 9.33333L4.66667 5.60667L8.39334 9.33333L9.33333 8.39334L5.60667 4.66667L9.33333 0.94Z", fill: "#00204D" }));
const SvgComputer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.666667 14V12.6667H15.3333V14H0.666667ZM2.66667 12C2.3 12 1.98611 11.8694 1.725 11.6083C1.46389 11.3472 1.33333 11.0333 1.33333 10.6667V3.33333C1.33333 2.96667 1.46389 2.65278 1.725 2.39167C1.98611 2.13056 2.3 2 2.66667 2H13.3333C13.7 2 14.0139 2.13056 14.275 2.39167C14.5361 2.65278 14.6667 2.96667 14.6667 3.33333V10.6667C14.6667 11.0333 14.5361 11.3472 14.275 11.6083C14.0139 11.8694 13.7 12 13.3333 12H2.66667ZM2.66667 10.6667H13.3333V3.33333H2.66667V10.6667Z", fill: "#0070BF" }));
const SvgConstruction = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_16771_2386)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.6027 8.70055L9.18848 10.1147L13.1859 14.1122L14.6001 12.698L10.6027 8.70055Z" }), /* @__PURE__ */ React.createElement("path", { d: "M11.6666 6.6667C12.9532 6.6667 13.9999 5.62003 13.9999 4.33337C13.9999 3.9467 13.8932 3.5867 13.7266 3.2667L11.9266 5.0667L10.9332 4.07337L12.7332 2.27337C12.4132 2.1067 12.0532 2.00003 11.6666 2.00003C10.3799 2.00003 9.33323 3.0467 9.33323 4.33337C9.33323 4.6067 9.38657 4.8667 9.47324 5.1067L8.2399 6.34003L7.05324 5.15337L7.52657 4.68003L6.58657 3.74003L7.9999 2.3267C7.2199 1.5467 5.95324 1.5467 5.17324 2.3267L2.81324 4.6867L3.75324 5.6267H1.87324L1.3999 6.10003L3.7599 8.46003L4.23324 7.9867V6.10003L5.17324 7.04003L5.64657 6.5667L6.83324 7.75337L1.89324 12.6934L3.30657 14.1067L10.8932 6.5267C11.1332 6.61337 11.3932 6.6667 11.6666 6.6667Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_16771_2386" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgContentCopy = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "content_copy", clipPath: "url(#clip0_5084_3019)" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M10.6666 0.666626H2.66659C1.93325 0.666626 1.33325 1.26663 1.33325 1.99996V11.3333H2.66659V1.99996H10.6666V0.666626ZM12.6666 3.33329H5.33325C4.59992 3.33329 3.99992 3.93329 3.99992 4.66663V14C3.99992 14.7333 4.59992 15.3333 5.33325 15.3333H12.6666C13.3999 15.3333 13.9999 14.7333 13.9999 14V4.66663C13.9999 3.93329 13.3999 3.33329 12.6666 3.33329ZM12.6666 14H5.33325V4.66663H12.6666V14Z", fill: "currentColor" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5084_3019" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "currentColor" }))));
const SvgCopy = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2584_3167)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.6667 0.666656H2.66671C1.93337 0.666656 1.33337 1.26666 1.33337 1.99999V11.3333H2.66671V1.99999H10.6667V0.666656ZM12.6667 3.33332H5.33337C4.60004 3.33332 4.00004 3.93332 4.00004 4.66666V14C4.00004 14.7333 4.60004 15.3333 5.33337 15.3333H12.6667C13.4 15.3333 14 14.7333 14 14V4.66666C14 3.93332 13.4 3.33332 12.6667 3.33332ZM12.6667 14H5.33337V4.66666H12.6667V14Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2584_3167" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgDei = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1548_33444", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1548_33444)" }, /* @__PURE__ */ React.createElement("path", { d: "M19 8C19.2833 8 19.5208 7.90417 19.7125 7.7125C19.9042 7.52083 20 7.28333 20 7C20 6.71667 19.9042 6.47917 19.7125 6.2875C19.5208 6.09583 19.2833 6 19 6C18.7167 6 18.4792 6.09583 18.2875 6.2875C18.0958 6.47917 18 6.71667 18 7C18 7.28333 18.0958 7.52083 18.2875 7.7125C18.4792 7.90417 18.7167 8 19 8ZM19 10C18.15 10 17.4375 9.7125 16.8625 9.1375C16.2875 8.5625 16 7.85 16 7C16 6.16667 16.2875 5.45833 16.8625 4.875C17.4375 4.29167 18.15 4 19 4C19.8333 4 20.5417 4.29167 21.125 4.875C21.7083 5.45833 22 6.16667 22 7C22 7.85 21.7083 8.5625 21.125 9.1375C20.5417 9.7125 19.8333 10 19 10ZM12 7C12.4167 7 12.7708 6.85833 13.0625 6.575C13.3542 6.29167 13.5 5.93333 13.5 5.5C13.5 5.08333 13.3542 4.72917 13.0625 4.4375C12.7708 4.14583 12.4167 4 12 4C11.5667 4 11.2083 4.14583 10.925 4.4375C10.6417 4.72917 10.5 5.08333 10.5 5.5C10.5 5.93333 10.6417 6.29167 10.925 6.575C11.2083 6.85833 11.5667 7 12 7ZM12 9C11.0167 9 10.1875 8.6625 9.51249 7.9875C8.83748 7.3125 8.49998 6.48333 8.49998 5.5C8.49998 4.53333 8.83748 3.70833 9.51249 3.025C10.1875 2.34167 11.0167 2 12 2C12.9667 2 13.7917 2.34167 14.475 3.025C15.1583 3.70833 15.5 4.53333 15.5 5.5C15.5 6.48333 15.1583 7.3125 14.475 7.9875C13.7917 8.6625 12.9667 9 12 9ZM7.99998 13.375C7.99998 13.875 8.26665 14.4583 8.79998 15.125C9.33332 15.7917 10.4 16.85 12 18.3C13.5667 16.8833 14.625 15.8417 15.175 15.175C15.725 14.5083 16 13.9083 16 13.375C16 12.9917 15.875 12.6667 15.625 12.4C15.375 12.1333 15.0667 12 14.7 12C14.4667 12 14.2458 12.05 14.0375 12.15C13.8292 12.25 13.6583 12.3917 13.525 12.575L12.325 14H11.65L10.45 12.575C10.3167 12.3917 10.1458 12.25 9.93748 12.15C9.72915 12.05 9.51665 12 9.29998 12C8.91665 12 8.60415 12.1333 8.36248 12.4C8.12082 12.6667 7.99998 12.9917 7.99998 13.375ZM5.99998 13.375C5.99998 12.4917 6.29998 11.7083 6.89998 11.025C7.49998 10.3417 8.29998 10 9.29998 10C9.81665 10 10.3125 10.1167 10.7875 10.35C11.2625 10.5833 11.6667 10.9 12 11.3C12.3333 10.9 12.7333 10.5833 13.2 10.35C13.6667 10.1167 14.1667 10 14.7 10C15.7 10 16.5 10.3458 17.1 11.0375C17.7 11.7292 18 12.5083 18 13.375C18 14.2583 17.6792 15.1292 17.0375 15.9875C16.3958 16.8458 15.0833 18.1833 13.1 20L12 21L10.9 20C8.88332 18.1667 7.56248 16.825 6.93748 15.975C6.31248 15.125 5.99998 14.2583 5.99998 13.375ZM4.99998 8C5.28332 8 5.52082 7.90417 5.71248 7.7125C5.90415 7.52083 5.99998 7.28333 5.99998 7C5.99998 6.71667 5.90415 6.47917 5.71248 6.2875C5.52082 6.09583 5.28332 6 4.99998 6C4.71665 6 4.47915 6.09583 4.28748 6.2875C4.09582 6.47917 3.99998 6.71667 3.99998 7C3.99998 7.28333 4.09582 7.52083 4.28748 7.7125C4.47915 7.90417 4.71665 8 4.99998 8ZM12.075 22V20H20V13H17.05V11H20C20.55 11 21.0208 11.1958 21.4125 11.5875C21.8042 11.9792 22 12.45 22 13V22H12.075ZM3.99998 20H12.075V22H1.99998V13C1.99998 12.45 2.19165 11.9792 2.57498 11.5875C2.95832 11.1958 3.43332 11 3.99998 11H6.94999V13H3.99998V20ZM4.99998 10C4.14998 10 3.43748 9.7125 2.86248 9.1375C2.28748 8.5625 1.99998 7.85 1.99998 7C1.99998 6.16667 2.28748 5.45833 2.86248 4.875C3.43748 4.29167 4.14998 4 4.99998 4C5.83332 4 6.54165 4.29167 7.12498 4.875C7.70832 5.45833 7.99998 6.16667 7.99998 7C7.99998 7.85 7.70832 8.5625 7.12498 9.1375C6.54165 9.7125 5.83332 10 4.99998 10Z", fill: "#0974C1" })));
const SvgDeleteOutline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z" }));
const SvgDoorOpen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "door_open" }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_0_4", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { id: "Bounding box", width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_0_4)" }, /* @__PURE__ */ React.createElement("path", { id: "door_open_2", d: "M7.33333 8.66667C7.52222 8.66667 7.68056 8.60278 7.80833 8.475C7.93611 8.34722 8 8.18889 8 8C8 7.81111 7.93611 7.65278 7.80833 7.525C7.68056 7.39722 7.52222 7.33333 7.33333 7.33333C7.14444 7.33333 6.98611 7.39722 6.85833 7.525C6.73056 7.65278 6.66667 7.81111 6.66667 8C6.66667 8.18889 6.73056 8.34722 6.85833 8.475C6.98611 8.60278 7.14444 8.66667 7.33333 8.66667ZM4.66667 14V12.6667L8.66667 12V4.58333C8.66667 4.41667 8.61667 4.26667 8.51667 4.13333C8.41667 4 8.28889 3.92222 8.13333 3.9L4.66667 3.33333V2L8.33333 2.6C8.82222 2.68889 9.22222 2.91667 9.53333 3.28333C9.84444 3.65 10 4.07778 10 4.56667V13.1L4.66667 14ZM2 14V12.6667H3.33333V3.33333C3.33333 2.95556 3.46389 2.63889 3.725 2.38333C3.98611 2.12778 4.3 2 4.66667 2H11.3333C11.7111 2 12.0278 2.12778 12.2833 2.38333C12.5389 2.63889 12.6667 2.95556 12.6667 3.33333V12.6667H14V14H2ZM4.66667 12.6667H11.3333V3.33333H4.66667V12.6667Z", fill: "#0974C1" }))));
const SvgDotsHorizontal = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15763_69969)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.59961 1.6001C5.18361 1.6001 1.59961 5.1841 1.59961 9.6001C1.59961 14.0161 5.18361 17.6001 9.59961 17.6001C14.0156 17.6001 17.5996 14.0161 17.5996 9.6001C17.5996 5.1841 14.0156 1.6001 9.59961 1.6001ZM9.59961 16.0001C6.06361 16.0001 3.19961 13.1361 3.19961 9.6001C3.19961 6.0641 6.06361 3.2001 9.59961 3.2001C13.1356 3.2001 15.9996 6.0641 15.9996 9.6001C15.9996 13.1361 13.1356 16.0001 9.59961 16.0001Z" }), /* @__PURE__ */ React.createElement("path", { d: "M5.59941 10.7999C6.26216 10.7999 6.79941 10.2626 6.79941 9.5999C6.79941 8.93716 6.26216 8.3999 5.59941 8.3999C4.93667 8.3999 4.39941 8.93716 4.39941 9.5999C4.39941 10.2626 4.93667 10.7999 5.59941 10.7999Z" }), /* @__PURE__ */ React.createElement("path", { d: "M9.59941 10.7999C10.2622 10.7999 10.7994 10.2626 10.7994 9.5999C10.7994 8.93716 10.2622 8.3999 9.59941 8.3999C8.93667 8.3999 8.39941 8.93716 8.39941 9.5999C8.39941 10.2626 8.93667 10.7999 9.59941 10.7999Z" }), /* @__PURE__ */ React.createElement("path", { d: "M13.5994 10.7999C14.2622 10.7999 14.7994 10.2626 14.7994 9.5999C14.7994 8.93716 14.2622 8.3999 13.5994 8.3999C12.9367 8.3999 12.3994 8.93716 12.3994 9.5999C12.3994 10.2626 12.9367 10.7999 13.5994 10.7999Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15763_69969" }, /* @__PURE__ */ React.createElement("rect", { width: 19.2, height: 19.2 }))));
const SvgDotsVertical = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_13886_3184)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00033 5.33341C8.73366 5.33341 9.33366 4.73341 9.33366 4.00008C9.33366 3.26675 8.73366 2.66675 8.00033 2.66675C7.26699 2.66675 6.66699 3.26675 6.66699 4.00008C6.66699 4.73341 7.26699 5.33341 8.00033 5.33341ZM8.00033 6.66675C7.26699 6.66675 6.66699 7.26675 6.66699 8.00008C6.66699 8.73342 7.26699 9.33342 8.00033 9.33342C8.73366 9.33342 9.33366 8.73342 9.33366 8.00008C9.33366 7.26675 8.73366 6.66675 8.00033 6.66675ZM8.00033 10.6667C7.26699 10.6667 6.66699 11.2667 6.66699 12.0001C6.66699 12.7334 7.26699 13.3334 8.00033 13.3334C8.73366 13.3334 9.33366 12.7334 9.33366 12.0001C9.33366 11.2667 8.73366 10.6667 8.00033 10.6667Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_13886_3184" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgDoubleThumbDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 24", width: 25, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.5 2.25753H20.8983C20.4579 2.25753 20.0975 2.68058 20.0975 3.19764L20.0975 11.6586C20.0975 12.1757 20.4579 12.5988 20.8983 12.5988H22.5L22.5 2.25753ZM6.61942 8.95113C6.53133 9.18615 6.48328 9.43999 6.48328 9.70322V10.7185C6.48328 11.7527 7.20403 12.5988 8.08495 12.5988H12.4895L11.7528 16.9703C11.7127 17.1771 11.7368 17.4027 11.8168 17.5908C12.001 18.0138 12.2333 18.3993 12.5216 18.7377L12.89 19.1795L18.0233 13.1534C18.3276 12.7962 18.4958 12.3167 18.4958 11.8185V4.44799C18.4958 3.24465 17.6549 2.25753 16.6219 2.25753H10.1271C9.56649 2.25753 9.03794 2.60537 8.74964 3.16944L6.61942 8.95113Z" }), /* @__PURE__ */ React.createElement("path", { d: "M2.5 12.5236C2.5 12.2603 2.54805 12.0065 2.63614 11.7715L4.76637 5.98977C5.05467 5.4257 5.58322 5.07786 6.1438 5.07786H6.62702L5.37468 8.47688L5.37329 8.48062C5.2304 8.86317 5.15257 9.27619 5.15257 9.70328V10.7186C5.15257 12.2878 6.28328 13.9502 8.10565 13.9502H10.912L10.443 16.733C10.3576 17.1951 10.4096 17.6871 10.5942 18.1204L10.5985 18.1303C10.7708 18.526 10.9817 18.9068 11.2382 19.2628L8.90669 21.9999L8.5383 21.558C8.25 21.2196 8.01776 20.8341 7.83357 20.4111C7.75348 20.2231 7.72946 19.9974 7.7695 19.7906L8.50627 15.4191L4.10167 15.4191C3.22075 15.4191 2.5 14.573 2.5 13.5389V12.5236Z" }));
const SvgDoubleThumbUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 24", width: 25, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 21.7423H4.10167C4.54213 21.7423 4.90251 21.3193 4.90251 20.8022V12.3412C4.90251 11.8242 4.54213 11.4011 4.10167 11.4011H2.5V21.7423ZM18.3806 15.0488C18.4687 14.8137 18.5167 14.5599 18.5167 14.2967V13.2813C18.5167 12.2472 17.796 11.4011 16.9151 11.4011H12.5105L13.2472 7.0296C13.2873 6.82277 13.2632 6.59715 13.1832 6.40912C12.999 5.98607 12.7667 5.60063 12.4784 5.26219L12.11 4.82033L6.97667 10.8465C6.67236 11.2037 6.50418 11.6832 6.50418 12.1814V19.5519C6.50418 20.7552 7.34506 21.7423 8.37814 21.7423H14.8729C15.4335 21.7423 15.9621 21.3945 16.2504 20.8304L18.3806 15.0488Z" }), /* @__PURE__ */ React.createElement("path", { d: "M22.5 11.4763C22.5 11.7396 22.452 11.9934 22.3639 12.2284L20.2336 18.0101C19.9453 18.5742 19.4168 18.922 18.8562 18.922H18.373L19.6253 15.523L19.6267 15.5193C19.7696 15.1367 19.8474 14.7237 19.8474 14.2966V13.2813C19.8474 11.7121 18.7167 10.0496 16.8943 10.0496H14.088L14.557 7.26688C14.6424 6.80475 14.5904 6.31275 14.4058 5.87948L14.4015 5.86958C14.2292 5.47391 14.0183 5.0931 13.7618 4.73704L16.0933 2L16.4617 2.44185C16.75 2.78029 16.9822 3.16574 17.1664 3.58879C17.2465 3.77681 17.2705 4.00244 17.2305 4.20926L16.4937 8.58078H20.8983C21.7792 8.58078 22.5 9.42688 22.5 10.461V11.4763Z" }));
const SvgDragHandle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2290_2471)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.3332 6H2.6665V7.33333H13.3332V6ZM2.6665 10H13.3332V8.66667H2.6665V10Z", fill: "#62748C" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2290_2471" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgEditPencil = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "edit", clipPath: "url(#clip0_0_67)" }, /* @__PURE__ */ React.createElement("g", { id: "Vector" }), /* @__PURE__ */ React.createElement("path", { id: "Vector_2", d: "M1.5 8.625V10.5H3.375L8.905 4.97L7.03 3.095L1.5 8.625ZM10.355 3.52C10.55 3.325 10.55 3.01 10.355 2.815L9.185 1.645C8.99 1.45 8.675 1.45 8.48 1.645L7.565 2.56L9.44 4.435L10.355 3.52V3.52Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_0_67" }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, fill: "white" }))));
const SvgEmptyBox = (props) => /* @__PURE__ */ React.createElement("svg", { width: 78, height: 48, viewBox: "0 0 78 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 39, cy: 41.0671, rx: 39, ry: 6.93333, fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M53.7241 0.5L67.2651 16.8955L40.5922 35.1338L11.7485 16.8809L25.3442 0.5H53.7241Z", stroke: "#62748C" }), /* @__PURE__ */ React.createElement("mask", { id: "path-3-inside-1_12803_13086", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M66.3831 16C67.4877 16 68.3831 16.8954 68.3831 18V41.7334C68.3831 42.8379 67.4877 43.7334 66.3831 43.7334H12.6849C11.5804 43.7334 10.6849 42.8379 10.6849 41.7334V18C10.6849 16.8954 11.5803 16 12.6849 16H26.7122L28.4339 22.0166C28.6795 22.8747 29.4643 23.4666 30.3568 23.4668H48.0687C49.0113 23.4668 49.8258 22.8083 50.0238 21.8867L51.2874 16H66.3831Z" })), /* @__PURE__ */ React.createElement("path", { d: "M66.3831 16C67.4877 16 68.3831 16.8954 68.3831 18V41.7334C68.3831 42.8379 67.4877 43.7334 66.3831 43.7334H12.6849C11.5804 43.7334 10.6849 42.8379 10.6849 41.7334V18C10.6849 16.8954 11.5803 16 12.6849 16H26.7122L28.4339 22.0166C28.6795 22.8747 29.4643 23.4666 30.3568 23.4668H48.0687C49.0113 23.4668 49.8258 22.8083 50.0238 21.8867L51.2874 16H66.3831Z", fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M68.3831 41.7334L69.3831 41.7334V41.7334H68.3831ZM12.6849 43.7334L12.6849 44.7334H12.6849V43.7334ZM10.6849 41.7334H9.68491V41.7334L10.6849 41.7334ZM12.6849 16V15V16ZM26.7122 16L27.6737 15.7249L27.4662 15H26.7122V16ZM28.4339 22.0166L27.4725 22.2917L27.4725 22.2918L28.4339 22.0166ZM30.3568 23.4668L30.3566 24.4668H30.3568V23.4668ZM48.0687 23.4668V24.4668H48.0687L48.0687 23.4668ZM50.0238 21.8867L51.0015 22.0968L51.0015 22.0966L50.0238 21.8867ZM51.2874 16V15H50.4793L50.3097 15.7901L51.2874 16ZM66.3831 16V17C66.9354 17 67.3831 17.4477 67.3831 18H68.3831H69.3831C69.3831 16.3431 68.04 15 66.3831 15V16ZM68.3831 18H67.3831V41.7334H68.3831H69.3831V18H68.3831ZM68.3831 41.7334L67.3831 41.7334C67.3831 42.2857 66.9354 42.7334 66.3831 42.7334V43.7334V44.7334C68.04 44.7334 69.3831 43.3902 69.3831 41.7334L68.3831 41.7334ZM66.3831 43.7334V42.7334H12.6849V43.7334V44.7334H66.3831V43.7334ZM12.6849 43.7334L12.6849 42.7334C12.1327 42.7334 11.6849 42.2857 11.6849 41.7334L10.6849 41.7334L9.68491 41.7334C9.68496 43.3902 11.028 44.7334 12.6849 44.7334L12.6849 43.7334ZM10.6849 41.7334H11.6849V18H10.6849H9.68491V41.7334H10.6849ZM10.6849 18H11.6849C11.6849 17.4477 12.1326 17 12.6849 17V16V15C11.0281 15 9.68491 16.3431 9.68491 18H10.6849ZM12.6849 16V17H26.7122V16V15H12.6849V16ZM26.7122 16L25.7508 16.2751L27.4725 22.2917L28.4339 22.0166L29.3953 21.7415L27.6737 15.7249L26.7122 16ZM28.4339 22.0166L27.4725 22.2918C27.8409 23.5787 29.0177 24.4666 30.3566 24.4668L30.3568 23.4668L30.357 22.4668C29.9109 22.4667 29.5182 22.1706 29.3953 21.7414L28.4339 22.0166ZM30.3568 23.4668V24.4668H48.0687V23.4668V22.4668H30.3568V23.4668ZM48.0687 23.4668L48.0687 24.4668C49.483 24.4667 50.7045 23.4789 51.0015 22.0968L50.0238 21.8867L49.0461 21.6767C48.947 22.1377 48.5397 22.4668 48.0687 22.4668L48.0687 23.4668ZM50.0238 21.8867L51.0015 22.0966L52.2652 16.2099L51.2874 16L50.3097 15.7901L49.046 21.6768L50.0238 21.8867ZM51.2874 16V17H66.3831V16V15H51.2874V16Z", fill: "#62748C", mask: "url(#path-3-inside-1_12803_13086)" }));
const SvgEmptyMagicPen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_18670_14457)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z", fill: "#8B5ED4" }), /* @__PURE__ */ React.createElement("path", { d: "M2.7417 3.4248L2.82178 3.26074L2.98877 3.18652L3.4126 3L2.98877 2.81348L2.82178 2.73926L2.7417 2.5752L2.50537 2.09473L2.27588 2.57227L2.19482 2.73926L2.0249 2.81348L1.59717 3L2.0249 3.18652L2.19482 3.25977L2.2749 3.42578L2.50635 3.9043L2.7417 3.4248Z", stroke: "#8B5ED4" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_18670_14457" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgEmptyPen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_18670_14516)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z", fill: "#339D8F" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_18670_14516" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgEnvelope = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1781_22902)" }, /* @__PURE__ */ React.createElement("path", { d: "M14.6666 4.00033C14.6666 3.26699 14.0666 2.66699 13.3333 2.66699H2.66659C1.93325 2.66699 1.33325 3.26699 1.33325 4.00033V12.0003C1.33325 12.7337 1.93325 13.3337 2.66659 13.3337H13.3333C14.0666 13.3337 14.6666 12.7337 14.6666 12.0003V4.00033ZM13.3333 4.00033L7.99992 7.32699L2.66659 4.00033H13.3333ZM13.3333 12.0003H2.66659V5.33366L7.99992 8.66699L13.3333 5.33366V12.0003Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1781_22902" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgError = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.5 6.8916V13.1084L13.1084 17.5H6.8916L2.5 13.1084V6.8916L6.8916 2.5H13.1084L17.5 6.8916ZM10 12.5C9.53987 12.5 9.16717 12.8729 9.16699 13.333C9.16699 13.7932 9.53976 14.167 10 14.167C10.4602 14.167 10.833 13.7932 10.833 13.333C10.8328 12.8729 10.4601 12.5 10 12.5ZM9.16699 5.83301V11.667H10.833V5.83301H9.16699Z", fill: "#D71717" }));
const SvgErrorBox = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 30", width: 50, height: 30, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 0.5H25H34L42.5 10L27 21.5L8.5 10L16.5 0.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("ellipse", { cx: 24.9998, cy: 25.6668, rx: 24.3748, ry: 4.33329, fill: "#FAD2D2" }), /* @__PURE__ */ React.createElement("path", { d: "M34.1133 0.5L42.3896 10.5205L25.9902 21.7334L8.24805 10.5059L16.5527 0.5H34.1133Z", stroke: "#D71717" }), /* @__PURE__ */ React.createElement("mask", { id: "sz-icon-error-box-mask", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10C42.4687 10.0001 43.3643 10.8955 43.3643 12V25.333C43.3643 26.4375 42.4687 27.3329 41.3643 27.333H9.30273C8.19817 27.333 7.30273 26.4376 7.30273 25.333V12C7.30273 10.8954 8.19816 10 9.30273 10H17.3193L18.2402 13.2168C18.4858 14.0749 19.2705 14.6669 20.1631 14.667H30.0615C31.0042 14.6669 31.8187 14.0077 32.0166 13.0859L32.6797 10H41.3643Z" })), /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10C42.4687 10.0001 43.3643 10.8955 43.3643 12V25.333C43.3643 26.4375 42.4687 27.3329 41.3643 27.333H9.30273C8.19817 27.333 7.30273 26.4376 7.30273 25.333V12C7.30273 10.8954 8.19816 10 9.30273 10H17.3193L18.2402 13.2168C18.4858 14.0749 19.2705 14.6669 20.1631 14.667H30.0615C31.0042 14.6669 31.8187 14.0077 32.0166 13.0859L32.6797 10H41.3643Z", fill: "#FAD2D2" }), /* @__PURE__ */ React.createElement("path", { d: "M41.3643 10L41.3644 9H41.3643V10ZM41.3643 27.333V28.333H41.3644L41.3643 27.333ZM9.30273 27.333L9.30273 28.333H9.30273V27.333ZM17.3193 10L18.2807 9.72478L18.0732 9H17.3193V10ZM18.2402 13.2168L19.2016 12.9416L19.2016 12.9416L18.2402 13.2168ZM20.1631 14.667L20.163 15.667H20.1631V14.667ZM30.0615 14.667V15.667H30.0616L30.0615 14.667ZM32.0166 13.0859L31.0389 12.8759L31.0389 12.8761L32.0166 13.0859ZM32.6797 10V9H31.8717L31.702 9.78992L32.6797 10ZM41.3643 10L41.3641 11C41.9165 11.0001 42.3643 11.4479 42.3643 12H43.3643H44.3643C44.3643 10.3431 43.0209 9.00018 41.3644 9L41.3643 10ZM43.3643 12H42.3643V25.333H43.3643H44.3643V12H43.3643ZM43.3643 25.333H42.3643C42.3643 25.8851 41.9165 26.3329 41.3641 26.333L41.3643 27.333L41.3644 28.333C43.0209 28.3328 44.3643 26.9899 44.3643 25.333H43.3643ZM41.3643 27.333V26.333H9.30273V27.333V28.333H41.3643V27.333ZM9.30273 27.333L9.30274 26.333C8.75045 26.333 8.30273 25.8853 8.30273 25.333H7.30273H6.30273C6.30273 26.9899 7.64588 28.333 9.30273 28.333L9.30273 27.333ZM7.30273 25.333H8.30273V12H7.30273H6.30273V25.333H7.30273ZM7.30273 12H8.30273C8.30273 11.4477 8.75045 11 9.30273 11V10V9C7.64588 9 6.30273 10.3431 6.30273 12H7.30273ZM9.30273 10V11H17.3193V10V9H9.30273V10ZM17.3193 10L16.358 10.2752L17.2789 13.492L18.2402 13.2168L19.2016 12.9416L18.2807 9.72478L17.3193 10ZM18.2402 13.2168L17.2788 13.492C17.6472 14.7789 18.8239 15.6669 20.163 15.667L20.1631 14.667L20.1632 13.667C19.7172 13.6669 19.3245 13.3709 19.2016 12.9416L18.2402 13.2168ZM20.1631 14.667V15.667H30.0615V14.667V13.667H20.1631V14.667ZM30.0615 14.667L30.0616 15.667C31.4764 15.6668 32.6977 14.6777 32.9943 13.2958L32.0166 13.0859L31.0389 12.8761C30.9398 13.3376 30.5321 13.6669 30.0614 13.667L30.0615 14.667ZM32.0166 13.0859L32.9943 13.296L33.6574 10.2101L32.6797 10L31.702 9.78992L31.0389 12.8759L32.0166 13.0859ZM32.6797 10V11H41.3643V10V9H32.6797V10Z", fill: "#D71717", mask: "url(#sz-icon-error-box-mask)" }));
const SvgErrorOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.33337 9.99992H8.66671V11.3333H7.33337V9.99992ZM7.33337 4.66659H8.66671V8.66659H7.33337V4.66659ZM7.99337 1.33325C4.31337 1.33325 1.33337 4.31992 1.33337 7.99992C1.33337 11.6799 4.31337 14.6666 7.99337 14.6666C11.68 14.6666 14.6667 11.6799 14.6667 7.99992C14.6667 4.31992 11.68 1.33325 7.99337 1.33325ZM8.00004 13.3333C5.05337 13.3333 2.66671 10.9466 2.66671 7.99992C2.66671 5.05325 5.05337 2.66659 8.00004 2.66659C10.9467 2.66659 13.3334 5.05325 13.3334 7.99992C13.3334 10.9466 10.9467 13.3333 8.00004 13.3333Z", fill: "currentColor" }));
const SvgExit = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2402_1513)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip1_2402_1513)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.3334 4.66667L10.3934 5.60667L12.1134 7.33333H5.33337V8.66667H12.1134L10.3934 10.3867L11.3334 11.3333L14.6667 8L11.3334 4.66667ZM2.66671 3.33333H8.00004V2H2.66671C1.93337 2 1.33337 2.6 1.33337 3.33333V12.6667C1.33337 13.4 1.93337 14 2.66671 14H8.00004V12.6667H2.66671V3.33333Z", fill: "#00204D" }))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2402_1513" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip1_2402_1513" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgExtension = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(2 2.5)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.5 2C8.78 2 9 2.22 9 2.5V4.5H15V10.5H17C17.28 10.5 17.5 10.72 17.5 11C17.5 11.28 17.28 11.5 17 11.5H15V17.5H12.88C12.2 15.75 10.49 14.5 8.5 14.5C6.51 14.5 4.8 15.75 4.12 17.5H2V15.38C3.75 14.7 5 12.99 5 11C5 9.01 3.76 7.3 2.01 6.62L2 4.5H8V2.5C8 2.22 8.22 2 8.5 2ZM8.5 0C7.12 0 6 1.12 6 2.5H2C0.9 2.5 0.00999999 3.4 0.00999999 4.5V8.3H0.3C1.79 8.3 3 9.51 3 11C3 12.49 1.79 13.7 0.3 13.7H0V17.5C0 18.6 0.9 19.5 2 19.5H5.8V19.2C5.8 17.71 7.01 16.5 8.5 16.5C9.99 16.5 11.2 17.71 11.2 19.2V19.5H15C16.1 19.5 17 18.6 17 17.5V13.5C18.38 13.5 19.5 12.38 19.5 11C19.5 9.62 18.38 8.5 17 8.5V4.5C17 3.4 16.1 2.5 15 2.5H11C11 1.12 9.88 0 8.5 0Z", fill: "#0974C1" })));
const SvgExternalLink = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5166_1970)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5166_1970" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgEye = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2525_1950)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00008 4.33333C10.5267 4.33333 12.7801 5.75333 13.8801 8C12.7801 10.2467 10.5334 11.6667 8.00008 11.6667C5.46675 11.6667 3.22008 10.2467 2.12008 8C3.22008 5.75333 5.47341 4.33333 8.00008 4.33333ZM8.00008 3C4.66675 3 1.82008 5.07333 0.666748 8C1.82008 10.9267 4.66675 13 8.00008 13C11.3334 13 14.1801 10.9267 15.3334 8C14.1801 5.07333 11.3334 3 8.00008 3ZM8.00008 6.33333C8.92008 6.33333 9.66675 7.08 9.66675 8C9.66675 8.92 8.92008 9.66667 8.00008 9.66667C7.08008 9.66667 6.33341 8.92 6.33341 8C6.33341 7.08 7.08008 6.33333 8.00008 6.33333ZM8.00008 5C6.34675 5 5.00008 6.34667 5.00008 8C5.00008 9.65333 6.34675 11 8.00008 11C9.65341 11 11.0001 9.65333 11.0001 8C11.0001 6.34667 9.65341 5 8.00008 5Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2525_1950" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgEyeFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4778_9477)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.99999 3C4.66666 3 1.81999 5.07333 0.666656 8C1.81999 10.9267 4.66666 13 7.99999 13C11.3333 13 14.18 10.9267 15.3333 8C14.18 5.07333 11.3333 3 7.99999 3ZM7.99999 11.3333C6.15999 11.3333 4.66666 9.84 4.66666 8C4.66666 6.16 6.15999 4.66667 7.99999 4.66667C9.83999 4.66667 11.3333 6.16 11.3333 8C11.3333 9.84 9.83999 11.3333 7.99999 11.3333ZM7.99999 6C6.89332 6 5.99999 6.89333 5.99999 8C5.99999 9.10667 6.89332 10 7.99999 10C9.10666 10 9.99999 9.10667 9.99999 8C9.99999 6.89333 9.10666 6 7.99999 6Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4778_9477" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgFace = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_183_5071)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.25 13C10.25 13.69 9.69 14.25 9 14.25C8.31 14.25 7.75 13.69 7.75 13C7.75 12.31 8.31 11.75 9 11.75C9.69 11.75 10.25 12.31 10.25 13ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM10.66 4.12C12.06 6.44 14.6 8 17.5 8C17.96 8 18.41 7.95 18.84 7.88C17.44 5.56 14.9 4 12 4C11.54 4 11.09 4.05 10.66 4.12ZM4.42 9.47C6.13 8.5 7.45 6.92 8.08 5.03C6.37 6 5.05 7.58 4.42 9.47ZM20 12C20 11.22 19.88 10.47 19.67 9.76C18.97 9.91 18.25 10 17.5 10C14.37 10 11.58 8.56 9.74 6.31C8.69 8.87 6.6 10.88 4 11.86C4.01 11.9 4 11.95 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_183_5071" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgFactCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15892_9722)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.333 2H2.66634C1.93301 2 1.33301 2.6 1.33301 3.33333V12.6667C1.33301 13.4 1.93301 14 2.66634 14H13.333C14.0663 14 14.6663 13.4 14.6663 12.6667V3.33333C14.6663 2.6 14.0663 2 13.333 2ZM6.66634 11.3333H3.33301V10H6.66634V11.3333ZM6.66634 8.66667H3.33301V7.33333H6.66634V8.66667ZM6.66634 6H3.33301V4.66667H6.66634V6ZM9.87967 10L7.99967 8.10667L8.93967 7.16667L9.87967 8.11333L11.993 6L12.9397 6.94667L9.87967 10Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15892_9722" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgFileDownload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.6673 6H10.0007V2H6.00065V6H3.33398L8.00065 10.6667L12.6673 6ZM3.33398 12V13.3333H12.6673V12H3.33398Z", fill: "white" }));
const SvgFileUpload = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" }));
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5063_36667)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.33333 5.33335C10.0697 5.33335 10.6667 4.7364 10.6667 4.00002C10.6667 3.26364 10.0697 2.66669 9.33333 2.66669C8.59695 2.66669 8 3.26364 8 4.00002C8 4.7364 8.59695 5.33335 9.33333 5.33335Z", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2.66699 4H8.00033", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.667 4H13.3337", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.33333 9.33335C6.06971 9.33335 6.66667 8.7364 6.66667 8.00002C6.66667 7.26364 6.06971 6.66669 5.33333 6.66669C4.59695 6.66669 4 7.26364 4 8.00002C4 8.7364 4.59695 9.33335 5.33333 9.33335Z", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2.66699 8H4.00033", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.66699 8H13.3337", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.3333 13.3334C12.0697 13.3334 12.6667 12.7364 12.6667 12C12.6667 11.2636 12.0697 10.6667 11.3333 10.6667C10.597 10.6667 10 11.2636 10 12C10 12.7364 10.597 13.3334 11.3333 13.3334Z", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2.66699 12H10.0003", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.667 12H13.3337", stroke: "#006AFF", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5063_36667" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgFilterAlt = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.9744 1.33333H8.64107L5.30107 5.53333L1.9744 1.33333ZM0.141069 1.07333C1.48774 2.8 3.9744 6 3.9744 6V10C3.9744 10.3667 4.2744 10.6667 4.64107 10.6667H5.9744C6.34107 10.6667 6.64107 10.3667 6.64107 10V6C6.64107 6 9.12107 2.8 10.4677 1.07333C10.8077 0.633333 10.4944 0 9.94107 0H0.667736C0.114403 0 -0.198931 0.633333 0.141069 1.07333Z", fill: "#006AFF" }));
const SvgFingerprint = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11_638)" }, /* @__PURE__ */ React.createElement("path", { d: "M17.8102 4.47C17.7302 4.47 17.6502 4.45 17.5802 4.41C15.6602 3.42 14.0002 3 12.0102 3C10.0302 3 8.15023 3.47 6.44023 4.41C6.20023 4.54 5.90023 4.45 5.76023 4.21C5.63023 3.97 5.72023 3.66 5.96023 3.53C7.82023 2.52 9.86023 2 12.0102 2C14.1402 2 16.0002 2.47 18.0402 3.52C18.2902 3.65 18.3802 3.95 18.2502 4.19C18.1602 4.37 17.9902 4.47 17.8102 4.47ZM3.50023 9.72C3.40023 9.72 3.30023 9.69 3.21023 9.63C2.98023 9.47 2.93023 9.16 3.09023 8.93C4.08023 7.53 5.34023 6.43 6.84023 5.66C9.98023 4.04 14.0002 4.03 17.1502 5.65C18.6502 6.42 19.9102 7.51 20.9002 8.9C21.0602 9.12 21.0102 9.44 20.7802 9.6C20.5502 9.76 20.2402 9.71 20.0802 9.48C19.1802 8.22 18.0402 7.23 16.6902 6.54C13.8202 5.07 10.1502 5.07 7.29023 6.55C5.93023 7.25 4.79023 8.25 3.89023 9.51C3.81023 9.65 3.66023 9.72 3.50023 9.72ZM9.75023 21.79C9.62023 21.79 9.49023 21.74 9.40023 21.64C8.53023 20.77 8.06023 20.21 7.39023 19C6.70023 17.77 6.34023 16.27 6.34023 14.66C6.34023 11.69 8.88023 9.27 12.0002 9.27C15.1202 9.27 17.6602 11.69 17.6602 14.66C17.6602 14.94 17.4402 15.16 17.1602 15.16C16.8802 15.16 16.6602 14.94 16.6602 14.66C16.6602 12.24 14.5702 10.27 12.0002 10.27C9.43023 10.27 7.34023 12.24 7.34023 14.66C7.34023 16.1 7.66023 17.43 8.27023 18.51C8.91023 19.66 9.35023 20.15 10.1202 20.93C10.3102 21.13 10.3102 21.44 10.1202 21.64C10.0102 21.74 9.88023 21.79 9.75023 21.79ZM16.9202 19.94C15.7302 19.94 14.6802 19.64 13.8202 19.05C12.3302 18.04 11.4402 16.4 11.4402 14.66C11.4402 14.38 11.6602 14.16 11.9402 14.16C12.2202 14.16 12.4402 14.38 12.4402 14.66C12.4402 16.07 13.1602 17.4 14.3802 18.22C15.0902 18.7 15.9202 18.93 16.9202 18.93C17.1602 18.93 17.5602 18.9 17.9602 18.83C18.2302 18.78 18.4902 18.96 18.5402 19.24C18.5902 19.51 18.4102 19.77 18.1302 19.82C17.5602 19.93 17.0602 19.94 16.9202 19.94ZM14.9102 22C14.8702 22 14.8202 21.99 14.7802 21.98C13.1902 21.54 12.1502 20.95 11.0602 19.88C9.66023 18.49 8.89023 16.64 8.89023 14.66C8.89023 13.04 10.2702 11.72 11.9702 11.72C13.6702 11.72 15.0502 13.04 15.0502 14.66C15.0502 15.73 15.9802 16.6 17.1302 16.6C18.2802 16.6 19.2102 15.73 19.2102 14.66C19.2102 10.89 15.9602 7.83 11.9602 7.83C9.12023 7.83 6.52023 9.41 5.35023 11.86C4.96023 12.67 4.76023 13.62 4.76023 14.66C4.76023 15.44 4.83023 16.67 5.43023 18.27C5.53023 18.53 5.40023 18.82 5.14023 18.91C4.88023 19.01 4.59023 18.87 4.50023 18.62C4.01023 17.31 3.77023 16.01 3.77023 14.66C3.77023 13.46 4.00023 12.37 4.45023 11.42C5.78023 8.63 8.73023 6.82 11.9602 6.82C16.5102 6.82 20.2102 10.33 20.2102 14.65C20.2102 16.27 18.8302 17.59 17.1302 17.59C15.4302 17.59 14.0502 16.27 14.0502 14.65C14.0502 13.58 13.1202 12.71 11.9702 12.71C10.8202 12.71 9.89023 13.58 9.89023 14.65C9.89023 16.36 10.5502 17.96 11.7602 19.16C12.7102 20.1 13.6202 20.62 15.0302 21.01C15.3002 21.08 15.4502 21.36 15.3802 21.62C15.3302 21.85 15.1202 22 14.9102 22Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11_638" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgFlagFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.333 14V2h9.334l-1.334 3.333 1.334 3.334H4.667V14H3.333Z", fill: "#00204D" }));
const SvgFlagOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.333 14V2h9.334l-1.334 3.333 1.334 3.334H4.667V14H3.333Zm1.334-6.667h6l-.8-2 .8-2h-6v4Z", fill: "#00204D" }));
const SvgForum = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5321_4637)" }, /* @__PURE__ */ React.createElement("path", { d: "M21 6.5C21.2739 6.5 21.5 6.72614 21.5 7V20.793L18.207 17.5H7C6.72614 17.5 6.5 17.2739 6.5 17V15.5H19.5V6.5H21ZM3 2.5H16C16.2739 2.5 16.5 2.72614 16.5 3V12C16.5 12.2739 16.2739 12.5 16 12.5H5.79297L2.5 15.793V3C2.5 2.72614 2.72614 2.5 3 2.5ZM3.5 13.377L5.37695 11.5H15.5V3.5H3.5V13.377Z", fill: "#0974C1", stroke: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5321_4637" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgFrameInspect = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.56667 8.56667C8.85556 8.27778 9 7.92222 9 7.5C9 7.07778 8.85556 6.72222 8.56667 6.43333C8.27778 6.14444 7.92222 6 7.5 6C7.07778 6 6.72222 6.14444 6.43333 6.43333C6.14444 6.72222 6 7.07778 6 7.5C6 7.92222 6.14444 8.27778 6.43333 8.56667C6.72222 8.85556 7.07778 9 7.5 9C7.92222 9 8.27778 8.85556 8.56667 8.56667ZM10.7167 11.6667L8.96667 9.91667C8.74444 10.0611 8.50833 10.1667 8.25833 10.2333C8.00833 10.3 7.75556 10.3333 7.5 10.3333C6.71111 10.3333 6.04167 10.0583 5.49167 9.50833C4.94167 8.95833 4.66667 8.28889 4.66667 7.5C4.66667 6.71111 4.94167 6.04167 5.49167 5.49167C6.04167 4.94167 6.71111 4.66667 7.5 4.66667C8.28889 4.66667 8.95833 4.94167 9.50833 5.49167C10.0583 6.04167 10.3333 6.71111 10.3333 7.5C10.3333 7.75556 10.2972 8.00833 10.225 8.25833C10.1528 8.50833 10.0444 8.74444 9.9 8.96667L11.6667 10.7333L10.7167 11.6667ZM3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V10H3.33333V12.6667H6V14H3.33333ZM10 14V12.6667H12.6667V10H14V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H10ZM2 6V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H6V3.33333H3.33333V6H2ZM12.6667 6V3.33333H10V2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V6H12.6667Z", fill: "#0070BF" }));
const SvgGear = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3461_5315)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.9532 8.65325C12.9799 8.43992 12.9999 8.22659 12.9999 7.99992C12.9999 7.77325 12.9799 7.55992 12.9532 7.34659L14.3599 6.24659C14.4866 6.14659 14.5199 5.96659 14.4399 5.81992L13.1066 3.51325C13.0466 3.40659 12.9332 3.34659 12.8132 3.34659C12.7732 3.34659 12.7332 3.35325 12.6999 3.36659L11.0399 4.03325C10.6932 3.76659 10.3199 3.54659 9.91323 3.37992L9.65989 1.61325C9.63989 1.45325 9.49989 1.33325 9.33323 1.33325H6.66656C6.49989 1.33325 6.35989 1.45325 6.33989 1.61325L6.08656 3.37992C5.67989 3.54659 5.30656 3.77325 4.95989 4.03325L3.29989 3.36659C3.25989 3.35325 3.21989 3.34659 3.17989 3.34659C3.06656 3.34659 2.95323 3.40659 2.89323 3.51325L1.55989 5.81992C1.47323 5.96659 1.51323 6.14659 1.63989 6.24659L3.04656 7.34659C3.01989 7.55992 2.99989 7.77992 2.99989 7.99992C2.99989 8.21992 3.01989 8.43992 3.04656 8.65325L1.63989 9.75325C1.51323 9.85325 1.47989 10.0333 1.55989 10.1799L2.89323 12.4866C2.95323 12.5933 3.06656 12.6533 3.18656 12.6533C3.22656 12.6533 3.26656 12.6466 3.29989 12.6333L4.95989 11.9666C5.30656 12.2333 5.67989 12.4533 6.08656 12.6199L6.33989 14.3866C6.35989 14.5466 6.49989 14.6666 6.66656 14.6666H9.33323C9.49989 14.6666 9.63989 14.5466 9.65989 14.3866L9.91323 12.6199C10.3199 12.4533 10.6932 12.2266 11.0399 11.9666L12.6999 12.6333C12.7399 12.6466 12.7799 12.6533 12.8199 12.6533C12.9332 12.6533 13.0466 12.5933 13.1066 12.4866L14.4399 10.1799C14.5199 10.0333 14.4866 9.85325 14.3599 9.75325L12.9532 8.65325ZM11.6332 7.51325C11.6599 7.71992 11.6666 7.85992 11.6666 7.99992C11.6666 8.13992 11.6532 8.28659 11.6332 8.48659L11.5399 9.23992L12.1332 9.70659L12.8532 10.2666L12.3866 11.0733L11.5399 10.7333L10.8466 10.4533L10.2466 10.9066C9.95989 11.1199 9.68656 11.2799 9.41323 11.3933L8.70656 11.6799L8.59989 12.4333L8.46656 13.3333H7.53323L7.40656 12.4333L7.29989 11.6799L6.59323 11.3933C6.30656 11.2733 6.03989 11.1199 5.77323 10.9199L5.16656 10.4533L4.45989 10.7399L3.61323 11.0799L3.14656 10.2733L3.86656 9.71325L4.45989 9.24659L4.36656 8.49325C4.34656 8.28659 4.33323 8.13325 4.33323 7.99992C4.33323 7.86659 4.34656 7.71325 4.36656 7.51325L4.45989 6.75992L3.86656 6.29325L3.14656 5.73325L3.61323 4.92659L4.45989 5.26659L5.15323 5.54659L5.75323 5.09325C6.03989 4.87992 6.31323 4.71992 6.58656 4.60659L7.29323 4.31992L7.39989 3.56659L7.53323 2.66659H8.45989L8.58656 3.56659L8.69323 4.31992L9.39989 4.60659C9.68656 4.72659 9.95323 4.87992 10.2199 5.07992L10.8266 5.54659L11.5332 5.25992L12.3799 4.91992L12.8466 5.72659L12.1332 6.29325L11.5399 6.75992L11.6332 7.51325ZM7.99989 5.33325C6.52656 5.33325 5.33323 6.52659 5.33323 7.99992C5.33323 9.47325 6.52656 10.6666 7.99989 10.6666C9.47323 10.6666 10.6666 9.47325 10.6666 7.99992C10.6666 6.52659 9.47323 5.33325 7.99989 5.33325ZM7.99989 9.33325C7.26656 9.33325 6.66656 8.73325 6.66656 7.99992C6.66656 7.26659 7.26656 6.66659 7.99989 6.66659C8.73323 6.66659 9.33323 7.26659 9.33323 7.99992C9.33323 8.73325 8.73323 9.33325 7.99989 9.33325Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3461_5315" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgGearFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.76 8.62676C12.7867 8.42676 12.8 8.2201 12.8 8.0001C12.8 7.78676 12.7867 7.57343 12.7533 7.37343L14.1067 6.3201C14.2267 6.22676 14.26 6.04676 14.1867 5.91343L12.9067 3.7001C12.8267 3.55343 12.66 3.50676 12.5133 3.55343L10.92 4.19343C10.5867 3.9401 10.2333 3.72676 9.84001 3.56676L9.60001 1.87343C9.57334 1.71343 9.44001 1.6001 9.28001 1.6001H6.72001C6.56001 1.6001 6.43334 1.71343 6.40667 1.87343L6.16667 3.56676C5.77334 3.72676 5.41334 3.94676 5.08667 4.19343L3.49334 3.55343C3.34667 3.5001 3.18001 3.55343 3.10001 3.7001L1.82667 5.91343C1.74667 6.05343 1.77334 6.22676 1.90667 6.3201L3.26001 7.37343C3.22667 7.57343 3.20001 7.79343 3.20001 8.0001C3.20001 8.20676 3.21334 8.42676 3.24667 8.62676L1.89334 9.6801C1.77334 9.77343 1.74001 9.95343 1.81334 10.0868L3.09334 12.3001C3.17334 12.4468 3.34001 12.4934 3.48667 12.4468L5.08001 11.8068C5.41334 12.0601 5.76667 12.2734 6.16001 12.4334L6.40001 14.1268C6.43334 14.2868 6.56001 14.4001 6.72001 14.4001H9.28001C9.44001 14.4001 9.57334 14.2868 9.59334 14.1268L9.83334 12.4334C10.2267 12.2734 10.5867 12.0601 10.9133 11.8068L12.5067 12.4468C12.6533 12.5001 12.82 12.4468 12.9 12.3001L14.18 10.0868C14.26 9.9401 14.2267 9.77343 14.1 9.6801L12.76 8.62676ZM8.00001 10.4001C6.68001 10.4001 5.60001 9.3201 5.60001 8.0001C5.60001 6.6801 6.68001 5.6001 8.00001 5.6001C9.32001 5.6001 10.4 6.6801 10.4 8.0001C10.4 9.3201 9.32001 10.4001 8.00001 10.4001Z", fill: "#62748C" }));
const SvgGlobe = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z", fill: "#0974C1" }));
const SvgGoogleCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.4467 0.5H15.213V5.21125H19.9448V1.82845C19.946 1.82845 19.7109 0.628477 18.4467 0.5Z", fill: "#1967D2" }), /* @__PURE__ */ React.createElement("path", { d: "M15.2142 20.4782V20.4897V20.5L19.946 15.7888H19.9036L15.2142 20.4782Z", fill: "#1967D2" }), /* @__PURE__ */ React.createElement("path", { d: "M19.946 15.7888V15.7464L19.9036 15.7888H19.946Z", fill: "#FBBC05" }), /* @__PURE__ */ React.createElement("path", { d: "M19.946 5.21124H15.2142V15.7463H19.946V5.21124Z", fill: "#FBBC05" }), /* @__PURE__ */ React.createElement("path", { d: "M19.9036 15.7888H15.2142V20.4782L19.9036 15.7888Z", fill: "#EA4335" }), /* @__PURE__ */ React.createElement("path", { d: "M15.2142 15.7888H19.9036L19.946 15.7464H15.2142V15.7888Z", fill: "#EA4335" }), /* @__PURE__ */ React.createElement("path", { d: "M15.2027 20.4897H15.2143V20.4781L15.2027 20.4897Z", fill: "#34A853" }), /* @__PURE__ */ React.createElement("path", { d: "M4.67914 15.7464V20.4897H15.2027L15.2142 15.7464H4.67914Z", fill: "#34A853" }), /* @__PURE__ */ React.createElement("path", { d: "M15.2143 15.7888V15.7464L15.2027 20.4897L15.2143 20.4782V15.7888Z", fill: "#34A853" }), /* @__PURE__ */ React.createElement("path", { d: "M0.0539551 15.7464V19.0444C0.0963525 20.1146 1.2475 20.4897 1.2475 20.4897H4.67912V15.7464H0.0539551Z", fill: "#188038" }), /* @__PURE__ */ React.createElement("path", { d: "M4.67912 5.21125H15.2142V0.5H1.38112C1.38112 0.5 0.13875 0.628477 0.0539551 1.95564V15.7464H4.67912V5.21125Z", fill: "#4285F4" }), /* @__PURE__ */ React.createElement("path", { d: "M8.12579 13.6139C7.88477 13.6139 7.65236 13.5823 7.42855 13.5192C7.21048 13.4561 7.00963 13.3614 6.82599 13.2351C6.64236 13.1031 6.47881 12.9396 6.33534 12.7445C6.19761 12.5494 6.09145 12.3227 6.01685 12.0645L7.07562 11.6427C7.15023 11.9296 7.27648 12.1477 7.45437 12.2969C7.63227 12.4403 7.85608 12.5121 8.12579 12.5121C8.24631 12.5121 8.36108 12.4949 8.47011 12.4604C8.57915 12.4203 8.67383 12.3657 8.75417 12.2969C8.83452 12.228 8.89764 12.1477 8.94355 12.0558C8.9952 11.9583 9.02102 11.8493 9.02102 11.7287C9.02102 11.4762 8.92633 11.2783 8.73696 11.1348C8.55332 10.9913 8.29795 10.9196 7.97085 10.9196H7.46298V9.89525H7.92781C8.04258 9.89525 8.15449 9.8809 8.26352 9.85221C8.37256 9.82352 8.46724 9.78048 8.54758 9.72309C8.63366 9.65997 8.69966 9.58249 8.74557 9.49068C8.79721 9.39312 8.82304 9.28122 8.82304 9.15497C8.82304 8.95985 8.75417 8.80204 8.61645 8.68153C8.47872 8.55528 8.29221 8.49215 8.05693 8.49215C7.80443 8.49215 7.60932 8.56102 7.47159 8.69875C7.3396 8.83073 7.24778 8.97994 7.19614 9.14636L6.16318 8.72457C6.21483 8.5811 6.2923 8.43477 6.3956 8.28556C6.49889 8.13062 6.62801 7.99289 6.78295 7.87238C6.94364 7.74613 7.13014 7.64571 7.34247 7.5711C7.5548 7.49076 7.79869 7.45059 8.07415 7.45059C8.35534 7.45059 8.61071 7.49076 8.84025 7.5711C9.07554 7.65144 9.27639 7.76335 9.44281 7.90681C9.60923 8.04454 9.73835 8.21096 9.83017 8.40607C9.92199 8.59545 9.9679 8.80204 9.9679 9.02585C9.9679 9.19801 9.94494 9.35295 9.89903 9.49068C9.85886 9.6284 9.80434 9.75179 9.73548 9.86082C9.66662 9.96985 9.58628 10.0645 9.49446 10.1449C9.40838 10.2195 9.31943 10.2797 9.22761 10.3256V10.3945C9.50307 10.5035 9.72974 10.6786 9.90764 10.9196C10.0913 11.1606 10.1831 11.4648 10.1831 11.832C10.1831 12.0903 10.1343 12.3284 10.0368 12.5465C9.9392 12.7588 9.79861 12.9453 9.61497 13.106C9.43707 13.2667 9.22187 13.3901 8.96937 13.4762C8.71687 13.568 8.43568 13.6139 8.12579 13.6139Z", fill: "#4285F4" }), /* @__PURE__ */ React.createElement("path", { d: "M12.2387 13.4762V8.91394L11.1972 9.35295L10.784 8.39747L12.5142 7.58832H13.3664V13.4762H12.2387Z", fill: "#4285F4" }));
const SvgGppBadShield = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 25.8333L20 22.3333L23.5 25.8333L25.8333 23.5L22.3333 20L25.8333 16.5L23.5 14.1667L20 17.6667L16.5 14.1667L14.1667 16.5L17.6667 20L14.1667 23.5L16.5 25.8333ZM20 36.6667C16.1389 35.6944 12.9514 33.4792 10.4375 30.0208C7.92361 26.5625 6.66667 22.7222 6.66667 18.5V8.33333L20 3.33333L33.3333 8.33333V18.5C33.3333 22.7222 32.0764 26.5625 29.5625 30.0208C27.0486 33.4792 23.8611 35.6944 20 36.6667ZM20 33.1667C22.8889 32.25 25.2778 30.4167 27.1667 27.6667C29.0556 24.9167 30 21.8611 30 18.5V10.625L20 6.875L10 10.625V18.5C10 21.8611 10.9444 24.9167 12.8333 27.6667C14.7222 30.4167 17.1111 32.25 20 33.1667Z", fill: "#D71717" }));
const SvgGroupAvatar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3540_66969)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.667 7.33331C11.7737 7.33331 12.6603 6.43998 12.6603 5.33331C12.6603 4.22665 11.7737 3.33331 10.667 3.33331C9.56032 3.33331 8.66699 4.22665 8.66699 5.33331C8.66699 6.43998 9.56032 7.33331 10.667 7.33331ZM5.33366 7.33331C6.44033 7.33331 7.32699 6.43998 7.32699 5.33331C7.32699 4.22665 6.44033 3.33331 5.33366 3.33331C4.22699 3.33331 3.33366 4.22665 3.33366 5.33331C3.33366 6.43998 4.22699 7.33331 5.33366 7.33331ZM5.33366 8.66665C3.78033 8.66665 0.666992 9.44665 0.666992 11V12.6666H10.0003V11C10.0003 9.44665 6.88699 8.66665 5.33366 8.66665ZM10.667 8.66665C10.4737 8.66665 10.2537 8.67998 10.0203 8.69998C10.7937 9.25998 11.3337 10.0133 11.3337 11V12.6666H15.3337V11C15.3337 9.44665 12.2203 8.66665 10.667 8.66665Z", fill: "#723BCA" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3540_66969" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgGroupIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3540_67837)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.6665 7.33331C11.7732 7.33331 12.6598 6.43998 12.6598 5.33331C12.6598 4.22665 11.7732 3.33331 10.6665 3.33331C9.55984 3.33331 8.6665 4.22665 8.6665 5.33331C8.6665 6.43998 9.55984 7.33331 10.6665 7.33331ZM5.33317 7.33331C6.43984 7.33331 7.3265 6.43998 7.3265 5.33331C7.3265 4.22665 6.43984 3.33331 5.33317 3.33331C4.2265 3.33331 3.33317 4.22665 3.33317 5.33331C3.33317 6.43998 4.2265 7.33331 5.33317 7.33331ZM5.33317 8.66665C3.77984 8.66665 0.666504 9.44665 0.666504 11V12.6666H9.99984V11C9.99984 9.44665 6.8865 8.66665 5.33317 8.66665ZM10.6665 8.66665C10.4732 8.66665 10.2532 8.67998 10.0198 8.69998C10.7932 9.25998 11.3332 10.0133 11.3332 11V12.6666H15.3332V11C15.3332 9.44665 12.2198 8.66665 10.6665 8.66665Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3540_67837" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgGroup = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.0266 7.33333L8.66659 4.97333L9.60659 4.03333L11.0199 5.44666L13.8466 2.62L14.7866 3.56L11.0266 7.33333ZM7.33325 4.66666H1.33325V5.99999H7.33325V4.66666ZM13.9999 8.93999L13.0599 8L11.3333 9.72666L9.60659 8L8.66659 8.93999L10.3933 10.6667L8.66659 12.3933L9.60659 13.3333L11.3333 11.6067L13.0599 13.3333L13.9999 12.3933L12.2733 10.6667L13.9999 8.93999ZM7.33325 10H1.33325V11.3333H7.33325V10Z", fill: "#00204D" }));
const SvgHelpOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3815_4485)" }, /* @__PURE__ */ React.createElement("path", { d: "M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3815_4485" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgHired = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1781_23325)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.99993 10.8001L3.19993 8.00006L2.2666 8.9334L5.99993 12.6667L13.9999 4.66673L13.0666 3.7334L5.99993 10.8001Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1781_23325" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgHiringProcessEmptyState = (props) => /* @__PURE__ */ React.createElement("svg", { width: 300, height: 153, viewBox: "0 0 300 153", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 12.5C0 9.73858 2.23858 7.5 5 7.5H27V36.5H5C2.23858 36.5 0 34.2614 0 31.5V12.5Z", fill: "#E5F0FF" }), /* @__PURE__ */ React.createElement("path", { d: "M14.7715 17.0127V27H13.124V18.9678L10.6836 19.7949V18.4346L14.5732 17.0127H14.7715Z", fill: "#00204D" }), /* @__PURE__ */ React.createElement("path", { d: "M35 0.5H246C250.142 0.5 253.5 3.85786 253.5 8V36C253.5 40.1421 250.142 43.5 246 43.5H35C30.8579 43.5 27.5 40.1421 27.5 36V8C27.5 3.85786 30.8579 0.5 35 0.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M35 0.5H246C250.142 0.5 253.5 3.85786 253.5 8V36C253.5 40.1421 250.142 43.5 246 43.5H35C30.8579 43.5 27.5 40.1421 27.5 36V8C27.5 3.85786 30.8579 0.5 35 0.5Z", stroke: "#ADBFD9" }), /* @__PURE__ */ React.createElement("rect", { x: 35, y: 8, width: 28, height: 28, rx: 14, fill: "#FFF6EA" }), /* @__PURE__ */ React.createElement("mask", { id: "mask0_6970_6962", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 41, y: 14, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { x: 41, y: 14, width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_6970_6962)" }, /* @__PURE__ */ React.createElement("path", { d: "M45.6667 25.3333H47V22H45.6667V25.3333ZM51 25.3333H52.3333V18.6667H51V25.3333ZM48.3333 25.3333H49.6667V23.3333H48.3333V25.3333ZM48.3333 22H49.6667V20.6667H48.3333V22ZM44.3333 28C43.9667 28 43.6528 27.8694 43.3917 27.6083C43.1306 27.3472 43 27.0333 43 26.6667V17.3333C43 16.9667 43.1306 16.6528 43.3917 16.3917C43.6528 16.1306 43.9667 16 44.3333 16H53.6667C54.0333 16 54.3472 16.1306 54.6083 16.3917C54.8694 16.6528 55 16.9667 55 17.3333V26.6667C55 27.0333 54.8694 27.3472 54.6083 27.6083C54.3472 27.8694 54.0333 28 53.6667 28H44.3333ZM44.3333 26.6667H53.6667V17.3333H44.3333V26.6667Z", fill: "#E0982B" })), /* @__PURE__ */ React.createElement("rect", { x: 75, y: 14, width: 116, height: 16, rx: 4, fill: "#E5F0FF" }), /* @__PURE__ */ React.createElement("rect", { x: 27, y: 53, width: 227, height: 44, rx: 8, fill: "#3388FF", fillOpacity: 0.05 }), /* @__PURE__ */ React.createElement("rect", { x: 27.5, y: 53.5, width: 226, height: 43, rx: 7.5, stroke: "#006AFF", strokeOpacity: 0.4, strokeDasharray: "6 6" }), /* @__PURE__ */ React.createElement("g", { opacity: 0.4 }, /* @__PURE__ */ React.createElement("path", { d: "M0 120.5C0 117.739 2.23858 115.5 5 115.5H27V144.5H5C2.23858 144.5 0 142.261 0 139.5V120.5Z", fill: "#E5F0FF" }), /* @__PURE__ */ React.createElement("path", { d: "M16.9453 133.688V135H10.2734V133.872L13.5137 130.338C13.8691 129.937 14.1494 129.59 14.3545 129.299C14.5596 129.007 14.7031 128.745 14.7852 128.513C14.8717 128.276 14.915 128.046 14.915 127.822C14.915 127.508 14.8558 127.232 14.7373 126.995C14.6234 126.754 14.4548 126.564 14.2314 126.428C14.0081 126.286 13.737 126.216 13.418 126.216C13.0488 126.216 12.7389 126.296 12.4883 126.455C12.2376 126.615 12.0485 126.836 11.9209 127.118C11.7933 127.396 11.7295 127.715 11.7295 128.075H10.082C10.082 127.496 10.2142 126.968 10.4785 126.489C10.7428 126.006 11.1257 125.623 11.627 125.341C12.1283 125.054 12.7321 124.91 13.4385 124.91C14.1038 124.91 14.6689 125.022 15.1338 125.245C15.5986 125.468 15.9518 125.785 16.1934 126.195C16.4395 126.605 16.5625 127.091 16.5625 127.651C16.5625 127.961 16.5124 128.269 16.4121 128.574C16.3118 128.88 16.1683 129.185 15.9814 129.49C15.7992 129.791 15.5827 130.094 15.332 130.399C15.0814 130.7 14.8057 131.006 14.5049 131.315L12.3516 133.688H16.9453Z", fill: "#00204D" }), /* @__PURE__ */ React.createElement("path", { d: "M35 108.5H246C250.142 108.5 253.5 111.858 253.5 116V144C253.5 148.142 250.142 151.5 246 151.5H35C30.8579 151.5 27.5 148.142 27.5 144V116C27.5 111.858 30.8579 108.5 35 108.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M35 108.5H246C250.142 108.5 253.5 111.858 253.5 116V144C253.5 148.142 250.142 151.5 246 151.5H35C30.8579 151.5 27.5 148.142 27.5 144V116C27.5 111.858 30.8579 108.5 35 108.5Z", stroke: "#ADBFD9" }), /* @__PURE__ */ React.createElement("g", { opacity: 0.7 }, /* @__PURE__ */ React.createElement("rect", { x: 35, y: 116, width: 28, height: 28, rx: 14, fill: "#E6F1FA" }), /* @__PURE__ */ React.createElement("mask", { id: "mask1_6970_6962", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 41, y: 122, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { x: 41, y: 122, width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask1_6970_6962)" }, /* @__PURE__ */ React.createElement("path", { d: "M46.333 129.333C46.5219 129.333 46.6802 129.269 46.808 129.142C46.9358 129.014 46.9997 128.855 46.9997 128.667C46.9997 128.478 46.9358 128.319 46.808 128.192C46.6802 128.064 46.5219 128 46.333 128C46.1441 128 45.9858 128.064 45.858 128.192C45.7302 128.319 45.6663 128.478 45.6663 128.667C45.6663 128.855 45.7302 129.014 45.858 129.142C45.9858 129.269 46.1441 129.333 46.333 129.333ZM48.9997 129.333C49.1886 129.333 49.3469 129.269 49.4747 129.142C49.6025 129.014 49.6663 128.855 49.6663 128.667C49.6663 128.478 49.6025 128.319 49.4747 128.192C49.3469 128.064 49.1886 128 48.9997 128C48.8108 128 48.6525 128.064 48.5247 128.192C48.3969 128.319 48.333 128.478 48.333 128.667C48.333 128.855 48.3969 129.014 48.5247 129.142C48.6525 129.269 48.8108 129.333 48.9997 129.333ZM51.6663 129.333C51.8552 129.333 52.0136 129.269 52.1413 129.142C52.2691 129.014 52.333 128.855 52.333 128.667C52.333 128.478 52.2691 128.319 52.1413 128.192C52.0136 128.064 51.8552 128 51.6663 128C51.4775 128 51.3191 128.064 51.1913 128.192C51.0636 128.319 50.9997 128.478 50.9997 128.667C50.9997 128.855 51.0636 129.014 51.1913 129.142C51.3191 129.269 51.4775 129.333 51.6663 129.333ZM42.333 136.667V124.667C42.333 124.3 42.4636 123.986 42.7247 123.725C42.9858 123.464 43.2997 123.333 43.6663 123.333H54.333C54.6997 123.333 55.0136 123.464 55.2747 123.725C55.5358 123.986 55.6663 124.3 55.6663 124.667V132.667C55.6663 133.033 55.5358 133.347 55.2747 133.608C55.0136 133.869 54.6997 134 54.333 134H44.9997L42.333 136.667ZM44.433 132.667H54.333V124.667H43.6663V133.417L44.433 132.667Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("rect", { x: 75, y: 122, width: 92, height: 16, rx: 4, fill: "#E5F0FF" }))), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter0_d_6970_6962)" }, /* @__PURE__ */ React.createElement("path", { d: "M38.5 78.5C38.5 75.7386 40.7386 73.5 43.5 73.5H65.5V102.5H43.5C40.7386 102.5 38.5 100.261 38.5 97.5V78.5Z", fill: "#CCE1FF" }), /* @__PURE__ */ React.createElement("mask", { id: "mask2_6970_6962", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 43, y: 79, width: 18, height: 18 }, /* @__PURE__ */ React.createElement("rect", { x: 43.5, y: 79.5, width: 17, height: 17, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask2_6970_6962)" }, /* @__PURE__ */ React.createElement("path", { d: "M49.8747 93.6667C49.4851 93.6667 49.1516 93.528 48.8742 93.2506C48.5967 92.9731 48.458 92.6396 48.458 92.25C48.458 91.8605 48.5967 91.527 48.8742 91.2495C49.1516 90.9721 49.4851 90.8334 49.8747 90.8334C50.2643 90.8334 50.5978 90.9721 50.8752 91.2495C51.1526 91.527 51.2913 91.8605 51.2913 92.25C51.2913 92.6396 51.1526 92.9731 50.8752 93.2506C50.5978 93.528 50.2643 93.6667 49.8747 93.6667ZM54.1247 93.6667C53.7351 93.6667 53.4016 93.528 53.1242 93.2506C52.8467 92.9731 52.708 92.6396 52.708 92.25C52.708 91.8605 52.8467 91.527 53.1242 91.2495C53.4016 90.9721 53.7351 90.8334 54.1247 90.8334C54.5143 90.8334 54.8478 90.9721 55.1252 91.2495C55.4026 91.527 55.5413 91.8605 55.5413 92.25C55.5413 92.6396 55.4026 92.9731 55.1252 93.2506C54.8478 93.528 54.5143 93.6667 54.1247 93.6667ZM49.8747 89.4167C49.4851 89.4167 49.1516 89.278 48.8742 89.0006C48.5967 88.7231 48.458 88.3896 48.458 88C48.458 87.6105 48.5967 87.277 48.8742 86.9995C49.1516 86.7221 49.4851 86.5834 49.8747 86.5834C50.2643 86.5834 50.5978 86.7221 50.8752 86.9995C51.1526 87.277 51.2913 87.6105 51.2913 88C51.2913 88.3896 51.1526 88.7231 50.8752 89.0006C50.5978 89.278 50.2643 89.4167 49.8747 89.4167ZM54.1247 89.4167C53.7351 89.4167 53.4016 89.278 53.1242 89.0006C52.8467 88.7231 52.708 88.3896 52.708 88C52.708 87.6105 52.8467 87.277 53.1242 86.9995C53.4016 86.7221 53.7351 86.5834 54.1247 86.5834C54.5143 86.5834 54.8478 86.7221 55.1252 86.9995C55.4026 87.277 55.5413 87.6105 55.5413 88C55.5413 88.3896 55.4026 88.7231 55.1252 89.0006C54.8478 89.278 54.5143 89.4167 54.1247 89.4167ZM49.8747 85.1667C49.4851 85.1667 49.1516 85.028 48.8742 84.7506C48.5967 84.4731 48.458 84.1396 48.458 83.75C48.458 83.3605 48.5967 83.027 48.8742 82.7495C49.1516 82.4721 49.4851 82.3334 49.8747 82.3334C50.2643 82.3334 50.5978 82.4721 50.8752 82.7495C51.1526 83.027 51.2913 83.3605 51.2913 83.75C51.2913 84.1396 51.1526 84.4731 50.8752 84.7506C50.5978 85.028 50.2643 85.1667 49.8747 85.1667ZM54.1247 85.1667C53.7351 85.1667 53.4016 85.028 53.1242 84.7506C52.8467 84.4731 52.708 84.1396 52.708 83.75C52.708 83.3605 52.8467 83.027 53.1242 82.7495C53.4016 82.4721 53.7351 82.3334 54.1247 82.3334C54.5143 82.3334 54.8478 82.4721 55.1252 82.7495C55.4026 83.027 55.5413 83.3605 55.5413 83.75C55.5413 84.1396 55.4026 84.4731 55.1252 84.7506C54.8478 85.028 54.5143 85.1667 54.1247 85.1667Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("path", { d: "M65.5 74C65.5 69.5817 69.0817 66 73.5 66H284.5C288.918 66 292.5 69.5817 292.5 74V102C292.5 106.418 288.918 110 284.5 110H73.5C69.0817 110 65.5 106.418 65.5 102V74Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M73.5 66.5H284.5C288.642 66.5 292 69.8579 292 74V102C292 106.142 288.642 109.5 284.5 109.5H73.5C69.3579 109.5 66 106.142 66 102V74C66 69.8579 69.3579 66.5 73.5 66.5Z", stroke: "#005FE6", strokeOpacity: 0.4 }), /* @__PURE__ */ React.createElement("g", { opacity: 0.7 }, /* @__PURE__ */ React.createElement("rect", { x: 73.5, y: 74, width: 28, height: 28, rx: 14, fill: "#F1EBFA" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6970_6962)" }, /* @__PURE__ */ React.createElement("path", { d: "M92.1667 86L93 84.1666L94.8333 83.3333L93 82.5L92.1667 80.6666L91.3333 82.5L89.5 83.3333L91.3333 84.1666L92.1667 86Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M92.1667 90L91.3333 91.8333L89.5 92.6667L91.3333 93.5L92.1667 95.3333L93 93.5L94.8333 92.6667L93 91.8333L92.1667 90Z", fill: "#723BCA" }), /* @__PURE__ */ React.createElement("path", { d: "M87.167 86.3333L85.5003 82.6666L83.8337 86.3333L80.167 88L83.8337 89.6666L85.5003 93.3333L87.167 89.6666L90.8337 88L87.167 86.3333ZM86.1603 88.66L85.5003 90.1133L84.8403 88.66L83.387 88L84.8403 87.34L85.5003 85.8866L86.1603 87.34L87.6137 88L86.1603 88.66Z", fill: "#723BCA" }))), /* @__PURE__ */ React.createElement("rect", { x: 113.5, y: 80, width: 120, height: 16, rx: 4, fill: "#E5F0FF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", { id: "filter0_d_6970_6962", x: 33.5, y: 62, width: 266, height: 56, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dx: 1, dy: 2 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 3 }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_6970_6962" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_6970_6962", result: "shape" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6970_6962" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(79.5 80)" }))));
const SvgIcAccessTime = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1841_1365)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.9935 1.33337C4.3135 1.33337 1.3335 4.32004 1.3335 8.00004C1.3335 11.68 4.3135 14.6667 7.9935 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00004C14.6668 4.32004 11.6802 1.33337 7.9935 1.33337ZM8.00016 13.3334C5.0535 13.3334 2.66683 10.9467 2.66683 8.00004C2.66683 5.05337 5.0535 2.66671 8.00016 2.66671C10.9468 2.66671 13.3335 5.05337 13.3335 8.00004C13.3335 10.9467 10.9468 13.3334 8.00016 13.3334Z", fill: "#00204D" }), /* @__PURE__ */ React.createElement("path", { d: "M8.3335 4.66663H7.3335V8.66663L10.8335 10.7666L11.3335 9.94663L8.3335 8.16663V4.66663Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1841_1365" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgIcCheckBig = (props) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 20, viewBox: "0 0 28 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 9.82609L10 17.6522L26 2", stroke: "#1F1F1F", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgIcCheckCircleOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1841_1161)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00016 1.33337C4.32016 1.33337 1.3335 4.32004 1.3335 8.00004C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00004C14.6668 4.32004 11.6802 1.33337 8.00016 1.33337ZM8.00016 13.3334C5.06016 13.3334 2.66683 10.94 2.66683 8.00004C2.66683 5.06004 5.06016 2.66671 8.00016 2.66671C10.9402 2.66671 13.3335 5.06004 13.3335 8.00004C13.3335 10.94 10.9402 13.3334 8.00016 13.3334ZM11.0602 5.05337L6.66683 9.44671L4.94016 7.72671L4.00016 8.66671L6.66683 11.3334L12.0002 6.00004L11.0602 5.05337Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1841_1161" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16 }))));
const SvgIcCloseGray = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z", fill: "#d6d6d6" }));
const SvgIcEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { width: 78, height: 48, viewBox: "0 0 78 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 39, cy: 41.0671, rx: 39, ry: 6.93333, fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M11.748 16.8817L25.344 0.5H53.723L67.2658 16.8963L40.5917 35.1349L11.748 16.8817Z", stroke: "#62748C" }), /* @__PURE__ */ React.createElement("mask", { id: "path-3-inside-1_1826_180563", fill: "white" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6846 16C11.58 16 10.6846 16.8954 10.6846 18V41.7333C10.6846 42.8379 11.58 43.7333 12.6846 43.7333H66.3832C67.4878 43.7333 68.3832 42.8379 68.3832 41.7333V18C68.3832 16.8954 67.4878 16 66.3832 16H51.2873L50.0237 21.8864C49.8259 22.8082 49.0111 23.4667 48.0683 23.4667H30.3568C29.4642 23.4667 28.6796 22.8751 28.434 22.017L26.7119 16H12.6846Z" })), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6846 16C11.58 16 10.6846 16.8954 10.6846 18V41.7333C10.6846 42.8379 11.58 43.7333 12.6846 43.7333H66.3832C67.4878 43.7333 68.3832 42.8379 68.3832 41.7333V18C68.3832 16.8954 67.4878 16 66.3832 16H51.2873L50.0237 21.8864C49.8259 22.8082 49.0111 23.4667 48.0683 23.4667H30.3568C29.4642 23.4667 28.6796 22.8751 28.434 22.017L26.7119 16H12.6846Z", fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M51.2873 16V15H50.4791L50.3095 15.7901L51.2873 16ZM50.0237 21.8864L49.046 21.6765V21.6765L50.0237 21.8864ZM28.434 22.017L27.4726 22.2921L28.434 22.017ZM26.7119 16L27.6733 15.7248L27.4659 15H26.7119V16ZM11.6846 18C11.6846 17.4477 12.1323 17 12.6846 17V15C11.0277 15 9.68457 16.3431 9.68457 18H11.6846ZM11.6846 41.7333V18H9.68457V41.7333H11.6846ZM12.6846 42.7333C12.1323 42.7333 11.6846 42.2856 11.6846 41.7333H9.68457C9.68457 43.3902 11.0277 44.7333 12.6846 44.7333V42.7333ZM66.3832 42.7333H12.6846V44.7333H66.3832V42.7333ZM67.3832 41.7333C67.3832 42.2856 66.9355 42.7333 66.3832 42.7333V44.7333C68.0401 44.7333 69.3832 43.3902 69.3832 41.7333H67.3832ZM67.3832 18V41.7333H69.3832V18H67.3832ZM66.3832 17C66.9355 17 67.3832 17.4477 67.3832 18H69.3832C69.3832 16.3431 68.0401 15 66.3832 15V17ZM51.2873 17H66.3832V15H51.2873V17ZM50.3095 15.7901L49.046 21.6765L51.0015 22.0963L52.265 16.2099L50.3095 15.7901ZM49.046 21.6765C48.9471 22.1374 48.5397 22.4667 48.0683 22.4667V24.4667C49.4825 24.4667 50.7047 23.479 51.0015 22.0963L49.046 21.6765ZM48.0683 22.4667H30.3568V24.4667H48.0683V22.4667ZM30.3568 22.4667C29.9105 22.4667 29.5182 22.1709 29.3954 21.7418L27.4726 22.2921C27.841 23.5794 29.0179 24.4667 30.3568 24.4667V22.4667ZM29.3954 21.7418L27.6733 15.7248L25.7505 16.2752L27.4726 22.2921L29.3954 21.7418ZM12.6846 17H26.7119V15H12.6846V17Z", fill: "#62748C", mask: "url(#path-3-inside-1_1826_180563)" }));
const SvgIcFileUpload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.9997 12.5V15H4.99967V12.5H3.33301V15C3.33301 15.9166 4.08301 16.6666 4.99967 16.6666H14.9997C15.9163 16.6666 16.6663 15.9166 16.6663 15V12.5H14.9997ZM5.83301 7.49998L7.00801 8.67498L9.16634 6.52498V13.3333H10.833V6.52498L12.9913 8.67498L14.1663 7.49998L9.99967 3.33331L5.83301 7.49998Z", fill: "#656565" }));
const SvgIcTick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 8.085 2.415 6l-.71.705L4.5 9.5l6-6-.705-.705L4.5 8.085z", fill: "#656565" }));
const SvgImage = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 16, viewBox: "0 -960 960 960", width: 16, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#00204D", d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Z" }));
const SvgInfo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_984_5406)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.33325 4.66668H8.66659V6.00001H7.33325V4.66668ZM7.33325 7.33334H8.66659V11.3333H7.33325V7.33334ZM7.99992 1.33334C4.31992 1.33334 1.33325 4.32001 1.33325 8.00001C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00001C14.6666 4.32001 11.6799 1.33334 7.99992 1.33334ZM7.99992 13.3333C5.05992 13.3333 2.66659 10.94 2.66659 8.00001C2.66659 5.06001 5.05992 2.66668 7.99992 2.66668C10.9399 2.66668 13.3333 5.06001 13.3333 8.00001C13.3333 10.94 10.9399 13.3333 7.99992 13.3333Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_984_5406" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgInfoV2 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.00004 1.33337C4.32004 1.33337 1.33337 4.32004 1.33337 8.00004C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8.00004 1.33337ZM9.33337 11.3334H6.66671V10H7.33337V8.66671H6.66671V7.33337H7.33337H8.66671V10H9.33337V11.3334ZM8.66671 6.00004H7.33337V4.66671H8.66671V6.00004Z", fill: "#006AFF" }));
const SvgIntegrityFlag = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "flag", d: "M9.6 4L9.33333 2.66667H3.33333V14H4.66667V9.33333H8.4L8.66667 10.6667H13.3333V4H9.6Z", fill: "#00204D" }));
const SvgInterview = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_7225_1488", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_7225_1488)" }), /* @__PURE__ */ React.createElement("path", { d: "M5.33319 7.33301C5.52208 7.33301 5.68041 7.26912 5.80819 7.14134C5.93597 7.01356 5.99986 6.85523 5.99986 6.66634C5.99986 6.47745 5.93597 6.31912 5.80819 6.19134C5.68041 6.06356 5.52208 5.99967 5.33319 5.99967C5.1443 5.99967 4.98597 6.06356 4.85819 6.19134C4.73041 6.31912 4.66652 6.47745 4.66652 6.66634C4.66652 6.85523 4.73041 7.01356 4.85819 7.14134C4.98597 7.26912 5.1443 7.33301 5.33319 7.33301ZM7.99986 7.33301C8.18875 7.33301 8.34708 7.26912 8.47486 7.14134C8.60264 7.01356 8.66652 6.85523 8.66652 6.66634C8.66652 6.47745 8.60264 6.31912 8.47486 6.19134C8.34708 6.06356 8.18875 5.99967 7.99986 5.99967C7.81097 5.99967 7.65264 6.06356 7.52486 6.19134C7.39708 6.31912 7.33319 6.47745 7.33319 6.66634C7.33319 6.85523 7.39708 7.01356 7.52486 7.14134C7.65264 7.26912 7.81097 7.33301 7.99986 7.33301ZM10.6665 7.33301C10.8554 7.33301 11.0137 7.26912 11.1415 7.14134C11.2693 7.01356 11.3332 6.85523 11.3332 6.66634C11.3332 6.47745 11.2693 6.31912 11.1415 6.19134C11.0137 6.06356 10.8554 5.99967 10.6665 5.99967C10.4776 5.99967 10.3193 6.06356 10.1915 6.19134C10.0637 6.31912 9.99986 6.47745 9.99986 6.66634C9.99986 6.85523 10.0637 7.01356 10.1915 7.14134C10.3193 7.26912 10.4776 7.33301 10.6665 7.33301ZM1.33319 14.6663V2.66634C1.33319 2.29967 1.46375 1.98579 1.72486 1.72467C1.98597 1.46356 2.29986 1.33301 2.66652 1.33301H13.3332C13.6999 1.33301 14.0137 1.46356 14.2749 1.72467C14.536 1.98579 14.6665 2.29967 14.6665 2.66634V10.6663C14.6665 11.033 14.536 11.3469 14.2749 11.608C14.0137 11.8691 13.6999 11.9997 13.3332 11.9997H3.99986L1.33319 14.6663ZM3.43319 10.6663H13.3332V2.66634H2.66652V11.4163L3.43319 10.6663Z", fill: "#62748C" }));
const SvgJob = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6283_26825)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.3333 4.00004H10.6666V2.66671C10.6666 1.92671 10.0733 1.33337 9.33331 1.33337H6.66665C5.92665 1.33337 5.33331 1.92671 5.33331 2.66671V4.00004H2.66665C1.92665 4.00004 1.33998 4.59337 1.33998 5.33337L1.33331 12.6667C1.33331 13.4067 1.92665 14 2.66665 14H13.3333C14.0733 14 14.6666 13.4067 14.6666 12.6667V5.33337C14.6666 4.59337 14.0733 4.00004 13.3333 4.00004ZM9.33331 4.00004H6.66665V2.66671H9.33331V4.00004Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6283_26825" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgLanguage = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 20.0001C8.63333 20.0001 7.34167 19.7376 6.125 19.2126C4.90833 18.6876 3.84583 17.9709 2.9375 17.0626C2.02917 16.1543 1.3125 15.0918 0.7875 13.8751C0.2625 12.6584 0 11.3668 0 10.0001C0 8.61676 0.2625 7.32093 0.7875 6.1126C1.3125 4.90426 2.02917 3.84593 2.9375 2.9376C3.84583 2.02926 4.90833 1.3126 6.125 0.787597C7.34167 0.262597 8.63333 9.72748e-05 10 9.72748e-05C11.3833 9.72748e-05 12.6792 0.262597 13.8875 0.787597C15.0958 1.3126 16.1542 2.02926 17.0625 2.9376C17.9708 3.84593 18.6875 4.90426 19.2125 6.1126C19.7375 7.32093 20 8.61676 20 10.0001C20 11.3668 19.7375 12.6584 19.2125 13.8751C18.6875 15.0918 17.9708 16.1543 17.0625 17.0626C16.1542 17.9709 15.0958 18.6876 13.8875 19.2126C12.6792 19.7376 11.3833 20.0001 10 20.0001ZM10 17.9501C10.4333 17.3501 10.8083 16.7251 11.125 16.0751C11.4417 15.4251 11.7 14.7334 11.9 14.0001H8.1C8.3 14.7334 8.55833 15.4251 8.875 16.0751C9.19167 16.7251 9.56667 17.3501 10 17.9501ZM7.4 17.5501C7.1 17.0001 6.8375 16.4293 6.6125 15.8376C6.3875 15.2459 6.2 14.6334 6.05 14.0001H3.1C3.58333 14.8334 4.1875 15.5584 4.9125 16.1751C5.6375 16.7918 6.46667 17.2501 7.4 17.5501ZM12.6 17.5501C13.5333 17.2501 14.3625 16.7918 15.0875 16.1751C15.8125 15.5584 16.4167 14.8334 16.9 14.0001H13.95C13.8 14.6334 13.6125 15.2459 13.3875 15.8376C13.1625 16.4293 12.9 17.0001 12.6 17.5501ZM2.25 12.0001H5.65C5.6 11.6668 5.5625 11.3376 5.5375 11.0126C5.5125 10.6876 5.5 10.3501 5.5 10.0001C5.5 9.6501 5.5125 9.3126 5.5375 8.9876C5.5625 8.6626 5.6 8.33343 5.65 8.0001H2.25C2.16667 8.33343 2.10417 8.6626 2.0625 8.9876C2.02083 9.3126 2 9.6501 2 10.0001C2 10.3501 2.02083 10.6876 2.0625 11.0126C2.10417 11.3376 2.16667 11.6668 2.25 12.0001ZM7.65 12.0001H12.35C12.4 11.6668 12.4375 11.3376 12.4625 11.0126C12.4875 10.6876 12.5 10.3501 12.5 10.0001C12.5 9.6501 12.4875 9.3126 12.4625 8.9876C12.4375 8.6626 12.4 8.33343 12.35 8.0001H7.65C7.6 8.33343 7.5625 8.6626 7.5375 8.9876C7.5125 9.3126 7.5 9.6501 7.5 10.0001C7.5 10.3501 7.5125 10.6876 7.5375 11.0126C7.5625 11.3376 7.6 11.6668 7.65 12.0001ZM14.35 12.0001H17.75C17.8333 11.6668 17.8958 11.3376 17.9375 11.0126C17.9792 10.6876 18 10.3501 18 10.0001C18 9.6501 17.9792 9.3126 17.9375 8.9876C17.8958 8.6626 17.8333 8.33343 17.75 8.0001H14.35C14.4 8.33343 14.4375 8.6626 14.4625 8.9876C14.4875 9.3126 14.5 9.6501 14.5 10.0001C14.5 10.3501 14.4875 10.6876 14.4625 11.0126C14.4375 11.3376 14.4 11.6668 14.35 12.0001ZM13.95 6.0001H16.9C16.4167 5.16676 15.8125 4.44176 15.0875 3.8251C14.3625 3.20843 13.5333 2.7501 12.6 2.4501C12.9 3.0001 13.1625 3.57093 13.3875 4.1626C13.6125 4.75426 13.8 5.36676 13.95 6.0001ZM8.1 6.0001H11.9C11.7 5.26676 11.4417 4.5751 11.125 3.9251C10.8083 3.2751 10.4333 2.6501 10 2.0501C9.56667 2.6501 9.19167 3.2751 8.875 3.9251C8.55833 4.5751 8.3 5.26676 8.1 6.0001ZM3.1 6.0001H6.05C6.2 5.36676 6.3875 4.75426 6.6125 4.1626C6.8375 3.57093 7.1 3.0001 7.4 2.4501C6.46667 2.7501 5.6375 3.20843 4.9125 3.8251C4.1875 4.44176 3.58333 5.16676 3.1 6.0001Z", fill: "#0974C1" }));
const SvgLightbulb = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_183_5080)" }, /* @__PURE__ */ React.createElement("path", { d: "M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_183_5080" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgLimitedAccess = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2818_6714)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip1_2818_6714)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 14.5C12.55 14.5 13 14.05 13 13.5C13 12.95 12.55 12.5 12 12.5C11.45 12.5 11 12.95 11 13.5C11 14.05 11.45 14.5 12 14.5ZM15 10H14.5V9C14.5 7.62 13.38 6.5 12 6.5C10.62 6.5 9.5 7.62 9.5 9V10H9C8.45 10 8 10.45 8 11V16C8 16.55 8.45 17 9 17H15C15.55 17 16 16.55 16 16V11C16 10.45 15.55 10 15 10ZM10.45 9C10.45 8.145 11.145 7.45 12 7.45C12.855 7.45 13.55 8.145 13.55 9V10H10.45V9ZM15 16H9V11H15V16Z", fill: "#0974C1" }))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2818_6714" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip1_2818_6714" }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(6 6)" }))));
const SvgLink = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "link", clipPath: "url(#clip0_4903_3411)" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M11.8333 4.66666H9.16668V5.99999H11.8333C12.9333 5.99999 13.8333 6.89999 13.8333 7.99999C13.8333 9.09999 12.9333 9.99999 11.8333 9.99999H9.16668V11.3333H11.8333C13.6733 11.3333 15.1667 9.83999 15.1667 7.99999C15.1667 6.15999 13.6733 4.66666 11.8333 4.66666ZM7.83334 9.99999H5.16668C4.06668 9.99999 3.16668 9.09999 3.16668 7.99999C3.16668 6.89999 4.06668 5.99999 5.16668 5.99999H7.83334V4.66666H5.16668C3.32668 4.66666 1.83334 6.15999 1.83334 7.99999C1.83334 9.83999 3.32668 11.3333 5.16668 11.3333H7.83334V9.99999ZM5.83334 7.33332H11.1667V8.66666H5.83334V7.33332Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4903_3411" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }))));
const SvgLinkOff = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8346_1700)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.333 4.66667H8.66634V5.93333H11.333C12.473 5.93333 13.3997 6.86 13.3997 8C13.3997 8.95333 12.7463 9.75333 11.8597 9.98667L12.833 10.96C13.9197 10.4067 14.6663 9.3 14.6663 8C14.6663 6.16 13.173 4.66667 11.333 4.66667ZM10.6663 7.33333H9.20634L10.5397 8.66667H10.6663V7.33333ZM1.33301 2.84667L3.40634 4.92C2.19301 5.41333 1.33301 6.60667 1.33301 8C1.33301 9.84 2.82634 11.3333 4.66634 11.3333H7.33301V10.0667H4.66634C3.52634 10.0667 2.59967 9.14 2.59967 8C2.59967 6.94 3.40634 6.06667 4.43967 5.95333L5.81967 7.33333H5.33301V8.66667H7.15301L8.66634 10.18V11.3333H9.81967L12.493 14L13.333 13.16L2.17967 2L1.33301 2.84667Z", fill: "#D71717" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8346_1700" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgList = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5323_4489)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.00004 1.33337H14C14.2963 1.33337 14.6667 1.62967 14.6667 2.00004V14C14.6667 14.2963 14.2963 14.6667 14 14.6667H2.00004C1.62967 14.6667 1.33337 14.2963 1.33337 14V2.00004C1.33337 1.62967 1.62967 1.33337 2.00004 1.33337ZM4.2967 4.29643H5.77818V5.77791H4.2967V4.29643ZM7.25966 4.29643H11.7041V5.77791H7.25966V4.29643ZM7.25966 7.25939H11.7041V8.74087H7.25966V7.25939ZM11.7041 10.2224H7.25966V11.7038H11.7041V10.2224ZM5.77818 7.25939H4.2967V8.74087H5.77818V7.25939ZM4.2967 10.2224H5.77818V11.7038H4.2967V10.2224Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5323_4489" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgLocalOffer = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4519_4228)" }, /* @__PURE__ */ React.createElement("path", { d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4519_4228" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgLocale = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 12, viewBox: "0 0 13 12", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.92417 7.62417L5.4425 6.16L5.46 6.1425C6.475 5.01083 7.19833 3.71 7.62417 2.33333H9.33333V1.16667H5.25V0H4.08333V1.16667H0V2.3275H6.51583C6.125 3.45333 5.50667 4.52083 4.66667 5.45417C4.12417 4.85333 3.675 4.19417 3.31917 3.5H2.1525C2.57833 4.45083 3.16167 5.34917 3.89083 6.16L0.921667 9.08833L1.75 9.91667L4.66667 7L6.48083 8.81417L6.92417 7.62417ZM10.2083 4.66667H9.04167L6.41667 11.6667H7.58333L8.23667 9.91667H11.0075L11.6667 11.6667H12.8333L10.2083 4.66667ZM8.68 8.75L9.625 6.22417L10.57 8.75H8.68V8.75Z", fill: "#00204D" }));
const SvgLock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3585_9454)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6666 5.33317H11.9999V3.99984C11.9999 2.15984 10.5066 0.666504 8.66658 0.666504C6.82659 0.666504 5.33325 2.15984 5.33325 3.99984V5.33317H4.66659C3.93325 5.33317 3.33325 5.93317 3.33325 6.6665V13.3332C3.33325 14.0665 3.93325 14.6665 4.66659 14.6665H12.6666C13.3999 14.6665 13.9999 14.0665 13.9999 13.3332V6.6665C13.9999 5.93317 13.3999 5.33317 12.6666 5.33317ZM6.66658 3.99984C6.66658 2.89317 7.55992 1.99984 8.66658 1.99984C9.77325 1.99984 10.6666 2.89317 10.6666 3.99984V5.33317H6.66658V3.99984ZM12.6666 13.3332H4.66659V6.6665H12.6666V13.3332ZM8.66658 11.3332C9.39992 11.3332 9.99992 10.7332 9.99992 9.99984C9.99992 9.2665 9.39992 8.6665 8.66658 8.6665C7.93325 8.6665 7.33325 9.2665 7.33325 9.99984C7.33325 10.7332 7.93325 11.3332 8.66658 11.3332Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3585_9454" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.666626)" }))));
const SvgLockOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11_8375)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20Z", fill: "#323232" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11_8375" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgLockUnlocked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 15, viewBox: "0 0 12 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.00008 11.3337C6.73341 11.3337 7.33341 10.7337 7.33341 10.0003C7.33341 9.26699 6.73341 8.66699 6.00008 8.66699C5.26675 8.66699 4.66675 9.26699 4.66675 10.0003C4.66675 10.7337 5.26675 11.3337 6.00008 11.3337ZM10.0001 5.33366H9.33341V4.00033C9.33341 2.16033 7.84008 0.666992 6.00008 0.666992C4.16008 0.666992 2.66675 2.16033 2.66675 4.00033H3.93341C3.93341 2.86033 4.86008 1.93366 6.00008 1.93366C7.14008 1.93366 8.06675 2.86033 8.06675 4.00033V5.33366H2.00008C1.26675 5.33366 0.666748 5.93366 0.666748 6.66699V13.3337C0.666748 14.067 1.26675 14.667 2.00008 14.667H10.0001C10.7334 14.667 11.3334 14.067 11.3334 13.3337V6.66699C11.3334 5.93366 10.7334 5.33366 10.0001 5.33366ZM10.0001 13.3337H2.00008V6.66699H10.0001V13.3337Z", fill: "#62748C" }));
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 79, height: 48, viewBox: "0 0 79 48", fill: "none", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 39.5, cy: 43.5, rx: 35, ry: 4.5, fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.5 17C49.5 20.4945 48.3797 23.7274 46.4787 26.359L60.8162 40.6965C61.5972 41.4776 61.5972 42.7439 60.8162 43.525L60.0223 44.3188C59.2412 45.0999 57.9749 45.0999 57.1938 44.3188L42.8559 29.9809C40.2248 31.8806 36.9931 33 33.5 33C24.6634 33 17.5 25.8366 17.5 17C17.5 8.16344 24.6634 1 33.5 1C42.3366 1 49.5 8.16344 49.5 17ZM33.5 28C39.5751 28 44.5 23.0751 44.5 17C44.5 10.9249 39.5751 6 33.5 6C27.4249 6 22.5 10.9249 22.5 17C22.5 23.0751 27.4249 28 33.5 28Z", fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M46.4787 26.359L46.0734 26.0663L45.824 26.4115L46.1251 26.7126L46.4787 26.359ZM60.8162 40.6965L61.1697 40.343L60.8162 40.6965ZM60.8162 43.525L61.1697 43.8785L60.8162 43.525ZM60.0223 44.3188L59.6687 43.9653L60.0223 44.3188ZM42.8559 29.9809L43.2095 29.6274L42.9084 29.3263L42.5632 29.5755L42.8559 29.9809ZM46.884 26.6518C48.8445 23.9378 50 20.6031 50 17H49C49 20.3859 47.9149 23.517 46.0734 26.0663L46.884 26.6518ZM61.1697 40.343L46.8322 26.0055L46.1251 26.7126L60.4626 41.0501L61.1697 40.343ZM61.1697 43.8785C62.146 42.9022 62.146 41.3193 61.1697 40.343L60.4626 41.0501C61.0484 41.6359 61.0484 42.5856 60.4626 43.1714L61.1697 43.8785ZM60.3758 44.6724L61.1697 43.8785L60.4626 43.1714L59.6687 43.9653L60.3758 44.6724ZM56.8403 44.6724C57.8166 45.6487 59.3995 45.6487 60.3758 44.6724L59.6687 43.9653C59.0829 44.5511 58.1332 44.5511 57.5474 43.9653L56.8403 44.6724ZM42.5024 30.3345L56.8403 44.6724L57.5474 43.9653L43.2095 29.6274L42.5024 30.3345ZM33.5 33.5C37.1017 33.5 40.4352 32.3454 43.1486 30.3863L42.5632 29.5755C40.0145 31.4157 36.8846 32.5 33.5 32.5V33.5ZM17 17C17 26.1127 24.3873 33.5 33.5 33.5V32.5C24.9396 32.5 18 25.5604 18 17H17ZM33.5 0.5C24.3873 0.5 17 7.8873 17 17H18C18 8.43959 24.9396 1.5 33.5 1.5V0.5ZM50 17C50 7.8873 42.6127 0.5 33.5 0.5V1.5C42.0604 1.5 49 8.43959 49 17H50ZM44 17C44 22.799 39.299 27.5 33.5 27.5V28.5C39.8513 28.5 45 23.3513 45 17H44ZM33.5 6.5C39.299 6.5 44 11.201 44 17H45C45 10.6487 39.8513 5.5 33.5 5.5V6.5ZM23 17C23 11.201 27.701 6.5 33.5 6.5V5.5C27.1487 5.5 22 10.6487 22 17H23ZM33.5 27.5C27.701 27.5 23 22.799 23 17H22C22 23.3513 27.1487 28.5 33.5 28.5V27.5Z", fill: "#62748C" }), /* @__PURE__ */ React.createElement("path", { d: "M62.5 24L67.5 29", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M67.5 24L62.5 29", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M52.5 3L55.5 6", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M55.5 3L52.5 6", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 30L15.5 35", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.5 30L10.5 35", stroke: "#EBF0F7", strokeLinecap: "round" }));
const SvgMap = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 48, height: 48, rx: 24, fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4857_427)" }, /* @__PURE__ */ React.createElement("path", { d: "M32.5 15L32.34 15.03L27 17.1L21 15L15.36 16.9C15.15 16.97 15 17.15 15 17.38V32.5C15 32.78 15.22 33 15.5 33L15.66 32.97L21 30.9L27 33L32.64 31.1C32.85 31.03 33 30.85 33 30.62V15.5C33 15.22 32.78 15 32.5 15ZM22 17.47L26 18.87V30.53L22 29.13V17.47ZM17 18.46L20 17.45V29.15L17 30.31V18.46ZM31 29.54L28 30.55V18.86L31 17.7V29.54Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4857_427" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(12 12)" }))));
const SvgMeeting = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2405_2953)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.3333 13.8889C13.3333 14.8093 12.5871 15.5555 11.6666 15.5555H4.44442C2.60346 15.5555 1.11108 14.0632 1.11108 12.2222V6.11108C1.11108 5.19067 1.85727 4.44441 2.77775 4.44441H9.99997C11.841 4.44441 13.3333 5.93679 13.3333 7.77775V13.8889ZM17.5555 5.44431L15.1111 7.27765C14.6914 7.59241 14.4444 8.0864 14.4444 8.61101V11.3887C14.4444 11.9134 14.6914 12.4073 15.1111 12.7221L17.5555 14.5554C18.1049 14.9674 18.8889 14.5755 18.8889 13.8887V6.11099C18.8889 5.42429 18.1049 5.03229 17.5555 5.44431Z", fill: "#0B5CFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2405_2953" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }))));
const SvgMicrosoftOutlook = (props) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 20, viewBox: "0 0 23 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6096_8778)" }, /* @__PURE__ */ React.createElement("path", { d: "M22.25 10.5C22.2512 10.3319 22.1643 10.1754 22.021 10.0875H22.0185L22.0095 10.0825L14.5595 5.67249C14.5273 5.65076 14.4939 5.63089 14.4595 5.613C14.1718 5.46459 13.8301 5.46459 13.5425 5.613C13.508 5.6309 13.4747 5.65076 13.4425 5.67249L5.99251 10.0825L5.98352 10.0875C5.75582 10.2291 5.68602 10.5285 5.82761 10.7562C5.86933 10.8232 5.92679 10.8791 5.99501 10.919L13.445 15.329C13.4773 15.3505 13.5107 15.3704 13.545 15.3885C13.8327 15.5369 14.1744 15.5369 14.462 15.3885C14.4964 15.3704 14.5297 15.3505 14.562 15.329L22.012 10.919C22.1608 10.8322 22.2517 10.6723 22.25 10.5Z", fill: "#0A2767" }), /* @__PURE__ */ React.createElement("path", { d: "M6.861 7.5555H11.75V12.037H6.861V7.5555ZM21.25 3V0.949995C21.2617 0.437448 20.856 0.0122818 20.3435 0H7.65651C7.14396 0.0122818 6.73826 0.437448 6.75 0.949995V3L14.25 4.99999L21.25 3Z", fill: "#0364B8" }), /* @__PURE__ */ React.createElement("path", { d: "M6.75 3H11.75V7.5H6.75V3Z", fill: "#0078D4" }), /* @__PURE__ */ React.createElement("path", { d: "M16.75 3H11.75V7.5L16.75 12H21.25V7.5L16.75 3Z", fill: "#28A8EA" }), /* @__PURE__ */ React.createElement("path", { d: "M11.75 7.5H16.75V12H11.75V7.5Z", fill: "#0078D4" }), /* @__PURE__ */ React.createElement("path", { d: "M11.75 12H16.75V16.5H11.75V12Z", fill: "#0364B8" }), /* @__PURE__ */ React.createElement("path", { d: "M6.86096 12.037H11.75V16.111H6.86096V12.037Z", fill: "#14447D" }), /* @__PURE__ */ React.createElement("path", { d: "M16.75 12H21.25V16.5H16.75V12Z", fill: "#0078D4" }), /* @__PURE__ */ React.createElement("path", { d: "M22.021 10.8915L22.0115 10.8965L14.5615 15.0865C14.529 15.1065 14.496 15.1255 14.4615 15.1425C14.3349 15.2027 14.1975 15.2368 14.0575 15.2425L13.6505 15.0045C13.6161 14.9872 13.5827 14.968 13.5505 14.947L6.0005 10.638H5.997L5.75 10.5V18.982C5.75385 19.5479 6.21559 20.0036 6.78149 20H21.2345C21.243 20 21.2505 19.996 21.2595 19.996C21.379 19.9883 21.4968 19.9637 21.6095 19.923C21.6581 19.9024 21.7051 19.878 21.75 19.85C21.7835 19.831 21.841 19.7895 21.841 19.7895C22.0971 19.6 22.2487 19.3006 22.25 18.982V10.5C22.2498 10.6622 22.1623 10.8118 22.021 10.8915Z", fill: "url(#paint0_linear_6096_8778)" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M21.85 10.4665V10.9865L14.06 16.35L5.995 10.6415C5.995 10.6387 5.99275 10.6365 5.99 10.6365L5.25 10.1915V9.81648L5.555 9.81148L6.2 10.1815L6.21499 10.1865L6.26999 10.2215C6.26999 10.2215 13.85 14.5465 13.87 14.5565L14.16 14.7265C14.185 14.7165 14.21 14.7065 14.24 14.6965C14.255 14.6865 21.765 10.4615 21.765 10.4615L21.85 10.4665Z", fill: "#0A2767" }), /* @__PURE__ */ React.createElement("path", { d: "M22.021 10.8915L22.0115 10.897L14.5615 15.087C14.529 15.107 14.496 15.126 14.4615 15.143C14.1721 15.2843 13.8338 15.2843 13.5445 15.143C13.5102 15.126 13.4768 15.1073 13.4445 15.087L5.9945 10.897L5.9855 10.8915C5.84167 10.8135 5.75149 10.6636 5.75 10.5V18.982C5.75358 19.5478 6.21516 20.0036 6.78095 20C6.78095 20 6.78098 20 6.781 20H21.219C21.7848 20.0036 22.2464 19.5478 22.25 18.982C22.25 18.982 22.25 18.982 22.25 18.982V10.5C22.2498 10.6622 22.1623 10.8118 22.021 10.8915Z", fill: "#1490DF" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.1, d: "M14.67 15.025L14.5585 15.0875C14.5262 15.1081 14.4928 15.1269 14.4585 15.144C14.3356 15.2043 14.2021 15.2396 14.0655 15.248L16.9 18.6L21.8445 19.7915C21.98 19.6891 22.0877 19.5546 22.158 19.4L14.67 15.025Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.05, d: "M15.175 14.741L14.5585 15.0875C14.5262 15.1081 14.4928 15.1269 14.4585 15.144C14.3356 15.2043 14.2021 15.2396 14.0655 15.248L15.3935 18.9095L21.846 19.79C22.1002 19.5991 22.2498 19.2998 22.25 18.982V18.8725L15.175 14.741Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M6.795 20H21.2175C21.4394 20.0011 21.6559 19.931 21.835 19.8L13.65 15.0055C13.6156 14.9882 13.5822 14.969 13.55 14.948L5.99999 10.639H5.99649L5.75 10.5V18.953C5.74944 19.5307 6.2173 19.9994 6.795 20Z", fill: "#28A8EA" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.1, d: "M12.75 4.9165V15.5815C12.7491 15.9554 12.5217 16.2915 12.175 16.4315C12.0676 16.4777 11.9519 16.5015 11.835 16.5015H5.75V4.5H6.75V4H11.835C12.3401 4.00191 12.7489 4.41137 12.75 4.9165Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.2, d: "M12.25 5.41649V16.0815C12.2513 16.2023 12.2256 16.3218 12.175 16.4315C12.0361 16.7737 11.7044 16.9983 11.335 17H5.75V4.5H11.335C11.4801 4.49854 11.6231 4.53473 11.75 4.605C12.0565 4.75942 12.2499 5.0733 12.25 5.41649Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.2, d: "M12.25 5.41649V15.0815C12.2476 15.5864 11.8399 15.9956 11.335 16H5.75V4.5H11.335C11.4801 4.49854 11.6231 4.53473 11.75 4.605C12.0565 4.75942 12.2499 5.0733 12.25 5.41649Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.2, d: "M11.75 5.4165V15.0815C11.7495 15.5872 11.3407 15.9975 10.835 16H5.75V4.5H10.835C11.3406 4.50027 11.7503 4.91038 11.75 5.416C11.75 5.41617 11.75 5.41633 11.75 5.4165Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M1.6665 4.5H10.8335C11.3397 4.5 11.75 4.91034 11.75 5.4165V14.5835C11.75 15.0897 11.3397 15.5 10.8335 15.5H1.6665C1.16032 15.5 0.75 15.0896 0.75 14.5835V5.4165C0.75 4.91034 1.16034 4.5 1.6665 4.5Z", fill: "url(#paint1_linear_6096_8778)" }), /* @__PURE__ */ React.createElement("path", { d: "M3.61452 8.344C3.8404 7.86274 4.205 7.45998 4.66152 7.18751C5.16708 6.89806 5.74271 6.75377 6.32502 6.7705C6.86473 6.7588 7.39728 6.89561 7.86452 7.166C8.30382 7.42798 8.65763 7.81184 8.88302 8.27099C9.12846 8.77694 9.25079 9.33376 9.24002 9.89599C9.25192 10.4836 9.12606 11.0658 8.87252 11.596C8.64177 12.0716 8.27673 12.4691 7.82252 12.7395C7.33727 13.0182 6.78494 13.1586 6.22552 13.1455C5.67429 13.1588 5.12999 13.0204 4.65202 12.7455C4.20891 12.4832 3.85066 12.0989 3.62002 11.6385C3.37312 11.1398 3.24934 10.5893 3.25903 10.033C3.24874 9.4504 3.37027 8.87302 3.61452 8.344ZM4.73052 11.059C4.85095 11.3632 5.05518 11.6271 5.31951 11.82C5.58875 12.0082 5.91114 12.1052 6.23951 12.097C6.58921 12.1108 6.93391 12.0104 7.22151 11.811C7.48249 11.6187 7.68136 11.3541 7.79351 11.05C7.91887 10.7103 7.98074 10.3505 7.97601 9.9885C7.97988 9.62301 7.92173 9.25953 7.804 8.9135C7.70003 8.60109 7.50757 8.3256 7.25001 8.1205C6.96962 7.91162 6.62584 7.80567 6.27651 7.8205C5.94102 7.81181 5.61141 7.90966 5.33501 8.1C5.06621 8.29369 4.8581 8.5599 4.73501 8.86749C4.46196 9.57257 4.46054 10.3539 4.73101 11.06L4.73052 11.059Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.75 3H21.25V7.5H16.75V3Z", fill: "#50D9FF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_6096_8778", x1: 14, y1: 10.5, x2: 14, y2: 20, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#35B8F1" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#28A8EA" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_6096_8778", x1: 2.66092, y1: 3.78387, x2: 9.83907, y2: 16.2161, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#1784D9" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#107AD5" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#0A63C9" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6096_8778" }, /* @__PURE__ */ React.createElement("rect", { width: 21.5, height: 20, fill: "white", transform: "translate(0.75)" }))));
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 2, viewBox: "0 0 14 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 2H0V0H14V2Z", fill: "#62748C" }));
const SvgMyLocation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_18246_4883)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.99984 5.33329C6.5265 5.33329 5.33317 6.52663 5.33317 7.99996C5.33317 9.47329 6.5265 10.6666 7.99984 10.6666C9.47317 10.6666 10.6665 9.47329 10.6665 7.99996C10.6665 6.52663 9.47317 5.33329 7.99984 5.33329ZM13.9598 7.33329C13.6532 4.55329 11.4465 2.34663 8.6665 2.03996V0.666626H7.33317V2.03996C4.55317 2.34663 2.3465 4.55329 2.03984 7.33329H0.666504V8.66663H2.03984C2.3465 11.4466 4.55317 13.6533 7.33317 13.96V15.3333H8.6665V13.96C11.4465 13.6533 13.6532 11.4466 13.9598 8.66663H15.3332V7.33329H13.9598V7.33329ZM7.99984 12.6666C5.41984 12.6666 3.33317 10.58 3.33317 7.99996C3.33317 5.41996 5.41984 3.33329 7.99984 3.33329C10.5798 3.33329 12.6665 5.41996 12.6665 7.99996C12.6665 10.58 10.5798 12.6666 7.99984 12.6666Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_18246_4883" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgNextWeek = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17943_91112)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.33301 12.3333L9.99967 9.66667L7.33301 7L6.66634 7.66667L8.66634 9.66667L6.66634 11.6667L7.33301 12.3333ZM13.333 4.66667H10.6663V3.33333C10.6663 2.96667 10.5197 2.63333 10.273 2.39333C10.033 2.14667 9.69967 2 9.33301 2H6.66634C5.93301 2 5.33301 2.6 5.33301 3.33333V4.66667H2.66634C1.93301 4.66667 1.33301 5.26667 1.33301 6V13.3333C1.33301 14.0667 1.93301 14.6667 2.66634 14.6667H13.333C14.0663 14.6667 14.6663 14.0667 14.6663 13.3333V6C14.6663 5.26667 14.0663 4.66667 13.333 4.66667ZM6.66634 3.33333H9.33301V4.66667H6.66634V3.33333ZM13.333 13.3333H2.66634V6H13.333V13.3333Z", fill: "#62748C" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17943_91112" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgNoSearchResults = (props) => /* @__PURE__ */ React.createElement("svg", { width: 78, height: 48, viewBox: "0 0 78 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 39, cy: 43.5, rx: 35, ry: 4.5, fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 17C49 20.4945 47.8797 23.7274 45.9787 26.359L60.3162 40.6965C61.0972 41.4776 61.0972 42.7439 60.3162 43.525L59.5223 44.3188C58.7412 45.0999 57.4749 45.0999 56.6938 44.3188L42.3559 29.9809C39.7248 31.8806 36.4931 33 33 33C24.1634 33 17 25.8366 17 17C17 8.16344 24.1634 1 33 1C41.8366 1 49 8.16344 49 17ZM33 28C39.0751 28 44 23.0751 44 17C44 10.9249 39.0751 6 33 6C26.9249 6 22 10.9249 22 17C22 23.0751 26.9249 28 33 28Z", fill: "#EBF0F7" }), /* @__PURE__ */ React.createElement("path", { d: "M45.9787 26.359L45.5734 26.0663L45.324 26.4115L45.6251 26.7126L45.9787 26.359ZM60.3162 40.6965L60.6697 40.343V40.343L60.3162 40.6965ZM60.3162 43.525L60.6697 43.8785V43.8785L60.3162 43.525ZM59.5223 44.3188L59.1687 43.9653V43.9653L59.5223 44.3188ZM42.3559 29.9809L42.7095 29.6274L42.4084 29.3263L42.0632 29.5755L42.3559 29.9809ZM46.384 26.6518C48.3445 23.9378 49.5 20.6031 49.5 17H48.5C48.5 20.3859 47.4149 23.517 45.5734 26.0663L46.384 26.6518ZM60.6697 40.343L46.3322 26.0055L45.6251 26.7126L59.9626 41.0501L60.6697 40.343ZM60.6697 43.8785C61.646 42.9022 61.646 41.3193 60.6697 40.343L59.9626 41.0501C60.5484 41.6359 60.5484 42.5856 59.9626 43.1714L60.6697 43.8785ZM59.8758 44.6724L60.6697 43.8785L59.9626 43.1714L59.1687 43.9653L59.8758 44.6724ZM56.3403 44.6724C57.3166 45.6487 58.8995 45.6487 59.8758 44.6724L59.1687 43.9653C58.5829 44.5511 57.6332 44.5511 57.0474 43.9653L56.3403 44.6724ZM42.0024 30.3345L56.3403 44.6724L57.0474 43.9653L42.7095 29.6274L42.0024 30.3345ZM33 33.5C36.6017 33.5 39.9352 32.3454 42.6486 30.3863L42.0632 29.5755C39.5145 31.4157 36.3846 32.5 33 32.5V33.5ZM16.5 17C16.5 26.1127 23.8873 33.5 33 33.5V32.5C24.4396 32.5 17.5 25.5604 17.5 17H16.5ZM33 0.5C23.8873 0.5 16.5 7.8873 16.5 17H17.5C17.5 8.43959 24.4396 1.5 33 1.5V0.5ZM49.5 17C49.5 7.8873 42.1127 0.5 33 0.5V1.5C41.5604 1.5 48.5 8.43959 48.5 17H49.5ZM43.5 17C43.5 22.799 38.799 27.5 33 27.5V28.5C39.3513 28.5 44.5 23.3513 44.5 17H43.5ZM33 6.5C38.799 6.5 43.5 11.201 43.5 17H44.5C44.5 10.6487 39.3513 5.5 33 5.5V6.5ZM22.5 17C22.5 11.201 27.201 6.5 33 6.5V5.5C26.6487 5.5 21.5 10.6487 21.5 17H22.5ZM33 27.5C27.201 27.5 22.5 22.799 22.5 17H21.5C21.5 23.3513 26.6487 28.5 33 28.5V27.5Z", fill: "#62748C" }), /* @__PURE__ */ React.createElement("path", { d: "M62 24L67 29", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M67 24L62 29", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M52 3L55 6", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M55 3L52 6", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 30L15 35", stroke: "#EBF0F7", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 30L10 35", stroke: "#EBF0F7", strokeLinecap: "round" }));
const SvgNoVideocam = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6832_2770)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.37334 5.33332L5.04001 3.99999L2.27334 1.23999L1.33334 2.17999L3.15334 3.99999H2.66668C2.30001 3.99999 2.00001 4.29999 2.00001 4.66666V11.3333C2.00001 11.7 2.30001 12 2.66668 12H10.6667C10.8067 12 10.9267 11.9467 11.0333 11.88L13.1533 14L14.0933 13.06L8.18668 7.15332L6.37334 5.33332ZM3.33334 10.6667V5.33332H4.48668L9.82001 10.6667H3.33334ZM10 5.33332V7.07332L14 11.0733V4.33332L11.3333 6.99999V4.66666C11.3333 4.29999 11.0333 3.99999 10.6667 3.99999H6.92668L8.26001 5.33332H10Z", fill: "#D71717" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6832_2770" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgOfferStage = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 15, viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.94375 6.35625L5.75625 3.16875L6.825 2.11875L8.94375 4.2375L13.2 0L14.25 1.05L8.94375 6.35625ZM4.5 11.9438L9.7125 13.3688L14.175 11.9813C14.1125 11.8688 14.0219 11.7719 13.9031 11.6906C13.7844 11.6094 13.65 11.5688 13.5 11.5688H9.7125C9.375 11.5688 9.10625 11.5563 8.90625 11.5313C8.70625 11.5063 8.5 11.4563 8.2875 11.3813L6.54375 10.8L6.95625 9.3375L8.475 9.84375C8.6875 9.90625 8.9375 9.95625 9.225 9.99375C9.5125 10.0313 9.9375 10.0563 10.5 10.0688C10.5 9.93125 10.4594 9.8 10.3781 9.675C10.2969 9.55 10.2 9.46875 10.0875 9.43125L5.7 7.81875H4.5V11.9438ZM0 14.5688V6.31875H5.7C5.7875 6.31875 5.875 6.32813 5.9625 6.34688C6.05 6.36563 6.13125 6.3875 6.20625 6.4125L10.6125 8.04375C11.025 8.19375 11.3594 8.45625 11.6156 8.83125C11.8719 9.20625 12 9.61875 12 10.0688H13.5C14.125 10.0688 14.6562 10.275 15.0938 10.6875C15.5312 11.1 15.75 11.6438 15.75 12.3188V13.0688L9.75 14.9438L4.5 13.4813V14.5688H0ZM1.5 13.0688H3V7.81875H1.5V13.0688Z", fill: "#007A6A" }));
const SvgOffered = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.33341 11.9997H10.6667V10.6663H5.33341V11.9997ZM5.33341 9.33301H10.6667V7.99967H5.33341V9.33301ZM4.00008 14.6663C3.63341 14.6663 3.31953 14.5358 3.05841 14.2747C2.7973 14.0136 2.66675 13.6997 2.66675 13.333V2.66634C2.66675 2.29967 2.7973 1.98579 3.05841 1.72467C3.31953 1.46356 3.63341 1.33301 4.00008 1.33301H9.33342L13.3334 5.33301V13.333C13.3334 13.6997 13.2029 14.0136 12.9417 14.2747C12.6806 14.5358 12.3667 14.6663 12.0001 14.6663H4.00008ZM8.66675 5.99967V2.66634H4.00008V13.333H12.0001V5.99967H8.66675Z", fill: "#0974C1" }));
const SvgOpenInFull = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11_859)" }, /* @__PURE__ */ React.createElement("path", { d: "M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11_859" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24 }))));
const SvgOpenInNew = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4778_9397)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4778_9397" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgPen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 11.5V14H4.5L11.8733 6.62662L9.37333 4.12662L2 11.5ZM13.8067 4.69329C14.0667 4.43329 14.0667 4.01329 13.8067 3.75329L12.2467 2.19329C11.9867 1.93329 11.5667 1.93329 11.3067 2.19329L10.0867 3.41329L12.5867 5.91329L13.8067 4.69329Z", fill: "#006AFF" }));
const SvgPending = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_13412_75)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25ZM4.375 8.4375C3.85625 8.4375 3.4375 8.01875 3.4375 7.5C3.4375 6.98125 3.85625 6.5625 4.375 6.5625C4.89375 6.5625 5.3125 6.98125 5.3125 7.5C5.3125 8.01875 4.89375 8.4375 4.375 8.4375ZM7.5 8.4375C6.98125 8.4375 6.5625 8.01875 6.5625 7.5C6.5625 6.98125 6.98125 6.5625 7.5 6.5625C8.01875 6.5625 8.4375 6.98125 8.4375 7.5C8.4375 8.01875 8.01875 8.4375 7.5 8.4375ZM10.625 8.4375C10.1063 8.4375 9.6875 8.01875 9.6875 7.5C9.6875 6.98125 10.1063 6.5625 10.625 6.5625C11.1437 6.5625 11.5625 6.98125 11.5625 7.5C11.5625 8.01875 11.1437 8.4375 10.625 8.4375Z", fill: "#FFD129" }), /* @__PURE__ */ React.createElement("circle", { cx: 4.375, cy: 7.5, r: 0.9375, fill: "#00204D" }), /* @__PURE__ */ React.createElement("circle", { cx: 7.5, cy: 7.5, r: 0.9375, fill: "#00204D" }), /* @__PURE__ */ React.createElement("circle", { cx: 10.625, cy: 7.5, r: 0.9375, fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_13412_75" }, /* @__PURE__ */ React.createElement("rect", { width: 15, height: 15, fill: "white" }))));
const SvgPendingAction = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_14757_916)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.721 6.15594C7.30512 6.15594 6.156 7.30506 6.156 8.72094C6.156 10.1368 7.30512 11.2859 8.721 11.2859C10.1369 11.2859 11.286 10.1368 11.286 8.72094C11.286 7.30506 10.1369 6.15594 8.721 6.15594ZM9.56745 9.92649L8.4645 8.82354V7.18194H8.9775V8.61321L9.92655 9.56226L9.56745 9.92649ZM9.234 1.53894H7.60266C7.3872 0.943859 6.8229 0.512939 6.156 0.512939C5.4891 0.512939 4.9248 0.943859 4.70934 1.53894H3.078C2.5137 1.53894 2.052 2.00064 2.052 2.56494V10.2599C2.052 10.8242 2.5137 11.2859 3.078 11.2859H6.21243C5.90976 10.9935 5.66352 10.6447 5.48397 10.2599H3.078V2.56494H4.104V4.10394H8.208V2.56494H9.234V5.17098C9.59823 5.22228 9.94194 5.33001 10.26 5.47878V2.56494C10.26 2.00064 9.7983 1.53894 9.234 1.53894ZM6.156 2.56494C5.87385 2.56494 5.643 2.33409 5.643 2.05194C5.643 1.76979 5.87385 1.53894 6.156 1.53894C6.43815 1.53894 6.669 1.76979 6.669 2.05194C6.669 2.33409 6.43815 2.56494 6.156 2.56494Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_14757_916" }, /* @__PURE__ */ React.createElement("rect", { width: 12.312, height: 12.312, fill: "white" }))));
const SvgPendingSimple = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 8, r: 1.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 1.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 8, r: 1.5, fill: "currentColor" }));
const SvgPercentileBlue = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 28, viewBox: "0 0 20 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.75 20.9002C6.375 20.9009 8.18733 20.0558 10.0418 12.9306C11.7039 6.54468 13.625 5.70018 17.25 5.7002", stroke: "#0974C1", strokeWidth: 2.2 }));
const SvgPercentileH1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 27, height: 42, viewBox: "0 0 27 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 31.3002C7.9 31.3013 10.5997 30.0447 13.3622 19.4507C15.8382 9.95581 18.7 8.70017 24.1 8.7002", stroke: "#00204D", strokeWidth: 3.3 }));
const SvgPercentileH2Medium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 28, viewBox: "0 0 19 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 20.9002C5.625 20.9009 7.43733 20.0558 9.29179 12.9306C10.9539 6.54468 12.875 5.70018 16.5 5.7002", stroke: "#00204D", strokeWidth: 2.2 }));
const SvgPercentileH2Regular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 28, viewBox: "0 0 19 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 21.1499C5.625 21.1507 7.43733 20.2889 9.29179 13.0231C10.9539 6.51106 12.875 5.64988 16.5 5.6499", stroke: "#00204D", strokeWidth: 1.75 }));
const SvgPercentileH3Medium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 26, viewBox: "0 0 14 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 18.1501C4.175 18.1507 5.51237 17.5224 6.88084 12.2254C8.10733 7.47791 9.525 6.85008 12.2 6.8501", stroke: "#00204D", strokeWidth: 1.7 }));
const SvgPercentileH3Regular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 26, viewBox: "0 0 14 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 18.3499C4.175 18.3505 5.51237 17.6999 6.88084 12.2154C8.10733 7.29993 9.525 6.64989 12.2 6.6499", stroke: "#00204D", strokeWidth: 1.3 }));
const SvgPercentileH4 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 20, viewBox: "0 0 11 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 14.3498C3.5 14.3502 4.49991 13.8609 5.52306 9.73585C6.44006 6.03872 7.5 5.54979 9.5 5.5498", stroke: "#00204D", strokeWidth: 1.3 }));
const SvgPercentileH4Blue = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 20, viewBox: "0 0 11 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 14.3498C3.5 14.3502 4.49991 13.8609 5.52306 9.73585C6.44006 6.03872 7.5 5.54979 9.5 5.5498", stroke: "#10b7ff", strokeWidth: 1.3 }));
const SvgPercentileH5 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 16, viewBox: "0 0 9 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 11.4298C2.7 11.4301 3.54992 11.0187 4.4196 7.54987C5.19905 4.44092 6.1 4.02978 7.8 4.02979", stroke: "#00204D", strokeWidth: 1.14 }));
const SvgPercentileP = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 20, viewBox: "0 0 11 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 14.48C3.5 14.4804 4.49991 13.98 5.52306 9.76117C6.44006 5.98001 7.5 5.47997 9.5 5.47998", stroke: "#00204D", strokeWidth: 1.07 }));
const SvgPercentilePSmall = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 16, viewBox: "0 0 9 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 11.55C2.7 11.5504 3.54992 11.1167 4.4196 7.46036C5.19905 4.18336 6.1 3.74999 7.8 3.75", stroke: "#00204D", strokeWidth: 0.9 }));
const SvgPersonAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_14486_557)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.66666 5.33329C8.66666 3.85996 7.47332 2.66663 5.99999 2.66663C4.52666 2.66663 3.33332 3.85996 3.33332 5.33329C3.33332 6.80663 4.52666 7.99996 5.99999 7.99996C7.47332 7.99996 8.66666 6.80663 8.66666 5.33329ZM9.99999 6.66663V7.99996H12V9.99996H13.3333V7.99996H15.3333V6.66663H13.3333V4.66663H12V6.66663H9.99999ZM0.666656 12V13.3333H11.3333V12C11.3333 10.2266 7.77999 9.33329 5.99999 9.33329C4.21999 9.33329 0.666656 10.2266 0.666656 12Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_14486_557" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgPersonSearch = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_438_70514)" }, /* @__PURE__ */ React.createElement("path", { d: "M10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M4 18C4.22 17.28 7.31 16 10 16C10 15.3 10.13 14.63 10.35 14.01C7.62 13.91 2 15.27 2 18V20H11.54C11.02 19.42 10.61 18.75 10.35 18H4Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M19.43 18.02C19.79 17.43 20 16.74 20 16C20 13.79 18.21 12 16 12C13.79 12 12 13.79 12 16C12 18.21 13.79 20 16 20C16.74 20 17.43 19.78 18.02 19.43C18.95 20.36 19.64 21.05 20.59 22L22 20.59C20.5 19.09 21.21 19.79 19.43 18.02ZM16 18C14.9 18 14 17.1 14 16C14 14.9 14.9 14 16 14C17.1 14 18 14.9 18 16C18 17.1 17.1 18 16 18Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_438_70514" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 10, viewBox: "0 0 8 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0V9.33333L7.33333 4.66667L0 0Z", fill: "#ADBFD9" }));
const SvgPlaylistAddCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7665_106005)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.33325 6.66667H1.33325V8H9.33325V6.66667ZM9.33325 4H1.33325V5.33333H9.33325V4ZM1.33325 10.6667H6.66659V9.33333H1.33325V10.6667ZM14.3333 7.66667L15.3333 8.66667L10.6733 13.3333L7.66659 10.3333L8.66659 9.33333L10.6733 11.3333L14.3333 7.66667Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7665_106005" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgPlaylistAddCheckBig = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5070_13550)" }, /* @__PURE__ */ React.createElement("path", { d: "M22.293 13L16.0088 19.293L12.207 15.499L13 14.7061L15.6572 17.3545L16.0107 17.707L16.3643 17.3535L21.5 12.207L22.293 13ZM9.5 14.5V15.5H2.5V14.5H9.5ZM13.5 10.5V11.5H2.5V10.5H13.5ZM13.5 6.5V7.5H2.5V6.5H13.5Z", fill: "#0974C1", stroke: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5070_13550" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgPsychology = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(4 3)" }, /* @__PURE__ */ React.createElement("path", { d: "M11.8198 4.22L10.8198 4.62C10.6098 4.46 10.3898 4.33 10.1498 4.23L9.99985 3.17C9.97985 3.07 9.89985 3 9.79985 3H8.19985C8.09985 3 8.01985 3.07 8.00985 3.17L7.85985 4.23C7.61985 4.33 7.38985 4.46 7.18985 4.62L6.18985 4.22C6.09985 4.19 5.98985 4.22 5.94985 4.31L5.14985 5.69C5.09985 5.78 5.11985 5.89 5.19985 5.95L6.04985 6.61C6.01985 6.73 5.99985 6.87 5.99985 7C5.99985 7.13 6.00985 7.26 6.02985 7.39L5.18985 8.05C5.10985 8.11 5.08985 8.22 5.13985 8.3L5.93985 9.69C5.98985 9.78 6.08985 9.81 6.18985 9.78L7.17985 9.38C7.38985 9.54 7.60985 9.67 7.85985 9.77L7.99985 10.83C8.01985 10.93 8.09985 11 8.19985 11H9.79985C9.89985 11 9.97985 10.93 9.99985 10.83L10.1498 9.77C10.3898 9.67 10.6198 9.54 10.8198 9.38L11.8098 9.78C11.8998 9.82 12.0098 9.78 12.0498 9.69L12.8498 8.3C12.8998 8.21 12.8798 8.11 12.7998 8.05L11.9698 7.39C11.9898 7.26 11.9998 7.13 11.9998 7C11.9998 6.86 11.9898 6.73 11.9698 6.61L12.8198 5.95C12.8998 5.89 12.9198 5.78 12.8698 5.69L12.0698 4.31C12.0198 4.22 11.9098 4.19 11.8198 4.22ZM8.99985 8.43C8.20985 8.43 7.56985 7.79 7.56985 7C7.56985 6.21 8.20985 5.57 8.99985 5.57C9.78985 5.57 10.4298 6.21 10.4298 7C10.4298 7.79 9.78985 8.43 8.99985 8.43Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M15.9398 6.06C15.5098 2.79 12.7098 0.2 9.40985 0.00999999C9.26985 -9.31323e-09 9.13985 0 8.99985 0C5.46985 0 2.56985 2.61 2.07985 6L0.149847 9.48C-0.260153 10.14 0.219847 11 0.999847 11H1.99985V13C1.99985 14.1 2.89985 15 3.99985 15H4.99985V18H11.9998V13.32C14.6198 12.07 16.3498 9.24 15.9398 6.06ZM10.8898 11.63L9.99985 12.05V16H6.99985V13H3.99985V9H2.69985L4.02985 6.67C4.20985 4.06 6.34985 2 8.99985 2C11.7598 2 13.9998 4.24 13.9998 7C13.9998 9.09 12.7098 10.88 10.8898 11.63Z", fill: "#0974C1" })));
const SvgPublish = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5442_7658)" }, /* @__PURE__ */ React.createElement("path", { d: "M3.33337 2.66663H12.6667V3.99996H3.33337V2.66663ZM3.33337 9.33329H6.00004V13.3333H10V9.33329H12.6667L8.00004 4.66663L3.33337 9.33329ZM8.66671 7.99996V12H7.33337V7.99996H6.55337L8.00004 6.55329L9.44671 7.99996H8.66671Z", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5442_7658" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgQuestionMark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.0667 10.6667C7.0667 9.76667 7.14725 9.11944 7.30837 8.725C7.46948 8.33056 7.81114 7.9 8.33337 7.43333C8.78892 7.03333 9.13614 6.68611 9.37503 6.39167C9.61392 6.09722 9.73337 5.76111 9.73337 5.38333C9.73337 4.92778 9.58059 4.55 9.27503 4.25C8.96948 3.95 8.54448 3.8 8.00003 3.8C7.43337 3.8 7.00281 3.97222 6.70837 4.31667C6.41392 4.66111 6.20559 5.01111 6.08337 5.36667L4.3667 4.63333C4.60003 3.92222 5.02781 3.30556 5.65003 2.78333C6.27225 2.26111 7.05559 2 8.00003 2C9.1667 2 10.0639 2.325 10.6917 2.975C11.3195 3.625 11.6334 4.40556 11.6334 5.31667C11.6334 5.87222 11.5139 6.34722 11.275 6.74167C11.0361 7.13611 10.6611 7.58333 10.15 8.08333C9.60559 8.60556 9.27503 9.00278 9.15837 9.275C9.0417 9.54722 8.98337 10.0111 8.98337 10.6667H7.0667ZM8.00003 14.6667C7.63337 14.6667 7.31948 14.5361 7.05837 14.275C6.79725 14.0139 6.6667 13.7 6.6667 13.3333C6.6667 12.9667 6.79725 12.6528 7.05837 12.3917C7.31948 12.1306 7.63337 12 8.00003 12C8.3667 12 8.68059 12.1306 8.9417 12.3917C9.20281 12.6528 9.33337 12.9667 9.33337 13.3333C9.33337 13.7 9.20281 14.0139 8.9417 14.275C8.68059 14.5361 8.3667 14.6667 8.00003 14.6667Z", fill: "#00204D" }));
const SvgRecordingInProgress = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1793_2929)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00008 14.0463C10.9456 14.0463 13.3334 11.6585 13.3334 8.71297C13.3334 5.76745 10.9456 3.37964 8.00008 3.37964C5.05456 3.37964 2.66675 5.76745 2.66675 8.71297C2.66675 11.6585 5.05456 14.0463 8.00008 14.0463Z", fill: "#D71717" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1793_2929" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.712891)" }))));
const SvgRecordingPause = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1908_6563)" }, /* @__PURE__ */ React.createElement("path", { d: "M4 12.6666H6.66667V3.33331H4V12.6666ZM9.33333 3.33331V12.6666H12V3.33331H9.33333Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1908_6563" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgRecordingResume = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1908_3887)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.33325 3.33331V12.6666L12.6666 7.99998L5.33325 3.33331Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1908_3887" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgRecordingStart = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1793_78)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00008 4.71297C10.2067 4.71297 12.0001 6.50631 12.0001 8.71297C12.0001 10.9196 10.2067 12.713 8.00008 12.713C5.79341 12.713 4.00008 10.9196 4.00008 8.71297C4.00008 6.50631 5.79341 4.71297 8.00008 4.71297ZM8.00008 3.37964C5.05341 3.37964 2.66675 5.76631 2.66675 8.71297C2.66675 11.6596 5.05341 14.0463 8.00008 14.0463C10.9467 14.0463 13.3334 11.6596 13.3334 8.71297C13.3334 5.76631 10.9467 3.37964 8.00008 3.37964Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1793_78" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0 0.712891)" }))));
const SvgRecordingStop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1908_3892)" }, /* @__PURE__ */ React.createElement("path", { d: "M4 4H12V12H4V4Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1908_3892" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgRemove = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_15321_17187)" }, /* @__PURE__ */ React.createElement("path", { d: "M19 13H5V11H19V13Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_15321_17187" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgRemoveCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8596_664)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.66671 7.33334V8.66668H11.3334V7.33334H4.66671ZM8.00004 1.33334C4.32004 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8.00004 1.33334ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 8.00001C2.66671 5.06001 5.06004 2.66668 8.00004 2.66668C10.94 2.66668 13.3334 5.06001 13.3334 8.00001C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z", fill: "#3388FF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8596_664" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgReplay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6080_3063)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.00033 3.33317V0.666504L4.66699 3.99984L8.00033 7.33317V4.6665C10.207 4.6665 12.0003 6.45984 12.0003 8.6665C12.0003 10.8732 10.207 12.6665 8.00033 12.6665C5.79366 12.6665 4.00033 10.8732 4.00033 8.6665H2.66699C2.66699 11.6132 5.05366 13.9998 8.00033 13.9998C10.947 13.9998 13.3337 11.6132 13.3337 8.6665C13.3337 5.71984 10.947 3.33317 8.00033 3.33317Z", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6080_3063" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgReport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { d: "M11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z", fill: "#0974C1" }));
const SvgRspDecisions = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 18, viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 4H16V6H0V4ZM0 10H16V8H0V10ZM0 14H7V12H0V14ZM0 18H7V16H0V18ZM11.41 15.17L10 13.75L8.59 15.16L11.41 18L16 13.42L14.58 12L11.41 15.17ZM0 0V2H16V0H0Z", fill: "#0974C1" }));
const SvgRspProfile = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 12, viewBox: "0 0 22 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 2C22 3.1 21.1 4 20 4C19.82 4 19.65 3.98 19.49 3.93L15.93 7.48C15.98 7.64 16 7.82 16 8C16 9.1 15.1 10 14 10C12.9 10 12 9.1 12 8C12 7.82 12.02 7.64 12.07 7.48L9.52 4.93C9.36 4.98 9.18 5 9 5C8.82 5 8.64 4.98 8.48 4.93L3.93 9.49C3.98 9.65 4 9.82 4 10C4 11.1 3.1 12 2 12C0.9 12 0 11.1 0 10C0 8.9 0.9 8 2 8C2.18 8 2.35 8.02 2.51 8.07L7.07 3.52C7.02 3.36 7 3.18 7 3C7 1.9 7.9 1 9 1C10.1 1 11 1.9 11 3C11 3.18 10.98 3.36 10.93 3.52L13.48 6.07C13.64 6.02 13.82 6 14 6C14.18 6 14.36 6.02 14.52 6.07L18.07 2.51C18.02 2.35 18 2.18 18 2C18 0.9 18.9 0 20 0C21.1 0 22 0.9 22 2Z", fill: "#0974C1" }));
const SvgRspRole = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM8 12C10.7 12 13.8 13.29 14 14H2C2.23 13.28 5.31 12 8 12ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z", fill: "#0974C1" }));
const SvgSaveAlt = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7002_2422)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6667 8V12.6667H3.33333V8H2V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667ZM8.66667 8.44667L10.3933 6.72667L11.3333 7.66667L8 11L4.66667 7.66667L5.60667 6.72667L7.33333 8.44667V2H8.66667V8.44667Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7002_2422" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgScoreChecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.0266 7.33333L8.66665 4.97333L9.60665 4.03333L11.02 5.44666L13.8466 2.62L14.7866 3.56L11.0266 7.33333ZM7.33331 4.66666H1.33331V6H7.33331V4.66666ZM14 8.94L13.06 8L11.3333 9.72666L9.60665 8L8.66665 8.94L10.3933 10.6667L8.66665 12.3933L9.60665 13.3333L11.3333 11.6067L13.06 13.3333L14 12.3933L12.2733 10.6667L14 8.94ZM7.33331 10H1.33331V11.3333H7.33331V10Z", fill: "#00204D" }));
const SvgSearchV2 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5305_4628)" }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 3.5C11.1861 3.5 8.5 6.18614 8.5 9.5C8.5 10.9857 9.0441 12.3514 9.94922 13.4043L10.249 13.751L10.5957 14.0508C11.6486 14.9559 13.0143 15.5 14.5 15.5C17.8139 15.5 20.5 12.8139 20.5 9.5C20.5 6.18614 17.8139 3.5 14.5 3.5ZM14.5 4.5C17.2661 4.5 19.5 6.73386 19.5 9.5C19.5 12.2661 17.2661 14.5 14.5 14.5C11.7339 14.5 9.5 12.2661 9.5 9.5C9.5 6.73386 11.7339 4.5 14.5 4.5ZM9.5 14.5078L9.63965 14.3633L9.72461 14.2754L9.63672 14.3604L9.49219 14.5H8.70703L4.21777 19L5 19.7822L9.5 15.292V14.5078Z", fill: "#0974C1", stroke: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5305_4628" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "matrix(-1 0 0 1 24 0)" }))));
const SvgSearchV3 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6795_2949)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.37001 6.69522H7.01465L6.88871 6.57377C7.32953 6.06097 7.59492 5.39524 7.59492 4.67103C7.59492 3.05617 6.28594 1.74719 4.67109 1.74719C3.05623 1.74719 1.74725 3.05617 1.74725 4.67103C1.74725 6.28588 3.05623 7.59486 4.67109 7.59486C5.3953 7.59486 6.06103 7.32947 6.57383 6.88864L6.69528 7.01459V7.36995L8.94439 9.61456L9.61462 8.94432L7.37001 6.69522ZM4.67109 6.69522C3.55103 6.69522 2.64689 5.79108 2.64689 4.67103C2.64689 3.55097 3.55103 2.64683 4.67109 2.64683C5.79114 2.64683 6.69528 3.55097 6.69528 4.67103C6.69528 5.79108 5.79114 6.69522 4.67109 6.69522Z", fill: "black" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6795_2949" }, /* @__PURE__ */ React.createElement("rect", { width: 10.7957, height: 10.7957, fill: "white", transform: "translate(0.397827 0.397827)" }))));
const SvgSelfAssessment = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 6.5V4.5H22V6.5H14ZM14 10.5V8.5H22V10.5H14ZM14 14.5V12.5H22V14.5H14ZM8 13.5C7.16667 13.5 6.45833 13.2083 5.875 12.625C5.29167 12.0417 5 11.3333 5 10.5C5 9.66667 5.29167 8.95833 5.875 8.375C6.45833 7.79167 7.16667 7.5 8 7.5C8.83333 7.5 9.54167 7.79167 10.125 8.375C10.7083 8.95833 11 9.66667 11 10.5C11 11.3333 10.7083 12.0417 10.125 12.625C9.54167 13.2083 8.83333 13.5 8 13.5ZM2 19.5V17.6C2 17.25 2.08333 16.9167 2.25 16.6C2.41667 16.2833 2.65 16.0333 2.95 15.85C3.7 15.4 4.49583 15.0625 5.3375 14.8375C6.17917 14.6125 7.06667 14.5 8 14.5C8.93333 14.5 9.82083 14.6125 10.6625 14.8375C11.5042 15.0625 12.3 15.4 13.05 15.85C13.35 16.0333 13.5833 16.2833 13.75 16.6C13.9167 16.9167 14 17.25 14 17.6V19.5H2ZM4.15 17.5H11.85C11.2667 17.1667 10.65 16.9167 10 16.75C9.35 16.5833 8.68333 16.5 8 16.5C7.31667 16.5 6.65 16.5833 6 16.75C5.35 16.9167 4.73333 17.1667 4.15 17.5ZM8 11.5C8.28333 11.5 8.52083 11.4042 8.7125 11.2125C8.90417 11.0208 9 10.7833 9 10.5C9 10.2167 8.90417 9.97917 8.7125 9.7875C8.52083 9.59583 8.28333 9.5 8 9.5C7.71667 9.5 7.47917 9.59583 7.2875 9.7875C7.09583 9.97917 7 10.2167 7 10.5C7 10.7833 7.09583 11.0208 7.2875 11.2125C7.47917 11.4042 7.71667 11.5 8 11.5Z", fill: "#0974C1" }));
const SvgShare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7442_368)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 10.72C11.4933 10.72 11.04 10.92 10.6933 11.2333L5.94 8.46665C5.97333 8.31331 6 8.15998 6 7.99998C6 7.83998 5.97333 7.68665 5.94 7.53331L10.64 4.79331C11 5.12665 11.4733 5.33331 12 5.33331C13.1067 5.33331 14 4.43998 14 3.33331C14 2.22665 13.1067 1.33331 12 1.33331C10.8933 1.33331 10 2.22665 10 3.33331C10 3.49331 10.0267 3.64665 10.06 3.79998L5.36 6.53998C5 6.20665 4.52667 5.99998 4 5.99998C2.89333 5.99998 2 6.89331 2 7.99998C2 9.10665 2.89333 9.99998 4 9.99998C4.52667 9.99998 5 9.79331 5.36 9.45998L10.1067 12.2333C10.0733 12.3733 10.0533 12.52 10.0533 12.6666C10.0533 13.74 10.9267 14.6133 12 14.6133C13.0733 14.6133 13.9467 13.74 13.9467 12.6666C13.9467 11.5933 13.0733 10.72 12 10.72Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7442_368" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgSkillLock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 14, viewBox: "0 0 11 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.33333 4.66667H8.66667V3.33333C8.66667 1.49333 7.17333 0 5.33333 0C3.49333 0 2 1.49333 2 3.33333V4.66667H1.33333C0.6 4.66667 0 5.26667 0 6V12.6667C0 13.4 0.6 14 1.33333 14H9.33333C10.0667 14 10.6667 13.4 10.6667 12.6667V6C10.6667 5.26667 10.0667 4.66667 9.33333 4.66667ZM5.33333 10.6667C4.6 10.6667 4 10.0667 4 9.33333C4 8.6 4.6 8 5.33333 8C6.06667 8 6.66667 8.6 6.66667 9.33333C6.66667 10.0667 6.06667 10.6667 5.33333 10.6667ZM7.4 4.66667H3.26667V3.33333C3.26667 2.19333 4.19333 1.26667 5.33333 1.26667C6.47333 1.26667 7.4 2.19333 7.4 3.33333V4.66667Z", fill: "#C4811D" }));
const SvgSkipped = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_13412_62)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 1.25C4.04375 1.25 1.25 4.04375 1.25 7.5C1.25 10.9563 4.04375 13.75 7.5 13.75C10.9563 13.75 13.75 10.9563 13.75 7.5C13.75 4.04375 10.9563 1.25 7.5 1.25ZM10.625 9.74375L9.74375 10.625L7.5 8.38125L5.25625 10.625L4.375 9.74375L6.61875 7.5L4.375 5.25625L5.25625 4.375L7.5 6.61875L9.74375 4.375L10.625 5.25625L8.38125 7.5L10.625 9.74375Z", fill: "#62748C" }), /* @__PURE__ */ React.createElement("path", { d: "M10.625 9.74375L9.74375 10.625L7.5 8.38125L5.25625 10.625L4.375 9.74375L6.61875 7.5L4.375 5.25625L5.25625 4.375L7.5 6.61875L9.74375 4.375L10.625 5.25625L8.38125 7.5L10.625 9.74375Z", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_13412_62" }, /* @__PURE__ */ React.createElement("rect", { width: 15, height: 15, fill: "white" }))));
const SvgSmallDownload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3495_33)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.6667 6H10V2H6.00001V6H3.33334L8.00001 10.6667L12.6667 6ZM7.33334 7.33333V3.33333H8.66668V7.33333H9.44668L8.00001 8.78L6.55334 7.33333H7.33334ZM3.33334 12H12.6667V13.3333H3.33334V12Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3495_33" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgSms = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_14596_206", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_14596_206)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.33325 7.33325C5.52214 7.33325 5.68047 7.26936 5.80825 7.14159C5.93603 7.01381 5.99992 6.85547 5.99992 6.66658C5.99992 6.4777 5.93603 6.31936 5.80825 6.19159C5.68047 6.06381 5.52214 5.99992 5.33325 5.99992C5.14436 5.99992 4.98603 6.06381 4.85825 6.19159C4.73047 6.31936 4.66658 6.4777 4.66658 6.66658C4.66658 6.85547 4.73047 7.01381 4.85825 7.14159C4.98603 7.26936 5.14436 7.33325 5.33325 7.33325ZM7.99992 7.33325C8.18881 7.33325 8.34714 7.26936 8.47492 7.14159C8.6027 7.01381 8.66658 6.85547 8.66658 6.66658C8.66658 6.4777 8.6027 6.31936 8.47492 6.19159C8.34714 6.06381 8.18881 5.99992 7.99992 5.99992C7.81103 5.99992 7.6527 6.06381 7.52492 6.19159C7.39714 6.31936 7.33325 6.4777 7.33325 6.66658C7.33325 6.85547 7.39714 7.01381 7.52492 7.14159C7.6527 7.26936 7.81103 7.33325 7.99992 7.33325ZM10.6666 7.33325C10.8555 7.33325 11.0138 7.26936 11.1416 7.14159C11.2694 7.01381 11.3333 6.85547 11.3333 6.66658C11.3333 6.4777 11.2694 6.31936 11.1416 6.19159C11.0138 6.06381 10.8555 5.99992 10.6666 5.99992C10.4777 5.99992 10.3194 6.06381 10.1916 6.19159C10.0638 6.31936 9.99992 6.4777 9.99992 6.66658C9.99992 6.85547 10.0638 7.01381 10.1916 7.14159C10.3194 7.26936 10.4777 7.33325 10.6666 7.33325ZM1.33325 14.6666V2.66659C1.33325 2.29992 1.46381 1.98603 1.72492 1.72492C1.98603 1.46381 2.29992 1.33325 2.66659 1.33325H13.3333C13.6999 1.33325 14.0138 1.46381 14.2749 1.72492C14.536 1.98603 14.6666 2.29992 14.6666 2.66659V10.6666C14.6666 11.0333 14.536 11.3471 14.2749 11.6083C14.0138 11.8694 13.6999 11.9999 13.3333 11.9999H3.99992L1.33325 14.6666ZM3.43325 10.6666H13.3333V2.66659H2.66659V11.4166L3.43325 10.6666Z", fill: "#62748C" })));
const SvgSourceOutlined = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zM6 14h12v-2H6v2zm0 3h8v-2H6v2zm0-6h12V9H6v2z", fill: "#0974C1" }));
const SvgSplitscreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 4v5H6V4h12m0-2H6c-1.1 0-2 .9-2 2v7h16V4c0-1.1-.9-2-2-2zm0 13v5H6v-5h12m2-2H4v7c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7z", fill: "currentColor" }));
const SvgSpot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 516, height: 515, viewBox: "0 0 516 515", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_41_890", style: {
  maskType: "luminance"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 516, height: 515 }, /* @__PURE__ */ React.createElement("path", { d: "M34.1408 129.296C11.0107 169.562 0.012459 213.447 0 256.749V256.929C0.0311475 346.027 46.5687 432.617 129.642 480.084C253.133 550.648 410.609 508.006 481.36 384.836C552.112 261.67 509.356 104.614 385.859 34.0503C345.461 10.9659 301.437 0 257.989 0C168.63 0.00621299 81.7467 46.4204 34.1408 129.296Z", fill: "white" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_41_890)" }, /* @__PURE__ */ React.createElement("path", { d: "M1811.48 -433.774L442.465 1949.35L487.125 1974.87L1856.14 -408.254L1811.48 -433.774Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M1722.15 -484.811L353.139 1898.31L397.802 1923.84L1766.81 -459.289L1722.15 -484.811Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M263.852 1847.26L1632.82 -535.891L1677.49 -510.371L308.514 1872.78L263.852 1847.26Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M1543.52 -586.893L174.505 1796.23L219.168 1821.75L1588.18 -561.372L1543.52 -586.893Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M85.1777 1745.19L1454.15 -637.954L1498.81 -612.437L129.843 1770.71L85.1777 1745.19Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M1364.84 -688.987L-4.16895 1694.14L40.4943 1719.66L1409.5 -663.466L1364.84 -688.987Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M1275.54 -740.027L-93.4751 1643.1L-48.8118 1668.62L1320.2 -714.506L1275.54 -740.027Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M972.493 -549.549L-81.9768 1286.04L-47.5753 1305.69L1006.89 -529.891L972.493 -549.549Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M-150.765 1246.73L903.676 -588.871L938.078 -569.216L-116.362 1266.39L-150.765 1246.73Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M834.879 -628.183L-219.591 1207.4L-185.19 1227.06L869.28 -608.525L834.879 -628.183Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M-288.36 1168.09L766.081 -667.505L800.481 -647.85L-253.957 1187.75L-288.36 1168.09Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M-357.186 1128.78L697.252 -706.822L731.654 -687.167L-322.787 1148.44L-357.186 1128.78Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M628.457 -746.125L-426.013 1089.46L-391.609 1109.12L662.861 -726.466L628.457 -746.125Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M559.669 -785.411L-494.802 1050.17L-460.4 1069.83L594.07 -765.753L559.669 -785.411Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M560.901 -1148.37L-808.109 1234.76L-763.446 1260.28L605.564 -1122.85L560.901 -1148.37Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M471.574 -1199.38L-897.437 1183.74L-852.773 1209.26L516.237 -1173.86L471.574 -1199.38Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M382.249 -1250.44L-986.763 1132.69L-942.1 1158.22L426.913 -1224.91L382.249 -1250.44Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M292.923 -1301.48L-1076.09 1081.65L-1031.43 1107.17L337.586 -1275.96L292.923 -1301.48Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M203.593 -1352.52L-1165.42 1030.6L-1120.75 1056.12L248.257 -1327L203.593 -1352.52Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M-1254.7 979.574L114.266 -1403.57L158.928 -1378.05L-1210.04 1005.1L-1254.7 979.574Z", fill: "#ffda54" }), /* @__PURE__ */ React.createElement("path", { d: "M24.9402 -1454.61L-1344.07 928.517L-1299.41 954.038L69.6034 -1429.09L24.9402 -1454.61Z", fill: "#ffda54" })));
const SvgSpotBlueLogo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#0060F0" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9, fill: "white" }), /* @__PURE__ */ React.createElement("mask", { id: "mask0_5071_3007", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 2, y: 2, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 8, fill: "white" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_5071_3007)" }, /* @__PURE__ */ React.createElement("path", { d: "M1.304 8.26702C0.959217 9.85472 1.05654 11.4354 1.51342 12.8809L1.51533 12.887C2.4573 15.8607 4.92105 18.2608 8.18794 18.9703C13.0443 20.025 17.8364 16.9429 18.8911 12.0864C19.9457 7.22992 16.8637 2.43784 12.0072 1.38322C10.4185 1.03819 8.83707 1.13584 7.39065 1.59347C4.41586 2.53488 2.01362 4.99928 1.304 8.26702Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M64.8953 -13.8284L16.6508 70.3771L18.2246 71.2788L66.4691 -12.9267L64.8953 -13.8284Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M61.7471 -15.6318L13.5026 68.5737L15.0766 69.4755L63.3211 -14.73L61.7471 -15.6318Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M10.3553 66.7699L58.5984 -17.4365L60.1724 -16.5348L11.9292 67.6716L10.3553 66.7699Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M55.4515 -19.2388L7.20699 64.9667L8.78094 65.8685L57.0254 -18.3371L55.4515 -19.2388Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M4.05949 63.1629L52.3026 -21.0433L53.8765 -20.1417L5.63352 64.0646L4.05949 63.1629Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M49.1555 -22.846L0.911015 61.3595L2.48496 62.2613L50.7294 -21.9442L49.1555 -22.846Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M46.0075 -24.6495L-2.23703 59.5561L-0.663078 60.4579L47.5815 -23.7477L46.0075 -24.6495Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M35.3287 -17.9191L-1.83121 46.9395L-0.618889 47.6341L36.5411 -17.2245L35.3287 -17.9191Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M-4.25565 45.5503L32.9033 -19.3089L34.1156 -18.6144L-3.0433 46.245L-4.25565 45.5503Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M30.4789 -20.6975L-6.68107 44.1612L-5.46875 44.8557L31.6912 -20.0029L30.4789 -20.6975Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M-9.10498 42.7721L28.0539 -22.0871L29.2662 -21.3926L-7.89262 43.4668L-9.10498 42.7721Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M-11.5296 41.383L25.6292 -23.4762L26.8416 -22.7818L-10.3173 42.0776L-11.5296 41.383Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M23.2051 -24.865L-13.9549 39.9936L-12.7425 40.6883L24.4175 -24.1704L23.2051 -24.865Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M20.7804 -26.2541L-16.3795 38.6045L-15.1672 39.2991L21.9928 -25.5595L20.7804 -26.2541Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M20.8245 -39.0779L-27.4199 45.1276L-25.846 46.0294L22.3985 -38.1761L20.8245 -39.0779Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M17.6762 -40.8813L-30.5682 43.3242L-28.9943 44.226L19.2502 -39.9795L17.6762 -40.8813Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M14.5281 -42.685L-33.7164 41.5206L-32.1424 42.4224L16.1021 -41.7832L14.5281 -42.685Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M11.3806 -44.4885L-36.8639 39.7171L-35.29 40.6189L12.9546 -43.5867L11.3806 -44.4885Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M8.23251 -46.292L-40.012 37.9135L-38.438 38.8153L9.80646 -45.3902L8.23251 -46.292Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M-43.1589 36.1108L5.08406 -48.0956L6.65798 -47.1938L-41.5851 37.0126L-43.1589 36.1108Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M1.93661 -49.8989L-46.3079 34.3066L-44.7339 35.2084L3.51056 -48.9971L1.93661 -49.8989Z", fill: "#0060F0" })));
const SvgSpottedZebraLogoLarge = (props) => /* @__PURE__ */ React.createElement("svg", { width: 103, height: 40, viewBox: "0 0 103 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M31.769 16.8733L38.4006 5.27045C37.8706 5.29659 37.3456 5.37501 36.833 5.50339L31.2651 15.2453C31.3902 15.812 31.5603 16.3592 31.769 16.8736V16.8733Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M34.9951 6.20892C33.6958 6.89903 32.5797 7.93303 31.7918 9.30336L31.7808 9.32253C31.2367 10.5302 30.9982 11.868 31.0194 13.1649L34.9951 6.20892Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M33.2569 19.2898L41.0852 5.59316C40.6625 5.4674 40.2342 5.37823 39.8045 5.32391L32.4409 18.2073C32.6881 18.6073 32.9616 18.9712 33.2569 19.2898Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M34.7691 20.409C34.9618 20.4938 35.1559 20.5728 35.3509 20.6457L43.3412 6.66582C43.1709 6.54993 42.9947 6.43956 42.813 6.33529C42.6313 6.23102 42.447 6.13459 42.261 6.04572L34.2214 20.1119C34.3994 20.2269 34.5822 20.3265 34.7691 20.409Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M45.8111 17.4034C46.5993 16.0244 46.9383 14.5105 46.8751 13.0319L42.649 20.4261C43.9243 19.7825 45.025 18.7787 45.8111 17.4031V17.4034Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M39.2887 21.2855C39.8172 21.2611 40.3376 21.1908 40.8438 21.0747L46.5532 11.0853C46.4043 10.5773 46.2064 10.0835 45.9606 9.61182L39.2887 21.2852V21.2855Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M37.8782 21.2434L45.2044 8.42506C44.9404 8.08087 44.6469 7.75586 44.325 7.4538L36.572 21.0186C37.0066 21.1229 37.443 21.1981 37.8779 21.2434H37.8782Z", fill: "#0060F0" }), /* @__PURE__ */ React.createElement("path", { d: "M9.10858 12.0159L7.18025 11.3022C6.14148 10.9746 5.84506 10.4988 5.84506 9.99346C5.84506 9.45816 6.29012 8.92287 7.18025 8.92287C7.80294 8.92287 8.57427 9.19066 8.96052 10.38L12.5506 9.48779C12.0166 6.98964 9.90976 5.35413 7.00176 5.35413C4.09377 5.35413 1.39411 7.04889 1.39411 9.93363C1.39411 11.8669 2.492 13.5326 5.04388 14.4542L7.12085 15.2273C8.12979 15.555 8.42621 16.0307 8.42621 16.5364C8.42621 17.3987 7.65488 17.8152 6.82414 17.8152C5.37015 17.8152 4.83584 16.7746 4.59882 16.0307L0.949047 17.0124C1.42367 19.9567 3.7678 21.4139 6.88325 21.4139C10.325 21.4139 12.9658 19.6593 12.9658 16.5367C12.9658 13.7408 10.77 12.5808 9.10858 12.0159Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M22.8462 5.35352C20.1167 5.35352 18.5143 6.84061 18.2767 7.40553H18.1878V5.65093H13.5888V26.7677H18.1878V19.3621H18.2767C18.5141 19.9271 20.1164 21.4136 22.8462 21.4136C26.3473 21.4136 30.2046 18.7667 30.2046 13.3838C30.2046 8.00095 26.3473 5.35352 22.8462 5.35352ZM21.8967 17.3098C19.8791 17.3098 18.069 15.9119 18.069 13.3841C18.069 10.8564 19.8788 9.45814 21.8967 9.45814C23.9145 9.45814 25.6945 10.886 25.6945 13.3841C25.6945 15.8823 23.8548 17.3098 21.8967 17.3098Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M74.661 21.4139C77.4798 21.4139 79.6755 20.2538 80.9513 18.6479L78.8741 16.4765C77.7469 17.3392 76.5305 17.6665 75.1655 17.6665C73.1184 17.6665 71.5754 16.8338 70.9524 15.1681H81.9304C82.9095 8.08954 78.3108 5.35352 74.3941 5.35352C70.4775 5.35352 66.5313 8.179 66.5313 13.4135C66.5313 18.6479 70.3886 21.4139 74.661 21.4139ZM74.4535 9.21968C75.9962 9.21968 77.569 10.0826 77.8953 11.8668H70.8632C71.3674 10.0228 72.9103 9.21968 74.4535 9.21968Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M90.2797 21.4142C93.0095 21.4142 94.6116 19.9271 94.8492 19.3622H94.9381V21.1168H99.5372V0H94.9381V7.40557H94.8492C94.6119 6.84064 93.0095 5.35384 90.2797 5.35384C86.7786 5.35384 82.9217 8.00099 82.9217 13.3842C82.9217 18.7673 86.7789 21.4145 90.2797 21.4145V21.4142ZM91.2293 9.45788C93.2468 9.45788 95.0569 10.8558 95.0569 13.3839C95.0569 15.9119 93.2471 17.3099 91.2293 17.3099C89.2114 17.3099 87.4613 15.882 87.4613 13.3839C87.4613 10.8857 89.2711 9.45788 91.2293 9.45788Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M43.6206 24.2368H29.5567V28.2519H36.3216L28.6665 39.7026H42.968V35.6874H35.9655L43.6206 24.2368Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M50.4753 23.9396C46.4993 23.9396 42.6125 26.7651 42.6125 31.9996C42.6125 37.234 46.4697 40 50.7422 40C53.5609 40 55.7564 38.8402 57.0325 37.234L54.9552 35.0626C53.8281 35.9253 52.6117 36.2526 51.2466 36.2526C49.1995 36.2526 47.6566 35.4196 47.0336 33.7539H58.0116C58.9907 26.6754 54.392 23.9393 50.4753 23.9393V23.9396ZM46.9446 30.4529C47.4488 28.6089 48.9918 27.8058 50.535 27.8058C52.0783 27.8058 53.6505 28.6687 53.9767 30.4529H46.9446Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M68.0406 23.9394C65.3108 23.9394 63.7085 25.4265 63.4712 25.9914H63.3822V18.5858H63.3813V9.30918H66.6153V5.65098H63.3813V1.69507H58.7823V5.65098H56.4979H53.2677V1.69536H48.6687V5.65098H46.3839V9.30889H48.6687V21.2881H53.2677V9.30918H56.4979H58.7823V25.3434H58.7835V39.7026H63.3822V37.948H63.4712C63.7085 38.5129 65.3108 39.9994 68.0406 39.9994C71.5417 39.9994 75.399 37.3526 75.399 31.9697C75.399 26.5868 71.5417 23.9394 68.0406 23.9394ZM67.0911 35.8957C65.0735 35.8957 63.264 34.4977 63.264 31.97C63.264 29.4422 65.0738 28.044 67.0911 28.044C69.1084 28.044 70.8892 29.4718 70.8892 31.97C70.8892 34.4681 69.0495 35.8957 67.0911 35.8957Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M86.4964 24.0881C86.1107 23.9693 85.7549 23.9396 85.3985 23.9396C82.6096 23.9396 81.1261 25.9321 80.6216 28.4306V24.2368H76.0226V39.7026H80.6216V33.3377C80.6216 30.423 82.3723 28.3707 85.4284 28.3707C85.814 28.3707 86.1406 28.4003 86.4964 28.4602V24.0881Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M97.9496 24.2368V25.9914H97.8606C97.6233 25.4264 96.0213 23.9393 93.2912 23.9393C89.79 23.9393 85.9328 26.5865 85.9328 31.9697C85.9328 37.3528 89.79 39.9994 93.2912 39.9994C96.0213 39.9994 97.6233 38.5126 97.8606 37.948H97.9496V39.7026H102.548V24.2368H97.9496ZM94.2407 35.8954C92.2825 35.8954 90.4727 34.4675 90.4727 31.9697C90.4727 29.4718 92.2825 28.0437 94.2407 28.0437C96.1989 28.0437 98.0684 29.4416 98.0684 31.9697C98.0684 34.4977 96.2586 35.8954 94.2407 35.8954Z", fill: "black" }));
const SvgStandardSecurity = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.9989 13.62C14.6175 13.62 15.1189 13.1186 15.1189 12.5C15.1189 11.8814 14.6175 11.38 13.9989 11.38C13.3803 11.38 12.8789 11.8814 12.8789 12.5C12.8789 13.1186 13.3803 13.62 13.9989 13.62Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0017 14.5C13.2717 14.5 11.8117 14.86 11.7617 15.58C12.2617 16.29 13.0817 16.75 14.0017 16.75C14.9217 16.75 15.7417 16.29 16.2417 15.58C16.1917 14.86 14.7317 14.5 14.0017 14.5Z", fill: "#0974C1" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8.09V3.27L7.5 0L0 3.27V8.18C0 12.72 3.2 16.97 7.5 18C8.05 17.87 8.58 17.68 9.1 17.45C10.18 18.99 11.97 20 14 20C17.31 20 20 17.31 20 14C20 11.03 17.84 8.57 15 8.09ZM8 14C8 14.56 8.08 15.11 8.23 15.62C7.99 15.73 7.75 15.84 7.5 15.92C4.33 14.92 2 11.68 2 8.18V4.58L7.5 2.18L13 4.58V8.09C10.16 8.57 8 11.03 8 14ZM14 18C11.79 18 10 16.21 10 14C10 11.79 11.79 10 14 10C16.21 10 18 11.79 18 14C18 16.21 16.21 18 14 18Z", fill: "#0974C1" }));
const SvgSupervisorAccount = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 12, viewBox: "0 0 11 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7126_16688)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.11292 5.99298C4.98108 5.99298 5.68729 5.28677 5.68729 4.41861C5.68729 3.55046 4.98108 2.84424 4.11292 2.84424C3.24477 2.84424 2.53855 3.55046 2.53855 4.41861C2.53855 5.28677 3.24477 5.99298 4.11292 5.99298ZM4.11292 3.74388C4.48627 3.74388 4.78765 4.04526 4.78765 4.41861C4.78765 4.79196 4.48627 5.09334 4.11292 5.09334C3.73957 5.09334 3.43819 4.79196 3.43819 4.41861C3.43819 4.04526 3.73957 3.74388 4.11292 3.74388ZM4.13541 8.24209H2.21018C2.6555 8.01718 3.4247 7.79227 4.11292 7.79227C4.1624 7.79227 4.21638 7.79677 4.26586 7.79677C4.4188 7.4684 4.68419 7.1985 5.00357 6.98259C4.6752 6.92411 4.36482 6.89263 4.11292 6.89263C3.06034 6.89263 0.964176 7.41892 0.964176 8.467V9.14173H4.11292V8.467C4.11292 8.39053 4.12192 8.31406 4.13541 8.24209ZM7.48658 7.11754C6.65891 7.11754 5.01256 7.57185 5.01256 8.467V9.14173H9.96059V8.467C9.96059 7.57185 8.31425 7.11754 7.48658 7.11754ZM8.03086 6.29886C8.37272 6.10544 8.61113 5.74108 8.61113 5.31825C8.61113 4.6975 8.10733 4.1937 7.48658 4.1937C6.86583 4.1937 6.36203 4.6975 6.36203 5.31825C6.36203 5.74108 6.60043 6.10544 6.94229 6.29886C7.10423 6.38883 7.28866 6.4428 7.48658 6.4428C7.6845 6.4428 7.86893 6.38883 8.03086 6.29886Z", fill: "black" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7126_16688" }, /* @__PURE__ */ React.createElement("rect", { width: 10.7957, height: 10.7957, fill: "white", transform: "translate(0.064537 0.595215)" }))));
const SvgSwapArrows = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4485_9821)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.66 7.33398L2 10.0007L4.66 12.6673V10.6673H9.33333V9.33398H4.66V7.33398ZM14 6.00065L11.34 3.33398V5.33398H6.66667V6.66732H11.34V8.66732L14 6.00065Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4485_9821" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgTabSwitch = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM3.33333 12.6667H12.6667V5.33333H3.33333V12.6667Z", fill: "#0070BF" }));
const SvgTalentPool = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 12, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.666626 11.3333V9.46663C0.666626 9.08885 0.763848 8.74163 0.958293 8.42496C1.15274 8.10829 1.41107 7.86663 1.73329 7.69996C2.42218 7.35552 3.12218 7.09718 3.83329 6.92496C4.5444 6.75274 5.26663 6.66663 5.99996 6.66663C6.73329 6.66663 7.45552 6.75274 8.16663 6.92496C8.87774 7.09718 9.57774 7.35552 10.2666 7.69996C10.5888 7.86663 10.8472 8.10829 11.0416 8.42496C11.2361 8.74163 11.3333 9.08885 11.3333 9.46663V11.3333H0.666626ZM12.6666 11.3333V9.33329C12.6666 8.8444 12.5305 8.37496 12.2583 7.92496C11.9861 7.47496 11.6 7.08885 11.1 6.76663C11.6666 6.83329 12.2 6.94718 12.7 7.10829C13.2 7.2694 13.6666 7.46663 14.1 7.69996C14.5 7.92218 14.8055 8.1694 15.0166 8.44163C15.2277 8.71385 15.3333 9.01107 15.3333 9.33329V11.3333H12.6666ZM5.99996 5.99996C5.26663 5.99996 4.63885 5.73885 4.11663 5.21663C3.5944 4.6944 3.33329 4.06663 3.33329 3.33329C3.33329 2.59996 3.5944 1.97218 4.11663 1.44996C4.63885 0.927737 5.26663 0.666626 5.99996 0.666626C6.73329 0.666626 7.36107 0.927737 7.88329 1.44996C8.40552 1.97218 8.66663 2.59996 8.66663 3.33329C8.66663 4.06663 8.40552 4.6944 7.88329 5.21663C7.36107 5.73885 6.73329 5.99996 5.99996 5.99996ZM12.6666 3.33329C12.6666 4.06663 12.4055 4.6944 11.8833 5.21663C11.3611 5.73885 10.7333 5.99996 9.99996 5.99996C9.87774 5.99996 9.72218 5.98607 9.53329 5.95829C9.3444 5.93052 9.18885 5.89996 9.06663 5.86663C9.36663 5.51107 9.59718 5.11663 9.75829 4.68329C9.9194 4.24996 9.99996 3.79996 9.99996 3.33329C9.99996 2.86663 9.9194 2.41663 9.75829 1.98329C9.59718 1.54996 9.36663 1.15551 9.06663 0.799959C9.22218 0.744404 9.37774 0.708293 9.53329 0.691626C9.68885 0.674959 9.8444 0.666626 9.99996 0.666626C10.7333 0.666626 11.3611 0.927737 11.8833 1.44996C12.4055 1.97218 12.6666 2.59996 12.6666 3.33329ZM1.99996 9.99996H9.99996V9.46663C9.99996 9.3444 9.9694 9.23329 9.90829 9.13329C9.84718 9.03329 9.76663 8.95551 9.66663 8.89996C9.06663 8.59996 8.46107 8.37496 7.84996 8.22496C7.23885 8.07496 6.62218 7.99996 5.99996 7.99996C5.37774 7.99996 4.76107 8.07496 4.14996 8.22496C3.53885 8.37496 2.93329 8.59996 2.33329 8.89996C2.23329 8.95551 2.15274 9.03329 2.09163 9.13329C2.03051 9.23329 1.99996 9.3444 1.99996 9.46663V9.99996ZM5.99996 4.66663C6.36663 4.66663 6.68052 4.53607 6.94163 4.27496C7.20274 4.01385 7.33329 3.69996 7.33329 3.33329C7.33329 2.96663 7.20274 2.65274 6.94163 2.39163C6.68052 2.13051 6.36663 1.99996 5.99996 1.99996C5.63329 1.99996 5.3194 2.13051 5.05829 2.39163C4.79718 2.65274 4.66663 2.96663 4.66663 3.33329C4.66663 3.69996 4.79718 4.01385 5.05829 4.27496C5.3194 4.53607 5.63329 4.66663 5.99996 4.66663Z", fill: "#0974C1" }));
const SvgTextFields = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 16, viewBox: "0 -960 960 960", width: 16, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#00204D", d: "M280-160v-520H80v-120h520v120H400v520H280Zm360 0v-320H520v-120h360v120H760v320H640Z" }));
const SvgThumbDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2m4 0v12h4V3z" }));
const SvgThumbDownFeedback = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2451_849)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.0001 2H4.00008C3.44675 2 2.97341 2.33333 2.77341 2.81333L0.760081 7.51333C0.700081 7.66667 0.666748 7.82667 0.666748 8V9.33333C0.666748 10.0667 1.26675 10.6667 2.00008 10.6667H6.20675L5.57341 13.7133L5.55341 13.9267C5.55341 14.2 5.66675 14.4533 5.84675 14.6333L6.55341 15.3333L10.9467 10.94C11.1867 10.7 11.3334 10.3667 11.3334 10V3.33333C11.3334 2.6 10.7334 2 10.0001 2ZM10.0001 10L7.10675 12.8933L8.00008 9.33333H2.00008V8L4.00008 3.33333H10.0001V10ZM12.6667 2H15.3334V10H12.6667V2Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2451_849" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgThumbDownOutline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.00008 2H11.3334V10.6667L6.66675 15.3333L5.83342 14.5C5.75564 14.4222 5.69175 14.3167 5.64175 14.1833C5.59175 14.05 5.56675 13.9222 5.56675 13.8V13.5667L6.30008 10.6667H2.00008C1.64453 10.6667 1.33341 10.5333 1.06675 10.2667C0.800081 10 0.666748 9.68889 0.666748 9.33333V8C0.666748 7.92222 0.677859 7.83889 0.700081 7.75C0.722304 7.66111 0.744526 7.57778 0.766748 7.5L2.76675 2.8C2.86675 2.57778 3.03341 2.38889 3.26675 2.23333C3.50008 2.07778 3.74453 2 4.00008 2ZM10.0001 3.33333H4.00008L2.00008 8V9.33333H8.00008L7.10008 13L10.0001 10.1V3.33333ZM11.3334 10.6667V9.33333H13.3334V3.33333H11.3334V2H14.6667V10.6667H11.3334Z", fill: "#0974C1" }));
const SvgThumbUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z" }));
const SvgThumbUpFeedback = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2451_5264)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.00008 14.0003H12.0001C12.5534 14.0003 13.0267 13.667 13.2267 13.187L15.2401 8.48699C15.3001 8.33366 15.3334 8.17366 15.3334 8.00033V6.66699C15.3334 5.93366 14.7334 5.33366 14.0001 5.33366H9.79341L10.4267 2.28699L10.4467 2.07366C10.4467 1.80033 10.3334 1.54699 10.1534 1.36699L9.44675 0.666992L5.05341 5.06033C4.81341 5.30033 4.66675 5.63366 4.66675 6.00033V12.667C4.66675 13.4003 5.26675 14.0003 6.00008 14.0003ZM6.00008 6.00033L8.89341 3.10699L8.00008 6.66699H14.0001V8.00033L12.0001 12.667H6.00008V6.00033ZM0.666748 6.00033H3.33341V14.0003H0.666748V6.00033Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2451_5264" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgTrendingUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_438_70508)" }, /* @__PURE__ */ React.createElement("path", { d: "M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z", fill: "#0974C1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_438_70508" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgUnarchive = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM12 9.5L17.5 15H14V17H10V15H6.5L12 9.5ZM5.12 5L5.94 4H18L18.93 5H5.12Z", fill: "#006AFF" }));
const SvgUser = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9682_109717)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.49984 4.00002C9.23317 4.00002 9.83317 4.60002 9.83317 5.33335C9.83317 6.06669 9.23317 6.66669 8.49984 6.66669C7.7665 6.66669 7.1665 6.06669 7.1665 5.33335C7.1665 4.60002 7.7665 4.00002 8.49984 4.00002ZM8.49984 10.6667C10.2998 10.6667 12.3665 11.5267 12.4998 12H4.49984C4.65317 11.52 6.7065 10.6667 8.49984 10.6667ZM8.49984 2.66669C7.0265 2.66669 5.83317 3.86002 5.83317 5.33335C5.83317 6.80669 7.0265 8.00002 8.49984 8.00002C9.97317 8.00002 11.1665 6.80669 11.1665 5.33335C11.1665 3.86002 9.97317 2.66669 8.49984 2.66669ZM8.49984 9.33335C6.71984 9.33335 3.1665 10.2267 3.1665 12V13.3334H13.8332V12C13.8332 10.2267 10.2798 9.33335 8.49984 9.33335Z", fill: "#00204D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9682_109717" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }))));
const SvgVerdictCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "check", clipPath: "url(#clip0_0_157)" }, /* @__PURE__ */ React.createElement("g", { id: "Vector" }), /* @__PURE__ */ React.createElement("path", { id: "Vector_2", d: "M6 10.78L3.22 8L2.27333 8.94L6 12.6667L14 4.66667L13.06 3.72667L6 10.78Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_0_157" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgVerdictClear = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { id: "clear", clipPath: "url(#clip0_0_150)" }, /* @__PURE__ */ React.createElement("g", { id: "Vector" }), /* @__PURE__ */ React.createElement("path", { id: "Vector_2", d: "M12.6667 4.27333L11.7267 3.33333L8 7.06L4.27333 3.33333L3.33333 4.27333L7.06 8L3.33333 11.7267L4.27333 12.6667L8 8.94L11.7267 12.6667L12.6667 11.7267L8.94 8L12.6667 4.27333Z", fill: "#D71717" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_0_150" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgVerifiedUser = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11_1288)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM7.41 11.59L6 13L10 17L18 9L16.59 7.58L10 14.17L7.41 11.59Z", fill: "#323232" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11_1288" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const SvgVerifiedUserShield = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.25 25.9167L27.6667 16.5L25.2917 14.125L18.25 21.1667L14.75 17.6667L12.375 20.0417L18.25 25.9167ZM20 36.6667C16.1389 35.6945 12.9514 33.4792 10.4375 30.0209C7.92361 26.5625 6.66667 22.7222 6.66667 18.5V8.33336L20 3.33336L33.3333 8.33336V18.5C33.3333 22.7222 32.0764 26.5625 29.5625 30.0209C27.0486 33.4792 23.8611 35.6945 20 36.6667ZM20 33.1667C22.8889 32.25 25.2778 30.4167 27.1667 27.6667C29.0556 24.9167 30 21.8611 30 18.5V10.625L20 6.87503L10 10.625V18.5C10 21.8611 10.9444 24.9167 12.8333 27.6667C14.7222 30.4167 17.1111 32.25 20 33.1667Z", fill: "#62748C" }));
const SvgVideoLibrary = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_3521_18281", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 16 }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_3521_18281)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.66683 9.66671L12.3335 6.66671L7.66683 3.66671V9.66671ZM5.3335 12C4.96683 12 4.65294 11.8695 4.39183 11.6084C4.13072 11.3473 4.00016 11.0334 4.00016 10.6667V2.66671C4.00016 2.30004 4.13072 1.98615 4.39183 1.72504C4.65294 1.46393 4.96683 1.33337 5.3335 1.33337H13.3335C13.7002 1.33337 14.0141 1.46393 14.2752 1.72504C14.5363 1.98615 14.6668 2.30004 14.6668 2.66671V10.6667C14.6668 11.0334 14.5363 11.3473 14.2752 11.6084C14.0141 11.8695 13.7002 12 13.3335 12H5.3335ZM2.66683 14.6667C2.30016 14.6667 1.98627 14.5362 1.72516 14.275C1.46405 14.0139 1.3335 13.7 1.3335 13.3334V4.00004H2.66683V13.3334H12.0002V14.6667H2.66683Z", fill: "#1C1B1F" })));
const SvgVideocam = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6059_6081)" }, /* @__PURE__ */ React.createElement("path", { d: "M10 5.33333V10.6667H3.33333V5.33333H10ZM10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4Z", fill: "#006AFF" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6059_6081" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgWarningAmber = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7486_2522)" }, /* @__PURE__ */ React.createElement("path", { d: "M0.666748 14H15.3334L8.00008 1.33337L0.666748 14ZM8.66675 12H7.33341V10.6667H8.66675V12ZM8.66675 9.33337H7.33341V6.66671H8.66675V9.33337Z", fill: "#C4811D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7486_2522" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const SvgWarningOutline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.50033 3.99325L13.5203 12.6666H3.48033L8.50033 3.99325ZM8.50033 1.33325L1.16699 13.9999H15.8337L8.50033 1.33325ZM9.16699 10.6666H7.83366V11.9999H9.16699V10.6666ZM9.16699 6.66659H7.83366V9.33325H9.16699V6.66659Z", fill: "currentColor" }));
const SvgSubject = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_19555_46487)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.33341 11.3333H2.66675V12.6667H9.33341V11.3333ZM13.3334 5.99999H2.66675V7.33333H13.3334V5.99999ZM2.66675 9.99999H13.3334V8.66666H2.66675V9.99999ZM2.66675 3.33333V4.66666H13.3334V3.33333H2.66675Z", fill: "#C4811D" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_19555_46487" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const IconEmail = SvgEmail;
const IconPageOutlined = SvgPageOutlined;
const IconPlus = SvgPlus;
const IconTrash = SvgTrash;
const IconAdd = SvgAdd;
const IconAddUser = SvgAddUser;
const IconAiInterview = SvgAiInterview;
const IconAiSmall = SvgAiSmall;
const IconAiSparkle = SvgAiSparkle;
const IconAlert = SvgAlert;
const IconAllInbox = SvgAllInbox;
const IconAnalytics = SvgAnalytics;
const IconAnimatedImages = SvgAnimatedImages;
const IconApartment = SvgApartment;
const IconArchive = SvgArchive;
const IconArrowBack = SvgArrowBack;
const IconArrowBackwardGreen = SvgArrowBackwardGreen;
const IconArrowDownAccordion = SvgArrowDownAccordion;
const IconArrowForward = SvgArrowForward;
const IconArrowForwardGreen = SvgArrowForwardGreen;
const IconArrowMedium = SvgArrowMedium;
const IconArrowNorthEast = SvgArrowNorthEast;
const IconAssignment = SvgAssignment;
const IconAssignmentDark = SvgAssignmentDark;
const IconAttachFile = SvgAttachFile;
const IconBin = SvgBin;
const IconBinOutline = SvgBinOutline;
const IconBlock = SvgBlock;
const IconBlueInfo = SvgBlueInfo;
const IconBook = SvgBook;
const IconBookmark = SvgBookmark;
const IconBookmarkFlagEmpty = SvgBookmarkFlagEmpty;
const IconBookmarkFlagFull = SvgBookmarkFlagFull;
const IconBookmarkOutline = SvgBookmarkOutline;
const IconBox = SvgBox;
const IconBreadcrumbArrow = SvgBreadcrumbArrow;
const IconBriefcase = SvgBriefcase;
const IconBuild = SvgBuild;
const IconCalculate = SvgCalculate;
const IconCalendar = SvgCalendar;
const IconCalendarEvent = SvgCalendarEvent;
const IconCalendarToday = SvgCalendarToday;
const IconCallSplit = SvgCallSplit;
const IconCancel = SvgCancel;
const IconCancelFilled = SvgCancelFilled;
const IconChat = SvgChat;
const IconChatIcon = SvgChatIcon;
const IconCheck = SvgCheck;
const IconCheckCircleGreen = SvgCheckCircleGreen;
const IconCheckCircleGreenSmall = SvgCheckCircleGreenSmall;
const IconCheckCircleOutline = SvgCheckCircleOutline;
const IconChecked = SvgChecked;
const IconChevronDown = SvgChevronDown;
const IconChevronLeft = SvgChevronLeft;
const IconChevronRight = SvgChevronRight;
const IconClock = SvgClock;
const IconClose = SvgClose;
const IconCloseSmall = SvgCloseSmall;
const IconComputer = SvgComputer;
const IconConstruction = SvgConstruction;
const IconContentCopy = SvgContentCopy;
const IconCopy = SvgCopy;
const IconDei = SvgDei;
const IconDeleteOutline = SvgDeleteOutline;
const IconDoorOpen = SvgDoorOpen;
const IconDotsHorizontal = SvgDotsHorizontal;
const IconDotsVertical = SvgDotsVertical;
const IconDoubleThumbDown = SvgDoubleThumbDown;
const IconDoubleThumbUp = SvgDoubleThumbUp;
const IconDragHandle = SvgDragHandle;
const IconEditPencil = SvgEditPencil;
const IconEmptyBox = SvgEmptyBox;
const IconEmptyMagicPen = SvgEmptyMagicPen;
const IconEmptyPen = SvgEmptyPen;
const IconEnvelope = SvgEnvelope;
const IconError = SvgError;
const IconErrorBox = SvgErrorBox;
const IconErrorOutline = SvgErrorOutline;
const IconExit = SvgExit;
const IconExtension = SvgExtension;
const IconExternalLink = SvgExternalLink;
const IconEye = SvgEye;
const IconEyeFilled = SvgEyeFilled;
const IconFace = SvgFace;
const IconFactCheck = SvgFactCheck;
const IconFileDownload = SvgFileDownload;
const IconFileUpload = SvgFileUpload;
const IconFilter = SvgFilter;
const IconFilterAlt = SvgFilterAlt;
const IconFingerprint = SvgFingerprint;
const IconFlagFilled = SvgFlagFilled;
const IconFlagOutline = SvgFlagOutline;
const IconForum = SvgForum;
const IconFrameInspect = SvgFrameInspect;
const IconGear = SvgGear;
const IconGearFilled = SvgGearFilled;
const IconGlobe = SvgGlobe;
const IconGoogleCalendar = SvgGoogleCalendar;
const IconGppBadShield = SvgGppBadShield;
const IconGroupAvatar = SvgGroupAvatar;
const IconGroupIcon = SvgGroupIcon;
const IconGroup = SvgGroup;
const IconHelpOutline = SvgHelpOutline;
const IconHired = SvgHired;
const IconHiringProcessEmptyState = SvgHiringProcessEmptyState;
const IconIcAccessTime = SvgIcAccessTime;
const IconIcCheckBig = SvgIcCheckBig;
const IconIcCheckCircleOutline = SvgIcCheckCircleOutline;
const IconIcCloseGray = SvgIcCloseGray;
const IconIcEmpty = SvgIcEmpty;
const IconIcFileUpload = SvgIcFileUpload;
const IconIcTick = SvgIcTick;
const IconImage = SvgImage;
const IconInfo = SvgInfo;
const IconInfoV2 = SvgInfoV2;
const IconIntegrityFlag = SvgIntegrityFlag;
const IconInterview = SvgInterview;
const IconJob = SvgJob;
const IconLanguage = SvgLanguage;
const IconLightbulb = SvgLightbulb;
const IconLimitedAccess = SvgLimitedAccess;
const IconLink = SvgLink;
const IconLinkOff = SvgLinkOff;
const IconList = SvgList;
const IconLocalOffer = SvgLocalOffer;
const IconLocale = SvgLocale;
const IconLock = SvgLock;
const IconLockOutline = SvgLockOutline;
const IconLockUnlocked = SvgLockUnlocked;
const IconMagnifyingGlass = SvgMagnifyingGlass;
const IconMap = SvgMap;
const IconMeeting = SvgMeeting;
const IconMicrosoftOutlook = SvgMicrosoftOutlook;
const IconMinus = SvgMinus;
const IconMyLocation = SvgMyLocation;
const IconNextWeek = SvgNextWeek;
const IconNoSearchResults = SvgNoSearchResults;
const IconNoVideocam = SvgNoVideocam;
const IconOfferStage = SvgOfferStage;
const IconOffered = SvgOffered;
const IconOpenInFull = SvgOpenInFull;
const IconOpenInNew = SvgOpenInNew;
const IconPen = SvgPen;
const IconPending = SvgPending;
const IconPendingAction = SvgPendingAction;
const IconPendingSimple = SvgPendingSimple;
const IconPercentileBlue = SvgPercentileBlue;
const IconPercentileH1 = SvgPercentileH1;
const IconPercentileH2Medium = SvgPercentileH2Medium;
const IconPercentileH2Regular = SvgPercentileH2Regular;
const IconPercentileH3Medium = SvgPercentileH3Medium;
const IconPercentileH3Regular = SvgPercentileH3Regular;
const IconPercentileH4 = SvgPercentileH4;
const IconPercentileH4Blue = SvgPercentileH4Blue;
const IconPercentileH5 = SvgPercentileH5;
const IconPercentileP = SvgPercentileP;
const IconPercentilePSmall = SvgPercentilePSmall;
const IconPersonAdd = SvgPersonAdd;
const IconPersonSearch = SvgPersonSearch;
const IconPlay = SvgPlay;
const IconPlaylistAddCheck = SvgPlaylistAddCheck;
const IconPlaylistAddCheckBig = SvgPlaylistAddCheckBig;
const IconPsychology = SvgPsychology;
const IconPublish = SvgPublish;
const IconQuestionMark = SvgQuestionMark;
const IconRecordingInProgress = SvgRecordingInProgress;
const IconRecordingPause = SvgRecordingPause;
const IconRecordingResume = SvgRecordingResume;
const IconRecordingStart = SvgRecordingStart;
const IconRecordingStop = SvgRecordingStop;
const IconRemove = SvgRemove;
const IconRemoveCircle = SvgRemoveCircle;
const IconReplay = SvgReplay;
const IconReport = SvgReport;
const IconRspDecisions = SvgRspDecisions;
const IconRspProfile = SvgRspProfile;
const IconRspRole = SvgRspRole;
const IconSaveAlt = SvgSaveAlt;
const IconScoreChecked = SvgScoreChecked;
const IconSearchV2 = SvgSearchV2;
const IconSearchV3 = SvgSearchV3;
const IconSelfAssessment = SvgSelfAssessment;
const IconShare = SvgShare;
const IconSkillLock = SvgSkillLock;
const IconSkipped = SvgSkipped;
const IconSmallDownload = SvgSmallDownload;
const IconSms = SvgSms;
const IconSourceOutlined = SvgSourceOutlined;
const IconSplitscreen = SvgSplitscreen;
const IconSpot = SvgSpot;
const IconSpotBlueLogo = SvgSpotBlueLogo;
const IconSpottedZebraLogoLarge = SvgSpottedZebraLogoLarge;
const IconStandardSecurity = SvgStandardSecurity;
const IconSupervisorAccount = SvgSupervisorAccount;
const IconSwapArrows = SvgSwapArrows;
const IconTabSwitch = SvgTabSwitch;
const IconTalentPool = SvgTalentPool;
const IconTextFields = SvgTextFields;
const IconThumbDown = SvgThumbDown;
const IconThumbDownFeedback = SvgThumbDownFeedback;
const IconThumbDownOutline = SvgThumbDownOutline;
const IconThumbUp = SvgThumbUp;
const IconThumbUpFeedback = SvgThumbUpFeedback;
const IconTrendingUp = SvgTrendingUp;
const IconUnarchive = SvgUnarchive;
const IconUser = SvgUser;
const IconVerdictCheck = SvgVerdictCheck;
const IconVerdictClear = SvgVerdictClear;
const IconVerifiedUser = SvgVerifiedUser;
const IconVerifiedUserShield = SvgVerifiedUserShield;
const IconVideoLibrary = SvgVideoLibrary;
const IconVideocam = SvgVideocam;
const IconWarningAmber = SvgWarningAmber;
const IconWarningOutline = SvgWarningOutline;
const IconSubject = SvgSubject;
const iconsObj = {
  access_time: IconIcAccessTime,
  add: IconAdd,
  add_user: IconAddUser,
  ai: IconAiSparkle,
  ai_interview: IconAiInterview,
  ai_small: IconAiSmall,
  alert: IconAlert,
  all_inbox: IconAllInbox,
  analytics: IconAnalytics,
  animated_images: IconAnimatedImages,
  apartment: IconApartment,
  archive: IconArchive,
  arrow_back: IconArrowBack,
  arrow_backward_green: IconArrowBackwardGreen,
  arrow_down_accordion: IconArrowDownAccordion,
  arrow_forward_green: IconArrowForwardGreen,
  arrow_forward_white: IconArrowForward,
  arrow_medium: IconArrowMedium,
  arrow_north_east: IconArrowNorthEast,
  assignment: IconAssignment,
  assignment_dark: IconAssignmentDark,
  attach_file: IconAttachFile,
  bin: IconBin,
  bin_outline: IconBinOutline,
  block: IconBlock,
  blue_info: IconBlueInfo,
  book: IconBook,
  bookmark: IconBookmark,
  bookmark_flag_empty: IconBookmarkFlagEmpty,
  bookmark_flag_full: IconBookmarkFlagFull,
  bookmark_outline: IconBookmarkOutline,
  box: IconBox,
  breadcrumb_arrow: IconBreadcrumbArrow,
  briefcase: IconBriefcase,
  build: IconBuild,
  calculate: IconCalculate,
  calendar: IconCalendar,
  calendar_event: IconCalendarEvent,
  calendar_today: IconCalendarToday,
  call_split: IconCallSplit,
  cancel: IconCancel,
  cancel_filled: IconCancelFilled,
  chat: IconChat,
  chat_icon: IconChatIcon,
  check: IconCheck,
  check_circle_green: IconCheckCircleGreen,
  check_circle_green_small: IconCheckCircleGreenSmall,
  check_circle_outline: IconCheckCircleOutline,
  checked: IconChecked,
  chevron_down: IconChevronDown,
  chevron_left: IconChevronLeft,
  chevron_right: IconChevronRight,
  clock: IconClock,
  close: IconClose,
  close_small: IconCloseSmall,
  computer: IconComputer,
  construction: IconConstruction,
  content_copy: IconContentCopy,
  copy: IconCopy,
  dei: IconDei,
  delete_outline: IconDeleteOutline,
  door_open: IconDoorOpen,
  dots_horizontal: IconDotsHorizontal,
  dots_vertical: IconDotsVertical,
  double_thumb_down: IconDoubleThumbDown,
  double_thumb_up: IconDoubleThumbUp,
  download: IconFileDownload,
  drag_handle: IconDragHandle,
  edit_pencil: IconEditPencil,
  email: IconEmail,
  empty: IconIcEmpty,
  empty_box: IconEmptyBox,
  empty_magic_pen: IconEmptyMagicPen,
  empty_pen: IconEmptyPen,
  envelope: IconEnvelope,
  error: IconError,
  error_box: IconErrorBox,
  error_outline: IconErrorOutline,
  exit: IconExit,
  expand: IconOpenInFull,
  extension: IconExtension,
  external_link: IconExternalLink,
  eye: IconEye,
  eye_filled: IconEyeFilled,
  face: IconFace,
  fact_check: IconFactCheck,
  file_upload: IconFileUpload,
  filter: IconFilter,
  filter_alt: IconFilterAlt,
  fingerprint: IconFingerprint,
  flag_filled: IconFlagFilled,
  flag_outline: IconFlagOutline,
  forum: IconForum,
  frame_inspect: IconFrameInspect,
  gear: IconGear,
  gear_filled: IconGearFilled,
  globe: IconGlobe,
  google_calendar: IconGoogleCalendar,
  gpp_bad_shield: IconGppBadShield,
  group: IconGroup,
  group_avatar: IconGroupAvatar,
  group_icon: IconGroupIcon,
  help_outline: IconHelpOutline,
  hired: IconHired,
  hiring_process_empty: IconHiringProcessEmptyState,
  ic_check_big: IconIcCheckBig,
  ic_check_circle_outline: IconIcCheckCircleOutline,
  ic_close_gray: IconIcCloseGray,
  image: IconImage,
  info: IconInfo,
  info_v2: IconInfoV2,
  integrity_flag: IconIntegrityFlag,
  interview: IconInterview,
  job: IconJob,
  language: IconLanguage,
  light_bulb: IconLightbulb,
  limited_access: IconLimitedAccess,
  link: IconLink,
  link_off: IconLinkOff,
  list: IconList,
  local_offer: IconLocalOffer,
  locale: IconLocale,
  location: IconMyLocation,
  lock: IconLockOutline,
  lock_outline: IconLock,
  lock_unlocked: IconLockUnlocked,
  map: IconMap,
  meeting: IconMeeting,
  microsoft_outlook: IconMicrosoftOutlook,
  minus: IconMinus,
  next_week: IconNextWeek,
  no_search_results: IconNoSearchResults,
  no_videocam: IconNoVideocam,
  offer_stage: IconOfferStage,
  offered: IconOffered,
  page_outlined: IconPageOutlined,
  pen: IconPen,
  pending: IconPending,
  pending_action: IconPendingAction,
  pending_simple: IconPendingSimple,
  percentile_blue: IconPercentileBlue,
  percentile_h1: IconPercentileH1,
  percentile_h2_medium: IconPercentileH2Medium,
  percentile_h2_regular: IconPercentileH2Regular,
  percentile_h3: IconPercentileH3Medium,
  percentile_h3_regular: IconPercentileH3Regular,
  percentile_h4: IconPercentileH4,
  percentile_h4_blue: IconPercentileH4Blue,
  percentile_h5: IconPercentileH5,
  percentile_p: IconPercentileP,
  percentile_p_small: IconPercentilePSmall,
  person_add: IconPersonAdd,
  person_search: IconPersonSearch,
  play: IconPlay,
  playlist_add_check: IconPlaylistAddCheck,
  playlist_add_check_big: IconPlaylistAddCheckBig,
  plus: IconPlus,
  psychology: IconPsychology,
  publish: IconPublish,
  question_mark: IconQuestionMark,
  recording_in_progress: IconRecordingInProgress,
  recording_pause: IconRecordingPause,
  recording_resume: IconRecordingResume,
  recording_start: IconRecordingStart,
  recording_stop: IconRecordingStop,
  redirection: IconOpenInNew,
  remove: IconRemove,
  remove_circle: IconRemoveCircle,
  replay: IconReplay,
  report: IconReport,
  rsp_decisions: IconRspDecisions,
  rsp_profile: IconRspProfile,
  rsp_role: IconRspRole,
  save_alt: IconSaveAlt,
  scores_checked: IconScoreChecked,
  search: IconMagnifyingGlass,
  search_v2: IconSearchV2,
  search_v3: IconSearchV3,
  self_assessment: IconSelfAssessment,
  share: IconShare,
  skill_lock: IconSkillLock,
  skipped: IconSkipped,
  small_download: IconSmallDownload,
  sms: IconSms,
  source_outlined: IconSourceOutlined,
  splitscreen: IconSplitscreen,
  spot: IconSpot,
  spot_blue: IconSpotBlueLogo,
  spotted_zebra_logo_large: IconSpottedZebraLogoLarge,
  standard_security: IconStandardSecurity,
  subject: IconSubject,
  supervisor_account: IconSupervisorAccount,
  swap_arrows: IconSwapArrows,
  tab_switch: IconTabSwitch,
  talent_pool: IconTalentPool,
  text_fields: IconTextFields,
  thumb_down: IconThumbDown,
  thumb_down_feedback: IconThumbDownFeedback,
  thumb_down_outline: IconThumbDownOutline,
  thumb_up: IconThumbUp,
  thumb_up_feedback: IconThumbUpFeedback,
  tick: IconIcTick,
  trash: IconTrash,
  trending_up: IconTrendingUp,
  unarchive: IconUnarchive,
  upload: IconIcFileUpload,
  user: IconUser,
  verdict_check: IconVerdictCheck,
  verdict_clear: IconVerdictClear,
  verified_user: IconVerifiedUser,
  verified_user_shield: IconVerifiedUserShield,
  video_cam: IconVideocam,
  video_library: IconVideoLibrary,
  warning_amber: IconWarningAmber,
  warning_outline: IconWarningOutline
};
const Icon$2 = ({ icon: icon2, ...rest }) => {
  const Component2 = iconsObj[icon2];
  return Component2 ? /* @__PURE__ */ jsx$1(Component2, { "data-testid": `${icon2}-icon`, ...rest }) : null;
};
const FileUploadStateIcon = ({
  icon: icon2,
  width,
  height,
  colorClassName
}) => /* @__PURE__ */ jsx$1(
  "span",
  {
    className: clsx(styles$F["icon"], colorClassName),
    style: { width, height },
    children: /* @__PURE__ */ jsx$1(Icon$2, { icon: icon2, width, height })
  }
);
const FileUploadFileRow = ({
  variant,
  fileName,
  cancelUploadAriaLabel,
  removeFileAriaLabel,
  dataTestId,
  onCancelUpload,
  onRemoveFile
}) => {
  const lead = variant === "uploading" ? /* @__PURE__ */ jsx$1("span", { className: styles$F["icon"], style: { width: 20, height: 20 }, children: /* @__PURE__ */ jsx$1(Loader, { variant: "spinner", size: "small", color: "interactive" }) }) : /* @__PURE__ */ jsx$1(
    FileUploadStateIcon,
    {
      icon: "check_circle_outline",
      width: 20,
      height: 20,
      colorClassName: styles$F["icon-green"]
    }
  );
  const trailing = variant === "uploading" ? /* @__PURE__ */ jsx$1(
    "button",
    {
      type: "button",
      className: styles$F["icon-button"],
      "aria-label": cancelUploadAriaLabel,
      "data-testid": `${dataTestId}__cancel-upload-button`,
      onClick: onCancelUpload,
      children: /* @__PURE__ */ jsx$1(FileUploadStateIcon, { icon: "close", width: 14, height: 14 })
    }
  ) : /* @__PURE__ */ jsx$1(
    "button",
    {
      type: "button",
      className: clsx(styles$F["icon-button"], styles$F["icon-button-red"]),
      "aria-label": removeFileAriaLabel,
      "data-testid": `${dataTestId}__remove-file-button`,
      onClick: onRemoveFile,
      children: /* @__PURE__ */ jsx$1(FileUploadStateIcon, { icon: "delete_outline", width: 20, height: 20 })
    }
  );
  return /* @__PURE__ */ jsxs("div", { className: styles$F["row"], children: [
    lead,
    /* @__PURE__ */ jsx$1(FileUploadFileName, { fileName, remeasureKey: variant }),
    trailing
  ] });
};
const FileUploadChooseFileButton = ({
  label: label2,
  dataTestId,
  onClick
}) => /* @__PURE__ */ jsx$1(
  Button$1,
  {
    variant: "primary",
    size: "medium",
    onClick,
    "data-testid": dataTestId,
    children: label2
  }
);
const FileUploadZoneContent = ({
  phase,
  isDragActive,
  labels,
  description: description2,
  errorTypeDescription,
  errorSizeDescription,
  errorUploadDescription,
  title: title2,
  dataTestId,
  onChooseFile,
  onBrowseFile
}) => {
  const chooseFileButton = /* @__PURE__ */ jsx$1(
    FileUploadChooseFileButton,
    {
      label: labels.chooseFileButton,
      dataTestId: `${dataTestId}__choose-file-button`,
      onClick: onChooseFile
    }
  );
  if (isDragActive) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx$1(FileUploadStateIcon, { icon: "box", width: 50, height: 30 }),
      /* @__PURE__ */ jsx$1("p", { className: styles$F["heading"], children: labels.dragOverTitle })
    ] });
  }
  if (phase === "invalid-type" || phase === "invalid-size") {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx$1(FileUploadStateIcon, { icon: "error_box", width: 50, height: 30 }),
      /* @__PURE__ */ jsxs("div", { className: styles$F["group"], children: [
        /* @__PURE__ */ jsx$1("p", { className: clsx(styles$F["heading"], styles$F["heading-error"]), children: phase === "invalid-type" ? labels.errorTypeTitle : labels.errorSizeTitle }),
        /* @__PURE__ */ jsx$1("p", { className: clsx(styles$F["description"], styles$F["description-error"]), children: phase === "invalid-type" ? errorTypeDescription : errorSizeDescription })
      ] }),
      /* @__PURE__ */ jsx$1("div", { children: chooseFileButton })
    ] });
  }
  if (phase === "failed") {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx$1(
        FileUploadStateIcon,
        {
          icon: "file_upload",
          width: 24,
          height: 24,
          colorClassName: styles$F["icon-red"]
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: styles$F["group"], children: [
        /* @__PURE__ */ jsx$1("p", { className: clsx(styles$F["heading"], styles$F["heading-error"]), children: labels.errorUploadTitle }),
        /* @__PURE__ */ jsx$1("p", { className: clsx(styles$F["description"], styles$F["description-error"]), children: errorUploadDescription ?? errorTypeDescription })
      ] }),
      /* @__PURE__ */ jsx$1("div", { children: chooseFileButton })
    ] });
  }
  let heading2 = title2;
  if (heading2 === void 0 || heading2 === null) {
    const [before, ...rest] = labels.title.split("{browse}");
    heading2 = /* @__PURE__ */ jsxs("p", { className: styles$F["heading"], children: [
      before,
      rest.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(
          "button",
          {
            type: "button",
            className: styles$F["browse"],
            onClick: onBrowseFile,
            children: labels.browseLink
          }
        ),
        rest.join("{browse}")
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      FileUploadStateIcon,
      {
        icon: "file_upload",
        width: 24,
        height: 24,
        colorClassName: styles$F["icon-interactive"]
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: styles$F["group"], children: [
      heading2,
      /* @__PURE__ */ jsx$1("p", { className: styles$F["description"], children: description2 })
    ] }),
    /* @__PURE__ */ jsx$1("div", { children: chooseFileButton })
  ] });
};
const DEFAULT_MAX_SIZE$1 = 1024 * 1024 * 1024;
const DEFAULT_ACCEPT_FILE_TYPES$1 = {
  "audio/mp4": [".mp4"],
  "audio/x-m4a": [".m4a"],
  "audio/ogg": [".ogg"],
  "audio/wav": [".wav"]
};
const DEFAULT_LABELS$1 = {
  title: "Drag and drop or {browse} to add a file",
  browseLink: "browse",
  dragOverTitle: "Upload to Spotted Zebra",
  errorTypeTitle: "Unsupported file type",
  errorSizeTitle: "This file is above the size limit",
  errorUploadTitle: "Upload failed. Please try again.",
  chooseFileButton: "Choose file",
  cancelUploadAriaLabel: "Cancel file upload",
  removeFileAriaLabel: "Remove file"
};
const isDragDropEvent = (event) => "type" in event && event.type === "drop";
const takeFirstFile = async (event) => (await fromEvent(event)).slice(0, 1);
const rejectionPhase = (rejections) => {
  const errors = rejections[0]?.errors ?? [];
  if (errors.some((error2) => error2.code === ErrorCode.FileInvalidType)) {
    return "invalid-type";
  }
  if (errors.some((error2) => error2.code === ErrorCode.FileTooLarge)) {
    return "invalid-size";
  }
  return null;
};
const FileUpload = ({
  description: description2,
  errorTypeDescription,
  errorSizeDescription,
  onFileSelected,
  onCancelUpload,
  onRemoveFile,
  title: title2,
  maxSize = DEFAULT_MAX_SIZE$1,
  acceptFileTypes = DEFAULT_ACCEPT_FILE_TYPES$1,
  uploaded,
  hasFailedUploadError,
  errorUploadDescription,
  labels,
  fullWidth: fullWidth2,
  onChooseFile,
  onBrowseFile,
  onDrop: onDropProp,
  className,
  dataTestId
}) => {
  const allLabels = { ...DEFAULT_LABELS$1, ...labels };
  const testId = dataTestId || "file-upload";
  const [phase, setPhase] = useState("idle");
  const [fileName, setFileName] = useState(null);
  const clearError = () => {
    setPhase(
      (current) => current === "invalid-type" || current === "invalid-size" || current === "failed" ? "idle" : current
    );
  };
  const { getRootProps, getInputProps, isDragActive, open: open2 } = useDropzone({
    accept: acceptFileTypes,
    maxSize,
    multiple: false,
    // Body clicks are inert by design — only browse, Choose file and the
    // keyboard open the picker (react-dropzone handles Enter/Space itself).
    noClick: true,
    useFsAccessApi: false,
    getFilesFromEvent: takeFirstFile,
    // Entering drag-over dismisses any displayed error; react-dropzone only
    // fires this for drags that actually carry files.
    onDragEnter: clearError,
    onDrop: (_accepted, _rejections, event) => {
      if (isDragDropEvent(event)) {
        onDropProp?.();
      }
    },
    onDropAccepted: (files) => {
      const file = files[0];
      setFileName(file.name);
      setPhase("uploading");
      onFileSelected(file);
    },
    onDropRejected: (rejections) => {
      setFileName(null);
      const nextPhase = rejectionPhase(rejections);
      if (nextPhase) {
        setPhase(nextPhase);
      }
    }
  });
  useEffect(() => {
    if (hasFailedUploadError) {
      setFileName(null);
      setPhase("failed");
    }
  }, [hasFailedUploadError]);
  useEffect(() => {
    if (uploaded) {
      setPhase((current) => current === "uploading" ? "uploaded" : current);
    }
  }, [uploaded]);
  const handleZoneKeyDown = (event) => {
    if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
      onChooseFile?.();
    }
  };
  const hiddenInput = /* @__PURE__ */ jsx$1("input", { ...getInputProps({ "aria-hidden": "true", tabIndex: -1 }) });
  if (phase === "uploading" || phase === "uploaded") {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...getRootProps({
          className: clsx(
            styles$F["container"],
            styles$F["fit"],
            fullWidth2 && styles$F["full"],
            className
          ),
          "data-testid": testId,
          tabIndex: -1
        }),
        children: [
          hiddenInput,
          /* @__PURE__ */ jsx$1(
            FileUploadFileRow,
            {
              variant: phase,
              fileName,
              cancelUploadAriaLabel: allLabels.cancelUploadAriaLabel,
              removeFileAriaLabel: allLabels.removeFileAriaLabel,
              dataTestId: testId,
              onCancelUpload: () => {
                setFileName(null);
                setPhase("idle");
                onCancelUpload();
              },
              onRemoveFile: () => {
                setFileName(null);
                setPhase("idle");
                onRemoveFile();
              }
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...getRootProps({
        className: clsx(
          styles$F["container"],
          isDragActive && styles$F["drag"],
          (phase === "invalid-type" || phase === "invalid-size") && !isDragActive && styles$F["invalid"],
          phase === "failed" && !isDragActive && [styles$F["failed"], styles$F["fit"]],
          fullWidth2 && styles$F["full"],
          className
        ),
        role: "button",
        "aria-label": allLabels.title.replace("{browse}", allLabels.browseLink),
        "data-testid": dataTestId,
        onKeyDown: handleZoneKeyDown
      }),
      children: [
        hiddenInput,
        /* @__PURE__ */ jsx$1("div", { className: styles$F["prompt"], children: /* @__PURE__ */ jsx$1(
          FileUploadZoneContent,
          {
            phase,
            isDragActive,
            labels: allLabels,
            description: description2,
            errorTypeDescription,
            errorSizeDescription,
            errorUploadDescription,
            title: title2,
            dataTestId: testId,
            onChooseFile: () => {
              onChooseFile?.();
              open2();
            },
            onBrowseFile: () => {
              onBrowseFile?.();
              open2();
            }
          }
        ) })
      ]
    }
  );
};
const CloseIcon$3 = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_11_9743)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
            fill: "#323232"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_11_9743", children: /* @__PURE__ */ jsx$1("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  );
};
const DisabledFileUploadIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_1_3536)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M6.00065 10.6667H10.0007V6.66667H12.6673L8.00065 2L3.33398 6.66667H6.00065V10.6667ZM3.33398 12H12.6673V13.3333H3.33398V12Z",
            fill: "#ADBFD9"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_1_3536", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
};
const styles$E = {
  "sz-file-upload-input": "file-upload-module_sz-file-upload-input__x7Dsd",
  "sz-file-upload-input_wrapper--focused": "file-upload-module_sz-file-upload-input_wrapper--focused__cKIbR",
  "sz-file-upload-input--disabled": "file-upload-module_sz-file-upload-input--disabled__K3aiq",
  "sz-file-upload-input__value": "file-upload-module_sz-file-upload-input__value__B-3qL",
  "sz-file-upload-input__label": "file-upload-module_sz-file-upload-input__label__qhh-1",
  "sz-file-upload-input__label--disabled": "file-upload-module_sz-file-upload-input__label--disabled__gsuZj",
  "sz-file-upload-input__icon": "file-upload-module_sz-file-upload-input__icon__W7S-k",
  "sz-file-upload-input__icon-wrapper": "file-upload-module_sz-file-upload-input__icon-wrapper__1MAri",
  "sz-file-upload-input__icon-container": "file-upload-module_sz-file-upload-input__icon-container__zTcWf",
  "sz-file-upload-input--error": "file-upload-module_sz-file-upload-input--error__MAayp"
};
const FileUploadIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#lrzh919rsa)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M6 10.667h4v-4h2.667L8 2 3.333 6.667H6v4zM3.333 12h9.334v1.333H3.333V12z",
            fill: "#000"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "lrzh919rsa", children: /* @__PURE__ */ jsx$1("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
      ]
    }
  );
};
const FileUploadInput = ({
  disabled: disabled2,
  className,
  id,
  onChange: onChange2,
  onBlur,
  name: name2,
  value: value2,
  ariaLabel,
  hasError,
  placeholder: placeholder2,
  onFocus: onFocus2,
  acceptedFileTypes
}) => {
  const [focused, setFocused] = useState(false);
  const ref2 = useRef(false);
  const inputRef = useRef(null);
  const handleChange = (event) => {
    if (!disabled2) {
      event.stopPropagation();
      onChange2(event.target?.files?.[0] || null, id);
    }
  };
  const handleClick = (event) => {
    if (disabled2) {
      event.preventDefault();
    }
  };
  const handleRemove = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    onChange2(null, id);
  };
  const handleFocus = (e3) => {
    if (!ref2.current) {
      setFocused(true);
    }
    onFocus2?.(e3.target?.files?.[0] || null, id);
  };
  const handleBlur = (e3) => {
    setFocused(false);
    onBlur?.(e3.target?.files?.[0] || null, id);
  };
  const handleMouseUp = (e3) => {
    ref2.current = false;
  };
  const handleMouseDown = (e3) => {
    ref2.current = true;
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      "data-testid": "sz-file-upload-input-wrapper",
      "aria-describedby": id,
      className: clsx(
        styles$E["sz-file-upload-input_wrapper"],
        focused && styles$E["sz-file-upload-input_wrapper--focused"]
      ),
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: clsx(
            styles$E["sz-file-upload-input"],
            disabled2 && styles$E["sz-file-upload-input--disabled"],
            hasError && !value2?.name && styles$E["sz-file-upload-input--error"],
            focused && styles$E["sz-file-upload-input--focused"],
            className
          ),
          children: [
            /* @__PURE__ */ jsx$1(
              "input",
              {
                id,
                name: name2,
                type: "file",
                onChange: handleChange,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onMouseUp: handleMouseUp,
                onMouseDown: handleMouseDown,
                onClick: handleClick,
                "aria-disabled": disabled2,
                "data-testid": "file-upload-input",
                "aria-label": ariaLabel,
                "aria-invalid": hasError,
                "aria-describedby": `file-upload-input-label-${id}`,
                "aria-errormessage": `file-upload-input-error-message-${id}`,
                ref: inputRef,
                accept: (acceptedFileTypes ?? []).join(",")
              }
            ),
            /* @__PURE__ */ jsxs(
              "label",
              {
                htmlFor: id,
                onClick: (e3) => {
                  e3.preventDefault();
                  e3.stopPropagation();
                  inputRef.current?.click();
                },
                className: clsx(
                  styles$E["sz-file-upload-input__label"],
                  disabled2 && styles$E["sz-file-upload-input__label--disabled"]
                ),
                children: [
                  /* @__PURE__ */ jsx$1("div", { className: styles$E["sz-file-upload-input__value"], children: value2?.name || placeholder2 }),
                  /* @__PURE__ */ jsx$1("div", { className: styles$E["sz-file-upload-input__icon-wrapper"], children: disabled2 ? /* @__PURE__ */ jsx$1(
                    DisabledFileUploadIcon,
                    {
                      className: styles$E["sz-file-upload-input__icon"]
                    }
                  ) : /* @__PURE__ */ jsx$1(
                    FileUploadIcon,
                    {
                      className: styles$E["sz-file-upload-input__icon"]
                    }
                  ) }),
                  !disabled2 && value2?.name && /* @__PURE__ */ jsx$1(
                    "button",
                    {
                      onClick: handleRemove,
                      className: styles$E["sz-file-upload-input__icon-container"],
                      "aria-controls": id,
                      "aria-label": "remove file",
                      "data-testid": "remove-file-button",
                      children: /* @__PURE__ */ jsx$1(CloseIcon$3, { className: styles$E["sz-file-upload-input__icon"] })
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
};
const title$6 = "informational-content-module_title__vFJVd";
const container$7 = "informational-content-module_container__-3MmS";
const vertical = "informational-content-module_vertical__nMkOC";
const horizontal$1 = "informational-content-module_horizontal__zhubu";
const card = "informational-content-module_card__6GRnC";
const cardIcon = "informational-content-module_cardIcon__oH96c";
const cardRightContent = "informational-content-module_cardRightContent__ik5WO";
const cardTitle = "informational-content-module_cardTitle__LVCSA";
const cardSubTitle = "informational-content-module_cardSubTitle__iyDEX";
const styles$D = {
  title: title$6,
  container: container$7,
  vertical,
  horizontal: horizontal$1,
  card,
  cardIcon,
  cardRightContent,
  cardTitle,
  cardSubTitle
};
const InformationalContent = ({
  id,
  testId,
  title: title2,
  items: items2,
  className,
  classNameTitle,
  classNameContent,
  orientation = "horizontal"
}) => {
  function handleKeyDown(event) {
    const activeItem = document.activeElement;
    if (event.code === "ArrowDown") {
      if (activeItem.nextElementSibling) {
        activeItem?.nextElementSibling?.focus();
      }
    }
    if (event.code === "ArrowUp") {
      if (activeItem.previousElementSibling) {
        activeItem?.previousElementSibling?.focus();
      }
    }
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    title2 && /* @__PURE__ */ jsx$1("div", { className: styles$D.title, children: title2 }),
    /* @__PURE__ */ jsx$1(
      "div",
      {
        id,
        className: clsx(
          styles$D.container,
          className,
          orientation === "vertical" ? styles$D.vertical : styles$D.horizontal
        ),
        "data-testid": testId,
        onKeyDown: handleKeyDown,
        children: items2.map((card2) => /* @__PURE__ */ jsx$1(
          InfoCard,
          {
            card: card2,
            classNameTitle,
            classNameContent
          },
          card2.id
        ))
      }
    )
  ] });
};
const InfoCard = ({
  card: card2,
  classNameTitle,
  classNameContent
}) => {
  const titleText = getTextFromReactNode(card2.title);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$D.card,
      "aria-label": `${titleText}. ${card2.content}`,
      tabIndex: 0,
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$D.cardIcon, children: card2.icon }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              styles$D.cardRightContent,
              !card2.title && styles$D.noTitleContaine
            ),
            children: [
              /* @__PURE__ */ jsx$1("div", { className: clsx(styles$D.cardTitle, classNameTitle), children: card2.title }),
              /* @__PURE__ */ jsx$1("div", { className: clsx(styles$D.cardSubTitle, classNameContent), children: card2.content })
            ]
          }
        )
      ]
    }
  );
};
function getTextFromReactNode(node2) {
  if (typeof node2 === "string") {
    return node2;
  }
  if (React__default.isValidElement(node2)) {
    return React__default.Children.toArray(node2.props.children).map(getTextFromReactNode).join("");
  }
  return "";
}
const ErrorIcon$3 = () => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      "data-testid": "ErrorIcon",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17ZM13 7H11V14H13V7Z",
          fill: "#D71717"
        }
      )
    }
  );
};
const InformationIcon$1 = () => {
  return /* @__PURE__ */ jsx$1("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM12 15H8V13H9V11H8V9H9H11V13H12V15ZM11 7H9V5H11V7Z", fill: "#006FBF" }) });
};
const NEUTRAL = "inline-notification-module_NEUTRAL__nxBUK";
const INFORMATION = "inline-notification-module_INFORMATION__i46Ar";
const SUCCESS = "inline-notification-module_SUCCESS__OdX4i";
const WARNING = "inline-notification-module_WARNING__68rZa";
const ERROR = "inline-notification-module_ERROR__LUH4g";
const body$1 = "inline-notification-module_body__dF12F";
const actions$2 = "inline-notification-module_actions__J38bU";
const title$5 = "inline-notification-module_title__-EY-G";
const styles$C = {
  "sz-inline-notification": "inline-notification-module_sz-inline-notification__L-6qt",
  NEUTRAL,
  INFORMATION,
  SUCCESS,
  WARNING,
  ERROR,
  "content-container": "inline-notification-module_content-container__uq68z",
  "text-container": "inline-notification-module_text-container__mR0zL",
  body: body$1,
  "icon-container": "inline-notification-module_icon-container__pd1dR",
  actions: actions$2,
  "dismiss-button": "inline-notification-module_dismiss-button__E9ExB",
  title: title$5
};
const SuccessIcon$1 = () => {
  return /* @__PURE__ */ jsx$1("svg", { "data-testid": "SuccessIcon", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z", fill: "#007A6A" }) });
};
const WarningIcon$2 = () => {
  return /* @__PURE__ */ jsxs("svg", { "data-testid": "WarningIcon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_159_8413)", children: /* @__PURE__ */ jsx$1("path", { d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z", fill: "#C4811D" }) }),
    /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_159_8413", children: /* @__PURE__ */ jsx$1("rect", { width: "24", height: "24", fill: "white" }) }) })
  ] });
};
const CloseIcon$2 = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2184_8127)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2184_8127", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "white"
          }
        ) }) })
      ]
    }
  );
};
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["NEUTRAL"] = "NEUTRAL";
  NotificationType2["INFORMATION"] = "INFORMATION";
  NotificationType2["SUCCESS"] = "SUCCESS";
  NotificationType2["WARNING"] = "WARNING";
  NotificationType2["ERROR"] = "ERROR";
  return NotificationType2;
})(NotificationType || {});
const InlineNotification = ({
  children,
  title: title2,
  notificationType = "INFORMATION",
  className,
  classNameTitle,
  dataTestId,
  id,
  dismissible,
  onDismiss,
  dismissButtonDisabled,
  dismissButtonAriaLabel = "Dismiss notification",
  action
}) => {
  const getIcon = useCallback(() => {
    switch (notificationType) {
      case "NEUTRAL":
      case "INFORMATION":
        return /* @__PURE__ */ jsx$1(InformationIcon$1, {});
      case "SUCCESS":
        return /* @__PURE__ */ jsx$1(SuccessIcon$1, {});
      case "WARNING":
        return /* @__PURE__ */ jsx$1(WarningIcon$2, {});
      case "ERROR":
        return /* @__PURE__ */ jsx$1(ErrorIcon$3, {});
    }
  }, [notificationType]);
  const getAriaLive = useCallback(() => {
    switch (notificationType) {
      case "WARNING":
        return "polite";
      case "ERROR":
        return "assertive";
      default:
        return "off";
    }
  }, [notificationType]);
  const handleDismiss = () => {
    if (onDismiss && !dismissButtonDisabled) {
      onDismiss();
    }
  };
  const dataTestIdSuffix = dataTestId ? `-${dataTestId}` : "";
  return /* @__PURE__ */ jsxs(
    "section",
    {
      "aria-live": getAriaLive(),
      className: clsx(
        styles$C["sz-inline-notification"],
        styles$C[notificationType],
        className
      ),
      "data-testid": dataTestId || "inline-notification",
      id,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$C["content-container"], children: [
          /* @__PURE__ */ jsx$1("div", { className: styles$C["icon-container"], children: getIcon() }),
          /* @__PURE__ */ jsxs("div", { className: styles$C["text-container"], children: [
            title2 && /* @__PURE__ */ jsx$1(
              "span",
              {
                className: clsx(styles$C["title"], classNameTitle),
                "data-testid": `inline-notification--title${dataTestIdSuffix}`,
                children: title2
              }
            ),
            /* @__PURE__ */ jsx$1(
              "div",
              {
                className: clsx(styles$C["body"], !title2 && styles$C["no-title"]),
                "data-testid": `inline-notification--body${dataTestIdSuffix}`,
                children
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles$C.actions, children: [
          action && action,
          dismissible && /* @__PURE__ */ jsx$1(
            Button$1,
            {
              onClick: handleDismiss,
              "data-testid": `inline-notification--dismiss${dataTestIdSuffix}`,
              "aria-label": dismissButtonAriaLabel,
              disabled: dismissButtonDisabled,
              size: "small",
              leftIcon: /* @__PURE__ */ jsx$1(CloseIcon$2, {}),
              variant: "text",
              className: styles$C["dismiss-button"]
            }
          )
        ] })
      ]
    }
  );
};
const Icon$1 = () => {
  return /* @__PURE__ */ jsx$1("svg", { width: "14", height: "14", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M13.8333 13.8333H2.16667V2.16667H8V0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V8H13.8333V13.8333ZM9.66667 0.5V2.16667H12.6583L4.46667 10.3583L5.64167 11.5333L13.8333 3.34167V6.33333H15.5V0.5H9.66667Z", fill: "#006AFF" }) });
};
const container$6 = "link-module_container__KRlBS";
const disabledLink$2 = "link-module_disabledLink__jmzh5";
const styles$B = {
  container: container$6,
  disabledLink: disabledLink$2
};
function Link$1({
  children,
  to,
  target,
  disabled: disabled2 = false,
  ariaLabel,
  className,
  onClick,
  ...rest
}) {
  const url = disabled2 ? void 0 : to;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      href: url,
      "aria-label": ariaLabel,
      className: clsx(
        styles$B.container,
        disabled2 && styles$B.disabledLink,
        className
      ),
      target,
      onClick,
      ...rest,
      children: [
        children,
        target && /* @__PURE__ */ jsx$1(Icon$1, {})
      ]
    }
  );
}
var lib$1 = { exports: {} };
var Modal$1 = {};
var ModalPortal = { exports: {} };
var focusManager = {};
var tabbable$1 = { exports: {} };
var hasRequiredTabbable;
function requireTabbable() {
  if (hasRequiredTabbable) return tabbable$1.exports;
  hasRequiredTabbable = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = findTabbableDescendants;
    var DISPLAY_NONE = "none";
    var DISPLAY_CONTENTS = "contents";
    var tabbableNode = /input|select|textarea|button|object|iframe/;
    function isNotOverflowing(element, style2) {
      return style2.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
      element.scrollWidth <= 0 && element.scrollHeight <= 0;
    }
    function hidesContents(element) {
      var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
      if (zeroSize && !element.innerHTML) return true;
      try {
        var style2 = window.getComputedStyle(element);
        var displayValue = style2.getPropertyValue("display");
        return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style2) : displayValue === DISPLAY_NONE;
      } catch (exception) {
        console.warn("Failed to inspect element style");
        return false;
      }
    }
    function visible(element) {
      var parentElement = element;
      var rootNode = element.getRootNode && element.getRootNode();
      while (parentElement) {
        if (parentElement === document.body) break;
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if (hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
      }
      return true;
    }
    function focusable(element, isTabIndexNotNaN) {
      var nodeName = element.nodeName.toLowerCase();
      var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
      return res && visible(element);
    }
    function tabbable3(element) {
      var tabIndex = element.getAttribute("tabindex");
      if (tabIndex === null) tabIndex = void 0;
      var isTabIndexNaN = isNaN(tabIndex);
      return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
    }
    function findTabbableDescendants(element) {
      var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
      }, []);
      return descendants.filter(tabbable3);
    }
    module.exports = exports$1["default"];
  })(tabbable$1, tabbable$1.exports);
  return tabbable$1.exports;
}
var hasRequiredFocusManager;
function requireFocusManager() {
  if (hasRequiredFocusManager) return focusManager;
  hasRequiredFocusManager = 1;
  Object.defineProperty(focusManager, "__esModule", {
    value: true
  });
  focusManager.resetState = resetState;
  focusManager.log = log;
  focusManager.handleBlur = handleBlur;
  focusManager.handleFocus = handleFocus;
  focusManager.markForFocusLater = markForFocusLater;
  focusManager.returnFocus = returnFocus;
  focusManager.popWithoutFocus = popWithoutFocus;
  focusManager.setupScopedFocus = setupScopedFocus;
  focusManager.teardownScopedFocus = teardownScopedFocus;
  var _tabbable = requireTabbable();
  var _tabbable2 = _interopRequireDefault(_tabbable);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var focusLaterElements = [];
  var modalElement = null;
  var needToFocus = false;
  function resetState() {
    focusLaterElements = [];
  }
  function log() {
  }
  function handleBlur() {
    needToFocus = true;
  }
  function handleFocus() {
    if (needToFocus) {
      needToFocus = false;
      if (!modalElement) {
        return;
      }
      setTimeout(function() {
        if (modalElement.contains(document.activeElement)) {
          return;
        }
        var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
        el.focus();
      }, 0);
    }
  }
  function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
  }
  function returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var toFocus = null;
    try {
      if (focusLaterElements.length !== 0) {
        toFocus = focusLaterElements.pop();
        toFocus.focus({ preventScroll });
      }
      return;
    } catch (e3) {
      console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
  }
  function setupScopedFocus(element) {
    modalElement = element;
    if (window.addEventListener) {
      window.addEventListener("blur", handleBlur, false);
      document.addEventListener("focus", handleFocus, true);
    } else {
      window.attachEvent("onBlur", handleBlur);
      document.attachEvent("onFocus", handleFocus);
    }
  }
  function teardownScopedFocus() {
    modalElement = null;
    if (window.addEventListener) {
      window.removeEventListener("blur", handleBlur);
      document.removeEventListener("focus", handleFocus);
    } else {
      window.detachEvent("onBlur", handleBlur);
      document.detachEvent("onFocus", handleFocus);
    }
  }
  return focusManager;
}
var scopeTab = { exports: {} };
var hasRequiredScopeTab;
function requireScopeTab() {
  if (hasRequiredScopeTab) return scopeTab.exports;
  hasRequiredScopeTab = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = scopeTab2;
    var _tabbable = requireTabbable();
    var _tabbable2 = _interopRequireDefault(_tabbable);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function getActiveElement() {
      var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
    }
    function scopeTab2(node2, event) {
      var tabbable3 = (0, _tabbable2.default)(node2);
      if (!tabbable3.length) {
        event.preventDefault();
        return;
      }
      var target = void 0;
      var shiftKey = event.shiftKey;
      var head = tabbable3[0];
      var tail = tabbable3[tabbable3.length - 1];
      var activeElement = getActiveElement();
      if (node2 === activeElement) {
        if (!shiftKey) return;
        target = tail;
      }
      if (tail === activeElement && !shiftKey) {
        target = head;
      }
      if (head === activeElement && shiftKey) {
        target = tail;
      }
      if (target) {
        event.preventDefault();
        target.focus();
        return;
      }
      var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
      var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (!isSafariDesktop) return;
      var x3 = tabbable3.indexOf(activeElement);
      if (x3 > -1) {
        x3 += shiftKey ? -1 : 1;
      }
      target = tabbable3[x3];
      if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
      }
      event.preventDefault();
      target.focus();
    }
    module.exports = exports$1["default"];
  })(scopeTab, scopeTab.exports);
  return scopeTab.exports;
}
var ariaAppHider = {};
var warning_1;
var hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning_1;
  hasRequiredWarning = 1;
  var warning2 = function() {
  };
  warning_1 = warning2;
  return warning_1;
}
var safeHTMLElement = {};
var exenv = { exports: {} };
var hasRequiredExenv;
function requireExenv() {
  if (hasRequiredExenv) return exenv.exports;
  hasRequiredExenv = 1;
  (function(module) {
    (function() {
      var canUseDOM2 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
      var ExecutionEnvironment = {
        canUseDOM: canUseDOM2,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM2 && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM2 && !!window.screen
      };
      if (module.exports) {
        module.exports = ExecutionEnvironment;
      } else {
        window.ExecutionEnvironment = ExecutionEnvironment;
      }
    })();
  })(exenv);
  return exenv.exports;
}
var hasRequiredSafeHTMLElement;
function requireSafeHTMLElement() {
  if (hasRequiredSafeHTMLElement) return safeHTMLElement;
  hasRequiredSafeHTMLElement = 1;
  Object.defineProperty(safeHTMLElement, "__esModule", {
    value: true
  });
  safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = void 0;
  var _exenv = requireExenv();
  var _exenv2 = _interopRequireDefault(_exenv);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var EE = _exenv2.default;
  var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
  safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
  safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
  safeHTMLElement.canUseDOM = EE.canUseDOM;
  safeHTMLElement.default = SafeHTMLElement;
  return safeHTMLElement;
}
var hasRequiredAriaAppHider;
function requireAriaAppHider() {
  if (hasRequiredAriaAppHider) return ariaAppHider;
  hasRequiredAriaAppHider = 1;
  Object.defineProperty(ariaAppHider, "__esModule", {
    value: true
  });
  ariaAppHider.resetState = resetState;
  ariaAppHider.log = log;
  ariaAppHider.assertNodeList = assertNodeList;
  ariaAppHider.setElement = setElement;
  ariaAppHider.validateElement = validateElement;
  ariaAppHider.hide = hide2;
  ariaAppHider.show = show;
  ariaAppHider.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
  var _warning = requireWarning();
  var _warning2 = _interopRequireDefault(_warning);
  var _safeHTMLElement = requireSafeHTMLElement();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var globalElement = null;
  function resetState() {
    if (globalElement) {
      if (globalElement.removeAttribute) {
        globalElement.removeAttribute("aria-hidden");
      } else if (globalElement.length != null) {
        globalElement.forEach(function(element) {
          return element.removeAttribute("aria-hidden");
        });
      } else {
        document.querySelectorAll(globalElement).forEach(function(element) {
          return element.removeAttribute("aria-hidden");
        });
      }
    }
    globalElement = null;
  }
  function log() {
  }
  function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) {
      throw new Error("react-modal: No elements were found for selector " + selector + ".");
    }
  }
  function setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
      var el = document.querySelectorAll(useElement);
      assertNodeList(el, useElement);
      useElement = el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
  }
  function validateElement(appElement) {
    var el = appElement || globalElement;
    if (el) {
      return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
    } else {
      (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
      return [];
    }
  }
  function hide2(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = void 0;
    try {
      for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;
        el.setAttribute("aria-hidden", "true");
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  function show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = void 0;
    try {
      for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var el = _step2.value;
        el.removeAttribute("aria-hidden");
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  function documentNotReadyOrSSRTesting() {
    globalElement = null;
  }
  return ariaAppHider;
}
var classList = {};
var hasRequiredClassList;
function requireClassList() {
  if (hasRequiredClassList) return classList;
  hasRequiredClassList = 1;
  Object.defineProperty(classList, "__esModule", {
    value: true
  });
  classList.resetState = resetState;
  classList.log = log;
  var htmlClassList = {};
  var docBodyClassList = {};
  function removeClass(at2, cls) {
    at2.classList.remove(cls);
  }
  function resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for (var cls in htmlClassList) {
      removeClass(htmlElement, htmlClassList[cls]);
    }
    var body2 = document.body;
    for (var _cls in docBodyClassList) {
      removeClass(body2, docBodyClassList[_cls]);
    }
    htmlClassList = {};
    docBodyClassList = {};
  }
  function log() {
  }
  var incrementReference = function incrementReference2(poll, className) {
    if (!poll[className]) {
      poll[className] = 0;
    }
    poll[className] += 1;
    return className;
  };
  var decrementReference = function decrementReference2(poll, className) {
    if (poll[className]) {
      poll[className] -= 1;
    }
    return className;
  };
  var trackClass = function trackClass2(classListRef, poll, classes) {
    classes.forEach(function(className) {
      incrementReference(poll, className);
      classListRef.add(className);
    });
  };
  var untrackClass = function untrackClass2(classListRef, poll, classes) {
    classes.forEach(function(className) {
      decrementReference(poll, className);
      poll[className] === 0 && classListRef.remove(className);
    });
  };
  classList.add = function add2(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
  classList.remove = function remove2(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
  return classList;
}
var portalOpenInstances = {};
var hasRequiredPortalOpenInstances;
function requirePortalOpenInstances() {
  if (hasRequiredPortalOpenInstances) return portalOpenInstances;
  hasRequiredPortalOpenInstances = 1;
  Object.defineProperty(portalOpenInstances, "__esModule", {
    value: true
  });
  portalOpenInstances.log = log;
  portalOpenInstances.resetState = resetState;
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var PortalOpenInstances = function PortalOpenInstances2() {
    var _this = this;
    _classCallCheck2(this, PortalOpenInstances2);
    this.register = function(openInstance) {
      if (_this.openInstances.indexOf(openInstance) !== -1) {
        return;
      }
      _this.openInstances.push(openInstance);
      _this.emit("register");
    };
    this.deregister = function(openInstance) {
      var index2 = _this.openInstances.indexOf(openInstance);
      if (index2 === -1) {
        return;
      }
      _this.openInstances.splice(index2, 1);
      _this.emit("deregister");
    };
    this.subscribe = function(callback) {
      _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
      _this.subscribers.forEach(function(subscriber) {
        return subscriber(
          eventType,
          // shallow copy to avoid accidental mutation
          _this.openInstances.slice()
        );
      });
    };
    this.openInstances = [];
    this.subscribers = [];
  };
  var portalOpenInstances$1 = new PortalOpenInstances();
  function log() {
    console.log("portalOpenInstances ----------");
    console.log(portalOpenInstances$1.openInstances.length);
    portalOpenInstances$1.openInstances.forEach(function(p2) {
      return console.log(p2);
    });
    console.log("end portalOpenInstances ----------");
  }
  function resetState() {
    portalOpenInstances$1 = new PortalOpenInstances();
  }
  portalOpenInstances.default = portalOpenInstances$1;
  return portalOpenInstances;
}
var bodyTrap = {};
var hasRequiredBodyTrap;
function requireBodyTrap() {
  if (hasRequiredBodyTrap) return bodyTrap;
  hasRequiredBodyTrap = 1;
  Object.defineProperty(bodyTrap, "__esModule", {
    value: true
  });
  bodyTrap.resetState = resetState;
  bodyTrap.log = log;
  var _portalOpenInstances = requirePortalOpenInstances();
  var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var before = void 0, after = void 0, instances = [];
  function resetState() {
    var _arr = [before, after];
    for (var _i = 0; _i < _arr.length; _i++) {
      var item2 = _arr[_i];
      if (!item2) continue;
      item2.parentNode && item2.parentNode.removeChild(item2);
    }
    before = after = null;
    instances = [];
  }
  function log() {
    console.log("bodyTrap ----------");
    console.log(instances.length);
    var _arr2 = [before, after];
    for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
      var item2 = _arr2[_i2];
      var check = item2 || {};
      console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function focusContent() {
    if (instances.length === 0) {
      return;
    }
    instances[instances.length - 1].focusContent();
  }
  function bodyTrap$1(eventType, openInstances) {
    if (!before && !after) {
      before = document.createElement("div");
      before.setAttribute("data-react-modal-body-trap", "");
      before.style.position = "absolute";
      before.style.opacity = "0";
      before.setAttribute("tabindex", "0");
      before.addEventListener("focus", focusContent);
      after = before.cloneNode();
      after.addEventListener("focus", focusContent);
    }
    instances = openInstances;
    if (instances.length > 0) {
      if (document.body.firstChild !== before) {
        document.body.insertBefore(before, document.body.firstChild);
      }
      if (document.body.lastChild !== after) {
        document.body.appendChild(after);
      }
    } else {
      if (before.parentElement) {
        before.parentElement.removeChild(before);
      }
      if (after.parentElement) {
        after.parentElement.removeChild(after);
      }
    }
  }
  _portalOpenInstances2.default.subscribe(bodyTrap$1);
  return bodyTrap;
}
var hasRequiredModalPortal;
function requireModalPortal() {
  if (hasRequiredModalPortal) return ModalPortal.exports;
  hasRequiredModalPortal = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    var _extends2 = Object.assign || function(target) {
      for (var i3 = 1; i3 < arguments.length; i3++) {
        var source = arguments[i3];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _createClass2 = /* @__PURE__ */ (function() {
      function defineProperties(target, props) {
        for (var i3 = 0; i3 < props.length; i3++) {
          var descriptor = props[i3];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
    var _react = React__default;
    var _propTypes = /* @__PURE__ */ requirePropTypes();
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _focusManager = requireFocusManager();
    var focusManager2 = _interopRequireWildcard(_focusManager);
    var _scopeTab = requireScopeTab();
    var _scopeTab2 = _interopRequireDefault(_scopeTab);
    var _ariaAppHider = requireAriaAppHider();
    var ariaAppHider2 = _interopRequireWildcard(_ariaAppHider);
    var _classList = requireClassList();
    var classList2 = _interopRequireWildcard(_classList);
    var _safeHTMLElement = requireSafeHTMLElement();
    var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
    var _portalOpenInstances = requirePortalOpenInstances();
    var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
    requireBodyTrap();
    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn2(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var CLASS_NAMES = {
      overlay: "ReactModal__Overlay",
      content: "ReactModal__Content"
    };
    var isTabKey = function isTabKey2(event) {
      return event.code === "Tab" || event.keyCode === 9;
    };
    var isEscKey = function isEscKey2(event) {
      return event.code === "Escape" || event.keyCode === 27;
    };
    var ariaHiddenInstances = 0;
    var ModalPortal2 = (function(_Component) {
      _inherits2(ModalPortal22, _Component);
      function ModalPortal22(props) {
        _classCallCheck2(this, ModalPortal22);
        var _this = _possibleConstructorReturn2(this, (ModalPortal22.__proto__ || Object.getPrototypeOf(ModalPortal22)).call(this, props));
        _this.setOverlayRef = function(overlay2) {
          _this.overlay = overlay2;
          _this.props.overlayRef && _this.props.overlayRef(overlay2);
        };
        _this.setContentRef = function(content2) {
          _this.content = content2;
          _this.props.contentRef && _this.props.contentRef(content2);
        };
        _this.afterClose = function() {
          var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
          var parentDocument = parentSelector && parentSelector().ownerDocument || document;
          bodyOpenClassName && classList2.remove(parentDocument.body, bodyOpenClassName);
          htmlOpenClassName && classList2.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
          if (ariaHideApp && ariaHiddenInstances > 0) {
            ariaHiddenInstances -= 1;
            if (ariaHiddenInstances === 0) {
              ariaAppHider2.show(appElement);
            }
          }
          if (_this.props.shouldFocusAfterRender) {
            if (_this.props.shouldReturnFocusAfterClose) {
              focusManager2.returnFocus(_this.props.preventScroll);
              focusManager2.teardownScopedFocus();
            } else {
              focusManager2.popWithoutFocus();
            }
          }
          if (_this.props.onAfterClose) {
            _this.props.onAfterClose();
          }
          _portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
          _this.beforeOpen();
          if (_this.state.afterOpen && _this.state.beforeClose) {
            clearTimeout(_this.closeTimer);
            _this.setState({ beforeClose: false });
          } else {
            if (_this.props.shouldFocusAfterRender) {
              focusManager2.setupScopedFocus(_this.node);
              focusManager2.markForFocusLater();
            }
            _this.setState({ isOpen: true }, function() {
              _this.openAnimationFrame = requestAnimationFrame(function() {
                _this.setState({ afterOpen: true });
                if (_this.props.isOpen && _this.props.onAfterOpen) {
                  _this.props.onAfterOpen({
                    overlayEl: _this.overlay,
                    contentEl: _this.content
                  });
                }
              });
            });
          }
        };
        _this.close = function() {
          if (_this.props.closeTimeoutMS > 0) {
            _this.closeWithTimeout();
          } else {
            _this.closeWithoutTimeout();
          }
        };
        _this.focusContent = function() {
          return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
        };
        _this.closeWithTimeout = function() {
          var closesAt = Date.now() + _this.props.closeTimeoutMS;
          _this.setState({ beforeClose: true, closesAt }, function() {
            _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
          });
        };
        _this.closeWithoutTimeout = function() {
          _this.setState({
            beforeClose: false,
            isOpen: false,
            afterOpen: false,
            closesAt: null
          }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
          if (isTabKey(event)) {
            (0, _scopeTab2.default)(_this.content, event);
          }
          if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
            event.stopPropagation();
            _this.requestClose(event);
          }
        };
        _this.handleOverlayOnClick = function(event) {
          if (_this.shouldClose === null) {
            _this.shouldClose = true;
          }
          if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
            if (_this.ownerHandlesClose()) {
              _this.requestClose(event);
            } else {
              _this.focusContent();
            }
          }
          _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
          _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
          if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
            event.preventDefault();
          }
        };
        _this.handleContentOnClick = function() {
          _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
          _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
          return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
          return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
          return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
          return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
          var classNames2 = (typeof additional === "undefined" ? "undefined" : _typeof2(additional)) === "object" ? additional : {
            base: CLASS_NAMES[which],
            afterOpen: CLASS_NAMES[which] + "--after-open",
            beforeClose: CLASS_NAMES[which] + "--before-close"
          };
          var className = classNames2.base;
          if (_this.state.afterOpen) {
            className = className + " " + classNames2.afterOpen;
          }
          if (_this.state.beforeClose) {
            className = className + " " + classNames2.beforeClose;
          }
          return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix2, items2) {
          return Object.keys(items2).reduce(function(acc, name2) {
            acc[prefix2 + "-" + name2] = items2[name2];
            return acc;
          }, {});
        };
        _this.state = {
          afterOpen: false,
          beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
      }
      _createClass2(ModalPortal22, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.isOpen) {
            this.open();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          if (this.props.isOpen && !prevProps.isOpen) {
            this.open();
          } else if (!this.props.isOpen && prevProps.isOpen) {
            this.close();
          }
          if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
            this.focusContent();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.isOpen) {
            this.afterClose();
          }
          clearTimeout(this.closeTimer);
          cancelAnimationFrame(this.openAnimationFrame);
        }
      }, {
        key: "beforeOpen",
        value: function beforeOpen() {
          var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
          var parentDocument = parentSelector && parentSelector().ownerDocument || document;
          bodyOpenClassName && classList2.add(parentDocument.body, bodyOpenClassName);
          htmlOpenClassName && classList2.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
          if (ariaHideApp) {
            ariaHiddenInstances += 1;
            ariaAppHider2.hide(appElement);
          }
          _portalOpenInstances2.default.register(this);
        }
        // Don't steal focus from inner elements
      }, {
        key: "render",
        value: function render() {
          var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles2 = _props2.defaultStyles, children = _props2.children;
          var contentStyles = className ? {} : defaultStyles2.content;
          var overlayStyles = overlayClassName ? {} : defaultStyles2.overlay;
          if (this.shouldBeClosed()) {
            return null;
          }
          var overlayProps = {
            ref: this.setOverlayRef,
            className: this.buildClassName("overlay", overlayClassName),
            style: _extends2({}, overlayStyles, this.props.style.overlay),
            onClick: this.handleOverlayOnClick,
            onMouseDown: this.handleOverlayOnMouseDown
          };
          var contentProps = _extends2({
            id,
            ref: this.setContentRef,
            style: _extends2({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", _extends2({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          });
          var contentElement = this.props.contentElement(contentProps, children);
          return this.props.overlayElement(overlayProps, contentElement);
        }
      }]);
      return ModalPortal22;
    })(_react.Component);
    ModalPortal2.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    };
    ModalPortal2.propTypes = {
      isOpen: _propTypes2.default.bool.isRequired,
      defaultStyles: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
      }),
      style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
      }),
      className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
      overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
      parentSelector: _propTypes2.default.func,
      bodyOpenClassName: _propTypes2.default.string,
      htmlOpenClassName: _propTypes2.default.string,
      ariaHideApp: _propTypes2.default.bool,
      appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
      onAfterOpen: _propTypes2.default.func,
      onAfterClose: _propTypes2.default.func,
      onRequestClose: _propTypes2.default.func,
      closeTimeoutMS: _propTypes2.default.number,
      shouldFocusAfterRender: _propTypes2.default.bool,
      shouldCloseOnOverlayClick: _propTypes2.default.bool,
      shouldReturnFocusAfterClose: _propTypes2.default.bool,
      preventScroll: _propTypes2.default.bool,
      role: _propTypes2.default.string,
      contentLabel: _propTypes2.default.string,
      aria: _propTypes2.default.object,
      data: _propTypes2.default.object,
      children: _propTypes2.default.node,
      shouldCloseOnEsc: _propTypes2.default.bool,
      overlayRef: _propTypes2.default.func,
      contentRef: _propTypes2.default.func,
      id: _propTypes2.default.string,
      overlayElement: _propTypes2.default.func,
      contentElement: _propTypes2.default.func,
      testId: _propTypes2.default.string
    };
    exports$1.default = ModalPortal2;
    module.exports = exports$1["default"];
  })(ModalPortal, ModalPortal.exports);
  return ModalPortal.exports;
}
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype = Component2.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
const reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" }));
const require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
var hasRequiredModal;
function requireModal() {
  if (hasRequiredModal) return Modal$1;
  hasRequiredModal = 1;
  Object.defineProperty(Modal$1, "__esModule", {
    value: true
  });
  Modal$1.bodyOpenClassName = Modal$1.portalClassName = void 0;
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i3 = 0; i3 < props.length; i3++) {
        var descriptor = props[i3];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  var _reactDom = ReactDOM__default;
  var _reactDom2 = _interopRequireDefault(_reactDom);
  var _propTypes = /* @__PURE__ */ requirePropTypes();
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _ModalPortal = requireModalPortal();
  var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
  var _ariaAppHider = requireAriaAppHider();
  var ariaAppHider2 = _interopRequireWildcard(_ariaAppHider);
  var _safeHTMLElement = requireSafeHTMLElement();
  var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
  var _reactLifecyclesCompat = require$$6;
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var portalClassName = Modal$1.portalClassName = "ReactModalPortal";
  var bodyOpenClassName = Modal$1.bodyOpenClassName = "ReactModal__Body--open";
  var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0;
  var createHTMLElement = function createHTMLElement2(name2) {
    return document.createElement(name2);
  };
  var getCreatePortal = function getCreatePortal2() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
  };
  function getParentElement(parentSelector2) {
    return parentSelector2();
  }
  var Modal2 = (function(_Component) {
    _inherits2(Modal22, _Component);
    function Modal22() {
      var _ref3;
      var _temp, _this, _ret;
      _classCallCheck2(this, Modal22);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn2(this, (_ref3 = Modal22.__proto__ || Object.getPrototypeOf(Modal22)).call.apply(_ref3, [this].concat(args))), _this), _this.removePortal = function() {
        !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
        var parent = getParentElement(_this.props.parentSelector);
        if (parent && parent.contains(_this.node)) {
          parent.removeChild(_this.node);
        } else {
          console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }
      }, _this.portalRef = function(ref2) {
        _this.portal = ref2;
      }, _this.renderPortal = function(props) {
        var createPortal2 = getCreatePortal();
        var portal = createPortal2(_this, _react2.default.createElement(_ModalPortal2.default, _extends2({ defaultStyles: Modal22.defaultStyles }, props)), _this.node);
        _this.portalRef(portal);
      }, _temp), _possibleConstructorReturn2(_this, _ret);
    }
    _createClass2(Modal22, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!_safeHTMLElement.canUseDOM) return;
        if (!isReact16) {
          this.node = createHTMLElement("div");
        }
        this.node.className = this.props.portalClassName;
        var parent = getParentElement(this.props.parentSelector);
        parent.appendChild(this.node);
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps) {
        var prevParent = getParentElement(prevProps.parentSelector);
        var nextParent = getParentElement(this.props.parentSelector);
        return { prevParent, nextParent };
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, _2, snapshot) {
        if (!_safeHTMLElement.canUseDOM) return;
        var _props = this.props, isOpen = _props.isOpen, portalClassName2 = _props.portalClassName;
        if (prevProps.portalClassName !== portalClassName2) {
          this.node.className = portalClassName2;
        }
        var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
        if (nextParent !== prevParent) {
          prevParent.removeChild(this.node);
          nextParent.appendChild(this.node);
        }
        if (!prevProps.isOpen && !isOpen) return;
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
        var state = this.portal.state;
        var now = Date.now();
        var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
        if (closesAt) {
          if (!state.beforeClose) {
            this.portal.closeWithTimeout();
          }
          setTimeout(this.removePortal, closesAt - now);
        } else {
          this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!_safeHTMLElement.canUseDOM || !isReact16) {
          return null;
        }
        if (!this.node && isReact16) {
          this.node = createHTMLElement("div");
        }
        var createPortal2 = getCreatePortal();
        return createPortal2(_react2.default.createElement(_ModalPortal2.default, _extends2({
          ref: this.portalRef,
          defaultStyles: Modal22.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function setAppElement(element) {
        ariaAppHider2.setElement(element);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]);
    return Modal22;
  })(_react.Component);
  Modal2.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
      content: _propTypes2.default.object,
      overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func
  };
  Modal2.defaultProps = {
    isOpen: false,
    portalClassName,
    bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
      return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
      return _react2.default.createElement(
        "div",
        props,
        contentEl
      );
    },
    contentElement: function contentElement(props, children) {
      return _react2.default.createElement(
        "div",
        props,
        children
      );
    }
  };
  Modal2.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  };
  (0, _reactLifecyclesCompat.polyfill)(Modal2);
  Modal$1.default = Modal2;
  return Modal$1;
}
var hasRequiredLib$1;
function requireLib$1() {
  if (hasRequiredLib$1) return lib$1.exports;
  hasRequiredLib$1 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    var _Modal = requireModal();
    var _Modal2 = _interopRequireDefault(_Modal);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports$1.default = _Modal2.default;
    module.exports = exports$1["default"];
  })(lib$1, lib$1.exports);
  return lib$1.exports;
}
var libExports$1 = requireLib$1();
const ReactModal = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1);
const CloseIcon$1 = () => {
  return /* @__PURE__ */ jsx$1("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M9.66732 1.27398L8.72732 0.333984L5.00065 4.06065L1.27398 0.333984L0.333984 1.27398L4.06065 5.00065L0.333984 8.72732L1.27398 9.66732L5.00065 5.94065L8.72732 9.66732L9.66732 8.72732L5.94065 5.00065L9.66732 1.27398Z", fill: "#00204D" }) });
};
const ErrorIcon$2 = () => {
  return /* @__PURE__ */ jsx$1("svg", { "data-testid": "ErrorIcon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17ZM13 7H11V14H13V7Z", fill: "#D71717" }) });
};
const InformationIcon = () => {
  return /* @__PURE__ */ jsx$1("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM12 15H8V13H9V11H8V9H9H11V13H12V15ZM11 7H9V5H11V7Z", fill: "#006FBF" }) });
};
const SuccessIcon = () => {
  return /* @__PURE__ */ jsx$1("svg", { "data-testid": "SuccessIcon", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z", fill: "#007A6A" }) });
};
const WarningIcon$1 = () => {
  return /* @__PURE__ */ jsxs("svg", { "data-testid": "WarningIcon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_159_8413)", children: /* @__PURE__ */ jsx$1("path", { d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z", fill: "#C4811D" }) }),
    /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_159_8413", children: /* @__PURE__ */ jsx$1("rect", { width: "24", height: "24", fill: "white" }) }) })
  ] });
};
const styles$A = {
  "sz-modal-buttons": "modal-buttons-module_sz-modal-buttons__NBGHH"
};
const ModalButtons$1 = ({
  confirmButtonProps,
  cancelButtonProps,
  className,
  confirmButtonChildren = "Confirm",
  cancelButtonChildren = "Cancel",
  hasCancelButton = true,
  onConfirmButtonClick,
  onCancelButtonClick
}) => {
  const parsedCancelButtonProps = {
    variant: "secondary",
    onClick: onCancelButtonClick,
    children: cancelButtonChildren,
    ...cancelButtonProps
  };
  const parsedConfirmButtonProps = {
    onClick: onConfirmButtonClick,
    children: confirmButtonChildren,
    ...confirmButtonProps
  };
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles$A["sz-modal-buttons"], className), children: [
    hasCancelButton && /* @__PURE__ */ jsx$1(Button$1, { size: "medium", ...parsedCancelButtonProps }),
    /* @__PURE__ */ jsx$1(
      Button$1,
      {
        size: "medium",
        "data-testid": "modalConfirm",
        ...parsedConfirmButtonProps
      }
    )
  ] });
};
const overlay$1 = "modal-module_overlay__a52Ni";
const dialogContent = "modal-module_dialogContent__j2CrK";
const dialogScrollable = "modal-module_dialogScrollable__wu8vQ";
const styles$z = {
  overlay: overlay$1,
  "sz-modal": "modal-module_sz-modal__6o1l7",
  "header-container": "modal-module_header-container__2ZqJ6",
  "header-text": "modal-module_header-text__VmJOw",
  "action-buttons": "modal-module_action-buttons__PzSqY",
  "icon-container": "modal-module_icon-container__28rhJ",
  "close-modal-button": "modal-module_close-modal-button__a877o",
  dialogContent,
  dialogScrollable
};
var ModalSize = /* @__PURE__ */ ((ModalSize2) => {
  ModalSize2["SMALL"] = "SMALL";
  ModalSize2["MEDIUM"] = "MEDIUM";
  ModalSize2["LARGE"] = "LARGE";
  return ModalSize2;
})(ModalSize || {});
var IconType = /* @__PURE__ */ ((IconType2) => {
  IconType2["INFORMATION"] = "INFORMATION";
  IconType2["SUCCESS"] = "SUCCESS";
  IconType2["WARNING"] = "WARNING";
  IconType2["ERROR"] = "ERROR";
  return IconType2;
})(IconType || {});
const getPortalParent = () => typeof document === "undefined" ? null : document.body;
const Modal = ({
  children,
  onClose,
  isOpen,
  modalSize = "MEDIUM",
  header: header2,
  className,
  buttonsProps,
  headerIconType,
  showCloseIcon = false,
  scrollable = false,
  overlayClassName,
  shouldCloseOnOverlayClick = true
}) => {
  useEffect(() => {
    if (isOpen) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
      };
    } else {
      window.onscroll = function() {
      };
    }
    return () => {
      window.onscroll = function() {
      };
    };
  }, [isOpen]);
  const getIcon = useCallback(() => {
    switch (headerIconType) {
      case "INFORMATION":
        return /* @__PURE__ */ jsx$1(InformationIcon, {});
      case "SUCCESS":
        return /* @__PURE__ */ jsx$1(SuccessIcon, {});
      case "WARNING":
        return /* @__PURE__ */ jsx$1(WarningIcon$1, {});
      case "ERROR":
        return /* @__PURE__ */ jsx$1(ErrorIcon$2, {});
    }
  }, [headerIconType]);
  const getSizeStyle = useCallback(() => {
    switch (modalSize) {
      case "SMALL":
        return { width: "400px" };
      case "MEDIUM":
        return { width: "560px" };
      case "LARGE":
        return { width: "720px" };
    }
  }, [modalSize]);
  return /* @__PURE__ */ jsxs(
    ReactModal,
    {
      ariaHideApp: false,
      closeTimeoutMS: 200,
      parentSelector: getPortalParent,
      aria: {
        labelledby: "dialogTitle",
        describedby: "dialogDesc"
      },
      className: clsx(styles$z["sz-modal"], className),
      isOpen,
      onRequestClose: onClose,
      overlayClassName: clsx(styles$z["overlay"], overlayClassName),
      shouldCloseOnOverlayClick,
      style: {
        content: getSizeStyle()
      },
      testId: "modal-dialog",
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$z["header-container"], children: [
          headerIconType && /* @__PURE__ */ jsx$1("div", { className: styles$z["icon-container"], children: getIcon() }),
          header2 && /* @__PURE__ */ jsx$1("span", { id: "dialogTitle", className: styles$z["header-text"], children: header2 }),
          showCloseIcon && /* @__PURE__ */ jsx$1(
            "button",
            {
              tabIndex: 0,
              onClick: onClose,
              "aria-label": "close modal",
              "data-testid": "close-modal-button",
              className: styles$z["close-modal-button"],
              children: /* @__PURE__ */ jsx$1(CloseIcon$1, {})
            }
          )
        ] }),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            id: "dialogDesc",
            className: clsx(
              styles$z["dialogContent"],
              scrollable ? styles$z["dialogScrollable"] : void 0
            ),
            children
          }
        ),
        buttonsProps && /* @__PURE__ */ jsx$1(
          ModalButtons$1,
          {
            ...buttonsProps,
            onCancelButtonClick: buttonsProps.onCancelButtonClick ?? onClose,
            className: clsx(styles$z["action-buttons"], buttonsProps?.className)
          }
        )
      ]
    }
  );
};
const container$5 = "multi-file-upload-module_container__GK0m3";
const list$1 = "multi-file-upload-module_list__TUb1V";
const row = "multi-file-upload-module_row__4Zfgv";
const eyebrow = "multi-file-upload-module_eyebrow__IT6io";
const status = "multi-file-upload-module_status__ffKL6";
const name = "multi-file-upload-module_name__qIraO";
const progress = "multi-file-upload-module_progress__k27ug";
const badge = "multi-file-upload-module_badge__47skT";
const remove = "multi-file-upload-module_remove__e5NBR";
const box = "multi-file-upload-module_box__BitgR";
const browse = "multi-file-upload-module_browse__Zbp2z";
const error$7 = "multi-file-upload-module_error__8f3fr";
const styles$y = {
  container: container$5,
  list: list$1,
  row,
  "row--uploading": "multi-file-upload-module_row--uploading__o9GzY",
  "row--uploaded": "multi-file-upload-module_row--uploaded__9rCG8",
  "row--fixed": "multi-file-upload-module_row--fixed__2Q4cm",
  "row--failed": "multi-file-upload-module_row--failed__8b78u",
  "row-icon": "multi-file-upload-module_row-icon__-nNTI",
  "row-body": "multi-file-upload-module_row-body__ZT39J",
  eyebrow,
  status,
  "status--uploading": "multi-file-upload-module_status--uploading__wNNQZ",
  "status--uploaded": "multi-file-upload-module_status--uploaded__2JgJc",
  "status--error": "multi-file-upload-module_status--error__cI8BK",
  name,
  progress,
  "row-trailing": "multi-file-upload-module_row-trailing__P4BH-",
  badge,
  remove,
  "row--editable": "multi-file-upload-module_row--editable__Vmrgs",
  box,
  "box--drag": "multi-file-upload-module_box--drag__4DCV5",
  "box-icon": "multi-file-upload-module_box-icon__6XFQh",
  "box-body": "multi-file-upload-module_box-body__io6yd",
  "box-title": "multi-file-upload-module_box-title__J1lyk",
  "box-hint": "multi-file-upload-module_box-hint__Qus91",
  browse,
  error: error$7,
  "box-trailing": "multi-file-upload-module_box-trailing__NHX02"
};
const MultiFileUploadDropZone = ({
  rootProps,
  inputProps,
  isDragActive,
  title: title2,
  dropHint,
  browseLink,
  limitsHint,
  uploadButtonAriaLabel,
  errorMessage,
  dataTestId,
  onOpenPicker
}) => {
  const [hintBefore, ...hintRest] = dropHint.split("{browse}");
  return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
    /* @__PURE__ */ jsx$1("input", { ...inputProps }),
    /* @__PURE__ */ jsx$1("span", { className: styles$y["box-icon"], children: /* @__PURE__ */ jsx$1(
      Icon$2,
      {
        icon: isDragActive ? "upload" : "attach_file",
        width: 20,
        height: 20
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: styles$y["box-body"], children: [
      /* @__PURE__ */ jsx$1("p", { className: styles$y["box-title"], children: title2 }),
      /* @__PURE__ */ jsxs("p", { className: styles$y["box-hint"], children: [
        hintBefore,
        hintRest.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx$1(
            "button",
            {
              type: "button",
              className: styles$y["browse"],
              "data-testid": `${dataTestId}__browse-button`,
              onClick: onOpenPicker,
              children: browseLink
            }
          ),
          hintRest.join("{browse}")
        ] })
      ] }),
      /* @__PURE__ */ jsx$1("p", { className: styles$y["box-hint"], children: limitsHint }),
      errorMessage && /* @__PURE__ */ jsx$1(
        "p",
        {
          className: styles$y["error"],
          role: "alert",
          "data-testid": `${dataTestId}__error`,
          children: errorMessage
        }
      )
    ] }),
    /* @__PURE__ */ jsx$1("div", { className: styles$y["box-trailing"], children: /* @__PURE__ */ jsx$1(
      Button$1,
      {
        variant: "secondary",
        size: "small",
        iconOnly: true,
        ariaLabel: uploadButtonAriaLabel,
        leftIcon: /* @__PURE__ */ jsx$1(Icon$2, { icon: "upload" }),
        "data-testid": `${dataTestId}__upload-button`,
        onClick: onOpenPicker
      }
    ) })
  ] });
};
const MultiFileUploadRowIcon = ({ icon: icon2 }) => /* @__PURE__ */ jsx$1("span", { className: styles$y["row-icon"], children: /* @__PURE__ */ jsx$1(Icon$2, { icon: icon2, width: 20, height: 20 }) });
const MultiFileUploadFixedRow = ({
  file,
  dataTestId
}) => /* @__PURE__ */ jsxs(
  "li",
  {
    className: clsx(styles$y["row"], styles$y["row--fixed"]),
    "data-testid": `${dataTestId}__fixed-row-${file.id}`,
    children: [
      /* @__PURE__ */ jsx$1(MultiFileUploadRowIcon, { icon: file.icon ?? "page_outlined" }),
      /* @__PURE__ */ jsxs("div", { className: styles$y["row-body"], children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$y["name"], children: /* @__PURE__ */ jsx$1(FileUploadFileName, { fileName: file.name }) }),
        file.description && /* @__PURE__ */ jsx$1("span", { className: styles$y["status"], children: file.description })
      ] })
    ]
  }
);
const INDICATOR_RADIUS = {
  sm: 2,
  md: 4,
  lg: 4
};
const clampValue = (value2, max2) => typeof value2 === "number" && !Number.isNaN(value2) ? Math.min(Math.max(value2, 0), max2) : null;
const resolveStatus = (status2, value2, max2) => {
  if (status2 === "complete" || status2 === "error") {
    return status2;
  }
  if (typeof value2 === "number" && max2 > 0 && value2 >= max2) {
    return "complete";
  }
  return "default";
};
const getDataState = (status2, value2) => {
  if (status2 === "error") {
    return "error";
  }
  if (value2 === null) {
    return "indeterminate";
  }
  return status2 === "complete" ? "complete" : "loading";
};
const ProgressBarContext = React__default.createContext({
  value: null,
  max: 100,
  status: "default",
  size: "md"
});
const progressBar = "progress-bar-module_progressBar__JRrJR";
const root$4 = "progress-bar-module_root__dqvpE";
const accent = "progress-bar-module_accent__Z21jd";
const completeInteractive = "progress-bar-module_completeInteractive__u-Gom";
const indicator$1 = "progress-bar-module_indicator__3Wa-y";
const sm = "progress-bar-module_sm__iwR1f";
const md = "progress-bar-module_md__c-0Vc";
const lg = "progress-bar-module_lg__4eqRF";
const sweep = "progress-bar-module_sweep__Sc1ip";
const header$5 = "progress-bar-module_header__kzOhi";
const label$6 = "progress-bar-module_label__pDwGS";
const value = "progress-bar-module_value__r9BQL";
const error$6 = "progress-bar-module_error__TQfjQ";
const helper = "progress-bar-module_helper__9L8e4";
const inlineRow = "progress-bar-module_inlineRow__nFs4A";
const inlineTrack = "progress-bar-module_inlineTrack__LVlin";
const styles$x = {
  progressBar,
  root: root$4,
  accent,
  completeInteractive,
  indicator: indicator$1,
  sm,
  md,
  lg,
  sweep,
  header: header$5,
  label: label$6,
  value,
  error: error$6,
  helper,
  inlineRow,
  inlineTrack
};
const ProgressBarIndicator = React__default.forwardRef(({ className, style: style2, ...props }, ref2) => {
  const { value: value2, max: max2, status: status2, size } = React__default.useContext(ProgressBarContext);
  const state = getDataState(status2, value2);
  const radius = INDICATOR_RADIUS[size];
  const percentage = state === "indeterminate" ? null : (value2 ?? 0) / max2 * 100;
  return /* @__PURE__ */ jsx$1(
    Progress.Indicator,
    {
      ref: ref2,
      className: clsx(styles$x.indicator, className),
      "data-state": state,
      style: percentage !== null ? {
        width: `${percentage}%`,
        minWidth: percentage > 0 ? radius : 0,
        ...style2
      } : style2,
      ...props
    }
  );
});
ProgressBarIndicator.displayName = "ProgressBar.Indicator";
const ProgressBarLabel = React__default.forwardRef(({ className, ...props }, ref2) => /* @__PURE__ */ jsx$1("span", { ref: ref2, className: clsx(styles$x.label, className), ...props }));
ProgressBarLabel.displayName = "ProgressBar.Label";
const ProgressBarRoot = React__default.forwardRef(
  ({
    value: valueProp,
    max: maxProp,
    size = "md",
    status: statusProp,
    trackTone = "neutral",
    completeTone = "interactive",
    valueLabel,
    className,
    children,
    ...props
  }, ref2) => {
    const max2 = typeof maxProp === "number" && maxProp > 0 ? maxProp : 100;
    const value2 = clampValue(valueProp, max2);
    const status2 = resolveStatus(statusProp, value2, max2);
    const accent2 = trackTone === "accent" && status2 === "default";
    const completeInteractive2 = completeTone === "interactive" && status2 === "complete";
    return /* @__PURE__ */ jsx$1(ProgressBarContext.Provider, { value: { value: value2, max: max2, status: status2, size }, children: /* @__PURE__ */ jsx$1(
      Progress.Root,
      {
        ref: ref2,
        value: value2,
        max: max2,
        className: clsx(
          styles$x.root,
          styles$x[size],
          accent2 && styles$x.accent,
          completeInteractive2 && styles$x.completeInteractive,
          className
        ),
        "data-state": getDataState(status2, value2),
        "aria-valuetext": valueLabel,
        ...props,
        children: children !== void 0 ? children : /* @__PURE__ */ jsx$1(ProgressBarIndicator, {})
      }
    ) });
  }
);
ProgressBarRoot.displayName = "ProgressBar.Root";
const ProgressBarBase = ({
  value: valueProp,
  max: maxProp,
  size: sizeProp,
  status: statusProp,
  label: label2,
  children,
  valueLabel,
  showPercentage = false,
  valuePlacement = "inline",
  trackTone,
  completeTone,
  helperText,
  "aria-label": ariaLabel,
  className,
  style: style2,
  id
}) => {
  const max2 = typeof maxProp === "number" && maxProp > 0 ? maxProp : 100;
  const value2 = clampValue(valueProp, max2);
  const size = sizeProp && sizeProp in INDICATOR_RADIUS ? sizeProp : "md";
  const status2 = resolveStatus(statusProp, value2, max2);
  const labelId = `${React__default.useId()}-label`;
  const inline2 = valuePlacement !== "above";
  const showPct = showPercentage && (inline2 || size !== "sm") && value2 !== null;
  const pctText = showPct ? `${Math.round(value2 / max2 * 100)}%` : null;
  const right2 = valueLabel !== void 0 && valueLabel !== null ? valueLabel : pctText;
  const valueClassName = clsx(styles$x.value, status2 === "error" && styles$x.error);
  const headerRight = inline2 ? null : right2;
  const hasHeader = label2 !== void 0 || children !== void 0 || headerRight !== null;
  const labelled = label2 !== void 0 || children !== void 0;
  let bar = /* @__PURE__ */ jsx$1(
    ProgressBarRoot,
    {
      value: valueProp,
      max: max2,
      size,
      status: status2,
      trackTone,
      completeTone,
      valueLabel: typeof right2 === "string" ? right2 : void 0,
      "aria-labelledby": labelled ? labelId : void 0,
      "aria-label": labelled ? void 0 : ariaLabel ?? "Progress"
    }
  );
  if (inline2) {
    bar = /* @__PURE__ */ jsxs("div", { className: styles$x.inlineRow, children: [
      /* @__PURE__ */ jsx$1("div", { className: styles$x.inlineTrack, children: bar }),
      right2 !== null ? /* @__PURE__ */ jsx$1("span", { className: valueClassName, children: right2 }) : null
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles$x.progressBar, className), style: style2, id, children: [
    hasHeader ? /* @__PURE__ */ jsxs("div", { className: styles$x.header, children: [
      children !== void 0 ? /* @__PURE__ */ jsx$1(ProgressBarLabel, { id: labelId, children }) : label2 !== void 0 ? /* @__PURE__ */ jsx$1(ProgressBarLabel, { id: labelId, children: label2 }) : /* @__PURE__ */ jsx$1("span", {}),
      headerRight !== null ? /* @__PURE__ */ jsx$1("span", { className: valueClassName, children: headerRight }) : null
    ] }) : null,
    bar,
    helperText ? /* @__PURE__ */ jsx$1(
      "div",
      {
        className: clsx(styles$x.helper, status2 === "error" && styles$x.error),
        children: helperText
      }
    ) : null
  ] });
};
ProgressBarBase.displayName = "ProgressBar";
const ProgressBar = Object.assign(ProgressBarBase, {
  Root: ProgressBarRoot,
  Indicator: ProgressBarIndicator,
  Label: ProgressBarLabel
});
const BYTES_PER_MEGABYTE = 1024 * 1024;
const DEFAULT_MAX_FILES = 5;
const DEFAULT_MAX_SIZE = 10 * BYTES_PER_MEGABYTE;
const DEFAULT_ACCEPT_FILE_TYPES = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx"
  ],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"]
};
const DEFAULT_LABELS = {
  title: "Attachments",
  titleWithFiles: "Add another attachment",
  dropHint: "Drag and drop or {browse} to upload a PDF, Word or PowerPoint file.",
  browseLink: "browse",
  limitsHint: "{size} per file, up to {count} files.",
  uploadButtonAriaLabel: "Upload an attachment",
  rowEyebrow: "Attachment",
  uploadingText: "Uploading...",
  uploadedText: "Uploaded {date}",
  failedText: "Upload failed",
  cancelAriaLabel: "Cancel upload of {name}",
  removeAriaLabel: "Remove {name}",
  progressAriaLabel: "Uploading {name}",
  errorType: "Upload a PDF, Word or PowerPoint file.",
  errorSize: "One file is over {size}. Upload a smaller one.",
  errorTooManyOne: "Only 1 more file can be attached.",
  errorTooMany: "Only {count} more files can be attached."
};
const fillPlaceholders = (template, values) => Object.entries(values).reduce(
  (text2, [key, value2]) => text2.split(`{${key}}`).join(String(value2)),
  template
);
const formatMaxSize = (bytes) => {
  const megabytes = bytes / BYTES_PER_MEGABYTE;
  const rounded = Number.isInteger(megabytes) ? megabytes : Math.round(megabytes * 10) / 10;
  return `${rounded} MB`;
};
const uploadedDateFormat = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric"
});
const uploadedTimeFormat = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZoneName: "short"
});
const formatUploadedAt = (date) => `${uploadedDateFormat.format(date)}, ${uploadedTimeFormat.format(date)}`;
const rejectionKind = (rejections) => {
  const codes = rejections.flatMap(
    (rejection) => rejection.errors.map((error2) => error2.code)
  );
  if (codes.includes(ErrorCode.FileInvalidType)) {
    return "type";
  }
  if (codes.includes(ErrorCode.FileTooLarge)) {
    return "size";
  }
  return null;
};
const resolveAddition = (accepted, rejections, room) => ({
  files: accepted.slice(0, Math.max(room, 0)),
  error: rejectionKind(rejections) ?? (accepted.length > room ? "too-many" : null)
});
const additionErrorMessage = (error2, room, maxSize, labels) => {
  if (error2 === "type") {
    return labels.errorType;
  }
  if (error2 === "size") {
    return fillPlaceholders(labels.errorSize, { size: formatMaxSize(maxSize) });
  }
  if (error2 === "too-many") {
    return room === 1 ? labels.errorTooManyOne : fillPlaceholders(labels.errorTooMany, { count: room });
  }
  return null;
};
const uploadedStatusText = (file, template, formatUploadedAt2) => fillPlaceholders(template, {
  date: file.uploadedAt ? formatUploadedAt2(file.uploadedAt) : ""
}).trim();
const MultiFileUploadRow = ({
  file,
  labels,
  formatUploadedAt: formatUploadedAt2,
  readOnly: readOnly2,
  dataTestId,
  onCancelUpload,
  onRemoveFile
}) => {
  const placeholders = { name: file.name };
  const editable = !readOnly2;
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: clsx(
        styles$y["row"],
        styles$y[`row--${file.status}`],
        editable && styles$y["row--editable"]
      ),
      "data-testid": `${dataTestId}__row-${file.id}`,
      children: [
        /* @__PURE__ */ jsx$1(MultiFileUploadRowIcon, { icon: "page_outlined" }),
        /* @__PURE__ */ jsxs("div", { className: styles$y["row-body"], children: [
          /* @__PURE__ */ jsx$1("span", { className: styles$y["eyebrow"], children: labels.rowEyebrow }),
          /* @__PURE__ */ jsx$1("div", { className: styles$y["name"], children: /* @__PURE__ */ jsx$1(FileUploadFileName, { fileName: file.name, remeasureKey: file.status }) }),
          file.status === "uploading" && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx$1(
              ProgressBar,
              {
                value: file.progress ?? null,
                size: "sm",
                "aria-label": fillPlaceholders(labels.progressAriaLabel, placeholders),
                className: styles$y["progress"]
              }
            ),
            /* @__PURE__ */ jsx$1(
              "span",
              {
                className: clsx(styles$y["status"], styles$y["status--uploading"]),
                children: labels.uploadingText
              }
            )
          ] }),
          file.status === "uploaded" && /* @__PURE__ */ jsx$1("span", { className: clsx(styles$y["status"], styles$y["status--uploaded"]), children: uploadedStatusText(file, labels.uploadedText, formatUploadedAt2) }),
          file.status === "failed" && /* @__PURE__ */ jsx$1("span", { className: clsx(styles$y["status"], styles$y["status--error"]), children: file.errorMessage ?? labels.failedText })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles$y["row-trailing"], children: [
          file.status === "uploading" && editable && /* @__PURE__ */ jsx$1(
            Button$1,
            {
              variant: "text",
              size: "small",
              iconOnly: true,
              ariaLabel: fillPlaceholders(labels.cancelAriaLabel, placeholders),
              leftIcon: /* @__PURE__ */ jsx$1(Icon$2, { icon: "close" }),
              "data-testid": `${dataTestId}__cancel-button-${file.id}`,
              onClick: onCancelUpload
            }
          ),
          file.status === "uploaded" && /* @__PURE__ */ jsx$1(
            "span",
            {
              className: styles$y["badge"],
              "aria-hidden": "true",
              "data-testid": `${dataTestId}__uploaded-badge-${file.id}`,
              children: /* @__PURE__ */ jsx$1(Icon$2, { icon: "check", width: 12, height: 12 })
            }
          ),
          file.status !== "uploading" && editable && /* @__PURE__ */ jsx$1(
            Button$1,
            {
              variant: "negativeSecondary",
              size: "small",
              iconOnly: true,
              className: styles$y["remove"],
              ariaLabel: fillPlaceholders(labels.removeAriaLabel, placeholders),
              leftIcon: /* @__PURE__ */ jsx$1(Icon$2, { icon: "delete_outline" }),
              "data-testid": `${dataTestId}__remove-button-${file.id}`,
              onClick: onRemoveFile
            }
          )
        ] })
      ]
    }
  );
};
const MultiFileUpload = ({
  files,
  onFilesAdded,
  onCancelUpload,
  onRemoveFile,
  fixedFiles = [],
  maxFiles = DEFAULT_MAX_FILES,
  maxSize = DEFAULT_MAX_SIZE,
  acceptFileTypes = DEFAULT_ACCEPT_FILE_TYPES,
  labels,
  formatUploadedAt: formatUploadedAt$1 = formatUploadedAt,
  readOnly: readOnly2 = false,
  className,
  dataTestId
}) => {
  const allLabels = { ...DEFAULT_LABELS, ...labels };
  const testId = dataTestId || "multi-file-upload";
  const room = maxFiles - files.length;
  const [errorMessage, setErrorMessage] = useState(null);
  const { getRootProps, getInputProps, isDragActive, open: open2 } = useDropzone({
    accept: acceptFileTypes,
    maxSize,
    multiple: true,
    noClick: true,
    noKeyboard: true,
    useFsAccessApi: false,
    onDragEnter: () => setErrorMessage(null),
    onDrop: (accepted, rejections) => {
      const addition = resolveAddition(accepted, rejections, room);
      setErrorMessage(
        additionErrorMessage(addition.error, room, maxSize, allLabels)
      );
      if (addition.files.length > 0) {
        onFilesAdded(addition.files);
      }
    }
  });
  const hasRows = fixedFiles.length > 0 || files.length > 0;
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles$y["container"], className), "data-testid": testId, children: [
    hasRows && /* @__PURE__ */ jsxs("ul", { className: styles$y["list"], children: [
      fixedFiles.map((file) => /* @__PURE__ */ jsx$1(
        MultiFileUploadFixedRow,
        {
          file,
          dataTestId: testId
        },
        file.id
      )),
      files.map((file) => /* @__PURE__ */ jsx$1(
        MultiFileUploadRow,
        {
          file,
          labels: allLabels,
          formatUploadedAt: formatUploadedAt$1,
          readOnly: readOnly2,
          dataTestId: testId,
          onCancelUpload: () => onCancelUpload(file.id),
          onRemoveFile: () => onRemoveFile(file.id)
        },
        file.id
      ))
    ] }),
    !readOnly2 && room > 0 && /* @__PURE__ */ jsx$1(
      MultiFileUploadDropZone,
      {
        rootProps: getRootProps({
          className: clsx(styles$y["box"], isDragActive && styles$y["box--drag"]),
          "data-testid": `${testId}__drop-zone`
        }),
        inputProps: getInputProps({ "aria-hidden": "true", tabIndex: -1 }),
        isDragActive,
        title: files.length > 0 ? allLabels.titleWithFiles : allLabels.title,
        dropHint: allLabels.dropHint,
        browseLink: allLabels.browseLink,
        limitsHint: fillPlaceholders(allLabels.limitsHint, {
          size: formatMaxSize(maxSize),
          count: maxFiles
        }),
        uploadButtonAriaLabel: allLabels.uploadButtonAriaLabel,
        errorMessage,
        dataTestId: testId,
        onOpenPicker: open2
      }
    )
  ] });
};
function _typeof$2(o2) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$2(o2);
}
function toPrimitive$1(t3, r2) {
  if ("object" != _typeof$2(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof$2(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function toPropertyKey$1(t3) {
  var i3 = toPrimitive$1(t3, "string");
  return "symbol" == _typeof$2(i3) ? i3 : i3 + "";
}
function _defineProperty$3(e3, r2, t3) {
  return (r2 = toPropertyKey$1(r2)) in e3 ? Object.defineProperty(e3, r2, {
    value: t3,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e3[r2] = t3, e3;
}
function ownKeys$1(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread2$1(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
function _arrayWithHoles$1(r2) {
  if (Array.isArray(r2)) return r2;
}
function _iterableToArrayLimit$1(r2, l2) {
  var t3 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t3) {
    var e3, n2, i3, u3, a4 = [], f2 = true, o2 = false;
    try {
      if (i3 = (t3 = t3.call(r2)).next, 0 === l2) {
        if (Object(t3) !== t3) return;
        f2 = false;
      } else for (; !(f2 = (e3 = i3.call(t3)).done) && (a4.push(e3.value), a4.length !== l2); f2 = true) ;
    } catch (r3) {
      o2 = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t3["return"] && (u3 = t3["return"](), Object(u3) !== u3)) return;
      } finally {
        if (o2) throw n2;
      }
    }
    return a4;
  }
}
function _arrayLikeToArray$2(r2, a4) {
  (null == a4 || a4 > r2.length) && (a4 = r2.length);
  for (var e3 = 0, n2 = Array(a4); e3 < a4; e3++) n2[e3] = r2[e3];
  return n2;
}
function _unsupportedIterableToArray$2(r2, a4) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray$2(r2, a4);
    var t3 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t3 && r2.constructor && (t3 = r2.constructor.name), "Map" === t3 || "Set" === t3 ? Array.from(r2) : "Arguments" === t3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3) ? _arrayLikeToArray$2(r2, a4) : void 0;
  }
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(r2, e3) {
  return _arrayWithHoles$1(r2) || _iterableToArrayLimit$1(r2, e3) || _unsupportedIterableToArray$2(r2, e3) || _nonIterableRest$1();
}
function _objectWithoutPropertiesLoose$1(r2, e3) {
  if (null == r2) return {};
  var t3 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e3.indexOf(n2)) continue;
    t3[n2] = r2[n2];
  }
  return t3;
}
function _objectWithoutProperties(e3, t3) {
  if (null == e3) return {};
  var o2, r2, i3 = _objectWithoutPropertiesLoose$1(e3, t3);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e3);
    for (r2 = 0; r2 < n2.length; r2++) o2 = n2[r2], -1 === t3.indexOf(o2) && {}.propertyIsEnumerable.call(e3, o2) && (i3[o2] = e3[o2]);
  }
  return i3;
}
var _excluded$6 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties(_ref3, _excluded$6);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray$1(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray$1(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray$1(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value3, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value3, actionMeta);
    }
    setStateValue(value3);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value3, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value3, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value3);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value2 = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2$1(_objectSpread2$1({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value: value2
  });
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t3 = arguments[e3];
      for (var r2 in t3) ({}).hasOwnProperty.call(t3, r2) && (n2[r2] = t3[r2]);
    }
    return n2;
  }, _extends$1.apply(null, arguments);
}
function _classCallCheck$2(a4, n2) {
  if (!(a4 instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e3, r2) {
  for (var t3 = 0; t3 < r2.length; t3++) {
    var o2 = r2[t3];
    o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e3, toPropertyKey$1(o2.key), o2);
  }
}
function _createClass$2(e3, r2, t3) {
  return r2 && _defineProperties$2(e3.prototype, r2), t3 && _defineProperties$2(e3, t3), Object.defineProperty(e3, "prototype", {
    writable: false
  }), e3;
}
function _setPrototypeOf$2(t3, e3) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e4) {
    return t4.__proto__ = e4, t4;
  }, _setPrototypeOf$2(t3, e3);
}
function _inherits$1(t3, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t3.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t3,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t3, "prototype", {
    writable: false
  }), e3 && _setPrototypeOf$2(t3, e3);
}
function _getPrototypeOf$1(t3) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$1(t3);
}
function _isNativeReflectConstruct$1() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _assertThisInitialized$2(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function _possibleConstructorReturn$1(t3, e3) {
  if (e3 && ("object" == _typeof$2(e3) || "function" == typeof e3)) return e3;
  if (void 0 !== e3) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(t3);
}
function _createSuper$1(t3) {
  var r2 = _isNativeReflectConstruct$1();
  return function() {
    var e3, o2 = _getPrototypeOf$1(t3);
    if (r2) {
      var s4 = _getPrototypeOf$1(this).constructor;
      e3 = Reflect.construct(o2, arguments, s4);
    } else e3 = o2.apply(this, arguments);
    return _possibleConstructorReturn$1(this, e3);
  };
}
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray$2(r2);
}
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray$2(r2) || _nonIterableSpread();
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i3 = 0; i3 < document.styleSheets.length; i3++) {
    if (document.styleSheets[i3].ownerNode === tag) {
      return document.styleSheets[i3];
    }
  }
  return void 0;
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e3) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
})();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign$1 = Object.assign;
function hash$2(value2, length2) {
  return charat(value2, 0) ^ 45 ? (((length2 << 2 ^ charat(value2, 0)) << 2 ^ charat(value2, 1)) << 2 ^ charat(value2, 2)) << 2 ^ charat(value2, 3) : 0;
}
function trim(value2) {
  return value2.trim();
}
function match$2(value2, pattern) {
  return (value2 = pattern.exec(value2)) ? value2[0] : value2;
}
function replace(value2, pattern, replacement) {
  return value2.replace(pattern, replacement);
}
function indexof(value2, search) {
  return value2.indexOf(search);
}
function charat(value2, index2) {
  return value2.charCodeAt(index2) | 0;
}
function substr(value2, begin, end2) {
  return value2.slice(begin, end2);
}
function strlen(value2) {
  return value2.length;
}
function sizeof(value2) {
  return value2.length;
}
function append(value2, array) {
  return array.push(value2), value2;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value2, root2, parent, type2, props, children, length2) {
  return { value: value2, root: root2, parent, type: type2, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign$1(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type2) {
  switch (type2) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value2) {
  return line = column = 1, length = strlen(characters = value2), position = 0, [];
}
function dealloc(value2) {
  return characters = "", value2;
}
function delimit(type2) {
  return trim(slice(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      // ] ) " '
      case type2:
        return position;
      // " '
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value2) {
  return dealloc(parse$1("", null, null, null, [""], value2 = alloc(value2), 0, [0], value2));
}
function parse$1(value2, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset3 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      // (
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      // \
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset3:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference2 = ruleset(characters2, root2, parent, index2, offset3, rules, points, type2, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset3 === 0)
                parse$1(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(value2, reference2, reference2, rule && append(ruleset(value2, reference2, reference2, 0, 0, rules, points, type2, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse$1(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
                }
        }
        index2 = offset3 = property = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset3 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset3 = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value2, root2, parent, index2, offset3, rules, points, type2, props, children, length2) {
  var post = offset3 - 1;
  var rule = offset3 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i3 = 0, j = 0, k3 = 0; i3 < index2; ++i3)
    for (var x3 = 0, y3 = substr(value2, post + 1, post = abs(j = points[i3])), z3 = value2; x3 < size; ++x3)
      if (z3 = trim(j > 0 ? rule[x3] + " " + y3 : replace(y3, /&\f/g, rule[x3])))
        props[k3++] = z3;
  return node(value2, root2, parent, offset3 === 0 ? RULESET : type2, props, children, length2);
}
function comment(value2, root2, parent) {
  return node(value2, root2, parent, COMMENT, from(char()), substr(value2, 2, -2), 0);
}
function declaration(value2, root2, parent, length2) {
  return node(value2, root2, parent, DECLARATION, substr(value2, 0, length2), substr(value2, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i3 = 0; i3 < length2; i3++)
    output += callback(children[i3], i3, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i3 = 0; i3 < length2; i3++)
      output += collection[i3](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize(fn2) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0) cache[arg] = fn2(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      // fallthrough
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value2, points) {
  return dealloc(toRules(alloc(value2), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value2 = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value2.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value2, points);
  var parentRules = parent.props;
  for (var i3 = 0, k3 = 0; i3 < rules.length; i3++) {
    for (var j = 0; j < parentRules.length; j++, k3++) {
      element.props[k3] = points[i3] ? rules[i3].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i3];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value2 = element.value;
    if (
      // charcode for l
      value2.charCodeAt(0) === 108 && // charcode for b
      value2.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value2, length2) {
  switch (hash$2(value2, length2)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + value2 + value2;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value2 + value2;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value2 + MOZ + value2 + MS + value2 + value2;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + value2 + MS + value2 + value2;
    // order
    case 6165:
      return WEBKIT + value2 + MS + "flex-" + value2 + value2;
    // align-items
    case 5187:
      return WEBKIT + value2 + replace(value2, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value2;
    // align-self
    case 5443:
      return WEBKIT + value2 + MS + "flex-item-" + replace(value2, /flex-|-self/, "") + value2;
    // align-content
    case 4675:
      return WEBKIT + value2 + MS + "flex-line-pack" + replace(value2, /align-content|flex-|-self/, "") + value2;
    // flex-shrink
    case 5548:
      return WEBKIT + value2 + MS + replace(value2, "shrink", "negative") + value2;
    // flex-basis
    case 5292:
      return WEBKIT + value2 + MS + replace(value2, "basis", "preferred-size") + value2;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace(value2, "-grow", "") + WEBKIT + value2 + MS + replace(value2, "grow", "positive") + value2;
    // transition
    case 4554:
      return WEBKIT + replace(value2, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value2;
    // cursor
    case 6187:
      return replace(replace(replace(value2, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value2, "") + value2;
    // background, background-image
    case 5495:
    case 3959:
      return replace(value2, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace(replace(value2, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value2 + value2;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value2, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value2;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value2) - 1 - length2 > 6) switch (charat(value2, length2 + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(value2, length2 + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace(value2, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value2, length2 + 3) == 108 ? "$3" : "$2-$3")) + value2;
        // (s)tretch
        case 115:
          return ~indexof(value2, "stretch") ? prefix(replace(value2, "stretch", "fill-available"), length2) + value2 : value2;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(value2, length2 + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(value2, strlen(value2) - 3 - (~indexof(value2, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace(value2, ":", ":" + WEBKIT) + value2;
        // (inline-)?fl(e)x
        case 101:
          return replace(value2, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value2, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value2;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(value2, length2 + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "tb") + value2;
        // vertical-r(l)
        case 108:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "tb-rl") + value2;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "lr") + value2;
      }
      return WEBKIT + value2 + MS + value2 + value2;
  }
  return value2;
}
var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element.length) return combine(element.props, function(value2) {
          switch (match$2(value2, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ":read-only":
            case ":read-write":
              return serialize([copy(element, {
                props: [replace(value2, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            // :placeholder
            case "::placeholder":
              return serialize([copy(element, {
                props: [replace(value2, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace(value2, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace(value2, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container2;
  var nodesToHydrate = [];
  {
    container2 = options2.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i3 = 1; i3 < attrib.length; i3++) {
          inserted[attrib[i3]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container: container2,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b3 = "function" === typeof Symbol && Symbol.for, c3 = b3 ? /* @__PURE__ */ Symbol.for("react.element") : 60103, d4 = b3 ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, e3 = b3 ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f2 = b3 ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, g2 = b3 ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, h4 = b3 ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, k3 = b3 ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l2 = b3 ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, m4 = b3 ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, n2 = b3 ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, p2 = b3 ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, q3 = b3 ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, r2 = b3 ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, t3 = b3 ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, v2 = b3 ? /* @__PURE__ */ Symbol.for("react.block") : 60121, w3 = b3 ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, x3 = b3 ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, y3 = b3 ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function z3(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var u3 = a4.$$typeof;
      switch (u3) {
        case c3:
          switch (a4 = a4.type, a4) {
            case l2:
            case m4:
            case e3:
            case g2:
            case f2:
            case p2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n2:
                case t3:
                case r2:
                case h4:
                  return a4;
                default:
                  return u3;
              }
          }
        case d4:
          return u3;
      }
    }
  }
  function A2(a4) {
    return z3(a4) === m4;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m4;
  reactIs_production_min$1.ContextConsumer = k3;
  reactIs_production_min$1.ContextProvider = h4;
  reactIs_production_min$1.Element = c3;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e3;
  reactIs_production_min$1.Lazy = t3;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d4;
  reactIs_production_min$1.Profiler = g2;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a4) {
    return A2(a4) || z3(a4) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A2;
  reactIs_production_min$1.isContextConsumer = function(a4) {
    return z3(a4) === k3;
  };
  reactIs_production_min$1.isContextProvider = function(a4) {
    return z3(a4) === h4;
  };
  reactIs_production_min$1.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === c3;
  };
  reactIs_production_min$1.isForwardRef = function(a4) {
    return z3(a4) === n2;
  };
  reactIs_production_min$1.isFragment = function(a4) {
    return z3(a4) === e3;
  };
  reactIs_production_min$1.isLazy = function(a4) {
    return z3(a4) === t3;
  };
  reactIs_production_min$1.isMemo = function(a4) {
    return z3(a4) === r2;
  };
  reactIs_production_min$1.isPortal = function(a4) {
    return z3(a4) === d4;
  };
  reactIs_production_min$1.isProfiler = function(a4) {
    return z3(a4) === g2;
  };
  reactIs_production_min$1.isStrictMode = function(a4) {
    return z3(a4) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a4) {
    return z3(a4) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === e3 || a4 === m4 || a4 === g2 || a4 === f2 || a4 === p2 || a4 === q3 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t3 || a4.$$typeof === r2 || a4.$$typeof === h4 || a4.$$typeof === k3 || a4.$$typeof === n2 || a4.$$typeof === w3 || a4.$$typeof === x3 || a4.$$typeof === y3 || a4.$$typeof === v2);
  };
  reactIs_production_min$1.typeOf = z3;
  return reactIs_production_min$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  {
    reactIs$1.exports = requireReactIs_production_min$1();
  }
  return reactIs$1.exports;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs$1();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i3 = 0; i3 < keys.length; ++i3) {
        var key = keys[i3];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty(targetComponent, key, descriptor);
          } catch (e3) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
var isBrowser$1 = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h4 = 0;
  var k3, i3 = 0, len = str.length;
  for (; len >= 4; ++i3, len -= 4) {
    k3 = str.charCodeAt(i3) & 255 | (str.charCodeAt(++i3) & 255) << 8 | (str.charCodeAt(++i3) & 255) << 16 | (str.charCodeAt(++i3) & 255) << 24;
    k3 = /* Math.imul(k, m): */
    (k3 & 65535) * 1540483477 + ((k3 >>> 16) * 59797 << 16);
    k3 ^= /* k >>> r: */
    k3 >>> 24;
    h4 = /* Math.imul(k, m): */
    (k3 & 65535) * 1540483477 + ((k3 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h4 & 65535) * 1540483477 + ((h4 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h4 ^= (str.charCodeAt(i3 + 2) & 255) << 16;
    case 2:
      h4 ^= (str.charCodeAt(i3 + 1) & 255) << 8;
    case 1:
      h4 ^= str.charCodeAt(i3) & 255;
      h4 = /* Math.imul(h, m): */
      (h4 & 65535) * 1540483477 + ((h4 >>> 16) * 59797 << 16);
  }
  h4 ^= h4 >>> 13;
  h4 = /* Math.imul(h, m): */
  (h4 & 65535) * 1540483477 + ((h4 >>> 16) * 59797 << 16);
  return ((h4 ^ h4 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value2) {
  return value2 != null && typeof value2 !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value2) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value2 === "string") {
        return value2.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value2 === "number" && value2 !== 0) {
    return value2 + "px";
  }
  return value2;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  {
    return asString;
  }
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i3 = 0; i3 < obj.length; i3++) {
      string += handleInterpolation(mergedProps, registered, obj[i3]) + ";";
    }
  } else {
    for (var key in obj) {
      var value2 = obj[key];
      if (typeof value2 !== "object") {
        var asString = value2;
        if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value2) && typeof value2[0] === "string" && registered == null) {
          for (var _i = 0; _i < value2.length; _i++) {
            if (isProcessableValue(value2[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value2[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value2);
          switch (key) {
            case "animation":
            case "animationName": {
              string += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i3 = 1; i3 < args.length; i3++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i3]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i3];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name2 = murmur2(styles2) + identifierName;
  return {
    name: name2,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect$1 = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect$1 || syncFallback;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref2) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref2);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type2, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type2;
  return newProps;
};
var Insertion = function Insertion2(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref2) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && true) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref2) {
    newProps.ref = ref2;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var jsx = function jsx2(type2, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type2, props);
  for (var i3 = 2; i3 < argsLength; i3++) {
    createElementArgArray[i3] = args[i3];
  }
  return React.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  /* @__PURE__ */ (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name2 = "animation-" + insertable.name;
  return {
    name: name2,
    styles: "@keyframes " + name2 + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function _taggedTemplateLiteral(e3, t3) {
  return t3 || (t3 = e3.slice(0)), Object.freeze(Object.defineProperties(e3, {
    raw: {
      value: Object.freeze(t3)
    }
  }));
}
var index$2 = useLayoutEffect$1;
var _excluded$4$1 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop$2 = function noop2() {
};
function applyPrefixToName(prefix2, name2) {
  if (!name2) {
    return prefix2;
  } else if (name2[0] === "-") {
    return prefix2 + name2;
  } else {
    return prefix2 + "__" + name2;
  }
}
function classNames(prefix2, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i3) {
    return i3;
  }).map(function(i3) {
    return String(i3).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value2) {
  if (isArray(value2)) return value2.filter(Boolean);
  if (_typeof$2(value2) === "object" && value2 !== null) return [value2];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$4$1);
  return _objectSpread2$1({}, innerProps);
};
var getStyleProps = function getStyleProps2(props, name2, classNamesState) {
  var cx = props.cx, getStyles2 = props.getStyles, getClassNames = props.getClassNames, className = props.className;
  return {
    css: getStyles2(name2, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name2, props), className)
  };
};
function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === "string") return _newValue;
  }
  return inputValue;
}
function isDocumentElement$1(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement$1(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop$1(el) {
  if (isDocumentElement$1(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top2) {
  if (isDocumentElement$1(el)) {
    window.scrollTo(0, top2);
    return;
  }
  el.scrollTop = top2;
}
function getScrollParent$1(element) {
  var style2 = getComputedStyle(element);
  var excludeStaticParent = style2.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style2.position === "fixed") return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style2 = getComputedStyle(parent);
    if (excludeStaticParent && style2.position === "static") {
      continue;
    }
    if (overflowRx.test(style2.overflow + style2.overflowY + style2.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t3, b3, c3, d4) {
  return c3 * ((t3 = t3 / d4 - 1) * t3 * t3 + 1) + b3;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$2;
  var start2 = getScrollTop$1(element);
  var change = to - start2;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e3) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e3) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w$2 = typeof window !== "undefined" ? window : {};
if (w$2.addEventListener && w$2.removeEventListener) {
  w$2.addEventListener("p", noop$2, options);
  w$2.removeEventListener("p", noop$2, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item2) {
  return item2 != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function(_ref3) {
    var _ref22 = _slicedToArray$1(_ref3, 1), key = _ref22[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function(newProps, _ref3) {
    var _ref4 = _slicedToArray$1(_ref3, 2), key = _ref4[0], val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
var _excluded$3$1 = ["children", "innerProps"], _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, preferredPlacement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent$1(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent) return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop$1(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22, unstyled) {
  var _objectSpread22;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _objectSpread2$1((_objectSpread22 = {
    label: "menu"
  }, _defineProperty$3(_objectSpread22, alignToControl(placement), "100%"), _defineProperty$3(_objectSpread22, "position", "absolute"), _defineProperty$3(_objectSpread22, "width", "100%"), _defineProperty$3(_objectSpread22, "zIndex", 1), _objectSpread22), unstyled ? {} : {
    backgroundColor: colors2.neutral0,
    borderRadius: borderRadius2,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: spacing2.menuGutter,
    marginTop: spacing2.menuGutter
  });
};
var PortalPlacementContext = /* @__PURE__ */ createContext(null);
var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
  var ref2 = useRef(null);
  var _useState = useState(maxMenuHeight), _useState2 = _slicedToArray$1(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
  var _useState3 = useState(null), _useState4 = _slicedToArray$1(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
  var controlHeight2 = theme.spacing.controlHeight;
  index$2(function() {
    var menuEl = ref2.current;
    if (!menuEl) return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll,
      isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref: ref2,
    placerProps: _objectSpread2$1(_objectSpread2$1({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight
    })
  });
};
var Menu$1 = function Menu2(props) {
  var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "menu", {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1$1 = Menu$1;
var menuListCSS = function menuListCSS2(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return _objectSpread2$1({
    maxHeight,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, unstyled ? {} : {
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2
  });
};
var MenuList$4 = function MenuList2(props) {
  var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends$1({}, getStyleProps(props, "menuList", {
    "menu-list": true,
    "menu-list--is-multi": isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return _objectSpread2$1({
    textAlign: "center"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage$2 = function NoOptionsMessage2(_ref6) {
  var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = _objectWithoutProperties(_ref6, _excluded$3$1);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2$1(_objectSpread2$1({}, restProps), {}, {
    children,
    innerProps
  }), "noOptionsMessage", {
    "menu-notice": true,
    "menu-notice--no-options": true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage2(_ref7) {
  var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = _objectWithoutProperties(_ref7, _excluded2$1);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2$1(_objectSpread2$1({}, restProps), {}, {
    children,
    innerProps
  }), "loadingMessage", {
    "menu-notice": true,
    "menu-notice--loading": true
  }), innerProps), children);
};
var menuPortalCSS = function menuPortalCSS2(_ref8) {
  var rect = _ref8.rect, offset3 = _ref8.offset, position2 = _ref8.position;
  return {
    left: rect.left,
    position: position2,
    top: offset3,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal2(props) {
  var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)), _useState6 = _slicedToArray$1(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function() {
    return {
      setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null), _useState8 = _slicedToArray$1(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function() {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset3 = rect[placement] + scrollDistance;
    if (offset3 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset3,
        rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index$2(function() {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function() {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index$2(function() {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function(menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
  var menuWrapper = jsx("div", _extends$1({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), "menuPortal", {
    "menu-portal": true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
};
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$1({}, getStyleProps(props, "container", {
    "--is-disabled": isDisabled,
    "--is-rtl": isRtl
  }), innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22, unstyled) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return _objectSpread2$1({
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, unstyled ? {} : {
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px")
  });
};
var ValueContainer$1 = function ValueContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
  return jsx("div", _extends$1({}, getStyleProps(props, "valueContainer", {
    "value-container": true,
    "value-container--is-multi": isMulti,
    "value-container--has-value": hasValue
  }), innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "indicatorsContainer", {
    indicators: true
  }), innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"], _excluded2$2 = ["innerProps", "isRtl", "size"];
var _ref2$2 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$2$1);
  return jsx("svg", _extends$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3, unstyled) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return _objectSpread2$1({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2,
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "dropdownIndicator", {
    indicator: true,
    "dropdown-indicator": true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator$2 = function ClearIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "clearIndicator", {
    indicator: true,
    "clear-indicator": true
  }), innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return _objectSpread2$1({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, getStyleProps(props, "indicatorSeparator", {
    "indicator-separator": true
  })));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5, unstyled) {
  var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return _objectSpread2$1({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2
  });
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset3 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset3 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(_ref7) {
  var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = _objectWithoutProperties(_ref7, _excluded2$2);
  return jsx("div", _extends$1({}, getStyleProps(_objectSpread2$1(_objectSpread2$1({}, restProps), {}, {
    innerProps,
    isRtl,
    size
  }), "loadingIndicator", {
    indicator: true,
    "loading-indicator": true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
var css$1 = function css(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return _objectSpread2$1({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  });
};
var Control$1 = function Control2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef
  }, getStyleProps(props, "control", {
    control: true,
    "control--is-disabled": isDisabled,
    "control--is-focused": isFocused,
    "control--menu-is-open": menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || void 0
  }), children);
};
var Control$1$1 = Control$1;
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3, unstyled) {
  var spacing2 = _ref3.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, cx = props.cx, getStyles2 = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label2 = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "group", {
    group: true
  }), innerProps), jsx(Heading, _extends$1({}, headingProps, {
    selectProps,
    theme,
    getStyles: getStyles2,
    getClassNames,
    cx
  }), label2), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, colors2 = _ref2$theme.colors, spacing2 = _ref2$theme.spacing;
  return _objectSpread2$1({
    label: "group",
    cursor: "default",
    display: "block"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  });
};
var GroupHeading = function GroupHeading2(props) {
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$1({}, getStyleProps(props, "groupHeading", {
    "group-heading": true
  }), innerProps));
};
var Group$1 = Group;
var _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, value2 = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2$1(_objectSpread2$1({
    visibility: isDisabled ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value2 ? "translateZ(0)" : ""
  }, containerStyle), unstyled ? {} : {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    color: colors2.neutral80
  });
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2$1({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden3) {
  return _objectSpread2$1({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden3 ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input$2 = function Input2(props) {
  var cx = props.cx, value2 = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden3 = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$5);
  return jsx("div", _extends$1({}, getStyleProps(props, "input", {
    "input-container": true
  }), {
    "data-value": value2 || ""
  }), jsx("input", _extends$1({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden3),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1$1 = Input$2;
var multiValueCSS = function multiValueCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return _objectSpread2$1({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    margin: spacing2.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return _objectSpread2$1({
    overflow: "hidden",
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return _objectSpread2$1({
    alignItems: "center",
    display: "flex"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends$1({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue$1 = function MultiValue2(props) {
  var children = props.children, components2 = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps3 = props.removeProps, selectProps = props.selectProps;
  var Container = components2.Container, Label = components2.Label, Remove = components2.Remove;
  return jsx(Container, {
    data,
    innerProps: _objectSpread2$1(_objectSpread2$1({}, getStyleProps(props, "multiValue", {
      "multi-value": true,
      "multi-value--is-disabled": isDisabled
    })), innerProps),
    selectProps
  }, jsx(Label, {
    data,
    innerProps: _objectSpread2$1({}, getStyleProps(props, "multiValueLabel", {
      "multi-value__label": true
    })),
    selectProps
  }, children), jsx(Remove, {
    data,
    innerProps: _objectSpread2$1(_objectSpread2$1({}, getStyleProps(props, "multiValueRemove", {
      "multi-value__remove": true
    })), {}, {
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps3),
    selectProps
  }));
};
var MultiValue$1$1 = MultiValue$1;
var optionCSS = function optionCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2$1({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  });
};
var Option$2 = function Option2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "option", {
    option: true,
    "option--is-disabled": isDisabled,
    "option--is-focused": isFocused,
    "option--is-selected": isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1$1 = Option$2;
var placeholderCSS = function placeholderCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2$1({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, unstyled ? {} : {
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "placeholder", {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css2 = function css3(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2$1({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var SingleValue$1 = function SingleValue2(props) {
  var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "singleValue", {
    "single-value": true,
    "single-value--is-disabled": isDisabled
  }), innerProps), children);
};
var SingleValue$1$1 = SingleValue$1;
var components = {
  ClearIndicator: ClearIndicator$2,
  Control: Control$1$1,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group: Group$1,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input: Input$1$1,
  LoadingIndicator,
  Menu: Menu$1$1,
  MenuList: MenuList$4,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage: NoOptionsMessage$2,
  MultiValue: MultiValue$1$1,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option: Option$1$1,
  Placeholder: Placeholder$1,
  SelectContainer,
  SingleValue: SingleValue$1$1,
  ValueContainer: ValueContainer$1
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2$1(_objectSpread2$1({}, components), props.components);
};
var safeIsNaN = Number.isNaN || function ponyfill(value2) {
  return typeof value2 === "number" && value2 !== value2;
};
function isEqual$4(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i3 = 0; i3 < newInputs.length; i3++) {
    if (!isEqual$4(newInputs[i3], lastInputs[i3])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache = null;
  function memoized2() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized2.clear = function clear() {
    cache = null;
  };
  return memoized2;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$1({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label2 = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label2, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label2, " is disabled. Select another option.") : "option ".concat(label2, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label2 = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice2 = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex2(arr, item2) {
      return arr && arr.length ? "".concat(arr.indexOf(item2) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label2, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu" && isAppleDevice2) {
      var disabled2 = isDisabled ? " disabled" : "";
      var status2 = "".concat(isSelected ? " selected" : "").concat(disabled2);
      return "".concat(label2).concat(status2, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice2 = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message2 = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value2 = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected2 = removedValue || option || asOption(value2);
      var label2 = selected2 ? getOptionLabel4(selected2) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2$1({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected2 && isOptionDisabled3(selected2, selectValue),
        label: label2,
        labels
      }, ariaSelection);
      message2 = messages.onChange(onChangeProps);
    }
    return message2;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? "menu" : "value",
        selectValue,
        isAppleDevice: isAppleDevice2
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue, isAppleDevice2]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue,
        isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(Fragment$1, null, jsx(A11yText$1, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d4) {
  return d4.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i$2 = 0; i$2 < diacritics.length; i$2++) {
  var diacritic = diacritics[i$2];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2$1({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input2 = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input2 = input2.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input2 = memoizedStripDiacriticsForInput(input2);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input2.length) === input2 : candidate.indexOf(input2) > -1;
  };
};
var _excluded$4 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties(_ref3, _excluded$4);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends$1({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el) return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e3) {
  e3.preventDefault();
}
function allowTouchMove(e3) {
  e3.stopPropagation();
}
function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;
  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
var _ref2 = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput2(_ref3) {
  var name2 = _ref3.name, onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name: name2,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange2() {
    }
  });
};
var RequiredInput$1 = RequiredInput;
function testPlatform(re2) {
  var _window$navigator$use;
  return typeof window !== "undefined" && window.navigator != null ? re2.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel2(group2) {
  return group2.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing$1 = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing: spacing$1
};
var defaultProps = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count2 = _ref3.count;
    return "".concat(count2, " result").concat(count2 !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label2 = getOptionLabel2(props, option);
  var value2 = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label: label2,
    value: value2,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable$1(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable$1(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable$1(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label2 = categorizedOption.label, value2 = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label2,
    value: value2,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getFocusedOptionId = function getFocusedOptionId2(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel2 = function getOptionLabel3(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i3) {
    return getOptionValue2(props, i3) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select$2 = /* @__PURE__ */ (function(_Component) {
  _inherits$1(Select22, _Component);
  var _super = _createSuper$1(Select22);
  function Select22(_props) {
    var _this;
    _classCallCheck$2(this, Select22);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function(ref2) {
      _this.controlRef = ref2;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref2) {
      _this.focusedOptionRef = ref2;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref2) {
      _this.menuListRef = ref2;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref2) {
      _this.inputRef = ref2;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name2 = _this$props.name;
      actionMeta.name = name2;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name2 = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i3) {
          return _this.getOptionValue(i3) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name: name2
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i3) {
        return _this.getOptionValue(i3) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getFocusedOptionId = function(focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function() {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return getOptionLabel2(_this.props, data);
    };
    _this.getOptionValue = function(data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function(key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function(key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function(element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value2, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2$1({
          value: value2
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement$1(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options2 = _this.getFocusableOptions();
      var focusedOptionIndex = options2.indexOf(focusedOption);
      _this.setState({
        focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function(e3) {
      e3.preventDefault();
      e3.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue) return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue) return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen) return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen) return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen) return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen) return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass$2(Select22, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
        // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen
      ) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length) return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1) nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options2[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      (function getTheme() {
        if (!this.props.theme) {
          return defaultTheme;
        }
        if (typeof this.props.theme === "function") {
          return this.props.theme(defaultTheme);
        }
        return _objectSpread2$1(_objectSpread2$1({}, defaultTheme), this.props.theme);
      })
    )
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles2 = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption2 = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles: getStyles2,
        getClassNames,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption: selectOption2,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0) return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      (function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener("compositionstart", this.onCompositionStart, false);
          document.addEventListener("compositionend", this.onCompositionEnd, false);
        }
      })
    )
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      (function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener("touchstart", this.onTouchStart, false);
          document.addEventListener("touchmove", this.onTouchMove, false);
          document.addEventListener("touchend", this.onTouchEnd, false);
        }
      })
    )
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      (function renderInput() {
        var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
        var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
        var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
        var commonProps = this.commonProps;
        var id = inputId || this.getElementId("input");
        var ariaAttributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
          "aria-autocomplete": "list",
          "aria-expanded": menuIsOpen,
          "aria-haspopup": true,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": required,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, menuIsOpen && {
          "aria-controls": this.getElementId("listbox")
        }), !isSearchable && {
          "aria-readonly": true
        }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        if (!isSearchable) {
          return /* @__PURE__ */ React.createElement(DummyInput, _extends$1({
            id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop$2,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex,
            inputMode: "none",
            form,
            value: ""
          }, ariaAttributes));
        }
        return /* @__PURE__ */ React.createElement(Input3, _extends$1({}, commonProps, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id,
          innerRef: this.getInputRef,
          isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex,
          form,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      })
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder2 = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React.createElement(Placeholder3, _extends$1({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder2);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React.createElement(MultiValue3, _extends$1({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e3) {
                e3.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React.createElement(SingleValue3, _extends$1({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(ClearIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading) return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(LoadingIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React.createElement(IndicatorSeparator3, _extends$1({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(DropdownIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal3 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;
      var render = function render2(props, id) {
        var type2 = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label2 = props.label, value2 = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: "option",
          "aria-selected": _this4.isAppleDevice ? void 0 : isSelected
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ React.createElement(Option3, _extends$1({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label: label2,
          type: type2,
          value: value2,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item2) {
          if (item2.type === "group") {
            var _data = item2.data, options2 = item2.options, groupIndex = item2.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React.createElement(Group3, _extends$1({}, commonProps, {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item2.data
              },
              label: _this4.formatGroupLabel(item2.data)
            }), item2.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item2.type === "option") {
            return render(item2, "".concat(item2.index));
          }
        });
      } else if (isLoading) {
        var message2 = loadingMessage2({
          inputValue
        });
        if (message2 === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(LoadingMessage3, commonProps, message2);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref2 = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React.createElement(Menu3, _extends$1({}, commonProps, menuPlacementProps, {
          innerRef: ref2,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading,
          placement
        }), /* @__PURE__ */ React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React.createElement(MenuList3, _extends$1({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": commonProps.isMulti,
              id: _this4.getElementId("listbox")
            },
            isLoading,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React.createElement(MenuPortal3, _extends$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name2 = _this$props13.name, required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /* @__PURE__ */ React.createElement(RequiredInput$1, {
          name: name2,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name2 || isDisabled) return;
      if (isMulti) {
        if (delimiter2) {
          var value2 = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React.createElement("input", {
            name: name2,
            type: "hidden",
            value: value2
          });
        } else {
          var input2 = selectValue.length > 0 ? selectValue.map(function(opt, i3) {
            return /* @__PURE__ */ React.createElement("input", {
              key: "i-".concat(i3),
              name: name2,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React.createElement("input", {
            name: name2,
            type: "hidden",
            value: ""
          });
          return /* @__PURE__ */ React.createElement("div", null, input2);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React.createElement("input", {
          name: name2,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React.createElement(LiveRegion$1, _extends$1({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React.createElement(SelectContainer3, _extends$1({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React.createElement(Control3, _extends$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React.createElement(ValueContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React.createElement(IndicatorsContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps2(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
      var options2 = props.options, value2 = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value2);
      var newMenuOptionsState = {};
      if (prevProps && (value2 !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedOptionId,
          focusableOptionsWithIds,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select22;
})(Component);
Select$2.defaultProps = defaultProps;
var StateManagedSelect = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */ React.createElement(Select$2, _extends$1({
    ref: ref2
  }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
function Input$1(props) {
  const { ariaDisabled, menuIsOpen, id } = props.selectProps;
  return /* @__PURE__ */ jsx$1(
    components.Input,
    {
      ...props,
      "aria-disabled": ariaDisabled,
      "aria-expanded": menuIsOpen,
      "aria-controls": id,
      autoComplete: "off",
      ...ariaDisabled && {
        onChange: (e3) => {
          e3.preventDefault();
        }
      }
    }
  );
}
const selectOption$1 = "multiselect-module_selectOption__OC-68";
const circle$1 = "multiselect-module_circle__7T1ma";
const labelWrapper$1 = "multiselect-module_labelWrapper__mXeJh";
const label$5 = "multiselect-module_label__4uQU9";
const selectOptionNote$1 = "multiselect-module_selectOptionNote__qvrE1";
const labelDescriptionContainer$1 = "multiselect-module_labelDescriptionContainer__A-pMU";
const labelDescriptionWrapper$1 = "multiselect-module_labelDescriptionWrapper__4QZKA";
const labelDescription$1 = "multiselect-module_labelDescription__t7lOC";
const labelCounter$1 = "multiselect-module_labelCounter__NqIPY";
const labelCounterContent$1 = "multiselect-module_labelCounterContent__NPG8u";
const labelCounterIcon$1 = "multiselect-module_labelCounterIcon__o6yh4";
const chip$1 = "multiselect-module_chip__3ngLN";
const loadMoreWrapper = "multiselect-module_loadMoreWrapper__DguzE";
const disabledOptions = "multiselect-module_disabledOptions__Mimqi";
const truncatedLabel$1 = "multiselect-module_truncatedLabel__NCatw";
const paginatedOptionsLoader$1 = "multiselect-module_paginatedOptionsLoader__1-6HC";
const styles$w = {
  selectOption: selectOption$1,
  circle: circle$1,
  labelWrapper: labelWrapper$1,
  label: label$5,
  selectOptionNote: selectOptionNote$1,
  labelDescriptionContainer: labelDescriptionContainer$1,
  labelDescriptionWrapper: labelDescriptionWrapper$1,
  labelDescription: labelDescription$1,
  labelCounter: labelCounter$1,
  labelCounterContent: labelCounterContent$1,
  labelCounterIcon: labelCounterIcon$1,
  chip: chip$1,
  loadMoreWrapper,
  disabledOptions,
  truncatedLabel: truncatedLabel$1,
  paginatedOptionsLoader: paginatedOptionsLoader$1
};
function MenuList$3(props) {
  const [optionsDisabled, setOptionsDisabled] = React__default.useState(false);
  const { children } = props;
  const {
    loadMoreButtonRef,
    isDataLoading,
    loadMoreButtonText,
    loadingText,
    loadMore,
    loadMoreDisabled,
    onLoadMore,
    loadingPaginatedOptions,
    loadOnScroll
  } = props.selectProps;
  function handleEnterKey(e3) {
    if (e3.key === "Enter") {
      onLoadMore && onLoadMore();
      e3.stopPropagation();
    }
  }
  const innerProps = {
    ...props.innerProps,
    "data-testid": "search-menu"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      components.MenuList,
      {
        ...props,
        innerProps,
        className: clsx(optionsDisabled && styles$w.disabledOptions),
        children: [
          children,
          loadingPaginatedOptions && /* @__PURE__ */ jsx$1("div", { className: styles$w.paginatedOptionsLoader, children: /* @__PURE__ */ jsx$1(Loader, { size: "small", variant: "bubbles" }) })
        ]
      }
    ),
    loadMore && loadingPaginatedOptions !== true && loadOnScroll !== true && /* @__PURE__ */ jsx$1("div", { className: styles$w.loadMoreWrapper, children: /* @__PURE__ */ jsx$1(
      Button$1,
      {
        ref: loadMoreButtonRef,
        variant: "secondary",
        size: "small",
        disabled: loadMoreDisabled,
        "data-testid": "search-load-more-button",
        onClick: onLoadMore,
        onKeyDown: handleEnterKey,
        onFocus: () => setOptionsDisabled(true),
        onBlur: () => setOptionsDisabled(false),
        children: isDataLoading ? loadingText : loadMoreButtonText
      }
    ) })
  ] });
}
const AVG_CHAR_WIDTH_AT_12px$1 = 6;
const CustomOption$1 = (props) => {
  const { label: label2, data, isSelected, isDisabled } = props;
  const labelContainerRef = useRef(null);
  const labelDescriptionRef = useRef(null);
  const [shouldTruncate, setShouldTruncate] = React__default.useState(false);
  const [remainingSpaceForLabel, setRemainingSpaceForLabel] = React__default.useState(0);
  useLayoutEffect$1(() => {
    if (!label2 || !labelContainerRef.current || !labelDescriptionRef.current || labelDescriptionRef?.current?.clientWidth === 0)
      return;
    const dropdownOptionWidth = labelContainerRef.current.clientWidth;
    const dropdownOptionLabelDescriptionWidth = labelDescriptionRef.current.clientWidth;
    const labelWidth = label2.length * AVG_CHAR_WIDTH_AT_12px$1;
    if (dropdownOptionWidth - dropdownOptionLabelDescriptionWidth - labelWidth < 0) {
      setShouldTruncate(true);
      setRemainingSpaceForLabel(
        dropdownOptionWidth - dropdownOptionLabelDescriptionWidth
      );
    }
  }, [labelContainerRef.current, labelDescriptionRef.current, label2]);
  return /* @__PURE__ */ jsx$1(
    components.Option,
    {
      ...props,
      "aria-checked": isSelected,
      isDisabled,
      children: /* @__PURE__ */ jsxs("div", { className: styles$w.selectOption, children: [
        /* @__PURE__ */ jsx$1("div", { children: isSelected && /* @__PURE__ */ jsx$1("div", { className: styles$w.circle }) }),
        /* @__PURE__ */ jsxs("div", { className: styles$w.labelWrapper, ref: labelContainerRef, children: [
          /* @__PURE__ */ jsx$1("div", { className: styles$w.label, children: shouldTruncate ? /* @__PURE__ */ jsx$1(Tooltip$3, { content: label2, children: /* @__PURE__ */ jsx$1(
            "span",
            {
              className: styles$w.truncatedLabel,
              style: { maxWidth: `${remainingSpaceForLabel}px` },
              children: label2
            }
          ) }) : /* @__PURE__ */ jsx$1("span", { className: styles$w.truncatedLabel, children: label2 }) }),
          /* @__PURE__ */ jsx$1(
            "div",
            {
              className: styles$w.labelDescriptionContainer,
              style: !data.labelCounter ? { flexGrow: 0 } : {},
              ref: labelDescriptionRef,
              children: /* @__PURE__ */ jsxs("div", { className: styles$w.labelDescriptionWrapper, children: [
                data.labelDescription && /* @__PURE__ */ jsxs(
                  "span",
                  {
                    className: styles$w.labelDescription,
                    style: data.labelCounter ? { flexGrow: 1 } : {},
                    children: [
                      /* @__PURE__ */ jsx$1("span", { children: "•" }),
                      /* @__PURE__ */ jsx$1("span", { children: data.labelDescription })
                    ]
                  }
                ),
                data.labelCounter && /* @__PURE__ */ jsxs("span", { className: styles$w.labelCounter, children: [
                  /* @__PURE__ */ jsx$1("span", { className: styles$w.labelCounterContent, children: data.labelCounter.content }),
                  /* @__PURE__ */ jsx$1("span", { className: styles$w.labelCounterIcon, children: data.labelCounter.icon })
                ] })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsx$1("div", {}),
        data.labelNote && /* @__PURE__ */ jsx$1("div", { className: styles$w.selectOptionNote, children: data.labelNote })
      ] }, data.value)
    }
  );
};
const DEFAULT_MAX_SELECETED_ELEMENTS_TO_SHOW = 3;
function MultiValue({
  children,
  index: index2,
  getValue,
  innerProps,
  ...props
}) {
  const maxToShow = props?.selectProps?.maxSelectedElementsToShow || DEFAULT_MAX_SELECETED_ELEMENTS_TO_SHOW;
  const numberOfSelectedItems = getValue().length;
  const numberOfOverflowItems = numberOfSelectedItems > maxToShow ? numberOfSelectedItems - maxToShow : 0;
  const isDisabled = props.selectProps.ariaDisabled;
  const { maxChipChars } = props.selectProps;
  const { labelCounter: labelCounter2, label: label2 } = props.data;
  return index2 < maxToShow ? /* @__PURE__ */ jsx$1(
    Chip,
    {
      onClick: (e3) => {
        e3.stopPropagation();
        props.removeProps?.onClick?.(e3);
      },
      icon: labelCounter2?.icon ?? void 0,
      className: styles$w.chip,
      disabled: isDisabled,
      ariaLabel: label2,
      tabIndex: -1,
      maxChars: maxChipChars,
      children: label2 || ""
    }
  ) : index2 === maxToShow ? /* @__PURE__ */ jsx$1(
    MoreSelectedBadge,
    {
      numberOfOverflowItems,
      isDisabled
    }
  ) : null;
}
const MoreSelectedBadge = ({
  numberOfOverflowItems,
  isDisabled = false
}) => /* @__PURE__ */ jsx$1(Chip, { fixed: true, disabled: isDisabled, children: `+ ${numberOfOverflowItems}` });
function NoOptionsMessage$1(props) {
  return /* @__PURE__ */ jsx$1(components.NoOptionsMessage, { ...props, children: /* @__PURE__ */ jsx$1("span", { className: "custom-css-class", children: "No results" }) });
}
function Multiselect({
  async,
  loadMore,
  loadMoreButtonText = "Load more results",
  loadingText = "Loading...",
  itemsPerLoadMore,
  onLoadMore,
  isLoading,
  onInputChange,
  id,
  onChange: onChange2,
  maxMenuHeight = 150,
  hasUnderline = true,
  placeholder: placeholder2 = "Select...",
  hasError,
  isDisabled,
  className,
  hasIndicator = true,
  onClearBtnClick,
  selectProps,
  components: components2,
  options: options2,
  value: value2,
  ariaLabel,
  maxChipChars = 12,
  onOpenMenu,
  hasValuesWithoutLabel,
  disableFilter = false,
  onMenuScrollToBottom,
  loadingPaginatedOptions,
  loadOnScroll,
  keepOpenForever = false,
  ...rest
}) {
  const [isOpen, setIsOpen] = React__default.useState(keepOpenForever);
  const selectRef = React__default.useRef(null);
  const [isLoadMoreFocused, setIsLoadMoreFocused] = React__default.useState(false);
  const loadMoreButtonRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (!loadMore && isLoadMoreFocused) {
      selectRef.current?.focus();
      setIsLoadMoreFocused(false);
    }
  }, [loadMore]);
  function handleChange(newValues, actionMeta) {
    if (isDisabled) return;
    if (actionMeta.action === "clear") {
      onClearBtnClick?.();
    }
    newValues ? onChange2(newValues, id, actionMeta) : onChange2([], id, actionMeta);
    selectRef?.current?.focus();
  }
  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === "Space" && !isDisabled) {
      setIsOpen(true);
      if (isLoadMoreFocused && onLoadMore) {
        event.preventDefault();
        onLoadMore();
      }
    }
    if (event.key === "Tab") {
      if (loadMore && isOpen) {
        setIsLoadMoreFocused(true);
      }
      if (document.activeElement === loadMoreButtonRef.current) {
        setIsLoadMoreFocused(false);
        if (!keepOpenForever) {
          setIsOpen(false);
        }
      }
    }
  }
  function handleMenuOpen() {
    if (!isDisabled) {
      setIsOpen(true);
      onOpenMenu?.();
    }
  }
  function handleMenuClose() {
    if (!isLoadMoreFocused && !keepOpenForever) {
      setIsOpen(false);
    }
  }
  function customFilter(option, searchText) {
    const labelNote = option?.data?.labelNote;
    const label2 = option?.label;
    const value22 = String(option?.value);
    if (labelNote && labelNote.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    if (label2 && option.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    if (value22 && value22.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    return false;
  }
  const parsedComponents = {
    MultiValue,
    Option: CustomOption$1,
    Input: Input$1,
    NoOptionsMessage: NoOptionsMessage$1,
    ...async && { MenuList: MenuList$3 },
    ...components2
  };
  const asyncProps = {
    ...async && {
      itemsPerLoadMore,
      loadMore: true,
      onLoadMore,
      isDataLoading: isLoading,
      loadMoreButtonText,
      loadingText
    }
  };
  const indicatorColor = React__default.useMemo(() => {
    if (isDisabled) return "var(--color-disabled-front)";
    if (hasError) return "var(--color-red-front)";
    return "var(--color-front)";
  }, [isDisabled, hasError]);
  const remainingOptions = options2?.filter((option) => {
    return !value2?.some((valueOption) => valueOption.value === option.value);
  });
  const parsedValue = useMemo(() => {
    if (!hasValuesWithoutLabel) return value2;
    return value2?.map((val) => {
      if (val.label === void 0) {
        return options2.find((option) => option.value === val.value);
      }
      return val;
    });
  }, [value2]);
  return /* @__PURE__ */ jsx$1(
    StateManagedSelect$1,
    {
      className: clsx(
        "sz-multiselect",
        hasUnderline && "sz-multiselect--underline",
        isDisabled && "sz-multiselect--disabled",
        hasError && "sz-multiselect--has-error",
        hasIndicator && "sz-multiselect--has-indicator",
        className
      ),
      loadMore,
      loadMoreButtonRef,
      onInputChange,
      ref: selectRef,
      menuIsOpen: isOpen,
      onMenuOpen: handleMenuOpen,
      onMenuClose: handleMenuClose,
      onBlur: keepOpenForever ? void 0 : handleMenuClose,
      id,
      onChange: handleChange,
      maxMenuHeight,
      classNamePrefix: "sz-multiselect",
      placeholder: placeholder2,
      isMulti: true,
      hideSelectedOptions: false,
      closeMenuOnSelect: false,
      components: parsedComponents,
      options: [...value2 ? value2 : [], ...remainingOptions],
      value: parsedValue,
      onKeyDown: handleKeyDown,
      "aria-errormessage": hasError && `input-error-message-${id}`,
      "aria-label": ariaLabel,
      "aria-invalid": hasError,
      ariaDisabled: isDisabled,
      tabSelectsValue: false,
      maxChipChars,
      isLoading,
      filterOption: disableFilter ? null : customFilter,
      onMenuScrollToBottom,
      loadingPaginatedOptions,
      loadOnScroll,
      styles: {
        placeholder: (defaultStyles2) => ({
          ...defaultStyles2,
          color: indicatorColor
        }),
        dropdownIndicator: (defaultStyles2) => ({
          ...defaultStyles2,
          color: indicatorColor
        }),
        clearIndicator: (defaultStyles2) => ({
          ...defaultStyles2,
          color: indicatorColor
        })
      },
      ...asyncProps,
      ...selectProps,
      ...rest
    }
  );
}
const Arrow = ({ direction = "right", color = "#03204D" }) => {
  if (direction === "right") {
    return /* @__PURE__ */ jsx$1("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M5.99996 0.666626L5.05996 1.60663L8.77996 5.33329H0.666626V6.66663H8.77996L5.05996 10.3933L5.99996 11.3333L11.3333 5.99996L5.99996 0.666626Z", fill: color }) });
  } else {
    return /* @__PURE__ */ jsx$1("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx$1("path", { d: "M11.3333 5.33329H3.21996L6.94663 1.60663L5.99996 0.666626L0.666626 5.99996L5.99996 11.3333L6.93996 10.3933L3.21996 6.66663H11.3333V5.33329Z", fill: color }) });
  }
};
const container$4 = "navigational-link-module_container__KCMyF";
const linkContainer = "navigational-link-module_linkContainer__hOwzv";
const activatedLink = "navigational-link-module_activatedLink__0DEh3";
const disabledLink$1 = "navigational-link-module_disabledLink__Du2E2";
const styles$v = {
  container: container$4,
  linkContainer,
  activatedLink,
  disabledLink: disabledLink$1
};
var define_process_env_default = {};
var enabled$1 = {};
try {
  if (define_process_env_default.CARBON_ENABLE_CSS_CUSTOM_PROPERTIES) {
    if (define_process_env_default.CARBON_ENABLE_CSS_CUSTOM_PROPERTIES === "true") {
      enabled$1.enableCssCustomProperties = true;
    } else {
      enabled$1.enableCssCustomProperties = false;
    }
  } else {
    enabled$1.enableCssCustomProperties = false;
  }
  if (define_process_env_default.CARBON_ENABLE_USE_CONTROLLED_STATE_WITH_VALUE) {
    if (define_process_env_default.CARBON_ENABLE_USE_CONTROLLED_STATE_WITH_VALUE === "true") {
      enabled$1.enableUseControlledStateWithValue = true;
    } else {
      enabled$1.enableUseControlledStateWithValue = false;
    }
  } else {
    enabled$1.enableUseControlledStateWithValue = false;
  }
  if (define_process_env_default.CARBON_ENABLE_CSS_GRID) {
    if (define_process_env_default.CARBON_ENABLE_CSS_GRID === "true") {
      enabled$1.enableCssGrid = true;
    } else {
      enabled$1.enableCssGrid = false;
    }
  } else {
    enabled$1.enableCssGrid = false;
  }
  if (define_process_env_default.CARBON_ENABLE_V11_RELEASE) {
    if (define_process_env_default.CARBON_ENABLE_V11_RELEASE === "true") {
      enabled$1.enableV11Release = true;
    } else {
      enabled$1.enableV11Release = false;
    }
  } else {
    enabled$1.enableV11Release = true;
  }
  if (define_process_env_default.CARBON_ENABLE_EXPERIMENTAL_TILE_CONTRAST) {
    if (define_process_env_default.CARBON_ENABLE_EXPERIMENTAL_TILE_CONTRAST === "true") {
      enabled$1.enableExperimentalTileContrast = true;
    } else {
      enabled$1.enableExperimentalTileContrast = false;
    }
  } else {
    enabled$1.enableExperimentalTileContrast = false;
  }
  if (define_process_env_default.CARBON_ENABLE_V12_TILE_DEFAULT_ICONS) {
    if (define_process_env_default.CARBON_ENABLE_V12_TILE_DEFAULT_ICONS === "true") {
      enabled$1.enableV12TileDefaultIcons = true;
    } else {
      enabled$1.enableV12TileDefaultIcons = false;
    }
  } else {
    enabled$1.enableV12TileDefaultIcons = false;
  }
  if (define_process_env_default.CARBON_ENABLE_V12_TILE_RADIO_ICONS) {
    if (define_process_env_default.CARBON_ENABLE_V12_TILE_RADIO_ICONS === "true") {
      enabled$1.enableV12TileRadioIcons = true;
    } else {
      enabled$1.enableV12TileRadioIcons = false;
    }
  } else {
    enabled$1.enableV12TileRadioIcons = false;
  }
  if (define_process_env_default.CARBON_ENABLE_V12_OVERFLOWMENU) {
    if (define_process_env_default.CARBON_ENABLE_V12_OVERFLOWMENU === "true") {
      enabled$1.enableV12Overflowmenu = true;
    } else {
      enabled$1.enableV12Overflowmenu = false;
    }
  } else {
    enabled$1.enableV12Overflowmenu = false;
  }
  if (define_process_env_default.CARBON_ENABLE_TREEVIEW_CONTROLLABLE) {
    if (define_process_env_default.CARBON_ENABLE_TREEVIEW_CONTROLLABLE === "true") {
      enabled$1.enableTreeviewControllable = true;
    } else {
      enabled$1.enableTreeviewControllable = false;
    }
  } else {
    enabled$1.enableTreeviewControllable = false;
  }
  if (define_process_env_default.CARBON_ENABLE_V12_STRUCTURED_LIST_VISIBLE_ICONS) {
    if (define_process_env_default.CARBON_ENABLE_V12_STRUCTURED_LIST_VISIBLE_ICONS === "true") {
      enabled$1.enableV12StructuredListVisibleIcons = true;
    } else {
      enabled$1.enableV12StructuredListVisibleIcons = false;
    }
  } else {
    enabled$1.enableV12StructuredListVisibleIcons = false;
  }
  if (define_process_env_default.CARBON_ENABLE_EXPERIMENTAL_FOCUS_WRAP_WITHOUT_SENTINELS) {
    if (define_process_env_default.CARBON_ENABLE_EXPERIMENTAL_FOCUS_WRAP_WITHOUT_SENTINELS === "true") {
      enabled$1.enableExperimentalFocusWrapWithoutSentinels = true;
    } else {
      enabled$1.enableExperimentalFocusWrapWithoutSentinels = false;
    }
  } else {
    enabled$1.enableExperimentalFocusWrapWithoutSentinels = false;
  }
} catch (error2) {
  enabled$1.enableCssCustomProperties = false;
  enabled$1.enableUseControlledStateWithValue = false;
  enabled$1.enableCssGrid = false;
  enabled$1.enableV11Release = true;
  enabled$1.enableExperimentalTileContrast = false;
  enabled$1.enableV12TileDefaultIcons = false;
  enabled$1.enableV12TileRadioIcons = false;
  enabled$1.enableV12Overflowmenu = false;
  enabled$1.enableTreeviewControllable = false;
  enabled$1.enableV12StructuredListVisibleIcons = false;
  enabled$1.enableExperimentalFocusWrapWithoutSentinels = false;
}
var featureFlagInfo = [{
  name: "enable-css-custom-properties",
  description: "Describe what the flag does",
  enabled: enabled$1.enableCssCustomProperties
}, {
  name: "enable-use-controlled-state-with-value",
  description: "Enable components to be created in either a controlled or uncontrolled mode\n",
  enabled: enabled$1.enableUseControlledStateWithValue
}, {
  name: "enable-css-grid",
  description: "Enable CSS Grid Layout in the Grid and Column React components\n",
  enabled: enabled$1.enableCssGrid
}, {
  name: "enable-v11-release",
  description: "Enable the features and functionality for the v11 Release\n",
  enabled: enabled$1.enableV11Release
}, {
  name: "enable-experimental-tile-contrast",
  description: "Enable the experimental tile improved contrast styles\n",
  enabled: enabled$1.enableExperimentalTileContrast
}, {
  name: "enable-v12-tile-default-icons",
  description: "Enable rendering of default icons in the tile components\n",
  enabled: enabled$1.enableV12TileDefaultIcons
}, {
  name: "enable-v12-tile-radio-icons",
  description: "Enable rendering of radio icons in the RadioTile component\n",
  enabled: enabled$1.enableV12TileRadioIcons
}, {
  name: "enable-v12-overflowmenu",
  description: "Enable the use of the v12 OverflowMenu leveraging the Menu subcomponents\n",
  enabled: enabled$1.enableV12Overflowmenu
}, {
  name: "enable-treeview-controllable",
  description: "Enable the new TreeView controllable API\n",
  enabled: enabled$1.enableTreeviewControllable
}, {
  name: "enable-v12-structured-list-visible-icons",
  description: "Enable rendering of radio icons in the StructuredList component\n",
  enabled: enabled$1.enableV12StructuredListVisibleIcons
}, {
  name: "enable-experimental-focus-wrap-without-sentinels",
  description: "Enable the new focus wrap behavior that doesn't use sentinel nodes\n",
  enabled: enabled$1.enableExperimentalFocusWrapWithoutSentinels
}];
function _iterableToArrayLimit(arr, i3) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s, _e2, _x, _r, _arr = [], _n = true, _d = false;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i3) ;
      else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i3); _n = true) ;
    } catch (err) {
      _d = true, _e2 = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e2;
      }
    }
    return _arr;
  }
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i3 = 0; i3 < props.length; i3++) {
    var descriptor = props[i3];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _slicedToArray(arr, i3) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i3) || _unsupportedIterableToArray$1(arr, i3) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i3 = 0, arr2 = new Array(len); i3 < len; i3++) arr2[i3] = arr[i3];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper$1(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (!it2) {
    if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$1(o2)) || allowArrayLike) {
      if (it2) o2 = it2;
      var i3 = 0;
      var F2 = function() {
      };
      return {
        s: F2,
        n: function() {
          if (i3 >= o2.length) return {
            done: true
          };
          return {
            done: false,
            value: o2[i3++]
          };
        },
        e: function(e3) {
          throw e3;
        },
        f: F2
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function() {
      it2 = it2.call(o2);
    },
    n: function() {
      var step = it2.next();
      normalCompletion = step.done;
      return step;
    },
    e: function(e3) {
      didErr = true;
      err = e3;
    },
    f: function() {
      try {
        if (!normalCompletion && it2.return != null) it2.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive$1(input2, hint) {
  if (typeof input2 !== "object" || input2 === null) return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint);
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(input2);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var FeatureFlagScope = /* @__PURE__ */ (function() {
  function FeatureFlagScope2(flags) {
    var _this = this;
    _classCallCheck$1(this, FeatureFlagScope2);
    this.flags = /* @__PURE__ */ new Map();
    if (flags) {
      Object.keys(flags).forEach(function(key) {
        _this.flags.set(key, flags[key]);
      });
    }
  }
  _createClass$1(FeatureFlagScope2, [{
    key: "checkForFlag",
    value: function checkForFlag(name2) {
      if (!this.flags.has(name2)) {
        throw new Error("Unable to find a feature flag with the name: `".concat(name2, "`"));
      }
    }
    /**
     * Add a feature flag
     * @param {string} name
     * @param {boolean} enabled
     */
  }, {
    key: "add",
    value: function add2(name2, enabled2) {
      if (this.flags.has(name2)) {
        throw new Error("The feature flag: ".concat(name2, " already exists"));
      }
      this.flags.set(name2, enabled2);
    }
    /**
     * Enable a feature flag
     * @param {string} name
     */
  }, {
    key: "enable",
    value: function enable2(name2) {
      this.checkForFlag(name2);
      this.flags.set(name2, true);
    }
    /**
     * Disable a feature flag
     * @param {string} name
     */
  }, {
    key: "disable",
    value: function disable2(name2) {
      this.checkForFlag(name2);
      this.flags.set(name2, false);
    }
    /**
     * Merge the given feature flags with the current set of feature flags.
     * Duplicate keys will be set to the value in the given feature flags.
     * @param {object} flags
     */
  }, {
    key: "merge",
    value: function merge22(flags) {
      var _this2 = this;
      Object.keys(flags).forEach(function(key) {
        _this2.flags.set(key, flags[key]);
      });
    }
    /**
     * @param {FeatureFlagScope} scope
     */
  }, {
    key: "mergeWithScope",
    value: function mergeWithScope(scope) {
      var _iterator = _createForOfIteratorHelper$1(scope.flags), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value2 = _step$value[1];
          if (this.flags.has(key)) {
            continue;
          }
          this.flags.set(key, value2);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Check if a feature flag is enabled
     * @param {string} name
     * @returns {boolean}
     */
  }, {
    key: "enabled",
    value: function enabled2(name2) {
      this.checkForFlag(name2);
      return this.flags.get(name2);
    }
  }]);
  return FeatureFlagScope2;
})();
var FeatureFlags = createScope();
for (var i$1 = 0; i$1 < featureFlagInfo.length; i$1++) {
  var featureFlag = featureFlagInfo[i$1];
  FeatureFlags.add(featureFlag.name, featureFlag.enabled);
}
function createScope(flags) {
  return new FeatureFlagScope(flags);
}
function enabled() {
  return FeatureFlags.enabled.apply(FeatureFlags, arguments);
}
function merge() {
  return FeatureFlags.merge.apply(FeatureFlags, arguments);
}
merge({
  "enable-css-custom-properties": true,
  "enable-css-grid": true,
  "enable-v11-release": true,
  "enable-experimental-tile-contrast": false,
  "enable-v12-tile-radio-icons": false,
  "enable-v12-structured-list-visible-icons": false
});
function _defineProperty$2(obj, key, value2) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toPrimitive(input2, hint) {
  if (typeof input2 !== "object" || input2 === null) return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint);
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
const PrefixContext = /* @__PURE__ */ React__default.createContext("cds");
function usePrefix() {
  return React__default.useContext(PrefixContext);
}
const defaultAttributes = {
  focusable: "false",
  preserveAspectRatio: "xMidYMid meet"
};
function getAttributes({ width, height, viewBox = `0 0 ${width} ${height}`, ...attributes } = {}) {
  const { tabindex, ...rest } = attributes;
  const iconAttributes = {
    ...defaultAttributes,
    ...rest,
    width,
    height,
    viewBox
  };
  if (iconAttributes["aria-label"] || iconAttributes["aria-labelledby"]) {
    iconAttributes.role = "img";
    if (tabindex !== void 0 && tabindex !== null) {
      iconAttributes.focusable = "true";
      iconAttributes.tabindex = tabindex;
    }
  } else iconAttributes["aria-hidden"] = true;
  return iconAttributes;
}
const Icon = forwardRef(function Icon2({ className, children, tabIndex, xmlns = "http://www.w3.org/2000/svg", preserveAspectRatio = "xMidYMid meet", ...rest }, ref2) {
  const { tabindex, ...attrs } = getAttributes({
    ...rest,
    tabindex: tabIndex
  });
  const props = attrs;
  if (className) props.className = className;
  if (tabindex !== void 0 && tabindex !== null) if (typeof tabindex === "number") props.tabIndex = tabindex;
  else props.tabIndex = Number(tabIndex);
  if (ref2) props.ref = ref2;
  if (xmlns) props.xmlns = xmlns;
  if (preserveAspectRatio) props.preserveAspectRatio = preserveAspectRatio;
  return React__default.createElement("svg", props, children);
});
Icon.displayName = "Icon";
Icon.propTypes = {
  "aria-hidden": PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["true", "false"])]),
  "aria-label": PropTypes.string,
  "aria-labelledby": PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewBox: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  xmlns: PropTypes.string
};
const AddFilled = /* @__PURE__ */ React__default.forwardRef(function AddFilled2({ children, size = 16, ...rest }, ref2) {
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z" }), /* @__PURE__ */ jsx$1("path", {
    fill: "none",
    d: "M24 17 17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
    "data-icon-path": "inner-path"
  }), children);
});
const ArrowUp$1 = /* @__PURE__ */ React__default.forwardRef(function ArrowUp2({ children, size = 16, ...rest }, ref2) {
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M3.7 6.7 7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M16 4 6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z" }), children);
});
const ArrowsVertical = /* @__PURE__ */ React__default.forwardRef(function ArrowsVertical2({ children, size = 16, ...rest }, ref2) {
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M27.6 20.6 24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22z" }), /* @__PURE__ */ jsx$1("path", { d: "M9 4 3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z" }), children);
});
const CaretLeft = /* @__PURE__ */ React__default.forwardRef(function CaretLeft2({ children, size = 16, ...rest }, ref2) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 8",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M5 8 0 4 5 0z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M20 24 10 16 20 8z" }), children);
});
const CaretRight = /* @__PURE__ */ React__default.forwardRef(function CaretRight2({ children, size = 16, ...rest }, ref2) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 8",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M0 0 5 4 0 8z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M12 8 22 16 12 24z" }), children);
});
const ChevronDown = /* @__PURE__ */ React__default.forwardRef(function ChevronDown2({ children, size = 16, ...rest }, ref2) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M5 6 0 1 .7.3 5 4.6 9.3.3 10 1z" }), children);
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M8 11 3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M16 22 6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z" }), children);
});
const ChevronLeft = /* @__PURE__ */ React__default.forwardRef(function ChevronLeft2({ children, size = 16, ...rest }, ref2) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M0 5 5 0 5.7.7 1.4 5 5.7 9.3 5 10z" }), children);
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M5 8 10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M10 16 20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z" }), children);
});
const ChevronRight = /* @__PURE__ */ React__default.forwardRef(function ChevronRight2({ children, size = 16, ...rest }, ref2) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M6 5 1 10 .3 9.3 4.6 5 .3.7 1 0z" }), children);
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M11 8 6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M22 16 12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z" }), children);
});
const Close = /* @__PURE__ */ React__default.forwardRef(function Close2({ children, size = 16, ...rest }, ref2) {
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M17.4141 16 24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z" }), children);
});
const OverflowMenuVertical = /* @__PURE__ */ React__default.forwardRef(function OverflowMenuVertical2({ children, size = 16, ...rest }, ref2) {
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  }), /* @__PURE__ */ jsx$1("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  }), children);
});
const Search$2 = /* @__PURE__ */ React__default.forwardRef(function Search2({ children, size = 16, ...rest }, ref2) {
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5 C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z" }), children);
});
const Settings = /* @__PURE__ */ React__default.forwardRef(function Settings2({ children, size = 16, ...rest }, ref2) {
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3 c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1 C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4 c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8 L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6 C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z" }), /* @__PURE__ */ jsx$1("path", { d: "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8 c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z" }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z" }), /* @__PURE__ */ jsx$1("path", { d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z" }), children);
});
const WarningAltFilled = /* @__PURE__ */ React__default.forwardRef(function WarningAltFilled2({ children, size = 16, ...rest }, ref2) {
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", {
    fill: "none",
    d: "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
    "data-icon-path": "inner-path"
  }), /* @__PURE__ */ jsx$1("path", { d: "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z" }), /* @__PURE__ */ jsx$1("path", { d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z" }), children);
});
const WarningFilled = /* @__PURE__ */ React__default.forwardRef(function WarningFilled2({ children, size = 16, ...rest }, ref2) {
  if (size === 16 || size === "16" || size === "16px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z" }), /* @__PURE__ */ jsx$1("path", {
    d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
    "data-icon-path": "inner-path",
    opacity: "0"
  }), children);
  if (size === 20 || size === "20" || size === "20px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S10.6,16,10,16z" }), /* @__PURE__ */ jsx$1("path", {
    d: "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
    "data-icon-path": "inner-path",
    opacity: "0"
  }), children);
  if (size === 24 || size === "24" || size === "24px") return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z" }), /* @__PURE__ */ jsx$1("path", {
    fill: "none",
    d: "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6 h-1.8v8h1.8V6z",
    "data-icon-path": "inner-path",
    opacity: "0"
  }), children);
  return React__default.createElement(Icon, {
    width: size,
    height: size,
    ref: ref2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, /* @__PURE__ */ jsx$1("path", { d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25 c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z" }), /* @__PURE__ */ jsx$1("path", {
    fill: "none",
    d: "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22 C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
    "data-icon-path": "inner-path",
    opacity: "0"
  }), children);
});
const TextDirectionContext = /* @__PURE__ */ createContext(null);
function Text(_ref3) {
  let {
    as,
    children,
    dir = "auto",
    ...rest
  } = _ref3;
  const context = useContext(TextDirectionContext);
  const textProps = {};
  const BaseComponent = as ?? "span";
  const value2 = {
    ...context
  };
  if (!context) {
    textProps.dir = dir;
    value2.direction = dir;
  } else {
    const {
      direction: parentDirection,
      getTextDirection
    } = context;
    if (getTextDirection && getTextDirection.current) {
      const text2 = getTextFromChildren(children);
      const override = getTextDirection.current(text2);
      if (parentDirection !== override) {
        textProps.dir = override;
        value2.direction = override;
      } else if (parentDirection === "auto") {
        textProps.dir = override;
      }
    } else if (parentDirection !== dir) {
      textProps.dir = dir;
      value2.direction = dir;
    } else if (parentDirection === "auto") {
      textProps.dir = dir;
    }
  }
  return /* @__PURE__ */ React__default.createElement(TextDirectionContext.Provider, {
    value: value2
  }, /* @__PURE__ */ React__default.createElement(BaseComponent, _extends({}, rest, textProps), children));
}
Text.propTypes = {
  /**
   * Provide a custom element type used to render the outermost node
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.elementType]),
  /**
   * Provide child elements or text to be rendered inside of this component
   */
  children: PropTypes.node.isRequired,
  /**
   * Specify the text direction to be used for this component and any of its
   * children
   */
  dir: PropTypes.oneOf(["ltr", "rtl", "auto"])
};
function getTextFromChildren(children) {
  if (typeof children === "string") {
    return children;
  }
  const text2 = React__default.Children.map(children, (child) => {
    if (typeof child === "string") {
      return child;
    }
    return null;
  })?.filter((text3) => {
    return text3 !== null;
  });
  if (text2?.length === 1) {
    return text2[0];
  }
  return text2;
}
function setupGetInstanceId$2() {
  let instanceId2 = 0;
  return function getInstanceId2() {
    return ++instanceId2;
  };
}
const canUseDOM = !!(typeof window !== "undefined" && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
window.document && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
window.document.createElement);
const IdPrefixContext = /* @__PURE__ */ React__default.createContext(null);
function useIdPrefix() {
  return React__default.useContext(IdPrefixContext);
}
const getId = setupGetInstanceId$2();
const useIsomorphicLayoutEffect$2 = canUseDOM ? useLayoutEffect$1 : useEffect;
let serverHandoffCompleted = false;
function useId$1() {
  let prefix2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "id";
  const _prefix = useIdPrefix();
  const [id, setId] = useState(() => {
    if (serverHandoffCompleted) {
      return `${_prefix ? `${_prefix}-` : ``}${prefix2}-${getId()}`;
    }
    return null;
  });
  useIsomorphicLayoutEffect$2(() => {
    if (id === null) {
      setId(`${_prefix ? `${_prefix}-` : ``}${prefix2}-${getId()}`);
    }
  }, [getId]);
  useEffect(() => {
    if (serverHandoffCompleted === false) {
      serverHandoffCompleted = true;
    }
  }, []);
  if (typeof React__default["useId"] === "function") {
    const id2 = nativeReactUseId(_prefix, prefix2);
    return id2;
  }
  return id;
}
function nativeReactUseId(_prefix, prefix2) {
  const getId2 = React__default["useId"]();
  const id = `${_prefix ? `${_prefix}-` : ``}${prefix2}-${getId2}`;
  return id;
}
function useFallbackId(id) {
  const fallback = useId$1();
  return id ?? fallback;
}
const didWarnAboutDeprecation$1 = {};
function deprecate(propType, message2) {
  function checker(props, propName, componentName) {
    if (props[propName] === void 0) {
      return;
    }
    if (!didWarnAboutDeprecation$1[componentName] || !didWarnAboutDeprecation$1[componentName][propName]) {
      didWarnAboutDeprecation$1[componentName] = {
        ...didWarnAboutDeprecation$1[componentName],
        [propName]: true
      };
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return propType(props, propName, componentName, ...rest);
  }
  return checker;
}
function matches$1(event, keysToMatch) {
  for (let i3 = 0; i3 < keysToMatch.length; i3++) {
    if (match$1(event, keysToMatch[i3])) {
      return true;
    }
  }
  return false;
}
function match$1(eventOrCode) {
  let {
    key,
    which,
    keyCode,
    code
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (typeof eventOrCode === "string") {
    return eventOrCode === key;
  }
  if (typeof eventOrCode === "number") {
    return eventOrCode === which || eventOrCode === keyCode;
  }
  if (eventOrCode.key && Array.isArray(key)) {
    return key.indexOf(eventOrCode.key) !== -1;
  }
  return eventOrCode.key === key || eventOrCode.which === which || eventOrCode.keyCode === keyCode || eventOrCode.code === code;
}
const Tab$3 = {
  key: "Tab",
  which: 9,
  keyCode: 9,
  code: "Tab"
};
const Enter = {
  key: "Enter",
  which: 13,
  keyCode: 13,
  code: "Enter"
};
const Escape = {
  key: [
    "Escape",
    // IE11 Escape
    "Esc"
  ],
  which: 27,
  keyCode: 27,
  code: "Esc"
};
const Space = {
  key: " ",
  which: 32,
  keyCode: 32,
  code: "Space"
};
const End = {
  key: "End",
  which: 35,
  keyCode: 35,
  code: "Numpad1"
};
const Home = {
  key: "Home",
  which: 36,
  keyCode: 36,
  code: "Numpad7"
};
const ArrowLeft = {
  key: "ArrowLeft",
  which: 37,
  keyCode: 37,
  code: "ArrowLeft"
};
const ArrowUp = {
  key: "ArrowUp",
  which: 38,
  keyCode: 38,
  code: "ArrowUp"
};
const ArrowRight = {
  key: "ArrowRight",
  which: 39,
  keyCode: 39,
  code: "ArrowRight"
};
const ArrowDown = {
  key: "ArrowDown",
  which: 40,
  keyCode: 40,
  code: "ArrowDown"
};
const Delete = {
  key: "Delete",
  which: 8,
  keyCode: 8,
  code: "ArrowDecimal"
};
const useIsomorphicEffect = typeof window !== "undefined" ? useLayoutEffect$1 : useEffect;
var useIsomorphicEffect$1 = useIsomorphicEffect;
const Link = /* @__PURE__ */ React__default.forwardRef(function Link2(_ref3, ref2) {
  let {
    as: BaseComponent,
    children,
    className: customClassName,
    href,
    disabled: disabled2 = false,
    inline: inline2 = false,
    visited = false,
    renderIcon: Icon3,
    size,
    target,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const className = r(`${prefix2}--link`, customClassName, {
    [`${prefix2}--link--disabled`]: disabled2,
    [`${prefix2}--link--inline`]: inline2,
    [`${prefix2}--link--visited`]: visited,
    [`${prefix2}--link--${size}`]: size
  });
  const rel = target === "_blank" ? "noopener" : void 0;
  const linkProps = {
    className: BaseComponent ? void 0 : className,
    rel,
    target
  };
  if (!disabled2) {
    linkProps.href = href;
  } else {
    linkProps.role = "link";
    linkProps["aria-disabled"] = true;
  }
  const BaseComponentAsAny = BaseComponent ?? "a";
  return /* @__PURE__ */ React__default.createElement(BaseComponentAsAny, _extends({
    ref: ref2
  }, linkProps, rest), children, !inline2 && Icon3 && /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--link__icon`
  }, /* @__PURE__ */ React__default.createElement(Icon3, null)));
});
Link.displayName = "Link";
Link.propTypes = {
  /**
   * Provide a custom element or component to render the top-level node for the
   * component.
   */
  as: PropTypes.elementType,
  /**
   * Provide the content for the Link
   */
  children: PropTypes.node,
  /**
   * Provide a custom className to be applied to the containing `<a>` node
   */
  className: PropTypes.string,
  /**
   * Specify if the control should be disabled, or not
   */
  disabled: PropTypes.bool,
  /**
   * Provide the `href` attribute for the `<a>` node
   */
  href: PropTypes.string,
  /**
   * Specify whether you want the inline version of this control
   */
  inline: PropTypes.bool,
  /**
   * Optional prop to render an icon next to the link.
   * Can be a React component class
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Specify the size of the Link. Currently supports either `sm`, 'md' (default) or 'lg` as an option.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Specify whether you want the link to receive visited styles after the link has been clicked
   */
  visited: PropTypes.bool
};
const didWarnAboutDeprecation = {};
function deprecateValuesWithin(propType, allowedValues, propMappingFunction2) {
  return function checker(props, propName, componentName) {
    if (props[propName] === void 0) {
      return;
    }
    if (!didWarnAboutDeprecation[componentName] || !didWarnAboutDeprecation[componentName][propName]) {
      didWarnAboutDeprecation[componentName] = {
        ...didWarnAboutDeprecation[componentName],
        [propName]: true
      };
      const deprecatedValue = props[propName];
      const newValue = propMappingFunction2 ? propMappingFunction2(deprecatedValue) : null;
      if (allowedValues && !allowedValues.includes(deprecatedValue)) {
        propMappingFunction2 ? `"${deprecatedValue}" is a deprecated value for the "${propName}" prop on the "${componentName}" component. Use "${newValue}" instead. "${deprecatedValue}" will be removed in the next major release.` : `"${deprecatedValue}" is a deprecated value for the "${propName}" prop on the "${componentName}" component. Allowed values is/are: ${allowedValues.join(", ")}.  "${deprecatedValue}" will be removed in the next major release. `;
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return propType(props, propName, componentName, ...rest);
  };
}
const useMergedRefs = (refs) => {
  return useCallback((node2) => {
    refs.forEach((ref2) => {
      if (typeof ref2 === "function") {
        ref2(node2);
      } else if (ref2 !== null && ref2 !== void 0) {
        ref2.current = node2;
      }
    });
  }, refs);
};
function useEvent$1(elementOrRef, eventName, callback) {
  const savedCallback = useRef(null);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = (event) => {
      if (savedCallback.current) {
        savedCallback.current(event);
      }
    };
    const element = "current" in elementOrRef ? elementOrRef.current : elementOrRef;
    element?.addEventListener?.(eventName, handler);
    return () => {
      element?.removeEventListener?.(eventName, handler);
    };
  }, [elementOrRef, eventName]);
}
function useWindowEvent(eventName, callback) {
  const savedCallback = useRef(null);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    function handler(event) {
      if (savedCallback.current) {
        savedCallback.current(event);
      }
    }
    window.addEventListener(eventName, handler);
    return () => {
      window.removeEventListener(eventName, handler);
    };
  }, [eventName]);
}
function mapPopoverAlignProp(align) {
  switch (align) {
    case "top-left":
      return "top-start";
    case "top-right":
      return "top-end";
    case "bottom-left":
      return "bottom-start";
    case "bottom-right":
      return "bottom-end";
    case "left-bottom":
      return "left-end";
    case "left-top":
      return "left-start";
    case "right-bottom":
      return "right-end";
    case "right-top":
      return "right-start";
    default:
      return align;
  }
}
var candidateSelectors = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var _isInert = function isInert(node2, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node2 === null || node2 === void 0 ? void 0 : (_node$getAttribute = node2.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node2, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node2 && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof node2.closest === "function" ? node2.closest("[inert]") : _isInert(node2.parentNode));
  return result;
};
var isContentEditable = function isContentEditable2(node2) {
  var _node$getAttribute2;
  var attValue = node2 === null || node2 === void 0 ? void 0 : (_node$getAttribute2 = node2.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node2, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (_isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var _getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options2) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (_isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content2 = assigned.length ? assigned : element.children;
      var nestedCandidates = _getCandidatesIteratively(content2, true, options2);
      if (options2.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options2.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options2.getShadowRoot === "function" && options2.getShadowRoot(element);
      var validShadowRoot = !_isInert(shadowRoot, false) && (!options2.shadowRootFilter || options2.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = _getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options2);
        if (options2.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node2) {
  return !isNaN(parseInt(node2.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node2) {
  if (!node2) {
    throw new Error("No node provided");
  }
  if (node2.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node2.tagName) || isContentEditable(node2)) && !hasTabIndex(node2)) {
      return 0;
    }
  }
  return node2.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node2, isScope) {
  var tabIndex = getTabIndex(node2);
  if (tabIndex < 0 && isScope && !hasTabIndex(node2)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a4, b3) {
  return a4.tabIndex === b3.tabIndex ? a4.documentOrder - b3.documentOrder : a4.tabIndex - b3.tabIndex;
};
var isInput = function isInput2(node2) {
  return node2.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node2) {
  return isInput(node2) && node2.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node2) {
  var r2 = node2.tagName === "DETAILS" && Array.prototype.slice.apply(node2.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r2;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i3 = 0; i3 < nodes.length; i3++) {
    if (nodes[i3].checked && nodes[i3].form === form) {
      return nodes[i3];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node2) {
  if (!node2.name) {
    return true;
  }
  var radioScope = node2.form || getRootNode(node2);
  var queryRadios = function queryRadios2(name2) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name2 + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node2.name));
  } else {
    try {
      radioSet = queryRadios(node2.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node2.form);
  return !checked || checked === node2;
};
var isRadio = function isRadio2(node2) {
  return isInput(node2) && node2.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node2) {
  return isRadio(node2) && !isTabbableRadio(node2);
};
var isNodeAttached = function isNodeAttached2(node2) {
  var _nodeRoot;
  var nodeRoot = node2 && getRootNode(node2);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node2) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node2 !== null && node2 !== void 0 && (_node$ownerDocument = node2.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node2));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node2) {
  var _node$getBoundingClie = node2.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node2, _ref3) {
  var displayCheck = _ref3.displayCheck, getShadowRoot = _ref3.getShadowRoot;
  if (displayCheck === "full-native") {
    if ("checkVisibility" in node2) {
      var visible = node2.checkVisibility({
        // Checking opacity might be desirable for some use cases, but natively,
        // opacity zero elements _are_ focusable and tabbable.
        checkOpacity: false,
        opacityProperty: false,
        contentVisibilityAuto: true,
        visibilityProperty: true,
        // This is an alias for `visibilityProperty`. Contemporary browsers
        // support both. However, this alias has wider browser support (Chrome
        // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
        // we include it anyway.
        checkVisibilityCSS: true
      });
      return !visible;
    }
  }
  var _getComputedStyle2 = getComputedStyle(node2), visibility = _getComputedStyle2.visibility;
  if (visibility === "hidden" || visibility === "collapse") {
    return true;
  }
  var isDirectSummary = matches.call(node2, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node2.parentElement : node2;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  displayCheck === "full-native" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node2;
      while (node2) {
        var parentElement = node2.parentElement;
        var rootNode = getRootNode(node2);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node2);
        } else if (node2.assignedSlot) {
          node2 = node2.assignedSlot;
        } else if (!parentElement && rootNode !== node2.ownerDocument) {
          node2 = rootNode.host;
        } else {
          node2 = parentElement;
        }
      }
      node2 = originalNode;
    }
    if (isNodeAttached(node2)) {
      return !node2.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node2);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node2) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node2.tagName)) {
    var parentNode = node2.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i3 = 0; i3 < parentNode.children.length; i3++) {
          var child = parentNode.children.item(i3);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node2);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options2, node2) {
  if (node2.disabled || isHiddenInput(node2) || isHidden(node2, options2) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node2) || isDisabledFromFieldset(node2)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options2, node2) {
  if (isNonTabbableRadio(node2) || getTabIndex(node2) < 0 || !isNodeMatchingSelectorFocusable(options2, node2)) {
    return false;
  }
  return true;
};
var isShadowRootTabbable = function isShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var _sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item2, i3) {
    var isScope = !!item2.scopeParent;
    var element = isScope ? item2.scopeParent : item2;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? _sortByOrder(item2.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i3,
        tabIndex: candidateTabindex,
        item: item2,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable2) {
    sortable2.isScope ? acc.push.apply(acc, sortable2.content) : acc.push(sortable2.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container2, options2) {
  options2 = options2 || {};
  var candidates;
  if (options2.getShadowRoot) {
    candidates = _getCandidatesIteratively([container2], options2.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options2),
      flatten: false,
      getShadowRoot: options2.getShadowRoot,
      shadowRootFilter: isShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container2, options2.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options2));
  }
  return _sortByOrder(candidates);
};
const SafeReact = {
  ...React
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn2) => fn2());
function useEffectEvent(callback) {
  const ref2 = React.useRef(() => {
  });
  useSafeInsertionEffect(() => {
    ref2.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref2.current == null ? void 0 : ref2.current(...args);
  }, []);
}
var index$1 = typeof document !== "undefined" ? useLayoutEffect$1 : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index$1(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l2) => l2 !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingRootContext(options2) {
  const {
    open: open2 = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options2;
  const floatingId = useId();
  const dataRef = React.useRef({});
  const [events] = React.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  const [positionReference, setPositionReference] = React.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open22, event, reason) => {
    dataRef.current.openEvent = open22 ? event : void 0;
    events.emit("openchange", {
      open: open22,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open22, event, reason);
  });
  const refs = React.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(() => ({
    dataRef,
    open: open2,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open2, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    nodeId
  } = options2;
  const internalRootContext = useFloatingRootContext({
    ...options2,
    elements: {
      reference: null,
      floating: null,
      ...options2.elements
    }
  });
  const rootContext = options2.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React.useState(null);
  const [positionReference, _setPositionReference] = React.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React.useRef(null);
  const tree = useFloatingTree();
  index$1(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position2 = useFloating$1({
    ...options2,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React.useCallback((node2) => {
    const computedPositionReference = isElement$1(node2) ? {
      getBoundingClientRect: () => node2.getBoundingClientRect(),
      contextElement: node2
    } : node2;
    _setPositionReference(computedPositionReference);
    position2.refs.setReference(computedPositionReference);
  }, [position2.refs]);
  const setReference = React.useCallback((node2) => {
    if (isElement$1(node2) || node2 === null) {
      domReferenceRef.current = node2;
      setDomReference(node2);
    }
    if (isElement$1(position2.refs.reference.current) || position2.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node2 !== null && !isElement$1(node2)) {
      position2.refs.setReference(node2);
    }
  }, [position2.refs]);
  const refs = React.useMemo(() => ({
    ...position2.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position2.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position2.elements,
    domReference
  }), [position2.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position2,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position2, refs, elements, nodeId, rootContext]);
  index$1(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node2 = tree == null ? void 0 : tree.nodesRef.current.find((node22) => node22.id === nodeId);
    if (node2) {
      node2.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position2,
    context,
    refs,
    elements
  }), [position2, refs, elements, context]);
}
const PopoverContext = /* @__PURE__ */ React__default.createContext({
  setFloating: {
    current: null
  },
  caretRef: {
    current: null
  },
  autoAlign: null
});
const propMappingFunction = (deprecatedValue) => {
  const mapping = {
    "top-left": "top-start",
    "top-right": "top-end",
    "bottom-left": "bottom-start",
    "bottom-right": "bottom-end",
    "left-bottom": "left-end",
    "left-top": "left-start",
    "right-bottom": "right-end",
    "right-top": "right-start"
  };
  return mapping[deprecatedValue];
};
const Popover = /* @__PURE__ */ React__default.forwardRef(function PopoverRenderFunction(_ref3, forwardRef2) {
  let {
    isTabTip,
    align: initialAlign = isTabTip ? "bottom-start" : "bottom",
    as: BaseComponent = "span",
    autoAlign = false,
    caret: caret2 = isTabTip ? false : true,
    className: customClassName,
    children,
    dropShadow = true,
    highContrast = false,
    onRequestClose,
    open: open2,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const floating = useRef(null);
  const caretRef = useRef(null);
  const popover = useRef(null);
  let align = mapPopoverAlignProp(initialAlign);
  useWindowEvent("blur", () => {
    if (open2) {
      onRequestClose?.();
    }
  });
  useWindowEvent("click", (event) => {
    if (open2 && !popover?.current?.contains(event.target)) {
      onRequestClose?.();
    }
  });
  const initialCaretHeight = React__default.Children.toArray(children).some((x3) => {
    return x3?.props?.className?.includes("slug");
  }) ? 7 : 6;
  const popoverDimensions = useRef({
    offset: 10,
    caretHeight: initialCaretHeight
  });
  useIsomorphicEffect$1(() => {
    if (caret2 && popover.current) {
      const getStyle = window.getComputedStyle(popover.current, null);
      const offsetProperty = getStyle.getPropertyValue("--cds-popover-offset");
      const caretProperty = getStyle.getPropertyValue("--cds-popover-caret-height");
      if (offsetProperty) {
        popoverDimensions.current.offset = offsetProperty.includes("px") ? Number(offsetProperty.split("px", 1)[0]) * 1 : Number(offsetProperty.split("rem", 1)[0]) * 16;
      }
      if (caretProperty) {
        popoverDimensions.current.caretHeight = caretProperty.includes("px") ? Number(caretProperty.split("px", 1)[0]) * 1 : Number(caretProperty.split("rem", 1)[0]) * 16;
      }
    }
  });
  const {
    refs,
    floatingStyles,
    placement,
    middlewareData
  } = useFloating(
    autoAlign ? {
      placement: align,
      // The floating element is positioned relative to its nearest
      // containing block (usually the viewport). It will in many cases also
      // “break” the floating element out of a clipping ancestor.
      // https://floating-ui.com/docs/misc#clipping
      strategy: "fixed",
      // Middleware order matters, arrow should be last
      middleware: [offset$4(!isTabTip ? popoverDimensions?.current?.offset : 0), flip$5({
        fallbackAxisSideDirection: "start"
      }), arrow$4({
        element: caretRef
      })],
      whileElementsMounted: autoUpdate$1
    } : {}
    // When autoAlign is turned off, floating-ui will not be used
  );
  const value2 = useMemo(() => {
    return {
      floating,
      setFloating: refs.setFloating,
      caretRef,
      autoAlign
    };
  }, [refs.setFloating, autoAlign]);
  if (isTabTip) {
    const tabTipAlignments = ["bottom-start", "bottom-end"];
    if (!tabTipAlignments.includes(align)) {
      align = "bottom-start";
    }
  }
  useEffect(() => {
    if (autoAlign) {
      Object.keys(floatingStyles).forEach((style2) => {
        if (refs.floating.current) {
          refs.floating.current.style[style2] = floatingStyles[style2];
        }
      });
      if (caret2 && middlewareData && middlewareData.arrow && caretRef?.current) {
        const {
          x: x3,
          y: y3
        } = middlewareData.arrow;
        const staticSide = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[placement.split("-")[0]];
        caretRef.current.style.left = x3 != null ? `${x3}px` : "";
        caretRef.current.style.top = y3 != null ? `${y3}px` : "";
        caretRef.current.style.right = "";
        caretRef.current.style.bottom = "";
        if (staticSide) {
          caretRef.current.style[staticSide] = `${-popoverDimensions?.current?.caretHeight}px`;
        }
      }
    }
  }, [floatingStyles, refs.floating, autoAlign, middlewareData, placement, caret2]);
  const ref2 = useMergedRefs([forwardRef2, popover]);
  const currentAlignment = autoAlign && placement !== align ? placement : align;
  const className = r({
    [`${prefix2}--popover-container`]: true,
    [`${prefix2}--popover--caret`]: caret2,
    [`${prefix2}--popover--drop-shadow`]: dropShadow,
    [`${prefix2}--popover--high-contrast`]: highContrast,
    [`${prefix2}--popover--open`]: open2,
    [`${prefix2}--popover--auto-align`]: autoAlign,
    [`${prefix2}--popover--${currentAlignment}`]: true,
    [`${prefix2}--popover--tab-tip`]: isTabTip
  }, customClassName);
  const mappedChildren = React__default.Children.map(children, (child) => {
    const item2 = child;
    if ((item2?.type === "button" || autoAlign && item2?.type?.displayName !== "PopoverContent" || autoAlign && item2?.type?.displayName === "ToggletipButton") && /* @__PURE__ */ React__default.isValidElement(item2)) {
      const className2 = item2?.props?.className;
      const ref22 = (item2?.props).ref;
      const tabTipClasses = r(`${prefix2}--popover--tab-tip__button`, className2);
      return /* @__PURE__ */ React__default.cloneElement(item2, {
        className: isTabTip && item2?.type === "button" ? tabTipClasses : className2 || "",
        // With cloneElement, if you pass a `ref`, it overrides the original ref.
        // https://react.dev/reference/react/cloneElement#parameters
        // The block below works around this and ensures that the original ref is still
        // called while allowing the floating-ui reference element to be set as well.
        // `useMergedRefs` can't be used here because hooks can't be called from within a callback.
        // More here: https://github.com/facebook/react/issues/8873#issuecomment-489579878
        ref: (node2) => {
          if (autoAlign && item2?.type?.displayName !== "PopoverContent" || autoAlign && item2?.type?.displayName === "ToggletipButton") {
            refs.setReference(node2);
          }
          if (typeof ref22 === "function") {
            ref22(node2);
          } else if (ref22 !== null && ref22 !== void 0) {
            ref22.current = node2;
          }
        }
      });
    } else {
      return item2;
    }
  });
  const BaseComponentAsAny = BaseComponent;
  return /* @__PURE__ */ React__default.createElement(PopoverContext.Provider, {
    value: value2
  }, /* @__PURE__ */ React__default.createElement(BaseComponentAsAny, _extends({}, rest, {
    className,
    ref: ref2
  }), autoAlign || isTabTip ? mappedChildren : children));
});
Popover.propTypes = {
  /**
   * Specify how the popover should align with the trigger element
   
   */
  align: deprecateValuesWithin(
    PropTypes.oneOf([
      "top",
      "top-left",
      // deprecated use top-start instead
      "top-right",
      // deprecated use top-end instead
      "bottom",
      "bottom-left",
      // deprecated use bottom-start instead
      "bottom-right",
      // deprecated use bottom-end instead
      "left",
      "left-bottom",
      // deprecated use left-end instead
      "left-top",
      // deprecated use left-start instead
      "right",
      "right-bottom",
      // deprecated use right-end instead
      "right-top",
      // deprecated use right-start instead
      // new values to match floating-ui
      "top-start",
      "top-end",
      "bottom-start",
      "bottom-end",
      "left-end",
      "left-start",
      "right-end",
      "right-start"
    ]),
    //allowed prop values
    ["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end"],
    //optional mapper function
    propMappingFunction
  ),
  /**
   * Provide a custom element or component to render the top-level node for the
   * component.
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /**
   * Will auto-align the popover on first render if it is not visible. This prop is currently experimental and is subject to future changes.
   */
  autoAlign: PropTypes.bool,
  /**
   * Specify whether a caret should be rendered
   */
  caret: PropTypes.bool,
  /**
   * Provide elements to be rendered inside of the component
   */
  children: PropTypes.node,
  /**
   * Provide a custom class name to be added to the outermost node in the
   * component
   */
  className: PropTypes.string,
  /**
   * Specify whether a drop shadow should be rendered on the popover
   */
  dropShadow: PropTypes.bool,
  /**
   * Render the component using the high-contrast variant
   */
  highContrast: PropTypes.bool,
  /**
   * Render the component using the tab tip variant
   */
  isTabTip: PropTypes.bool,
  /**
   * Specify a handler for closing popover.
   * The handler should take care of closing the popover, e.g. changing the `open` prop.
   */
  onRequestClose: PropTypes.func,
  /**
   * Specify whether the component is currently open or closed
   */
  open: PropTypes.bool.isRequired
};
function PopoverContentRenderFunction(_ref22, forwardRef2) {
  let {
    className,
    children,
    ...rest
  } = _ref22;
  const prefix2 = usePrefix();
  const {
    setFloating,
    caretRef,
    autoAlign
  } = React__default.useContext(PopoverContext);
  const ref2 = useMergedRefs([setFloating, forwardRef2]);
  return /* @__PURE__ */ React__default.createElement("span", _extends({}, rest, {
    className: `${prefix2}--popover`
  }), /* @__PURE__ */ React__default.createElement("span", {
    className: r(`${prefix2}--popover-content`, className),
    ref: ref2
  }, children, autoAlign && /* @__PURE__ */ React__default.createElement("span", {
    className: r({
      [`${prefix2}--popover-caret`]: true,
      [`${prefix2}--popover--auto-align`]: true
    }),
    ref: caretRef
  })), !autoAlign && /* @__PURE__ */ React__default.createElement("span", {
    className: r({
      [`${prefix2}--popover-caret`]: true
    }),
    ref: caretRef
  }));
}
const PopoverContent = /* @__PURE__ */ React__default.forwardRef(PopoverContentRenderFunction);
PopoverContent.displayName = "PopoverContent";
PopoverContent.propTypes = {
  /**
   * Provide elements to be rendered inside of the component
   */
  children: PropTypes.node,
  /**
   * Provide a custom class name to be added to the outermost node in the
   * component
   */
  className: PropTypes.string
};
function useDelayedState(initialState2) {
  const [state, setState] = useState(initialState2);
  const timeoutId = useRef(null);
  const setStateWithDelay = useCallback(function(stateToSet) {
    let delayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    window.clearTimeout(timeoutId.current ?? void 0);
    timeoutId.current = null;
    if (delayMs === 0) {
      setState(stateToSet);
      return;
    }
    timeoutId.current = window.setTimeout(() => {
      setState(stateToSet);
      timeoutId.current = null;
    }, delayMs);
  }, []);
  useEffect(() => {
    return () => {
      window.clearTimeout(timeoutId.current ?? void 0);
    };
  }, []);
  return [state, setStateWithDelay];
}
function getInteractiveContent(node2) {
  if (!node2 || !node2.childNodes) {
    return null;
  }
  if (isFocusable(node2)) {
    return node2;
  }
  for (const childNode of node2.childNodes) {
    const interactiveNode = getInteractiveContent(childNode);
    if (interactiveNode) {
      return interactiveNode;
    }
  }
  return null;
}
function isFocusable(element) {
  if (element.tabIndex === void 0 || element.tabIndex < 0) {
    return false;
  }
  if (element.disabled) {
    return false;
  }
  switch (element.nodeName) {
    case "A":
      return !!element.href && element.rel !== "ignore";
    case "INPUT":
      return element.type !== "hidden";
    default:
      return true;
  }
}
const DRAG_STOP_EVENT_TYPES = /* @__PURE__ */ new Set(["mouseup", "touchend", "touchcancel"]);
function Tooltip$2(_ref3) {
  let {
    align = "top",
    className: customClassName,
    children,
    label: label2,
    description: description2,
    enterDelayMs = 100,
    leaveDelayMs = 300,
    defaultOpen = false,
    closeOnActivation = false,
    ...rest
  } = _ref3;
  useRef(null);
  const [open2, setOpen] = useDelayedState(defaultOpen);
  const [isDragging, setIsDragging] = useState(false);
  const [focusByMouse, setFocusByMouse] = useState(false);
  const [isPointerIntersecting, setIsPointerIntersecting] = useState(false);
  const id = useId$1("tooltip");
  const prefix2 = usePrefix();
  const child = React__default.Children.only(children);
  const triggerProps = {
    onFocus: () => !focusByMouse && setOpen(true),
    onBlur: () => {
      setOpen(false);
      setFocusByMouse(false);
    },
    onClick: () => closeOnActivation && setOpen(false),
    // This should be placed on the trigger in case the element is disabled
    onMouseEnter,
    onMouseLeave,
    onMouseDown,
    onMouseMove,
    onTouchStart: onDragStart
  };
  function getChildEventHandlers(childProps) {
    const eventHandlerFunctions = Object.keys(triggerProps).filter((prop) => prop.startsWith("on"));
    const eventHandlers = {};
    eventHandlerFunctions.forEach((functionName) => {
      eventHandlers[functionName] = (evt) => {
        triggerProps[functionName](evt);
        if (childProps?.[functionName]) {
          childProps?.[functionName](evt);
        }
      };
    });
    return eventHandlers;
  }
  if (label2) {
    triggerProps["aria-labelledby"] = id;
  } else {
    triggerProps["aria-describedby"] = id;
  }
  function onKeyDown(event) {
    if (open2 && match$1(event, Escape)) {
      event.stopPropagation();
      setOpen(false);
    }
    if (open2 && closeOnActivation && (match$1(event, Enter) || match$1(event, Space))) {
      setOpen(false);
    }
  }
  function onMouseEnter() {
    if (!rest?.onMouseEnter) {
      setIsPointerIntersecting(true);
      setOpen(true, enterDelayMs);
    }
  }
  function onMouseDown() {
    setFocusByMouse(true);
    onDragStart();
  }
  function onMouseLeave() {
    setIsPointerIntersecting(false);
    if (isDragging) {
      return;
    }
    setOpen(false, leaveDelayMs);
  }
  function onMouseMove(evt) {
    if (evt.buttons === 1) {
      setIsDragging(true);
    } else {
      setIsDragging(false);
    }
  }
  function onDragStart() {
    setIsDragging(true);
  }
  const onDragStop = useCallback(() => {
    setIsDragging(false);
    if (!isPointerIntersecting) {
      setOpen(false, leaveDelayMs);
    }
  }, [isPointerIntersecting, leaveDelayMs, setOpen]);
  useEffect(() => {
    if (isDragging) {
      DRAG_STOP_EVENT_TYPES.forEach((eventType) => {
        document.addEventListener(eventType, onDragStop);
      });
    }
    return () => {
      DRAG_STOP_EVENT_TYPES.forEach((eventType) => {
        document.removeEventListener(eventType, onDragStop);
      });
    };
  }, [isDragging, onDragStop]);
  return /* @__PURE__ */ React__default.createElement(Popover, _extends({}, rest, {
    align,
    className: r(`${prefix2}--tooltip`, customClassName),
    dropShadow: false,
    highContrast: true,
    onKeyDown,
    onMouseLeave,
    open: open2
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--tooltip-trigger__wrapper`
  }, child !== void 0 ? /* @__PURE__ */ React__default.cloneElement(child, {
    ...triggerProps,
    ...getChildEventHandlers(child.props)
  }) : null), /* @__PURE__ */ React__default.createElement(PopoverContent, {
    "aria-hidden": open2 ? "false" : "true",
    className: `${prefix2}--tooltip-content`,
    id,
    role: "tooltip"
  }, label2 || description2));
}
Tooltip$2.propTypes = {
  /**
   * Specify how the trigger should align with the tooltip
   */
  align: PropTypes.oneOf([
    "top",
    "top-left",
    // deprecated use top-start instead
    "top-right",
    // deprecated use top-end instead
    "bottom",
    "bottom-left",
    // deprecated use bottom-start instead
    "bottom-right",
    // deprecated use bottom-end instead
    "left",
    "left-bottom",
    // deprecated use left-end instead
    "left-top",
    // deprecated use left-start instead
    "right",
    "right-bottom",
    // deprecated use right-end instead
    "right-top",
    // deprecated use right-start instead
    // new values to match floating-ui
    "top-start",
    "top-end",
    "bottom-start",
    "bottom-end",
    "left-end",
    "left-start",
    "right-end",
    "right-start"
  ]),
  /**
   * Pass in the child to which the tooltip will be applied
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Determines wether the tooltip should close when inner content is activated (click, Enter or Space)
   */
  closeOnActivation: PropTypes.bool,
  /**
   * Specify whether the tooltip should be open when it first renders
   */
  defaultOpen: PropTypes.bool,
  /**
   * Provide the description to be rendered inside of the Tooltip. The
   * description will use `aria-describedby` and will describe the child node
   * in addition to the text rendered inside of the child. This means that if you
   * have text in the child node, that it will be announced alongside the
   * description to the screen reader.
   *
   * Note: if label and description are both provided, label will be used and
   * description will not be used
   */
  description: PropTypes.node,
  /**
   * Specify the duration in milliseconds to delay before displaying the tooltip
   */
  enterDelayMs: PropTypes.number,
  /**
   * Provide the label to be rendered inside of the Tooltip. The label will use
   * `aria-labelledby` and will fully describe the child node that is provided.
   * This means that if you have text in the child node, that it will not be
   * announced to the screen reader.
   *
   * Note: if label and description are both provided, description will not be
   * used
   */
  label: PropTypes.node,
  /**
   * Specify the duration in milliseconds to delay before hiding the tooltip
   */
  leaveDelayMs: PropTypes.number
};
const ButtonBase = /* @__PURE__ */ React__default.forwardRef(function ButtonBase2(_ref3, ref2) {
  let {
    as,
    children,
    className,
    dangerDescription = "danger",
    disabled: disabled2 = false,
    hasIconOnly = false,
    href,
    iconDescription,
    isExpressive = false,
    isSelected,
    kind = "primary",
    onBlur,
    onClick,
    onFocus: onFocus2,
    onMouseEnter,
    onMouseLeave,
    renderIcon: ButtonImageElement,
    size,
    tabIndex,
    type: type2 = "button",
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const buttonClasses = r(className, {
    [`${prefix2}--btn`]: true,
    [`${prefix2}--btn--sm`]: size === "sm" && !isExpressive,
    // TODO: V12 - Remove this class
    [`${prefix2}--btn--md`]: size === "md" && !isExpressive,
    // TODO: V12 - Remove this class
    [`${prefix2}--btn--xl`]: size === "xl",
    // TODO: V12 - Remove this class
    [`${prefix2}--btn--2xl`]: size === "2xl",
    // TODO: V12 - Remove this class
    [`${prefix2}--layout--size-${size}`]: size,
    [`${prefix2}--btn--${kind}`]: kind,
    [`${prefix2}--btn--disabled`]: disabled2,
    [`${prefix2}--btn--expressive`]: isExpressive,
    [`${prefix2}--btn--icon-only`]: hasIconOnly && !className?.includes(`${prefix2}--btn--icon-only`),
    [`${prefix2}--btn--selected`]: hasIconOnly && isSelected && kind === "ghost"
  });
  const commonProps = {
    tabIndex,
    className: buttonClasses,
    ref: ref2
  };
  const buttonImage = !ButtonImageElement ? null : /* @__PURE__ */ React__default.createElement(ButtonImageElement, {
    "aria-label": iconDescription,
    className: `${prefix2}--btn__icon`,
    "aria-hidden": "true"
  });
  const dangerButtonVariants = ["danger", "danger--tertiary", "danger--ghost"];
  let component = "button";
  const assistiveId = useId$1("danger-description");
  const {
    "aria-pressed": ariaPressed,
    "aria-describedby": ariaDescribedBy
  } = rest;
  let otherProps = {
    disabled: disabled2,
    type: type2,
    "aria-describedby": dangerButtonVariants.includes(kind) ? assistiveId : ariaDescribedBy || void 0,
    "aria-pressed": ariaPressed ?? (hasIconOnly && kind === "ghost" ? isSelected : void 0)
  };
  const anchorProps = {
    href
  };
  let assistiveText = null;
  if (dangerButtonVariants.includes(kind)) {
    assistiveText = /* @__PURE__ */ React__default.createElement("span", {
      id: assistiveId,
      className: `${prefix2}--visually-hidden`
    }, dangerDescription);
  }
  if (as) {
    component = as;
    otherProps = {
      ...otherProps,
      ...anchorProps
    };
  } else if (href && !disabled2) {
    component = "a";
    otherProps = anchorProps;
  }
  return /* @__PURE__ */ React__default.createElement(component, {
    onMouseEnter,
    onMouseLeave,
    onFocus: onFocus2,
    onBlur,
    onClick,
    ...rest,
    ...commonProps,
    ...otherProps
  }, assistiveText, children, buttonImage);
});
const IconButtonKinds = ["primary", "secondary", "ghost", "tertiary"];
const IconButton = /* @__PURE__ */ React__default.forwardRef(function IconButton2(_ref3, ref2) {
  let {
    align,
    children,
    className,
    closeOnActivation = true,
    defaultOpen = false,
    disabled: disabled2,
    enterDelayMs = 100,
    kind,
    label: label2,
    leaveDelayMs = 100,
    wrapperClasses,
    size,
    isSelected,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const tooltipClasses = r(wrapperClasses, `${prefix2}--icon-tooltip`, {
    [`${prefix2}--icon-tooltip--disabled`]: disabled2
  });
  return /* @__PURE__ */ React__default.createElement(Tooltip$2, {
    align,
    closeOnActivation,
    className: tooltipClasses,
    defaultOpen,
    enterDelayMs,
    label: label2,
    leaveDelayMs
  }, /* @__PURE__ */ React__default.createElement(ButtonBase, _extends({}, rest, {
    disabled: disabled2,
    kind,
    ref: ref2,
    size,
    className: r(`${prefix2}--btn--icon-only`, {
      [`${prefix2}--btn--selected`]: isSelected
    }, className)
  }), children));
});
IconButton.propTypes = {
  /**
   * Specify how the trigger should align with the tooltip
   */
  align: PropTypes.oneOf(["top", "top-left", "top-start", "top-right", "top-end", "bottom", "bottom-left", "bottom-start", "bottom-right", "bottom-end", "left", "right"]),
  /**
   * Provide an icon or asset to be rendered inside of the IconButton
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to your Button
   */
  className: PropTypes.string,
  /**
   * Determines whether the tooltip should close when inner content is activated (click, Enter or Space)
   */
  closeOnActivation: PropTypes.bool,
  /**
   * Specify whether the tooltip should be open when it first renders
   */
  defaultOpen: PropTypes.bool,
  /**
   * Specify whether the Button should be disabled, or not
   */
  disabled: PropTypes.bool,
  /**
   * Specify the duration in milliseconds to delay before displaying the tooltip
   */
  enterDelayMs: PropTypes.number,
  /**
   * Specify whether the IconButton is currently selected
   */
  isSelected: PropTypes.bool,
  /**
   * Specify the type of button to be used as the base for the IconButton
   */
  kind: PropTypes.oneOf(IconButtonKinds),
  /**
   * Provide the label to be rendered inside of the Tooltip. The label will use
   * `aria-labelledby` and will fully describe the child node that is provided.
   * This means that if you have text in the child node it will not be
   * announced to the screen reader.
   */
  label: PropTypes.node.isRequired,
  /**
   * Specify the duration in milliseconds to delay before hiding the tooltip
   */
  leaveDelayMs: PropTypes.number,
  /**
   * Specify the size of the Button. Defaults to `md`.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Specify an optional className to be added to your Tooltip wrapper
   */
  wrapperClasses: PropTypes.string
};
const composeEventHandlers = (fns) => function(event) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  for (let i3 = 0; i3 < fns.length; i3++) {
    if (event.defaultPrevented) {
      break;
    }
    const fn2 = fns[i3];
    if (typeof fn2 === "function") {
      fn2(event, ...args);
    }
  }
};
const ButtonKinds = ["primary", "secondary", "danger", "ghost", "danger--primary", "danger--ghost", "danger--tertiary", "tertiary"];
function isIconOnlyButton(hasIconOnly, _kind) {
  if (hasIconOnly === true) {
    return true;
  }
  return false;
}
const Button = /* @__PURE__ */ React__default.forwardRef(function Button2(props, ref2) {
  const tooltipRef = useRef(null);
  const {
    as,
    children,
    hasIconOnly = false,
    iconDescription,
    kind = "primary",
    onBlur,
    onClick,
    onFocus: onFocus2,
    onMouseEnter,
    onMouseLeave,
    renderIcon: ButtonImageElement,
    size,
    tooltipAlignment = "center",
    tooltipPosition = "top",
    ...rest
  } = props;
  const handleClick = (evt) => {
    if (evt.target === tooltipRef.current) {
      evt.preventDefault();
    }
  };
  const iconOnlyImage = !ButtonImageElement ? null : /* @__PURE__ */ React__default.createElement(ButtonImageElement, null);
  if (!isIconOnlyButton(hasIconOnly)) {
    const {
      tooltipAlignment: tooltipAlignment2,
      ...propsWithoutTooltipAlignment
    } = props;
    return /* @__PURE__ */ React__default.createElement(ButtonBase, _extends({
      ref: ref2
    }, propsWithoutTooltipAlignment));
  } else {
    let align = void 0;
    if (tooltipPosition === "top" || tooltipPosition === "bottom") {
      if (tooltipAlignment === "center") {
        align = tooltipPosition;
      }
      if (tooltipAlignment === "end") {
        align = `${tooltipPosition}-end`;
      }
      if (tooltipAlignment === "start") {
        align = `${tooltipPosition}-start`;
      }
    }
    if (tooltipPosition === "right" || tooltipPosition === "left") {
      align = tooltipPosition;
    }
    return /* @__PURE__ */ React__default.createElement(IconButton, _extends({}, rest, {
      ref: ref2,
      as,
      align,
      label: iconDescription,
      kind,
      size,
      onMouseEnter,
      onMouseLeave,
      onFocus: onFocus2,
      onBlur,
      onClick: composeEventHandlers([onClick, handleClick]),
      renderIcon: iconOnlyImage ? null : ButtonImageElement
      // avoid doubling the icon.
    }), iconOnlyImage ?? children);
  }
});
Button.displayName = "Button";
Button.propTypes = {
  /**
   * Specify how the button itself should be rendered.
   * Make sure to apply all props to the root node and render children appropriately
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.elementType]),
  /**
   * Specify the content of your Button
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to your Button
   */
  className: PropTypes.string,
  /**
   * Specify the message read by screen readers for the danger button variant
   */
  dangerDescription: PropTypes.string,
  /**
   * Specify whether the Button should be disabled, or not
   */
  disabled: PropTypes.bool,
  /**
   * Specify if the button is an icon-only button
   */
  hasIconOnly: PropTypes.bool,
  /**
   * Optionally specify an href for your Button to become an `<a>` element
   */
  href: PropTypes.string,
  /**
   * If specifying the `renderIcon` prop, provide a description for that icon that can
   * be read by screen readers
   */
  iconDescription: (props) => {
    if (props.renderIcon && !props.children && !props.iconDescription) {
      return new Error("renderIcon property specified without also providing an iconDescription property.");
    }
    return null;
  },
  /**
   * Specify whether the Button is expressive, or not
   */
  isExpressive: PropTypes.bool,
  /**
   * Specify whether the Button is currently selected. Only applies to the Ghost variant.
   */
  isSelected: PropTypes.bool,
  /**
   * Specify the kind of Button you want to create
   */
  // TODO: this should be either ButtonKinds or IconButtonKinds based on the value of "hasIconOnly"
  kind: PropTypes.oneOf(ButtonKinds),
  /**
   * Provide an optional function to be called when the button element
   * loses focus
   */
  onBlur: PropTypes.func,
  /**
   * Provide an optional function to be called when the button element
   * is clicked
   */
  onClick: PropTypes.func,
  /**
   * Provide an optional function to be called when the button element
   * receives focus
   */
  onFocus: PropTypes.func,
  /**
   * Provide an optional function to be called when the mouse
   * enters the button element
   */
  onMouseEnter: PropTypes.func,
  /**
   * Provide an optional function to be called when the mouse
   * leaves the button element
   */
  onMouseLeave: PropTypes.func,
  /**
   * Optional prop to allow overriding the icon rendering.
   * Can be a React component class
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Optional prop to specify the role of the Button
   */
  role: PropTypes.string,
  /**
   * Specify the size of the button, from the following list of sizes:
   */
  size: PropTypes.oneOf(["sm", "md", "lg", "xl", "2xl"]),
  /**
   * Optional prop to specify the tabIndex of the Button
   */
  tabIndex: PropTypes.number,
  /**
   * Specify the alignment of the tooltip to the icon-only button.
   * Can be one of: start, center, or end.
   */
  tooltipAlignment: PropTypes.oneOf(["start", "center", "end"]),
  /**
   * Specify the direction of the tooltip for icon-only buttons.
   * Can be either top, right, bottom, or left.
   */
  tooltipPosition: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  /**
   * Optional prop to specify the type of the Button
   */
  type: PropTypes.oneOf(["button", "reset", "submit"])
};
const noopFn = () => {
};
var MapShim = (function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    (function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value2) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value2;
        } else {
          this.__entries__.push([key, value2]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    })()
  );
})();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = (function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
})();
var requestAnimationFrame$1 = (function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
})();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  (function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  })()
);
var defineConfigurable = (function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
});
var getWindowOf = (function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
});
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value2) {
  return parseFloat(value2) || 0;
}
function getBordersSize(styles2) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position2) {
    var value2 = styles2["border-" + position2 + "-width"];
    return size + toFloat(value2);
  }, 0);
}
function getPaddings(styles2) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value2 = styles2["padding-" + position2];
    paddings[position2] = toFloat(value2);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles2 = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles2);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles2.width), height = toFloat(styles2.height);
  if (styles2.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles2, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles2, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = (function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
})();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x3 = _a.x, y3 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x3,
    y: y3,
    width,
    height,
    top: y3,
    right: x3 + width,
    bottom: height + y3,
    left: x3
  });
  return rect;
}
function createRectInit(x3, y3, width, height) {
  return { x: x3, y: y3, width, height };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  })()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  })()
);
var ResizeObserverSPI = (
  /** @class */
  (function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  })()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$1 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserver2(callback) {
      if (!(this instanceof ResizeObserver2)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver2;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver$1.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = (function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
})();
var lodash_debounce;
var hasRequiredLodash_debounce;
function requireLodash_debounce() {
  if (hasRequiredLodash_debounce) return lodash_debounce;
  hasRequiredLodash_debounce = 1;
  var FUNC_ERROR_TEXT = "Expected a function";
  var NAN = 0 / 0;
  var symbolTag = "[object Symbol]";
  var reTrim = /^\s+|\s+$/g;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal || freeSelf || Function("return this")();
  var objectProto = Object.prototype;
  var objectToString = objectProto.toString;
  var nativeMax = Math.max, nativeMin = Math.min;
  var now = function() {
    return root2.Date.now();
  };
  function debounce2(func, wait, options2) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject2(options2)) {
      leading = !!options2.leading;
      maxing = "maxWait" in options2;
      maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options2 ? !!options2.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
      return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result : trailingEdge(now());
    }
    function debounced() {
      var time = now(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  function isObject2(value2) {
    var type2 = typeof value2;
    return !!value2 && (type2 == "object" || type2 == "function");
  }
  function isObjectLike(value2) {
    return !!value2 && typeof value2 == "object";
  }
  function isSymbol(value2) {
    return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
  }
  function toNumber(value2) {
    if (typeof value2 == "number") {
      return value2;
    }
    if (isSymbol(value2)) {
      return NAN;
    }
    if (isObject2(value2)) {
      var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
      value2 = isObject2(other) ? other + "" : other;
    }
    if (typeof value2 != "string") {
      return value2 === 0 ? value2 : +value2;
    }
    value2 = value2.replace(reTrim, "");
    var isBinary = reIsBinary.test(value2);
    return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
  }
  lodash_debounce = debounce2;
  return lodash_debounce;
}
var lodash_debounceExports = requireLodash_debounce();
const debounce$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_debounceExports);
var reactIs = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b3 = /* @__PURE__ */ Symbol.for("react.element"), c3 = /* @__PURE__ */ Symbol.for("react.portal"), d4 = /* @__PURE__ */ Symbol.for("react.fragment"), e3 = /* @__PURE__ */ Symbol.for("react.strict_mode"), f2 = /* @__PURE__ */ Symbol.for("react.profiler"), g2 = /* @__PURE__ */ Symbol.for("react.provider"), h4 = /* @__PURE__ */ Symbol.for("react.context"), k3 = /* @__PURE__ */ Symbol.for("react.server_context"), l2 = /* @__PURE__ */ Symbol.for("react.forward_ref"), m4 = /* @__PURE__ */ Symbol.for("react.suspense"), n2 = /* @__PURE__ */ Symbol.for("react.suspense_list"), p2 = /* @__PURE__ */ Symbol.for("react.memo"), q3 = /* @__PURE__ */ Symbol.for("react.lazy"), t3 = /* @__PURE__ */ Symbol.for("react.offscreen"), u3;
  u3 = /* @__PURE__ */ Symbol.for("react.module.reference");
  function v2(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var r2 = a4.$$typeof;
      switch (r2) {
        case b3:
          switch (a4 = a4.type, a4) {
            case d4:
            case f2:
            case e3:
            case m4:
            case n2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case h4:
                case l2:
                case q3:
                case p2:
                case g2:
                  return a4;
                default:
                  return r2;
              }
          }
        case c3:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h4;
  reactIs_production_min.ContextProvider = g2;
  reactIs_production_min.Element = b3;
  reactIs_production_min.ForwardRef = l2;
  reactIs_production_min.Fragment = d4;
  reactIs_production_min.Lazy = q3;
  reactIs_production_min.Memo = p2;
  reactIs_production_min.Portal = c3;
  reactIs_production_min.Profiler = f2;
  reactIs_production_min.StrictMode = e3;
  reactIs_production_min.Suspense = m4;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a4) {
    return v2(a4) === h4;
  };
  reactIs_production_min.isContextProvider = function(a4) {
    return v2(a4) === g2;
  };
  reactIs_production_min.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === b3;
  };
  reactIs_production_min.isForwardRef = function(a4) {
    return v2(a4) === l2;
  };
  reactIs_production_min.isFragment = function(a4) {
    return v2(a4) === d4;
  };
  reactIs_production_min.isLazy = function(a4) {
    return v2(a4) === q3;
  };
  reactIs_production_min.isMemo = function(a4) {
    return v2(a4) === p2;
  };
  reactIs_production_min.isPortal = function(a4) {
    return v2(a4) === c3;
  };
  reactIs_production_min.isProfiler = function(a4) {
    return v2(a4) === f2;
  };
  reactIs_production_min.isStrictMode = function(a4) {
    return v2(a4) === e3;
  };
  reactIs_production_min.isSuspense = function(a4) {
    return v2(a4) === m4;
  };
  reactIs_production_min.isSuspenseList = function(a4) {
    return v2(a4) === n2;
  };
  reactIs_production_min.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === d4 || a4 === f2 || a4 === e3 || a4 === m4 || a4 === n2 || a4 === t3 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === q3 || a4.$$typeof === p2 || a4.$$typeof === g2 || a4.$$typeof === h4 || a4.$$typeof === l2 || a4.$$typeof === u3 || void 0 !== a4.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v2;
  return reactIs_production_min;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  {
    reactIs.exports = requireReactIs_production_min();
  }
  return reactIs.exports;
}
var reactIsExports = requireReactIs();
const FormContext = /* @__PURE__ */ createContext({
  isFluid: false
});
const mergeRefs = function() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return (el) => {
    refs.forEach((ref2) => {
      if (typeof ref2 === "function") {
        ref2(el);
      } else if (Object(ref2) === ref2) {
        ref2.current = el;
      }
    });
  };
};
var mergeRefs$1 = mergeRefs;
const menuDefaultState = {
  isRoot: true,
  mode: "full",
  hasIcons: false,
  size: null,
  items: [],
  requestCloseRoot: () => {
  }
};
function menuReducer(state, action) {
  switch (action.type) {
    case "enableIcons":
      return {
        ...state,
        hasIcons: true
      };
    case "registerItem":
      return {
        ...state,
        items: [...state.items, action.payload].filter((item2) => item2.ref.current !== null)
      };
  }
}
const MenuContext = /* @__PURE__ */ createContext({
  state: menuDefaultState,
  // 'dispatch' is populated by the root menu
  dispatch: (_2) => {
  }
});
const LayoutDirectionContext = /* @__PURE__ */ React__default.createContext({
  direction: "ltr"
});
function useLayoutDirection() {
  return useContext(LayoutDirectionContext);
}
const spacing = 8;
const Menu = /* @__PURE__ */ forwardRef(function Menu22(_ref3, forwardRef2) {
  let {
    children,
    className,
    containerRef,
    label: label2,
    menuAlignment,
    mode = "full",
    onClose,
    onOpen,
    open: open2,
    size = "sm",
    // TODO: #16004
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    target = document.body,
    x: x3 = 0,
    y: y3 = 0,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const focusReturn = useRef(null);
  const context = useContext(MenuContext);
  const isRoot = context.state.isRoot;
  if (context.state.mode === "basic" && !isRoot) ;
  const menuSize = isRoot ? size : context.state.size;
  const [childState, childDispatch] = useReducer(menuReducer, {
    ...context.state,
    isRoot: false,
    mode,
    size,
    requestCloseRoot: isRoot ? handleClose : context.state.requestCloseRoot
  });
  const childContext = useMemo(() => {
    return {
      state: childState,
      dispatch: childDispatch
    };
  }, [childState, childDispatch]);
  const menu = useRef(null);
  const ref2 = useMergedRefs([forwardRef2, menu]);
  const [position2, setPosition] = useState([-1, -1]);
  const focusableItems = childContext.state.items.filter((item2) => !item2.disabled && item2.ref.current);
  let actionButtonWidth;
  if (containerRef?.current) {
    const {
      width: w3
    } = containerRef.current.getBoundingClientRect();
    actionButtonWidth = w3;
  }
  const {
    direction
  } = useLayoutDirection();
  function returnFocus() {
    if (focusReturn.current) {
      focusReturn.current.focus();
    }
  }
  function handleOpen() {
    if (menu.current) {
      focusReturn.current = document.activeElement;
      const pos = calculatePosition();
      if ((document?.dir === "rtl" || direction === "rtl") && !rest?.id?.includes("MenuButton")) {
        menu.current.style.insetInlineStart = `initial`;
        menu.current.style.insetInlineEnd = `${pos[0]}px`;
      } else {
        menu.current.style.insetInlineStart = `${pos[0]}px`;
        menu.current.style.insetInlineEnd = `initial`;
      }
      menu.current.style.insetBlockStart = `${pos[1]}px`;
      setPosition(pos);
      menu.current.focus();
      if (onOpen) {
        onOpen();
      }
    }
  }
  function handleClose(e3) {
    if (/^key/.test(e3.type)) {
      window.addEventListener("keyup", returnFocus, {
        once: true
      });
    } else if (e3.type === "click" && menu.current) {
      menu.current.addEventListener("focusout", returnFocus, {
        once: true
      });
    } else {
      returnFocus();
    }
    if (onClose) {
      onClose();
    }
  }
  function handleKeyDown(e3) {
    e3.stopPropagation();
    if ((match$1(e3, Escape) || !isRoot && match$1(e3, ArrowLeft)) && onClose) {
      handleClose(e3);
    } else {
      focusItem(e3);
    }
  }
  function focusItem(e3) {
    const currentItem = focusableItems.findIndex((item2) => item2.ref?.current?.contains(document.activeElement));
    let indexToFocus = currentItem;
    if (currentItem === -1) {
      indexToFocus = 0;
    } else if (e3) {
      if (match$1(e3, ArrowUp)) {
        indexToFocus = indexToFocus - 1;
      }
      if (match$1(e3, ArrowDown)) {
        indexToFocus = indexToFocus + 1;
      }
    }
    if (indexToFocus < 0) {
      indexToFocus = focusableItems.length - 1;
    }
    if (indexToFocus >= focusableItems.length) {
      indexToFocus = 0;
    }
    if (indexToFocus !== currentItem) {
      const nodeToFocus = focusableItems[indexToFocus];
      nodeToFocus.ref.current.focus();
    }
  }
  function handleBlur(e3) {
    if (open2 && onClose && isRoot && !menu.current?.contains(e3.relatedTarget)) {
      handleClose(e3);
    }
  }
  function fitValue(range2, axis) {
    if (!menu.current) {
      return;
    }
    const {
      width,
      height
    } = menu.current.getBoundingClientRect();
    const alignment = isRoot ? "vertical" : "horizontal";
    const axes = {
      x: {
        max: window.innerWidth,
        size: width,
        anchor: alignment === "horizontal" ? range2[1] : range2[0],
        reversedAnchor: alignment === "horizontal" ? range2[0] : range2[1],
        offset: 0
      },
      y: {
        max: window.innerHeight,
        size: height,
        anchor: alignment === "horizontal" ? range2[0] : range2[1],
        reversedAnchor: alignment === "horizontal" ? range2[1] : range2[0],
        offset: isRoot ? 0 : 4
        // top padding in menu, used to align the menu items
      }
    };
    if (actionButtonWidth && actionButtonWidth < axes.x.size && (menuAlignment === "bottom" || menuAlignment === "top")) {
      axes.x.size = actionButtonWidth;
    }
    if (actionButtonWidth && (menuAlignment === "bottom-end" || menuAlignment === "top-end") && axes.x.anchor >= 87 && actionButtonWidth < axes.x.size) {
      const diff = axes.x.anchor + axes.x.reversedAnchor;
      axes.x.anchor = axes.x.anchor + diff;
    }
    const {
      max: max2,
      size: size2,
      anchor: anchor2,
      reversedAnchor,
      offset: offset3
    } = axes[axis];
    const options2 = [
      // towards max (preferred)
      max2 - spacing - size2 - anchor2 >= 0 ? anchor2 - offset3 : false,
      // towards min / reversed (first fallback)
      reversedAnchor - size2 >= 0 ? reversedAnchor - size2 + offset3 : false,
      // align at max (second fallback)
      max2 - spacing - size2
    ];
    const topAlignment = menuAlignment === "top" || menuAlignment === "top-end" || menuAlignment === "top-start";
    if (typeof options2[0] === "number" && topAlignment && options2[0] >= 0 && !options2[1] && axis === "y") {
      menu.current.style.transform = "translate(0)";
    } else if (topAlignment && !options2[0] && axis === "y") {
      options2[0] = anchor2 - offset3;
    }
    const bestOption = options2.find((option) => option !== false);
    return bestOption >= spacing ? bestOption : spacing;
  }
  function notEmpty(value2) {
    return value2 !== null && value2 !== void 0;
  }
  function getPosition(x22) {
    if (Array.isArray(x22)) {
      const filtered = x22.filter(notEmpty);
      if (filtered.length === 2) {
        return filtered;
      } else {
        return;
      }
    } else {
      return [x22, x22];
    }
  }
  function calculatePosition() {
    const ranges = {
      x: getPosition(x3),
      y: getPosition(y3)
    };
    if (!ranges.x || !ranges.y) {
      return [-1, -1];
    }
    return [fitValue(ranges.x, "x") ?? -1, fitValue(ranges.y, "y") ?? -1];
  }
  useEffect(() => {
    if (open2 && focusableItems.length > 0) {
      focusItem();
    }
  }, [open2, focusableItems]);
  useEffect(() => {
    if (open2) {
      handleOpen();
    } else {
      setPosition([-1, -1]);
    }
  }, [open2]);
  const classNames2 = r(className, `${prefix2}--menu`, `${prefix2}--menu--${menuSize}`, {
    // --open sets visibility and --shown sets opacity.
    // visibility is needed for focusing elements.
    // opacity is only set once the position has been set correctly
    // to avoid a flicker effect when opening.
    [`${prefix2}--menu--box-shadow-top`]: menuAlignment && menuAlignment.slice(0, 3) === "top",
    [`${prefix2}--menu--open`]: open2,
    [`${prefix2}--menu--shown`]: position2[0] >= 0 && position2[1] >= 0,
    [`${prefix2}--menu--with-icons`]: childContext.state.hasIcons
  });
  const rendered = /* @__PURE__ */ React__default.createElement(MenuContext.Provider, {
    value: childContext
  }, /* @__PURE__ */ React__default.createElement("ul", _extends({}, rest, {
    className: classNames2,
    role: "menu",
    ref: ref2,
    "aria-label": label2,
    tabIndex: -1,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  }), children));
  return isRoot ? open2 && /* @__PURE__ */ createPortal(rendered, target) || null : rendered;
});
Menu.propTypes = {
  /**
   * A collection of MenuItems to be rendered within this Menu.
   */
  children: PropTypes.node,
  /**
   * Additional CSS class names.
   */
  className: PropTypes.string,
  /**
   * A label describing the Menu.
   */
  // @ts-ignore-next-line -- avoid spurious (?) TS2322 error
  label: PropTypes.string,
  /**
   * Specify how the menu should align with the button element
   */
  menuAlignment: PropTypes.string,
  /**
   * The mode of this menu. Defaults to full.
   * `full` supports nesting and selectable menu items, but no icons.
   * `basic` supports icons but no nesting or selectable menu items.
   *
   * **This prop is not intended for use and will be set by the respective implementation (like useContextMenu, MenuButton, and ComboButton).**
   */
  mode: PropTypes.oneOf(["full", "basic"]),
  /**
   * Provide an optional function to be called when the Menu should be closed.
   */
  onClose: PropTypes.func,
  /**
   * Provide an optional function to be called when the Menu is opened.
   */
  onOpen: PropTypes.func,
  /**
   * Whether the Menu is open or not.
   */
  open: PropTypes.bool,
  /**
   * Specify the size of the Menu.
   */
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  /**
   * Specify a DOM node where the Menu should be rendered in. Defaults to document.body.
   */
  // @ts-ignore-next-line -- avoid spurious (?) TS2322 error
  target: PropTypes.object,
  /**
   * Specify the x position of the Menu. Either pass a single number or an array with two numbers describing your activator's boundaries ([x1, x2])
   */
  // @ts-ignore-next-line -- avoid spurious (?) TS2322 error
  x: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  /**
   * Specify the y position of the Menu. Either pass a single number or an array with two numbers describing your activator's boundaries ([y1, y2])
   */
  // @ts-ignore-next-line -- avoid spurious (?) TS2322 error
  y: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
};
function useControllableState(_ref3) {
  let {
    defaultValue,
    name: name2 = "custom",
    onChange: onChange2,
    value: value2
  } = _ref3;
  const [state, internalSetState] = useState(value2 ?? defaultValue);
  const controlled = useRef(null);
  if (controlled.current === null) {
    controlled.current = value2 !== void 0;
  }
  function setState(stateOrUpdater) {
    const value22 = typeof stateOrUpdater === "function" ? stateOrUpdater(state) : stateOrUpdater;
    if (controlled.current === false) {
      internalSetState(value22);
    }
    if (onChange2) {
      onChange2(value22);
    }
  }
  useEffect(() => {
    const controlledValue = value2 !== void 0;
    if (controlled.current === false && controlledValue) ;
    if (controlled.current === true && !controlledValue) ;
  }, [name2, value2]);
  if (controlled.current === true) {
    return [value2, setState];
  }
  return [state, setState];
}
function useAttachedMenu(anchor2) {
  const [open2, setOpen] = useState(false);
  const [position2, setPosition] = useState([[-1, -1], [-1, -1]]);
  function openMenu() {
    const anchorEl = anchor2?.current || anchor2;
    if (anchorEl) {
      const {
        left: left2,
        top: top2,
        right: right2,
        bottom: bottom2
      } = anchorEl.getBoundingClientRect();
      setPosition([[left2, right2], [top2, bottom2]]);
    }
    setOpen(true);
  }
  function closeMenu() {
    setOpen(false);
  }
  function handleClick() {
    if (open2) {
      closeMenu();
    } else {
      openMenu();
    }
  }
  function handleMousedown(e3) {
    e3.preventDefault();
  }
  return {
    open: open2,
    x: position2[0],
    y: position2[1],
    handleClick,
    handleMousedown,
    handleClose: closeMenu
  };
}
function requiredIfGivenPropIsTruthy(name2, propType) {
  return function check(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return propType(props, propName, componentName, ...rest);
  };
}
var lodash_findlast = { exports: {} };
lodash_findlast.exports;
var hasRequiredLodash_findlast;
function requireLodash_findlast() {
  if (hasRequiredLodash_findlast) return lodash_findlast.exports;
  hasRequiredLodash_findlast = 1;
  (function(module, exports$1) {
    var LARGE_ARRAY_SIZE = 200;
    var FUNC_ERROR_TEXT = "Expected a function";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reTrim = /^\s+|\s+$/g;
    var reEscapeChar = /\\(\\)?/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports$1 && !exports$1.nodeType && exports$1;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = (function() {
      try {
        return freeProcess && freeProcess.binding("util");
      } catch (e3) {
      }
    })();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array ? array.length : 0;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      array.length;
      var index2 = fromIndex + 1;
      while (index2--) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? void 0 : object[key];
      };
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value2) {
        return func(value2);
      };
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function isHostObject(value2) {
      var result = false;
      if (value2 != null && typeof value2.toString != "function") {
        try {
          result = !!(value2 + "");
        } catch (e3) {
        }
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value2, key) {
        result[++index2] = [key, value2];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value2) {
        result[++index2] = value2;
      });
      return result;
    }
    var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var maskSrcKey = (function() {
      var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid2 ? "Symbol(src)_1." + uid2 : "";
    })();
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
    var nativeKeys = overArg(Object.keys, Object), nativeMax = Math.max, nativeMin = Math.min;
    var DataView2 = getNative(root2, "DataView"), Map2 = getNative(root2, "Map"), Promise2 = getNative(root2, "Promise"), Set2 = getNative(root2, "Set"), WeakMap2 = getNative(root2, "WeakMap"), nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
    function Hash(entries) {
      var index2 = -1, length2 = entries ? entries.length : 0;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value2) {
      var data = this.__data__;
      data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index2 = -1, length2 = entries ? entries.length : 0;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
    }
    function listCacheDelete(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index2 == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index2, 1);
      }
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      return index2 < 0 ? void 0 : data[index2][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value2) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        data.push([key, value2]);
      } else {
        data[index2][1] = value2;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index2 = -1, length2 = entries ? entries.length : 0;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      return getMapData(this, key)["delete"](key);
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value2) {
      getMapData(this, key).set(key, value2);
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index2 = -1, length2 = values ? values.length : 0;
      this.__data__ = new MapCache();
      while (++index2 < length2) {
        this.add(values[index2]);
      }
    }
    function setCacheAdd(value2) {
      this.__data__.set(value2, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value2) {
      return this.__data__.has(value2);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      this.__data__ = new ListCache(entries);
    }
    function stackClear() {
      this.__data__ = new ListCache();
    }
    function stackDelete(key) {
      return this.__data__["delete"](key);
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value2) {
      var cache = this.__data__;
      if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value2]);
          return this;
        }
        cache = this.__data__ = new MapCache(pairs);
      }
      cache.set(key, value2);
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value2, inherited) {
      var result = isArray2(value2) || isArguments2(value2) ? baseTimes(value2.length, String) : [];
      var length2 = result.length, skipIndexes = !!length2;
      for (var key in value2) {
        if (hasOwnProperty.call(value2, key) && !(skipIndexes && (key == "length" || isIndex(key, length2)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key)) {
          return length2;
        }
      }
      return -1;
    }
    function baseGet(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);
      var index2 = 0, length2 = path.length;
      while (object != null && index2 < length2) {
        object = object[toKey2(path[index2++])];
      }
      return index2 && index2 == length2 ? object : void 0;
    }
    function baseGetTag(value2) {
      return objectToString.call(value2);
    }
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    function baseIsEqual(value2, other, customizer, bitmask, stack) {
      if (value2 === other) {
        return true;
      }
      if (value2 == null || other == null || !isObject2(value2) && !isObjectLike(other)) {
        return value2 !== value2 && other !== other;
      }
      return baseIsEqualDeep(value2, other, baseIsEqual, customizer, bitmask, stack);
    }
    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
      var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = arrayTag, othTag = arrayTag;
      if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
      }
      if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
      }
      var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
      }
      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
    }
    function baseIsMatch(object, source, matchData, customizer) {
      var index2 = matchData.length, length2 = index2;
      if (object == null) {
        return !length2;
      }
      object = Object(object);
      while (index2--) {
        var data = matchData[index2];
        if (data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index2 < length2) {
        data = matchData[index2];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (data[2]) {
          if (objValue === void 0 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          var result;
          if (!(result === void 0 ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    function baseIsNative(value2) {
      if (!isObject2(value2) || isMasked(value2)) {
        return false;
      }
      var pattern = isFunction(value2) || isHostObject(value2) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value2));
    }
    function baseIsTypedArray(value2) {
      return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[objectToString.call(value2)];
    }
    function baseIteratee(value2) {
      if (typeof value2 == "function") {
        return value2;
      }
      if (value2 == null) {
        return identity;
      }
      if (typeof value2 == "object") {
        return isArray2(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
      }
      return property(value2);
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey2(path), srcValue);
      }
      return function(object) {
        var objValue = get2(object, path);
        return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, void 0, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
      };
    }
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }
    function baseToString(value2) {
      if (typeof value2 == "string") {
        return value2;
      }
      if (isSymbol(value2)) {
        return symbolToString ? symbolToString.call(value2) : "";
      }
      var result = value2 + "";
      return result == "0" && 1 / value2 == -INFINITY ? "-0" : result;
    }
    function castPath(value2) {
      return isArray2(value2) ? value2 : stringToPath(value2);
    }
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = baseIteratee(predicate);
          collection = keys(collection);
          predicate = function(key) {
            return iteratee(iterable[key], key, iterable);
          };
        }
        var index2 = findIndexFunc(collection, predicate, fromIndex);
        return index2 > -1 ? iterable[iteratee ? collection[index2] : index2] : void 0;
      };
    }
    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index2 = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index2 < arrLength) {
        var arrValue = array[index2], othValue = other[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!seen.has(othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= UNORDERED_COMPARE_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key = objProps[index2];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key = objProps[index2];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getMatchData(object) {
      var result = keys(object), length2 = result.length;
      while (length2--) {
        var key = result[length2], value2 = object[key];
        result[length2] = [key, value2, isStrictComparable(value2)];
      }
      return result;
    }
    function getNative(object, key) {
      var value2 = getValue(object, key);
      return baseIsNative(value2) ? value2 : void 0;
    }
    var getTag = baseGetTag;
    if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value2) {
        var result = objectToString.call(value2), Ctor = result == objectTag ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function hasPath(object, path, hasFunc) {
      path = isKey(path, object) ? [path] : castPath(path);
      var result, index2 = -1, length2 = path.length;
      while (++index2 < length2) {
        var key = toKey2(path[index2]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result) {
        return result;
      }
      var length2 = object ? object.length : 0;
      return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray2(object) || isArguments2(object));
    }
    function isIndex(value2, length2) {
      length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
      return !!length2 && (typeof value2 == "number" || reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
    }
    function isKey(value2, object) {
      if (isArray2(value2)) {
        return false;
      }
      var type2 = typeof value2;
      if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value2 == null || isSymbol(value2)) {
        return true;
      }
      return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
    }
    function isKeyable(value2) {
      var type2 = typeof value2;
      return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value2 !== "__proto__" : value2 === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value2) {
      var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value2 === proto;
    }
    function isStrictComparable(value2) {
      return value2 === value2 && !isObject2(value2);
    }
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
      };
    }
    var stringToPath = memoize2(function(string) {
      string = toString(string);
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push("");
      }
      string.replace(rePropName, function(match2, number, quote, string2) {
        result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match2);
      });
      return result;
    });
    function toKey2(value2) {
      if (typeof value2 == "string" || isSymbol(value2)) {
        return value2;
      }
      var result = value2 + "";
      return result == "0" && 1 / value2 == -INFINITY ? "-0" : result;
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e3) {
        }
        try {
          return func + "";
        } catch (e3) {
        }
      }
      return "";
    }
    function findLastIndex(array, predicate, fromIndex) {
      var length2 = array ? array.length : 0;
      if (!length2) {
        return -1;
      }
      var index2 = length2 - 1;
      if (fromIndex !== void 0) {
        index2 = toInteger2(fromIndex);
        index2 = fromIndex < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
      }
      return baseFindIndex(array, baseIteratee(predicate), index2);
    }
    var findLast2 = createFind(findLastIndex);
    function memoize2(func, resolver) {
      if (typeof func != "function" || resolver && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized2 = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized2.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized2.cache = cache.set(key, result);
        return result;
      };
      memoized2.cache = new (memoize2.Cache || MapCache)();
      return memoized2;
    }
    memoize2.Cache = MapCache;
    function eq(value2, other) {
      return value2 === other || value2 !== value2 && other !== other;
    }
    function isArguments2(value2) {
      return isArrayLikeObject(value2) && hasOwnProperty.call(value2, "callee") && (!propertyIsEnumerable.call(value2, "callee") || objectToString.call(value2) == argsTag);
    }
    var isArray2 = Array.isArray;
    function isArrayLike(value2) {
      return value2 != null && isLength(value2.length) && !isFunction(value2);
    }
    function isArrayLikeObject(value2) {
      return isObjectLike(value2) && isArrayLike(value2);
    }
    function isFunction(value2) {
      var tag = isObject2(value2) ? objectToString.call(value2) : "";
      return tag == funcTag || tag == genTag;
    }
    function isLength(value2) {
      return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
    }
    function isObject2(value2) {
      var type2 = typeof value2;
      return !!value2 && (type2 == "object" || type2 == "function");
    }
    function isObjectLike(value2) {
      return !!value2 && typeof value2 == "object";
    }
    function isSymbol(value2) {
      return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function toFinite(value2) {
      if (!value2) {
        return value2 === 0 ? value2 : 0;
      }
      value2 = toNumber(value2);
      if (value2 === INFINITY || value2 === -INFINITY) {
        var sign2 = value2 < 0 ? -1 : 1;
        return sign2 * MAX_INTEGER;
      }
      return value2 === value2 ? value2 : 0;
    }
    function toInteger2(value2) {
      var result = toFinite(value2), remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    function toNumber(value2) {
      if (typeof value2 == "number") {
        return value2;
      }
      if (isSymbol(value2)) {
        return NAN;
      }
      if (isObject2(value2)) {
        var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
        value2 = isObject2(other) ? other + "" : other;
      }
      if (typeof value2 != "string") {
        return value2 === 0 ? value2 : +value2;
      }
      value2 = value2.replace(reTrim, "");
      var isBinary = reIsBinary.test(value2);
      return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
    }
    function toString(value2) {
      return value2 == null ? "" : baseToString(value2);
    }
    function get2(object, path, defaultValue) {
      var result = object == null ? void 0 : baseGet(object, path);
      return result === void 0 ? defaultValue : result;
    }
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function identity(value2) {
      return value2;
    }
    function property(path) {
      return isKey(path) ? baseProperty(toKey2(path)) : basePropertyDeep(path);
    }
    module.exports = findLast2;
  })(lodash_findlast, lodash_findlast.exports);
  return lodash_findlast.exports;
}
var lodash_findlastExports = requireLodash_findlast();
const findLast = /* @__PURE__ */ getDefaultExportFromCjs(lodash_findlastExports);
const DOCUMENT_POSITION_BROAD_PRECEDING = (
  // Checks `typeof Node` for `react-docgen`
  typeof Node !== "undefined" && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
  Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS
);
const DOCUMENT_POSITION_BROAD_FOLLOWING = (
  // Checks `typeof Node` for `react-docgen`
  typeof Node !== "undefined" && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
  Node.DOCUMENT_POSITION_FOLLOWING | Node.DOCUMENT_POSITION_CONTAINED_BY
);
const selectorTabbable = `
  a[href], area[href], input:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  iframe, object, embed, *[tabindex]:not([tabindex='-1']):not([disabled]), *[contenteditable=true]
`;
const selectorFocusable = `
  a[href], area[href], input:not([disabled]),
  button:not([disabled]),select:not([disabled]),
  textarea:not([disabled]),
  iframe, object, embed, *[tabindex]:not([disabled]), *[contenteditable=true]
`;
function elementOrParentIsFloatingMenu(node2) {
  let selectorsFloatingMenus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (node2 && typeof node2.closest === "function") {
    const allSelectorsFloatingMenus = [`.cds--overflow-menu-options`, `.cds--tooltip`, ".flatpickr-calendar", ...selectorsFloatingMenus];
    return allSelectorsFloatingMenus.some((selector) => node2.closest(selector));
  }
}
function wrapFocus(_ref3) {
  let {
    bodyNode,
    startTrapNode,
    endTrapNode,
    currentActiveNode,
    oldActiveNode,
    selectorsFloatingMenus
  } = _ref3;
  if (bodyNode && currentActiveNode && oldActiveNode && !bodyNode.contains(currentActiveNode) && !elementOrParentIsFloatingMenu(currentActiveNode, selectorsFloatingMenus)) {
    const comparisonResult = oldActiveNode.compareDocumentPosition(currentActiveNode);
    if (currentActiveNode === startTrapNode || comparisonResult & DOCUMENT_POSITION_BROAD_PRECEDING) {
      const tabbable22 = findLast(bodyNode.querySelectorAll(selectorTabbable), (elem) => Boolean(elem.offsetParent));
      if (tabbable22) {
        tabbable22.focus();
      } else if (bodyNode !== oldActiveNode) {
        bodyNode.focus();
      }
    } else if (currentActiveNode === endTrapNode || comparisonResult & DOCUMENT_POSITION_BROAD_FOLLOWING) {
      const tabbable22 = Array.prototype.find.call(bodyNode.querySelectorAll(selectorTabbable), (elem) => Boolean(elem.offsetParent));
      if (tabbable22) {
        tabbable22.focus();
      } else if (bodyNode !== oldActiveNode) {
        bodyNode.focus();
      }
    }
  }
}
function wrapFocusWithoutSentinels(_ref22) {
  let {
    containerNode,
    currentActiveNode,
    event
  } = _ref22;
  if (["blur", "focusout", "focusin", "focus"].includes(event.type) && false) ;
  const tabbables = tabbable(containerNode);
  const firstTabbable = tabbables[0];
  const lastTabbable = tabbables[tabbables.length - 1];
  if (currentActiveNode === lastTabbable && !event.shiftKey) {
    event.preventDefault();
    firstTabbable.focus();
  }
  if (currentActiveNode === firstTabbable && event.shiftKey) {
    event.preventDefault();
    lastTabbable.focus();
  }
}
const FeatureFlagContext = /* @__PURE__ */ createContext(FeatureFlags);
({
  children: PropTypes.node,
  /**
   * Provide the feature flags to enabled or disabled in the current React tree
   */
  flags: PropTypes.objectOf(PropTypes.bool)
});
function useFeatureFlag(flag) {
  const scope = useContext(FeatureFlagContext);
  return scope.enabled(flag);
}
function createClassWrapper(Component2) {
  function ClassWrapper(props) {
    return /* @__PURE__ */ React__default.createElement(Component2, props);
  }
  const name2 = Component2.displayName || Component2.name;
  ClassWrapper.displayName = `ClassWrapper(${name2})`;
  return ClassWrapper;
}
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
var hasRequiredLodash_isequal;
function requireLodash_isequal() {
  if (hasRequiredLodash_isequal) return lodash_isequal.exports;
  hasRequiredLodash_isequal = 1;
  (function(module, exports$1) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports$1 && !exports$1.nodeType && exports$1;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = (function() {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e3) {
      }
    })();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value2 = array[index2];
        if (predicate(value2, index2, array)) {
          result[resIndex++] = value2;
        }
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length2 = values.length, offset3 = array.length;
      while (++index2 < length2) {
        array[offset3 + index2] = values[index2];
      }
      return array;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value2) {
        return func(value2);
      };
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value2, key) {
        result[++index2] = [key, value2];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value2) {
        result[++index2] = value2;
      });
      return result;
    }
    var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = (function() {
      var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid2 ? "Symbol(src)_1." + uid2 : "";
    })();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
    var DataView2 = getNative(root2, "DataView"), Map2 = getNative(root2, "Map"), Promise2 = getNative(root2, "Promise"), Set2 = getNative(root2, "Set"), WeakMap2 = getNative(root2, "WeakMap"), nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value2) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index2 == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index2, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      return index2 < 0 ? void 0 : data[index2][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value2) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        ++this.size;
        data.push([key, value2]);
      } else {
        data[index2][1] = value2;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value2) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value2);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index2 = -1, length2 = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index2 < length2) {
        this.add(values[index2]);
      }
    }
    function setCacheAdd(value2) {
      this.__data__.set(value2, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value2) {
      return this.__data__.has(value2);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value2) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value2]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value2);
      this.size = data.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value2, inherited) {
      var isArr = isArray2(value2), isArg = !isArr && isArguments2(value2), isBuff = !isArr && !isArg && isBuffer(value2), isType = !isArr && !isArg && !isBuff && isTypedArray(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value2.length, String) : [], length2 = result.length;
      for (var key in value2) {
        if (hasOwnProperty.call(value2, key) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length2)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key)) {
          return length2;
        }
      }
      return -1;
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value2) {
      if (value2 == null) {
        return value2 === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString(value2);
    }
    function baseIsArguments(value2) {
      return isObjectLike(value2) && baseGetTag(value2) == argsTag;
    }
    function baseIsEqual(value2, other, bitmask, customizer, stack) {
      if (value2 === other) {
        return true;
      }
      if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
        return value2 !== value2 && other !== other;
      }
      return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
    }
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    function baseIsNative(value2) {
      if (!isObject2(value2) || isMasked(value2)) {
        return false;
      }
      var pattern = isFunction(value2) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value2));
    }
    function baseIsTypedArray(value2) {
      return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index2 < arrLength) {
        var arrValue = array[index2], othValue = other[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key = objProps[index2];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key = objProps[index2];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value2 = getValue(object, key);
      return baseIsNative(value2) ? value2 : void 0;
    }
    function getRawTag(value2) {
      var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
      try {
        value2[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e3) {
      }
      var result = nativeObjectToString.call(value2);
      if (unmasked) {
        if (isOwn) {
          value2[symToStringTag] = tag;
        } else {
          delete value2[symToStringTag];
        }
      }
      return result;
    }
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value2) {
        var result = baseGetTag(value2), Ctor = result == objectTag ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isIndex(value2, length2) {
      length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
      return !!length2 && (typeof value2 == "number" || reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
    }
    function isKeyable(value2) {
      var type2 = typeof value2;
      return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value2 !== "__proto__" : value2 === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value2) {
      var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value2 === proto;
    }
    function objectToString(value2) {
      return nativeObjectToString.call(value2);
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e3) {
        }
        try {
          return func + "";
        } catch (e3) {
        }
      }
      return "";
    }
    function eq(value2, other) {
      return value2 === other || value2 !== value2 && other !== other;
    }
    var isArguments2 = baseIsArguments(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? baseIsArguments : function(value2) {
      return isObjectLike(value2) && hasOwnProperty.call(value2, "callee") && !propertyIsEnumerable.call(value2, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike(value2) {
      return value2 != null && isLength(value2.length) && !isFunction(value2);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual2(value2, other) {
      return baseIsEqual(value2, other);
    }
    function isFunction(value2) {
      if (!isObject2(value2)) {
        return false;
      }
      var tag = baseGetTag(value2);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value2) {
      return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
    }
    function isObject2(value2) {
      var type2 = typeof value2;
      return value2 != null && (type2 == "object" || type2 == "function");
    }
    function isObjectLike(value2) {
      return value2 != null && typeof value2 == "object";
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module.exports = isEqual2;
  })(lodash_isequal, lodash_isequal.exports);
  return lodash_isequal.exports;
}
var lodash_isequalExports = requireLodash_isequal();
const isEqual$3 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_isequalExports);
const sortStates = {
  NONE: "NONE",
  DESC: "DESC",
  ASC: "ASC"
};
const getCellId = (rowId, header2) => `${rowId}:${header2}`;
const compare = function(a4, b3) {
  let locale2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en";
  a4 === null ? a4 = "" : null;
  b3 === null ? b3 = "" : null;
  if (typeof a4 === "number" && typeof b3 === "number") {
    return a4 - b3;
  }
  if (typeof a4 === "string" && typeof b3 === "string") {
    return compareStrings(a4, b3, locale2);
  }
  if (typeof a4 === "object" && typeof b3 === "object") {
    if (typeof a4.props?.children === "string" && typeof b3.props?.children === "string") {
      return compareStrings(a4.props.children, b3.props.children, locale2);
    }
  }
  return compareStrings("" + a4, "" + b3, locale2);
};
const compareStrings = function(a4, b3) {
  let locale2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en";
  if (!isNaN(a4) && !isNaN(parseFloat(a4)) && !isNaN(b3) && !isNaN(parseFloat(b3))) {
    return a4.localeCompare(b3, locale2, {
      numeric: true
    });
  }
  return a4.localeCompare(b3, locale2);
};
const sortRows = (_ref3) => {
  let {
    rowIds,
    cellsById,
    sortDirection,
    key,
    locale: locale2 = "en",
    sortRow = defaultSortRow
  } = _ref3;
  return rowIds.slice().sort((a4, b3) => {
    const cellA = cellsById[getCellId(a4, key)];
    const cellB = cellsById[getCellId(b3, key)];
    return sortRow(cellA && cellA.value, cellB && cellB.value, {
      key,
      sortDirection,
      locale: locale2,
      sortStates,
      compare,
      rowIds: [a4, b3]
    });
  });
};
const defaultSortRow = (cellA, cellB, _ref22) => {
  let {
    sortDirection,
    sortStates: sortStates2,
    locale: locale2
  } = _ref22;
  if (sortDirection === sortStates2.ASC) {
    return compare(cellA, cellB, locale2);
  }
  return compare(cellB, cellA, locale2);
};
const initialSortState = sortStates.NONE;
const getNextSortDirection = (prevHeader, header2, prevState) => {
  if (prevHeader === header2) {
    if (prevState === "NONE") {
      return sortStates.ASC;
    }
    if (prevState === "ASC") {
      return sortStates.DESC;
    }
    return sortStates.NONE;
  }
  return sortStates.ASC;
};
const getNextSortState = (props, state, _ref3) => {
  let {
    key
  } = _ref3;
  const {
    sortDirection,
    sortHeaderKey
  } = state;
  const nextSortDirection = getNextSortDirection(key, sortHeaderKey, sortDirection);
  return getSortedState(props, state, key, nextSortDirection);
};
const getSortedState = (props, state, key, sortDirection) => {
  const {
    rowIds,
    cellsById,
    initialRowOrder
  } = state;
  const {
    locale: locale2,
    sortRow
  } = props;
  const nextRowIds = sortDirection !== sortStates.NONE ? sortRows({
    rowIds,
    cellsById,
    sortDirection,
    key,
    locale: locale2,
    sortRow
  }) : initialRowOrder;
  return {
    sortHeaderKey: key,
    sortDirection,
    rowIds: nextRowIds
  };
};
const normalize = function(rows, headers) {
  let prevState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    rowsById: prevRowsByIds
  } = prevState;
  const rowIds = new Array(rows.length);
  const rowsById = {};
  const cellsById = {};
  rows.forEach((row2, i3) => {
    rowIds[i3] = row2.id;
    const {
      id,
      isSelected = false,
      isExpanded = false,
      disabled: disabled2 = false
    } = row2;
    rowsById[id] = {
      id,
      isSelected,
      isExpanded,
      disabled: disabled2,
      cells: new Array(headers.length)
    };
    if (prevRowsByIds && prevRowsByIds[row2.id] !== void 0) {
      rowsById[row2.id].isSelected = prevRowsByIds[row2.id].isSelected;
      rowsById[row2.id].isExpanded = prevRowsByIds[row2.id].isExpanded;
    }
    headers.forEach((_ref3, i4) => {
      let {
        key,
        slug
      } = _ref3;
      const id2 = getCellId(row2.id, key);
      cellsById[id2] = {
        id: id2,
        value: row2[key],
        isEditable: false,
        isEditing: false,
        isValid: true,
        errors: null,
        hasSlugHeader: !!slug,
        info: {
          header: key
        }
      };
      rowsById[row2.id].cells[i4] = id2;
    });
  });
  return {
    rowIds,
    rowsById,
    cellsById
  };
};
var normalize$1 = normalize;
const getDerivedStateFromProps = (props, prevState) => {
  const {
    rowIds,
    rowsById,
    cellsById
  } = normalize$1(props.rows, props.headers, prevState);
  const state = {
    rowIds,
    rowsById,
    cellsById,
    sortDirection: prevState.sortDirection || initialSortState,
    sortHeaderKey: prevState.sortHeaderKey || null,
    // Copy over rowIds so the reference doesn't mutate the stored
    // `initialRowOrder`
    initialRowOrder: rowIds.slice(),
    filterInputValue: prevState.filterInputValue || null,
    // Optional state field to indicate whether a consumer should show a
    // batch actions menu
    shouldShowBatchActions: prevState.shouldShowBatchActions || false
  };
  if (prevState.sortDirection && prevState.sortHeaderKey) {
    const {
      rowIds: rowIds2
    } = getSortedState(props, state, prevState.sortHeaderKey, prevState.sortDirection);
    state.rowIds = rowIds2;
  }
  state.isExpandedAll = state.rowIds.every((id) => {
    return state.rowsById[id].isExpanded === true;
  });
  return state;
};
var getDerivedStateFromProps$1 = getDerivedStateFromProps;
const denormalize = (rowIds, rowsById, cellsById) => {
  return rowIds.map((id) => ({
    ...rowsById[id],
    cells: rowsById[id].cells.map((cellId) => cellsById[cellId])
  }));
};
var denormalize$1 = denormalize;
const defaultFilterRows = (_ref3) => {
  let {
    rowIds,
    headers,
    cellsById,
    inputValue,
    getCellId: getCellId2
  } = _ref3;
  return rowIds.filter((rowId) => headers.some((_ref22) => {
    let {
      key
    } = _ref22;
    const id = getCellId2(rowId, key);
    if (typeof cellsById[id].value === "boolean") {
      return false;
    }
    return ("" + cellsById[id].value).toLowerCase().includes(inputValue.toLowerCase());
  }));
};
const setupGetInstanceId = () => {
  let instanceId2 = 0;
  return function getInstanceId2() {
    return ++instanceId2;
  };
};
var setupGetInstanceId$1 = setupGetInstanceId;
const TableContext = /* @__PURE__ */ createContext({
  titleId: void 0,
  descriptionId: void 0
});
const isElementWrappingContent = (element, context) => {
  if (element.children.length > 0) {
    return false;
  }
  const computedStyles = window.getComputedStyle(element);
  context.font = computedStyles.font ? computedStyles.font : `${computedStyles.fontSize}" "${computedStyles.fontFamily}`;
  const measuredText = context?.measureText(element.textContent ?? "");
  let textWidth = measuredText.width ?? 0;
  const letterSpacing = computedStyles.letterSpacing?.split("px");
  if (letterSpacing && letterSpacing.length && !isNaN(Number(letterSpacing[0]))) {
    textWidth += Number(letterSpacing[0]) * (element.textContent?.length ?? 0);
  }
  const paddingLeft = computedStyles.paddingLeft?.split("px");
  if (paddingLeft && paddingLeft.length && !isNaN(Number(paddingLeft[0]))) {
    textWidth += Number(paddingLeft[0]);
  }
  const paddingRight = computedStyles.paddingLeft?.split("px");
  if (paddingRight && paddingRight.length && !isNaN(Number(paddingRight[0]))) {
    textWidth += Number(paddingRight[0]);
  }
  if (textWidth > element.getBoundingClientRect().width) {
    return true;
  }
  return false;
};
const Table$1 = (_ref3) => {
  let {
    className,
    children,
    useZebraStyles,
    size = "lg",
    isSortable = false,
    useStaticWidth,
    stickyHeader: stickyHeader2,
    overflowMenuOnHover = true,
    experimentalAutoAlign = false,
    ...other
  } = _ref3;
  const {
    titleId,
    descriptionId
  } = useContext(TableContext);
  const prefix2 = usePrefix();
  const [isScrollable, setIsScrollable] = useState(false);
  const tableRef = useRef(null);
  const componentClass = r(`${prefix2}--data-table`, className, {
    [`${prefix2}--data-table--${size}`]: size,
    [`${prefix2}--data-table--sort`]: isSortable,
    [`${prefix2}--data-table--zebra`]: useZebraStyles,
    [`${prefix2}--data-table--static`]: useStaticWidth,
    [`${prefix2}--data-table--sticky-header`]: stickyHeader2,
    [`${prefix2}--data-table--visible-overflow-menu`]: !overflowMenuOnHover
  });
  const toggleTableBodyAlignmentClass = useCallback(function() {
    let alignTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    alignTop ? tableRef.current?.classList.add(`${prefix2}--data-table--top-aligned-body`) : tableRef.current?.classList.remove(`${prefix2}--data-table--top-aligned-body`);
  }, [prefix2]);
  const toggleTableHeaderAlignmentClass = useCallback(function() {
    let alignTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    alignTop ? tableRef.current?.classList.add(`${prefix2}--data-table--top-aligned-header`) : tableRef.current?.classList.remove(`${prefix2}--data-table--top-aligned-header`);
  }, [prefix2]);
  const setTableAlignment = useCallback(() => {
    if (experimentalAutoAlign) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (tableRef.current && context) {
        const isBodyMultiline = Array.from(tableRef.current.querySelectorAll("td")).some((td) => isElementWrappingContent(td, context));
        const isHeaderMultiline = Array.from(tableRef.current.querySelectorAll("th")).some((th) => {
          const label2 = th.querySelector(`.${prefix2}--table-header-label`);
          return label2 && isElementWrappingContent(label2, context);
        });
        toggleTableBodyAlignmentClass(isBodyMultiline);
        toggleTableHeaderAlignmentClass(isHeaderMultiline);
      }
    } else {
      toggleTableBodyAlignmentClass(false);
      toggleTableHeaderAlignmentClass(false);
    }
  }, [experimentalAutoAlign, toggleTableBodyAlignmentClass, toggleTableHeaderAlignmentClass, prefix2]);
  const debouncedSetTableAlignment = debounce$1(setTableAlignment, 100);
  useWindowEvent("resize", debouncedSetTableAlignment);
  const setTabIndex = useCallback(() => {
    const tableContainer2 = tableRef?.current?.parentNode;
    const tableHeader2 = tableRef?.current?.firstChild;
    if (tableHeader2?.scrollWidth > tableContainer2?.clientWidth) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  }, []);
  const debouncedSetTabIndex = debounce$1(setTabIndex, 100);
  useWindowEvent("resize", debouncedSetTabIndex);
  useIsomorphicEffect$1(() => {
    setTabIndex();
  }, [setTabIndex]);
  if (typeof document !== "undefined" && document?.fonts?.status && document.fonts.status !== "loaded") {
    document.fonts.ready.then(() => {
      setTableAlignment();
    });
  }
  useIsomorphicEffect$1(() => {
    setTableAlignment();
  }, [setTableAlignment, size]);
  const table2 = /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--data-table-content`,
    tabIndex: isScrollable ? 0 : void 0
  }, /* @__PURE__ */ React__default.createElement("table", _extends({
    "aria-labelledby": titleId,
    "aria-describedby": descriptionId
  }, other, {
    className: componentClass,
    ref: tableRef
  }), children));
  return stickyHeader2 ? /* @__PURE__ */ React__default.createElement("section", {
    className: `${prefix2}--data-table_inner-container`
  }, table2) : table2;
};
Table$1.propTypes = {
  /**
   * Pass in the children that will be rendered within the Table
   */
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Experimental property. Allows table to align cell contents to the top if there is text wrapping in the content. Might have performance issues, intended for smaller tables
   */
  experimentalAutoAlign: PropTypes.bool,
  /**
   * `false` If true, will apply sorting styles
   */
  isSortable: PropTypes.bool,
  /**
   * Specify whether the overflow menu (if it exists) should be shown always, or only on hover
   */
  overflowMenuOnHover: PropTypes.bool,
  /**
   *  Change the row height of table. Currently supports `xs`, `sm`, `md`, `lg`, and `xl`.
   */
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * `false` If true, will keep the header sticky (only data rows will scroll)
   */
  stickyHeader: PropTypes.bool,
  /**
   * `false` If true, will use a width of 'auto' instead of 100%
   */
  useStaticWidth: PropTypes.bool,
  /**
   * `true` to add useZebraStyles striping.
   */
  useZebraStyles: PropTypes.bool
};
const wrapComponent = (_ref3) => {
  let {
    name: name2,
    className: getClassName,
    type: type2
  } = _ref3;
  function Component2(_ref22) {
    let {
      className: baseClassName,
      ...other
    } = _ref22;
    const prefix2 = usePrefix();
    const componentClass = r(typeof getClassName === "function" ? getClassName(prefix2) : getClassName, baseClassName);
    return /* @__PURE__ */ React__default.createElement(type2, {
      ...other,
      // Prevent Weird quirk where `cx` will evaluate to an empty string, '',
      // and so we have empty `class` attributes in the resulting markup
      // eslint-disable-next-line no-extra-boolean-cast
      className: !!componentClass ? componentClass : void 0
    });
  }
  Component2.displayName = name2;
  Component2.propTypes = {
    className: PropTypes.string
  };
  return Component2;
};
const TableActionList = wrapComponent({
  name: "TableActionList",
  type: "div",
  className: (prefix2) => `${prefix2}--action-list`
});
const TableBatchAction = (_ref3) => {
  let {
    renderIcon = AddFilled,
    iconDescription = "Add",
    ...props
  } = _ref3;
  return /* @__PURE__ */ React__default.createElement(Button, _extends({
    renderIcon,
    iconDescription
  }, props));
};
TableBatchAction.propTypes = {
  /**
   * Specify if the button is an icon-only button
   */
  hasIconOnly: PropTypes.bool,
  /**
   * If specifying the `renderIcon` prop, provide a description for that icon that can
   * be read by screen readers
   */
  iconDescription: (props) => {
    if (props.renderIcon && !props.children && !props.iconDescription) {
      return new Error("renderIcon property specified without also providing an iconDescription property.");
    }
    return void 0;
  },
  /**
   * Optional function to render your own icon in the underlying button
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
const TableBatchActionsTranslationKeys = ["carbon.table.batch.cancel", "carbon.table.batch.items.selected", "carbon.table.batch.item.selected", "carbon.table.batch.selectAll"];
const translationKeys$3 = {
  "carbon.table.batch.cancel": "Cancel",
  "carbon.table.batch.items.selected": "items selected",
  "carbon.table.batch.item.selected": "item selected",
  "carbon.table.batch.selectAll": "Select all"
};
const translateWithId$3 = function(id) {
  let {
    totalSelected,
    totalCount
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    totalSelected: 0,
    totalCount: 0
  };
  if (id === "carbon.table.batch.cancel") {
    return translationKeys$3[id];
  }
  if (id === "carbon.table.batch.selectAll") {
    return `${translationKeys$3[id]} (${totalCount})`;
  }
  return `${totalSelected} ${translationKeys$3[id]}`;
};
const TableBatchActions = (_ref3) => {
  let {
    className,
    children,
    shouldShowBatchActions,
    totalSelected,
    totalCount,
    onCancel,
    onSelectAll,
    translateWithId: t3 = translateWithId$3,
    ...rest
  } = _ref3;
  const [isScrolling, setIsScrolling] = React__default.useState(false);
  const prefix2 = usePrefix();
  const batchActionsClasses = r({
    [`${prefix2}--batch-actions`]: true,
    [`${prefix2}--batch-actions--active`]: shouldShowBatchActions
  }, className);
  const batchSummaryClasses = r(`${prefix2}--batch-summary`, {
    [`${prefix2}--batch-summary__scroll`]: isScrolling
  });
  return /* @__PURE__ */ React__default.createElement("div", _extends({
    onScroll: () => {
      setIsScrolling(!isScrolling);
    },
    "aria-hidden": !shouldShowBatchActions,
    className: batchActionsClasses
  }, rest), /* @__PURE__ */ React__default.createElement("div", {
    className: batchSummaryClasses
  }, /* @__PURE__ */ React__default.createElement("p", {
    className: `${prefix2}--batch-summary__para`
  }, /* @__PURE__ */ React__default.createElement(Text, null, totalSelected > 1 || totalSelected === 0 ? t3("carbon.table.batch.items.selected", {
    totalSelected
  }) : t3("carbon.table.batch.item.selected", {
    totalSelected
  }))), onSelectAll && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--batch-summary__divider`
  }, "|"), /* @__PURE__ */ React__default.createElement(Button, {
    onClick: onSelectAll,
    tabIndex: shouldShowBatchActions ? 0 : -1
  }, t3("carbon.table.batch.selectAll", {
    totalCount
  })))), /* @__PURE__ */ React__default.createElement(TableActionList, null, children, /* @__PURE__ */ React__default.createElement(Button, {
    className: `${prefix2}--batch-summary__cancel`,
    tabIndex: shouldShowBatchActions ? 0 : -1,
    onClick: onCancel
  }, t3("carbon.table.batch.cancel"))));
};
TableBatchActions.translationKeys = TableBatchActionsTranslationKeys;
TableBatchActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Hook required to listen for when the user initiates a cancel request
   * through this component
   */
  onCancel: PropTypes.func.isRequired,
  /**
   * Hook to listen for when the user initiates a select all
   * request through this component. This _only_ controls the rendering
   * of the `Select All` button and does not include built in functionality
   */
  onSelectAll: PropTypes.func,
  /**
   * Boolean specifier for whether or not the batch action bar should be
   * displayed
   */
  shouldShowBatchActions: PropTypes.bool,
  /**
   * Numeric representation of the total number of items in a table.
   * This number is used in the select all button text
   */
  totalCount: PropTypes.number,
  /**
   * Numeric representation of the total number of items selected in a table.
   * This number is used to derive the selection message
   */
  totalSelected: PropTypes.number.isRequired,
  /**
   * Supply a method to translate internal strings with your i18n tool of
   * choice. Translation keys are available on the `translationKeys` field for
   * this component.
   */
  translateWithId: PropTypes.func
};
const TableBody = (_ref3) => {
  let {
    children,
    className,
    ...rest
  } = _ref3;
  return /* @__PURE__ */ React__default.createElement("tbody", _extends({
    "aria-live": "polite",
    className
  }, rest), children);
};
TableBody.propTypes = {
  /**
   * `polite` Adjust the notification behavior of screen readers
   */
  "aria-live": PropTypes.oneOf(["polite", "assertive", "off"]),
  children: PropTypes.node,
  className: PropTypes.string
};
const TableCell = (_ref3) => {
  let {
    children,
    className,
    hasSlugHeader,
    colSpan,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const tableCellClassNames = r(className, {
    [`${prefix2}--table-cell--column-slug`]: hasSlugHeader
  });
  return /* @__PURE__ */ React__default.createElement("td", _extends({
    className: tableCellClassNames ? tableCellClassNames : void 0,
    colSpan
  }, rest), children);
};
TableCell.displayName = "TableCell";
const TableContainer = (_ref3) => {
  let {
    className,
    children,
    title: title2,
    description: description2,
    stickyHeader: stickyHeader2,
    useStaticWidth,
    ...rest
  } = _ref3;
  const baseId = useId$1("tc");
  const titleId = `${baseId}-title`;
  const descriptionId = `${baseId}-description`;
  const prefix2 = usePrefix();
  const tableContainerClasses = r(className, `${prefix2}--data-table-container`, {
    [`${prefix2}--data-table--max-width`]: stickyHeader2,
    [`${prefix2}--data-table-container--static`]: useStaticWidth
  });
  const value2 = useMemo(() => {
    return {
      titleId: title2 ? titleId : void 0,
      descriptionId: description2 ? descriptionId : void 0
    };
  }, [title2, description2, titleId, descriptionId]);
  return /* @__PURE__ */ React__default.createElement(TableContext.Provider, {
    value: value2
  }, /* @__PURE__ */ React__default.createElement("div", _extends({}, rest, {
    className: tableContainerClasses
  }), title2 && /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--data-table-header`
  }, /* @__PURE__ */ React__default.createElement("h4", {
    className: `${prefix2}--data-table-header__title`,
    id: titleId
  }, title2), /* @__PURE__ */ React__default.createElement("p", {
    className: `${prefix2}--data-table-header__description`,
    id: descriptionId
  }, description2)), children));
};
TableContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Optional description text for the Table
   */
  description: PropTypes.node,
  /**
   * Specify whether the table should have a sticky header
   */
  stickyHeader: PropTypes.bool,
  /**
   * Provide a title for the Table
   */
  title: PropTypes.node,
  /**
   * If true, will use a width of 'fit-content' to match the inner table width
   */
  useStaticWidth: PropTypes.bool
};
const TableExpandHeader = (_ref3) => {
  let {
    ["aria-controls"]: ariaControls,
    ["aria-label"]: ariaLabel,
    ariaLabel: deprecatedAriaLabel,
    className: headerClassName,
    enableExpando,
    enableToggle,
    id = "expand",
    isExpanded,
    onExpand,
    expandIconDescription,
    children,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const className = r(`${prefix2}--table-expand`, headerClassName);
  const previousValue = isExpanded ? "collapsed" : void 0;
  return /* @__PURE__ */ React__default.createElement("th", _extends({
    scope: "col",
    className,
    "data-previous-value": previousValue,
    id
  }, rest), enableExpando || enableToggle ? /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: `${prefix2}--table-expand__button`,
    onClick: onExpand,
    title: expandIconDescription,
    "aria-label": deprecatedAriaLabel || ariaLabel,
    "aria-expanded": isExpanded,
    "aria-controls": ariaControls
  }, /* @__PURE__ */ React__default.createElement(ChevronRight, {
    className: `${prefix2}--table-expand__svg`,
    "aria-label": expandIconDescription
  })) : null, children);
};
TableExpandHeader.propTypes = {
  /**
   * Space separated list of one or more ID values referencing the TableExpandedRow(s) being controlled by the TableExpandHeader
   */
  ["aria-controls"]: PropTypes.string,
  /**
   * Specify the string read by a voice reader when the expand trigger is
   * focused
   */
  ["aria-label"]: PropTypes.string,
  /**
   * Deprecated, please use `aria-label` instead.
   * Specify the string read by a voice reader when the expand trigger is
   * focused
   */
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * The enableExpando prop is being replaced by enableToggle
   */
  enableExpando: deprecate(PropTypes.bool),
  /**
   * Specify whether an expand all button should be displayed
   */
  enableToggle: PropTypes.bool,
  /**
   * The description of the chevron right icon, to be put in its SVG `<title>` element.
   */
  expandIconDescription: PropTypes.string,
  /**
   * Supply an id to the th element.
   */
  id: PropTypes.string,
  /**
   * Specify whether this row is expanded or not. This helps coordinate data
   * attributes so that `TableExpandRow` and `TableExpandedRow` work together
   */
  isExpanded: requiredIfGivenPropIsTruthy("enableToggle", PropTypes.bool),
  /**
   * Hook for when a listener initiates a request to expand the given row
   */
  onExpand: PropTypes.oneOfType([requiredIfGivenPropIsTruthy("enableExpando", PropTypes.func), requiredIfGivenPropIsTruthy("enableToggle", PropTypes.func)])
};
const TableExpandRow = /* @__PURE__ */ React__default.forwardRef((_ref3, ref2) => {
  let {
    ["aria-controls"]: ariaControls,
    ["aria-label"]: ariaLabel,
    ariaLabel: deprecatedAriaLabel,
    className: rowClassName,
    children,
    isExpanded,
    onExpand,
    expandIconDescription,
    isSelected,
    expandHeader = "expand",
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  let rowHasSlug;
  const slug = React__default.Children.toArray(children).map((child) => {
    if (child.type?.displayName === "TableSlugRow") {
      if (child.props.slug) {
        rowHasSlug = true;
      }
      return child;
    }
  });
  const normalizedChildren = React__default.Children.toArray(children).map((child) => {
    if (child.type?.displayName !== "TableSlugRow") {
      return child;
    }
  });
  const className = r({
    [`${prefix2}--parent-row`]: true,
    [`${prefix2}--expandable-row`]: isExpanded,
    [`${prefix2}--data-table--selected`]: isSelected,
    [`${prefix2}--data-table--slug-row`]: rowHasSlug
  }, rowClassName);
  const previousValue = isExpanded ? "collapsed" : void 0;
  return /* @__PURE__ */ React__default.createElement("tr", _extends({}, rest, {
    ref: ref2,
    className,
    "data-parent-row": true
  }), slug, /* @__PURE__ */ React__default.createElement(TableCell, {
    className: `${prefix2}--table-expand`,
    "data-previous-value": previousValue,
    headers: expandHeader
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    className: `${prefix2}--table-expand__button`,
    onClick: onExpand,
    title: expandIconDescription,
    "aria-label": deprecatedAriaLabel || ariaLabel,
    "aria-expanded": isExpanded,
    "aria-controls": ariaControls
  }, /* @__PURE__ */ React__default.createElement(ChevronRight, {
    className: `${prefix2}--table-expand__svg`,
    "aria-label": expandIconDescription
  }))), normalizedChildren);
});
TableExpandRow.propTypes = {
  /**
   * Space separated list of one or more ID values referencing the TableExpandedRow(s) being controlled by the TableExpandRow
   * TODO: make this required in v12
   */
  ["aria-controls"]: PropTypes.string,
  /**
   * Specify the string read by a voice reader when the expand trigger is
   * focused
   */
  /**@ts-ignore*/
  ["aria-label"]: PropTypes.string,
  /**
   * Deprecated, please use `aria-label` instead.
   * Specify the string read by a voice reader when the expand trigger is
   * focused
   */
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * The id of the matching th node in the table head. Addresses a11y concerns outlined here: https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html and https://www.w3.org/TR/WCAG20-TECHS/H43
   */
  expandHeader: PropTypes.string,
  /**
   * The description of the chevron right icon, to be put in its SVG `<title>` element.
   */
  expandIconDescription: PropTypes.string,
  /**
   * Specify whether this row is expanded or not. This helps coordinate data
   * attributes so that `TableExpandRow` and `TableExpandedRow` work together
   */
  isExpanded: PropTypes.bool.isRequired,
  /**
   * Specify if the row is selected
   */
  isSelected: PropTypes.bool,
  /**
   * Hook for when a listener initiates a request to expand the given row
   */
  onExpand: PropTypes.func.isRequired
};
TableExpandRow.displayName = "TableExpandRow";
const TableExpandedRow = (_ref3) => {
  let {
    className: customClassName,
    children,
    colSpan,
    ...rest
  } = _ref3;
  const rowRef = useRef(null);
  const prefix2 = usePrefix();
  const className = r(`${prefix2}--expandable-row`, customClassName);
  const toggleParentHoverClass = (eventType) => {
    if (rowRef && rowRef.current && rowRef.current.previousElementSibling) {
      const parentNode = rowRef.current.previousElementSibling;
      if (eventType === "enter") {
        parentNode.classList.add(`${prefix2}--expandable-row--hover`);
      } else {
        parentNode.classList.remove(`${prefix2}--expandable-row--hover`);
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement("tr", _extends({
    ref: rowRef,
    onMouseEnter: () => toggleParentHoverClass("enter"),
    onMouseLeave: () => toggleParentHoverClass("leave")
  }, rest, {
    className,
    "data-child-row": true
  }), /* @__PURE__ */ React__default.createElement(TableCell, {
    colSpan
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--child-row-inner-container`
  }, children)));
};
TableExpandedRow.propTypes = {
  /**
   * Pass in the contents for your TableExpandedRow
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * The width of the expanded row's internal cell
   */
  colSpan: PropTypes.number.isRequired
};
const TableHead = wrapComponent({
  name: "TableHead",
  type: "thead"
});
const defaultScope = "col";
const translationKeys$2 = {
  buttonDescription: "carbon.table.header.icon.description"
};
const translateWithId$2 = (key, args) => {
  if (args && key === translationKeys$2.buttonDescription) {
    if (args.isSortHeader && sortStates) {
      if (args.sortDirection === sortStates.NONE) {
        return `Click to sort rows by ${args.header} header in ascending order`;
      }
      if (args.sortDirection === sortStates.ASC) {
        return `Click to sort rows by ${args.header} header in descending order`;
      }
      return `Click to unsort rows by ${args.header} header`;
    }
    return `Click to sort rows by ${args.header} header in ascending order`;
  }
  return "";
};
const sortDirections = {
  [sortStates.NONE]: "none",
  [sortStates.ASC]: "ascending",
  [sortStates.DESC]: "descending"
};
const TableHeader = /* @__PURE__ */ React__default.forwardRef(function TableHeader2(_ref3, ref2) {
  let {
    className: headerClassName,
    children,
    colSpan,
    isSortable = false,
    isSortHeader,
    onClick,
    scope = defaultScope,
    sortDirection,
    translateWithId: t3 = translateWithId$2,
    slug,
    id,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const uniqueId = useId$1("table-sort");
  const slugRef = useRef(null);
  let normalizedSlug;
  if (slug) {
    normalizedSlug = /* @__PURE__ */ React__default.cloneElement(slug, {
      size: "mini",
      ref: slugRef
    });
  }
  const headerLabelClassNames = r({
    [`${prefix2}--table-header-label`]: true,
    [`${prefix2}--table-header-label--slug`]: slug
  });
  if (!isSortable) {
    return /* @__PURE__ */ React__default.createElement("th", _extends({}, rest, {
      id,
      className: headerClassName,
      scope,
      colSpan,
      ref: ref2
    }), children ? /* @__PURE__ */ React__default.createElement("div", {
      className: headerLabelClassNames
    }, children, normalizedSlug) : null);
  }
  const className = r(headerClassName, {
    [`${prefix2}--table-sort`]: true,
    [`${prefix2}--table-sort--active`]: isSortHeader && sortDirection !== sortStates.NONE,
    [`${prefix2}--table-sort--descending`]: isSortHeader && sortDirection === sortStates.DESC
  });
  const ariaSort = !isSortHeader || !sortDirection ? "none" : sortDirections[sortDirection];
  const sortDescription = t3 && t3("carbon.table.header.icon.description", {
    header: children,
    sortDirection,
    isSortHeader,
    sortStates
  });
  const headerClasses = r(headerClassName, `${prefix2}--table-sort__header`, {
    [`${prefix2}--table-sort__header--slug`]: slug
  });
  const handleClick = (evt) => {
    if (slug && slugRef.current && slugRef.current.contains(evt.target)) {
      return;
    } else if (onClick) {
      return onClick(evt);
    }
  };
  return /* @__PURE__ */ React__default.createElement("th", {
    id,
    "aria-sort": ariaSort,
    className: headerClasses,
    colSpan,
    ref: ref2,
    scope
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--table-sort__description`,
    id: uniqueId
  }, sortDescription), /* @__PURE__ */ React__default.createElement("button", _extends({
    type: "button",
    "aria-describedby": uniqueId,
    className,
    onClick: handleClick
  }, rest), /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--table-sort__flex`
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--table-header-label`
  }, children), /* @__PURE__ */ React__default.createElement(ArrowUp$1, {
    size: 20,
    className: `${prefix2}--table-sort__icon`
  }), /* @__PURE__ */ React__default.createElement(ArrowsVertical, {
    size: 20,
    className: `${prefix2}--table-sort__icon-unsorted`
  }), normalizedSlug)));
});
TableHeader.propTypes = {
  /**
   * Pass in children that will be embedded in the table header label
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Specify `colSpan` as a non-negative integer value to indicate how
   * many columns the TableHeader cell extends in a table
   */
  colSpan: PropTypes.number,
  /**
   * Supply an id to the th element.
   */
  id: PropTypes.string,
  /**
   * Specify whether this header is the header by which a table is being sorted
   * by
   */
  isSortHeader: PropTypes.bool,
  /**
   * Specify whether this header is one through which a user can sort the table
   */
  isSortable: PropTypes.bool,
  /**
   * Hook that is invoked when the header is clicked
   */
  onClick: PropTypes.func,
  /**
   * Specify the scope of this table header. You can find more info about this
   * attribute at the following URL:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/th#attr-scope
   */
  scope: PropTypes.string,
  /**
   * Specify which direction we are currently sorting by, should be one of DESC,
   * NONE, or ASC.
   */
  sortDirection: PropTypes.oneOf(Object.values(sortStates)),
  /**
   * Supply a method to translate internal strings with your i18n tool of
   * choice. Translation keys are available on the `translationKeys` field for
   * this component.
   */
  translateWithId: PropTypes.func
};
TableHeader.translationKeys = Object.values(translationKeys$2);
TableHeader.displayName = "TableHeader";
var lodash_omit;
var hasRequiredLodash_omit;
function requireLodash_omit() {
  if (hasRequiredLodash_omit) return lodash_omit;
  hasRequiredLodash_omit = 1;
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal || freeSelf || Function("return this")();
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  function arrayIncludes(array, value2) {
    var length2 = array ? array.length : 0;
    return !!length2 && baseIndexOf(array, value2, 0) > -1;
  }
  function arrayMap(array, iteratee) {
    var index2 = -1, length2 = array ? array.length : 0, result = Array(length2);
    while (++index2 < length2) {
      result[index2] = iteratee(array[index2], index2, array);
    }
    return result;
  }
  function arrayPush(array, values) {
    var index2 = -1, length2 = values.length, offset3 = array.length;
    while (++index2 < length2) {
      array[offset3 + index2] = values[index2];
    }
    return array;
  }
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length2 = array.length, index2 = fromIndex + -1;
    while (++index2 < length2) {
      if (predicate(array[index2], index2, array)) {
        return index2;
      }
    }
    return -1;
  }
  function baseIndexOf(array, value2, fromIndex) {
    if (value2 !== value2) {
      return baseFindIndex(array, baseIsNaN, fromIndex);
    }
    var index2 = fromIndex - 1, length2 = array.length;
    while (++index2 < length2) {
      if (array[index2] === value2) {
        return index2;
      }
    }
    return -1;
  }
  function baseIsNaN(value2) {
    return value2 !== value2;
  }
  function baseTimes(n2, iteratee) {
    var index2 = -1, result = Array(n2);
    while (++index2 < n2) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject(value2) {
    var result = false;
    if (value2 != null && typeof value2.toString != "function") {
      try {
        result = !!(value2 + "");
      } catch (e3) {
      }
    }
    return result;
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
  var coreJsData = root2["__core-js_shared__"];
  var maskSrcKey = (function() {
    var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid2 ? "Symbol(src)_1." + uid2 : "";
  })();
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var objectToString = objectProto.toString;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Symbol2 = root2.Symbol, getPrototype = overArg(Object.getPrototypeOf, Object), propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
  var nativeGetSymbols = Object.getOwnPropertySymbols, nativeMax = Math.max;
  var Map2 = getNative(root2, "Map"), nativeCreate = getNative(Object, "create");
  function Hash(entries) {
    var index2 = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }
  function hashSet(key, value2) {
    var data = this.__data__;
    data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries) {
    var index2 = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
  }
  function listCacheDelete(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index2, 1);
    }
    return true;
  }
  function listCacheGet(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value2) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      data.push([key, value2]);
    } else {
      data[index2][1] = value2;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries) {
    var index2 = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value2) {
    getMapData(this, key).set(key, value2);
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function SetCache(values) {
    var index2 = -1, length2 = values ? values.length : 0;
    this.__data__ = new MapCache();
    while (++index2 < length2) {
      this.add(values[index2]);
    }
  }
  function setCacheAdd(value2) {
    this.__data__.set(value2, HASH_UNDEFINED);
    return this;
  }
  function setCacheHas(value2) {
    return this.__data__.has(value2);
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  function arrayLikeKeys(value2, inherited) {
    var result = isArray2(value2) || isArguments2(value2) ? baseTimes(value2.length, String) : [];
    var length2 = result.length, skipIndexes = !!length2;
    for (var key in value2) {
      if (!(skipIndexes && (key == "length" || isIndex(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf(array, key) {
    var length2 = array.length;
    while (length2--) {
      if (eq(array[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseDifference(array, values, iteratee, comparator) {
    var index2 = -1, includes = arrayIncludes, isCommon = true, length2 = array.length, result = [], valuesLength = values.length;
    if (!length2) {
      return result;
    }
    if (values.length >= LARGE_ARRAY_SIZE) {
      includes = cacheHas;
      isCommon = false;
      values = new SetCache(values);
    }
    outer:
      while (++index2 < length2) {
        var value2 = array[index2], computed = value2;
        value2 = value2 !== 0 ? value2 : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value2);
        } else if (!includes(values, computed, comparator)) {
          result.push(value2);
        }
      }
    return result;
  }
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index2 = -1, length2 = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index2 < length2) {
      var value2 = array[index2];
      if (predicate(value2)) {
        {
          arrayPush(result, value2);
        }
      } else {
        result[result.length] = value2;
      }
    }
    return result;
  }
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  function baseIsNative(value2) {
    if (!isObject2(value2) || isMasked(value2)) {
      return false;
    }
    var pattern = isFunction(value2) || isHostObject(value2) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value2));
  }
  function baseKeysIn(object) {
    if (!isObject2(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  function basePick(object, props) {
    object = Object(object);
    return basePickBy(object, props, function(value2, key) {
      return key in object;
    });
  }
  function basePickBy(object, props, predicate) {
    var index2 = -1, length2 = props.length, result = {};
    while (++index2 < length2) {
      var key = props[index2], value2 = object[key];
      if (predicate(value2, key)) {
        result[key] = value2;
      }
    }
    return result;
  }
  function baseRest(func, start2) {
    start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
    return function() {
      var args = arguments, index2 = -1, length2 = nativeMax(args.length - start2, 0), array = Array(length2);
      while (++index2 < length2) {
        array[index2] = args[start2 + index2];
      }
      index2 = -1;
      var otherArgs = Array(start2 + 1);
      while (++index2 < start2) {
        otherArgs[index2] = args[index2];
      }
      otherArgs[start2] = array;
      return apply(func, this, otherArgs);
    };
  }
  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
  }
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative(object, key) {
    var value2 = getValue(object, key);
    return baseIsNative(value2) ? value2 : void 0;
  }
  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while (object) {
      arrayPush(result, getSymbols(object));
      object = getPrototype(object);
    }
    return result;
  };
  function isFlattenable(value2) {
    return isArray2(value2) || isArguments2(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
  }
  function isIndex(value2, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
    return !!length2 && (typeof value2 == "number" || reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
  }
  function isKeyable(value2) {
    var type2 = typeof value2;
    return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value2 !== "__proto__" : value2 === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value2) {
    var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value2 === proto;
  }
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  function toKey2(value2) {
    if (typeof value2 == "string" || isSymbol(value2)) {
      return value2;
    }
    var result = value2 + "";
    return result == "0" && 1 / value2 == -Infinity ? "-0" : result;
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e3) {
      }
      try {
        return func + "";
      } catch (e3) {
      }
    }
    return "";
  }
  function eq(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
  }
  function isArguments2(value2) {
    return isArrayLikeObject(value2) && hasOwnProperty.call(value2, "callee") && (!propertyIsEnumerable.call(value2, "callee") || objectToString.call(value2) == argsTag);
  }
  var isArray2 = Array.isArray;
  function isArrayLike(value2) {
    return value2 != null && isLength(value2.length) && !isFunction(value2);
  }
  function isArrayLikeObject(value2) {
    return isObjectLike(value2) && isArrayLike(value2);
  }
  function isFunction(value2) {
    var tag = isObject2(value2) ? objectToString.call(value2) : "";
    return tag == funcTag || tag == genTag;
  }
  function isLength(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
  }
  function isObject2(value2) {
    var type2 = typeof value2;
    return !!value2 && (type2 == "object" || type2 == "function");
  }
  function isObjectLike(value2) {
    return !!value2 && typeof value2 == "object";
  }
  function isSymbol(value2) {
    return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
  }
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
  }
  var omit2 = baseRest(function(object, props) {
    if (object == null) {
      return {};
    }
    props = arrayMap(baseFlatten(props), toKey2);
    return basePick(object, baseDifference(getAllKeysIn(object), props));
  });
  function stubArray() {
    return [];
  }
  lodash_omit = omit2;
  return lodash_omit;
}
var lodash_omitExports = requireLodash_omit();
const omit = /* @__PURE__ */ getDefaultExportFromCjs(lodash_omitExports);
const TableRow = (props) => {
  const prefix2 = usePrefix();
  let rowHasSlug;
  if (props?.children) {
    React__default.Children.toArray(props.children).map((child) => {
      if (child.type?.displayName === "TableSlugRow") {
        if (child.props.slug) {
          rowHasSlug = true;
        }
      }
    });
  }
  const className = r(props.className, {
    [`${prefix2}--data-table--selected`]: props.isSelected,
    [`${prefix2}--data-table--slug-row`]: rowHasSlug
  });
  const cleanProps = {
    ...omit(props, ["ariaLabel", "aria-label", "aria-controls", "onExpand", "isExpanded", "isSelected"]),
    className: className || void 0
  };
  return /* @__PURE__ */ React__default.createElement("tr", cleanProps);
};
TableRow.propTypes = {
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Specify if the row is selected
   */
  isSelected: PropTypes.bool
};
const InlineCheckbox = /* @__PURE__ */ React__default.forwardRef(function InlineCheckbox2(props, forwardRef2) {
  const {
    ["aria-label"]: ariaLabel,
    ariaLabel: deprecatedAriaLabel,
    checked = false,
    disabled: disabled2,
    id,
    indeterminate,
    name: name2,
    onChange: onChange2 = () => {
    },
    onClick,
    onKeyDown,
    title: title2
  } = props;
  const prefix2 = usePrefix();
  const inputRef = useRef(null);
  const ref2 = useMergedRefs([inputRef, forwardRef2]);
  const inputProps = {
    checked,
    className: `${prefix2}--checkbox`,
    disabled: disabled2,
    id,
    name: name2,
    onClick: onClick ? onClickCheckBoxInput : onClick,
    onChange: (evt) => {
      onChange2(evt.target.checked, id, evt);
    },
    onKeyDown,
    ref: ref2,
    type: "checkbox"
  };
  if (indeterminate) {
    inputProps.checked = false;
  }
  useEffect(() => {
    if (inputRef?.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  function onClickCheckBoxInput(evt) {
    if (indeterminate) {
      evt.target.checked = false;
    }
    onClick(evt);
  }
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: `${prefix2}--checkbox--inline`
    },
    /* @__PURE__ */ React__default.createElement("input", inputProps),
    /* eslint-disable jsx-a11y/label-has-for,jsx-a11y/label-has-associated-control,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
    /* @__PURE__ */ React__default.createElement("label", {
      htmlFor: id,
      className: `${prefix2}--checkbox-label`,
      title: title2,
      onClick: (evt) => {
        evt.stopPropagation();
      }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `${prefix2}--visually-hidden`
    }, deprecatedAriaLabel || ariaLabel))
  );
});
InlineCheckbox.propTypes = {
  /**
   * Specify the label for the control
   */
  ["aria-label"]: PropTypes.string.isRequired,
  /**
   * Deprecated, please use `aria-label` instead.
   * Specify the label for the control
   */
  ariaLabel: deprecate(PropTypes.string.isRequired),
  /**
   * Specify whether the underlying control is checked, or not
   */
  checked: PropTypes.bool,
  /**
   * Specify whether the underlying input control should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Provide an `id` for the underlying input control
   */
  id: PropTypes.string.isRequired,
  /**
   * Specify whether the control is in an indterminate state
   */
  indeterminate: PropTypes.bool,
  /**
   * Provide a `name` for the underlying input control
   */
  name: PropTypes.string.isRequired,
  /**
   * Provide an optional hook that is called each time the input is updated
   */
  onChange: PropTypes.func,
  /**
   * Provide a handler that is invoked when a user clicks on the control
   */
  onClick: PropTypes.func,
  /**
   * Provide a handler that is invoked on the key down event for the control
   */
  onKeyDown: PropTypes.func,
  /**
   * Provide an optional tooltip for the InlineCheckbox
   */
  title: PropTypes.string
};
var InlineCheckbox$1 = InlineCheckbox;
const TableSelectAll = (_ref3) => {
  let {
    ariaLabel = "Select all rows in the table",
    checked,
    id,
    indeterminate,
    name: name2,
    onSelect,
    disabled: disabled2,
    className
  } = _ref3;
  const prefix2 = usePrefix();
  return /* @__PURE__ */ React__default.createElement("th", {
    "aria-live": "off",
    scope: "col",
    className: r(`${prefix2}--table-column-checkbox`, className)
  }, /* @__PURE__ */ React__default.createElement(InlineCheckbox$1, {
    "aria-label": ariaLabel,
    checked,
    id,
    indeterminate,
    name: name2,
    onClick: onSelect,
    disabled: disabled2
  }));
};
TableSelectAll.propTypes = {
  /**
   * Specify the aria label for the underlying input control
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * Specify whether all items are selected, or not
   */
  checked: PropTypes.bool.isRequired,
  /**
   * The CSS class names of the cell that wraps the underlying input control
   */
  className: PropTypes.string,
  /**
   * Specify whether the checkbox input should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Provide an `id` for the underlying input control
   */
  id: PropTypes.string.isRequired,
  /**
   * Specify whether the selection only has a subset of all items
   */
  indeterminate: PropTypes.bool,
  /**
   * Provide a `name` for the underlying input control
   */
  name: PropTypes.string.isRequired,
  /**
   * Provide a handler to listen to when a user initiates a selection request
   */
  onSelect: PropTypes.func.isRequired
};
const RadioButton$1 = /* @__PURE__ */ React__default.forwardRef((props, ref2) => {
  const {
    className,
    disabled: disabled2,
    hideLabel,
    id,
    labelPosition = "right",
    labelText = "",
    name: name2,
    onChange: onChange2 = () => {
    },
    value: value2 = "",
    slug,
    required,
    ...rest
  } = props;
  const prefix2 = usePrefix();
  const uid2 = useId$1("radio-button");
  const uniqueId = id || uid2;
  function handleOnChange(event) {
    onChange2(value2, name2, event);
  }
  const innerLabelClasses = r(`${prefix2}--radio-button__label-text`, {
    [`${prefix2}--visually-hidden`]: hideLabel
  });
  const wrapperClasses = r(className, `${prefix2}--radio-button-wrapper`, {
    [`${prefix2}--radio-button-wrapper--label-${labelPosition}`]: labelPosition !== "right",
    [`${prefix2}--radio-button-wrapper--slug`]: slug
  });
  const inputRef = useRef(null);
  let normalizedSlug;
  if (slug && /* @__PURE__ */ React__default.isValidElement(slug)) {
    const size = slug.props?.["kind"] === "inline" ? "md" : "mini";
    normalizedSlug = /* @__PURE__ */ React__default.cloneElement(slug, {
      size
    });
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: wrapperClasses
  }, /* @__PURE__ */ React__default.createElement("input", _extends({}, rest, {
    type: "radio",
    className: `${prefix2}--radio-button`,
    onChange: handleOnChange,
    id: uniqueId,
    ref: mergeRefs$1(inputRef, ref2),
    disabled: disabled2,
    value: value2,
    name: name2,
    required
  })), /* @__PURE__ */ React__default.createElement("label", {
    htmlFor: uniqueId,
    className: `${prefix2}--radio-button__label`
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--radio-button__appearance`
  }), labelText && /* @__PURE__ */ React__default.createElement(Text, {
    className: innerLabelClasses
  }, labelText, normalizedSlug)));
});
RadioButton$1.displayName = "RadioButton";
RadioButton$1.propTypes = {
  /**
   * Specify whether the `<RadioButton>` is currently checked
   */
  checked: PropTypes.bool,
  /**
   * Provide an optional className to be applied to the containing node
   */
  className: PropTypes.string,
  /**
   * Specify whether the `<RadioButton>` should be checked by default
   */
  defaultChecked: PropTypes.bool,
  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,
  /**
   * Provide a unique id for the underlying `<input>` node
   */
  id: PropTypes.string,
  /**
   * Provide where label text should be placed
   * NOTE: `top`/`bottom` are deprecated
   */
  labelPosition: PropTypes.oneOf(["right", "left"]),
  /**
   * Provide label text to be read by screen readers when interacting with the
   * control
   */
  labelText: PropTypes.node.isRequired,
  /**
   * Provide a name for the underlying `<input>` node
   */
  name: PropTypes.string,
  /**
   * Provide an optional `onChange` hook that is called each time the value of
   * the underlying `<input>` changes
   */
  onChange: PropTypes.func,
  /**
   * Provide a handler that is invoked when a user clicks on the control
   */
  onClick: PropTypes.func,
  /**
   * `true` to specify if the control is required.
   */
  required: PropTypes.bool,
  /**
   * **Experimental**: Provide a `Slug` component to be rendered inside the `RadioButton` component
   */
  slug: PropTypes.node,
  /**
   * Specify the value of the `<RadioButton>`
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
const TableSelectRow = (_ref3) => {
  let {
    ariaLabel,
    checked,
    id,
    name: name2,
    onSelect,
    onChange: onChange2,
    disabled: disabled2,
    radio,
    className
  } = _ref3;
  const prefix2 = usePrefix();
  const selectionInputProps = {
    id,
    name: name2,
    onClick: onSelect,
    onChange: onChange2,
    checked,
    disabled: disabled2
  };
  const InlineInputComponent = radio ? RadioButton$1 : InlineCheckbox$1;
  const tableSelectRowClasses = r(`${prefix2}--table-column-checkbox`, {
    ...className && {
      [className]: true
    },
    [`${prefix2}--table-column-radio`]: radio
  });
  return /* @__PURE__ */ React__default.createElement("td", {
    className: tableSelectRowClasses,
    "aria-live": "off"
  }, /* @__PURE__ */ React__default.createElement(InlineInputComponent, _extends({}, selectionInputProps, radio && {
    labelText: ariaLabel,
    hideLabel: true
  }, !radio && {
    ["aria-label"]: ariaLabel
  })));
};
TableSelectRow.propTypes = {
  /**
   * Specify the aria label for the underlying input control
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * Specify whether this row is selected, or not
   */
  checked: PropTypes.bool.isRequired,
  /**
   * The CSS class names of the cell that wraps the underlying input control
   */
  className: PropTypes.string,
  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Provide an `id` for the underlying input control
   */
  id: PropTypes.string.isRequired,
  /**
   * Provide a `name` for the underlying input control
   */
  name: PropTypes.string.isRequired,
  /**
   * Provide an optional hook that is called each time the input is updated
   */
  onChange: PropTypes.func,
  /**
   * Provide a handler to listen to when a user initiates a selection request
   */
  onSelect: PropTypes.func.isRequired,
  /**
   * Specify whether the control should be a radio button or inline checkbox
   */
  radio: PropTypes.bool
};
const TableSlugRow = (_ref3) => {
  let {
    className,
    slug
  } = _ref3;
  const prefix2 = usePrefix();
  const TableSlugRowClasses = r({
    ...className && {
      [className]: true
    },
    [`${prefix2}--table-column-slug`]: true,
    [`${prefix2}--table-column-slug--active`]: slug
  });
  let normalizedSlug;
  if (slug) {
    normalizedSlug = /* @__PURE__ */ React__default.cloneElement(slug, {
      size: "mini"
    });
  }
  return /* @__PURE__ */ React__default.createElement("td", {
    className: TableSlugRowClasses
  }, normalizedSlug);
};
TableSlugRow.propTypes = {
  /**
   * The CSS class names of the cell that wraps the underlying input control
   */
  className: PropTypes.string,
  /**
   * Provide a `Slug` component to be rendered inside the `TableSlugRow` component
   */
  slug: PropTypes.node
};
const TableToolbar = (_ref3) => {
  let {
    ["aria-label"]: ariaLabel = "data table toolbar",
    ariaLabel: deprecatedAriaLabel,
    children,
    size,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const className = r({
    [`${prefix2}--table-toolbar`]: true,
    [`${prefix2}--table-toolbar--${size}`]: size
  });
  return /* @__PURE__ */ React__default.createElement("section", _extends({
    "aria-label": deprecatedAriaLabel || ariaLabel
  }, rest, {
    className
  }), children);
};
TableToolbar.propTypes = {
  /**
   * 'aria-label' of the TableToolbar component.
   * Specify a label to be read by screen readers on the container node
   */
  ["aria-label"]: PropTypes.string,
  /**
   * Deprecated, please use `aria-label` instead.
   * Specify a label to be read by screen readers on the container node.
   * 'aria-label' of the TableToolbar component.
   */
  ariaLabel: deprecate(PropTypes.string),
  /**
   * Pass in the children that will be rendered inside the TableToolbar
   */
  children: PropTypes.node,
  /**
   * `lg` Change the row height of table
   */
  size: PropTypes.oneOf(["sm", "lg"])
};
const OverflowMenuItem = /* @__PURE__ */ React__default.forwardRef(function OverflowMenuItem2(_ref3, ref2) {
  let {
    className,
    closeMenu,
    disabled: disabled2 = false,
    handleOverflowMenuItemFocus,
    hasDivider = false,
    href,
    isDelete = false,
    index: index2,
    itemText = "Provide itemText",
    onClick = () => {
    },
    onKeyDown = () => {
    },
    requireTitle,
    title: title2,
    wrapperClassName,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  function setTabFocus(evt) {
    if (match$1(evt, ArrowDown)) {
      handleOverflowMenuItemFocus?.({
        currentIndex: index2,
        direction: 1
      });
    }
    if (match$1(evt, ArrowUp)) {
      handleOverflowMenuItemFocus?.({
        currentIndex: index2,
        direction: -1
      });
    }
  }
  function handleClick(evt) {
    onClick(evt);
    if (closeMenu) {
      closeMenu();
    }
  }
  const overflowMenuBtnClasses = r(`${prefix2}--overflow-menu-options__btn`, className);
  const overflowMenuItemClasses = r(`${prefix2}--overflow-menu-options__option`, {
    [`${prefix2}--overflow-menu--divider`]: hasDivider,
    [`${prefix2}--overflow-menu-options__option--danger`]: isDelete,
    [`${prefix2}--overflow-menu-options__option--disabled`]: disabled2
  }, wrapperClassName);
  const TagToUse = href ? "a" : "button";
  const OverflowMenuItemContent = (() => {
    if (typeof itemText !== "string") {
      return itemText;
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      className: `${prefix2}--overflow-menu-options__option-content`
    }, itemText);
  })();
  return /* @__PURE__ */ React__default.createElement(Text, {
    as: "li",
    className: overflowMenuItemClasses,
    role: "none"
  }, /* @__PURE__ */ React__default.createElement(TagToUse, _extends({
    className: overflowMenuBtnClasses,
    disabled: disabled2,
    href,
    onClick: handleClick,
    onKeyDown: (evt) => {
      setTabFocus(evt);
      onKeyDown(evt);
    },
    role: "menuitem",
    ref: ref2,
    tabIndex: -1,
    title: requireTitle ? title2 || itemText : void 0
  }, rest), OverflowMenuItemContent));
});
OverflowMenuItem.propTypes = {
  /**
   * The CSS class name to be placed on the button element
   */
  className: PropTypes.string,
  /**
   * A callback to tell the parent menu component that the menu should be closed.
   */
  closeMenu: PropTypes.func,
  /**
   * `true` to make this menu item disabled.
   */
  disabled: PropTypes.bool,
  handleOverflowMenuItemFocus: PropTypes.func,
  /**
   * `true` to make this menu item a divider.
   */
  hasDivider: PropTypes.bool,
  /**
   * If given, overflow item will render as a link with the given href
   */
  href: PropTypes.string,
  index: PropTypes.number,
  /**
   * `true` to make this menu item a "danger button".
   */
  isDelete: PropTypes.bool,
  /**
   * The text in the menu item.
   */
  itemText: PropTypes.node.isRequired,
  /**
   * event handlers
   */
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseUp: PropTypes.func,
  /**
   * `true` if this menu item has long text and requires a browser tooltip
   */
  requireTitle: PropTypes.bool,
  /**
   * Specify a title for the OverflowMenuItem
   */
  title: PropTypes.string,
  /**
   * The CSS class name to be placed on the wrapper list item element
   */
  wrapperClassName: PropTypes.string
};
const TableToolbarAction = /* @__PURE__ */ React__default.forwardRef((_ref3, ref2) => {
  let {
    children,
    ...rest
  } = _ref3;
  return /* @__PURE__ */ React__default.createElement(OverflowMenuItem, _extends({
    ref: ref2,
    itemText: children
  }, rest));
});
TableToolbarAction.displayName = "TableToolbarAction";
TableToolbarAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
const TableToolbarContent = wrapComponent({
  name: "TableToolbarContent",
  type: "div",
  className: (prefix2) => `${prefix2}--toolbar-content`
});
function focus(elementOrRef) {
  const element = elementOrRef.current || elementOrRef;
  if (element && element.focus && document.activeElement !== element) {
    element.focus();
  }
}
var _Close;
const Search$1 = /* @__PURE__ */ React__default.forwardRef(function Search(_ref3, forwardRef2) {
  let {
    autoComplete = "off",
    className,
    closeButtonLabelText = "Clear search input",
    defaultValue,
    disabled: disabled2,
    isExpanded = true,
    id,
    labelText,
    // @ts-expect-error: deprecated prop
    light,
    onChange: onChange2 = () => {
    },
    onClear = () => {
    },
    onKeyDown,
    onExpand,
    placeholder: placeholder2 = "Search",
    renderIcon,
    role = "searchbox",
    size = "md",
    type: type2 = "text",
    value: value2,
    ...rest
  } = _ref3;
  const hasPropValue = value2 || defaultValue ? true : false;
  const prefix2 = usePrefix();
  const {
    isFluid
  } = useContext(FormContext);
  const inputRef = useRef(null);
  const ref2 = useMergedRefs([forwardRef2, inputRef]);
  const expandButtonRef = useRef(null);
  const inputId = useId$1("search-input");
  const uniqueId = id || inputId;
  const searchId = `${uniqueId}-search`;
  const [hasContent, setHasContent] = useState(hasPropValue || false);
  const [prevValue, setPrevValue] = useState(value2);
  const searchClasses = r({
    [`${prefix2}--search`]: true,
    [`${prefix2}--search--sm`]: size === "sm",
    [`${prefix2}--search--md`]: size === "md",
    [`${prefix2}--search--lg`]: size === "lg",
    [`${prefix2}--search--light`]: light,
    [`${prefix2}--search--disabled`]: disabled2,
    [`${prefix2}--search--fluid`]: isFluid
  }, className);
  const clearClasses = r({
    [`${prefix2}--search-close`]: true,
    [`${prefix2}--search-close--hidden`]: !hasContent || !isExpanded
  });
  if (value2 !== prevValue) {
    setHasContent(!!value2);
    setPrevValue(value2);
  }
  function clearInput() {
    if (!value2 && inputRef.current) {
      inputRef.current.value = "";
    }
    const inputTarget = Object.assign({}, inputRef.current, {
      value: ""
    });
    const clearedEvt = {
      target: inputTarget,
      type: "change"
    };
    onChange2(clearedEvt);
    onClear();
    setHasContent(false);
    focus(inputRef);
  }
  function handleChange(event) {
    setHasContent(event.target.value !== "");
  }
  function handleKeyDown(event) {
    if (match$1(event, Escape)) {
      event.stopPropagation();
      if (inputRef.current?.value) {
        clearInput();
      } else if (onExpand && isExpanded) {
        expandButtonRef.current?.focus();
      }
    }
  }
  function handleExpandButtonKeyDown(event) {
    if (match$1(event, Enter) || match$1(event, Space)) {
      event.stopPropagation();
      if (onExpand) {
        onExpand(event);
      }
    }
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    role: "search",
    "aria-label": placeholder2,
    className: searchClasses
  }, /* @__PURE__ */ React__default.createElement("div", {
    "aria-label": "button",
    "aria-labelledby": onExpand ? uniqueId : void 0,
    role: "button",
    className: `${prefix2}--search-magnifier`,
    onClick: onExpand,
    onKeyDown: handleExpandButtonKeyDown,
    tabIndex: onExpand && !isExpanded ? 0 : -1,
    ref: expandButtonRef,
    "aria-expanded": onExpand && isExpanded ? true : false,
    "aria-controls": onExpand ? uniqueId : void 0
  }, /* @__PURE__ */ React__default.createElement(CustomSearchIcon, {
    icon: renderIcon
  })), /* @__PURE__ */ React__default.createElement("label", {
    id: searchId,
    htmlFor: uniqueId,
    className: `${prefix2}--label`
  }, labelText), /* @__PURE__ */ React__default.createElement("input", _extends({
    autoComplete,
    className: `${prefix2}--search-input`,
    defaultValue,
    disabled: disabled2,
    role,
    ref: ref2,
    id: uniqueId,
    onChange: composeEventHandlers([onChange2, handleChange]),
    onKeyDown: composeEventHandlers([onKeyDown, handleKeyDown]),
    placeholder: placeholder2,
    type: type2,
    value: value2,
    tabIndex: onExpand && !isExpanded ? -1 : void 0
  }, rest)), /* @__PURE__ */ React__default.createElement("button", {
    "aria-label": closeButtonLabelText,
    className: clearClasses,
    disabled: disabled2,
    onClick: clearInput,
    title: closeButtonLabelText,
    type: "button"
  }, _Close || (_Close = /* @__PURE__ */ React__default.createElement(Close, null))));
});
Search$1.displayName = "Search";
Search$1.propTypes = {
  /**
   * Specify an optional value for the `autocomplete` property on the underlying
   * `<input>`, defaults to "off"
   */
  autoComplete: PropTypes.string,
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Specify a label to be read by screen readers on the "close" button
   */
  closeButtonLabelText: PropTypes.string,
  /**
   * Optionally provide the default value of the `<input>`
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Specify whether the `<input>` should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Specify a custom `id` for the input
   */
  id: PropTypes.string,
  /**
   * Specify whether or not ExpandableSearch should render expanded or not
   */
  isExpanded: PropTypes.bool,
  /**
   * Provide the label text for the Search icon
   */
  labelText: PropTypes.node.isRequired,
  /**
   * Specify light version or default version of this control
   */
  light: deprecate(PropTypes.bool),
  /**
   * Optional callback called when the search value changes.
   */
  onChange: PropTypes.func,
  /**
   * Optional callback called when the search value is cleared.
   */
  onClear: PropTypes.func,
  /**
   * Optional callback called when the magnifier icon is clicked in ExpandableSearch.
   */
  onExpand: PropTypes.func,
  /**
   * Provide a handler that is invoked on the key down event for the input
   */
  onKeyDown: PropTypes.func,
  /**
   * Provide an optional placeholder text for the Search.
   * Note: if the label and placeholder differ,
   * VoiceOver on Mac will read both
   */
  placeholder: PropTypes.string,
  /**
   * Rendered icon for the Search.
   * Can be a React component class
   */
  // @ts-expect-error: PropTypes are not expressive enough to cover this case
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Specify the role for the underlying `<input>`, defaults to `searchbox`
   */
  role: PropTypes.string,
  /**
   * Specify the size of the Search
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Optional prop to specify the type of the `<input>`
   */
  type: PropTypes.string,
  /**
   * Specify the value of the `<input>`
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
function CustomSearchIcon(_ref22) {
  let {
    icon: Icon3
  } = _ref22;
  const prefix2 = usePrefix();
  if (Icon3) {
    return /* @__PURE__ */ React__default.createElement(Icon3, {
      className: `${prefix2}--search-magnifier-icon`
    });
  }
  return /* @__PURE__ */ React__default.createElement(Search$2, {
    className: `${prefix2}--search-magnifier-icon`
  });
}
CustomSearchIcon.propTypes = {
  /**
   * Rendered icon for the Search. Can be a React component class
   */
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
const getInstanceId$3 = setupGetInstanceId$1();
const translationKeys$1 = {
  "carbon.table.toolbar.search.label": "Filter table",
  "carbon.table.toolbar.search.placeholder": "Filter table"
};
const translateWithId$1 = (id) => {
  return translationKeys$1[id];
};
const TableToolbarSearch = (_ref3) => {
  let {
    className,
    searchContainerClass,
    onChange: onChangeProp,
    onClear = noopFn,
    translateWithId: t3 = translateWithId$1,
    placeholder: placeholder2,
    labelText,
    expanded: expandedProp,
    defaultExpanded,
    defaultValue,
    disabled: disabled2,
    onExpand,
    persistent = false,
    id,
    onBlur,
    onFocus: onFocus2,
    size = "lg",
    tabIndex = "0",
    ...rest
  } = _ref3;
  const {
    current: controlled
  } = useRef(expandedProp !== void 0);
  const [expandedState, setExpandedState] = useState(Boolean(defaultExpanded || defaultValue));
  const expanded2 = controlled ? expandedProp : expandedState;
  const [value2, setValue] = useState(defaultValue || "");
  const uniqueId = useMemo(getInstanceId$3, []);
  const [focusTarget, setFocusTarget] = useState(null);
  const prefix2 = usePrefix();
  useEffect(() => {
    if (focusTarget) {
      focusTarget.current?.querySelector?.("input")?.focus();
      setFocusTarget(null);
    }
  }, [focusTarget]);
  useEffect(
    () => {
      if (defaultValue) {
        onChangeProp?.("", defaultValue);
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const searchClasses = r(className, {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [searchContainerClass]: searchContainerClass,
    [`${prefix2}--toolbar-search-container-active`]: expanded2,
    [`${prefix2}--toolbar-search-container-disabled`]: disabled2,
    [`${prefix2}--toolbar-search-container-expandable`]: !persistent,
    [`${prefix2}--toolbar-search-container-persistent`]: persistent
  });
  const handleExpand = function(event) {
    let value3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !expanded2;
    if (!disabled2) {
      if (!controlled && !persistent) {
        setExpandedState(value3);
      }
      if (onExpand) {
        onExpand(event, value3);
      }
    }
  };
  const onChange2 = (e3) => {
    setValue(e3.target.value);
    if (onChangeProp) {
      onChangeProp(e3);
    }
  };
  const handleOnFocus = (event) => handleExpand(event, true);
  const handleOnBlur = (event) => !value2 && handleExpand(event, false);
  return /* @__PURE__ */ React__default.createElement(Search$1, _extends({
    disabled: disabled2,
    className: searchClasses,
    value: value2,
    id: typeof id !== "undefined" ? id : `table-toolbar-search-${uniqueId.toString()}`,
    labelText: labelText || t3("carbon.table.toolbar.search.label"),
    placeholder: placeholder2 || t3("carbon.table.toolbar.search.placeholder"),
    onChange: onChange2,
    onClear,
    onFocus: onFocus2 ? (event) => onFocus2(event, handleExpand) : handleOnFocus,
    onBlur: onBlur ? (event) => onBlur(event, handleExpand) : handleOnBlur,
    size,
    tabIndex
  }, rest));
};
TableToolbarSearch.propTypes = {
  children: PropTypes.node,
  /**
   * Provide an optional class name for the search container
   */
  className: PropTypes.string,
  /**
   * Specifies if the search should initially render in an expanded state
   */
  defaultExpanded: PropTypes.bool,
  /**
   * Provide an optional default value for the Search component
   */
  defaultValue: PropTypes.string,
  /**
   * Specifies if the search should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Specifies if the search should expand
   */
  expanded: PropTypes.bool,
  /**
   * Provide an optional id for the search container
   */
  id: PropTypes.string,
  /**
   * Provide an optional label text for the Search component icon
   */
  labelText: PropTypes.string,
  /**
   * Provide an optional function to be called when the search input loses focus, this will be
   * passed the event as the first parameter and a function to handle the expanding of the search
   * input as the second
   */
  onBlur: PropTypes.func,
  /**
   * Provide an optional hook that is called each time the input is updated
   */
  onChange: PropTypes.func,
  /**
   * Optional callback called when the search value is cleared.
   */
  onClear: PropTypes.func,
  /**
   * Provide an optional hook that is called each time the input is expanded
   */
  onExpand: PropTypes.func,
  /**
   * Provide an optional function to be called when the search input gains focus, this will be
   * passed the event as the first parameter and a function to handle the expanding of the search
   * input as the second.
   */
  onFocus: PropTypes.func,
  /**
   * Whether the search should be allowed to expand
   */
  persistent: PropTypes.bool,
  /**
   * Provide an optional placeholder text for the Search component
   */
  placeholder: PropTypes.string,
  /**
   * Provide an optional className for the overall container of the Search
   */
  searchContainerClass: PropTypes.string,
  /**
   * Specify the size of the Search
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Optional prop to specify the tabIndex of the <Search> (in expanded state) or the container (in collapsed state)
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Provide custom text for the component for each translation id
   */
  translateWithId: PropTypes.func
};
const defaultSize = "md";
const OverflowMenu$2 = /* @__PURE__ */ React__default.forwardRef(function OverflowMenu(_ref3, forwardRef2) {
  let {
    children,
    className,
    label: label2 = "Options",
    renderIcon: IconElement = OverflowMenuVertical,
    size = defaultSize,
    menuAlignment = "bottom-start",
    tooltipAlignment,
    ...rest
  } = _ref3;
  const id = useId$1("overflowmenu");
  const prefix2 = usePrefix();
  const triggerRef = useRef(null);
  const {
    open: open2,
    x: x3,
    y: y3,
    handleClick: hookOnClick,
    handleMousedown,
    handleClose
  } = useAttachedMenu(triggerRef);
  function handleTriggerClick() {
    if (triggerRef.current) {
      hookOnClick();
    }
  }
  const containerClasses = r(className, `${prefix2}--overflow-menu__container`);
  const menuClasses = r(`${prefix2}--overflow-menu__${menuAlignment}`);
  const triggerClasses = r(`${prefix2}--overflow-menu`, {
    [`${prefix2}--overflow-menu--open`]: open2
  }, size !== defaultSize && `${prefix2}--overflow-menu--${size}`);
  return /* @__PURE__ */ React__default.createElement("div", _extends({}, rest, {
    className: containerClasses,
    "aria-owns": open2 ? id : void 0,
    ref: forwardRef2
  }), /* @__PURE__ */ React__default.createElement(IconButton, {
    "aria-controls": open2 ? id : void 0,
    "aria-haspopup": true,
    "aria-expanded": open2,
    className: triggerClasses,
    onClick: handleTriggerClick,
    onMouseDown: handleMousedown,
    ref: triggerRef,
    label: label2,
    align: tooltipAlignment
  }, /* @__PURE__ */ React__default.createElement(IconElement, {
    className: `${prefix2}--overflow-menu__icon`
  })), /* @__PURE__ */ React__default.createElement(Menu, {
    containerRef: triggerRef,
    menuAlignment,
    className: menuClasses,
    id,
    size,
    open: open2,
    onClose: handleClose,
    x: x3,
    y: y3,
    label: label2
  }, children));
});
OverflowMenu$2.propTypes = {
  /**
   * A collection of MenuItems to be rendered within this OverflowMenu.
   */
  children: PropTypes.node,
  /**
   * Additional CSS class names for the trigger button.
   */
  className: PropTypes.string,
  /**
   * A label describing the options available. Is used in the trigger tooltip and as the menu's accessible label.
   */
  label: PropTypes.string,
  /**
   * Experimental property. Specify how the menu should align with the button element
   */
  menuAlignment: PropTypes.oneOf(["top-start", "top-end", "bottom-start", "bottom-end"]),
  /**
   * Optionally provide a custom icon to be rendered on the trigger button.
   */
  // @ts-expect-error: PropTypes are not expressive enough to cover this case
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Specify the size of the menu, from a list of available sizes.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * Specify how the trigger tooltip should be aligned.
   */
  tooltipAlignment: PropTypes.oneOf(["top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right", "left", "right"])
};
class ClickListener extends React__default.Component {
  static getEventTarget(evt) {
    if (evt.composed && typeof evt.composedPath === "function") {
      return evt.composedPath()[0];
    }
    return evt.target;
  }
  constructor(props) {
    super(props);
    this.handleRef = this.handleRef.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }
  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  }
  handleDocumentClick(evt) {
    if (this.element) {
      if (this.element.contains && !this.element.contains(ClickListener.getEventTarget(evt))) {
        this.props.onClickOutside(evt);
      }
    }
  }
  handleRef(el) {
    const {
      children
    } = this.props;
    this.element = el;
    if (children.ref && typeof children.ref === "function") {
      children.ref(el);
    }
  }
  render() {
    return /* @__PURE__ */ React__default.cloneElement(this.props.children, {
      ref: this.handleRef
    });
  }
}
_defineProperty$2(ClickListener, "propTypes", {
  children: PropTypes.element.isRequired,
  onClickOutside: PropTypes.func.isRequired
});
var lib;
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  lib = typeof self === "object" && self.self === self && self || typeof commonjsGlobal === "object" && commonjsGlobal.global === commonjsGlobal && commonjsGlobal || lib;
  return lib;
}
var libExports = requireLib();
const window$1 = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
const OptimizedResize = /* @__PURE__ */ (function optimizedResize() {
  const callbacks = [];
  let running = false;
  function runCallbacks() {
    callbacks.forEach((callback) => {
      callback();
    });
    running = false;
  }
  function resize() {
    if (!running) {
      running = true;
      window$1.requestAnimationFrame(runCallbacks);
    }
  }
  function addCallback(callback) {
    if (callback) {
      const index2 = callbacks.indexOf(callback);
      if (index2 < 0) {
        callbacks.push(callback);
      }
    }
  }
  return {
    // public method to add additional callback
    add: (callback) => {
      if (!callbacks.length) {
        window$1.addEventListener("resize", resize);
      }
      addCallback(callback);
      return {
        release() {
          const index2 = callbacks.indexOf(callback);
          if (index2 >= 0) {
            callbacks.splice(index2, 1);
          }
        }
      };
    }
  };
})();
var OptimizedResize$1 = OptimizedResize;
const DIRECTION_LEFT = "left";
const DIRECTION_TOP = "top";
const DIRECTION_RIGHT = "right";
const DIRECTION_BOTTOM = "bottom";
const hasChangeInOffset = function() {
  let oldMenuOffset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  let menuOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (typeof oldMenuOffset !== typeof menuOffset) {
    return true;
  }
  if (Object(menuOffset) === menuOffset && typeof menuOffset !== "function") {
    return oldMenuOffset.top !== menuOffset.top || oldMenuOffset.left !== menuOffset.left;
  }
  return oldMenuOffset !== menuOffset;
};
const getFloatingPosition = (_ref3) => {
  let {
    menuSize,
    refPosition = {},
    offset: offset3 = {},
    direction = DIRECTION_BOTTOM,
    scrollX: pageXOffset = 0,
    scrollY: pageYOffset = 0,
    container: container2
  } = _ref3;
  const {
    left: refLeft = 0,
    top: refTop = 0,
    right: refRight = 0,
    bottom: refBottom = 0
  } = refPosition;
  const scrollX = container2.position !== "static" ? 0 : pageXOffset;
  const scrollY = container2.position !== "static" ? 0 : pageYOffset;
  const relativeDiff = {
    top: container2.position !== "static" ? container2.rect.top : 0,
    left: container2.position !== "static" ? container2.rect.left : 0
  };
  const {
    width,
    height
  } = menuSize;
  const {
    top: top2 = 0,
    left: left2 = 0
  } = offset3;
  const refCenterHorizontal = (refLeft + refRight) / 2;
  const refCenterVertical = (refTop + refBottom) / 2;
  return {
    [DIRECTION_LEFT]: () => ({
      left: refLeft - width + scrollX - left2 - relativeDiff.left,
      top: refCenterVertical - height / 2 + scrollY + top2 - 9 - relativeDiff.top
    }),
    [DIRECTION_TOP]: () => ({
      left: refCenterHorizontal - width / 2 + scrollX + left2 - relativeDiff.left,
      top: refTop - height + scrollY - top2 - relativeDiff.top
    }),
    [DIRECTION_RIGHT]: () => ({
      left: refRight + scrollX + left2 - relativeDiff.left,
      top: refCenterVertical - height / 2 + scrollY + top2 + 3 - relativeDiff.top
    }),
    [DIRECTION_BOTTOM]: () => ({
      left: refCenterHorizontal - width / 2 + scrollX + left2 - relativeDiff.left,
      top: refBottom + scrollY + top2 - relativeDiff.top
    })
  }[direction]();
};
class FloatingMenu extends React__default.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty$2(this, "_placeInProgress", false);
    _defineProperty$2(this, "state", {
      /**
       * The position of the menu, relative to the top-left corner of the viewport.
       * @type {FloatingMenu~offset}
       */
      floatingPosition: void 0
    });
    _defineProperty$2(this, "_menuContainer", null);
    _defineProperty$2(this, "_menuBody", null);
    _defineProperty$2(this, "startSentinel", /* @__PURE__ */ React__default.createRef());
    _defineProperty$2(this, "endSentinel", /* @__PURE__ */ React__default.createRef());
    _defineProperty$2(this, "_updateMenuSize", function() {
      let prevProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      let isAdjustment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      const menuBody = _this._menuBody;
      if (!menuBody) {
        return;
      }
      const {
        menuOffset: oldMenuOffset = {},
        menuDirection: oldMenuDirection
      } = prevProps;
      const {
        menuOffset = {},
        menuDirection = DIRECTION_BOTTOM
      } = _this.props;
      if (hasChangeInOffset(oldMenuOffset, menuOffset) || oldMenuDirection !== menuDirection || isAdjustment) {
        const {
          flipped,
          triggerRef,
          updateOrientation = null
        } = _this.props;
        const {
          current: triggerEl
        } = triggerRef;
        const menuSize = menuBody.getBoundingClientRect();
        const refPosition = triggerEl && triggerEl.getBoundingClientRect();
        const offset3 = typeof menuOffset !== "function" ? menuOffset : menuOffset(menuBody, menuDirection, triggerEl, flipped);
        if (updateOrientation) {
          updateOrientation({
            menuSize,
            refPosition,
            direction: menuDirection,
            offset: offset3,
            scrollX: window$1.pageXOffset,
            scrollY: window$1.pageYOffset,
            container: {
              rect: _this.props.target().getBoundingClientRect(),
              position: getComputedStyle(_this.props.target()).position
            }
          });
        }
        if (menuSize.width > 0 && menuSize.height > 0 || !offset3) {
          _this.setState({
            floatingPosition: getFloatingPosition({
              menuSize,
              refPosition,
              direction: menuDirection,
              offset: offset3,
              scrollX: window$1.pageXOffset,
              scrollY: window$1.pageYOffset,
              container: {
                rect: _this.props.target().getBoundingClientRect(),
                position: getComputedStyle(_this.props.target()).position
              }
            })
          }, () => {
            if (!isAdjustment) {
              const newMenuSize = menuBody.getBoundingClientRect();
              if (newMenuSize !== menuSize) {
                _this._updateMenuSize(_this.props, true);
              }
            }
          });
        }
      }
    });
    _defineProperty$2(this, "_focusMenuContent", (menuBody) => {
      const primaryFocusNode = menuBody.querySelector(this.props.selectorPrimaryFocus || null);
      const tabbableNode = menuBody.querySelector(selectorTabbable);
      const focusableNode = menuBody.querySelector(selectorFocusable);
      const focusTarget = primaryFocusNode || // User defined focusable node
      tabbableNode || // First sequentially focusable node
      focusableNode || // First programmatic focusable node
      menuBody;
      focusTarget.focus();
    });
    _defineProperty$2(this, "_menuRef", (menuBody) => {
      const {
        menuRef
      } = this.props;
      this._placeInProgress = !!menuBody;
      menuRef && menuRef(this._menuBody = menuBody);
      if (menuBody) {
        this._updateMenuSize();
      }
    });
    _defineProperty$2(this, "_getChildrenWithProps", () => {
      const {
        styles: styles2,
        children
      } = this.props;
      const {
        floatingPosition: pos
      } = this.state;
      const positioningStyle = pos ? {
        left: `${pos.left}px`,
        top: `${pos.top}px`,
        right: "auto"
      } : {
        visibility: "hidden",
        top: "0px"
      };
      return /* @__PURE__ */ React__default.cloneElement(children, {
        ref: this._menuRef,
        style: {
          ...styles2,
          ...positioningStyle,
          position: "absolute",
          opacity: 1
        }
      });
    });
    _defineProperty$2(this, "handleBlur", (_ref22) => {
      let {
        target: oldActiveNode,
        relatedTarget: currentActiveNode
      } = _ref22;
      if (currentActiveNode && oldActiveNode) {
        const {
          current: startSentinelNode
        } = this.startSentinel;
        const {
          current: endSentinelNode
        } = this.endSentinel;
        wrapFocus({
          bodyNode: this._menuBody,
          currentActiveNode,
          oldActiveNode
        });
      }
    });
    _defineProperty$2(this, "handleKeyDown", (event) => {
      if (match$1(event, Tab$3) && this._menuBody) {
        wrapFocusWithoutSentinels({
          containerNode: this._menuBody,
          currentActiveNode: event.target,
          event
        });
      }
    });
  }
  componentWillUnmount() {
    this.hResize.release();
  }
  componentDidMount() {
    this.hResize = OptimizedResize$1.add(() => {
      this._updateMenuSize();
    });
  }
  componentDidUpdate(prevProps) {
    this._updateMenuSize(prevProps);
    const {
      onPlace
    } = this.props;
    if (this._placeInProgress && this.state.floatingPosition) {
      if (this._menuBody && !this._menuBody.contains(document.activeElement)) {
        this._focusMenuContent(this._menuBody);
      }
      if (typeof onPlace === "function") {
        onPlace(this._menuBody);
        this._placeInProgress = false;
      }
    }
  }
  render() {
    const {
      context: prefix2
    } = this;
    const focusTrapWithoutSentinels = enabled("enable-experimental-focus-wrap-without-sentinels");
    if (typeof document !== "undefined") {
      const {
        focusTrap,
        target
      } = this.props;
      return /* @__PURE__ */ ReactDOM__default.createPortal(
        //eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /* @__PURE__ */ React__default.createElement("div", {
          onBlur: focusTrap && !focusTrapWithoutSentinels ? this.handleBlur : () => {
          },
          onKeyDown: focusTrapWithoutSentinels ? this.handleKeyDown : () => {
          }
        }, !focusTrapWithoutSentinels && /* @__PURE__ */ React__default.createElement("span", {
          ref: this.startSentinel,
          tabIndex: "0",
          role: "link",
          className: `${prefix2}--visually-hidden`
        }, "Focus sentinel"), this._getChildrenWithProps(), !focusTrapWithoutSentinels && /* @__PURE__ */ React__default.createElement("span", {
          ref: this.endSentinel,
          tabIndex: "0",
          role: "link",
          className: `${prefix2}--visually-hidden`
        }, "Focus sentinel")),
        !target ? document.body : target()
      );
    }
    return null;
  }
}
_defineProperty$2(FloatingMenu, "contextType", PrefixContext);
_defineProperty$2(FloatingMenu, "propTypes", {
  /**
   * Contents to put into the floating menu.
   */
  children: PropTypes.object,
  /**
   * `true` if the menu alignment should be flipped.
   */
  flipped: PropTypes.bool,
  /**
   * Enable or disable focus trap behavior
   */
  focusTrap: PropTypes.bool,
  /**
   * Where to put the tooltip, relative to the trigger button.
   */
  menuDirection: PropTypes.oneOf([DIRECTION_LEFT, DIRECTION_TOP, DIRECTION_RIGHT, DIRECTION_BOTTOM]),
  /**
   * The adjustment of the floating menu position, considering the position of dropdown arrow, etc.
   */
  menuOffset: PropTypes.oneOfType([PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }), PropTypes.func]),
  /**
   * The callback called when the menu body has been mounted to/will be unmounted from the DOM.
   */
  menuRef: PropTypes.func,
  /**
   * The callback called when the menu body has been mounted and positioned.
   */
  onPlace: PropTypes.func,
  /**
   * Specify a CSS selector that matches the DOM element that should
   * be focused when the Modal opens
   */
  selectorPrimaryFocus: PropTypes.string,
  /**
   * The additional styles to put to the floating menu.
   */
  styles: PropTypes.object,
  /**
   * The query selector indicating where the floating menu body should be placed.
   */
  target: PropTypes.func,
  /**
   * The element ref of the tooltip's trigger button.
   */
  triggerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  /**
   * Optional function to change orientation of tooltip based on parent
   */
  updateOrientation: PropTypes.func
});
var FloatingMenu$1 = FloatingMenu;
const getInstanceId$2 = setupGetInstanceId$2();
const on = function(element) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  element.addEventListener(...args);
  return {
    release() {
      element.removeEventListener(...args);
      return null;
    }
  };
};
const triggerButtonPositionProps = {
  [DIRECTION_TOP]: "bottom",
  [DIRECTION_BOTTOM]: "top"
};
const getMenuOffset = (menuBody, direction, trigger2, flip2) => {
  const triggerButtonPositionProp = triggerButtonPositionProps[direction];
  const {
    offsetWidth: menuWidth,
    offsetHeight: menuHeight
  } = menuBody;
  switch (triggerButtonPositionProp) {
    case "top":
    case "bottom": {
      const triggerWidth = !trigger2 ? 0 : trigger2.offsetWidth;
      return {
        left: (!flip2 ? 1 : -1) * (menuWidth / 2 - triggerWidth / 2),
        top: 0
      };
    }
    case "left":
    case "right": {
      const triggerHeight = !trigger2 ? 0 : trigger2.offsetHeight;
      return {
        left: 0,
        top: (!flip2 ? 1 : -1) * (menuHeight / 2 - triggerHeight / 2)
      };
    }
  }
};
let OverflowMenu$1 = class OverflowMenu2 extends React__default.Component {
  constructor() {
    super(...arguments);
    _defineProperty$2(this, "state", {
      open: false,
      // Set a default value for 'open'
      hasMountedTrigger: false,
      // Set a default value for 'hasMountedTrigger'
      click: false
      // Set a default value for 'click'
    });
    _defineProperty$2(this, "instanceId", getInstanceId$2());
    _defineProperty$2(this, "_hFocusIn", null);
    _defineProperty$2(this, "_hBlurTimeout", void 0);
    _defineProperty$2(this, "_triggerRef", /* @__PURE__ */ React__default.createRef());
    _defineProperty$2(this, "handleClick", (evt) => {
      const {
        onClick = noopFn
      } = this.props;
      this.setState({
        click: true
      });
      evt.stopPropagation();
      if (!this._menuBody || !this._menuBody.contains(evt.target)) {
        this.setState({
          open: !this.state.open
        });
        onClick(evt);
      }
    });
    _defineProperty$2(this, "closeMenuAndFocus", () => {
      const wasClicked = this.state.click;
      const wasOpen = this.state.open;
      this.closeMenu(() => {
        if (wasOpen && !wasClicked) {
          this.focusMenuEl();
        }
      });
    });
    _defineProperty$2(this, "closeMenuOnEscape", () => {
      const wasOpen = this.state.open;
      this.closeMenu(() => {
        if (wasOpen) {
          this.focusMenuEl();
        }
      });
    });
    _defineProperty$2(this, "handleKeyPress", (evt) => {
      if (this.state.open && matches$1(evt, [ArrowUp, ArrowRight, ArrowDown, ArrowLeft])) {
        evt.preventDefault();
      }
      if (matches$1(evt, [Escape])) {
        this.closeMenuOnEscape();
        evt.stopPropagation();
      }
    });
    _defineProperty$2(this, "handleClickOutside", (evt) => {
      if (this.state.open && (!this._menuBody || !this._menuBody.contains(evt.target))) {
        this.closeMenu();
      }
    });
    _defineProperty$2(this, "closeMenu", (onCloseMenu) => {
      const {
        onClose = noopFn
      } = this.props;
      this.setState({
        open: false
      }, () => {
        if (onCloseMenu) {
          onCloseMenu();
        }
        onClose();
      });
    });
    _defineProperty$2(this, "focusMenuEl", () => {
      const {
        current: triggerEl
      } = this._triggerRef;
      if (triggerEl) {
        triggerEl.focus();
      }
    });
    _defineProperty$2(this, "handleOverflowMenuItemFocus", (_ref3) => {
      let {
        currentIndex,
        direction
      } = _ref3;
      const enabledIndices = React__default.Children.toArray(this.props.children).reduce((acc, curr, i3) => {
        if (/* @__PURE__ */ React__default.isValidElement(curr) && !curr.props.disabled) {
          acc.push(i3);
        }
        return acc;
      }, []);
      const nextValidIndex = (() => {
        const nextIndex = enabledIndices.indexOf(currentIndex) + direction;
        switch (nextIndex) {
          case -1:
            return enabledIndices.length - 1;
          case enabledIndices.length:
            return 0;
          default:
            return nextIndex;
        }
      })();
      const overflowMenuItem = this[`overflowMenuItem${enabledIndices[nextValidIndex]}`];
      overflowMenuItem?.focus();
    });
    _defineProperty$2(this, "_menuBody", null);
    _defineProperty$2(this, "_bindMenuBody", (menuBody) => {
      if (!menuBody) {
        this._menuBody = menuBody;
      }
      if (!menuBody && this._hFocusIn) {
        this._hFocusIn = this._hFocusIn.release();
      }
    });
    _defineProperty$2(this, "_handlePlace", (menuBody) => {
      const {
        onOpen = noopFn
      } = this.props;
      if (menuBody) {
        this._menuBody = menuBody;
        const hasFocusin = "onfocusin" in window;
        const focusinEventName = hasFocusin ? "focusin" : "focus";
        this._hFocusIn = on(menuBody.ownerDocument, focusinEventName, (event) => {
          const target = ClickListener.getEventTarget(event);
          const {
            current: triggerEl
          } = this._triggerRef;
          if (typeof target.matches === "function") {
            if (!menuBody.contains(target) && triggerEl && !target.matches(`.${this.context}--overflow-menu:first-child,.${this.context}--overflow-menu-options:first-child`)) {
              this.closeMenuAndFocus();
            }
          }
        }, !hasFocusin);
        onOpen();
      }
    });
    _defineProperty$2(this, "_getTarget", () => {
      const {
        current: triggerEl
      } = this._triggerRef;
      return triggerEl instanceof Element && triggerEl.closest("[data-floating-menu-container]") || document.body;
    });
  }
  componentDidUpdate(_2, prevState) {
    const {
      onClose = noopFn
    } = this.props;
    if (!this.state.open && prevState.open) {
      onClose();
    }
  }
  componentDidMount() {
    if (this._triggerRef.current) {
      this.setState({
        hasMountedTrigger: true
      });
    }
  }
  static getDerivedStateFromProps(_ref22, state) {
    let {
      open: open2
    } = _ref22;
    const {
      prevOpen
    } = state;
    return prevOpen === open2 ? null : {
      open: open2,
      prevOpen: open2
    };
  }
  componentWillUnmount() {
    if (typeof this._hBlurTimeout === "number") {
      clearTimeout(this._hBlurTimeout);
      this._hBlurTimeout = void 0;
    }
  }
  render() {
    const prefix2 = this.context;
    const {
      id,
      ["aria-label"]: ariaLabel = null,
      ariaLabel: deprecatedAriaLabel,
      children,
      iconDescription = "Options",
      direction = DIRECTION_BOTTOM,
      flipped = false,
      focusTrap = true,
      menuOffset = getMenuOffset,
      menuOffsetFlip = getMenuOffset,
      iconClass,
      onClick = noopFn,
      // eslint-disable-line
      onOpen = noopFn,
      // eslint-disable-line
      selectorPrimaryFocus = "[data-floating-menu-primary-focus]",
      // eslint-disable-line
      renderIcon: IconElement = OverflowMenuVertical,
      // eslint-disable-next-line react/prop-types
      innerRef: ref2,
      menuOptionsClass,
      light,
      size = "md",
      ...other
    } = this.props;
    const {
      open: open2 = false
    } = this.state;
    const overflowMenuClasses = r(this.props.className, `${prefix2}--overflow-menu`, {
      [`${prefix2}--overflow-menu--open`]: open2,
      [`${prefix2}--overflow-menu--light`]: light,
      [`${prefix2}--overflow-menu--${size}`]: size
    });
    const overflowMenuOptionsClasses = r(menuOptionsClass, `${prefix2}--overflow-menu-options`, {
      [`${prefix2}--overflow-menu--flip`]: this.props.flipped,
      [`${prefix2}--overflow-menu-options--open`]: open2,
      [`${prefix2}--overflow-menu-options--light`]: light,
      [`${prefix2}--overflow-menu-options--${size}`]: size
    });
    const overflowMenuIconClasses = r(`${prefix2}--overflow-menu__icon`, iconClass);
    const childrenWithProps = React__default.Children.toArray(children).map((child, index2) => /* @__PURE__ */ React__default.isValidElement(child) ? /* @__PURE__ */ React__default.cloneElement(child, {
      // @ts-expect-error: PropTypes are not expressive enough to cover this case
      closeMenu: child.props.closeMenu || this.closeMenuAndFocus,
      handleOverflowMenuItemFocus: this.handleOverflowMenuItemFocus,
      ref: (e3) => {
        this[`overflowMenuItem${index2}`] = e3;
      },
      index: index2
    }) : null);
    const menuBodyId = `overflow-menu-${this.instanceId}__menu-body`;
    const menuBody = /* @__PURE__ */ React__default.createElement("ul", {
      className: overflowMenuOptionsClasses,
      tabIndex: -1,
      role: "menu",
      "aria-label": ariaLabel || deprecatedAriaLabel,
      onKeyDown: this.handleKeyPress,
      id: menuBodyId
    }, childrenWithProps);
    const wrappedMenuBody = /* @__PURE__ */ React__default.createElement(FloatingMenu$1, {
      focusTrap,
      triggerRef: this._triggerRef,
      menuDirection: direction,
      menuOffset: flipped ? menuOffsetFlip : menuOffset,
      menuRef: this._bindMenuBody,
      flipped: this.props.flipped,
      target: this._getTarget,
      onPlace: this._handlePlace,
      selectorPrimaryFocus: this.props.selectorPrimaryFocus
    }, /* @__PURE__ */ React__default.cloneElement(menuBody, {
      "data-floating-menu-direction": direction
    }));
    const iconProps = {
      className: overflowMenuIconClasses,
      "aria-label": iconDescription
    };
    return /* @__PURE__ */ React__default.createElement(ClickListener, {
      onClickOutside: this.handleClickOutside
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: `${prefix2}--overflow-menu__wrapper`,
      "aria-owns": open2 ? menuBodyId : void 0
    }, /* @__PURE__ */ React__default.createElement(IconButton, _extends({}, other, {
      type: "button",
      "aria-haspopup": true,
      "aria-expanded": open2,
      "aria-controls": open2 ? menuBodyId : void 0,
      className: overflowMenuClasses,
      onClick: this.handleClick,
      id,
      ref: mergeRefs$1(this._triggerRef, ref2),
      size,
      label: iconDescription
    }), /* @__PURE__ */ React__default.createElement(IconElement, iconProps)), open2 && this.state.hasMountedTrigger && wrappedMenuBody));
  }
};
_defineProperty$2(OverflowMenu$1, "propTypes", {
  /**
   * Specify a label to be read by screen readers on the container node
   */
  ["aria-label"]: PropTypes.string,
  /**
   * Deprecated, please use `aria-label` instead.
   * Specify a label to be read by screen readers on the container note.
   */
  ariaLabel: deprecate(PropTypes.string),
  /**
   * The child nodes.
   */
  children: PropTypes.node,
  /**
   * The CSS class names.
   */
  className: PropTypes.string,
  /**
   * The menu direction.
   */
  direction: PropTypes.oneOf([DIRECTION_TOP, DIRECTION_BOTTOM]),
  /**
   * `true` if the menu alignment should be flipped.
   */
  flipped: PropTypes.bool,
  /**
   * Enable or disable focus trap behavior
   */
  focusTrap: PropTypes.bool,
  /**
   * The CSS class for the icon.
   */
  iconClass: PropTypes.string,
  /**
   * The icon description.
   */
  iconDescription: PropTypes.string,
  /**
   * The element ID.
   */
  id: PropTypes.string,
  /**
   * `true` to use the light version. For use on $ui-01 backgrounds only.
   * Don't use this to make OverflowMenu background color same as container background color.
   */
  light: deprecate(PropTypes.bool),
  /**
   * The adjustment in position applied to the floating menu.
   */
  menuOffset: PropTypes.oneOfType([PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }), PropTypes.func]),
  /**
   * The adjustment in position applied to the floating menu.
   */
  menuOffsetFlip: PropTypes.oneOfType([PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }), PropTypes.func]),
  /**
   * The class to apply to the menu options
   */
  menuOptionsClass: PropTypes.string,
  /**
   * The event handler for the `click` event.
   */
  onClick: PropTypes.func,
  /**
   * Function called when menu is closed
   */
  onClose: PropTypes.func,
  /**
   * The event handler for the `focus` event.
   */
  onFocus: PropTypes.func,
  /**
   * The event handler for the `keydown` event.
   */
  onKeyDown: PropTypes.func,
  /**
   * Function called when menu is opened
   */
  onOpen: PropTypes.func,
  /**
   * `true` if the menu should be open.
   */
  open: PropTypes.bool,
  /**
   * Function called to override icon rendering.
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Specify a CSS selector that matches the DOM element that should
   * be focused when the OverflowMenu opens
   */
  selectorPrimaryFocus: PropTypes.string,
  /**
   * Specify the size of the OverflowMenu. Currently supports either `sm`, 'md' (default) or 'lg` as an option.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"])
});
_defineProperty$2(OverflowMenu$1, "contextType", PrefixContext);
(() => {
  const forwardRef2 = (props, ref2) => /* @__PURE__ */ React__default.createElement(OverflowMenu$1, _extends({}, props, {
    innerRef: ref2
  }));
  forwardRef2.displayName = "OverflowMenu";
  return /* @__PURE__ */ React__default.forwardRef(forwardRef2);
})();
const OverflowMenuV11 = createClassWrapper(OverflowMenu$1);
function OverflowMenu3(props) {
  const enableV12OverflowMenu = useFeatureFlag("enable-v12-overflowmenu");
  return enableV12OverflowMenu ? /* @__PURE__ */ React__default.createElement(OverflowMenu$2, props) : /* @__PURE__ */ React__default.createElement(OverflowMenuV11, props);
}
OverflowMenu3.displayName = "OverflowMenu";
const defaultIconDescription = "Settings";
const TableToolbarMenu = (_ref3) => {
  let {
    className,
    renderIcon = Settings,
    iconDescription = defaultIconDescription,
    children,
    menuOptionsClass,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const toolbarActionClasses = r(className, `${prefix2}--toolbar-action ${prefix2}--overflow-menu`);
  const menuOptionsClasses = r(menuOptionsClass, `${prefix2}--toolbar-action__menu`);
  return /* @__PURE__ */ React__default.createElement(OverflowMenu3, _extends({
    "aria-label": iconDescription,
    renderIcon,
    className: toolbarActionClasses,
    title: iconDescription,
    iconDescription,
    menuOptionsClass: menuOptionsClasses,
    flipped: true
  }, rest), children);
};
TableToolbarMenu.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Provide an optional class name for the toolbar menu
   */
  className: PropTypes.string,
  /**
   * The description of the menu icon.
   */
  iconDescription: PropTypes.string,
  /**
   * Provide an optional class name for the toolbar menu
   */
  menuOptionsClass: PropTypes.string,
  /**
   * Optional prop to allow overriding the default menu icon
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
const getInstanceId$1 = setupGetInstanceId$1();
const translationKeys = {
  expandRow: "carbon.table.row.expand",
  collapseRow: "carbon.table.row.collapse",
  expandAll: "carbon.table.all.expand",
  collapseAll: "carbon.table.all.collapse",
  selectAll: "carbon.table.all.select",
  unselectAll: "carbon.table.all.unselect",
  selectRow: "carbon.table.row.select",
  unselectRow: "carbon.table.row.unselect"
};
const defaultTranslations = {
  [translationKeys.expandAll]: "Expand all rows",
  [translationKeys.collapseAll]: "Collapse all rows",
  [translationKeys.expandRow]: "Expand current row",
  [translationKeys.collapseRow]: "Collapse current row",
  [translationKeys.selectAll]: "Select all rows",
  [translationKeys.unselectAll]: "Unselect all rows",
  [translationKeys.selectRow]: "Select row",
  [translationKeys.unselectRow]: "Unselect row"
};
const translateWithId = (id) => defaultTranslations[id];
class DataTable extends React__default.Component {
  constructor(_props) {
    var _this;
    super(_props);
    _this = this;
    _defineProperty$2(this, "instanceId", void 0);
    _defineProperty$2(this, "getHeaderProps", (_ref3) => {
      let {
        header: header2,
        onClick,
        isSortable = this.props.isSortable,
        ...rest
      } = _ref3;
      const {
        sortDirection,
        sortHeaderKey
      } = this.state;
      return {
        ...rest,
        key: header2.key,
        sortDirection,
        isSortable,
        isSortHeader: sortHeaderKey === header2.key,
        slug: header2.slug,
        onClick: (event) => {
          const nextSortState = getNextSortState(this.props, this.state, {
            key: header2.key
          });
          this.setState(nextSortState, () => {
            onClick && this.handleOnHeaderClick(onClick, {
              sortHeaderKey: header2.key,
              sortDirection: nextSortState.sortDirection
            })(event);
          });
        }
      };
    });
    _defineProperty$2(this, "getExpandHeaderProps", function() {
      let {
        onClick,
        onExpand,
        ...rest
      } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const {
        translateWithId: t3 = translateWithId
      } = _this.props;
      const {
        isExpandedAll,
        rowIds,
        rowsById
      } = _this.state;
      const isExpanded = isExpandedAll || rowIds.every((id) => rowsById[id].isExpanded);
      const translationKey = isExpanded ? translationKeys.collapseAll : translationKeys.expandAll;
      return {
        ...rest,
        ariaLabel: t3(translationKey),
        // TODO: remove in v12
        "aria-label": t3(translationKey),
        // Provide a string of all the expanded row id's, separated by a space.
        "aria-controls": rowIds.map((id) => `expanded-row-${id}`).join(" "),
        isExpanded,
        // Compose the event handlers so we don't overwrite a consumer's `onClick`
        // handler
        onExpand: composeEventHandlers([_this.handleOnExpandAll, onExpand, onClick && _this.handleOnExpandHeaderClick(onClick, {
          isExpanded
        })])
      };
    });
    _defineProperty$2(this, "handleOnHeaderClick", (onClick, sortParams) => {
      return (e3) => onClick(e3, sortParams);
    });
    _defineProperty$2(this, "handleOnExpandHeaderClick", (onClick, expandParams) => {
      return (e3) => onClick(e3, expandParams);
    });
    _defineProperty$2(this, "getRowProps", (_ref22) => {
      let {
        row: row2,
        onClick,
        ...rest
      } = _ref22;
      const {
        translateWithId: t3 = translateWithId
      } = this.props;
      const translationKey = row2.isExpanded ? translationKeys.collapseRow : translationKeys.expandRow;
      return {
        ...rest,
        key: row2.id,
        // Compose the event handlers so we don't overwrite a consumer's `onClick`
        // handler
        onExpand: composeEventHandlers([this.handleOnExpandRow(row2.id), onClick]),
        isExpanded: row2.isExpanded,
        ariaLabel: t3(translationKey),
        // TODO remove in v12
        "aria-label": t3(translationKey),
        "aria-controls": `expanded-row-${row2.id}`,
        isSelected: row2.isSelected,
        disabled: row2.disabled
      };
    });
    _defineProperty$2(this, "getExpandedRowProps", (_ref3) => {
      let {
        row: row2,
        ...rest
      } = _ref3;
      return {
        ...rest,
        id: `expanded-row-${row2.id}`
      };
    });
    _defineProperty$2(this, "getSelectionProps", function() {
      let {
        onClick,
        row: row2,
        ...rest
      } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const {
        translateWithId: t3 = translateWithId
      } = _this.props;
      if (row2) {
        const translationKey2 = row2.isSelected ? translationKeys.unselectRow : translationKeys.selectRow;
        return {
          ...rest,
          checked: row2.isSelected,
          onSelect: composeEventHandlers([_this.handleOnSelectRow(row2.id), onClick]),
          id: `${_this.getTablePrefix()}__select-row-${row2.id}`,
          name: `select-row`,
          ariaLabel: t3(translationKey2),
          disabled: row2.disabled,
          radio: _this.props.radio || null
        };
      }
      const rowCount = _this.state.rowIds.length;
      const selectedRowCount = _this.getSelectedRows().length;
      const checked = rowCount > 0 && selectedRowCount === rowCount;
      const indeterminate = rowCount > 0 && selectedRowCount > 0 && selectedRowCount !== rowCount;
      const translationKey = checked || indeterminate ? translationKeys.unselectAll : translationKeys.selectAll;
      return {
        ...rest,
        ariaLabel: t3(translationKey),
        checked,
        id: `${_this.getTablePrefix()}__select-all`,
        indeterminate,
        name: "select-all",
        onSelect: composeEventHandlers([_this.handleSelectAll, onClick])
      };
    });
    _defineProperty$2(this, "getToolbarProps", function() {
      let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const {
        size
      } = _this.props;
      const isSmall = size === "xs" || size === "sm";
      return {
        ...props,
        size: isSmall ? "sm" : void 0
      };
    });
    _defineProperty$2(this, "getBatchActionProps", function() {
      let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const {
        shouldShowBatchActions
      } = _this.state;
      const totalSelected = _this.getSelectedRows().length;
      return {
        onSelectAll: void 0,
        totalCount: _this.state.rowIds.length || 0,
        ...props,
        shouldShowBatchActions: shouldShowBatchActions && totalSelected > 0,
        totalSelected,
        onCancel: _this.handleOnCancel
      };
    });
    _defineProperty$2(this, "getTableProps", () => {
      const {
        useZebraStyles,
        size = "lg",
        isSortable,
        useStaticWidth,
        stickyHeader: stickyHeader2,
        overflowMenuOnHover = false,
        experimentalAutoAlign
      } = this.props;
      return {
        useZebraStyles,
        size,
        isSortable,
        useStaticWidth,
        stickyHeader: stickyHeader2,
        overflowMenuOnHover,
        experimentalAutoAlign
      };
    });
    _defineProperty$2(this, "getTableContainerProps", () => {
      const {
        stickyHeader: stickyHeader2,
        useStaticWidth
      } = this.props;
      return {
        stickyHeader: stickyHeader2,
        useStaticWidth
      };
    });
    _defineProperty$2(this, "getCellProps", (_ref4) => {
      let {
        cell: cell2,
        ...rest
      } = _ref4;
      return {
        ...rest,
        hasSlugHeader: cell2.hasSlugHeader
      };
    });
    _defineProperty$2(this, "getSelectedRows", () => this.state.rowIds.filter((id) => {
      const row2 = this.state.rowsById[id];
      return row2.isSelected && !row2.disabled;
    }));
    _defineProperty$2(this, "getFilteredRowIds", () => {
      const {
        filterRows = defaultFilterRows
      } = this.props;
      const filteredRowIds = typeof this.state.filterInputValue === "string" ? filterRows({
        rowIds: this.state.rowIds,
        headers: this.props.headers,
        cellsById: this.state.cellsById,
        inputValue: this.state.filterInputValue,
        getCellId
      }) : this.state.rowIds;
      if (filteredRowIds.length == 0) {
        return [];
      }
      return filteredRowIds;
    });
    _defineProperty$2(this, "getTablePrefix", () => `data-table-${this.instanceId}`);
    _defineProperty$2(this, "setAllSelectedState", (initialState2, isSelected, filteredRowIds) => {
      const {
        rowIds
      } = initialState2;
      const isFiltered = rowIds.length != filteredRowIds.length;
      return {
        rowsById: rowIds.reduce((acc, id) => {
          const row2 = {
            ...initialState2.rowsById[id]
          };
          if (!row2.disabled && (!isFiltered || filteredRowIds.includes(id))) {
            row2.isSelected = isSelected;
          }
          acc[id] = row2;
          return acc;
        }, {})
      };
    });
    _defineProperty$2(this, "handleOnCancel", () => {
      this.setState((state) => {
        return {
          shouldShowBatchActions: false,
          ...this.setAllSelectedState(state, false, this.getFilteredRowIds())
        };
      });
    });
    _defineProperty$2(this, "handleSelectAll", () => {
      this.setState((state) => {
        const filteredRowIds = this.getFilteredRowIds();
        const {
          rowsById
        } = state;
        const isSelected = !(Object.values(rowsById).filter((row2) => row2.isSelected && !row2.disabled).length > 0);
        return {
          shouldShowBatchActions: isSelected,
          ...this.setAllSelectedState(state, isSelected, filteredRowIds)
        };
      });
    });
    _defineProperty$2(this, "handleOnSelectRow", (rowId) => () => {
      this.setState((state) => {
        const row2 = state.rowsById[rowId];
        if (this.props.radio) {
          const rowsById = Object.entries(state.rowsById).reduce((p2, c3) => {
            const [key, val] = c3;
            val.isSelected = false;
            p2[key] = val;
            return p2;
          }, {});
          return {
            shouldShowBatchActions: false,
            rowsById: {
              ...rowsById,
              [rowId]: {
                ...row2,
                isSelected: !row2.isSelected
              }
            }
          };
        }
        const selectedRows = state.rowIds.filter((id) => state.rowsById[id].isSelected).length;
        const selectedRowsCount = !row2.isSelected ? selectedRows + 1 : selectedRows - 1;
        return {
          // Basic assumption here is that we want to show the batch action bar if
          // the row is being selected. If it's being unselected, then see if we
          // have a non-zero number of selected rows that batch actions could
          // still apply to
          shouldShowBatchActions: !row2.isSelected || selectedRowsCount > 0,
          rowsById: {
            ...state.rowsById,
            [rowId]: {
              ...row2,
              isSelected: !row2.isSelected
            }
          }
        };
      });
    });
    _defineProperty$2(this, "handleOnExpandRow", (rowId) => () => {
      this.setState((state) => {
        const row2 = state.rowsById[rowId];
        const {
          isExpandedAll
        } = state;
        return {
          isExpandedAll: row2.isExpanded ? false : isExpandedAll,
          rowsById: {
            ...state.rowsById,
            [rowId]: {
              ...row2,
              isExpanded: !row2.isExpanded
            }
          }
        };
      });
    });
    _defineProperty$2(this, "handleOnExpandAll", () => {
      this.setState((state) => {
        const {
          rowIds,
          isExpandedAll
        } = state;
        return {
          isExpandedAll: !isExpandedAll,
          rowsById: rowIds.reduce((acc, id) => ({
            ...acc,
            [id]: {
              ...state.rowsById[id],
              isExpanded: !isExpandedAll
            }
          }), {})
        };
      });
    });
    _defineProperty$2(this, "handleSortBy", (headerKey) => () => {
      this.setState((state) => getNextSortState(this.props, state, {
        key: headerKey
      }));
    });
    _defineProperty$2(this, "handleOnInputValueChange", (event, defaultValue) => {
      if (event.target) {
        this.setState({
          filterInputValue: event.target.value
        });
      }
      if (defaultValue) {
        this.setState({
          filterInputValue: defaultValue
        });
      }
    });
    this.state = {
      ...getDerivedStateFromProps$1(_props, {}),
      isExpandedAll: false
      // Start with collapsed state, treat `undefined` as neutral state
    };
    this.instanceId = getInstanceId$1();
  }
  // if state needs to be updated then wait for only update after state is finished
  shouldComponentUpdate(nextProps) {
    if (this.props !== nextProps) {
      const nextRowIds = nextProps.rows.map((row2) => row2.id);
      const rowIds = this.props.rows.map((row2) => row2.id);
      if (!isEqual$3(nextRowIds, rowIds)) {
        this.setState((state) => getDerivedStateFromProps$1(this.props, state));
        return false;
      }
      const nextHeaders = nextProps.headers.map((header2) => header2.key);
      const headers = this.props.headers.map((header2) => header2.key);
      if (!isEqual$3(nextHeaders, headers)) {
        this.setState((state) => getDerivedStateFromProps$1(this.props, state));
        return false;
      }
      if (!isEqual$3(nextProps.rows, this.props.rows)) {
        this.setState((state) => getDerivedStateFromProps$1(this.props, state));
        return false;
      }
    }
    return true;
  }
  render() {
    const {
      children,
      filterRows = defaultFilterRows,
      headers,
      render
    } = this.props;
    const {
      filterInputValue,
      rowIds,
      rowsById,
      cellsById
    } = this.state;
    const filteredRowIds = typeof filterInputValue === "string" ? filterRows({
      rowIds,
      headers,
      cellsById,
      inputValue: filterInputValue,
      getCellId
    }) : rowIds;
    const renderProps = {
      // Data derived from state
      rows: denormalize$1(filteredRowIds, rowsById, cellsById),
      headers: this.props.headers,
      selectedRows: denormalize$1(this.getSelectedRows(), rowsById, cellsById),
      // Prop accessors/getters
      getHeaderProps: this.getHeaderProps,
      getExpandHeaderProps: this.getExpandHeaderProps,
      getRowProps: this.getRowProps,
      getExpandedRowProps: this.getExpandedRowProps,
      getSelectionProps: this.getSelectionProps,
      getToolbarProps: this.getToolbarProps,
      getBatchActionProps: this.getBatchActionProps,
      getTableProps: this.getTableProps,
      getTableContainerProps: this.getTableContainerProps,
      getCellProps: this.getCellProps,
      // Custom event handlers
      onInputChange: this.handleOnInputValueChange,
      // Expose internal state change actions
      sortBy: (headerKey) => this.handleSortBy(headerKey)(),
      selectAll: this.handleSelectAll,
      selectRow: (rowId) => this.handleOnSelectRow(rowId)(),
      expandRow: (rowId) => this.handleOnExpandRow(rowId)(),
      expandAll: this.handleOnExpandAll,
      radio: this.props.radio
    };
    if (render !== void 0) {
      return render(renderProps);
    }
    if (children !== void 0) {
      return children(renderProps);
    }
    return null;
  }
}
_defineProperty$2(DataTable, "propTypes", {
  /**
   * Experimental property. Allows table to align cell contents to the top if there is text wrapping in the content. Might have performance issues, intended for smaller tables
   */
  experimentalAutoAlign: PropTypes.bool,
  /**
   * Optional hook to manually control filtering of the rows from the
   * TableToolbarSearch component
   */
  filterRows: PropTypes.func,
  /**
   * The `headers` prop represents the order in which the headers should
   * appear in the table. We expect an array of objects to be passed in, where
   * `key` is the name of the key in a row object, and `header` is the name of
   * the header.
   */
  headers: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    header: PropTypes.node.isRequired
  })).isRequired,
  /**
   * Specify whether the table should be able to be sorted by its headers
   */
  isSortable: PropTypes.bool,
  /**
   * Provide a string for the current locale
   */
  locale: PropTypes.string,
  /**
   * Specify whether the overflow menu (if it exists) should be shown always, or only on hover
   */
  overflowMenuOnHover: PropTypes.bool,
  /**
   * Specify whether the control should be a radio button or inline checkbox
   */
  radio: PropTypes.bool,
  /**
   * The `rows` prop is where you provide us with a list of all the rows that
   * you want to render in the table. The only hard requirement is that this
   * is an array of objects, and that each object has a unique `id` field
   * available on it.
   */
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    isExpanded: PropTypes.bool
  })).isRequired,
  /**
   *  Change the row height of table. Currently supports `xs`, `sm`, `md`, `lg`, and `xl`.
   */
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * Optional hook to manually control sorting of the rows.
   */
  sortRow: PropTypes.func,
  /**
   * Specify whether the header should be sticky.
   * Still experimental: may not work with every combination of table props
   */
  stickyHeader: PropTypes.bool,
  /**
   * Optional method that takes in a message id and returns an
   * internationalized string. See `DataTable.translationKeys` for all
   * available message ids.
   */
  translateWithId: PropTypes.func,
  /**
   * `false` If true, will use a width of 'auto' instead of 100%
   */
  useStaticWidth: PropTypes.bool,
  /**
   * `true` to add useZebraStyles striping.
   */
  useZebraStyles: PropTypes.bool
});
_defineProperty$2(DataTable, "translationKeys", Object.values(translationKeys));
_defineProperty$2(DataTable, "Table", void 0);
_defineProperty$2(DataTable, "TableActionList", void 0);
_defineProperty$2(DataTable, "TableBatchAction", void 0);
_defineProperty$2(DataTable, "TableBatchActions", void 0);
_defineProperty$2(DataTable, "TableBody", void 0);
_defineProperty$2(DataTable, "TableCell", void 0);
_defineProperty$2(DataTable, "TableContainer", void 0);
_defineProperty$2(DataTable, "TableExpandHeader", void 0);
_defineProperty$2(DataTable, "TableExpandRow", void 0);
_defineProperty$2(DataTable, "TableExpandedRow", void 0);
_defineProperty$2(DataTable, "TableHead", void 0);
_defineProperty$2(DataTable, "TableHeader", void 0);
_defineProperty$2(DataTable, "TableRow", void 0);
_defineProperty$2(DataTable, "TableSelectAll", void 0);
_defineProperty$2(DataTable, "TableSelectRow", void 0);
_defineProperty$2(DataTable, "TableSlugRow", void 0);
_defineProperty$2(DataTable, "TableToolbar", void 0);
_defineProperty$2(DataTable, "TableToolbarAction", void 0);
_defineProperty$2(DataTable, "TableToolbarContent", void 0);
_defineProperty$2(DataTable, "TableToolbarSearch", void 0);
_defineProperty$2(DataTable, "TableToolbarMenu", void 0);
DataTable.Table = Table$1;
DataTable.TableActionList = TableActionList;
DataTable.TableBatchAction = TableBatchAction;
DataTable.TableBatchActions = TableBatchActions;
DataTable.TableBody = TableBody;
DataTable.TableCell = TableCell;
DataTable.TableContainer = TableContainer;
DataTable.TableExpandHeader = TableExpandHeader;
DataTable.TableExpandRow = TableExpandRow;
DataTable.TableExpandedRow = TableExpandedRow;
DataTable.TableHead = TableHead;
DataTable.TableHeader = TableHeader;
DataTable.TableRow = TableRow;
DataTable.TableSelectAll = TableSelectAll;
DataTable.TableSelectRow = TableSelectRow;
DataTable.TableSlugRow = TableSlugRow;
DataTable.TableToolbar = TableToolbar;
DataTable.TableToolbarAction = TableToolbarAction;
DataTable.TableToolbarContent = TableToolbarContent;
DataTable.TableToolbarSearch = TableToolbarSearch;
DataTable.TableToolbarMenu = TableToolbarMenu;
const getInstanceId = setupGetInstanceId$2();
const Select$1 = /* @__PURE__ */ React__default.forwardRef(function Select(_ref3, ref2) {
  let {
    className,
    id,
    inline: inline2 = false,
    labelText = "Select",
    disabled: disabled2 = false,
    children,
    // reserved for use with Pagination component
    noLabel = false,
    // eslint-disable-next-line no-unused-vars
    hideLabel = false,
    invalid: invalid2 = false,
    invalidText = "",
    helperText = "",
    light = false,
    readOnly: readOnly2,
    size,
    warn = false,
    warnText,
    onChange: onChange2,
    slug,
    ...other
  } = _ref3;
  const prefix2 = usePrefix();
  const {
    isFluid
  } = useContext(FormContext);
  const [isFocused, setIsFocused] = useState(false);
  const [title2, setTitle] = useState("");
  const {
    current: selectInstanceId
  } = useRef(getInstanceId());
  const selectClasses = r({
    [`${prefix2}--select`]: true,
    [`${prefix2}--select--inline`]: inline2,
    [`${prefix2}--select--light`]: light,
    [`${prefix2}--select--invalid`]: invalid2,
    [`${prefix2}--select--disabled`]: disabled2,
    [`${prefix2}--select--readonly`]: readOnly2,
    [`${prefix2}--select--warning`]: warn,
    [`${prefix2}--select--fluid--invalid`]: isFluid && invalid2,
    [`${prefix2}--select--fluid--focus`]: isFluid && isFocused,
    [`${prefix2}--select--slug`]: slug
  });
  const labelClasses = r(`${prefix2}--label`, {
    [`${prefix2}--visually-hidden`]: hideLabel,
    [`${prefix2}--label--disabled`]: disabled2
  });
  const inputClasses = r({
    [`${prefix2}--select-input`]: true,
    [`${prefix2}--select-input--${size}`]: size
  });
  const errorId = `${id}-error-msg`;
  const errorText = (() => {
    if (invalid2) {
      return invalidText;
    }
    if (warn) {
      return warnText;
    }
  })();
  const error2 = invalid2 || warn ? /* @__PURE__ */ React__default.createElement(Text, {
    as: "div",
    className: `${prefix2}--form-requirement`,
    id: errorId
  }, errorText) : null;
  const helperTextClasses = r(`${prefix2}--form__helper-text`, {
    [`${prefix2}--form__helper-text--disabled`]: disabled2
  });
  const helperId = !helperText ? void 0 : `select-helper-text-${selectInstanceId}`;
  const helper2 = helperText ? /* @__PURE__ */ React__default.createElement(Text, {
    as: "div",
    id: helperId,
    className: helperTextClasses
  }, helperText) : null;
  const ariaProps = {};
  if (invalid2) {
    ariaProps["aria-describedby"] = errorId;
  } else if (!inline2 && !isFluid) {
    ariaProps["aria-describedby"] = helper2 ? helperId : void 0;
  }
  const handleFocus = (evt) => {
    setIsFocused(evt.type === "focus" ? true : false);
  };
  const handleChange = (evt) => {
    setTitle(evt?.target?.value);
  };
  const readOnlyEventHandlers = {
    onMouseDown: (evt) => {
      if (readOnly2) {
        evt.preventDefault();
        evt.target.focus();
      }
    },
    onKeyDown: (evt) => {
      const selectAccessKeys = ["ArrowDown", "ArrowUp", " "];
      if (readOnly2 && selectAccessKeys.includes(evt.key)) {
        evt.preventDefault();
      }
    }
  };
  let normalizedSlug;
  if (slug && slug["type"]?.displayName === "Slug") {
    normalizedSlug = /* @__PURE__ */ React__default.cloneElement(slug, {
      size: "mini"
    });
  }
  const input2 = (() => {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("select", _extends({}, other, ariaProps, {
      id,
      className: inputClasses,
      disabled: disabled2 || void 0,
      "aria-invalid": invalid2 || void 0,
      "aria-readonly": readOnly2 || void 0,
      title: title2,
      onChange: composeEventHandlers([onChange2, handleChange])
    }, readOnlyEventHandlers, {
      ref: ref2
    }), children), /* @__PURE__ */ React__default.createElement(ChevronDown, {
      className: `${prefix2}--select__arrow`
    }), invalid2 && /* @__PURE__ */ React__default.createElement(WarningFilled, {
      className: `${prefix2}--select__invalid-icon`
    }), !invalid2 && warn && /* @__PURE__ */ React__default.createElement(WarningAltFilled, {
      className: `${prefix2}--select__invalid-icon ${prefix2}--select__invalid-icon--warning`
    }));
  })();
  return /* @__PURE__ */ React__default.createElement("div", {
    className: r(`${prefix2}--form-item`, className)
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: selectClasses
  }, !noLabel && /* @__PURE__ */ React__default.createElement(Text, {
    as: "label",
    htmlFor: id,
    className: labelClasses
  }, labelText), inline2 && /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--select-input--inline__wrapper`
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--select-input__wrapper`,
    "data-invalid": invalid2 || null
  }, input2), error2), !inline2 && /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--select-input__wrapper`,
    "data-invalid": invalid2 || null,
    onFocus: handleFocus,
    onBlur: handleFocus
  }, input2, normalizedSlug, isFluid && /* @__PURE__ */ React__default.createElement("hr", {
    className: `${prefix2}--select__divider`
  }), isFluid && error2 ? error2 : null), !inline2 && !isFluid && error2 ? error2 : helper2));
});
Select$1.displayName = "Select";
Select$1.propTypes = {
  /**
   * Provide the contents of your Select
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be applied to the node containing the label and the select box
   */
  className: PropTypes.string,
  /**
   * Optionally provide the default value of the `<select>`
   */
  defaultValue: PropTypes.any,
  /**
   * Specify whether the control is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Provide text that is used alongside the control label for additional help
   */
  helperText: PropTypes.node,
  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,
  /**
   * Specify a custom `id` for the `<select>`
   */
  id: PropTypes.string.isRequired,
  /**
   * Specify whether you want the inline version of this control
   */
  inline: PropTypes.bool,
  /**
   * Specify if the currently value is invalid.
   */
  invalid: PropTypes.bool,
  /**
   * Message which is displayed if the value is invalid.
   */
  invalidText: PropTypes.node,
  /**
   * Provide label text to be read by screen readers when interacting with the
   * control
   */
  labelText: PropTypes.node,
  /**
   * `true` to use the light version. For use on $ui-01 backgrounds only.
   * Don't use this to make tile background color same as container background color.
   */
  light: deprecate(PropTypes.bool),
  /**
   * Reserved for use with Pagination component. Will not render a label for the
   * select since Pagination renders one for us.
   */
  noLabel: PropTypes.bool,
  /**
   * Provide an optional `onChange` hook that is called each time the value of
   * the underlying `<input>` changes
   */
  onChange: PropTypes.func,
  /**
   * Whether the select should be read-only
   */
  readOnly: PropTypes.bool,
  /**
   * Specify the size of the Select Input.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * **Experimental**: Provide a `Slug` component to be rendered inside the `Select` component
   */
  slug: PropTypes.node,
  /**
   * Specify whether the control is currently in warning state
   */
  warn: PropTypes.bool,
  /**
   * Provide the text that is displayed when the control is in warning state
   */
  warnText: PropTypes.node
};
const SelectItem = (_ref3) => {
  let {
    className,
    value: value2 = "",
    disabled: disabled2 = false,
    hidden: hidden2 = false,
    text: text2 = "",
    ...other
  } = _ref3;
  const prefix2 = usePrefix();
  const selectItemClasses = r({
    [`${prefix2}--select-option`]: true,
    ...className && {
      [className]: className
    }
  });
  return /* @__PURE__ */ React__default.createElement("option", _extends({}, other, {
    className: selectItemClasses,
    value: value2,
    disabled: disabled2,
    hidden: hidden2
  }), text2);
};
SelectItem.propTypes = {
  /**
   * Specify an optional className to be applied to the node
   */
  className: PropTypes.string,
  /**
   * Specify whether the <SelectItem> should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Specify whether the <SelectItem> is hidden
   */
  hidden: PropTypes.bool,
  /**
   * Provide the contents of your <SelectItem>
   */
  text: PropTypes.string.isRequired,
  /**
   * Specify the value of the <SelectItem>
   */
  value: PropTypes.any.isRequired
};
function equals(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
    return false;
  }
  if (arr1 === arr2) {
    return true;
  }
  for (let i3 = 0; i3 < arr1.length; i3++) {
    if (arr1[i3] !== arr2[i3]) {
      return false;
    }
  }
  return true;
}
var _CaretLeft, _CaretRight;
function mapPageSizesToObject(sizes) {
  return typeof sizes[0] === "object" && sizes[0] !== null ? sizes : sizes.map((size) => ({
    text: size,
    value: size
  }));
}
function renderSelectItems(total) {
  let counter2 = 1;
  const itemArr = [];
  while (counter2 <= total) {
    itemArr.push(/* @__PURE__ */ React__default.createElement(SelectItem, {
      key: counter2,
      value: counter2,
      text: String(counter2)
    }));
    counter2++;
  }
  return itemArr;
}
function getPageSize(pageSizes, pageSize) {
  if (pageSize) {
    const hasSize = pageSizes.find((size) => {
      return pageSize === size.value;
    });
    if (hasSize) {
      return pageSize;
    }
  }
  return pageSizes[0].value;
}
const Pagination = /* @__PURE__ */ React__default.forwardRef(function Pagination2(_ref3, ref2) {
  let {
    backwardText = "Previous page",
    className: customClassName = "",
    disabled: disabled2 = false,
    forwardText = "Next page",
    id,
    isLastPage = false,
    itemText = (min2, max2) => `${min2}–${max2} items`,
    itemRangeText = (min2, max2, total) => `${min2}–${max2} of ${total} items`,
    itemsPerPageText = "Items per page:",
    onChange: onChange2,
    pageNumberText: _pageNumberText = "Page Number",
    pageRangeText = (_current, total) => `of ${total} ${total === 1 ? "page" : "pages"}`,
    page: controlledPage = 1,
    pageInputDisabled,
    pageSize: controlledPageSize,
    pageSizeInputDisabled,
    pageSizes: controlledPageSizes,
    pageText = (page2) => `page ${page2}`,
    pagesUnknown = false,
    size = "md",
    totalItems,
    ...rest
  } = _ref3;
  const prefix2 = usePrefix();
  const inputId = useFallbackId(id?.toString());
  const backBtnRef = useRef(null);
  const forwardBtnRef = useRef(null);
  const [pageSizes, setPageSizes] = useState(() => {
    return mapPageSizesToObject(controlledPageSizes);
  });
  const [prevPageSizes, setPrevPageSizes] = useState(controlledPageSizes);
  const [page, setPage] = useState(controlledPage);
  const [prevControlledPage, setPrevControlledPage] = useState(controlledPage);
  const [pageSize, setPageSize] = useState(() => {
    return getPageSize(pageSizes, controlledPageSize);
  });
  const [prevControlledPageSize, setPrevControlledPageSize] = useState(controlledPageSize);
  const className = r({
    [`${prefix2}--pagination`]: true,
    [`${prefix2}--pagination--${size}`]: size,
    [customClassName]: !!customClassName
  });
  const totalPages = totalItems ? Math.max(Math.ceil(totalItems / pageSize), 1) : NaN;
  const backButtonDisabled = disabled2 || page === 1;
  const backButtonClasses = r({
    [`${prefix2}--pagination__button`]: true,
    [`${prefix2}--pagination__button--backward`]: true,
    [`${prefix2}--pagination__button--no-index`]: backButtonDisabled
  });
  const forwardButtonDisabled = disabled2 || page === totalPages;
  const forwardButtonClasses = r({
    [`${prefix2}--pagination__button`]: true,
    [`${prefix2}--pagination__button--forward`]: true,
    [`${prefix2}--pagination__button--no-index`]: forwardButtonDisabled
  });
  const selectItems = renderSelectItems(totalPages);
  if (controlledPage !== prevControlledPage) {
    setPage(controlledPage);
    setPrevControlledPage(controlledPage);
  }
  if (controlledPageSize !== prevControlledPageSize) {
    setPageSize(getPageSize(pageSizes, controlledPageSize));
    setPrevControlledPageSize(controlledPageSize);
  }
  if (!equals(controlledPageSizes, prevPageSizes)) {
    const pageSizes2 = mapPageSizesToObject(controlledPageSizes);
    const hasPageSize = pageSizes2.find((size2) => {
      return size2.value === pageSize;
    });
    if (!hasPageSize) {
      setPage(1);
    }
    setPageSizes(pageSizes2);
    setPrevPageSizes(controlledPageSizes);
  }
  function handleSizeChange(event) {
    const pageSize2 = Number(event.target.value);
    const changes = {
      pageSize: pageSize2,
      page: 1
    };
    setPage(changes.page);
    setPageSize(changes.pageSize);
    if (onChange2) {
      onChange2(changes);
    }
  }
  function handlePageInputChange(event) {
    const page2 = Number(event.target.value);
    if (page2 > 0 && totalItems && page2 <= Math.max(Math.ceil(totalItems / pageSize), 1)) {
      setPage(page2);
      if (onChange2) {
        onChange2({
          page: page2,
          pageSize
        });
      }
    }
  }
  function incrementPage() {
    const nextPage = page + 1;
    setPage(nextPage);
    if (nextPage === totalPages && backBtnRef?.current) {
      backBtnRef.current.focus();
    }
    if (onChange2) {
      onChange2({
        page: nextPage,
        pageSize,
        ref: backBtnRef
      });
    }
  }
  function decrementPage() {
    const nextPage = page - 1;
    setPage(nextPage);
    if (nextPage === 1 && forwardBtnRef?.current) {
      forwardBtnRef.current.focus();
    }
    if (onChange2) {
      onChange2({
        page: nextPage,
        pageSize,
        ref: forwardBtnRef
      });
    }
  }
  return /* @__PURE__ */ React__default.createElement("div", _extends({
    className,
    ref: ref2
  }, rest), /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--pagination__left`
  }, /* @__PURE__ */ React__default.createElement("label", {
    id: `${prefix2}-pagination-select-${inputId}-count-label`,
    className: `${prefix2}--pagination__text`,
    htmlFor: `${prefix2}-pagination-select-${inputId}`
  }, itemsPerPageText), /* @__PURE__ */ React__default.createElement(Select$1, {
    id: `${prefix2}-pagination-select-${inputId}`,
    className: `${prefix2}--select__item-count`,
    labelText: "",
    hideLabel: true,
    noLabel: true,
    inline: true,
    onChange: handleSizeChange,
    disabled: pageSizeInputDisabled || disabled2,
    value: pageSize
  }, pageSizes.map((sizeObj) => /* @__PURE__ */ React__default.createElement(SelectItem, {
    key: sizeObj.value,
    value: sizeObj.value,
    text: String(sizeObj.text)
  }))), /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--pagination__text ${prefix2}--pagination__items-count`
  }, pagesUnknown || !totalItems ? itemText(pageSize * (page - 1) + 1, page * pageSize) : itemRangeText(Math.min(pageSize * (page - 1) + 1, totalItems), Math.min(page * pageSize, totalItems), totalItems))), /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--pagination__right`
  }, pagesUnknown ? /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--pagination__text ${prefix2}--pagination__page-text ${prefix2}--pagination__unknown-pages-text`
  }, pageText(page)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Select$1, {
    id: `${prefix2}-pagination-select-${inputId}-right`,
    className: `${prefix2}--select__page-number`,
    labelText: `Page number, of ${totalPages} pages`,
    inline: true,
    hideLabel: true,
    onChange: handlePageInputChange,
    value: page,
    disabled: pageInputDisabled || disabled2
  }, selectItems), /* @__PURE__ */ React__default.createElement("span", {
    className: `${prefix2}--pagination__text`
  }, pageRangeText(page, totalPages))), /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--pagination__control-buttons`
  }, /* @__PURE__ */ React__default.createElement(IconButton, {
    align: "top",
    disabled: backButtonDisabled,
    kind: "ghost",
    className: backButtonClasses,
    label: backwardText,
    onClick: decrementPage,
    ref: backBtnRef
  }, _CaretLeft || (_CaretLeft = /* @__PURE__ */ React__default.createElement(CaretLeft, null))), /* @__PURE__ */ React__default.createElement(IconButton, {
    align: "top-right",
    disabled: forwardButtonDisabled || isLastPage,
    kind: "ghost",
    className: forwardButtonClasses,
    label: forwardText,
    onClick: incrementPage,
    ref: forwardBtnRef
  }, _CaretRight || (_CaretRight = /* @__PURE__ */ React__default.createElement(CaretRight, null))))));
});
Pagination.propTypes = {
  /**
   * The description for the backward icon.
   */
  backwardText: PropTypes.string,
  /**
   * The CSS class names.
   */
  className: PropTypes.string,
  /**
   * `true` if the backward/forward buttons, as well as the page select elements,  should be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * The description for the forward icon.
   */
  forwardText: PropTypes.string,
  /**
   * The unique ID of this component instance.
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // TODO: remove when v9 is deprecated
  /**
   * `true` if the current page should be the last page.
   */
  isLastPage: PropTypes.bool,
  /**
   * The function returning a translatable text showing where the current page is,
   * in a manner of the range of items.
   */
  itemRangeText: PropTypes.func,
  /**
   * A variant of `itemRangeText`, used if the total number of items is unknown.
   */
  itemText: PropTypes.func,
  /**
   * The translatable text indicating the number of items per page.
   */
  itemsPerPageText: PropTypes.string,
  /**
   * The callback function called when the current page changes.
   */
  onChange: PropTypes.func,
  /**
   * The current page.
   */
  page: PropTypes.number,
  /**
   * `true` if the select box to change the page should be disabled.
   */
  pageInputDisabled: PropTypes.bool,
  pageNumberText: PropTypes.string,
  /**
   * A function returning PII showing where the current page is.
   */
  pageRangeText: PropTypes.func,
  /**
   * The number dictating how many items a page contains.
   */
  pageSize: PropTypes.number,
  /**
   * `true` if the select box to change the items per page should be disabled.
   */
  pageSizeInputDisabled: PropTypes.bool,
  /**
   * The choices for `pageSize`.
   */
  pageSizes: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number.isRequired), PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }).isRequired)]).isRequired,
  /**
   * The translatable text showing the current page.
   */
  pageText: PropTypes.func,
  /**
   * `true` if the total number of items is unknown.
   */
  pagesUnknown: PropTypes.bool,
  /**
   * Specify the size of the Pagination.
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  /**
   * The total number of items.
   */
  totalItems: PropTypes.number
};
const rem = (px) => {
  return `${px / 16}rem`;
};
const breakpoints = {
  lg: {
    width: rem(1056)
  }
};
function useEffectOnce(callback) {
  const savedCallback = useRef(callback);
  const effectGuard = useRef(false);
  useEffect(() => {
    savedCallback.current = callback;
  });
  useEffect(() => {
    if (effectGuard.current !== true) {
      effectGuard.current = true;
      savedCallback.current();
    }
  }, []);
}
function usePressable(ref2) {
  let {
    onPress,
    onPressIn,
    onPressOut,
    onLongPress,
    delayLongPressMs = 500
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const savedOnPress = useRef(onPress);
  const savedOnPressIn = useRef(onPressIn);
  const savedOnPressOut = useRef(onPressOut);
  const savedOnLongPress = useRef(onLongPress);
  const [pendingLongPress, setPendingLongPress] = useState(false);
  const [longPress, setLongPress] = useState(false);
  const state = useRef({
    longPress: false
  });
  useEffect(() => {
    savedOnPress.current = onPress;
  }, [onPress]);
  useEffect(() => {
    savedOnPressIn.current = onPressIn;
  }, [onPressIn]);
  useEffect(() => {
    savedOnPressOut.current = onPressOut;
  }, [onPressOut]);
  useEffect(() => {
    savedOnLongPress.current = onLongPress;
  }, [onLongPress]);
  useEffect(() => {
    const {
      current: element
    } = ref2;
    function onPointerDown(event) {
      setPendingLongPress(true);
      savedOnPressIn.current?.();
      event.preventDefault();
    }
    function onPointerUp() {
      setPendingLongPress(false);
      setLongPress(false);
      savedOnPressOut.current?.(state.current);
    }
    function onPointerCancel() {
      setPendingLongPress(false);
      setLongPress(false);
      savedOnPressOut.current?.();
      state.current.longPress = false;
    }
    function onPointerLeave() {
      setPendingLongPress(false);
      setLongPress(false);
      savedOnPressOut.current?.();
      state.current.longPress = false;
    }
    function onClick() {
      setLongPress(false);
      setPendingLongPress(false);
      savedOnPress.current?.(state.current);
      state.current.longPress = false;
    }
    function onContextMenu(event) {
      event.preventDefault();
    }
    element.addEventListener("pointerdown", onPointerDown);
    element.addEventListener("pointerup", onPointerUp);
    element.addEventListener("pointercancel", onPointerCancel);
    element.addEventListener("pointerleave", onPointerLeave);
    element.addEventListener("click", onClick);
    element.addEventListener("contextmenu", onContextMenu);
    return () => {
      element.removeEventListener("pointerdown", onPointerDown);
      element.removeEventListener("pointerup", onPointerUp);
      element.removeEventListener("pointercancel", onPointerCancel);
      element.removeEventListener("pointerleave", onPointerLeave);
      element.removeEventListener("click", onClick);
      element.removeEventListener("contextmenu", onContextMenu);
    };
  }, [ref2]);
  useEffect(() => {
    if (pendingLongPress) {
      const timeoutId = setTimeout(() => {
        setPendingLongPress(false);
        setLongPress(true);
      }, delayLongPressMs);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [pendingLongPress, delayLongPressMs]);
  useEffect(() => {
    if (longPress) {
      state.current.longPress = true;
      return savedOnLongPress.current?.();
    }
  }, [longPress]);
}
function useMatchMedia(mediaQueryString) {
  const [matches2, setMatches] = useState(() => {
    if (canUseDOM) {
      const mediaQueryList = window.matchMedia(mediaQueryString);
      return mediaQueryList.matches;
    }
    return false;
  });
  useEffect(() => {
    function listener(event) {
      setMatches(event.matches);
    }
    const mediaQueryList = window.matchMedia(mediaQueryString);
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", listener);
    } else {
      mediaQueryList.addListener(listener);
    }
    setMatches(mediaQueryList.matches);
    return () => {
      if (mediaQueryList.addEventListener) {
        mediaQueryList.removeEventListener("change", listener);
      } else {
        mediaQueryList.removeListener(listener);
      }
    };
  }, [mediaQueryString]);
  return matches2;
}
var _ChevronLeft, _ChevronRight;
const TabsContext$1 = /* @__PURE__ */ React__default.createContext({
  baseId: "",
  activeIndex: 0,
  defaultSelectedIndex: 0,
  dismissable: false,
  onTabCloseRequest() {
  },
  setActiveIndex() {
  },
  selectedIndex: 0,
  setSelectedIndex() {
  }
});
const TabContext$1 = /* @__PURE__ */ React__default.createContext({
  index: 0,
  hasSecondaryLabel: false
});
const lgMediaQuery = `(min-width: ${breakpoints.lg.width})`;
const TabPanelContext$1 = /* @__PURE__ */ React__default.createContext(0);
function Tabs$1(_ref3) {
  let {
    children,
    defaultSelectedIndex = 0,
    onChange: onChange2,
    selectedIndex: controlledSelectedIndex,
    dismissable,
    onTabCloseRequest
  } = _ref3;
  const baseId = useId$1("ccs");
  const [activeIndex, setActiveIndex] = useState(defaultSelectedIndex);
  const [selectedIndex, setSelectedIndex] = useControllableState({
    value: controlledSelectedIndex,
    defaultValue: defaultSelectedIndex,
    onChange: (value3) => onChange2?.({
      selectedIndex: value3
    })
  });
  const value2 = {
    baseId,
    activeIndex,
    defaultSelectedIndex,
    dismissable,
    onTabCloseRequest,
    setActiveIndex,
    selectedIndex,
    setSelectedIndex
  };
  return /* @__PURE__ */ React__default.createElement(TabsContext$1.Provider, {
    value: value2
  }, children);
}
Tabs$1.propTypes = {
  /**
   * Provide child elements to be rendered inside the `Tabs`.
   * These elements should render either `TabsList` or `TabsPanels`
   */
  children: PropTypes.node,
  /**
   * Specify which content tab should be initially selected when the component
   * is first rendered
   */
  defaultSelectedIndex: PropTypes.number,
  /**
   * Whether the render Tab children should be dismissable.
   */
  dismissable: PropTypes.bool,
  /**
   * Provide an optional function which is called whenever the state of the
   * `Tabs` changes
   */
  onChange: PropTypes.func,
  /**
   * If specifying the `onTabCloseRequest` prop, provide a callback function
   * responsible for removing the tab when close button is pressed on one of the Tab elements
   */
  onTabCloseRequest: (props) => {
    if (props.dismissable && !props.onTabCloseRequest) {
      return new Error("dismissable property specified without also providing an onTabCloseRequest property.");
    }
    return void 0;
  },
  /**
   * Control which content panel is currently selected. This puts the component
   * in a controlled mode and should be used along with `onChange`
   */
  selectedIndex: PropTypes.number
};
function getNextIndex(event, total, index2) {
  switch (true) {
    case match$1(event, ArrowRight):
      return (index2 + 1) % total;
    case match$1(event, ArrowLeft):
      return (total + index2 - 1) % total;
    case match$1(event, Home):
      return 0;
    case match$1(event, End):
      return total - 1;
    default:
      return index2;
  }
}
function TabList$1(_ref22) {
  let {
    activation = "automatic",
    "aria-label": label2,
    children,
    className: customClassName,
    contained = false,
    fullWidth: fullWidth2 = false,
    iconSize,
    leftOverflowButtonProps,
    light,
    rightOverflowButtonProps,
    scrollDebounceWait = 200,
    scrollIntoView: scrollIntoView2,
    ...rest
  } = _ref22;
  const {
    activeIndex,
    selectedIndex,
    setSelectedIndex,
    setActiveIndex,
    dismissable
  } = React__default.useContext(TabsContext$1);
  const prefix2 = usePrefix();
  const ref2 = useRef(null);
  const previousButton = useRef(null);
  const nextButton = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [scrollLeft, setScrollLeft] = useState(0);
  let hasSecondaryLabelTabs = false;
  if (contained) {
    hasSecondaryLabelTabs = React__default.Children.toArray(children).some((child) => {
      return reactIsExports.isElement(child) && !!child.props.secondaryLabel;
    });
  }
  const isLg = useMatchMedia(lgMediaQuery);
  const distributeWidth = fullWidth2 && contained && isLg && React__default.Children.toArray(children).length < 9;
  const className = r(`${prefix2}--tabs`, {
    [`${prefix2}--tabs--contained`]: contained,
    [`${prefix2}--tabs--light`]: light,
    [`${prefix2}--tabs__icon--default`]: iconSize === "default",
    [`${prefix2}--tabs__icon--lg`]: iconSize === "lg",
    // TODO: V12 - Remove this class
    [`${prefix2}--layout--size-lg`]: iconSize === "lg",
    [`${prefix2}--tabs--tall`]: hasSecondaryLabelTabs,
    [`${prefix2}--tabs--full-width`]: distributeWidth,
    [`${prefix2}--tabs--dismissable`]: dismissable
  }, customClassName);
  const buttonWidth = 44;
  const [isNextButtonVisible, setIsNextButtonVisible] = useState(ref2.current ? scrollLeft + buttonWidth + ref2.current.clientWidth < ref2.current.scrollWidth : false);
  const isPreviousButtonVisible = ref2.current ? isScrollable && scrollLeft > 0 : false;
  const previousButtonClasses = r(`${prefix2}--tab--overflow-nav-button`, `${prefix2}--tab--overflow-nav-button--previous`, {
    [`${prefix2}--tab--overflow-nav-button--hidden`]: !isPreviousButtonVisible
  });
  const nextButtonClasses = r(`${prefix2}--tab--overflow-nav-button`, `${prefix2}--tab--overflow-nav-button--next`, {
    [`${prefix2}--tab--overflow-nav-button--hidden`]: !isNextButtonVisible
  });
  const tabs = useRef([]);
  const debouncedOnScroll = useCallback(() => {
    return debounce$1((event) => {
      setScrollLeft(event.target.scrollLeft);
    }, scrollDebounceWait);
  }, [scrollDebounceWait]);
  function onKeyDown(event) {
    if (matches$1(event, [ArrowRight, ArrowLeft, Home, End])) {
      event.preventDefault();
      const filtredTabs = tabs.current.filter((tab2) => tab2 !== null);
      const activeTabs = filtredTabs.filter((tab2) => !tab2.disabled);
      const currentIndex = activeTabs.indexOf(tabs.current[activation === "automatic" ? selectedIndex : activeIndex]);
      const nextIndex = tabs.current.indexOf(activeTabs[getNextIndex(event, activeTabs.length, currentIndex)]);
      if (activation === "automatic") {
        setSelectedIndex(nextIndex);
      } else if (activation === "manual") {
        setActiveIndex(nextIndex);
      }
      tabs.current[nextIndex]?.focus();
    }
  }
  useEffectOnce(() => {
    const tab2 = tabs.current[selectedIndex];
    if (scrollIntoView2 && tab2) {
      tab2.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    }
  });
  useEffect(() => {
    setIsNextButtonVisible(ref2.current ? scrollLeft + buttonWidth + ref2.current.clientWidth < ref2.current.scrollWidth : false);
    if (dismissable) {
      if (ref2.current) {
        setIsScrollable(ref2.current.scrollWidth > ref2.current.clientWidth);
      }
    }
  }, [scrollLeft, children, dismissable]);
  useEffectOnce(() => {
    if (tabs.current[selectedIndex]?.disabled) {
      const activeTabs = tabs.current.filter((tab2) => {
        return !tab2.disabled;
      });
      if (activeTabs.length > 0) {
        const tab2 = activeTabs[0];
        setSelectedIndex(tabs.current.indexOf(tab2));
      }
    }
  });
  useIsomorphicEffect$1(() => {
    if (ref2.current) {
      setIsScrollable(ref2.current.scrollWidth > ref2.current.clientWidth);
    }
    function handler() {
      if (ref2.current) {
        setIsScrollable(ref2.current.scrollWidth > ref2.current.clientWidth);
      }
    }
    const debouncedHandler = debounce$1(handler, 200);
    window.addEventListener("resize", debouncedHandler);
    return () => {
      debouncedHandler.cancel();
      window.removeEventListener("resize", debouncedHandler);
    };
  }, []);
  useIsomorphicEffect$1(() => {
    if (scrollLeft !== null && ref2.current) {
      ref2.current.scrollLeft = scrollLeft;
    }
  }, [scrollLeft]);
  useIsomorphicEffect$1(() => {
    if (!isScrollable || !ref2.current) {
      return;
    }
    const tab2 = activation === "manual" ? tabs.current[activeIndex] : tabs.current[selectedIndex];
    if (tab2) {
      const {
        width: tabWidth
      } = tab2.getBoundingClientRect();
      const start2 = tab2.offsetLeft;
      const end2 = tab2.offsetLeft + tabWidth;
      const visibleStart = ref2.current.scrollLeft + buttonWidth;
      const visibleEnd = ref2.current.scrollLeft + ref2.current.clientWidth - buttonWidth;
      if (start2 < visibleStart) {
        setScrollLeft(start2 - buttonWidth);
      }
      if (end2 > visibleEnd) {
        setScrollLeft(end2 + buttonWidth - ref2.current.clientWidth);
      }
    }
  }, [activation, activeIndex, selectedIndex, isScrollable, children]);
  usePressable(previousButton, {
    onPress(_ref3) {
      let {
        longPress
      } = _ref3;
      if (!longPress && ref2.current) {
        setScrollLeft(Math.max(scrollLeft - ref2.current.scrollWidth / tabs.current.length * 1.5, 0));
      }
    },
    onLongPress() {
      return createLongPressBehavior(ref2, "backward", setScrollLeft);
    }
  });
  usePressable(nextButton, {
    onPress(_ref4) {
      let {
        longPress
      } = _ref4;
      if (!longPress && ref2.current) {
        setScrollLeft(Math.min(scrollLeft + ref2.current.scrollWidth / tabs.current.length * 1.5, ref2.current.scrollWidth - ref2.current.clientWidth));
      }
    },
    onLongPress() {
      return createLongPressBehavior(ref2, "forward", setScrollLeft);
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className
  }, /* @__PURE__ */ React__default.createElement("button", _extends({
    "aria-hidden": "true",
    tabIndex: -1,
    "aria-label": "Scroll left",
    ref: previousButton,
    className: previousButtonClasses,
    type: "button"
  }, leftOverflowButtonProps), _ChevronLeft || (_ChevronLeft = /* @__PURE__ */ React__default.createElement(ChevronLeft, null))), /* @__PURE__ */ React__default.createElement("div", _extends({}, rest, {
    "aria-label": label2,
    ref: ref2,
    role: "tablist",
    className: `${prefix2}--tab--list`,
    onScroll: debouncedOnScroll,
    onKeyDown
  }), React__default.Children.map(children, (child, index2) => {
    return !reactIsExports.isElement(child) ? null : /* @__PURE__ */ React__default.createElement(TabContext$1.Provider, {
      value: {
        index: index2,
        hasSecondaryLabel: hasSecondaryLabelTabs,
        contained
      }
    }, /* @__PURE__ */ React__default.cloneElement(child, {
      ref: (node2) => {
        tabs.current[index2] = node2;
      }
    }));
  })), /* @__PURE__ */ React__default.createElement("button", _extends({
    "aria-hidden": "true",
    tabIndex: -1,
    "aria-label": "Scroll right",
    ref: nextButton,
    className: nextButtonClasses,
    type: "button"
  }, rightOverflowButtonProps), _ChevronRight || (_ChevronRight = /* @__PURE__ */ React__default.createElement(ChevronRight, null))));
}
TabList$1.propTypes = {
  /**
   * Specify whether the content tab should be activated automatically or
   * manually
   */
  activation: PropTypes.oneOf(["automatic", "manual"]),
  /**
   * Provide an accessible label to be read when a user interacts with this
   * component
   */
  "aria-label": PropTypes.string.isRequired,
  /**
   * Provide child elements to be rendered inside `ContentTabs`.
   * These elements should render a `ContentTab`
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to the container node
   */
  className: PropTypes.string,
  /**
   * Specify whether component is contained type
   */
  contained: PropTypes.bool,
  /**
   * Used for tabs within a grid, this makes it so tabs span the full container width and have the same width. Only available on contained tabs with <9 children
   */
  fullWidth: PropTypes.bool,
  /**
   * If using `IconTab`, specify the size of the icon being used.
   */
  iconSize: PropTypes.oneOf(["default", "lg"]),
  /**
   * Provide the props that describe the left overflow button
   */
  leftOverflowButtonProps: PropTypes.object,
  /**
   * Specify whether to use the light component variant
   */
  light: deprecate(PropTypes.bool),
  /**
   * Provide the props that describe the right overflow button
   */
  rightOverflowButtonProps: PropTypes.object,
  /**
   * Optionally provide a delay (in milliseconds) passed to the lodash
   * debounce of the onScroll handler. This will impact the responsiveness
   * of scroll arrow buttons rendering when scrolling to the first or last tab.
   */
  scrollDebounceWait: PropTypes.number,
  /**
   * Choose whether to automatically scroll
   * to newly selected tabs on component rerender
   */
  scrollIntoView: PropTypes.bool
};
function createLongPressBehavior(ref2, direction, setScrollLeft) {
  const node2 = ref2.current;
  if (!node2) {
    return () => {
    };
  }
  const defaultScrollBehavior = node2?.style["scroll-behavior"];
  node2.style["scroll-behavior"] = "auto";
  const scrollDelta = direction === "forward" ? 5 : -5;
  let frameId = null;
  function tick() {
    if (!node2) {
      return;
    }
    node2.scrollLeft = node2.scrollLeft + scrollDelta;
    frameId = requestAnimationFrame(tick);
  }
  frameId = requestAnimationFrame(tick);
  return () => {
    node2.style["scroll-behavior"] = defaultScrollBehavior;
    setScrollLeft(node2.scrollLeft);
    if (frameId) {
      cancelAnimationFrame(frameId);
    }
  };
}
const Tab$2 = /* @__PURE__ */ forwardRef(function Tab(_ref5, forwardRef2) {
  let {
    as = "button",
    children,
    className: customClassName,
    disabled: disabled2,
    onClick,
    onKeyDown,
    secondaryLabel,
    renderIcon: Icon3,
    ...rest
  } = _ref5;
  const prefix2 = usePrefix();
  const {
    selectedIndex,
    setSelectedIndex,
    baseId,
    dismissable,
    onTabCloseRequest
  } = React__default.useContext(TabsContext$1);
  const {
    index: index2,
    hasSecondaryLabel,
    contained
  } = React__default.useContext(TabContext$1);
  const dismissIconRef = useRef(null);
  const tabRef = useRef(null);
  const ref2 = useMergedRefs([forwardRef2, tabRef]);
  const [ignoreHover, setIgnoreHover] = useState(false);
  const id = `${baseId}-tab-${index2}`;
  const panelId = `${baseId}-tabpanel-${index2}`;
  const className = r(`${prefix2}--tabs__nav-item`, `${prefix2}--tabs__nav-link`, {
    [`${prefix2}--tabs__nav-item--selected`]: selectedIndex === index2,
    [`${prefix2}--tabs__nav-item--disabled`]: disabled2,
    [`${prefix2}--tabs__nav-item--hover-off`]: ignoreHover
  }, customClassName);
  const BaseComponent = as;
  const onDismissIconMouseEnter = (evt) => {
    if (contained && tabRef.current) {
      evt.stopPropagation();
      setIgnoreHover(true);
      tabRef.current.classList.add(`${prefix2}--tabs__nav-item--hover-off`);
    }
  };
  const onDismissIconMouseLeave = () => {
    if (contained && tabRef.current) {
      tabRef.current.classList.remove(`${prefix2}--tabs__nav-item--hover-off`);
      setIgnoreHover(false);
    }
  };
  useEvent$1(dismissIconRef, "mouseover", onDismissIconMouseEnter);
  useEvent$1(dismissIconRef, "mouseleave", onDismissIconMouseLeave);
  const handleClose = (evt) => {
    evt.stopPropagation();
    onTabCloseRequest?.(index2);
    if (tabRef.current && tabRef.current.parentElement) {
      const tabCount = Array.from(tabRef.current.parentElement.childNodes).filter((node2) => {
        const element = node2;
        return element.classList.contains("cds--tabs__nav-link") && !element.classList.contains("cds--tabs__nav-item--disabled");
      }).length;
      if (tabRef.current && index2 + 1 !== tabCount) {
        tabRef.current.focus();
      } else {
        const prevTabIndex = (tabCount - 2) * 2;
        tabRef.current.parentElement.childNodes[prevTabIndex]?.focus();
      }
    }
  };
  const handleKeyDown = (event) => {
    if (dismissable && match$1(event, Delete)) {
      handleClose(event);
    }
    onKeyDown?.(event);
  };
  const DismissIcon2 = /* @__PURE__ */ React__default.createElement("div", {
    className: r({
      [`${prefix2}--tabs__nav-item--close`]: dismissable,
      [`${prefix2}--tabs__nav-item--close--hidden`]: !dismissable
    })
  }, /* @__PURE__ */ React__default.createElement("button", {
    type: "button",
    tabIndex: selectedIndex === index2 && dismissable ? 0 : -1,
    "aria-disabled": disabled2,
    "aria-hidden": selectedIndex === index2 && dismissable ? "false" : "true",
    disabled: disabled2,
    className: r({
      [`${prefix2}--tabs__nav-item--close-icon`]: dismissable,
      [`${prefix2}--visually-hidden`]: !dismissable,
      [`${prefix2}--tabs__nav-item--close-icon--selected`]: selectedIndex === index2,
      [`${prefix2}--tabs__nav-item--close-icon--disabled`]: disabled2
    }),
    onClick: handleClose,
    title: `Remove ${typeof children === "string" ? children : ""} tab`,
    ref: dismissIconRef
  }, /* @__PURE__ */ React__default.createElement(Close, {
    "aria-hidden": selectedIndex === index2 && dismissable ? "false" : "true",
    "aria-label": `Press delete to remove ${typeof children === "string" ? children : ""} tab`
  })));
  const hasIcon = Icon3 ?? dismissable;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(BaseComponent, _extends({}, rest, {
    "aria-controls": panelId,
    "aria-disabled": disabled2,
    "aria-selected": selectedIndex === index2,
    ref: ref2,
    id,
    role: "tab",
    className,
    disabled: disabled2,
    onClick: (evt) => {
      if (disabled2) {
        return;
      }
      setSelectedIndex(index2);
      onClick?.(evt);
    },
    onKeyDown: handleKeyDown,
    tabIndex: selectedIndex === index2 ? "0" : "-1",
    type: "button"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--tabs__nav-item-label-wrapper`
  }, dismissable && Icon3 && /* @__PURE__ */ React__default.createElement("div", {
    className: `${prefix2}--tabs__nav-item--icon-left`
  }, /* @__PURE__ */ React__default.createElement(Icon3, {
    size: 16
  })), /* @__PURE__ */ React__default.createElement(Text, {
    className: `${prefix2}--tabs__nav-item-label`
  }, children), !dismissable && Icon3 && /* @__PURE__ */ React__default.createElement("div", {
    className: r(`${prefix2}--tabs__nav-item--icon`, {
      [`${prefix2}--visually-hidden`]: !hasIcon
    })
  }, !dismissable && Icon3 && /* @__PURE__ */ React__default.createElement(Icon3, {
    size: 16
  }))), hasSecondaryLabel && secondaryLabel && /* @__PURE__ */ React__default.createElement(Text, {
    as: "div",
    className: `${prefix2}--tabs__nav-item-secondary-label`,
    title: secondaryLabel
  }, secondaryLabel)), DismissIcon2);
});
Tab$2.propTypes = {
  /**
   * Provide a custom element to render instead of the default button
   */
  // @ts-expect-error: Invalid prop type derivation
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /**
   * Provide child elements to be rendered inside `Tab`.
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to your Tab
   */
  className: PropTypes.string,
  /**
   * Whether your Tab is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Provide a handler that is invoked when a user clicks on the control
   */
  onClick: PropTypes.func,
  /**
   * Provide a handler that is invoked on the key down event for the control
   */
  onKeyDown: PropTypes.func,
  /*
   * An optional parameter to allow overriding the anchor rendering.
   * Useful for using Tab along with react-router or other client
   * side router libraries.
   **/
  renderButton: PropTypes.func,
  /**
   * Optional prop to render an icon next to the label.
   * Can be a React component class
   */
  // @ts-expect-error: Invalid prop type derivation
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /*
   * An optional label to render under the primary tab label.
  /* This prop is only useful for conained tabs
   **/
  secondaryLabel: PropTypes.string
};
const IconTab = /* @__PURE__ */ React__default.forwardRef(function IconTab2(_ref6, ref2) {
  let {
    children,
    className: customClassName,
    defaultOpen = false,
    enterDelayMs,
    leaveDelayMs,
    label: label2,
    ...rest
  } = _ref6;
  const prefix2 = usePrefix();
  const classNames2 = r(`${prefix2}--tabs__nav-item--icon-only`, customClassName);
  return /* @__PURE__ */ React__default.createElement(Tooltip$2, {
    align: "bottom",
    defaultOpen,
    className: `${prefix2}--icon-tooltip`,
    enterDelayMs,
    label: label2,
    leaveDelayMs
  }, /* @__PURE__ */ React__default.createElement(Tab$2, _extends({
    className: classNames2,
    ref: ref2
  }, rest), children));
});
IconTab.propTypes = {
  /**
   * Provide an icon to be rendered inside `IconTab` as the visual label for Tab.
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to your Tab
   */
  className: PropTypes.string,
  /**
   * Specify whether the tooltip for the icon should be open when it first renders
   */
  defaultOpen: PropTypes.bool,
  /**
   * Specify the duration in milliseconds to delay before displaying the tooltip for the icon.
   */
  enterDelayMs: PropTypes.number,
  /**
   * Provide the label to be rendered inside the Tooltip. The label will use
   * `aria-labelledby` and will fully describe the child node that is provided.
   * This means that if you have text in the child node it will not be
   * announced to the screen reader.
   */
  label: PropTypes.node.isRequired,
  /**
   * Specify the duration in milliseconds to delay before hiding the tooltip
   */
  leaveDelayMs: PropTypes.number
};
const TabPanel$1 = /* @__PURE__ */ React__default.forwardRef(function TabPanel(_ref7, forwardRef2) {
  let {
    children,
    className: customClassName,
    ...rest
  } = _ref7;
  const prefix2 = usePrefix();
  const panel2 = useRef(null);
  const ref2 = useMergedRefs([forwardRef2, panel2]);
  const [tabIndex, setTabIndex] = useState(0);
  const [interactiveContent, setInteractiveContent] = useState(false);
  const {
    selectedIndex,
    baseId
  } = React__default.useContext(TabsContext$1);
  const index2 = React__default.useContext(TabPanelContext$1);
  const id = `${baseId}-tabpanel-${index2}`;
  const tabId = `${baseId}-tab-${index2}`;
  const className = r(`${prefix2}--tab-content`, customClassName, {
    [`${prefix2}--tab-content--interactive`]: interactiveContent
  });
  useEffectOnce(() => {
    if (!panel2.current) {
      return;
    }
    const content2 = getInteractiveContent(panel2.current);
    if (content2) {
      setInteractiveContent(true);
      setTabIndex(-1);
    }
  });
  useEffect(() => {
    const node2 = panel2.current;
    if (!node2) {
      return;
    }
    function callback() {
      const content2 = getInteractiveContent(node2);
      if (content2) {
        setInteractiveContent(true);
        setTabIndex(-1);
      } else {
        setInteractiveContent(false);
        setTabIndex(0);
      }
    }
    const observer = new MutationObserver(callback);
    observer.observe(node2, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  return /* @__PURE__ */ React__default.createElement("div", _extends({}, rest, {
    "aria-labelledby": tabId,
    id,
    className,
    ref: ref2,
    role: "tabpanel",
    tabIndex,
    hidden: selectedIndex !== index2
  }), children);
});
TabPanel$1.propTypes = {
  /**
   * Provide child elements to be rendered inside `TabPanel`.
   */
  children: PropTypes.node,
  /**
   * Specify an optional className to be added to TabPanel.
   */
  className: PropTypes.string
};
function TabPanels$1(_ref8) {
  let {
    children
  } = _ref8;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, (child, index2) => {
    return /* @__PURE__ */ React__default.createElement(TabPanelContext$1.Provider, {
      value: index2
    }, child);
  }));
}
TabPanels$1.propTypes = {
  /**
   * Provide child elements to be rendered inside `TabPanels`.
   */
  children: PropTypes.node
};
function NavLink({
  children,
  to,
  direction,
  active: active2 = false,
  disabled: disabled2 = false,
  ariaLabel,
  className,
  ...rest
}) {
  const url = disabled2 ? void 0 : to;
  return /* @__PURE__ */ jsxs(
    Link,
    {
      href: url,
      "aria-label": ariaLabel,
      className: clsx(
        styles$v.container,
        active2 ? styles$v.activatedLink : "",
        disabled2 ? styles$v.disabledLink : "",
        className
      ),
      ...rest,
      children: [
        direction === "backward" && /* @__PURE__ */ jsx$1(Arrow, { direction: "left" }),
        /* @__PURE__ */ jsx$1("div", { className: styles$v.linkContainer, children }),
        direction === "forward" && /* @__PURE__ */ jsx$1(Arrow, { direction: "right" })
      ]
    }
  );
}
let e = { data: "" }, t = (t3) => {
  if ("object" == typeof window) {
    let e3 = (t3 ? t3.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), { innerHTML: " ", id: "_goober" });
    return e3.nonce = window.__nonce__, e3.parentNode || (t3 || document.head).appendChild(e3), e3.firstChild;
  }
  return t3 || e;
}, a = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, l = /\/\*[^]*?\*\/|  +/g, n$1 = /\n+/g, o = (e3, t3) => {
  let r2 = "", a4 = "", l2 = "";
  for (let n2 in e3) {
    let c3 = e3[n2];
    "@" == n2[0] ? "i" == n2[1] ? r2 = n2 + " " + c3 + ";" : a4 += "f" == n2[1] ? o(c3, n2) : n2 + "{" + o(c3, "k" == n2[1] ? "" : t3) + "}" : "object" == typeof c3 ? a4 += o(c3, t3 ? t3.replace(/([^,])+/g, (e4) => n2.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t4) => /&/.test(t4) ? t4.replace(/&/g, e4) : e4 ? e4 + " " + t4 : t4)) : n2) : null != c3 && (n2 = "-" == n2[1] ? n2 : n2.replace(/[A-Z]/g, "-$&").toLowerCase(), l2 += o.p ? o.p(n2, c3) : n2 + ":" + c3 + ";");
  }
  return r2 + (t3 && l2 ? t3 + "{" + l2 + "}" : l2) + a4;
}, c = {}, i = (e3) => {
  if ("object" == typeof e3) {
    let t3 = "";
    for (let r2 in e3) t3 += r2 + i(e3[r2]);
    return t3;
  }
  return e3;
}, s = (e3, t3, r2, s4, p2) => {
  let u3 = i(e3), d4 = c[u3] || (c[u3] = ((e4) => {
    let t4 = 0, r3 = 11;
    for (; t4 < e4.length; ) r3 = 101 * r3 + e4.charCodeAt(t4++) >>> 0;
    return "go" + r3;
  })(u3));
  if (!c[d4]) {
    let t4 = u3 !== e3 ? e3 : ((e4) => {
      let t5, r3, o2 = [{}];
      for (; t5 = a.exec(e4.replace(l, "")); ) t5[4] ? o2.shift() : t5[3] ? (r3 = t5[3].replace(n$1, " ").trim(), o2.unshift(o2[0][r3] = o2[0][r3] || {})) : o2[0][t5[1]] = t5[2].replace(n$1, " ").trim();
      return o2[0];
    })(e3);
    c[d4] = o(p2 ? { ["@keyframes " + d4]: t4 } : t4, r2 ? "" : "." + d4);
  }
  let f2 = r2 && c.g;
  return r2 && (c.g = c[d4]), ((e4, t4, r3, a4) => {
    a4 ? t4.data = t4.data.replace(a4, e4) : -1 === t4.data.indexOf(e4) && (t4.data = r3 ? e4 + t4.data : t4.data + e4);
  })(c[d4], t3, s4, f2), d4;
}, p = (e3, t3, r2) => e3.reduce((e4, a4, l2) => {
  let n2 = t3[l2];
  if (n2 && n2.call) {
    let e5 = n2(r2), t4 = e5 && e5.props && e5.props.className || /^go/.test(e5) && e5;
    n2 = t4 ? "." + t4 : e5 && "object" == typeof e5 ? e5.props ? "" : o(e5, "") : false === e5 ? "" : e5;
  }
  return e4 + a4 + (null == n2 ? "" : n2);
}, "");
function u$1(e3) {
  let r2 = this || {}, a4 = e3.call ? e3(r2.p) : e3;
  return s(a4.unshift ? a4.raw ? p(a4, [].slice.call(arguments, 1), r2.p) : a4.reduce((e4, t3) => Object.assign(e4, t3 && t3.call ? t3(r2.p) : t3), {}) : a4, t(r2.target), r2.g, r2.o, r2.k);
}
let d, f, g;
u$1.bind({ g: 1 });
let h$1 = u$1.bind({ k: 1 });
function m(e3, t3, r2, a4) {
  o.p = t3, d = e3, f = r2, g = a4;
}
function w$1(e3, t3) {
  let r2 = this || {};
  return function() {
    let a4 = arguments;
    function l2(n2, o2) {
      let c3 = Object.assign({}, n2), i3 = c3.className || l2.className;
      r2.p = Object.assign({ theme: f && f() }, c3), r2.o = /go\d/.test(i3), c3.className = u$1.apply(r2, a4) + (i3 ? " " + i3 : "");
      let s4 = e3;
      return e3[0] && (s4 = c3.as || e3, delete c3.as), g && s4[0] && g(c3), d(s4, c3);
    }
    return l2;
  };
}
var W = (e3) => typeof e3 == "function", T = (e3, t3) => W(e3) ? e3(t3) : e3;
var U = /* @__PURE__ */ (() => {
  let e3 = 0;
  return () => (++e3).toString();
})(), b = /* @__PURE__ */ (() => {
  let e3;
  return () => {
    if (e3 === void 0 && typeof window < "u") {
      let t3 = matchMedia("(prefers-reduced-motion: reduce)");
      e3 = !t3 || t3.matches;
    }
    return e3;
  };
})();
var Q = 20;
var S = /* @__PURE__ */ new Map(), X = 1e3, $ = (e3) => {
  if (S.has(e3)) return;
  let t3 = setTimeout(() => {
    S.delete(e3), u({ type: 4, toastId: e3 });
  }, X);
  S.set(e3, t3);
}, J = (e3) => {
  let t3 = S.get(e3);
  t3 && clearTimeout(t3);
}, v = (e3, t3) => {
  switch (t3.type) {
    case 0:
      return { ...e3, toasts: [t3.toast, ...e3.toasts].slice(0, Q) };
    case 1:
      return t3.toast.id && J(t3.toast.id), { ...e3, toasts: e3.toasts.map((r2) => r2.id === t3.toast.id ? { ...r2, ...t3.toast } : r2) };
    case 2:
      let { toast: o2 } = t3;
      return e3.toasts.find((r2) => r2.id === o2.id) ? v(e3, { type: 1, toast: o2 }) : v(e3, { type: 0, toast: o2 });
    case 3:
      let { toastId: s4 } = t3;
      return s4 ? $(s4) : e3.toasts.forEach((r2) => {
        $(r2.id);
      }), { ...e3, toasts: e3.toasts.map((r2) => r2.id === s4 || s4 === void 0 ? { ...r2, visible: false } : r2) };
    case 4:
      return t3.toastId === void 0 ? { ...e3, toasts: [] } : { ...e3, toasts: e3.toasts.filter((r2) => r2.id !== t3.toastId) };
    case 5:
      return { ...e3, pausedAt: t3.time };
    case 6:
      let a4 = t3.time - (e3.pausedAt || 0);
      return { ...e3, pausedAt: void 0, toasts: e3.toasts.map((r2) => ({ ...r2, pauseDuration: r2.pauseDuration + a4 })) };
  }
}, A = [], P = { toasts: [], pausedAt: void 0 }, u = (e3) => {
  P = v(P, e3), A.forEach((t3) => {
    t3(P);
  });
}, Y = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, I = (e3 = {}) => {
  let [t3, o2] = useState(P);
  useEffect(() => (A.push(o2), () => {
    let a4 = A.indexOf(o2);
    a4 > -1 && A.splice(a4, 1);
  }), [t3]);
  let s4 = t3.toasts.map((a4) => {
    var r2, c3;
    return { ...e3, ...e3[a4.type], ...a4, duration: a4.duration || ((r2 = e3[a4.type]) == null ? void 0 : r2.duration) || (e3 == null ? void 0 : e3.duration) || Y[a4.type], style: { ...e3.style, ...(c3 = e3[a4.type]) == null ? void 0 : c3.style, ...a4.style } };
  });
  return { ...t3, toasts: s4 };
};
var G = (e3, t3 = "blank", o2) => ({ createdAt: Date.now(), visible: true, type: t3, ariaProps: { role: "status", "aria-live": "polite" }, message: e3, pauseDuration: 0, ...o2, id: (o2 == null ? void 0 : o2.id) || U() }), h = (e3) => (t3, o2) => {
  let s4 = G(t3, e3, o2);
  return u({ type: 2, toast: s4 }), s4.id;
}, n = (e3, t3) => h("blank")(e3, t3);
n.error = h("error");
n.success = h("success");
n.loading = h("loading");
n.custom = h("custom");
n.dismiss = (e3) => {
  u({ type: 3, toastId: e3 });
};
n.remove = (e3) => u({ type: 4, toastId: e3 });
n.promise = (e3, t3, o2) => {
  let s4 = n.loading(t3.loading, { ...o2, ...o2 == null ? void 0 : o2.loading });
  return e3.then((a4) => (n.success(T(t3.success, a4), { id: s4, ...o2, ...o2 == null ? void 0 : o2.success }), a4)).catch((a4) => {
    n.error(T(t3.error, a4), { id: s4, ...o2, ...o2 == null ? void 0 : o2.error });
  }), e3;
};
var Z = (e3, t3) => {
  u({ type: 1, toast: { id: e3, height: t3 } });
}, ee = () => {
  u({ type: 5, time: Date.now() });
}, D = (e3) => {
  let { toasts: t3, pausedAt: o2 } = I(e3);
  useEffect(() => {
    if (o2) return;
    let r2 = Date.now(), c3 = t3.map((i3) => {
      if (i3.duration === 1 / 0) return;
      let d4 = (i3.duration || 0) + i3.pauseDuration - (r2 - i3.createdAt);
      if (d4 < 0) {
        i3.visible && n.dismiss(i3.id);
        return;
      }
      return setTimeout(() => n.dismiss(i3.id), d4);
    });
    return () => {
      c3.forEach((i3) => i3 && clearTimeout(i3));
    };
  }, [t3, o2]);
  let s4 = useCallback(() => {
    o2 && u({ type: 6, time: Date.now() });
  }, [o2]), a4 = useCallback((r2, c3) => {
    let { reverseOrder: i3 = false, gutter: d4 = 8, defaultPosition: p2 } = c3 || {}, g2 = t3.filter((m4) => (m4.position || p2) === (r2.position || p2) && m4.height), E3 = g2.findIndex((m4) => m4.id === r2.id), x3 = g2.filter((m4, R3) => R3 < E3 && m4.visible).length;
    return g2.filter((m4) => m4.visible).slice(...i3 ? [x3 + 1] : [0, x3]).reduce((m4, R3) => m4 + (R3.height || 0) + d4, 0);
  }, [t3]);
  return { toasts: t3, handlers: { updateHeight: Z, startPause: ee, endPause: s4, calculateOffset: a4 } };
};
var oe = h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, re = h$1`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, se = h$1`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, _ = w$1("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e3) => e3.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e3) => e3.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var ne = h$1`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, V = w$1("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e3) => e3.secondary || "#e0e0e0"};
  border-right-color: ${(e3) => e3.primary || "#616161"};
  animation: ${ne} 1s linear infinite;
`;
var pe = h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, de$1 = h$1`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, w = w$1("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e3) => e3.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${de$1} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e3) => e3.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var ue$1 = w$1("div")`
  position: absolute;
`, le$1 = w$1("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, Te$1 = h$1`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, fe$1 = w$1("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Te$1} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, M = ({ toast: e3 }) => {
  let { icon: t3, type: o2, iconTheme: s4 } = e3;
  return t3 !== void 0 ? typeof t3 == "string" ? React.createElement(fe$1, null, t3) : t3 : o2 === "blank" ? null : React.createElement(le$1, null, React.createElement(V, { ...s4 }), o2 !== "loading" && React.createElement(ue$1, null, o2 === "error" ? React.createElement(_, { ...s4 }) : React.createElement(w, { ...s4 })));
};
var ye$1 = (e3) => `
0% {transform: translate3d(0,${e3 * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, ge$1 = (e3) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e3 * -150}%,-1px) scale(.6); opacity:0;}
`, he$1 = "0%{opacity:0;} 100%{opacity:1;}", xe$1 = "0%{opacity:1;} 100%{opacity:0;}", be$1 = w$1("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Se$1 = w$1("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Ae$1 = (e3, t3) => {
  let s4 = e3.includes("top") ? 1 : -1, [a4, r2] = b() ? [he$1, xe$1] : [ye$1(s4), ge$1(s4)];
  return { animation: t3 ? `${h$1(a4)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${h$1(r2)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, F = React.memo(({ toast: e3, position: t3, style: o2, children: s4 }) => {
  let a4 = e3.height ? Ae$1(e3.position || t3 || "top-center", e3.visible) : { opacity: 0 }, r2 = React.createElement(M, { toast: e3 }), c3 = React.createElement(Se$1, { ...e3.ariaProps }, T(e3.message, e3));
  return React.createElement(be$1, { className: e3.className, style: { ...a4, ...o2, ...e3.style } }, typeof s4 == "function" ? s4({ icon: r2, message: c3 }) : React.createElement(React.Fragment, null, r2, c3));
});
m(React.createElement);
var Ee$1 = ({ id: e3, className: t3, style: o2, onHeightUpdate: s4, children: a4 }) => {
  let r2 = React.useCallback((c3) => {
    if (c3) {
      let i3 = () => {
        let d4 = c3.getBoundingClientRect().height;
        s4(e3, d4);
      };
      i3(), new MutationObserver(i3).observe(c3, { subtree: true, childList: true, characterData: true });
    }
  }, [e3, s4]);
  return React.createElement("div", { ref: r2, className: t3, style: o2 }, a4);
}, Re$1 = (e3, t3) => {
  let o2 = e3.includes("top"), s4 = o2 ? { top: 0 } : { bottom: 0 }, a4 = e3.includes("center") ? { justifyContent: "center" } : e3.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: b() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t3 * (o2 ? 1 : -1)}px)`, ...s4, ...a4 };
}, ve$1 = u$1`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, O = 16, Ie$1 = ({ reverseOrder: e3, position: t3 = "top-center", toastOptions: o2, gutter: s4, children: a4, containerStyle: r2, containerClassName: c3 }) => {
  let { toasts: i3, handlers: d4 } = D(o2);
  return React.createElement("div", { style: { position: "fixed", zIndex: 9999, top: O, left: O, right: O, bottom: O, pointerEvents: "none", ...r2 }, className: c3, onMouseEnter: d4.startPause, onMouseLeave: d4.endPause }, i3.map((p2) => {
    let g2 = p2.position || t3, E3 = d4.calculateOffset(p2, { reverseOrder: e3, gutter: s4, defaultPosition: t3 }), x3 = Re$1(g2, E3);
    return React.createElement(Ee$1, { id: p2.id, key: p2.id, onHeightUpdate: d4.updateHeight, className: p2.visible ? ve$1 : "", style: x3 }, p2.type === "custom" ? T(p2.message, p2) : a4 ? a4(p2) : React.createElement(F, { toast: p2, position: g2 }));
  }));
};
const CheckCircleIcon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2100_55239)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
            fill: "#007A6A"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2100_55239", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "white"
          }
        ) }) })
      ]
    }
  );
};
const ErrorIcon$1 = () => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17ZM13 7H11V14H13V7Z",
          fill: "#D71717"
        }
      )
    }
  );
};
const InfoCircleIcon = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2100_55236)", children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM14 17H10V15H11V13H10V11H11H13V15H14V17ZM13 9H11V7H13V9Z",
          fill: "#006FBF"
        }
      ) }),
      /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2100_55236", children: /* @__PURE__ */ jsx$1(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white"
        }
      ) }) })
    ]
  }
);
const WarningIcon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2100_55227)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
            fill: "#C4811D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2100_55227", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "white"
          }
        ) }) })
      ]
    }
  );
};
const notificationBody = "notification-body-module_notificationBody__yhJBZ";
const header$4 = "notification-body-module_header__OdaRC";
const closeIconWrapper = "notification-body-module_closeIconWrapper__mdNoJ";
const closeIcon = "notification-body-module_closeIcon__VVn30";
const content$4 = "notification-body-module_content__le2Jm";
const styles$u = {
  notificationBody,
  header: header$4,
  closeIconWrapper,
  closeIcon,
  content: content$4
};
const CloseIcon = ({ className, onClick }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    onClick,
    children: [
      /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2109_56777)", children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z",
          fill: "#00204D"
        }
      ) }),
      /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2109_56777", children: /* @__PURE__ */ jsx$1(
        "rect",
        {
          width: "12",
          height: "12",
          fill: "white"
        }
      ) }) })
    ]
  }
);
const NotificationBody = ({
  title: title2,
  content: content2,
  dismissable = true,
  onDismiss
}) => {
  return /* @__PURE__ */ jsxs("div", { className: styles$u.notificationBody, children: [
    title2 && /* @__PURE__ */ jsxs("div", { className: styles$u.header, children: [
      title2,
      /* @__PURE__ */ jsx$1("div", { className: styles$u.closeIconWrapper, children: dismissable && /* @__PURE__ */ jsx$1(
        CloseIcon,
        {
          className: styles$u.closeIcon,
          onClick: () => onDismiss && onDismiss()
        }
      ) })
    ] }),
    content2 && /* @__PURE__ */ jsx$1("div", { className: styles$u.content, children: content2 })
  ] });
};
var TNotification = /* @__PURE__ */ ((TNotification2) => {
  TNotification2["success"] = "success";
  TNotification2["error"] = "error";
  TNotification2["warning"] = "warning";
  TNotification2["info"] = "info";
  return TNotification2;
})(TNotification || {});
const defaultTime = 4e3;
const useNotification = () => {
  const handleMsgType = ({
    type: type2,
    message: message2,
    title: title2,
    dismissable = false,
    time = defaultTime
  }) => {
    const toastBaseOptions = {
      duration: time,
      className: "sz-toast"
    };
    const getNotificationBody = (toastId) => {
      return /* @__PURE__ */ jsx$1(
        NotificationBody,
        {
          content: message2,
          title: title2,
          dismissable,
          onDismiss: () => {
            n.dismiss(toastId);
          }
        }
      );
    };
    switch (type2) {
      case "info":
        n((t3) => getNotificationBody(t3.id), {
          ...toastBaseOptions,
          icon: /* @__PURE__ */ jsx$1(InfoCircleIcon, {})
        });
        break;
      case "success":
        n((t3) => getNotificationBody(t3.id), {
          ...toastBaseOptions,
          icon: /* @__PURE__ */ jsx$1(CheckCircleIcon, {})
        });
        break;
      case "warning":
        n((t3) => getNotificationBody(t3.id), {
          ...toastBaseOptions,
          icon: /* @__PURE__ */ jsx$1(WarningIcon, {})
        });
        break;
      case "error":
        n((t3) => getNotificationBody(t3.id), {
          ...toastBaseOptions,
          icon: /* @__PURE__ */ jsx$1(ErrorIcon$1, {}),
          ariaProps: { role: "status", "aria-live": "assertive" }
        });
        break;
      default:
        n((t3) => getNotificationBody(t3.id), {
          ...toastBaseOptions,
          icon: /* @__PURE__ */ jsx$1(InfoCircleIcon, {})
        });
    }
  };
  const notificationContainer = () => /* @__PURE__ */ jsx$1(Ie$1, { position: "top-right" });
  return { notificationContainer, handleMsgType };
};
const pageIndicator = "page-indicator-module_pageIndicator__TZY4-";
const hidden = "page-indicator-module_hidden__9xSpl";
const pageIndicatorText = "page-indicator-module_pageIndicatorText__a2pet";
const pageIndicatorSuffix = "page-indicator-module_pageIndicatorSuffix__zLw97";
const styles$t = {
  pageIndicator,
  hidden,
  pageIndicatorText,
  pageIndicatorSuffix
};
const PageIndicator = ({
  numberOfQuestionsPerPage = 0,
  remainingQuestions = 0,
  totalQuestions = 0,
  currentPage,
  existingPages,
  prefixWord,
  connectorWord
}) => {
  const totalNumberOfPages = React__default.useMemo(
    () => existingPages ?? Math.ceil(totalQuestions / numberOfQuestionsPerPage),
    [totalQuestions, existingPages]
  );
  const currentPageNumber = React__default.useMemo(
    () => currentPage ?? Math.ceil(
      (totalQuestions - remainingQuestions) / numberOfQuestionsPerPage
    ) + 1,
    [totalQuestions, remainingQuestions, numberOfQuestionsPerPage, currentPage]
  );
  const prefixText = `${prefixWord} ${currentPageNumber}`;
  const suffixText = `${connectorWord} ${totalNumberOfPages}`;
  const pageIndicatorText2 = `${prefixText} ${suffixText}`;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$t.pageIndicator,
      "aria-label": pageIndicatorText2,
      children: [
        /* @__PURE__ */ jsxs(
          "span",
          {
            "aria-hidden": "true",
            className: styles$t.pageIndicatorText,
            children: [
              prefixText,
              " "
            ]
          }
        ),
        /* @__PURE__ */ jsx$1(
          "span",
          {
            "aria-hidden": "true",
            className: styles$t.pageIndicatorSuffix,
            children: suffixText
          }
        ),
        /* @__PURE__ */ jsx$1("span", { className: styles$t.hidden, children: pageIndicatorText2 })
      ]
    }
  );
};
const anchor = "popper-module_anchor__85o-D";
const panel = "popper-module_panel__LNMHJ";
const header$3 = "popper-module_header__iH27U";
const title$4 = "popper-module_title__Ckwdk";
const close = "popper-module_close__LqwlG";
const body = "popper-module_body__FOOy6";
const footer = "popper-module_footer__hh85I";
const styles$s = {
  anchor,
  panel,
  header: header$3,
  title: title$4,
  close,
  body,
  "body-below-header": "popper-module_body-below-header__dNZv9",
  footer
};
const VIEWPORT_GUTTER = 8;
const toCssSize = (value2) => typeof value2 === "number" ? `${value2}px` : value2;
const caretMiddleware = {
  name: "szCaret",
  fn({ x: x3, y: y3, rects, placement }) {
    const side = placement.split("-")[0];
    if (side === "top" || side === "bottom") {
      const centre2 = rects.reference.x + rects.reference.width / 2 - x3;
      const max22 = Math.max(14, rects.floating.width - 14);
      return { data: { left: Math.min(Math.max(centre2, 14), max22) - 5 } };
    }
    const centre = rects.reference.y + rects.reference.height / 2 - y3;
    const max2 = Math.max(14, rects.floating.height - 14);
    return { data: { top: Math.min(Math.max(centre, 14), max2) - 5 } };
  }
};
const openPoppers = /* @__PURE__ */ new Set();
const Popper$1 = ({
  trigger: trigger2,
  children,
  title: title2,
  footer: footer2,
  placement = "bottom-start",
  offset: offset3 = 8,
  showArrow = false,
  showClose = true,
  closeLabel = "Close",
  dismissOnOutsideClick = false,
  width,
  maxWidth = 320,
  maxHeight,
  isOpen,
  defaultOpen = false,
  onOpenChange,
  onClose,
  ariaLabel,
  zIndex = 1200,
  className,
  id,
  dataTestid
}) => {
  const isControlled = isOpen !== void 0 && isOpen !== null;
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const open2 = isControlled ? !!isOpen : uncontrolledOpen;
  const autoId = useId$2();
  const baseId = id ?? `sz-popper${autoId}`;
  const panelId = `${baseId}-panel`;
  const titleId = `${baseId}-title`;
  const anchorRef = useRef(null);
  const setOpen = useCallback(
    (next2) => {
      if (!isControlled) {
        setUncontrolledOpen(next2);
      }
      onOpenChange?.(next2);
      if (!next2) {
        onClose?.();
      }
    },
    [isControlled, onOpenChange, onClose]
  );
  const {
    refs,
    x: x3,
    y: y3,
    strategy,
    middlewareData,
    placement: resolvedPlacement,
    isPositioned
  } = useFloating$1({
    strategy: "fixed",
    placement,
    open: open2,
    whileElementsMounted: autoUpdate$1,
    middleware: [
      offset$4(offset3),
      flip$5({ padding: VIEWPORT_GUTTER }),
      shift$2({
        mainAxis: true,
        crossAxis: true,
        padding: VIEWPORT_GUTTER
      }),
      ...showArrow ? [caretMiddleware] : []
    ]
  });
  useEffect(() => {
    if (!open2) return;
    const entry = { close: () => setOpen(false) };
    openPoppers.forEach((other) => other.close());
    openPoppers.add(entry);
    return () => {
      openPoppers.delete(entry);
    };
  }, [open2, setOpen]);
  useEffect(() => {
    if (!open2) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        setOpen(false);
      }
    };
    const onPointerDown = (event) => {
      if (!dismissOnOutsideClick) return;
      const panel22 = refs.floating.current;
      const anchor2 = anchorRef.current;
      if (panel22 && panel22.contains(event.target)) return;
      if (anchor2 && anchor2.contains(event.target)) return;
      setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    return () => {
      document.removeEventListener("keydown", onKeyDown, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
    };
  }, [open2, dismissOnOutsideClick, setOpen, refs.floating]);
  const wasOpen = useRef(false);
  const didFocus = useRef(false);
  useEffect(() => {
    const panel22 = refs.floating.current;
    if (open2 && isPositioned && panel22) {
      if (!didFocus.current) {
        didFocus.current = true;
        const target = panel22.querySelector(
          'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
        );
        (target ?? panel22).focus({ preventScroll: true });
      }
    } else if (!open2 && wasOpen.current && anchorRef.current) {
      didFocus.current = false;
      const target = anchorRef.current.querySelector(
        "button,[href],[tabindex]"
      ) ?? anchorRef.current;
      target.focus({ preventScroll: true });
    }
    if (!open2 || isPositioned) wasOpen.current = open2;
  }, [open2, isPositioned, refs.floating]);
  const side = resolvedPlacement.split("-")[0] ?? "bottom";
  const hasHeader = title2 !== void 0 || showClose;
  let arrowStyle = null;
  if (showArrow) {
    const base = {
      position: "absolute",
      width: "10px",
      height: "10px",
      background: "var(--color-white, #fff)",
      transform: "rotate(45deg)"
    };
    const line2 = "1px solid var(--color-disabled-back, #ebf0f7)";
    const arrowX = middlewareData.szCaret?.left ?? 0;
    const arrowY = middlewareData.szCaret?.top ?? 0;
    if (side === "bottom") {
      arrowStyle = { ...base, top: "-6px", left: arrowX, borderTop: line2, borderLeft: line2 };
    } else if (side === "top") {
      arrowStyle = { ...base, bottom: "-6px", left: arrowX, borderBottom: line2, borderRight: line2 };
    } else if (side === "right") {
      arrowStyle = { ...base, left: "-6px", top: arrowY, borderBottom: line2, borderLeft: line2 };
    } else {
      arrowStyle = { ...base, right: "-6px", top: arrowY, borderTop: line2, borderRight: line2 };
    }
  }
  const panel2 = open2 ? createPortal(
    /* @__PURE__ */ jsxs(
      "div",
      {
        ref: refs.setFloating,
        id: panelId,
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": title2 !== void 0 ? titleId : void 0,
        "aria-label": title2 === void 0 ? ariaLabel : void 0,
        "data-testid": dataTestid,
        "data-side": side,
        "data-state": "open",
        tabIndex: -1,
        className: clsx(styles$s.panel, className),
        style: {
          position: strategy,
          top: `${Math.round(y3)}px`,
          left: `${Math.round(x3)}px`,
          visibility: isPositioned ? "visible" : "hidden",
          zIndex,
          width: toCssSize(width),
          maxWidth: toCssSize(maxWidth)
        },
        children: [
          arrowStyle && /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", style: arrowStyle }),
          hasHeader && /* @__PURE__ */ jsxs(
            "div",
            {
              className: styles$s.header,
              "data-testid": dataTestid ? `${dataTestid}-header` : void 0,
              children: [
                /* @__PURE__ */ jsx$1("span", { id: titleId, className: styles$s.title, children: title2 }),
                showClose && /* @__PURE__ */ jsx$1(
                  "button",
                  {
                    type: "button",
                    className: styles$s.close,
                    "aria-label": closeLabel,
                    onClick: (event) => {
                      event.stopPropagation();
                      setOpen(false);
                    },
                    children: /* @__PURE__ */ jsx$1("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", children: /* @__PURE__ */ jsx$1(
                      "path",
                      {
                        d: "M1 1l10 10M11 1L1 11",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                      }
                    ) })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx$1(
            "div",
            {
              className: clsx(styles$s.body, hasHeader && styles$s["body-below-header"]),
              "data-testid": dataTestid ? `${dataTestid}-body` : void 0,
              style: maxHeight !== void 0 ? { overflowY: "auto", maxHeight: toCssSize(maxHeight) } : void 0,
              children
            }
          ),
          footer2 && /* @__PURE__ */ jsx$1("div", { className: styles$s.footer, children: footer2 })
        ]
      }
    ),
    document.body
  ) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      "span",
      {
        ref: (node2) => {
          anchorRef.current = node2;
          refs.setReference(node2);
        },
        className: styles$s.anchor,
        "data-testid": dataTestid ? `${dataTestid}-trigger` : void 0,
        onClick: () => setOpen(!open2),
        "aria-haspopup": "dialog",
        "aria-expanded": open2 ? "true" : "false",
        "aria-controls": open2 ? panelId : void 0,
        children: trigger2
      }
    ),
    panel2
  ] });
};
const YellowCheckIcon = ({ disabled: disabled2 }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1(
          "circle",
          {
            cx: "8.06641",
            cy: "8",
            r: "8",
            fill: disabled2 ? "#EBF0F7" : "#FFD129"
          }
        ),
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_2071_11851)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M6.86491 9.66755L5.19691 7.99955L4.62891 8.56355L6.86491 10.7995L11.6649 5.99955L11.1009 5.43555L6.86491 9.66755Z",
            fill: disabled2 ? "#ADBFD9" : "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_2071_11851", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "9.6",
            height: "9.6",
            fill: "white",
            transform: "translate(3.26562 3.19922)"
          }
        ) }) })
      ]
    }
  );
};
const container$3 = "radio-button-module_container__EEDt-";
const withImage = "radio-button-module_withImage__QVuh3";
const error$5 = "radio-button-module_error__WluB6";
const disabled$6 = "radio-button-module_disabled__o0NbG";
const image = "radio-button-module_image__IgWK0";
const squareOutline = "radio-button-module_squareOutline__cwFee";
const wrapper = "radio-button-module_wrapper__GTvyw";
const svgWithLabel = "radio-button-module_svgWithLabel__DdZtO";
const label$4 = "radio-button-module_label__cdHBo";
const svgContainer = "radio-button-module_svgContainer__BtrmH";
const svgWithLabelDisabled = "radio-button-module_svgWithLabelDisabled__ninFa";
const styles$r = {
  container: container$3,
  withImage,
  error: error$5,
  disabled: disabled$6,
  image,
  squareOutline,
  wrapper,
  svgWithLabel,
  label: label$4,
  svgContainer,
  svgWithLabelDisabled
};
const SvgWithLabel = ({
  children,
  label: label2,
  selected: selected2,
  disabled: disabled2,
  hasError
}) => {
  const shouldShowLabelElement = () => {
    return !(hasError && !selected2 && !label2);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        styles$r.svgWithLabel,
        disabled2 && styles$r.svgWithLabelDisabled
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$r.image, children: [
          /* @__PURE__ */ jsx$1("div", { className: styles$r.wrapper }),
          children
        ] }),
        shouldShowLabelElement() && /* @__PURE__ */ jsxs("div", { className: styles$r.label, children: [
          selected2 && /* @__PURE__ */ jsx$1(
            "span",
            {
              className: styles$r.svgContainer,
              "aria-hidden": "true",
              children: /* @__PURE__ */ jsx$1(YellowCheckIcon, { disabled: disabled2 })
            }
          ),
          /* @__PURE__ */ jsx$1("span", { className: clsx(selected2 && styles$r.labelText), children: label2 })
        ] })
      ]
    }
  );
};
function RadioButton({
  children,
  id,
  inputId,
  name: name2,
  disabled: disabled2,
  hasError,
  errorElementId,
  value: value2,
  checked,
  ariaLabel,
  className,
  withImage: withImage2 = false,
  withSquareOutline,
  tabIndex,
  onChange: onChange2,
  onBlur,
  onClick
}) {
  const handleChange = (e3) => {
    if (!disabled2 && onChange2) {
      onChange2(e3, id);
    }
  };
  const handleClick = () => {
    if (!disabled2 && onClick) {
      onClick(value2, id);
    }
  };
  const controlId = inputId ?? id;
  return /* @__PURE__ */ jsxs(
    "label",
    {
      htmlFor: controlId,
      className: clsx(
        styles$r.container,
        withImage2 && styles$r.withImage,
        hasError && styles$r.error,
        disabled2 && styles$r.disabled,
        withSquareOutline && styles$r.squareOutline,
        className
      ),
      "aria-label": ariaLabel,
      onMouseUp: handleClick,
      children: [
        /* @__PURE__ */ jsx$1(
          "input",
          {
            type: "radio",
            id: controlId,
            "data-testid": id,
            name: name2,
            "aria-disabled": disabled2,
            onClick: (e3) => disabled2 && e3.preventDefault(),
            value: value2,
            checked,
            "aria-errormessage": errorElementId,
            "aria-invalid": hasError,
            onChange: handleChange,
            onBlur,
            tabIndex
          }
        ),
        children
      ]
    }
  );
}
const BLUE$1 = "#006FBF";
const WHITE$1 = "#FFFFFF";
const DISABLED$5 = "#ADBFD9";
const BarChartWithBorder = ({
  value: value2,
  isDisabled,
  className
}) => {
  const defaultColor = isDisabled ? DISABLED$5 : BLUE$1;
  const thirdBarFill = value2 === 4 ? defaultColor : WHITE$1;
  const secondBarFill = [4, 3].includes(value2) ? BLUE$1 : WHITE$1;
  const firstBarFill = value2 !== 1 ? defaultColor : WHITE$1;
  const strokeColor = defaultColor;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "96",
      height: "96",
      viewBox: "0 0 96 96",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "95",
            height: "95",
            rx: "3.5",
            fill: "white",
            stroke: "#E6F1FA"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "mask",
          {
            id: "path-2-inside-1_1944_47633",
            fill: "white",
            children: /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "24",
                y: "56",
                width: "12",
                height: "16",
                rx: "1"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1(
          "rect",
          {
            x: "24",
            y: "56",
            width: "12",
            height: "16",
            rx: "1",
            fill: firstBarFill,
            stroke: strokeColor,
            strokeWidth: "4",
            mask: "url(#path-2-inside-1_1944_47633)"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "mask",
          {
            id: "path-3-inside-2_1944_47633",
            fill: "white",
            children: /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "42",
                y: "40",
                width: "12",
                height: "32",
                rx: "1"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1(
          "rect",
          {
            x: "42",
            y: "40",
            width: "12",
            height: "32",
            rx: "1",
            fill: secondBarFill,
            stroke: strokeColor,
            strokeWidth: "4",
            mask: "url(#path-3-inside-2_1944_47633)"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "mask",
          {
            id: "path-4-inside-3_1944_47633",
            fill: "white",
            children: /* @__PURE__ */ jsx$1(
              "rect",
              {
                x: "60",
                y: "24",
                width: "12",
                height: "48",
                rx: "1"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1(
          "rect",
          {
            x: "60",
            y: "24",
            width: "12",
            height: "48",
            rx: "1",
            fill: thirdBarFill,
            stroke: strokeColor,
            strokeWidth: "4",
            mask: "url(#path-4-inside-3_1944_47633)"
          }
        )
      ]
    }
  );
};
const ratingContainer = "rating-module_ratingContainer__f-x0v";
const star = "rating-module_star__I48hq";
const icon$2 = "rating-module_icon__JJN3N";
const styles$q = {
  ratingContainer,
  star,
  icon: icon$2
};
const StarFullIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_13159_22610)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M7.215 5L6 1L4.785 5H1L4.09 7.205L2.915 11L6 8.655L9.09 11L7.915 7.205L11 5H7.215Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_13159_22610", children: /* @__PURE__ */ jsx$1("rect", { width: "12", height: "12", fill: "white" }) }) })
      ]
    }
  );
};
const StarHalfIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_13159_22611)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M11 4.62L7.405 4.31L6 1L4.595 4.315L1 4.62L3.73 6.985L2.91 10.5L6 8.635L9.09 10.5L8.275 6.985L11 4.62ZM6 7.7V3.05L6.855 5.07L9.045 5.26L7.385 6.7L7.885 8.84L6 7.7Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_13159_22611", children: /* @__PURE__ */ jsx$1("rect", { width: "12", height: "12", fill: "white" }) }) })
      ]
    }
  );
};
const StarEmptyIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_13159_22625)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M11 4.62L7.405 4.31L6 1L4.595 4.315L1 4.62L3.73 6.985L2.91 10.5L6 8.635L9.09 10.5L8.275 6.985L11 4.62ZM6 7.7L4.12 8.835L4.62 6.695L2.96 5.255L5.15 5.065L6 3.05L6.855 5.07L9.045 5.26L7.385 6.7L7.885 8.84L6 7.7Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_13159_22625", children: /* @__PURE__ */ jsx$1("rect", { width: "12", height: "12", fill: "white" }) }) })
      ]
    }
  );
};
function Rating({
  value: value2,
  max: max2 = 5,
  className,
  iconProps,
  ariaLabel,
  testId
}) {
  const clampedValue = Math.min(Math.max(0, value2), max2);
  const fullStars = Math.floor(clampedValue);
  const hasHalfStar = clampedValue % 1 >= 0.5;
  const emptyStars = max2 - fullStars - (hasHalfStar ? 1 : 0);
  const renderFullStar = (index2) => {
    if (iconProps?.full) {
      return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: iconProps.full }, `full-${index2}`);
    }
    return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: /* @__PURE__ */ jsx$1(StarFullIcon, { className: styles$q.icon }) }, `full-${index2}`);
  };
  const renderHalfStar = () => {
    if (iconProps?.half) {
      return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: iconProps.half }, "half");
    }
    return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: /* @__PURE__ */ jsx$1(StarHalfIcon, { className: styles$q.icon }) }, "half");
  };
  const renderEmptyStar = (index2) => {
    if (iconProps?.empty) {
      return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: iconProps.empty }, `empty-${index2}`);
    }
    return /* @__PURE__ */ jsx$1("span", { className: styles$q.star, children: /* @__PURE__ */ jsx$1(StarEmptyIcon, { className: styles$q.icon }) }, `empty-${index2}`);
  };
  const accessibilityLabel = ariaLabel ?? `Rating: ${clampedValue} out of ${max2}`;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(styles$q.ratingContainer, className),
      role: "img",
      "aria-label": accessibilityLabel,
      "data-testid": testId,
      children: [
        Array.from({ length: fullStars }, (_2, i3) => renderFullStar(i3)),
        hasHalfStar && renderHalfStar(),
        Array.from({ length: emptyStars }, (_2, i3) => renderEmptyStar(i3))
      ]
    }
  );
}
const scoreCard = "score-card-module_scoreCard__1I-3f";
const tooltip = "score-card-module_tooltip__uzbU1";
const header$2 = "score-card-module_header__iRGfC";
const title$3 = "score-card-module_title__uV-CH";
const infoIconWrapper = "score-card-module_infoIconWrapper__rPcL4";
const content$3 = "score-card-module_content__N6AIF";
const score = "score-card-module_score__8-yNy";
const ratingSection = "score-card-module_ratingSection__Cc9Gr";
const rating = "score-card-module_rating__j-ztE";
const subtitle = "score-card-module_subtitle__Wv3mQ";
const styles$p = {
  scoreCard,
  tooltip,
  header: header$2,
  title: title$3,
  infoIconWrapper,
  content: content$3,
  score,
  ratingSection,
  rating,
  subtitle
};
const InfoIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_13159_22602)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M7.33333 4.66665H8.66666V5.99998H7.33333V4.66665ZM7.33333 7.33331H8.66666V11.3333H7.33333V7.33331ZM7.99999 1.33331C4.31999 1.33331 1.33333 4.31998 1.33333 7.99998C1.33333 11.68 4.31999 14.6666 7.99999 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 7.99999 1.33331ZM7.99999 13.3333C5.05999 13.3333 2.66666 10.94 2.66666 7.99998C2.66666 5.05998 5.05999 2.66665 7.99999 2.66665C10.94 2.66665 13.3333 5.05998 13.3333 7.99998C13.3333 10.94 10.94 13.3333 7.99999 13.3333Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_13159_22602", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
};
function ScoreCard({
  title: title2,
  score: score2,
  rating: rating2,
  maxRating = 5,
  subtitle: subtitle2,
  tooltip: tooltip2,
  ariaLabel,
  className,
  testId,
  useNAForZeroScore = false
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(styles$p.scoreCard, className),
      "aria-label": ariaLabel,
      "data-testid": testId,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$p.header, children: [
          /* @__PURE__ */ jsx$1("span", { className: styles$p.title, children: title2 }),
          tooltip2 && /* @__PURE__ */ jsx$1("div", { children: /* @__PURE__ */ jsx$1(
            Tooltip$3,
            {
              content: tooltip2,
              ariaLabel: tooltip2,
              className: styles$p.tooltip,
              place: "top",
              children: /* @__PURE__ */ jsx$1(
                "span",
                {
                  className: styles$p.infoIconWrapper,
                  "data-testid": testId ? `${testId}-info-icon` : void 0,
                  children: /* @__PURE__ */ jsx$1(InfoIcon, { className: styles$p.infoIcon })
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles$p.content, children: [
          /* @__PURE__ */ jsx$1("span", { className: styles$p.score, children: useNAForZeroScore && score2 === 0 ? "N/A" : score2.toFixed(1) }),
          /* @__PURE__ */ jsxs("div", { className: styles$p.ratingSection, children: [
            /* @__PURE__ */ jsx$1(
              Rating,
              {
                value: rating2,
                max: maxRating,
                className: styles$p.rating,
                testId: testId ? `${testId}-rating` : void 0
              }
            ),
            /* @__PURE__ */ jsx$1("span", { className: styles$p.subtitle, children: subtitle2 })
          ] })
        ] })
      ]
    }
  );
}
const scoreIndicator = "score-indicator-module_scoreIndicator__PeL4Q";
const indicatorWrapper = "score-indicator-module_indicatorWrapper__jCI9p";
const indicator = "score-indicator-module_indicator__aE8I5";
const text = "score-indicator-module_text__wmafx";
const integralIcon = "score-indicator-module_integralIcon__Isewb";
const dark = "score-indicator-module_dark__mYA7H";
const darkIntegralIcon = "score-indicator-module_darkIntegralIcon__RPUbY";
const styles$o = {
  scoreIndicator,
  indicatorWrapper,
  indicator,
  text,
  integralIcon,
  dark,
  darkIntegralIcon
};
function IntegralIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "7",
      height: "9",
      viewBox: "0 0 7 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.07765 1.6997C4.64221 2.12115 4.24487 2.93586 3.85748 4.56454C3.42227 6.3943 2.9721 7.52473 2.34852 8.18538C1.68325 8.89019 0.883947 9.00025 0 9.00005L0.000202167 8.10005C0.816256 8.10023 1.29191 7.99364 1.69402 7.56761C2.13783 7.09743 2.54745 6.18286 2.98191 4.35628C3.37397 2.70796 3.81684 1.66748 4.45174 1.053C5.11744 0.408691 5.92022 0.300044 6.8001 0.300049L6.8001 1.20005C5.97998 1.20004 5.48229 1.30807 5.07765 1.6997Z",
          fill: "#00204D"
        }
      )
    }
  );
}
const getIndicatorColor = (score2) => {
  if (score2 >= 96 && score2 <= 100) return "#007A6A";
  if (score2 >= 75 && score2 <= 95) return "#339D8F";
  if (score2 >= 50 && score2 <= 74) return "#92D4C1";
  if (score2 >= 25 && score2 <= 49) return "#FFEDD5";
  if (score2 >= 7 && score2 <= 24) return "#ADBFD9";
  return "#EBF0F7";
};
const getIndicatorColorForOneDigitScore = (score2) => {
  if (score2 === 5) return "#007A6A";
  if (score2 >= 4 && score2 < 5) return "#339D8F";
  if (score2 >= 3 && score2 < 4) return "#92D4C1";
  if (score2 >= 2 && score2 < 3) return "#FFEDD5";
  if (score2 > 0 && score2 < 2) return "#FFF6EA";
  return "#EBF0F7";
};
const ScoreIndicator = ({
  text: text2,
  score: score2,
  dark: dark2,
  className,
  isOneDigitScore,
  hideIntegralIcon,
  dataTestId
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(styles$o.scoreIndicator, className, {
        [styles$o.dark]: dark2
      }),
      "data-testid": dataTestId,
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$o.indicatorWrapper, children: /* @__PURE__ */ jsx$1(
          "div",
          {
            className: styles$o.indicator,
            style: {
              backgroundColor: isOneDigitScore ? getIndicatorColorForOneDigitScore(score2) : getIndicatorColor(score2)
            }
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: styles$o.text, children: [
          text2,
          !hideIntegralIcon && /* @__PURE__ */ jsx$1(
            IntegralIcon,
            {
              className: clsx(styles$o.integralIcon, {
                [styles$o.darkIntegralIcon]: dark2
              })
            }
          )
        ] })
      ]
    }
  );
};
var _excluded$3 = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function useAsync(_ref3) {
  var _ref$defaultOptions = _ref3.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref3.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref3.loadOptions;
  _ref3.options;
  var _ref$isLoading = _ref3.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref3.onInputChange, _ref$filterOption = _ref3.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = _objectWithoutProperties(_ref3, _excluded$3);
  var propsInputValue = restSelectProps.inputValue;
  var lastRequest = useRef(void 0);
  var mounted = useRef(false);
  var _useState = useState(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : void 0), _useState2 = _slicedToArray$1(_useState, 2), defaultOptions2 = _useState2[0], setDefaultOptions = _useState2[1];
  var _useState3 = useState(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = _slicedToArray$1(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
  var _useState5 = useState(propsDefaultOptions === true), _useState6 = _slicedToArray$1(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
  var _useState7 = useState(void 0), _useState8 = _slicedToArray$1(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
  var _useState9 = useState([]), _useState10 = _slicedToArray$1(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
  var _useState11 = useState(false), _useState12 = _slicedToArray$1(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
  var _useState13 = useState({}), _useState14 = _slicedToArray$1(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
  var _useState15 = useState(void 0), _useState16 = _slicedToArray$1(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
  var _useState17 = useState(void 0), _useState18 = _slicedToArray$1(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
  if (cacheOptions !== prevCacheOptions) {
    setOptionsCache({});
    setPrevCacheOptions(cacheOptions);
  }
  if (propsDefaultOptions !== prevDefaultOptions) {
    setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : void 0);
    setPrevDefaultOptions(propsDefaultOptions);
  }
  useEffect(function() {
    mounted.current = true;
    return function() {
      mounted.current = false;
    };
  }, []);
  var loadOptions = useCallback(function(inputValue, callback) {
    if (!propsLoadOptions) return callback();
    var loader2 = propsLoadOptions(inputValue, callback);
    if (loader2 && typeof loader2.then === "function") {
      loader2.then(callback, function() {
        return callback();
      });
    }
  }, [propsLoadOptions]);
  useEffect(function() {
    if (propsDefaultOptions === true) {
      loadOptions(stateInputValue, function(options3) {
        if (!mounted.current) return;
        setDefaultOptions(options3 || []);
        setIsLoading(!!lastRequest.current);
      });
    }
  }, []);
  var onInputChange = useCallback(function(newValue, actionMeta) {
    var inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);
    if (!inputValue) {
      lastRequest.current = void 0;
      setStateInputValue("");
      setLoadedInputValue("");
      setLoadedOptions([]);
      setIsLoading(false);
      setPassEmptyOptions(false);
      return;
    }
    if (cacheOptions && optionsCache[inputValue]) {
      setStateInputValue(inputValue);
      setLoadedInputValue(inputValue);
      setLoadedOptions(optionsCache[inputValue]);
      setIsLoading(false);
      setPassEmptyOptions(false);
    } else {
      var request = lastRequest.current = {};
      setStateInputValue(inputValue);
      setIsLoading(true);
      setPassEmptyOptions(!loadedInputValue);
      loadOptions(inputValue, function(options3) {
        if (!mounted) return;
        if (request !== lastRequest.current) return;
        lastRequest.current = void 0;
        setIsLoading(false);
        setLoadedInputValue(inputValue);
        setLoadedOptions(options3 || []);
        setPassEmptyOptions(false);
        setOptionsCache(options3 ? _objectSpread2$1(_objectSpread2$1({}, optionsCache), {}, _defineProperty$3({}, inputValue, options3)) : optionsCache);
      });
    }
  }, [cacheOptions, loadOptions, loadedInputValue, optionsCache, propsOnInputChange]);
  var options2 = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions2 || [];
  return _objectSpread2$1(_objectSpread2$1({}, restSelectProps), {}, {
    options: options2,
    isLoading: isLoading || propsIsLoading,
    onInputChange,
    filterOption
  });
}
var AsyncSelect = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var stateManagedProps = useAsync(props);
  var selectProps = useStateManager(stateManagedProps);
  return /* @__PURE__ */ React.createElement(Select$2, _extends$1({
    ref: ref2
  }, selectProps));
});
var AsyncSelect$1 = AsyncSelect;
function ClearIndicator$1(props) {
  const { ariaDisabled, ariaLabelClearButton = `Clear all values` } = props.selectProps;
  function handleEnterKey(event) {
    if (event.key === "Enter" && !ariaDisabled) {
      props.clearValue();
    }
  }
  return /* @__PURE__ */ jsx$1(
    "button",
    {
      tabIndex: ariaDisabled ? -1 : 0,
      "aria-label": ariaLabelClearButton,
      onKeyDown: handleEnterKey,
      children: /* @__PURE__ */ jsx$1(components.ClearIndicator, { ...props })
    }
  );
}
const ClearIcon$1 = ({ className }) => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      className,
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M9.66659 1.2735L8.72659 0.333496L4.99992 4.06016L1.27325 0.333496L0.333252 1.2735L4.05992 5.00016L0.333252 8.72683L1.27325 9.66683L4.99992 5.94016L8.72659 9.66683L9.66659 8.72683L5.93992 5.00016L9.66659 1.2735Z",
          fill: "#323232"
        }
      )
    }
  );
};
const SearchIcon = ({ className, width = 12 }) => {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      className,
      width,
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M8.33333 7.33333H7.80667L7.62 7.15333C8.27333 6.39333 8.66667 5.40667 8.66667 4.33333C8.66667 1.94 6.72667 0 4.33333 0C1.94 0 0 1.94 0 4.33333C0 6.72667 1.94 8.66667 4.33333 8.66667C5.40667 8.66667 6.39333 8.27333 7.15333 7.62L7.33333 7.80667V8.33333L10.6667 11.66L11.66 10.6667L8.33333 7.33333V7.33333ZM4.33333 7.33333C2.67333 7.33333 1.33333 5.99333 1.33333 4.33333C1.33333 2.67333 2.67333 1.33333 4.33333 1.33333C5.99333 1.33333 7.33333 2.67333 7.33333 4.33333C7.33333 5.99333 5.99333 7.33333 4.33333 7.33333Z",
          fill: "black"
        }
      )
    }
  );
};
const Control = ({ children, ...props }) => {
  const {
    clearButton,
    ariaLabelClearButton,
    onClearBtnClick,
    hasSearchButton,
    onSearchBtnClick,
    searchButtonAriaLabel,
    searchButtonText,
    ariaDisabled
  } = props.selectProps;
  return /* @__PURE__ */ jsxs(components.Control, { ...props, children: [
    /* @__PURE__ */ jsx$1(
      SearchIcon,
      {
        className: clsx(
          "search__control-icon",
          props.isFocused && "search__control-icon--active"
        ),
        width: 16
      }
    ),
    children,
    /* @__PURE__ */ jsxs("div", { className: "search__reverse-order", children: [
      hasSearchButton && /* @__PURE__ */ jsx$1(
        Button$1,
        {
          className: clsx(
            "search__search-btn",
            !props.isFocused && "search__search-btn--not-active"
          ),
          variant: "secondary",
          size: "small",
          "data-testid": "search-button",
          ariaLabel: searchButtonAriaLabel,
          onClick: onSearchBtnClick,
          tabIndex: ariaDisabled ? -1 : 0,
          disabled: ariaDisabled,
          children: searchButtonText
        }
      ),
      clearButton && /* @__PURE__ */ jsx$1(
        "button",
        {
          className: "search__clear-btn",
          "data-testid": "search-clear-button",
          "aria-label": ariaLabelClearButton,
          onClick: onClearBtnClick,
          tabIndex: ariaDisabled ? -1 : 0,
          children: /* @__PURE__ */ jsx$1(ClearIcon$1, { className: "search__clear-btn-icon" })
        }
      )
    ] })
  ] });
};
function Input(props) {
  const { ariaDisabled, id, ariaLabel } = props.selectProps;
  return /* @__PURE__ */ jsx$1(
    components.Input,
    {
      ...props,
      "aria-disabled": ariaDisabled,
      "aria-controls": id,
      autoComplete: "off",
      "aria-label": ariaLabel,
      ...ariaLabel && { "aria-describedby": "" },
      ...ariaDisabled && {
        onChange: (e3) => {
          e3.preventDefault();
        }
      }
    }
  );
}
const MenuList$2 = ({
  children,
  ...props
}) => {
  const { isLoading, searchingLabel, loadMoreButtonRef } = props.selectProps;
  if (isLoading) return /* @__PURE__ */ jsx$1("div", { className: "searching-label", children: searchingLabel });
  const hasDropdownItems = Children.toArray(children).length > 1;
  return /* @__PURE__ */ jsxs(
    components.MenuList,
    {
      ...props,
      innerProps: Object.assign({}, props.innerProps, {
        "data-testid": "search-menu"
      }),
      children: [
        children,
        props.selectProps.loadMore && hasDropdownItems && /* @__PURE__ */ jsx$1("div", { className: "search__load-more-wrapper", children: /* @__PURE__ */ jsx$1(
          Button$1,
          {
            ref: loadMoreButtonRef,
            variant: "secondary",
            size: "small",
            disabled: props.selectProps.loadMoreDisabled,
            "data-testid": "search-load-more-button",
            onClick: props.selectProps.onLoadMore,
            children: isLoading ? "Loading..." : "Load more"
          }
        ) })
      ]
    }
  );
};
const Option$1 = (props) => {
  return /* @__PURE__ */ jsxs(
    components.Option,
    {
      ...props,
      className: clsx(
        "search__option",
        props.data.icon && "search__option--with-icon"
      ),
      innerProps: Object.assign({}, props.innerProps, {
        "data-testid": "search-option"
      }),
      "data-testid": "search-option",
      children: [
        /* @__PURE__ */ jsxs("h4", { className: "search__option-label", "data-testid": "search-option-label", children: [
          /* @__PURE__ */ jsx$1("div", { className: "search__option-label-text", children: props.data.label }),
          props.data.icon && /* @__PURE__ */ jsx$1("div", { className: "search__option-icon", "data-testid": "search-option-icon", children: props.data.icon }),
          props.data.labelTag && /* @__PURE__ */ jsx$1("div", { className: "search__option-label-tag", children: props.data.labelTag })
        ] }),
        props.data.secondLabel && /* @__PURE__ */ jsx$1(
          "p",
          {
            className: "search__option-label-2",
            "data-testid": "search-option-secondLabel",
            children: props.data.secondLabel
          }
        )
      ]
    }
  );
};
const ValueContainer = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(components.ValueContainer, { ...props, children: [
    !props.selectProps.inputValue && /* @__PURE__ */ jsx$1(
      components.Placeholder,
      {
        ...props,
        isFocused: !!props.selectProps.focused,
        children: props.selectProps.placeholder
      }
    ),
    React__default.Children.map(children, (child) => {
      return child?.type !== components.Placeholder && child;
    })
  ] });
};
const selectStyles = {
  control: (styles2, { isFocused }) => ({
    ...styles2,
    borderTop: "none",
    borderRight: "none",
    borderLeft: "none",
    borderRadius: "0",
    boxShadow: "none",
    minHeight: "unset",
    ...isFocused ? { borderColor: "var(--color-front)" } : {},
    "&:hover": { borderColor: "var(--color-front)" }
  }),
  placeholder: (styles2) => ({
    ...styles2,
    fontSize: "12px"
  }),
  input: (styles2) => ({
    ...styles2,
    fontSize: "12px",
    color: "#000",
    input: {
      opacity: "1 !important"
    }
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: () => ({
    display: "none"
  }),
  valueContainer: (styles2) => ({
    ...styles2,
    padding: "2px 0",
    marginLeft: "8px"
  }),
  singleValue: () => ({ display: "none" }),
  menu: (styles2) => ({
    ...styles2,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)"
  }),
  menuList: (styles2) => ({
    ...styles2,
    maxHeight: "380px",
    padding: "16px 8px",
    "&::-webkit-scrollbar": {
      width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
      width: "4px",
      borderRadius: "2px",
      backgroundColor: "#d6d6d6"
    }
  }),
  option: (styles2) => ({
    ...styles2,
    padding: "8px",
    borderRadius: "4px",
    cursor: "pointer"
  }),
  noOptionsMessage: (styles2) => ({
    ...styles2,
    fontSize: "12px"
  }),
  loadingMessage: (styles2) => ({
    ...styles2,
    fontSize: "12px"
  })
};
const SearchComponent = (props, ref2) => {
  const {
    id,
    placeholder: placeholder2 = "Search",
    async = false,
    internalSearch = false,
    autoSearch = true,
    isDisabled = false,
    clearButton = true,
    className,
    onSearch,
    hasSearchButton = true,
    searchButtonText = "Search",
    searchingLabel = "Searching...",
    searchButtonAriaLabel,
    clearButtonAriaLabel,
    ariaLabel,
    loadMore,
    onLoadMore,
    noResultsText = "No results",
    onClearBtnClick,
    ...rest
  } = props;
  const [inputValue, setInputValue] = useState("");
  const [menuIsOpen, setMenuIsOpen] = useState(props.menuIsOpen);
  const selectRef = useRef();
  const [isLoadMoreFocused, setIsLoadMoreFocused] = React__default.useState(false);
  const loadMoreButtonRef = React__default.useRef(null);
  useImperativeHandle(ref2, () => ({
    focus: () => {
      selectRef.current?.focus();
      setMenuIsOpen(true);
    }
  }));
  useEffect(() => {
    setMenuIsOpen(props.menuIsOpen);
  }, [props.menuIsOpen]);
  useEffect(() => {
    setInputValue(props?.value?.label);
  }, [props.value?.label]);
  React__default.useEffect(() => {
    if (!loadMore && isLoadMoreFocused) {
      selectRef.current?.focus();
      setIsLoadMoreFocused(false);
      setMenuIsOpen(true);
    }
  }, [loadMore]);
  function handleInputChange2(text2, actionMeta) {
    if (!text2 || text2 === "") {
      setMenuIsOpen(false);
    }
    if (actionMeta.action === "input-change") {
      setInputValue(text2);
      if (autoSearch) {
        props.onInputChange?.(text2, actionMeta);
      }
    }
  }
  function handleClearBtnClick() {
    setInputValue("");
    props.onInputChange?.("", { action: "input-change", prevInputValue: "" });
    onClearBtnClick?.();
    selectRef?.current?.focus();
  }
  function handleSearch() {
    setMenuIsOpen(true);
    onSearch?.(inputValue);
  }
  function handleKeyDown(event) {
    if ((event.key === "Enter" || event.key === "Space") && !isDisabled) {
      handleSearch();
      setMenuIsOpen(true);
      if (isLoadMoreFocused && onLoadMore) {
        event.preventDefault();
        onLoadMore();
      }
    }
    if (event.key === "Tab") {
      if (loadMore && isMenuOpen) {
        setIsLoadMoreFocused(true);
      }
      if (document.activeElement === loadMoreButtonRef.current) {
        setIsLoadMoreFocused(false);
        setMenuIsOpen(false);
      }
    }
  }
  function handleChange(item2) {
    props.onChange?.(item2);
    setMenuIsOpen(false);
    selectRef.current?.blur();
  }
  function handleMenuOpen() {
    if (!isDisabled) {
      setMenuIsOpen(true);
    }
  }
  function handleMenuClose() {
    if (!isLoadMoreFocused) {
      setMenuIsOpen(false);
    } else {
      setMenuIsOpen(true);
    }
  }
  const isMenuOpen = internalSearch && menuIsOpen && !isDisabled || !!props.menuIsOpen;
  const hasClearButton = clearButton && inputValue && inputValue !== "";
  const selectProps = {
    ...rest,
    ...!isDisabled && { props },
    id,
    onMenuOpen: handleMenuOpen,
    onMenuClose: handleMenuClose,
    styles: selectStyles,
    components: {
      Control,
      Option: Option$1,
      MenuList: MenuList$2,
      ValueContainer,
      Input,
      ClearIndicator: ClearIndicator$1
    },
    menuIsOpen: isMenuOpen,
    closeMenuOnSelect: true,
    tabSelectsValue: false,
    ref: selectRef,
    openMenuOnFocus: !isDisabled && true,
    // onFocus: handleFocus,
    onBlur: handleMenuClose,
    onKeyDown: handleKeyDown,
    onSearchBtnClick: handleSearch,
    onClearBtnClick: handleClearBtnClick,
    onInputChange: handleInputChange2,
    onChange: handleChange,
    ariaDisabled: isDisabled,
    noOptionsMessage: () => /* @__PURE__ */ jsx$1("div", { className: "searching-label", children: noResultsText }),
    placeholder: placeholder2,
    inputValue,
    clearButton: hasClearButton,
    // focused,
    searchingLabel,
    hasSearchButton,
    searchButtonText,
    searchButtonAriaLabel,
    ariaLabelClearButton: clearButtonAriaLabel,
    ariaLabel,
    classNamePrefix: "sz-search",
    loadMore,
    onLoadMore,
    loadMoreButtonRef
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(
        "sz-search",
        isDisabled && "sz-search--disabled",
        className
      ),
      "data-testid": "search",
      children: async ? /* @__PURE__ */ jsx$1(AsyncSelect$1, { ...selectProps }) : /* @__PURE__ */ jsx$1(StateManagedSelect$1, { ...selectProps })
    }
  );
};
const Search3 = memo(forwardRef(SearchComponent));
const styles$n = {
  "sz-text-input": "text-input-module_sz-text-input__Gr3k5",
  "sz-text-input_focused": "text-input-module_sz-text-input_focused__o5qft",
  "sz-text-input_error": "text-input-module_sz-text-input_error__omzg0",
  "sz-text-input__input-wrapper": "text-input-module_sz-text-input__input-wrapper__XU6it",
  "sz-text-input__input-element": "text-input-module_sz-text-input__input-element__c9Gmb",
  "sz-text-input_disabled": "text-input-module_sz-text-input_disabled__Ls5bJ",
  "sz-text-input__password-visibility-icon": "text-input-module_sz-text-input__password-visibility-icon__18Nfl",
  "sz-text-input__icon-wrapper": "text-input-module_sz-text-input__icon-wrapper__q3n-e",
  "sz-text-input__password-visibility-button": "text-input-module_sz-text-input__password-visibility-button__5nnA8",
  "sz-text-input__character-counter": "text-input-module_sz-text-input__character-counter__Lk6wd",
  "sz-text-input__character-counter-error": "text-input-module_sz-text-input__character-counter-error__F5awk"
};
const VisibilityIcon = ({ className }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_11_1332)", children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
          fill: "#323232"
        }
      ) }),
      /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_11_1332", children: /* @__PURE__ */ jsx$1("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
const VisibilityShowIcon = ({ className }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    children: [
      /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_400_3869)", children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M7.99996 3.99997C10.5266 3.99997 12.78 5.41997 13.88 7.66663C13.4866 8.47997 12.9333 9.17997 12.2733 9.74663L13.2133 10.6866C14.14 9.86664 14.8733 8.83997 15.3333 7.66663C14.18 4.73997 11.3333 2.66663 7.99996 2.66663C7.15329 2.66663 6.33996 2.79997 5.57329 3.04663L6.67329 4.14663C7.10663 4.05997 7.54663 3.99997 7.99996 3.99997ZM7.28663 4.75997L8.66663 6.13997C9.04663 6.30663 9.35329 6.6133 9.51996 6.9933L10.9 8.3733C10.9533 8.14663 10.9933 7.90663 10.9933 7.65997C11 6.00663 9.65329 4.66663 7.99996 4.66663C7.75329 4.66663 7.51996 4.69997 7.28663 4.75997ZM1.33996 2.57997L3.12663 4.36663C2.03996 5.21997 1.17996 6.3533 0.666626 7.66663C1.81996 10.5933 4.66663 12.6666 7.99996 12.6666C9.01329 12.6666 9.98663 12.4733 10.88 12.12L13.16 14.4L14.1 13.46L2.27996 1.6333L1.33996 2.57997ZM6.33996 7.57997L8.07996 9.31997C8.05329 9.32663 8.02663 9.3333 7.99996 9.3333C7.07996 9.3333 6.33329 8.58663 6.33329 7.66663C6.33329 7.6333 6.33996 7.6133 6.33996 7.57997ZM4.07329 5.3133L5.23996 6.47997C5.08663 6.84663 4.99996 7.24663 4.99996 7.66663C4.99996 9.31997 6.34663 10.6666 7.99996 10.6666C8.41996 10.6666 8.81996 10.58 9.17996 10.4266L9.83329 11.08C9.24663 11.24 8.63329 11.3333 7.99996 11.3333C5.47329 11.3333 3.21996 9.9133 2.11996 7.66663C2.58663 6.7133 3.26663 5.92663 4.07329 5.3133Z",
          fill: "#323232"
        }
      ) }),
      /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_400_3869", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
);
const TextInput = ({
  id,
  onChange: onChange2,
  onBlur,
  onFocus: onFocus2,
  type: type2 = "text",
  disabled: disabled2,
  hasError,
  icon: icon2,
  className,
  onMouseDown,
  onMouseUp,
  ariaLabel,
  revealPasswordIconAriaLabel,
  hidePasswordIconAriaLabel,
  maxCharacters,
  maxCharactersError,
  value: value2,
  inputRef,
  ...rest
}) => {
  const [focused, setFocused] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const ref2 = useRef(false);
  const inputRefLocal = useRef(null);
  useImperativeHandle(
    inputRef,
    () => {
      const htmlInputElement = inputRefLocal.current;
      return {
        ...htmlInputElement,
        focus: () => {
          if (!ref2.current) {
            setFocused(true);
          }
          htmlInputElement.focus();
          onFocus2?.(htmlInputElement.value, id);
        }
      };
    },
    []
  );
  const handleFocus = (e3) => {
    if (!ref2.current) {
      setFocused(true);
    }
    onFocus2?.(e3.target.value, id);
  };
  const handleBlur = (e3) => {
    setFocused(false);
    onBlur?.(e3.target.value, id);
  };
  const handleMouseUp = (e3) => {
    ref2.current = false;
    onMouseUp?.(e3);
  };
  const handleMouseDown = (e3) => {
    ref2.current = true;
    onMouseDown?.(e3);
  };
  const togglePasswordVisibility = () => {
    setPasswordVisibility((prevVal) => !prevVal);
  };
  const parsedType = getInputType(type2, passwordVisibility);
  const characterCounterValue = value2?.length || 0;
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      "data-testid": "text-input-wrapper",
      "aria-describedby": id,
      className: clsx(
        styles$n["sz-text-input"],
        focused && styles$n["sz-text-input_focused"],
        hasError && styles$n["sz-text-input_error"],
        disabled2 && styles$n["sz-text-input_disabled"],
        className
      ),
      children: /* @__PURE__ */ jsxs("div", { className: styles$n["sz-text-input__input-wrapper"], children: [
        /* @__PURE__ */ jsx$1(
          "input",
          {
            className: styles$n["sz-text-input__input-element"],
            onChange: (event) => !disabled2 && onChange2?.(event.target.value, id),
            onBlur: handleBlur,
            onFocus: handleFocus,
            type: parsedType,
            id,
            "aria-disabled": disabled2,
            onMouseUp: handleMouseUp,
            onMouseDown: handleMouseDown,
            "aria-label": ariaLabel,
            "aria-invalid": hasError,
            "aria-describedby": `input-label-${id}`,
            "aria-errormessage": `input-error-message-${id}`,
            value: value2,
            ref: inputRefLocal,
            ...rest
          }
        ),
        /* @__PURE__ */ jsx$1("div", { className: styles$n["sz-text-input__icon-wrapper"], children: icon2 }),
        type2 === "password" && /* @__PURE__ */ jsx$1(
          "button",
          {
            onClick: togglePasswordVisibility,
            className: styles$n["sz-text-input__password-visibility-button"],
            disabled: disabled2,
            "aria-pressed": passwordVisibility,
            "aria-controls": id,
            "aria-label": passwordVisibility ? hidePasswordIconAriaLabel || "Hide password text" : revealPasswordIconAriaLabel || "Reveal password text",
            "data-testid": "password-visibility-button",
            type: "button",
            children: passwordVisibility ? /* @__PURE__ */ jsx$1(
              VisibilityShowIcon,
              {
                className: styles$n["sz-text-input__password-visibility-icon"]
              }
            ) : /* @__PURE__ */ jsx$1(
              VisibilityIcon,
              {
                className: styles$n["sz-text-input__password-visibility-icon"]
              }
            )
          }
        ),
        maxCharacters && /* @__PURE__ */ jsxs(
          "div",
          {
            "data-testid": "text-input-character-counter",
            className: clsx(
              styles$n["sz-text-input__character-counter"],
              maxCharactersError && styles$n["sz-text-input__character-counter-error"]
            ),
            children: [
              characterCounterValue,
              "/",
              maxCharacters
            ]
          }
        )
      ] })
    }
  );
};
function getInputType(type2, passwordVisibility) {
  if (type2 !== "password") {
    return type2;
  }
  return passwordVisibility ? "text" : "password";
}
const overlay = "searchable-select-module_overlay__619Fu";
const inline = "searchable-select-module_inline__winzt";
const multiControl = "searchable-select-module_multiControl__yIV2k";
const error$4 = "searchable-select-module_error__vR4yJ";
const disabled$5 = "searchable-select-module_disabled__o6ijJ";
const chip = "searchable-select-module_chip__-hiQk";
const multiInput = "searchable-select-module_multiInput__rzd3-";
const actions$1 = "searchable-select-module_actions__gdF5r";
const iconButton = "searchable-select-module_iconButton__DOfQr";
const chevron$1 = "searchable-select-module_chevron__usG-8";
const chevronOpen = "searchable-select-module_chevronOpen__RalH7";
const content$2 = "searchable-select-module_content__5xehk";
const list = "searchable-select-module_list__deRK1";
const group = "searchable-select-module_group__4OXFC";
const groupLabel$1 = "searchable-select-module_groupLabel__zPatn";
const groupLabelLarge = "searchable-select-module_groupLabelLarge__BSCP5";
const groupCount = "searchable-select-module_groupCount__E92yo";
const separator$1 = "searchable-select-module_separator__wwLEn";
const item$2 = "searchable-select-module_item__OZXrO";
const itemActive = "searchable-select-module_itemActive__yVY0N";
const itemSelected = "searchable-select-module_itemSelected__GanK2";
const itemLabel$1 = "searchable-select-module_itemLabel__Ms08c";
const itemDisabled = "searchable-select-module_itemDisabled__NVmg0";
const itemIndicator$1 = "searchable-select-module_itemIndicator__rEciX";
const indicatorDot$1 = "searchable-select-module_indicatorDot__jU2ub";
const itemIcon$1 = "searchable-select-module_itemIcon__VX9vn";
const itemDescription = "searchable-select-module_itemDescription__EkLpN";
const empty = "searchable-select-module_empty__Z6un1";
const loading = "searchable-select-module_loading__cFbS2";
const styles$m = {
  overlay,
  inline,
  multiControl,
  error: error$4,
  disabled: disabled$5,
  chip,
  multiInput,
  actions: actions$1,
  iconButton,
  chevron: chevron$1,
  chevronOpen,
  content: content$2,
  list,
  group,
  groupLabel: groupLabel$1,
  groupLabelLarge,
  groupCount,
  separator: separator$1,
  item: item$2,
  itemActive,
  itemSelected,
  itemLabel: itemLabel$1,
  itemDisabled,
  itemIndicator: itemIndicator$1,
  indicatorDot: indicatorDot$1,
  itemIcon: itemIcon$1,
  itemDescription,
  empty,
  loading
};
function ChevronDownIcon$1({ className }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_5459_2088)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M11.06 5.72665L8 8.77999L4.94 5.72665L4 6.66665L8 10.6667L12 6.66665L11.06 5.72665Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_5459_2088", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
}
function ClearIcon({ className }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { "clip-path": "url(#clip0_14805_4618)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M12.6668 4.27337L11.7268 3.33337L8.00016 7.06004L4.2735 3.33337L3.3335 4.27337L7.06016 8.00004L3.3335 11.7267L4.2735 12.6667L8.00016 8.94004L11.7268 12.6667L12.6668 11.7267L8.94016 8.00004L12.6668 4.27337Z",
            fill: "#000B1A"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_14805_4618", children: /* @__PURE__ */ jsx$1("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
}
function SearchableSelectList({
  groups,
  baseId,
  selectedKeys,
  activeKey,
  onSelect,
  onHoverOption,
  emptyMessage,
  isLoading,
  largeGroupLabels,
  className
}) {
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      id: `${baseId}-listbox`,
      role: "listbox",
      "aria-busy": isLoading || void 0,
      className: clsx(styles$m.list, className),
      children: isLoading ? /* @__PURE__ */ jsx$1("div", { className: styles$m.loading, children: /* @__PURE__ */ jsx$1(Loader, { variant: "bubbles", size: "small" }) }) : groups.length === 0 ? /* @__PURE__ */ jsx$1("div", { className: styles$m.empty, children: emptyMessage }) : groups.map((group2, groupIndex) => /* @__PURE__ */ jsxs("div", { className: styles$m.group, children: [
        groupIndex > 0 && /* @__PURE__ */ jsx$1("div", { className: styles$m.separator }),
        group2.label && /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              styles$m.groupLabel,
              largeGroupLabels && styles$m.groupLabelLarge
            ),
            children: [
              group2.label,
              group2.showCount !== false && /* @__PURE__ */ jsxs("span", { className: styles$m.groupCount, children: [
                " ",
                "(",
                group2.options.length,
                ")"
              ] })
            ]
          }
        ),
        group2.options.map((option) => {
          const key = String(option.value);
          const isSelected = selectedKeys.has(key);
          const isActive2 = key === activeKey;
          return /* @__PURE__ */ jsxs(
            "div",
            {
              id: `${baseId}-option-${key}`,
              role: "option",
              "aria-selected": isSelected,
              "aria-disabled": option.disabled || void 0,
              className: clsx(
                styles$m.item,
                isActive2 && styles$m.itemActive,
                isSelected && styles$m.itemSelected,
                option.disabled && styles$m.itemDisabled
              ),
              onMouseEnter: () => {
                if (!option.disabled) onHoverOption(key);
              },
              onMouseDown: (event) => {
                if (option.disabled) return;
                event.preventDefault();
                onSelect(option.value);
              },
              children: [
                /* @__PURE__ */ jsx$1("span", { className: styles$m.itemIndicator, children: isSelected && /* @__PURE__ */ jsx$1("span", { className: styles$m.indicatorDot }) }),
                option.icon && /* @__PURE__ */ jsx$1("span", { className: styles$m.itemIcon, children: option.icon }),
                /* @__PURE__ */ jsx$1("span", { className: styles$m.itemLabel, children: option.label }),
                option.description && /* @__PURE__ */ jsxs("span", { className: styles$m.itemDescription, children: [
                  /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", children: "•" }),
                  " ",
                  option.description
                ] })
              ]
            },
            key
          );
        })
      ] }, group2.label ?? groupIndex))
    }
  );
}
function matchesQuery(option, query) {
  const lowercaseQuery = query.toLowerCase();
  const haystacks = [
    option.label,
    option.description,
    option.note,
    ...option.keywords ?? []
  ];
  return haystacks.some(
    (text2) => text2 != null && text2.toLowerCase().includes(lowercaseQuery)
  );
}
function toArray(value2) {
  if (value2 === void 0) return [];
  return Array.isArray(value2) ? value2 : [value2];
}
function stripOnChange(input2) {
  const { onChange: onChange2, ...rest } = input2;
  return rest;
}
function keyToValue(groups, key) {
  for (const group2 of groups) {
    for (const option of group2.options) {
      if (String(option.value) === key) return option.value;
    }
  }
  return key;
}
function SearchableSelect(props) {
  const {
    options: options2,
    groups,
    value: value2,
    defaultValue,
    inline: inline2 = false,
    placeholder: placeholder2 = "",
    searchPlaceholder = "Search",
    label: label2,
    alwaysShowLabel = false,
    largeGroupLabels = false,
    emptyMessage = "No results",
    noMatchesMessage = "No matches",
    isLoading = false,
    defaultOpen = false,
    clearable = true,
    keepSelectedInPlace = false,
    disableFilter = false,
    disabled: disabled2,
    error: error2,
    className,
    contentClassName,
    align = "start",
    sideOffset = 0,
    id,
    "aria-label": ariaLabel,
    multiselect,
    onInputChange,
    onValueChange
  } = props;
  const maxChipChars = multiselect ? props.maxChipChars : void 0;
  const maxChipsToShow = multiselect ? props.maxSelectedElementsToShow ?? 3 : 3;
  const generatedId = useId$2();
  const baseId = id ?? generatedId;
  const inputId = `${baseId}-input`;
  const isControlled = value2 !== void 0;
  const [internalValue, setInternalValue] = useState(
    () => toArray(defaultValue)
  );
  const [open2, setOpen] = useState(defaultOpen);
  const [query, setQuery] = useState("");
  const [userTyped, setUserTyped] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const inputRef = useRef(null);
  const controlRef = useRef(null);
  const selectedList = isControlled ? toArray(value2) : internalValue;
  const effectiveOpen = inline2 || open2;
  const { normalisedGroups, optionByKey } = useMemo(() => {
    const allGroups = [
      ...options2 ? [{ options: options2 }] : [],
      ...groups ?? []
    ];
    const map = /* @__PURE__ */ new Map();
    allGroups.forEach(
      (group2) => group2.options.forEach((option) => map.set(String(option.value), option))
    );
    return { normalisedGroups: allGroups, optionByKey: map };
  }, [options2, groups]);
  const selectedKeys = useMemo(
    () => new Set(selectedList.map(String)),
    [selectedList]
  );
  const selectedOptions = useMemo(
    () => selectedList.map((v2) => optionByKey.get(String(v2))).filter((o2) => o2 !== void 0),
    [selectedList, optionByKey]
  );
  const selectedOption = selectedOptions[0];
  const { filteredGroups, navigableKeys } = useMemo(() => {
    const normalisedQuery = query.trim().toLowerCase();
    const shouldFilter = !disableFilter && userTyped && normalisedQuery !== "";
    const visibleGroups = [];
    const keys = [];
    normalisedGroups.forEach((group2) => {
      let groupOptions = shouldFilter ? group2.options.filter((option) => matchesQuery(option, normalisedQuery)) : group2.options;
      if (groupOptions.length === 0) return;
      if (!keepSelectedInPlace && selectedKeys.size > 0) {
        const selected2 = groupOptions.filter(
          (o2) => selectedKeys.has(String(o2.value))
        );
        if (selected2.length > 0 && selected2.length < groupOptions.length) {
          groupOptions = [
            ...selected2,
            ...groupOptions.filter((o2) => !selectedKeys.has(String(o2.value)))
          ];
        }
      }
      visibleGroups.push({ ...group2, options: groupOptions });
      groupOptions.forEach((option) => {
        if (!option.disabled) keys.push(String(option.value));
      });
    });
    return { filteredGroups: visibleGroups, navigableKeys: keys };
  }, [
    normalisedGroups,
    query,
    disableFilter,
    userTyped,
    selectedKeys,
    keepSelectedInPlace
  ]);
  useEffect(() => {
    setActiveIndex(
      (current) => navigableKeys.length === 0 ? -1 : Math.min(current, navigableKeys.length - 1)
    );
  }, [navigableKeys.length]);
  useEffect(() => {
    if (!open2 || multiselect) return;
    const inputEl = document.getElementById(inputId);
    inputEl?.select();
  }, [open2, multiselect, inputId]);
  const activeKey = navigableKeys[activeIndex];
  const activeDescendant = effectiveOpen && activeKey ? `${baseId}-option-${activeKey}` : void 0;
  const emit = (nextList) => {
    if (!isControlled) setInternalValue(nextList);
    if (multiselect) {
      onValueChange?.(nextList);
    } else {
      onValueChange?.(nextList[0]);
    }
  };
  const updateQuery = (next2) => {
    setQuery(next2);
    setActiveIndex(0);
    onInputChange?.(next2);
  };
  const openMenu = () => {
    if (disabled2 || open2) return;
    setQuery(multiselect ? "" : selectedOption?.label ?? "");
    setUserTyped(false);
    setActiveIndex(0);
    setOpen(true);
  };
  const closeMenu = () => {
    setOpen(false);
    setQuery("");
    setUserTyped(false);
  };
  const handleSelect = (next2) => {
    if (multiselect) {
      const key = String(next2);
      const exists = selectedKeys.has(key);
      emit(
        exists ? selectedList.filter((v2) => String(v2) !== key) : [...selectedList, next2]
      );
      setQuery("");
      setUserTyped(false);
      setActiveIndex(-1);
      inputRef.current?.focus();
      return;
    }
    emit([next2]);
    setQuery("");
    setUserTyped(false);
    setActiveIndex(-1);
    if (!inline2) closeMenu();
    blurInput();
  };
  const removeValue = (target) => {
    emit(selectedList.filter((v2) => String(v2) !== String(target)));
    inputRef.current?.focus();
  };
  const clearAll = () => {
    emit([]);
    if (multiselect) {
      inputRef.current?.focus();
    } else {
      closeMenu();
      blurInput();
    }
  };
  const selectInputText = () => {
    requestAnimationFrame(() => {
      const el = document.getElementById(inputId);
      el?.select();
    });
  };
  const blurInput = () => {
    const el = document.getElementById(inputId);
    el?.blur();
  };
  const moveActive = (delta) => {
    const count2 = navigableKeys.length;
    if (count2 === 0) return;
    setActiveIndex((current) => {
      const next2 = current < 0 ? delta > 0 ? 0 : count2 - 1 : (current + delta + count2) % count2;
      document.getElementById(`${baseId}-option-${navigableKeys[next2]}`)?.scrollIntoView({ block: "nearest" });
      return next2;
    });
  };
  const handleKeyDown = (event) => {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        if (!effectiveOpen) openMenu();
        else moveActive(1);
        break;
      case "ArrowUp":
        event.preventDefault();
        if (effectiveOpen) moveActive(-1);
        break;
      case "Enter":
        if (effectiveOpen && activeKey) {
          event.preventDefault();
          handleSelect(keyToValue(filteredGroups, activeKey));
        }
        break;
      case "Backspace":
        if (multiselect && clearable && query === "" && selectedList.length > 0) {
          removeValue(selectedList[selectedList.length - 1]);
        }
        break;
      case "Escape":
        if (!inline2 && open2) {
          event.preventDefault();
          event.stopPropagation();
          closeMenu();
        }
        break;
    }
  };
  const hasSelection = selectedList.length > 0;
  const inputValue = multiselect ? query : userTyped ? query : selectedOption?.label ?? "";
  const inputPlaceholder = hasSelection ? "" : inline2 || open2 ? searchPlaceholder : placeholder2;
  const hasInputContent = multiselect ? hasSelection || query !== "" : inputValue !== "";
  const displayLabel = !!label2 && (alwaysShowLabel || hasInputContent);
  const chevron2 = !inline2 && /* @__PURE__ */ jsx$1(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: styles$m.iconButton,
      "aria-label": open2 ? "Close menu" : "Open menu",
      disabled: disabled2,
      onMouseDown: (event) => {
        event.preventDefault();
        if (open2) {
          closeMenu();
        } else {
          inputRef.current?.focus();
          openMenu();
        }
      },
      children: /* @__PURE__ */ jsx$1(
        ChevronDownIcon$1,
        {
          className: clsx(styles$m.chevron, open2 && styles$m.chevronOpen)
        }
      )
    }
  );
  const clearButton = clearable && hasSelection && !disabled2 && /* @__PURE__ */ jsx$1(
    "button",
    {
      type: "button",
      className: styles$m.iconButton,
      "aria-label": "Clear selection",
      onMouseDown: (event) => {
        event.preventDefault();
        event.stopPropagation();
        clearAll();
      },
      children: /* @__PURE__ */ jsx$1(ClearIcon, {})
    }
  );
  const sharedInputProps = {
    id: inputId,
    value: inputValue,
    placeholder: inputPlaceholder,
    disabled: disabled2,
    autoComplete: "off",
    role: "combobox",
    "aria-expanded": effectiveOpen,
    "aria-controls": `${baseId}-listbox`,
    "aria-activedescendant": activeDescendant,
    "aria-autocomplete": "list",
    "aria-label": ariaLabel,
    onKeyDown: handleKeyDown,
    onFocus: () => {
      if (!inline2) {
        openMenu();
      } else if (!multiselect) {
        selectInputText();
      }
    },
    onClick: () => {
      if (!inline2 && !open2) openMenu();
    },
    onChange: (next2) => {
      if (!inline2 && !open2) setOpen(true);
      setUserTyped(true);
      updateQuery(next2);
      if (!multiselect && next2 === "" && selectedList.length > 0) {
        emit([]);
      }
    }
  };
  const control = multiselect ? /* @__PURE__ */ jsx$1(
    FieldLabel,
    {
      id: inputId,
      label: label2,
      displayLabel,
      hasError: !!error2,
      disabled: disabled2,
      bottomText: error2,
      renderBottomText: !!error2,
      preventLableClickEvent: true,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: clsx(
            styles$m.multiControl,
            error2 && styles$m.error,
            disabled2 && styles$m.disabled
          ),
          onMouseDown: (event) => {
            if (event.target === event.currentTarget) inputRef.current?.focus();
          },
          children: [
            selectedOptions.slice(0, maxChipsToShow).map((option) => /* @__PURE__ */ jsx$1(
              Chip,
              {
                className: styles$m.chip,
                fixed: !clearable,
                disabled: disabled2,
                ariaLabel: option.label,
                icon: option.icon,
                maxChars: maxChipChars,
                onClick: clearable ? (event) => {
                  event.stopPropagation();
                  removeValue(option.value);
                } : void 0,
                children: option.label
              },
              String(option.value)
            )),
            selectedOptions.length > maxChipsToShow && /* @__PURE__ */ jsx$1(Chip, { className: styles$m.chip, fixed: true, disabled: disabled2, children: `+ ${selectedOptions.length - maxChipsToShow}` }),
            /* @__PURE__ */ jsx$1(
              "input",
              {
                ref: inputRef,
                className: styles$m.multiInput,
                onChange: (event) => sharedInputProps.onChange(event.target.value),
                ...stripOnChange(sharedInputProps)
              }
            ),
            chevron2
          ]
        }
      )
    }
  ) : /* @__PURE__ */ jsx$1(
    FieldLabel,
    {
      id: inputId,
      label: label2,
      displayLabel,
      hasError: !!error2,
      disabled: disabled2,
      bottomText: error2,
      renderBottomText: !!error2,
      preventLableClickEvent: true,
      children: /* @__PURE__ */ jsx$1(
        TextInput,
        {
          hasError: !!error2,
          ariaLabel,
          inputRef,
          icon: /* @__PURE__ */ jsxs("span", { className: styles$m.actions, children: [
            clearButton,
            chevron2
          ] }),
          onChange: (next2) => sharedInputProps.onChange(next2),
          ...stripOnChange(sharedInputProps)
        }
      )
    }
  );
  const list2 = /* @__PURE__ */ jsx$1(
    SearchableSelectList,
    {
      groups: filteredGroups,
      baseId,
      selectedKeys,
      activeKey,
      onSelect: handleSelect,
      onHoverOption: (key) => {
        const navIndex = navigableKeys.indexOf(key);
        if (navIndex !== -1) setActiveIndex(navIndex);
      },
      isLoading,
      emptyMessage: normalisedGroups.some((group2) => group2.options.length > 0) ? noMatchesMessage : emptyMessage,
      largeGroupLabels
    }
  );
  if (inline2) {
    return /* @__PURE__ */ jsxs("div", { className: clsx(styles$m.inline, className, contentClassName), children: [
      control,
      list2
    ] });
  }
  return /* @__PURE__ */ jsxs(RadixPopover.Root, { open: open2, onOpenChange: setOpen, modal: false, children: [
    /* @__PURE__ */ jsx$1(RadixPopover.Anchor, { asChild: true, children: /* @__PURE__ */ jsx$1("div", { ref: controlRef, className: clsx(styles$m.overlay, className), children: control }) }),
    /* @__PURE__ */ jsx$1(RadixPopover.Portal, { children: /* @__PURE__ */ jsx$1(
      RadixPopover.Content,
      {
        className: clsx(styles$m.content, contentClassName),
        align,
        sideOffset,
        onOpenAutoFocus: (event) => event.preventDefault(),
        onCloseAutoFocus: (event) => event.preventDefault(),
        onInteractOutside: (event) => {
          if (controlRef.current?.contains(event.target)) {
            event.preventDefault();
          }
        },
        children: list2
      }
    ) })
  ] });
}
const root$3 = "segmented-control-module_root__MZjDJ";
const item$1 = "segmented-control-module_item__q4fTX";
const small$2 = "segmented-control-module_small__zZ7mi";
const medium$2 = "segmented-control-module_medium__aKGr9";
const large$1 = "segmented-control-module_large__BQjBD";
const styles$l = {
  root: root$3,
  item: item$1,
  small: small$2,
  medium: medium$2,
  large: large$1
};
const SegmentedControlRoot = React__default.forwardRef(
  ({
    className,
    size = "medium",
    value: valueProp,
    defaultValue,
    onValueChange,
    ...props
  }, ref2) => {
    const isControlled = valueProp !== void 0;
    const [internalValue, setInternalValue] = React__default.useState(defaultValue);
    const value2 = isControlled ? valueProp : internalValue;
    const handleValueChange = (next2) => {
      if (!next2) {
        return;
      }
      if (!isControlled) {
        setInternalValue(next2);
      }
      onValueChange?.(next2);
    };
    return /* @__PURE__ */ jsx$1(
      ToggleGroup.Root,
      {
        ref: ref2,
        type: "single",
        value: value2,
        onValueChange: handleValueChange,
        className: clsx(styles$l.root, styles$l[size], className),
        ...props
      }
    );
  }
);
SegmentedControlRoot.displayName = "SegmentedControl.Root";
const SegmentedControlItem = React__default.forwardRef(({ className, children, ...props }, ref2) => /* @__PURE__ */ jsx$1(
  ToggleGroup.Item,
  {
    ref: ref2,
    className: clsx(styles$l.item, className),
    ...props,
    children
  }
));
SegmentedControlItem.displayName = "SegmentedControl.Item";
const SegmentedControl = {
  Root: SegmentedControlRoot,
  Item: SegmentedControlItem
};
const SCALE_RAMP = [
  {
    background: "var(--color-amber-back, #fff6ea)",
    color: "var(--color-front, #00204d)"
  },
  {
    background: "var(--color-amber-back-dark, #ffedd5)",
    color: "var(--color-front, #00204d)"
  },
  {
    background: "var(--color-green-front-light, #339d8f)",
    color: "#fff"
  },
  { background: "var(--color-green-front, #007a6a)", color: "#fff" },
  {
    background: "color-mix(in oklab, var(--color-green-front, #007a6a) 78%, var(--color-front-dark, #000b1a))",
    color: "#fff"
  }
];
const NEUTRAL_SCALE_COLOR = {
  background: "var(--color-disabled-back, #ebf0f7)",
  color: "var(--color-front, #00204d)"
};
function sampleScaleRamp(index2, count2, override) {
  const stops = override && override.length ? override : SCALE_RAMP;
  if (count2 <= 1) {
    return stops[stops.length - 1];
  }
  const i3 = Math.round(index2 * (stops.length - 1) / (count2 - 1));
  return stops[Math.max(0, Math.min(stops.length - 1, i3))];
}
const SEGMENTED_SCALE_SIZES = [
  "small",
  "medium"
];
const WARN_PREFIX$1 = "[SegmentedScale]";
const toKey = (value2) => String(value2);
const hasLabel = (label2) => label2 !== void 0 && label2 !== null && label2 !== "";
const labelLength = (label2) => typeof label2 === "string" ? label2.length : label2 === void 0 || label2 === null ? 0 : String(label2).length;
function compactCells(cells) {
  const shortCells = cells.filter(
    (c3) => !c3.icon && labelLength(c3.label) > 0 && labelLength(c3.label) <= 2
  ).length;
  const compact2 = /* @__PURE__ */ new Set();
  if (shortCells >= 2) {
    cells.forEach((c3) => {
      if (!c3.icon && labelLength(c3.label) > 2) {
        compact2.add(c3.key);
      }
    });
  }
  return compact2;
}
function scalePositions(cells) {
  const index2 = /* @__PURE__ */ new Map();
  let count2 = 0;
  cells.forEach((c3) => {
    index2.set(c3.key, c3.excludeFromScale ? -1 : count2++);
  });
  return { index: index2, count: count2 };
}
const SegmentedScaleContext = React__default.createContext(null);
function useSegmentedScaleContext() {
  const ctx = React__default.useContext(SegmentedScaleContext);
  if (!ctx) {
    throw new Error(
      "SegmentedScale.Item must be rendered inside SegmentedScale.Root"
    );
  }
  return ctx;
}
const root$2 = "segmented-scale-module_root__Tu2Ak";
const fullWidth = "segmented-scale-module_fullWidth__o87YD";
const cell = "segmented-scale-module_cell__mCdgn";
const readOnly = "segmented-scale-module_readOnly__VU0GD";
const scaled = "segmented-scale-module_scaled__XltGC";
const selected$2 = "segmented-scale-module_selected__0qZx8";
const dimmed = "segmented-scale-module_dimmed__K7ffJ";
const icon$1 = "segmented-scale-module_icon__KxVST";
const small$1 = "segmented-scale-module_small__7KCUX";
const iconOnly = "segmented-scale-module_iconOnly__lW6J2";
const medium$1 = "segmented-scale-module_medium__eQT9b";
const compact = "segmented-scale-module_compact__SEKDy";
const wrap = "segmented-scale-module_wrap__ccJ7f";
const wrapRow = "segmented-scale-module_wrapRow__jyWV7";
const selectedLabel = "segmented-scale-module_selectedLabel__c-xEH";
const styles$k = {
  root: root$2,
  fullWidth,
  cell,
  readOnly,
  scaled,
  selected: selected$2,
  dimmed,
  icon: icon$1,
  small: small$1,
  iconOnly,
  medium: medium$1,
  compact,
  wrap,
  wrapRow,
  selectedLabel
};
function SegmentedScaleItem({
  value: value2,
  label: labelProp,
  children,
  icon: icon2,
  tooltip: tooltip2,
  ariaLabel,
  disabled: disabled2
}) {
  const { showScale, readOnly: readOnly2, disableNonSelected, cells } = useSegmentedScaleContext();
  const key = toKey(value2);
  const state = cells.get(key) ?? { selected: false, compact: false };
  const label2 = labelProp !== void 0 ? labelProp : children;
  const iconOnly2 = !!icon2 && !hasLabel(label2);
  const dim = disableNonSelected && !state.selected;
  const style2 = state.stop ? {
    "--segmented-scale-bg": state.stop.background,
    "--segmented-scale-fg": state.stop.color
  } : void 0;
  return /* @__PURE__ */ jsxs(
    ToggleGroup.Item,
    {
      value: key,
      disabled: disabled2,
      className: clsx(
        styles$k.cell,
        readOnly2 && styles$k.readOnly,
        state.selected && !showScale && styles$k.selected,
        state.selected && showScale && styles$k.scaled,
        dim && styles$k.dimmed,
        state.compact && styles$k.compact,
        iconOnly2 && styles$k.iconOnly
      ),
      style: style2,
      "aria-label": ariaLabel || (typeof label2 === "string" ? void 0 : key),
      "data-tooltip-content": tooltip2 || void 0,
      "data-testid": `segmented-scale-cell-${key}`,
      children: [
        icon2 ? /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", className: styles$k.icon, children: icon2 }) : null,
        hasLabel(label2) ? /* @__PURE__ */ jsx$1("span", { children: label2 }) : null
      ]
    }
  );
}
SegmentedScaleItem.displayName = "SegmentedScale.Item";
function SegmentedScaleRoot({
  children,
  ...props
}) {
  const {
    showScale: showScaleProp,
    scaleColors,
    showSelectedLabel,
    size: sizeProp,
    readOnly: readOnly2 = false,
    disabled: disabled2 = false,
    disableNonSelected = false,
    fullWidth: fullWidth2,
    ariaLabel,
    id,
    className,
    dataTestid
  } = props;
  const multiple = props.multiple === true;
  const isControlled = props.value !== void 0;
  const showScale = !!showScaleProp && !multiple;
  const size = sizeProp && SEGMENTED_SCALE_SIZES.includes(sizeProp) ? sizeProp : "small";
  const [uncontrolled, setUncontrolled] = useState(
    () => props.defaultValue !== void 0 ? props.defaultValue : multiple ? [] : void 0
  );
  const value2 = isControlled ? props.value : uncontrolled;
  const autoId = useId$2();
  const groupId = id || `segmented-scale-${autoId}`;
  const rootRef = useRef(null);
  const warnedOverflow = useRef(false);
  useEffect(() => {
    if (sizeProp && !SEGMENTED_SCALE_SIZES.includes(sizeProp)) {
      console.warn(
        `${WARN_PREFIX$1} unknown size "${sizeProp}" — falling back to "small". Only "small" and "medium" exist.`
      );
    }
  }, [sizeProp]);
  useEffect(() => {
    if (showScaleProp && multiple) {
      console.warn(
        `${WARN_PREFIX$1} \`showScale\` is ignored with \`multiple\`: a ramp asserts one position on one axis.`
      );
    }
  }, [showScaleProp, multiple]);
  useEffect(() => {
    const el = rootRef.current;
    if (!el || warnedOverflow.current) {
      return;
    }
    const overflow = el.scrollWidth - el.clientWidth;
    if (overflow > 1) {
      warnedOverflow.current = true;
      console.warn(
        `${WARN_PREFIX$1} overflows its container by ${overflow}px. A SegmentedScale is always one row — it never wraps. Either this is the wrong component (too many options → Select; too many steps → Slider), or reduce \`size\` / shorten labels so it fits.`
      );
    }
  });
  const cells = useMemo(() => {
    const list2 = [];
    Children.forEach(children, (child) => {
      if (!isValidElement(child)) {
        return;
      }
      if (child.type !== SegmentedScaleItem) {
        return;
      }
      const {
        value: v2,
        label: label2,
        children: itemChildren,
        icon: icon2,
        tooltip: tooltip22,
        excludeFromScale
      } = child.props;
      list2.push({
        key: toKey(v2),
        value: v2,
        label: label2 !== void 0 ? label2 : itemChildren,
        icon: icon2,
        tooltip: tooltip22,
        excludeFromScale
      });
    });
    return list2;
  }, [children]);
  const cellByKey = useMemo(
    () => new Map(cells.map((c3) => [c3.key, c3])),
    [cells]
  );
  const isSelected = (v2) => multiple ? Array.isArray(value2) && value2.includes(v2) : value2 === v2;
  const commit = (next2) => {
    if (!isControlled) {
      setUncontrolled(next2);
    }
    props.onChange?.(next2);
  };
  const handleSingleChange = (nextKey) => {
    if (readOnly2) {
      return;
    }
    if (nextKey === "") {
      if (props.deselectable) {
        commit(void 0);
      }
      return;
    }
    const cell2 = cellByKey.get(nextKey);
    if (cell2) {
      commit(cell2.value);
    }
  };
  const handleMultipleChange = (nextKeys) => {
    if (readOnly2) {
      return;
    }
    commit(
      nextKeys.map((k3) => cellByKey.get(k3)?.value).filter((v2) => v2 !== void 0)
    );
  };
  const compact2 = compactCells(cells);
  const scale = scalePositions(cells);
  const cellStates = /* @__PURE__ */ new Map();
  cells.forEach((c3) => {
    const selected2 = isSelected(c3.value);
    let stop;
    if (showScale && selected2) {
      stop = c3.excludeFromScale ? NEUTRAL_SCALE_COLOR : sampleScaleRamp(
        scale.index.get(c3.key) ?? 0,
        scale.count,
        scaleColors
      );
    }
    cellStates.set(c3.key, { selected: selected2, stop, compact: compact2.has(c3.key) });
  });
  const selectedCell = cells.filter((c3) => isSelected(c3.value)).pop();
  const anyTooltip = cells.some((c3) => !!c3.tooltip);
  const context = {
    size,
    showScale,
    readOnly: readOnly2,
    disableNonSelected,
    cells: cellStates
  };
  const rootProps = {
    ref: rootRef,
    id: groupId,
    className: clsx(
      styles$k.root,
      styles$k[size],
      fullWidth2 && styles$k.fullWidth,
      className
    ),
    disabled: disabled2,
    "aria-label": ariaLabel,
    "aria-disabled": disabled2 ? true : void 0,
    "aria-readonly": readOnly2 ? true : void 0,
    "data-testid": dataTestid
  };
  const group2 = /* @__PURE__ */ jsx$1(SegmentedScaleContext.Provider, { value: context, children: multiple ? /* @__PURE__ */ jsx$1(
    ToggleGroup.Root,
    {
      type: "multiple",
      role: "group",
      value: Array.isArray(value2) ? value2.map(toKey) : [],
      onValueChange: handleMultipleChange,
      ...rootProps,
      children
    }
  ) : /* @__PURE__ */ jsx$1(
    ToggleGroup.Root,
    {
      type: "single",
      value: value2 === void 0 ? "" : toKey(value2),
      onValueChange: handleSingleChange,
      ...rootProps,
      children
    }
  ) });
  const tooltip2 = anyTooltip ? /* @__PURE__ */ jsx$1(
    Tooltip$3,
    {
      anchorSelect: `[id="${groupId}"] [data-tooltip-content]`,
      place: "top",
      dataTestid: "segmented-scale-tooltip",
      render: ({ activeAnchor }) => activeAnchor ? activeAnchor.getAttribute("data-tooltip-content") : null
    }
  ) : null;
  if (!showSelectedLabel) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      group2,
      tooltip2
    ] });
  }
  const selectedLabel2 = selectedCell ? selectedCell.tooltip || (typeof selectedCell.label === "string" ? selectedCell.label : " ") : " ";
  return /* @__PURE__ */ jsxs("div", { className: styles$k.wrap, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$k.wrapRow, children: [
      group2,
      tooltip2
    ] }),
    /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$k.selectedLabel,
        "data-testid": "segmented-scale-selected-label",
        children: selectedLabel2
      }
    )
  ] });
}
SegmentedScaleRoot.displayName = "SegmentedScale.Root";
function SegmentedScaleBase({
  options: options2,
  ...props
}) {
  return /* @__PURE__ */ jsx$1(SegmentedScaleRoot, { ...props, children: (options2 || []).map((option) => /* @__PURE__ */ jsx$1(SegmentedScaleItem, { ...option }, toKey(option.value))) });
}
SegmentedScaleBase.displayName = "SegmentedScale";
const SegmentedScale = Object.assign(SegmentedScaleBase, {
  Root: SegmentedScaleRoot,
  Item: SegmentedScaleItem
});
const trigger = "select-menu-module_trigger__IIDzd";
const error$3 = "select-menu-module_error__jj1PO";
const disabled$4 = "select-menu-module_disabled__IXwWO";
const chevron = "select-menu-module_chevron__-mnCa";
const triggerIcon = "select-menu-module_triggerIcon__1aLad";
const triggerLabel = "select-menu-module_triggerLabel__TL2az";
const placeholder = "select-menu-module_placeholder__BBhlm";
const content$1 = "select-menu-module_content__c-V8n";
const groupLabel = "select-menu-module_groupLabel__toA8S";
const item = "select-menu-module_item__5yA5e";
const itemLabel = "select-menu-module_itemLabel__m47VL";
const itemIndicator = "select-menu-module_itemIndicator__u5PgB";
const indicatorDot = "select-menu-module_indicatorDot__nN3kk";
const itemIcon = "select-menu-module_itemIcon__uRsKC";
const separator = "select-menu-module_separator__iimMP";
const styles$j = {
  trigger,
  error: error$3,
  disabled: disabled$4,
  chevron,
  triggerIcon,
  triggerLabel,
  placeholder,
  content: content$1,
  groupLabel,
  item,
  itemLabel,
  itemIndicator,
  indicatorDot,
  itemIcon,
  separator
};
function SelectMenu({
  options: options2,
  groups,
  value: value2,
  defaultValue,
  onValueChange,
  placeholder: placeholder2,
  triggerIcon: triggerIcon2,
  triggerLabel: triggerLabel2,
  disabled: disabled2,
  error: error2,
  className,
  contentClassName,
  align = "start",
  sideOffset = 0,
  id,
  "aria-label": ariaLabel
}) {
  const isControlled = value2 !== void 0;
  const [internalValue, setInternalValue] = useState(
    defaultValue
  );
  const selectedValue = isControlled ? value2 : internalValue;
  const { normalisedGroups, keyToValue: keyToValue2, selectedOption } = useMemo(() => {
    const allGroups = [
      ...options2 ? [{ options: options2 }] : [],
      ...groups ?? []
    ];
    const map = /* @__PURE__ */ new Map();
    let selected2;
    allGroups.forEach((group2) => {
      group2.options.forEach((option) => {
        const key = String(option.value);
        map.set(key, option.value);
        if (selectedValue !== void 0 && String(selectedValue) === key) {
          selected2 = option;
        }
      });
    });
    return {
      normalisedGroups: allGroups,
      keyToValue: map,
      selectedOption: selected2
    };
  }, [options2, groups, selectedValue]);
  const handleValueChange = (key) => {
    const nextValue = keyToValue2.get(key);
    if (nextValue === void 0) return;
    if (!isControlled) setInternalValue(nextValue);
    onValueChange?.(nextValue);
  };
  const selectedKey = selectedValue !== void 0 ? String(selectedValue) : void 0;
  const triggerContent = triggerLabel2 ?? selectedOption?.label ?? placeholder2 ?? "";
  return /* @__PURE__ */ jsxs(RadixDropdownMenu.Root, { modal: false, children: [
    /* @__PURE__ */ jsx$1(RadixDropdownMenu.Trigger, { asChild: true, disabled: disabled2, children: /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        id,
        "aria-label": ariaLabel,
        className: clsx(
          styles$j.trigger,
          error2 && styles$j.error,
          disabled2 && styles$j.disabled,
          className
        ),
        children: [
          triggerIcon2 && /* @__PURE__ */ jsx$1("span", { className: styles$j.triggerIcon, children: triggerIcon2 }),
          /* @__PURE__ */ jsx$1(
            "span",
            {
              className: clsx(
                styles$j.triggerLabel,
                !selectedOption && !triggerLabel2 && styles$j.placeholder
              ),
              children: triggerContent
            }
          ),
          /* @__PURE__ */ jsx$1(ChevronDownIcon$1, { className: styles$j.chevron })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx$1(RadixDropdownMenu.Portal, { children: /* @__PURE__ */ jsx$1(
      RadixDropdownMenu.Content,
      {
        className: clsx(styles$j.content, contentClassName),
        align,
        sideOffset,
        children: /* @__PURE__ */ jsx$1(
          RadixDropdownMenu.RadioGroup,
          {
            value: selectedKey,
            onValueChange: handleValueChange,
            children: normalisedGroups.map((group2, groupIndex) => /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
              groupIndex > 0 && /* @__PURE__ */ jsx$1(RadixDropdownMenu.Separator, { className: styles$j.separator }),
              group2.label && /* @__PURE__ */ jsx$1(RadixDropdownMenu.Label, { className: styles$j.groupLabel, children: group2.label }),
              group2.options.map((option) => /* @__PURE__ */ jsxs(
                RadixDropdownMenu.RadioItem,
                {
                  value: String(option.value),
                  disabled: option.disabled,
                  className: styles$j.item,
                  children: [
                    /* @__PURE__ */ jsx$1("span", { className: styles$j.itemIndicator, children: /* @__PURE__ */ jsx$1(RadixDropdownMenu.ItemIndicator, { children: /* @__PURE__ */ jsx$1("span", { className: styles$j.indicatorDot }) }) }),
                    option.icon && /* @__PURE__ */ jsx$1("span", { className: styles$j.itemIcon, children: option.icon }),
                    /* @__PURE__ */ jsx$1("span", { className: styles$j.itemLabel, children: option.label })
                  ]
                },
                String(option.value)
              ))
            ] }, groupIndex))
          }
        )
      }
    ) })
  ] });
}
const CustomInput = (props) => {
  const { ariaDisabled, menuIsOpen, id } = props.selectProps;
  const handleChangePrevention = (e3) => {
    if (ariaDisabled) {
      e3.preventDefault();
      e3.stopPropagation();
      return;
    }
  };
  return /* @__PURE__ */ jsx$1(
    components.Input,
    {
      tabIndex: 0,
      role: "combobox",
      "aria-expanded": menuIsOpen,
      "aria-controls": id,
      autoComplete: "off",
      autoCorrect: "off",
      spellCheck: "false",
      "aria-disabled": ariaDisabled,
      onKeyDown: handleChangePrevention,
      ...props
    }
  );
};
const selectOption = "select-module_selectOption__FmcU5";
const circle = "select-module_circle__HxTLp";
const labelWrapper = "select-module_labelWrapper__V9nGA";
const labelWrapperWithTag = "select-module_labelWrapperWithTag__fGRq7";
const label$3 = "select-module_label__ay-3s";
const labelIconWrapper = "select-module_labelIconWrapper__PqHoY";
const selectOptionNote = "select-module_selectOptionNote__MbJe-";
const labelDescriptionContainer = "select-module_labelDescriptionContainer__nkq0R";
const labelDescriptionWrapper = "select-module_labelDescriptionWrapper__KgasE";
const labelDescription = "select-module_labelDescription__rT732";
const labelCounter = "select-module_labelCounter__FfV7S";
const labelCounterContent = "select-module_labelCounterContent__s9TuZ";
const labelCounterIcon = "select-module_labelCounterIcon__5h4gg";
const selectNoMatches = "select-module_selectNoMatches__lq9Wy";
const selectLoadMore = "select-module_selectLoadMore__SSymv";
const paginatedOptionsLoader = "select-module_paginatedOptionsLoader__R5Snv";
const clearValueButton = "select-module_clearValueButton__XoaQI";
const truncatedLabel = "select-module_truncatedLabel__ZFBor";
const styles$i = {
  selectOption,
  circle,
  labelWrapper,
  labelWrapperWithTag,
  label: label$3,
  labelIconWrapper,
  selectOptionNote,
  labelDescriptionContainer,
  labelDescriptionWrapper,
  labelDescription,
  labelCounter,
  labelCounterContent,
  labelCounterIcon,
  selectNoMatches,
  selectLoadMore,
  paginatedOptionsLoader,
  clearValueButton,
  truncatedLabel
};
const AVG_CHAR_WIDTH_AT_12px = 6;
const CustomOption = (props) => {
  const { label: label2, data, isSelected, isDisabled } = props;
  const labelContainerRef = useRef(null);
  const labelDescriptionRef = useRef(null);
  const [shouldTruncate, setShouldTruncate] = React__default.useState(false);
  const [remainingSpaceForLabel, setRemainingSpaceForLabel] = React__default.useState(0);
  useLayoutEffect$1(() => {
    if (!label2 || !labelContainerRef.current || !labelDescriptionRef.current || labelDescriptionRef?.current?.clientWidth === 0)
      return;
    const dropdownOptionWidth = labelContainerRef.current.clientWidth;
    const dropdownOptionLabelDescriptionWidth = labelDescriptionRef.current.clientWidth;
    const labelWidth = label2.length * AVG_CHAR_WIDTH_AT_12px;
    if (dropdownOptionWidth - dropdownOptionLabelDescriptionWidth - labelWidth < 0) {
      setShouldTruncate(true);
      setRemainingSpaceForLabel(
        dropdownOptionWidth - dropdownOptionLabelDescriptionWidth
      );
    }
  }, [labelContainerRef.current, labelDescriptionRef.current, label2]);
  return /* @__PURE__ */ jsx$1(
    components.Option,
    {
      ...props,
      "aria-checked": isSelected,
      isDisabled,
      children: /* @__PURE__ */ jsxs("div", { className: styles$i.selectOption, children: [
        /* @__PURE__ */ jsx$1("div", { children: isSelected && /* @__PURE__ */ jsx$1("div", { className: styles$i.circle }) }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              styles$i.labelWrapper,
              data.labelTag && styles$i.labelWrapperWithTag
            ),
            ref: labelContainerRef,
            children: [
              /* @__PURE__ */ jsx$1("div", { className: styles$i.label, children: shouldTruncate ? /* @__PURE__ */ jsx$1(Tooltip$3, { content: label2, children: /* @__PURE__ */ jsx$1(
                "span",
                {
                  className: styles$i.truncatedLabel,
                  style: { maxWidth: `${remainingSpaceForLabel}px` },
                  children: label2
                }
              ) }) : /* @__PURE__ */ jsx$1("span", { className: styles$i.truncatedLabel, children: label2 }) }),
              /* @__PURE__ */ jsx$1(
                "div",
                {
                  className: styles$i.labelDescriptionContainer,
                  style: !data.labelCounter ? { flexGrow: 0 } : {},
                  ref: labelDescriptionRef,
                  children: /* @__PURE__ */ jsxs("div", { className: styles$i.labelDescriptionWrapper, children: [
                    data.labelDescription && /* @__PURE__ */ jsxs(
                      "span",
                      {
                        className: styles$i.labelDescription,
                        style: data.labelCounter ? { flexGrow: 1 } : {},
                        children: [
                          /* @__PURE__ */ jsx$1("span", { children: "•" }),
                          /* @__PURE__ */ jsx$1("span", { children: data.labelDescription })
                        ]
                      }
                    ),
                    data.labelCounter && /* @__PURE__ */ jsxs("span", { className: styles$i.labelCounter, children: [
                      /* @__PURE__ */ jsx$1("span", { className: styles$i.labelCounterContent, children: data.labelCounter.content }),
                      /* @__PURE__ */ jsx$1("span", { className: styles$i.labelCounterIcon, children: data.labelCounter.icon })
                    ] }),
                    data.labelTag && /* @__PURE__ */ jsx$1("span", { className: styles$i.labelTag, children: data.labelTag })
                  ] })
                }
              ),
              data.labelIcon && /* @__PURE__ */ jsx$1("div", { className: styles$i.labelIconWrapper, children: data.labelIcon })
            ]
          }
        ),
        /* @__PURE__ */ jsx$1("div", {}),
        data.labelNote && /* @__PURE__ */ jsx$1("div", { className: styles$i.selectOptionNote, children: data.labelNote })
      ] }, data.value)
    }
  );
};
const NoOptionsMessage = (props) => {
  const { options: options2 } = props.selectProps;
  return /* @__PURE__ */ jsx$1(components.NoOptionsMessage, { ...props, children: options2.length ? /* @__PURE__ */ jsx$1("span", { className: styles$i.selectNoMatches, children: "No matches" }) : /* @__PURE__ */ jsx$1("span", { children: "No results" }) });
};
const MenuList$1 = ({
  children,
  ...props
}) => {
  const {
    loadMore,
    loadMoreButtonText,
    loadMoreDisabled,
    onLoadMore,
    loadMoreButtonRef,
    loadingPaginatedOptions
  } = props.selectProps;
  const innerProps = {
    ...props.innerProps,
    "data-testid": "search-menu"
  };
  return /* @__PURE__ */ jsxs(components.MenuList, { ...props, innerProps, children: [
    children,
    loadMore && loadingPaginatedOptions !== true && /* @__PURE__ */ jsx$1("div", { className: styles$i.selectLoadMore, children: /* @__PURE__ */ jsx$1(
      Button$1,
      {
        ref: loadMoreButtonRef,
        variant: "secondary",
        size: "small",
        disabled: loadMoreDisabled,
        "data-testid": "select-load-more-button",
        onClick: onLoadMore,
        children: loadMoreButtonText
      }
    ) }),
    loadingPaginatedOptions && /* @__PURE__ */ jsx$1("div", { className: styles$i.paginatedOptionsLoader, children: /* @__PURE__ */ jsx$1(Loader, { size: "small", variant: "bubbles" }) })
  ] });
};
function ClearIndicator(props) {
  const { ariaDisabled, ariaLabelClearButton = `Clear selected value` } = props.selectProps;
  function handleEnterKey(event) {
    if (event.key === "Enter") {
      props.clearValue();
    }
  }
  return /* @__PURE__ */ jsx$1(
    "button",
    {
      tabIndex: ariaDisabled ? -1 : 0,
      "aria-label": ariaLabelClearButton,
      onKeyDown: handleEnterKey,
      className: styles$i.clearValueButton,
      children: /* @__PURE__ */ jsx$1(components.ClearIndicator, { ...props })
    }
  );
}
const nullOption = {
  label: "",
  value: ""
};
const CLASS_NAME_PREFIX = "sz-select";
function Select2({
  options: options2,
  id,
  maxMenuHeight = 200,
  hasNullValue = false,
  hasUnderline = true,
  placeholder: placeholder2 = "",
  hasError,
  value: value2,
  className,
  hasIndicator = true,
  hasClearIndicator = true,
  onClearBtnClick,
  selectProps,
  isDisabled = false,
  ariaLabel,
  components: components2,
  isLoading,
  loadMore,
  onLoadMore,
  onChange: onChange2,
  onInputChange,
  onOpenMenu,
  disableFilter = false,
  menuPortalTarget = document.body,
  onMenuScrollToBottom,
  loadingPaginatedOptions,
  // this props won't work until menuPortalTarget={null} get's passed
  keepOpenForever = false,
  defaultOpen = false,
  keepSelectedItemInPlace = false,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(keepOpenForever || defaultOpen);
  const [isLoadMoreFocused, setIsLoadMoreFocused] = useState(false);
  const loadMoreButtonRef = useRef(null);
  const selectRef = useRef(null);
  useEffect(() => {
    if (!loadMore && isLoadMoreFocused) {
      selectRef.current?.focus();
      setIsLoadMoreFocused(false);
    }
  }, [loadMore]);
  const parsedClassName = clsx(
    CLASS_NAME_PREFIX,
    hasUnderline && `${CLASS_NAME_PREFIX}--underline`,
    hasError && `${CLASS_NAME_PREFIX}--has-error`,
    hasIndicator && `${CLASS_NAME_PREFIX}--has-indicator`,
    isDisabled && `${CLASS_NAME_PREFIX}--disabled`,
    className
  );
  const customComponents = {
    Option: CustomOption,
    Input: CustomInput,
    NoOptionsMessage,
    MenuList: MenuList$1,
    ClearIndicator,
    ...components2
  };
  const parsedOptions = hasNullValue ? [nullOption, ...options2] : options2;
  const indicatorColor = useMemo(() => {
    if (isDisabled) {
      return "var(--color-disabled-front)";
    }
    return hasError ? "var(--color-red-front)" : "var(--color-front)";
  }, [isDisabled, hasError]);
  const isSelectedValueSet = () => {
    return hasNullValue && value2?.value === nullOption.value || !!value2?.value;
  };
  const optionsSorted = useMemo(() => {
    return keepSelectedItemInPlace ? parsedOptions : [
      ...isSelectedValueSet() ? [value2] : [],
      ...parsedOptions.filter((option) => {
        return value2?.value !== option.value;
      })
    ];
  }, [value2, parsedOptions, keepSelectedItemInPlace]);
  const customStyles2 = {
    menuPortal: (defaultStyles2) => ({
      ...defaultStyles2,
      zIndex: 9999
    }),
    placeholder: (defaultStyles2) => ({
      ...defaultStyles2,
      color: indicatorColor
    }),
    dropdownIndicator: (defaultStyles2) => ({
      ...defaultStyles2,
      color: indicatorColor
    }),
    clearIndicator: (defaultStyles2) => ({
      ...defaultStyles2,
      color: indicatorColor
    })
  };
  const handleChange = (newValue, { action }) => {
    if (action === "clear") {
      onClearBtnClick?.();
    }
    onChange2(newValue ?? nullOption, id);
  };
  function handleInputChange2(value22) {
    onInputChange?.(value22);
  }
  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === "Space") {
      setIsOpen(true);
      if (isLoadMoreFocused && onLoadMore) {
        event.preventDefault();
        onLoadMore();
      }
    }
    if (event.key === "Tab") {
      if (loadMore && isOpen) {
        setIsLoadMoreFocused(true);
      }
      if (document.activeElement === loadMoreButtonRef.current) {
        setIsLoadMoreFocused(false);
        if (!keepOpenForever) {
          setIsOpen(false);
        }
      }
    }
  }
  function handleMenuOpen() {
    if (!isDisabled && !keepOpenForever) {
      setIsOpen(true);
      onOpenMenu?.();
    }
  }
  function handleMenuClose() {
    if (!isLoadMoreFocused && !keepOpenForever) {
      setIsOpen(false);
    }
  }
  function customFilter(option, searchText) {
    const labelNote = option?.data?.labelNote;
    const label2 = option?.label;
    const value22 = String(option?.value);
    if (labelNote && labelNote.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    if (label2 && option.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    if (value22 && value22.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    return false;
  }
  const parsedValue = useMemo(() => {
    if (!value2?.value) return null;
    if (value2.label === void 0) {
      return options2.find((option) => option.value === value2.value);
    }
    return value2;
  }, [value2]);
  return /* @__PURE__ */ jsx$1(
    StateManagedSelect$1,
    {
      ref: selectRef,
      value: parsedValue,
      options: optionsSorted,
      menuPortalTarget,
      styles: customStyles2,
      className: parsedClassName,
      components: customComponents,
      id,
      isClearable: hasClearIndicator,
      maxMenuHeight,
      isSearchable: true,
      placeholder: placeholder2,
      classNamePrefix: CLASS_NAME_PREFIX,
      menuIsOpen: isOpen,
      "aria-errormessage": hasError && `input-error-message-${id}`,
      "aria-label": ariaLabel,
      "aria-invalid": hasError,
      ariaDisabled: isDisabled,
      tabSelectsValue: false,
      onMenuOpen: handleMenuOpen,
      onMenuClose: handleMenuClose,
      onBlur: handleMenuClose,
      onChange: handleChange,
      onInputChange: handleInputChange2,
      onKeyDown: handleKeyDown,
      isLoading,
      loadMore,
      loadMoreButtonRef,
      onLoadMore,
      filterOption: disableFilter ? null : customFilter,
      onMenuScrollToBottom,
      loadingPaginatedOptions,
      ...selectProps,
      ...rest
    }
  );
}
const skillCard = "skill-card-module_skillCard__eWZaM";
const main$1 = "skill-card-module_main__buYSb";
const label$2 = "skill-card-module_label__1bvBG";
const icons = "skill-card-module_icons__NgqY9";
const actions = "skill-card-module_actions__Xs1E6";
const actionIcon = "skill-card-module_actionIcon__hQcQ9";
const addButton = "skill-card-module_addButton__JIThh";
const dismissButton = "skill-card-module_dismissButton__ET5ft";
const icon = "skill-card-module_icon__VQmr5";
const disabled$3 = "skill-card-module_disabled__gvZwo";
const styles$h = {
  skillCard,
  main: main$1,
  label: label$2,
  icons,
  actions,
  actionIcon,
  addButton,
  dismissButton,
  icon,
  disabled: disabled$3
};
const GREEN$1 = "#007A6A";
const DISABLED$4 = "#ADBFD9";
const ValidatedIcon = ({ isDisabled, className }) => {
  const defaultColor = isDisabled ? DISABLED$4 : GREEN$1;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      role: "img",
      "data-testid": "SuccessIcon",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1(
          "circle",
          {
            cx: "10",
            cy: "10",
            r: "9",
            stroke: defaultColor,
            strokeWidth: "2",
            fill: "none"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M5 10L8 13L15 6",
            stroke: defaultColor,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
};
const GRAY = "#62748C";
const DISABLED$3 = "#ADBFD9";
const TagIcon = ({ isDisabled, className }) => {
  const defaultColor = isDisabled ? DISABLED$3 : GRAY;
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      role: "img",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M7.27746 1.9127L6.74774 1.38177L6.74774 1.38177L7.27746 1.9127ZM1.90444 7.27345L1.37472 6.74251H1.37472L1.90444 7.27345ZM1.90444 10.0452L1.37472 10.5761L1.90444 10.0452ZM5.96473 14.0962L6.49446 13.5653L5.96473 14.0962ZM8.74283 14.0962L8.21311 13.5653L8.74283 14.0962ZM14.1159 8.73547L14.6456 9.26641V9.26641L14.1159 8.73547ZM13.2 0.583984H8.65125V2.08398H13.2V0.583984ZM8.65125 0.583984C7.923 0.583984 7.24696 0.883682 6.74774 1.38177L7.80718 2.44364C8.04065 2.21071 8.34152 2.08398 8.65125 2.08398V0.583984ZM6.74774 1.38177L1.37472 6.74251L2.43416 7.80438L7.80718 2.44364L6.74774 1.38177ZM1.37472 6.74251C0.317802 7.79701 0.317802 9.52163 1.37472 10.5761L2.43416 9.51426C1.96465 9.04582 1.96465 8.27282 2.43416 7.80438L1.37472 6.74251ZM1.37472 10.5761L5.43501 14.6272L6.49446 13.5653L2.43416 9.51426L1.37472 10.5761ZM5.43501 14.6272C6.49098 15.6807 8.21659 15.6807 9.27255 14.6272L8.21311 13.5653C7.74265 14.0347 6.96492 14.0347 6.49446 13.5653L5.43501 14.6272ZM9.27255 14.6272L14.6456 9.26641L13.5861 8.20453L8.21311 13.5653L9.27255 14.6272ZM14.6456 9.26641C15.1662 8.74699 15.4154 8.06232 15.4154 7.36482H13.9154C13.9154 7.70293 13.7982 7.99294 13.5861 8.20453L14.6456 9.26641ZM15.4154 7.36482V2.79601H13.9154V7.36482H15.4154ZM15.4154 2.79601C15.4154 1.59845 14.447 0.583984 13.2 0.583984V2.08398C13.6015 2.08398 13.9154 2.40971 13.9154 2.79601H15.4154Z",
          fill: defaultColor
        }
      )
    }
  );
};
const WHITE = "#FFF";
const DISABLED$2 = "#ADBFD9";
const PlusIcon$1 = ({ isDisabled, className }) => {
  const defaultColor = isDisabled ? DISABLED$2 : WHITE;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_1750_3341)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M12.6673 8.66732H8.66732V12.6673H7.33398V8.66732H3.33398V7.33398H7.33398V3.33398H8.66732V7.33398H12.6673V8.66732Z",
            fill: defaultColor
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_1750_3341", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "16",
            height: "16",
            fill: defaultColor
          }
        ) }) })
      ]
    }
  );
};
const RED$1 = "#D71717";
const DISABLED$1 = "#ADBFD9";
const DismissIcon = ({ isDisabled, className }) => {
  const defaultColor = isDisabled ? DISABLED$1 : RED$1;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_1750_10656)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M4.00065 12.6667C4.00065 13.4 4.60065 14 5.33398 14H10.6673C11.4007 14 12.0007 13.4 12.0007 12.6667V4.66667H4.00065V12.6667ZM5.33398 6H10.6673V12.6667H5.33398V6ZM10.334 2.66667L9.66732 2H6.33398L5.66732 2.66667H3.33398V4H12.6673V2.66667H10.334Z",
            fill: defaultColor
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_1750_10656", children: /* @__PURE__ */ jsx$1(
          "rect",
          {
            width: "16",
            height: "16",
            fill: "white"
          }
        ) }) })
      ]
    }
  );
};
const SKILL_PROFICIENY = {
  1: "no knowledge",
  2: "beginner",
  3: "intermediate",
  4: "expert"
};
function SkillCard({
  id,
  label: label2,
  isDisabled,
  proficiency,
  validated,
  companyOwned,
  ariaLabel,
  dismissAriaLabel,
  addButtonAriaLabel,
  testId,
  onClick,
  onDismiss,
  onAdd
}) {
  const isRecommendedSkill = !!(onDismiss || onAdd);
  const handleSkillCardClick = () => {
    if (!isRecommendedSkill && onClick) {
      onClick(id);
    }
  };
  const handleDismissClick = () => {
    if (onDismiss) {
      onDismiss(id);
    }
  };
  const handleAddClick = () => {
    if (onAdd) {
      onAdd(id);
    }
  };
  const getProficiencyAriaLabel = () => {
    return proficiency ? `${!companyOwned ? ", " : " "}with ${SKILL_PROFICIENY[proficiency]} proficiency` : "";
  };
  const getCompanySpecificAriaLabel = () => {
    return companyOwned ? `, company specific` : "";
  };
  const combinedAriaLabel = `${ariaLabel ?? label2}${getCompanySpecificAriaLabel()}${getProficiencyAriaLabel()}${validated ? ", validated" : ""}`;
  const handleKeydown = (event) => {
    if (event.key === "Enter") {
      handleSkillCardClick();
    }
  };
  return /* @__PURE__ */ jsxs(
    "fieldset",
    {
      className: clsx(styles$h.skillCard, isDisabled && styles$h.disabled),
      onClick: handleSkillCardClick,
      onKeyDown: handleKeydown,
      "aria-label": combinedAriaLabel,
      "aria-disabled": isDisabled,
      tabIndex: isRecommendedSkill ? -1 : 0,
      role: !isRecommendedSkill ? "button" : void 0,
      "data-testid": testId,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles$h.main, children: [
          /* @__PURE__ */ jsx$1("label", { className: styles$h.label, children: label2 }),
          /* @__PURE__ */ jsxs("div", { className: styles$h.icons, "aria-hidden": "true", children: [
            companyOwned && /* @__PURE__ */ jsx$1(TagIcon, { isDisabled, className: styles$h.icon }),
            proficiency && /* @__PURE__ */ jsx$1(
              BarChart,
              {
                value: proficiency,
                isDisabled,
                className: styles$h.icon
              }
            ),
            validated && /* @__PURE__ */ jsx$1(ValidatedIcon, { isDisabled, className: styles$h.icon })
          ] })
        ] }),
        isRecommendedSkill && /* @__PURE__ */ jsxs("div", { className: styles$h.actions, children: [
          /* @__PURE__ */ jsx$1(
            Button$1,
            {
              className: styles$h.addButton,
              size: "medium",
              disabled: isDisabled,
              "aria-label": addButtonAriaLabel,
              onClick: handleAddClick,
              "data-testid": `skill-card-add-button-${id}`,
              children: /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", className: styles$h.actionIcon, children: /* @__PURE__ */ jsx$1(PlusIcon$1, { isDisabled }) })
            }
          ),
          /* @__PURE__ */ jsx$1(
            Button$1,
            {
              className: styles$h.dismissButton,
              size: "medium",
              variant: "text",
              disabled: isDisabled,
              "aria-label": dismissAriaLabel,
              onClick: handleDismissClick,
              "data-testid": `skill-card-dismiss-button-${id}`,
              children: /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", className: styles$h.actionIcon, children: /* @__PURE__ */ jsx$1(DismissIcon, { isDisabled }) })
            }
          )
        ] })
      ]
    }
  );
}
const sliderContainer = "slider-input-module_sliderContainer__7gU-k";
const sliderTrack = "slider-input-module_sliderTrack__iFhio";
const sliderRange = "slider-input-module_sliderRange__GMhE0";
const sliderThumb = "slider-input-module_sliderThumb__Q2XlK";
const error$2 = "slider-input-module_error__e3Uzf";
const disabled$2 = "slider-input-module_disabled__AXkU9";
const styles$g = {
  sliderContainer,
  sliderTrack,
  sliderRange,
  sliderThumb,
  error: error$2,
  disabled: disabled$2
};
function SliderInput({
  value: value2,
  defaultValue,
  className,
  error: error2,
  disabled: disabled2,
  thumbLabels,
  ...props
}) {
  const thumbCount = (value2 ?? defaultValue ?? [0]).length;
  return /* @__PURE__ */ jsxs(
    RadixSlider.Root,
    {
      value: value2,
      defaultValue,
      className: clsx(
        className,
        styles$g.sliderContainer,
        error2 && styles$g.error,
        disabled2 && styles$g.disabled
      ),
      disabled: disabled2,
      ...props,
      children: [
        /* @__PURE__ */ jsx$1(RadixSlider.Track, { className: styles$g.sliderTrack, children: /* @__PURE__ */ jsx$1(RadixSlider.Range, { className: styles$g.sliderRange }) }),
        Array.from({ length: thumbCount }, (_2, i3) => /* @__PURE__ */ jsx$1(
          RadixSlider.Thumb,
          {
            className: styles$g.sliderThumb,
            "aria-label": thumbLabels?.[i3]
          },
          i3
        ))
      ]
    }
  );
}
var warned = {};
var preMessage = function preMessage2(fn2) {
};
function warning$1(valid, message2) {
}
function note(valid, message2) {
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message2) {
  if (!valid && !warned[message2]) {
    method(false, message2);
    warned[message2] = true;
  }
}
function warningOnce(valid, message2) {
  call(warning$1, valid, message2);
}
function noteOnce(valid, message2) {
  call(note, valid, message2);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var Track = function Track2(props) {
  var _ref3, _ref22;
  var className = props.className, included = props.included, vertical2 = props.vertical, style2 = props.style;
  var length2 = props.length, offset3 = props.offset, reverse = props.reverse;
  if (length2 < 0) {
    reverse = !reverse;
    length2 = Math.abs(length2);
    offset3 = 100 - offset3;
  }
  var positonStyle = vertical2 ? (_ref3 = {}, _defineProperty$3(_ref3, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$3(_ref3, reverse ? "bottom" : "top", "auto"), _defineProperty$3(_ref3, "height", "".concat(length2, "%")), _ref3) : (_ref22 = {}, _defineProperty$3(_ref22, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$3(_ref22, reverse ? "left" : "right", "auto"), _defineProperty$3(_ref22, "width", "".concat(length2, "%")), _ref22);
  var elStyle = _objectSpread2$1(_objectSpread2$1({}, style2), positonStyle);
  return included ? /* @__PURE__ */ React__default.createElement("div", {
    className,
    style: elStyle
  }) : null;
};
function _superPropBase(t3, o2) {
  for (; !{}.hasOwnProperty.call(t3, o2) && null !== (t3 = _getPrototypeOf$1(t3)); ) ;
  return t3;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e3, t3, r2) {
    var p2 = _superPropBase(e3, t3);
    if (p2) {
      var n2 = Object.getOwnPropertyDescriptor(p2, t3);
      return n2.get ? n2.get.call(arguments.length < 3 ? e3 : r2) : n2.value;
    }
  }, _get.apply(null, arguments);
}
function addEventListenerWrap(target, eventType, cb, option) {
  var callback = ReactDOM__default.unstable_batchedUpdates ? function run(e3) {
    ReactDOM__default.unstable_batchedUpdates(cb, e3);
  } : cb;
  if (target !== null && target !== void 0 && target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove2() {
      if (target !== null && target !== void 0 && target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}
var calcPoints = function calcPoints2(vertical2, marks, dots, step, min2, max2) {
  warningOnce(dots ? step > 0 : true, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
  var points = Object.keys(marks).map(parseFloat).sort(function(a4, b3) {
    return a4 - b3;
  });
  if (dots && step) {
    for (var i3 = min2; i3 <= max2; i3 += step) {
      if (points.indexOf(i3) === -1) {
        points.push(i3);
      }
    }
  }
  return points;
};
var Steps = function Steps2(_ref3) {
  var prefixCls = _ref3.prefixCls, vertical2 = _ref3.vertical, reverse = _ref3.reverse, marks = _ref3.marks, dots = _ref3.dots, step = _ref3.step, included = _ref3.included, lowerBound = _ref3.lowerBound, upperBound = _ref3.upperBound, max2 = _ref3.max, min2 = _ref3.min, dotStyle = _ref3.dotStyle, activeDotStyle = _ref3.activeDotStyle;
  var range2 = max2 - min2;
  var elements = calcPoints(vertical2, marks, dots, step, min2, max2).map(function(point) {
    var _classNames;
    var offset3 = "".concat(Math.abs(point - min2) / range2 * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style2 = vertical2 ? _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$3({}, reverse ? "top" : "bottom", offset3)) : _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$3({}, reverse ? "right" : "left", offset3));
    if (isActived) {
      style2 = _objectSpread2$1(_objectSpread2$1({}, style2), activeDotStyle);
    }
    var pointClassName = r((_classNames = {}, _defineProperty$3(_classNames, "".concat(prefixCls, "-dot"), true), _defineProperty$3(_classNames, "".concat(prefixCls, "-dot-active"), isActived), _defineProperty$3(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
    return /* @__PURE__ */ React__default.createElement("span", {
      className: pointClassName,
      style: style2,
      key: point
    });
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, elements);
};
var Marks = function Marks2(_ref3) {
  var className = _ref3.className, vertical2 = _ref3.vertical, reverse = _ref3.reverse, marks = _ref3.marks, included = _ref3.included, upperBound = _ref3.upperBound, lowerBound = _ref3.lowerBound, max2 = _ref3.max, min2 = _ref3.min, onClickLabel = _ref3.onClickLabel;
  var marksKeys = Object.keys(marks);
  var range2 = max2 - min2;
  var elements = marksKeys.map(parseFloat).sort(function(a4, b3) {
    return a4 - b3;
  }).map(function(point) {
    var _classNames;
    var markPoint = marks[point];
    var markPointIsObject = _typeof$2(markPoint) === "object" && !/* @__PURE__ */ React__default.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }
    var isActive2 = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = r((_classNames = {}, _defineProperty$3(_classNames, "".concat(className, "-text"), true), _defineProperty$3(_classNames, "".concat(className, "-text-active"), isActive2), _classNames));
    var bottomStyle = _defineProperty$3({
      marginBottom: "-50%"
    }, reverse ? "top" : "bottom", "".concat((point - min2) / range2 * 100, "%"));
    var leftStyle = _defineProperty$3({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? "right" : "left", "".concat((point - min2) / range2 * 100, "%"));
    var style2 = vertical2 ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _objectSpread2$1(_objectSpread2$1({}, style2), markPoint.style) : style2;
    return /* @__PURE__ */ React__default.createElement("span", {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e3) {
        return onClickLabel(e3, point);
      },
      onTouchStart: function onTouchStart(e3) {
        return onClickLabel(e3, point);
      }
    }, markLabel);
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    className
  }, elements);
};
var Handle = /* @__PURE__ */ (function(_React$Component) {
  _inherits$1(Handle2, _React$Component);
  var _super = _createSuper$1(Handle2);
  function Handle2() {
    var _this;
    _classCallCheck$2(this, Handle2);
    _this = _super.apply(this, arguments);
    _this.state = {
      clickFocused: false
    };
    _this.setHandleRef = function(node2) {
      _this.handle = node2;
    };
    _this.handleMouseUp = function() {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    };
    _this.handleMouseDown = function(e3) {
      e3.preventDefault();
      _this.focus();
    };
    _this.handleBlur = function() {
      _this.setClickFocus(false);
    };
    _this.handleKeyDown = function() {
      _this.setClickFocus(false);
    };
    return _this;
  }
  _createClass$2(Handle2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onMouseUpListener = addEventListenerWrap(document, "mouseup", this.handleMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: "setClickFocus",
    value: function setClickFocus(focused) {
      this.setState({
        clickFocused: focused
      });
    }
  }, {
    key: "clickFocus",
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus2() {
      this.handle.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _ref3, _ref22;
      var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical2 = _this$props.vertical, reverse = _this$props.reverse, offset3 = _this$props.offset, style2 = _this$props.style, disabled2 = _this$props.disabled, min2 = _this$props.min, max2 = _this$props.max, value2 = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = _objectWithoutProperties(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);
      var className = r(this.props.className, _defineProperty$3({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
      var positionStyle = vertical2 ? (_ref3 = {}, _defineProperty$3(_ref3, reverse ? "top" : "bottom", "".concat(offset3, "%")), _defineProperty$3(_ref3, reverse ? "bottom" : "top", "auto"), _defineProperty$3(_ref3, "transform", reverse ? null : "translateY(+50%)"), _ref3) : (_ref22 = {}, _defineProperty$3(_ref22, reverse ? "right" : "left", "".concat(offset3, "%")), _defineProperty$3(_ref22, reverse ? "left" : "right", "auto"), _defineProperty$3(_ref22, "transform", "translateX(".concat(reverse ? "+" : "-", "50%)")), _ref22);
      var elStyle = _objectSpread2$1(_objectSpread2$1({}, style2), positionStyle);
      var mergedTabIndex = tabIndex || 0;
      if (disabled2 || tabIndex === null) {
        mergedTabIndex = null;
      }
      var ariaValueText;
      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value2);
      }
      return /* @__PURE__ */ React__default.createElement("div", _extends$1({
        ref: this.setHandleRef,
        tabIndex: mergedTabIndex
      }, restProps, {
        className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        role: "slider",
        "aria-valuemin": min2,
        "aria-valuemax": max2,
        "aria-valuenow": value2,
        "aria-disabled": !!disabled2,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }));
    }
  }]);
  return Handle2;
})(React__default.Component);
var KeyCode = {
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40
};
function isEventFromHandle(e3, handles) {
  try {
    return Object.keys(handles).some(function(key) {
      return e3.target === findDOMNode$1(handles[key]);
    });
  } catch (error2) {
    return false;
  }
}
function isValueOutOfRange(value2, _ref3) {
  var min2 = _ref3.min, max2 = _ref3.max;
  return value2 < min2 || value2 > max2;
}
function isNotTouchEvent(e3) {
  return e3.touches.length > 1 || e3.type.toLowerCase() === "touchend" && e3.touches.length > 0;
}
function getClosestPoint(val, _ref22) {
  var marks = _ref22.marks, step = _ref22.step, min2 = _ref22.min, max2 = _ref22.max;
  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var baseNum = Math.pow(10, getPrecision(step));
    var maxSteps = Math.floor((max2 * baseNum - min2 * baseNum) / (step * baseNum));
    var steps = Math.min((val - min2) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min2;
    points.push(closestStep);
  }
  var diffs = points.map(function(point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf(".") >= 0) {
    precision = stepString.length - stepString.indexOf(".") - 1;
  }
  return precision;
}
function getMousePosition(vertical2, e3) {
  return vertical2 ? e3.clientY : e3.pageX;
}
function getTouchPosition(vertical2, e3) {
  return vertical2 ? e3.touches[0].clientY : e3.touches[0].pageX;
}
function getHandleCenterPosition(vertical2, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical2 ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max2 = _ref3.max, min2 = _ref3.min;
  if (val <= min2) {
    return min2;
  }
  if (val >= max2) {
    return max2;
  }
  return val;
}
function ensureValuePrecision(val, props) {
  var step = props.step;
  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0;
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e3) {
  e3.stopPropagation();
  e3.preventDefault();
}
function calculateNextValue(func, value2, props) {
  var operations = {
    increase: function increase(a4, b3) {
      return a4 + b3;
    },
    decrease: function decrease(a4, b3) {
      return a4 - b3;
    }
  };
  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value2)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];
  if (props.step) {
    return operations[func](value2, props.step);
  }
  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value2;
}
function getKeyboardValueMutator(e3, vertical2, reverse) {
  var increase = "increase";
  var decrease = "decrease";
  var method = increase;
  switch (e3.keyCode) {
    case KeyCode.UP:
      method = vertical2 && reverse ? decrease : increase;
      break;
    case KeyCode.RIGHT:
      method = !vertical2 && reverse ? decrease : increase;
      break;
    case KeyCode.DOWN:
      method = vertical2 && reverse ? increase : decrease;
      break;
    case KeyCode.LEFT:
      method = !vertical2 && reverse ? increase : decrease;
      break;
    case KeyCode.END:
      return function(value2, props) {
        return props.max;
      };
    case KeyCode.HOME:
      return function(value2, props) {
        return props.min;
      };
    case KeyCode.PAGE_UP:
      return function(value2, props) {
        return value2 + props.step * 2;
      };
    case KeyCode.PAGE_DOWN:
      return function(value2, props) {
        return value2 - props.step * 2;
      };
    default:
      return void 0;
  }
  return function(value2, props) {
    return calculateNextValue(method, value2, props);
  };
}
function noop$1() {
}
function createSlider(Component2) {
  var _a;
  return _a = /* @__PURE__ */ (function(_Component) {
    _inherits$1(ComponentEnhancer, _Component);
    var _super = _createSuper$1(ComponentEnhancer);
    function ComponentEnhancer(props) {
      var _this;
      _classCallCheck$2(this, ComponentEnhancer);
      _this = _super.call(this, props);
      _this.onDown = function(e3, position2) {
        var p2 = position2;
        var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
        var bounds = _this.state.bounds;
        var value2 = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p2) || [] : [];
        var inPoint = isEventFromHandle(e3, _this.handlesRefs);
        _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value2.map(function(n2, i3) {
          var v2 = !i3 ? n2 >= bounds[i3] : true;
          return i3 === value2.length - 1 ? n2 <= bounds[i3] : v2;
        }).some(function(c3) {
          return !c3;
        });
        if (_this.dragTrack) {
          _this.dragOffset = p2;
          _this.startBounds = _toConsumableArray(bounds);
        } else {
          if (!inPoint) {
            _this.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e3.target);
            _this.dragOffset = p2 - handlePosition;
            p2 = handlePosition;
          }
          _this.onStart(p2);
        }
      };
      _this.onMouseDown = function(e3) {
        if (e3.button !== 0) {
          return;
        }
        _this.removeDocumentEvents();
        var isVertical = _this.props.vertical;
        var position2 = getMousePosition(isVertical, e3);
        _this.onDown(e3, position2);
        _this.addDocumentMouseEvents();
      };
      _this.onTouchStart = function(e3) {
        if (isNotTouchEvent(e3)) return;
        var isVertical = _this.props.vertical;
        var position2 = getTouchPosition(isVertical, e3);
        _this.onDown(e3, position2);
        _this.addDocumentTouchEvents();
        pauseEvent(e3);
      };
      _this.onFocus = function(e3) {
        var _this$props2 = _this.props, onFocus2 = _this$props2.onFocus, vertical2 = _this$props2.vertical;
        if (isEventFromHandle(e3, _this.handlesRefs) && !_this.dragTrack) {
          var handlePosition = getHandleCenterPosition(vertical2, e3.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          pauseEvent(e3);
          if (onFocus2) {
            onFocus2(e3);
          }
        }
      };
      _this.onBlur = function(e3) {
        var onBlur = _this.props.onBlur;
        if (!_this.dragTrack) {
          _this.onEnd();
        }
        if (onBlur) {
          onBlur(e3);
        }
      };
      _this.onMouseUp = function() {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };
      _this.onMouseMove = function(e3) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position2 = getMousePosition(_this.props.vertical, e3);
        _this.onMove(e3, position2 - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };
      _this.onTouchMove = function(e3) {
        if (isNotTouchEvent(e3) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position2 = getTouchPosition(_this.props.vertical, e3);
        _this.onMove(e3, position2 - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };
      _this.onKeyDown = function(e3) {
        if (_this.sliderRef && isEventFromHandle(e3, _this.handlesRefs)) {
          _this.onKeyboard(e3);
        }
      };
      _this.onClickMarkLabel = function(e3, value2) {
        e3.stopPropagation();
        _this.onChange({
          value: value2
        });
        _this.setState({
          value: value2
        }, function() {
          return _this.onEnd(true);
        });
      };
      _this.saveSlider = function(slider2) {
        _this.sliderRef = slider2;
      };
      var step = props.step, max2 = props.max, min2 = props.min;
      var isPointDiffEven = isFinite(max2 - min2) ? (max2 - min2) % step === 0 : true;
      warningOnce(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max2 - min2, ") should be a multiple of Slider[step] (").concat(step, ")"));
      _this.handlesRefs = {};
      return _this;
    }
    _createClass$2(ComponentEnhancer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
        var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled2 = _this$props3.disabled;
        if (autoFocus && !disabled2) {
          this.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (_get(_getPrototypeOf$1(ComponentEnhancer.prototype), "componentWillUnmount", this)) _get(_getPrototypeOf$1(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider2 = this.sliderRef;
        var _this$props4 = this.props, vertical2 = _this$props4.vertical, reverse = _this$props4.reverse;
        var rect = slider2.getBoundingClientRect();
        if (vertical2) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider2 = this.sliderRef;
        if (!slider2) {
          return 0;
        }
        var coords = slider2.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        this.onTouchMoveListener = addEventListenerWrap(this.document, "touchmove", this.onTouchMove);
        this.onTouchUpListener = addEventListenerWrap(this.document, "touchend", this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListenerWrap(this.document, "mousemove", this.onMouseMove);
        this.onMouseUpListener = addEventListenerWrap(this.document, "mouseup", this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
      }
    }, {
      key: "focus",
      value: function focus2() {
        var _this$handlesRefs$;
        if (this.props.disabled) {
          return;
        }
        (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 ? void 0 : _this$handlesRefs$.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this2 = this;
        if (this.props.disabled) {
          return;
        }
        Object.keys(this.handlesRefs).forEach(function(key) {
          var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
          (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 ? void 0 : (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 ? void 0 : _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
        });
      }
    }, {
      key: "calcValue",
      value: function calcValue(offset3) {
        var _this$props5 = this.props, vertical2 = _this$props5.vertical, min2 = _this$props5.min, max2 = _this$props5.max;
        var ratio = Math.abs(Math.max(offset3, 0) / this.getSliderLength());
        var value2 = vertical2 ? (1 - ratio) * (max2 - min2) + min2 : ratio * (max2 - min2) + min2;
        return value2;
      }
    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position2) {
        var sign2 = this.props.reverse ? -1 : 1;
        var pixelOffset = sign2 * (position2 - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value2) {
        var _this$props6 = this.props, min2 = _this$props6.min, max2 = _this$props6.max;
        var ratio = (value2 - min2) / (max2 - min2);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index2, handle) {
        this.handlesRefs[index2] = handle;
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;
        var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled2 = _this$props7.disabled, vertical2 = _this$props7.vertical, reverse = _this$props7.reverse, min2 = _this$props7.min, max2 = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style2 = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
        var _get$call = _get(_getPrototypeOf$1(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
        var sliderClassName = r(prefixCls, (_classNames = {}, _defineProperty$3(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), _defineProperty$3(_classNames, "".concat(prefixCls, "-disabled"), disabled2), _defineProperty$3(_classNames, "".concat(prefixCls, "-vertical"), vertical2), _defineProperty$3(_classNames, className, className), _classNames));
        return /* @__PURE__ */ React__default.createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled2 ? noop$1 : this.onTouchStart,
          onMouseDown: disabled2 ? noop$1 : this.onMouseDown,
          onMouseUp: disabled2 ? noop$1 : this.onMouseUp,
          onKeyDown: disabled2 ? noop$1 : this.onKeyDown,
          onFocus: disabled2 ? noop$1 : this.onFocus,
          onBlur: disabled2 ? noop$1 : this.onBlur,
          style: style2
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: _objectSpread2$1(_objectSpread2$1({}, maximumTrackStyle), railStyle)
        }), tracks, /* @__PURE__ */ React__default.createElement(Steps, {
          prefixCls,
          vertical: vertical2,
          reverse,
          marks,
          dots,
          step,
          included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max2,
          min: min2,
          dotStyle,
          activeDotStyle
        }), handles, /* @__PURE__ */ React__default.createElement(Marks, {
          className: "".concat(prefixCls, "-mark"),
          onClickLabel: disabled2 ? noop$1 : this.onClickMarkLabel,
          vertical: vertical2,
          marks,
          included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max2,
          min: min2,
          reverse
        }), children);
      }
    }]);
    return ComponentEnhancer;
  })(Component2), _a.displayName = "ComponentEnhancer(".concat(Component2.displayName, ")"), _a.defaultProps = _objectSpread2$1(_objectSpread2$1({}, Component2.defaultProps), {}, {
    prefixCls: "rc-slider",
    className: "",
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(props) {
      var index2 = props.index, restProps = _objectWithoutProperties(props, ["index"]);
      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(Handle, _extends$1({}, restProps, {
        key: index2
      }));
    },
    onBeforeChange: noop$1,
    onChange: noop$1,
    onAfterChange: noop$1,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _a;
}
var Slider$1 = /* @__PURE__ */ (function(_React$Component) {
  _inherits$1(Slider2, _React$Component);
  var _super = _createSuper$1(Slider2);
  function Slider2(props) {
    var _this;
    _classCallCheck$2(this, Slider2);
    _this = _super.call(this, props);
    _this.positionGetValue = function(position2) {
      return [];
    };
    _this.onEnd = function(force) {
      var dragging = _this.state.dragging;
      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({
        dragging: false
      });
    };
    var defaultValue = props.defaultValue !== void 0 ? props.defaultValue : props.min;
    var value2 = props.value !== void 0 ? props.value : defaultValue;
    _this.state = {
      value: _this.trimAlignValue(value2),
      dragging: false
    };
    warningOnce(!("minimumTrackStyle" in props), "minimumTrackStyle will be deprecated, please use trackStyle instead.");
    warningOnce(!("maximumTrackStyle" in props), "maximumTrackStyle will be deprecated, please use railStyle instead.");
    return _this;
  }
  _createClass$2(Slider2, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value2) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value2) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index2, h4) {
    }
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props, min2 = _this$props.min, max2 = _this$props.max, value2 = _this$props.value, onChange2 = _this$props.onChange;
      if (!("min" in this.props || "max" in this.props)) {
        return;
      }
      var theValue = value2 !== void 0 ? value2 : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue === prevState.value) {
        return;
      }
      this.setState({
        value: nextValue
      });
      if (!(min2 === prevProps.min && max2 === prevProps.max) && isValueOutOfRange(theValue, this.props)) {
        onChange2(nextValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange2(state) {
      var props = this.props;
      var isNotControlled = !("value" in props);
      var nextState = state.value > this.props.max ? _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        value: this.props.max
      }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }
      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position2) {
      this.setState({
        dragging: true
      });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);
      var value2 = this.calcValueByPos(position2);
      this.startValue = value2;
      this.startPosition = position2;
      if (value2 === prevValue) return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        value: value2
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e3, position2) {
      pauseEvent(e3);
      var oldValue = this.state.value;
      var value2 = this.calcValueByPos(position2);
      if (value2 === oldValue) return;
      this.onChange({
        value: value2
      });
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e3) {
      var _this$props2 = this.props, reverse = _this$props2.reverse, vertical2 = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e3, vertical2, reverse);
      if (valueMutator) {
        pauseEvent(e3);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value2 = this.trimAlignValue(mutatedValue);
        if (value2 === oldValue) return;
        this.onChange({
          value: value2
        });
        this.props.onAfterChange(value2);
        this.onEnd();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      var minPoint = this.props.startPoint || this.props.min;
      return this.state.value > minPoint ? minPoint : this.state.value;
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      if (this.state.value < this.props.startPoint) {
        return this.props.startPoint;
      }
      return this.state.value;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue2(v2) {
      var nextProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (v2 === null) {
        return null;
      }
      var mergedProps = _objectSpread2$1(_objectSpread2$1({}, this.props), nextProps);
      var val = ensureValueInRange(v2, mergedProps);
      return ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical2 = _this$props3.vertical, included = _this$props3.included, disabled2 = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min2 = _this$props3.min, max2 = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
      var _this$state = this.state, value2 = _this$state.value, dragging = _this$state.dragging;
      var offset3 = this.calcOffset(value2);
      var handle = handleGenerator({
        className: "".concat(prefixCls, "-handle"),
        prefixCls,
        vertical: vertical2,
        offset: offset3,
        value: value2,
        dragging,
        disabled: disabled2,
        min: min2,
        max: max2,
        reverse,
        index: 0,
        tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref2(h4) {
          return _this2.saveHandle(0, h4);
        }
      });
      var trackOffset = startPoint !== void 0 ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      var track = /* @__PURE__ */ React__default.createElement(Track, {
        className: "".concat(prefixCls, "-track"),
        vertical: vertical2,
        included,
        offset: trackOffset,
        reverse,
        length: offset3 - trackOffset,
        style: _objectSpread2$1(_objectSpread2$1({}, minimumTrackStyle), mergedTrackStyle)
      });
      return {
        tracks: track,
        handles: handle
      };
    }
  }]);
  return Slider2;
})(React__default.Component);
const Slider$2 = createSlider(Slider$1);
var _trimAlignValue = function trimAlignValue(_ref3) {
  var value2 = _ref3.value, handle = _ref3.handle, bounds = _ref3.bounds, props = _ref3.props;
  var allowCross = props.allowCross, pushable = props.pushable;
  var thershold = Number(pushable);
  var valInRange = ensureValueInRange(value2, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== void 0) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return ensureValuePrecision(valNotConflict, props);
};
var Range = /* @__PURE__ */ (function(_React$Component) {
  _inherits$1(Range2, _React$Component);
  var _super = _createSuper$1(Range2);
  function Range2(props) {
    var _this;
    _classCallCheck$2(this, Range2);
    _this = _super.call(this, props);
    _this.positionGetValue = function(position2) {
      var bounds2 = _this.getValue();
      var value3 = _this.calcValueByPos(position2);
      var closestBound = _this.getClosestBound(value3);
      var index2 = _this.getBoundNeedMoving(value3, closestBound);
      var prevValue = bounds2[index2];
      if (value3 === prevValue) return null;
      var nextBounds = _toConsumableArray(bounds2);
      nextBounds[index2] = value3;
      return nextBounds;
    };
    _this.onEnd = function(force) {
      var handle = _this.state.handle;
      _this.removeDocumentEvents();
      if (!handle) {
        _this.dragTrack = false;
      }
      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({
        handle: null
      });
    };
    var count2 = props.count, min2 = props.min, max2 = props.max;
    var initialValue = Array.apply(void 0, _toConsumableArray(Array(count2 + 1))).map(function() {
      return min2;
    });
    var defaultValue = "defaultValue" in props ? props.defaultValue : initialValue;
    var value2 = props.value !== void 0 ? props.value : defaultValue;
    var bounds = value2.map(function(v2, i3) {
      return _trimAlignValue({
        value: v2,
        handle: i3,
        props
      });
    });
    var recent = bounds[0] === max2 ? 0 : bounds.length - 1;
    _this.state = {
      handle: null,
      recent,
      bounds
    };
    return _this;
  }
  _createClass$2(Range2, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value2) {
      return 0;
    }
  }, {
    key: "getSliderLength",
    value: function getSliderLength() {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value2) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index2, h4) {
    }
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var _this$props = this.props, onChange2 = _this$props.onChange, value2 = _this$props.value, min2 = _this$props.min, max2 = _this$props.max;
      if (!("min" in this.props || "max" in this.props)) {
        return;
      }
      if (min2 === prevProps.min && max2 === prevProps.max) {
        return;
      }
      var currentValue = value2 || prevState.bounds;
      if (currentValue.some(function(v2) {
        return isValueOutOfRange(v2, _this2.props);
      })) {
        var newValues = currentValue.map(function(v2) {
          return ensureValueInRange(v2, _this2.props);
        });
        onChange2(newValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange2(state) {
      var props = this.props;
      var isNotControlled = !("value" in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ["handle", "recent"].forEach(function(item2) {
          if (state[item2] !== void 0) {
            controlledState[item2] = state[item2];
          }
        });
        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }
      var data = _objectSpread2$1(_objectSpread2$1({}, this.state), state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position2) {
      var props = this.props, state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);
      var value2 = this.calcValueByPos(position2);
      this.startValue = value2;
      this.startPosition = position2;
      var closestBound = this.getClosestBound(value2);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value2, closestBound);
      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value2 === prevValue) return;
      var nextBounds = _toConsumableArray(state.bounds);
      nextBounds[this.prevMovedHandleIndex] = value2;
      this.onChange({
        bounds: nextBounds
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e3, position2, dragTrack, startBounds) {
      pauseEvent(e3);
      var state = this.state, props = this.props;
      var maxValue = props.max || 100;
      var minValue = props.min || 0;
      if (dragTrack) {
        var pos = props.vertical ? -position2 : position2;
        pos = props.reverse ? -pos : pos;
        var max2 = maxValue - Math.max.apply(Math, _toConsumableArray(startBounds));
        var min2 = minValue - Math.min.apply(Math, _toConsumableArray(startBounds));
        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min2), max2);
        var nextBounds = startBounds.map(function(v2) {
          return Math.floor(Math.max(Math.min(v2 + ratio, maxValue), minValue));
        });
        if (state.bounds.map(function(c3, i3) {
          return c3 === nextBounds[i3];
        }).some(function(c3) {
          return !c3;
        })) {
          this.onChange({
            bounds: nextBounds
          });
        }
        return;
      }
      var value2 = this.calcValueByPos(position2);
      var oldValue = state.bounds[state.handle];
      if (value2 === oldValue) return;
      this.moveTo(value2);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e3) {
      var _this$props2 = this.props, reverse = _this$props2.reverse, vertical2 = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e3, vertical2, reverse);
      if (valueMutator) {
        pauseEvent(e3);
        var state = this.state, props = this.props;
        var bounds = state.bounds, handle = state.handle;
        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value2 = _trimAlignValue({
          value: mutatedValue,
          handle,
          bounds: state.bounds,
          props
        });
        if (value2 === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value2, isFromKeyboardEvent);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: "getClosestBound",
    value: function getClosestBound(value2) {
      var bounds = this.state.bounds;
      var closestBound = 0;
      for (var i3 = 1; i3 < bounds.length - 1; i3 += 1) {
        if (value2 >= bounds[i3]) {
          closestBound = i3;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value2) < Math.abs(bounds[closestBound] - value2)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: "getBoundNeedMoving",
    value: function getBoundNeedMoving(value2, closestBound) {
      var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }
      if (isAtTheSamePoint && value2 !== bounds[closestBound + 1]) {
        boundNeedMoving = value2 < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      var bounds = this.state.bounds;
      return bounds[bounds.length - 1];
    }
    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */
  }, {
    key: "getPoints",
    value: function getPoints() {
      var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min2 = _this$props3.min, max2 = _this$props3.max;
      var cache = this.internalPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = _objectSpread2$1({}, marks);
        if (step !== null) {
          for (var point = min2; point <= max2; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function(a4, b3) {
          return a4 - b3;
        });
        this.internalPointsCache = {
          marks,
          step,
          points
        };
      }
      return this.internalPointsCache.points;
    }
  }, {
    key: "moveTo",
    value: function moveTo(value2, isFromKeyboardEvent) {
      var _this3 = this;
      var state = this.state, props = this.props;
      var nextBounds = _toConsumableArray(state.bounds);
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value2;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function(a4, b3) {
          return a4 - b3;
        });
        nextHandle = nextBounds.indexOf(value2);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        this.props.onAfterChange(nextBounds);
        this.setState({}, function() {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: "pushSurroundingHandles",
    value: function pushSurroundingHandles(bounds, handle) {
      var value2 = bounds[handle];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var direction = 0;
      if (bounds[handle + 1] - value2 < threshold) {
        direction = 1;
      }
      if (value2 - bounds[handle - 1] < threshold) {
        direction = -1;
      }
      if (direction === 0) {
        return;
      }
      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value2);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: "pushHandle",
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      return true;
    }
  }, {
    key: "pushHandleOnePoint",
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        return false;
      }
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue2(value2) {
      var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
      return _trimAlignValue({
        value: value2,
        handle,
        bounds,
        props: this.props
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
      var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical2 = _this$props4.vertical, included = _this$props4.included, disabled2 = _this$props4.disabled, min2 = _this$props4.min, max2 = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
      var offsets = bounds.map(function(v2) {
        return _this4.calcOffset(v2);
      });
      var handleClassName = "".concat(prefixCls, "-handle");
      var handles = bounds.map(function(v2, i3) {
        var _classNames;
        var mergedTabIndex = tabIndex[i3] || 0;
        if (disabled2 || tabIndex[i3] === null) {
          mergedTabIndex = null;
        }
        var dragging = handle === i3;
        return handleGenerator({
          className: r((_classNames = {}, _defineProperty$3(_classNames, handleClassName, true), _defineProperty$3(_classNames, "".concat(handleClassName, "-").concat(i3 + 1), true), _defineProperty$3(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
          prefixCls,
          vertical: vertical2,
          dragging,
          offset: offsets[i3],
          value: v2,
          index: i3,
          tabIndex: mergedTabIndex,
          min: min2,
          max: max2,
          reverse,
          disabled: disabled2,
          style: handleStyle[i3],
          ref: function ref2(h4) {
            return _this4.saveHandle(i3, h4);
          },
          ariaLabel: ariaLabelGroupForHandles[i3],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i3],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i3]
        });
      });
      var tracks = bounds.slice(0, -1).map(function(_2, index2) {
        var _classNames2;
        var i3 = index2 + 1;
        var trackClassName = r((_classNames2 = {}, _defineProperty$3(_classNames2, "".concat(prefixCls, "-track"), true), _defineProperty$3(_classNames2, "".concat(prefixCls, "-track-").concat(i3), true), _classNames2));
        return /* @__PURE__ */ React__default.createElement(Track, {
          className: trackClassName,
          vertical: vertical2,
          reverse,
          included,
          offset: offsets[i3 - 1],
          length: offsets[i3] - offsets[i3 - 1],
          style: trackStyle[index2],
          key: i3
        });
      });
      return {
        tracks,
        handles
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps2(props, state) {
      if (!("value" in props || "min" in props || "max" in props)) {
        return null;
      }
      var value2 = props.value || state.bounds;
      var nextBounds = value2.map(function(v2, i3) {
        return _trimAlignValue({
          value: v2,
          handle: i3,
          bounds: state.bounds,
          props
        });
      });
      if (state.bounds.length === nextBounds.length) {
        if (nextBounds.every(function(v2, i3) {
          return v2 === state.bounds[i3];
        })) {
          return null;
        }
      } else {
        nextBounds = value2.map(function(v2, i3) {
          return _trimAlignValue({
            value: v2,
            handle: i3,
            props
          });
        });
      }
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        bounds: nextBounds
      });
    }
  }]);
  return Range2;
})(React__default.Component);
Range.displayName = "Range";
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  draggableTrack: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};
const Range$1 = createSlider(Range);
var raf = function raf2(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf2(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id);
      callback();
    } else {
      var realId = raf(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function(id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
function contains$1(root2, n2) {
  if (!root2) {
    return false;
  }
  if (root2.contains) {
    return root2.contains(n2);
  }
  var node2 = n2;
  while (node2) {
    if (node2 === root2) {
      return true;
    }
    node2 = node2.parentNode;
  }
  return false;
}
function isDOM(node2) {
  return node2 instanceof HTMLElement || node2 instanceof SVGElement;
}
function getDOM(node2) {
  if (node2 && _typeof$2(node2) === "object" && isDOM(node2.nativeElement)) {
    return node2.nativeElement;
  }
  if (isDOM(node2)) {
    return node2;
  }
  return null;
}
function findDOMNode(node2) {
  var domNode = getDOM(node2);
  if (domNode) {
    return domNode;
  }
  if (node2 instanceof React__default.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = ReactDOM__default.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(ReactDOM__default, node2);
  }
  return null;
}
var REACT_ELEMENT_TYPE_18 = /* @__PURE__ */ Symbol.for("react.element");
var REACT_ELEMENT_TYPE_19 = /* @__PURE__ */ Symbol.for("react.transitional.element");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
function isFragment(object) {
  return (
    // Base object type
    object && _typeof$2(object) === "object" && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE
  );
}
var ReactMajorVersion = Number(version.split(".")[0]);
var fillRef = function fillRef2(ref2, node2) {
  if (typeof ref2 === "function") {
    ref2(node2);
  } else if (_typeof$2(ref2) === "object" && ref2 && "current" in ref2) {
    ref2.current = node2;
  }
};
var composeRef = function composeRef2() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function(node2) {
    refs.forEach(function(ref2) {
      fillRef(ref2, node2);
    });
  };
};
var supportRef = function supportRef2(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }
  if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) {
    return true;
  }
  var type2 = reactIsExports.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type2 === "function" && !((_type$prototype = type2.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type2.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node2) {
  return /* @__PURE__ */ isValidElement(node2) && !isFragment(node2);
}
var getNodeRef = function getNodeRef2(node2) {
  if (node2 && isReactElement(node2)) {
    var ele = node2;
    return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
  }
  return null;
};
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var Portal = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
  var parentRef = useRef();
  var containerRef = useRef();
  useImperativeHandle(ref2, function() {
    return {};
  });
  var initRef = useRef(false);
  if (!initRef.current && canUseDom()) {
    containerRef.current = getContainer();
    parentRef.current = containerRef.current.parentNode;
    initRef.current = true;
  }
  useEffect(function() {
    didUpdate === null || didUpdate === void 0 || didUpdate(props);
  });
  useEffect(function() {
    if (containerRef.current.parentNode === null && parentRef.current !== null) {
      parentRef.current.appendChild(containerRef.current);
    }
    return function() {
      var _containerRef$current;
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /* @__PURE__ */ ReactDOM__default.createPortal(children, containerRef.current) : null;
});
function isPointsEq(a1, a22, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a22[0];
  }
  return a1[0] === a22[0] && a1[1] === a22[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _objectSpread2$1(_objectSpread2$1({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements2 = Object.keys(builtinPlacements);
  for (var i3 = 0; i3 < placements2.length; i3 += 1) {
    var placement = placements2[i3];
    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return "";
}
const isMobile = (function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
});
var Context = /* @__PURE__ */ React.createContext({});
var DomWrapper = /* @__PURE__ */ (function(_React$Component) {
  _inherits$1(DomWrapper2, _React$Component);
  var _super = _createSuper$1(DomWrapper2);
  function DomWrapper2() {
    _classCallCheck$2(this, DomWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass$2(DomWrapper2, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper2;
})(React.Component);
function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}
var useInternalLayoutEffect = canUseDom() ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect = function useLayoutEffect2(callback, deps) {
  var firstMountRef = React.useRef(true);
  useInternalLayoutEffect(function() {
    return callback(firstMountRef.current);
  }, deps);
  useInternalLayoutEffect(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue), _React$useState2 = _slicedToArray$1(_React$useState, 2), value2 = _React$useState2[0], setValue = _React$useState2[1];
  React.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value2, safeSetState];
}
function useSyncState(defaultValue) {
  var _React$useReducer = React.useReducer(function(x3) {
    return x3 + 1;
  }, 0), _React$useReducer2 = _slicedToArray$1(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
  var currentValueRef = React.useRef(defaultValue);
  var getValue = useEvent(function() {
    return currentValueRef.current;
  });
  var setValue = useEvent(function(updater) {
    currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue, setValue];
}
var STATUS_NONE = "none";
var STATUS_APPEAR = "appear";
var STATUS_ENTER = "enter";
var STATUS_LEAVE = "leave";
var STEP_NONE = "none";
var STEP_PREPARE = "prepare";
var STEP_START = "start";
var STEP_ACTIVE = "active";
var STEP_ACTIVATED = "end";
var STEP_PREPARED = "prepared";
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== "undefined" ? window : {});
var style = {};
if (canUseDom()) {
  var _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i3 = 0; i3 < len; i3 += 1) {
      var styleProp = stylePropList[i3];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend");
var internalTransitionEndName = getVendorPrefixedEventName("transitionend");
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || "animationend";
var transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$1(transitionName, transitionType) {
  if (!transitionName) return null;
  if (_typeof$2(transitionName) === "object") {
    var type2 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName[type2];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
const useDomMotionEvents = (function(onInternalMotionEnd) {
  var cacheElementRef = useRef();
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);
      cacheElementRef.current = element;
    }
  }
  React.useEffect(function() {
    return function() {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
var useIsomorphicLayoutEffect$1 = canUseDom() ? useLayoutEffect$1 : useEffect;
const useNextFrame = (function() {
  var nextFrameRef = React.useRef(null);
  function cancelNextFrame() {
    wrapperRaf.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = wrapperRaf(function() {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];
var SkipStep = false;
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
const useStepQueue = (function(status2, prepareOnly, callback) {
  var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray$1(_useState, 2), step = _useState2[0], setStep = _useState2[1];
  var _useNextFrame = useNextFrame(), _useNextFrame2 = _slicedToArray$1(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  useIsomorphicLayoutEffect$1(function() {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index2 = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index2 + 1];
      var result = callback(step);
      if (result === SkipStep) {
        setStep(nextStep, true);
      } else if (nextStep) {
        nextFrame(function(info) {
          function doNext() {
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status2, step]);
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
function useStatus(supportMotion, visible, getElement2, _ref3) {
  var _ref$motionEnter = _ref3.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref3.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref3.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref3.motionDeadline, motionLeaveImmediately = _ref3.motionLeaveImmediately, onAppearPrepare = _ref3.onAppearPrepare, onEnterPrepare = _ref3.onEnterPrepare, onLeavePrepare = _ref3.onLeavePrepare, onAppearStart = _ref3.onAppearStart, onEnterStart = _ref3.onEnterStart, onLeaveStart = _ref3.onLeaveStart, onAppearActive = _ref3.onAppearActive, onEnterActive = _ref3.onEnterActive, onLeaveActive = _ref3.onLeaveActive, onAppearEnd = _ref3.onAppearEnd, onEnterEnd = _ref3.onEnterEnd, onLeaveEnd = _ref3.onLeaveEnd, onVisibleChanged = _ref3.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray$1(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE), _useSyncState2 = _slicedToArray$1(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
  var _useState3 = useSafeState(null), _useState4 = _slicedToArray$1(_useState3, 2), style2 = _useState4[0], setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = useRef(false);
  var deadlineRef = useRef(null);
  function getDomElement() {
    return getElement2();
  }
  var activeRef = useRef(false);
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = useEvent(function(event) {
    var status2 = getStatus();
    if (status2 === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status2 === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status2 === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status2 === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray$1(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var getEventHandlers = function getEventHandlers2(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = React.useMemo(function() {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }
    if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
      patchMotionEvents(getDomElement());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    if (step === STEP_PREPARED) {
      updateMotionEndStatus();
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray$1(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active2 = isActive(step);
  activeRef.current = active2;
  var visibleRef = useRef(null);
  useIsomorphicLayoutEffect$1(function() {
    if (mountedRef.current && visibleRef.current === visible) {
      return;
    }
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      setStatus(STATUS_NONE);
    }
    visibleRef.current = visible;
  }, [visible]);
  useEffect(function() {
    if (
      // Cancel appear
      currentStatus === STATUS_APPEAR && !motionAppear || // Cancel enter
      currentStatus === STATUS_ENTER && !motionEnter || // Cancel leave
      currentStatus === STATUS_LEAVE && !motionLeave
    ) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  useEffect(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React.useRef(false);
  useEffect(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && currentStatus === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);
  var mergedStyle = style2;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2$1({
      transition: "none"
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
function genCSSMotion(config) {
  var transitionSupport = config;
  if (_typeof$2(config) === "object") {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion2 = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
    var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
    var _React$useContext = React.useContext(Context), contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);
    var nodeRef = useRef();
    var wrapperNodeRef = useRef();
    function getDomElement() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e3) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props), _useStatus2 = _slicedToArray$1(_useStatus, 4), status2 = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React.useCallback(function(node2) {
      nodeRef.current = node2;
      fillRef(ref2, node2);
    }, [ref2]);
    var motionChildren;
    var mergedProps = _objectSpread2$1(_objectSpread2$1({}, eventProps), {}, {
      visible
    });
    if (!children) {
      motionChildren = null;
    } else if (status2 === STATUS_NONE) {
      if (mergedVisible) {
        motionChildren = children(_objectSpread2$1({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      var motionCls = getTransitionName$1(motionName, "".concat(status2, "-").concat(statusSuffix));
      motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
        className: r(getTransitionName$1(motionName, status2), _defineProperty$3(_defineProperty$3({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === "string")),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var originNodeRef = getNodeRef(motionChildren);
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion2.displayName = "CSSMotion";
  return CSSMotion2;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add";
var STATUS_KEEP = "keep";
var STATUS_REMOVE = "remove";
var STATUS_REMOVED = "removed";
function wrapKeyToObject(key) {
  var keyObj;
  if (key && _typeof$2(key) === "object" && "key" in key) {
    keyObj = key;
  } else {
    keyObj = {
      key
    };
  }
  return _objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list2 = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i3 = currentIndex; i3 < currentLen; i3 += 1) {
      var currentKeyObj = currentKeyObjects[i3];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i3) {
          list2 = list2.concat(currentKeyObjects.slice(currentIndex, i3).map(function(obj) {
            return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i3;
        }
        list2.push(_objectSpread2$1(_objectSpread2$1({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list2.push(_objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list2 = list2.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys = {};
  list2.forEach(function(_ref3) {
    var key = _ref3.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function(key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list2 = list2.filter(function(_ref22) {
      var key = _ref22.key, status2 = _ref22.status;
      return key !== matchKey || status2 !== STATUS_REMOVE;
    });
    list2.forEach(function(node2) {
      if (node2.key === matchKey) {
        node2.status = STATUS_KEEP;
      }
    });
  });
  return list2;
}
var _excluded$2 = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2 = ["status"];
var MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(transitionSupport) {
  var CSSMotion$1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion;
  var CSSMotionList = /* @__PURE__ */ (function(_React$Component) {
    _inherits$1(CSSMotionList2, _React$Component);
    var _super = _createSuper$1(CSSMotionList2);
    function CSSMotionList2() {
      var _this;
      _classCallCheck$2(this, CSSMotionList2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty$3(_assertThisInitialized$2(_this), "state", {
        keyEntities: []
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "removeKey", function(removeKey) {
        _this.setState(function(prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function(entity) {
            if (entity.key !== removeKey) return entity;
            return _objectSpread2$1(_objectSpread2$1({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function() {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function(_ref3) {
            var status2 = _ref3.status;
            return status2 !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    _createClass$2(CSSMotionList2, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged;
        _this$props.onAllRemoved;
        var restProps = _objectWithoutProperties(_this$props, _excluded$2);
        var Component2 = component || React.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React.createElement(Component2, restProps, keyEntities.map(function(_ref22, index2) {
          var status2 = _ref22.status, eventProps = _objectWithoutProperties(_ref22, _excluded2);
          var visible = status2 === STATUS_ADD || status2 === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(CSSMotion$1, _extends$1({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function(props, ref2) {
            return children(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
              index: index2
            }), ref2);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps2(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList2;
  })(React.Component);
  _defineProperty$3(CSSMotionList, "defaultProps", {
    component: "div"
  });
  return CSSMotionList;
}
genCSSMotionList(supportTransition);
function getMotion(_ref3) {
  var prefixCls = _ref3.prefixCls, motion = _ref3.motion, animation2 = _ref3.animation, transitionName = _ref3.transitionName;
  if (motion) {
    return motion;
  }
  if (animation2) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation2)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}
function Mask(props) {
  var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
  if (!mask) {
    return null;
  }
  var motion = {};
  if (maskMotion || maskTransitionName || maskAnimation) {
    motion = _objectSpread2$1({
      motionAppear: true
    }, getMotion({
      motion: maskMotion,
      prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    }));
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$1({}, motion, {
    visible,
    removeOnLeave: true
  }), function(_ref3) {
    var className = _ref3.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex
      },
      className: r("".concat(prefixCls, "-mask"), className)
    });
  });
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = null != arguments[i3] ? arguments[i3] : {};
    i3 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _defineProperty$1(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var vendorPrefix;
var jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0) {
    return vendorPrefix;
  }
  vendorPrefix = "";
  var style2 = document.createElement("p").style;
  var testProp = "Transform";
  for (var key in jsCssMap) {
    if (key + testProp in style2) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(node2, value2) {
  var name2 = getTransitionName();
  if (name2) {
    node2.style[name2] = value2;
    if (name2 !== "transitionProperty") {
      node2.style.transitionProperty = value2;
    }
  }
}
function setTransform(node2, value2) {
  var name2 = getTransformName();
  if (name2) {
    node2.style[name2] = value2;
    if (name2 !== "transform") {
      node2.style.transform = value2;
    }
  }
}
function getTransitionProperty(node2) {
  return node2.style.transitionProperty || node2.style[getTransitionName()];
}
function getTransformXY(node2) {
  var style2 = window.getComputedStyle(node2, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node2, xy) {
  var style2 = window.getComputedStyle(node2, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(",").map(function(item2) {
        return parseFloat(item2, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node2, "matrix(".concat(arr.join(","), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(",").map(function(item2) {
        return parseFloat(item2, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node2, "matrix3d(".concat(arr.join(","), ")"));
    }
  } else {
    setTransform(node2, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = "none";
  elem.offsetHeight;
  elem.style.display = originalStyle;
}
function css4(el, name2, v2) {
  var value2 = v2;
  if (_typeof$1(name2) === "object") {
    for (var i3 in name2) {
      if (name2.hasOwnProperty(i3)) {
        css4(el, i3, name2[i3]);
      }
    }
    return void 0;
  }
  if (typeof value2 !== "undefined") {
    if (typeof value2 === "number") {
      value2 = "".concat(value2, "px");
    }
    el.style[name2] = value2;
    return void 0;
  }
  return getComputedStyleX(el, name2);
}
function getClientPosition(elem) {
  var box2;
  var x3;
  var y3;
  var doc = elem.ownerDocument;
  var body2 = doc.body;
  var docElem = doc && doc.documentElement;
  box2 = elem.getBoundingClientRect();
  x3 = Math.floor(box2.left);
  y3 = Math.floor(box2.top);
  x3 -= docElem.clientLeft || body2.clientLeft || 0;
  y3 -= docElem.clientTop || body2.clientTop || 0;
  return {
    left: x3,
    top: y3
  };
}
function getScroll(w3, top2) {
  var ret = w3["page".concat(top2 ? "Y" : "X", "Offset")];
  var method = "scroll".concat(top2 ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d4 = w3.document;
    ret = d4.documentElement[method];
    if (typeof ret !== "number") {
      ret = d4.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w3) {
  return getScroll(w3);
}
function getScrollTop(w3) {
  return getScroll(w3, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w3 = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w3);
  pos.top += getScrollTop(w3);
  return pos;
}
function isWindow(obj) {
  return obj !== null && obj !== void 0 && obj == obj.window;
}
function getDocument(node2) {
  if (isWindow(node2)) {
    return node2.document;
  }
  if (node2.nodeType === 9) {
    return node2;
  }
  return node2.ownerDocument;
}
function _getComputedStyle(elem, name2, cs) {
  var computedStyle = cs;
  var val = "";
  var d4 = getDocument(elem);
  computedStyle = computedStyle || d4.defaultView.getComputedStyle(elem, null);
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name2) || computedStyle[name2];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name2) {
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name2];
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name2)) {
    var style2 = elem.style;
    var left2 = style2[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
    style2[LEFT] = name2 === "fontSize" ? "1em" : ret || 0;
    ret = style2.pixelLeft + PX;
    style2[LEFT] = left2;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === "left") {
    return option.useCssRight ? "right" : dir;
  }
  return option.useCssBottom ? "bottom" : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === "left") {
    return "right";
  } else if (dir === "right") {
    return "left";
  } else if (dir === "top") {
    return "bottom";
  } else if (dir === "bottom") {
    return "top";
  }
}
function setLeftTop(elem, offset3, option) {
  if (css4(elem, "position") === "static") {
    elem.style.position = "relative";
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection("left", option);
  var verticalProperty = getOffsetDirection("top", option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== "left") {
    presetH = 999;
  }
  if (verticalProperty !== "top") {
    presetV = 999;
  }
  var originalTransition = "";
  var originalOffset = getOffset(elem);
  if ("left" in offset3 || "top" in offset3) {
    originalTransition = getTransitionProperty(elem) || "";
    setTransitionProperty(elem, "none");
  }
  if ("left" in offset3) {
    elem.style[oppositeHorizontalProperty] = "";
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ("top" in offset3) {
    elem.style[oppositeVerticalProperty] = "";
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset3) {
    if (offset3.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === "left" ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css4(elem, originalStyle);
  forceRelayout(elem);
  if ("left" in offset3 || "top" in offset3) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset3) {
    if (offset3.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset3[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css4(elem, ret);
}
function setTransform$1(elem, offset3) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ("left" in offset3) {
    resultXY.x = originalXY.x + offset3.left - originalOffset.left;
  }
  if ("top" in offset3) {
    resultXY.y = originalXY.y + offset3.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset3, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset3.left.toFixed(0);
    var tTop = offset3.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset3, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset3);
  } else {
    setLeftTop(elem, offset3, option);
  }
}
function each(arr, fn2) {
  for (var i3 = 0; i3 < arr.length; i3++) {
    fn2(arr[i3]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options2, callback) {
  var old = {};
  var style2 = elem.style;
  var name2;
  for (name2 in options2) {
    if (options2.hasOwnProperty(name2)) {
      old[name2] = style2[name2];
      style2[name2] = options2[name2];
    }
  }
  callback.call(elem);
  for (name2 in options2) {
    if (options2.hasOwnProperty(name2)) {
      style2[name2] = old[name2];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value2 = 0;
  var prop;
  var j;
  var i3;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i3 = 0; i3 < which.length; i3++) {
        var cssProp = void 0;
        if (prop === "border") {
          cssProp = "".concat(prop).concat(which[i3], "Width");
        } else {
          cssProp = prop + which[i3];
        }
        value2 += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value2;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(["Width", "Height"], function(name2) {
  domUtils["doc".concat(name2)] = function(refWin) {
    var d4 = refWin.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d4.documentElement["scroll".concat(name2)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d4.body["scroll".concat(name2)],
      domUtils["viewport".concat(name2)](d4)
    );
  };
  domUtils["viewport".concat(name2)] = function(win) {
    var prop = "client".concat(name2);
    var doc = win.document;
    var body2 = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    return doc.compatMode === "CSS1Compat" && documentElementProp || body2 && body2[prop] || documentElementProp;
  };
});
function getWH(elem, name2, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name2 === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name2 === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name2 === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  var borderBoxValue = name2 === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === void 0 || borderBoxValue <= 0) {
    borderBoxValue = void 0;
    cssBoxValue = getComputedStyleX(elem, name2);
    if (cssBoxValue === null || cssBoxValue === void 0 || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name2] || 0;
    }
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === void 0) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ["border", "padding"], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(void 0, args);
  } else {
    swap(elem, cssShow, function() {
      val = getWH.apply(void 0, args);
    });
  }
  return val;
}
each(["width", "height"], function(name2) {
  var first = name2.charAt(0).toUpperCase() + name2.slice(1);
  domUtils["outer".concat(first)] = function(el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name2, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name2 === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[name2] = function(elem, v2) {
    var val = v2;
    if (val !== void 0) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ["padding", "border"], which);
        }
        return css4(elem, name2, val);
      }
      return void 0;
    }
    return elem && getWHIgnoreDisplay(elem, name2, CONTENT_INDEX);
  };
});
function mix(to, from2) {
  for (var i3 in from2) {
    if (from2.hasOwnProperty(i3)) {
      to[i3] = from2[i3];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node2) {
    if (node2 && node2.document && node2.setTimeout) {
      return node2;
    }
    var doc = node2.ownerDocument || node2;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument,
  offset: function offset(el, value2, option) {
    if (typeof value2 !== "undefined") {
      setOffset(el, value2, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow,
  each,
  css: css4,
  clone: function clone(obj) {
    var i3;
    var ret = {};
    for (i3 in obj) {
      if (obj.hasOwnProperty(i3)) {
        ret[i3] = obj[i3];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i3 in obj) {
        if (obj.hasOwnProperty(i3)) {
          ret.overflow[i3] = obj.overflow[i3];
        }
      }
    }
    return ret;
  },
  mix,
  getWindowScrollLeft: function getWindowScrollLeft(w3) {
    return getScrollLeft(w3);
  },
  getWindowScrollTop: function getWindowScrollTop(w3) {
    return getScrollTop(w3);
  },
  merge: function merge2() {
    var ret = {};
    for (var i3 = 0; i3 < arguments.length; i3++) {
      utils.mix(ret, i3 < 0 || arguments.length <= i3 ? void 0 : arguments[i3]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);
var getParent2 = utils.getParent;
function getOffsetParent$1(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  var doc = utils.getDocument(element);
  var body2 = doc.body;
  var parent;
  var positionStyle = utils.css(element, "position");
  var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === "html" ? null : getParent2(element);
  }
  for (parent = getParent2(element); parent && parent !== body2 && parent.nodeType !== 9; parent = getParent2(parent)) {
    positionStyle = utils.css(parent, "position");
    if (positionStyle !== "static") {
      return parent;
    }
  }
  return null;
}
var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body2 = doc.body;
  var parent = null;
  for (
    parent = getParent$1(element);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body2 && parent !== doc;
    parent = getParent$1(parent)
  ) {
    var positionStyle = utils.css(parent, "position");
    if (positionStyle === "fixed") {
      return true;
    }
  }
  return false;
}
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent$1(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body2 = doc.body;
  var documentElement = doc.documentElement;
  while (el) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body2 && el !== documentElement && utils.css(el, "overflow") !== "visible") {
      var pos = utils.offset(el);
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(
        visibleRect.right,
        // consider area without scrollBar
        pos.left + el.clientWidth
      );
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body2 || el === documentElement) {
      break;
    }
    el = getOffsetParent$1(el);
  }
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position2 = utils.css(element, "position");
    if (position2 === "absolute") {
      element.style.position = "fixed";
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;
  var bodyStyle = window.getComputedStyle(body2);
  if (bodyStyle.overflowX === "hidden") {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === "hidden") {
    documentHeight = win.innerHeight;
  }
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}
function getRegion(node2) {
  var offset3;
  var w3;
  var h4;
  if (!utils.isWindow(node2) && node2.nodeType !== 9) {
    offset3 = utils.offset(node2);
    w3 = utils.outerWidth(node2);
    h4 = utils.outerHeight(node2);
  } else {
    var win = utils.getWindow(node2);
    offset3 = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w3 = utils.viewportWidth(win);
    h4 = utils.viewportHeight(win);
  }
  offset3.width = w3;
  offset3.height = h4;
  return offset3;
}
function getAlignOffset(region, align) {
  var V2 = align.charAt(0);
  var H4 = align.charAt(1);
  var w3 = region.width;
  var h4 = region.height;
  var x3 = region.left;
  var y3 = region.top;
  if (V2 === "c") {
    y3 += h4 / 2;
  } else if (V2 === "b") {
    y3 += h4;
  }
  if (H4 === "c") {
    x3 += w3 / 2;
  } else if (H4 === "r") {
    x3 += w3;
  }
  return {
    left: x3,
    top: y3
  };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset3, targetOffset2) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset3[0] - targetOffset2[0]),
    top: Math.round(elRegion.top - diff[1] + offset3[1] - targetOffset2[1])
  };
}
function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip$2(points, reg, map) {
  var ret = [];
  utils.each(points, function(p2) {
    ret.push(p2.replace(reg, function(m4) {
      return map[m4];
    }));
  });
  return ret;
}
function flipOffset(offset3, index2) {
  offset3[index2] = -offset3[index2];
  return offset3;
}
function convertOffset(str, offsetLen) {
  var n2;
  if (/%$/.test(str)) {
    n2 = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n2 = parseInt(str, 10);
  }
  return n2 || 0;
}
function normalizeOffset(offset3, el) {
  offset3[0] = convertOffset(offset3[0], el.width);
  offset3[1] = convertOffset(offset3[1], el.height);
}
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset3 = align.offset || [0, 0];
  var targetOffset2 = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset3 = [].concat(offset3);
  targetOffset2 = [].concat(targetOffset2);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  var elRegion = getRegion(source);
  normalizeOffset(offset3, elRegion);
  normalizeOffset(targetOffset2, tgtRegion);
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
  var newElRegion = utils.merge(elRegion, elFuturePos);
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        var newPoints = flip$2(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
        var newOffset = flipOffset(offset3, 0);
        var newTargetOffset = flipOffset(targetOffset2, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset3 = newOffset;
          targetOffset2 = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        var _newPoints = flip$2(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
        var _newOffset = flipOffset(offset3, 1);
        var _newTargetOffset = flipOffset(targetOffset2, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset3 = _newOffset;
          targetOffset2 = _newTargetOffset;
        }
      }
    }
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;
      if (isStillFailX) {
        _newPoints2 = flip$2(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip$2(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
      }
      points = _newPoints2;
      offset3 = align.offset || [0, 0];
      targetOffset2 = align.targetOffset || [0, 0];
    }
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
  }
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points,
    offset: offset3,
    targetOffset: targetOffset2,
    overflow: newOverflowCfg
  };
}
function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent$1;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ("pageX" in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ("pageY" in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
  var points = [align.points[0], "cc"];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points
  }), pointInView);
}
function isEqual$2(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var refSet = /* @__PURE__ */ new Set();
  function deepEqual(a4, b3) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var circular = refSet.has(a4);
    warningOnce(!circular, "Warning: There may be circular references");
    if (circular) {
      return false;
    }
    if (a4 === b3) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a4);
    var newLevel = level + 1;
    if (Array.isArray(a4)) {
      if (!Array.isArray(b3) || a4.length !== b3.length) {
        return false;
      }
      for (var i3 = 0; i3 < a4.length; i3++) {
        if (!deepEqual(a4[i3], b3[i3], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a4 && b3 && _typeof$2(a4) === "object" && _typeof$2(b3) === "object") {
      var keys = Object.keys(a4);
      if (keys.length !== Object.keys(b3).length) {
        return false;
      }
      return keys.every(function(key) {
        return deepEqual(a4[key], b3[key], newLevel);
      });
    }
    return false;
  }
  return deepEqual(obj1, obj2);
}
const isVisible = (function(element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
});
const useBuffer = (function(callback, buffer) {
  var calledRef = React__default.useRef(false);
  var timeoutRef = React__default.useRef(null);
  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }
  function trigger2(force) {
    cancelTrigger();
    if (!calledRef.current || force === true) {
      if (callback(force) === false) {
        return;
      }
      calledRef.current = true;
      timeoutRef.current = window.setTimeout(function() {
        calledRef.current = false;
      }, buffer);
    } else {
      timeoutRef.current = window.setTimeout(function() {
        calledRef.current = false;
        trigger2();
      }, buffer);
    }
  }
  return [trigger2, function() {
    calledRef.current = false;
    cancelTrigger();
  }];
});
function isSamePoint(prev2, next2) {
  if (prev2 === next2) return true;
  if (!prev2 || !next2) return false;
  if ("pageX" in next2 && "pageY" in next2) {
    return prev2.pageX === next2.pageX && prev2.pageY === next2.pageY;
  }
  if ("clientX" in next2 && "clientY" in next2) {
    return prev2.clientX === next2.clientX && prev2.clientY === next2.clientY;
  }
  return false;
}
function restoreFocus(activeElement, container2) {
  if (activeElement !== document.activeElement && contains$1(container2, activeElement) && typeof activeElement.focus === "function") {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;
  function onResize(_ref3) {
    var _ref22 = _slicedToArray$1(_ref3, 1), target = _ref22[0].target;
    if (!document.documentElement.contains(target)) return;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      Promise.resolve().then(function() {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }
    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }
  var resizeObserver = new index(onResize);
  if (element) {
    resizeObserver.observe(element);
  }
  return function() {
    resizeObserver.disconnect();
  };
}
function getElement(func) {
  if (typeof func !== "function") return null;
  return func();
}
function getPoint(point) {
  if (_typeof$2(point) !== "object" || !point) return null;
  return point;
}
var Align = function Align2(_ref3, ref2) {
  var children = _ref3.children, disabled2 = _ref3.disabled, target = _ref3.target, align = _ref3.align, onAlign = _ref3.onAlign, monitorWindowResize = _ref3.monitorWindowResize, _ref$monitorBufferTim = _ref3.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = React__default.useRef({});
  var nodeRef = React__default.useRef();
  var childNode = React__default.Children.only(children);
  var forceAlignPropsRef = React__default.useRef({});
  forceAlignPropsRef.current.disabled = disabled2;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.align = align;
  forceAlignPropsRef.current.onAlign = onAlign;
  var _useBuffer = useBuffer(function() {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
    var source = nodeRef.current;
    if (!latestDisabled && latestTarget && source) {
      var _result;
      var _element = getElement(latestTarget);
      var _point = getPoint(latestTarget);
      cacheRef.current.element = _element;
      cacheRef.current.point = _point;
      cacheRef.current.align = latestAlign;
      var _document = document, activeElement = _document.activeElement;
      if (_element && isVisible(_element)) {
        _result = alignElement(source, _element, latestAlign);
      } else if (_point) {
        _result = alignPoint(source, _point, latestAlign);
      }
      restoreFocus(activeElement, source);
      if (latestOnAlign && _result) {
        latestOnAlign(source, _result);
      }
      return true;
    }
    return false;
  }, monitorBufferTime), _useBuffer2 = _slicedToArray$1(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1];
  var _React$useState = React__default.useState(), _React$useState2 = _slicedToArray$1(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
  var _React$useState3 = React__default.useState(), _React$useState4 = _slicedToArray$1(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
  useLayoutEffect(function() {
    setElement(getElement(target));
    setPoint(getPoint(target));
  });
  React__default.useEffect(function() {
    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point) || !isEqual$2(cacheRef.current.align, align)) {
      _forceAlign();
    }
  });
  React__default.useEffect(function() {
    var cancelFn = monitorResize(nodeRef.current, _forceAlign);
    return cancelFn;
  }, [nodeRef.current]);
  React__default.useEffect(function() {
    var cancelFn = monitorResize(element, _forceAlign);
    return cancelFn;
  }, [element]);
  React__default.useEffect(function() {
    if (!disabled2) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled2]);
  React__default.useEffect(function() {
    if (monitorWindowResize) {
      var cancelFn = addEventListenerWrap(window, "resize", _forceAlign);
      return cancelFn.remove;
    }
  }, [monitorWindowResize]);
  React__default.useEffect(function() {
    return function() {
      cancelForceAlign();
    };
  }, []);
  React__default.useImperativeHandle(ref2, function() {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  });
  if (/* @__PURE__ */ React__default.isValidElement(childNode)) {
    childNode = /* @__PURE__ */ React__default.cloneElement(childNode, {
      ref: composeRef(childNode.ref, nodeRef)
    });
  }
  return childNode;
};
var RcAlign = /* @__PURE__ */ React__default.forwardRef(Align);
RcAlign.displayName = "Align";
function _OverloadYield(e3, d4) {
  this.v = e3, this.k = d4;
}
function _regeneratorDefine(e3, r2, n2, t3) {
  var i3 = Object.defineProperty;
  try {
    i3({}, "", {});
  } catch (e4) {
    i3 = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e4, r3, n3, t4) {
    function o2(r4, n4) {
      _regeneratorDefine(e4, r4, function(e5) {
        return this._invoke(r4, n4, e5);
      });
    }
    r3 ? i3 ? i3(e4, r3, {
      value: n3,
      enumerable: !t4,
      configurable: !t4,
      writable: !t4
    }) : e4[r3] = n3 : (o2("next", 0), o2("throw", 1), o2("return", 2));
  }, _regeneratorDefine(e3, r2, n2, t3);
}
function _regenerator() {
  var e3, t3, r2 = "function" == typeof Symbol ? Symbol : {}, n2 = r2.iterator || "@@iterator", o2 = r2.toStringTag || "@@toStringTag";
  function i3(r3, n3, o3, i4) {
    var c4 = n3 && n3.prototype instanceof Generator ? n3 : Generator, u4 = Object.create(c4.prototype);
    return _regeneratorDefine(u4, "_invoke", (function(r4, n4, o4) {
      var i5, c5, u5, f3 = 0, p2 = o4 || [], y3 = false, G3 = {
        p: 0,
        n: 0,
        v: e3,
        a: d4,
        f: d4.bind(e3, 4),
        d: function d5(t4, r5) {
          return i5 = t4, c5 = 0, u5 = e3, G3.n = r5, a4;
        }
      };
      function d4(r5, n5) {
        for (c5 = r5, u5 = n5, t3 = 0; !y3 && f3 && !o5 && t3 < p2.length; t3++) {
          var o5, i6 = p2[t3], d5 = G3.p, l2 = i6[2];
          r5 > 3 ? (o5 = l2 === n5) && (u5 = i6[(c5 = i6[4]) ? 5 : (c5 = 3, 3)], i6[4] = i6[5] = e3) : i6[0] <= d5 && ((o5 = r5 < 2 && d5 < i6[1]) ? (c5 = 0, G3.v = n5, G3.n = i6[1]) : d5 < l2 && (o5 = r5 < 3 || i6[0] > n5 || n5 > l2) && (i6[4] = r5, i6[5] = n5, G3.n = l2, c5 = 0));
        }
        if (o5 || r5 > 1) return a4;
        throw y3 = true, n5;
      }
      return function(o5, p3, l2) {
        if (f3 > 1) throw TypeError("Generator is already running");
        for (y3 && 1 === p3 && d4(p3, l2), c5 = p3, u5 = l2; (t3 = c5 < 2 ? e3 : u5) || !y3; ) {
          i5 || (c5 ? c5 < 3 ? (c5 > 1 && (G3.n = -1), d4(c5, u5)) : G3.n = u5 : G3.v = u5);
          try {
            if (f3 = 2, i5) {
              if (c5 || (o5 = "next"), t3 = i5[o5]) {
                if (!(t3 = t3.call(i5, u5))) throw TypeError("iterator result is not an object");
                if (!t3.done) return t3;
                u5 = t3.value, c5 < 2 && (c5 = 0);
              } else 1 === c5 && (t3 = i5["return"]) && t3.call(i5), c5 < 2 && (u5 = TypeError("The iterator does not provide a '" + o5 + "' method"), c5 = 1);
              i5 = e3;
            } else if ((t3 = (y3 = G3.n < 0) ? u5 : r4.call(n4, G3)) !== a4) break;
          } catch (t4) {
            i5 = e3, c5 = 1, u5 = t4;
          } finally {
            f3 = 1;
          }
        }
        return {
          value: t3,
          done: y3
        };
      };
    })(r3, o3, i4), true), u4;
  }
  var a4 = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  t3 = Object.getPrototypeOf;
  var c3 = [][n2] ? t3(t3([][n2]())) : (_regeneratorDefine(t3 = {}, n2, function() {
    return this;
  }), t3), u3 = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c3);
  function f2(e4) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e4, GeneratorFunctionPrototype) : (e4.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e4, o2, "GeneratorFunction")), e4.prototype = Object.create(u3), e4;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u3, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o2, "GeneratorFunction"), _regeneratorDefine(u3), _regeneratorDefine(u3, o2, "Generator"), _regeneratorDefine(u3, n2, function() {
    return this;
  }), _regeneratorDefine(u3, "toString", function() {
    return "[object Generator]";
  }), (_regenerator = function _regenerator2() {
    return {
      w: i3,
      m: f2
    };
  })();
}
function AsyncIterator(t3, e3) {
  function n2(r3, o2, i3, f2) {
    try {
      var c3 = t3[r3](o2), u3 = c3.value;
      return u3 instanceof _OverloadYield ? e3.resolve(u3.v).then(function(t4) {
        n2("next", t4, i3, f2);
      }, function(t4) {
        n2("throw", t4, i3, f2);
      }) : e3.resolve(u3).then(function(t4) {
        c3.value = t4, i3(c3);
      }, function(t4) {
        return n2("throw", t4, i3, f2);
      });
    } catch (t4) {
      f2(t4);
    }
  }
  var r2;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
    return this;
  })), _regeneratorDefine(this, "_invoke", function(t4, o2, i3) {
    function f2() {
      return new e3(function(e4, r3) {
        n2(t4, i3, e4, r3);
      });
    }
    return r2 = r2 ? r2.then(f2, f2) : f2();
  }, true);
}
function _regeneratorAsyncGen(r2, e3, t3, o2, n2) {
  return new AsyncIterator(_regenerator().w(r2, e3, t3, o2), n2 || Promise);
}
function _regeneratorAsync(n2, e3, r2, t3, o2) {
  var a4 = _regeneratorAsyncGen(n2, e3, r2, t3, o2);
  return a4.next().then(function(n3) {
    return n3.done ? n3.value : a4.next();
  });
}
function _regeneratorKeys(e3) {
  var n2 = Object(e3), r2 = [];
  for (var t3 in n2) r2.unshift(t3);
  return function e4() {
    for (; r2.length; ) if ((t3 = r2.pop()) in n2) return e4.value = t3, e4.done = false, e4;
    return e4.done = true, e4;
  };
}
function _regeneratorValues(e3) {
  if (null != e3) {
    var t3 = e3["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r2 = 0;
    if (t3) return t3.call(e3);
    if ("function" == typeof e3.next) return e3;
    if (!isNaN(e3.length)) return {
      next: function next2() {
        return e3 && r2 >= e3.length && (e3 = void 0), {
          value: e3 && e3[r2++],
          done: !e3
        };
      }
    };
  }
  throw new TypeError(_typeof$2(e3) + " is not iterable");
}
function _regeneratorRuntime() {
  var r2 = _regenerator(), e3 = r2.m(_regeneratorRuntime), t3 = (Object.getPrototypeOf ? Object.getPrototypeOf(e3) : e3.__proto__).constructor;
  function n2(r3) {
    var e4 = "function" == typeof r3 && r3.constructor;
    return !!e4 && (e4 === t3 || "GeneratorFunction" === (e4.displayName || e4.name));
  }
  var o2 = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a4(r3) {
    var e4, t4;
    return function(n3) {
      e4 || (e4 = {
        stop: function stop() {
          return t4(n3.a, 2);
        },
        "catch": function _catch() {
          return n3.v;
        },
        abrupt: function abrupt(r4, e5) {
          return t4(n3.a, o2[r4], e5);
        },
        delegateYield: function delegateYield(r4, o3, a5) {
          return e4.resultName = o3, t4(n3.d, _regeneratorValues(r4), a5);
        },
        finish: function finish(r4) {
          return t4(n3.f, r4);
        }
      }, t4 = function t5(r4, _t2, o3) {
        n3.p = e4.prev, n3.n = e4.next;
        try {
          return r4(_t2, o3);
        } finally {
          e4.next = n3.n;
        }
      }), e4.resultName && (e4[e4.resultName] = n3.v, e4.resultName = void 0), e4.sent = n3.v, e4.next = n3.n;
      try {
        return r3.call(this, e4);
      } finally {
        n3.p = e4.prev, n3.n = e4.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime2() {
    return {
      wrap: function wrap2(e4, t4, n3, o3) {
        return r2.w(a4(e4), t4, n3, o3 && o3.reverse());
      },
      isGeneratorFunction: n2,
      mark: r2.m,
      awrap: function awrap(r3, e4) {
        return new _OverloadYield(r3, e4);
      },
      AsyncIterator,
      async: function async(r3, e4, t4, o3, u3) {
        return (n2(e4) ? _regeneratorAsyncGen : _regeneratorAsync)(a4(r3), e4, t4, o3, u3);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function asyncGeneratorStep(n2, t3, e3, r2, o2, a4, c3) {
  try {
    var i3 = n2[a4](c3), u3 = i3.value;
  } catch (n3) {
    return void e3(n3);
  }
  i3.done ? t3(u3) : Promise.resolve(u3).then(r2, o2);
}
function _asyncToGenerator(n2) {
  return function() {
    var t3 = this, e3 = arguments;
    return new Promise(function(r2, o2) {
      var a4 = n2.apply(t3, e3);
      function _next(n3) {
        asyncGeneratorStep(a4, r2, o2, _next, _throw, "next", n3);
      }
      function _throw(n3) {
        asyncGeneratorStep(a4, r2, o2, _next, _throw, "throw", n3);
      }
      _next(void 0);
    });
  };
}
var StatusQueue = ["measure", "alignPre", "align", null, "motion"];
const useVisibleStatus = (function(visible, doMeasure) {
  var _useState = useSafeState(null), _useState2 = _slicedToArray$1(_useState, 2), status2 = _useState2[0], setInternalStatus = _useState2[1];
  var rafRef = useRef();
  function setStatus(nextStatus) {
    setInternalStatus(nextStatus, true);
  }
  function cancelRaf() {
    wrapperRaf.cancel(rafRef.current);
  }
  function goNextStatus(callback) {
    cancelRaf();
    rafRef.current = wrapperRaf(function() {
      setStatus(function(prev2) {
        switch (status2) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return prev2;
      });
      callback === null || callback === void 0 ? void 0 : callback();
    });
  }
  useEffect(function() {
    setStatus("measure");
  }, [visible]);
  useEffect(function() {
    switch (status2) {
      case "measure":
        doMeasure();
        break;
    }
    if (status2) {
      rafRef.current = wrapperRaf(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
        var index2, nextStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index2 = StatusQueue.indexOf(status2);
                nextStatus = StatusQueue[index2 + 1];
                if (nextStatus && index2 !== -1) {
                  setStatus(nextStatus);
                }
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, [status2]);
  useEffect(function() {
    return function() {
      cancelRaf();
    };
  }, []);
  return [status2, goNextStatus];
});
const useStretchStyle = (function(stretch) {
  var _React$useState = React.useState({
    width: 0,
    height: 0
  }), _React$useState2 = _slicedToArray$1(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
  function measureStretch(element) {
    var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
    var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height;
    if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
      tgtWidth = width;
      tgtHeight = height;
    }
    setTargetSize({
      width: tgtWidth,
      height: tgtHeight
    });
  }
  var style2 = React.useMemo(function() {
    var sizeStyle = {};
    if (stretch) {
      var width = targetSize.width, height = targetSize.height;
      if (stretch.indexOf("height") !== -1 && height) {
        sizeStyle.height = height;
      } else if (stretch.indexOf("minHeight") !== -1 && height) {
        sizeStyle.minHeight = height;
      }
      if (stretch.indexOf("width") !== -1 && width) {
        sizeStyle.width = width;
      } else if (stretch.indexOf("minWidth") !== -1 && width) {
        sizeStyle.minWidth = width;
      }
    }
    return sizeStyle;
  }, [stretch, targetSize]);
  return [style2, measureStretch];
});
var PopupInner = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
  var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style2 = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
  var alignRef = useRef();
  var elementRef = useRef();
  var _useState = useState(), _useState2 = _slicedToArray$1(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1];
  var _useStretchStyle = useStretchStyle(stretch), _useStretchStyle2 = _slicedToArray$1(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
  function doMeasure() {
    if (stretch) {
      measureStretchStyle(getRootDomNode());
    }
  }
  var _useVisibleStatus = useVisibleStatus(visible, doMeasure), _useVisibleStatus2 = _slicedToArray$1(_useVisibleStatus, 2), status2 = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1];
  var _useState3 = useState(0), _useState4 = _slicedToArray$1(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
  var prepareResolveRef = useRef();
  useLayoutEffect(function() {
    if (status2 === "alignPre") {
      setAlignTimes(0);
    }
  }, [status2]);
  function getAlignTarget() {
    if (point) {
      return point;
    }
    return getRootDomNode;
  }
  function forceAlign() {
    var _alignRef$current;
    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
  }
  function onInternalAlign(popupDomNode, matchAlign) {
    var nextAlignedClassName = getClassNameFromAlign(matchAlign);
    if (alignedClassName !== nextAlignedClassName) {
      setAlignedClassName(nextAlignedClassName);
    }
    setAlignTimes(function(val) {
      return val + 1;
    });
    if (status2 === "align") {
      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
    }
  }
  useLayoutEffect(function() {
    if (status2 === "align") {
      if (alignTimes < 3) {
        forceAlign();
      } else {
        goNextStatus(function() {
          var _prepareResolveRef$cu;
          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
        });
      }
    }
  }, [alignTimes]);
  var motion = _objectSpread2$1({}, getMotion(props));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(eventName) {
    var originHandler = motion[eventName];
    motion[eventName] = function(element, event) {
      goNextStatus();
      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
    };
  });
  function onShowPrepare() {
    return new Promise(function(resolve) {
      prepareResolveRef.current = resolve;
    });
  }
  React.useEffect(function() {
    if (!motion.motionName && status2 === "motion") {
      goNextStatus();
    }
  }, [motion.motionName, status2]);
  React.useImperativeHandle(ref2, function() {
    return {
      forceAlign,
      getElement: function getElement2() {
        return elementRef.current;
      }
    };
  });
  var mergedStyle = _objectSpread2$1(_objectSpread2$1({}, stretchStyle), {}, {
    zIndex,
    opacity: status2 === "motion" || status2 === "stable" || !visible ? void 0 : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !visible && status2 !== "stable" ? "none" : void 0
  }, style2);
  var alignDisabled = true;
  if (align !== null && align !== void 0 && align.points && (status2 === "align" || status2 === "stable")) {
    alignDisabled = false;
  }
  var childNode = children;
  if (React.Children.count(children) > 1) {
    childNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$1({
    visible,
    ref: elementRef,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }, motion, {
    onAppearPrepare: onShowPrepare,
    onEnterPrepare: onShowPrepare,
    removeOnLeave: destroyPopupOnHide,
    forceRender
  }), function(_ref3, motionRef) {
    var motionClassName = _ref3.className, motionStyle = _ref3.style;
    var mergedClassName = r(prefixCls, className, alignedClassName, motionClassName);
    return /* @__PURE__ */ React.createElement(RcAlign, {
      target: getAlignTarget(),
      key: "popup",
      ref: alignRef,
      monitorWindowResize: true,
      disabled: alignDisabled,
      align,
      onAlign: onInternalAlign
    }, /* @__PURE__ */ React.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      onMouseEnter,
      onMouseLeave,
      onMouseDownCapture: onMouseDown,
      onTouchStartCapture: onTouchStart,
      onClick,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode));
  });
});
PopupInner.displayName = "PopupInner";
var MobilePopupInner = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
  var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
  var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
  var elementRef = React.useRef();
  React.useImperativeHandle(ref2, function() {
    return {
      forceAlign: function forceAlign() {
      },
      getElement: function getElement2() {
        return elementRef.current;
      }
    };
  });
  var mergedStyle = _objectSpread2$1({
    zIndex
  }, popupStyle);
  var childNode = children;
  if (React.Children.count(children) > 1) {
    childNode = /* @__PURE__ */ React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }
  if (popupRender) {
    childNode = popupRender(childNode);
  }
  return /* @__PURE__ */ React.createElement(CSSMotion, _extends$1({
    visible,
    ref: elementRef,
    removeOnLeave: true
  }, popupMotion), function(_ref3, motionRef) {
    var motionClassName = _ref3.className, motionStyle = _ref3.style;
    var mergedClassName = r(prefixCls, popupClassName, motionClassName);
    return /* @__PURE__ */ React.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      onClick,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode);
  });
});
MobilePopupInner.displayName = "MobilePopupInner";
var _excluded$1 = ["visible", "mobile"];
var Popup$1 = /* @__PURE__ */ React.forwardRef(function(_ref3, ref2) {
  var visible = _ref3.visible, mobile = _ref3.mobile, props = _objectWithoutProperties(_ref3, _excluded$1);
  var _useState = useState(visible), _useState2 = _slicedToArray$1(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
  var _useState3 = useState(false), _useState4 = _slicedToArray$1(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
  var cloneProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    visible: innerVisible
  });
  useEffect(function() {
    serInnerVisible(visible);
    if (visible && mobile) {
      setInMobile(isMobile());
    }
  }, [visible, mobile]);
  var popupNode = inMobile ? /* @__PURE__ */ React.createElement(MobilePopupInner, _extends$1({}, cloneProps, {
    mobile,
    ref: ref2
  })) : /* @__PURE__ */ React.createElement(PopupInner, _extends$1({}, cloneProps, {
    ref: ref2
  }));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Mask, cloneProps), popupNode);
});
Popup$1.displayName = "Popup";
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function noop() {
}
function returnEmptyString() {
  return "";
}
function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }
  return window.document;
}
var ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function generateTrigger(PortalComponent) {
  var Trigger2 = /* @__PURE__ */ (function(_React$Component) {
    _inherits$1(Trigger3, _React$Component);
    var _super = _createSuper$1(Trigger3);
    function Trigger3(props) {
      var _this;
      _classCallCheck$2(this, Trigger3);
      _this = _super.call(this, props);
      _defineProperty$3(_assertThisInitialized$2(_this), "popupRef", /* @__PURE__ */ React.createRef());
      _defineProperty$3(_assertThisInitialized$2(_this), "triggerRef", /* @__PURE__ */ React.createRef());
      _defineProperty$3(_assertThisInitialized$2(_this), "portalContainer", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "attachId", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "clickOutsideHandler", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "touchOutsideHandler", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "contextMenuOutsideHandler1", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "contextMenuOutsideHandler2", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "mouseDownTimeout", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "focusTime", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "preClickTime", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "preTouchTime", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "delayTimer", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "hasPopupMouseDown", void 0);
      _defineProperty$3(_assertThisInitialized$2(_this), "onMouseEnter", function(e3) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;
        _this.fireEvents("onMouseEnter", e3);
        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e3);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onMouseMove", function(e3) {
        _this.fireEvents("onMouseMove", e3);
        _this.setPoint(e3);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onMouseLeave", function(e3) {
        _this.fireEvents("onMouseLeave", e3);
        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onPopupMouseEnter", function() {
        _this.clearDelayTimer();
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onPopupMouseLeave", function(e3) {
        var _this$popupRef$curren;
        if (e3.relatedTarget && !e3.relatedTarget.setTimeout && contains$1((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e3.relatedTarget)) {
          return;
        }
        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onFocus", function(e3) {
        _this.fireEvents("onFocus", e3);
        _this.clearDelayTimer();
        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();
          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onMouseDown", function(e3) {
        _this.fireEvents("onMouseDown", e3);
        _this.preClickTime = Date.now();
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onTouchStart", function(e3) {
        _this.fireEvents("onTouchStart", e3);
        _this.preTouchTime = Date.now();
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onBlur", function(e3) {
        _this.fireEvents("onBlur", e3);
        _this.clearDelayTimer();
        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onContextMenu", function(e3) {
        e3.preventDefault();
        _this.fireEvents("onContextMenu", e3);
        _this.setPopupVisible(true, e3);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onContextMenuClose", function() {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onClick", function(event) {
        _this.fireEvents("onClick", event);
        if (_this.focusTime) {
          var preTime;
          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }
          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }
          _this.focusTime = 0;
        }
        _this.preClickTime = 0;
        _this.preTouchTime = 0;
        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }
        var nextVisible = !_this.state.popupVisible;
        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onPopupMouseDown", function() {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function() {
          _this.hasPopupMouseDown = false;
        }, 0);
        if (_this.context) {
          var _this$context;
          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "onDocumentClick", function(event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }
        var target = event.target;
        var root2 = _this.getRootDomNode();
        var popupNode = _this.getPopupDomNode();
        if (
          // mousedown on the target should also close popup when action is contextMenu.
          // https://github.com/ant-design/ant-design/issues/29853
          (!contains$1(root2, target) || _this.isContextMenuOnly()) && !contains$1(popupNode, target) && !_this.hasPopupMouseDown
        ) {
          _this.close();
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "getRootDomNode", function() {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;
        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }
        try {
          var domNode = findDOMNode(_this.triggerRef.current);
          if (domNode) {
            return domNode;
          }
        } catch (err) {
        }
        return ReactDOM__default.findDOMNode(_assertThisInitialized$2(_this));
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "getPopupClassNameFromAlign", function(align) {
        var className = [];
        var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint2 = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
        if (popupPlacement && builtinPlacements) {
          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint2));
        }
        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }
        return className.join(" ");
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "getComponent", function() {
        var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint2 = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
        var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
        var align = _this.getPopupAlign();
        var mouseProps = {};
        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }
        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }
        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return /* @__PURE__ */ React.createElement(Popup$1, _extends$1({
          prefixCls,
          destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint2 && point,
          className: popupClassName,
          align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask,
          zIndex,
          transitionName: popupTransitionName,
          maskAnimation,
          maskTransitionName,
          maskMotion,
          ref: _this.popupRef,
          motion: popupMotion,
          mobile,
          forceRender,
          onClick: onPopupClick
        }), typeof popup === "function" ? popup() : popup);
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "attachParent", function(popupContainer) {
        wrapperRaf.cancel(_this.attachId);
        var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument2 = _this$props3.getDocument;
        var domNode = _this.getRootDomNode();
        var mountNode;
        if (!getPopupContainer) {
          mountNode = getDocument2(_this.getRootDomNode()).body;
        } else if (domNode || getPopupContainer.length === 0) {
          mountNode = getPopupContainer(domNode);
        }
        if (mountNode) {
          mountNode.appendChild(popupContainer);
        } else {
          _this.attachId = wrapperRaf(function() {
            _this.attachParent(popupContainer);
          });
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "getContainer", function() {
        if (!_this.portalContainer) {
          var getDocument2 = _this.props.getDocument;
          var popupContainer = getDocument2(_this.getRootDomNode()).createElement("div");
          popupContainer.style.position = "absolute";
          popupContainer.style.top = "0";
          popupContainer.style.left = "0";
          popupContainer.style.width = "100%";
          _this.portalContainer = popupContainer;
        }
        _this.attachParent(_this.portalContainer);
        return _this.portalContainer;
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "setPoint", function(point) {
        var alignPoint2 = _this.props.alignPoint;
        if (!alignPoint2 || !point) return;
        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "handlePortalUpdate", function() {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      });
      _defineProperty$3(_assertThisInitialized$2(_this), "triggerContextValue", {
        onPopupMouseDown: _this.onPopupMouseDown
      });
      var _popupVisible;
      if ("popupVisible" in props) {
        _popupVisible = !!props.popupVisible;
      } else {
        _popupVisible = !!props.defaultPopupVisible;
      }
      _this.state = {
        prevPopupVisible: _popupVisible,
        popupVisible: _popupVisible
      };
      ALL_HANDLERS.forEach(function(h4) {
        _this["fire".concat(h4)] = function(e3) {
          _this.fireEvents(h4, e3);
        };
      });
      return _this;
    }
    _createClass$2(Trigger3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state;
        if (state.popupVisible) {
          var currentDocument;
          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument(this.getRootDomNode());
            this.clickOutsideHandler = addEventListenerWrap(currentDocument, "mousedown", this.onDocumentClick);
          }
          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.touchOutsideHandler = addEventListenerWrap(currentDocument, "touchstart", this.onDocumentClick);
          }
          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, "scroll", this.onContextMenuClose);
          }
          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextMenuClose);
          }
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
        wrapperRaf.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        var _this$popupRef$curren2;
        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
        if (popupPlacement && builtinPlacements) {
          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
        }
        return popupAlign;
      }
    }, {
      key: "setPopupVisible",
      value: (
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */
        function setPopupVisible(popupVisible, event) {
          var alignPoint2 = this.props.alignPoint;
          var prevPopupVisible = this.state.popupVisible;
          this.clearDelayTimer();
          if (prevPopupVisible !== popupVisible) {
            if (!("popupVisible" in this.props)) {
              this.setState({
                popupVisible,
                prevPopupVisible
              });
            }
            this.props.onPopupVisibleChange(popupVisible);
          }
          if (alignPoint2 && event && popupVisible) {
            this.setPoint(event);
          }
        }
      )
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;
        var delay = delayS * 1e3;
        this.clearDelayTimer();
        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            _this2.setPopupVisible(visible, point);
            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }
        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }
        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }
        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;
        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }
        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
        return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function isContextMenuOnly() {
        var action = this.props.action;
        return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
        return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
        return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
        return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
        return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
        return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
        return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible) {
          var _this$popupRef$curren3;
          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type2, e3) {
        var childCallback = this.props.children.props[type2];
        if (childCallback) {
          childCallback(e3);
        }
        var callback = this.props[type2];
        if (callback) {
          callback(e3);
        }
      }
    }, {
      key: "close",
      value: function close2() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint2 = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
        var child = React.Children.only(children);
        var newChildProps = {
          key: "trigger"
        };
        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
        }
        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains("onClick");
          newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
          newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
        }
        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter;
          if (alignPoint2) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
        }
        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
        }
        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains("onFocus");
          newChildProps.onBlur = this.createTwoChains("onBlur");
        }
        var childrenClassName = r(child && child.props && child.props.className, className);
        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }
        var cloneProps = _objectSpread2$1({}, newChildProps);
        if (supportRef(child)) {
          cloneProps.ref = composeRef(this.triggerRef, child.ref);
        }
        var trigger2 = /* @__PURE__ */ React.cloneElement(child, cloneProps);
        var portal;
        if (popupVisible || this.popupRef.current || forceRender) {
          portal = /* @__PURE__ */ React.createElement(PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }
        if (!popupVisible && autoDestroy) {
          portal = null;
        }
        return /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
          value: this.triggerContextValue
        }, trigger2, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps2(_ref3, prevState) {
        var popupVisible = _ref3.popupVisible;
        var newState = {};
        if (popupVisible !== void 0 && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }
        return newState;
      }
    }]);
    return Trigger3;
  })(React.Component);
  _defineProperty$3(Trigger2, "contextType", TriggerContext);
  _defineProperty$3(Trigger2, "defaultProps", {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  });
  return Trigger2;
}
const Trigger = generateTrigger(Portal);
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements$1 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset
  }
};
function Popup(props) {
  var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style2 = props.style;
  return /* @__PURE__ */ React.createElement("div", {
    className: r("".concat(prefixCls, "-content"), className),
    style: style2
  }, showArrow !== false && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-arrow"),
    key: "arrow"
  }, arrowContent), /* @__PURE__ */ React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof children === "function" ? children() : children));
}
var _excluded = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"];
var Tooltip = function Tooltip2(props, ref2) {
  var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger2 = _props$trigger === void 0 ? ["hover"] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation2 = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay2 = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = _objectWithoutProperties(props, _excluded);
  var domRef = useRef(null);
  useImperativeHandle(ref2, function() {
    return domRef.current;
  });
  var extraProps = _objectSpread2$1({}, restProps);
  if ("visible" in props) {
    extraProps.popupVisible = props.visible;
  }
  var getPopupElement = function getPopupElement2() {
    return /* @__PURE__ */ React.createElement(Popup, {
      showArrow,
      arrowContent,
      key: "content",
      prefixCls,
      id,
      overlayInnerStyle
    }, overlay2);
  };
  var destroyTooltip = false;
  var autoDestroy = false;
  if (typeof destroyTooltipOnHide === "boolean") {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && _typeof$2(destroyTooltipOnHide) === "object") {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }
  return /* @__PURE__ */ React.createElement(Trigger, _extends$1({
    popupClassName: overlayClassName,
    prefixCls,
    popup: getPopupElement,
    action: trigger2,
    builtinPlacements: placements$1,
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation2,
    popupMotion: motion,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy,
    mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay
  }, extraProps), children);
};
const Tooltip$1 = /* @__PURE__ */ forwardRef(Tooltip);
var SliderTooltip = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
  var visible = props.visible, overlay2 = props.overlay;
  var innerRef = React.useRef(null);
  var tooltipRef = composeRef(ref2, innerRef);
  var rafRef = React.useRef(null);
  function cancelKeepAlign() {
    wrapperRaf.cancel(rafRef.current);
  }
  function keepAlign() {
    rafRef.current = wrapperRaf(function() {
      var _innerRef$current;
      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.forcePopupAlign();
    });
  }
  React.useEffect(function() {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [visible, overlay2]);
  return /* @__PURE__ */ React.createElement(Tooltip$1, _extends$1({
    ref: tooltipRef
  }, props));
});
function createSliderWithTooltip(Component2) {
  var _a;
  return _a = /* @__PURE__ */ (function(_React$Component) {
    _inherits$1(ComponentWrapper, _React$Component);
    var _super = _createSuper$1(ComponentWrapper);
    function ComponentWrapper() {
      var _this;
      _classCallCheck$2(this, ComponentWrapper);
      _this = _super.apply(this, arguments);
      _this.state = {
        visibles: {}
      };
      _this.handleTooltipVisibleChange = function(index2, visible) {
        _this.setState(function(prevState) {
          return {
            visibles: _objectSpread2$1(_objectSpread2$1({}, prevState.visibles), {}, _defineProperty$3({}, index2, visible))
          };
        });
      };
      _this.handleWithTooltip = function(_ref3) {
        var value2 = _ref3.value, dragging = _ref3.dragging, index2 = _ref3.index, disabled2 = _ref3.disabled, restProps = _objectWithoutProperties(_ref3, ["value", "dragging", "index", "disabled"]);
        var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
        var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? "rc-slider-tooltip" : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay2 = _tipProps$overlay === void 0 ? tipFormatter(value2) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? "top" : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = _objectWithoutProperties(tipProps, ["prefixCls", "overlay", "placement", "visible"]);
        var handleStyleWithIndex;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index2] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }
        return /* @__PURE__ */ React__default.createElement(SliderTooltip, _extends$1({}, restTooltipProps, {
          getTooltipContainer,
          prefixCls,
          overlay: overlay2,
          placement,
          visible: !disabled2 && (_this.state.visibles[index2] || dragging) || visible,
          key: index2
        }), /* @__PURE__ */ React__default.createElement(Handle, _extends$1({}, restProps, {
          style: _objectSpread2$1({}, handleStyleWithIndex),
          value: value2,
          onMouseEnter: function onMouseEnter() {
            return _this.handleTooltipVisibleChange(index2, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleTooltipVisibleChange(index2, false);
          }
        })));
      };
      return _this;
    }
    _createClass$2(ComponentWrapper, [{
      key: "render",
      value: function render() {
        return /* @__PURE__ */ React__default.createElement(Component2, _extends$1({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);
    return ComponentWrapper;
  })(React__default.Component), _a.defaultProps = {
    tipFormatter: function tipFormatter(value2) {
      return value2;
    },
    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node2) {
      return node2.parentNode;
    }
  }, _a;
}
var InternalSlider = Slider$2;
InternalSlider.Range = Range$1;
InternalSlider.Handle = Handle;
InternalSlider.createSliderWithTooltip = createSliderWithTooltip;
const DragMeIcon = ({ className, style: style2 }) => /* @__PURE__ */ jsx$1(
  "svg",
  {
    className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    style: style2,
    children: /* @__PURE__ */ jsx$1(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M6 0C4.895 0 4 .895 4 2v20c0 1.105.895 2 2 2s2-.895 2-2V2c0-1.105-.895-2-2-2zm12 0c-1.105 0-2 .895-2 2v20c0 1.105.895 2 2 2s2-.895 2-2V2c0-1.105-.895-2-2-2z",
        clipRule: "evenodd"
      }
    )
  }
);
var lodash$1 = { exports: {} };
var lodash = lodash$1.exports;
var hasRequiredLodash;
function requireLodash() {
  if (hasRequiredLodash) return lodash$1.exports;
  hasRequiredLodash = 1;
  (function(module, exports$1) {
    (function() {
      var undefined$1;
      var VERSION = "4.18.1";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`", INVALID_TEMPL_IMPORTS_ERROR_TEXT = "Invalid `imports` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root2 = freeGlobal || freeSelf || Function("return this")();
      var freeExports = exports$1 && !exports$1.nodeType && exports$1;
      var freeModule = freeExports && true && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = (function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e3) {
        }
      })();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          var value2 = array[index2];
          setter(accumulator, value2, iteratee(value2), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (iteratee(array[index2], index2, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length2 = array == null ? 0 : array.length;
        while (length2--) {
          if (iteratee(array[length2], length2, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (!predicate(array[index2], index2, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value2 = array[index2];
          if (predicate(value2, index2, array)) {
            result[resIndex++] = value2;
          }
        }
        return result;
      }
      function arrayIncludes(array, value2) {
        var length2 = array == null ? 0 : array.length;
        return !!length2 && baseIndexOf(array, value2, 0) > -1;
      }
      function arrayIncludesWith(array, value2, comparator) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (comparator(value2, array[index2])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
        while (++index2 < length2) {
          result[index2] = iteratee(array[index2], index2, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index2 = -1, length2 = values.length, offset3 = array.length;
        while (++index2 < length2) {
          array[offset3 + index2] = values[index2];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        if (initAccum && length2) {
          accumulator = array[++index2];
        }
        while (++index2 < length2) {
          accumulator = iteratee(accumulator, array[index2], index2, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length2 = array == null ? 0 : array.length;
        if (initAccum && length2) {
          accumulator = array[--length2];
        }
        while (length2--) {
          accumulator = iteratee(accumulator, array[length2], length2, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (predicate(array[index2], index2, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value2, key, collection2) {
          if (predicate(value2, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length2) {
          if (predicate(array[index2], index2, array)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value2, fromIndex) {
        return value2 === value2 ? strictIndexOf(array, value2, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value2, fromIndex, comparator) {
        var index2 = fromIndex - 1, length2 = array.length;
        while (++index2 < length2) {
          if (comparator(array[index2], value2)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIsNaN(value2) {
        return value2 !== value2;
      }
      function baseMean(array, iteratee) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseSum(array, iteratee) / length2 : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined$1 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined$1 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value2, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value2) : iteratee(accumulator, value2, index2, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length2 = array.length;
        array.sort(comparer);
        while (length2--) {
          array[length2] = array[length2].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index2 = -1, length2 = array.length;
        while (++index2 < length2) {
          var current = iteratee(array[index2]);
          if (current !== undefined$1) {
            result = result === undefined$1 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n2, iteratee) {
        var index2 = -1, result = Array(n2);
        while (++index2 < n2) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value2) {
          return func(value2);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index2 = -1, length2 = strSymbols.length;
        while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index2 = strSymbols.length;
        while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function countHolders(array, placeholder2) {
        var length2 = array.length, result = 0;
        while (length2--) {
          if (array[length2] === placeholder2) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined$1 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value2, key) {
          result[++index2] = [key, value2];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder2) {
        var index2 = -1, length2 = array.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value2 = array[index2];
          if (value2 === placeholder2 || value2 === PLACEHOLDER) {
            array[index2] = PLACEHOLDER;
            result[resIndex++] = index2;
          }
        }
        return result;
      }
      function setToArray(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value2) {
          result[++index2] = value2;
        });
        return result;
      }
      function setToPairs(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value2) {
          result[++index2] = [value2, value2];
        });
        return result;
      }
      function strictIndexOf(array, value2, fromIndex) {
        var index2 = fromIndex - 1, length2 = array.length;
        while (++index2 < length2) {
          if (array[index2] === value2) {
            return index2;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value2, fromIndex) {
        var index2 = fromIndex + 1;
        while (index2--) {
          if (array[index2] === value2) {
            return index2;
          }
        }
        return index2;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index2 = string.length;
        while (index2-- && reWhitespace.test(string.charAt(index2))) {
        }
        return index2;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = (function runInContext2(context) {
        context = context == null ? root2 : _2.defaults(root2.Object(), context, _2.pick(root2, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = (function() {
          var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid2 ? "Symbol(src)_1." + uid2 : "";
        })();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root2._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
        var defineProperty = (function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e3) {
          }
        })();
        var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
        function lodash2(value2) {
          if (isObjectLike(value2) && !isArray2(value2) && !(value2 instanceof LazyWrapper)) {
            if (value2 instanceof LodashWrapper) {
              return value2;
            }
            if (hasOwnProperty.call(value2, "__wrapped__")) {
              return wrapperClone(value2);
            }
          }
          return new LodashWrapper(value2);
        }
        var baseCreate = /* @__PURE__ */ (function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined$1;
            return result2;
          };
        })();
        function baseLodash() {
        }
        function LodashWrapper(value2, chainAll) {
          this.__wrapped__ = value2;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined$1;
        }
        lodash2.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash2
          }
        };
        lodash2.prototype = baseLodash.prototype;
        lodash2.prototype.constructor = lodash2;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value2) {
          this.__wrapped__ = value2;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end2 = view.end, length2 = end2 - start2, index2 = isRight ? end2 : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length2, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length2-- && resIndex < takeCount) {
              index2 += dir;
              var iterIndex = -1, value2 = array[index2];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type2 = data.type, computed = iteratee2(value2);
                if (type2 == LAZY_MAP_FLAG) {
                  value2 = computed;
                } else if (!computed) {
                  if (type2 == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value2;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined$1 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value2) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value2 === undefined$1 ? HASH_UNDEFINED : value2;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index2 == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index2, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          return index2 < 0 ? undefined$1 : data[index2][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value2) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            ++this.size;
            data.push([key, value2]);
          } else {
            data[index2][1] = value2;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value2) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value2);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index2 = -1, length2 = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index2 < length2) {
            this.add(values2[index2]);
          }
        }
        function setCacheAdd(value2) {
          this.__data__.set(value2, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value2) {
          return this.__data__.has(value2);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value2) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value2]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value2);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value2, inherited) {
          var isArr = isArray2(value2), isArg = !isArr && isArguments2(value2), isBuff = !isArr && !isArg && isBuffer(value2), isType = !isArr && !isArg && !isBuff && isTypedArray(value2), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value2.length, String2) : [], length2 = result2.length;
          for (var key in value2) {
            if ((inherited || hasOwnProperty.call(value2, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length2)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length2 = array.length;
          return length2 ? array[baseRandom(0, length2 - 1)] : undefined$1;
        }
        function arraySampleSize(array, n2) {
          return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value2) {
          if (value2 !== undefined$1 && !eq(object[key], value2) || value2 === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value2);
          }
        }
        function assignValue(object, key, value2) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value2)) || value2 === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value2);
          }
        }
        function assocIndexOf(array, key) {
          var length2 = array.length;
          while (length2--) {
            if (eq(array[length2][0], key)) {
              return length2;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value2, key, collection2) {
            setter(accumulator, value2, iteratee2(value2), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value2) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value2,
              "writable": true
            });
          } else {
            object[key] = value2;
          }
        }
        function baseAt(object, paths) {
          var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object == null;
          while (++index2 < length2) {
            result2[index2] = skip ? undefined$1 : get2(object, paths[index2]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined$1) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined$1) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value2, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value2, key, object, stack) : customizer(value2);
          }
          if (result2 !== undefined$1) {
            return result2;
          }
          if (!isObject2(value2)) {
            return value2;
          }
          var isArr = isArray2(value2);
          if (isArr) {
            result2 = initCloneArray(value2);
            if (!isDeep) {
              return copyArray(value2, result2);
            }
          } else {
            var tag = getTag(value2), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value2)) {
              return cloneBuffer(value2, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value2);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value2, baseAssignIn(result2, value2)) : copySymbols(value2, baseAssign(result2, value2));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value2 : {};
              }
              result2 = initCloneByTag(value2, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value2);
          if (stacked) {
            return stacked;
          }
          stack.set(value2, result2);
          if (isSet(value2)) {
            value2.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value2, stack));
            });
          } else if (isMap(value2)) {
            value2.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined$1 : keysFunc(value2);
          arrayEach(props || value2, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value2[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length2 = props.length;
          if (object == null) {
            return !length2;
          }
          object = Object2(object);
          while (length2--) {
            var key = props[length2], predicate = source[key], value2 = object[key];
            if (value2 === undefined$1 && !(key in object) || !predicate(value2)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined$1, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array.length, result2 = [], valuesLength = values2.length;
          if (!length2) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index2 < length2) {
              var value2 = array[index2], computed = iteratee2 == null ? value2 : iteratee2(value2);
              value2 = comparator || value2 !== 0 ? value2 : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value2);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value2);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value2, index2, collection2) {
            result2 = !!predicate(value2, index2, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index2 = -1, length2 = array.length;
          while (++index2 < length2) {
            var value2 = array[index2], current = iteratee2(value2);
            if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value2;
            }
          }
          return result2;
        }
        function baseFill(array, value2, start2, end2) {
          var length2 = array.length;
          start2 = toInteger2(start2);
          if (start2 < 0) {
            start2 = -start2 > length2 ? 0 : length2 + start2;
          }
          end2 = end2 === undefined$1 || end2 > length2 ? length2 : toInteger2(end2);
          if (end2 < 0) {
            end2 += length2;
          }
          end2 = start2 > end2 ? 0 : toLength(end2);
          while (start2 < end2) {
            array[start2++] = value2;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value2, index2, collection2) {
            if (predicate(value2, index2, collection2)) {
              result2.push(value2);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index2 = -1, length2 = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index2 < length2) {
            var value2 = array[index2];
            if (depth > 0 && predicate(value2)) {
              if (depth > 1) {
                baseFlatten(value2, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value2);
              }
            } else if (!isStrict) {
              result2[result2.length] = value2;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index2 = 0, length2 = path.length;
          while (object != null && index2 < length2) {
            object = object[toKey2(path[index2++])];
          }
          return index2 && index2 == length2 ? object : undefined$1;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value2) {
          if (value2 == null) {
            return value2 === undefined$1 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value2) ? getRawTag(value2) : objectToString(value2);
        }
        function baseGt(value2, other) {
          return value2 > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start2, end2) {
          return number >= nativeMin(start2, end2) && number < nativeMax(start2, end2);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
          }
          array = arrays[0];
          var index2 = -1, seen = caches[0];
          outer:
            while (++index2 < length2 && result2.length < maxLength) {
              var value2 = array[index2], computed = iteratee2 ? iteratee2(value2) : value2;
              value2 = comparator || value2 !== 0 ? value2 : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value2);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value2, key, object2) {
            setter(accumulator, iteratee2(value2), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey2(last(path))];
          return func == null ? undefined$1 : apply(func, object, args);
        }
        function baseIsArguments(value2) {
          return isObjectLike(value2) && baseGetTag(value2) == argsTag;
        }
        function baseIsArrayBuffer(value2) {
          return isObjectLike(value2) && baseGetTag(value2) == arrayBufferTag;
        }
        function baseIsDate(value2) {
          return isObjectLike(value2) && baseGetTag(value2) == dateTag;
        }
        function baseIsEqual(value2, other, bitmask, customizer, stack) {
          if (value2 === other) {
            return true;
          }
          if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
            return value2 !== value2 && other !== other;
          }
          return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value2) {
          return isObjectLike(value2) && getTag(value2) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
          if (object == null) {
            return !length2;
          }
          object = Object2(object);
          while (index2--) {
            var data = matchData[index2];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index2 < length2) {
            data = matchData[index2];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined$1 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value2) {
          if (!isObject2(value2) || isMasked(value2)) {
            return false;
          }
          var pattern = isFunction(value2) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value2));
        }
        function baseIsRegExp(value2) {
          return isObjectLike(value2) && baseGetTag(value2) == regexpTag;
        }
        function baseIsSet(value2) {
          return isObjectLike(value2) && getTag(value2) == setTag;
        }
        function baseIsTypedArray(value2) {
          return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
        }
        function baseIteratee(value2) {
          if (typeof value2 == "function") {
            return value2;
          }
          if (value2 == null) {
            return identity;
          }
          if (typeof value2 == "object") {
            return isArray2(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
          }
          return property(value2);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value2, other) {
          return value2 < other;
        }
        function baseMap(collection, iteratee2) {
          var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value2, key, collection2) {
            result2[++index2] = iteratee2(value2, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey2(path), srcValue);
          }
          return function(object) {
            var objValue = get2(object, path);
            return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
              if (newValue === undefined$1) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
          var isCommon = newValue === undefined$1;
          if (isCommon) {
            var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray2(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments2(srcValue)) {
              newValue = objValue;
              if (isArguments2(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n2) {
          var length2 = array.length;
          if (!length2) {
            return;
          }
          n2 += n2 < 0 ? length2 : 0;
          return isIndex(n2, length2) ? array[n2] : undefined$1;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray2(iteratee2)) {
                return function(value2) {
                  return baseGet(value2, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index2 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value2, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value2);
            });
            return { "criteria": criteria, "index": ++index2, "value": value2 };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value2, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index2 = -1, length2 = paths.length, result2 = {};
          while (++index2 < length2) {
            var path = paths[index2], value2 = baseGet(object, path);
            if (predicate(value2, path)) {
              baseSet(result2, castPath(path, object), value2);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index2 < length2) {
            var fromIndex = 0, value2 = values2[index2], computed = iteratee2 ? iteratee2(value2) : value2;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length2 = array ? indexes.length : 0, lastIndex = length2 - 1;
          while (length2--) {
            var index2 = indexes[length2];
            if (length2 == lastIndex || index2 !== previous) {
              var previous = index2;
              if (isIndex(index2)) {
                splice.call(array, index2, 1);
              } else {
                baseUnset(array, index2);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start2, end2, step, fromRight) {
          var index2 = -1, length2 = nativeMax(nativeCeil((end2 - start2) / (step || 1)), 0), result2 = Array2(length2);
          while (length2--) {
            result2[fromRight ? length2 : ++index2] = start2;
            start2 += step;
          }
          return result2;
        }
        function baseRepeat(string, n2) {
          var result2 = "";
          if (!string || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n2 % 2) {
              result2 += string;
            }
            n2 = nativeFloor(n2 / 2);
            if (n2) {
              string += string;
            }
          } while (n2);
          return result2;
        }
        function baseRest(func, start2) {
          return setToString(overRest(func, start2, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n2) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n2, 0, array.length));
        }
        function baseSet(object, path, value2, customizer) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index2 = -1, length2 = path.length, lastIndex = length2 - 1, nested = object;
          while (nested != null && ++index2 < length2) {
            var key = toKey2(path[index2]), newValue = value2;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index2 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
              if (newValue === undefined$1) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start2, end2) {
          var index2 = -1, length2 = array.length;
          if (start2 < 0) {
            start2 = -start2 > length2 ? 0 : length2 + start2;
          }
          end2 = end2 > length2 ? length2 : end2;
          if (end2 < 0) {
            end2 += length2;
          }
          length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
          start2 >>>= 0;
          var result2 = Array2(length2);
          while (++index2 < length2) {
            result2[index2] = array[index2 + start2];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value2, index2, collection2) {
            result2 = predicate(value2, index2, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value2, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value2 == "number" && value2 === value2 && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value2 : computed < value2)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value2, identity, retHighest);
        }
        function baseSortedIndexBy(array, value2, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value2 = iteratee2(value2);
          var valIsNaN = value2 !== value2, valIsNull = value2 === null, valIsSymbol = isSymbol(value2), valIsUndefined = value2 === undefined$1;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value2 : computed < value2;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index2 = -1, length2 = array.length, resIndex = 0, result2 = [];
          while (++index2 < length2) {
            var value2 = array[index2], computed = iteratee2 ? iteratee2(value2) : value2;
            if (!index2 || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value2 === 0 ? 0 : value2;
            }
          }
          return result2;
        }
        function baseToNumber(value2) {
          if (typeof value2 == "number") {
            return value2;
          }
          if (isSymbol(value2)) {
            return NAN;
          }
          return +value2;
        }
        function baseToString(value2) {
          if (typeof value2 == "string") {
            return value2;
          }
          if (isArray2(value2)) {
            return arrayMap(value2, baseToString) + "";
          }
          if (isSymbol(value2)) {
            return symbolToString ? symbolToString.call(value2) : "";
          }
          var result2 = value2 + "";
          return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, length2 = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length2 >= LARGE_ARRAY_SIZE) {
            var set3 = iteratee2 ? null : createSet(array);
            if (set3) {
              return setToArray(set3);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index2 < length2) {
              var value2 = array[index2], computed = iteratee2 ? iteratee2(value2) : value2;
              value2 = comparator || value2 !== 0 ? value2 : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value2);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value2);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          var index2 = -1, length2 = path.length;
          if (!length2) {
            return true;
          }
          while (++index2 < length2) {
            var key = toKey2(path[index2]);
            if (key === "__proto__" && !hasOwnProperty.call(object, "__proto__")) {
              return false;
            }
            if ((key === "constructor" || key === "prototype") && index2 < length2 - 1) {
              return false;
            }
          }
          var obj = parent(object, path);
          return obj == null || delete obj[toKey2(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length2 = array.length, index2 = fromRight ? length2 : -1;
          while ((fromRight ? index2-- : ++index2 < length2) && predicate(array[index2], index2, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
        }
        function baseWrapperValue(value2, actions2) {
          var result2 = value2;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions2, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length2 = arrays.length;
          if (length2 < 2) {
            return length2 ? baseUniq(arrays[0]) : [];
          }
          var index2 = -1, result2 = Array2(length2);
          while (++index2 < length2) {
            var array = arrays[index2], othIndex = -1;
            while (++othIndex < length2) {
              if (othIndex != index2) {
                result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index2 = -1, length2 = props.length, valsLength = values2.length, result2 = {};
          while (++index2 < length2) {
            var value2 = index2 < valsLength ? values2[index2] : undefined$1;
            assignFunc(result2, props[index2], value2);
          }
          return result2;
        }
        function castArrayLikeObject(value2) {
          return isArrayLikeObject(value2) ? value2 : [];
        }
        function castFunction(value2) {
          return typeof value2 == "function" ? value2 : identity;
        }
        function castPath(value2, object) {
          if (isArray2(value2)) {
            return value2;
          }
          return isKey(value2, object) ? [value2] : stringToPath(toString(value2));
        }
        var castRest = baseRest;
        function castSlice(array, start2, end2) {
          var length2 = array.length;
          end2 = end2 === undefined$1 ? length2 : end2;
          return !start2 && end2 >= length2 ? array : baseSlice(array, start2, end2);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root2.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value2, other) {
          if (value2 !== other) {
            var valIsDefined = value2 !== undefined$1, valIsNull = value2 === null, valIsReflexive = value2 === value2, valIsSymbol = isSymbol(value2);
            var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value2 > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value2 < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
          while (++index2 < length2) {
            var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
            if (result2) {
              if (index2 >= ordersLength) {
                return result2;
              }
              var order2 = orders[index2];
              return result2 * (order2 == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset3 = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset3 + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset3 + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index2 = -1, length2 = source.length;
          array || (array = Array2(length2));
          while (++index2 < length2) {
            array[index2] = source[index2];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index2 = -1, length2 = props.length;
          while (++index2 < length2) {
            var key = props[index2];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
            if (newValue === undefined$1) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length2 < 3 ? undefined$1 : customizer;
              length2 = 1;
            }
            object = Object2(object);
            while (++index2 < length2) {
              var source = sources[index2];
              if (source) {
                assigner(object, source, index2, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
            while (fromRight ? index2-- : ++index2 < length2) {
              if (iteratee2(iterable[index2], index2, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index2 = -1, iterable = Object2(object), props = keysFunc(object), length2 = props.length;
            while (length2--) {
              var key = props[fromRight ? length2 : ++index2];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper2() {
            var fn2 = this && this !== root2 && this instanceof wrapper2 ? Ctor : func;
            return fn2.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper2;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper2() {
            var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder2 = getHolder(wrapper2);
            while (index2--) {
              args[index2] = arguments[index2];
            }
            var holders = length2 < 3 && args[0] !== placeholder2 && args[length2 - 1] !== placeholder2 ? [] : replaceHolders(args, placeholder2);
            length2 -= holders.length;
            if (length2 < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper2.placeholder,
                undefined$1,
                args,
                holders,
                undefined$1,
                undefined$1,
                arity - length2
              );
            }
            var fn2 = this && this !== root2 && this instanceof wrapper2 ? Ctor : func;
            return apply(fn2, this, args);
          }
          return wrapper2;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index2 = findIndexFunc(collection, predicate, fromIndex);
            return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index2--) {
              var func = funcs[index2];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper2 && getFuncName(func) == "wrapper") {
                var wrapper2 = new LodashWrapper([], true);
              }
            }
            index2 = wrapper2 ? index2 : length2;
            while (++index2 < length2) {
              func = funcs[index2];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper2 = wrapper2[getFuncName(data[0])].apply(wrapper2, data[3]);
              } else {
                wrapper2 = func.length == 1 && isLaziable(func) ? wrapper2[funcName]() : wrapper2.thru(func);
              }
            }
            return function() {
              var args = arguments, value2 = args[0];
              if (wrapper2 && args.length == 1 && isArray2(value2)) {
                return wrapper2.plant(value2).value();
              }
              var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value2;
              while (++index3 < length2) {
                result2 = funcs[index3].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
          function wrapper2() {
            var length2 = arguments.length, args = Array2(length2), index2 = length2;
            while (index2--) {
              args[index2] = arguments[index2];
            }
            if (isCurried) {
              var placeholder2 = getHolder(wrapper2), holdersCount = countHolders(args, placeholder2);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length2 -= holdersCount;
            if (isCurried && length2 < arity) {
              var newHolders = replaceHolders(args, placeholder2);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper2.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length2
              );
            }
            var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
            length2 = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length2 > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length2) {
              args.length = ary2;
            }
            if (this && this !== root2 && this instanceof wrapper2) {
              fn2 = Ctor || createCtor(fn2);
            }
            return fn2.apply(thisBinding, args);
          }
          return wrapper2;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value2, other) {
            var result2;
            if (value2 === undefined$1 && other === undefined$1) {
              return defaultValue;
            }
            if (value2 !== undefined$1) {
              result2 = value2;
            }
            if (other !== undefined$1) {
              if (result2 === undefined$1) {
                return other;
              }
              if (typeof value2 == "string" || typeof other == "string") {
                value2 = baseToString(value2);
                other = baseToString(other);
              } else {
                value2 = baseToNumber(value2);
                other = baseToNumber(other);
              }
              result2 = operator(value2, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length2, chars) {
          chars = chars === undefined$1 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length2) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper2() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root2 && this instanceof wrapper2 ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn2, isBind ? thisArg : this, args);
          }
          return wrapper2;
        }
        function createRange(fromRight) {
          return function(start2, end2, step) {
            if (step && typeof step != "number" && isIterateeCall(start2, end2, step)) {
              end2 = step = undefined$1;
            }
            start2 = toFinite(start2);
            if (end2 === undefined$1) {
              end2 = start2;
              start2 = 0;
            } else {
              end2 = toFinite(end2);
            }
            step = step === undefined$1 ? start2 < end2 ? 1 : -1 : toFinite(step);
            return baseRange(start2, end2, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value2, other) {
            if (!(typeof value2 == "string" && typeof other == "string")) {
              value2 = toNumber(value2);
              other = toNumber(other);
            }
            return operator(value2, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder2, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= -4;
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined$1, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder2;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger2(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value2 = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value2) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop3 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length2 = partials ? partials.length : 0;
          if (!length2) {
            bitmask &= -97;
            partials = holders = undefined$1;
          }
          ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger2(ary2), 0);
          arity = arity === undefined$1 ? arity : toInteger2(arity);
          length2 -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined$1;
          }
          var data = isBindKey ? undefined$1 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length2, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= -25;
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined$1, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value2) {
          return isPlainObject(value2) ? undefined$1 : value2;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
          stack.set(array, other);
          stack.set(other, array);
          while (++index2 < arrLength) {
            var arrValue = array[index2], othValue = other[index2];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
            }
            if (compared !== undefined$1) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index2 = objLength;
          while (index2--) {
            var key = objProps[index2];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index2 < objLength) {
            key = objProps[index2];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined$1, flatten2), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop3 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length2 = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length2--) {
            var data = array[length2], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash2.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length2 = result2.length;
          while (length2--) {
            var key = result2[length2], value2 = object[key];
            result2[length2] = [key, value2, isStrictComparable(value2)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value2 = getValue(object, key);
          return baseIsNative(value2) ? value2 : undefined$1;
        }
        function getRawTag(value2) {
          var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
          try {
            value2[symToStringTag] = undefined$1;
            var unmasked = true;
          } catch (e3) {
          }
          var result2 = nativeObjectToString.call(value2);
          if (unmasked) {
            if (isOwn) {
              value2[symToStringTag] = tag;
            } else {
              delete value2[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value2) {
            var result2 = baseGetTag(value2), Ctor = result2 == objectTag ? value2.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start2, end2, transforms) {
          var index2 = -1, length2 = transforms.length;
          while (++index2 < length2) {
            var data = transforms[index2], size2 = data.size;
            switch (data.type) {
              case "drop":
                start2 += size2;
                break;
              case "dropRight":
                end2 -= size2;
                break;
              case "take":
                end2 = nativeMin(end2, start2 + size2);
                break;
              case "takeRight":
                start2 = nativeMax(start2, end2 - size2);
                break;
            }
          }
          return { "start": start2, "end": end2 };
        }
        function getWrapDetails(source) {
          var match2 = source.match(reWrapDetails);
          return match2 ? match2[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index2 = -1, length2 = path.length, result2 = false;
          while (++index2 < length2) {
            var key = toKey2(path[index2]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index2 != length2) {
            return result2;
          }
          length2 = object == null ? 0 : object.length;
          return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray2(object) || isArguments2(object));
        }
        function initCloneArray(array) {
          var length2 = array.length, result2 = new array.constructor(length2);
          if (length2 && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length2 = details.length;
          if (!length2) {
            return source;
          }
          var lastIndex = length2 - 1;
          details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length2 > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value2) {
          return isArray2(value2) || isArguments2(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
        }
        function isIndex(value2, length2) {
          var type2 = typeof value2;
          length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
          return !!length2 && (type2 == "number" || type2 != "symbol" && reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
        }
        function isIterateeCall(value2, index2, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type2 = typeof index2;
          if (type2 == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type2 == "string" && index2 in object) {
            return eq(object[index2], value2);
          }
          return false;
        }
        function isKey(value2, object) {
          if (isArray2(value2)) {
            return false;
          }
          var type2 = typeof value2;
          if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value2 == null || isSymbol(value2)) {
            return true;
          }
          return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object2(object);
        }
        function isKeyable(value2) {
          var type2 = typeof value2;
          return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value2 !== "__proto__" : value2 === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash2[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value2) {
          var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value2 === proto;
        }
        function isStrictComparable(value2) {
          return value2 === value2 && !isObject2(value2);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize2(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value2 = source[3];
          if (value2) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value2, source[4]) : value2;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value2 = source[5];
          if (value2) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value2, source[6]) : value2;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value2 = source[7];
          if (value2) {
            data[7] = value2;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value2) {
          return nativeObjectToString.call(value2);
        }
        function overRest(func, start2, transform2) {
          start2 = nativeMax(start2 === undefined$1 ? func.length - 1 : start2, 0);
          return function() {
            var args = arguments, index2 = -1, length2 = nativeMax(args.length - start2, 0), array = Array2(length2);
            while (++index2 < length2) {
              array[index2] = args[start2 + index2];
            }
            index2 = -1;
            var otherArgs = Array2(start2 + 1);
            while (++index2 < start2) {
              otherArgs[index2] = args[index2];
            }
            otherArgs[start2] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length2--) {
            var index2 = indexes[length2];
            array[length2] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root2.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper2, reference2, bitmask) {
          var source = reference2 + "";
          return setToString(wrapper2, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count2 = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count2 >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count2 = 0;
            }
            return func.apply(undefined$1, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index2 = -1, length2 = array.length, lastIndex = length2 - 1;
          size2 = size2 === undefined$1 ? length2 : size2;
          while (++index2 < size2) {
            var rand = baseRandom(index2, lastIndex), value2 = array[rand];
            array[rand] = array[index2];
            array[index2] = value2;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match2, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
          });
          return result2;
        });
        function toKey2(value2) {
          if (typeof value2 == "string" || isSymbol(value2)) {
            return value2;
          }
          var result2 = value2 + "";
          return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e3) {
            }
            try {
              return func + "";
            } catch (e3) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value2 = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value2)) {
              details.push(value2);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper2) {
          if (wrapper2 instanceof LazyWrapper) {
            return wrapper2.clone();
          }
          var result2 = new LodashWrapper(wrapper2.__wrapped__, wrapper2.__chain__);
          result2.__actions__ = copyArray(wrapper2.__actions__);
          result2.__index__ = wrapper2.__index__;
          result2.__values__ = wrapper2.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger2(size2), 0);
          }
          var length2 = array == null ? 0 : array.length;
          if (!length2 || size2 < 1) {
            return [];
          }
          var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size2));
          while (index2 < length2) {
            result2[resIndex++] = baseSlice(array, index2, index2 += size2);
          }
          return result2;
        }
        function compact2(array) {
          var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index2 < length2) {
            var value2 = array[index2];
            if (value2) {
              result2[resIndex++] = value2;
            }
          }
          return result2;
        }
        function concat() {
          var length2 = arguments.length;
          if (!length2) {
            return [];
          }
          var args = Array2(length2 - 1), array = arguments[0], index2 = length2;
          while (index2--) {
            args[index2 - 1] = arguments[index2];
          }
          return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
        });
        function drop(array, n2, guard) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
          return baseSlice(array, n2 < 0 ? 0 : n2, length2);
        }
        function dropRight(array, n2, guard) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
          n2 = length2 - n2;
          return baseSlice(array, 0, n2 < 0 ? 0 : n2);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value2, start2, end2) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          if (start2 && typeof start2 != "number" && isIterateeCall(array, value2, start2)) {
            start2 = 0;
            end2 = length2;
          }
          return baseFill(array, value2, start2, end2);
        }
        function findIndex2(array, predicate, fromIndex) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length2 + index2, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return -1;
          }
          var index2 = length2 - 1;
          if (fromIndex !== undefined$1) {
            index2 = toInteger2(fromIndex);
            index2 = fromIndex < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
        }
        function flatten2(array) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          depth = depth === undefined$1 ? 1 : toInteger2(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index2 < length2) {
            var pair = pairs[index2];
            baseAssignValue(result2, pair[0], pair[1]);
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined$1;
        }
        function indexOf(array, value2, fromIndex) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length2 + index2, 0);
          }
          return baseIndexOf(array, value2, index2);
        }
        function initial(array) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined$1;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
        });
        function join(array, separator2) {
          return array == null ? "" : nativeJoin.call(array, separator2);
        }
        function last(array) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? array[length2 - 1] : undefined$1;
        }
        function lastIndexOf(array, value2, fromIndex) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return -1;
          }
          var index2 = length2;
          if (fromIndex !== undefined$1) {
            index2 = toInteger2(fromIndex);
            index2 = index2 < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
          }
          return value2 === value2 ? strictLastIndexOf(array, value2, index2) : baseFindIndex(array, baseIsNaN, index2, true);
        }
        function nth(array, n2) {
          return array && array.length ? baseNth(array, toInteger2(n2)) : undefined$1;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length2 = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index2) {
            return isIndex(index2, length2) ? +index2 : index2;
          }).sort(compareAscending));
          return result2;
        });
        function remove2(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index2 = -1, indexes = [], length2 = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index2 < length2) {
            var value2 = array[index2];
            if (predicate(value2, index2, array)) {
              result2.push(value2);
              indexes.push(index2);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice2(array, start2, end2) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          if (end2 && typeof end2 != "number" && isIterateeCall(array, start2, end2)) {
            start2 = 0;
            end2 = length2;
          } else {
            start2 = start2 == null ? 0 : toInteger2(start2);
            end2 = end2 === undefined$1 ? length2 : toInteger2(end2);
          }
          return baseSlice(array, start2, end2);
        }
        function sortedIndex(array, value2) {
          return baseSortedIndex(array, value2);
        }
        function sortedIndexBy(array, value2, iteratee2) {
          return baseSortedIndexBy(array, value2, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value2) {
          var length2 = array == null ? 0 : array.length;
          if (length2) {
            var index2 = baseSortedIndex(array, value2);
            if (index2 < length2 && eq(array[index2], value2)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value2) {
          return baseSortedIndex(array, value2, true);
        }
        function sortedLastIndexBy(array, value2, iteratee2) {
          return baseSortedIndexBy(array, value2, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value2) {
          var length2 = array == null ? 0 : array.length;
          if (length2) {
            var index2 = baseSortedIndex(array, value2, true) - 1;
            if (eq(array[index2], value2)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? baseSlice(array, 1, length2) : [];
        }
        function take(array, n2, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
          return baseSlice(array, 0, n2 < 0 ? 0 : n2);
        }
        function takeRight(array, n2, guard) {
          var length2 = array == null ? 0 : array.length;
          if (!length2) {
            return [];
          }
          n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
          n2 = length2 - n2;
          return baseSlice(array, n2 < 0 ? 0 : n2, length2);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length2 = 0;
          array = arrayFilter(array, function(group2) {
            if (isArrayLikeObject(group2)) {
              length2 = nativeMax(group2.length, length2);
              return true;
            }
          });
          return baseTimes(length2, function(index2) {
            return arrayMap(array, baseProperty(index2));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group2) {
            return apply(iteratee2, undefined$1, group2);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value2) {
          var result2 = lodash2(value2);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value2, interceptor) {
          interceptor(value2);
          return value2;
        }
        function thru(value2, interceptor) {
          return interceptor(value2);
        }
        var wrapperAt = flatRest(function(paths) {
          var length2 = paths.length, start2 = length2 ? paths[0] : 0, value2 = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length2 > 1 || this.__actions__.length || !(value2 instanceof LazyWrapper) || !isIndex(start2)) {
            return this.thru(interceptor);
          }
          value2 = value2.slice(start2, +start2 + (length2 ? 1 : 0));
          value2.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined$1
          });
          return new LodashWrapper(value2, this.__chain__).thru(function(array) {
            if (length2 && !array.length) {
              array.push(undefined$1);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined$1) {
            this.__values__ = toArray2(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value2 = done ? undefined$1 : this.__values__[this.__index__++];
          return { "done": done, "value": value2 };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value2) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone3 = wrapperClone(parent2);
            clone3.__index__ = 0;
            clone3.__values__ = undefined$1;
            if (result2) {
              previous.__wrapped__ = clone3;
            } else {
              result2 = clone3;
            }
            var previous = clone3;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value2;
          return result2;
        }
        function wrapperReverse() {
          var value2 = this.__wrapped__;
          if (value2 instanceof LazyWrapper) {
            var wrapped = value2;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined$1
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value2, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray2(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray2(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex2);
        var findLast2 = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined$1 ? 1 : toInteger2(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray2(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray2(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value2, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value2);
          } else {
            baseAssignValue(result2, key, [value2]);
          }
        });
        function includes(collection, value2, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
          var length2 = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length2 + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length2 && collection.indexOf(value2, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value2, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value2) {
            result2[++index2] = isFunc ? apply(path, value2, args) : baseInvoke(value2, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value2, key) {
          baseAssignValue(result2, key, value2);
        });
        function map(collection, iteratee2) {
          var func = isArray2(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray2(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined$1 : orders;
          if (!isArray2(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value2, key) {
          result2[key ? 0 : 1].push(value2);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray2(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray2(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n2, guard) {
          if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined$1) {
            n2 = 1;
          } else {
            n2 = toInteger2(n2);
          }
          var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n2);
        }
        function shuffle(collection) {
          var func = isArray2(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray2(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length2 = iteratees.length;
          if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root2.Date.now();
        };
        function after(n2, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n2 = toInteger2(n2);
          return function() {
            if (--n2 < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n2, guard) {
          n2 = guard ? undefined$1 : n2;
          n2 = func && n2 == null ? func.length : n2;
          return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
        }
        function before(n2, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n2 = toInteger2(n2);
          return function() {
            if (--n2 > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n2 <= 1) {
              func = undefined$1;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce2(func, wait, options2) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options2)) {
            leading = !!options2.leading;
            maxing = "maxWait" in options2;
            maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options2 ? !!options2.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined$1;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined$1;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined$1;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined$1) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined$1;
          }
          function flush() {
            return timerId === undefined$1 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined$1) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined$1) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip2(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize2(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized2 = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized2.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized2.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized2.cache = new (memoize2.Cache || MapCache)();
          return memoized2;
        }
        memoize2.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index2 = -1, length2 = nativeMin(args.length, funcsLength);
            while (++index2 < length2) {
              args[index2] = transforms[index2].call(this, args[index2]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
        });
        function rest(func, start2) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start2 = start2 === undefined$1 ? start2 : toInteger2(start2);
          return baseRest(func, start2);
        }
        function spread(func, start2) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start2 = start2 == null ? 0 : nativeMax(toInteger2(start2), 0);
          return baseRest(function(args) {
            var array = args[start2], otherArgs = castSlice(args, 0, start2);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options2) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options2)) {
            leading = "leading" in options2 ? !!options2.leading : leading;
            trailing = "trailing" in options2 ? !!options2.trailing : trailing;
          }
          return debounce2(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap2(value2, wrapper2) {
          return partial(castFunction(wrapper2), value2);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value2 = arguments[0];
          return isArray2(value2) ? value2 : [value2];
        }
        function clone2(value2) {
          return baseClone(value2, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value2, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value2, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value2) {
          return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value2, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value2, other) {
          return value2 === other || value2 !== value2 && other !== other;
        }
        var gt2 = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value2, other) {
          return value2 >= other;
        });
        var isArguments2 = baseIsArguments(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? baseIsArguments : function(value2) {
          return isObjectLike(value2) && hasOwnProperty.call(value2, "callee") && !propertyIsEnumerable.call(value2, "callee");
        };
        var isArray2 = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value2) {
          return value2 != null && isLength(value2.length) && !isFunction(value2);
        }
        function isArrayLikeObject(value2) {
          return isObjectLike(value2) && isArrayLike(value2);
        }
        function isBoolean(value2) {
          return value2 === true || value2 === false || isObjectLike(value2) && baseGetTag(value2) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement2(value2) {
          return isObjectLike(value2) && value2.nodeType === 1 && !isPlainObject(value2);
        }
        function isEmpty(value2) {
          if (value2 == null) {
            return true;
          }
          if (isArrayLike(value2) && (isArray2(value2) || typeof value2 == "string" || typeof value2.splice == "function" || isBuffer(value2) || isTypedArray(value2) || isArguments2(value2))) {
            return !value2.length;
          }
          var tag = getTag(value2);
          if (tag == mapTag || tag == setTag) {
            return !value2.size;
          }
          if (isPrototype(value2)) {
            return !baseKeys(value2).length;
          }
          for (var key in value2) {
            if (hasOwnProperty.call(value2, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual2(value2, other) {
          return baseIsEqual(value2, other);
        }
        function isEqualWith(value2, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          var result2 = customizer ? customizer(value2, other) : undefined$1;
          return result2 === undefined$1 ? baseIsEqual(value2, other, undefined$1, customizer) : !!result2;
        }
        function isError(value2) {
          if (!isObjectLike(value2)) {
            return false;
          }
          var tag = baseGetTag(value2);
          return tag == errorTag || tag == domExcTag || typeof value2.message == "string" && typeof value2.name == "string" && !isPlainObject(value2);
        }
        function isFinite2(value2) {
          return typeof value2 == "number" && nativeIsFinite(value2);
        }
        function isFunction(value2) {
          if (!isObject2(value2)) {
            return false;
          }
          var tag = baseGetTag(value2);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value2) {
          return typeof value2 == "number" && value2 == toInteger2(value2);
        }
        function isLength(value2) {
          return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
        }
        function isObject2(value2) {
          var type2 = typeof value2;
          return value2 != null && (type2 == "object" || type2 == "function");
        }
        function isObjectLike(value2) {
          return value2 != null && typeof value2 == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value2) {
          return isNumber(value2) && value2 != +value2;
        }
        function isNative(value2) {
          if (isMaskable(value2)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value2);
        }
        function isNull(value2) {
          return value2 === null;
        }
        function isNil(value2) {
          return value2 == null;
        }
        function isNumber(value2) {
          return typeof value2 == "number" || isObjectLike(value2) && baseGetTag(value2) == numberTag;
        }
        function isPlainObject(value2) {
          if (!isObjectLike(value2) || baseGetTag(value2) != objectTag) {
            return false;
          }
          var proto = getPrototype(value2);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value2) {
          return isInteger(value2) && value2 >= -MAX_SAFE_INTEGER && value2 <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value2) {
          return typeof value2 == "string" || !isArray2(value2) && isObjectLike(value2) && baseGetTag(value2) == stringTag;
        }
        function isSymbol(value2) {
          return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag(value2) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value2) {
          return value2 === undefined$1;
        }
        function isWeakMap(value2) {
          return isObjectLike(value2) && getTag(value2) == weakMapTag;
        }
        function isWeakSet(value2) {
          return isObjectLike(value2) && baseGetTag(value2) == weakSetTag;
        }
        var lt2 = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value2, other) {
          return value2 <= other;
        });
        function toArray2(value2) {
          if (!value2) {
            return [];
          }
          if (isArrayLike(value2)) {
            return isString(value2) ? stringToArray(value2) : copyArray(value2);
          }
          if (symIterator && value2[symIterator]) {
            return iteratorToArray(value2[symIterator]());
          }
          var tag = getTag(value2), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value2);
        }
        function toFinite(value2) {
          if (!value2) {
            return value2 === 0 ? value2 : 0;
          }
          value2 = toNumber(value2);
          if (value2 === INFINITY || value2 === -INFINITY) {
            var sign2 = value2 < 0 ? -1 : 1;
            return sign2 * MAX_INTEGER;
          }
          return value2 === value2 ? value2 : 0;
        }
        function toInteger2(value2) {
          var result2 = toFinite(value2), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value2) {
          return value2 ? baseClamp(toInteger2(value2), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value2) {
          if (typeof value2 == "number") {
            return value2;
          }
          if (isSymbol(value2)) {
            return NAN;
          }
          if (isObject2(value2)) {
            var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
            value2 = isObject2(other) ? other + "" : other;
          }
          if (typeof value2 != "string") {
            return value2 === 0 ? value2 : +value2;
          }
          value2 = baseTrim(value2);
          var isBinary = reIsBinary.test(value2);
          return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
        }
        function toPlainObject(value2) {
          return copyObject(value2, keysIn(value2));
        }
        function toSafeInteger(value2) {
          return value2 ? baseClamp(toInteger2(value2), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value2 === 0 ? value2 : 0;
        }
        function toString(value2) {
          return value2 == null ? "" : baseToString(value2);
        }
        var assign2 = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at2 = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index2 = -1;
          var length2 = sources.length;
          var guard = length2 > 2 ? sources[2] : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length2 = 1;
          }
          while (++index2 < length2) {
            var source = sources[index2];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value2 = object[key];
              if (value2 === undefined$1 || eq(value2, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined$1, customDefaultsMerge);
          return apply(mergeWith, undefined$1, args);
        });
        function findKey2(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get2(object, path, defaultValue) {
          var result2 = object == null ? undefined$1 : baseGet(object, path);
          return result2 === undefined$1 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value2, key) {
          if (value2 != null && typeof value2.toString != "function") {
            value2 = nativeObjectToString.call(value2);
          }
          result2[value2] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value2, key) {
          if (value2 != null && typeof value2.toString != "function") {
            value2 = nativeObjectToString.call(value2);
          }
          if (hasOwnProperty.call(result2, value2)) {
            result2[value2].push(key);
          } else {
            result2[value2] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value2, key, object2) {
            baseAssignValue(result2, iteratee2(value2, key, object2), value2);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value2, key, object2) {
            baseAssignValue(result2, key, iteratee2(value2, key, object2));
          });
          return result2;
        }
        var merge3 = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit2 = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length2 = paths.length;
          while (length2--) {
            baseUnset(result2, paths[length2]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value2, path) {
            return predicate(value2, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index2 = -1, length2 = path.length;
          if (!length2) {
            length2 = 1;
            object = undefined$1;
          }
          while (++index2 < length2) {
            var value2 = object == null ? undefined$1 : object[toKey2(path[index2])];
            if (value2 === undefined$1) {
              index2 = length2;
              value2 = defaultValue;
            }
            object = isFunction(value2) ? value2.call(object) : value2;
          }
          return object;
        }
        function set2(object, path, value2) {
          return object == null ? object : baseSet(object, path, value2);
        }
        function setWith(object, path, value2, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object == null ? object : baseSet(object, path, value2, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray2(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value2, index2, object2) {
            return iteratee2(accumulator, value2, index2, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp2(number, lower, upper) {
          if (upper === undefined$1) {
            upper = lower;
            lower = undefined$1;
          }
          if (upper !== undefined$1) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined$1) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start2, end2) {
          start2 = toFinite(start2);
          if (end2 === undefined$1) {
            end2 = start2;
            start2 = 0;
          } else {
            end2 = toFinite(end2);
          }
          number = toNumber(number);
          return baseInRange(number, start2, end2);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined$1;
          }
          if (floating === undefined$1) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined$1;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined$1;
            }
          }
          if (lower === undefined$1 && upper === undefined$1) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined$1) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index2) {
          word = word.toLowerCase();
          return result2 + (index2 ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position2) {
          string = toString(string);
          target = baseToString(target);
          var length2 = string.length;
          position2 = position2 === undefined$1 ? length2 : baseClamp(toInteger2(position2), 0, length2);
          var end2 = position2;
          position2 -= target.length;
          return position2 >= 0 && string.slice(position2, end2) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length2, chars) {
          string = toString(string);
          length2 = toInteger2(length2);
          var strLength = length2 ? stringSize(string) : 0;
          if (!length2 || strLength >= length2) {
            return string;
          }
          var mid = (length2 - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length2, chars) {
          string = toString(string);
          length2 = toInteger2(length2);
          var strLength = length2 ? stringSize(string) : 0;
          return length2 && strLength < length2 ? string + createPadding(length2 - strLength, chars) : string;
        }
        function padStart(string, length2, chars) {
          string = toString(string);
          length2 = toInteger2(length2);
          var strLength = length2 ? stringSize(string) : 0;
          return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n2, guard) {
          if (guard ? isIterateeCall(string, n2, guard) : n2 === undefined$1) {
            n2 = 1;
          } else {
            n2 = toInteger2(n2);
          }
          return baseRepeat(toString(string), n2);
        }
        function replace2() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator2, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator2, limit)) {
            separator2 = limit = undefined$1;
          }
          limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator2 == "string" || separator2 != null && !isRegExp(separator2))) {
            separator2 = baseToString(separator2);
            if (!separator2 && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator2, limit);
        }
        var startCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position2) {
          string = toString(string);
          position2 = position2 == null ? 0 : baseClamp(toInteger2(position2), 0, string.length);
          target = baseToString(target);
          return string.slice(position2, position2 + target.length) == target;
        }
        function template(string, options2, guard) {
          var settings = lodash2.templateSettings;
          if (guard && isIterateeCall(string, options2, guard)) {
            options2 = undefined$1;
          }
          string = toString(string);
          options2 = assignWith({}, options2, settings, customDefaultsAssignIn);
          var imports = assignWith({}, options2.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          arrayEach(importsKeys, function(key) {
            if (reForbiddenIdentifierChars.test(key)) {
              throw new Error2(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            }
          });
          var isEscaping, isEvaluating, index2 = 0, interpolate = options2.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options2.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options2.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options2, "sourceURL") ? (options2.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset3) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index2, offset3).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index2 = offset3 + match2.length;
            return match2;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options2, "variable") && options2.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value2) {
          return toString(value2).toLowerCase();
        }
        function toUpper(value2) {
          return toString(value2).toUpperCase();
        }
        function trim2(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end2 = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start2, end2).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end2 = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end2).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start2 = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start2).join("");
        }
        function truncate(string, options2) {
          var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options2)) {
            var separator2 = "separator" in options2 ? options2.separator : separator2;
            length2 = "length" in options2 ? toInteger2(options2.length) : length2;
            omission = "omission" in options2 ? baseToString(options2.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length2 >= strLength) {
            return string;
          }
          var end2 = length2 - stringSize(omission);
          if (end2 < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end2).join("") : string.slice(0, end2);
          if (separator2 === undefined$1) {
            return result2 + omission;
          }
          if (strSymbols) {
            end2 += result2.length - end2;
          }
          if (isRegExp(separator2)) {
            if (string.slice(end2).search(separator2)) {
              var match2, substring = result2;
              if (!separator2.global) {
                separator2 = RegExp2(separator2.source, toString(reFlags.exec(separator2)) + "g");
              }
              separator2.lastIndex = 0;
              while (match2 = separator2.exec(substring)) {
                var newEnd = match2.index;
              }
              result2 = result2.slice(0, newEnd === undefined$1 ? end2 : newEnd);
            }
          } else if (string.indexOf(baseToString(separator2), end2) != end2) {
            var index2 = result2.lastIndexOf(separator2);
            if (index2 > -1) {
              result2 = result2.slice(0, index2);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined$1 : pattern;
          if (pattern === undefined$1) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined$1, args);
          } catch (e3) {
            return isError(e3) ? e3 : new Error2(e3);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey2(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length2 ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index2 = -1;
            while (++index2 < length2) {
              var pair = pairs[index2];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value2) {
          return function() {
            return value2;
          };
        }
        function defaultTo(value2, defaultValue) {
          return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value2) {
          return value2;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches2(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options2) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options2 == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options2 = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options2) && "chain" in options2) || !!options2.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions2 = result2.__actions__ = copyArray(this.__actions__);
                  actions2.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root2._ === this) {
            root2._ = oldDash;
          }
          return this;
        }
        function noop3() {
        }
        function nthArg(n2) {
          n2 = toInteger2(n2);
          return baseRest(function(args) {
            return baseNth(args, n2);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey2(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined$1 : baseGet(object, path);
          };
        }
        var range2 = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n2, iteratee2) {
          n2 = toInteger2(n2);
          if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
            return [];
          }
          var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin(n2, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n2 -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length2, iteratee2);
          while (++index2 < n2) {
            iteratee2(index2);
          }
          return result2;
        }
        function toPath(value2) {
          if (isArray2(value2)) {
            return arrayMap(value2, toKey2);
          }
          return isSymbol(value2) ? [value2] : copyArray(stringToPath(toString(value2)));
        }
        function uniqueId(prefix2) {
          var id = ++idCounter;
          return toString(prefix2) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor2 = createRound("floor");
        function max2(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min2(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round2 = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash2.after = after;
        lodash2.ary = ary;
        lodash2.assign = assign2;
        lodash2.assignIn = assignIn;
        lodash2.assignInWith = assignInWith;
        lodash2.assignWith = assignWith;
        lodash2.at = at2;
        lodash2.before = before;
        lodash2.bind = bind;
        lodash2.bindAll = bindAll;
        lodash2.bindKey = bindKey;
        lodash2.castArray = castArray;
        lodash2.chain = chain;
        lodash2.chunk = chunk;
        lodash2.compact = compact2;
        lodash2.concat = concat;
        lodash2.cond = cond;
        lodash2.conforms = conforms;
        lodash2.constant = constant;
        lodash2.countBy = countBy;
        lodash2.create = create;
        lodash2.curry = curry;
        lodash2.curryRight = curryRight;
        lodash2.debounce = debounce2;
        lodash2.defaults = defaults;
        lodash2.defaultsDeep = defaultsDeep;
        lodash2.defer = defer;
        lodash2.delay = delay;
        lodash2.difference = difference;
        lodash2.differenceBy = differenceBy;
        lodash2.differenceWith = differenceWith;
        lodash2.drop = drop;
        lodash2.dropRight = dropRight;
        lodash2.dropRightWhile = dropRightWhile;
        lodash2.dropWhile = dropWhile;
        lodash2.fill = fill;
        lodash2.filter = filter;
        lodash2.flatMap = flatMap;
        lodash2.flatMapDeep = flatMapDeep;
        lodash2.flatMapDepth = flatMapDepth;
        lodash2.flatten = flatten2;
        lodash2.flattenDeep = flattenDeep;
        lodash2.flattenDepth = flattenDepth;
        lodash2.flip = flip2;
        lodash2.flow = flow;
        lodash2.flowRight = flowRight;
        lodash2.fromPairs = fromPairs;
        lodash2.functions = functions;
        lodash2.functionsIn = functionsIn;
        lodash2.groupBy = groupBy;
        lodash2.initial = initial;
        lodash2.intersection = intersection;
        lodash2.intersectionBy = intersectionBy;
        lodash2.intersectionWith = intersectionWith;
        lodash2.invert = invert;
        lodash2.invertBy = invertBy;
        lodash2.invokeMap = invokeMap;
        lodash2.iteratee = iteratee;
        lodash2.keyBy = keyBy;
        lodash2.keys = keys;
        lodash2.keysIn = keysIn;
        lodash2.map = map;
        lodash2.mapKeys = mapKeys;
        lodash2.mapValues = mapValues;
        lodash2.matches = matches2;
        lodash2.matchesProperty = matchesProperty;
        lodash2.memoize = memoize2;
        lodash2.merge = merge3;
        lodash2.mergeWith = mergeWith;
        lodash2.method = method;
        lodash2.methodOf = methodOf;
        lodash2.mixin = mixin;
        lodash2.negate = negate;
        lodash2.nthArg = nthArg;
        lodash2.omit = omit2;
        lodash2.omitBy = omitBy;
        lodash2.once = once;
        lodash2.orderBy = orderBy;
        lodash2.over = over;
        lodash2.overArgs = overArgs;
        lodash2.overEvery = overEvery;
        lodash2.overSome = overSome;
        lodash2.partial = partial;
        lodash2.partialRight = partialRight;
        lodash2.partition = partition;
        lodash2.pick = pick;
        lodash2.pickBy = pickBy;
        lodash2.property = property;
        lodash2.propertyOf = propertyOf;
        lodash2.pull = pull;
        lodash2.pullAll = pullAll;
        lodash2.pullAllBy = pullAllBy;
        lodash2.pullAllWith = pullAllWith;
        lodash2.pullAt = pullAt;
        lodash2.range = range2;
        lodash2.rangeRight = rangeRight;
        lodash2.rearg = rearg;
        lodash2.reject = reject;
        lodash2.remove = remove2;
        lodash2.rest = rest;
        lodash2.reverse = reverse;
        lodash2.sampleSize = sampleSize;
        lodash2.set = set2;
        lodash2.setWith = setWith;
        lodash2.shuffle = shuffle;
        lodash2.slice = slice2;
        lodash2.sortBy = sortBy;
        lodash2.sortedUniq = sortedUniq;
        lodash2.sortedUniqBy = sortedUniqBy;
        lodash2.split = split;
        lodash2.spread = spread;
        lodash2.tail = tail;
        lodash2.take = take;
        lodash2.takeRight = takeRight;
        lodash2.takeRightWhile = takeRightWhile;
        lodash2.takeWhile = takeWhile;
        lodash2.tap = tap;
        lodash2.throttle = throttle2;
        lodash2.thru = thru;
        lodash2.toArray = toArray2;
        lodash2.toPairs = toPairs;
        lodash2.toPairsIn = toPairsIn;
        lodash2.toPath = toPath;
        lodash2.toPlainObject = toPlainObject;
        lodash2.transform = transform;
        lodash2.unary = unary;
        lodash2.union = union;
        lodash2.unionBy = unionBy;
        lodash2.unionWith = unionWith;
        lodash2.uniq = uniq;
        lodash2.uniqBy = uniqBy;
        lodash2.uniqWith = uniqWith;
        lodash2.unset = unset;
        lodash2.unzip = unzip;
        lodash2.unzipWith = unzipWith;
        lodash2.update = update;
        lodash2.updateWith = updateWith;
        lodash2.values = values;
        lodash2.valuesIn = valuesIn;
        lodash2.without = without;
        lodash2.words = words;
        lodash2.wrap = wrap2;
        lodash2.xor = xor;
        lodash2.xorBy = xorBy;
        lodash2.xorWith = xorWith;
        lodash2.zip = zip;
        lodash2.zipObject = zipObject;
        lodash2.zipObjectDeep = zipObjectDeep;
        lodash2.zipWith = zipWith;
        lodash2.entries = toPairs;
        lodash2.entriesIn = toPairsIn;
        lodash2.extend = assignIn;
        lodash2.extendWith = assignInWith;
        mixin(lodash2, lodash2);
        lodash2.add = add;
        lodash2.attempt = attempt;
        lodash2.camelCase = camelCase;
        lodash2.capitalize = capitalize;
        lodash2.ceil = ceil;
        lodash2.clamp = clamp2;
        lodash2.clone = clone2;
        lodash2.cloneDeep = cloneDeep;
        lodash2.cloneDeepWith = cloneDeepWith;
        lodash2.cloneWith = cloneWith;
        lodash2.conformsTo = conformsTo;
        lodash2.deburr = deburr;
        lodash2.defaultTo = defaultTo;
        lodash2.divide = divide;
        lodash2.endsWith = endsWith;
        lodash2.eq = eq;
        lodash2.escape = escape;
        lodash2.escapeRegExp = escapeRegExp;
        lodash2.every = every;
        lodash2.find = find;
        lodash2.findIndex = findIndex2;
        lodash2.findKey = findKey2;
        lodash2.findLast = findLast2;
        lodash2.findLastIndex = findLastIndex;
        lodash2.findLastKey = findLastKey;
        lodash2.floor = floor2;
        lodash2.forEach = forEach;
        lodash2.forEachRight = forEachRight;
        lodash2.forIn = forIn;
        lodash2.forInRight = forInRight;
        lodash2.forOwn = forOwn;
        lodash2.forOwnRight = forOwnRight;
        lodash2.get = get2;
        lodash2.gt = gt2;
        lodash2.gte = gte;
        lodash2.has = has;
        lodash2.hasIn = hasIn;
        lodash2.head = head;
        lodash2.identity = identity;
        lodash2.includes = includes;
        lodash2.indexOf = indexOf;
        lodash2.inRange = inRange;
        lodash2.invoke = invoke;
        lodash2.isArguments = isArguments2;
        lodash2.isArray = isArray2;
        lodash2.isArrayBuffer = isArrayBuffer;
        lodash2.isArrayLike = isArrayLike;
        lodash2.isArrayLikeObject = isArrayLikeObject;
        lodash2.isBoolean = isBoolean;
        lodash2.isBuffer = isBuffer;
        lodash2.isDate = isDate2;
        lodash2.isElement = isElement2;
        lodash2.isEmpty = isEmpty;
        lodash2.isEqual = isEqual2;
        lodash2.isEqualWith = isEqualWith;
        lodash2.isError = isError;
        lodash2.isFinite = isFinite2;
        lodash2.isFunction = isFunction;
        lodash2.isInteger = isInteger;
        lodash2.isLength = isLength;
        lodash2.isMap = isMap;
        lodash2.isMatch = isMatch;
        lodash2.isMatchWith = isMatchWith;
        lodash2.isNaN = isNaN2;
        lodash2.isNative = isNative;
        lodash2.isNil = isNil;
        lodash2.isNull = isNull;
        lodash2.isNumber = isNumber;
        lodash2.isObject = isObject2;
        lodash2.isObjectLike = isObjectLike;
        lodash2.isPlainObject = isPlainObject;
        lodash2.isRegExp = isRegExp;
        lodash2.isSafeInteger = isSafeInteger;
        lodash2.isSet = isSet;
        lodash2.isString = isString;
        lodash2.isSymbol = isSymbol;
        lodash2.isTypedArray = isTypedArray;
        lodash2.isUndefined = isUndefined;
        lodash2.isWeakMap = isWeakMap;
        lodash2.isWeakSet = isWeakSet;
        lodash2.join = join;
        lodash2.kebabCase = kebabCase;
        lodash2.last = last;
        lodash2.lastIndexOf = lastIndexOf;
        lodash2.lowerCase = lowerCase;
        lodash2.lowerFirst = lowerFirst;
        lodash2.lt = lt2;
        lodash2.lte = lte;
        lodash2.max = max2;
        lodash2.maxBy = maxBy;
        lodash2.mean = mean;
        lodash2.meanBy = meanBy;
        lodash2.min = min2;
        lodash2.minBy = minBy;
        lodash2.stubArray = stubArray;
        lodash2.stubFalse = stubFalse;
        lodash2.stubObject = stubObject;
        lodash2.stubString = stubString;
        lodash2.stubTrue = stubTrue;
        lodash2.multiply = multiply;
        lodash2.nth = nth;
        lodash2.noConflict = noConflict;
        lodash2.noop = noop3;
        lodash2.now = now;
        lodash2.pad = pad;
        lodash2.padEnd = padEnd;
        lodash2.padStart = padStart;
        lodash2.parseInt = parseInt2;
        lodash2.random = random;
        lodash2.reduce = reduce;
        lodash2.reduceRight = reduceRight;
        lodash2.repeat = repeat;
        lodash2.replace = replace2;
        lodash2.result = result;
        lodash2.round = round2;
        lodash2.runInContext = runInContext2;
        lodash2.sample = sample;
        lodash2.size = size;
        lodash2.snakeCase = snakeCase;
        lodash2.some = some;
        lodash2.sortedIndex = sortedIndex;
        lodash2.sortedIndexBy = sortedIndexBy;
        lodash2.sortedIndexOf = sortedIndexOf;
        lodash2.sortedLastIndex = sortedLastIndex;
        lodash2.sortedLastIndexBy = sortedLastIndexBy;
        lodash2.sortedLastIndexOf = sortedLastIndexOf;
        lodash2.startCase = startCase;
        lodash2.startsWith = startsWith;
        lodash2.subtract = subtract;
        lodash2.sum = sum;
        lodash2.sumBy = sumBy;
        lodash2.template = template;
        lodash2.times = times;
        lodash2.toFinite = toFinite;
        lodash2.toInteger = toInteger2;
        lodash2.toLength = toLength;
        lodash2.toLower = toLower;
        lodash2.toNumber = toNumber;
        lodash2.toSafeInteger = toSafeInteger;
        lodash2.toString = toString;
        lodash2.toUpper = toUpper;
        lodash2.trim = trim2;
        lodash2.trimEnd = trimEnd;
        lodash2.trimStart = trimStart;
        lodash2.truncate = truncate;
        lodash2.unescape = unescape;
        lodash2.uniqueId = uniqueId;
        lodash2.upperCase = upperCase;
        lodash2.upperFirst = upperFirst;
        lodash2.each = forEach;
        lodash2.eachRight = forEachRight;
        lodash2.first = head;
        mixin(lodash2, (function() {
          var source = {};
          baseForOwn(lodash2, function(func, methodName) {
            if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        })(), { "chain": false });
        lodash2.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash2[methodName].placeholder = lodash2;
        });
        arrayEach(["drop", "take"], function(methodName, index2) {
          LazyWrapper.prototype[methodName] = function(n2) {
            n2 = n2 === undefined$1 ? 1 : nativeMax(toInteger2(n2), 0);
            var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n2, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n2) {
            return this.reverse()[methodName](n2).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
          var type2 = index2 + 1, isFilter = type2 == LAZY_FILTER_FLAG || type2 == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type2
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index2) {
          var takeName = "take" + (index2 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index2) {
          var dropName = "drop" + (index2 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value2) {
            return baseInvoke(value2, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start2, end2) {
          start2 = toInteger2(start2);
          var result2 = this;
          if (result2.__filtered__ && (start2 > 0 || end2 < 0)) {
            return new LazyWrapper(result2);
          }
          if (start2 < 0) {
            result2 = result2.takeRight(-start2);
          } else if (start2) {
            result2 = result2.drop(start2);
          }
          if (end2 !== undefined$1) {
            end2 = toInteger2(end2);
            result2 = end2 < 0 ? result2.dropRight(-end2) : result2.take(end2 - start2);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash2.prototype[methodName] = function() {
            var value2 = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value2 instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value2);
            var interceptor = function(value3) {
              var result3 = lodashFunc.apply(lodash2, arrayPush([value3], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value2 = onlyLazy ? value2 : new LazyWrapper(this);
              var result2 = func.apply(value2, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash2.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value2 = this.value();
              return func.apply(isArray2(value2) ? value2 : [], args);
            }
            return this[chainName](function(value3) {
              return func.apply(isArray2(value3) ? value3 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash2[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined$1
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash2.prototype.at = wrapperAt;
        lodash2.prototype.chain = wrapperChain;
        lodash2.prototype.commit = wrapperCommit;
        lodash2.prototype.next = wrapperNext;
        lodash2.prototype.plant = wrapperPlant;
        lodash2.prototype.reverse = wrapperReverse;
        lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
        lodash2.prototype.first = lodash2.prototype.head;
        if (symIterator) {
          lodash2.prototype[symIterator] = wrapperToIterator;
        }
        return lodash2;
      });
      var _2 = runInContext();
      if (freeModule) {
        (freeModule.exports = _2)._ = _2;
        freeExports._ = _2;
      } else {
        root2._ = _2;
      }
    }).call(lodash);
  })(lodash$1, lodash$1.exports);
  return lodash$1.exports;
}
var lodashExports = requireLodash();
const getMarks = (propsMarks, min2, max2, marksVisible, disabled2) => lodashExports.range(min2, max2 + 1).reduce(
  (acc, curr) => ({
    ...acc,
    [curr]: propsMarks?.[curr] && marksVisible ? {
      style: {
        fontSize: "14px",
        lineHeight: "20px",
        color: !disabled2 ? "#00204D" : "#ADBFD9",
        cursor: !disabled2 ? "pointer" : "not-allowed",
        width: 100,
        paddingTop: 8,
        ...propsMarks[curr]?.style
      },
      label: propsMarks[curr].label
    } : {
      label: ""
    }
  }),
  {}
);
const DEFAULT_HANDLE_SIZE = 24;
const DEFAULT_HANDLE_ICON_SIZE = 10;
const getStyles = (handleSize, marksVisible, disabled2) => {
  const handleStyle = {
    height: handleSize,
    width: handleSize,
    marginTop: -handleSize / 2 + 2,
    border: !disabled2 ? "1px solid #00204D" : "1px solid #ADBFD9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    backgroundColor: !disabled2 ? "#FFD129" : "#EBF0F7",
    cursor: !disabled2 ? "pointer" : "not-allowed"
  };
  const customRailStyle = {
    height: handleSize,
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `0 ${handleSize}px`,
    borderRadius: handleSize / 2,
    cursor: !disabled2 ? "pointer" : "not-allowed"
  };
  const handleIconStyle = {
    width: handleSize * DEFAULT_HANDLE_ICON_SIZE / DEFAULT_HANDLE_SIZE,
    height: handleSize * DEFAULT_HANDLE_ICON_SIZE / DEFAULT_HANDLE_SIZE
  };
  const wrapperStyle = {
    height: marksVisible ? handleSize + 20 : handleSize
  };
  const trackStyle = {
    backgroundColor: "transparent"
  };
  const railStyle = {
    backgroundColor: "transparent"
  };
  const dotStyle = {
    border: 0,
    cursor: !disabled2 ? "pointer" : "not-allowed",
    height: handleSize,
    width: handleSize * 2,
    marginLeft: -handleSize,
    marginBottom: -handleSize / 2 + 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 0,
    backgroundColor: "transparent"
  };
  return {
    trackStyle,
    dotStyle,
    railStyle,
    wrapperStyle,
    handleIconStyle,
    customRailStyle,
    handleStyle
  };
};
const slider__handle = "slider-module_slider__handle__yKBq-";
const slider$1 = "slider-module_slider__2oXtv";
const slider__unselected = "slider-module_slider__unselected__fn8R4";
const slider__focused = "slider-module_slider__focused__URKTf";
const slider__selected = "slider-module_slider__selected__bCm4d";
const styles$f = {
  "slider__custom-rail": "slider-module_slider__custom-rail__ZZ3J1",
  "slider__custom-rail--unselected": "slider-module_slider__custom-rail--unselected__V2enU",
  "slider__with-reset": "slider-module_slider__with-reset__yCykE",
  "slider__reset-button": "slider-module_slider__reset-button__9fsty",
  "slider__reset-button-available": "slider-module_slider__reset-button-available__QlRWI",
  slider__handle,
  "slider__handle-icon-hidden": "slider-module_slider__handle-icon-hidden__DMsPE",
  "slider__handle-icon-wrapper": "slider-module_slider__handle-icon-wrapper__iGaZo",
  slider: slider$1,
  slider__unselected,
  "slider__custom-rail--focused": "slider-module_slider__custom-rail--focused__Jyz8N",
  "slider__show-marks-on-selected": "slider-module_slider__show-marks-on-selected__tuCMl",
  "slider--disabled": "slider-module_slider--disabled__e8Gdi",
  slider__focused,
  slider__selected
};
const Slider = ({
  handleSize = DEFAULT_HANDLE_SIZE,
  value: value2,
  id,
  onChange: onChange2,
  marks,
  min: min2,
  max: max2,
  startPoint,
  disabled: disabled2,
  className,
  ariaLabel,
  step = 1,
  marksVisible = true,
  showMarksOnSelected = false,
  ariaValueTextFormatterForHandle,
  withReset,
  dataTestId,
  ...props
}) => {
  const [showValue, setShowValue] = useState(value2 !== void 0);
  const [focused, setFocused] = useState(false);
  const focusRef = useRef(false);
  const tabRef = useRef(false);
  const resetRef = useRef(false);
  const generatedMarks = getMarks(marks, min2, max2, marksVisible, disabled2);
  const {
    handleStyle,
    handleIconStyle,
    wrapperStyle,
    dotStyle,
    railStyle,
    trackStyle,
    customRailStyle
  } = getStyles(handleSize, marksVisible, disabled2);
  const parseAriaValueTextFormatterForHandle = (value22) => {
    if (ariaValueTextFormatterForHandle) {
      return ariaValueTextFormatterForHandle(value22);
    }
    return marks[value22].label;
  };
  useEffect(() => {
    if (!showValue && value2 !== void 0) {
      setShowValue(true);
    }
  }, [value2]);
  const handleChange = (newValue) => {
    if (!disabled2) {
      onChange2(newValue, id);
      if (!showValue) {
        setShowValue(true);
      }
    }
  };
  const handleAfterChange = (newValue) => {
    if (value2 === void 0 && (isUsingMouse() || !resetRef.current && !tabRef.current)) {
      setShowValue(true);
      onChange2(newValue, id);
      resetRef.current = false;
    }
  };
  const handleReset = () => {
    resetRef.current = true;
    tabRef.current = false;
    setShowValue(false);
    setFocused(false);
    onChange2(void 0, id);
  };
  const isUsingMouse = () => {
    return document.body.classList.contains("using-mouse");
  };
  const handleFocusCapture = () => {
    if (!isUsingMouse()) {
      focusRef.current = true;
      setFocused(true);
    }
  };
  const resetFocus = () => {
    focusRef.current = false;
    setFocused(false);
  };
  const shiftKeyPressedRef = useRef(false);
  const handleKeyDown = (e3) => {
    if (e3.key === "Shift") {
      shiftKeyPressedRef.current = true;
    } else if (value2 === void 0 && focusRef.current) {
      if (e3.key === "Enter" || e3.key === " ") {
        resetRef.current = false;
        setShowValue(true);
        handleChange(min2);
      } else if (e3.key === "Tab") {
        resetRef.current = false;
        tabRef.current = true;
        resetFocus();
      }
    }
  };
  const handleKeyUp = (e3) => {
    if (e3.key === "Shift") {
      shiftKeyPressedRef.current = false;
    }
  };
  const handleResetButtonKeyDown = (e3) => {
    if (e3.key === "Tab") {
      resetFocus();
    } else if (e3.key === "Shift") {
      shiftKeyPressedRef.current = true;
    }
  };
  const handleBlur = () => {
    if (shiftKeyPressedRef.current) {
      resetFocus();
      shiftKeyPressedRef.current = false;
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        styles$f["slider"],
        disabled2 && styles$f["slider--disabled"],
        withReset && styles$f["slider__with-reset"],
        showValue ? styles$f["slider__selected"] : styles$f["slider__unselected"],
        focused && styles$f["slider__focused"],
        showMarksOnSelected && styles$f["slider__show-marks-on-selected"],
        className
      ),
      style: wrapperStyle,
      "data-testid": dataTestId ?? "slider-wrapper",
      onFocusCapture: handleFocusCapture,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      children: [
        /* @__PURE__ */ jsx$1(
          "div",
          {
            style: customRailStyle,
            className: clsx(
              styles$f["slider__custom-rail"],
              !showValue && styles$f["slider__custom-rail--unselected"],
              focused && styles$f["slider__custom-rail--focused"]
            ),
            "data-testid": dataTestId ? `${dataTestId}-rail` : "slider-rail",
            onBlur: handleBlur,
            children: /* @__PURE__ */ jsx$1(
              InternalSlider,
              {
                handle: ({ className: className2, dragging, ...handleProps }) => {
                  return /* @__PURE__ */ jsx$1(Fragment, { children: showValue ? (
                    // @ts-ignore
                    /* @__PURE__ */ jsx$1(
                      Handle,
                      {
                        ...handleProps,
                        className: clsx(className2, styles$f["slider__handle"]),
                        children: /* @__PURE__ */ jsx$1(
                          "div",
                          {
                            style: { height: handleSize, width: handleSize },
                            className: styles$f["slider__handle-icon-wrapper"],
                            children: /* @__PURE__ */ jsx$1(DragMeIcon, { style: handleIconStyle })
                          }
                        )
                      }
                    )
                  ) : (
                    // @ts-ignore
                    /* @__PURE__ */ jsx$1(
                      Handle,
                      {
                        ...handleProps,
                        style: dotStyle,
                        className: styles$f["slider__handle-icon-hidden"],
                        children: /* @__PURE__ */ jsx$1("div", {})
                      }
                    )
                  ) });
                },
                handleStyle,
                dotStyle,
                railStyle,
                trackStyle,
                onChange: handleChange,
                onAfterChange: handleAfterChange,
                value: value2 ?? min2,
                dots: true,
                marks: generatedMarks,
                min: min2,
                max: max2,
                ariaLabelForHandle: ariaLabel,
                ariaValueTextFormatterForHandle: parseAriaValueTextFormatterForHandle,
                step,
                ...props
              }
            )
          }
        ),
        withReset && /* @__PURE__ */ jsx$1(
          "button",
          {
            className: clsx(
              styles$f["slider__reset-button"],
              value2 !== void 0 && styles$f["slider__reset-button-available"]
            ),
            onClick: handleReset,
            "data-testid": dataTestId ? `${dataTestId}-reset-button` : "slider-reset-button",
            onKeyDown: handleResetButtonKeyDown,
            children: "Reset"
          }
        )
      ]
    }
  );
};
const Switch = ({
  id,
  className,
  value: value2,
  disabled: disabled2,
  label: label2,
  ariaLabel,
  dataTestId,
  onToggle,
  size = "small"
}) => {
  const handleToggle = useCallback(() => {
    onToggle(!value2, id);
  }, [onToggle, value2, id]);
  const handleKeyboardPress = (event) => {
    if (event.code === "Enter" || event.code === "Space") {
      handleToggle();
    }
  };
  const checkboxId = `${id}-checkbox`;
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(
        "switch",
        `switch--state-${value2 ? "on" : "off"}`,
        disabled2 && "switch--disabled",
        `switch--size-${size}`,
        className
      ),
      onKeyDown: handleKeyboardPress,
      children: /* @__PURE__ */ jsxs(
        "label",
        {
          id,
          htmlFor: checkboxId,
          className: "switch__label",
          tabIndex: 0,
          "aria-checked": value2 || false,
          "aria-label": ariaLabel,
          role: "checkbox",
          "data-testid": dataTestId || "switch",
          children: [
            /* @__PURE__ */ jsx$1(
              "input",
              {
                checked: value2 || false,
                className: "switch__checkbox",
                id: checkboxId,
                type: "checkbox",
                disabled: disabled2,
                onChange: handleToggle,
                "data-testid": "checkbox"
              }
            ),
            /* @__PURE__ */ jsx$1("div", { className: "switch__button-wrapper", children: /* @__PURE__ */ jsx$1(
              "span",
              {
                className: clsx(
                  "switch__button",
                  `switch__button${!disabled2 ? `${value2 ? "-on" : "-off"}` : `${value2 ? "-disabled-on" : "-disabled-off"}`}`
                )
              }
            ) }),
            label2 && /* @__PURE__ */ jsx$1("span", { className: "switch__label-content", children: label2 })
          ]
        }
      )
    }
  );
};
function ChevronDownIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M11.06 5.72665L8 8.77999L4.94 5.72665L4 6.66665L8 10.6667L12 6.66665L11.06 5.72665Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function EmptyIcon() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "78",
      height: "48",
      viewBox: "0 0 78 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1(
          "ellipse",
          {
            cx: "39",
            cy: "41.0671",
            rx: "39",
            ry: "6.93333",
            fill: "#EBF0F7"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M11.748 16.8817L25.344 0.5H53.723L67.2658 16.8963L40.5917 35.1349L11.748 16.8817Z",
            stroke: "#62748C"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "mask",
          {
            id: "path-3-inside-1_1826_180563",
            fill: "white",
            children: /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.6846 16C11.58 16 10.6846 16.8954 10.6846 18V41.7333C10.6846 42.8379 11.58 43.7333 12.6846 43.7333H66.3832C67.4878 43.7333 68.3832 42.8379 68.3832 41.7333V18C68.3832 16.8954 67.4878 16 66.3832 16H51.2873L50.0237 21.8864C49.8259 22.8082 49.0111 23.4667 48.0683 23.4667H30.3568C29.4642 23.4667 28.6796 22.8751 28.434 22.017L26.7119 16H12.6846Z"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.6846 16C11.58 16 10.6846 16.8954 10.6846 18V41.7333C10.6846 42.8379 11.58 43.7333 12.6846 43.7333H66.3832C67.4878 43.7333 68.3832 42.8379 68.3832 41.7333V18C68.3832 16.8954 67.4878 16 66.3832 16H51.2873L50.0237 21.8864C49.8259 22.8082 49.0111 23.4667 48.0683 23.4667H30.3568C29.4642 23.4667 28.6796 22.8751 28.434 22.017L26.7119 16H12.6846Z",
            fill: "#EBF0F7"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M51.2873 16V15H50.4791L50.3095 15.7901L51.2873 16ZM50.0237 21.8864L49.046 21.6765V21.6765L50.0237 21.8864ZM28.434 22.017L27.4726 22.2921L28.434 22.017ZM26.7119 16L27.6733 15.7248L27.4659 15H26.7119V16ZM11.6846 18C11.6846 17.4477 12.1323 17 12.6846 17V15C11.0277 15 9.68457 16.3431 9.68457 18H11.6846ZM11.6846 41.7333V18H9.68457V41.7333H11.6846ZM12.6846 42.7333C12.1323 42.7333 11.6846 42.2856 11.6846 41.7333H9.68457C9.68457 43.3902 11.0277 44.7333 12.6846 44.7333V42.7333ZM66.3832 42.7333H12.6846V44.7333H66.3832V42.7333ZM67.3832 41.7333C67.3832 42.2856 66.9355 42.7333 66.3832 42.7333V44.7333C68.0401 44.7333 69.3832 43.3902 69.3832 41.7333H67.3832ZM67.3832 18V41.7333H69.3832V18H67.3832ZM66.3832 17C66.9355 17 67.3832 17.4477 67.3832 18H69.3832C69.3832 16.3431 68.0401 15 66.3832 15V17ZM51.2873 17H66.3832V15H51.2873V17ZM50.3095 15.7901L49.046 21.6765L51.0015 22.0963L52.265 16.2099L50.3095 15.7901ZM49.046 21.6765C48.9471 22.1374 48.5397 22.4667 48.0683 22.4667V24.4667C49.4825 24.4667 50.7047 23.479 51.0015 22.0963L49.046 21.6765ZM48.0683 22.4667H30.3568V24.4667H48.0683V22.4667ZM30.3568 22.4667C29.9105 22.4667 29.5182 22.1709 29.3954 21.7418L27.4726 22.2921C27.841 23.5794 29.0179 24.4667 30.3568 24.4667V22.4667ZM29.3954 21.7418L27.6733 15.7248L25.7505 16.2752L27.4726 22.2921L29.3954 21.7418ZM12.6846 17H26.7119V15H12.6846V17Z",
            fill: "#62748C",
            mask: "url(#path-3-inside-1_1826_180563)"
          }
        )
      ]
    }
  );
}
function MinusIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "17",
      height: "17",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1("path", { d: "M5 12h14" })
    }
  );
}
function NoSearchResultsIcon() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "78",
      height: "48",
      viewBox: "0 0 78 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1(
          "ellipse",
          {
            cx: "39",
            cy: "43.5",
            rx: "35",
            ry: "4.5",
            fill: "#EBF0F7"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M49 17C49 20.4939 47.8801 23.7262 45.9797 26.3576L60.3171 40.6951C61.0982 41.4761 61.0982 42.7424 60.3171 43.5235L59.5232 44.3174C58.7422 45.0984 57.4759 45.0984 56.6948 44.3174L42.3573 29.9799C39.726 31.8802 36.4938 33 33 33C24.1634 33 17 25.8366 17 17C17 8.16344 24.1634 1 33 1C41.8366 1 49 8.16344 49 17ZM33 28C39.0751 28 44 23.0751 44 17C44 10.9249 39.0751 6 33 6C26.9249 6 22 10.9249 22 17C22 23.0751 26.9249 28 33 28Z",
            fill: "#EBF0F7"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M45.9797 26.3576L45.5744 26.0649L45.3251 26.4101L45.6261 26.7112L45.9797 26.3576ZM60.3171 40.6951L60.6707 40.3415L60.3171 40.6951ZM60.3171 43.5235L60.6707 43.877L60.3171 43.5235ZM59.5232 44.3174L59.1697 43.9638L59.5232 44.3174ZM42.3573 29.9799L42.7109 29.6263L42.4098 29.3253L42.0646 29.5746L42.3573 29.9799ZM46.385 26.6504C48.3449 23.9366 49.5 20.6025 49.5 17H48.5C48.5 20.3853 47.4153 23.5158 45.5744 26.0649L46.385 26.6504ZM60.6707 40.3415L46.3333 26.0041L45.6261 26.7112L59.9636 41.0486L60.6707 40.3415ZM60.6707 43.877C61.647 42.9007 61.647 41.3178 60.6707 40.3415L59.9636 41.0486C60.5494 41.6344 60.5494 42.5841 59.9636 43.1699L60.6707 43.877ZM59.8768 44.6709L60.6707 43.877L59.9636 43.1699L59.1697 43.9638L59.8768 44.6709ZM56.3413 44.6709C57.3176 45.6472 58.9005 45.6472 59.8768 44.6709L59.1697 43.9638C58.5839 44.5496 57.6342 44.5496 57.0484 43.9638L56.3413 44.6709ZM42.0038 30.3335L56.3413 44.6709L57.0484 43.9638L42.7109 29.6263L42.0038 30.3335ZM33 33.5C36.6023 33.5 39.9364 32.345 42.6501 30.3853L42.0646 29.5746C39.5156 31.4154 36.3852 32.5 33 32.5V33.5ZM16.5 17C16.5 26.1127 23.8873 33.5 33 33.5V32.5C24.4396 32.5 17.5 25.5604 17.5 17H16.5ZM33 0.5C23.8873 0.5 16.5 7.8873 16.5 17H17.5C17.5 8.43959 24.4396 1.5 33 1.5V0.5ZM49.5 17C49.5 7.8873 42.1127 0.5 33 0.5V1.5C41.5604 1.5 48.5 8.43959 48.5 17H49.5ZM43.5 17C43.5 22.799 38.799 27.5 33 27.5V28.5C39.3513 28.5 44.5 23.3513 44.5 17H43.5ZM33 6.5C38.799 6.5 43.5 11.201 43.5 17H44.5C44.5 10.6487 39.3513 5.5 33 5.5V6.5ZM22.5 17C22.5 11.201 27.201 6.5 33 6.5V5.5C26.6487 5.5 21.5 10.6487 21.5 17H22.5ZM33 27.5C27.201 27.5 22.5 22.799 22.5 17H21.5C21.5 23.3513 26.6487 28.5 33 28.5V27.5Z",
            fill: "#62748C"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M62 24L67 29",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M67 24L62 29",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M52 3L55 6",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M55 3L52 6",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M10 30L15 35",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M15 30L10 35",
            stroke: "#EBF0F7",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function PlusIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "17",
      height: "17",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1("path", { d: "M12 5v14M5 12h14" })
    }
  );
}
function SortArrowsVerticalIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1("path", { d: "M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z" })
    }
  );
}
function SortArrowUpIcon({ className }) {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx$1("path", { d: "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z" })
    }
  );
}
const tableWrapper = "table-module_tableWrapper__Wyte1";
const tableSelectAll = "table-module_tableSelectAll__gM6Cc";
const tableContainer = "table-module_tableContainer__PHBjN";
const tableHeader = "table-module_tableHeader__C5ve7";
const columnGroupToggle = "table-module_columnGroupToggle__Cn0Ui";
const sortableColumnGroupHeaderContent = "table-module_sortableColumnGroupHeaderContent__8c8mM";
const tableRow = "table-module_tableRow__mbKlG";
const tableRowClickable = "table-module_tableRowClickable__ZTa7v";
const pinnedRow = "table-module_pinnedRow__MkNrG";
const pinnedGroupHeaderRow = "table-module_pinnedGroupHeaderRow__geEzA";
const pinnedGroupToggle = "table-module_pinnedGroupToggle__pG4Kw";
const pinnedGroupLabel = "table-module_pinnedGroupLabel__WZPJf";
const pinnedGroupMeta = "table-module_pinnedGroupMeta__lHqzl";
const pinnedGroupCount = "table-module_pinnedGroupCount__pKG5k";
const pinnedGroupAction = "table-module_pinnedGroupAction__zvZZV";
const pinnedGroupChevron = "table-module_pinnedGroupChevron__fjarn";
const pinnedGroupChevronCollapsed = "table-module_pinnedGroupChevronCollapsed__rTe4B";
const loader = "table-module_loader__NIswY";
const archiveCellWrapper = "table-module_archiveCellWrapper__Lx357";
const hoverableVisible = "table-module_hoverableVisible__M5EFq";
const hoverableHidden = "table-module_hoverableHidden__-AQqs";
const statePlaceholder = "table-module_statePlaceholder__iRU8L";
const noItemsContent = "table-module_noItemsContent__oMji-";
const noItemsButtonContainer = "table-module_noItemsButtonContainer__z0r6x";
const pagination = "table-module_pagination__6SKNx";
const toolbarContainer = "table-module_toolbarContainer__5IONp";
const toolbarLeftContainer = "table-module_toolbarLeftContainer__oy5DZ";
const toolbarLeftContainerEnd = "table-module_toolbarLeftContainerEnd__TFFPk";
const toolbarLeftContainerStart = "table-module_toolbarLeftContainerStart__VKPah";
const toolbarRightContainer = "table-module_toolbarRightContainer__9S4ol";
const toolbarDelimiter = "table-module_toolbarDelimiter__dTpg0";
const disabledLink = "table-module_disabledLink__3FCgG";
const styles$e = {
  tableWrapper,
  tableSelectAll,
  tableContainer,
  tableHeader,
  columnGroupToggle,
  sortableColumnGroupHeaderContent,
  tableRow,
  tableRowClickable,
  pinnedRow,
  pinnedGroupHeaderRow,
  pinnedGroupToggle,
  pinnedGroupLabel,
  pinnedGroupMeta,
  pinnedGroupCount,
  pinnedGroupAction,
  pinnedGroupChevron,
  pinnedGroupChevronCollapsed,
  loader,
  archiveCellWrapper,
  hoverableVisible,
  hoverableHidden,
  statePlaceholder,
  noItemsContent,
  noItemsButtonContainer,
  pagination,
  toolbarContainer,
  toolbarLeftContainer,
  toolbarLeftContainerEnd,
  toolbarLeftContainerStart,
  toolbarRightContainer,
  toolbarDelimiter,
  disabledLink
};
var HeaderSortDirection = /* @__PURE__ */ ((HeaderSortDirection2) => {
  HeaderSortDirection2["ASC"] = "ASC";
  HeaderSortDirection2["DESC"] = "DESC";
  HeaderSortDirection2["NONE"] = "NONE";
  return HeaderSortDirection2;
})(HeaderSortDirection || {});
function Table({
  title: title2,
  headerData,
  rowData = [],
  loading: loading2 = false,
  hasPagination = false,
  className,
  isSortable = true,
  unsortableHeaderKeys = [],
  descendingFirstHeaderKeys,
  noItemsConf,
  tableSearchDirty = false,
  noSearchResultsText = "No results found. Please adjust your search / filters.",
  isArchivable = false,
  hasHoverableActions = false,
  onArchiveRow,
  onUnarchiveRow,
  onDeleteRow,
  onRowClick,
  onRowCtrlOrCmdClick,
  externalSort,
  pagination: pagination2,
  dataTestId = "sz-table",
  hasToolbar = false,
  toolbarConf,
  stickyHeader: stickyHeader2,
  linkComponent,
  hasBatchActions = false,
  unlinkedColumnKeys = ["actions"],
  batchActions = [],
  pinnedRowIds = [],
  pinnedGroupConf,
  collapsibleColumnGroups = []
}) {
  const [hoveredRowId, setHoveredRowId] = React__default.useState();
  const [isPinnedGroupCollapsedInternal, setIsPinnedGroupCollapsedInternal] = React__default.useState(pinnedGroupConf?.defaultCollapsed || false);
  const [expandedGroupKeys, setExpandedGroupKeys] = React__default.useState(
    () => new Set(
      collapsibleColumnGroups.filter((group2) => group2.defaultExpanded).map((group2) => group2.summaryKey)
    )
  );
  const pinnedGroupId = `${dataTestId}-pinned-group`;
  const isPinnedGroupControlled = pinnedGroupConf?.isCollapsed !== void 0;
  const isPinnedGroupCollapsed = isPinnedGroupControlled ? pinnedGroupConf.isCollapsed : isPinnedGroupCollapsedInternal;
  const LinkComponent = linkComponent;
  const originalRowsById = React__default.useMemo(
    () => Object.fromEntries(rowData.map((row2) => [row2.id, row2])),
    [rowData]
  );
  const getUpdatedRows = () => {
    if (isArchivable) {
      return rowData.map((row2) => ({
        ...row2,
        archived: /* @__PURE__ */ jsx$1("div", { className: styles$e.archiveCellWrapper, children: /* @__PURE__ */ jsx$1(
          ArchiveRowCell,
          {
            id: row2.id,
            status: row2?.status || "",
            isHovered: hoveredRowId === row2.id,
            onArchive: onArchiveRow,
            onUnarchive: onUnarchiveRow,
            onDelete: onDeleteRow
          }
        ) })
      }));
    }
    if (hasHoverableActions) {
      return rowData.map((row2) => ({
        ...row2,
        actions: /* @__PURE__ */ jsx$1(
          "div",
          {
            className: hoveredRowId === row2.id ? styles$e.hoverableVisible : styles$e.hoverableHidden,
            children: row2.actions
          }
        )
      }));
    }
    return rowData;
  };
  const rows = getUpdatedRows();
  const headers = isArchivable ? [...headerData, { key: "archived", header: "Archived" }] : [...headerData];
  const headerKeys = new Set(headers.map((header2) => header2.key));
  const activeColumnGroups = collapsibleColumnGroups.filter(
    (group2) => group2.columnKeys.length > 0 && headerKeys.has(group2.summaryKey) && group2.columnKeys.every((columnKey) => headerKeys.has(columnKey))
  );
  function isColumnGroupExpanded(group2) {
    return group2.isExpanded ?? expandedGroupKeys.has(group2.summaryKey);
  }
  const hiddenColumnKeys = new Set(
    activeColumnGroups.flatMap(
      (group2) => isColumnGroupExpanded(group2) ? [group2.summaryKey] : group2.columnKeys
    )
  );
  const visibleHeaders = headers.filter(
    (header2) => !hiddenColumnKeys.has(header2.key)
  );
  const columnGroupTogglesByHeaderKey = new Map(
    activeColumnGroups.map((group2) => {
      const isExpanded = isColumnGroupExpanded(group2);
      return [
        isExpanded ? group2.columnKeys[0] : group2.summaryKey,
        { group: group2, isExpanded }
      ];
    })
  );
  function handleToggleColumnGroup(group2) {
    const isExpanded = isColumnGroupExpanded(group2);
    group2.onToggleExpanded?.(!isExpanded);
    if (group2.isExpanded !== void 0) {
      return;
    }
    setExpandedGroupKeys((previousKeys) => {
      const nextKeys = new Set(previousKeys);
      if (isExpanded) {
        nextKeys.delete(group2.summaryKey);
      } else {
        nextKeys.add(group2.summaryKey);
      }
      return nextKeys;
    });
  }
  function handleRowHover(id) {
    setHoveredRowId(id);
    return;
  }
  function resetRowHover() {
    setHoveredRowId(null);
  }
  function handleRowClick(event, row2) {
    if (isCtrlOrCmdPressed(event)) {
      onRowCtrlOrCmdClick?.(row2);
    } else {
      onRowClick?.(row2);
    }
  }
  function handleEnterOrSpaceKeydown(event, row2) {
    if (isEnterOrSpaceKey(event)) {
      if (isCtrlOrCmdPressed(event)) {
        onRowCtrlOrCmdClick?.(row2);
      } else {
        onRowClick?.(row2);
      }
    }
  }
  function handleTogglePinnedGroup() {
    pinnedGroupConf?.onToggleCollapse?.(!isPinnedGroupCollapsed);
    if (!isPinnedGroupControlled) {
      setIsPinnedGroupCollapsedInternal((prev2) => !prev2);
    }
  }
  const pinnedIdSet = new Set(pinnedRowIds.map(String));
  const hasRows = !!rowData.length;
  const isTableSortable = hasRows && isSortable;
  const currentPageSize = pagination2?.currentPageSize || 20;
  const showPagination = hasPagination && pagination2.totalNumberOfItems > currentPageSize;
  const areRowsFocusable = isArchivable || hasHoverableActions;
  const unlinkedColumnKeySet = React__default.useMemo(
    () => new Set(unlinkedColumnKeys),
    [unlinkedColumnKeys]
  );
  function stopCellEventPropagation(event) {
    event.stopPropagation();
  }
  return /* @__PURE__ */ jsxs("div", { className: styles$e.tableWrapper, "data-testid": dataTestId, children: [
    hasRows && showPagination && /* @__PURE__ */ jsx$1(
      Pagination,
      {
        className: styles$e.pagination,
        itemsPerPageText: "Items per page:",
        onChange: pagination2?.onChange,
        pageNumberText: "Page Number",
        pageSize: currentPageSize,
        pageSizes: [5, 10, 20, 50, 100],
        totalItems: pagination2?.totalNumberOfItems,
        page: pagination2?.page,
        "data-testid": pagination2["data-testid"]
      }
    ),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx$1(
        DataTable,
        {
          isSortable: isTableSortable,
          rows,
          headers: visibleHeaders,
          children: ({
            rows: denormalizedRows,
            headers: headers2,
            getHeaderProps,
            getTableProps,
            getToolbarProps,
            getRowProps,
            getBatchActionProps,
            getSelectionProps,
            selectRow,
            selectedRows,
            getTableContainerProps
          }) => {
            const mergedRows = denormalizedRows?.map((row2) => ({
              ...originalRowsById[row2.id],
              ...row2
            }));
            const batchActionProps = getBatchActionProps();
            const mergedRowsById = Object.fromEntries(
              mergedRows.map((row2) => [String(row2.id), row2])
            );
            const pinnedRows = pinnedRowIds.map((pinnedRowId) => mergedRowsById[String(pinnedRowId)]).filter(Boolean);
            const unpinnedRows = mergedRows.filter(
              (row2) => !pinnedIdSet.has(String(row2.id))
            );
            const hasPinnedGroup = pinnedRows.length > 0;
            const pinnedGroupColumnCount = headers2.length + (hasBatchActions ? 1 : 0);
            const pinnedGroupLabel2 = pinnedGroupConf?.label || "Pinned";
            const pinnedItemNoun = pinnedGroupConf?.itemNoun || "row";
            const pluralisedItemNoun = (count2) => `${pinnedItemNoun}${count2 === 1 ? "" : "s"}`;
            const pinnedItemCount = (count2) => `${count2} pinned ${pluralisedItemNoun(count2)}`;
            const pinnedTotalCount = pinnedGroupConf?.totalCount ?? pinnedRows.length;
            const notShownCount = Math.max(
              pinnedTotalCount - pinnedRows.length,
              0
            );
            const pinnedGroupCountText = isPinnedGroupCollapsed ? `${pinnedItemCount(pinnedRows.length)} hidden` : [
              pinnedGroupConf?.limit ? `${pinnedTotalCount} of max ${pinnedGroupConf.limit}` : `${pinnedTotalCount}`,
              notShownCount > 0 ? `${notShownCount} ${pluralisedItemNoun(
                notShownCount
              )} not shown` : void 0
            ].filter(Boolean).join(" · ");
            function renderTableRow(row2, rowIndex, { testIdPrefix = dataTestId, rowClassName = "" } = {}) {
              return /* @__PURE__ */ jsxs(
                TableRow,
                {
                  "data-testid": `${testIdPrefix}-row-${rowIndex}`,
                  className: clsx(
                    styles$e.tableRow,
                    onRowClick && styles$e.tableRowClickable,
                    rowClassName,
                    row2.className
                  ),
                  tabIndex: onRowClick || areRowsFocusable ? 0 : -1,
                  onMouseOver: () => handleRowHover(row2.id),
                  onFocus: areRowsFocusable ? () => handleRowHover(row2.id) : void 0,
                  onClick: (event) => handleRowClick(event, row2),
                  onKeyDown: (event) => handleEnterOrSpaceKeydown(event, row2),
                  children: [
                    hasBatchActions && /* @__PURE__ */ jsx$1(TableSelectRow, { ...getSelectionProps({ row: row2 }) }),
                    row2.cells.map((cell2, rowCellIndex) => {
                      const isUnlinkedColumn = unlinkedColumnKeySet.has(
                        cell2.info.header
                      );
                      return /* @__PURE__ */ jsx$1(
                        TableCell,
                        {
                          "data-testid": `${testIdPrefix}-cell-${rowIndex}-${rowCellIndex}`,
                          "data-column-key": cell2.info.header,
                          onClick: isUnlinkedColumn ? stopCellEventPropagation : void 0,
                          onKeyDown: isUnlinkedColumn ? stopCellEventPropagation : void 0,
                          children: LinkComponent && !isUnlinkedColumn ? /* @__PURE__ */ jsx$1(
                            "div",
                            {
                              className: clsx(
                                row2.disabled && styles$e.disabledLink
                              ),
                              children: /* @__PURE__ */ jsx$1(LinkComponent, { ...row2.linkComponentProps, children: cell2.value })
                            }
                          ) : cell2.value
                        },
                        cell2.id
                      );
                    })
                  ]
                },
                row2.id
              );
            }
            return /* @__PURE__ */ jsxs(
              TableContainer,
              {
                title: title2,
                tabIndex: 0,
                className: clsx(styles$e.tableContainer, className),
                onMouseLeave: resetRowHover,
                ...getTableContainerProps(),
                children: [
                  hasToolbar && toolbarConf && /* @__PURE__ */ jsxs(
                    TableToolbar,
                    {
                      ...getToolbarProps(),
                      "aria-label": toolbarConf?.ariaLabel || "Table toolbar",
                      children: [
                        /* @__PURE__ */ jsx$1(TableBatchActions, { ...batchActionProps, children: hasBatchActions && batchActions.map((batchAction) => /* @__PURE__ */ jsx$1(
                          TableBatchAction,
                          {
                            tabIndex: batchActionProps.shouldShowBatchActions ? 0 : -1,
                            renderIcon: batchAction.icon ? batchAction.icon : false,
                            onClick: batchAction.onClick,
                            className: batchAction.className,
                            children: batchAction.label
                          }
                        )) }),
                        /* @__PURE__ */ jsx$1(TableToolbarContent, { children: /* @__PURE__ */ jsxs(
                          "div",
                          {
                            className: clsx(
                              styles$e.toolbarContainer,
                              toolbarConf?.containerClass
                            ),
                            children: [
                              /* @__PURE__ */ jsxs(
                                "div",
                                {
                                  className: clsx(
                                    styles$e.toolbarLeftContainer,
                                    toolbarConf?.leftContainerClass
                                  ),
                                  children: [
                                    /* @__PURE__ */ jsx$1("div", { className: styles$e.toolbarLeftContainerEnd, children: toolbarConf?.componentListLeft }),
                                    /* @__PURE__ */ jsx$1("div", { className: styles$e.toolbarLeftContainerStart, children: toolbarConf?.componentListLeftStart })
                                  ]
                                }
                              ),
                              toolbarConf.componentListRight && /* @__PURE__ */ jsx$1("div", { className: clsx(styles$e.toolbarDelimiter) }),
                              toolbarConf.componentListRight && /* @__PURE__ */ jsx$1(
                                "div",
                                {
                                  className: clsx(
                                    styles$e.toolbarRightContainer,
                                    toolbarConf?.rightContainerClass
                                  ),
                                  children: toolbarConf?.componentListRight
                                }
                              )
                            ]
                          }
                        ) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    Table$1,
                    {
                      ...getTableProps(),
                      size: "lg",
                      className: styles$e.table,
                      stickyHeader: stickyHeader2,
                      children: [
                        /* @__PURE__ */ jsx$1(TableHead, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
                          hasBatchActions && /* @__PURE__ */ jsx$1(
                            TableSelectAll,
                            {
                              ...getSelectionProps(),
                              className: styles$e.tableSelectAll
                            }
                          ),
                          headers2.map((header2, key) => /* @__PURE__ */ jsx$1(
                            CustomTableHeader,
                            {
                              header: header2,
                              getHeaderProps,
                              isTableSortable,
                              unsortableHeaderKeys,
                              descendingFirstHeaderKeys,
                              externalSort,
                              loading: loading2,
                              dataTestId: `${dataTestId}-header-${key}`,
                              columnGroupToggle: columnGroupTogglesByHeaderKey.get(
                                header2.key
                              ),
                              onToggleColumnGroup: handleToggleColumnGroup
                            },
                            key
                          ))
                        ] }) }),
                        !loading2 && hasPinnedGroup && /* @__PURE__ */ jsx$1(TableBody, { children: /* @__PURE__ */ jsx$1(TableRow, { className: styles$e.pinnedGroupHeaderRow, children: /* @__PURE__ */ jsx$1(TableCell, { colSpan: pinnedGroupColumnCount, children: /* @__PURE__ */ jsxs(
                          "button",
                          {
                            type: "button",
                            className: styles$e.pinnedGroupToggle,
                            style: pinnedGroupConf?.labelIndent === void 0 ? void 0 : {
                              "--pinned-group-label-indent": `${pinnedGroupConf.labelIndent}px`
                            },
                            "aria-expanded": !isPinnedGroupCollapsed,
                            "aria-controls": pinnedGroupId,
                            title: `${isPinnedGroupCollapsed ? "Show" : "Hide"} ${pinnedGroupLabel2.toLowerCase()}`,
                            onClick: handleTogglePinnedGroup,
                            "data-testid": `${dataTestId}-pinned-group-toggle`,
                            children: [
                              /* @__PURE__ */ jsx$1(
                                ChevronDownIcon,
                                {
                                  className: clsx(
                                    styles$e.pinnedGroupChevron,
                                    isPinnedGroupCollapsed && styles$e.pinnedGroupChevronCollapsed
                                  )
                                }
                              ),
                              /* @__PURE__ */ jsx$1("span", { className: styles$e.pinnedGroupLabel, children: pinnedGroupLabel2 }),
                              /* @__PURE__ */ jsxs("span", { className: styles$e.pinnedGroupMeta, children: [
                                /* @__PURE__ */ jsx$1(
                                  "span",
                                  {
                                    className: styles$e.pinnedGroupCount,
                                    "data-testid": `${dataTestId}-pinned-group-${isPinnedGroupCollapsed ? "summary" : "count"}`,
                                    children: pinnedGroupCountText
                                  }
                                ),
                                /* @__PURE__ */ jsx$1("span", { className: styles$e.pinnedGroupAction, children: isPinnedGroupCollapsed ? "Show" : "Hide" })
                              ] })
                            ]
                          }
                        ) }) }) }),
                        !loading2 && hasPinnedGroup && /* @__PURE__ */ jsx$1(TableBody, { id: pinnedGroupId, children: !isPinnedGroupCollapsed && pinnedRows.map(
                          (row2, rowIndex) => renderTableRow(row2, rowIndex, {
                            testIdPrefix: `${dataTestId}-pinned`,
                            rowClassName: styles$e.pinnedRow
                          })
                        ) }),
                        !loading2 && /* @__PURE__ */ jsx$1(TableBody, { children: unpinnedRows.map(
                          (row2, rowIndex) => renderTableRow(row2, rowIndex)
                        ) })
                      ]
                    }
                  )
                ]
              }
            );
          }
        }
      ),
      /* @__PURE__ */ jsx$1(TableStatePlaceholder, {})
    ] })
  ] });
  function ArchiveRowCell({
    id,
    status: status2,
    isHovered,
    onArchive,
    onUnarchive,
    onDelete
  }) {
    const statusIsOpen = status2.toLowerCase() === "open";
    const statusIsArchived = status2.toLowerCase() === "archived";
    if (statusIsOpen && !isHovered) {
      return /* @__PURE__ */ jsx$1(
        Button$1,
        {
          size: "small",
          className: styles$e.archivableOpenBtn,
          style: {
            backgroundColor: "var(--color-green-back-dark)",
            color: "var(--color-front)"
          },
          children: "Open"
        }
      );
    }
    if (statusIsOpen && isHovered) {
      return /* @__PURE__ */ jsx$1(
        Button$1,
        {
          size: "small",
          className: styles$e.archivableArchiveBtn,
          style: {
            backgroundColor: "var(--color-green-back-dark)",
            color: "var(--color-front)"
          },
          onClick: () => onArchive?.(id),
          children: "Archive"
        }
      );
    }
    if (statusIsArchived && isHovered) {
      return /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "5px" }, children: [
        /* @__PURE__ */ jsx$1(
          Button$1,
          {
            size: "small",
            variant: "secondary",
            onClick: () => onDelete?.(id),
            children: "Delete"
          }
        ),
        /* @__PURE__ */ jsx$1(
          Button$1,
          {
            size: "small",
            variant: "primary",
            onClick: () => onUnarchive?.(id),
            children: "Unarchive"
          }
        )
      ] });
    }
    if (statusIsArchived && !isHovered) {
      return /* @__PURE__ */ jsx$1(
        Button$1,
        {
          style: {
            backgroundColor: "var(--color-disabled-back)",
            color: "var(--color-front)"
          },
          size: "small",
          children: "Archived"
        }
      );
    }
    return /* @__PURE__ */ jsx$1(Button$1, { variant: "primary", size: "small", children: status2 });
  }
  function TableStatePlaceholder() {
    const listIsEmpty = !rowData.length;
    const {
      noItemComponent,
      noItemsText = "There are no items in the table.",
      onNoItemsPrimaryBtnClick,
      onNoItemsSecondaryBtnClick,
      noItemsPrimaryButtonText,
      noItemsSecondaryButtonText
    } = noItemsConf || {};
    if (loading2) {
      return /* @__PURE__ */ jsx$1("div", { className: styles$e.statePlaceholder, children: /* @__PURE__ */ jsx$1(
        Loader,
        {
          variant: "bubbles",
          color: "interactive",
          className: styles$e.loader
        }
      ) });
    }
    if (listIsEmpty && tableSearchDirty) {
      return /* @__PURE__ */ jsxs("div", { className: styles$e.statePlaceholder, children: [
        /* @__PURE__ */ jsx$1(NoSearchResultsIcon, {}),
        /* @__PURE__ */ jsx$1("div", { className: styles$e.noItemsContent, children: noSearchResultsText })
      ] });
    }
    if (listIsEmpty && !tableSearchDirty) {
      return noItemComponent ? noItemComponent : /* @__PURE__ */ jsxs("div", { className: styles$e.statePlaceholder, children: [
        /* @__PURE__ */ jsx$1(EmptyIcon, {}),
        /* @__PURE__ */ jsxs("div", { className: styles$e.noItemsContent, children: [
          noItemsText,
          noItemsConf && noItemsPrimaryButtonText && noItemsSecondaryButtonText && /* @__PURE__ */ jsxs("div", { className: styles$e.noItemsButtonContainer, children: [
            /* @__PURE__ */ jsx$1(
              Button$1,
              {
                variant: "primary",
                size: "small",
                onClick: onNoItemsPrimaryBtnClick,
                children: noItemsPrimaryButtonText
              }
            ),
            /* @__PURE__ */ jsx$1(
              Button$1,
              {
                variant: "secondary",
                size: "small",
                onClick: onNoItemsSecondaryBtnClick,
                children: noItemsSecondaryButtonText
              }
            )
          ] })
        ] })
      ] });
    }
    return null;
  }
}
function CustomTableHeader({
  header: header2,
  getHeaderProps,
  isTableSortable,
  unsortableHeaderKeys,
  externalSort,
  loading: loading2,
  dataTestId,
  descendingFirstHeaderKeys,
  columnGroupToggle: columnGroupToggle2,
  onToggleColumnGroup
}) {
  const isSortable = isTableSortable && !unsortableHeaderKeys.includes(header2.key);
  const headerDefaultProps = getHeaderProps({ header: header2, isSortable });
  const handleClick = () => {
    if (!externalSort || loading2) return;
    if (descendingFirstHeaderKeys?.includes(header2.key)) {
      const newSortDirection = header2.key === externalSort.sortedHeader && externalSort.sortDirection === "DESC" ? "ASC" : "DESC";
      externalSort.onClick(header2.key, newSortDirection);
    } else {
      const newSortDirection = header2.key === externalSort.sortedHeader && externalSort.sortDirection === "ASC" ? "DESC" : "ASC";
      externalSort.onClick(header2.key, newSortDirection);
    }
  };
  const headerProps = externalSort ? {
    ...headerDefaultProps,
    onClick: handleClick,
    sortDirection: header2.key === externalSort.sortedHeader ? externalSort.sortDirection : "NONE",
    isSortHeader: header2.key === externalSort.sortedHeader
  } : headerDefaultProps;
  if (columnGroupToggle2 && isSortable) {
    return /* @__PURE__ */ jsx$1(
      SortableColumnGroupHeader,
      {
        header: header2,
        dataTestId,
        columnGroupToggle: columnGroupToggle2,
        onToggleColumnGroup,
        onSort: externalSort ? handleClick : headerDefaultProps.onClick,
        sortDirection: headerProps.isSortHeader ? headerProps.sortDirection : "NONE"
        /* NONE */
      }
    );
  }
  return /* @__PURE__ */ jsx$1(
    TableHeader,
    {
      ...headerProps,
      className: styles$e.tableHeader,
      "data-testid": dataTestId,
      "data-column-key": header2.key,
      children: columnGroupToggle2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(
          ColumnGroupToggle,
          {
            group: columnGroupToggle2.group,
            isExpanded: columnGroupToggle2.isExpanded,
            onToggle: onToggleColumnGroup
          }
        ),
        header2.header
      ] }) : header2.header
    }
  );
}
const ARIA_SORT_BY_DIRECTION = {
  [
    "ASC"
    /* ASC */
  ]: "ascending",
  [
    "DESC"
    /* DESC */
  ]: "descending",
  [
    "NONE"
    /* NONE */
  ]: "none"
};
function SortableColumnGroupHeader({
  header: header2,
  dataTestId,
  columnGroupToggle: columnGroupToggle2,
  onToggleColumnGroup,
  onSort,
  sortDirection
}) {
  const isSorted = sortDirection !== "NONE";
  return /* @__PURE__ */ jsx$1(
    "th",
    {
      scope: "col",
      "aria-sort": ARIA_SORT_BY_DIRECTION[sortDirection],
      className: clsx(styles$e.tableHeader, "cds--table-sort__header"),
      "data-testid": dataTestId,
      "data-column-key": header2.key,
      children: /* @__PURE__ */ jsxs("div", { className: styles$e.sortableColumnGroupHeaderContent, children: [
        /* @__PURE__ */ jsx$1(
          ColumnGroupToggle,
          {
            group: columnGroupToggle2.group,
            isExpanded: columnGroupToggle2.isExpanded,
            onToggle: onToggleColumnGroup
          }
        ),
        /* @__PURE__ */ jsx$1(
          "button",
          {
            type: "button",
            className: clsx(styles$e.tableHeader, "cds--table-sort", {
              "cds--table-sort--active": isSorted,
              "cds--table-sort--descending": sortDirection === "DESC"
              /* DESC */
            }),
            onClick: onSort,
            children: /* @__PURE__ */ jsxs("span", { className: "cds--table-sort__flex", children: [
              /* @__PURE__ */ jsx$1("div", { className: "cds--table-header-label", children: header2.header }),
              /* @__PURE__ */ jsx$1(SortArrowUpIcon, { className: "cds--table-sort__icon" }),
              /* @__PURE__ */ jsx$1(SortArrowsVerticalIcon, { className: "cds--table-sort__icon-unsorted" })
            ] })
          }
        )
      ] })
    }
  );
}
function ColumnGroupToggle({
  group: group2,
  isExpanded,
  onToggle
}) {
  const label2 = isExpanded ? `Collapse ${group2.label} into one column` : `Show a column per ${group2.label}`;
  return /* @__PURE__ */ jsx$1(
    "button",
    {
      type: "button",
      className: styles$e.columnGroupToggle,
      "aria-expanded": isExpanded,
      "aria-label": label2,
      title: label2,
      onClick: (event) => {
        event.stopPropagation();
        onToggle?.(group2);
      },
      children: isExpanded ? /* @__PURE__ */ jsx$1(MinusIcon, {}) : /* @__PURE__ */ jsx$1(PlusIcon, {})
    }
  );
}
function isCtrlOrCmdPressed(event) {
  return event.ctrlKey || event.metaKey;
}
function isEnterOrSpaceKey(event) {
  return event.key === "Enter" || event.key === "Space";
}
function ErrorIcon() {
  return /* @__PURE__ */ jsx$1(
    "svg",
    {
      className: "sz-tabs-tab-error-icon",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx$1(
        "path",
        {
          d: "M7.3335 10.0007H8.66683V11.334H7.3335V10.0007ZM7.3335 4.66732H8.66683V8.66732H7.3335V4.66732ZM7.9935 1.33398C4.3135 1.33398 1.3335 4.32065 1.3335 8.00065C1.3335 11.6807 4.3135 14.6673 7.9935 14.6673C11.6802 14.6673 14.6668 11.6807 14.6668 8.00065C14.6668 4.32065 11.6802 1.33398 7.9935 1.33398ZM8.00016 13.334C5.0535 13.334 2.66683 10.9473 2.66683 8.00065C2.66683 5.05398 5.0535 2.66732 8.00016 2.66732C10.9468 2.66732 13.3335 5.05398 13.3335 8.00065C13.3335 10.9473 10.9468 13.334 8.00016 13.334Z",
          fill: "#D71717"
        }
      )
    }
  );
}
const tabsContainer = "tabs-module_tabsContainer__k8DKy";
const tabList = "tabs-module_tabList__Fgii3";
const tabsContainerVertical = "tabs-module_tabsContainerVertical__rGl0z";
const counter = "tabs-module_counter__2SKpW";
const tab = "tabs-module_tab__vmSck";
const errorTooltip = "tabs-module_errorTooltip__kIVTE";
const errorTooltipIconWrapper = "tabs-module_errorTooltipIconWrapper__irXTb";
const styles$d = {
  tabsContainer,
  tabList,
  tabsContainerVertical,
  counter,
  tab,
  errorTooltip,
  errorTooltipIconWrapper
};
function Counter({ value: value2, className, counterIcon }) {
  return /* @__PURE__ */ jsxs("span", { className: clsx(className, styles$d.counter), role: "status", children: [
    value2,
    counterIcon
  ] });
}
function TabCustom(props, ref2) {
  const {
    children,
    icon: icon2,
    hasError,
    hasErrorIcon = false,
    errorMessage,
    counter: counter2,
    counterIcon,
    disabled: disabled2,
    className,
    component,
    to,
    href,
    ...rest
  } = props;
  const Component2 = component || "a";
  const LinkWrapper = React__default.forwardRef(
    (wrapperProps, ref22) => {
      const {
        "aria-controls": ariaControls,
        "aria-disabled": ariaDisabled,
        "aria-selected": ariaSelected,
        role,
        tabIndex,
        onClick,
        onKeyDown,
        className: wrapperClassName,
        ...linkProps
      } = wrapperProps;
      return /* @__PURE__ */ jsx$1(
        Component2,
        {
          ref: ref22,
          ...linkProps,
          ...to && { to },
          ...href && { href },
          className: wrapperClassName,
          "aria-controls": ariaControls,
          "aria-disabled": ariaDisabled,
          "aria-selected": ariaSelected,
          role,
          tabIndex,
          onClick,
          onKeyDown,
          children
        }
      );
    }
  );
  const hasTooltipIconError = Boolean(hasError && errorMessage && hasErrorIcon);
  const hasTooltipError = Boolean(hasError && errorMessage);
  return /* @__PURE__ */ jsxs(
    Tab$2,
    {
      ...rest,
      ref: ref2,
      className: clsx(styles$d.tab, className),
      disabled: disabled2,
      "aria-invalid": hasError,
      "aria-errormessage": errorMessage,
      ...(to || href) && { as: LinkWrapper },
      children: [
        icon2 && /* @__PURE__ */ jsx$1("span", { className: "sz-tabs-tab-icon", children: icon2 }),
        /* @__PURE__ */ jsx$1(
          TooltipContent,
          {
            errorMessage,
            hasTooltipError,
            hasTooltipIconError,
            children
          }
        ),
        counter2 !== void 0 && counter2 !== null && /* @__PURE__ */ jsx$1(
          Counter,
          {
            value: counter2,
            counterIcon,
            className: "sz-tabs-tab-counter"
          }
        ),
        " ",
        hasTooltipIconError && /* @__PURE__ */ jsx$1(
          Tooltip$3,
          {
            ...errorMessage && { content: errorMessage },
            className: styles$d.errorTooltip,
            children: /* @__PURE__ */ jsx$1("div", { className: styles$d.errorTooltipIconWrapper, children: /* @__PURE__ */ jsx$1(ErrorIcon, {}) })
          }
        )
      ]
    }
  );
}
function TooltipContent({
  errorMessage,
  hasTooltipError,
  hasTooltipIconError,
  children
}) {
  const getChildrenAsString = () => {
    const childrenArray = React__default.Children.toArray(children);
    if (childrenArray.length === 1 && typeof childrenArray[0] === "string") {
      return childrenArray[0].toString();
    }
    return null;
  };
  const childrenAsString = getChildrenAsString();
  const truncateText = Boolean(
    childrenAsString && childrenAsString.length > 30
  );
  if (truncateText || !hasTooltipIconError && hasTooltipError) {
    return /* @__PURE__ */ jsx$1("div", { children: /* @__PURE__ */ jsx$1(
      Tooltip$3,
      {
        ...errorMessage && { content: errorMessage },
        ...truncateText && { content: childrenAsString },
        className: styles$d.errorTooltip,
        children: /* @__PURE__ */ jsx$1(
          "div",
          {
            className: clsx(
              "cds--tabs__nav-item-label"
            ),
            children
          }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsx$1(Fragment, { children });
}
const Tab$1 = forwardRef(TabCustom);
function TabListCustom(props, ref2) {
  const { children, ariaLabel, className, ...rest } = props;
  return /* @__PURE__ */ jsx$1(
    TabList$1,
    {
      ...rest,
      className: clsx(styles$d.tabList, className),
      ref: ref2,
      children
    }
  );
}
const TabList = forwardRef(TabListCustom);
const initialState = {
  currentTabIndex: 0
};
const TabsContext = createContext(initialState);
const TabPanelContext = createContext(0);
function TabPanelCustom({ children, className }) {
  const { currentTabIndex } = useContext(TabsContext);
  const panelIndex = useContext(TabPanelContext);
  return /* @__PURE__ */ jsx$1(TabPanel$1, { className, children: panelIndex === currentTabIndex && children });
}
const TabPanel2 = forwardRef(TabPanelCustom);
function TabPanels({ children }) {
  return /* @__PURE__ */ jsx$1(TabPanels$1, { children: React__default.Children.map(children, (child, index2) => {
    return /* @__PURE__ */ jsx$1(TabPanelContext.Provider, { value: index2, children: child });
  }) });
}
function Tabs({
  selectedTabIndex,
  orientation,
  onSelectTab,
  children,
  className
}) {
  const [currentTabIndex, setCurrentTabIndex] = useState(selectedTabIndex ?? 0);
  const hasModifierKey = useRef(false);
  useEffect(() => {
    if (selectedTabIndex !== void 0) {
      setCurrentTabIndex(selectedTabIndex);
    }
  }, [selectedTabIndex]);
  function handleTabChange({ selectedIndex }) {
    if (hasModifierKey.current) {
      return;
    }
    setCurrentTabIndex(selectedIndex);
    onSelectTab?.(selectedIndex);
  }
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(
        className,
        orientation === "vertical" && styles$d.tabsContainerVertical,
        styles$d.tabsContainer
      ),
      onMouseDownCapture: (e3) => {
        hasModifierKey.current = e3.metaKey || e3.ctrlKey;
      },
      children: /* @__PURE__ */ jsx$1(TabsContext.Provider, { value: { currentTabIndex }, children: /* @__PURE__ */ jsx$1(Tabs$1, { selectedIndex: currentTabIndex, onChange: handleTabChange, children }) })
    }
  );
}
function useAccessibilityKeyboardDetection() {
  React__default.useEffect(() => {
    document.addEventListener("mousedown", () => {
      document.body.classList.add("using-mouse");
    });
    document.addEventListener("keydown", (event) => {
      if (event.code === "Tab" || event.shiftKey && event.code === "Tab") {
        document.body.classList.remove("using-mouse");
      }
    });
  }, []);
}
const IconX = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1("g", { clipPath: "url(#clip0_397_9298)", children: /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z",
            fill: "#00204D"
          }
        ) }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_397_9298", children: /* @__PURE__ */ jsx$1("rect", { width: "12", height: "12", fill: "white" }) }) })
      ]
    }
  );
};
const INTERACTIVE = "tag-module_INTERACTIVE__cBs7I";
const INTERACTIVE_LIGHT = "tag-module_INTERACTIVE_LIGHT__FVENs";
const ACTIVATED = "tag-module_ACTIVATED__-Zf-W";
const OUTLINE = "tag-module_OUTLINE__vo2qa";
const COVERED = "tag-module_COVERED__MtqwF";
const GREEN = "tag-module_GREEN__juNmS";
const GREEN_BACK = "tag-module_GREEN_BACK__yyR-4";
const GREEN_BACK_MAX = "tag-module_GREEN_BACK_MAX__CjnMk";
const GREEN_FRONT = "tag-module_GREEN_FRONT__AQh90";
const GREEN_FRONT_LIGHT = "tag-module_GREEN_FRONT_LIGHT__KS8ua";
const BLUE = "tag-module_BLUE__z7Bpc";
const YELLOW = "tag-module_YELLOW__fScRM";
const YELLOW_BACK = "tag-module_YELLOW_BACK__LP7GN";
const RED = "tag-module_RED__RD-C8";
const PURPLE = "tag-module_PURPLE__Mf90l";
const DISABLED = "tag-module_DISABLED__3yUqw";
const DISABLED_FRONT = "tag-module_DISABLED_FRONT__v3F6h";
const NONE = "tag-module_NONE__Gpm5m";
const presentational = "tag-module_presentational__3o8Xd";
const selected$1 = "tag-module_selected__dzzur";
const DARK_BACK_BLUE = "tag-module_DARK_BACK_BLUE__OhRkp";
const iconWrapper = "tag-module_iconWrapper__S48jF";
const SMALL$1 = "tag-module_SMALL__ft2iJ";
const LARGE$1 = "tag-module_LARGE__FpDEp";
const styles$c = {
  "tag-container": "tag-module_tag-container__YC7BI",
  INTERACTIVE,
  INTERACTIVE_LIGHT,
  ACTIVATED,
  OUTLINE,
  COVERED,
  GREEN,
  GREEN_BACK,
  GREEN_BACK_MAX,
  GREEN_FRONT,
  GREEN_FRONT_LIGHT,
  BLUE,
  YELLOW,
  YELLOW_BACK,
  RED,
  PURPLE,
  DISABLED,
  DISABLED_FRONT,
  NONE,
  "main-button": "tag-module_main-button__tXi-6",
  "dismiss-button": "tag-module_dismiss-button__8Dinv",
  presentational,
  selected: selected$1,
  DARK_BACK_BLUE,
  iconWrapper,
  SMALL: SMALL$1,
  LARGE: LARGE$1
};
var TagSize = /* @__PURE__ */ ((TagSize2) => {
  TagSize2["SMALL"] = "SMALL";
  TagSize2["LARGE"] = "LARGE";
  return TagSize2;
})(TagSize || {});
var TagColor = /* @__PURE__ */ ((TagColor2) => {
  TagColor2["INTERACTIVE"] = "INTERACTIVE";
  TagColor2["INTERACTIVE_LIGHT"] = "INTERACTIVE_LIGHT";
  TagColor2["OUTLINE"] = "OUTLINE";
  TagColor2["COVERED"] = "COVERED";
  TagColor2["ACTIVATED"] = "ACTIVATED";
  TagColor2["GREEN"] = "GREEN";
  TagColor2["GREEN_BACK"] = "GREEN_BACK";
  TagColor2["GREEN_BACK_MAX"] = "GREEN_BACK_MAX";
  TagColor2["GREEN_FRONT"] = "GREEN_FRONT";
  TagColor2["GREEN_FRONT_LIGHT"] = "GREEN_FRONT_LIGHT";
  TagColor2["BLUE"] = "BLUE";
  TagColor2["YELLOW"] = "YELLOW";
  TagColor2["YELLOW_BACK"] = "YELLOW_BACK";
  TagColor2["RED"] = "RED";
  TagColor2["PURPLE"] = "PURPLE";
  TagColor2["DARK_BACK_BLUE"] = "DARK_BACK_BLUE";
  TagColor2["DISABLED"] = "DISABLED";
  TagColor2["DISABLED_FRONT"] = "DISABLED_FRONT";
  TagColor2["NONE"] = "NONE";
  return TagColor2;
})(TagColor || {});
const Tag = ({
  id,
  icon: icon2,
  children,
  containerClass,
  ariaLabel,
  ariaLabelDismiss,
  ariaLabelDismissPrefix = "Dismiss",
  isSelected = false,
  isDisabled = false,
  isDismissible = true,
  isPresentational = false,
  tagColor = "GREEN",
  onDismiss,
  onClick,
  customId,
  size = "SMALL",
  dataTestId
}) => {
  useAccessibilityKeyboardDetection();
  const handleDismiss = (event) => {
    if (onDismiss && !isDisabled && !isPresentational) {
      onDismiss(event);
    }
  };
  const handleOnClick = (event) => {
    if (onClick && !isDisabled && !isPresentational) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ jsx$1("div", { className: styles$c[isDisabled ? "DISABLED" : tagColor], id, children: /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": dataTestId || "tag-component",
      className: clsx(
        containerClass,
        styles$c["tag-container"],
        styles$c[tagColor]
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            id: customId,
            tabIndex: isPresentational ? -1 : 0,
            "aria-label": ariaLabel || children?.toString(),
            "aria-disabled": isDisabled,
            className: clsx(
              styles$c["main-button"],
              isPresentational && styles$c["presentational"],
              isSelected && styles$c["selected"],
              styles$c[size]
            ),
            onClick: handleOnClick,
            children: [
              icon2 && /* @__PURE__ */ jsx$1("span", { className: styles$c.iconWrapper, children: icon2 }),
              " ",
              children
            ]
          }
        ),
        isDismissible && /* @__PURE__ */ jsx$1(
          "button",
          {
            type: "button",
            id: customId,
            tabIndex: isPresentational ? -1 : 0,
            "aria-label": `${ariaLabelDismissPrefix} ${ariaLabelDismiss || children?.toString()}`,
            "aria-disabled": isDisabled,
            className: clsx(
              styles$c["dismiss-button"],
              isPresentational && styles$c["presentational"],
              styles$c[size]
            ),
            onClick: handleDismiss,
            children: /* @__PURE__ */ jsx$1(IconX, {})
          }
        )
      ]
    }
  ) });
};
const styles$b = {
  "sz-text-area": "text-area-module_sz-text-area__Ha96C",
  "sz-text-area_focused": "text-area-module_sz-text-area_focused__jCBth",
  "sz-text-area__area-wrapper": "text-area-module_sz-text-area__area-wrapper__RBhmF",
  "sz-text-area_error": "text-area-module_sz-text-area_error__bj738",
  "sz-text-area__title": "text-area-module_sz-text-area__title__NOsdM",
  "sz-text-area_disabled": "text-area-module_sz-text-area_disabled__-MNJY",
  "sz-text-area__area-element": "text-area-module_sz-text-area__area-element__k3VpH",
  "sz-text-area__title-wrapper": "text-area-module_sz-text-area__title-wrapper__4kWlp",
  "sz-text-area__max-characters": "text-area-module_sz-text-area__max-characters__ePC7u",
  "sz-text-area__max-characters-error": "text-area-module_sz-text-area__max-characters-error__2RmlD",
  "sz-text-area_active": "text-area-module_sz-text-area_active__5NZrW",
  "sz-text-area__error-title": "text-area-module_sz-text-area__error-title__5YMxM"
};
const TextArea = forwardRef(
  ({
    id,
    onChange: onChange2,
    onBlur,
    onFocus: onFocus2,
    disabled: disabled2,
    hasError,
    errorText,
    className,
    classNameWrapper,
    onMouseDown,
    onMouseUp,
    ariaLabel,
    title: title2,
    rows,
    autosize = false,
    maxCharacters,
    maxCharactersError,
    autoFocusOnMount = false,
    ...rest
  }, ref2) => {
    const [focused, setFocused] = useState(false);
    const [active2, setActive] = useState(false);
    const refState = useRef(false);
    const refInput = useRef(null);
    useEffect(() => {
      debugger;
      if (autoFocusOnMount && refInput) {
        const length2 = refInput?.current?.value.length || 0;
        refInput?.current?.setSelectionRange(length2, length2);
        refInput?.current?.focus();
      }
    }, []);
    useLayoutEffect$1(() => {
      if (autosize) {
        setHeight();
      }
    }, []);
    const handleFocus = (e3) => {
      if (!refState.current) {
        setFocused(true);
      }
      onFocus2?.(e3.target.value, id);
    };
    const handleBlur = (e3) => {
      setFocused(false);
      setActive(false);
      onBlur?.(e3.target.value, id);
    };
    const handleMouseUp = (e3) => {
      refState.current = false;
      onMouseUp?.(e3);
    };
    const handleMouseDown = (e3) => {
      refState.current = true;
      setActive(true);
      onMouseDown?.(e3);
    };
    const handleInputChange2 = (e3) => {
      if (!disabled2) {
        onChange2?.(e3.target.value, id);
        if (autosize) {
          setHeight();
        }
      }
    };
    const setHeight = () => {
      let elem = refInput?.current;
      if (elem) {
        const style2 = getComputedStyle(elem, null);
        const verticalBorders = Math.round(
          parseFloat(style2.borderTopWidth) + parseFloat(style2.borderBottomWidth)
        );
        const maxHeight = parseFloat(style2.maxHeight) || 300;
        elem.style.height = "auto";
        const newHeight = elem.scrollHeight + verticalBorders;
        elem.style.overflowY = newHeight > maxHeight ? "auto" : "hidden";
        elem.style.height = Math.min(newHeight, maxHeight) + "px";
      }
    };
    const handleRefMount = (el) => {
      refInput.current = el;
      if (ref2) {
        if (typeof ref2 === "function") {
          ref2(el);
        } else {
          ref2.current = el;
        }
      }
    };
    const isTitleActive = (active2 || !!refInput?.current?.value || focused) && !hasError && !disabled2;
    return /* @__PURE__ */ jsx$1(
      "fieldset",
      {
        "data-testid": "text-area-wrapper",
        className: clsx(
          styles$b["sz-text-area"],
          focused && styles$b["sz-text-area_focused"],
          hasError && styles$b["sz-text-area_error"],
          disabled2 && styles$b["sz-text-area_disabled"],
          classNameWrapper
        ),
        children: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("div", { className: styles$b["sz-text-area__title-wrapper"], children: [
            title2 && /* @__PURE__ */ jsx$1(
              "span",
              {
                id: `textarea-title-${id}`,
                className: clsx(
                  isTitleActive && styles$b["sz-text-area_active"],
                  styles$b["sz-text-area__title"]
                ),
                children: title2
              }
            ),
            maxCharacters && /* @__PURE__ */ jsxs(
              "span",
              {
                className: clsx(
                  styles$b["sz-text-area__max-characters"],
                  maxCharactersError && styles$b["sz-text-area__max-characters-error"]
                ),
                children: [
                  rest.value?.length || 0,
                  "/",
                  maxCharacters
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsx$1("div", { className: styles$b["sz-text-area__area-wrapper"], children: /* @__PURE__ */ jsx$1(
            "textarea",
            {
              ref: handleRefMount,
              rows: rows || 2,
              "aria-describedby": `textarea-title-${id}`,
              className: clsx(styles$b["sz-text-area__area-element"], className),
              onChange: handleInputChange2,
              onBlur: handleBlur,
              onFocus: handleFocus,
              id,
              "aria-disabled": disabled2,
              "aria-errormessage": `textarea-error-message-${id}`,
              onMouseUp: handleMouseUp,
              onMouseDown: handleMouseDown,
              "aria-label": ariaLabel,
              "aria-invalid": hasError,
              "data-testid": id,
              ...rest
            }
          ) }),
          hasError && /* @__PURE__ */ jsx$1(
            "span",
            {
              id: `textarea-error-message-${id}`,
              "aria-live": "polite",
              className: styles$b["sz-text-area__error-title"],
              children: errorText
            }
          )
        ] })
      }
    );
  }
);
const WEEK_CALENDAR_ROW_HEIGHT = 26;
const WARN_PREFIX = "[WeekCalendar]";
const MINUTES_PER_DAY = 24 * 60;
const outsideHoursOf = (day2, geometry) => {
  const { dayStartMin, dayEndMin, workStartMin, workEndMin } = geometry;
  const ranges = day2.outsideHours ?? [
    { startMin: dayStartMin, endMin: workStartMin },
    { startMin: workEndMin, endMin: dayEndMin }
  ];
  return ranges.map((range2) => ({
    startMin: Math.max(range2.startMin, dayStartMin),
    endMin: Math.min(range2.endMin, dayEndMin)
  })).filter((range2) => range2.endMin > range2.startMin);
};
const makeCellId = (weekKey, dayId, startMin) => `${weekKey}:${dayId}:${startMin}`;
const parseCellId = (cellId) => {
  const first = cellId.indexOf(":");
  const last = cellId.lastIndexOf(":");
  if (first === -1 || first === last) {
    return null;
  }
  const startMin = Number(cellId.slice(last + 1));
  if (!Number.isFinite(startMin)) {
    return null;
  }
  return {
    weekKey: cellId.slice(0, first),
    dayId: cellId.slice(first + 1, last),
    startMin
  };
};
const minutesToLabel = (min2) => {
  const m4 = (min2 % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
  const h4 = Math.floor(m4 / 60);
  const mm = m4 % 60;
  return `${String(h4).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
};
const shiftMinutes = (min2, offsetMinutes) => ((min2 + offsetMinutes) % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
const formatTimeRange = (startMin, endMin) => `${minutesToLabel(startMin)} – ${minutesToLabel(endMin)}`;
const rowStarts = (dayStartMin, dayEndMin, resolutionMins) => {
  const starts = [];
  for (let m4 = dayStartMin; m4 < dayEndMin; m4 += resolutionMins) {
    starts.push(m4);
  }
  return starts;
};
const viewportRowCount = (viewport2, resolutionMins) => Math.max(1, Math.ceil((viewport2.endMin - viewport2.startMin) / resolutionMins));
const minutesToPx = (min2, dayStartMin, resolutionMins) => (min2 - dayStartMin) / resolutionMins * WEEK_CALENDAR_ROW_HEIGHT;
const hourMarks = (dayStartMin, dayEndMin) => {
  const marks = [];
  for (let m4 = Math.ceil(dayStartMin / 60) * 60; m4 <= dayEndMin; m4 += 60) {
    marks.push(m4);
  }
  return marks;
};
const isElapsedStart = (day2, startMin) => startMin < (day2?.elapsedUntilMin ?? 0);
const isSelectableStart = (startMin, slotMins, dayEndMin, elapsedUntilMin = 0) => startMin >= elapsedUntilMin && startMin + slotMins <= dayEndMin;
const elapsedRangeOf = (day2, geometry) => {
  const endMin = Math.min(day2.elapsedUntilMin ?? 0, geometry.dayEndMin);
  return endMin > geometry.dayStartMin ? { startMin: geometry.dayStartMin, endMin } : null;
};
const overlaps = (aStart, aEnd, bStart, bEnd) => aStart < bEnd && bStart < aEnd;
const eventsAtCell = (day2, startMin, resolutionMins) => (day2.events || []).filter(
  (e3) => overlaps(startMin, startMin + resolutionMins, e3.startMin, e3.endMin)
);
const OUTSIDE_HOURS_LABEL = "Outside hours";
const tooLateLabel = (slotMins) => `Not enough time left in the day for a ${slotMins}-minute interview`;
const eventLabel = (event, showEventTitles) => {
  if (event.kind === "outsideHours") {
    return OUTSIDE_HOURS_LABEL;
  }
  return showEventTitles ? event.title || "Busy" : "Busy";
};
const rangeOverlapsBusy = (day2, startMin, endMin) => (day2.events || []).some(
  (e3) => overlaps(startMin, endMin, e3.startMin, e3.endMin)
);
const mergeRuns = (opts) => {
  const { cellIds, weekKey, days, resolutionMins } = opts;
  const byDay = /* @__PURE__ */ new Map();
  cellIds.forEach((id) => {
    const parsed = parseCellId(id);
    if (!parsed || parsed.weekKey !== weekKey) {
      return;
    }
    const starts = byDay.get(parsed.dayId);
    if (starts) {
      starts.push(parsed.startMin);
    } else {
      byDay.set(parsed.dayId, [parsed.startMin]);
    }
  });
  const blocks = [];
  days.forEach((day2) => {
    const starts = byDay.get(day2.id);
    if (!starts) {
      return;
    }
    starts.sort((a4, b3) => a4 - b3);
    let runStart = starts[0];
    let runEnd = starts[0] + resolutionMins;
    const flush = () => {
      blocks.push({
        id: `${day2.id}:${runStart}-${runEnd}`,
        dayId: day2.id,
        startMin: runStart,
        endMin: runEnd,
        overBusy: rangeOverlapsBusy(day2, runStart, runEnd)
      });
    };
    for (let i3 = 1; i3 < starts.length; i3 += 1) {
      if (starts[i3] === runEnd) {
        runEnd = starts[i3] + resolutionMins;
      } else if (starts[i3] > runEnd) {
        flush();
        runStart = starts[i3];
        runEnd = starts[i3] + resolutionMins;
      }
    }
    flush();
  });
  return blocks;
};
const cellAriaLabel = (opts) => {
  const {
    day: day2,
    startMin,
    selected: selected2,
    busy: busy2,
    elapsed: elapsed2 = false,
    tooLate = false,
    primaryZone,
    secondaryZone
  } = opts;
  let label2 = `${day2.label} ${day2.dateLabel}, ${minutesToLabel(startMin)}`;
  if (primaryZone) {
    label2 += ` ${primaryZone.label}`;
  }
  if (secondaryZone) {
    label2 += ` (${minutesToLabel(
      shiftMinutes(startMin, secondaryZone.offsetMinutes)
    )} ${secondaryZone.label})`;
  }
  if (elapsed2) {
    label2 += ", already passed";
  }
  if (tooLate && !elapsed2) {
    label2 += ", too late in the day";
  }
  if (busy2 && !selected2) {
    label2 += elapsed2 || tooLate ? ", busy" : ", busy — offer anyway";
  }
  if (selected2) {
    label2 += busy2 ? ", chosen, over busy time" : ", chosen";
  }
  return label2;
};
const laneEvents = (events) => {
  const sorted = [...events].sort(
    (a4, b3) => a4.startMin - b3.startMin || a4.endMin - b3.endMin
  );
  const lanes = [];
  const placed = sorted.map((event) => {
    let laneIndex = lanes.findIndex((end2) => end2 <= event.startMin);
    if (laneIndex === -1) {
      laneIndex = lanes.length;
      lanes.push(event.endMin);
    } else {
      lanes[laneIndex] = event.endMin;
    }
    return { event, laneIndex, laneCount: 1 };
  });
  let clusterStart = 0;
  let clusterEnd = -Infinity;
  let maxLane = 0;
  const closeCluster = (upTo) => {
    for (let i3 = clusterStart; i3 < upTo; i3 += 1) {
      placed[i3].laneCount = maxLane + 1;
    }
  };
  placed.forEach((p2, i3) => {
    if (p2.event.startMin >= clusterEnd) {
      closeCluster(i3);
      clusterStart = i3;
      maxLane = 0;
    }
    maxLane = Math.max(maxLane, p2.laneIndex);
    clusterEnd = Math.max(clusterEnd, p2.event.endMin);
  });
  closeCluster(placed.length);
  return placed;
};
const cellsToSlots = (opts) => {
  const { cellIds, suggestions, slotMins, dayEndMin } = opts;
  const suggested = new Set(suggestions.map((s4) => `${s4.dayId}:${s4.startMin}`));
  const byDay = /* @__PURE__ */ new Map();
  cellIds.forEach((id) => {
    const parsed = parseCellId(id);
    if (!parsed) {
      return;
    }
    const dayKey2 = `${parsed.weekKey}:${parsed.dayId}`;
    const entry = byDay.get(dayKey2);
    if (entry) {
      entry.starts.push(parsed.startMin);
    } else {
      byDay.set(dayKey2, { weekKey: parsed.weekKey, starts: [parsed.startMin] });
    }
  });
  const slots = [];
  [...byDay.entries()].sort(([a4], [b3]) => a4.localeCompare(b3)).forEach(([dayKey2, { weekKey, starts }]) => {
    const dayId = dayKey2.slice(weekKey.length + 1);
    starts.sort((a4, b3) => a4 - b3);
    let coveredUntil = -Infinity;
    starts.forEach((cellStart) => {
      if (cellStart < coveredUntil) {
        return;
      }
      const aligned = suggested.has(`${dayId}:${cellStart}`);
      const startMin = aligned ? cellStart : Math.min(cellStart, dayEndMin - slotMins);
      const endMin = startMin + slotMins;
      if (!slots.some(
        (s4) => s4.weekKey === weekKey && s4.dayId === dayId && s4.startMin === startMin
      )) {
        slots.push({
          weekKey,
          dayId,
          startMin,
          endMin,
          source: aligned ? "suggested" : "manual"
        });
      }
      coveredUntil = endMin;
    });
  });
  return slots;
};
const WeekCalendarContext = createContext(null);
const useWeekCalendarContext = () => {
  const context = useContext(WeekCalendarContext);
  if (!context) {
    throw new Error(
      "WeekCalendar internals must be rendered inside <WeekCalendar>."
    );
  }
  return context;
};
const root$1 = "week-calendar-module_root__dtqgq";
const scroll = "week-calendar-module_scroll__dMsoZ";
const viewport$1 = "week-calendar-module_viewport__QNSS4";
const grid = "week-calendar-module_grid__U4IJb";
const withSecondaryZone = "week-calendar-module_withSecondaryZone__FcA4a";
const gutterHead = "week-calendar-module_gutterHead__Y4l6K";
const dayHeaders = "week-calendar-module_dayHeaders__xM9ck";
const dayHeader = "week-calendar-module_dayHeader__zoMZ-";
const dayName$1 = "week-calendar-module_dayName__I9ZTs";
const dayDate = "week-calendar-module_dayDate__cqMgE";
const gutterBody = "week-calendar-module_gutterBody__TZ-W8";
const hourLabel = "week-calendar-module_hourLabel__NLYeE";
const daysArea = "week-calendar-module_daysArea__1YYEg";
const dayCards = "week-calendar-module_dayCards__004U3";
const dayCard = "week-calendar-module_dayCard__-lg4D";
const dayBody = "week-calendar-module_dayBody__GRGlI";
const hourLine = "week-calendar-module_hourLine__2Z3Yl";
const outsideHours = "week-calendar-module_outsideHours__mw243";
const elapsedWash = "week-calendar-module_elapsedWash__rky-3";
const hold = "week-calendar-module_hold__h35L1";
const busyEvent = "week-calendar-module_busyEvent__j5RuH";
const busyEventTitle = "week-calendar-module_busyEventTitle__r0ppJ";
const busyEventTime = "week-calendar-module_busyEventTime__6Ye2S";
const hitLayer = "week-calendar-module_hitLayer__oNo4U";
const hitRow = "week-calendar-module_hitRow__nlD19";
const hitCell = "week-calendar-module_hitCell__u9et7";
const suppressed = "week-calendar-module_suppressed__AC-2o";
const busy = "week-calendar-module_busy__A35hu";
const elapsed = "week-calendar-module_elapsed__NgK8q";
const chosenLayer = "week-calendar-module_chosenLayer__8Fu-c";
const chosenDay = "week-calendar-module_chosenDay__uozKE";
const chosenBlock = "week-calendar-module_chosenBlock__Xn55x";
const overBusy = "week-calendar-module_overBusy__qff2w";
const removeButton = "week-calendar-module_removeButton__jfO1r";
const chosenLabelRow = "week-calendar-module_chosenLabelRow__ZH-69";
const chosenTime = "week-calendar-module_chosenTime__GPN3n";
const overBusyMarker = "week-calendar-module_overBusyMarker__GwPPB";
const chosenSublabel = "week-calendar-module_chosenSublabel__2OsYH";
const legend = "week-calendar-module_legend__oAQyg";
const legendItem = "week-calendar-module_legendItem__CLvxT";
const legendWarn = "week-calendar-module_legendWarn__AUz6r";
const legendSwatch = "week-calendar-module_legendSwatch__EGJdr";
const picked = "week-calendar-module_picked__Fbm--";
const free = "week-calendar-module_free__14XGu";
const outsideHoursSwatch = "week-calendar-module_outsideHoursSwatch__WLd-U";
const elapsedSwatch = "week-calendar-module_elapsedSwatch__kljV0";
const overBusySwatch = "week-calendar-module_overBusySwatch__tTq0W";
const holdSwatch = "week-calendar-module_holdSwatch__oHMBY";
const skeletonGrid = "week-calendar-module_skeletonGrid__zVx9M";
const skeletonColumn = "week-calendar-module_skeletonColumn__gsZtJ";
const skeletonCell = "week-calendar-module_skeletonCell__BnsGX";
const skeletonHeader = "week-calendar-module_skeletonHeader__vq-Bh";
const visuallyHidden = "week-calendar-module_visuallyHidden__2TAZ3";
const styles$a = {
  root: root$1,
  scroll,
  viewport: viewport$1,
  grid,
  withSecondaryZone,
  gutterHead,
  dayHeaders,
  dayHeader,
  dayName: dayName$1,
  dayDate,
  gutterBody,
  hourLabel,
  daysArea,
  dayCards,
  dayCard,
  dayBody,
  hourLine,
  outsideHours,
  elapsedWash,
  hold,
  busyEvent,
  busyEventTitle,
  busyEventTime,
  hitLayer,
  hitRow,
  hitCell,
  suppressed,
  busy,
  elapsed,
  chosenLayer,
  chosenDay,
  chosenBlock,
  overBusy,
  removeButton,
  chosenLabelRow,
  chosenTime,
  overBusyMarker,
  chosenSublabel,
  legend,
  legendItem,
  legendWarn,
  legendSwatch,
  picked,
  free,
  outsideHoursSwatch,
  elapsedSwatch,
  overBusySwatch,
  holdSwatch,
  skeletonGrid,
  skeletonColumn,
  skeletonCell,
  skeletonHeader,
  visuallyHidden
};
const SUBLABEL_MIN_HEIGHT = 34;
function WeekCalendarChosenLayer() {
  const { days, dayStartMin, resolutionMins, effectiveBlocks, clearBlock } = useWeekCalendarContext();
  const px = (min2) => minutesToPx(min2, dayStartMin, resolutionMins);
  return /* @__PURE__ */ jsx$1("div", { className: styles$a.chosenLayer, children: days.map((day2) => /* @__PURE__ */ jsx$1("div", { className: styles$a.chosenDay, children: effectiveBlocks.filter((block) => block.dayId === day2.id).map((block) => {
    const range2 = formatTimeRange(block.startMin, block.endMin);
    const label2 = block.label || range2;
    const sublabel = block.overBusy ? "Over busy time" : block.sublabel;
    const height = px(block.endMin) - px(block.startMin) - 1;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: clsx(
          styles$a.chosenBlock,
          block.overBusy && styles$a.overBusy
        ),
        style: { top: px(block.startMin), height },
        title: label2,
        "data-testid": `week-calendar-block-${block.id}`,
        children: [
          /* @__PURE__ */ jsxs("span", { className: styles$a.chosenLabelRow, children: [
            /* @__PURE__ */ jsxs("span", { "aria-hidden": "true", className: styles$a.chosenTime, children: [
              block.overBusy && /* @__PURE__ */ jsx$1("span", { className: styles$a.overBusyMarker, children: "!" }),
              label2
            ] }),
            /* @__PURE__ */ jsx$1(
              "button",
              {
                type: "button",
                className: styles$a.removeButton,
                "aria-label": `Remove ${day2.label} ${day2.dateLabel}, ${range2}`,
                "data-testid": `week-calendar-remove-${block.id}`,
                onClick: () => clearBlock(block),
                children: "×"
              }
            )
          ] }),
          sublabel && height >= SUBLABEL_MIN_HEIGHT && /* @__PURE__ */ jsx$1("span", { "aria-hidden": "true", className: styles$a.chosenSublabel, children: sublabel })
        ]
      },
      block.id
    );
  }) }, day2.id)) });
}
WeekCalendarChosenLayer.displayName = "WeekCalendar.ChosenLayer";
function WeekCalendarDayCard({ day: day2 }) {
  const {
    dayStartMin,
    dayEndMin,
    workStartMin,
    workEndMin,
    resolutionMins,
    showEventTitles
  } = useWeekCalendarContext();
  const px = (min2) => minutesToPx(min2, dayStartMin, resolutionMins);
  const interiorHours = hourMarks(dayStartMin, dayEndMin).filter(
    (mark) => mark > dayStartMin && mark < dayEndMin
  );
  const elapsed2 = elapsedRangeOf(day2, { dayStartMin, dayEndMin });
  return /* @__PURE__ */ jsx$1("div", { className: styles$a.dayCard, "data-testid": `week-calendar-day-${day2.id}`, children: /* @__PURE__ */ jsxs("div", { className: styles$a.dayBody, "aria-hidden": "true", children: [
    outsideHoursOf(day2, {
      dayStartMin,
      dayEndMin,
      workStartMin,
      workEndMin
    }).map((range2) => /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$a.outsideHours,
        style: {
          top: px(range2.startMin),
          height: px(range2.endMin) - px(range2.startMin)
        },
        "data-testid": `week-calendar-outside-hours-${day2.id}-${range2.startMin}`
      },
      range2.startMin
    )),
    elapsed2 && /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$a.elapsedWash,
        style: {
          top: px(elapsed2.startMin),
          height: px(elapsed2.endMin) - px(elapsed2.startMin)
        },
        "data-testid": `week-calendar-elapsed-${day2.id}`
      }
    ),
    interiorHours.map((mark) => /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$a.hourLine,
        style: { top: px(mark) }
      },
      mark
    )),
    (day2.holds || []).filter(
      (hold2) => hold2.endMin > dayStartMin && hold2.startMin < dayEndMin
    ).map((hold2) => /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$a.hold,
        style: {
          top: px(Math.max(hold2.startMin, dayStartMin)),
          height: px(Math.min(hold2.endMin, dayEndMin)) - px(Math.max(hold2.startMin, dayStartMin))
        },
        "data-testid": `week-calendar-hold-${hold2.id}`
      },
      hold2.id
    )),
    laneEvents(day2.events || []).filter(
      ({ event }) => event.endMin > dayStartMin && event.startMin < dayEndMin
    ).map(({ event, laneIndex, laneCount }) => {
      const title2 = eventLabel(event, showEventTitles);
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: styles$a.busyEvent,
          style: {
            top: px(Math.max(event.startMin, dayStartMin)),
            height: Math.max(
              WEEK_CALENDAR_ROW_HEIGHT - 2,
              px(Math.min(event.endMin, dayEndMin)) - px(Math.max(event.startMin, dayStartMin))
            ),
            left: `${laneIndex / laneCount * 100}%`,
            width: `${1 / laneCount * 100}%`,
            ["--wc-owner-color"]: event.color,
            ["--wc-owner-bg"]: event.background
          },
          title: title2,
          "data-testid": `week-calendar-event-${event.id}`,
          children: [
            /* @__PURE__ */ jsx$1("span", { className: styles$a.busyEventTitle, children: title2 }),
            event.endMin - event.startMin >= 60 && /* @__PURE__ */ jsx$1("span", { className: styles$a.busyEventTime, children: formatTimeRange(event.startMin, event.endMin) })
          ]
        },
        event.id
      );
    })
  ] }) });
}
WeekCalendarDayCard.displayName = "WeekCalendar.DayCard";
function WeekCalendarGutter({
  offsetMinutes = 0
}) {
  const { dayStartMin, dayEndMin, resolutionMins } = useWeekCalendarContext();
  return /* @__PURE__ */ jsx$1("div", { className: styles$a.gutterBody, "aria-hidden": "true", children: hourMarks(dayStartMin, dayEndMin).map((mark) => /* @__PURE__ */ jsx$1(
    "div",
    {
      className: styles$a.hourLabel,
      style: { top: minutesToPx(mark, dayStartMin, resolutionMins) },
      children: minutesToLabel(shiftMinutes(mark, offsetMinutes))
    },
    mark
  )) });
}
WeekCalendarGutter.displayName = "WeekCalendar.Gutter";
function WeekCalendarHitCell({
  day: day2,
  startMin,
  colIndex
}) {
  const {
    weekKey,
    dayEndMin,
    resolutionMins,
    slotMins,
    showEventTitles,
    primaryZone,
    secondaryZone,
    selectedCells,
    blockAt,
    focusedCellId,
    registerCell,
    onCellFocus,
    onCellPointerDown,
    onCellPointerEnter,
    onCellPointerLeave
  } = useWeekCalendarContext();
  const cellId = makeCellId(weekKey, day2.id, startMin);
  const busyEvents = eventsAtCell(day2, startMin, resolutionMins);
  const busy2 = busyEvents.length > 0;
  const elapsed2 = isElapsedStart(day2, startMin);
  const suppressed2 = !isSelectableStart(
    startMin,
    slotMins,
    dayEndMin,
    day2.elapsedUntilMin
  );
  const tooLate = suppressed2 && !elapsed2;
  const selected2 = selectedCells.has(cellId) || blockAt(day2.id, startMin) !== void 0;
  const onlyOutsideHours = busy2 && busyEvents.every((e3) => e3.kind === "outsideHours");
  const busyTooltip = busy2 ? showEventTitles ? busyEvents.map(
    (e3) => `${e3.ownerLabel ? `${e3.ownerLabel} — ` : ""}${eventLabel(
      e3,
      showEventTitles
    )} (${formatTimeRange(e3.startMin, e3.endMin)})`
  ).join("\n") : onlyOutsideHours ? elapsed2 ? OUTSIDE_HOURS_LABEL : `${OUTSIDE_HOURS_LABEL} — offering this time falls outside their assumed working hours` : elapsed2 ? "Busy" : "Busy — offering this time books over an existing event" : void 0;
  const tooltipContent = tooLate ? tooLateLabel(slotMins) : busyTooltip;
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      role: "gridcell",
      "aria-colindex": colIndex + 1,
      "aria-selected": suppressed2 ? void 0 : selected2,
      "aria-disabled": suppressed2 ? true : void 0,
      "aria-label": cellAriaLabel({
        day: day2,
        startMin,
        selected: selected2,
        busy: busy2,
        elapsed: elapsed2,
        tooLate,
        primaryZone,
        secondaryZone
      }),
      tabIndex: cellId === focusedCellId ? 0 : -1,
      ref: (el) => registerCell(cellId, el),
      className: clsx(
        styles$a.hitCell,
        busy2 && styles$a.busy,
        suppressed2 && styles$a.suppressed,
        elapsed2 && styles$a.elapsed
      ),
      "data-testid": `week-calendar-cell-${day2.id}-${startMin}`,
      "data-cell-id": cellId,
      "data-tooltip-content": tooltipContent,
      onFocus: () => onCellFocus(cellId),
      onPointerDown: (event) => onCellPointerDown(cellId, event),
      onPointerEnter: () => onCellPointerEnter(cellId),
      onPointerLeave: () => onCellPointerLeave(cellId)
    }
  );
}
WeekCalendarHitCell.displayName = "WeekCalendar.HitCell";
function WeekCalendarHitGrid({ ariaLabel }) {
  const { days, dayStartMin, dayEndMin, resolutionMins, onGridKeyDown } = useWeekCalendarContext();
  const starts = rowStarts(dayStartMin, dayEndMin, resolutionMins);
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      role: "grid",
      "aria-label": ariaLabel,
      "aria-multiselectable": "true",
      "aria-rowcount": starts.length,
      "aria-colcount": days.length,
      className: styles$a.hitLayer,
      "data-testid": "week-calendar-grid",
      onKeyDown: onGridKeyDown,
      children: starts.map((startMin, rowIndex) => /* @__PURE__ */ jsx$1(
        "div",
        {
          role: "row",
          "aria-rowindex": rowIndex + 1,
          className: styles$a.hitRow,
          children: days.map((day2, colIndex) => /* @__PURE__ */ jsx$1(
            WeekCalendarHitCell,
            {
              day: day2,
              startMin,
              colIndex
            },
            day2.id
          ))
        },
        startMin
      ))
    }
  );
}
WeekCalendarHitGrid.displayName = "WeekCalendar.HitGrid";
function WeekCalendarLegend({ legend: legend2 }) {
  const {
    days,
    dayStartMin,
    dayEndMin,
    workStartMin,
    workEndMin,
    effectiveBlocks
  } = useWeekCalendarContext();
  const anyOverBusy = effectiveBlocks.some((b3) => b3.overBusy);
  const anyHolds = days.some((d4) => (d4.holds || []).length > 0);
  const hasWash = days.some(
    (day2) => outsideHoursOf(day2, { dayStartMin, dayEndMin, workStartMin, workEndMin }).length > 0
  );
  const anyElapsed = days.some(
    (day2) => elapsedRangeOf(day2, { dayStartMin, dayEndMin }) !== null
  );
  return /* @__PURE__ */ jsxs("ul", { className: styles$a.legend, "data-testid": "week-calendar-legend", children: [
    /* @__PURE__ */ jsxs("li", { className: styles$a.legendItem, children: [
      /* @__PURE__ */ jsx$1("span", { className: clsx(styles$a.legendSwatch, styles$a.picked) }),
      legend2?.pickedLabel || "Chosen"
    ] }),
    /* @__PURE__ */ jsxs("li", { className: styles$a.legendItem, children: [
      /* @__PURE__ */ jsx$1("span", { className: clsx(styles$a.legendSwatch, styles$a.free) }),
      legend2?.freeLabel || "Free"
    ] }),
    (legend2?.people || []).map((person) => /* @__PURE__ */ jsxs("li", { className: styles$a.legendItem, children: [
      /* @__PURE__ */ jsx$1(
        "span",
        {
          className: styles$a.legendSwatch,
          style: {
            background: person.background || person.color,
            borderLeft: `3px solid ${person.color}`
          }
        }
      ),
      person.label
    ] }, person.id)),
    hasWash && /* @__PURE__ */ jsxs("li", { className: styles$a.legendItem, children: [
      /* @__PURE__ */ jsx$1(
        "span",
        {
          className: clsx(styles$a.legendSwatch, styles$a.outsideHoursSwatch)
        }
      ),
      legend2?.outsideHoursLabel || "Outside working hours"
    ] }),
    anyElapsed && /* @__PURE__ */ jsxs(
      "li",
      {
        className: styles$a.legendItem,
        "data-testid": "week-calendar-legend-elapsed",
        children: [
          /* @__PURE__ */ jsx$1("span", { className: clsx(styles$a.legendSwatch, styles$a.elapsedSwatch) }),
          legend2?.elapsedLabel || "Already passed"
        ]
      }
    ),
    anyHolds && /* @__PURE__ */ jsxs("li", { className: styles$a.legendItem, children: [
      /* @__PURE__ */ jsx$1("span", { className: clsx(styles$a.legendSwatch, styles$a.holdSwatch) }),
      legend2?.holdLabel || "Held for another candidate"
    ] }),
    anyOverBusy && /* @__PURE__ */ jsxs(
      "li",
      {
        className: clsx(styles$a.legendItem, styles$a.legendWarn),
        "data-testid": "week-calendar-legend-over-busy",
        children: [
          /* @__PURE__ */ jsx$1("span", { className: clsx(styles$a.legendSwatch, styles$a.overBusySwatch) }),
          legend2?.overBusyLabel || "Offered over busy time"
        ]
      }
    )
  ] });
}
WeekCalendarLegend.displayName = "WeekCalendar.Legend";
function WeekCalendarSkeleton({
  dayCount,
  rowCount
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-busy": "true",
      className: styles$a.skeletonGrid,
      style: { ["--wc-days"]: dayCount },
      "data-testid": "week-calendar-skeleton",
      children: [
        /* @__PURE__ */ jsx$1("span", { className: styles$a.visuallyHidden, children: "Loading calendar" }),
        /* @__PURE__ */ jsxs("div", { "aria-hidden": "true", className: styles$a.skeletonColumn, children: [
          /* @__PURE__ */ jsx$1("div", { className: clsx(styles$a.skeletonCell, styles$a.skeletonHeader) }),
          Array.from({ length: Math.ceil(rowCount / 2) }, (_2, i3) => /* @__PURE__ */ jsx$1("div", { className: styles$a.skeletonCell }, i3))
        ] }),
        Array.from({ length: dayCount }, (_2, day2) => /* @__PURE__ */ jsxs("div", { "aria-hidden": "true", className: styles$a.skeletonColumn, children: [
          /* @__PURE__ */ jsx$1("div", { className: clsx(styles$a.skeletonCell, styles$a.skeletonHeader) }),
          Array.from({ length: Math.ceil(rowCount / 2) }, (_22, i3) => /* @__PURE__ */ jsx$1("div", { className: styles$a.skeletonCell }, i3))
        ] }, day2))
      ]
    }
  );
}
WeekCalendarSkeleton.displayName = "WeekCalendar.Skeleton";
const RESOLUTIONS = [15, 30];
function WeekCalendar({
  days,
  weekKey,
  value: value2,
  onChange: onChange2,
  blocks,
  onClearBlock,
  dayStartMin = 480,
  dayEndMin = 1080,
  workStartMin = 540,
  workEndMin = 1020,
  slotMins: slotMinsProp,
  resolutionMins: resolutionMinsProp,
  viewport: viewport2,
  primaryZone,
  secondaryZone,
  showEventTitles = false,
  loading: loading2 = false,
  legend: legend2,
  ariaLabel = "Week calendar",
  className,
  dataTestid = "week-calendar"
}) {
  const resolutionMins = resolutionMinsProp && RESOLUTIONS.includes(resolutionMinsProp) ? resolutionMinsProp : 30;
  const slotMins = slotMinsProp ?? resolutionMins;
  const blocksMode = blocks !== void 0;
  const rows = rowStarts(dayStartMin, dayEndMin, resolutionMins);
  const visibleRows = viewport2 ? viewportRowCount(viewport2, resolutionMins) : rows.length;
  const tooltipUid = useId$2();
  const scrollRef = useRef(null);
  const viewportStartMin = viewport2?.startMin;
  useLayoutEffect$1(() => {
    if (loading2 || viewportStartMin === void 0 || !scrollRef.current) {
      return;
    }
    scrollRef.current.scrollTop = minutesToPx(
      viewportStartMin,
      dayStartMin,
      resolutionMins
    );
  }, [loading2, viewportStartMin, dayStartMin, resolutionMins]);
  useEffect(() => {
    if (resolutionMinsProp && !RESOLUTIONS.includes(resolutionMinsProp)) {
      console.warn(
        `${WARN_PREFIX} unknown resolution ${resolutionMinsProp} — falling back to 30. Only 30 and 15 exist.`
      );
    }
  }, [resolutionMinsProp]);
  useEffect(() => {
    if (blocksMode && !onClearBlock) {
      console.warn(
        `${WARN_PREFIX} \`blocks\` was supplied without \`onClearBlock\` — chosen blocks will not be removable.`
      );
    }
  }, [blocksMode, onClearBlock]);
  const selectedCells = useMemo(() => new Set(value2), [value2]);
  const effectiveBlocks = useMemo(
    () => blocks ?? mergeRuns({ cellIds: value2, weekKey, days, resolutionMins }),
    [blocks, value2, weekKey, days, resolutionMins]
  );
  const blockAt = useCallback(
    (dayId, startMin) => effectiveBlocks.find(
      (b3) => b3.dayId === dayId && startMin >= b3.startMin && startMin < b3.endMin
    ),
    [effectiveBlocks]
  );
  const canPick = (dayId, startMin) => isSelectableStart(
    startMin,
    slotMins,
    dayEndMin,
    days.find((d4) => d4.id === dayId)?.elapsedUntilMin
  );
  const [focusedCell, setFocusedCell] = useState(null);
  const cellRefs = useRef(/* @__PURE__ */ new Map());
  const isValidCell = (cellId) => {
    const parsed = parseCellId(cellId);
    return !!parsed && parsed.weekKey === weekKey && days.some((d4) => d4.id === parsed.dayId) && rows.includes(parsed.startMin);
  };
  const defaultCell = days.length > 0 && rows.length > 0 ? makeCellId(weekKey, days[0].id, rows[0]) : "";
  const focusedCellId = focusedCell && isValidCell(focusedCell) ? focusedCell : defaultCell;
  const registerCell = useCallback((cellId, el) => {
    if (el) {
      cellRefs.current.set(cellId, el);
    } else {
      cellRefs.current.delete(cellId);
    }
  }, []);
  const isCellSelected = (cellId) => {
    if (selectedCells.has(cellId)) {
      return true;
    }
    const parsed = parseCellId(cellId);
    return !!parsed && parsed.weekKey === weekKey && blockAt(parsed.dayId, parsed.startMin) !== void 0;
  };
  const clearBlock = (block) => {
    if (blocksMode) {
      onClearBlock?.(block.id);
      return;
    }
    onChange2(
      value2.filter((id) => {
        const parsed = parseCellId(id);
        return !parsed || parsed.weekKey !== weekKey || parsed.dayId !== block.dayId || parsed.startMin < block.startMin || parsed.startMin >= block.endMin;
      })
    );
  };
  const toggleCell = (cellId) => {
    const parsed = parseCellId(cellId);
    if (!parsed || !isValidCell(cellId)) {
      return;
    }
    if (!canPick(parsed.dayId, parsed.startMin)) {
      return;
    }
    const block = blockAt(parsed.dayId, parsed.startMin);
    if (block) {
      clearBlock(block);
      return;
    }
    if (selectedCells.has(cellId)) {
      onChange2(value2.filter((id) => id !== cellId));
    } else {
      onChange2([...value2, cellId]);
    }
  };
  const toggleCellRef = useRef(toggleCell);
  toggleCellRef.current = toggleCell;
  const dragRef = useRef(null);
  const windowListenersRef = useRef(null);
  const detachWindowListeners = useCallback(() => {
    const listeners = windowListenersRef.current;
    if (listeners) {
      window.removeEventListener("pointerup", listeners.up);
      window.removeEventListener("blur", listeners.blur);
      windowListenersRef.current = null;
    }
  }, []);
  const attachWindowListeners = useCallback(() => {
    if (windowListenersRef.current) {
      return;
    }
    const up = () => {
      const drag2 = dragRef.current;
      if (drag2 && drag2.mode === "remove" && !drag2.moved) {
        toggleCellRef.current(drag2.startCell);
      }
      dragRef.current = null;
      detachWindowListeners();
    };
    const blur = () => {
      dragRef.current = null;
      detachWindowListeners();
    };
    windowListenersRef.current = { up, blur };
    window.addEventListener("pointerup", up);
    window.addEventListener("blur", blur);
  }, [detachWindowListeners]);
  useEffect(() => detachWindowListeners, [detachWindowListeners]);
  const applyCellToDrag = (drag2, cellId) => {
    const parsed = parseCellId(cellId);
    if (!parsed || !canPick(parsed.dayId, parsed.startMin)) {
      return false;
    }
    if (drag2.mode === "add") {
      if (drag2.paint.has(cellId)) {
        return false;
      }
      drag2.paint.add(cellId);
      return true;
    }
    const block = blocksMode ? blockAt(parsed.dayId, parsed.startMin) : void 0;
    if (block) {
      if (!drag2.clearedBlocks.has(block.id)) {
        drag2.clearedBlocks.add(block.id);
        onClearBlock?.(block.id);
      }
      let changed = false;
      drag2.paint.forEach((id) => {
        const p2 = parseCellId(id);
        if (p2 && p2.weekKey === weekKey && p2.dayId === block.dayId && p2.startMin >= block.startMin && p2.startMin < block.endMin) {
          drag2.paint.delete(id);
          changed = true;
        }
      });
      return changed;
    }
    if (drag2.paint.has(cellId)) {
      drag2.paint.delete(cellId);
      return true;
    }
    return false;
  };
  const commitDrag = (drag2) => {
    onChange2([...drag2.paint]);
  };
  const onCellPointerDown = (cellId, event) => {
    if (event.button !== 0) {
      return;
    }
    const parsed = parseCellId(cellId);
    if (!parsed || !canPick(parsed.dayId, parsed.startMin)) {
      return;
    }
    setFocusedCell(cellId);
    const drag2 = {
      mode: isCellSelected(cellId) ? "remove" : "add",
      startCell: cellId,
      lastCell: cellId,
      moved: false,
      paint: new Set(value2),
      clearedBlocks: /* @__PURE__ */ new Set()
    };
    dragRef.current = drag2;
    attachWindowListeners();
    if (drag2.mode === "add") {
      if (applyCellToDrag(drag2, cellId)) {
        commitDrag(drag2);
      }
    }
  };
  const onCellPointerEnter = (cellId) => {
    const drag2 = dragRef.current;
    if (!drag2 || cellId === drag2.lastCell) {
      return;
    }
    let changed = false;
    if (!drag2.moved) {
      drag2.moved = true;
      if (drag2.mode === "remove") {
        changed = applyCellToDrag(drag2, drag2.startCell) || changed;
      }
    }
    const from2 = parseCellId(drag2.lastCell);
    const to = parseCellId(cellId);
    if (from2 && to && from2.dayId === to.dayId && from2.weekKey === to.weekKey) {
      const step = to.startMin > from2.startMin ? resolutionMins : -resolutionMins;
      for (let m4 = from2.startMin + step; step > 0 ? m4 <= to.startMin : m4 >= to.startMin; m4 += step) {
        changed = applyCellToDrag(drag2, makeCellId(weekKey, to.dayId, m4)) || changed;
      }
    } else {
      changed = applyCellToDrag(drag2, cellId) || changed;
    }
    drag2.lastCell = cellId;
    if (changed) {
      commitDrag(drag2);
    }
  };
  const onCellPointerLeave = (cellId) => {
    const drag2 = dragRef.current;
    if (!drag2 || drag2.moved || cellId !== drag2.startCell) {
      return;
    }
    drag2.moved = true;
    if (drag2.mode === "remove" && applyCellToDrag(drag2, drag2.startCell)) {
      commitDrag(drag2);
    }
  };
  const onCellFocus = (cellId) => {
    setFocusedCell(cellId);
  };
  const onGridKeyDown = (event) => {
    const targetCell = event.target.closest?.(
      "[data-cell-id]"
    );
    const currentCellId = targetCell?.getAttribute("data-cell-id") || focusedCellId;
    const parsed = parseCellId(currentCellId);
    if (!parsed) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleCell(currentCellId);
      return;
    }
    const dayIndex = days.findIndex((d4) => d4.id === parsed.dayId);
    const rowIndex = rows.indexOf(parsed.startMin);
    if (dayIndex === -1 || rowIndex === -1) {
      return;
    }
    let nextDay = dayIndex;
    let nextRow = rowIndex;
    switch (event.key) {
      case "ArrowDown":
        nextRow = Math.min(rowIndex + 1, rows.length - 1);
        break;
      case "ArrowUp":
        nextRow = Math.max(rowIndex - 1, 0);
        break;
      case "ArrowRight":
        nextDay = Math.min(dayIndex + 1, days.length - 1);
        break;
      case "ArrowLeft":
        nextDay = Math.max(dayIndex - 1, 0);
        break;
      case "Home":
        nextDay = 0;
        if (event.ctrlKey) {
          nextRow = 0;
        }
        break;
      case "End":
        nextDay = days.length - 1;
        if (event.ctrlKey) {
          nextRow = rows.length - 1;
        }
        break;
      default:
        return;
    }
    event.preventDefault();
    const nextId = makeCellId(weekKey, days[nextDay].id, rows[nextRow]);
    if (nextId !== currentCellId) {
      setFocusedCell(nextId);
      cellRefs.current.get(nextId)?.focus();
    }
  };
  const context = {
    weekKey,
    days,
    dayStartMin,
    dayEndMin,
    workStartMin,
    workEndMin,
    resolutionMins,
    slotMins,
    showEventTitles,
    primaryZone,
    secondaryZone,
    selectedCells,
    effectiveBlocks,
    blockAt,
    focusedCellId,
    registerCell,
    onCellFocus,
    onCellPointerDown,
    onCellPointerEnter,
    onCellPointerLeave,
    onGridKeyDown,
    clearBlock,
    tooltipUid
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(styles$a.root, className),
      "data-testid": dataTestid,
      "data-wc-uid": tooltipUid,
      children: /* @__PURE__ */ jsx$1(WeekCalendarContext.Provider, { value: context, children: loading2 ? /* @__PURE__ */ jsx$1("div", { className: styles$a.scroll, children: /* @__PURE__ */ jsx$1(
        WeekCalendarSkeleton,
        {
          dayCount: days.length || 5,
          rowCount: visibleRows
        }
      ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(
          "div",
          {
            ref: scrollRef,
            className: clsx(styles$a.scroll, viewport2 && styles$a.viewport),
            style: { ["--wc-viewport-rows"]: visibleRows },
            "data-testid": `${dataTestid}-scroll`,
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                className: clsx(
                  styles$a.grid,
                  secondaryZone && styles$a.withSecondaryZone
                ),
                style: {
                  ["--wc-days"]: days.length,
                  ["--wc-rows"]: rows.length
                },
                children: [
                  /* @__PURE__ */ jsx$1("div", { className: styles$a.gutterHead, "aria-hidden": "true", children: primaryZone?.label }),
                  secondaryZone && /* @__PURE__ */ jsx$1("div", { className: styles$a.gutterHead, "aria-hidden": "true", children: secondaryZone.label }),
                  /* @__PURE__ */ jsx$1("div", { className: styles$a.dayHeaders, children: days.map((day2) => /* @__PURE__ */ jsxs("div", { className: styles$a.dayHeader, children: [
                    /* @__PURE__ */ jsx$1("span", { className: styles$a.dayName, children: day2.label }),
                    /* @__PURE__ */ jsx$1("span", { className: styles$a.dayDate, children: day2.dateLabel })
                  ] }, day2.id)) }),
                  /* @__PURE__ */ jsx$1(WeekCalendarGutter, {}),
                  secondaryZone && /* @__PURE__ */ jsx$1(
                    WeekCalendarGutter,
                    {
                      offsetMinutes: secondaryZone.offsetMinutes
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { className: styles$a.daysArea, children: [
                    /* @__PURE__ */ jsx$1("div", { className: styles$a.dayCards, children: days.map((day2) => /* @__PURE__ */ jsx$1(WeekCalendarDayCard, { day: day2 }, day2.id)) }),
                    /* @__PURE__ */ jsx$1(WeekCalendarHitGrid, { ariaLabel }),
                    /* @__PURE__ */ jsx$1(WeekCalendarChosenLayer, {})
                  ] })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1(WeekCalendarLegend, { legend: legend2 }),
        /* @__PURE__ */ jsx$1(
          Tooltip$3,
          {
            anchorSelect: `[data-wc-uid="${tooltipUid}"] [data-tooltip-content]`,
            place: "top",
            dataTestid: "week-calendar-tooltip",
            render: ({ activeAnchor }) => activeAnchor ? activeAnchor.getAttribute("data-tooltip-content") : null
          }
        )
      ] }) })
    }
  );
}
WeekCalendar.displayName = "WeekCalendar";
var ActorRole = /* @__PURE__ */ ((ActorRole2) => {
  ActorRole2["AssessorOrInterviewer"] = "ASSESSOR_OR_INTERVIEWER";
  ActorRole2["EarlyCareerTeamMember"] = "EARLY_CAREER_TEAM_MEMBER";
  ActorRole2["HeadOfPeopleOrTalent"] = "HEAD_OF_PEOPLE_OR_TALENT";
  ActorRole2["HiringManager"] = "HIRING_MANAGER";
  ActorRole2["Interviewer"] = "INTERVIEWER";
  ActorRole2["LineManager"] = "LINE_MANAGER";
  ActorRole2["RecruiterOrTalentAcquisitionPartner"] = "RECRUITER_OR_TALENT_ACQUISITION_PARTNER";
  ActorRole2["ReskillingTeamMember"] = "RESKILLING_TEAM_MEMBER";
  return ActorRole2;
})(ActorRole || {});
var ProductSolution = /* @__PURE__ */ ((ProductSolution2) => {
  ProductSolution2["EarlyCareerHiring"] = "EARLY_CAREER_HIRING";
  ProductSolution2["Learning"] = "LEARNING";
  ProductSolution2["ProfessionalHiring"] = "PROFESSIONAL_HIRING";
  ProductSolution2["Reskilling"] = "RESKILLING";
  ProductSolution2["SuccessionPlanning"] = "SUCCESSION_PLANNING";
  ProductSolution2["VolumeHiring"] = "VOLUME_HIRING";
  return ProductSolution2;
})(ProductSolution || {});
var AnalyticsCustomEvents = /* @__PURE__ */ ((AnalyticsCustomEvents2) => {
  AnalyticsCustomEvents2["UTM_PARAMS"] = "utm-params";
  return AnalyticsCustomEvents2;
})(AnalyticsCustomEvents || {});
const DEBOUNCE_KEYSTROKE_EVENT = 5e3;
const actorRolesAcrossSolutions = [
  {
    actorRole: "HIRING_MANAGER",
    productSolution: "PROFESSIONAL_HIRING"
    /* ProfessionalHiring */
  },
  {
    actorRole: "HEAD_OF_PEOPLE_OR_TALENT",
    productSolution: "PROFESSIONAL_HIRING"
    /* ProfessionalHiring */
  },
  {
    actorRole: "RECRUITER_OR_TALENT_ACQUISITION_PARTNER",
    productSolution: "PROFESSIONAL_HIRING"
    /* ProfessionalHiring */
  },
  {
    actorRole: "INTERVIEWER",
    productSolution: "PROFESSIONAL_HIRING"
    /* ProfessionalHiring */
  },
  {
    actorRole: "RESKILLING_TEAM_MEMBER",
    productSolution: "RESKILLING"
    /* Reskilling */
  },
  {
    actorRole: "HIRING_MANAGER",
    productSolution: "RESKILLING"
    /* Reskilling */
  },
  {
    actorRole: "LINE_MANAGER",
    productSolution: "RESKILLING"
    /* Reskilling */
  },
  {
    actorRole: "EARLY_CAREER_TEAM_MEMBER",
    productSolution: "EARLY_CAREER_HIRING"
    /* EarlyCareerHiring */
  },
  {
    actorRole: "ASSESSOR_OR_INTERVIEWER",
    productSolution: "EARLY_CAREER_HIRING"
    /* EarlyCareerHiring */
  },
  {
    actorRole: "HEAD_OF_PEOPLE_OR_TALENT",
    productSolution: "EARLY_CAREER_HIRING"
    /* EarlyCareerHiring */
  }
];
const ALLOWED_UTM_PARAMS = [
  "utm_id",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content"
];
const defaultProjectUserRoleProperties = actorRolesAcrossSolutions.reduce(
  (defaults, { actorRole, productSolution }) => {
    defaults[`${actorRole}-${productSolution}`] = false;
    return defaults;
  },
  {}
);
const TRACK_EVENT_DEFAULT_DELAY = 5e3;
const debouncedEventTrackers = {};
class HeapAnalyticsClient {
  async setAnalyticsContext({
    user,
    projectUsers,
    includeActorRoleProperties = true,
    includeUserRoleProperties = true,
    appName
  }) {
    try {
      heap.identify(user.subId);
      const heapUserProperties = {
        isInternalUser: user.isInternal,
        ...includeUserRoleProperties && this._getUserRoleProperties(user.roles),
        ...includeActorRoleProperties && this._getProjectUserRoleProperties(projectUsers),
        ...appName && { app_name: appName }
      };
      heap.addUserProperties(heapUserProperties);
      if (appName) {
        heap.addEventProperties({ app_name: appName });
      }
    } catch (error2) {
      console.error(
        "[AnalyticsClient] Error setting analytics context:",
        error2
      );
    }
  }
  trackUTMParams() {
    const queryParams = new URLSearchParams(window.location.search);
    let UTMParams = {};
    queryParams.forEach((value2, key) => {
      if (ALLOWED_UTM_PARAMS.includes(key)) {
        UTMParams[key] = value2;
      }
    });
    if (!lodashExports.isEmpty(UTMParams)) {
      this.trackEvent({
        name: "utm-params",
        properties: UTMParams
      });
    }
  }
  async trackEvent({
    name: name2,
    properties,
    options: options2
  }) {
    try {
      if (!options2) {
        heap.track(name2, properties);
        return;
      }
      const delay = options2.delay === true ? TRACK_EVENT_DEFAULT_DELAY : options2.delay;
      if (!debouncedEventTrackers[name2] || debouncedEventTrackers[name2].delay !== delay) {
        debouncedEventTrackers[name2] = {
          debouncedFunc: lodashExports.debounce(() => heap.track(name2, properties), delay),
          delay
        };
      }
      debouncedEventTrackers[name2].debouncedFunc();
    } catch (error2) {
      console.error("[AnalyticsClient] Error tracking analytics event:", error2);
    }
  }
  async clearEventProperties() {
    try {
      heap.clearEventProperties();
    } catch (error2) {
      console.error(
        "[AnalyticsClient] Error clearing analytics event properties:",
        error2
      );
    }
  }
  async resetIdentity() {
    try {
      heap.resetIdentity();
    } catch (error2) {
      console.error("[AnalyticsClient] Error reseting identity:", error2);
    }
  }
  async addEventProperties(properties) {
    try {
      heap.clearEventProperties();
      heap.addEventProperties(properties);
    } catch (error2) {
      console.error(
        "[AnalyticsClient] Error adding analytics event properties:",
        error2
      );
    }
  }
  _getUserRoleProperties(userRoles) {
    return userRoles.reduce((acc, { companyRole }, index2) => {
      acc[`roleName-${index2}`] = lodashExports.kebabCase(companyRole.role.name);
      acc[`companyUuid-${index2}`] = companyRole.companyUuid;
      return acc;
    }, {});
  }
  _getProjectUserRoleProperties(projectUsers) {
    if (!projectUsers) {
      return defaultProjectUserRoleProperties;
    }
    return actorRolesAcrossSolutions.reduce(
      (acc, { actorRole, productSolution }) => {
        const res = projectUsers.find(
          (projectUser) => projectUser.actorRole === actorRole && projectUser.project.productSolution === productSolution
        );
        acc[`${actorRole}-${productSolution}`] = Boolean(res);
        return acc;
      },
      { ...defaultProjectUserRoleProperties }
    );
  }
}
const analyticsClient = new HeapAnalyticsClient();
const AUTH_TOKEN = "auth_token";
const AUTHENTICATION_ROUTES = {
  login: "/auth/login",
  signUp: "/auth/sign-up",
  restorePassword: "/auth/restore-password",
  createPassword: "/auth/password-recovery",
  directInvitation: "/auth/direct-inv",
  indirectInvite: "/inv"
};
const AUTH_APP_ENDPOINTS = {
  [AUTHENTICATION_ROUTES.directInvitation]: "sign-up",
  [AUTHENTICATION_ROUTES.indirectInvite]: "sign-up",
  [AUTHENTICATION_ROUTES.login]: "",
  [AUTHENTICATION_ROUTES.signUp]: "sign-up",
  [AUTHENTICATION_ROUTES.restorePassword]: "reset-password",
  [AUTHENTICATION_ROUTES.createPassword]: "set-new-password"
  /* SET_NEW_PASSWORD */
};
function useAuthAppRedirect(options2) {
  const { authAppBaseUrl, pathname, search, clientType } = options2;
  const getAuthAppEndpoint = (language, pathname2) => {
    return "/" + language + "/" + (AUTH_APP_ENDPOINTS[pathname2] ?? "");
  };
  const getRedirectPath = (authRedirectUrl) => {
    return authRedirectUrl && authRedirectUrl !== "/" ? {
      redirect_path: authRedirectUrl
    } : {};
  };
  const getQueryParam = (search2, paramName) => {
    const queryParams = new URLSearchParams(search2);
    return queryParams.get(paramName);
  };
  const getIndirectInviteParams = (search2) => {
    const queryParams = { "indirect-inv": "true" };
    const urlParams = new URLSearchParams(search2);
    urlParams.forEach((value2, key) => queryParams[key] = value2);
    const authToken = localStorage.getItem(AUTH_TOKEN);
    if (authToken) {
      queryParams[AUTH_TOKEN] = authToken;
    }
    return queryParams;
  };
  const getRouteSpecificParams = (pathname2, authRedirectUrl) => {
    switch (pathname2) {
      case AUTHENTICATION_ROUTES.login:
        return getRedirectPath(authRedirectUrl);
      case AUTHENTICATION_ROUTES.createPassword:
        return {
          token: getQueryParam(search, "token") || ""
        };
      case AUTHENTICATION_ROUTES.directInvitation:
        return {
          "direct-inv": getQueryParam(search, "inv") || ""
        };
      case AUTHENTICATION_ROUTES.signUp:
      case AUTHENTICATION_ROUTES.indirectInvite:
        return getIndirectInviteParams(search);
    }
    return {};
  };
  const getLanguage = (pathname2, language) => {
    if (pathname2 === AUTHENTICATION_ROUTES.createPassword) {
      const locale2 = getQueryParam(search, "locale");
      if (locale2) {
        return locale2 === "en-gb" ? "en" : locale2;
      }
    }
    return language || "en";
  };
  const redirect = (clientType2, url, queryParams) => {
    if (url && clientType2) {
      const urlToRedirect = new URL(url);
      urlToRedirect.searchParams.append("redirect_app", clientType2);
      if (queryParams) {
        Object.keys(queryParams).forEach((key) => {
          urlToRedirect.searchParams.append(key, queryParams[key]);
        });
      }
      window.location.replace(urlToRedirect.toString());
    } else {
      console.error("Authentication App url is not set");
    }
  };
  const redirectToAuthApp = (language, authRedirectUrl) => {
    redirect(
      clientType,
      authAppBaseUrl + getAuthAppEndpoint(getLanguage(pathname, language), pathname),
      getRouteSpecificParams(pathname, authRedirectUrl)
    );
  };
  return redirectToAuthApp;
}
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["AFAR"] = "aa";
  Language2["AFRIKAANS"] = "af";
  Language2["AKAN"] = "ak";
  Language2["ALBANIAN"] = "sq";
  Language2["AMHARIC"] = "am";
  Language2["ARABIC"] = "ar";
  Language2["ARAGONESE"] = "an";
  Language2["ARMENIAN"] = "hy";
  Language2["ASSAMESE"] = "as";
  Language2["AVARIC"] = "av";
  Language2["AVESTAN"] = "ae";
  Language2["AYMARA"] = "ay";
  Language2["AZERBAIJANI"] = "az";
  Language2["BAMBARA"] = "bm";
  Language2["BASHKIR"] = "ba";
  Language2["BASQUE"] = "eu";
  Language2["BELARUSIAN"] = "be";
  Language2["BENGALI"] = "bn";
  Language2["BISLAMA"] = "bi";
  Language2["BOSNIAN"] = "bs";
  Language2["BRETON"] = "br";
  Language2["BULGARIAN"] = "bg";
  Language2["BURMESE"] = "my";
  Language2["CATALAN_VALENCIAN"] = "ca";
  Language2["CHAMORRO"] = "ch";
  Language2["CHECHEN"] = "ce";
  Language2["CHICHEWA_CHEWA_NYANJA"] = "ny";
  Language2["CHINESE"] = "zh";
  Language2["CHUVASH"] = "cv";
  Language2["CORNISH"] = "kw";
  Language2["CORSICAN"] = "co";
  Language2["CREE"] = "cr";
  Language2["CROATIAN"] = "hr";
  Language2["CZECH"] = "cs";
  Language2["DANISH"] = "da";
  Language2["DIVEHI_DHIVEHI_MALDIVIAN"] = "dv";
  Language2["DUTCH_FLEMISH"] = "nl";
  Language2["DZONGKHA"] = "dz";
  Language2["ENGLISH"] = "en";
  Language2["ESPERANTO"] = "eo";
  Language2["ESTONIAN"] = "et";
  Language2["EWE"] = "ee";
  Language2["FAROESE"] = "fo";
  Language2["FIJIAN"] = "fj";
  Language2["FINNISH"] = "fi";
  Language2["FRENCH"] = "fr";
  Language2["FULAH"] = "ff";
  Language2["GALICIAN"] = "gl";
  Language2["GEORGIAN"] = "ka";
  Language2["GERMAN"] = "de";
  Language2["GREEK_MODERN"] = "el";
  Language2["GUARANI"] = "gn";
  Language2["GUJARATI"] = "gu";
  Language2["HAITIAN"] = "ht";
  Language2["HAUSA"] = "ha";
  Language2["HEBREW"] = "he";
  Language2["HERERO"] = "hz";
  Language2["HINDI"] = "hi";
  Language2["HIRI_MOTU"] = "ho";
  Language2["HUNGARIAN"] = "hu";
  Language2["INTERLINGUA"] = "ia";
  Language2["INDONESIAN"] = "id";
  Language2["INTERLINGUE"] = "ie";
  Language2["IRISH"] = "ga";
  Language2["IGBO"] = "ig";
  Language2["INUPIAQ"] = "ik";
  Language2["IDO"] = "io";
  Language2["ICELANDIC"] = "is";
  Language2["ITALIAN"] = "it";
  Language2["INUKTITUT"] = "iu";
  Language2["JAPANESE"] = "ja";
  Language2["JAVANESE"] = "jv";
  Language2["KALAALLISUT_GREENLANDIC"] = "kl";
  Language2["KANNADA"] = "kn";
  Language2["KANURI"] = "kr";
  Language2["KASHMIRI"] = "ks";
  Language2["KAZAKH"] = "kk";
  Language2["CENTRAL_KHMER"] = "km";
  Language2["KIKUYU_GIKUYU"] = "ki";
  Language2["KINYARWANDA"] = "rw";
  Language2["KIRGHIZ_KYRGYZ"] = "ky";
  Language2["KOMI"] = "kv";
  Language2["KONGO"] = "kg";
  Language2["KOREAN"] = "ko";
  Language2["KURDISH"] = "ku";
  Language2["KUANYAMA_KWANYAMA"] = "kj";
  Language2["LATIN"] = "la";
  Language2["LUXEMBOURGISH_LETZEBURGESCH"] = "lb";
  Language2["GANDA"] = "lg";
  Language2["LIMBURGAN_LIMBURGER_LIMBURGISH"] = "li";
  Language2["LINGALA"] = "ln";
  Language2["LAO"] = "lo";
  Language2["LITHUANIAN"] = "lt";
  Language2["LUBA_KATANGA"] = "lu";
  Language2["LATVIAN"] = "lv";
  Language2["MANX"] = "gv";
  Language2["MACEDONIAN"] = "mk";
  Language2["MALAGASY"] = "mg";
  Language2["MALAY"] = "ms";
  Language2["MALAYALAM"] = "ml";
  Language2["MALTESE"] = "mt";
  Language2["MAORI"] = "mi";
  Language2["MARATHI"] = "mr";
  Language2["MARSHALLESE"] = "mh";
  Language2["MONGOLIAN"] = "mn";
  Language2["NAURU"] = "na";
  Language2["NAVAJO_NAVAHO"] = "nv";
  Language2["NORTH_NDEBELE"] = "nd";
  Language2["NEPALI"] = "ne";
  Language2["NDONGA"] = "ng";
  Language2["NORWEGIAN_BOKMAL"] = "nb";
  Language2["NORWEGIAN_NYNORSK"] = "nn";
  Language2["NORWEGIAN"] = "no";
  Language2["SICHUAN_YI_NUOSU"] = "ii";
  Language2["SOUTH_NDEBELE"] = "nr";
  Language2["OCCITAN"] = "oc";
  Language2["OJIBWA"] = "oj";
  Language2["OLD_SLAVONIC"] = "cu";
  Language2["OROMO"] = "om";
  Language2["ORIYA"] = "or";
  Language2["OSSETIAN_OSSETIC"] = "os";
  Language2["PUNJABI_PANJABI"] = "pa";
  Language2["PALI"] = "pi";
  Language2["PERSIAN"] = "fa";
  Language2["POLISH"] = "pl";
  Language2["PASHTO_PUSHTO"] = "ps";
  Language2["PORTUGUESE"] = "pt";
  Language2["QUECHUA"] = "qu";
  Language2["ROMANSH"] = "rm";
  Language2["RUNDI"] = "rn";
  Language2["ROMANIAN_MOLDAVIAN"] = "ro";
  Language2["RUSSIAN"] = "ru";
  Language2["SANSKRIT"] = "sa";
  Language2["SARDINIAN"] = "sc";
  Language2["SINDHI"] = "sd";
  Language2["NORTHERN_SAMI"] = "se";
  Language2["SAMOAN"] = "sm";
  Language2["SANGO"] = "sg";
  Language2["SERBIAN"] = "sr";
  Language2["GAELIC"] = "gd";
  Language2["SHONA"] = "sn";
  Language2["SINHALA_SINHALESE"] = "si";
  Language2["SLOVAK"] = "sk";
  Language2["SLOVENIAN"] = "sl";
  Language2["SOMALI"] = "so";
  Language2["SOUTHERN_SOTHO"] = "st";
  Language2["SPANISH_CASTILIAN"] = "es";
  Language2["SUNDANESE"] = "su";
  Language2["SWAHILI"] = "sw";
  Language2["SWATI"] = "ss";
  Language2["SWEDISH"] = "sv";
  Language2["TAMIL"] = "ta";
  Language2["TELUGU"] = "te";
  Language2["TAJIK"] = "tg";
  Language2["THAI"] = "th";
  Language2["TIGRINYA"] = "ti";
  Language2["TIBETAN"] = "bo";
  Language2["TURKMEN"] = "tk";
  Language2["TAGALOG"] = "tl";
  Language2["TSWANA"] = "tn";
  Language2["TONGA"] = "to";
  Language2["TURKISH"] = "tr";
  Language2["TSONGA"] = "ts";
  Language2["TATAR"] = "tt";
  Language2["TWI"] = "tw";
  Language2["TAHITIAN"] = "ty";
  Language2["UIGHUR"] = "ug";
  Language2["UKRAINIAN"] = "uk";
  Language2["URDU"] = "ur";
  Language2["UZBEK"] = "uz";
  Language2["VENDA"] = "ve";
  Language2["VIETNAMESE"] = "vi";
  Language2["VOLAPUK"] = "vo";
  Language2["WALLOON"] = "wa";
  Language2["WELSH"] = "cy";
  Language2["WOLOF"] = "wo";
  Language2["WESTERN_FRISIAN"] = "fy";
  Language2["XHOSA"] = "xh";
  Language2["YIDDISH"] = "yi";
  Language2["YORUBA"] = "yo";
  Language2["ZHUANG_CHUANG"] = "za";
  Language2["ZULU"] = "zu";
  return Language2;
})(Language || {});
var SupportedLocale = /* @__PURE__ */ ((SupportedLocale2) => {
  SupportedLocale2["ENGLISH"] = "en-gb";
  SupportedLocale2["DANISH"] = "da";
  SupportedLocale2["GERMAN"] = "de";
  SupportedLocale2["SPANISH_LATIN_AMERICAN"] = "es-419";
  SupportedLocale2["FRENCH"] = "fr";
  SupportedLocale2["INDONESIAN"] = "id";
  SupportedLocale2["ITALIAN"] = "it";
  SupportedLocale2["KOREAN"] = "ko";
  SupportedLocale2["MALAY"] = "ms";
  SupportedLocale2["DUTCH"] = "nl";
  SupportedLocale2["TURKISH"] = "tr";
  SupportedLocale2["CHINESE"] = "zh";
  SupportedLocale2["CHINESE_TRADITIONAL"] = "zh-tw";
  return SupportedLocale2;
})(SupportedLocale || {});
var PersonalNameOrder = /* @__PURE__ */ ((PersonalNameOrder2) => {
  PersonalNameOrder2["WESTERN"] = "western";
  PersonalNameOrder2["EASTERN"] = "eastern";
  return PersonalNameOrder2;
})(PersonalNameOrder || {});
function formatPersonalName({
  familyName,
  givenName
}, locale2 = "en-gb") {
  const metadata = getSupportedLocaleMetadata(locale2);
  switch (metadata.personalNameOrder) {
    case "eastern":
      return `${familyName} ${givenName}`;
    case "western":
    default:
      return `${givenName} ${familyName}`;
  }
}
function transformSupportedLocaleToLanguage(locale2) {
  return supportedLocaleToLanguage[locale2];
}
function transformLanguageToSupportedLocale(language) {
  const entry = Object.entries(supportedLocaleToLanguage).find(
    ([_2, value2]) => language === value2
  );
  if (!entry) return "en-gb";
  return entry[0];
}
function clientTransformSupportedLocaleToLanguage(localeKey) {
  const locale2 = SupportedLocale[localeKey];
  const language = transformSupportedLocaleToLanguage(locale2);
  const languageKey = Object.keys(Language).find(
    (key) => Language[key] === language
  );
  if (!languageKey) throw new Error("Invalid language");
  return languageKey;
}
const supportedLocaleToLanguage = {
  [
    "en-gb"
    /* ENGLISH */
  ]: "en",
  [
    "da"
    /* DANISH */
  ]: "da",
  [
    "de"
    /* GERMAN */
  ]: "de",
  [
    "es-419"
    /* SPANISH_LATIN_AMERICAN */
  ]: "es",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "id"
    /* INDONESIAN */
  ]: "id",
  [
    "it"
    /* ITALIAN */
  ]: "it",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ms"
    /* MALAY */
  ]: "ms",
  [
    "nl"
    /* DUTCH */
  ]: "nl",
  [
    "tr"
    /* TURKISH */
  ]: "tr",
  [
    "zh"
    /* CHINESE */
  ]: "zu",
  [
    "zh-tw"
    /* CHINESE_TRADITIONAL */
  ]: "zh"
  /* CHINESE */
};
const FAQ_DEFAULT_URL = "https://www.spottedzebra.co.uk/faq/candidate-faq";
const supportedLocalesMetadata = {
  [
    "en-gb"
    /* ENGLISH */
  ]: {
    name: {
      english: "English",
      native: "English"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "da"
    /* DANISH */
  ]: {
    name: {
      english: "Danish",
      native: "Dansk"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "de"
    /* GERMAN */
  ]: {
    name: {
      english: "German",
      native: "Deutsch"
    },
    faqURL: `${FAQ_DEFAULT_URL}-de`,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "es-419"
    /* SPANISH_LATIN_AMERICAN */
  ]: {
    name: {
      english: "Spanish (Latin American)",
      native: "Español (Latinoamérica)"
    },
    faqURL: `${FAQ_DEFAULT_URL}-de`,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "fr"
    /* FRENCH */
  ]: {
    name: {
      english: "French",
      native: "Français"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "id"
    /* INDONESIAN */
  ]: {
    name: {
      english: "Indonesian",
      native: "Bahasa Indonesia"
    },
    faqURL: `${FAQ_DEFAULT_URL}-id`,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "it"
    /* ITALIAN */
  ]: {
    name: {
      english: "Italian",
      native: "Italiano"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "ko"
    /* KOREAN */
  ]: {
    name: {
      english: "Korean",
      native: "한국어"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "eastern"
    /* EASTERN */
  },
  [
    "ms"
    /* MALAY */
  ]: {
    name: {
      english: "Malay",
      native: "Bahasa Melayu"
    },
    faqURL: FAQ_DEFAULT_URL,
    // I'm pretty sure Malay is Western, and Chinese Malay is Eastern.
    // But that's probably a separate locale code.
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "nl"
    /* DUTCH */
  ]: {
    name: {
      english: "Dutch",
      native: "Nederlands"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "tr"
    /* TURKISH */
  ]: {
    name: {
      english: "Turkish",
      native: "Türkçe"
    },
    faqURL: `${FAQ_DEFAULT_URL}-tr`,
    personalNameOrder: "western"
    /* WESTERN */
  },
  [
    "zh"
    /* CHINESE */
  ]: {
    name: {
      english: "Chinese (Simplified)",
      native: "中文"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "eastern"
    /* EASTERN */
  },
  [
    "zh-tw"
    /* CHINESE_TRADITIONAL */
  ]: {
    name: {
      english: "Chinese (Traditional)",
      native: "中文（繁體）"
    },
    faqURL: FAQ_DEFAULT_URL,
    personalNameOrder: "eastern"
    /* EASTERN */
  }
};
function getSupportedLocaleMetadata(locale2) {
  return supportedLocalesMetadata[locale2];
}
function useLocales() {
  return {
    Language,
    SupportedLocale,
    PersonalNameOrder,
    getSupportedLocaleMetadata,
    transformLanguageToSupportedLocale,
    transformSupportedLocaleToLanguage,
    clientTransformSupportedLocaleToLanguage,
    formatPersonalName,
    supportedLocaleToLanguage
  };
}
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function isDate(value2) {
  requiredArgs(1, arguments);
  return value2 instanceof Date || _typeof(value2) === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day2 = date.getUTCDay();
  var diff = (day2 < weekStartsOn ? 7 : 0) + day2 - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfUTCWeek(dirtyDate, options2) {
  var _ref3, _ref22, _ref32, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref3 = (_ref22 = (_ref32 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref32 !== void 0 ? _ref32 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day2 = date.getUTCDay();
  var diff = (day2 < weekStartsOn ? 7 : 0) + day2 - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options2) {
  var _ref3, _ref22, _ref32, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref3 = (_ref22 = (_ref32 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref32 !== void 0 ? _ref32 : defaultOptions2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options2);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options2);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options2) {
  var _ref3, _ref22, _ref32, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref3 = (_ref22 = (_ref32 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref32 !== void 0 ? _ref32 : defaultOptions2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1);
  var year = getUTCWeekYear(dirtyDate, options2);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options2);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCWeek(dirtyDate, options2) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options2).getTime() - startOfUTCWeekYear(date, options2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign2 = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$1 = {
  // Year
  y: function y(date, token2) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M2(date, token2) {
    var month2 = date.getUTCMonth();
    return token2 === "M" ? String(month2 + 1) : addLeadingZeros(month2 + 1, 2);
  },
  // Day of the month
  d: function d2(date, token2) {
    return addLeadingZeros(date.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a2(date, token2) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h2(date, token2) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H2(date, token2) {
    return addLeadingZeros(date.getUTCHours(), token2.length);
  },
  // Minute
  m: function m2(date, token2) {
    return addLeadingZeros(date.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s2(date, token2) {
    return addLeadingZeros(date.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S2(date, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
var dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G2(date, token2, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$1.y(date, token2);
  },
  // Local week-numbering year
  Y: function Y2(date, token2, localize2, options2) {
    var signedWeekYear = getUTCWeekYear(date, options2);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R2(date, token2) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u2(date, token2) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function Q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M3(date, token2, localize2) {
    var month2 = date.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$1.M(date, token2);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month2 + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month2, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month2, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month2, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L2(date, token2, localize2) {
    var month2 = date.getUTCMonth();
    switch (token2) {
      // 1, 2, ..., 12
      case "L":
        return String(month2 + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month2 + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month2 + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month2, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month2, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month2, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w2(date, token2, localize2, options2) {
    var week = getUTCWeek(date, options2);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function I2(date, token2, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function d3(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$1.d(date, token2);
  },
  // Day of year
  D: function D2(date, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function E2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token2) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e2(date, token2, localize2, options2) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c2(date, token2, localize2, options2) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a3(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h3(date, token2, localize2) {
    if (token2 === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$1.h(date, token2);
  },
  // Hour [0-23]
  H: function H3(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$1.H(date, token2);
  },
  // Hour [0-11]
  K: function K(date, token2, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Hour [1-24]
  k: function k2(date, token2, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Minute
  m: function m3(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$1.m(date, token2);
  },
  // Second
  s: function s3(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$1.s(date, token2);
  },
  // Fraction of second
  S: function S3(date, token2) {
    return formatters$1.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T2(date, token2, _localize, options2) {
    var originalDate = options2._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset3, dirtyDelimiter) {
  var sign2 = offset3 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset3);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  var delimiter2 = dirtyDelimiter;
  return sign2 + String(hours) + delimiter2 + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset3, dirtyDelimiter) {
  if (offset3 % 60 === 0) {
    var sign2 = offset3 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset3) / 60, 2);
  }
  return formatTimezone(offset3, dirtyDelimiter);
}
function formatTimezone(offset3, dirtyDelimiter) {
  var delimiter2 = dirtyDelimiter || "";
  var sign2 = offset3 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset3);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter2 + minutes;
}
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input2) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token2, count2, options2) {
  var result;
  var tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options2 !== null && options2 !== void 0 && options2.addSuffix) {
    if (options2.comparison && options2.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options2.width ? String(options2.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, options2) {
    var context = options2 !== null && options2 !== void 0 && options2.context ? String(options2.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options2 !== null && options2 !== void 0 && options2.width ? String(options2.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options2 !== null && options2 !== void 0 && options2.width ? String(options2.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options2.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options2.valueCallback ? options2.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options2.valueCallback ? options2.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options2) {
  var _ref3, _options$locale, _ref22, _ref32, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale$1 = (_ref3 = (_options$locale = options2 === null || options2 === void 0 ? void 0 : options2.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref3 !== void 0 ? _ref3 : locale;
  var firstWeekContainsDate = toInteger((_ref22 = (_ref32 = (_ref4 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale2 = options2.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref32 !== void 0 ? _ref32 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale3 = options2.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale$1.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale$1.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$1(input2) {
  var matched = input2.match(escapedStringRegExp$1);
  if (!matched) {
    return input2;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
var MILLISECONDS_IN_MINUTE = 6e4;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
function subQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day2 = date.getDay();
  return day2;
}
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
function startOfWeek(dirtyDate, options2) {
  var _ref3, _ref22, _ref32, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref3 = (_ref22 = (_ref32 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref32 !== void 0 ? _ref32 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day2 = date.getDay();
  var diff = (day2 < weekStartsOn ? 7 : 0) + day2 - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month2 = date.getMonth();
  return month2;
}
function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = /* @__PURE__ */ new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month2 = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day2 = date.getDate();
  var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
  dateWithDesiredMonth.setFullYear(year, month2, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date.setMonth(month2, Math.min(day2, daysInMonth));
  return date;
}
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var MILLISECONDS_IN_DAY = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month2 = currentMonth - currentMonth % 3;
  date.setMonth(month2, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month2 = date.getMonth();
  date.setFullYear(date.getFullYear(), month2 + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isEqual$1(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  return time >= startTime && time <= endTime;
}
function _arrayLikeToArray(r2, a4) {
  (null == a4 || a4 > r2.length) && (a4 = r2.length);
  for (var e3 = 0, n2 = Array(a4); e3 < a4; e3++) n2[e3] = r2[e3];
  return n2;
}
function _unsupportedIterableToArray(r2, a4) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a4);
    var t3 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t3 && r2.constructor && (t3 = r2.constructor.name), "Map" === t3 || "Set" === t3 ? Array.from(r2) : "Arguments" === t3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3) ? _arrayLikeToArray(r2, a4) : void 0;
  }
}
function _createForOfIteratorHelper(r2, e3) {
  var t3 = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t3) {
    if (Array.isArray(r2) || (t3 = _unsupportedIterableToArray(r2)) || e3) {
      t3 && (r2 = t3);
      var _n = 0, F2 = function F3() {
      };
      return {
        s: F2,
        n: function n2() {
          return _n >= r2.length ? {
            done: true
          } : {
            done: false,
            value: r2[_n++]
          };
        },
        e: function e4(r3) {
          throw r3;
        },
        f: F2
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o2, a4 = true, u3 = false;
  return {
    s: function s4() {
      t3 = t3.call(r2);
    },
    n: function n2() {
      var r3 = t3.next();
      return a4 = r3.done, r3;
    },
    e: function e4(r3) {
      u3 = true, o2 = r3;
    },
    f: function f2() {
      try {
        a4 || null == t3["return"] || t3["return"]();
      } finally {
        if (u3) throw o2;
      }
    }
  };
}
function assign(target, object) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}
function _assertThisInitialized$1(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function _setPrototypeOf$1(t3, e3) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e4) {
    return t4.__proto__ = e4, t4;
  }, _setPrototypeOf$1(t3, e3);
}
function _inherits(t3, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t3.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t3,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t3, "prototype", {
    writable: false
  }), e3 && _setPrototypeOf$1(t3, e3);
}
function _getPrototypeOf(t3) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf(t3);
}
function _isNativeReflectConstruct() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _possibleConstructorReturn(t3, e3) {
  if (e3 && ("object" == _typeof(e3) || "function" == typeof e3)) return e3;
  if (void 0 !== e3) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t3);
}
function _createSuper(t3) {
  var r2 = _isNativeReflectConstruct();
  return function() {
    var e3, o2 = _getPrototypeOf(t3);
    if (r2) {
      var s4 = _getPrototypeOf(this).constructor;
      e3 = Reflect.construct(o2, arguments, s4);
    } else e3 = o2.apply(this, arguments);
    return _possibleConstructorReturn(this, e3);
  };
}
function _classCallCheck(a4, n2) {
  if (!(a4 instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(t3, r2) {
  if ("object" != _typeof(t3) || !t3) return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i3 = e3.call(t3, r2);
    if ("object" != _typeof(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function toPropertyKey(t3) {
  var i3 = toPrimitive(t3, "string");
  return "symbol" == _typeof(i3) ? i3 : i3 + "";
}
function _defineProperties(e3, r2) {
  for (var t3 = 0; t3 < r2.length; t3++) {
    var o2 = r2[t3];
    o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e3, toPropertyKey(o2.key), o2);
  }
}
function _createClass(e3, r2, t3) {
  return r2 && _defineProperties(e3.prototype, r2), Object.defineProperty(e3, "prototype", {
    writable: false
  }), e3;
}
function _defineProperty(e3, r2, t3) {
  return (r2 = toPropertyKey(r2)) in e3 ? Object.defineProperty(e3, r2, {
    value: t3,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e3[r2] = t3, e3;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /* @__PURE__ */ (function() {
  function Setter2() {
    _classCallCheck(this, Setter2);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter2, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
})();
var ValueSetter = /* @__PURE__ */ (function(_Setter) {
  _inherits(ValueSetter2, _Setter);
  var _super = _createSuper(ValueSetter2);
  function ValueSetter2(value2, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value2;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter2, [{
    key: "validate",
    value: function validate(utcDate, options2) {
      return this.validateValue(utcDate, this.value, options2);
    }
  }, {
    key: "set",
    value: function set2(utcDate, flags, options2) {
      return this.setValue(utcDate, flags, this.value, options2);
    }
  }]);
  return ValueSetter2;
})(Setter);
var DateToSystemTimezoneSetter = /* @__PURE__ */ (function(_Setter2) {
  _inherits(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized$1(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set2(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
})(Setter);
var Parser = /* @__PURE__ */ (function() {
  function Parser2() {
    _classCallCheck(this, Parser2);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser2, [{
    key: "run",
    value: function run(dateString, token2, match2, options2) {
      var result = this.parse(dateString, token2, match2, options2);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser2;
})();
var EraParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(EraParser2, _Parser);
  var _super = _createSuper(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 140);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass(EraParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return match2.era(dateString, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return match2.era(dateString, {
            width: "wide"
          }) || match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      flags.era = value2;
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser2;
})(Parser);
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign2 = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(YearParser2, _Parser);
  var _super = _createSuper(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(YearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      var currentYear = date.getUTCFullYear();
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser2;
})(Parser);
var LocalWeekYearParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(LocalWeekYearParser2, _Parser);
  var _super = _createSuper(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "Yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2, options2) {
      var currentYear = getUTCWeekYear(date, options2);
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options2.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options2);
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, options2.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options2);
    }
  }]);
  return LocalWeekYearParser2;
})(Parser);
var ISOWeekYearParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ISOWeekYearParser2, _Parser);
  var _super = _createSuper(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value2, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
})(Parser);
var ExtendedYearParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ExtendedYearParser2, _Parser);
  var _super = _createSuper(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ExtendedYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser2;
})(Parser);
var QuarterParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(QuarterParser2, _Parser);
  var _super = _createSuper(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(QuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return parseNDigits(token2.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser2;
})(Parser);
var StandAloneQuarterParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return parseNDigits(token2.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser2;
})(Parser);
var MonthParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(MonthParser2, _Parser);
  var _super = _createSuper(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        // 1, 2, ..., 12
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        // 01, 02, ..., 12
        case "MM":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        // Jan, Feb, ..., Dec
        case "MMM":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser2;
})(Parser);
var StandAloneMonthParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(StandAloneMonthParser2, _Parser);
  var _super = _createSuper(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        // 1, 2, ..., 12
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        // 01, 02, ..., 12
        case "LL":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        // Jan, Feb, ..., Dec
        case "LLL":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser2;
})(Parser);
function setUTCWeek(dirtyDate, dirtyWeek, options2) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options2) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var LocalWeekParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(LocalWeekParser2, _Parser);
  var _super = _createSuper(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "w":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "wo":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options2) {
      return startOfUTCWeek(setUTCWeek(date, value2, options2), options2);
    }
  }]);
  return LocalWeekParser2;
})(Parser);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var ISOWeekParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ISOWeekParser2, _Parser);
  var _super = _createSuper(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "I":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "Io":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value2));
    }
  }]);
  return ISOWeekParser2;
})(Parser);
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(DateParser2, _Parser);
  var _super = _createSuper(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DateParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "d":
          return parseNumericPattern(numericPatterns.date, dateString);
        case "do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month2 = date.getUTCMonth();
      if (isLeapYear) {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR[month2];
      } else {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH[month2];
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCDate(value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser2;
})(Parser);
var DayOfYearParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(DayOfYearParser2, _Parser);
  var _super = _createSuper(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayOfYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case "Do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value2 >= 1 && value2 <= 366;
      } else {
        return value2 >= 1 && value2 <= 365;
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(0, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser2;
})(Parser);
function setUTCDay(dirtyDate, dirtyDay, options2) {
  var _ref3, _ref22, _ref32, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref3 = (_ref22 = (_ref32 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref32 !== void 0 ? _ref32 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day2 = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day2 % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day2 - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var DayParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(DayParser2, _Parser);
  var _super = _createSuper(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options2) {
      date = setUTCDay(date, value2, options2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser2;
})(Parser);
var LocalDayParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(LocalDayParser2, _Parser);
  var _super = _createSuper(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass(LocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options2) {
      var valueCallback3 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        // 3
        case "e":
        case "ee":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        // 3rd
        case "eo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        // Tue
        case "eee":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options2) {
      date = setUTCDay(date, value2, options2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser2;
})(Parser);
var StandAloneLocalDayParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options2) {
      var valueCallback3 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        // 3
        case "c":
        case "cc":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        // 3rd
        case "co":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        // Tue
        case "ccc":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options2) {
      date = setUTCDay(date, value2, options2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser2;
})(Parser);
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day2 = toInteger(dirtyDay);
  if (day2 % 7 === 0) {
    day2 = day2 - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day2 % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day2 - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var ISODayParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ISODayParser2, _Parser);
  var _super = _createSuper(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISODayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        if (value2 === 0) {
          return 7;
        }
        return value2;
      };
      switch (token2) {
        // 2
        case "i":
        case "ii":
          return parseNDigits(token2.length, dateString);
        // 2nd
        case "io":
          return match2.ordinalNumber(dateString, {
            unit: "day"
          });
        // Tue
        case "iii":
          return mapValue(match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        // T
        case "iiiii":
          return mapValue(match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        // Tu
        case "iiiiii":
          return mapValue(match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        // Tuesday
        case "iiii":
        default:
          return mapValue(match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 7;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date = setUTCISODay(date, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser2;
})(Parser);
var AMPMParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(AMPMParser2, _Parser);
  var _super = _createSuper(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser2;
})(Parser);
var AMPMMidnightParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(AMPMMidnightParser2, _Parser);
  var _super = _createSuper(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser2;
})(Parser);
var DayPeriodParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(DayPeriodParser2, _Parser);
  var _super = _createSuper(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass(DayPeriodParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser2;
})(Parser);
var Hour1to12Parser = /* @__PURE__ */ (function(_Parser) {
  _inherits(Hour1to12Parser2, _Parser);
  var _super = _createSuper(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour1to12Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case "ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 12;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else if (!isPM && value2 === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser2;
})(Parser);
var Hour0to23Parser = /* @__PURE__ */ (function(_Parser) {
  _inherits(Hour0to23Parser2, _Parser);
  var _super = _createSuper(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0to23Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case "Ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 23;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(value2, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser2;
})(Parser);
var Hour0To11Parser = /* @__PURE__ */ (function(_Parser) {
  _inherits(Hour0To11Parser2, _Parser);
  var _super = _createSuper(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0To11Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case "Ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser2;
})(Parser);
var Hour1To24Parser = /* @__PURE__ */ (function(_Parser) {
  _inherits(Hour1To24Parser2, _Parser);
  var _super = _createSuper(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass(Hour1To24Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case "ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 1 && value2 <= 24;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var hours = value2 <= 24 ? value2 % 24 : value2;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser2;
})(Parser);
var MinuteParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(MinuteParser2, _Parser);
  var _super = _createSuper(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 60);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(MinuteParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, dateString);
        case "mo":
          return match2.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMinutes(value2, 0, 0);
      return date;
    }
  }]);
  return MinuteParser2;
})(Parser);
var SecondParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(SecondParser2, _Parser);
  var _super = _createSuper(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 50);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(SecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "s":
          return parseNumericPattern(numericPatterns.second, dateString);
        case "so":
          return match2.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCSeconds(value2, 0);
      return date;
    }
  }]);
  return SecondParser2;
})(Parser);
var FractionOfSecondParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(FractionOfSecondParser2, _Parser);
  var _super = _createSuper(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 30);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      var valueCallback3 = function valueCallback4(value2) {
        return Math.floor(value2 * Math.pow(10, -token2.length + 3));
      };
      return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMilliseconds(value2);
      return date;
    }
  }]);
  return FractionOfSecondParser2;
})(Parser);
var ISOTimezoneWithZParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneWithZParser2;
})(Parser);
var ISOTimezoneParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(ISOTimezoneParser2, _Parser);
  var _super = _createSuper(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneParser2;
})(Parser);
var TimestampSecondsParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(TimestampSecondsParser2, _Parser);
  var _super = _createSuper(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 40);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2 * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
})(Parser);
var TimestampMillisecondsParser = /* @__PURE__ */ (function(_Parser) {
  _inherits(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 20);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
})(Parser);
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options2) {
  var _ref3, _options$locale, _ref22, _ref32, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale$1 = (_ref3 = (_options$locale = options2 === null || options2 === void 0 ? void 0 : options2.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref3 !== void 0 ? _ref3 : locale;
  if (!locale$1.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref22 = (_ref32 = (_ref4 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale2 = options2.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref32 !== void 0 ? _ref32 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale3 = options2.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens), _step;
  try {
    var _loop = function _loop2() {
      var token2 = _step.value;
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser.run(dateString, token2, locale$1.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a4, b3) {
    return b3 - a4;
  }).filter(function(priority, index2, array) {
    return array.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a4, b3) {
      return b3.subPriority - a4.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input2) {
  return input2.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options2) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = void 0) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset3;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset3 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset3)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset3);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month2 = parseDateUnit(captures[2]) - 1;
  var day2 = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month2, day2) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month2, Math.max(dayOfYear, day2));
    return date;
  }
}
function parseDateUnit(value2) {
  return value2 ? parseInt(value2) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value2) {
  return value2 && parseFloat(value2.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign2 = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day2) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day2 + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month2, date) {
  return month2 >= 0 && month2 <= 11 && date >= 1 && date <= (daysInMonths[month2] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day2) {
  return week >= 1 && week <= 53 && day2 >= 0 && day2 <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key = sourceKeys[i3];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }
  return current.classList.contains(ignoreClass);
}
function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  while (current.parentNode || current.host) {
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }
    current = current.parentNode || current.host;
  }
  return current;
}
function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}
var testPassiveEventSupport = function testPassiveEventSupport2() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return;
  }
  var passive2 = false;
  var options2 = Object.defineProperty({}, "passive", {
    get: function get2() {
      passive2 = true;
    }
  });
  var noop3 = function noop4() {
  };
  window.addEventListener("testPassiveEventSupport", noop3, options2);
  window.removeEventListener("testPassiveEventSupport", noop3, options2);
  return passive2;
};
function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }
  return function() {
    return ++seed;
  };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ["touchstart", "touchmove"];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }
  return handlerOptions;
}
function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;
  var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  return _temp = _class = /* @__PURE__ */ (function(_Component) {
    _inheritsLoose(onClickOutside, _Component);
    function onClickOutside(props) {
      var _this;
      _this = _Component.call(this, props) || this;
      _this.__outsideClickHandler = function(event) {
        if (typeof _this.__clickOutsideHandlerProp === "function") {
          _this.__clickOutsideHandlerProp(event);
          return;
        }
        var instance = _this.getInstance();
        if (typeof instance.props.handleClickOutside === "function") {
          instance.props.handleClickOutside(event);
          return;
        }
        if (typeof instance.handleClickOutside === "function") {
          instance.handleClickOutside(event);
          return;
        }
        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };
      _this.__getComponentNode = function() {
        var instance = _this.getInstance();
        if (typeof instance.setClickOutsideRef === "function") {
          return instance.setClickOutsideRef();
        }
        return findDOMNode$1(instance);
      };
      _this.enableOnClickOutside = function() {
        if (typeof document === "undefined" || enabledInstances[_this._uid]) {
          return;
        }
        if (typeof passiveEventSupport === "undefined") {
          passiveEventSupport = testPassiveEventSupport();
        }
        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;
        if (!events.forEach) {
          events = [events];
        }
        handlersMap[_this._uid] = function(event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;
          if (_this.props.preventDefault) {
            event.preventDefault();
          }
          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }
          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }
          _this.__outsideClickHandler(event);
        };
        events.forEach(function(eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };
      _this.disableOnClickOutside = function() {
        delete enabledInstances[_this._uid];
        var fn2 = handlersMap[_this._uid];
        if (fn2 && typeof document !== "undefined") {
          var events = _this.props.eventTypes;
          if (!events.forEach) {
            events = [events];
          }
          events.forEach(function(eventName) {
            return document.removeEventListener(eventName, fn2, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };
      _this.getRef = function(ref2) {
        return _this.instanceRef = ref2;
      };
      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    var _proto = onClickOutside.prototype;
    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref2 = this.instanceRef;
      return ref2.getInstance ? ref2.getInstance() : ref2;
    };
    _proto.componentDidMount = function componentDidMount() {
      if (typeof document === "undefined" || !document.createElement) {
        return;
      }
      this.getInstance();
      this.componentNode = this.__getComponentNode();
      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    _proto.render = function render() {
      var _this$props = this.props;
      _this$props.excludeScrollbar;
      var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }
      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };
    return onClickOutside;
  })(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function() {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}
var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref3) {
  var children = _ref3.children;
  var _React$useState = React.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
  var hasUnmounted = React.useRef(false);
  React.useEffect(function() {
    return function() {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function(node2) {
    if (!hasUnmounted.current) {
      setReferenceNode(node2);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /* @__PURE__ */ React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
var unwrapArray = function unwrapArray2(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke2(fn2) {
  if (typeof fn2 === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn2.apply(void 0, args);
  }
};
var setRef = function setRef2(ref2, node2) {
  if (typeof ref2 === "function") {
    return safeInvoke(ref2, node2);
  } else if (ref2 != null) {
    ref2.current = node2;
  }
};
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref3) {
    var key = _ref3[0], value2 = _ref3[1];
    acc[key] = value2;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow2(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function isElement(node2) {
  var OwnElement = getWindow2(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement(node2) {
  var OwnElement = getWindow2(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow2(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function(name2) {
    var style2 = state.styles[name2] || {};
    var attributes = state.attributes[name2] || {};
    var element = state.elements[name2];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name3) {
      var value2 = attributes[name3];
      if (value2 === false) {
        element.removeAttribute(name3);
      } else {
        element.setAttribute(name3, value2 === true ? "" : value2);
      }
    });
  });
}
function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name2) {
      var element = state.elements[name2];
      var attributes = state.attributes[name2] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item2) {
      return item2.brand + "/" + item2.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref3 = isElement(element) ? getWindow2(element) : window, visualViewport = _ref3.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x3 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y3 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y3,
    right: x3 + width,
    bottom: y3 + height,
    left: x3,
    x: x3,
    y: y3
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow2(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css5 = getComputedStyle$1(currentNode);
    if (css5.transform !== "none" || css5.perspective !== "none" || css5.contain === "paint" || ["transform", "perspective"].indexOf(css5.willChange) !== -1 || isFirefox && css5.willChange === "filter" || isFirefox && css5.filter && css5.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow2(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$12, value2, max$12) {
  return max(min$12, min(value2, max$12));
}
function withinMaxClamp(min2, value2, max2) {
  var v2 = within(min2, value2, max2);
  return v2 > max2 ? max2 : v2;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value2, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value2;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref3) {
  var _state$modifiersData$;
  var state = _ref3.state, name2 = _ref3.name, options2 = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options2.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset3 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset3, _state$modifiersData$.centerOffset = offset3 - center, _state$modifiersData$);
}
function effect$1(_ref22) {
  var state = _ref22.state, options2 = _ref22.options;
  var _options$element = options2.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref3, win) {
  var x3 = _ref3.x, y3 = _ref3.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x3 * dpr) / dpr || 0,
    y: round(y3 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, variation = _ref22.variation, offsets = _ref22.offsets, position2 = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive, roundOffsets = _ref22.roundOffsets, isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x, x3 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y3 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x3,
    y: y3
  }) : {
    x: x3,
    y: y3
  };
  x3 = _ref3.x;
  y3 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow2(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y3 -= offsetY - popperRect.height;
      y3 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x3 -= offsetX - popperRect.width;
      x3 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x3,
    y: y3
  }, getWindow2(popper2)) : {
    x: x3,
    y: y3
  };
  x3 = _ref4.x;
  y3 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x3 + "px, " + y3 + "px)" : "translate3d(" + x3 + "px, " + y3 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y3 + "px" : "", _Object$assign2[sideX] = hasX ? x3 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options2 = _ref5.options;
  var _options$gpuAccelerat = options2.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options2.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options2.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref3) {
  var state = _ref3.state, instance = _ref3.instance, options2 = _ref3.options;
  var _options$scroll = options2.scroll, scroll2 = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options2.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow2(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll2) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll2) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow2(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow2(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x3 = 0;
  var y3 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x3 = visualViewport.offsetLeft;
      y3 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x3 + getWindowScrollBarX(element),
    y: y3
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body2 = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body2 ? body2.scrollWidth : 0, body2 ? body2.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body2 ? body2.scrollHeight : 0, body2 ? body2.clientHeight : 0);
  var x3 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y3 = -winScroll.scrollTop;
  if (getComputedStyle$1(body2 || html).direction === "rtl") {
    x3 += max(html.clientWidth, body2 ? body2.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x3,
    y: y3
  };
}
function isScrollParent(element) {
  var _getComputedStyle2 = getComputedStyle$1(element), overflow = _getComputedStyle2.overflow, overflowX = _getComputedStyle2.overflowX, overflowY = _getComputedStyle2.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode(node2));
}
function listScrollParents(element, list2) {
  var _element$ownerDocumen;
  if (list2 === void 0) {
    list2 = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow2(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list2.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)))
  );
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref3) {
  var reference2 = _ref3.reference, element = _ref3.element, placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset3 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset3[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$12 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$12.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$12;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a4, b3) {
    return overflows[a4] - overflows[b3];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name2 = _ref3.name;
  if (state.modifiersData[name2]._skip) {
    return;
  }
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options2.fallbackPlacements, padding = options2.padding, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, _options$flipVariatio = options2.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options2.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i3 = 0; i3 < placements2.length; i3++) {
    var placement = placements2[i3];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name2]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref3) {
  var state = _ref3.state, name2 = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name2] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset3) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref3 = typeof offset3 === "function" ? offset3(Object.assign({}, rects, {
    placement
  })) : offset3, skidding = _ref3[0], distance = _ref3[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset2(_ref22) {
  var state = _ref22.state, options2 = _ref22.options, name2 = _ref22.name;
  var _options$offset = options2.offset, offset3 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset3);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x3 = _data$state$placement.x, y3 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x3;
    state.modifiersData.popperOffsets.y += y3;
  }
  state.modifiersData[name2] = data;
}
const offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset2
};
function popperOffsets(_ref3) {
  var state = _ref3.state, name2 = _ref3.name;
  state.modifiersData[name2] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name2 = _ref3.name;
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, padding = options2.padding, _options$tether = options2.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options2.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset3 = popperOffsets2[mainAxis];
    var min$12 = offset3 + overflow[mainSide];
    var max$12 = offset3 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset3 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset3 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$12, tetherMin) : min$12, offset3, tether ? max(max$12, tetherMax) : max$12);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset3;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name2] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow2(node2) || !isHTMLElement(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll2 = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll2.scrollLeft - offsets.x,
    y: rect.top + scroll2.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options2) {
    if (options2 === void 0) {
      options2 = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options3 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options3);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m4) {
          return m4.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name2 = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name: name2,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options2).then(function(state2) {
      if (!isDestroyed && options2.onFirstUpdate) {
        options2.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name2 = _ref3.name, _ref$options = _ref3.options, options3 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name: name2,
            instance,
            options: options3
          });
          var noopFn2 = function noopFn3() {
          };
          effectCleanupFns.push(cleanupFn || noopFn2);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var reactFastCompare;
var hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var hasElementType = typeof Element !== "undefined";
  var hasMap = typeof Map === "function";
  var hasSet = typeof Set === "function";
  var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
  function equal(a4, b3) {
    if (a4 === b3) return true;
    if (a4 && b3 && typeof a4 == "object" && typeof b3 == "object") {
      if (a4.constructor !== b3.constructor) return false;
      var length2, i3, keys;
      if (Array.isArray(a4)) {
        length2 = a4.length;
        if (length2 != b3.length) return false;
        for (i3 = length2; i3-- !== 0; )
          if (!equal(a4[i3], b3[i3])) return false;
        return true;
      }
      var it2;
      if (hasMap && a4 instanceof Map && b3 instanceof Map) {
        if (a4.size !== b3.size) return false;
        it2 = a4.entries();
        while (!(i3 = it2.next()).done)
          if (!b3.has(i3.value[0])) return false;
        it2 = a4.entries();
        while (!(i3 = it2.next()).done)
          if (!equal(i3.value[1], b3.get(i3.value[0]))) return false;
        return true;
      }
      if (hasSet && a4 instanceof Set && b3 instanceof Set) {
        if (a4.size !== b3.size) return false;
        it2 = a4.entries();
        while (!(i3 = it2.next()).done)
          if (!b3.has(i3.value[0])) return false;
        return true;
      }
      if (hasArrayBuffer && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b3)) {
        length2 = a4.length;
        if (length2 != b3.length) return false;
        for (i3 = length2; i3-- !== 0; )
          if (a4[i3] !== b3[i3]) return false;
        return true;
      }
      if (a4.constructor === RegExp) return a4.source === b3.source && a4.flags === b3.flags;
      if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b3.valueOf === "function") return a4.valueOf() === b3.valueOf();
      if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b3.toString === "function") return a4.toString() === b3.toString();
      keys = Object.keys(a4);
      length2 = keys.length;
      if (length2 !== Object.keys(b3).length) return false;
      for (i3 = length2; i3-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b3, keys[i3])) return false;
      if (hasElementType && a4 instanceof Element) return false;
      for (i3 = length2; i3-- !== 0; ) {
        if ((keys[i3] === "_owner" || keys[i3] === "__v" || keys[i3] === "__o") && a4.$$typeof) {
          continue;
        }
        if (!equal(a4[keys[i3]], b3[keys[i3]])) return false;
      }
      return true;
    }
    return a4 !== a4 && b3 !== b3;
  }
  reactFastCompare = function isEqual2(a4, b3) {
    try {
      return equal(a4, b3);
    } catch (error2) {
      if ((error2.message || "").match(/stack|recursion/i)) {
        console.warn("react-fast-compare cannot handle circular refs");
        return false;
      }
      throw error2;
    }
  };
  return reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const isEqual = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompareExports);
var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper2(referenceElement, popperElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options2.onFirstUpdate,
    placement: options2.placement || "bottom",
    strategy: options2.strategy || "absolute",
    modifiers: options2.modifiers || EMPTY_MODIFIERS$1
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref3) {
        var state2 = _ref3.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options2.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options2.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
var NOOP = function NOOP2() {
  return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE2() {
  return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref3) {
  var _ref$placement = _ref3.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref3.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref3.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref3.referenceElement, onFirstUpdate = _ref3.onFirstUpdate, innerRef = _ref3.innerRef, children = _ref3.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);
  var _React$useState = React.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
  var _React$useState2 = React.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
  React.useEffect(function() {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options2 = React.useMemo(function() {
    return {
      placement,
      strategy,
      onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: "arrow",
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options2), state = _usePopper.state, styles2 = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
  var childrenProps = React.useMemo(function() {
    return {
      ref: setPopperElement,
      style: styles2.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles2.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles2, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
var warningExports = requireWarning();
const warning = /* @__PURE__ */ getDefaultExportFromCjs(warningExports);
function Reference(_ref3) {
  var children = _ref3.children, innerRef = _ref3.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function(node2) {
    setRef(innerRef, node2);
    safeInvoke(setReferenceNode, node2);
  }, [innerRef, setReferenceNode]);
  React.useEffect(function() {
    return function() {
      return setRef(innerRef, null);
    };
  }, []);
  React.useEffect(function() {
    warning(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
function set(dirtyDate, values) {
  requiredArgs(2, arguments);
  if (_typeof(values) !== "object" || values === null) {
    throw new RangeError("values parameter must be an object");
  }
  var date = toDate(dirtyDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = setMonth(date, values.month);
  }
  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }
  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }
  return date;
}
function le(e3, t3) {
  var r2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e3);
    t3 && (n2 = n2.filter((function(t4) {
      return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
    }))), r2.push.apply(r2, n2);
  }
  return r2;
}
function de(e3) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var r2 = null != arguments[t3] ? arguments[t3] : {};
    t3 % 2 ? le(Object(r2), true).forEach((function(t4) {
      ve(e3, t4, r2[t4]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r2)) : le(Object(r2)).forEach((function(t4) {
      Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r2, t4));
    }));
  }
  return e3;
}
function ue(e3) {
  return ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
    return typeof e4;
  } : function(e4) {
    return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
  }, ue(e3);
}
function he(e3, t3) {
  if (!(e3 instanceof t3)) throw new TypeError("Cannot call a class as a function");
}
function me(e3, t3) {
  for (var r2 = 0; r2 < t3.length; r2++) {
    var n2 = t3[r2];
    n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, _e(n2.key), n2);
  }
}
function fe(e3, t3, r2) {
  return t3 && me(e3.prototype, t3), r2 && me(e3, r2), Object.defineProperty(e3, "prototype", { writable: false }), e3;
}
function ve(e3, t3, r2) {
  return (t3 = _e(t3)) in e3 ? Object.defineProperty(e3, t3, { value: r2, enumerable: true, configurable: true, writable: true }) : e3[t3] = r2, e3;
}
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e3) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var r2 = arguments[t3];
      for (var n2 in r2) Object.prototype.hasOwnProperty.call(r2, n2) && (e3[n2] = r2[n2]);
    }
    return e3;
  }, ye.apply(this, arguments);
}
function De(e3, t3) {
  if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
  e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), Object.defineProperty(e3, "prototype", { writable: false }), t3 && we(e3, t3);
}
function ge(e3) {
  return ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
    return e4.__proto__ || Object.getPrototypeOf(e4);
  }, ge(e3);
}
function we(e3, t3) {
  return we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
    return e4.__proto__ = t4, e4;
  }, we(e3, t3);
}
function ke(e3) {
  if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function be(e3) {
  var t3 = (function() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
      }))), true;
    } catch (e4) {
      return false;
    }
  })();
  return function() {
    var r2, n2 = ge(e3);
    if (t3) {
      var o2 = ge(this).constructor;
      r2 = Reflect.construct(n2, arguments, o2);
    } else r2 = n2.apply(this, arguments);
    return (function(e4, t4) {
      if (t4 && ("object" == typeof t4 || "function" == typeof t4)) return t4;
      if (void 0 !== t4) throw new TypeError("Derived constructors may only return object or undefined");
      return ke(e4);
    })(this, r2);
  };
}
function Se(e3) {
  return (function(e4) {
    if (Array.isArray(e4)) return Ce(e4);
  })(e3) || (function(e4) {
    if ("undefined" != typeof Symbol && null != e4[Symbol.iterator] || null != e4["@@iterator"]) return Array.from(e4);
  })(e3) || (function(e4, t3) {
    if (!e4) return;
    if ("string" == typeof e4) return Ce(e4, t3);
    var r2 = Object.prototype.toString.call(e4).slice(8, -1);
    "Object" === r2 && e4.constructor && (r2 = e4.constructor.name);
    if ("Map" === r2 || "Set" === r2) return Array.from(e4);
    if ("Arguments" === r2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r2)) return Ce(e4, t3);
  })(e3) || (function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  })();
}
function Ce(e3, t3) {
  (null == t3 || t3 > e3.length) && (t3 = e3.length);
  for (var r2 = 0, n2 = new Array(t3); r2 < t3; r2++) n2[r2] = e3[r2];
  return n2;
}
function _e(e3) {
  var t3 = (function(e4, t4) {
    if ("object" != typeof e4 || null === e4) return e4;
    var r2 = e4[Symbol.toPrimitive];
    if (void 0 !== r2) {
      var n2 = r2.call(e4, t4);
      if ("object" != typeof n2) return n2;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t4 ? String : Number)(e4);
  })(e3, "string");
  return "symbol" == typeof t3 ? t3 : String(t3);
}
var Me = function(e3, t3) {
  switch (e3) {
    case "P":
      return t3.date({ width: "short" });
    case "PP":
      return t3.date({ width: "medium" });
    case "PPP":
      return t3.date({ width: "long" });
    default:
      return t3.date({ width: "full" });
  }
}, Ee = function(e3, t3) {
  switch (e3) {
    case "p":
      return t3.time({ width: "short" });
    case "pp":
      return t3.time({ width: "medium" });
    case "ppp":
      return t3.time({ width: "long" });
    default:
      return t3.time({ width: "full" });
  }
}, Pe = { p: Ee, P: function(e3, t3) {
  var r2, n2 = e3.match(/(P+)(p+)?/) || [], o2 = n2[1], a4 = n2[2];
  if (!a4) return Me(e3, t3);
  switch (o2) {
    case "P":
      r2 = t3.dateTime({ width: "short" });
      break;
    case "PP":
      r2 = t3.dateTime({ width: "medium" });
      break;
    case "PPP":
      r2 = t3.dateTime({ width: "long" });
      break;
    default:
      r2 = t3.dateTime({ width: "full" });
  }
  return r2.replace("{{date}}", Me(o2, t3)).replace("{{time}}", Ee(a4, t3));
} }, Ne = 12, xe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ye(e3) {
  var t3 = e3 ? "string" == typeof e3 || e3 instanceof String ? parseISO(e3) : toDate(e3) : /* @__PURE__ */ new Date();
  return Ie(t3) ? t3 : null;
}
function Ie(e3, t3) {
  return t3 = t3 || /* @__PURE__ */ new Date("1/1/1000"), isValid(e3) && !isBefore(e3, t3);
}
function Oe(e3, t3, r2) {
  if ("en" === r2) return format(e3, t3, { awareOfUnicodeTokens: true });
  var n2 = Ge(r2);
  return r2 && !n2 && console.warn('A locale object was not found for the provided string ["'.concat(r2, '"].')), !n2 && $e() && Ge($e()) && (n2 = Ge($e())), format(e3, t3, { locale: n2 || null, awareOfUnicodeTokens: true });
}
function Te(e3, t3) {
  var r2 = t3.dateFormat, n2 = t3.locale;
  return e3 && Oe(e3, Array.isArray(r2) ? r2[0] : r2, n2) || "";
}
function Re(e3, t3) {
  var r2 = t3.hour, n2 = void 0 === r2 ? 0 : r2, o2 = t3.minute, a4 = void 0 === o2 ? 0 : o2, s4 = t3.second;
  return setHours(setMinutes(setSeconds(e3, void 0 === s4 ? 0 : s4), a4), n2);
}
function Le(e3, t3, r2) {
  var n2 = Ge(t3 || $e());
  return startOfWeek(e3, { locale: n2, weekStartsOn: r2 });
}
function Fe(e3) {
  return startOfMonth(e3);
}
function Ae(e3) {
  return startOfYear(e3);
}
function Ke(e3) {
  return startOfQuarter(e3);
}
function Be() {
  return startOfDay(Ye());
}
function Qe(e3, t3) {
  return e3 && t3 ? isSameYear(e3, t3) : !e3 && !t3;
}
function We(e3, t3) {
  return e3 && t3 ? isSameMonth(e3, t3) : !e3 && !t3;
}
function je(e3, t3) {
  return e3 && t3 ? isSameQuarter(e3, t3) : !e3 && !t3;
}
function He(e3, t3) {
  return e3 && t3 ? isSameDay(e3, t3) : !e3 && !t3;
}
function Ve(e3, t3) {
  return e3 && t3 ? isEqual$1(e3, t3) : !e3 && !t3;
}
function qe(e3, t3, r2) {
  var n2, o2 = startOfDay(t3), a4 = endOfDay(r2);
  try {
    n2 = isWithinInterval(e3, { start: o2, end: a4 });
  } catch (e4) {
    n2 = false;
  }
  return n2;
}
function $e() {
  return ("undefined" != typeof window ? window : globalThis).__localeId__;
}
function Ge(e3) {
  if ("string" == typeof e3) {
    var t3 = "undefined" != typeof window ? window : globalThis;
    return t3.__localeData__ ? t3.__localeData__[e3] : null;
  }
  return e3;
}
function Je(e3, t3) {
  return Oe(setMonth(Ye(), e3), "LLLL", t3);
}
function Xe(e3, t3) {
  return Oe(setMonth(Ye(), e3), "LLL", t3);
}
function Ze(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.excludeDateIntervals, s4 = t3.includeDates, i3 = t3.includeDateIntervals, p2 = t3.filterDate;
  return it(e3, { minDate: r2, maxDate: n2 }) || o2 && o2.some((function(t4) {
    return He(e3, t4);
  })) || a4 && a4.some((function(t4) {
    var r3 = t4.start, n3 = t4.end;
    return isWithinInterval(e3, { start: r3, end: n3 });
  })) || s4 && !s4.some((function(t4) {
    return He(e3, t4);
  })) || i3 && !i3.some((function(t4) {
    var r3 = t4.start, n3 = t4.end;
    return isWithinInterval(e3, { start: r3, end: n3 });
  })) || p2 && !p2(Ye(e3)) || false;
}
function et(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.excludeDates, n2 = t3.excludeDateIntervals;
  return n2 && n2.length > 0 ? n2.some((function(t4) {
    var r3 = t4.start, n3 = t4.end;
    return isWithinInterval(e3, { start: r3, end: n3 });
  })) : r2 && r2.some((function(t4) {
    return He(e3, t4);
  })) || false;
}
function tt(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate;
  return it(e3, { minDate: startOfMonth(r2), maxDate: endOfMonth(n2) }) || o2 && o2.some((function(t4) {
    return We(e3, t4);
  })) || a4 && !a4.some((function(t4) {
    return We(e3, t4);
  })) || s4 && !s4(Ye(e3)) || false;
}
function rt(e3, t3, r2, n2) {
  var o2 = getYear(e3), a4 = getMonth(e3), s4 = getYear(t3), i3 = getMonth(t3), p2 = getYear(n2);
  return o2 === s4 && o2 === p2 ? a4 <= r2 && r2 <= i3 : o2 < s4 ? p2 === o2 && a4 <= r2 || p2 === s4 && i3 >= r2 || p2 < s4 && p2 > o2 : void 0;
}
function nt(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate;
  return it(e3, { minDate: r2, maxDate: n2 }) || o2 && o2.some((function(t4) {
    return je(e3, t4);
  })) || a4 && !a4.some((function(t4) {
    return je(e3, t4);
  })) || s4 && !s4(Ye(e3)) || false;
}
function ot(e3, t3, r2) {
  if (!isValid(t3) || !isValid(r2)) return false;
  var n2 = getYear(t3), a4 = getYear(r2);
  return n2 <= e3 && a4 >= e3;
}
function at(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate, i3 = new Date(e3, 0, 1);
  return it(i3, { minDate: startOfYear(r2), maxDate: endOfYear(n2) }) || o2 && o2.some((function(e4) {
    return Qe(i3, e4);
  })) || a4 && !a4.some((function(e4) {
    return Qe(i3, e4);
  })) || s4 && !s4(Ye(i3)) || false;
}
function st(e3, t3, r2, n2) {
  var o2 = getYear(e3), a4 = getQuarter(e3), s4 = getYear(t3), i3 = getQuarter(t3), p2 = getYear(n2);
  return o2 === s4 && o2 === p2 ? a4 <= r2 && r2 <= i3 : o2 < s4 ? p2 === o2 && a4 <= r2 || p2 === s4 && i3 >= r2 || p2 < s4 && p2 > o2 : void 0;
}
function it(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate;
  return r2 && differenceInCalendarDays(e3, r2) < 0 || n2 && differenceInCalendarDays(e3, n2) > 0;
}
function pt(e3, t3) {
  return t3.some((function(t4) {
    return getHours(t4) === getHours(e3) && getMinutes(t4) === getMinutes(e3);
  }));
}
function ct(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.excludeTimes, n2 = t3.includeTimes, o2 = t3.filterTime;
  return r2 && pt(e3, r2) || n2 && !pt(e3, n2) || o2 && !o2(e3) || false;
}
function lt(e3, t3) {
  var r2 = t3.minTime, n2 = t3.maxTime;
  if (!r2 || !n2) throw new Error("Both minTime and maxTime props required");
  var o2, a4 = Ye(), s4 = setHours(setMinutes(a4, getMinutes(e3)), getHours(e3)), i3 = setHours(setMinutes(a4, getMinutes(r2)), getHours(r2)), p2 = setHours(setMinutes(a4, getMinutes(n2)), getHours(n2));
  try {
    o2 = !isWithinInterval(s4, { start: i3, end: p2 });
  } catch (e4) {
    o2 = false;
  }
  return o2;
}
function dt(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.includeDates, o2 = subMonths(e3, 1);
  return r2 && differenceInCalendarMonths(r2, o2) > 0 || n2 && n2.every((function(e4) {
    return differenceInCalendarMonths(e4, o2) > 0;
  })) || false;
}
function ut(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.maxDate, n2 = t3.includeDates, o2 = addMonths(e3, 1);
  return r2 && differenceInCalendarMonths(o2, r2) > 0 || n2 && n2.every((function(e4) {
    return differenceInCalendarMonths(o2, e4) > 0;
  })) || false;
}
function ht(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.includeDates, o2 = subYears(e3, 1);
  return r2 && differenceInCalendarYears(r2, o2) > 0 || n2 && n2.every((function(e4) {
    return differenceInCalendarYears(e4, o2) > 0;
  })) || false;
}
function mt(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.maxDate, n2 = t3.includeDates, o2 = addYears(e3, 1);
  return r2 && differenceInCalendarYears(o2, r2) > 0 || n2 && n2.every((function(e4) {
    return differenceInCalendarYears(o2, e4) > 0;
  })) || false;
}
function ft(e3) {
  var t3 = e3.minDate, r2 = e3.includeDates;
  if (r2 && t3) {
    var n2 = r2.filter((function(e4) {
      return differenceInCalendarDays(e4, t3) >= 0;
    }));
    return min$1(n2);
  }
  return r2 ? min$1(r2) : t3;
}
function vt(e3) {
  var t3 = e3.maxDate, r2 = e3.includeDates;
  if (r2 && t3) {
    var n2 = r2.filter((function(e4) {
      return differenceInCalendarDays(e4, t3) <= 0;
    }));
    return max$1(n2);
  }
  return r2 ? max$1(r2) : t3;
}
function yt() {
  for (var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r2 = /* @__PURE__ */ new Map(), o2 = 0, a4 = e3.length; o2 < a4; o2++) {
    var s4 = e3[o2];
    if (isDate(s4)) {
      var i3 = Oe(s4, "MM.dd.yyyy"), p2 = r2.get(i3) || [];
      p2.includes(t3) || (p2.push(t3), r2.set(i3, p2));
    } else if ("object" === ue(s4)) {
      var c3 = Object.keys(s4), l2 = c3[0], d4 = s4[c3[0]];
      if ("string" == typeof l2 && d4.constructor === Array) for (var u3 = 0, h4 = d4.length; u3 < h4; u3++) {
        var m4 = Oe(d4[u3], "MM.dd.yyyy"), f2 = r2.get(m4) || [];
        f2.includes(l2) || (f2.push(l2), r2.set(m4, f2));
      }
    }
  }
  return r2;
}
function Dt(e3, t3, r2, n2, o2) {
  for (var a4 = o2.length, p2 = [], c3 = 0; c3 < a4; c3++) {
    var l2 = addMinutes(addHours(e3, getHours(o2[c3])), getMinutes(o2[c3])), d4 = addMinutes(e3, (r2 + 1) * n2);
    isAfter(l2, t3) && isBefore(l2, d4) && p2.push(o2[c3]);
  }
  return p2;
}
function gt(e3) {
  return e3 < 10 ? "0".concat(e3) : "".concat(e3);
}
function wt(e3) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ne, r2 = Math.ceil(getYear(e3) / t3) * t3;
  return { startPeriod: r2 - (t3 - 1), endPeriod: r2 };
}
function kt(e3, t3, r2, n2) {
  for (var o2 = [], a4 = 0; a4 < 2 * t3 + 1; a4++) {
    var s4 = e3 + t3 - a4, i3 = true;
    r2 && (i3 = getYear(r2) <= s4), n2 && i3 && (i3 = getYear(n2) >= s4), i3 && o2.push(s4);
  }
  return o2;
}
var bt = onClickOutsideHOC((function(n2) {
  De(a4, React__default.Component);
  var o2 = be(a4);
  function a4(r2) {
    var n3;
    he(this, a4), ve(ke(n3 = o2.call(this, r2)), "renderOptions", (function() {
      var t3 = n3.props.year, r3 = n3.state.yearsList.map((function(r4) {
        return React__default.createElement("div", { className: t3 === r4 ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: r4, onClick: n3.onChange.bind(ke(n3), r4), "aria-selected": t3 === r4 ? "true" : void 0 }, t3 === r4 ? React__default.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", r4);
      })), o3 = n3.props.minDate ? getYear(n3.props.minDate) : null, a5 = n3.props.maxDate ? getYear(n3.props.maxDate) : null;
      return a5 && n3.state.yearsList.find((function(e3) {
        return e3 === a5;
      })) || r3.unshift(React__default.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: n3.incrementYears }, React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), o3 && n3.state.yearsList.find((function(e3) {
        return e3 === o3;
      })) || r3.push(React__default.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: n3.decrementYears }, React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), r3;
    })), ve(ke(n3), "onChange", (function(e3) {
      n3.props.onChange(e3);
    })), ve(ke(n3), "handleClickOutside", (function() {
      n3.props.onCancel();
    })), ve(ke(n3), "shiftYears", (function(e3) {
      var t3 = n3.state.yearsList.map((function(t4) {
        return t4 + e3;
      }));
      n3.setState({ yearsList: t3 });
    })), ve(ke(n3), "incrementYears", (function() {
      return n3.shiftYears(1);
    })), ve(ke(n3), "decrementYears", (function() {
      return n3.shiftYears(-1);
    }));
    var s4 = r2.yearDropdownItemNumber, i3 = r2.scrollableYearDropdown, p2 = s4 || (i3 ? 10 : 5);
    return n3.state = { yearsList: kt(n3.props.year, p2, n3.props.minDate, n3.props.maxDate) }, n3.dropdownRef = createRef(), n3;
  }
  return fe(a4, [{ key: "componentDidMount", value: function() {
    var e3 = this.dropdownRef.current;
    if (e3) {
      var t3 = e3.children ? Array.from(e3.children) : null, r2 = t3 ? t3.find((function(e4) {
        return e4.ariaSelected;
      })) : null;
      e3.scrollTop = r2 ? r2.offsetTop + (r2.clientHeight - e3.clientHeight) / 2 : (e3.scrollHeight - e3.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var t3 = r({ "react-datepicker__year-dropdown": true, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return React__default.createElement("div", { className: t3, ref: this.dropdownRef }, this.renderOptions());
  } }]), a4;
})()), St = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), ve(ke(t4), "renderSelectOptions", (function() {
      for (var r3 = t4.props.minDate ? getYear(t4.props.minDate) : 1900, n3 = t4.props.maxDate ? getYear(t4.props.maxDate) : 2100, o3 = [], a5 = r3; a5 <= n3; a5++) o3.push(React__default.createElement("option", { key: a5, value: a5 }, a5));
      return o3;
    })), ve(ke(t4), "onSelectChange", (function(e3) {
      t4.onChange(e3.target.value);
    })), ve(ke(t4), "renderSelectMode", (function() {
      return React__default.createElement("select", { value: t4.props.year, className: "react-datepicker__year-select", onChange: t4.onSelectChange }, t4.renderSelectOptions());
    })), ve(ke(t4), "renderReadView", (function(r3) {
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(e3) {
        return t4.toggleDropdown(e3);
      } }, React__default.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t4.props.year));
    })), ve(ke(t4), "renderDropdown", (function() {
      return React__default.createElement(bt, { key: "dropdown", year: t4.props.year, onChange: t4.onChange, onCancel: t4.toggleDropdown, minDate: t4.props.minDate, maxDate: t4.props.maxDate, scrollableYearDropdown: t4.props.scrollableYearDropdown, yearDropdownItemNumber: t4.props.yearDropdownItemNumber });
    })), ve(ke(t4), "renderScrollMode", (function() {
      var e3 = t4.state.dropdownVisible, r3 = [t4.renderReadView(!e3)];
      return e3 && r3.unshift(t4.renderDropdown()), r3;
    })), ve(ke(t4), "onChange", (function(e3) {
      t4.toggleDropdown(), e3 !== t4.props.year && t4.props.onChange(e3);
    })), ve(ke(t4), "toggleDropdown", (function(e3) {
      t4.setState({ dropdownVisible: !t4.state.dropdownVisible }, (function() {
        t4.props.adjustDateOnChange && t4.handleYearChange(t4.props.date, e3);
      }));
    })), ve(ke(t4), "handleYearChange", (function(e3, r3) {
      t4.onSelect(e3, r3), t4.setOpen();
    })), ve(ke(t4), "onSelect", (function(e3, r3) {
      t4.props.onSelect && t4.props.onSelect(e3, r3);
    })), ve(ke(t4), "setOpen", (function() {
      t4.props.setOpen && t4.props.setOpen(true);
    })), t4;
  }
  return fe(n2, [{ key: "render", value: function() {
    var t4;
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode();
        break;
      case "select":
        t4 = this.renderSelectMode();
    }
    return React__default.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
})(), Ct = onClickOutsideHOC((function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "isSelectedMonth", (function(e3) {
      return t4.props.month === e3;
    })), ve(ke(t4), "renderOptions", (function() {
      return t4.props.monthNames.map((function(r3, n3) {
        return React__default.createElement("div", { className: t4.isSelectedMonth(n3) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: r3, onClick: t4.onChange.bind(ke(t4), n3), "aria-selected": t4.isSelectedMonth(n3) ? "true" : void 0 }, t4.isSelectedMonth(n3) ? React__default.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", r3);
      }));
    })), ve(ke(t4), "onChange", (function(e3) {
      return t4.props.onChange(e3);
    })), ve(ke(t4), "handleClickOutside", (function() {
      return t4.props.onCancel();
    })), t4;
  }
  return fe(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n2;
})()), _t = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), ve(ke(t4), "renderSelectOptions", (function(t5) {
      return t5.map((function(t6, r3) {
        return React__default.createElement("option", { key: r3, value: r3 }, t6);
      }));
    })), ve(ke(t4), "renderSelectMode", (function(r3) {
      return React__default.createElement("select", { value: t4.props.month, className: "react-datepicker__month-select", onChange: function(e3) {
        return t4.onChange(e3.target.value);
      } }, t4.renderSelectOptions(r3));
    })), ve(ke(t4), "renderReadView", (function(r3, n3) {
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t4.toggleDropdown }, React__default.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, n3[t4.props.month]));
    })), ve(ke(t4), "renderDropdown", (function(r3) {
      return React__default.createElement(Ct, { key: "dropdown", month: t4.props.month, monthNames: r3, onChange: t4.onChange, onCancel: t4.toggleDropdown });
    })), ve(ke(t4), "renderScrollMode", (function(e3) {
      var r3 = t4.state.dropdownVisible, n3 = [t4.renderReadView(!r3, e3)];
      return r3 && n3.unshift(t4.renderDropdown(e3)), n3;
    })), ve(ke(t4), "onChange", (function(e3) {
      t4.toggleDropdown(), e3 !== t4.props.month && t4.props.onChange(e3);
    })), ve(ke(t4), "toggleDropdown", (function() {
      return t4.setState({ dropdownVisible: !t4.state.dropdownVisible });
    })), t4;
  }
  return fe(n2, [{ key: "render", value: function() {
    var t4, r3 = this, n3 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(e3) {
      return Xe(e3, r3.props.locale);
    } : function(e3) {
      return Je(e3, r3.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode(n3);
        break;
      case "select":
        t4 = this.renderSelectMode(n3);
    }
    return React__default.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
})();
function Mt(e3, t3) {
  for (var r2 = [], n2 = Fe(e3), o2 = Fe(t3); !isAfter(n2, o2); ) r2.push(Ye(n2)), n2 = addMonths(n2, 1);
  return r2;
}
var Et, Pt = onClickOutsideHOC((function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2(t4) {
    var r2;
    return he(this, o2), ve(ke(r2 = n2.call(this, t4)), "renderOptions", (function() {
      return r2.state.monthYearsList.map((function(t5) {
        var n3 = getTime(t5), o3 = Qe(r2.props.date, t5) && We(r2.props.date, t5);
        return React__default.createElement("div", { className: o3 ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: n3, onClick: r2.onChange.bind(ke(r2), n3), "aria-selected": o3 ? "true" : void 0 }, o3 ? React__default.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", Oe(t5, r2.props.dateFormat, r2.props.locale));
      }));
    })), ve(ke(r2), "onChange", (function(e3) {
      return r2.props.onChange(e3);
    })), ve(ke(r2), "handleClickOutside", (function() {
      r2.props.onCancel();
    })), r2.state = { monthYearsList: Mt(r2.props.minDate, r2.props.maxDate) }, r2;
  }
  return fe(o2, [{ key: "render", value: function() {
    var t4 = r({ "react-datepicker__month-year-dropdown": true, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return React__default.createElement("div", { className: t4 }, this.renderOptions());
  } }]), o2;
})()), Nt = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), ve(ke(t4), "renderSelectOptions", (function() {
      for (var r3 = Fe(t4.props.minDate), n3 = Fe(t4.props.maxDate), o3 = []; !isAfter(r3, n3); ) {
        var a5 = getTime(r3);
        o3.push(React__default.createElement("option", { key: a5, value: a5 }, Oe(r3, t4.props.dateFormat, t4.props.locale))), r3 = addMonths(r3, 1);
      }
      return o3;
    })), ve(ke(t4), "onSelectChange", (function(e3) {
      t4.onChange(e3.target.value);
    })), ve(ke(t4), "renderSelectMode", (function() {
      return React__default.createElement("select", { value: getTime(Fe(t4.props.date)), className: "react-datepicker__month-year-select", onChange: t4.onSelectChange }, t4.renderSelectOptions());
    })), ve(ke(t4), "renderReadView", (function(r3) {
      var n3 = Oe(t4.props.date, t4.props.dateFormat, t4.props.locale);
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(e3) {
        return t4.toggleDropdown(e3);
      } }, React__default.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, n3));
    })), ve(ke(t4), "renderDropdown", (function() {
      return React__default.createElement(Pt, { key: "dropdown", date: t4.props.date, dateFormat: t4.props.dateFormat, onChange: t4.onChange, onCancel: t4.toggleDropdown, minDate: t4.props.minDate, maxDate: t4.props.maxDate, scrollableMonthYearDropdown: t4.props.scrollableMonthYearDropdown, locale: t4.props.locale });
    })), ve(ke(t4), "renderScrollMode", (function() {
      var e3 = t4.state.dropdownVisible, r3 = [t4.renderReadView(!e3)];
      return e3 && r3.unshift(t4.renderDropdown()), r3;
    })), ve(ke(t4), "onChange", (function(e3) {
      t4.toggleDropdown();
      var r3 = Ye(parseInt(e3));
      Qe(t4.props.date, r3) && We(t4.props.date, r3) || t4.props.onChange(r3);
    })), ve(ke(t4), "toggleDropdown", (function() {
      return t4.setState({ dropdownVisible: !t4.state.dropdownVisible });
    })), t4;
  }
  return fe(n2, [{ key: "render", value: function() {
    var t4;
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode();
        break;
      case "select":
        t4 = this.renderSelectMode();
    }
    return React__default.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
})(), xt = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2() {
    var t4;
    he(this, o2);
    for (var a4 = arguments.length, s4 = new Array(a4), i3 = 0; i3 < a4; i3++) s4[i3] = arguments[i3];
    return ve(ke(t4 = n2.call.apply(n2, [this].concat(s4))), "dayEl", React__default.createRef()), ve(ke(t4), "handleClick", (function(e3) {
      !t4.isDisabled() && t4.props.onClick && t4.props.onClick(e3);
    })), ve(ke(t4), "handleMouseEnter", (function(e3) {
      !t4.isDisabled() && t4.props.onMouseEnter && t4.props.onMouseEnter(e3);
    })), ve(ke(t4), "handleOnKeyDown", (function(e3) {
      " " === e3.key && (e3.preventDefault(), e3.key = "Enter"), t4.props.handleOnKeyDown(e3);
    })), ve(ke(t4), "isSameDay", (function(e3) {
      return He(t4.props.day, e3);
    })), ve(ke(t4), "isKeyboardSelected", (function() {
      return !t4.props.disabledKeyboardNavigation && !t4.isSameDay(t4.props.selected) && t4.isSameDay(t4.props.preSelection);
    })), ve(ke(t4), "isDisabled", (function() {
      return Ze(t4.props.day, t4.props);
    })), ve(ke(t4), "isExcluded", (function() {
      return et(t4.props.day, t4.props);
    })), ve(ke(t4), "getHighLightedClass", (function() {
      var e3 = t4.props, r2 = e3.day, n3 = e3.highlightDates;
      if (!n3) return false;
      var o3 = Oe(r2, "MM.dd.yyyy");
      return n3.get(o3);
    })), ve(ke(t4), "isInRange", (function() {
      var e3 = t4.props, r2 = e3.day, n3 = e3.startDate, o3 = e3.endDate;
      return !(!n3 || !o3) && qe(r2, n3, o3);
    })), ve(ke(t4), "isInSelectingRange", (function() {
      var e3, r2 = t4.props, n3 = r2.day, o3 = r2.selectsStart, a5 = r2.selectsEnd, s5 = r2.selectsRange, i4 = r2.selectsDisabledDaysInRange, p2 = r2.startDate, c3 = r2.endDate, l2 = null !== (e3 = t4.props.selectingDate) && void 0 !== e3 ? e3 : t4.props.preSelection;
      return !(!(o3 || a5 || s5) || !l2 || !i4 && t4.isDisabled()) && (o3 && c3 && (isBefore(l2, c3) || Ve(l2, c3)) ? qe(n3, l2, c3) : (a5 && p2 && (isAfter(l2, p2) || Ve(l2, p2)) || !(!s5 || !p2 || c3 || !isAfter(l2, p2) && !Ve(l2, p2))) && qe(n3, p2, l2));
    })), ve(ke(t4), "isSelectingRangeStart", (function() {
      var e3;
      if (!t4.isInSelectingRange()) return false;
      var r2 = t4.props, n3 = r2.day, o3 = r2.startDate, a5 = r2.selectsStart, s5 = null !== (e3 = t4.props.selectingDate) && void 0 !== e3 ? e3 : t4.props.preSelection;
      return He(n3, a5 ? s5 : o3);
    })), ve(ke(t4), "isSelectingRangeEnd", (function() {
      var e3;
      if (!t4.isInSelectingRange()) return false;
      var r2 = t4.props, n3 = r2.day, o3 = r2.endDate, a5 = r2.selectsEnd, s5 = r2.selectsRange, i4 = null !== (e3 = t4.props.selectingDate) && void 0 !== e3 ? e3 : t4.props.preSelection;
      return He(n3, a5 || s5 ? i4 : o3);
    })), ve(ke(t4), "isRangeStart", (function() {
      var e3 = t4.props, r2 = e3.day, n3 = e3.startDate, o3 = e3.endDate;
      return !(!n3 || !o3) && He(n3, r2);
    })), ve(ke(t4), "isRangeEnd", (function() {
      var e3 = t4.props, r2 = e3.day, n3 = e3.startDate, o3 = e3.endDate;
      return !(!n3 || !o3) && He(o3, r2);
    })), ve(ke(t4), "isWeekend", (function() {
      var e3 = getDay(t4.props.day);
      return 0 === e3 || 6 === e3;
    })), ve(ke(t4), "isAfterMonth", (function() {
      return void 0 !== t4.props.month && (t4.props.month + 1) % 12 === getMonth(t4.props.day);
    })), ve(ke(t4), "isBeforeMonth", (function() {
      return void 0 !== t4.props.month && (getMonth(t4.props.day) + 1) % 12 === t4.props.month;
    })), ve(ke(t4), "isCurrentDay", (function() {
      return t4.isSameDay(Ye());
    })), ve(ke(t4), "isSelected", (function() {
      return t4.isSameDay(t4.props.selected);
    })), ve(ke(t4), "getClassNames", (function(e3) {
      var n3, o3 = t4.props.dayClassName ? t4.props.dayClassName(e3) : void 0;
      return r("react-datepicker__day", o3, "react-datepicker__day--" + Oe(t4.props.day, "ddd", n3), { "react-datepicker__day--disabled": t4.isDisabled(), "react-datepicker__day--excluded": t4.isExcluded(), "react-datepicker__day--selected": t4.isSelected(), "react-datepicker__day--keyboard-selected": t4.isKeyboardSelected(), "react-datepicker__day--range-start": t4.isRangeStart(), "react-datepicker__day--range-end": t4.isRangeEnd(), "react-datepicker__day--in-range": t4.isInRange(), "react-datepicker__day--in-selecting-range": t4.isInSelectingRange(), "react-datepicker__day--selecting-range-start": t4.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": t4.isSelectingRangeEnd(), "react-datepicker__day--today": t4.isCurrentDay(), "react-datepicker__day--weekend": t4.isWeekend(), "react-datepicker__day--outside-month": t4.isAfterMonth() || t4.isBeforeMonth() }, t4.getHighLightedClass("react-datepicker__day--highlighted"));
    })), ve(ke(t4), "getAriaLabel", (function() {
      var e3 = t4.props, r2 = e3.day, n3 = e3.ariaLabelPrefixWhenEnabled, o3 = void 0 === n3 ? "Choose" : n3, a5 = e3.ariaLabelPrefixWhenDisabled, s5 = void 0 === a5 ? "Not available" : a5, i4 = t4.isDisabled() || t4.isExcluded() ? s5 : o3;
      return "".concat(i4, " ").concat(Oe(r2, "PPPP", t4.props.locale));
    })), ve(ke(t4), "getTabIndex", (function(e3, r2) {
      var n3 = e3 || t4.props.selected, o3 = r2 || t4.props.preSelection;
      return t4.isKeyboardSelected() || t4.isSameDay(n3) && He(o3, n3) ? 0 : -1;
    })), ve(ke(t4), "handleFocusDay", (function() {
      var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = false;
      0 === t4.getTabIndex() && !e3.isInputFocused && t4.isSameDay(t4.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r2 = true), t4.props.inline && !t4.props.shouldFocusDayInline && (r2 = false), t4.props.containerRef && t4.props.containerRef.current && t4.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r2 = true), t4.props.monthShowsDuplicateDaysEnd && t4.isAfterMonth() && (r2 = false), t4.props.monthShowsDuplicateDaysStart && t4.isBeforeMonth() && (r2 = false)), r2 && t4.dayEl.current.focus({ preventScroll: true });
    })), ve(ke(t4), "renderDayContents", (function() {
      return t4.props.monthShowsDuplicateDaysEnd && t4.isAfterMonth() || t4.props.monthShowsDuplicateDaysStart && t4.isBeforeMonth() ? null : t4.props.renderDayContents ? t4.props.renderDayContents(getDate(t4.props.day), t4.props.day) : getDate(t4.props.day);
    })), ve(ke(t4), "render", (function() {
      return React__default.createElement("div", { ref: t4.dayEl, className: t4.getClassNames(t4.props.day), onKeyDown: t4.handleOnKeyDown, onClick: t4.handleClick, onMouseEnter: t4.handleMouseEnter, tabIndex: t4.getTabIndex(), "aria-label": t4.getAriaLabel(), role: "option", "aria-disabled": t4.isDisabled(), "aria-current": t4.isCurrentDay() ? "date" : void 0, "aria-selected": t4.isSelected() || t4.isInRange() }, t4.renderDayContents());
    })), t4;
  }
  return fe(o2, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(e3) {
    this.handleFocusDay(e3);
  } }]), o2;
})(), Yt = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2() {
    var e3;
    he(this, o2);
    for (var t4 = arguments.length, r2 = new Array(t4), a4 = 0; a4 < t4; a4++) r2[a4] = arguments[a4];
    return ve(ke(e3 = n2.call.apply(n2, [this].concat(r2))), "handleClick", (function(t5) {
      e3.props.onClick && e3.props.onClick(t5);
    })), e3;
  }
  return fe(o2, [{ key: "render", value: function() {
    var t4 = this.props, n3 = t4.weekNumber, o3 = t4.ariaLabelPrefix, a4 = void 0 === o3 ? "week " : o3, s4 = { "react-datepicker__week-number": true, "react-datepicker__week-number--clickable": !!t4.onClick };
    return React__default.createElement("div", { className: r(s4), "aria-label": "".concat(a4, " ").concat(this.props.weekNumber), onClick: this.handleClick }, n3);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), o2;
})(), It = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "handleDayClick", (function(e3, r3) {
      t4.props.onDayClick && t4.props.onDayClick(e3, r3);
    })), ve(ke(t4), "handleDayMouseEnter", (function(e3) {
      t4.props.onDayMouseEnter && t4.props.onDayMouseEnter(e3);
    })), ve(ke(t4), "handleWeekClick", (function(e3, r3, n3) {
      "function" == typeof t4.props.onWeekSelect && t4.props.onWeekSelect(e3, r3, n3), t4.props.shouldCloseOnSelect && t4.props.setOpen(false);
    })), ve(ke(t4), "formatWeekNumber", (function(e3) {
      return t4.props.formatWeekNumber ? t4.props.formatWeekNumber(e3) : (function(e4, t5) {
        var r3 = $e() && Ge($e());
        return getISOWeek(e4, r3 ? { locale: r3 } : null);
      })(e3);
    })), ve(ke(t4), "renderDays", (function() {
      var r3 = Le(t4.props.day, t4.props.locale, t4.props.calendarStartDay), n3 = [], o3 = t4.formatWeekNumber(r3);
      if (t4.props.showWeekNumber) {
        var a5 = t4.props.onWeekSelect ? t4.handleWeekClick.bind(ke(t4), r3, o3) : void 0;
        n3.push(React__default.createElement(Yt, { key: "W", weekNumber: o3, onClick: a5, ariaLabelPrefix: t4.props.ariaLabelPrefix }));
      }
      return n3.concat([0, 1, 2, 3, 4, 5, 6].map((function(n4) {
        var o4 = addDays(r3, n4);
        return React__default.createElement(xt, { ariaLabelPrefixWhenEnabled: t4.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t4.props.disabledDayAriaLabelPrefix, key: o4.valueOf(), day: o4, month: t4.props.month, onClick: t4.handleDayClick.bind(ke(t4), o4), onMouseEnter: t4.handleDayMouseEnter.bind(ke(t4), o4), minDate: t4.props.minDate, maxDate: t4.props.maxDate, excludeDates: t4.props.excludeDates, excludeDateIntervals: t4.props.excludeDateIntervals, includeDates: t4.props.includeDates, includeDateIntervals: t4.props.includeDateIntervals, highlightDates: t4.props.highlightDates, selectingDate: t4.props.selectingDate, filterDate: t4.props.filterDate, preSelection: t4.props.preSelection, selected: t4.props.selected, selectsStart: t4.props.selectsStart, selectsEnd: t4.props.selectsEnd, selectsRange: t4.props.selectsRange, selectsDisabledDaysInRange: t4.props.selectsDisabledDaysInRange, startDate: t4.props.startDate, endDate: t4.props.endDate, dayClassName: t4.props.dayClassName, renderDayContents: t4.props.renderDayContents, disabledKeyboardNavigation: t4.props.disabledKeyboardNavigation, handleOnKeyDown: t4.props.handleOnKeyDown, isInputFocused: t4.props.isInputFocused, containerRef: t4.props.containerRef, inline: t4.props.inline, shouldFocusDayInline: t4.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: t4.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t4.props.monthShowsDuplicateDaysStart, locale: t4.props.locale });
      })));
    })), t4;
  }
  return fe(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__week" }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: true };
  } }]), n2;
})(), Ot = "two_columns", Tt = "three_columns", Rt = "four_columns", Lt = (ve(Et = {}, Ot, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), ve(Et, Tt, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), ve(Et, Rt, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 }), Et);
function Ft(e3, t3) {
  return e3 ? Rt : t3 ? Ot : Tt;
}
var At = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2() {
    var t4;
    he(this, o2);
    for (var a4 = arguments.length, s4 = new Array(a4), i3 = 0; i3 < a4; i3++) s4[i3] = arguments[i3];
    return ve(ke(t4 = n2.call.apply(n2, [this].concat(s4))), "MONTH_REFS", Se(Array(12)).map((function() {
      return React__default.createRef();
    }))), ve(ke(t4), "QUARTER_REFS", Se(Array(4)).map((function() {
      return React__default.createRef();
    }))), ve(ke(t4), "isDisabled", (function(e3) {
      return Ze(e3, t4.props);
    })), ve(ke(t4), "isExcluded", (function(e3) {
      return et(e3, t4.props);
    })), ve(ke(t4), "handleDayClick", (function(e3, r2) {
      t4.props.onDayClick && t4.props.onDayClick(e3, r2, t4.props.orderInDisplay);
    })), ve(ke(t4), "handleDayMouseEnter", (function(e3) {
      t4.props.onDayMouseEnter && t4.props.onDayMouseEnter(e3);
    })), ve(ke(t4), "handleMouseLeave", (function() {
      t4.props.onMouseLeave && t4.props.onMouseLeave();
    })), ve(ke(t4), "isRangeStartMonth", (function(e3) {
      var r2 = t4.props, n3 = r2.day, o3 = r2.startDate, a5 = r2.endDate;
      return !(!o3 || !a5) && We(setMonth(n3, e3), o3);
    })), ve(ke(t4), "isRangeStartQuarter", (function(e3) {
      var r2 = t4.props, n3 = r2.day, o3 = r2.startDate, a5 = r2.endDate;
      return !(!o3 || !a5) && je(setQuarter(n3, e3), o3);
    })), ve(ke(t4), "isRangeEndMonth", (function(e3) {
      var r2 = t4.props, n3 = r2.day, o3 = r2.startDate, a5 = r2.endDate;
      return !(!o3 || !a5) && We(setMonth(n3, e3), a5);
    })), ve(ke(t4), "isRangeEndQuarter", (function(e3) {
      var r2 = t4.props, n3 = r2.day, o3 = r2.startDate, a5 = r2.endDate;
      return !(!o3 || !a5) && je(setQuarter(n3, e3), a5);
    })), ve(ke(t4), "isInSelectingRangeMonth", (function(e3) {
      var r2, n3 = t4.props, o3 = n3.day, a5 = n3.selectsStart, s5 = n3.selectsEnd, i4 = n3.selectsRange, p2 = n3.startDate, c3 = n3.endDate, l2 = null !== (r2 = t4.props.selectingDate) && void 0 !== r2 ? r2 : t4.props.preSelection;
      return !(!(a5 || s5 || i4) || !l2) && (a5 && c3 ? rt(l2, c3, e3, o3) : (s5 && p2 || !(!i4 || !p2 || c3)) && rt(p2, l2, e3, o3));
    })), ve(ke(t4), "isSelectingMonthRangeStart", (function(e3) {
      var r2;
      if (!t4.isInSelectingRangeMonth(e3)) return false;
      var n3 = t4.props, o3 = n3.day, a5 = n3.startDate, s5 = n3.selectsStart, i4 = setMonth(o3, e3), p2 = null !== (r2 = t4.props.selectingDate) && void 0 !== r2 ? r2 : t4.props.preSelection;
      return We(i4, s5 ? p2 : a5);
    })), ve(ke(t4), "isSelectingMonthRangeEnd", (function(e3) {
      var r2;
      if (!t4.isInSelectingRangeMonth(e3)) return false;
      var n3 = t4.props, o3 = n3.day, a5 = n3.endDate, s5 = n3.selectsEnd, i4 = n3.selectsRange, p2 = setMonth(o3, e3), c3 = null !== (r2 = t4.props.selectingDate) && void 0 !== r2 ? r2 : t4.props.preSelection;
      return We(p2, s5 || i4 ? c3 : a5);
    })), ve(ke(t4), "isInSelectingRangeQuarter", (function(e3) {
      var r2, n3 = t4.props, o3 = n3.day, a5 = n3.selectsStart, s5 = n3.selectsEnd, i4 = n3.selectsRange, p2 = n3.startDate, c3 = n3.endDate, l2 = null !== (r2 = t4.props.selectingDate) && void 0 !== r2 ? r2 : t4.props.preSelection;
      return !(!(a5 || s5 || i4) || !l2) && (a5 && c3 ? st(l2, c3, e3, o3) : (s5 && p2 || !(!i4 || !p2 || c3)) && st(p2, l2, e3, o3));
    })), ve(ke(t4), "isWeekInMonth", (function(e3) {
      var r2 = t4.props.day, n3 = addDays(e3, 6);
      return We(e3, r2) || We(n3, r2);
    })), ve(ke(t4), "isCurrentMonth", (function(e3, t5) {
      return getYear(e3) === getYear(Ye()) && t5 === getMonth(Ye());
    })), ve(ke(t4), "isCurrentQuarter", (function(e3, t5) {
      return getYear(e3) === getYear(Ye()) && t5 === getQuarter(Ye());
    })), ve(ke(t4), "isSelectedMonth", (function(e3, t5, r2) {
      return getMonth(r2) === t5 && getYear(e3) === getYear(r2);
    })), ve(ke(t4), "isSelectedQuarter", (function(e3, t5, r2) {
      return getQuarter(e3) === t5 && getYear(e3) === getYear(r2);
    })), ve(ke(t4), "renderWeeks", (function() {
      for (var r2 = [], n3 = t4.props.fixedHeight, o3 = 0, a5 = false, s5 = Le(Fe(t4.props.day), t4.props.locale, t4.props.calendarStartDay); r2.push(React__default.createElement(It, { ariaLabelPrefix: t4.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: t4.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t4.props.disabledDayAriaLabelPrefix, key: o3, day: s5, month: getMonth(t4.props.day), onDayClick: t4.handleDayClick, onDayMouseEnter: t4.handleDayMouseEnter, onWeekSelect: t4.props.onWeekSelect, formatWeekNumber: t4.props.formatWeekNumber, locale: t4.props.locale, minDate: t4.props.minDate, maxDate: t4.props.maxDate, excludeDates: t4.props.excludeDates, excludeDateIntervals: t4.props.excludeDateIntervals, includeDates: t4.props.includeDates, includeDateIntervals: t4.props.includeDateIntervals, inline: t4.props.inline, shouldFocusDayInline: t4.props.shouldFocusDayInline, highlightDates: t4.props.highlightDates, selectingDate: t4.props.selectingDate, filterDate: t4.props.filterDate, preSelection: t4.props.preSelection, selected: t4.props.selected, selectsStart: t4.props.selectsStart, selectsEnd: t4.props.selectsEnd, selectsRange: t4.props.selectsRange, selectsDisabledDaysInRange: t4.props.selectsDisabledDaysInRange, showWeekNumber: t4.props.showWeekNumbers, startDate: t4.props.startDate, endDate: t4.props.endDate, dayClassName: t4.props.dayClassName, setOpen: t4.props.setOpen, shouldCloseOnSelect: t4.props.shouldCloseOnSelect, disabledKeyboardNavigation: t4.props.disabledKeyboardNavigation, renderDayContents: t4.props.renderDayContents, handleOnKeyDown: t4.props.handleOnKeyDown, isInputFocused: t4.props.isInputFocused, containerRef: t4.props.containerRef, calendarStartDay: t4.props.calendarStartDay, monthShowsDuplicateDaysEnd: t4.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t4.props.monthShowsDuplicateDaysStart })), !a5; ) {
        o3++, s5 = addWeeks(s5, 1);
        var i4 = n3 && o3 >= 6, p2 = !n3 && !t4.isWeekInMonth(s5);
        if (i4 || p2) {
          if (!t4.props.peekNextMonth) break;
          a5 = true;
        }
      }
      return r2;
    })), ve(ke(t4), "onMonthClick", (function(e3, r2) {
      t4.handleDayClick(Fe(setMonth(t4.props.day, r2)), e3);
    })), ve(ke(t4), "onMonthMouseEnter", (function(e3) {
      t4.handleDayMouseEnter(Fe(setMonth(t4.props.day, e3)));
    })), ve(ke(t4), "handleMonthNavigation", (function(e3, r2) {
      t4.isDisabled(r2) || t4.isExcluded(r2) || (t4.props.setPreSelection(r2), t4.MONTH_REFS[e3].current && t4.MONTH_REFS[e3].current.focus());
    })), ve(ke(t4), "onMonthKeyDown", (function(e3, r2) {
      var n3 = t4.props, o3 = n3.selected, a5 = n3.preSelection, s5 = n3.disabledKeyboardNavigation, i4 = n3.showTwoColumnMonthYearPicker, p2 = n3.showFourColumnMonthYearPicker, c3 = n3.setPreSelection, d4 = e3.key;
      if ("Tab" !== d4 && e3.preventDefault(), !s5) {
        var u3 = Ft(p2, i4), h4 = Lt[u3].verticalNavigationOffset, m4 = Lt[u3].grid;
        switch (d4) {
          case "Enter":
            t4.onMonthClick(e3, r2), c3(o3);
            break;
          case "ArrowRight":
            t4.handleMonthNavigation(11 === r2 ? 0 : r2 + 1, addMonths(a5, 1));
            break;
          case "ArrowLeft":
            t4.handleMonthNavigation(0 === r2 ? 11 : r2 - 1, subMonths(a5, 1));
            break;
          case "ArrowUp":
            t4.handleMonthNavigation(m4[0].includes(r2) ? r2 + 12 - h4 : r2 - h4, subMonths(a5, h4));
            break;
          case "ArrowDown":
            t4.handleMonthNavigation(m4[m4.length - 1].includes(r2) ? r2 - 12 + h4 : r2 + h4, addMonths(a5, h4));
        }
      }
    })), ve(ke(t4), "onQuarterClick", (function(e3, r2) {
      t4.handleDayClick(Ke(setQuarter(t4.props.day, r2)), e3);
    })), ve(ke(t4), "onQuarterMouseEnter", (function(e3) {
      t4.handleDayMouseEnter(Ke(setQuarter(t4.props.day, e3)));
    })), ve(ke(t4), "handleQuarterNavigation", (function(e3, r2) {
      t4.isDisabled(r2) || t4.isExcluded(r2) || (t4.props.setPreSelection(r2), t4.QUARTER_REFS[e3 - 1].current && t4.QUARTER_REFS[e3 - 1].current.focus());
    })), ve(ke(t4), "onQuarterKeyDown", (function(e3, r2) {
      var n3 = e3.key;
      if (!t4.props.disabledKeyboardNavigation) switch (n3) {
        case "Enter":
          t4.onQuarterClick(e3, r2), t4.props.setPreSelection(t4.props.selected);
          break;
        case "ArrowRight":
          t4.handleQuarterNavigation(4 === r2 ? 1 : r2 + 1, addQuarters(t4.props.preSelection, 1));
          break;
        case "ArrowLeft":
          t4.handleQuarterNavigation(1 === r2 ? 4 : r2 - 1, subQuarters(t4.props.preSelection, 1));
      }
    })), ve(ke(t4), "getMonthClassNames", (function(e3) {
      var n3 = t4.props, o3 = n3.day, a5 = n3.startDate, s5 = n3.endDate, i4 = n3.selected, p2 = n3.minDate, c3 = n3.maxDate, l2 = n3.preSelection, d4 = n3.monthClassName, u3 = n3.excludeDates, h4 = n3.includeDates, m4 = d4 ? d4(setMonth(o3, e3)) : void 0, f2 = setMonth(o3, e3);
      return r("react-datepicker__month-text", "react-datepicker__month-".concat(e3), m4, { "react-datepicker__month-text--disabled": (p2 || c3 || u3 || h4) && tt(f2, t4.props), "react-datepicker__month-text--selected": t4.isSelectedMonth(o3, e3, i4), "react-datepicker__month-text--keyboard-selected": !t4.props.disabledKeyboardNavigation && getMonth(l2) === e3, "react-datepicker__month-text--in-selecting-range": t4.isInSelectingRangeMonth(e3), "react-datepicker__month-text--in-range": rt(a5, s5, e3, o3), "react-datepicker__month-text--range-start": t4.isRangeStartMonth(e3), "react-datepicker__month-text--range-end": t4.isRangeEndMonth(e3), "react-datepicker__month-text--selecting-range-start": t4.isSelectingMonthRangeStart(e3), "react-datepicker__month-text--selecting-range-end": t4.isSelectingMonthRangeEnd(e3), "react-datepicker__month-text--today": t4.isCurrentMonth(o3, e3) });
    })), ve(ke(t4), "getTabIndex", (function(e3) {
      var r2 = getMonth(t4.props.preSelection);
      return t4.props.disabledKeyboardNavigation || e3 !== r2 ? "-1" : "0";
    })), ve(ke(t4), "getQuarterTabIndex", (function(e3) {
      var r2 = getQuarter(t4.props.preSelection);
      return t4.props.disabledKeyboardNavigation || e3 !== r2 ? "-1" : "0";
    })), ve(ke(t4), "getAriaLabel", (function(e3) {
      var r2 = t4.props, n3 = r2.chooseDayAriaLabelPrefix, o3 = void 0 === n3 ? "Choose" : n3, a5 = r2.disabledDayAriaLabelPrefix, s5 = void 0 === a5 ? "Not available" : a5, i4 = r2.day, p2 = setMonth(i4, e3), c3 = t4.isDisabled(p2) || t4.isExcluded(p2) ? s5 : o3;
      return "".concat(c3, " ").concat(Oe(p2, "MMMM yyyy"));
    })), ve(ke(t4), "getQuarterClassNames", (function(e3) {
      var n3 = t4.props, o3 = n3.day, a5 = n3.startDate, s5 = n3.endDate, i4 = n3.selected, p2 = n3.minDate, c3 = n3.maxDate, l2 = n3.preSelection;
      return r("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e3), { "react-datepicker__quarter-text--disabled": (p2 || c3) && nt(setQuarter(o3, e3), t4.props), "react-datepicker__quarter-text--selected": t4.isSelectedQuarter(o3, e3, i4), "react-datepicker__quarter-text--keyboard-selected": getQuarter(l2) === e3, "react-datepicker__quarter-text--in-selecting-range": t4.isInSelectingRangeQuarter(e3), "react-datepicker__quarter-text--in-range": st(a5, s5, e3, o3), "react-datepicker__quarter-text--range-start": t4.isRangeStartQuarter(e3), "react-datepicker__quarter-text--range-end": t4.isRangeEndQuarter(e3) });
    })), ve(ke(t4), "getMonthContent", (function(e3) {
      var r2 = t4.props, n3 = r2.showFullMonthYearPicker, o3 = r2.renderMonthContent, a5 = r2.locale, s5 = Xe(e3, a5), i4 = Je(e3, a5);
      return o3 ? o3(e3, s5, i4) : n3 ? i4 : s5;
    })), ve(ke(t4), "getQuarterContent", (function(e3) {
      var r2 = t4.props, n3 = r2.renderQuarterContent, o3 = (function(e4, t5) {
        return Oe(setQuarter(Ye(), e4), "QQQ", t5);
      })(e3, r2.locale);
      return n3 ? n3(e3, o3) : o3;
    })), ve(ke(t4), "renderMonths", (function() {
      var r2 = t4.props, n3 = r2.showTwoColumnMonthYearPicker, o3 = r2.showFourColumnMonthYearPicker, a5 = r2.day, s5 = r2.selected;
      return Lt[Ft(o3, n3)].grid.map((function(r3, n4) {
        return React__default.createElement("div", { className: "react-datepicker__month-wrapper", key: n4 }, r3.map((function(r4, n5) {
          return React__default.createElement("div", { ref: t4.MONTH_REFS[r4], key: n5, onClick: function(e3) {
            t4.onMonthClick(e3, r4);
          }, onKeyDown: function(e3) {
            t4.onMonthKeyDown(e3, r4);
          }, onMouseEnter: function() {
            return t4.onMonthMouseEnter(r4);
          }, tabIndex: t4.getTabIndex(r4), className: t4.getMonthClassNames(r4), role: "option", "aria-label": t4.getAriaLabel(r4), "aria-current": t4.isCurrentMonth(a5, r4) ? "date" : void 0, "aria-selected": t4.isSelectedMonth(a5, r4, s5) }, t4.getMonthContent(r4));
        })));
      }));
    })), ve(ke(t4), "renderQuarters", (function() {
      var r2 = t4.props, n3 = r2.day, o3 = r2.selected;
      return React__default.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map((function(r3, a5) {
        return React__default.createElement("div", { key: a5, ref: t4.QUARTER_REFS[a5], role: "option", onClick: function(e3) {
          t4.onQuarterClick(e3, r3);
        }, onKeyDown: function(e3) {
          t4.onQuarterKeyDown(e3, r3);
        }, onMouseEnter: function() {
          return t4.onQuarterMouseEnter(r3);
        }, className: t4.getQuarterClassNames(r3), "aria-selected": t4.isSelectedQuarter(n3, r3, o3), tabIndex: t4.getQuarterTabIndex(r3), "aria-current": t4.isCurrentQuarter(n3, r3) ? "date" : void 0 }, t4.getQuarterContent(r3));
      })));
    })), ve(ke(t4), "getClassNames", (function() {
      var e3 = t4.props, n3 = e3.selectingDate, o3 = e3.selectsStart, a5 = e3.selectsEnd, s5 = e3.showMonthYearPicker, i4 = e3.showQuarterYearPicker;
      return r("react-datepicker__month", { "react-datepicker__month--selecting-range": n3 && (o3 || a5) }, { "react-datepicker__monthPicker": s5 }, { "react-datepicker__quarterPicker": i4 });
    })), t4;
  }
  return fe(o2, [{ key: "render", value: function() {
    var t4 = this.props, r2 = t4.showMonthYearPicker, n3 = t4.showQuarterYearPicker, o3 = t4.day, a4 = t4.ariaLabelPrefix, s4 = void 0 === a4 ? "month " : a4;
    return React__default.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(s4, " ").concat(Oe(o3, "yyyy-MM")), role: "listbox" }, r2 ? this.renderMonths() : n3 ? this.renderQuarters() : this.renderWeeks());
  } }]), o2;
})(), Kt = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2() {
    var t4;
    he(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), i3 = 0; i3 < o2; i3++) a4[i3] = arguments[i3];
    return ve(ke(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { height: null }), ve(ke(t4), "handleClick", (function(e3) {
      (t4.props.minTime || t4.props.maxTime) && lt(e3, t4.props) || (t4.props.excludeTimes || t4.props.includeTimes || t4.props.filterTime) && ct(e3, t4.props) || t4.props.onChange(e3);
    })), ve(ke(t4), "isSelectedTime", (function(e3, r3, n3) {
      return t4.props.selected && r3 === getHours(e3) && n3 === getMinutes(e3);
    })), ve(ke(t4), "liClasses", (function(e3, r3, n3) {
      var o3 = ["react-datepicker__time-list-item", t4.props.timeClassName ? t4.props.timeClassName(e3, r3, n3) : void 0];
      return t4.isSelectedTime(e3, r3, n3) && o3.push("react-datepicker__time-list-item--selected"), ((t4.props.minTime || t4.props.maxTime) && lt(e3, t4.props) || (t4.props.excludeTimes || t4.props.includeTimes || t4.props.filterTime) && ct(e3, t4.props)) && o3.push("react-datepicker__time-list-item--disabled"), t4.props.injectTimes && (60 * getHours(e3) + getMinutes(e3)) % t4.props.intervals != 0 && o3.push("react-datepicker__time-list-item--injected"), o3.join(" ");
    })), ve(ke(t4), "handleOnKeyDown", (function(e3, r3) {
      " " === e3.key && (e3.preventDefault(), e3.key = "Enter"), "Enter" === e3.key && t4.handleClick(r3), t4.props.handleOnKeyDown(e3);
    })), ve(ke(t4), "renderTimes", (function() {
      for (var r3, n3 = [], o3 = t4.props.format ? t4.props.format : "p", a5 = t4.props.intervals, i4 = (r3 = Ye(t4.props.selected), startOfDay(r3)), p2 = 1440 / a5, c3 = t4.props.injectTimes && t4.props.injectTimes.sort((function(e3, t5) {
        return e3 - t5;
      })), l2 = t4.props.selected || t4.props.openToDate || Ye(), d4 = getHours(l2), u3 = getMinutes(l2), h4 = setHours(setMinutes(i4, u3), d4), m4 = 0; m4 < p2; m4++) {
        var f2 = addMinutes(i4, m4 * a5);
        if (n3.push(f2), c3) {
          var v2 = Dt(i4, f2, m4, a5, c3);
          n3 = n3.concat(v2);
        }
      }
      return n3.map((function(r4, n4) {
        return React__default.createElement("li", { key: n4, onClick: t4.handleClick.bind(ke(t4), r4), className: t4.liClasses(r4, d4, u3), ref: function(e3) {
          (isBefore(r4, h4) || Ve(r4, h4)) && (t4.centerLi = e3);
        }, onKeyDown: function(e3) {
          t4.handleOnKeyDown(e3, r4);
        }, tabIndex: "0", "aria-selected": t4.isSelectedTime(r4, d4, u3) ? "true" : void 0 }, Oe(r4, o3, t4.props.locale));
      }));
    })), t4;
  }
  return fe(n2, [{ key: "componentDidMount", value: function() {
    this.list.scrollTop = this.centerLi && n2.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t4 = this, r3 = this.state.height;
    return React__default.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, React__default.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(e3) {
      t4.header = e3;
    } }, React__default.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), React__default.createElement("div", { className: "react-datepicker__time" }, React__default.createElement("div", { className: "react-datepicker__time-box" }, React__default.createElement("ul", { className: "react-datepicker__time-list", ref: function(e3) {
      t4.list = e3;
    }, style: r3 ? { height: r3 } : {}, tabIndex: "0" }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n2;
})();
ve(Kt, "calcCenterPosition", (function(e3, t3) {
  return t3.offsetTop - (e3 / 2 - t3.clientHeight / 2);
}));
var Bt = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2(t4) {
    var a4;
    return he(this, o2), ve(ke(a4 = n2.call(this, t4)), "YEAR_REFS", Se(Array(a4.props.yearItemNumber)).map((function() {
      return React__default.createRef();
    }))), ve(ke(a4), "isDisabled", (function(e3) {
      return Ze(e3, a4.props);
    })), ve(ke(a4), "isExcluded", (function(e3) {
      return et(e3, a4.props);
    })), ve(ke(a4), "selectingDate", (function() {
      var e3;
      return null !== (e3 = a4.props.selectingDate) && void 0 !== e3 ? e3 : a4.props.preSelection;
    })), ve(ke(a4), "updateFocusOnPaginate", (function(e3) {
      var t5 = (function() {
        this.YEAR_REFS[e3].current.focus();
      }).bind(ke(a4));
      window.requestAnimationFrame(t5);
    })), ve(ke(a4), "handleYearClick", (function(e3, t5) {
      a4.props.onDayClick && a4.props.onDayClick(e3, t5);
    })), ve(ke(a4), "handleYearNavigation", (function(e3, t5) {
      var r2 = a4.props, n3 = r2.date, o3 = r2.yearItemNumber, s4 = wt(n3, o3).startPeriod;
      a4.isDisabled(t5) || a4.isExcluded(t5) || (a4.props.setPreSelection(t5), e3 - s4 == -1 ? a4.updateFocusOnPaginate(o3 - 1) : e3 - s4 === o3 ? a4.updateFocusOnPaginate(0) : a4.YEAR_REFS[e3 - s4].current.focus());
    })), ve(ke(a4), "isSameDay", (function(e3, t5) {
      return He(e3, t5);
    })), ve(ke(a4), "isCurrentYear", (function(e3) {
      return e3 === getYear(Ye());
    })), ve(ke(a4), "isRangeStart", (function(e3) {
      return a4.props.startDate && a4.props.endDate && Qe(setYear(Ye(), e3), a4.props.startDate);
    })), ve(ke(a4), "isRangeEnd", (function(e3) {
      return a4.props.startDate && a4.props.endDate && Qe(setYear(Ye(), e3), a4.props.endDate);
    })), ve(ke(a4), "isInRange", (function(e3) {
      return ot(e3, a4.props.startDate, a4.props.endDate);
    })), ve(ke(a4), "isInSelectingRange", (function(e3) {
      var t5 = a4.props, r2 = t5.selectsStart, n3 = t5.selectsEnd, o3 = t5.selectsRange, s4 = t5.startDate, i3 = t5.endDate;
      return !(!(r2 || n3 || o3) || !a4.selectingDate()) && (r2 && i3 ? ot(e3, a4.selectingDate(), i3) : (n3 && s4 || !(!o3 || !s4 || i3)) && ot(e3, s4, a4.selectingDate()));
    })), ve(ke(a4), "isSelectingRangeStart", (function(e3) {
      if (!a4.isInSelectingRange(e3)) return false;
      var t5 = a4.props, r2 = t5.startDate, n3 = t5.selectsStart, o3 = setYear(Ye(), e3);
      return Qe(o3, n3 ? a4.selectingDate() : r2);
    })), ve(ke(a4), "isSelectingRangeEnd", (function(e3) {
      if (!a4.isInSelectingRange(e3)) return false;
      var t5 = a4.props, r2 = t5.endDate, n3 = t5.selectsEnd, o3 = t5.selectsRange, s4 = setYear(Ye(), e3);
      return Qe(s4, n3 || o3 ? a4.selectingDate() : r2);
    })), ve(ke(a4), "isKeyboardSelected", (function(e3) {
      var t5 = Ae(setYear(a4.props.date, e3));
      return !a4.props.disabledKeyboardNavigation && !a4.props.inline && !He(t5, Ae(a4.props.selected)) && He(t5, Ae(a4.props.preSelection));
    })), ve(ke(a4), "onYearClick", (function(e3, t5) {
      var r2 = a4.props.date;
      a4.handleYearClick(Ae(setYear(r2, t5)), e3);
    })), ve(ke(a4), "onYearKeyDown", (function(e3, t5) {
      var r2 = e3.key;
      if (!a4.props.disabledKeyboardNavigation) switch (r2) {
        case "Enter":
          a4.onYearClick(e3, t5), a4.props.setPreSelection(a4.props.selected);
          break;
        case "ArrowRight":
          a4.handleYearNavigation(t5 + 1, addYears(a4.props.preSelection, 1));
          break;
        case "ArrowLeft":
          a4.handleYearNavigation(t5 - 1, subYears(a4.props.preSelection, 1));
      }
    })), ve(ke(a4), "getYearClassNames", (function(e3) {
      var t5 = a4.props, n3 = t5.minDate, o3 = t5.maxDate, s4 = t5.selected, i3 = t5.excludeDates, p2 = t5.includeDates, c3 = t5.filterDate;
      return r("react-datepicker__year-text", { "react-datepicker__year-text--selected": e3 === getYear(s4), "react-datepicker__year-text--disabled": (n3 || o3 || i3 || p2 || c3) && at(e3, a4.props), "react-datepicker__year-text--keyboard-selected": a4.isKeyboardSelected(e3), "react-datepicker__year-text--range-start": a4.isRangeStart(e3), "react-datepicker__year-text--range-end": a4.isRangeEnd(e3), "react-datepicker__year-text--in-range": a4.isInRange(e3), "react-datepicker__year-text--in-selecting-range": a4.isInSelectingRange(e3), "react-datepicker__year-text--selecting-range-start": a4.isSelectingRangeStart(e3), "react-datepicker__year-text--selecting-range-end": a4.isSelectingRangeEnd(e3), "react-datepicker__year-text--today": a4.isCurrentYear(e3) });
    })), ve(ke(a4), "getYearTabIndex", (function(e3) {
      return a4.props.disabledKeyboardNavigation ? "-1" : e3 === getYear(a4.props.preSelection) ? "0" : "-1";
    })), ve(ke(a4), "getYearContainerClassNames", (function() {
      var e3 = a4.props, t5 = e3.selectingDate, n3 = e3.selectsStart, o3 = e3.selectsEnd, s4 = e3.selectsRange;
      return r("react-datepicker__year", { "react-datepicker__year--selecting-range": t5 && (n3 || o3 || s4) });
    })), ve(ke(a4), "getYearContent", (function(e3) {
      return a4.props.renderYearContent ? a4.props.renderYearContent(e3) : e3;
    })), a4;
  }
  return fe(o2, [{ key: "render", value: function() {
    for (var t4 = this, r2 = [], n3 = this.props, o3 = n3.date, a4 = n3.yearItemNumber, s4 = n3.onYearMouseEnter, i3 = n3.onYearMouseLeave, p2 = wt(o3, a4), c3 = p2.startPeriod, l2 = p2.endPeriod, d4 = function(n4) {
      r2.push(React__default.createElement("div", { ref: t4.YEAR_REFS[n4 - c3], onClick: function(e3) {
        t4.onYearClick(e3, n4);
      }, onKeyDown: function(e3) {
        t4.onYearKeyDown(e3, n4);
      }, tabIndex: t4.getYearTabIndex(n4), className: t4.getYearClassNames(n4), onMouseEnter: function(e3) {
        return s4(e3, n4);
      }, onMouseLeave: function(e3) {
        return i3(e3, n4);
      }, key: n4, "aria-current": t4.isCurrentYear(n4) ? "date" : void 0 }, t4.getYearContent(n4)));
    }, u3 = c3; u3 <= l2; u3++) d4(u3);
    return React__default.createElement("div", { className: this.getYearContainerClassNames() }, React__default.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, r2));
  } }]), o2;
})(), Qt = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2(t4) {
    var o2;
    return he(this, n2), ve(ke(o2 = r2.call(this, t4)), "onTimeChange", (function(e3) {
      o2.setState({ time: e3 });
      var t5 = /* @__PURE__ */ new Date();
      t5.setHours(e3.split(":")[0]), t5.setMinutes(e3.split(":")[1]), o2.props.onChange(t5);
    })), ve(ke(o2), "renderTimeInput", (function() {
      var t5 = o2.state.time, r3 = o2.props, n3 = r3.date, a4 = r3.timeString, s4 = r3.customTimeInput;
      return s4 ? React__default.cloneElement(s4, { date: n3, value: t5, onChange: o2.onTimeChange }) : React__default.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: true, value: t5, onChange: function(e3) {
        o2.onTimeChange(e3.target.value || a4);
      } });
    })), o2.state = { time: o2.props.timeString }, o2;
  }
  return fe(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__input-time-container" }, React__default.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), React__default.createElement("div", { className: "react-datepicker-time__input-container" }, React__default.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(e3, t4) {
    return e3.timeString !== t4.time ? { time: e3.timeString } : null;
  } }]), n2;
})();
function Wt(t3) {
  var r2 = t3.className, n2 = t3.children, o2 = t3.showPopperArrow, a4 = t3.arrowProps, s4 = void 0 === a4 ? {} : a4;
  return React__default.createElement("div", { className: r2 }, o2 && React__default.createElement("div", ye({ className: "react-datepicker__triangle" }, s4)), n2);
}
var jt = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Ht = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2(t4) {
    var a4;
    return he(this, o2), ve(ke(a4 = n2.call(this, t4)), "handleClickOutside", (function(e3) {
      a4.props.onClickOutside(e3);
    })), ve(ke(a4), "setClickOutsideRef", (function() {
      return a4.containerRef.current;
    })), ve(ke(a4), "handleDropdownFocus", (function(e3) {
      (function() {
        var e4 = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
        return jt.some((function(t5) {
          return e4.indexOf(t5) >= 0;
        }));
      })(e3.target) && a4.props.onDropdownFocus();
    })), ve(ke(a4), "getDateInView", (function() {
      var e3 = a4.props, t5 = e3.preSelection, r2 = e3.selected, n3 = e3.openToDate, o3 = ft(a4.props), s4 = vt(a4.props), i3 = Ye(), p2 = n3 || r2 || t5;
      return p2 || (o3 && isBefore(i3, o3) ? o3 : s4 && isAfter(i3, s4) ? s4 : i3);
    })), ve(ke(a4), "increaseMonth", (function() {
      a4.setState((function(e3) {
        var t5 = e3.date;
        return { date: addMonths(t5, 1) };
      }), (function() {
        return a4.handleMonthChange(a4.state.date);
      }));
    })), ve(ke(a4), "decreaseMonth", (function() {
      a4.setState((function(e3) {
        var t5 = e3.date;
        return { date: subMonths(t5, 1) };
      }), (function() {
        return a4.handleMonthChange(a4.state.date);
      }));
    })), ve(ke(a4), "handleDayClick", (function(e3, t5, r2) {
      a4.props.onSelect(e3, t5, r2), a4.props.setPreSelection && a4.props.setPreSelection(e3);
    })), ve(ke(a4), "handleDayMouseEnter", (function(e3) {
      a4.setState({ selectingDate: e3 }), a4.props.onDayMouseEnter && a4.props.onDayMouseEnter(e3);
    })), ve(ke(a4), "handleMonthMouseLeave", (function() {
      a4.setState({ selectingDate: null }), a4.props.onMonthMouseLeave && a4.props.onMonthMouseLeave();
    })), ve(ke(a4), "handleYearMouseEnter", (function(e3, t5) {
      a4.setState({ selectingDate: setYear(Ye(), t5) }), a4.props.onYearMouseEnter && a4.props.onYearMouseEnter(e3, t5);
    })), ve(ke(a4), "handleYearMouseLeave", (function(e3, t5) {
      a4.props.onYearMouseLeave && a4.props.onYearMouseLeave(e3, t5);
    })), ve(ke(a4), "handleYearChange", (function(e3) {
      a4.props.onYearChange && (a4.props.onYearChange(e3), a4.setState({ isRenderAriaLiveMessage: true })), a4.props.adjustDateOnChange && (a4.props.onSelect && a4.props.onSelect(e3), a4.props.setOpen && a4.props.setOpen(true)), a4.props.setPreSelection && a4.props.setPreSelection(e3);
    })), ve(ke(a4), "handleMonthChange", (function(e3) {
      a4.handleCustomMonthChange(e3), a4.props.adjustDateOnChange && (a4.props.onSelect && a4.props.onSelect(e3), a4.props.setOpen && a4.props.setOpen(true)), a4.props.setPreSelection && a4.props.setPreSelection(e3);
    })), ve(ke(a4), "handleCustomMonthChange", (function(e3) {
      a4.props.onMonthChange && (a4.props.onMonthChange(e3), a4.setState({ isRenderAriaLiveMessage: true }));
    })), ve(ke(a4), "handleMonthYearChange", (function(e3) {
      a4.handleYearChange(e3), a4.handleMonthChange(e3);
    })), ve(ke(a4), "changeYear", (function(e3) {
      a4.setState((function(t5) {
        var r2 = t5.date;
        return { date: setYear(r2, e3) };
      }), (function() {
        return a4.handleYearChange(a4.state.date);
      }));
    })), ve(ke(a4), "changeMonth", (function(e3) {
      a4.setState((function(t5) {
        var r2 = t5.date;
        return { date: setMonth(r2, e3) };
      }), (function() {
        return a4.handleMonthChange(a4.state.date);
      }));
    })), ve(ke(a4), "changeMonthYear", (function(e3) {
      a4.setState((function(t5) {
        var r2 = t5.date;
        return { date: setYear(setMonth(r2, getMonth(e3)), getYear(e3)) };
      }), (function() {
        return a4.handleMonthYearChange(a4.state.date);
      }));
    })), ve(ke(a4), "header", (function() {
      var t5 = Le(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a4.state.date, a4.props.locale, a4.props.calendarStartDay), n3 = [];
      return a4.props.showWeekNumbers && n3.push(React__default.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a4.props.weekLabel || "#")), n3.concat([0, 1, 2, 3, 4, 5, 6].map((function(n4) {
        var o3 = addDays(t5, n4), s4 = a4.formatWeekday(o3, a4.props.locale), i3 = a4.props.weekDayClassName ? a4.props.weekDayClassName(o3) : void 0;
        return React__default.createElement("div", { key: n4, className: r("react-datepicker__day-name", i3) }, s4);
      })));
    })), ve(ke(a4), "formatWeekday", (function(e3, t5) {
      return a4.props.formatWeekDay ? (function(e4, t6, r2) {
        return t6(Oe(e4, "EEEE", r2));
      })(e3, a4.props.formatWeekDay, t5) : a4.props.useWeekdaysShort ? (function(e4, t6) {
        return Oe(e4, "EEE", t6);
      })(e3, t5) : (function(e4, t6) {
        return Oe(e4, "EEEEEE", t6);
      })(e3, t5);
    })), ve(ke(a4), "decreaseYear", (function() {
      a4.setState((function(e3) {
        var t5 = e3.date;
        return { date: subYears(t5, a4.props.showYearPicker ? a4.props.yearItemNumber : 1) };
      }), (function() {
        return a4.handleYearChange(a4.state.date);
      }));
    })), ve(ke(a4), "clearSelectingDate", (function() {
      a4.setState({ selectingDate: null });
    })), ve(ke(a4), "renderPreviousButton", (function() {
      if (!a4.props.renderCustomHeader) {
        var t5;
        switch (true) {
          case a4.props.showMonthYearPicker:
            t5 = ht(a4.state.date, a4.props);
            break;
          case a4.props.showYearPicker:
            t5 = (function(e3) {
              var t6 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r3 = t6.minDate, n4 = t6.yearItemNumber, o4 = void 0 === n4 ? Ne : n4, a5 = wt(Ae(subYears(e3, o4)), o4).endPeriod, s5 = r3 && getYear(r3);
              return s5 && s5 > a5 || false;
            })(a4.state.date, a4.props);
            break;
          default:
            t5 = dt(a4.state.date, a4.props);
        }
        if ((a4.props.forceShowMonthNavigation || a4.props.showDisabledMonthNavigation || !t5) && !a4.props.showTimeSelectOnly) {
          var r2 = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], n3 = a4.decreaseMonth;
          (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker) && (n3 = a4.decreaseYear), t5 && a4.props.showDisabledMonthNavigation && (r2.push("react-datepicker__navigation--previous--disabled"), n3 = null);
          var o3 = a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker, s4 = a4.props, i3 = s4.previousMonthButtonLabel, p2 = s4.previousYearButtonLabel, c3 = a4.props, l2 = c3.previousMonthAriaLabel, d4 = void 0 === l2 ? "string" == typeof i3 ? i3 : "Previous Month" : l2, u3 = c3.previousYearAriaLabel, h4 = void 0 === u3 ? "string" == typeof p2 ? p2 : "Previous Year" : u3;
          return React__default.createElement("button", { type: "button", className: r2.join(" "), onClick: n3, onKeyDown: a4.props.handleOnKeyDown, "aria-label": o3 ? h4 : d4 }, React__default.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, o3 ? a4.props.previousYearButtonLabel : a4.props.previousMonthButtonLabel));
        }
      }
    })), ve(ke(a4), "increaseYear", (function() {
      a4.setState((function(e3) {
        var t5 = e3.date;
        return { date: addYears(t5, a4.props.showYearPicker ? a4.props.yearItemNumber : 1) };
      }), (function() {
        return a4.handleYearChange(a4.state.date);
      }));
    })), ve(ke(a4), "renderNextButton", (function() {
      if (!a4.props.renderCustomHeader) {
        var t5;
        switch (true) {
          case a4.props.showMonthYearPicker:
            t5 = mt(a4.state.date, a4.props);
            break;
          case a4.props.showYearPicker:
            t5 = (function(e3) {
              var t6 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r3 = t6.maxDate, n4 = t6.yearItemNumber, o4 = void 0 === n4 ? Ne : n4, a5 = wt(addYears(e3, o4), o4).startPeriod, s5 = r3 && getYear(r3);
              return s5 && s5 < a5 || false;
            })(a4.state.date, a4.props);
            break;
          default:
            t5 = ut(a4.state.date, a4.props);
        }
        if ((a4.props.forceShowMonthNavigation || a4.props.showDisabledMonthNavigation || !t5) && !a4.props.showTimeSelectOnly) {
          var r2 = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a4.props.showTimeSelect && r2.push("react-datepicker__navigation--next--with-time"), a4.props.todayButton && r2.push("react-datepicker__navigation--next--with-today-button");
          var n3 = a4.increaseMonth;
          (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker) && (n3 = a4.increaseYear), t5 && a4.props.showDisabledMonthNavigation && (r2.push("react-datepicker__navigation--next--disabled"), n3 = null);
          var o3 = a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker, s4 = a4.props, i3 = s4.nextMonthButtonLabel, p2 = s4.nextYearButtonLabel, c3 = a4.props, l2 = c3.nextMonthAriaLabel, d4 = void 0 === l2 ? "string" == typeof i3 ? i3 : "Next Month" : l2, h4 = c3.nextYearAriaLabel, m4 = void 0 === h4 ? "string" == typeof p2 ? p2 : "Next Year" : h4;
          return React__default.createElement("button", { type: "button", className: r2.join(" "), onClick: n3, onKeyDown: a4.props.handleOnKeyDown, "aria-label": o3 ? m4 : d4 }, React__default.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, o3 ? a4.props.nextYearButtonLabel : a4.props.nextMonthButtonLabel));
        }
      }
    })), ve(ke(a4), "renderCurrentMonth", (function() {
      var t5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a4.state.date, r2 = ["react-datepicker__current-month"];
      return a4.props.showYearDropdown && r2.push("react-datepicker__current-month--hasYearDropdown"), a4.props.showMonthDropdown && r2.push("react-datepicker__current-month--hasMonthDropdown"), a4.props.showMonthYearDropdown && r2.push("react-datepicker__current-month--hasMonthYearDropdown"), React__default.createElement("div", { className: r2.join(" ") }, Oe(t5, a4.props.dateFormat, a4.props.locale));
    })), ve(ke(a4), "renderYearDropdown", (function() {
      var t5 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showYearDropdown && !t5) return React__default.createElement(St, { adjustDateOnChange: a4.props.adjustDateOnChange, date: a4.state.date, onSelect: a4.props.onSelect, setOpen: a4.props.setOpen, dropdownMode: a4.props.dropdownMode, onChange: a4.changeYear, minDate: a4.props.minDate, maxDate: a4.props.maxDate, year: getYear(a4.state.date), scrollableYearDropdown: a4.props.scrollableYearDropdown, yearDropdownItemNumber: a4.props.yearDropdownItemNumber });
    })), ve(ke(a4), "renderMonthDropdown", (function() {
      var t5 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showMonthDropdown && !t5) return React__default.createElement(_t, { dropdownMode: a4.props.dropdownMode, locale: a4.props.locale, onChange: a4.changeMonth, month: getMonth(a4.state.date), useShortMonthInDropdown: a4.props.useShortMonthInDropdown });
    })), ve(ke(a4), "renderMonthYearDropdown", (function() {
      var t5 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showMonthYearDropdown && !t5) return React__default.createElement(Nt, { dropdownMode: a4.props.dropdownMode, locale: a4.props.locale, dateFormat: a4.props.dateFormat, onChange: a4.changeMonthYear, minDate: a4.props.minDate, maxDate: a4.props.maxDate, date: a4.state.date, scrollableMonthYearDropdown: a4.props.scrollableMonthYearDropdown });
    })), ve(ke(a4), "handleTodayButtonClick", (function(e3) {
      a4.props.onSelect(Be(), e3), a4.props.setPreSelection && a4.props.setPreSelection(Be());
    })), ve(ke(a4), "renderTodayButton", (function() {
      if (a4.props.todayButton && !a4.props.showTimeSelectOnly) return React__default.createElement("div", { className: "react-datepicker__today-button", onClick: function(e3) {
        return a4.handleTodayButtonClick(e3);
      } }, a4.props.todayButton);
    })), ve(ke(a4), "renderDefaultHeader", (function(t5) {
      var r2 = t5.monthDate, n3 = t5.i;
      return React__default.createElement("div", { className: "react-datepicker__header ".concat(a4.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a4.renderCurrentMonth(r2), React__default.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a4.props.dropdownMode), onFocus: a4.handleDropdownFocus }, a4.renderMonthDropdown(0 !== n3), a4.renderMonthYearDropdown(0 !== n3), a4.renderYearDropdown(0 !== n3)), React__default.createElement("div", { className: "react-datepicker__day-names" }, a4.header(r2)));
    })), ve(ke(a4), "renderCustomHeader", (function() {
      var t5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = t5.monthDate, n3 = t5.i;
      if (a4.props.showTimeSelect && !a4.state.monthContainer || a4.props.showTimeSelectOnly) return null;
      var o3 = dt(a4.state.date, a4.props), s4 = ut(a4.state.date, a4.props), i3 = ht(a4.state.date, a4.props), p2 = mt(a4.state.date, a4.props), c3 = !a4.props.showMonthYearPicker && !a4.props.showQuarterYearPicker && !a4.props.showYearPicker;
      return React__default.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a4.props.onDropdownFocus }, a4.props.renderCustomHeader(de(de({}, a4.state), {}, { customHeaderCount: n3, monthDate: r2, changeMonth: a4.changeMonth, changeYear: a4.changeYear, decreaseMonth: a4.decreaseMonth, increaseMonth: a4.increaseMonth, decreaseYear: a4.decreaseYear, increaseYear: a4.increaseYear, prevMonthButtonDisabled: o3, nextMonthButtonDisabled: s4, prevYearButtonDisabled: i3, nextYearButtonDisabled: p2 })), c3 && React__default.createElement("div", { className: "react-datepicker__day-names" }, a4.header(r2)));
    })), ve(ke(a4), "renderYearHeader", (function() {
      var t5 = a4.state.date, r2 = a4.props, n3 = r2.showYearPicker, o3 = wt(t5, r2.yearItemNumber), s4 = o3.startPeriod, i3 = o3.endPeriod;
      return React__default.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, n3 ? "".concat(s4, " - ").concat(i3) : getYear(t5));
    })), ve(ke(a4), "renderHeader", (function(e3) {
      switch (true) {
        case void 0 !== a4.props.renderCustomHeader:
          return a4.renderCustomHeader(e3);
        case (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker):
          return a4.renderYearHeader(e3);
        default:
          return a4.renderDefaultHeader(e3);
      }
    })), ve(ke(a4), "renderMonths", (function() {
      if (!a4.props.showTimeSelectOnly && !a4.props.showYearPicker) {
        for (var t5 = [], r2 = a4.props.showPreviousMonths ? a4.props.monthsShown - 1 : 0, n3 = subMonths(a4.state.date, r2), o3 = 0; o3 < a4.props.monthsShown; ++o3) {
          var s4 = o3 - a4.props.monthSelectedIn, i3 = addMonths(n3, s4), p2 = "month-".concat(o3), c3 = o3 < a4.props.monthsShown - 1, d4 = o3 > 0;
          t5.push(React__default.createElement("div", { key: p2, ref: function(e3) {
            a4.monthContainer = e3;
          }, className: "react-datepicker__month-container" }, a4.renderHeader({ monthDate: i3, i: o3 }), React__default.createElement(At, { chooseDayAriaLabelPrefix: a4.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a4.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a4.props.weekAriaLabelPrefix, ariaLabelPrefix: a4.props.monthAriaLabelPrefix, onChange: a4.changeMonthYear, day: i3, dayClassName: a4.props.dayClassName, calendarStartDay: a4.props.calendarStartDay, monthClassName: a4.props.monthClassName, onDayClick: a4.handleDayClick, handleOnKeyDown: a4.props.handleOnDayKeyDown, onDayMouseEnter: a4.handleDayMouseEnter, onMouseLeave: a4.handleMonthMouseLeave, onWeekSelect: a4.props.onWeekSelect, orderInDisplay: o3, formatWeekNumber: a4.props.formatWeekNumber, locale: a4.props.locale, minDate: a4.props.minDate, maxDate: a4.props.maxDate, excludeDates: a4.props.excludeDates, excludeDateIntervals: a4.props.excludeDateIntervals, highlightDates: a4.props.highlightDates, selectingDate: a4.state.selectingDate, includeDates: a4.props.includeDates, includeDateIntervals: a4.props.includeDateIntervals, inline: a4.props.inline, shouldFocusDayInline: a4.props.shouldFocusDayInline, fixedHeight: a4.props.fixedHeight, filterDate: a4.props.filterDate, preSelection: a4.props.preSelection, setPreSelection: a4.props.setPreSelection, selected: a4.props.selected, selectsStart: a4.props.selectsStart, selectsEnd: a4.props.selectsEnd, selectsRange: a4.props.selectsRange, selectsDisabledDaysInRange: a4.props.selectsDisabledDaysInRange, showWeekNumbers: a4.props.showWeekNumbers, startDate: a4.props.startDate, endDate: a4.props.endDate, peekNextMonth: a4.props.peekNextMonth, setOpen: a4.props.setOpen, shouldCloseOnSelect: a4.props.shouldCloseOnSelect, renderDayContents: a4.props.renderDayContents, renderMonthContent: a4.props.renderMonthContent, renderQuarterContent: a4.props.renderQuarterContent, renderYearContent: a4.props.renderYearContent, disabledKeyboardNavigation: a4.props.disabledKeyboardNavigation, showMonthYearPicker: a4.props.showMonthYearPicker, showFullMonthYearPicker: a4.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a4.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a4.props.showFourColumnMonthYearPicker, showYearPicker: a4.props.showYearPicker, showQuarterYearPicker: a4.props.showQuarterYearPicker, isInputFocused: a4.props.isInputFocused, containerRef: a4.containerRef, monthShowsDuplicateDaysEnd: c3, monthShowsDuplicateDaysStart: d4 })));
        }
        return t5;
      }
    })), ve(ke(a4), "renderYears", (function() {
      if (!a4.props.showTimeSelectOnly) return a4.props.showYearPicker ? React__default.createElement("div", { className: "react-datepicker__year--container" }, a4.renderHeader(), React__default.createElement(Bt, ye({ onDayClick: a4.handleDayClick, selectingDate: a4.state.selectingDate, clearSelectingDate: a4.clearSelectingDate, date: a4.state.date }, a4.props, { onYearMouseEnter: a4.handleYearMouseEnter, onYearMouseLeave: a4.handleYearMouseLeave }))) : void 0;
    })), ve(ke(a4), "renderTimeSection", (function() {
      if (a4.props.showTimeSelect && (a4.state.monthContainer || a4.props.showTimeSelectOnly)) return React__default.createElement(Kt, { selected: a4.props.selected, openToDate: a4.props.openToDate, onChange: a4.props.onTimeChange, timeClassName: a4.props.timeClassName, format: a4.props.timeFormat, includeTimes: a4.props.includeTimes, intervals: a4.props.timeIntervals, minTime: a4.props.minTime, maxTime: a4.props.maxTime, excludeTimes: a4.props.excludeTimes, filterTime: a4.props.filterTime, timeCaption: a4.props.timeCaption, todayButton: a4.props.todayButton, showMonthDropdown: a4.props.showMonthDropdown, showMonthYearDropdown: a4.props.showMonthYearDropdown, showYearDropdown: a4.props.showYearDropdown, withPortal: a4.props.withPortal, monthRef: a4.state.monthContainer, injectTimes: a4.props.injectTimes, locale: a4.props.locale, handleOnKeyDown: a4.props.handleOnKeyDown, showTimeSelectOnly: a4.props.showTimeSelectOnly });
    })), ve(ke(a4), "renderInputTimeSection", (function() {
      var t5 = new Date(a4.props.selected), r2 = Ie(t5) && Boolean(a4.props.selected) ? "".concat(gt(t5.getHours()), ":").concat(gt(t5.getMinutes())) : "";
      if (a4.props.showTimeInput) return React__default.createElement(Qt, { date: t5, timeString: r2, timeInputLabel: a4.props.timeInputLabel, onChange: a4.props.onTimeChange, customTimeInput: a4.props.customTimeInput });
    })), ve(ke(a4), "renderAriaLiveRegion", (function() {
      var t5, r2 = wt(a4.state.date, a4.props.yearItemNumber), n3 = r2.startPeriod, o3 = r2.endPeriod;
      return t5 = a4.props.showYearPicker ? "".concat(n3, " - ").concat(o3) : a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker ? getYear(a4.state.date) : "".concat(Je(getMonth(a4.state.date), a4.props.locale), " ").concat(getYear(a4.state.date)), React__default.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, a4.state.isRenderAriaLiveMessage && t5);
    })), ve(ke(a4), "renderChildren", (function() {
      if (a4.props.children) return React__default.createElement("div", { className: "react-datepicker__children-container" }, a4.props.children);
    })), a4.containerRef = React__default.createRef(), a4.state = { date: a4.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: false }, a4;
  }
  return fe(o2, [{ key: "componentDidMount", value: function() {
    var e3 = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void e3.setState({ monthContainer: e3.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(e3) {
    var t4 = this;
    if (!this.props.preSelection || He(this.props.preSelection, e3.preSelection) && this.props.monthSelectedIn === e3.monthSelectedIn) this.props.openToDate && !He(this.props.openToDate, e3.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var r2 = !We(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, (function() {
        return r2 && t4.handleCustomMonthChange(t4.state.date);
      }));
    }
  } }, { key: "render", value: function() {
    var t4 = this.props.container || Wt;
    return React__default.createElement("div", { ref: this.containerRef }, React__default.createElement(t4, { className: r("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, monthSelectedIn: 0, forceShowMonthNavigation: false, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: Ne };
  } }]), o2;
})(), Vt = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2(e3) {
    var t4;
    return he(this, n2), (t4 = r2.call(this, e3)).el = document.createElement("div"), t4;
  }
  return fe(n2, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return ReactDOM__default.createPortal(this.props.children, this.el);
  } }]), n2;
})(), qt = function(e3) {
  return !e3.disabled && -1 !== e3.tabIndex;
}, Ut = (function(t3) {
  De(n2, React__default.Component);
  var r2 = be(n2);
  function n2(t4) {
    var o2;
    return he(this, n2), ve(ke(o2 = r2.call(this, t4)), "getTabChildren", (function() {
      return Array.prototype.slice.call(o2.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(qt);
    })), ve(ke(o2), "handleFocusStart", (function() {
      var e3 = o2.getTabChildren();
      e3 && e3.length > 1 && e3[e3.length - 1].focus();
    })), ve(ke(o2), "handleFocusEnd", (function() {
      var e3 = o2.getTabChildren();
      e3 && e3.length > 1 && e3[0].focus();
    })), o2.tabLoopRef = React__default.createRef(), o2;
  }
  return fe(n2, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? React__default.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, React__default.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, React__default.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: true };
  } }]), n2;
})(), zt = (function(t3) {
  De(o2, React__default.Component);
  var n2 = be(o2);
  function o2() {
    return he(this, o2), n2.apply(this, arguments);
  }
  return fe(o2, [{ key: "render", value: function() {
    var t4, n3 = this.props, o3 = n3.className, a4 = n3.wrapperClassName, s4 = n3.hidePopper, i3 = n3.popperComponent, p2 = n3.popperModifiers, c3 = n3.popperPlacement, l2 = n3.popperProps, d4 = n3.targetComponent, u3 = n3.enableTabLoop, h4 = n3.popperOnKeyDown, m4 = n3.portalId, f2 = n3.portalHost;
    if (!s4) {
      var v2 = r("react-datepicker-popper", o3);
      t4 = React__default.createElement(Popper, ye({ modifiers: p2, placement: c3 }, l2), (function(t5) {
        var r2 = t5.ref, n4 = t5.style, o4 = t5.placement, a5 = t5.arrowProps;
        return React__default.createElement(Ut, { enableTabLoop: u3 }, React__default.createElement("div", { ref: r2, style: n4, className: v2, "data-placement": o4, onKeyDown: h4 }, React__default.cloneElement(i3, { arrowProps: a5 })));
      }));
    }
    this.props.popperContainer && (t4 = React__default.createElement(this.props.popperContainer, {}, t4)), m4 && !s4 && (t4 = React__default.createElement(Vt, { portalId: m4, portalHost: f2 }, t4));
    var y3 = r("react-datepicker-wrapper", a4);
    return React__default.createElement(Manager, { className: "react-datepicker-manager" }, React__default.createElement(Reference, null, (function(t5) {
      var r2 = t5.ref;
      return React__default.createElement("div", { ref: r2, className: y3 }, d4);
    })), t4);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: true, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), o2;
})(), $t = "react-datepicker-ignore-onclickoutside", Gt = onClickOutsideHOC(Ht);
var Jt = "Date input not valid.", Xt = (function(t3) {
  De(a4, React__default.Component);
  var o2 = be(a4);
  function a4(t4) {
    var s4;
    return he(this, a4), ve(ke(s4 = o2.call(this, t4)), "getPreSelection", (function() {
      return s4.props.openToDate ? s4.props.openToDate : s4.props.selectsEnd && s4.props.startDate ? s4.props.startDate : s4.props.selectsStart && s4.props.endDate ? s4.props.endDate : Ye();
    })), ve(ke(s4), "calcInitialState", (function() {
      var e3, t5 = s4.getPreSelection(), r2 = ft(s4.props), n2 = vt(s4.props), o3 = r2 && isBefore(t5, startOfDay(r2)) ? r2 : n2 && isAfter(t5, endOfDay(n2)) ? n2 : t5;
      return { open: s4.props.startOpen || false, preventFocus: false, preSelection: null !== (e3 = s4.props.selectsRange ? s4.props.startDate : s4.props.selected) && void 0 !== e3 ? e3 : o3, highlightDates: yt(s4.props.highlightDates), focused: false, shouldFocusDayInline: false, isRenderAriaLiveMessage: false };
    })), ve(ke(s4), "clearPreventFocusTimeout", (function() {
      s4.preventFocusTimeout && clearTimeout(s4.preventFocusTimeout);
    })), ve(ke(s4), "setFocus", (function() {
      s4.input && s4.input.focus && s4.input.focus({ preventScroll: true });
    })), ve(ke(s4), "setBlur", (function() {
      s4.input && s4.input.blur && s4.input.blur(), s4.cancelFocusInput();
    })), ve(ke(s4), "setOpen", (function(e3) {
      var t5 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      s4.setState({ open: e3, preSelection: e3 && s4.state.open ? s4.state.preSelection : s4.calcInitialState().preSelection, lastPreSelectChange: er }, (function() {
        e3 || s4.setState((function(e4) {
          return { focused: !!t5 && e4.focused };
        }), (function() {
          !t5 && s4.setBlur(), s4.setState({ inputValue: null });
        }));
      }));
    })), ve(ke(s4), "inputOk", (function() {
      return isDate(s4.state.preSelection);
    })), ve(ke(s4), "isCalendarOpen", (function() {
      return void 0 === s4.props.open ? s4.state.open && !s4.props.disabled && !s4.props.readOnly : s4.props.open;
    })), ve(ke(s4), "handleFocus", (function(e3) {
      s4.state.preventFocus || (s4.props.onFocus(e3), s4.props.preventOpenOnFocus || s4.props.readOnly || s4.setOpen(true)), s4.setState({ focused: true });
    })), ve(ke(s4), "cancelFocusInput", (function() {
      clearTimeout(s4.inputFocusTimeout), s4.inputFocusTimeout = null;
    })), ve(ke(s4), "deferFocusInput", (function() {
      s4.cancelFocusInput(), s4.inputFocusTimeout = setTimeout((function() {
        return s4.setFocus();
      }), 1);
    })), ve(ke(s4), "handleDropdownFocus", (function() {
      s4.cancelFocusInput();
    })), ve(ke(s4), "handleBlur", (function(e3) {
      (!s4.state.open || s4.props.withPortal || s4.props.showTimeInput) && s4.props.onBlur(e3), s4.setState({ focused: false });
    })), ve(ke(s4), "handleCalendarClickOutside", (function(e3) {
      s4.props.inline || s4.setOpen(false), s4.props.onClickOutside(e3), s4.props.withPortal && e3.preventDefault();
    })), ve(ke(s4), "handleChange", (function() {
      for (var e3 = arguments.length, t5 = new Array(e3), r2 = 0; r2 < e3; r2++) t5[r2] = arguments[r2];
      var n2 = t5[0];
      if (!s4.props.onChangeRaw || (s4.props.onChangeRaw.apply(ke(s4), t5), "function" == typeof n2.isDefaultPrevented && !n2.isDefaultPrevented())) {
        s4.setState({ inputValue: n2.target.value, lastPreSelectChange: Zt });
        var o3, a5, i3, p2, c3, l2, d4, u3, h4 = (o3 = n2.target.value, a5 = s4.props.dateFormat, i3 = s4.props.locale, p2 = s4.props.strictParsing, c3 = s4.props.minDate, l2 = null, d4 = Ge(i3) || Ge($e()), u3 = true, Array.isArray(a5) ? (a5.forEach((function(e4) {
          var t6 = parse(o3, e4, /* @__PURE__ */ new Date(), { locale: d4 });
          p2 && (u3 = Ie(t6, c3) && o3 === Oe(t6, e4, i3)), Ie(t6, c3) && u3 && (l2 = t6);
        })), l2) : (l2 = parse(o3, a5, /* @__PURE__ */ new Date(), { locale: d4 }), p2 ? u3 = Ie(l2) && o3 === Oe(l2, a5, i3) : Ie(l2) || (a5 = a5.match(xe).map((function(e4) {
          var t6 = e4[0];
          return "p" === t6 || "P" === t6 ? d4 ? (0, Pe[t6])(e4, d4.formatLong) : t6 : e4;
        })).join(""), o3.length > 0 && (l2 = parse(o3, a5.slice(0, o3.length), /* @__PURE__ */ new Date())), Ie(l2) || (l2 = new Date(o3))), Ie(l2) && u3 ? l2 : null));
        s4.props.showTimeSelectOnly && s4.props.selected && !He(h4, s4.props.selected) && (h4 = set(s4.props.selected, null == h4 ? { hours: getHours(s4.props.selected), minutes: getMinutes(s4.props.selected), seconds: getSeconds(s4.props.selected) } : { hours: getHours(h4), minutes: getMinutes(h4), seconds: getSeconds(h4) })), !h4 && n2.target.value || s4.setSelected(h4, n2, true);
      }
    })), ve(ke(s4), "handleSelect", (function(e3, t5, r2) {
      if (s4.setState({ preventFocus: true }, (function() {
        return s4.preventFocusTimeout = setTimeout((function() {
          return s4.setState({ preventFocus: false });
        }), 50), s4.preventFocusTimeout;
      })), s4.props.onChangeRaw && s4.props.onChangeRaw(t5), s4.setSelected(e3, t5, false, r2), s4.props.showDateSelect && s4.setState({ isRenderAriaLiveMessage: true }), !s4.props.shouldCloseOnSelect || s4.props.showTimeSelect) s4.setPreSelection(e3);
      else if (!s4.props.inline) {
        s4.props.selectsRange || s4.setOpen(false);
        var n2 = s4.props, o3 = n2.startDate, a5 = n2.endDate;
        !o3 || a5 || isBefore(e3, o3) || s4.setOpen(false);
      }
    })), ve(ke(s4), "setSelected", (function(e3, t5, r2, n2) {
      var o3 = e3;
      if (s4.props.showYearPicker) {
        if (null !== o3 && at(getYear(o3), s4.props)) return;
      } else if (s4.props.showMonthYearPicker) {
        if (null !== o3 && tt(o3, s4.props)) return;
      } else if (null !== o3 && Ze(o3, s4.props)) return;
      var a5 = s4.props, i3 = a5.onChange, p2 = a5.selectsRange, c3 = a5.startDate, l2 = a5.endDate;
      if (!Ve(s4.props.selected, o3) || s4.props.allowSameDay || p2) if (null !== o3 && (!s4.props.selected || r2 && (s4.props.showTimeSelect || s4.props.showTimeSelectOnly || s4.props.showTimeInput) || (o3 = Re(o3, { hour: getHours(s4.props.selected), minute: getMinutes(s4.props.selected), second: getSeconds(s4.props.selected) })), s4.props.inline || s4.setState({ preSelection: o3 }), s4.props.focusSelectedMonth || s4.setState({ monthSelectedIn: n2 })), p2) {
        var d4 = c3 && !l2, u3 = c3 && l2;
        !c3 && !l2 ? i3([o3, null], t5) : d4 && (isBefore(o3, c3) ? i3([o3, null], t5) : i3([c3, o3], t5)), u3 && i3([o3, null], t5);
      } else i3(o3, t5);
      r2 || (s4.props.onSelect(o3, t5), s4.setState({ inputValue: null }));
    })), ve(ke(s4), "setPreSelection", (function(e3) {
      var t5 = void 0 !== s4.props.minDate, r2 = void 0 !== s4.props.maxDate, n2 = true;
      if (e3) {
        var o3 = startOfDay(e3);
        if (t5 && r2) n2 = qe(e3, s4.props.minDate, s4.props.maxDate);
        else if (t5) {
          var a5 = startOfDay(s4.props.minDate);
          n2 = isAfter(e3, a5) || Ve(o3, a5);
        } else if (r2) {
          var i3 = endOfDay(s4.props.maxDate);
          n2 = isBefore(e3, i3) || Ve(o3, i3);
        }
      }
      n2 && s4.setState({ preSelection: e3 });
    })), ve(ke(s4), "handleTimeChange", (function(e3) {
      var t5 = Re(s4.props.selected ? s4.props.selected : s4.getPreSelection(), { hour: getHours(e3), minute: getMinutes(e3) });
      s4.setState({ preSelection: t5 }), s4.props.onChange(t5), s4.props.shouldCloseOnSelect && s4.setOpen(false), s4.props.showTimeInput && s4.setOpen(true), (s4.props.showTimeSelectOnly || s4.props.showTimeSelect) && s4.setState({ isRenderAriaLiveMessage: true }), s4.setState({ inputValue: null });
    })), ve(ke(s4), "onInputClick", (function() {
      s4.props.disabled || s4.props.readOnly || s4.setOpen(true), s4.props.onInputClick();
    })), ve(ke(s4), "onInputKeyDown", (function(e3) {
      s4.props.onKeyDown(e3);
      var t5 = e3.key;
      if (s4.state.open || s4.props.inline || s4.props.preventOpenOnFocus) {
        if (s4.state.open) {
          if ("ArrowDown" === t5 || "ArrowUp" === t5) {
            e3.preventDefault();
            var r2 = s4.calendar.componentNode && s4.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
            return void (r2 && r2.focus({ preventScroll: true }));
          }
          var n2 = Ye(s4.state.preSelection);
          "Enter" === t5 ? (e3.preventDefault(), s4.inputOk() && s4.state.lastPreSelectChange === er ? (s4.handleSelect(n2, e3), !s4.props.shouldCloseOnSelect && s4.setPreSelection(n2)) : s4.setOpen(false)) : "Escape" === t5 ? (e3.preventDefault(), s4.setOpen(false)) : "Tab" === t5 && e3.shiftKey && s4.setOpen(false), s4.inputOk() || s4.props.onInputError({ code: 1, msg: Jt });
        }
      } else "ArrowDown" !== t5 && "ArrowUp" !== t5 && "Enter" !== t5 || s4.onInputClick();
    })), ve(ke(s4), "onPortalKeyDown", (function(e3) {
      "Escape" === e3.key && (e3.preventDefault(), s4.setState({ preventFocus: true }, (function() {
        s4.setOpen(false), setTimeout((function() {
          s4.setFocus(), s4.setState({ preventFocus: false });
        }));
      })));
    })), ve(ke(s4), "onDayKeyDown", (function(e3) {
      s4.props.onKeyDown(e3);
      var t5 = e3.key, r2 = Ye(s4.state.preSelection);
      if ("Enter" === t5) e3.preventDefault(), s4.handleSelect(r2, e3), !s4.props.shouldCloseOnSelect && s4.setPreSelection(r2);
      else if ("Escape" === t5) e3.preventDefault(), s4.setOpen(false), s4.inputOk() || s4.props.onInputError({ code: 1, msg: Jt });
      else if (!s4.props.disabledKeyboardNavigation) {
        var n2;
        switch (t5) {
          case "ArrowLeft":
            n2 = subDays(r2, 1);
            break;
          case "ArrowRight":
            n2 = addDays(r2, 1);
            break;
          case "ArrowUp":
            n2 = subWeeks(r2, 1);
            break;
          case "ArrowDown":
            n2 = addWeeks(r2, 1);
            break;
          case "PageUp":
            n2 = subMonths(r2, 1);
            break;
          case "PageDown":
            n2 = addMonths(r2, 1);
            break;
          case "Home":
            n2 = subYears(r2, 1);
            break;
          case "End":
            n2 = addYears(r2, 1);
        }
        if (!n2) return void (s4.props.onInputError && s4.props.onInputError({ code: 1, msg: Jt }));
        if (e3.preventDefault(), s4.setState({ lastPreSelectChange: er }), s4.props.adjustDateOnChange && s4.setSelected(n2), s4.setPreSelection(n2), s4.props.inline) {
          var o3 = getMonth(r2), a5 = getMonth(n2), i3 = getYear(r2), d4 = getYear(n2);
          o3 !== a5 || i3 !== d4 ? s4.setState({ shouldFocusDayInline: true }) : s4.setState({ shouldFocusDayInline: false });
        }
      }
    })), ve(ke(s4), "onPopperKeyDown", (function(e3) {
      "Escape" === e3.key && (e3.preventDefault(), s4.setState({ preventFocus: true }, (function() {
        s4.setOpen(false), setTimeout((function() {
          s4.setFocus(), s4.setState({ preventFocus: false });
        }));
      })));
    })), ve(ke(s4), "onClearClick", (function(e3) {
      e3 && e3.preventDefault && e3.preventDefault(), s4.props.selectsRange ? s4.props.onChange([null, null], e3) : s4.props.onChange(null, e3), s4.setState({ inputValue: null });
    })), ve(ke(s4), "clear", (function() {
      s4.onClearClick();
    })), ve(ke(s4), "onScroll", (function(e3) {
      "boolean" == typeof s4.props.closeOnScroll && s4.props.closeOnScroll ? e3.target !== document && e3.target !== document.documentElement && e3.target !== document.body || s4.setOpen(false) : "function" == typeof s4.props.closeOnScroll && s4.props.closeOnScroll(e3) && s4.setOpen(false);
    })), ve(ke(s4), "renderCalendar", (function() {
      return s4.props.inline || s4.isCalendarOpen() ? React__default.createElement(Gt, { ref: function(e3) {
        s4.calendar = e3;
      }, locale: s4.props.locale, calendarStartDay: s4.props.calendarStartDay, chooseDayAriaLabelPrefix: s4.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: s4.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: s4.props.weekAriaLabelPrefix, monthAriaLabelPrefix: s4.props.monthAriaLabelPrefix, adjustDateOnChange: s4.props.adjustDateOnChange, setOpen: s4.setOpen, shouldCloseOnSelect: s4.props.shouldCloseOnSelect, dateFormat: s4.props.dateFormatCalendar, useWeekdaysShort: s4.props.useWeekdaysShort, formatWeekDay: s4.props.formatWeekDay, dropdownMode: s4.props.dropdownMode, selected: s4.props.selected, preSelection: s4.state.preSelection, onSelect: s4.handleSelect, onWeekSelect: s4.props.onWeekSelect, openToDate: s4.props.openToDate, minDate: s4.props.minDate, maxDate: s4.props.maxDate, selectsStart: s4.props.selectsStart, selectsEnd: s4.props.selectsEnd, selectsRange: s4.props.selectsRange, startDate: s4.props.startDate, endDate: s4.props.endDate, excludeDates: s4.props.excludeDates, excludeDateIntervals: s4.props.excludeDateIntervals, filterDate: s4.props.filterDate, onClickOutside: s4.handleCalendarClickOutside, formatWeekNumber: s4.props.formatWeekNumber, highlightDates: s4.state.highlightDates, includeDates: s4.props.includeDates, includeDateIntervals: s4.props.includeDateIntervals, includeTimes: s4.props.includeTimes, injectTimes: s4.props.injectTimes, inline: s4.props.inline, shouldFocusDayInline: s4.state.shouldFocusDayInline, peekNextMonth: s4.props.peekNextMonth, showMonthDropdown: s4.props.showMonthDropdown, showPreviousMonths: s4.props.showPreviousMonths, useShortMonthInDropdown: s4.props.useShortMonthInDropdown, showMonthYearDropdown: s4.props.showMonthYearDropdown, showWeekNumbers: s4.props.showWeekNumbers, showYearDropdown: s4.props.showYearDropdown, withPortal: s4.props.withPortal, forceShowMonthNavigation: s4.props.forceShowMonthNavigation, showDisabledMonthNavigation: s4.props.showDisabledMonthNavigation, scrollableYearDropdown: s4.props.scrollableYearDropdown, scrollableMonthYearDropdown: s4.props.scrollableMonthYearDropdown, todayButton: s4.props.todayButton, weekLabel: s4.props.weekLabel, outsideClickIgnoreClass: $t, fixedHeight: s4.props.fixedHeight, monthsShown: s4.props.monthsShown, monthSelectedIn: s4.state.monthSelectedIn, onDropdownFocus: s4.handleDropdownFocus, onMonthChange: s4.props.onMonthChange, onYearChange: s4.props.onYearChange, dayClassName: s4.props.dayClassName, weekDayClassName: s4.props.weekDayClassName, monthClassName: s4.props.monthClassName, timeClassName: s4.props.timeClassName, showDateSelect: s4.props.showDateSelect, showTimeSelect: s4.props.showTimeSelect, showTimeSelectOnly: s4.props.showTimeSelectOnly, onTimeChange: s4.handleTimeChange, timeFormat: s4.props.timeFormat, timeIntervals: s4.props.timeIntervals, minTime: s4.props.minTime, maxTime: s4.props.maxTime, excludeTimes: s4.props.excludeTimes, filterTime: s4.props.filterTime, timeCaption: s4.props.timeCaption, className: s4.props.calendarClassName, container: s4.props.calendarContainer, yearItemNumber: s4.props.yearItemNumber, yearDropdownItemNumber: s4.props.yearDropdownItemNumber, previousMonthAriaLabel: s4.props.previousMonthAriaLabel, previousMonthButtonLabel: s4.props.previousMonthButtonLabel, nextMonthAriaLabel: s4.props.nextMonthAriaLabel, nextMonthButtonLabel: s4.props.nextMonthButtonLabel, previousYearAriaLabel: s4.props.previousYearAriaLabel, previousYearButtonLabel: s4.props.previousYearButtonLabel, nextYearAriaLabel: s4.props.nextYearAriaLabel, nextYearButtonLabel: s4.props.nextYearButtonLabel, timeInputLabel: s4.props.timeInputLabel, disabledKeyboardNavigation: s4.props.disabledKeyboardNavigation, renderCustomHeader: s4.props.renderCustomHeader, popperProps: s4.props.popperProps, renderDayContents: s4.props.renderDayContents, renderMonthContent: s4.props.renderMonthContent, renderQuarterContent: s4.props.renderQuarterContent, renderYearContent: s4.props.renderYearContent, onDayMouseEnter: s4.props.onDayMouseEnter, onMonthMouseLeave: s4.props.onMonthMouseLeave, onYearMouseEnter: s4.props.onYearMouseEnter, onYearMouseLeave: s4.props.onYearMouseLeave, selectsDisabledDaysInRange: s4.props.selectsDisabledDaysInRange, showTimeInput: s4.props.showTimeInput, showMonthYearPicker: s4.props.showMonthYearPicker, showFullMonthYearPicker: s4.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: s4.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: s4.props.showFourColumnMonthYearPicker, showYearPicker: s4.props.showYearPicker, showQuarterYearPicker: s4.props.showQuarterYearPicker, showPopperArrow: s4.props.showPopperArrow, excludeScrollbar: s4.props.excludeScrollbar, handleOnKeyDown: s4.props.onKeyDown, handleOnDayKeyDown: s4.onDayKeyDown, isInputFocused: s4.state.focused, customTimeInput: s4.props.customTimeInput, setPreSelection: s4.setPreSelection }, s4.props.children) : null;
    })), ve(ke(s4), "renderAriaLiveRegion", (function() {
      var t5, r2 = s4.props, n2 = r2.dateFormat, o3 = r2.locale, a5 = s4.props.showTimeInput || s4.props.showTimeSelect ? "PPPPp" : "PPPP";
      return t5 = s4.props.selectsRange ? "Selected start date: ".concat(Te(s4.props.startDate, { dateFormat: a5, locale: o3 }), ". ").concat(s4.props.endDate ? "End date: " + Te(s4.props.endDate, { dateFormat: a5, locale: o3 }) : "") : s4.props.showTimeSelectOnly ? "Selected time: ".concat(Te(s4.props.selected, { dateFormat: n2, locale: o3 })) : s4.props.showYearPicker ? "Selected year: ".concat(Te(s4.props.selected, { dateFormat: "yyyy", locale: o3 })) : s4.props.showMonthYearPicker ? "Selected month: ".concat(Te(s4.props.selected, { dateFormat: "MMMM yyyy", locale: o3 })) : s4.props.showQuarterYearPicker ? "Selected quarter: ".concat(Te(s4.props.selected, { dateFormat: "yyyy, QQQ", locale: o3 })) : "Selected date: ".concat(Te(s4.props.selected, { dateFormat: a5, locale: o3 })), React__default.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, t5);
    })), ve(ke(s4), "renderDateInput", (function() {
      var t5, n2 = r(s4.props.className, ve({}, $t, s4.state.open)), o3 = s4.props.customInput || React__default.createElement("input", { type: "text" }), a5 = s4.props.customInputRef || "ref", i3 = "string" == typeof s4.props.value ? s4.props.value : "string" == typeof s4.state.inputValue ? s4.state.inputValue : s4.props.selectsRange ? (function(e3, t6, r2) {
        if (!e3) return "";
        var n3 = Te(e3, r2), o4 = t6 ? Te(t6, r2) : "";
        return "".concat(n3, " - ").concat(o4);
      })(s4.props.startDate, s4.props.endDate, s4.props) : Te(s4.props.selected, s4.props);
      return React__default.cloneElement(o3, (ve(t5 = {}, a5, (function(e3) {
        s4.input = e3;
      })), ve(t5, "value", i3), ve(t5, "onBlur", s4.handleBlur), ve(t5, "onChange", s4.handleChange), ve(t5, "onClick", s4.onInputClick), ve(t5, "onFocus", s4.handleFocus), ve(t5, "onKeyDown", s4.onInputKeyDown), ve(t5, "id", s4.props.id), ve(t5, "name", s4.props.name), ve(t5, "form", s4.props.form), ve(t5, "autoFocus", s4.props.autoFocus), ve(t5, "placeholder", s4.props.placeholderText), ve(t5, "disabled", s4.props.disabled), ve(t5, "autoComplete", s4.props.autoComplete), ve(t5, "className", r(o3.props.className, n2)), ve(t5, "title", s4.props.title), ve(t5, "readOnly", s4.props.readOnly), ve(t5, "required", s4.props.required), ve(t5, "tabIndex", s4.props.tabIndex), ve(t5, "aria-describedby", s4.props.ariaDescribedBy), ve(t5, "aria-invalid", s4.props.ariaInvalid), ve(t5, "aria-labelledby", s4.props.ariaLabelledBy), ve(t5, "aria-required", s4.props.ariaRequired), t5));
    })), ve(ke(s4), "renderClearButton", (function() {
      var t5 = s4.props, r2 = t5.isClearable, n2 = t5.selected, o3 = t5.startDate, a5 = t5.endDate, i3 = t5.clearButtonTitle, p2 = t5.clearButtonClassName, c3 = void 0 === p2 ? "" : p2, l2 = t5.ariaLabelClose, d4 = void 0 === l2 ? "Close" : l2;
      return !r2 || null == n2 && null == o3 && null == a5 ? null : React__default.createElement("button", { type: "button", className: "react-datepicker__close-icon ".concat(c3).trim(), "aria-label": d4, onClick: s4.onClearClick, title: i3, tabIndex: -1 });
    })), s4.state = s4.calcInitialState(), s4;
  }
  return fe(a4, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, true);
  } }, { key: "componentDidUpdate", value: function(e3, t4) {
    var r2, n2;
    e3.inline && (r2 = e3.selected, n2 = this.props.selected, r2 && n2 ? getMonth(r2) !== getMonth(n2) || getYear(r2) !== getYear(n2) : r2 !== n2) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e3.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e3.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: yt(this.props.highlightDates) }), t4.focused || Ve(e3.selected, this.props.selected) || this.setState({ inputValue: null }), t4.open !== this.state.open && (false === t4.open && true === this.state.open && this.props.onCalendarOpen(), true === t4.open && false === this.state.open && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, true);
  } }, { key: "renderInputContainer", value: function() {
    var t4 = this.props.showIcon;
    return React__default.createElement("div", { className: "react-datepicker__input-container".concat(t4 ? " react-datepicker__view-calendar-icon" : "") }, t4 && React__default.createElement("svg", { className: "react-datepicker__calendar-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" }, React__default.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var t4 = this.renderCalendar();
    if (this.props.inline) return t4;
    if (this.props.withPortal) {
      var r2 = this.state.open ? React__default.createElement(Ut, { enableTabLoop: this.props.enableTabLoop }, React__default.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t4)) : null;
      return this.state.open && this.props.portalId && (r2 = React__default.createElement(Vt, { portalId: this.props.portalId, portalHost: this.props.portalHost }, r2)), React__default.createElement("div", null, this.renderInputContainer(), r2);
    }
    return React__default.createElement(zt, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: t4, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: false, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: false, disabledKeyboardNavigation: false, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: false, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: false, withPortal: false, selectsDisabledDaysInRange: false, shouldCloseOnSelect: true, showTimeSelect: false, showTimeInput: false, showPreviousMonths: false, showMonthYearPicker: false, showFullMonthYearPicker: false, showTwoColumnMonthYearPicker: false, showFourColumnMonthYearPicker: false, showYearPicker: false, showQuarterYearPicker: false, strictParsing: false, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: true, yearItemNumber: Ne, focusSelectedMonth: false, showPopperArrow: true, excludeScrollbar: true, customTimeInput: null, calendarStartDay: void 0 };
  } }]), a4;
})(), Zt = "input", er = "navigate";
const root = "availability-calendar-module_root__h3nk4";
const header$1 = "availability-calendar-module_header__a91pl";
const month = "availability-calendar-module_month__dNKKh";
const nav = "availability-calendar-module_nav__DU8XI";
const dayName = "availability-calendar-module_dayName__HF1dx";
const day = "availability-calendar-module_day__CiruZ";
const available = "availability-calendar-module_available__fUEgU";
const selected = "availability-calendar-module_selected__JBV6Z";
const styles$9 = {
  root,
  header: header$1,
  month,
  nav,
  dayName,
  day,
  available,
  selected
};
const padDay = (dayOfMonth) => String(dayOfMonth).padStart(2, "0");
const monthLabelOptions = {
  month: "long",
  year: "numeric"
};
const formatMonth = (date, locale2) => {
  const code = typeof locale2 === "string" ? locale2 : locale2?.code;
  try {
    return date.toLocaleDateString(code, monthLabelOptions);
  } catch {
    return date.toLocaleDateString(void 0, monthLabelOptions);
  }
};
const Chevron = ({ direction }) => /* @__PURE__ */ jsx$1(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    children: /* @__PURE__ */ jsx$1(
      "path",
      {
        d: direction === "left" ? "M10 3 5 8l5 5" : "M6 3l5 5-5 5",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const dayKey = (date) => date.getFullYear() * 1e4 + (date.getMonth() + 1) * 100 + date.getDate();
const AvailabilityCalendar = ({
  availableDates,
  selectedDate = null,
  onSelect,
  onMonthChange,
  initialMonth,
  minDate,
  maxDate,
  locale: locale2,
  className,
  ariaLabel = "Available dates",
  previousMonthAriaLabel = "Previous month",
  nextMonthAriaLabel = "Next month",
  chooseDayAriaLabelPrefix = "Choose",
  unavailableDayAriaLabelPrefix = "Not available"
}) => {
  const availableKeys = useMemo(
    () => new Set(availableDates.map(dayKey)),
    [availableDates]
  );
  const bounds = useMemo(() => {
    if (availableKeys.size === 0) {
      return null;
    }
    const keys = [...availableKeys];
    return { first: Math.min(...keys), last: Math.max(...keys) };
  }, [availableKeys]);
  const isAvailable = useCallback(
    (date) => availableKeys.has(dayKey(date)),
    [availableKeys]
  );
  const selectedKey = selectedDate ? dayKey(selectedDate) : null;
  const dayClassName = (date) => clsx(
    styles$9.day,
    isAvailable(date) && styles$9.available,
    dayKey(date) === selectedKey && styles$9.selected
  );
  const handleChange = (date) => {
    if (date) {
      onSelect(date);
    }
  };
  const renderHeader = ({
    monthDate,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  }) => {
    const year = monthDate.getFullYear();
    const month2 = monthDate.getMonth();
    const monthStartKey = dayKey(new Date(year, month2, 1));
    const nextMonthStartKey = dayKey(new Date(year, month2 + 1, 1));
    const hasEarlierSlot = bounds !== null && bounds.first < monthStartKey;
    const hasLaterSlot = bounds !== null && bounds.last >= nextMonthStartKey;
    return /* @__PURE__ */ jsxs("div", { className: styles$9.header, children: [
      /* @__PURE__ */ jsx$1(
        "button",
        {
          type: "button",
          className: styles$9.nav,
          "aria-label": previousMonthAriaLabel,
          onClick: decreaseMonth,
          disabled: prevMonthButtonDisabled || !hasEarlierSlot,
          children: /* @__PURE__ */ jsx$1(Chevron, { direction: "left" })
        }
      ),
      /* @__PURE__ */ jsx$1("span", { className: styles$9.month, children: formatMonth(monthDate, locale2) }),
      /* @__PURE__ */ jsx$1(
        "button",
        {
          type: "button",
          className: styles$9.nav,
          "aria-label": nextMonthAriaLabel,
          onClick: increaseMonth,
          disabled: nextMonthButtonDisabled || !hasLaterSlot,
          children: /* @__PURE__ */ jsx$1(Chevron, { direction: "right" })
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(styles$9.root, className),
      role: "group",
      "aria-label": ariaLabel,
      "data-testid": "availability-calendar",
      children: /* @__PURE__ */ jsx$1(
        Xt,
        {
          inline: true,
          selected: selectedDate,
          openToDate: selectedDate ?? initialMonth,
          filterDate: isAvailable,
          dayClassName,
          weekDayClassName: () => styles$9.dayName,
          minDate,
          maxDate,
          locale: locale2,
          calendarStartDay: 1,
          formatWeekDay: (nameOfDay) => nameOfDay.substring(0, 3),
          renderDayContents: padDay,
          renderCustomHeader: renderHeader,
          chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: unavailableDayAriaLabelPrefix,
          onChange: handleChange,
          onMonthChange
        }
      )
    }
  );
};
const checkbox = "checkbox-module_checkbox__aFjGa";
const checkbox__label = "checkbox-module_checkbox__label__KuEGC";
const checkbox__input = "checkbox-module_checkbox__input__v6EGi";
const styles$8 = {
  checkbox,
  "checkbox__input-container": "checkbox-module_checkbox__input-container__RzMJX",
  "checkbox__input-container-disabled": "checkbox-module_checkbox__input-container-disabled__pmZ1-",
  checkbox__label,
  "checkbox__bottom-text": "checkbox-module_checkbox__bottom-text__5IUNr",
  checkbox__input,
  "checkbox__input-disabled": "checkbox-module_checkbox__input-disabled__80xGK",
  "checkbox__input-error": "checkbox-module_checkbox__input-error__zqzLT",
  "checkbox--disabled": "checkbox-module_checkbox--disabled__HYEF5",
  "checkbox--error": "checkbox-module_checkbox--error__DxME7"
};
const Checkbox = ({
  checked,
  indeterminate = false,
  label: label2,
  id,
  name: name2,
  disabled: disabled2 = false,
  hasError,
  bottomText,
  bottomTextAriaLive = "polite",
  className,
  dataTestid,
  onChange: onChange2,
  tabIndex,
  ariaLabel,
  ariaRequired,
  ...props
}) => {
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  });
  const handleLabelClick = (e3) => {
    if (disabled2 || id) {
      e3.preventDefault();
    }
    !disabled2 && onChange2(e3);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": dataTestid ? `${dataTestid}-wrapper` : "checkbox-wrapper",
      className: clsx(
        className,
        styles$8["checkbox"],
        disabled2 && styles$8["checkbox--disabled"],
        hasError && styles$8["checkbox--error"]
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: clsx(
              styles$8["checkbox__input-container"],
              disabled2 && styles$8["checkbox__input-container-disabled"]
            ),
            children: [
              /* @__PURE__ */ jsx$1(
                "input",
                {
                  ref: inputRef,
                  className: clsx(
                    styles$8["checkbox__input"],
                    disabled2 && styles$8["checkbox__input-disabled"],
                    hasError && styles$8["checkbox__input-error"]
                  ),
                  "data-testid": dataTestid ? `${dataTestid}-input` : "checkbox",
                  type: "checkbox",
                  id,
                  name: name2,
                  checked,
                  readOnly: true,
                  "aria-checked": indeterminate ? "mixed" : void 0,
                  "aria-disabled": disabled2,
                  "aria-invalid": hasError,
                  "aria-errormessage": `checkbox-error-message-${id}`,
                  "aria-label": ariaLabel,
                  "aria-required": ariaRequired,
                  onClick: (e3) => !disabled2 ? onChange2(e3) : e3.preventDefault(),
                  tabIndex,
                  ...props
                }
              ),
              label2 && /* @__PURE__ */ jsx$1(
                "label",
                {
                  htmlFor: id,
                  className: styles$8["checkbox__label"],
                  onClick: handleLabelClick,
                  children: label2
                }
              )
            ]
          }
        ),
        Boolean(bottomText) && /* @__PURE__ */ jsx$1(
          "div",
          {
            className: styles$8["checkbox__bottom-text"],
            "aria-live": bottomTextAriaLive,
            id: `checkbox-error-message-${id}`,
            children: bottomText
          }
        )
      ]
    }
  );
};
const CheckboxGroupContext = createContext({
  onChange: () => {
  },
  value: []
});
const styles$7 = {
  "checkbox-group": "checkbox-group-module_checkbox-group__Ky8-Q",
  "checkbox-group__legend": "checkbox-group-module_checkbox-group__legend__-3ALf",
  "checkbox-group__error": "checkbox-group-module_checkbox-group__error__dLF42"
};
const CheckboxGroup = ({
  children,
  id,
  hasError,
  error: error2 = "",
  className,
  legend: legend2,
  value: value2,
  disabled: disabled2,
  onChange: onChange2
}) => {
  const errorElementId = `checkbox-group-error-${id}`;
  const handleChange = (optionId) => {
    if (value2.includes(optionId)) {
      return onChange2(
        value2.filter((prevOptionId) => prevOptionId !== optionId),
        id
      );
    }
    return onChange2([...value2, optionId], id);
  };
  return /* @__PURE__ */ jsx$1(
    CheckboxGroupContext.Provider,
    {
      value: {
        hasError,
        errorElementId,
        value: value2,
        onChange: handleChange,
        disabled: disabled2
      },
      children: /* @__PURE__ */ jsxs(
        "fieldset",
        {
          id,
          className: clsx(styles$7["checkbox-group"], className),
          "data-testid": "checkbox-group",
          children: [
            Boolean(legend2) && /* @__PURE__ */ jsx$1(
              "legend",
              {
                "data-testid": "checkbox-group-legend",
                className: styles$7["checkbox-group__legend"],
                children: legend2
              }
            ),
            children,
            /* @__PURE__ */ jsx$1(
              "p",
              {
                id: errorElementId,
                className: styles$7["checkbox-group__error"],
                role: "alert",
                "aria-live": "assertive",
                "aria-atomic": "true",
                children: error2
              }
            )
          ]
        }
      )
    }
  );
};
const styles$6 = {
  "checkbox-group-item": "checkbox-group-item-module_checkbox-group-item__75ahF",
  "checkbox-group-item__label": "checkbox-group-item-module_checkbox-group-item__label__jllE3",
  "checkbox-group-item__input": "checkbox-group-item-module_checkbox-group-item__input__wGjt6",
  "checkbox-group-item__input-disabled": "checkbox-group-item-module_checkbox-group-item__input-disabled__jHH-G",
  "checkbox-group-item__input-error": "checkbox-group-item-module_checkbox-group-item__input-error__mCCy3",
  "checkbox-group-item--disabled": "checkbox-group-item-module_checkbox-group-item--disabled__1aO5-",
  "checkbox-group-item--error": "checkbox-group-item-module_checkbox-group-item--error__yKo-i"
};
const CheckboxGroupItem = ({
  label: label2,
  id,
  name: name2,
  disabled: disabled2,
  stopEventPropagation,
  className,
  ...props
}) => {
  const checkboxGroupContextValue = useContext(CheckboxGroupContext);
  const checkboxLabelId = `checkbox-group-item-label-${id}`;
  const checked = checkboxGroupContextValue.value.includes(id);
  const parsedDisabled = disabled2 || checkboxGroupContextValue.disabled;
  const handleChange = (event) => {
    !parsedDisabled ? checkboxGroupContextValue.onChange(id) : event.preventDefault();
    if (stopEventPropagation) {
      event.stopPropagation();
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": "checkbox-group-item-wrapper",
      className: clsx(
        styles$6["checkbox-group-item"],
        parsedDisabled && styles$6["checkbox-group-item--disabled"],
        checkboxGroupContextValue.hasError && styles$6["checkbox-group-item--error"],
        className
      ),
      children: [
        /* @__PURE__ */ jsx$1(
          "input",
          {
            className: clsx(
              styles$6["checkbox-group-item__input"],
              disabled2 && styles$6["checkbox-group-item__input-disabled"],
              checkboxGroupContextValue.hasError && styles$6["checkbox-group-item__input-error"]
            ),
            "data-testid": "checkbox-group-item",
            type: "checkbox",
            id,
            name: name2,
            checked,
            readOnly: true,
            "aria-disabled": parsedDisabled,
            "aria-invalid": checkboxGroupContextValue.hasError,
            "aria-errormessage": checkboxGroupContextValue.errorElementId,
            "aria-describedby": checkboxLabelId,
            onClick: handleChange,
            ...props
          }
        ),
        label2 && /* @__PURE__ */ jsx$1(
          "span",
          {
            id: checkboxLabelId,
            className: styles$6["checkbox-group-item__label"],
            onClick: handleChange,
            children: label2
          }
        )
      ]
    }
  );
};
const dateFormat = "dd/MM/yyyy";
const popperModifiers = [
  {
    name: "offset",
    options: { offset: [0, 10] }
  },
  {
    name: "flip",
    options: { allowedAutoPlacements: ["top", "bottom"] }
  },
  {
    name: "preventOverflow",
    options: {
      rootBoundary: "viewport",
      tether: false,
      altAxis: true
    }
  }
];
const DATE_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
const Datepicker = ({
  label: label2,
  ariaLabel,
  ariaLabelClear = "Clear",
  id,
  hasError,
  errorText,
  bottomText,
  customPlaceholder,
  date,
  name: name2,
  isDisabled,
  className = "datepicker",
  isClearable = true,
  hideBottomTextWhenFilled = true,
  autoComplete,
  onDateChange,
  minDate
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [typing, setTyping] = useState(false);
  const [validDate, setValidDate] = useState(false);
  const [hideBottomText, setHideBottomText] = useState(false);
  const [dateValue, setDateValue] = useState();
  useEffect(() => {
    if (!date) {
      setTyping(false);
    }
    const allWithClass = Array.from(
      document.getElementsByClassName("react-datepicker__close-icon")
    );
    allWithClass.forEach((button2) => button2.setAttribute("tabindex", "0"));
  }, [date]);
  const handleChange = (newDate) => {
    onDateChange(newDate ? newDate.toDateString() : "");
  };
  const parsedValue = date ? new Date(date) : null;
  const refCustomInput = useRef();
  const isValidDate = (value2) => {
    return DATE_REGEX.test(value2);
  };
  const getPlaceholder = () => {
    if (!isDisabled && isOpen) {
      return "";
    }
    return hasError ? "DD/MM/YYYY" : customPlaceholder || label2;
  };
  const CustomInput2 = forwardRef(({ value: value2, onClick, onChange: onChange2, onFocus: onFocus2, onBlur, onKeyDown }, ref2) => {
    if (!value2) {
      setValidDate(false);
      setHideBottomText(false);
      setDateValue("");
    } else if (isValidDate(value2)) {
      setValidDate(true);
      setDateValue(value2);
    }
    const handleInputChange2 = (event) => {
      setDateValue(event.currentTarget.value);
      onChange2 && onChange2(event);
    };
    return /* @__PURE__ */ jsx$1(
      "input",
      {
        value: dateValue,
        className: clsx("calendar-custom-input", hasError && "input-error"),
        onClick: !isDisabled ? onClick : () => {
        },
        onChange: !isDisabled ? handleInputChange2 : () => {
        },
        onKeyDown,
        onFocus: onFocus2,
        autoFocus: isOpen || typing,
        onBlur,
        ref: ref2,
        tabIndex: 0,
        id,
        placeholder: getPlaceholder(),
        "data-testid": "datepicker-input",
        "aria-disabled": isDisabled,
        "aria-label": ariaLabel,
        "aria-describedby": `input-label-${id}`,
        "aria-invalid": hasError,
        "aria-errormessage": `input-error-message-${id}`,
        autoComplete
      }
    );
  });
  const datePickerRef = useRef(null);
  const handleKeyDown = (event) => {
    const { code } = event;
    if (code === "Tab" && datePickerRef.current?.isCalendarOpen()) {
      closeDatepicker();
    } else if (code === "Enter") {
      setHideBottomText(validDate);
    } else if (code !== "Backspace" && !isDisabled) {
      setTyping(true);
    }
  };
  const handleInputClick = () => {
    setIsOpen(true);
  };
  const setDateValueToCorrectDate = () => {
    if (typing && parsedValue) {
      setDateValue(parsedValue.toLocaleDateString("en-GB"));
    }
  };
  const closeDatepicker = () => {
    setIsOpen(false);
    setDateValueToCorrectDate();
  };
  const handleBlur = () => {
    setDateValueToCorrectDate();
    setTyping(false);
    setHideBottomText(validDate);
  };
  const getBottomText = () => {
    if (hasError) {
      return errorText || bottomText;
    }
    return hideBottomTextWhenFilled && hideBottomText ? "" : bottomText;
  };
  const handleSelect = () => {
    setHideBottomText(true);
  };
  return /* @__PURE__ */ jsx$1(
    FieldLabel,
    {
      label: label2,
      displayLabel: !!date || hasError || !isDisabled && isOpen || typing,
      hasError,
      id,
      bottomText: getBottomText(),
      className: "sz-datepicker-form-field",
      disabled: isDisabled,
      children: /* @__PURE__ */ jsx$1("div", { className: clsx(className, isDisabled && "datepicker_disabled"), children: /* @__PURE__ */ jsx$1(
        Xt,
        {
          "data-testid": "datepicker",
          selected: parsedValue,
          popperClassName: "calendar-datepicker-class",
          disabled: isDisabled,
          "aria-disabled": isDisabled,
          dateFormat,
          minDate,
          formatWeekDay: (nameOfDay) => nameOfDay.substring(0, 3),
          calendarStartDay: 1,
          className: hasError ? "datepicker__input-error" : "",
          name: name2 || "",
          ref: datePickerRef,
          open: isOpen,
          preventOpenOnFocus: true,
          customInput: /* @__PURE__ */ jsx$1(CustomInput2, { ref: refCustomInput }),
          showYearDropdown: false,
          isClearable: !isDisabled && isClearable,
          ariaLabelClose: ariaLabelClear,
          popperPlacement: "top",
          popperModifiers,
          disabledKeyboardNavigation: true,
          enableTabLoop: false,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          onInputClick: handleInputClick,
          onBlur: handleBlur,
          onCalendarClose: closeDatepicker,
          onClickOutside: closeDatepicker,
          onSelect: handleSelect
        }
      ) })
    }
  );
};
const container$2 = "edit-form-wrapper-module_container__1rODH";
const header = "edit-form-wrapper-module_header__dQ-E0";
const title$2 = "edit-form-wrapper-module_title__EfCU-";
const buttonsWrapper = "edit-form-wrapper-module_buttonsWrapper__zYSzJ";
const contentWrapper$1 = "edit-form-wrapper-module_contentWrapper__AyhzO";
const styles$5 = {
  container: container$2,
  header,
  title: title$2,
  buttonsWrapper,
  contentWrapper: contentWrapper$1
};
function EditFormWrapper({
  children,
  title: title2,
  formId,
  onSaveClick,
  onCancelClick,
  onResetClick,
  saveBtnText,
  cancelBtnText,
  hasResetAllButton = true,
  resetAllBtnText,
  className
}) {
  const [rerenderTrigger, setRerenderTrigger] = React__default.useState(0);
  function handleResetAllClick() {
    setRerenderTrigger((_prev) => _prev + 1);
    onResetClick?.();
  }
  function handleSaveClick() {
    onSaveClick?.();
  }
  function handleCancelClick() {
    onCancelClick?.();
  }
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles$5.container, className), children: [
    /* @__PURE__ */ jsxs("div", { className: styles$5.header, children: [
      /* @__PURE__ */ jsx$1("p", { className: styles$5.title, children: title2 }),
      /* @__PURE__ */ jsxs("div", { className: styles$5.buttonsWrapper, children: [
        /* @__PURE__ */ jsx$1(Button$1, { size: "small", onClick: handleCancelClick, children: cancelBtnText ?? "Cancel" }),
        hasResetAllButton && /* @__PURE__ */ jsx$1(Button$1, { onClick: handleResetAllClick, size: "small", children: resetAllBtnText ?? "Reset all" }),
        /* @__PURE__ */ jsx$1(
          Button$1,
          {
            variant: "secondary",
            size: "small",
            onClick: handleSaveClick,
            form: formId,
            type: "submit",
            children: saveBtnText ?? "Save"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx$1(ContentWrapper, { children }, rerenderTrigger)
  ] });
}
function ContentWrapper({ children }) {
  return /* @__PURE__ */ jsx$1("div", { className: styles$5.contentWrapper, children });
}
const FileInputField = ({
  label: label2,
  id,
  hasError,
  bottomText,
  value: value2,
  className,
  ...rest
}) => /* @__PURE__ */ jsx$1(
  FieldLabel,
  {
    label: label2,
    displayLabel: !!value2,
    hasError,
    id,
    bottomText,
    className,
    children: /* @__PURE__ */ jsx$1(FileUploadInput, { id, hasError, value: value2, ...rest })
  }
);
const CheckboxPure = memo(Checkbox);
const FormikCheckboxFormField = ({
  id,
  onChange: onChange2,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    () => {
      helpers.setValue(!field.value);
      onChange2?.(!field.value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [field.value]
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    CheckboxPure,
    {
      checked: field.value,
      onChange: handleChange,
      id,
      hasError,
      bottomText: hasError ? meta.error : "",
      ...props
    }
  );
};
const DatepickerPure = memo(Datepicker);
const FormikDatepicker = ({
  id,
  onDateChange,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleDateChange = useCallback(
    (newValues) => {
      helpers.setValue(newValues);
      onDateChange?.(newValues);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    DatepickerPure,
    {
      id,
      date: field.value,
      onDateChange: handleDateChange,
      hasError,
      errorText: hasError ? meta.error : "",
      ...props
    }
  );
};
const FileInputFieldPure = memo(FileInputField);
const FormikFileInput = ({
  id,
  onChange: onChange2,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues) => {
      helpers.setValue(newValues);
      onChange2?.(newValues, id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    FileInputFieldPure,
    {
      id,
      value: field.value,
      onChange: handleChange,
      hasError,
      bottomText: hasError ? meta.error : "",
      ...props
    }
  );
};
const MultiselectFormField = ({
  label: label2,
  id,
  hasError,
  bottomText,
  value: value2,
  ariaLabel,
  ...rest
}) => /* @__PURE__ */ jsx$1(
  FieldLabel,
  {
    label: value2?.length ? label2 : "",
    hasError,
    id,
    bottomText,
    children: /* @__PURE__ */ jsx$1(
      Multiselect,
      {
        id,
        hasError,
        value: value2,
        ariaLabel: ariaLabel ? ariaLabel : label2,
        ...rest
      }
    )
  }
);
const MultiselectFormFieldPure = memo(MultiselectFormField);
const FormikMultiselectFormField = ({
  id,
  options: options2,
  onChange: onChange2,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues, id2, actionMeta) => {
      helpers.setValue(newValues);
      onChange2?.(newValues, id2, actionMeta);
    },
    [onChange2, id]
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    MultiselectFormFieldPure,
    {
      id,
      value: field.value,
      onChange: handleChange,
      options: options2,
      hasError,
      bottomText: hasError ? meta.error : "",
      ...props
    }
  );
};
const radioButtonGroup = "radio-button-group-module_radioButtonGroup__hr6lj";
const title$1 = "radio-button-group-module_title__tZKXy";
const titleDisabled = "radio-button-group-module_titleDisabled__c7JNg";
const items = "radio-button-group-module_items__ZOW6r";
const horizontal = "radio-button-group-module_horizontal__iAlDz";
const error$1 = "radio-button-group-module_error__BwBCu";
const styles$4 = {
  radioButtonGroup,
  title: title$1,
  titleDisabled,
  items,
  horizontal,
  error: error$1
};
function RadioButtonGroup({
  id,
  name: name2,
  label: label2,
  value: value2,
  ariaLabel,
  options: options2 = [],
  className,
  radioButtonClassName,
  hasError,
  error: error2,
  disabled: disabled2,
  layout = "vertical",
  withSquareOutline,
  onChange: onChange2,
  onClick,
  onEnterOrSpace
}) {
  const errorElementId = `radio-button-group-error-${id}`;
  const handleChange = (e3, id2) => {
    onChange2(e3.target.value, id2);
  };
  const handleKeyPress = (event) => {
    if (onEnterOrSpace && (event.key === "Enter" || event.key === " ")) {
      onEnterOrSpace();
    }
  };
  return /* @__PURE__ */ jsxs(
    "fieldset",
    {
      id,
      "data-testid": `radio-button-group-${id}`,
      "aria-label": ariaLabel || label2,
      "aria-disabled": disabled2,
      className: clsx(styles$4.radioButtonGroup, className),
      onKeyDown: handleKeyPress,
      children: [
        !!label2 && /* @__PURE__ */ jsx$1(
          "legend",
          {
            "data-testid": "radio-button-group-legend",
            className: clsx(styles$4.title, disabled2 && styles$4.titleDisabled),
            children: label2
          }
        ),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: clsx(
              styles$4.items,
              layout !== "vertical" && styles$4.horizontal
            ),
            children: options2.map((option) => /* @__PURE__ */ jsx$1(
              RadioButton,
              {
                name: name2,
                id: option.id,
                inputId: `${id}-${option.id}`,
                value: option.value,
                checked: value2 === option.value,
                ariaLabel: option.ariaLabel,
                hasError: option.hasError || hasError,
                errorElementId,
                disabled: option.disabled || disabled2,
                withSquareOutline,
                onChange: handleChange,
                onClick,
                withImage: !!option.image,
                className: radioButtonClassName,
                children: !!option.image ? /* @__PURE__ */ jsx$1(
                  SvgWithLabel,
                  {
                    label: option.label,
                    selected: value2 === option.value,
                    disabled: disabled2 || option.disabled,
                    hasError,
                    children: option.image
                  }
                ) : option.label
              },
              option.id
            ))
          }
        ),
        hasError && error2 && /* @__PURE__ */ jsx$1(
          "p",
          {
            id: errorElementId,
            className: styles$4.error,
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            children: error2
          }
        )
      ]
    }
  );
}
const FormikRadioButtonGroup = ({
  id,
  onChange: onChange2,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues) => {
      helpers.setValue(newValues);
      onChange2?.(newValues, id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    RadioButtonGroup,
    {
      value: field.value,
      onChange: handleChange,
      id,
      hasError,
      error: hasError ? meta.error : "",
      ...props
    }
  );
};
function SelectFormField({
  label: label2,
  id,
  hasError,
  bottomText,
  value: value2,
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx$1(
    FieldLabel,
    {
      label: label2,
      displayLabel: !!value2?.value,
      hasError,
      id,
      bottomText,
      className,
      children: /* @__PURE__ */ jsx$1(Select2, { id, hasError, value: value2, ...rest })
    }
  );
}
function FormikSelectFormField({
  id,
  options: options2,
  onChange: onChange2,
  useFormikField,
  ...props
}) {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues) => {
      helpers.setValue(newValues);
      onChange2?.(newValues, id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const hasError = Boolean(meta.error && meta.touched);
  const error2 = meta.error;
  return /* @__PURE__ */ jsx$1(
    SelectFormField,
    {
      id,
      value: field.value,
      onChange: handleChange,
      options: options2,
      hasError,
      bottomText: hasError ? error2?.value : "",
      ...props
    }
  );
}
const MenuButton = ({ children, onClick }) => {
  return /* @__PURE__ */ jsx$1(
    "button",
    {
      className: "sz-select-with-menu-button__menu-button",
      onClick,
      type: "button",
      children
    }
  );
};
const SingleValue = ({
  children,
  ...props
}) => {
  if (!props.data) {
    return /* @__PURE__ */ jsx$1(components.SingleValue, { ...props, children });
  }
  return /* @__PURE__ */ jsxs(components.SingleValue, { ...props, children: [
    /* @__PURE__ */ jsx$1("div", { className: "sz-select-with-menu-button__selected-value-label", children: props.data.label }),
    props.data.labelNote ? /* @__PURE__ */ jsx$1("div", { className: "sz-select-with-menu-button__selected-value-label-note", children: props.data.labelNote }) : null
  ] });
};
const Option = ({
  data,
  ...rest
}) => {
  if (!data) {
    return null;
  }
  return /* @__PURE__ */ jsxs(components.Option, { data, ...rest, children: [
    /* @__PURE__ */ jsx$1("div", { className: "sz-select-with-menu-button__option-label", children: data.label }),
    data.labelNote ? /* @__PURE__ */ jsx$1("div", { className: "sz-select-with-menu-button__option-label-note", children: data.labelNote }) : null
  ] });
};
const MenuList = (props) => {
  const { menuButtonProps, hasMenuButton } = props.selectProps;
  return /* @__PURE__ */ jsxs(components.MenuList, { ...props, children: [
    hasMenuButton ? /* @__PURE__ */ jsx$1("div", { className: "sz-select-with-menu-button__menu-button-wrapper", children: /* @__PURE__ */ jsx$1(MenuButton, { ...menuButtonProps }) }) : null,
    props.children
  ] });
};
const SelectWithMenuButton = ({
  hasMenuButton = true,
  menuButtonProps,
  className,
  ...rest
}) => /* @__PURE__ */ jsx$1(
  Select2,
  {
    components: { MenuList, Option, SingleValue },
    className: `sz-select-with-menu-button${className ? ` ${className}` : ""}`,
    selectProps: {
      hasMenuButton,
      menuButtonProps
    },
    hasIndicator: false,
    ...rest
  }
);
const SelectWithMenuButtonField = ({
  label: label2,
  id,
  hasError,
  bottomText,
  value: value2,
  ...rest
}) => /* @__PURE__ */ jsx$1(
  FieldLabel,
  {
    label: value2?.value ? label2 : "",
    hasError,
    id,
    bottomText,
    children: /* @__PURE__ */ jsx$1(SelectWithMenuButton, { id, hasError, value: value2, ...rest })
  }
);
const SelectWithMenuButtonPure = memo(SelectWithMenuButtonField);
const FormikSelectWithMenuButton = ({
  id,
  options: options2,
  useFormikField,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues) => helpers.setValue(newValues),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const hasError = Boolean(meta.error && meta.touched);
  const error2 = meta.error;
  return /* @__PURE__ */ jsx$1(
    SelectWithMenuButtonPure,
    {
      id,
      value: field.value,
      onChange: handleChange,
      options: options2,
      hasError,
      bottomText: hasError ? error2?.value : "",
      ...props
    }
  );
};
const TextInputField = ({
  label: label2,
  id,
  hasError,
  bottomText,
  value: value2,
  className,
  disabled: disabled2,
  errorAriaLive,
  onChange: onChange2,
  onBlur,
  onFocus: onFocus2,
  type: type2,
  ariaLabel,
  icon: icon2,
  autoComplete,
  required,
  inputRef,
  renderBottomText = true,
  ...restInputProps
}) => /* @__PURE__ */ jsx$1(
  FieldLabel,
  {
    label: label2,
    displayLabel: !!value2,
    hasError,
    id,
    bottomText,
    className,
    disabled: disabled2,
    ariaLabel,
    errorAriaLive,
    preventLableClickEvent: true,
    renderBottomText,
    children: /* @__PURE__ */ jsx$1(
      TextInput,
      {
        id,
        hasError,
        value: value2,
        disabled: disabled2,
        onChange: onChange2,
        onBlur,
        type: type2,
        ariaLabel,
        icon: icon2,
        autoComplete,
        required,
        inputRef,
        ...restInputProps
      }
    )
  }
);
const FormikTextInputField = ({
  id,
  onChange: onChange2,
  useFormikField,
  inputRef,
  ...props
}) => {
  const [field, meta, helpers] = useFormikField(id);
  const handleChange = useCallback(
    (newValues) => {
      helpers.setValue(newValues);
      onChange2?.(newValues, id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const hasError = Boolean(meta.error && meta.touched);
  return /* @__PURE__ */ jsx$1(
    TextInputField,
    {
      id,
      value: field.value,
      onChange: handleChange,
      hasError,
      bottomText: hasError ? meta.error : "",
      inputRef,
      ...props
    }
  );
};
function SpottedZebraLogo() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "61",
      height: "24",
      viewBox: "0 0 61 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_276_29978)", children: [
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M18.2942 10.1239L22.2307 3.16211C21.9161 3.17779 21.6044 3.22485 21.3002 3.30187L17.9951 9.14708C18.0694 9.48708 18.1704 9.8154 18.2942 10.124V10.1239Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M20.2092 3.72559C19.438 4.13965 18.7755 4.76006 18.3078 5.58226L18.3013 5.59376C17.9783 6.31838 17.8367 7.12107 17.8493 7.89919L20.2092 3.72559Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M19.1777 11.574L23.8245 3.35588C23.5735 3.28043 23.3193 3.22692 23.0643 3.19434L18.6934 10.9244C18.8401 11.1644 19.0024 11.3828 19.1777 11.574Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M20.0751 12.245C20.1894 12.2959 20.3047 12.3433 20.4204 12.387L25.1634 3.99902C25.0622 3.92949 24.9577 3.86326 24.8498 3.8007C24.742 3.73814 24.6326 3.68028 24.5222 3.62695L19.75 12.0667C19.8556 12.1357 19.9641 12.1955 20.0751 12.245Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M26.6289 10.4423C27.0968 9.61484 27.298 8.70655 27.2605 7.81934L24.752 12.2559C25.5089 11.8697 26.1623 11.2675 26.6289 10.4421V10.4423Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M22.7578 12.7719C23.0715 12.7572 23.3804 12.715 23.6809 12.6453L27.0699 6.65165C26.9815 6.34685 26.864 6.05059 26.7182 5.76758L22.7578 12.7717V12.7719Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M21.9209 12.7465L26.2696 5.05542C26.1129 4.84891 25.9387 4.6539 25.7476 4.47266L21.1455 12.6116C21.4035 12.6742 21.6625 12.7193 21.9207 12.7465H21.9209Z",
              fill: "#0060F0"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M4.84337 7.20996L3.69874 6.78177C3.08214 6.5852 2.90619 6.29974 2.90619 5.99651C2.90619 5.67533 3.17038 5.35415 3.69874 5.35415C4.06836 5.35415 4.52621 5.51483 4.75548 6.22847L6.88649 5.69311C6.56951 4.19421 5.31893 3.21289 3.5928 3.21289C1.86666 3.21289 0.264184 4.22976 0.264184 5.96061C0.264184 7.12056 0.915872 8.12 2.43063 8.67296L3.66349 9.13687C4.26237 9.33344 4.43832 9.6189 4.43832 9.9223C4.43832 10.4397 3.98047 10.6896 3.48736 10.6896C2.62429 10.6896 2.30714 10.0652 2.16644 9.6189L0 10.2079C0.281727 11.9745 1.67316 12.8488 3.52245 12.8488C5.5654 12.8488 7.13296 11.7961 7.13296 9.92248C7.13296 8.24495 5.82959 7.54891 4.84337 7.20996Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M12.9978 3.21191C11.3776 3.21191 10.4265 4.10418 10.2854 4.44313H10.2326V3.39037H7.50275V16.0605H10.2326V11.6172H10.2854C10.4263 11.9561 11.3774 12.848 12.9978 12.848C15.076 12.848 17.3656 11.2599 17.3656 8.03014C17.3656 4.80039 15.076 3.21191 12.9978 3.21191ZM12.4342 10.3858C11.2366 10.3858 10.1621 9.54699 10.1621 8.03032C10.1621 6.51364 11.2364 5.6747 12.4342 5.6747C13.6319 5.6747 14.6885 6.53142 14.6885 8.03032C14.6885 9.52922 13.5965 10.3858 12.4342 10.3858Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M43.7542 12.8482C45.4274 12.8482 46.7308 12.1522 47.4881 11.1886L46.255 9.88578C45.586 10.4034 44.864 10.5998 44.0537 10.5998C42.8385 10.5998 41.9227 10.1001 41.5529 9.10069H48.0692C48.6504 4.85354 45.9207 3.21191 43.5958 3.21191C41.271 3.21191 38.9286 4.90722 38.9286 8.04792C38.9286 11.1886 41.2182 12.8482 43.7542 12.8482ZM43.6311 5.53163C44.5468 5.53163 45.4804 6.04939 45.674 7.11993H41.4999C41.7992 6.01349 42.715 5.53163 43.6311 5.53163Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M53.0249 12.8486C54.6452 12.8486 55.5962 11.9563 55.7372 11.6174H55.79V12.6702H58.5199V0H55.79V4.44337H55.7372C55.5963 4.10442 54.6452 3.21233 53.0249 3.21233C50.9466 3.21233 48.6572 4.80063 48.6572 8.03056C48.6572 11.2605 50.9468 12.8488 53.0249 12.8488V12.8486ZM53.5885 5.67477C54.7861 5.67477 55.8605 6.51353 55.8605 8.03038C55.8605 9.54723 54.7863 10.386 53.5885 10.386C52.3907 10.386 51.3519 9.52928 51.3519 8.03038C51.3519 6.53148 52.4261 5.67477 53.5885 5.67477Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M25.3296 14.542H16.9815V16.9511H20.9971L16.4531 23.8215H24.9423V21.4124H20.7857L25.3296 14.542Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M29.3977 14.3635C27.0376 14.3635 24.7305 16.0588 24.7305 19.1995C24.7305 22.3402 27.0201 23.9997 29.5561 23.9997C31.2293 23.9997 32.5325 23.3039 33.29 22.3402L32.0569 21.0373C31.3879 21.5549 30.6658 21.7513 29.8556 21.7513C28.6404 21.7513 27.7246 21.2515 27.3548 20.2521H33.8711C34.4523 16.0049 31.7226 14.3633 29.3977 14.3633V14.3635ZM27.302 18.2715C27.6012 17.165 28.5171 16.6832 29.4331 16.6832C30.3492 16.6832 31.2824 17.2009 31.4761 18.2715H27.302Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M39.8248 14.3633C38.2044 14.3633 37.2533 15.2555 37.1124 15.5945H37.0596V11.1511H37.0591V5.5851H38.9787V3.39016H37.0591V1.0166H34.3292V3.39016H32.9732H31.0558V1.01678H28.3259V3.39016H26.9697V5.58493H28.3259V12.7725H31.0558V5.5851H32.9732H34.3292V15.2057H34.3299V23.8213H37.0596V22.7685H37.1124C37.2533 23.1075 38.2044 23.9994 39.8248 23.9994C41.903 23.9994 44.1926 22.4113 44.1926 19.1815C44.1926 15.9517 41.903 14.3633 39.8248 14.3633ZM39.2612 21.5371C38.0636 21.5371 36.9894 20.6984 36.9894 19.1817C36.9894 17.665 38.0637 16.8261 39.2612 16.8261C40.4586 16.8261 41.5157 17.6828 41.5157 19.1817C41.5157 20.6806 40.4237 21.5371 39.2612 21.5371Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M50.7796 14.4533C50.5507 14.382 50.3395 14.3643 50.1279 14.3643C48.4725 14.3643 47.5918 15.5598 47.2924 17.0588V14.5425H44.5625V23.8221H47.2924V20.0031C47.2924 18.2543 48.3316 17.0229 50.1456 17.0229C50.3745 17.0229 50.5684 17.0407 50.7796 17.0766V14.4533Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M57.5783 14.5417V15.5945H57.5255C57.3846 15.2555 56.4336 14.3633 54.8131 14.3633C52.7349 14.3633 50.4453 15.9516 50.4453 19.1815C50.4453 22.4114 52.7349 23.9994 54.8131 23.9994C56.4336 23.9994 57.3846 23.1073 57.5255 22.7685H57.5783V23.8213H60.308V14.5417H57.5783ZM55.3767 21.5369C54.2144 21.5369 53.1401 20.6802 53.1401 19.1815C53.1401 17.6828 54.2144 16.8259 55.3767 16.8259C56.5391 16.8259 57.6488 17.6647 57.6488 19.1815C57.6488 20.6984 56.5745 21.5369 55.3767 21.5369Z",
              fill: "black"
            }
          )
        ] }),
        /* @__PURE__ */ jsx$1("defs", { children: /* @__PURE__ */ jsx$1("clipPath", { id: "clip0_276_29978", children: /* @__PURE__ */ jsx$1("rect", { width: "60.3077", height: "24", fill: "white" }) }) })
      ]
    }
  );
}
const maintenancePage = "maintenance-page-module_maintenancePage__s9NO8";
const container$1 = "maintenance-page-module_container__dv-9V";
const logo = "maintenance-page-module_logo__4xZgQ";
const message = "maintenance-page-module_message__o6JzW";
const title = "maintenance-page-module_title__-27ay";
const link = "maintenance-page-module_link__gwKaQ";
const buttonContainer = "maintenance-page-module_buttonContainer__P4mPk";
const styles$3 = {
  maintenancePage,
  container: container$1,
  logo,
  message,
  title,
  link,
  buttonContainer
};
const MaintenancePage = ({ handleRefresh }) => {
  return /* @__PURE__ */ jsx$1("div", { className: styles$3.maintenancePage, children: /* @__PURE__ */ jsxs("div", { className: styles$3.container, children: [
    /* @__PURE__ */ jsx$1("div", { className: styles$3.logo, children: /* @__PURE__ */ jsx$1(SpottedZebraLogo, {}) }),
    /* @__PURE__ */ jsxs("div", { className: styles$3.message, children: [
      /* @__PURE__ */ jsx$1("h2", { className: styles$3.title, children: "We're Under Maintenance" }),
      /* @__PURE__ */ jsx$1("p", { children: "We're currently working on improvements. Please check back later." }),
      /* @__PURE__ */ jsxs("p", { children: [
        "If you were affected by this, please contact",
        " ",
        /* @__PURE__ */ jsx$1("a", { href: "mailto:support@spottedzebra.co.uk", className: styles$3.link, children: "support@spottedzebra.co.uk" })
      ] })
    ] }),
    /* @__PURE__ */ jsx$1("div", { className: styles$3.buttonContainer, children: /* @__PURE__ */ jsx$1(Button$1, { variant: "primary", onClick: handleRefresh, id: "refreshBtn", children: "Refresh" }) })
  ] }) });
};
function ModalButtons({
  confirmButtonProps,
  cancelButtonProps,
  buttonsPosition = "end",
  buttonsFullWidth = false,
  className,
  confirmButtonChildren = "Confirm",
  cancelButtonChildren = "Cancel",
  hasCancelButton = true,
  onConfirmButtonClick,
  onCancelButtonClick
}) {
  const parsedCancelButtonProps = {
    variant: "secondary",
    onClick: onCancelButtonClick,
    children: cancelButtonChildren,
    ...cancelButtonProps
  };
  const parsedConfirmButtonProps = {
    onClick: onConfirmButtonClick,
    children: confirmButtonChildren,
    ...confirmButtonProps
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "sz-modal-buttons",
        `sz-modal-buttons--buttons-position-${buttonsPosition}`,
        buttonsFullWidth && "sz-modal-buttons--buttons-full-width",
        className
      ),
      children: [
        hasCancelButton && /* @__PURE__ */ jsx$1(Button$1, { size: "medium", ...parsedCancelButtonProps }),
        /* @__PURE__ */ jsx$1(Button$1, { size: "medium", ...parsedConfirmButtonProps })
      ]
    }
  );
}
const NotificationModal = ({
  type: type2,
  message: message2,
  hasCancelButton,
  title: title2,
  isOpen,
  className,
  okButtonChildren = "OK",
  onOkClick,
  onCancelClick,
  onClose,
  confirmButtonProps,
  cancelButtonProps,
  cancelButtonChildren = "Cancel"
}) => {
  const contentMap = () => {
    switch (type2) {
      case IconType.INFORMATION:
        return "Info";
      case IconType.WARNING:
        return "Are you sure?";
      case IconType.ERROR:
        return "Error";
      case IconType.SUCCESS:
        return "Success";
      default:
        return "";
    }
  };
  return /* @__PURE__ */ jsx$1(
    Modal,
    {
      isOpen,
      onClose,
      className: clsx("sz-notification-modal", className),
      header: title2 || contentMap(),
      headerIconType: type2,
      modalSize: ModalSize.SMALL,
      buttonsProps: {
        onConfirmButtonClick: onOkClick,
        onCancelButtonClick: onCancelClick,
        className: "sz-notification-modal__modal-buttons",
        confirmButtonChildren: okButtonChildren,
        hasCancelButton,
        confirmButtonProps,
        cancelButtonProps,
        cancelButtonChildren
      },
      children: message2 && /* @__PURE__ */ jsx$1("div", { className: "sz-notification-modal__message", children: message2 })
    }
  );
};
const NotificationModalType = IconType;
const label$1 = "segmented-button-module_label__ZyLLd";
const primary = "segmented-button-module_primary__2Wd56";
const secondary = "segmented-button-module_secondary__hSAQx";
const active = "segmented-button-module_active__A7zaB";
const disabled$1 = "segmented-button-module_disabled__R0oz3";
const LARGE = "segmented-button-module_LARGE__GbDjk";
const MEDIUM = "segmented-button-module_MEDIUM__wUs41";
const SMALL = "segmented-button-module_SMALL__XC4PS";
const styles$2 = {
  "sz-segment-button": "segmented-button-module_sz-segment-button__pn9wh",
  "sz-segment-item-button": "segmented-button-module_sz-segment-item-button__94rsE",
  label: label$1,
  primary,
  secondary,
  active,
  disabled: disabled$1,
  LARGE,
  MEDIUM,
  SMALL,
  "on-press": "segmented-button-module_on-press__X-fQy"
};
var SegmentButtonSize = /* @__PURE__ */ ((SegmentButtonSize2) => {
  SegmentButtonSize2["LARGE"] = "LARGE";
  SegmentButtonSize2["MEDIUM"] = "MEDIUM";
  SegmentButtonSize2["SMALL"] = "SMALL";
  return SegmentButtonSize2;
})(SegmentButtonSize || {});
const ItemButton = ({
  title: title2,
  ariaLabel,
  toolbarId,
  index: index2,
  activeItem,
  size,
  onClick,
  disabledItems = []
}) => {
  const [isPressed, setIsPressed] = useState(false);
  const isDisabled = disabledItems.includes(index2);
  const handleClick = useCallback(() => {
    !isDisabled && onClick(index2);
  }, [index2, isDisabled, onClick]);
  const handleRemoveFocus = () => {
    setIsPressed(true);
    const item2 = document.activeElement;
    item2?.blur();
  };
  const handleChangeDefaultTabIndex = () => {
    setIsPressed(false);
    const toolbar = document.querySelector(toolbarId);
    toolbar?.querySelectorAll("button").forEach((btn, i3) => btn.tabIndex = index2 === i3 ? 0 : -1);
  };
  return /* @__PURE__ */ jsx$1(Fragment$1, { children: /* @__PURE__ */ jsx$1(
    "button",
    {
      className: clsx(
        styles$2["sz-segment-item-button"],
        styles$2[`${size}`],
        activeItem === index2 && styles$2["active"],
        isDisabled && styles$2["disabled"],
        isPressed && styles$2["on-press"]
      ),
      "aria-disabled": isDisabled,
      "aria-label": ariaLabel ?? (typeof title2 === "string" ? title2 : void 0),
      "aria-pressed": activeItem === index2,
      tabIndex: index2 === 0 ? 0 : -1,
      onClick: handleClick,
      onMouseDown: handleRemoveFocus,
      onMouseUp: handleChangeDefaultTabIndex,
      children: /* @__PURE__ */ jsx$1("span", { className: styles$2["label"], children: title2 })
    }
  ) }, `sz-segment-item_${index2}`);
};
const KEYCODE = {
  LEFT: 37,
  RIGHT: 39
};
const SegmentedButton = ({
  titlesObj,
  size = SegmentButtonSize.MEDIUM,
  onClick,
  activeItem,
  disabledItems,
  id = "sz-segment-button",
  ariaLabel
}) => {
  const toolbarId = `#${id}`;
  const activate = (item2) => {
    item2.focus();
  };
  const handleOnClick = (index2) => {
    onClick?.(index2);
    const toolbar = document.querySelector(toolbarId);
    toolbar?.querySelectorAll("button").forEach((btn, i3) => btn.tabIndex = index2 === i3 ? 0 : -1);
  };
  const focusNextItem = () => {
    const item2 = document.activeElement;
    if (item2?.nextElementSibling)
      activate(item2.nextElementSibling);
  };
  const focusPreviousItem = () => {
    const item2 = document.activeElement;
    if (item2?.previousElementSibling)
      activate(item2.previousElementSibling);
  };
  const onKeyDown = (event) => {
    switch (event.keyCode) {
      case KEYCODE.RIGHT:
        event.preventDefault();
        return focusNextItem();
      case KEYCODE.LEFT:
        event.preventDefault();
        return focusPreviousItem();
    }
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      role: "toolbar",
      className: styles$2["sz-segment-button"],
      onKeyDown,
      id,
      "aria-label": ariaLabel,
      "data-testid": id,
      children: titlesObj.map(({ title: title2, ariaLabel: ariaLabel2 }, index2) => /* @__PURE__ */ jsx$1(
        ItemButton,
        {
          toolbarId,
          activeItem,
          onClick: handleOnClick,
          size,
          ariaLabel: ariaLabel2,
          index: index2,
          title: title2,
          disabledItems
        },
        ariaLabel2 ?? index2
      ))
    }
  );
};
const SparkleIcon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "SparkleIcon",
      width: "16",
      height: "16",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M8 5 C8.3 8.7 10.3 10.7 14 11 C10.3 11.3 8.3 13.3 8 17 C7.7 13.3 5.7 11.3 2 11 C5.7 10.7 7.7 8.7 8 5 Z",
            fill: "#6D3FD6"
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M15 3 C15.15 4.85 16.15 5.85 18 6 C16.15 6.15 15.15 7.15 15 9 C14.85 7.15 13.85 6.15 12 6 C13.85 5.85 14.85 4.85 15 3 Z",
            fill: "#6D3FD6"
          }
        )
      ]
    }
  );
};
const selectionTile = "selection-tile-module_selectionTile__xSYpK";
const selectionTileDisableHoverStyle = "selection-tile-module_selectionTileDisableHoverStyle__EipWL";
const contentWrapper = "selection-tile-module_contentWrapper__NTGf5";
const inputs = "selection-tile-module_inputs__tze-R";
const hiddenInputs = "selection-tile-module_hiddenInputs__FTGQP";
const content = "selection-tile-module_content__XdpIO";
const selectionTileError = "selection-tile-module_selectionTileError__wkwU4";
const selectionTileChecked = "selection-tile-module_selectionTileChecked__IwIJo";
const selectionTileDisabled = "selection-tile-module_selectionTileDisabled__h339m";
const selectionTileCheckedError = "selection-tile-module_selectionTileCheckedError__J-aXV";
const styles$1 = {
  selectionTile,
  selectionTileDisableHoverStyle,
  contentWrapper,
  inputs,
  hiddenInputs,
  content,
  selectionTileError,
  selectionTileChecked,
  selectionTileDisabled,
  selectionTileCheckedError
};
function SelectionTile({
  id,
  children,
  value: value2,
  name: name2,
  multiple,
  checked = false,
  hiddenInputs: hiddenInputs2 = false,
  className,
  disabled: disabled2,
  error: error2,
  dataTestId,
  disableHoverStyle,
  onChange: onChange2
}) {
  const testId = dataTestId || "selection-tile";
  const contentId = `${id}-content`;
  const handleKeyDown = (e3) => {
    if (e3.key === "Enter" || e3.key === " ") {
      e3.preventDefault();
      !disabled2 && onChange2(value2, !checked);
    }
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: clsx(styles$1.selectionTile, className, {
        [styles$1.selectionTileDisabled]: disabled2,
        [styles$1.selectionTileError]: error2,
        [styles$1.selectionTileChecked]: checked,
        [styles$1.selectionTileCheckedError]: checked && error2,
        [styles$1.selectionTileDisableHoverStyle]: disableHoverStyle
      }),
      role: multiple ? "checkbox" : "radio",
      "aria-checked": checked,
      "aria-labelledby": contentId,
      "aria-disabled": disabled2,
      tabIndex: disabled2 ? -1 : 0,
      "data-testid": testId,
      onClick: () => !disabled2 && onChange2(value2, !checked),
      onKeyDown: handleKeyDown,
      children: /* @__PURE__ */ jsxs("div", { className: styles$1.contentWrapper, children: [
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: clsx(styles$1.inputs, {
              [styles$1.hiddenInputs]: hiddenInputs2
            }),
            children: multiple ? /* @__PURE__ */ jsx$1(
              Checkbox,
              {
                checked,
                onChange: () => onChange2(value2, !checked),
                dataTestid: `${testId}__checkbox`,
                name: name2,
                hasError: !!error2,
                tabIndex: -1,
                "aria-hidden": "true",
                disabled: disabled2
              }
            ) : /* @__PURE__ */ jsx$1(
              RadioButton,
              {
                id: `${testId}__radio`,
                name: name2,
                value: value2,
                checked,
                disabled: disabled2,
                hasError: !!error2,
                onChange: (e3) => onChange2(value2, Boolean(e3.target.value)),
                tabIndex: -1,
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx$1("div", { id: contentId, className: styles$1.content, children })
      ] })
    }
  );
}
const container = "slider-with-inputs-module_container__sihL0";
const label = "slider-with-inputs-module_label__8JATr";
const slider = "slider-with-inputs-module_slider__dpgWu";
const inputsContainer = "slider-with-inputs-module_inputsContainer__FJkyH";
const input = "slider-with-inputs-module_input__gI1VA";
const large = "slider-with-inputs-module_large__bZz5b";
const medium = "slider-with-inputs-module_medium__u55Ee";
const small = "slider-with-inputs-module_small__rOFCJ";
const error = "slider-with-inputs-module_error__gcmFV";
const disabled = "slider-with-inputs-module_disabled__-M4LD";
const styles = {
  container,
  label,
  slider,
  inputsContainer,
  input,
  large,
  medium,
  small,
  error,
  disabled
};
function SliderWithInputs({
  value: value2,
  error: error2,
  disabled: disabled2,
  id,
  onValueChange,
  label: label2,
  thumbLabels = ["Minimum value", "Maximum value"],
  step,
  className,
  renderError = true,
  maxInputLabel = "Max",
  minInputLabel = "Min",
  inputWidth = "medium",
  ...props
}) {
  const groupLabelId = `${id}-label`;
  const [minRaw, setMinRaw] = useState(value2[0].toString());
  const [maxRaw, setMaxRaw] = useState(value2[1].toString());
  useEffect(() => {
    setMinRaw(value2[0].toString());
  }, [value2[0]]);
  useEffect(() => {
    setMaxRaw(value2[1].toString());
  }, [value2[1]]);
  function handleMinChange(newValue) {
    setMinRaw(newValue);
    const parsed = parseFloat(newValue);
    if (isNaN(parsed)) return;
    onValueChange([parsed, value2[1]]);
  }
  function handleMaxChange(newValue) {
    setMaxRaw(newValue);
    const parsed = parseFloat(newValue);
    if (isNaN(parsed)) return;
    onValueChange([value2[0], parsed]);
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "group",
      "aria-labelledby": label2 ? groupLabelId : void 0,
      className: clsx(
        styles.container,
        error2 && styles.error,
        disabled2 && styles.disabled,
        className
      ),
      children: [
        label2 && /* @__PURE__ */ jsx$1("span", { id: groupLabelId, className: styles.label, children: label2 }),
        /* @__PURE__ */ jsx$1(
          SliderInput,
          {
            value: value2,
            error: error2,
            disabled: disabled2,
            thumbLabels,
            "aria-labelledby": label2 ? groupLabelId : void 0,
            onValueChange,
            step,
            className: styles.slider,
            ...props
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: styles.inputsContainer, children: [
          /* @__PURE__ */ jsx$1(
            TextInputField,
            {
              label: minInputLabel,
              id: `${id}-min`,
              onChange: handleMinChange,
              value: minRaw,
              disabled: disabled2,
              hasError: !!error2,
              step,
              "aria-describedby": error2 ? `${id}-error` : void 0,
              className: clsx(styles.input, styles[inputWidth]),
              renderBottomText: false
            }
          ),
          /* @__PURE__ */ jsx$1(
            TextInputField,
            {
              label: maxInputLabel,
              id: `${id}-max`,
              onChange: handleMaxChange,
              value: maxRaw,
              disabled: disabled2,
              hasError: !!error2,
              "aria-describedby": error2 ? `${id}-error` : void 0,
              step,
              className: clsx(styles.input, styles[inputWidth]),
              renderBottomText: false
            }
          )
        ] }),
        renderError && /* @__PURE__ */ jsx$1(
          "span",
          {
            id: `${id}-error`,
            className: styles.error,
            role: "alert",
            "aria-live": "polite",
            children: error2
          }
        )
      ]
    }
  );
}
const Tab2 = ({
  onClick,
  value: value2,
  isSelected,
  title: title2,
  icon: icon2,
  description: description2,
  additionalInfo,
  error: error2
}) => {
  const handleClick = () => {
    onClick(value2);
  };
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: clsx(
        "sz-tab",
        isSelected && "sz-tab--selected",
        error2 && "sz-tab--error"
      ),
      onClick: handleClick,
      "data-testid": "sz-tab",
      children: [
        icon2 && /* @__PURE__ */ jsx$1("div", { className: "sz-tab__icon-wrapper", children: icon2 }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx$1("div", { className: "sz-tab__title", children: title2 }),
          description2 && /* @__PURE__ */ jsx$1("div", { className: "sz-tab__description", children: description2 })
        ] }),
        additionalInfo && /* @__PURE__ */ jsx$1("div", { className: "sz-tab__additional-info", children: additionalInfo })
      ]
    }
  );
};
const TabPanelLegacy = ({ value: value2, children }) => {
  const { selected: selected2 } = useTabContext();
  if (!selected2) {
    throw new Error("TabPanel used outside of TabContext");
  }
  return value2 === selected2 ? /* @__PURE__ */ jsx$1(Fragment, { children }) : null;
};
const TabContext = createContext({
  selected: "",
  options: [],
  onChange: (_selected) => {
  }
});
const useTabContext = () => useContext(TabContext);
const TabListLegacy = ({
  children,
  initialValue,
  options: options2,
  className
}) => {
  const [selected2, setSelected] = useState(initialValue);
  const handleChange = useCallback((selected22) => {
    setSelected(selected22);
  }, []);
  return /* @__PURE__ */ jsxs(
    TabContext.Provider,
    {
      value: {
        selected: selected2,
        onChange: handleChange,
        options: options2
      },
      children: [
        /* @__PURE__ */ jsx$1("div", { className: clsx("sz-tabs-list", className), children: options2.map((option) => /* @__PURE__ */ createElement(
          Tab2,
          {
            ...option,
            isSelected: option.value === selected2,
            onClick: handleChange,
            key: option.value
          }
        )) }),
        children
      ]
    }
  );
};
export {
  ALLOWED_UTM_PARAMS,
  AUTHENTICATION_ROUTES,
  AUTH_TOKEN,
  Accordion,
  AccordionItem,
  ActionCard,
  ActorRole,
  AdvancedTable,
  AnalyticsCustomEvents,
  AvailabilityCalendar,
  Avatar,
  AvatarsGroup,
  BarChart,
  BarChartWithBorder,
  Button$1 as Button,
  Checkbox,
  CheckboxGroup,
  CheckboxGroupItem,
  Chip,
  ColorVariant,
  Countdown,
  DEBOUNCE_KEYSTROKE_EVENT,
  Datepicker,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
  EditFormWrapper,
  FieldLabel,
  FileInputField,
  FileUpload,
  FileUploadInput,
  FormikCheckboxFormField,
  FormikDatepicker,
  FormikFileInput,
  FormikMultiselectFormField,
  FormikRadioButtonGroup,
  FormikSelectFormField,
  FormikSelectWithMenuButton,
  FormikTextInputField,
  HeaderSortDirection,
  Icon$2 as Icon,
  IconAdd,
  IconAddUser,
  IconAiInterview,
  IconAiSmall,
  IconAiSparkle,
  IconAlert,
  IconAllInbox,
  IconAnalytics,
  IconAnimatedImages,
  IconApartment,
  IconArchive,
  IconArrowBack,
  IconArrowBackwardGreen,
  IconArrowDownAccordion,
  IconArrowForward,
  IconArrowForwardGreen,
  IconArrowMedium,
  IconArrowNorthEast,
  IconAssignment,
  IconAssignmentDark,
  IconAttachFile,
  IconBin,
  IconBinOutline,
  IconBlock,
  IconBlueInfo,
  IconBook,
  IconBookmark,
  IconBookmarkFlagEmpty,
  IconBookmarkFlagFull,
  IconBookmarkOutline,
  IconBox,
  IconBreadcrumbArrow,
  IconBriefcase,
  IconBuild,
  IconCalculate,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarToday,
  IconCallSplit,
  IconCancel,
  IconCancelFilled,
  IconChat,
  IconChatIcon,
  IconCheck,
  IconCheckCircleGreen,
  IconCheckCircleGreenSmall,
  IconCheckCircleOutline,
  IconChecked,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconClock,
  IconClose,
  IconCloseSmall,
  IconComputer,
  IconConstruction,
  IconContentCopy,
  IconCopy,
  IconDei,
  IconDeleteOutline,
  IconDoorOpen,
  IconDotsHorizontal,
  IconDotsVertical,
  IconDoubleThumbDown,
  IconDoubleThumbUp,
  IconDragHandle,
  IconEditPencil,
  IconEmail,
  IconEmptyBox,
  IconEmptyMagicPen,
  IconEmptyPen,
  IconEnvelope,
  IconError,
  IconErrorBox,
  IconErrorOutline,
  IconExit,
  IconExtension,
  IconExternalLink,
  IconEye,
  IconEyeFilled,
  IconFace,
  IconFactCheck,
  IconFileDownload,
  IconFileUpload,
  IconFilter,
  IconFilterAlt,
  IconFingerprint,
  IconFlagFilled,
  IconFlagOutline,
  IconForum,
  IconFrameInspect,
  IconGear,
  IconGearFilled,
  IconGlobe,
  IconGoogleCalendar,
  IconGppBadShield,
  IconGroup,
  IconGroupAvatar,
  IconGroupIcon,
  IconHelpOutline,
  IconHired,
  IconHiringProcessEmptyState,
  IconIcAccessTime,
  IconIcCheckBig,
  IconIcCheckCircleOutline,
  IconIcCloseGray,
  IconIcEmpty,
  IconIcFileUpload,
  IconIcTick,
  IconImage,
  IconInfo,
  IconInfoV2,
  IconIntegrityFlag,
  IconInterview,
  IconJob,
  IconLanguage,
  IconLightbulb,
  IconLimitedAccess,
  IconLink,
  IconLinkOff,
  IconList,
  IconLocalOffer,
  IconLocale,
  IconLock,
  IconLockOutline,
  IconLockUnlocked,
  IconMagnifyingGlass,
  IconMap,
  IconMeeting,
  IconMicrosoftOutlook,
  IconMinus,
  IconMyLocation,
  IconNextWeek,
  IconNoSearchResults,
  IconNoVideocam,
  IconOfferStage,
  IconOffered,
  IconOpenInFull,
  IconOpenInNew,
  IconPageOutlined,
  IconPen,
  IconPending,
  IconPendingAction,
  IconPendingSimple,
  IconPercentileBlue,
  IconPercentileH1,
  IconPercentileH2Medium,
  IconPercentileH2Regular,
  IconPercentileH3Medium,
  IconPercentileH3Regular,
  IconPercentileH4,
  IconPercentileH4Blue,
  IconPercentileH5,
  IconPercentileP,
  IconPercentilePSmall,
  IconPersonAdd,
  IconPersonSearch,
  IconPlay,
  IconPlaylistAddCheck,
  IconPlaylistAddCheckBig,
  IconPlus,
  IconPsychology,
  IconPublish,
  IconQuestionMark,
  IconRecordingInProgress,
  IconRecordingPause,
  IconRecordingResume,
  IconRecordingStart,
  IconRecordingStop,
  IconRemove,
  IconRemoveCircle,
  IconReplay,
  IconReport,
  IconRspDecisions,
  IconRspProfile,
  IconRspRole,
  IconSaveAlt,
  IconScoreChecked,
  IconSearchV2,
  IconSearchV3,
  IconSelfAssessment,
  IconShare,
  IconSkillLock,
  IconSkipped,
  IconSmallDownload,
  IconSms,
  IconSourceOutlined,
  IconSplitscreen,
  IconSpot,
  IconSpotBlueLogo,
  IconSpottedZebraLogoLarge,
  IconStandardSecurity,
  IconSubject,
  IconSupervisorAccount,
  IconSwapArrows,
  IconTabSwitch,
  IconTalentPool,
  IconTextFields,
  IconThumbDown,
  IconThumbDownFeedback,
  IconThumbDownOutline,
  IconThumbUp,
  IconThumbUpFeedback,
  IconTrash,
  IconTrendingUp,
  IconType,
  IconUnarchive,
  IconUser,
  IconVerdictCheck,
  IconVerdictClear,
  IconVerifiedUser,
  IconVerifiedUserShield,
  IconVideoLibrary,
  IconVideocam,
  IconWarningAmber,
  IconWarningOutline,
  InformationalContent,
  InlineNotification,
  Language,
  Link$1 as Link,
  Loader,
  MaintenancePage,
  MenuPosition,
  Modal,
  ModalButtons,
  ModalSize,
  MultiFileUpload,
  Multiselect,
  MultiselectFormField,
  NEUTRAL_SCALE_COLOR,
  NavLink,
  NotificationModal,
  NotificationModalType,
  NotificationType,
  PageIndicator,
  PersonalNameOrder,
  Popper$1 as Popper,
  ProductSolution,
  ProgressBar,
  RadioButton,
  RadioButtonGroup,
  Rating,
  SCALE_RAMP,
  ScoreCard,
  ScoreIndicator,
  Search3 as Search,
  SearchableSelect,
  SegmentButtonSize,
  SegmentedButton,
  SegmentedControl,
  SegmentedScale,
  Select2 as Select,
  SelectFormField,
  SelectMenu,
  SelectWithMenuButton,
  SelectWithMenuButtonField,
  SelectionTile,
  SkillCard,
  Slider,
  SliderInput,
  SliderWithInputs,
  SparkleIcon,
  SupportedLocale,
  SvgWithLabel,
  Switch,
  TNotification,
  Tab$1 as Tab,
  TabList,
  TabListLegacy,
  TabPanel2 as TabPanel,
  TabPanelLegacy,
  TabPanels,
  Table,
  Tabs,
  Tag,
  TagColor,
  TagSize,
  TextArea,
  TextInput,
  TextInputField,
  Tooltip$3 as Tooltip,
  WEEK_CALENDAR_ROW_HEIGHT,
  WeekCalendar,
  actorRolesAcrossSolutions,
  analyticsClient,
  cellsToSlots,
  clientTransformSupportedLocaleToLanguage,
  components,
  defaultProjectUserRoleProperties,
  formatPersonalName,
  formatTimeRange,
  getSupportedLocaleMetadata,
  iconsObj,
  makeCellId,
  mergeRuns,
  minutesToLabel,
  parseCellId,
  sampleScaleRamp,
  supportedLocaleToLanguage,
  supportedLocalesMetadata,
  transformLanguageToSupportedLocale,
  transformSupportedLocaleToLanguage,
  useAccessibilityKeyboardDetection,
  useAuthAppRedirect,
  useDrawer,
  useInterval,
  useIsDomReady,
  useLocales,
  useNotification,
  useTabContext
};
//# sourceMappingURL=index.js.map
